export default ({ run () { (function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.3/optimize for better performance and smaller assets.');


var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));


  var app = ports ? { ports: ports } : {};
  app.unmount = function () {
    stepper(model, true /* isSync */);
    _Platform_enqueueEffects(managers, _Platform_batch(_List_Nil), _Platform_batch(_List_Nil));
    managers = null;
    model = null;
    stepper = null;
    ports = null;
    var node = _VirtualDom_lastDomNode;
    _VirtualDom_lastDomNode = null;
    if (node.elmFs) {
      for (var key in node.elmFs) {
        node.removeEventListener(key, node.elmFs[key]);
      }
      delete node.elmFs;
    }
    if (node.replaceChildren) {
      node.replaceChildren();
    }
    if (args && args.node) {
      node.replaceWith(args.node);
    } else {
      node.remove();
    }
    if (import.meta.hot) {
      var index = import.meta.hot.data.elmApps.indexOf(app);
      if (index !== -1) {
        import.meta.hot.data.elmApps.splice(index, 1);
      }
    }
  };
  if (import.meta.hot) {
    import.meta.hot.data.elmApps ??= [];
    import.meta.hot.data.elmApps.push(app);
  }
  return app;

}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}



// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);


  var app = {};
  app.unmount = function () {
    if (node.replaceChildren) {
      node.replaceChildren();
    }
    node.replaceWith(args.node);
    if (import.meta.hot) {
      var index = import.meta.hot.data.elmApps.indexOf(app);
      if (index !== -1) {
        import.meta.hot.data.elmApps.splice(index, 1);
      }
    }
  };
  if (import.meta.hot) {
    import.meta.hot.data.elmApps ??= [];
    import.meta.hot.data.elmApps.push(app);
  }
  return app;

});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


var _VirtualDom_lastDomNode = null;
function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return _VirtualDom_lastDomNode = rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_lastDomNode = _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}



// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{tail: tail, nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\u000A    ',
		A2($elm$core$String$split, '\u000A', str));
};
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\u000A\u000A(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\u0027' + (f + '\u0027]'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\u000A\u000A',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\u000A\u000A';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\u000A\u000A    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\u000A\u000A' + msg));
			}
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$Page = function (a) {
	return {$: 'Page', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$Lang = F4(
	function (a, b, c, d) {
		return {$: 'Lang', a: a, b: b, c: c, d: d};
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 'Min', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = {$: 'Western'};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	system: $cuducos$elm_format_number$FormatNumber$Locales$Western,
	decimals: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	zeroPrefix: '',
	zeroSuffix: '',
	negativePrefix: '−',
	negativeSuffix: '',
	positivePrefix: '',
	positiveSuffix: '',
	decimalSeparator: '.',
	thousandSeparator: ''
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $enkidatron$elm_cldr$Internal$Locale$Locale = function (a) {
	return {$: 'Locale', a: a};
};
var $joneshf$elm_tagged$Tagged$Tagged = function (a) {
	return {$: 'Tagged', a: a};
};
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $enkidatron$elm_cldr$Internal$Locale$empty = $enkidatron$elm_cldr$Internal$Locale$Locale(
	{
		eraNames: {
			wide: {ad: 'CE', bc: 'BCE'},
			narrow: {ad: 'CE', bc: 'BCE'},
			abbreviated: {ad: 'CE', bc: 'BCE'}
		},
		languageId: A4(
			$enkidatron$elm_cldr$Internal$Locale$Lang,
			$joneshf$elm_tagged$Tagged$Tagged(''),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing),
		dateSymbols: {full: _List_Nil, _long: _List_Nil, _short: _List_Nil, medium: _List_Nil},
		periodNames: {
			wide: {
				am: 'AM',
				pm: 'PM',
				dayPeriods: $elm$core$Dict$fromList(_List_Nil)
			},
			narrow: {
				am: 'AM',
				pm: 'PM',
				dayPeriods: $elm$core$Dict$fromList(_List_Nil)
			},
			abbreviated: {
				am: 'AM',
				pm: 'PM',
				dayPeriods: $elm$core$Dict$fromList(_List_Nil)
			}
		},
		timeSymbols: {full: _List_Nil, _long: _List_Nil, _short: _List_Nil, medium: _List_Nil},
		dateTimeTokens: {full: _List_Nil, _long: _List_Nil, _short: _List_Nil, medium: _List_Nil},
		currencySymbols: $elm$core$Dict$empty,
		hour12ByDefault: false,
		availableFormats: _List_Nil,
		dayPeriodRuleSet: _List_Nil,
		monthFormatNames: {
			wide: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'},
			narrow: {apr: '4', aug: '8', dec: '12', feb: '2', jan: '1', jul: '7', jun: '6', mar: '3', may: '5', nov: '11', oct: '10', sep: '9'},
			abbreviated: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'}
		},
		weekdayFormatNames: {
			wide: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'},
			narrow: {fri: 'F', mon: 'M', sat: 'S', sun: 'S', thu: 'T', tue: 'T', wed: 'W'},
			abbreviated: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'}
		},
		decimalNumberFormat: $cuducos$elm_format_number$FormatNumber$Locales$base,
		percentNumberFormat: $cuducos$elm_format_number$FormatNumber$Locales$base,
		currencyNumberFormat: $cuducos$elm_format_number$FormatNumber$Locales$base,
		monthStandaloneNames: {
			wide: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'},
			narrow: {apr: '4', aug: '8', dec: '12', feb: '2', jan: '1', jul: '7', jun: '6', mar: '3', may: '5', nov: '11', oct: '10', sep: '9'},
			abbreviated: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'}
		},
		weekdayStandaloneNames: {
			wide: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'},
			narrow: {fri: 'F', mon: 'M', sat: 'S', sun: 'S', thu: 'T', tue: 'T', wed: 'W'},
			abbreviated: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'}
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 'Empty':
					return list;
				case 'AddRight':
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0.a;
		var _v1 = parse(
			{col: 1, row: 1, src: src, indent: 1, offset: 0, context: _List_Nil});
		if (_v1.$ === 'Good') {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {col: col, row: row, problem: problem};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
};
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (_v0.$ === 'Ok') {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$expand = function (info) {
	return {
		script: info.script,
		variant: info.variant,
		eraNames: info.eraNames,
		language: info.language,
		territory: info.territory,
		periodNames: info.periodNames,
		datePatterns: info.datePatterns,
		timePatterns: info.timePatterns,
		timeSkeletons: info.timeSkeletons,
		currencySymbols: info.currencySymbols,
		availableFormats: info.availableFormats,
		dateTimePatterns: info.dateTimePatterns,
		monthFormatNames: info.monthFormatNames,
		weekdayFormatNames: info.weekdayFormatNames,
		decimalNumberFormat: info.decimalNumberFormat,
		percentNumberFormat: info.percentNumberFormat,
		currencyNumberFormat: info.currencyNumberFormat,
		monthStandaloneNames: A2($elm$core$Maybe$withDefault, info.monthFormatNames, info.monthStandaloneNames),
		weekdayStandaloneNames: A2($elm$core$Maybe$withDefault, info.weekdayFormatNames, info.weekdayStandaloneNames)
	};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 'Bad', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 'Good', a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$core$String$length = _String_length;
var $elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {col: col, row: row, problem: problem, contextStack: contextStack};
	});
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 'AddRight', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return _Utils_eq(
				$elm$core$String$length(s.src),
				s.offset) ? A3($elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 'Token', a: a, b: b};
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, row: newRow, src: s.src, indent: s.indent, offset: newOffset, context: s.context});
		});
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 'ExpectingSymbol', a: a};
};
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe = $elm$parser$Parser$symbol('|');
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0.a;
		var parseB = _v1.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v2 = parseA(s0);
				if (_v2.$ === 'Bad') {
					var p = _v2.a;
					var x = _v2.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v2.a;
					var a = _v2.b;
					var s1 = _v2.c;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3(
							$elm$parser$Parser$Advanced$Good,
							p1 || p2,
							A2(func, a, b),
							s2);
					}
				}
			});
	});
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $enkidatron$elm_cldr$Internal$LanguageInfo$Compact = function (language) {
	return function (script) {
		return function (territory) {
			return function (variant) {
				return function (periodNames) {
					return function (datePatterns) {
						return function (monthFormatNames) {
							return function (monthStandaloneNames) {
								return function (weekdayFormatNames) {
									return function (weekdayStandaloneNames) {
										return function (eraNames) {
											return function (timePatterns) {
												return function (dateTimePatterns) {
													return function (availableFormats) {
														return function (timeSkeletons) {
															return function (decimalNumberFormat) {
																return function (currencyNumberFormat) {
																	return function (percentNumberFormat) {
																		return function (currencySymbols) {
																			return {script: script, variant: variant, eraNames: eraNames, language: language, territory: territory, periodNames: periodNames, datePatterns: datePatterns, timePatterns: timePatterns, timeSkeletons: timeSkeletons, currencySymbols: currencySymbols, availableFormats: availableFormats, dateTimePatterns: dateTimePatterns, monthFormatNames: monthFormatNames, weekdayFormatNames: weekdayFormatNames, decimalNumberFormat: decimalNumberFormat, percentNumberFormat: percentNumberFormat, currencyNumberFormat: currencyNumberFormat, monthStandaloneNames: monthStandaloneNames, weekdayStandaloneNames: weekdayStandaloneNames};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, false, a, s);
		});
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {col: s.col + (newOffset - s.offset), row: s.row, src: s.src, indent: s.indent, offset: newOffset, context: s.context};
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 'Err') {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.offset, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.src);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.row, s.col - (floatOffset + s.offset), invalid, s.context));
		} else {
			if (_Utils_eq(s.offset, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.offset, intPair, s);
				} else {
					if (floatSettings.$ === 'Err') {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.offset, floatOffset, s.src));
						if (_v1.$ === 'Nothing') {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.offset, s.src)) {
				var zeroOffset = s.offset + 1;
				var baseOffset = zeroOffset + 1;
				return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.src) ? A5(
					$elm$parser$Parser$Advanced$finalizeInt,
					c.invalid,
					c.hex,
					baseOffset,
					A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.src),
					s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.src) ? A5(
					$elm$parser$Parser$Advanced$finalizeInt,
					c.invalid,
					c.octal,
					baseOffset,
					A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.src),
					s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.src) ? A5(
					$elm$parser$Parser$Advanced$finalizeInt,
					c.invalid,
					c.binary,
					baseOffset,
					A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.src),
					s) : A6(
					$elm$parser$Parser$Advanced$finalizeFloat,
					c.invalid,
					c.expecting,
					c._int,
					c._float,
					_Utils_Tuple2(zeroOffset, 0),
					s)));
			} else {
				return A6(
					$elm$parser$Parser$Advanced$finalizeFloat,
					c.invalid,
					c.expecting,
					c._int,
					c._float,
					A3($elm$parser$Parser$Advanced$consumeBase, 10, s.offset, s.src),
					s);
			}
		});
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				hex: $elm$core$Result$Err(invalid),
				_int: $elm$core$Result$Ok($elm$core$Basics$identity),
				_float: $elm$core$Result$Err(invalid),
				octal: $elm$core$Result$Err(invalid),
				binary: $elm$core$Result$Err(invalid),
				invalid: invalid,
				expecting: expecting
			});
	});
var $elm$parser$Parser$ExpectingInt = {$: 'ExpectingInt'};
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						func(a),
						s1);
				} else {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				}
			});
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parseA(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					var _v2 = callback(a);
					var parseB = _v2.a;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
					}
				}
			});
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 'Problem', a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeParser = function (innerParser) {
	return A2(
		$elm$parser$Parser$andThen,
		function (x) {
			switch (x) {
				case 0:
					return $elm$parser$Parser$succeed($elm$core$Maybe$Nothing);
				case 1:
					return A2($elm$parser$Parser$map, $elm$core$Maybe$Just, innerParser);
				default:
					return $elm$parser$Parser$problem('Unexpected number encountered while evaulating a Maybe');
			}
		},
		A2($elm$parser$Parser$ignorer, $elm$parser$Parser$int, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
};
var $enkidatron$elm_cldr$Internal$Structures$EraNames = F2(
	function (bc, ad) {
		return {ad: ad, bc: bc};
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.offset, offset) < 0,
					_Utils_Tuple0,
					{col: col, row: row, src: s0.src, indent: s0.indent, offset: offset, context: s0.context});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
		});
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						A2(
							func,
							A3($elm$core$String$slice, s0.offset, s1.offset, s0.src),
							a),
						s1);
				}
			});
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString = $elm$parser$Parser$getChompedString(
	$elm$parser$Parser$chompWhile(
		function (_char) {
			return !_Utils_eq(
				_char,
				_Utils_chr('|'));
		}));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$eraNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$EraNames),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $enkidatron$elm_cldr$Internal$Structures$Pattern3 = F3(
	function (abbreviated, wide, narrow) {
		return {wide: wide, narrow: narrow, abbreviated: abbreviated};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser = function (innerParser) {
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$Pattern3),
				innerParser),
			innerParser),
		innerParser);
};
var $enkidatron$elm_cldr$Internal$Structures$Patterns = F4(
	function (_short, medium, _long, full) {
		return {full: full, _long: _long, _short: _short, medium: medium};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser = function (innerParser) {
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$Patterns),
					innerParser),
				innerParser),
			innerParser),
		innerParser);
};
var $enkidatron$elm_cldr$Internal$Structures$MonthNames = function (jan) {
	return function (feb) {
		return function (mar) {
			return function (apr) {
				return function (may) {
					return function (jun) {
						return function (jul) {
							return function (aug) {
								return function (sep) {
									return function (oct) {
										return function (nov) {
											return function (dec) {
												return {apr: apr, aug: aug, dec: dec, feb: feb, jan: jan, jul: jul, jun: jun, mar: mar, may: may, nov: nov, oct: oct, sep: sep};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$monthNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$keeper,
												$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$MonthNames),
												A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
											A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
										A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
									A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
								A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
					A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
				A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $elm_community$string_extra$String$Extra$nonEmpty = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser = A2($elm$parser$Parser$map, $elm_community$string_extra$String$Extra$nonEmpty, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString);
var $enkidatron$elm_cldr$Internal$Structures$PeriodNames = F3(
	function (am, pm, dayPeriods) {
		return {am: am, pm: pm, dayPeriods: dayPeriods};
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0.a;
			var _v1 = parse(s0);
			if (_v1.$ === 'Good') {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (step.$ === 'Loop') {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
			});
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (step.$ === 'Loop') {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser = A2(
	$elm$parser$Parser$andThen,
	function (count) {
		return A2(
			$elm$parser$Parser$loop,
			_Utils_Tuple2(count, _List_Nil),
			function (_v0) {
				var x = _v0.a;
				var revItems = _v0.b;
				return (x > 0) ? A2(
					$elm$parser$Parser$map,
					function (item) {
						return $elm$parser$Parser$Loop(
							_Utils_Tuple2(
								x - 1,
								A2($elm$core$List$cons, item, revItems)));
					},
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($elm$core$Tuple$pair),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))) : $elm$parser$Parser$succeed(
					$elm$parser$Parser$Done(
						$elm$core$List$reverse(revItems)));
			});
	},
	A2($elm$parser$Parser$ignorer, $elm$parser$Parser$int, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$dayPeriodsParser = A2($elm$parser$Parser$map, $elm$core$Dict$fromList, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser);
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$periodNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$PeriodNames),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$dayPeriodsParser);
var $enkidatron$elm_cldr$Internal$Structures$WeekdayNames = F7(
	function (sun, mon, tue, wed, thu, fri, sat) {
		return {fri: fri, mon: mon, sat: sat, sun: sun, thu: thu, tue: tue, wed: wed};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$weekdayNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$WeekdayNames),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
					A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
				A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $cuducos$elm_format_number$FormatNumber$Locales$Locale = function (decimals) {
	return function (system) {
		return function (thousandSeparator) {
			return function (decimalSeparator) {
				return function (negativePrefix) {
					return function (negativeSuffix) {
						return function (positivePrefix) {
							return function (positiveSuffix) {
								return function (zeroPrefix) {
									return function (zeroSuffix) {
										return {system: system, decimals: decimals, zeroPrefix: zeroPrefix, zeroSuffix: zeroSuffix, negativePrefix: negativePrefix, negativeSuffix: negativeSuffix, positivePrefix: positivePrefix, positiveSuffix: positiveSuffix, decimalSeparator: decimalSeparator, thousandSeparator: thousandSeparator};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Indian = {$: 'Indian'};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
				return _Utils_eq(newOffset, -1) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: 1, row: s.row + 1, src: s.src, indent: s.indent, offset: s.offset + 1, context: s.context}) : A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: s.col + 1, row: s.row, src: s.src, indent: s.indent, offset: newOffset, context: s.context}));
			});
	});
var $elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberSystemParser = A2(
	$elm$parser$Parser$andThen,
	function (tag) {
		switch (tag) {
			case 'W':
				return $elm$parser$Parser$succeed($cuducos$elm_format_number$FormatNumber$Locales$Western);
			case 'I':
				return $elm$parser$Parser$succeed($cuducos$elm_format_number$FormatNumber$Locales$Indian);
			default:
				var other = tag;
				return $elm$parser$Parser$problem('Error while parsing a FormatNumber.Locales.System, found: ' + other);
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf(
			function (_char) {
				return A2(
					$elm$core$List$member,
					_char,
					_List_fromArray(
						[
							_Utils_chr('W'),
							_Utils_chr('I')
						]));
			})));
var $cuducos$elm_format_number$FormatNumber$Locales$Max = function (a) {
	return {$: 'Max', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 'Exact', a: a};
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberDecimalsParser = A2(
	$elm$parser$Parser$andThen,
	function (tag) {
		switch (tag) {
			case 'N':
				return A2($elm$parser$Parser$map, $cuducos$elm_format_number$FormatNumber$Locales$Min, $elm$parser$Parser$int);
			case 'X':
				return A2($elm$parser$Parser$map, $cuducos$elm_format_number$FormatNumber$Locales$Max, $elm$parser$Parser$int);
			case 'E':
				return A2($elm$parser$Parser$map, $cuducos$elm_format_number$FormatNumber$Locales$Exact, $elm$parser$Parser$int);
			default:
				var other = tag;
				return $elm$parser$Parser$problem('Error while parsing a FormatNumber.Locales.Decimals, found: ' + other);
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf(
			function (_char) {
				return A2(
					$elm$core$List$member,
					_char,
					_List_fromArray(
						[
							_Utils_chr('N'),
							_Utils_chr('X'),
							_Utils_chr('E')
						]));
			})));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										$elm$parser$Parser$succeed($cuducos$elm_format_number$FormatNumber$Locales$Locale),
										$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberDecimalsParser),
									$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberSystemParser),
								A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
					A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
				A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$keeper,
												A2(
													$elm$parser$Parser$keeper,
													A2(
														$elm$parser$Parser$keeper,
														A2(
															$elm$parser$Parser$keeper,
															A2(
																$elm$parser$Parser$keeper,
																A2(
																	$elm$parser$Parser$keeper,
																	A2(
																		$elm$parser$Parser$keeper,
																		A2(
																			$elm$parser$Parser$keeper,
																			$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$LanguageInfo$Compact),
																			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
																		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
																	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
																A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
															$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$periodNamesParser)),
														$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
															A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
													$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$monthNamesParser)),
												$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeParser(
													$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$monthNamesParser))),
											$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$weekdayNamesParser)),
										$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeParser(
											$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$weekdayNamesParser))),
									$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$eraNamesParser)),
								$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
									A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
							$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
								A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
						$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser),
					$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
				$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser),
			$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser),
		$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser, $elm$parser$Parser$end));
var $elm$core$Result$toMaybe = function (result) {
	if (result.$ === 'Ok') {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parse = function (words) {
	return A2(
		$elm$core$Maybe$map,
		$enkidatron$elm_cldr$Internal$LanguageInfo$expand,
		$elm$core$Result$toMaybe(
			A2($elm$parser$Parser$run, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parser, words)));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm$core$Basics$apR);
var $enkidatron$elm_cldr$Internal$Locale$Internal = function (monthFormatNames) {
	return function (monthStandaloneNames) {
		return function (weekdayFormatNames) {
			return function (weekdayStandaloneNames) {
				return function (eraNames) {
					return function (periodNames) {
						return function (dayPeriodRuleSet) {
							return function (dateSymbols) {
								return function (timeSymbols) {
									return function (dateTimeTokens) {
										return function (languageId) {
											return function (availableFormats) {
												return function (hour12ByDefault) {
													return function (decimalNumberFormat) {
														return function (currencyNumberFormat) {
															return function (percentNumberFormat) {
																return function (currencySymbols) {
																	return {eraNames: eraNames, languageId: languageId, dateSymbols: dateSymbols, periodNames: periodNames, timeSymbols: timeSymbols, dateTimeTokens: dateTimeTokens, currencySymbols: currencySymbols, hour12ByDefault: hour12ByDefault, availableFormats: availableFormats, dayPeriodRuleSet: dayPeriodRuleSet, monthFormatNames: monthFormatNames, weekdayFormatNames: weekdayFormatNames, decimalNumberFormat: decimalNumberFormat, percentNumberFormat: percentNumberFormat, currencyNumberFormat: currencyNumberFormat, monthStandaloneNames: monthStandaloneNames, weekdayStandaloneNames: weekdayStandaloneNames};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$Day = function (a) {
	return {$: 'Day', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Era = function (a) {
	return {$: 'Era', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Wide = {$: 'Wide'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Year = function (a) {
	return {$: 'Year', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Month = function (a) {
	return {$: 'Month', a: a};
};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 'Append', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
		});
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $enkidatron$elm_cldr$Internal$FormatSymbols$Narrow = {$: 'Narrow'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Weekday = function (a) {
	return {$: 'Weekday', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$parseWord = F2(
	function (word, item) {
		return A2(
			$elm$parser$Parser$map,
			function (_v0) {
				return item;
			},
			$elm$parser$Parser$symbol(word));
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$YearOfWeek = function (a) {
	return {$: 'YearOfWeek', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated = {$: 'Abbreviated'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Text = function (a) {
	return {$: 'Text', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Number = function (a) {
	return {$: 'Number', a: a};
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit = {$: 'TwoDigit'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits = {$: 'MinimumDigits'};
var $enkidatron$elm_cldr$Internal$Parse$parseWidth5 = F2(
	function (baseCharacter, toItem) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 5, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Text($enkidatron$elm_cldr$Internal$FormatSymbols$Narrow))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 4, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Text($enkidatron$elm_cldr$Internal$FormatSymbols$Wide))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 3, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Text($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 2, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Number($enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					baseCharacter,
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Number($enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits)))
				]));
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$MonthStandalone = function (a) {
	return {$: 'MonthStandalone', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$parseTextWidth5 = F2(
	function (baseCharacter, toItem) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 5, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Narrow)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 4, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Wide)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 3, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 2, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					baseCharacter,
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated))
				]));
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone = function (a) {
	return {$: 'WeekdayStandalone', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2 = F2(
	function (baseCharacter, toItem) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 2, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					baseCharacter,
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits))
				]));
	});
var $enkidatron$elm_cldr$Internal$Parse$dateSymbolParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'G', $enkidatron$elm_cldr$Internal$FormatSymbols$Era),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'y', $enkidatron$elm_cldr$Internal$FormatSymbols$Year),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'Y', $enkidatron$elm_cldr$Internal$FormatSymbols$YearOfWeek),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWidth5, 'M', $enkidatron$elm_cldr$Internal$FormatSymbols$Month),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWidth5, 'L', $enkidatron$elm_cldr$Internal$FormatSymbols$MonthStandalone),
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'E', $enkidatron$elm_cldr$Internal$FormatSymbols$Weekday),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'ccccc',
			$enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone($enkidatron$elm_cldr$Internal$FormatSymbols$Narrow)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'cccc',
			$enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone($enkidatron$elm_cldr$Internal$FormatSymbols$Wide)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'ccc',
			$enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated)),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'd', $enkidatron$elm_cldr$Internal$FormatSymbols$Day)
		]));
var $elm$core$Set$Set_elm_builtin = function (a) {
	return {$: 'Set_elm_builtin', a: a};
};
var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
var $enkidatron$elm_cldr$Internal$FormatSymbols$Symbol = function (a) {
	return {$: 'Symbol', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (_v0.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$parser$Parser$Advanced$varHelp = F7(
	function (isGood, offset, row, col, src, indent, context) {
		varHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, src);
			if (_Utils_eq(newOffset, -1)) {
				return {col: col, row: row, src: src, indent: indent, offset: offset, context: context};
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$variable = function (i) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var firstOffset = A3($elm$parser$Parser$Advanced$isSubChar, i.start, s.offset, s.src);
			if (_Utils_eq(firstOffset, -1)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, i.expecting));
			} else {
				var s1 = _Utils_eq(firstOffset, -2) ? A7($elm$parser$Parser$Advanced$varHelp, i.inner, s.offset + 1, s.row + 1, 1, s.src, s.indent, s.context) : A7($elm$parser$Parser$Advanced$varHelp, i.inner, firstOffset, s.row, s.col + 1, s.src, s.indent, s.context);
				var name = A3($elm$core$String$slice, s.offset, s1.offset, s.src);
				return A2($elm$core$Set$member, name, i.reserved) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, i.expecting)) : A3($elm$parser$Parser$Advanced$Good, true, name, s1);
			}
		});
};
var $elm$parser$Parser$ExpectingVariable = {$: 'ExpectingVariable'};
var $elm$parser$Parser$variable = function (i) {
	return $elm$parser$Parser$Advanced$variable(
		{inner: i.inner, start: i.start, reserved: i.reserved, expecting: $elm$parser$Parser$ExpectingVariable});
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 'Expecting', a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.context)) : A3(
				$elm$parser$Parser$Advanced$Good,
				_Utils_cmp(s.offset, newOffset) < 0,
				_Utils_Tuple0,
				{col: newCol, row: newRow, src: s.src, indent: s.indent, offset: newOffset, context: s.context});
		});
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $enkidatron$elm_cldr$Internal$Parse$withLiteralParser = function (innerParser) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$map, $enkidatron$elm_cldr$Internal$FormatSymbols$Symbol, innerParser),
				A2(
				$elm$parser$Parser$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$Literal,
				$elm$parser$Parser$variable(
					{
						inner: function (c) {
							return (!$elm$core$Char$isAlpha(c)) && (!_Utils_eq(
								c,
								_Utils_chr('\'')));
						},
						start: function (c) {
							return (!$elm$core$Char$isAlpha(c)) && (!_Utils_eq(
								c,
								_Utils_chr('\'')));
						},
						reserved: $elm$core$Set$empty
					})),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$FormatSymbols$Literal),
					$elm$parser$Parser$symbol('\u0027')),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getChompedString(
						$elm$parser$Parser$chompUntil('\u0027')),
					$elm$parser$Parser$symbol('\u0027')))
			]));
};
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern = F2(
	function (innerFun, pattern) {
		return A5(
			$elm$core$Maybe$map4,
			$enkidatron$elm_cldr$Internal$Structures$Patterns,
			innerFun(pattern._short),
			innerFun(pattern.medium),
			innerFun(pattern._long),
			innerFun(pattern.full));
	});
var $elm$parser$Parser$Optional = {$: 'Optional'};
var $elm$parser$Parser$Advanced$revAlways = F2(
	function (_v0, b) {
		return b;
	});
var $elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var $elm$parser$Parser$Advanced$sequenceEndOptional = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var parseEnd = A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return $elm$parser$Parser$Advanced$Done(
					$elm$core$List$reverse(revItems));
			},
			ender);
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							$elm$parser$Parser$Advanced$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$Advanced$map,
										function (item) {
											return $elm$parser$Parser$Advanced$Loop(
												A2($elm$core$List$cons, item, revItems));
										},
										parseItem),
										parseEnd
									])))),
						parseEnd
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEndForbidden = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var chompRest = function (item) {
			return A5(
				$elm$parser$Parser$Advanced$sequenceEndForbidden,
				ender,
				ws,
				parseItem,
				sep,
				A2($elm$core$List$cons, item, revItems));
		};
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$map,
								function (item) {
									return $elm$parser$Parser$Advanced$Loop(
										A2($elm$core$List$cons, item, revItems));
								},
								parseItem))),
						A2(
						$elm$parser$Parser$Advanced$map,
						function (_v0) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(revItems));
						},
						ender)
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEndMandatory = F4(
	function (ws, parseItem, sep, revItems) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (item) {
						return $elm$parser$Parser$Advanced$Loop(
							A2($elm$core$List$cons, item, revItems));
					},
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						parseItem,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							ws,
							A2($elm$parser$Parser$Advanced$ignorer, sep, ws)))),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							$elm$core$List$reverse(revItems));
					},
					$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0))
				]));
	});
var $elm$parser$Parser$Advanced$sequenceEnd = F5(
	function (ender, ws, parseItem, sep, trailing) {
		var chompRest = function (item) {
			switch (trailing.$) {
				case 'Forbidden':
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
				case 'Optional':
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
				default:
					return A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$skip,
								sep,
								A2(
									$elm$parser$Parser$Advanced$skip,
									ws,
									A2(
										$elm$parser$Parser$Advanced$loop,
										_List_fromArray(
											[item]),
										A3($elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))),
						ender);
			}
		};
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2($elm$parser$Parser$Advanced$andThen, chompRest, parseItem),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					ender)
				]));
	});
var $elm$parser$Parser$Advanced$sequence = function (i) {
	return A2(
		$elm$parser$Parser$Advanced$skip,
		$elm$parser$Parser$Advanced$token(i.start),
		A2(
			$elm$parser$Parser$Advanced$skip,
			i.spaces,
			A5(
				$elm$parser$Parser$Advanced$sequenceEnd,
				$elm$parser$Parser$Advanced$token(i.end),
				i.spaces,
				i.item,
				$elm$parser$Parser$Advanced$token(i.separator),
				i.trailing)));
};
var $elm$parser$Parser$Advanced$Optional = {$: 'Optional'};
var $elm$parser$Parser$Advanced$Forbidden = {$: 'Forbidden'};
var $elm$parser$Parser$Advanced$Mandatory = {$: 'Mandatory'};
var $elm$parser$Parser$toAdvancedTrailing = function (trailing) {
	switch (trailing.$) {
		case 'Forbidden':
			return $elm$parser$Parser$Advanced$Forbidden;
		case 'Optional':
			return $elm$parser$Parser$Advanced$Optional;
		default:
			return $elm$parser$Parser$Advanced$Mandatory;
	}
};
var $elm$parser$Parser$sequence = function (i) {
	return $elm$parser$Parser$Advanced$sequence(
		{
			end: $elm$parser$Parser$toToken(i.end),
			item: i.item,
			start: $elm$parser$Parser$toToken(i.start),
			spaces: i.spaces,
			trailing: $elm$parser$Parser$toAdvancedTrailing(i.trailing),
			separator: $elm$parser$Parser$toToken(i.separator)
		});
};
var $enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper = function (innerParser) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$sequence(
			{
				end: '',
				item: innerParser,
				start: '',
				spaces: $elm$parser$Parser$succeed(_Utils_Tuple0),
				trailing: $elm$parser$Parser$Optional,
				separator: ''
			}),
		$elm$parser$Parser$end);
};
var $enkidatron$elm_cldr$Internal$Parse$dateSymbols = function (info) {
	return A2(
		$enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern,
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run(
				$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
					$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$dateSymbolParser))),
			$elm$core$Result$toMaybe),
		info.datePatterns);
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Long = {$: 'Long'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Short = {$: 'Short'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Minute = function (a) {
	return {$: 'Minute', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Period = function (a) {
	return {$: 'Period', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Second = function (a) {
	return {$: 'Second', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0 = function (a) {
	return {$: 'Hour12From0', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1 = function (a) {
	return {$: 'Hour12From1', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0 = function (a) {
	return {$: 'Hour24From0', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1 = function (a) {
	return {$: 'Hour24From1', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat = function (a) {
	return {$: 'ZoneGmtFormat', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneIso8601Basic = {$: 'ZoneIso8601Basic'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$FlexibleDayPeriod = function (a) {
	return {$: 'FlexibleDayPeriod', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds = function (a) {
	return {$: 'FractionalSeconds', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat = function (a) {
	return {$: 'ZoneNonLocationFormat', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat = function (a) {
	return {$: 'ZoneGenericNonLocationFormat', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$timeSymbolParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'a', $enkidatron$elm_cldr$Internal$FormatSymbols$Period),
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'B', $enkidatron$elm_cldr$Internal$FormatSymbols$FlexibleDayPeriod),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'h', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'H', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'K', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'k', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'm', $enkidatron$elm_cldr$Internal$FormatSymbols$Minute),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 's', $enkidatron$elm_cldr$Internal$FormatSymbols$Second),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'SSS',
			$enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(3)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'SS',
			$enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(2)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'S',
			$enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(1)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'zzzz',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Long)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'zzz',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'zz',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'z',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWord, 'Z', $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneIso8601Basic),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'OOOO',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Long)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'O',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'vvvv',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Long)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'v',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short))
		]));
var $enkidatron$elm_cldr$Internal$Parse$timeSymbols = function (info) {
	return A2(
		$enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern,
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run(
				$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
					$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$timeSymbolParser))),
			$elm$core$Result$toMaybe),
		info.timePatterns);
};
var $enkidatron$elm_cldr$Internal$Locale$Root = {$: 'Root'};
var $joneshf$elm_tagged$Tagged$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		return $joneshf$elm_tagged$Tagged$Tagged(
			f(x));
	});
var $elm$core$String$toLower = _String_toLower;
var $elm$core$String$toUpper = _String_toUpper;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm$core$String$cons = _String_cons;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{multiline: false, caseInsensitive: false},
		string);
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\u005Cw+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.match;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\u005Cs+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.match;
			},
			uppercaseMatch),
		ws);
};
var $enkidatron$elm_cldr$Internal$Locale$normalize = function (langId) {
	if (langId.$ === 'Root') {
		return $enkidatron$elm_cldr$Internal$Locale$Root;
	} else {
		var langTag = langId.a;
		var maybeScript = langId.b;
		var maybeRegion = langId.c;
		var maybeVariant = langId.d;
		return A4(
			$enkidatron$elm_cldr$Internal$Locale$Lang,
			A2($joneshf$elm_tagged$Tagged$map, $elm$core$String$toLower, langTag),
			A2(
				$elm$core$Maybe$map,
				$joneshf$elm_tagged$Tagged$map($elm_community$string_extra$String$Extra$toTitleCase),
				maybeScript),
			A2(
				$elm$core$Maybe$map,
				$joneshf$elm_tagged$Tagged$map($elm$core$String$toUpper),
				maybeRegion),
			A2(
				$elm$core$Maybe$map,
				$joneshf$elm_tagged$Tagged$map($elm$core$String$toUpper),
				maybeVariant));
	}
};
var $enkidatron$elm_cldr$Internal$Parse$toLanguageId = function (info) {
	return (info.language === 'root') ? $enkidatron$elm_cldr$Internal$Locale$Root : $enkidatron$elm_cldr$Internal$Locale$normalize(
		A4(
			$enkidatron$elm_cldr$Internal$Locale$Lang,
			$joneshf$elm_tagged$Tagged$Tagged(info.language),
			A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$Tagged, info.script),
			A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$Tagged, info.territory),
			A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$Tagged, info.variant)));
};
var $enkidatron$elm_cldr$Internal$Locale$Text = function (a) {
	return {$: 'Text', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$DateGoesHere = {$: 'DateGoesHere'};
var $enkidatron$elm_cldr$Internal$Locale$TimeGoesHere = {$: 'TimeGoesHere'};
var $enkidatron$elm_cldr$Internal$Parse$dateTimeTokenParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($enkidatron$elm_cldr$Internal$Parse$parseWord, '{1}', $enkidatron$elm_cldr$Internal$Locale$DateGoesHere),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWord, '{0}', $enkidatron$elm_cldr$Internal$Locale$TimeGoesHere),
			A2(
			$elm$parser$Parser$map,
			$enkidatron$elm_cldr$Internal$Locale$Text,
			$elm$parser$Parser$variable(
				{
					inner: function (c) {
						return (!$elm$core$Char$isAlpha(c)) && ((!_Utils_eq(
							c,
							_Utils_chr('\''))) && (!_Utils_eq(
							c,
							_Utils_chr('{'))));
					},
					start: function (c) {
						return (!$elm$core$Char$isAlpha(c)) && ((!_Utils_eq(
							c,
							_Utils_chr('\''))) && (!_Utils_eq(
							c,
							_Utils_chr('{'))));
					},
					reserved: $elm$core$Set$empty
				})),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Locale$Text),
				$elm$parser$Parser$symbol('\u0027')),
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompUntil('\u0027')),
				$elm$parser$Parser$symbol('\u0027')))
		]));
var $enkidatron$elm_cldr$Internal$Parse$dateTimeTokens = function (info) {
	return A2(
		$enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern,
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run(
				$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper($enkidatron$elm_cldr$Internal$Parse$dateTimeTokenParser)),
			$elm$core$Result$toMaybe),
		info.dateTimePatterns);
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 'Nothing') {
			return mb;
		} else {
			return ma;
		}
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $enkidatron$elm_cldr$Internal$Parse$dayPeriodRules = F2(
	function (dayPeriods, info) {
		var fullTag = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(info.language),
						info.script,
						info.territory,
						info.variant
					])));
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				A2($elm$core$Dict$get, fullTag, dayPeriods),
				A2($elm$core$Dict$get, info.language, dayPeriods)));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (head.$ === 'Just') {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $elm$core$String$endsWith = _String_endsWith;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $enkidatron$elm_cldr$Internal$Parse$unsupportedKeys = $elm$core$Set$fromList(
	_List_fromArray(
		['MMMMW-count-zero', 'MMMMW-count-one', 'MMMMW-count-two', 'MMMMW-count-few', 'MMMMW-count-many', 'MMMMW-count-other', 'MEd-alt-variant', 'Md-alt-variant', 'MMdd-alt-variant', 'yQ', 'yQQQ', 'yQQQQ', 'yMEd-alt-variant', 'yMd-alt-variant', 'yw-count-zero', 'yw-count-one', 'yw-count-two', 'yw-count-few', 'yw-count-many', 'yw-count-other']));
var $enkidatron$elm_cldr$Internal$Parse$isSupportedKey = function (key) {
	return (!A2($elm$core$Set$member, key, $enkidatron$elm_cldr$Internal$Parse$unsupportedKeys)) && (!A2($elm$core$String$endsWith, '-alt-ascii', key));
};
var $enkidatron$elm_cldr$Internal$Locale$DateAF = function (a) {
	return {$: 'DateAF', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$TimeAF = function (a) {
	return {$: 'TimeAF', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$DateTimeAF = function (a) {
	return {$: 'DateTimeAF', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$DateSet = function (a) {
	return {$: 'DateSet', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$TimeSet = function (a) {
	return {$: 'TimeSet', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$EmptySet = {$: 'EmptySet'};
var $enkidatron$elm_cldr$Internal$Options$dateSubset = function (opts) {
	return {day: opts.day, era: opts.era, year: opts.year, month: opts.month, weekday: opts.weekday};
};
var $enkidatron$elm_cldr$Internal$Options$timeSubset = function (opts) {
	return {hour: opts.hour, zone: opts.zone, hour12: opts.hour12, minute: opts.minute, period: opts.period, second: opts.second, dayPeriod: opts.dayPeriod, fractionalSecondDigits: opts.fractionalSecondDigits};
};
var $enkidatron$elm_cldr$Internal$Options$DateTimeSet = function (a) {
	return {$: 'DateTimeSet', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$hasDateFields = function (opts) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				!_Utils_eq(opts.era, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.year, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.month, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.day, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.weekday, $elm$core$Maybe$Nothing)
			]));
};
var $enkidatron$elm_cldr$Internal$Options$hasTimeFields = function (opts) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				!_Utils_eq(opts.period, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.hour, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.minute, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.second, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.fractionalSecondDigits, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.zone, $elm$core$Maybe$Nothing)
			]));
};
var $enkidatron$elm_cldr$Internal$Options$shrinkOptions = function (opts) {
	var _v0 = _Utils_Tuple2(
		$enkidatron$elm_cldr$Internal$Options$hasDateFields(opts),
		$enkidatron$elm_cldr$Internal$Options$hasTimeFields(opts));
	if (_v0.a) {
		if (_v0.b) {
			return $enkidatron$elm_cldr$Internal$Options$DateTimeSet(opts);
		} else {
			return $enkidatron$elm_cldr$Internal$Options$DateSet(
				$enkidatron$elm_cldr$Internal$Options$dateSubset(opts));
		}
	} else {
		if (_v0.b) {
			return $enkidatron$elm_cldr$Internal$Options$TimeSet(
				$enkidatron$elm_cldr$Internal$Options$timeSubset(opts));
		} else {
			return $enkidatron$elm_cldr$Internal$Options$EmptySet;
		}
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Date = function (a) {
	return {$: 'Date', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Time = function (a) {
	return {$: 'Time', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$formatSymbolParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$parser$Parser$map, $enkidatron$elm_cldr$Internal$FormatSymbols$Date, $enkidatron$elm_cldr$Internal$Parse$dateSymbolParser),
			A2($elm$parser$Parser$map, $enkidatron$elm_cldr$Internal$FormatSymbols$Time, $enkidatron$elm_cldr$Internal$Parse$timeSymbolParser)
		]));
var $enkidatron$elm_cldr$Internal$Parse$availableFormatForOptions = F2(
	function (options, pattern) {
		var _v0 = $enkidatron$elm_cldr$Internal$Options$shrinkOptions(options);
		switch (_v0.$) {
			case 'DateTimeSet':
				var dtOpts = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (symbols) {
						return $enkidatron$elm_cldr$Internal$Locale$DateTimeAF(
							{options: dtOpts, formatSymbols: symbols});
					},
					$elm$core$Result$toMaybe(
						A2(
							$elm$parser$Parser$run,
							$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
								$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$formatSymbolParser)),
							pattern)));
			case 'DateSet':
				var dOpts = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (symbols) {
						return $enkidatron$elm_cldr$Internal$Locale$DateAF(
							{options: dOpts, formatSymbols: symbols});
					},
					$elm$core$Result$toMaybe(
						A2(
							$elm$parser$Parser$run,
							$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
								$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$dateSymbolParser)),
							pattern)));
			case 'TimeSet':
				var tOpts = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (symbols) {
						return $enkidatron$elm_cldr$Internal$Locale$TimeAF(
							{options: tOpts, formatSymbols: symbols});
					},
					$elm$core$Result$toMaybe(
						A2(
							$elm$parser$Parser$run,
							$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
								$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$timeSymbolParser)),
							pattern)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Options$Numeric = {$: 'Numeric'};
var $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit = {$: 'TwoDigit'};
var $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords = function (list) {
	return $elm$parser$Parser$oneOf(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var word = _v0.a;
					var item = _v0.b;
					return A2(
						$enkidatron$elm_cldr$Internal$Parse$parseWord,
						word,
						$elm$core$Maybe$Just(item));
				},
				list),
			_List_fromArray(
				[
					$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
				])));
};
var $enkidatron$elm_cldr$Internal$Parse$parseDay = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('dd', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('d', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$Long = {$: 'Long'};
var $enkidatron$elm_cldr$Cldr$Format$Options$Short = {$: 'Short'};
var $enkidatron$elm_cldr$Cldr$Format$Options$Narrow = {$: 'Narrow'};
var $enkidatron$elm_cldr$Internal$Parse$parseEra = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('GGGGG', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('GGGG', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('G', $enkidatron$elm_cldr$Cldr$Format$Options$Short)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$Hour12 = {$: 'Hour12'};
var $enkidatron$elm_cldr$Cldr$Format$Options$Hour24 = {$: 'Hour24'};
var $enkidatron$elm_cldr$Internal$Parse$parseHour = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hh',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit, $enkidatron$elm_cldr$Cldr$Format$Options$Hour12)),
			_Utils_Tuple2(
			'h',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$Numeric, $enkidatron$elm_cldr$Cldr$Format$Options$Hour12)),
			_Utils_Tuple2(
			'HH',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit, $enkidatron$elm_cldr$Cldr$Format$Options$Hour24)),
			_Utils_Tuple2(
			'H',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$Numeric, $enkidatron$elm_cldr$Cldr$Format$Options$Hour24))
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseYear = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('yy', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('y', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$LongName = {$: 'LongName'};
var $enkidatron$elm_cldr$Cldr$Format$Options$ShortName = {$: 'ShortName'};
var $enkidatron$elm_cldr$Internal$Parse$parseZone = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('zzzz', $enkidatron$elm_cldr$Cldr$Format$Options$LongName),
			_Utils_Tuple2('z', $enkidatron$elm_cldr$Cldr$Format$Options$ShortName),
			_Utils_Tuple2('vvvv', $enkidatron$elm_cldr$Cldr$Format$Options$LongName),
			_Utils_Tuple2('v', $enkidatron$elm_cldr$Cldr$Format$Options$ShortName),
			_Utils_Tuple2('Z', $enkidatron$elm_cldr$Cldr$Format$Options$ShortName)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$Text = function (a) {
	return {$: 'Text', a: a};
};
var $enkidatron$elm_cldr$Cldr$Format$Options$Number = function (a) {
	return {$: 'Number', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$parseMonth = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'MMMMM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Text($enkidatron$elm_cldr$Cldr$Format$Options$Narrow)),
			_Utils_Tuple2(
			'MMMM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Text($enkidatron$elm_cldr$Cldr$Format$Options$Long)),
			_Utils_Tuple2(
			'MMM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Text($enkidatron$elm_cldr$Cldr$Format$Options$Short)),
			_Utils_Tuple2(
			'MM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Number($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit)),
			_Utils_Tuple2(
			'M',
			$enkidatron$elm_cldr$Cldr$Format$Options$Number($enkidatron$elm_cldr$Cldr$Format$Options$Numeric))
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseMinute = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('mm', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('m', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parsePeriod = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('aaaaa', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('aaaa', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('a', $enkidatron$elm_cldr$Cldr$Format$Options$Short)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseSecond = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('ss', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('s', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseWeekday = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('EEEEE', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('EEEE', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('E', $enkidatron$elm_cldr$Cldr$Format$Options$Short),
			_Utils_Tuple2('cccc', $enkidatron$elm_cldr$Cldr$Format$Options$Long)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseDayPeriod = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('BBBBB', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('BBBB', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('BBB', $enkidatron$elm_cldr$Cldr$Format$Options$Short),
			_Utils_Tuple2('BB', $enkidatron$elm_cldr$Cldr$Format$Options$Short),
			_Utils_Tuple2('B', $enkidatron$elm_cldr$Cldr$Format$Options$Short)
		]));
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $enkidatron$elm_cldr$Internal$Parse$buildKeyOptions = function (era) {
	return function (year) {
		return function (month) {
			return function (weekday) {
				return function (day) {
					return function (period) {
						return function (dayPeriod) {
							return function (hourAndType) {
								return function (minute) {
									return function (second) {
										return function (zone) {
											return {
												day: day,
												era: era,
												hour: A2($elm$core$Maybe$map, $elm$core$Tuple$first, hourAndType),
												year: year,
												zone: zone,
												month: month,
												hour12: A2($elm$core$Maybe$map, $elm$core$Tuple$second, hourAndType),
												minute: minute,
												period: period,
												second: second,
												weekday: weekday,
												dayPeriod: dayPeriod,
												fractionalSecondDigits: $elm$core$Maybe$Nothing
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $enkidatron$elm_cldr$Internal$Parse$availableFormatKeyOptionsParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$keeper,
											$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Parse$buildKeyOptions),
											$enkidatron$elm_cldr$Internal$Parse$parseEra),
										$enkidatron$elm_cldr$Internal$Parse$parseYear),
									$enkidatron$elm_cldr$Internal$Parse$parseMonth),
								$enkidatron$elm_cldr$Internal$Parse$parseWeekday),
							$enkidatron$elm_cldr$Internal$Parse$parseDay),
						$enkidatron$elm_cldr$Internal$Parse$parsePeriod),
					$enkidatron$elm_cldr$Internal$Parse$parseDayPeriod),
				$enkidatron$elm_cldr$Internal$Parse$parseHour),
			$enkidatron$elm_cldr$Internal$Parse$parseMinute),
		$enkidatron$elm_cldr$Internal$Parse$parseSecond),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$Parse$parseZone, $elm$parser$Parser$end));
var $enkidatron$elm_cldr$Internal$Parse$parseOptionsFromAvailableFormatKey = $elm$parser$Parser$run($enkidatron$elm_cldr$Internal$Parse$availableFormatKeyOptionsParser);
var $enkidatron$elm_cldr$Internal$Parse$parseAvailableFormat = function (_v0) {
	var key = _v0.a;
	var pattern = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function (opts) {
			return A2($enkidatron$elm_cldr$Internal$Parse$availableFormatForOptions, opts, pattern);
		},
		$elm$core$Result$toMaybe(
			$enkidatron$elm_cldr$Internal$Parse$parseOptionsFromAvailableFormatKey(key)));
};
var $enkidatron$elm_cldr$Internal$Parse$availableFormatList = function (info) {
	return $elm_community$maybe_extra$Maybe$Extra$combine(
		A2(
			$elm$core$List$map,
			$enkidatron$elm_cldr$Internal$Parse$parseAvailableFormat,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $enkidatron$elm_cldr$Internal$Parse$isSupportedKey),
				info.availableFormats)));
};
var $elm$core$String$contains = _String_contains;
var $enkidatron$elm_cldr$Internal$Parse$twelveHourByDefault = function (info) {
	var allPatterns = _List_fromArray(
		[info.timeSkeletons._short, info.timeSkeletons.medium, info.timeSkeletons._long, info.timeSkeletons.full]);
	var contains12Hour = A2(
		$elm$core$List$any,
		$elm$core$String$contains('h'),
		allPatterns);
	var contains24Hour = A2(
		$elm$core$List$any,
		$elm$core$String$contains('H'),
		allPatterns);
	var _v0 = _Utils_Tuple2(contains12Hour, contains24Hour);
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(true);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(false);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $enkidatron$elm_cldr$Internal$Parse$parseInfo = F2(
	function (dayPeriods, info) {
		return A2(
			$elm$core$Maybe$map,
			$enkidatron$elm_cldr$Internal$Locale$Locale,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$apR(
					$elm$core$Dict$fromList(info.currencySymbols)),
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$apR(info.percentNumberFormat),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$apR(info.currencyNumberFormat),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$apR(info.decimalNumberFormat),
							A2(
								$elm_community$maybe_extra$Maybe$Extra$andMap,
								$enkidatron$elm_cldr$Internal$Parse$twelveHourByDefault(info),
								A2(
									$elm_community$maybe_extra$Maybe$Extra$andMap,
									$enkidatron$elm_cldr$Internal$Parse$availableFormatList(info),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$apR(
											$enkidatron$elm_cldr$Internal$Parse$toLanguageId(info)),
										A2(
											$elm_community$maybe_extra$Maybe$Extra$andMap,
											$enkidatron$elm_cldr$Internal$Parse$dateTimeTokens(info),
											A2(
												$elm_community$maybe_extra$Maybe$Extra$andMap,
												$enkidatron$elm_cldr$Internal$Parse$timeSymbols(info),
												A2(
													$elm_community$maybe_extra$Maybe$Extra$andMap,
													$enkidatron$elm_cldr$Internal$Parse$dateSymbols(info),
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$apR(
															A2($enkidatron$elm_cldr$Internal$Parse$dayPeriodRules, dayPeriods, info)),
														A2(
															$elm$core$Maybe$map,
															$elm$core$Basics$apR(info.periodNames),
															A2(
																$elm$core$Maybe$map,
																$elm$core$Basics$apR(info.eraNames),
																A2(
																	$elm$core$Maybe$map,
																	$elm$core$Basics$apR(info.weekdayStandaloneNames),
																	A2(
																		$elm$core$Maybe$map,
																		$elm$core$Basics$apR(info.weekdayFormatNames),
																		A2(
																			$elm$core$Maybe$map,
																			$elm$core$Basics$apR(info.monthStandaloneNames),
																			A2(
																				$elm$core$Maybe$map,
																				$elm$core$Basics$apR(info.monthFormatNames),
																				$elm$core$Maybe$Just($enkidatron$elm_cldr$Internal$Locale$Internal)))))))))))))))))));
	});
var $enkidatron$elm_cldr$Internal$Parse$parse = F2(
	function (dayPeriods, text) {
		return A2(
			$elm$core$Maybe$andThen,
			$enkidatron$elm_cldr$Internal$Parse$parseInfo(dayPeriods),
			$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parse(text));
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$At = F2(
	function (a, b) {
		return {$: 'At', a: a, b: b};
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore = F3(
	function (a, b, c) {
		return {$: 'FromBefore', a: a, b: b, c: c};
	});
var $enkidatron$elm_cldr$Generated$En$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'en',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$En$en = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en = $enkidatron$elm_cldr$Generated$En$en;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $enkidatron$elm_cldr$Generated$En$en_GB = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GB||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMEEEEd|EEEE d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMEEEEd|EEEE d MMM|MMMMd|d MMMM|MMMMEEEEd|EEEE d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMEEEEd|EEEE d MMM y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GB = $enkidatron$elm_cldr$Generated$En$en_GB;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $tremlab$bugsnag_elm$BugsnagElm$Info = {$: 'Info'};
var $tremlab$bugsnag_elm$BugsnagElm$Error = {$: 'Error'};
var $elm$core$Maybe$isJust = function (maybe) {
	if (maybe.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 'BadUrl_', a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 'Sending', a: a};
};
var $elm$http$Http$Timeout_ = {$: 'Timeout_'};
var $elm$http$Http$Receiving = function (a) {
	return {$: 'Receiving', a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 'BadStatus_', a: a, b: b};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 'GoodStatus_', a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$http$Http$resultToTask = function (result) {
	if (result.$ === 'Ok') {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		_Utils_Tuple0,
		$elm$http$Http$resultToTask,
		{url: r.url, body: r.body, expect: r.resolver, method: r.method, headers: r.headers, timeout: r.timeout, tracker: $elm$core$Maybe$Nothing, allowCookiesFromOtherDomains: false});
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 'Header', a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				dictionary));
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $tremlab$bugsnag_elm$BugsnagElm$severityToString = function (report) {
	switch (report.$) {
		case 'Error':
			return 'error';
		case 'Info':
			return 'info';
		default:
			return 'warning';
	}
};
var $tremlab$bugsnag_elm$BugsnagElm$bugsnagElmVersion = '1.0.0';
var $tremlab$bugsnag_elm$BugsnagElm$toJsonBody = F5(
	function (bugsnagConfig, severity, message, context, metadata) {
		var userInfo = function () {
			var _v0 = bugsnagConfig.user;
			if (_v0.$ === 'Just') {
				var user = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'user',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(user.id)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(user.username)),
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(user.email))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'payloadVersion',
						$elm$json$Json$Encode$string('5')),
						_Utils_Tuple2(
						'notifier',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('bugsnag-elm')),
									_Utils_Tuple2(
									'version',
									$elm$json$Json$Encode$string($tremlab$bugsnag_elm$BugsnagElm$bugsnagElmVersion)),
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string('https://github.com/noredink/bugsnag-elm'))
								]))),
						_Utils_Tuple2(
						'events',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$object(
									_Utils_ap(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'exceptions',
												A2(
													$elm$json$Json$Encode$list,
													$elm$core$Basics$identity,
													_List_fromArray(
														[
															$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'errorClass',
																	$elm$json$Json$Encode$string(message)),
																	_Utils_Tuple2(
																	'stacktrace',
																	A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil))
																]))
														]))),
												_Utils_Tuple2(
												'context',
												$elm$json$Json$Encode$string(context)),
												_Utils_Tuple2(
												'severity',
												$elm$json$Json$Encode$string(
													$tremlab$bugsnag_elm$BugsnagElm$severityToString(severity))),
												_Utils_Tuple2(
												'metadata',
												A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, metadata)),
												_Utils_Tuple2(
												'app',
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'version',
															$elm$json$Json$Encode$string(bugsnagConfig.appVersion)),
															_Utils_Tuple2(
															'releaseStage',
															$elm$json$Json$Encode$string(bugsnagConfig.releaseStage)),
															_Utils_Tuple2(
															'type',
															$elm$json$Json$Encode$string('elm'))
														])))
											]),
										userInfo))
								])))
					])));
	});
var $tremlab$bugsnag_elm$BugsnagElm$endpointUrl = 'https://notify.bugsnag.com';
var $elm$http$Http$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $elm$http$Http$Timeout = {$: 'Timeout'};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $elm$http$Http$NetworkError = {$: 'NetworkError'};
var $tremlab$bugsnag_elm$BugsnagElm$resolveNotify = function (response) {
	switch (response.$) {
		case 'BadUrl_':
			var url = response.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadUrl(url));
		case 'Timeout_':
			return $elm$core$Result$Err($elm$http$Http$Timeout);
		case 'NetworkError_':
			return $elm$core$Result$Err($elm$http$Http$NetworkError);
		case 'BadStatus_':
			var metadata = response.a;
			var body = response.b;
			return $elm$core$Result$Err(
				$elm$http$Http$BadStatus(metadata.statusCode));
		default:
			return $elm$core$Result$Ok(_Utils_Tuple0);
	}
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $tremlab$bugsnag_elm$BugsnagElm$notify = F5(
	function (bugsnagConfig, severity, message, context, metadata) {
		var shouldSend = $elm$core$List$isEmpty(bugsnagConfig.enabledReleaseStages) || A2($elm$core$List$member, bugsnagConfig.releaseStage, bugsnagConfig.enabledReleaseStages);
		var body = A5($tremlab$bugsnag_elm$BugsnagElm$toJsonBody, bugsnagConfig, severity, message, context, metadata);
		if (shouldSend) {
			return $elm$http$Http$task(
				{
					url: $tremlab$bugsnag_elm$BugsnagElm$endpointUrl,
					body: body,
					method: 'POST',
					headers: _List_fromArray(
						[
							A2($elm$http$Http$header, 'Bugsnag-Api-Key', bugsnagConfig.apiKey),
							A2($elm$http$Http$header, 'Bugsnag-Payload-Version', '5')
						]),
					timeout: $elm$core$Maybe$Nothing,
					resolver: $elm$http$Http$stringResolver($tremlab$bugsnag_elm$BugsnagElm$resolveNotify)
				});
		} else {
			return $elm$core$Task$succeed(_Utils_Tuple0);
		}
	});
var $tremlab$bugsnag_elm$BugsnagElm$Warning = {$: 'Warning'};
var $tremlab$bugsnag_elm$BugsnagElm$start = function (bugsnagConfig) {
	return {
		info: A2($tremlab$bugsnag_elm$BugsnagElm$notify, bugsnagConfig, $tremlab$bugsnag_elm$BugsnagElm$Info),
		error: A2($tremlab$bugsnag_elm$BugsnagElm$notify, bugsnagConfig, $tremlab$bugsnag_elm$BugsnagElm$Error),
		warning: A2($tremlab$bugsnag_elm$BugsnagElm$notify, bugsnagConfig, $tremlab$bugsnag_elm$BugsnagElm$Warning)
	};
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Data$User$User = F7(
	function (accountId, email, firstName, lastName, profilePhoto, isAdmin, roles) {
		return {email: email, roles: roles, isAdmin: isAdmin, lastName: lastName, accountId: accountId, firstName: firstName, profilePhoto: profilePhoto};
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$map2 = _Json_map2;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (_v0.$ === 'Ok') {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (_v1.$ === 'Ok') {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Data$User$FleetUser = {$: 'FleetUser'};
var $author$project$Data$User$Administrator = {$: 'Administrator'};
var $author$project$Data$User$parseRole = function (role) {
	switch (role) {
		case 'administrator':
			return $elm$core$Maybe$Just($author$project$Data$User$Administrator);
		case 'user':
			return $elm$core$Maybe$Just($author$project$Data$User$FleetUser);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$User$roleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (role) {
		var _v0 = $author$project$Data$User$parseRole(role);
		if (_v0.$ === 'Just') {
			var r = _v0.a;
			return $elm$json$Json$Decode$succeed(r);
		} else {
			return $elm$json$Json$Decode$fail('Invalid role: ' + role);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$User$AccountId = function (a) {
	return {$: 'AccountId', a: a};
};
var $author$project$Data$User$accountIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$User$AccountId, $elm$json$Json$Decode$string);
var $author$project$Data$User$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'roles',
	$elm$json$Json$Decode$dict($author$project$Data$User$roleDecoder),
	$elm$core$Dict$fromList(_List_Nil),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'isAdmin',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'profilePhoto',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lastName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'firstName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'accountId',
							$author$project$Data$User$accountIdDecoder,
							$elm$json$Json$Decode$succeed($author$project$Data$User$User))))))));
var $author$project$Data$Fleet$Fleet = function (fleetId) {
	return function (slug) {
		return function (name) {
			return function (isPrivate) {
				return function (timeZoneId) {
					return function (latitude) {
						return function (longitude) {
							return function (zoom) {
								return function (shortDistanceUnit) {
									return function (longDistanceUnit) {
										return function (speedUnit) {
											return function (isHelmEnabled) {
												return function (isSeaRescue) {
													return function (fleetType) {
														return function (speedAlertsEnabled) {
															return function (notificationGroups) {
																return function (helmConfiguration) {
																	return function (watermarkImage) {
																		return function (guestViewConfiguration) {
																			return {name: name, slug: slug, zoom: zoom, fleetId: fleetId, latitude: latitude, fleetType: fleetType, isPrivate: isPrivate, longitude: longitude, speedUnit: speedUnit, timeZoneId: timeZoneId, isSeaRescue: isSeaRescue, isHelmEnabled: isHelmEnabled, watermarkImage: watermarkImage, longDistanceUnit: longDistanceUnit, helmConfiguration: helmConfiguration, shortDistanceUnit: shortDistanceUnit, notificationGroups: notificationGroups, speedAlertsEnabled: speedAlertsEnabled, guestViewConfiguration: guestViewConfiguration};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Data$SpeedUnit$Knots = {$: 'Knots'};
var $author$project$Data$SpeedUnit$MilesPerHour = {$: 'MilesPerHour'};
var $author$project$Data$SpeedUnit$KilometresPerHour = {$: 'KilometresPerHour'};
var $author$project$Data$SpeedUnit$parse = function (s) {
	switch (s) {
		case 'knots':
			return $elm$core$Maybe$Just($author$project$Data$SpeedUnit$Knots);
		case 'kilometersPerHour':
			return $elm$core$Maybe$Just($author$project$Data$SpeedUnit$KilometresPerHour);
		case 'milesPerHour':
			return $elm$core$Maybe$Just($author$project$Data$SpeedUnit$MilesPerHour);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$SpeedUnit$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$SpeedUnit$parse(s);
		if (_v0.$ === 'Just') {
			var u = _v0.a;
			return $elm$json$Json$Decode$succeed(u);
		} else {
			return $elm$json$Json$Decode$fail('Unknown speed unit: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$DistanceUnit$Miles = {$: 'Miles'};
var $author$project$Data$DistanceUnit$Yards = {$: 'Yards'};
var $author$project$Data$DistanceUnit$Metres = {$: 'Metres'};
var $author$project$Data$DistanceUnit$Kilometres = {$: 'Kilometres'};
var $author$project$Data$DistanceUnit$NauticalMiles = {$: 'NauticalMiles'};
var $author$project$Data$DistanceUnit$parse = function (s) {
	switch (s) {
		case 'meters':
			return $elm$core$Maybe$Just($author$project$Data$DistanceUnit$Metres);
		case 'yards':
			return $elm$core$Maybe$Just($author$project$Data$DistanceUnit$Yards);
		case 'nauticalMiles':
			return $elm$core$Maybe$Just($author$project$Data$DistanceUnit$NauticalMiles);
		case 'kilometers':
			return $elm$core$Maybe$Just($author$project$Data$DistanceUnit$Kilometres);
		case 'miles':
			return $elm$core$Maybe$Just($author$project$Data$DistanceUnit$Miles);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$DistanceUnit$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$DistanceUnit$parse(s);
		if (_v0.$ === 'Just') {
			var u = _v0.a;
			return $elm$json$Json$Decode$succeed(u);
		} else {
			return $elm$json$Json$Decode$fail('Unknown distance unit: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Fleet$Tourism = {$: 'Tourism'};
var $author$project$Data$Fleet$FleetId = function (a) {
	return {$: 'FleetId', a: a};
};
var $author$project$Data$Fleet$fleetIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Fleet$FleetId, $elm$json$Json$Decode$string);
var $author$project$Data$Fleet$Rescue = {$: 'Rescue'};
var $author$project$Data$Fleet$Commuter = {$: 'Commuter'};
var $author$project$Data$Fleet$Vehicles = {$: 'Vehicles'};
var $author$project$Data$Fleet$Workboats = {$: 'Workboats'};
var $author$project$Data$Fleet$fleetTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'tourism':
				return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$Tourism);
			case 'workboats':
				return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$Workboats);
			case 'rescue':
				return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$Rescue);
			case 'commuter':
				return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$Commuter);
			case 'vehicles':
				return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$Vehicles);
			default:
				return $elm$json$Json$Decode$fail('Unknown FleetType: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Fleet$HelmConfiguration = F3(
	function (tenantId, apiKey, eventTypeId) {
		return {apiKey: apiKey, tenantId: tenantId, eventTypeId: eventTypeId};
	});
var $author$project$Data$Fleet$helmConfigurationDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Fleet$HelmConfiguration,
	A2($elm$json$Json$Decode$field, 'tenantId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'apiKey', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'eventTypeId', $elm$json$Json$Decode$string));
var $author$project$Data$Fleet$AllNotifications = {$: 'AllNotifications'};
var $author$project$Data$Fleet$legacyNotificationGroups = function (recipients) {
	return $elm$core$List$isEmpty(recipients) ? _List_Nil : _List_fromArray(
		[
			{
			name: 'All notifications',
			recipients: recipients,
			subscriptions: _List_fromArray(
				[$author$project$Data$Fleet$AllNotifications])
		}
		]);
};
var $author$project$Data$Fleet$NotificationGroup = F3(
	function (name, recipients, subscriptions) {
		return {name: name, recipients: recipients, subscriptions: subscriptions};
	});
var $author$project$Data$Fleet$SMS = function (a) {
	return {$: 'SMS', a: a};
};
var $author$project$Data$Fleet$Email = function (a) {
	return {$: 'Email', a: a};
};
var $author$project$Data$Fleet$notificationRecipientDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Fleet$Email,
			A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Fleet$SMS,
			A2($elm$json$Json$Decode$field, 'sms', $elm$json$Json$Decode$string))
		]));
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$AlertType$HighWater = {$: 'HighWater'};
var $author$project$Data$AlertType$OverSpeed = {$: 'OverSpeed'};
var $author$project$Data$AlertType$LowBattery = {$: 'LowBattery'};
var $author$project$Data$AlertType$RestrictedZone = {$: 'RestrictedZone'};
var $author$project$Data$Fleet$AlertNotification = function (a) {
	return {$: 'AlertNotification', a: a};
};
var $author$project$Data$AlertType$AfterHoursMovement = {$: 'AfterHoursMovement'};
var $author$project$Data$Fleet$GeofenceNotification = {$: 'GeofenceNotification'};
var $author$project$Data$Fleet$notificationSubscriptions = _List_fromArray(
	[
		$author$project$Data$Fleet$GeofenceNotification,
		$author$project$Data$Fleet$AlertNotification($author$project$Data$AlertType$OverSpeed),
		$author$project$Data$Fleet$AlertNotification($author$project$Data$AlertType$RestrictedZone),
		$author$project$Data$Fleet$AlertNotification($author$project$Data$AlertType$LowBattery),
		$author$project$Data$Fleet$AlertNotification($author$project$Data$AlertType$HighWater),
		$author$project$Data$Fleet$AlertNotification($author$project$Data$AlertType$AfterHoursMovement)
	]);
var $author$project$Data$Fleet$notificationSubscriptionToString = function (s) {
	switch (s.$) {
		case 'AllNotifications':
			return 'all';
		case 'GeofenceNotification':
			return 'geofence_notify';
		default:
			switch (s.a.$) {
				case 'CapsizeAlert':
					var _v1 = s.a;
					return 'capsize_alert';
				case 'RestrictedZone':
					var _v2 = s.a;
					return 'restricted_zone';
				case 'OverSpeed':
					var _v3 = s.a;
					return 'over_speed';
				case 'LowBattery':
					var _v4 = s.a;
					return 'low_battery';
				case 'HighWater':
					var _v5 = s.a;
					return 'high_water';
				default:
					var _v6 = s.a;
					return 'after_hours_movement';
			}
	}
};
var $author$project$Data$Fleet$notificationSubscriptionFromString = function (s) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (n) {
				return _Utils_eq(
					$author$project$Data$Fleet$notificationSubscriptionToString(n),
					s);
			},
			A2($elm$core$List$cons, $author$project$Data$Fleet$AllNotifications, $author$project$Data$Fleet$notificationSubscriptions)));
};
var $author$project$Data$Fleet$notificationSubscriptionDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Fleet$notificationSubscriptionFromString, $elm$json$Json$Decode$string);
var $author$project$Data$Fleet$notificationGroupDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Fleet$NotificationGroup,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'recipients',
		$elm$json$Json$Decode$list($author$project$Data$Fleet$notificationRecipientDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'subscriptions',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$json$Json$Decode$list($author$project$Data$Fleet$notificationSubscriptionDecoder))));
var $author$project$Data$Fleet$notificationGroupsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'notificationGroups',
			$elm$json$Json$Decode$list($author$project$Data$Fleet$notificationGroupDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Fleet$legacyNotificationGroups,
			A2(
				$elm$json$Json$Decode$field,
				'notificationRecipients',
				$elm$json$Json$Decode$list($author$project$Data$Fleet$notificationRecipientDecoder))),
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$Data$Fleet$GuestViewConfiguration = F4(
	function (dashboardKey, displayRoutes, showPopup, autoDisplayPlaceDistance) {
		return {showPopup: showPopup, dashboardKey: dashboardKey, displayRoutes: displayRoutes, autoDisplayPlaceDistance: autoDisplayPlaceDistance};
	});
var $author$project$Data$Fleet$All = {$: 'All'};
var $author$project$Data$Fleet$None = {$: 'None'};
var $author$project$Data$Fleet$Specified = function (a) {
	return {$: 'Specified', a: a};
};
var $author$project$Data$Route$RouteId = function (a) {
	return {$: 'RouteId', a: a};
};
var $author$project$Data$Route$routeIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Route$RouteId, $elm$json$Json$Decode$string);
var $author$project$Data$Fleet$routeVisibilityDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (s) {
				switch (s) {
					case 'all':
						return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$All);
					case 'none':
						return $elm$json$Json$Decode$succeed($author$project$Data$Fleet$None);
					default:
						return $elm$json$Json$Decode$fail('Unknown RouteVisibility: ' + s);
				}
			},
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Fleet$Specified,
			A2(
				$elm$json$Json$Decode$field,
				'specified',
				$elm$json$Json$Decode$list($author$project$Data$Route$routeIdDecoder)))
		]));
var $author$project$Data$Fleet$guestViewConfigurationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'autoDisplayPlaceDistance',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'showPopup',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'displayRoutes',
			$author$project$Data$Fleet$routeVisibilityDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'dashboardKey',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$Fleet$GuestViewConfiguration)))));
var $author$project$Data$Fleet$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'guestViewConfiguration',
	$elm$json$Json$Decode$maybe($author$project$Data$Fleet$guestViewConfigurationDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'watermarkImage',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'helmConfiguration',
			$elm$json$Json$Decode$maybe($author$project$Data$Fleet$helmConfigurationDecoder),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Data$Fleet$notificationGroupsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'speedAlertsEnabled',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'fleetType',
						$author$project$Data$Fleet$fleetTypeDecoder,
						$author$project$Data$Fleet$Tourism,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'isSeaRescue',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'isHelmEnabled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'speedUnit',
									$author$project$Data$SpeedUnit$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'longDistanceUnit',
										$author$project$Data$DistanceUnit$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'shortDistanceUnit',
											$author$project$Data$DistanceUnit$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'zoom',
												$elm$json$Json$Decode$float,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'longitude',
													$elm$json$Json$Decode$float,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'latitude',
														$elm$json$Json$Decode$float,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'timeZoneId',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'isPrivate',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'name',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'slug',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'fleetId',
																			$author$project$Data$Fleet$fleetIdDecoder,
																			$elm$json$Json$Decode$succeed($author$project$Data$Fleet$Fleet))))))))))))))))))));
var $author$project$Data$Session$Session = F3(
	function (user, fleets, authToken) {
		return {user: user, fleets: fleets, authToken: authToken};
	});
var $author$project$Data$Session$Token = function (a) {
	return {$: 'Token', a: a};
};
var $elm$core$String$toInt = _String_toInt;
var $jweir$elm_iso8601$ISO8601$Extras$toInt = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(str));
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $jweir$elm_iso8601$ISO8601$parseOffset = function (timeString) {
	var match = A3(
		$elm$regex$Regex$findAtMost,
		1,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('([-+])(\u005Cd\u005Cd):?(\u005Cd\u005Cd)')),
		A2($elm$core$Maybe$withDefault, '', timeString));
	var parts = A2(
		$elm$core$List$map,
		function ($) {
			return $.submatches;
		},
		match);
	var calc = F2(
		function (modifier, minutes) {
			switch (modifier) {
				case '+':
					return minutes;
				case '-':
					return (-1) * minutes;
				default:
					return minutes;
			}
		});
	_v0$2:
	while (true) {
		if ((((parts.b && parts.a.b) && (parts.a.a.$ === 'Just')) && parts.a.b.b) && (parts.a.b.a.$ === 'Just')) {
			if (parts.a.b.b.b) {
				if (((parts.a.b.b.a.$ === 'Just') && (!parts.a.b.b.b.b)) && (!parts.b.b)) {
					var _v1 = parts.a;
					var modifier = _v1.a.a;
					var _v2 = _v1.b;
					var hour_ = _v2.a.a;
					var _v3 = _v2.b;
					var minute_ = _v3.a.a;
					return A2(
						calc,
						modifier,
						($jweir$elm_iso8601$ISO8601$Extras$toInt(hour_) * 60) + $jweir$elm_iso8601$ISO8601$Extras$toInt(minute_));
				} else {
					break _v0$2;
				}
			} else {
				if (!parts.b.b) {
					var _v4 = parts.a;
					var modifier = _v4.a.a;
					var _v5 = _v4.b;
					var hour_ = _v5.a.a;
					return A2(
						calc,
						modifier,
						$jweir$elm_iso8601$ISO8601$Extras$toInt(hour_) * 60);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $jweir$elm_iso8601$ISO8601$iso8601Regex = A2(
	$elm$regex$Regex$findAtMost,
	1,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^' + ('(\u005Cd{4})-?' + ('(\u005Cd{2})?-?' + ('(\u005Cd{2})?' + ('T?' + ('(\u005Cd{2})?:?' + ('(\u005Cd{2})?:?' + ('(\u005Cd{2})?' + ('([.,]\u005Cd{1,})?' + ('(Z|[+-]\u005Cd{2}:?\u005Cd{2})?' + '(.*)?'))))))))))));
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{tail: jsArray, nodeList: nodeList, nodeListSize: nodeListSize});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $jweir$elm_iso8601$ISO8601$Extras$calendar = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_Utils_Tuple3('January', 31, 31),
			_Utils_Tuple3('February', 28, 29),
			_Utils_Tuple3('March', 31, 31),
			_Utils_Tuple3('April', 30, 30),
			_Utils_Tuple3('May', 31, 31),
			_Utils_Tuple3('June', 30, 30),
			_Utils_Tuple3('July', 31, 31),
			_Utils_Tuple3('August', 31, 31),
			_Utils_Tuple3('September', 30, 30),
			_Utils_Tuple3('October', 31, 31),
			_Utils_Tuple3('November', 30, 30),
			_Utils_Tuple3('December', 31, 31)
		]));
var $elm$core$Basics$modBy = _Basics_modBy;
var $jweir$elm_iso8601$ISO8601$Extras$isLeapYear = function (year) {
	var c = !A2($elm$core$Basics$modBy, 400, year);
	var b = !A2($elm$core$Basics$modBy, 100, year);
	var a = !A2($elm$core$Basics$modBy, 4, year);
	var _v0 = _List_fromArray(
		[a, b, c]);
	_v0$3:
	while (true) {
		if ((_v0.b && _v0.a) && _v0.b.b) {
			if (!_v0.b.a) {
				if (_v0.b.b.b && (!_v0.b.b.b.b)) {
					var _v3 = _v0.b;
					var _v4 = _v3.b;
					return true;
				} else {
					break _v0$3;
				}
			} else {
				if (_v0.b.b.b) {
					if (_v0.b.b.a) {
						if (!_v0.b.b.b.b) {
							var _v1 = _v0.b;
							var _v2 = _v1.b;
							return true;
						} else {
							break _v0$3;
						}
					} else {
						if (!_v0.b.b.b.b) {
							var _v5 = _v0.b;
							var _v6 = _v5.b;
							return false;
						} else {
							break _v0$3;
						}
					}
				} else {
					break _v0$3;
				}
			}
		} else {
			break _v0$3;
		}
	}
	return false;
};
var $jweir$elm_iso8601$ISO8601$Extras$daysInMonth = F2(
	function (year, monthInt) {
		var calMonth = A2($elm$core$Array$get, monthInt - 1, $jweir$elm_iso8601$ISO8601$Extras$calendar);
		if (calMonth.$ === 'Just') {
			var _v1 = calMonth.a;
			var days = _v1.b;
			var leapDays = _v1.c;
			return $jweir$elm_iso8601$ISO8601$Extras$isLeapYear(year) ? leapDays : days;
		} else {
			return 0;
		}
	});
var $jweir$elm_iso8601$ISO8601$validateHour = function (time) {
	var s = time.second;
	var m = time.minute;
	var h = time.hour;
	return ((h === 24) && ((m + s) > 0)) ? $elm$core$Result$Err('hour is out of range') : (((h < 0) || (h > 24)) ? $elm$core$Result$Err('hour is out of range') : (((m < 0) || (m > 59)) ? $elm$core$Result$Err('minute is out of range') : (((s < 0) || (s > 59)) ? $elm$core$Result$Err('second is out of range') : $elm$core$Result$Ok(time))));
};
var $jweir$elm_iso8601$ISO8601$validateTime = function (time) {
	return ((time.month < 1) || (time.month > 12)) ? $elm$core$Result$Err('month is out of range') : (((time.day < 1) || (_Utils_cmp(
		time.day,
		A2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth, time.year, time.month)) > 0)) ? $elm$core$Result$Err('day is out of range') : $jweir$elm_iso8601$ISO8601$validateHour(time));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $jweir$elm_iso8601$ISO8601$parseMilliseconds = function (msString) {
	if (msString.$ === 'Nothing') {
		return 0;
	} else {
		var s = msString.a;
		var decimalStr = A4(
			$elm$regex$Regex$replaceAtMost,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[,.]')),
			function (_v1) {
				return '0.';
			},
			s);
		var decimal = A2(
			$elm$core$Maybe$withDefault,
			0.0,
			$elm$core$String$toFloat(decimalStr));
		return $elm$core$Basics$round(1000 * decimal);
	}
};
var $jweir$elm_iso8601$ISO8601$fromString = function (s) {
	var unwrap = F2(
		function (x, d) {
			return $jweir$elm_iso8601$ISO8601$Extras$toInt(
				A2($elm$core$Maybe$withDefault, d, x));
		});
	var parts = A2(
		$elm$core$List$map,
		function ($) {
			return $.submatches;
		},
		$jweir$elm_iso8601$ISO8601$iso8601Regex(s));
	if (((((((((((parts.b && parts.a.b) && parts.a.b.b) && parts.a.b.b.b) && parts.a.b.b.b.b) && parts.a.b.b.b.b.b) && parts.a.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b.b.b) && (!parts.a.b.b.b.b.b.b.b.b.b.b)) && (!parts.b.b)) {
		var _v1 = parts.a;
		var y = _v1.a;
		var _v2 = _v1.b;
		var mon = _v2.a;
		var _v3 = _v2.b;
		var d = _v3.a;
		var _v4 = _v3.b;
		var h = _v4.a;
		var _v5 = _v4.b;
		var min = _v5.a;
		var _v6 = _v5.b;
		var sec = _v6.a;
		var _v7 = _v6.b;
		var mil = _v7.a;
		var _v8 = _v7.b;
		var off = _v8.a;
		var _v9 = _v8.b;
		var invalid = _v9.a;
		if (invalid.$ === 'Just') {
			return $elm$core$Result$Err('unexpected text');
		} else {
			return $jweir$elm_iso8601$ISO8601$validateTime(
				{
					day: A2(unwrap, d, '1'),
					hour: A2(unwrap, h, '0'),
					year: A2(unwrap, y, '0'),
					month: A2(unwrap, mon, '1'),
					minute: A2(unwrap, min, '0'),
					offset: $jweir$elm_iso8601$ISO8601$parseOffset(off),
					second: A2(unwrap, sec, '0'),
					millisecond: $jweir$elm_iso8601$ISO8601$parseMilliseconds(mil)
				});
		}
	} else {
		return $elm$core$Result$Err('Unable to parse time');
	}
};
var $jweir$elm_iso8601$ISO8601$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		var _v0 = $jweir$elm_iso8601$ISO8601$fromString(v);
		if (_v0.$ === 'Err') {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		} else {
			var t = _v0.a;
			return $elm$json$Json$Decode$succeed(t);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $jweir$elm_iso8601$ISO8601$ims = 1;
var $jweir$elm_iso8601$ISO8601$isec = $jweir$elm_iso8601$ISO8601$ims * 1000;
var $jweir$elm_iso8601$ISO8601$imin = $jweir$elm_iso8601$ISO8601$isec * 60;
var $jweir$elm_iso8601$ISO8601$ihour = $jweir$elm_iso8601$ISO8601$imin * 60;
var $jweir$elm_iso8601$ISO8601$iday = $jweir$elm_iso8601$ISO8601$ihour * 24;
var $jweir$elm_iso8601$ISO8601$Extras$daysInYear = function (year) {
	return $jweir$elm_iso8601$ISO8601$Extras$isLeapYear(year) ? 366 : 365;
};
var $jweir$elm_iso8601$ISO8601$offsetToTime = function (time) {
	return time.offset * $jweir$elm_iso8601$ISO8601$imin;
};
var $jweir$elm_iso8601$ISO8601$toTime = function (time) {
	if (time.year < 1970) {
		var totalDays = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$jweir$elm_iso8601$ISO8601$Extras$daysInMonth(time.year),
				A2($elm$core$List$range, 1, time.month)));
		var years = A2(
			$elm$core$List$map,
			$jweir$elm_iso8601$ISO8601$Extras$daysInYear,
			A2($elm$core$List$range, time.year + 1, 1970 - 1));
		var tots = _List_fromArray(
			[
				$jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(years),
				$jweir$elm_iso8601$ISO8601$iday * ($jweir$elm_iso8601$ISO8601$Extras$daysInYear(time.year) - totalDays),
				$jweir$elm_iso8601$ISO8601$iday * (A2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth, time.year, time.month) - time.day),
				($jweir$elm_iso8601$ISO8601$iday - $jweir$elm_iso8601$ISO8601$ihour) - ($jweir$elm_iso8601$ISO8601$ihour * time.hour),
				($jweir$elm_iso8601$ISO8601$ihour - $jweir$elm_iso8601$ISO8601$imin) - ($jweir$elm_iso8601$ISO8601$imin * time.minute),
				$jweir$elm_iso8601$ISO8601$imin - ($jweir$elm_iso8601$ISO8601$isec * time.second),
				$jweir$elm_iso8601$ISO8601$offsetToTime(time)
			]);
		return 0 - ($elm$core$List$sum(tots) - time.millisecond);
	} else {
		var months = A2(
			$elm$core$List$map,
			$jweir$elm_iso8601$ISO8601$Extras$daysInMonth(time.year),
			A2($elm$core$List$range, 1, time.month - 1));
		var years = A2(
			$elm$core$List$map,
			$jweir$elm_iso8601$ISO8601$Extras$daysInYear,
			A2($elm$core$List$range, 1970, time.year - 1));
		var tots = _List_fromArray(
			[
				$jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(years),
				$jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(months),
				$jweir$elm_iso8601$ISO8601$iday * (time.day - 1),
				$jweir$elm_iso8601$ISO8601$ihour * time.hour,
				$jweir$elm_iso8601$ISO8601$imin * time.minute,
				$jweir$elm_iso8601$ISO8601$isec * time.second,
				(-1) * $jweir$elm_iso8601$ISO8601$offsetToTime(time)
			]);
		return $elm$core$List$sum(tots) + time.millisecond;
	}
};
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $jweir$elm_iso8601$ISO8601$toPosix = function (time) {
	return $elm$time$Time$millisToPosix(
		$jweir$elm_iso8601$ISO8601$toTime(time));
};
var $author$project$Data$Session$AuthToken = F2(
	function (token, expiry) {
		return {token: token, expiry: expiry};
	});
var $author$project$Data$Session$authTokenDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Session$AuthToken,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Session$Token,
		A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'expiry',
		A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$toPosix, $jweir$elm_iso8601$ISO8601$decode)));
var $author$project$Data$Session$decode = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Session$Session,
	A2($elm$json$Json$Decode$field, 'user', $author$project$Data$User$decode),
	A2(
		$elm$json$Json$Decode$field,
		'fleets',
		$elm$json$Json$Decode$list($author$project$Data$Fleet$decode)),
	A2($elm$json$Json$Decode$field, 'authToken', $author$project$Data$Session$authTokenDecoder));
var $author$project$Data$TrackDuration$LastHour = {$: 'LastHour'};
var $author$project$Data$TrackDuration$Last7Days = {$: 'Last7Days'};
var $author$project$Data$TrackDuration$Last14Days = {$: 'Last14Days'};
var $author$project$Data$TrackDuration$Last30Days = {$: 'Last30Days'};
var $author$project$Data$TrackDuration$Last24Hours = {$: 'Last24Hours'};
var $author$project$Data$TrackDuration$LastTripToday = {$: 'LastTripToday'};
var $author$project$Data$TrackDuration$parse = function (str) {
	switch (str) {
		case 'last':
			return $elm$core$Maybe$Just($author$project$Data$TrackDuration$LastTripToday);
		case 'hour':
			return $elm$core$Maybe$Just($author$project$Data$TrackDuration$LastHour);
		case 'day':
			return $elm$core$Maybe$Just($author$project$Data$TrackDuration$Last24Hours);
		case 'week':
			return $elm$core$Maybe$Just($author$project$Data$TrackDuration$Last7Days);
		case 'fortnight':
			return $elm$core$Maybe$Just($author$project$Data$TrackDuration$Last14Days);
		case 'month':
			return $elm$core$Maybe$Just($author$project$Data$TrackDuration$Last30Days);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$TrackDuration$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$TrackDuration$parse(s);
		if (_v0.$ === 'Just') {
			var range = _v0.a;
			return $elm$json$Json$Decode$succeed(range);
		} else {
			return $elm$json$Json$Decode$fail('Invalid TrackDuration: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$core$List$sortWith = _List_sortWith;
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$FeatureDrop$State$priorityRank = function (priority) {
	if (priority.$ === 'Just') {
		switch (priority.a.$) {
			case 'Critical':
				var _v1 = priority.a;
				return 0;
			case 'Normal':
				var _v2 = priority.a;
				return 1;
			default:
				var _v3 = priority.a;
				return 2;
		}
	} else {
		return 1;
	}
};
var $author$project$FeatureDrop$State$compareFeatures = F2(
	function (a, b) {
		var _v0 = A2(
			$elm$core$Basics$compare,
			$author$project$FeatureDrop$State$priorityRank(a.priority),
			$author$project$FeatureDrop$State$priorityRank(b.priority));
		if (_v0.$ === 'EQ') {
			return A2($justinmimbs$date$Date$compare, b.releasedAt, a.releasedAt);
		} else {
			var order = _v0;
			return order;
		}
	});
var $author$project$FeatureDrop$State$sortByPriority = function (features) {
	return A2($elm$core$List$sortWith, $author$project$FeatureDrop$State$compareFeatures, features);
};
var $author$project$FeatureDrop$State$build = F6(
	function (manifest, newFeatures, watermark, dismissedIds, dependencyState, triggerContext) {
		return {
			locale: $enkidatron$elm_cldr$Cldr$Locale$en,
			manifest: manifest,
			newCount: $elm$core$List$length(newFeatures),
			watermark: watermark,
			dismissing: $elm$core$Set$empty,
			newFeatures: newFeatures,
			dismissedIds: dismissedIds,
			triggerContext: triggerContext,
			dependencyState: dependencyState,
			newFeaturesSorted: $author$project$FeatureDrop$State$sortByPriority(newFeatures)
		};
	});
var $author$project$FeatureDrop$Manifest$FeatureCTA = F2(
	function (label, url) {
		return {url: url, label: label};
	});
var $author$project$FeatureDrop$Manifest$ctaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$FeatureCTA)));
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (result.$ === 'Ok') {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(_Utils_Tuple0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return _Utils_eq(
											c,
											_Utils_chr('-'));
									}),
									$elm$parser$Parser$succeed(_Utils_Tuple0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(_Utils_Tuple0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$commit = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, true, a, s);
		});
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 'OrdinalDay', a: a};
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 'MonthAndDay', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0.a;
	return $elm$parser$Parser$Advanced$Parser(
		function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 'Bad') {
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, false, x);
			} else {
				var a = _v1.b;
				var s1 = _v1.c;
				return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
			}
		});
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 'WeekAndWeekday', a: a, b: b};
	});
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (result.$ === 'Ok') {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$RD = function (a) {
	return {$: 'RD', a: a};
};
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$RD(
		$justinmimbs$date$Date$daysBeforeYear(y) + 1);
};
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(jan4));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn)));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				$justinmimbs$date$Date$daysBeforeYear(y) + od));
	});
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jan = {$: 'Jan'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		default:
			return $elm$time$Time$Dec;
	}
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeYear(y) + A2(
					$justinmimbs$date$Date$daysBeforeMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + d)));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 'MonthAndDay':
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 'WeekAndWeekday':
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.problem;
	if (problem.$ === 'Problem') {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq(
										_Utils_chr('T')))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$FeatureDrop$Manifest$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$FeatureDrop$Manifest$metaDecoder = $elm$json$Json$Decode$dict($elm$json$Json$Decode$value);
var $author$project$FeatureDrop$Manifest$FeatureEntry = function (id) {
	return function (label) {
		return function (description) {
			return function (version) {
				return function (releasedAt) {
					return function (showNewUntil) {
						return function (sidebarKey) {
							return function (category) {
								return function (product) {
									return function (url) {
										return function (flagKey) {
											return function (type_) {
												return function (priority) {
													return function (image) {
														return function (cta) {
															return function (publishAt) {
																return function (meta) {
																	return function (variants) {
																		return function (variantSplit) {
																			return function (audience) {
																				return function (dependsOn) {
																					return function (trigger) {
																						return {id: id, cta: cta, url: url, meta: meta, image: image, label: label, type_: type_, flagKey: flagKey, product: product, trigger: trigger, version: version, audience: audience, category: category, priority: priority, variants: variants, dependsOn: dependsOn, publishAt: publishAt, releasedAt: releasedAt, sidebarKey: sidebarKey, description: description, showNewUntil: showNewUntil, variantSplit: variantSplit};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$json_extra$Json$Decode$Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$value),
				json);
			if (_v0.$ === 'Ok') {
				var val = _v0.a;
				return A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, fieldName, decoder));
			} else {
				return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
			}
		};
		return A2($elm$json$Json$Decode$andThen, finishDecoding, $elm$json$Json$Decode$value);
	});
var $author$project$FeatureDrop$Manifest$optionalField = F2(
	function (key, valueDecoder) {
		return $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom(
			A2($elm_community$json_extra$Json$Decode$Extra$optionalField, key, valueDecoder));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$FeatureDrop$Manifest$PageTrigger = function (a) {
	return {$: 'PageTrigger', a: a};
};
var $author$project$FeatureDrop$Manifest$TimeTrigger = function (a) {
	return {$: 'TimeTrigger', a: a};
};
var $author$project$FeatureDrop$Manifest$UsageTrigger = function (a) {
	return {$: 'UsageTrigger', a: a};
};
var $author$project$FeatureDrop$Manifest$ScrollTrigger = function (a) {
	return {$: 'ScrollTrigger', a: a};
};
var $author$project$FeatureDrop$Manifest$MilestoneTrigger = function (a) {
	return {$: 'MilestoneTrigger', a: a};
};
var $author$project$FeatureDrop$Manifest$FrustrationTrigger = function (a) {
	return {$: 'FrustrationTrigger', a: a};
};
var $author$project$FeatureDrop$Manifest$triggerDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (t) {
		switch (t) {
			case 'page':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$FeatureDrop$Manifest$PageTrigger,
					A2($elm$json$Json$Decode$field, 'match', $elm$json$Json$Decode$string));
			case 'usage':
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (event, minActions) {
							return $author$project$FeatureDrop$Manifest$UsageTrigger(
								{event: event, minActions: minActions});
						}),
					A2($elm$json$Json$Decode$field, 'event', $elm$json$Json$Decode$string),
					A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'minActions', $elm$json$Json$Decode$int));
			case 'time':
				return A2(
					$elm$json$Json$Decode$map,
					function (minSeconds) {
						return $author$project$FeatureDrop$Manifest$TimeTrigger(
							{minSeconds: minSeconds});
					},
					A2($elm$json$Json$Decode$field, 'minSeconds', $elm$json$Json$Decode$float));
			case 'milestone':
				return A2(
					$elm$json$Json$Decode$map,
					function (event) {
						return $author$project$FeatureDrop$Manifest$MilestoneTrigger(
							{event: event});
					},
					A2($elm$json$Json$Decode$field, 'event', $elm$json$Json$Decode$string));
			case 'frustration':
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (pattern, threshold) {
							return $author$project$FeatureDrop$Manifest$FrustrationTrigger(
								{pattern: pattern, threshold: threshold});
						}),
					A2($elm$json$Json$Decode$field, 'pattern', $elm$json$Json$Decode$string),
					A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'threshold', $elm$json$Json$Decode$float));
			case 'scroll':
				return A2(
					$elm$json$Json$Decode$map,
					function (minPercent) {
						return $author$project$FeatureDrop$Manifest$ScrollTrigger(
							{minPercent: minPercent});
					},
					A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'minPercent', $elm$json$Json$Decode$float));
			case 'custom':
				return $elm$json$Json$Decode$fail('\u0022custom\u0022 triggers carry a function and cannot be decoded from JSON');
			default:
				return $elm$json$Json$Decode$fail('Unknown FeatureTrigger type: ' + t);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$FeatureDrop$Manifest$FeatureVariant = F5(
	function (label, description, image, cta, meta) {
		return {cta: cta, meta: meta, image: image, label: label, description: description};
	});
var $author$project$FeatureDrop$Manifest$variantDecoder = A3(
	$author$project$FeatureDrop$Manifest$optionalField,
	'meta',
	$author$project$FeatureDrop$Manifest$metaDecoder,
	A3(
		$author$project$FeatureDrop$Manifest$optionalField,
		'cta',
		$author$project$FeatureDrop$Manifest$ctaDecoder,
		A3(
			$author$project$FeatureDrop$Manifest$optionalField,
			'image',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$FeatureDrop$Manifest$optionalField,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$FeatureDrop$Manifest$optionalField,
					'label',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$FeatureVariant))))));
var $author$project$FeatureDrop$Manifest$VersionRange = function (a) {
	return {$: 'VersionRange', a: a};
};
var $author$project$FeatureDrop$Manifest$VersionString = function (a) {
	return {$: 'VersionString', a: a};
};
var $author$project$FeatureDrop$Manifest$versionDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$FeatureDrop$Manifest$VersionString, $elm$json$Json$Decode$string),
			A3(
			$author$project$FeatureDrop$Manifest$optionalField,
			'showIn',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$FeatureDrop$Manifest$optionalField,
				'deprecatedAt',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$FeatureDrop$Manifest$optionalField,
					'showNewUntil',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$FeatureDrop$Manifest$optionalField,
						'introduced',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed(
							F4(
								function (introduced, showNewUntil, deprecatedAt, showIn) {
									return $author$project$FeatureDrop$Manifest$VersionRange(
										{showIn: showIn, introduced: introduced, deprecatedAt: deprecatedAt, showNewUntil: showNewUntil});
								}))))))
		]));
var $author$project$FeatureDrop$Manifest$Fix = {$: 'Fix'};
var $author$project$FeatureDrop$Manifest$Feature = {$: 'Feature'};
var $author$project$FeatureDrop$Manifest$Breaking = {$: 'Breaking'};
var $author$project$FeatureDrop$Manifest$Improvement = {$: 'Improvement'};
var $author$project$FeatureDrop$Manifest$featureTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'feature':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Feature);
			case 'improvement':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Improvement);
			case 'fix':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Fix);
			case 'breaking':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Breaking);
			default:
				return $elm$json$Json$Decode$fail('Unknown FeatureType: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$FeatureDrop$Manifest$AudienceRule = F4(
	function (plan, role, region, custom) {
		return {plan: plan, role: role, custom: custom, region: region};
	});
var $author$project$FeatureDrop$Manifest$audienceRuleDecoder = A3(
	$author$project$FeatureDrop$Manifest$optionalField,
	'custom',
	$author$project$FeatureDrop$Manifest$metaDecoder,
	A3(
		$author$project$FeatureDrop$Manifest$optionalField,
		'region',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$author$project$FeatureDrop$Manifest$optionalField,
			'role',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$author$project$FeatureDrop$Manifest$optionalField,
				'plan',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$AudienceRule)))));
var $author$project$FeatureDrop$Manifest$FeatureDependencies = F3(
	function (seen, clicked, dismissed) {
		return {seen: seen, clicked: clicked, dismissed: dismissed};
	});
var $author$project$FeatureDrop$Manifest$dependenciesDecoder = A3(
	$author$project$FeatureDrop$Manifest$optionalField,
	'dismissed',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$author$project$FeatureDrop$Manifest$optionalField,
		'clicked',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$author$project$FeatureDrop$Manifest$optionalField,
			'seen',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$FeatureDependencies))));
var $author$project$FeatureDrop$Manifest$Low = {$: 'Low'};
var $author$project$FeatureDrop$Manifest$Normal = {$: 'Normal'};
var $author$project$FeatureDrop$Manifest$Critical = {$: 'Critical'};
var $author$project$FeatureDrop$Manifest$featurePriorityDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'critical':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Critical);
			case 'normal':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Normal);
			case 'low':
				return $elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$Low);
			default:
				return $elm$json$Json$Decode$fail('Unknown FeaturePriority: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$FeatureDrop$Manifest$entryDecoder = A3(
	$author$project$FeatureDrop$Manifest$optionalField,
	'trigger',
	$author$project$FeatureDrop$Manifest$triggerDecoder,
	A3(
		$author$project$FeatureDrop$Manifest$optionalField,
		'dependsOn',
		$author$project$FeatureDrop$Manifest$dependenciesDecoder,
		A3(
			$author$project$FeatureDrop$Manifest$optionalField,
			'audience',
			$author$project$FeatureDrop$Manifest$audienceRuleDecoder,
			A3(
				$author$project$FeatureDrop$Manifest$optionalField,
				'variantSplit',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$float),
				A3(
					$author$project$FeatureDrop$Manifest$optionalField,
					'variants',
					$elm$json$Json$Decode$dict($author$project$FeatureDrop$Manifest$variantDecoder),
					A3(
						$author$project$FeatureDrop$Manifest$optionalField,
						'meta',
						$author$project$FeatureDrop$Manifest$metaDecoder,
						A3(
							$author$project$FeatureDrop$Manifest$optionalField,
							'publishAt',
							$author$project$FeatureDrop$Manifest$dateDecoder,
							A3(
								$author$project$FeatureDrop$Manifest$optionalField,
								'cta',
								$author$project$FeatureDrop$Manifest$ctaDecoder,
								A3(
									$author$project$FeatureDrop$Manifest$optionalField,
									'image',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$FeatureDrop$Manifest$optionalField,
										'priority',
										$author$project$FeatureDrop$Manifest$featurePriorityDecoder,
										A3(
											$author$project$FeatureDrop$Manifest$optionalField,
											'type',
											$author$project$FeatureDrop$Manifest$featureTypeDecoder,
											A3(
												$author$project$FeatureDrop$Manifest$optionalField,
												'flagKey',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$FeatureDrop$Manifest$optionalField,
													'url',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$FeatureDrop$Manifest$optionalField,
														'product',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$FeatureDrop$Manifest$optionalField,
															'category',
															$elm$json$Json$Decode$string,
															A3(
																$author$project$FeatureDrop$Manifest$optionalField,
																'sidebarKey',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'showNewUntil',
																	$author$project$FeatureDrop$Manifest$dateDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'releasedAt',
																		$author$project$FeatureDrop$Manifest$dateDecoder,
																		A3(
																			$author$project$FeatureDrop$Manifest$optionalField,
																			'version',
																			$author$project$FeatureDrop$Manifest$versionDecoder,
																			A3(
																				$author$project$FeatureDrop$Manifest$optionalField,
																				'description',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'label',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'id',
																						$elm$json$Json$Decode$string,
																						$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$FeatureEntry)))))))))))))))))))))));
var $author$project$FeatureDrop$Manifest$decoder = $elm$json$Json$Decode$list($author$project$FeatureDrop$Manifest$entryDecoder);
var $author$project$FeatureDrop$State$stringSetDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Set$fromList,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$FeatureDrop$Manifest$TriggerContext = F7(
	function (path, events, milestones, usage, elapsedMs, scrollPercent, metadata) {
		return {path: path, usage: usage, events: events, metadata: metadata, elapsedMs: elapsedMs, milestones: milestones, scrollPercent: scrollPercent};
	});
var $author$project$FeatureDrop$Manifest$optionalStringSet = function (key) {
	return $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom(
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(_List_Nil),
				$elm$core$Set$fromList),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				key,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
};
var $author$project$FeatureDrop$Manifest$triggerContextDecoder = A3(
	$author$project$FeatureDrop$Manifest$optionalField,
	'metadata',
	$author$project$FeatureDrop$Manifest$metaDecoder,
	A3(
		$author$project$FeatureDrop$Manifest$optionalField,
		'scrollPercent',
		$elm$json$Json$Decode$float,
		A3(
			$author$project$FeatureDrop$Manifest$optionalField,
			'elapsedMs',
			$elm$json$Json$Decode$float,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault($elm$core$Dict$empty),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$optionalField,
						'usage',
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$float))),
				A2(
					$author$project$FeatureDrop$Manifest$optionalStringSet,
					'milestones',
					A2(
						$author$project$FeatureDrop$Manifest$optionalStringSet,
						'events',
						A3(
							$author$project$FeatureDrop$Manifest$optionalField,
							'path',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$TriggerContext))))))));
var $author$project$FeatureDrop$Manifest$FeatureDependencyState = F3(
	function (seenIds, clickedIds, dismissedIds) {
		return {seenIds: seenIds, clickedIds: clickedIds, dismissedIds: dismissedIds};
	});
var $author$project$FeatureDrop$Manifest$dependencyStateDecoder = A2(
	$author$project$FeatureDrop$Manifest$optionalStringSet,
	'dismissedIds',
	A2(
		$author$project$FeatureDrop$Manifest$optionalStringSet,
		'clickedIds',
		A2(
			$author$project$FeatureDrop$Manifest$optionalStringSet,
			'seenIds',
			$elm$json$Json$Decode$succeed($author$project$FeatureDrop$Manifest$FeatureDependencyState))));
var $author$project$FeatureDrop$State$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'triggerContext',
	$elm$json$Json$Decode$nullable($author$project$FeatureDrop$Manifest$triggerContextDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dependencyState',
		$author$project$FeatureDrop$Manifest$dependencyStateDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'dismissedIds',
			$author$project$FeatureDrop$State$stringSetDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'watermark',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'newFeatures',
					$elm$json$Json$Decode$list($author$project$FeatureDrop$Manifest$entryDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'manifest',
						$author$project$FeatureDrop$Manifest$decoder,
						$elm$json$Json$Decode$succeed($author$project$FeatureDrop$State$build)))))));
var $author$project$Gen$Route$NotFound = {$: 'NotFound'};
var $author$project$Gen$Route$toHref = function (route) {
	var joinAsHref = function (segments) {
		return '/' + A2($elm$core$String$join, '/', segments);
	};
	switch (route.$) {
		case 'Changelog':
			return joinAsHref(
				_List_fromArray(
					['changelog']));
		case 'Fleet_':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet]));
		case 'Forbidden':
			return joinAsHref(
				_List_fromArray(
					['forbidden']));
		case 'Home_':
			return joinAsHref(_List_Nil);
		case 'Login':
			return joinAsHref(
				_List_fromArray(
					['login']));
		case 'Register':
			return joinAsHref(
				_List_fromArray(
					['register']));
		case 'Fleet___Boats':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'boats']));
		case 'Fleet___Dashboard':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'dashboard']));
		case 'Fleet___DateRangeSummary':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'date-range-summary']));
		case 'Fleet___Discovery':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'discovery']));
		case 'Fleet___Edit':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'edit']));
		case 'Fleet___Geofences':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'geofences']));
		case 'Fleet___MonthlyUtilisation':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'monthly-utilisation']));
		case 'Fleet___NewBoat':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'new-boat']));
		case 'Fleet___OnTime':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'on-time']));
		case 'Fleet___Places':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'places']));
		case 'Fleet___Public':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'public']));
		case 'Fleet___Routes':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'routes']));
		case 'Fleet___Summary':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'summary']));
		case 'Fleet___Users':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'users']));
		case 'Fleet___Video':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'video']));
		case 'Fleet___WeeklyUtilisation':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'weekly-utilisation']));
		case 'Fleet___Boats__BoatId___Edit':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'boats', params.boatId, 'edit']));
		case 'Fleet___Boats__BoatId___Logs':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'boats', params.boatId, 'logs']));
		case 'Fleet___Public__BoatId_':
			var params = route.a;
			return joinAsHref(
				_List_fromArray(
					[params.fleet, 'public', params.boatId]));
		default:
			return joinAsHref(
				_List_fromArray(
					['not-found']));
	}
};
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {host: host, path: path, port_: port_, query: query, fragment: fragment, protocol: protocol};
	});
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Request$pushRoute = F2(
	function (route, req) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			req.key,
			$author$project$Gen$Route$toHref(route));
	});
var $author$project$FeatureDrop$State$setLocale = F2(
	function (locale, state) {
		return _Utils_update(
			state,
			{locale: locale});
	});
var $enkidatron$elm_cldr$Generated$Af$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'af',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Af$af = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Af$dayPeriods, 'af||||vm.|nm.|7|afternoon1|die middag|am|vm.|evening1|die aand|midnight|middernag|morning1|die oggend|night1|die nag|pm|nm.|vm.|nm.|7|afternoon1|die middag|am|vm.|evening1|die aand|midnight|middernag|morning1|die oggend|night1|die nag|pm|nm.|v|n|7|afternoon1|m|am|v|evening1|a|midnight|mn|morning1|o|night1|n|pm|n|y-MM-dd|dd MMM y|dd MMMM y|EEEE dd MMMM y|Jan.|Feb.|Mrt.|Apr.|Mei|Jun.|Jul.|Aug.|Sep.|Okt.|Nov.|Des.|Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|So.|Ma.|Di.|Wo.|Do.|Vr.|Sa.|Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag|S|M|D|W|D|V|S|0|v.C.|n.C.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|ccc|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d|Ehm|E hh:mm\u202Fa|EHm|E HH:mm|Ehms|E hh:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|dd MMM y G|GyMMMEd|E dd MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|MM-y|yMd|y-MM-dd|yMEd|E y-MM-dd|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027van\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027van\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-¤||¤||¤||E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|leu|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$af = $enkidatron$elm_cldr$Generated$Af$af;
var $enkidatron$elm_cldr$Generated$Am$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'am',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Am$am = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Am$dayPeriods, 'am||||ጥዋት|ከሰዓት|8|afternoon1|ከሰዓት|am|ጥዋት|evening1|በምሽት|midnight|እኩለ ሌሊት|morning1|ጥዋት|night1|በሌሊት|noon|ቀትር|pm|ከሰዓት|ጥዋት|ከሰዓት|8|afternoon1|ከሰዓት|am|ጥዋት|evening1|በምሽት|midnight|እኩለ ሌሊት|morning1|ጥዋት|night1|በሌሊት|noon|ቀትር|pm|ከሰዓት|ጠ|ከ|8|afternoon1|ከሰዓት|am|ጠ|evening1|በምሽት|midnight|እኩለ ሌሊት|morning1|ጥዋት|night1|በሌሊት|noon|ቀ|pm|ከ|dd/MM/y|d MMM y|d MMMM y|y MMMM d, EEEE|ጃን|ፌብ|ማርች|ኤፕሪ|ሜይ|ጁን|ጁላይ|ኦገስ|ሴፕቴ|ኦክቶ|ኖቬም|ዲሴም|ጃንዋሪ|ፌብሩዋሪ|ማርች|ኤፕሪል|ሜይ|ጁን|ጁላይ|ኦገስት|ሴፕቴምበር|ኦክቶበር|ኖቬምበር|ዲሴምበር|ጃ|ፌ|ማ|ኤ|ሜ|ጁ|ጁ|ኦ|ሴ|ኦ|ኖ|ዲ|0|እሑድ|ሰኞ|ማክሰ|ረቡዕ|ሐሙስ|ዓርብ|ቅዳሜ|እሑድ|ሰኞ|ማክሰኞ|ረቡዕ|ሐሙስ|ዓርብ|ቅዳሜ|እ|ሰ|ማ|ረ|ሐ|ዓ|ቅ|0|ዓ/ዓ|ዓ/ም|ዓመተ ዓለም|ዓመተ ምሕረት|ዓ/ዓ|ዓ/ም|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|H|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E፣ M/d|MMM|LLL|MMMd|MMM d|MMMEd|E፣ MMM d|MMMMd|MMMM d|MMMMEd|E፣ MMMM d|MMMMW-count-one|ሳምንት W የ MMMM|MMMMW-count-other|ሳምንት W የ MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E፣ d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E፣ MMM d y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNH|የቻይና ዩዋን|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|ETB|ብር|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$am = $enkidatron$elm_cldr$Generated$Am$am;
var $enkidatron$elm_cldr$Generated$Ar$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ar',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(3, 0),
					'night2')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ar$ar = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar = $enkidatron$elm_cldr$Generated$Ar$ar;
var $enkidatron$elm_cldr$Generated$Az$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'az',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(17, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(17, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Az$az = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Az$dayPeriods, 'az||||AM|PM|10|afternoon1|gündüz|am|AM|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|günorta|pm|PM|AM|PM|10|afternoon1|gündüz|am|AM|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|günorta|pm|PM|a|p|10|afternoon1|gündüz|am|a|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|g|pm|p|dd.MM.yy|d MMM y|d MMMM y|d MMMM y, EEEE|yan|fev|mar|apr|may|iyn|iyl|avq|sen|okt|noy|dek|yanvar|fevral|mart|aprel|may|iyun|iyul|avqust|sentyabr|oktyabr|noyabr|dekabr|1|2|3|4|5|6|7|8|9|10|11|12|0|B.|B.e.|Ç.a.|Ç.|C.a.|C.|Ş.|bazar|bazar ertəsi|çərşənbə axşamı|çərşənbə|cümə axşamı|cümə|şənbə|7|1|2|3|4|5|6|1|B.|B.E.|Ç.A.|Ç.|C.A.|C.|Ş.|bazar|bazar ertəsi|çərşənbə axşamı|çərşənbə|cümə axşamı|cümə|şənbə|7|1|2|3|4|5|6|e.ə.|y.e.|eramızdan əvvəl|yeni era|e.ə.|y.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG d MMM y|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMM, W \u0027həftə\u0027|MMMMW-count-other|MMMM, W \u0027həftə\u0027|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y, E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y, E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y, w \u0027həftə\u0027|yw-count-other|Y, w \u0027həftə\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|ley|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|S£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$az = $enkidatron$elm_cldr$Generated$Az$az;
var $enkidatron$elm_cldr$Generated$Be$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Be$be = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Be$dayPeriods, 'be||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|am|pm|2|am|am|pm|pm|d.MM.yy|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|сту|лют|сак|кра|мая|чэр|ліп|жні|вер|кас|ліс|сне|студзеня|лютага|сакавіка|красавіка|мая|чэрвеня|ліпеня|жніўня|верасня|кастрычніка|лістапада|снежня|с|л|с|к|м|ч|л|ж|в|к|л|с|1|сту|лют|сак|кра|май|чэр|ліп|жні|вер|кас|ліс|сне|студзень|люты|сакавік|красавік|май|чэрвень|ліпень|жнівень|верасень|кастрычнік|лістапад|снежань|с|л|с|к|м|ч|л|ж|в|к|л|с|нд|пн|аў|ср|чц|пт|сб|нядзеля|панядзелак|аўторак|серада|чацвер|пятніца|субота|н|п|а|с|ч|п|с|0|да н.э.|н.э.|да нараджэння Хрыстова|ад нараджэння Хрыстова|да н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss, zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|hh\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W \u0027тыдзень\u0027 MMMM|MMMMW-count-few|W \u0027тыдзень\u0027 MMMM|MMMMW-count-many|W \u0027тыдзень\u0027 MMMM|MMMMW-count-other|W \u0027тыдзень\u0027 MMMM|ms|mm.ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|LLL y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w \u0027тыдзень\u0027 Y|yw-count-few|w \u0027тыдзень\u0027 Y|yw-count-many|w \u0027тыдзень\u0027 Y|yw-count-other|w \u0027тыдзень\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BD$|BND|$|BOB|Bs|BRL|BRL|BSD|B$|BWP|P|BYN|Br|BZD|BZ$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|CUC$|CUP|$MN|CZK|Kč|DKK|kr|DOP|RD$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|FK£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|G$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|Íkr|JMD|J$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|CI$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|L$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|N$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|SI$|SEK|kr|SGD|S$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|$|UYU|$U|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$be = $enkidatron$elm_cldr$Generated$Be$be;
var $enkidatron$elm_cldr$Generated$Bg$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'bg',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(11, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(11, 0),
					_Utils_Tuple2(14, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Bg$bg = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bg$dayPeriods, 'bg||||am|pm|8|afternoon1|следобед|am|am|evening1|вечерта|midnight|полунощ|morning1|сутринта|morning2|на обяд|night1|през нощта|pm|pm|пр.об.|сл.об.|8|afternoon1|следобед|am|пр.об.|evening1|вечерта|midnight|полунощ|morning1|сутринта|morning2|на обяд|night1|през нощта|pm|сл.об.|am|pm|8|afternoon1|следобед|am|am|evening1|вечерта|midnight|полунощ|morning1|сутринта|morning2|на обяд|night1|през нощта|pm|pm|d.MM.yy\u202F\u0027г\u0027.|d.MM.y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|яну|фев|март|апр|май|юни|юли|авг|сеп|окт|ное|дек|януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември|я|ф|м|а|м|ю|ю|а|с|о|н|д|0|нд|пн|вт|ср|чт|пт|сб|неделя|понеделник|вторник|сряда|четвъртък|петък|събота|н|п|в|с|ч|п|с|0|пр.Хр.|сл.Хр.|преди Христа|след Христа|пр.Хр.|сл.Хр.|H:mm|H:mm:ss|H:mm:ss \u0027ч\u0027. z|H:mm:ss \u0027ч\u0027. zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h \u0027ч\u0027. B|Bhm|h:mm \u0027ч\u0027. B|Bhms|h:mm:ss \u0027ч\u0027. B|d|d|E|ccc|EBhm|E, h:mm \u0027ч\u0027. B|EBhms|E, h:mm:ss \u0027ч\u0027. B|Ed|E, d|Ehm|E, h:mm \u0027ч\u0027. a|EHm|E, HH:mm \u0027ч\u0027.|Ehms|E, h:mm:ss \u0027ч\u0027. a|EHms|E, HH:mm:ss \u0027ч\u0027.|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y\u202F\u0027г\u0027. GGGGG|GyMMM|MM.y\u202F\u0027г\u0027. G|GyMMMd|d.MM.y\u202F\u0027г\u0027. G|GyMMMEd|E, d.MM.y\u202F\u0027г\u0027. G|GyMMMM|MMMM y\u202F\u0027г\u0027. G|GyMMMMd|d MMMM y\u202F\u0027г\u0027. G|GyMMMMEd|E, d MMMM y\u202F\u0027г\u0027. G|h|h \u0027ч\u0027. a|H|HH \u0027ч\u0027.|hm|h:mm \u0027ч\u0027. a|Hm|HH:mm \u0027ч\u0027.|hms|h:mm:ss \u0027ч\u0027. a|Hms|HH:mm:ss \u0027ч\u0027.|hmsv|h:mm:ss \u0027ч\u0027. a v|Hmsv|HH:mm:ss \u0027ч\u0027. v|hmv|h:mm \u0027ч\u0027. a v|Hmv|HH:mm \u0027ч\u0027. v|M|L|Md|d.MM|MEd|E, d.MM|MMM|MM|MMMd|d.MM|MMMEd|E, d.MM|MMMM|LLLL|MMMMd|d MMMM|MMMMdd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027седмица\u0027 W \u0027от\u0027 MMMM|MMMMW-count-other|\u0027седмица\u0027 W \u0027от\u0027 MMMM|ms|m:ss|y|y\u202F\u0027г\u0027.|yM|MM.y\u202F\u0027г\u0027.|yMd|d.MM.y\u202F\u0027г\u0027.|yMEd|E, d.MM.y\u202F\u0027г\u0027.|yMMM|MM.y\u202F\u0027г\u0027.|yMMMd|d.MM.y\u202F\u0027г\u0027.|yMMMEd|E, d.MM.y\u202F\u0027г\u0027.|yMMMM|MMMM y\u202F\u0027г\u0027.|yMMMMd|d MMMM y\u202F\u0027г\u0027.|yMMMMEd|E, d MMMM y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|\u0027седмица\u0027 w \u0027от\u0027 Y \u0027г\u0027.|yw-count-other|\u0027седмица\u0027 w \u0027от\u0027 Y \u0027г\u0027.|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|Af|AMD|AMD|AOA|Kz|ARS|ARS|AUD|AUD|AZN|AZN|BAM|KM|BBD|BBD|BDT|BDT|BGN|лв.|BMD|BMD|BND|BND|BOB|Bs|BRL|BRL|BSD|BSD|BWP|P|BZD|BZD|CAD|CAD|CLP|CLP|CNY|CNY|COP|COP|CRC|CRC|CUC|$|CUP|CUP|CZK|Kč|DKK|kr|DOP|DOP|EGP|E£|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|GBP|GBP|GEL|₾|GHS|GHS|GIP|GIP|GNF|FG|GTQ|Q|GYD|GYD|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|JMD|JPY|JPY|KGS|\u20C0|KHR|KHR|KMF|CF|KPW|₩|KRW|KRW|KYD|KYD|KZT|KZT|LAK|LAK|LBP|L£|LKR|Rs|LRD|LRD|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|MNT|MUR|Rs|MXN|MXN|MYR|RM|NAD|NAD|NGN|NGN|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|PYG|RON|RON|RUB|₽|RWF|RF|SBD|SBD|SEK|kr|SGD|SGD|SHP|£|SRD|SRD|SSP|SSP|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|TRY|TTD|TTD|TWD|TWD|UAH|UAH|USD|щ.д.|UYU|UYU|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bg = $enkidatron$elm_cldr$Generated$Bg$bg;
var $enkidatron$elm_cldr$Generated$Bn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'bn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Bn$bn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bn$dayPeriods, 'bn||||AM|PM|8|afternoon1|দুপুর|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যা|morning1|ভোর|morning2|সকাল|night1|রাত্রি|pm|PM|AM|PM|8|afternoon1|দুপুরবেলায়|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যাবেলায়|morning1|ভোরবেলায়|morning2|সকালবেলায়|night1|রাত্রিবেলায়|pm|PM|AM|PM|8|afternoon1|দুপুর|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যা|morning1|ভোর|morning2|সকাল|night1|রাত্রি|pm|PM|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|জানু|ফেব|মার্চ|এপ্রি|মে|জুন|জুল|আগ|সেপ|অক্টো|নভে|ডিসে|জানুয়ারী|ফেব্রুয়ারী|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জা|ফে|মা|এ|মে|জুন|জু|আ|সে|অ|ন|ডি|1|জানু|ফেব|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জানুয়ারী|ফেব্রুয়ারী|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জা|ফে|মা|এ|মে|জুন|জু|আ|সে|অ|ন|ডি|রবি|সোম|মঙ্গল|বুধ|বৃহস্পতি|শুক্র|শনি|রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার|শুক্রবার|শনিবার|র|সো|ম|বু|বৃ|শু|শ|0|খ্রিস্টপূর্ব|খৃষ্টাব্দ|খ্রিস্টপূর্ব|খ্রীষ্টাব্দ|খ্রিস্টপূর্ব|খৃষ্টাব্দ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM, y G|GyMMMEd|E, d MMM, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d-M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|MMMM এর Wয় সপ্তাহ|MMMMW-count-other|MMMM এর Wয় সপ্তাহ|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y এর wতম সপ্তাহ|yw-count-other|Y এর wতম সপ্তাহ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-|¤||¤||¤|E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bn = $enkidatron$elm_cldr$Generated$Bn$bn;
var $enkidatron$elm_cldr$Generated$Bs$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'bs',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Bs$bs = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bs$dayPeriods, 'bs||||AM|PM|8|afternoon1|poslijepodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|PM|prijepodne|popodne|8|afternoon1|poslijepodne|am|prijepodne|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|popodne|prijepodne|popodne|8|afternoon1|poslijepodne|am|prijepodne|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|popodne|d. M. y.|d. MMM y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec|januar|februar|mart|april|maj|juni|juli|august|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|N|P|U|S|Č|P|S|1|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|p. n. e.|n. e.|prije nove ere|nove ere|p.n.e.|n. e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d/M/y. G|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|L|Md|d.M.|MEd|E, d.M.|MMdd|d. M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027sedmica\u0027 \u0027mjesec\u0027 MMMM|MMMMW-count-few|W. \u0027sedmica\u0027 \u0027mjesec\u0027 MMMM|MMMMW-count-other|W. \u0027sedmica\u0027 \u0027mjesec\u0027 MMMM|ms|mm:ss|y|y.|yM|MM/y|yMd|d.M.y.|yMEd|E, d.M.y.|yMM|M/y|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|LLLL y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RSD|din.|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bs = $enkidatron$elm_cldr$Generated$Bs$bs;
var $enkidatron$elm_cldr$Generated$Ca$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ca',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ca$ca = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ca$dayPeriods, 'ca||||a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u00A0m.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|mat.|morning2|matí|night1|nit|pm|p.\u202Fm.|d/M/yy|d MMM y|d MMMM \u0027del\u0027 y|EEEE, d MMMM \u0027del\u0027 y|de gen.|de febr.|de març|d’abr.|de maig|de juny|de jul.|d’ag.|de set.|d’oct.|de nov.|de des.|de gener|de febrer|de març|d’abril|de maig|de juny|de juliol|d’agost|de setembre|d’octubre|de novembre|de desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|1|gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.|gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|dg.|dl.|dt.|dc.|dj.|dv.|ds.|diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte|dg.|dl.|dt.|dc.|dj.|dv.|ds.|0|aC|dC|abans de Crist|després de Crist|aC|dC|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM \u0027del\u0027 y G|GyMMMEd|E, d MMM \u0027del\u0027 y G|GyMMMM|LLLL \u0027del\u0027 y G|GyMMMMd|d MMMM \u0027del\u0027 y G|GyMMMMEd|E, d MMMM \u0027del\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa (vvvv)|Hmvvvv|H:mm (vvvv)|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027setmana\u0027 W MMMM|MMMMW-count-other|\u0027setmana\u0027 W MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|LLL \u0027del\u0027 y|yMMMd|d MMM \u0027del\u0027 y|yMMMEd|E, d MMM y|yMMMM|LLLL \u0027del\u0027 y|yMMMMd|d MMMM \u0027del\u0027 y|yMMMMEd|E, d MMMM \u0027del\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027setmana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027setmana\u0027 w \u0027del\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs F|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ca = $enkidatron$elm_cldr$Generated$Ca$ca;
var $enkidatron$elm_cldr$Generated$Cs$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'cs',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Cs$cs = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Cs$dayPeriods, 'cs||||dop.|odp.|9|afternoon1|odp.|am|dop.|evening1|več.|midnight|půln.|morning1|r.|morning2|dop.|night1|v n.|noon|pol.|pm|odp.|dop.|odp.|9|afternoon1|odpoledne|am|dop.|evening1|večer|midnight|půlnoc|morning1|ráno|morning2|dopoledne|night1|v noci|noon|poledne|pm|odp.|dop.|odp.|9|afternoon1|o.|am|dop.|evening1|v.|midnight|půl.|morning1|r.|morning2|d.|night1|n.|noon|pol.|pm|odp.|dd.MM.yy|d. M. y|d. MMMM y|EEEE d. MMMM y|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro|ledna|února|března|dubna|května|června|července|srpna|září|října|listopadu|prosince|1|2|3|4|5|6|7|8|9|10|11|12|1|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro|leden|únor|březen|duben|květen|červen|červenec|srpen|září|říjen|listopad|prosinec|1|2|3|4|5|6|7|8|9|10|11|12|ne|po|út|st|čt|pá|so|neděle|pondělí|úterý|středa|čtvrtek|pátek|sobota|N|P|Ú|S|Č|P|S|0|př. n. l.|n. l.|před naším letopočtem|našeho letopočtu|př.n.l.|n.l.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss, zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|d. M. y GGGGG|GyMMM|LLLL y G|GyMMMd|d. M. y G|GyMMMEd|E d. M. y G|GyMMMMd|d. MMMM y G|GyMMMMEd|E d. MMMM y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa, vvvv|Hmsvvvv|H:mm:ss, vvvv|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa, vvvv|Hmvvvv|H:mm, vvvv|M|L|Md|d. M.|MEd|E d. M.|MMM|LLL|MMMd|d. M.|MMMEd|E d. M.|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \u0027týden\u0027 MMMM|MMMMW-count-few|W. \u0027týden\u0027 MMMM|MMMMW-count-many|W. \u0027týden\u0027 MMMM|MMMMW-count-other|W. \u0027týden\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d. M. y|yMEd|E d. M. y|yMMM|LLLL y|yMMMd|d. M. y|yMMMEd|E d. M. y|yMMMM|LLLL y|yMMMMd|d. MMMM y|yMMMMEd|E d. MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \u0027týden\u0027 \u0027roku\u0027 Y|yw-count-few|w. \u0027týden\u0027 \u0027roku\u0027 Y|yw-count-many|w. \u0027týden\u0027 \u0027roku\u0027 Y|yw-count-other|w. \u0027týden\u0027 \u0027roku\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CSK|Kčs|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XEU|ECU|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$cs = $enkidatron$elm_cldr$Generated$Cs$cs;
var $enkidatron$elm_cldr$Generated$Cy$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'cy',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Cy$cy = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Cy$dayPeriods, 'cy||||AM|PM|7|afternoon1|y prynhawn|am|AM|evening1|yr hwyr|midnight|canol nos|morning1|y bore|noon|canol dydd|pm|PM|yb|yh|7|afternoon1|y prynhawn|am|yb|evening1|yr hwyr|midnight|canol nos|morning1|y bore|noon|canol dydd|pm|yh|b|h|7|afternoon1|yn y prynhawn|am|b|evening1|min nos|midnight|canol nos|morning1|yn y bore|noon|canol dydd|pm|h|dd/MM/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Ion|Chwef|Maw|Ebr|Mai|Meh|Gorff|Awst|Medi|Hyd|Tach|Rhag|Ionawr|Chwefror|Mawrth|Ebrill|Mai|Mehefin|Gorffennaf|Awst|Medi|Hydref|Tachwedd|Rhagfyr|I|Ch|M|E|M|M|G|A|M|H|T|Rh|1|Ion|Chw|Maw|Ebr|Mai|Meh|Gor|Awst|Medi|Hyd|Tach|Rhag|Ionawr|Chwefror|Mawrth|Ebrill|Mai|Mehefin|Gorffennaf|Awst|Medi|Hydref|Tachwedd|Rhagfyr|I|Ch|M|E|M|M|G|A|M|H|T|Rh|Sul|Llun|Maw|Mer|Iau|Gwen|Sad|Dydd Sul|Dydd Llun|Dydd Mawrth|Dydd Mercher|Dydd Iau|Dydd Gwener|Dydd Sadwrn|S|Ll|M|M|I|G|S|1|Sul|Llun|Maw|Mer|Iau|Gwe|Sad|Dydd Sul|Dydd Llun|Dydd Mawrth|Dydd Mercher|Dydd Iau|Dydd Gwener|Dydd Sadwrn|S|Ll|M|M|I|G|S|CC|OC|Cyn Crist|Oed Crist|C|O|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|58|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|MMMM d|MMMMW-count-zero|\u0027wythnos\u0027 W \u0027o\u0027 MMMM|MMMMW-count-one|\u0027wythnos\u0027 W \u0027o\u0027 MMMM|MMMMW-count-two|\u0027wythnos\u0027 W \u0027o\u0027 MMMM|MMMMW-count-few|\u0027wythnos\u0027 W \u0027o\u0027 MMMM|MMMMW-count-many|\u0027wythnos\u0027 W \u0027o\u0027 MMMM|MMMMW-count-other|\u0027wythnos\u0027 W \u0027o\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQ|Q y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|\u0027wythnos\u0027 w \u0027o\u0027 Y|yw-count-one|\u0027wythnos\u0027 w \u0027o\u0027 Y|yw-count-two|\u0027wythnos\u0027 w \u0027o\u0027 Y|yw-count-few|\u0027wythnos\u0027 w \u0027o\u0027 Y|yw-count-many|\u0027wythnos\u0027 w \u0027o\u0027 Y|yw-count-other|\u0027wythnos\u0027 w \u0027o\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|TK|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|BWP|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$cy = $enkidatron$elm_cldr$Generated$Cy$cy;
var $enkidatron$elm_cldr$Generated$Da$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'da',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Da$da = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Da$dayPeriods, 'da||||AM|PM|8|afternoon1|om eftermiddagen|am|AM|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|PM|AM|PM|8|afternoon1|om eftermiddagen|am|AM|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|PM|a|p|8|afternoon1|om eftermiddagen|am|a|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE \u0027den\u0027 d. MMMM y|jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.|januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|søn.|man.|tirs.|ons.|tors.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|efter Kristus|fKr|eKr|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d.|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E \u0027den\u0027 d.|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss\u202Fa v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|M|Md|d.M|MEd|E d.M|MMdd|dd.MM|MMM|MMM|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \u0027uge\u0027 \u0027i\u0027 MMMM|MMMMW-count-other|W. \u0027uge\u0027 \u0027i\u0027 MMMM|ms|mm.ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027uge\u0027 w \u0027i\u0027 Y|yw-count-other|\u0027uge\u0027 w \u0027i\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr.|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr.|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr.|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr.|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$da = $enkidatron$elm_cldr$Generated$Da$da;
var $enkidatron$elm_cldr$Generated$De$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'de',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$De$de = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jan.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sept.|Okt.|Nov.|Dez.|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \u0027Uhr\u0027 a|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|111|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de = $enkidatron$elm_cldr$Generated$De$de;
var $enkidatron$elm_cldr$Generated$El$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'el',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(17, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(17, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$El$el = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$El$dayPeriods, 'el||||π.μ.|μ.μ.|6|afternoon1|μεσημ.|am|π.μ.|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μ.μ.|π.μ.|μ.μ.|6|afternoon1|το μεσημέρι|am|π.μ.|evening1|το απόγευμα|morning1|το πρωί|night1|το βράδυ|pm|μ.μ.|πμ|μμ|6|afternoon1|μεσημ.|am|πμ|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μμ|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|Ιαν|Φεβ|Μαρ|Απρ|Μαΐ|Ιουν|Ιουλ|Αυγ|Σεπ|Οκτ|Νοε|Δεκ|Ιανουαρίου|Φεβρουαρίου|Μαρτίου|Απριλίου|Μαΐου|Ιουνίου|Ιουλίου|Αυγούστου|Σεπτεμβρίου|Οκτωβρίου|Νοεμβρίου|Δεκεμβρίου|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|1|Ιαν|Φεβ|Μάρ|Απρ|Μάι|Ιούν|Ιούλ|Αύγ|Σεπ|Οκτ|Νοέ|Δεκ|Ιανουάριος|Φεβρουάριος|Μάρτιος|Απρίλιος|Μάιος|Ιούνιος|Ιούλιος|Αύγουστος|Σεπτέμβριος|Οκτώβριος|Νοέμβριος|Δεκέμβριος|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|Κυρ|Δευ|Τρί|Τετ|Πέμ|Παρ|Σάβ|Κυριακή|Δευτέρα|Τρίτη|Τετάρτη|Πέμπτη|Παρασκευή|Σάββατο|Κ|Δ|Τ|Τ|Π|Π|Σ|0|π.Χ.|μ.Χ.|προ Χριστού|μετά Χριστόν|π.Χ.|μ.Χ.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} - {0}|{1} - {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|MMM|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|εβδομάδα W του MMMM|MMMMW-count-other|εβδομάδα W του MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|εβδομάδα w του Y|yw-count-other|εβδομάδα w του Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GRD|Δρχ|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$el = $enkidatron$elm_cldr$Generated$El$el;
var $enkidatron$elm_cldr$Generated$Es$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'es',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				])),
			_Utils_Tuple2(
			'es_co',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Es$es = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|X|J|V|S|0|a. C.|d. C.|antes de Cristo|después de Cristo|a. C.|d. C.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|EGP|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es = $enkidatron$elm_cldr$Generated$Es$es;
var $enkidatron$elm_cldr$Generated$Et$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'et',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(23, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Et$et = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Et$dayPeriods, 'et||||AM|PM|8|afternoon1|pärastlõunal|am|AM|evening1|õhtul|midnight|keskööl|morning1|hommikul|night1|öösel|noon|keskpäeval|pm|PM|AM|PM|8|afternoon1|pärastlõunal|am|AM|evening1|õhtul|midnight|keskööl|morning1|hommikul|night1|öösel|noon|keskpäeval|pm|PM|AM|PM|8|afternoon1|pärastlõunal|am|AM|evening1|õhtul|midnight|keskööl|morning1|hommikul|night1|öösel|noon|keskpäeval|pm|PM|dd.MM.yy|d. MMM y|d. MMMM y|EEEE, d. MMMM y|jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets|jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember|J|V|M|A|M|J|J|A|S|O|N|D|0|P|E|T|K|N|R|L|pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev|P|E|T|K|N|R|L|0|eKr|pKr|enne Kristust|pärast Kristust|eKr|pKr|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|M|Md|d.M|MEd|E, d.M|MMM|MMMM|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|MMMM (W. \u0027nädal\u0027)|MMMMW-count-other|MMMM (W. \u0027nädal\u0027)|mmss|mm:ss|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \u0027nädal\u0027 (Y)|yw-count-other|w. \u0027nädal\u0027 (Y)|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EEK|kr|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$et = $enkidatron$elm_cldr$Generated$Et$et;
var $enkidatron$elm_cldr$Generated$Eu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'eu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Eu$eu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Eu$dayPeriods, 'eu||||AM|PM|9|afternoon1|eguerd.|afternoon2|arrats.|am|AM|evening1|iluntz.|midnight|gauerdia|morning1|goizald.|morning2|goizeko|night1|gaueko|pm|PM|AM|PM|9|afternoon1|eguerdiko|afternoon2|arratsaldeko|am|AM|evening1|iluntzeko|midnight|gauerdia|morning1|goizaldeko|morning2|goizeko|night1|gaueko|pm|PM|g|a|9|afternoon1|eguerd.|afternoon2|arrats.|am|g|evening1|iluntz.|midnight|gauerd.|morning1|goizald.|morning2|goizeko|night1|gaueko|pm|a|yy/M/d|y(\u0027e\u0027)\u0027ko\u0027 MMM d(\u0027a\u0027)|y(\u0027e\u0027)\u0027ko\u0027 MMMM\u0027ren\u0027 d(\u0027a\u0027)|y(\u0027e\u0027)\u0027ko\u0027 MMMM\u0027ren\u0027 d(\u0027a\u0027), EEEE|urt.|ots.|mar.|api.|mai.|eka.|uzt.|abu.|ira.|urr.|aza.|abe.|urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua|U|O|M|A|M|E|U|A|I|U|A|A|0|ig.|al.|ar.|az.|og.|or.|lr.|igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata|I|A|A|A|O|O|L|0|K.a.|K.o.|K.a.|Kristo ondoren|a|o|HH:mm|HH:mm:ss|HH:mm:ss (z)|HH:mm:ss (zzzz)|{1} ({0})|{1} ({0})|{1} ({0})|{1} ({0})|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y. \u0027urteko\u0027 MMM|GyMMMd|G y. \u0027urteko\u0027 MMM d(\u0027a\u0027)|GyMMMEd|G y. \u0027urteko\u0027 MMM d(\u0027a\u0027), E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|M/d|MEd|M/d, E|MMM|LLL|MMMd|MMM d(\u0027a\u0027)|MMMEd|MMM d(\u0027a\u0027), E|MMMMd|MMMM\u0027ren\u0027 d(\u0027a\u0027)|MMMMW-count-one|MMMM\u0027ren\u0027 W. \u0027astea\u0027|MMMMW-count-other|MMMM\u0027ren\u0027 W. \u0027astea\u0027|ms|mm:ss|y|y|yM|y/M|yMd|y/M/d|yMEd|y/M/d, E|yMMM|y MMM|yMMMd|y MMM d(\u0027a\u0027)|yMMMEd|y MMM d(\u0027a\u0027), E|yMMMM|y(\u0027e\u0027)\u0027ko\u0027 MMMM|yMMMMd|y(\u0027e\u0027)\u0027ko\u0027 MMMM\u0027ren\u0027 d(\u0027a\u0027)|yMMMMEd|y(\u0027e\u0027)\u0027ko\u0027 MMMM\u0027ren\u0027 d(\u0027a\u0027), E|yQQQ|y(\u0027e\u0027)\u0027ko\u0027 QQQ|yQQQQ|y(\u0027e\u0027)\u0027ko\u0027 QQQQ|yw-count-one|Y. \u0027urteko\u0027 w. \u0027astea\u0027|yw-count-other|Y. \u0027urteko\u0027 w. \u0027astea\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−%\u00A0||%\u00A0||%\u00A0||106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$eu = $enkidatron$elm_cldr$Generated$Eu$eu;
var $enkidatron$elm_cldr$Generated$Fa$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fa',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(4, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'night2')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fa$fa = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fa$dayPeriods, 'fa||||ق.ظ.|ب.ظ.|8|afternoon1|ظهر|afternoon2|عصر|am|ق.ظ.|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|ب.ظ.|قبل\u200Cازظهر|بعدازظهر|8|afternoon1|بعدازظهر|afternoon2|عصر|am|قبل\u200Cازظهر|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|بعدازظهر|ق|ب|8|afternoon1|ظ|afternoon2|ع|am|ق|morning1|ب|morning2|ص|night1|ش|night2|ن|pm|ب|y/M/d|d MMM y|d MMMM y|EEEE d MMMM y|ژانویه|فوریه|مارس|آوریل|مه|ژوئن|ژوئیه|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژانویهٔ|فوریهٔ|مارس|آوریل|مهٔ|ژوئن|ژوئیهٔ|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژ|ف|م|آ|م|ژ|ژ|ا|س|ا|ن|د|1|ژانویه|فوریه|مارس|آوریل|مه|ژوئن|ژوئیه|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژانویه|فوریه|مارس|آوریل|مه|ژوئن|ژوئیه|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژ|ف|م|آ|م|ژ|ژ|ا|س|ا|ن|د|یکشنبه|دوشنبه|سه\u200Cشنبه|چهارشنبه|پنجشنبه|جمعه|شنبه|یکشنبه|دوشنبه|سه\u200Cشنبه|چهارشنبه|پنجشنبه|جمعه|شنبه|ی|د|س|چ|پ|ج|ش|0|ق.م.|م.|قبل از میلاد|میلادی|ق|م|H:mm|H:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1}،\u200F {0}|{1}،\u200F {0}|{1}، ساعت {0}|{1}، ساعت {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E H:mm|Ehms|E h:mm:ss a|EHms|E H:mm:ss|Gy|y G|GyMd|y/M/d GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|H|HHmmZ|HH:mm (Z)|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|M/d|MEd|E M/d|MMM|LLL|MMMd|d LLL|MMMEd|E d LLL|MMMMd|d LLLL|MMMMEd|E d LLLL|MMMMW-count-one|هفتهٔ Wم LLLL|MMMMW-count-other|هفتهٔ Wم LLLL|mmss|mm:ss|ms|m:ss|y|y|yM|y/M|yMd|y/M/d|yMEd|E y/M/d|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM y|yQQQ|QQQQ y|yQQQQ|QQQQ y|yw-count-one|هفتهٔ wم Y|yw-count-other|هفتهٔ wم Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|\u200E−||||||E2W,|.|\u200E−\u200E¤\u00A0||\u200E¤\u00A0||\u200E¤\u00A0||E0W,|.|\u200E−|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|$CA|CLP|$|CNY|¥CN|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|$HK|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IRR|ریال|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|$MX|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$EC|XOF|فرانک\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$fa = $enkidatron$elm_cldr$Generated$Fa$fa;
var $enkidatron$elm_cldr$Generated$Fi$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fi',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(23, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fi$fi = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fi$dayPeriods, 'fi||||ap.|ip.|9|afternoon1|iltap.|am|ap.|evening1|illalla|midnight|keskiyöllä|morning1|aamulla|morning2|aamup.|night1|yöllä|noon|keskip.|pm|ip.|ap.|ip.|9|afternoon1|iltapäivällä|am|ap.|evening1|illalla|midnight|keskiyöllä|morning1|aamulla|morning2|aamupäivällä|night1|yöllä|noon|keskipäivällä|pm|ip.|ap.|ip.|9|afternoon1|ip.|am|ap.|evening1|illalla|midnight|ky.|morning1|aamulla|morning2|ap.|night1|yöllä|noon|kp.|pm|ip.|d.M.y|d.M.y|d. MMMM y|cccc d. MMMM y|tammik.|helmik.|maalisk.|huhtik.|toukok.|kesäk.|heinäk.|elok.|syysk.|lokak.|marrask.|jouluk.|tammikuuta|helmikuuta|maaliskuuta|huhtikuuta|toukokuuta|kesäkuuta|heinäkuuta|elokuuta|syyskuuta|lokakuuta|marraskuuta|joulukuuta|T|H|M|H|T|K|H|E|S|L|M|J|1|tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu|tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu|T|H|M|H|T|K|H|E|S|L|M|J|su|ma|ti|ke|to|pe|la|sunnuntaina|maanantaina|tiistaina|keskiviikkona|torstaina|perjantaina|lauantaina|S|M|T|K|T|P|L|1|su|ma|ti|ke|to|pe|la|sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai|S|M|T|K|T|P|L|eKr.|jKr.|ennen Kristuksen syntymää|jälkeen Kristuksen syntymän|eKr|jKr|H.mm|H.mm.ss|H.mm.ss z|H.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E d.|Ehm|E h.mm\u202Fa|EHm|E H.mm|Ehms|E h.mm.ss\u202Fa|EHms|E H.mm.ss|Gy|y G|GyMd|M.d.y G|GyMMM|LLL y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|GyMMMMd|d. MMMM y G|GyMMMMEd|E d. MMMM y G|h|h\u202Fa|H|H|hm|h.mm\u202Fa|Hm|H.mm|hms|h.mm.ss\u202Fa|Hms|H.mm.ss|hmsv|h.mm.ss\u202Fa v|Hmsv|H.mm.ss v|hmv|h.mm\u202Fa v|Hmv|H.mm v|M|L|Md|d.M.|MEd|E d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|ccc d. MMM|MMMMd|d. MMMM|MMMMEd|ccc d. MMMM|MMMMW-count-one|LLLL\u0027n\u0027 W. \u0027viikko\u0027|MMMMW-count-other|LLLL\u0027n\u0027 W. \u0027viikko\u0027|ms|m.ss|y|y|yM|L.y|yMd|d.M.y|yMEd|E d.M.y|yMM|M.y|yMMM|LLL y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|LLLL y|yMMMMccccd|cccc d. MMMM y|yMMMMd|d. MMMM y|yMMMMEd|E d. MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027vuoden\u0027 Y \u0027viikko\u0027 w|yw-count-other|\u0027vuoden\u0027 Y \u0027viikko\u0027 w|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|AOA|ARS|ARS|AUD|AUD|AZN|₼|BAM|BAM|BBD|BBD|BDT|BDT|BMD|BMD|BND|BND|BOB|BOB|BRL|BRL|BSD|BSD|BWP|BWP|BZD|BZD|CAD|CAD|CLP|CLP|CNY|CNY|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CZK|CZK|DKK|DKK|DOP|DOP|EGP|EGP|ESP|ESP|EUR|€|FIM|mk|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HKD|HNL|HNL|HRK|HRK|HUF|HUF|IDR|IDR|ILS|ILS|INR|INR|ISK|ISK|JMD|JMD|JPY|¥|KGS|\u20C0|KHR|KHR|KMF|KMF|KPW|KPW|KRW|KRW|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LTL|LTL|LVL|LVL|MGA|MGA|MMK|MMK|MNT|MNT|MUR|MUR|MXN|MXN|MYR|MYR|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZD|PHP|PHP|PKR|PKR|PLN|PLN|PYG|PYG|RON|RON|RUB|₽|RWF|RWF|SBD|SBD|SEK|SEK|SGD|SGD|SHP|SHP|SRD|SRD|SSP|SSP|STN|STD|SYP|SYP|THB|THB|TOP|TOP|TRY|TRY|TTD|TTD|TWD|TWD|UAH|UAH|USD|$|UYU|UYU|VEF|VEF|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$fi = $enkidatron$elm_cldr$Generated$Fi$fi;
var $enkidatron$elm_cldr$Generated$Fr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fr$fr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr = $enkidatron$elm_cldr$Generated$Fr$fr;
var $enkidatron$elm_cldr$Generated$Ga$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ga$ga = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ga$dayPeriods, 'ga||||r.n.|i.n.|2|am|r.n.|pm|i.n.|r.n.|i.n.|2|am|r.n.|pm|i.n.|r.n.|i.n.|2|am|r.n.|pm|i.n.|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|Ean|Feabh|Márta|Aib|Beal|Meith|Iúil|Lún|MFómh|DFómh|Samh|Noll|Eanáir|Feabhra|Márta|Aibreán|Bealtaine|Meitheamh|Iúil|Lúnasa|Meán Fómhair|Deireadh Fómhair|Samhain|Nollaig|E|F|M|A|B|M|I|L|M|D|S|N|0|Domh|Luan|Máirt|Céad|Déar|Aoine|Sath|Dé Domhnaigh|Dé Luain|Dé Máirt|Dé Céadaoin|Déardaoin|Dé hAoine|Dé Sathairn|D|L|M|C|D|A|S|0|RC|AD|Roimh Chríost|Anno Domini|RC|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|LL|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-two|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-few|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-many|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-other|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-two|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-few|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-many|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ga = $enkidatron$elm_cldr$Generated$Ga$ga;
var $enkidatron$elm_cldr$Generated$Gd$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Gd$gd = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Gd$dayPeriods, 'gd||||m|f|2|am|m|pm|f|m|f|2|am|m|pm|f|m|f|2|am|m|pm|f|dd/MM/y|d MMM y|d\u0027mh\u0027 MMMM y|EEEE, d\u0027mh\u0027 MMMM y|Faoi|Gearr|Màrt|Gibl|Cèit|Ògmh|Iuch|Lùna|Sult|Dàmh|Samh|Dùbh|dhen Fhaoilleach|dhen Ghearran|dhen Mhàrt|dhen Ghiblean|dhen Chèitean|dhen Ògmhios|dhen Iuchar|dhen Lùnastal|dhen t-Sultain|dhen Dàmhair|dhen t-Samhain|dhen Dùbhlachd|F|G|M|G|C|Ò|I|L|S|D|S|D|1|Faoi|Gearr|Màrt|Gibl|Cèit|Ògmh|Iuch|Lùna|Sult|Dàmh|Samh|Dùbh|Am Faoilleach|An Gearran|Am Màrt|An Giblean|An Cèitean|An t-Ògmhios|An t-Iuchar|An Lùnastal|An t-Sultain|An Dàmhair|An t-Samhain|An Dùbhlachd|F|G|M|G|C|Ò|I|L|S|D|S|D|DiD|DiL|DiM|DiC|Dia|Dih|DiS|DiDòmhnaich|DiLuain|DiMàirt|DiCiadain|DiarDaoin|DihAoine|DiSathairne|D|L|M|C|A|H|S|0|RC|AD|Ro Chrìosta|An dèidh Chrìosta|R|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|55|Bh|hB|Bhm|h:mmB|Bhms|h:mm:ssB|d|d|E|ccc|EBhm|E h:mmB|EBhms|E h:mm:ssB|Ed|E, d|Ehm|E h:mma|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|LLL y G|GyMMMd|d\u0027mh\u0027 MMM y G|GyMMMEd|E, d\u0027mh\u0027 MMM y G|h|ha|H|HH|hm|h:mma|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mma v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d\u0027mh\u0027 MMMM|MMMMW-count-one|\u0027seachdain\u0027 W MMMM|MMMMW-count-two|\u0027seachdain\u0027 W MMMM|MMMMW-count-few|\u0027seachdain\u0027 W MMMM|MMMMW-count-other|\u0027seachdain\u0027 W MMMM|ms|mm:ss|y|y|yM|L/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|LL/y|yMMM|LLL Y|yMMMd|d\u0027mh\u0027 MMM y|yMMMEd|E, d\u0027mh\u0027 MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027seachdain\u0027 w \u0027dhe\u0027 Y|yw-count-two|\u0027seachdain\u0027 w \u0027dhe\u0027 Y|yw-count-few|\u0027seachdain\u0027 w \u0027dhe\u0027 Y|yw-count-other|\u0027seachdain\u0027 w \u0027dhe\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|leu|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$gd = $enkidatron$elm_cldr$Generated$Gd$gd;
var $enkidatron$elm_cldr$Generated$Gl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'gl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Gl$gl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Gl$dayPeriods, 'gl||||a.m.|p.m.|8|afternoon1|do mediodía|am|a.m.|evening1|da tarde|midnight|da noite|morning1|da madrugada|morning2|da mañá|night1|da noite|pm|p.m.|a.m.|p.m.|8|afternoon1|do mediodía|am|a.m.|evening1|da tarde|midnight|da noite|morning1|da madrugada|morning2|da mañá|night1|da noite|pm|p.m.|a.m.|p.m.|8|afternoon1|do mediodía|am|a.m.|evening1|da tarde|midnight|da noite|morning1|da madrugada|morning2|da mañá|night1|da noite|pm|p.m.|dd/MM/yy|d \u0027de\u0027 MMM \u0027de\u0027 y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|xan.|feb.|mar.|abr.|maio|xuño|xul.|ago.|set.|out.|nov.|dec.|xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro|x.|f.|m.|a.|m.|x.|x.|a.|s.|o.|n.|d.|1|xan.|feb.|mar.|abr.|maio|xuño|xul.|ago.|set.|out.|nov.|dec.|xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro|X|F|M|A|M|X|X|A|S|O|N|D|dom.|luns|mar.|mér.|xov.|ven.|sáb.|domingo|luns|martes|mércores|xoves|venres|sábado|d.|l.|m.|m.|x.|v.|s.|1|dom.|luns|mar.|mér.|xov.|ven.|sáb.|domingo|luns|martes|mércores|xoves|venres|sábado|D|L|M|M|X|V|S|a.C.|d.C.|antes de Cristo|despois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d \u0027de\u0027 MMM|MMMEd|E, d \u0027de\u0027 MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM/y|yMMM|MMM \u0027de\u0027 y|yMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMM|MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|$MX|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|руб|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$gl = $enkidatron$elm_cldr$Generated$Gl$gl;
var $enkidatron$elm_cldr$Generated$Gu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'gu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Gu$gu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Gu$dayPeriods, 'gu||||AM|PM|7|afternoon1|બપોરે|am|AM|evening1|સાંજે|midnight|મધ્યરાત્રિ|morning1|સવારે|night1|રાત્રે|pm|PM|AM|PM|7|afternoon1|બપોરે|am|AM|evening1|સાંજે|midnight|મધ્યરાત્રિ|morning1|સવારે|night1|રાત્રે|pm|PM|AM|PM|7|afternoon1|બપોરે|am|AM|evening1|સાંજે|midnight|મ.રાત્રિ|morning1|સવારે|night1|રાત્રે|pm|PM|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઑક્ટો|નવે|ડિસે|જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટેમ્બર|ઑક્ટોબર|નવેમ્બર|ડિસેમ્બર|જા|ફે|મા|એ|મે|જૂ|જુ|ઑ|સ|ઑ|ન|ડિ|0|રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ|રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર|ર|સો|મં|બુ|ગુ|શુ|શ|0|ઈ.સ.પૂર્વે|ઈ.સ.|ઈસવીસન પૂર્વે|ઇસવીસન|ઇ સ પુ|ઇસ|hh:mm a|hh:mm:ss a|hh:mm:ss a z|hh:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|MMM, G y|GyMMMd|d MMM, G y|GyMMMEd|E, d MMM, G y|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMMના W અઠવાડિયા|MMMMW-count-other|MMMMના W અઠવાડિયા|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y ના w અઠવાડિયા|yw-count-other|Y ના w અઠવાડિયા|ahhmm|ahhmmss|ahhmmssz|ahhmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|રૂ.|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$gu = $enkidatron$elm_cldr$Generated$Gu$gu;
var $enkidatron$elm_cldr$Generated$Ha$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ha$ha = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ha$dayPeriods, 'ha||||SF|YM|2|am|SF|pm|YM|Safiya|Yamma|2|am|Safiya|pm|Yamma|SF|YM|2|am|SF|pm|YM|d/M/yy|d MMM, y|d MMMM, y|EEEE d MMMM, y|Jan|Fab|Mar|Afi|May|Yun|Yul|Agu|Sat|Okt|Nuw|Dis|Janairu|Faburairu|Maris|Afirilu|Mayu|Yuni|Yuli|Agusta|Satumba|Oktoba|Nuwamba|Disamba|J|F|M|A|M|Y|Y|A|S|O|N|D|0|Lah|Lit|Tal|Lar|Alh|Jum|Asa|Lahadi|Litinin|Talata|Laraba|Alhamis|Jummaʼa|Asabar|L|L|T|L|A|J|A|0|K.H|BHAI|Kafin haihuwar annab|Bayan haihuwar annab|K.H|BHAI|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027satin\u0027 W \u0027cikin\u0027 MMMM|MMMMW-count-other|\u0027satin\u0027 W \u0027cikin\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|y-MM-dd|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|y MMM d, E|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027sati\u0027 w \u0027cikin\u0027 Y|yw-count-other|\u0027sati\u0027 w \u0027cikin\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ha = $enkidatron$elm_cldr$Generated$Ha$ha;
var $enkidatron$elm_cldr$Generated$He$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'he',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'night2')
				]))
		]));
var $enkidatron$elm_cldr$Generated$He$he = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$He$dayPeriods, 'he||||לפנה״צ|אחה״צ|9|afternoon1|צהריים|afternoon2|אחר הצהריים|am|לפנה״צ|evening1|ערב|midnight|חצות|morning1|בוקר|night1|לילה|night2|לפנות בוקר|pm|אחה״צ|לפנה״צ|אחה״צ|9|afternoon1|בצהריים|afternoon2|אחר הצהריים|am|לפנה״צ|evening1|בערב|midnight|חצות|morning1|בבוקר|night1|בלילה|night2|לפנות בוקר|pm|אחה״צ|לפנה״צ|אחה״צ|9|afternoon1|בצהריים|afternoon2|אחה״צ|am|לפנה״צ|evening1|בערב|midnight|חצות|morning1|בבוקר|night1|בלילה|night2|לפנות בוקר|pm|אחה״צ|d.M.y|d בMMM y|d בMMMM y|EEEE, d בMMMM y|ינו׳|פבר׳|מרץ|אפר׳|מאי|יוני|יולי|אוג׳|ספט׳|אוק׳|נוב׳|דצמ׳|ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר|1|2|3|4|5|6|7|8|9|10|11|12|0|יום א׳|יום ב׳|יום ג׳|יום ד׳|יום ה׳|יום ו׳|שבת|יום ראשון|יום שני|יום שלישי|יום רביעי|יום חמישי|יום שישי|יום שבת|א׳|ב׳|ג׳|ד׳|ה׳|ו׳|ש׳|0|לפנה״ס|לספירה|לפני הספירה|לספירה|לפני|אחריי|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E ה-d|Ehm|E h:mm a|EHm|E H:mm|Ehms|E h:mm:ss a|EHms|E H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d בMMM y G|GyMMMEd|E, d בMMM y G|h|\u200Fh a|H|H|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d בMMM|MMMEd|E, d בMMM|MMMMd|d בMMMM|MMMMW-count-one|שבוע W בMMMM|MMMMW-count-two|שבוע W בMMMM|MMMMW-count-other|שבוע W בMMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMM|M.y|yMMM|MMM y|yMMMd|d בMMM y|yMMMEd|E, d בMMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|שבוע w בשנת Y|yw-count-two|שבוע w בשנת Y|yw-count-other|שבוע w בשנת Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0\u200F¤|\u200F|\u00A0\u200F¤|\u200F|\u00A0\u200F¤|E0W,|.|\u200E-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р|BZD|$|CAD|CA$|CLP|$|CNY|\u200ECN¥\u200E|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILP|ל״י|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$he = $enkidatron$elm_cldr$Generated$He$he;
var $enkidatron$elm_cldr$Generated$Hi$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hi',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				])),
			_Utils_Tuple2(
			'hi_latn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hi$hi = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hi$dayPeriods, 'hi||||am|pm|7|afternoon1|दोपहर|am|am|evening1|शाम|midnight|मध्यरात्रि|morning1|सुबह|night1|रात|pm|pm|am|pm|7|afternoon1|दोपहर|am|am|evening1|शाम|midnight|मध्यरात्रि|morning1|सुबह|night1|रात|pm|pm|am|pm|7|afternoon1|दोपहर|am|am|evening1|शाम|midnight|मध्यरात्रि|morning1|सुबह|night1|रात|pm|pm|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|जन॰|फ़र॰|मार्च|अप्रैल|मई|जून|जुल॰|अग॰|सित॰|अक्तू॰|नव॰|दिस॰|जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर|ज|फ़|मा|अ|म|जू|जु|अ|सि|अ|न|दि|0|रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि|रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार|र|सो|मं|बु|गु|शु|श|0|ईसा-पूर्व|ईस्वी|ईसा-पूर्व|ईसवी सन|ईसा-पूर्व|ईस्वी|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|53|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG d/M/y|GyMMM|MMM G y|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|MMMM का सप्ताह W|MMMMW-count-other|MMMM का सप्ताह W|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM/y|yMMdd|dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y का सप्ताह w|yw-count-other|Y का सप्ताह w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|लेई|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hi = $enkidatron$elm_cldr$Generated$Hi$hi;
var $enkidatron$elm_cldr$Generated$Hr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hr$hr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hr$dayPeriods, 'hr||||AM|PM|8|afternoon1|popodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|poslije podne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|popodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|dd. MM. y.|d. MMM y.|d. MMMM y.|EEEE, d. MMMM y.|sij|velj|ožu|tra|svi|lip|srp|kol|ruj|lis|stu|pro|siječnja|veljače|ožujka|travnja|svibnja|lipnja|srpnja|kolovoza|rujna|listopada|studenoga|prosinca|1.|2.|3.|4.|5.|6.|7.|8.|9.|10.|11.|12.|1|sij|velj|ožu|tra|svi|lip|srp|kol|ruj|lis|stu|pro|siječanj|veljača|ožujak|travanj|svibanj|lipanj|srpanj|kolovoz|rujan|listopad|studeni|prosinac|1.|2.|3.|4.|5.|6.|7.|8.|9.|10.|11.|12.|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|N|P|U|S|Č|P|S|1|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|pr. Kr.|po. Kr.|prije Krista|poslije Krista|pr.n.e.|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d. M. y. GGGGG|GyMMM|LLL y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|dd. MM.|MEd|E, dd. MM.|MMdd|dd. MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027tjedan\u0027 MMMM|MMMMW-count-few|W. \u0027tjedan\u0027 MMMM|MMMMW-count-other|W. \u0027tjedan\u0027 MMMM|ms|mm:ss|y|y.|yM|MM. y.|yMd|dd. MM. y.|yMEd|E, dd. MM. y.|yMM|MM. y.|yMMM|LLL y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|LLLL y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027tjedan\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027tjedan\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027tjedan\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hr = $enkidatron$elm_cldr$Generated$Hr$hr;
var $enkidatron$elm_cldr$Generated$Hu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hu$hu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hu$dayPeriods, 'hu||||de.|du.|10|afternoon1|du.|am|de.|evening1|este|midnight|éjfél|morning1|reggel|morning2|de.|night1|éjjel|night2|hajnal|noon|dél|pm|du.|de.|du.|10|afternoon1|délután|am|de.|evening1|este|midnight|éjfél|morning1|reggel|morning2|délelőtt|night1|éjjel|night2|hajnal|noon|dél|pm|du.|de.|du.|10|afternoon1|du.|am|de.|evening1|este|midnight|éjfél|morning1|reggel|morning2|de.|night1|éjjel|night2|hajnal|noon|dél|pm|du.|y. MM. dd.|y. MMM d.|y. MMMM d.|y. MMMM d., EEEE|jan.|febr.|márc.|ápr.|máj.|jún.|júl.|aug.|szept.|okt.|nov.|dec.|január|február|március|április|május|június|július|augusztus|szeptember|október|november|december|J|F|M|Á|M|J|J|A|Sz|O|N|D|0|V|H|K|Sze|Cs|P|Szo|vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat|V|H|K|Sz|Cs|P|Sz|0|i. e.|i. sz.|Krisztus előtt|időszámításunk szerint|ie.|isz.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d., E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y.|GyMd|GGGGG y. MM. dd.|GyMMM|G y. MMM|GyMMMd|G y. MMM d.|GyMMMEd|G y. MMM d., E|h|a\u202Fh|H|H|hm|a\u202Fh:mm|Hm|H:mm|hms|a\u202Fh:mm:ss|Hms|H:mm:ss|hmsv|a\u202Fh:mm:ss v|Hmsv|HH:mm:ss v|hmv|a\u202Fh:mm v|Hmv|HH:mm v|M|L|Md|M. d.|MEd|M. d., E|MMM|LLL|MMMd|MMM d.|MMMEd|MMM d., E|MMMMd|MMMM d.|MMMMW-count-one|MMMM W. \u0027hete\u0027|MMMMW-count-other|MMMM W. \u0027hete\u0027|mmss|mm:ss|ms|mm:ss|y|y.|yM|y. M.|yMd|y. MM. dd.|yMEd|y. MM. dd., E|yMMM|y. MMM|yMMMd|y. MMM d.|yMMMEd|y. MMM d., E|yMMMM|y. MMMM|yQQQ|y. QQQ|yQQQQ|y. QQQQ|yw-count-one|Y w. \u0027hete\u0027|yw-count-other|Y w. \u0027hete\u0027|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hu = $enkidatron$elm_cldr$Generated$Hu$hu;
var $enkidatron$elm_cldr$Generated$Hy$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hy',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hy$hy = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hy$dayPeriods, 'hy||||AM|PM|8|afternoon1|ցերեկը|am|AM|evening1|երեկոյան|midnight|կեսգիշեր|morning1|առավոտյան|night1|գիշերը|noon|կեսօր|pm|PM|AM|PM|8|afternoon1|ցերեկվա|am|AM|evening1|երեկոյան|midnight|կեսգիշերին|morning1|առավոտյան|night1|գիշերվա|noon|կեսօրին|pm|PM|ա|հ|8|afternoon1|ցրկ|am|ա|evening1|երկ|midnight|կգ․|morning1|առվ|night1|գշր|noon|կօ․|pm|հ|dd.MM.yy|dd MMM, y թ.|dd MMMM, y թ.|y թ. MMMM d, EEEE|հնվ|փտվ|մրտ|ապր|մյս|հնս|հլս|օգս|սեպ|հոկ|նոյ|դեկ|հունվարի|փետրվարի|մարտի|ապրիլի|մայիսի|հունիսի|հուլիսի|օգոստոսի|սեպտեմբերի|հոկտեմբերի|նոյեմբերի|դեկտեմբերի|Հ|Փ|Մ|Ա|Մ|Հ|Հ|Օ|Ս|Հ|Ն|Դ|1|հնվ|փտվ|մրտ|ապր|մյս|հնս|հլս|օգս|սեպ|հոկ|նոյ|դեկ|հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր|Հ|Փ|Մ|Ա|Մ|Հ|Հ|Օ|Ս|Հ|Ն|Դ|կիր|երկ|երք|չրք|հնգ|ուր|շբթ|կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ|Կ|Ե|Ե|Չ|Հ|Ո|Շ|0|մ.թ.ա.|մ.թ.|Քրիստոսից առաջ|Քրիստոսից հետո|մ.թ.ա.|մ.թ.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h-ին|Bhm|B h:mm-ին|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm-ին|EBhms|E B h:mm:ss|Ed|d, ccc|Ehm|E, h:mm a|EHm|E, HH:mm|Ehms|E, h:mm:ss a|EHms|E, HH:mm:ss|Gy|G y թ.|GyMd|dd.MM.y GGGGG|GyMMM|G y թ. MMM|GyMMMd|G y թ․ MMM d|GyMMMEd|G y թ. MMM d, E|h|h a|H|H|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|MMMM d|MMMMW-count-one|MMMM W-ին շաբաթ|MMMMW-count-other|MMMM W-րդ շաբաթ|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|d.MM.y թ., E|yMMM|y թ. LLL|yMMMd|d MMM, y թ.|yMMMEd|y թ. MMM d, E|yMMMM|y թ․ LLLL|yQQQ|y թ. QQQ|yQQQQ|y թ. QQQQ|yw-count-one|Y թ․ w-ին շաբաթ|yw-count-other|Y թ․ w-րդ շաբաթ|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hy = $enkidatron$elm_cldr$Generated$Hy$hy;
var $enkidatron$elm_cldr$Generated$Id$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'id',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(15, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(15, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Id$id = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Id$dayPeriods, 'id||||AM|PM|8|afternoon1|siang|am|AM|evening1|sore|midnight|tengah malam|morning1|pagi|night1|malam|noon|tengah hari|pm|PM|AM|PM|8|afternoon1|siang|am|AM|evening1|sore|midnight|tengah malam|morning1|pagi|night1|malam|noon|tengah hari|pm|PM|AM|PM|8|afternoon1|siang|am|AM|evening1|sore|midnight|tengah malam|morning1|pagi|night1|malam|noon|tengah hari|pm|PM|dd/MM/yy|d MMM y|d MMMM y|EEEE, dd MMMM y|Jan|Feb|Mar|Apr|Mei|Jun|Jul|Agu|Sep|Okt|Nov|Des|Januari|Februari|Maret|April|Mei|Juni|Juli|Agustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|Min|Sen|Sel|Rab|Kam|Jum|Sab|Minggu|Senin|Selasa|Rabu|Kamis|Jumat|Sabtu|M|S|S|R|K|J|S|0|SM|M|Sebelum Masehi|Masehi|SM|M|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E, d|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss. a v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-other|\u0027minggu\u0027 \u0027ke\u0027-W MMMM|ms|mm.ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027minggu\u0027 \u0027ke\u0027-w Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|Rs|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$id = $enkidatron$elm_cldr$Generated$Id$id;
var $enkidatron$elm_cldr$Generated$Ig$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ig$ig = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ig$dayPeriods, 'ig||||A.M.|P.M.|2|am|A.M.|pm|P.M.|N’ụtụtụ|N’abali|2|am|N’ụtụtụ|pm|N’abali|A.M.|P.M.|2|am|A.M.|pm|P.M.|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Jen|Feb|Maa|Epr|Mee|Juu|Jul|Ọgọ|Sep|Ọkt|Nov|Dis|Jenụwarị|Febrụwarị|Maachị|Epreel|Mee|Juun|Julaị|Ọgọọst|Septemba|Ọktoba|Novemba|Disemba|J|F|M|E|M|J|J|Ọ|S|Ọ|N|D|0|Sọn|Mọn|Tiu|Wen|Tọọ|Fraị|Sat|Sọndee|Mọnde|Tiuzdee|Wenezdee|Tọọzdee|Fraịdee|Satọdee|S|M|T|W|T|F|S|0|T.K.|A.K.|Tupu Kraist|Afọ Kraịst|T.K.|A.K.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|MMM G y|GyMMMd|d MMM, G y|GyMMMEd|E, d MMM, G y|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-other|\u0027Izu\u0027 W \u0027n\u0027‘\u0027ime\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027Izu\u0027 w \u0027n\u0027 \u0027ime\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ig = $enkidatron$elm_cldr$Generated$Ig$ig;
var $enkidatron$elm_cldr$Generated$Is$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'is',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Is$is = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Is$dayPeriods, 'is||||f.h.|e.h.|8|afternoon1|síðdegis|am|f.h.|evening1|að kvöldi|midnight|miðnætti|morning1|að morgni|night1|að nóttu|noon|hádegi|pm|e.h.|f.h.|e.h.|8|afternoon1|síðdegis|am|f.h.|evening1|að kvöldi|midnight|miðnætti|morning1|að morgni|night1|að nóttu|noon|hádegi|pm|e.h.|f.|e.|8|afternoon1|sd.|am|f.|evening1|kv.|midnight|mn.|morning1|mrg.|night1|n.|noon|h.|pm|e.|d.M.y|d. MMM y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|mar.|apr.|maí|jún.|júl.|ágú.|sep.|okt.|nóv.|des.|janúar|febrúar|mars|apríl|maí|júní|júlí|ágúst|september|október|nóvember|desember|J|F|M|A|M|J|J|Á|S|O|N|D|0|sun.|mán.|þri.|mið.|fim.|fös.|lau.|sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur|S|M|Þ|M|F|F|L|0|f.Kr.|e.Kr.|fyrir Krist|eftir Krist|f.k.|e.k.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|v – HH:mm:ss|hmv|h:mm\u202Fa v|Hmv|v – HH:mm|M|L|Md|d.M.|MEd|E, d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027viku\u0027 W \u0027í\u0027 MMMM|MMMMW-count-other|\u0027viku\u0027 W \u0027í\u0027 MMMM|ms|mm:ss|y|y|yM|M. y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027viku\u0027 w \u0027af\u0027 Y|yw-count-other|\u0027viku\u0027 w \u0027af\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr.|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr.|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr.|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr.|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$is = $enkidatron$elm_cldr$Generated$Is$is;
var $enkidatron$elm_cldr$Generated$It$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'it',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$It$it = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$It$dayPeriods, 'it||||AM|PM|8|afternoon1|di pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|AM|PM|8|afternoon1|del pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|m.|p.|8|afternoon1|di pomeriggio|am|m.|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|p.|dd/MM/yy|d MMM y|d MMMM y|EEEE d MMMM y|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic|gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|G|F|M|A|M|G|L|A|S|O|N|D|0|dom|lun|mar|mer|gio|ven|sab|domenica|lunedì|martedì|mercoledì|giovedì|venerdì|sabato|D|L|M|M|G|V|S|0|a.C.|d.C.|avanti Cristo|dopo Cristo|aC|dC|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027settimana\u0027 W \u0027di\u0027 MMMM|MMMMW-count-other|\u0027settimana\u0027 W \u0027di\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027settimana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027settimana\u0027 w \u0027del\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|NKr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$it = $enkidatron$elm_cldr$Generated$It$it;
var $enkidatron$elm_cldr$Generated$Ja$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ja',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(23, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(4, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ja$ja = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ja$dayPeriods, 'ja||||午前|午後|9|afternoon1|昼|am|午前|evening1|夕方|midnight|真夜中|morning1|朝|night1|夜|night2|夜中|noon|正午|pm|午後|午前|午後|9|afternoon1|昼|am|午前|evening1|夕方|midnight|真夜中|morning1|朝|night1|夜|night2|夜中|noon|正午|pm|午後|午前|午後|9|afternoon1|昼|am|午前|evening1|夕方|midnight|真夜中|morning1|朝|night1|夜|night2|夜中|noon|正午|pm|午後|y/MM/dd|y/MM/dd|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|日|月|火|水|木|金|土|日曜日|月曜日|火曜日|水曜日|木曜日|金曜日|土曜日|日|月|火|水|木|金|土|0|紀元前|西暦|紀元前|西暦|BC|AD|H:mm|H:mm:ss|H:mm:ss z|H時mm分ss秒 zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|BK時|Bhm|BK:mm|Bhms|BK:mm:ss|d|d日|E|ccc|EBhm|BK:mm (E)|EBhms|BK:mm:ss (E)|Ed|d日(E)|EEEEd|d日EEEE|Ehm|aK:mm (E)|EHm|H:mm (E)|Ehms|aK:mm:ss (E)|EHms|H:mm:ss (E)|Gy|Gy年|GyMd|Gy/M/d|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日(E)|GyMMMEEEEd|Gy年M月d日EEEE|h|aK時|H|H時|hm|aK:mm|Hm|H:mm|hms|aK:mm:ss|Hms|H:mm:ss|hmsv|aK:mm:ss v|Hmsv|H:mm:ss v|hmv|aK:mm v|Hmv|H:mm v|M|M月|Md|M/d|MEd|M/d(E)|MEEEEd|M/dEEEE|MMM|M月|MMMd|M月d日|MMMEd|M月d日(E)|MMMEEEEd|M月d日EEEE|MMMMd|M月d日|MMMMW-count-other|M月第W週|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/d(E)|yMEEEEd|y/M/dEEEE|yMM|y/MM|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日(E)|yMMMEEEEd|y年M月d日EEEE|yMMMM|y年M月|yQQQ|y/QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w週|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|元|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|￥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|レイ|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ja = $enkidatron$elm_cldr$Generated$Ja$ja;
var $enkidatron$elm_cldr$Generated$Jv$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Jv$jv = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Jv$dayPeriods, 'jv||||Isuk|Wengi|2|am|Isuk|pm|Wengi|Isuk|Wengi|2|am|Isuk|pm|Wengi|Isuk|Wengi|2|am|Isuk|pm|Wengi|dd-MM-y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|Mei|Jun|Jul|Agt|Sep|Okt|Nov|Des|Januari|Februari|Maret|April|Mei|Juni|Juli|Agustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|Ahad|Sen|Sel|Rab|Kam|Jum|Sab|Ahad|Senin|Selasa|Rabu|Kamis|Jumat|Sabtu|A|S|S|R|K|J|S|0|SM|M|Sakdurunge Masehi|Masehi|SM|M|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027pekan\u0027 W \u0027ing\u0027 MMMM|ms|mm:ss|y|y|yM|MM-y|yMd|dd-MM-y|yMEd|E, dd-MM-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027pekan\u0027 w \u0027ing\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$jv = $enkidatron$elm_cldr$Generated$Jv$jv;
var $enkidatron$elm_cldr$Generated$Ka$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ka',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ka$ka = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ka$dayPeriods, 'ka||||AM|PM|8|afternoon1|ნაშუადღ.|am|AM|evening1|საღ.|midnight|შუაღამეს|morning1|დილ.|night1|ღამ.|noon|შუადღ.|pm|PM|AM|PM|8|afternoon1|ნაშუადღევს|am|AM|evening1|საღამოს|midnight|შუაღამეს|morning1|დილით|night1|ღამით|noon|შუადღეს|pm|PM|a|p|8|afternoon1|ნაშუადღ.|am|a|evening1|საღ.|midnight|შუაღამეს|morning1|დილ.|night1|ღამ.|noon|შუადღ.|pm|p|dd.MM.yy|d MMM. y|d MMMM, y|EEEE, dd MMMM, y|იან|თებ|მარ|აპრ|მაი|ივნ|ივლ|აგვ|სექ|ოქტ|ნოე|დეკ|იანვარი|თებერვალი|მარტი|აპრილი|მაისი|ივნისი|ივლისი|აგვისტო|სექტემბერი|ოქტომბერი|ნოემბერი|დეკემბერი|ი|თ|მ|ა|მ|ი|ი|ა|ს|ო|ნ|დ|0|კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ|კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი|კ|ო|ს|ო|ხ|პ|შ|0|ძვ. წ.|ახ. წ.|ძველი წელთაღრიცხვით|ახალი წელთაღრიცხვით|ძვ. წ.|ახ. წ.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E, h:mm a|EHm|E, HH:mm|Ehms|E, h:mm:ss a|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM. y G|GyMMMd|d MMM. y G|GyMMMEd|E, d MMM. y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMMს კვირა W|MMMMW-count-other|MMMMს კვირა W|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM. y|yMMMd|d MMM. y|yMMMEd|E, d MMM. y|yMMMM|MMMM, y|yQQQ|QQQ, y|yQQQQ|QQQQ, y|yw-count-one|კვირა w, Y|yw-count-other|კვირა w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ka = $enkidatron$elm_cldr$Generated$Ka$ka;
var $enkidatron$elm_cldr$Generated$Kk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'kk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Kk$kk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Kk$dayPeriods, 'kk||||AM|PM|8|afternoon1|түстен кейінгі|am|AM|evening1|кешкі|midnight|түн жарымы|morning1|таңғы|night1|түнгі|noon|түскі|pm|PM|AM|PM|8|afternoon1|түстен кейінгі|am|AM|evening1|кешкі|midnight|түн жарымы|morning1|таңғы|night1|түнгі|noon|түскі|pm|PM|AM|PM|8|afternoon1|түстен кейінгі|am|AM|evening1|кешкі|midnight|түнгі|morning1|таңғы|night1|түнгі|noon|түскі|pm|PM|dd.MM.yy|y\u202F\u0027ж\u0027. dd MMM|y\u202F\u0027ж\u0027. d MMMM|y\u202F\u0027ж\u0027. d MMMM, EEEE|қаң.|ақп.|нау.|сәу.|мам.|мау.|шіл.|там.|қыр.|қаз.|қар.|жел.|қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан|Қ|А|Н|С|М|М|Ш|Т|Қ|Қ|Қ|Ж|1|қаң.|ақп.|нау.|сәу.|мам.|мау.|шіл.|там.|қыр.|қаз.|қар.|жел.|Қаңтар|Ақпан|Наурыз|Сәуір|Мамыр|Маусым|Шілде|Тамыз|Қыркүйек|Қазан|Қараша|Желтоқсан|Қ|А|Н|С|М|М|Ш|Т|Қ|Қ|Қ|Ж|жс|дс|сс|ср|бс|жм|сб|жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі|Ж|Д|С|С|Б|Ж|С|0|б.з.д.|б.з.|Біздің заманымызға дейін|біздің заманымыз|б.з.д.|б.з.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y\u202F\u0027ж\u0027.|GyMd|dd-MM-GGGGG y|GyMMM|G y\u202F\u0027ж\u0027. MMM|GyMMMd|G y\u202F\u0027ж\u0027. d MMM|GyMMMEd|G y\u202F\u0027ж\u0027. d MMM, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMM \u0027айының\u0027 W-\u0027аптасы\u0027|MMMMW-count-other|MMMM \u0027айының\u0027 W-\u0027аптасы\u0027|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y, E|yMMM|y\u202F\u0027ж\u0027. MMM|yMMMd|y\u202F\u0027ж\u0027. d MMM|yMMMEd|y\u202F\u0027ж\u0027. d MMM, E|yMMMM|y\u202F\u0027ж\u0027. MMMM|yQQQ|y\u202F\u0027ж\u0027. QQQ|yQQQQ|y\u202F\u0027ж\u0027. QQQQ|yw-count-one|Y \u0027жылдың\u0027 w-\u0027аптасы\u0027|yw-count-other|Y \u0027жылдың\u0027 w-\u0027аптасы\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LSL|ЛСЛ|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$kk = $enkidatron$elm_cldr$Generated$Kk$kk;
var $enkidatron$elm_cldr$Generated$Km$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'km',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Km$km = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Km$dayPeriods, 'km||||AM|PM|8|afternoon1|នៅពេលរសៀល|am|AM|evening1|នៅពេល\u200Bល្ងាច|midnight|អធ្រាត្រ|morning1|នៅពេល\u200Bព្រឹក|night1|នៅពេល\u200Bយប់|noon|ថ្ងៃត្រង់|pm|PM|AM|PM|8|afternoon1|នៅពេលរសៀល|am|AM|evening1|នៅពេល\u200Bល្ងាច|midnight|អធ្រាត្រ|morning1|នៅពេល\u200Bព្រឹក|night1|នៅពេល\u200Bយប់|noon|ថ្ងៃត្រង់|pm|PM|a|p|8|afternoon1|នៅពេលរសៀល|am|a|evening1|នៅពេល\u200Bល្ងាច|midnight|អធ្រាត្រ|morning1|នៅពេល\u200Bព្រឹក|night1|នៅពេល\u200Bយប់|noon|ថ្ងៃត្រង់|pm|p|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ|មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ|ម|ក|ម|ម|ឧ|ម|ក|ស|ក|ត|វ|ធ|0|អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហ|សុក្រ|សៅរ៍|អាទិត្យ|ច័ន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍|អ|ច|អ|ព|ព|ស|ស|1|អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហ|សុក្រ|សៅរ៍|អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍|អ|ច|អ|ព|ព|ស|ស|មុន គ.ស.|គ.ស.|មុន\u200Bគ្រិស្តសករាជ|គ្រិស្តសករាជ|មុន គ.ស.|គ.ស.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|MMMM d|MMMMW-count-other|សប្តាហ៍ទី W នៃខែ MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|សប្តាហ៍ទី w នៃឆ្នាំ Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-|¤||¤||¤|E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LSL|ឡូទី|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$km = $enkidatron$elm_cldr$Generated$Km$km;
var $enkidatron$elm_cldr$Generated$Kn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'kn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Kn$kn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Kn$dayPeriods, 'kn||||ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|7|afternoon1|ಮಧ್ಯಾಹ್ನ|am|ಪೂರ್ವಾಹ್ನ|evening1|ಸಂಜೆ|midnight|ಮಧ್ಯ ರಾತ್ರಿ|morning1|ಬೆಳಗ್ಗೆ|night1|ರಾತ್ರಿ|pm|ಅಪರಾಹ್ನ|ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|7|afternoon1|ಮಧ್ಯಾಹ್ನ|am|ಪೂರ್ವಾಹ್ನ|evening1|ಸಂಜೆ|midnight|ಮಧ್ಯ ರಾತ್ರಿ|morning1|ಬೆಳಗ್ಗೆ|night1|ರಾತ್ರಿ|pm|ಅಪರಾಹ್ನ|ಪೂ|ಅ|7|afternoon1|ಮಧ್ಯಾಹ್ನ|am|ಪೂ|evening1|ಸಂಜೆ|midnight|ಮಧ್ಯರಾತ್ರಿ|morning1|ಬೆಳಗ್ಗೆ|night1|ರಾತ್ರಿ|pm|ಅ|d/M/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ|ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಜೂ|ಜು|ಆ|ಸೆ|ಅ|ನ|ಡಿ|1|ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ|ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಜೂ|ಜು|ಆ|ಸೆ|ಅ|ನ|ಡಿ|ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ|ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ|ಭಾ|ಸೋ|ಮಂ|ಬು|ಗು|ಶು|ಶ|0|ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ|ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ|hh:mm a|hh:mm:ss a|hh:mm:ss a z|hh:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/M, E|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, M/d/y|yMM|MM-y|yMMM|MMM y|yMMMd|MMM d,y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahhmm|ahhmmss|ahhmmssz|ahhmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|ಲೀ|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$kn = $enkidatron$elm_cldr$Generated$Kn$kn;
var $enkidatron$elm_cldr$Generated$Ko$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ko',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ko$ko = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ko$dayPeriods, 'ko||||AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|PM|오전|오후|9|afternoon1|오후|am|오전|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|오후|AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|PM|yy. M. d.|y. M. d.|y년 MMMM d일|y년 MMMM d일 EEEE|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|0|일|월|화|수|목|금|토|일요일|월요일|화요일|수요일|목요일|금요일|토요일|일|월|화|수|목|금|토|0|BC|AD|기원전|서기|BC|AD|a h:mm|a h:mm:ss|a h시 m분 s초 z|a h시 m분 s초 zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|B h시|Bhm|B h:mm|Bhms|B h:mm:ss|d|d일|E|ccc|EBhm|(E) B h:mm|EBhms|(E) B h:mm:ss|Ed|d일 (E)|EEEEd|d일 EEEE|Ehm|(E) a h:mm|EHm|(E) HH:mm|Ehms|(E) a h:mm:ss|EHms|(E) HH:mm:ss|Gy|G y년|GyMd|GGGGG y/M/d|GyMMM|G y년 MMM|GyMMMd|G y년 MMM d일|GyMMMEd|G y년 MMM d일 (E)|GyMMMEEEEd|G y년 MMM d일 EEEE|h|a h시|H|H시|HHmmss|HH:mm:ss|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|H시 m분 s초|hmsv|a h:mm:ss v|Hmsv|H시 m분 s초 v|hmv|a h:mm v|Hmv|HH:mm v|M|M월|Md|M. d.|MEd|M. d. (E)|MEEEEd|M. d. EEEE|MMM|LLL|MMMd|MMM d일|MMMEd|MMM d일 (E)|MMMEEEEd|MMM d일 EEEE|MMMMd|MMMM d일|MMMMW-count-other|MMMM W번째 주|mmss|mm:ss|ms|mm:ss|y|y년|yM|y. M.|yMd|y. M. d.|yMEd|y. M. d. (E)|yMEEEEd|y. M. d. EEEE|yMM|y. M.|yMMM|y년 MMM|yMMMd|y년 MMM d일|yMMMEd|y년 MMM d일 (E)|yMMMEEEEd|y년 MMM d일 EEEE|yMMMM|y년 MMMM|yQQQ|y년 QQQ|yQQQQ|y년 QQQQ|yw-count-other|Y년 w번째 주|ahmm|ahmmss|ahmsz|ahmszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ko = $enkidatron$elm_cldr$Generated$Ko$ko;
var $enkidatron$elm_cldr$Generated$Ky$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ky',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ky$ky = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ky$dayPeriods, 'ky||||тң|тк|8|afternoon1|түштөн кийин|am|тң|evening1|кечинде|midnight|түн ортосу|morning1|эртең менен|night1|түн ичинде|noon|чак түш|pm|тк|таңкы|түштөн кийинки|8|afternoon1|түштөн кийин|am|таңкы|evening1|кечинде|midnight|түн ортосу|morning1|эртең менен|night1|түн ичинде|noon|чак түш|pm|түштөн кийинки|тң|тк|8|afternoon1|түшт кйн|am|тң|evening1|кечк|midnight|түн орт|morning1|эртң мн|night1|түн|noon|чт|pm|тк|d/M/yy|y-\u0027ж\u0027., d-MMM|y-\u0027ж\u0027., d-MMMM|y-\u0027ж\u0027., d-MMMM, EEEE|янв.|фев.|мар.|апр.|май|июн.|июл.|авг.|сен.|окт.|ноя.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|Янв|Фев|Мар|Апр|Май|Июн|Июл|Авг|Сен|Окт|Ноя|Дек|Январь|Февраль|Март|Апрель|Май|Июнь|Июль|Август|Сентябрь|Октябрь|Ноябрь|Декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|жек.|дүй.|шейш.|шарш.|бейш.|жума|ишм.|жекшемби|дүйшөмбү|шейшемби|шаршемби|бейшемби|жума|ишемби|Ж|Д|Ш|Ш|Б|Ж|И|0|б.з.ч.|б.з.|биздин заманга чейин|биздин заман|б.з.ч.|б.з.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y-\u0027ж\u0027.|GyMd|GGGGG y-MM-dd|GyMMM|G y-\u0027ж\u0027. MMM|GyMMMd|G y-\u0027ж\u0027. d-MMM|GyMMMEd|G y-\u0027ж\u0027. d-MMM, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|dd-MM, E|MMM|LLL|MMMd|d-MMM|MMMEd|d-MMM, E|MMMMd|d-MMMM|MMMMW-count-one|MMMM \u0027айынын\u0027 W-\u0027аптасы\u0027|MMMMW-count-other|MMMM \u0027айынын\u0027 W-\u0027аптасы\u0027|ms|mm:ss|y|y|yM|y-MM|yMd|y-dd-MM|yMEd|y-dd-MM, E|yMMM|y-\u0027ж\u0027. MMM|yMMMd|y-\u0027ж\u0027. d-MMM|yMMMEd|y-\u0027ж\u0027. d-MMM, E|yMMMM|y-\u0027ж\u0027., MMMM|yQQQ|y-\u0027ж\u0027., QQQ|yQQQQ|y-\u0027ж\u0027., QQQQ|yw-count-one|Y-\u0027жылдын\u0027 w-\u0027аптасы\u0027|yw-count-other|Y-\u0027жылдын\u0027 w-\u0027аптасы\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|BD$|BND|$|BOB|Bs|BRL|BRL|BSD|B$|BWP|P|BYN|р.|BZD|BZ$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|RD$|EGP|LE|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|Kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|J$|JPY|JP¥|KGS|сом|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ky = $enkidatron$elm_cldr$Generated$Ky$ky;
var $enkidatron$elm_cldr$Generated$Lo$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'lo',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Lo$lo = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Lo$dayPeriods, 'lo||||ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ|8|afternoon1|ຕອນບ່າຍ|am|ກ່ອນທ່ຽງ|evening1|ຕອນແລງ|midnight|ທ່ຽງຄືນ|morning1|ຕອນເຊົ້າ|night1|ກາງຄືນ|noon|ຕອນທ່ຽງ|pm|ຫຼັງທ່ຽງ|ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ|8|afternoon1|ຕອນບ່າຍ|am|ກ່ອນທ່ຽງ|evening1|ຕອນແລງ|midnight|ທ່ຽງຄືນ|morning1|ຕອນເຊົ້າ|night1|ຕອນກາງຄືນ|noon|ຕອນທ່ຽງ|pm|ຫຼັງທ່ຽງ|ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ|8|afternoon1|ຕອນທ່ຽງ|am|ກ່ອນທ່ຽງ|evening1|ຕອນແລງ|midnight|ທ່ຽງຄືນ|morning1|ຕອນເຊົ້າ|night1|ກາງຄືນ|noon|ຕອນທ່ຽງ|pm|ຫຼັງທ່ຽງ|d/M/y|d MMM y|d MMMM y|EEEE ທີ d MMMM G y|ມ.ກ.|ກ.ພ.|ມ.ນ.|ມ.ສ.|ພ.ພ.|ມິ.ຖ.|ກ.ລ.|ສ.ຫ.|ກ.ຍ.|ຕ.ລ.|ພ.ຈ.|ທ.ວ.|ມັງກອນ|ກຸມພາ|ມີນາ|ເມສາ|ພຶດສະພາ|ມິຖຸນາ|ກໍລະກົດ|ສິງຫາ|ກັນຍາ|ຕຸລາ|ພະຈິກ|ທັນວາ|1|2|3|4|5|6|7|8|9|10|11|12|0|ອາທິດ|ຈັນ|ອັງຄານ|ພຸດ|ພະຫັດ|ສຸກ|ເສົາ|ວັນອາທິດ|ວັນຈັນ|ວັນອັງຄານ|ວັນພຸດ|ວັນພະຫັດ|ວັນສຸກ|ວັນເສົາ|ອາ|ຈ|ອ|ພ|ພຫ|ສຸ|ສ|0|ກ່ອນ ຄ.ສ.|ຄ.ສ.|ກ່ອນຄຣິດສັກກະລາດ|ຄຣິດສັກກະລາດ|ກ່ອນ ຄ.ສ.|ຄ.ສ.|H:mm|H:mm:ss|H ໂມງ m ນາທີ ss ວິນາທີ z|H ໂມງ m ນາທີ ss ວິນາທີ zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM, G y|GyMMMd|d MMMM, G y|GyMMMEd|E d MMMM, G y|h|h ໂມງa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-other|ອາທິດທີ່ W ຂອງເດືອນ M|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|ອາທິດທີ່ w ຂອງປີ Y|Hmm|Hmmss|Hmssz|Hmsszzzz|X3W.|,|-||||||E2W.|,|¤-||¤||¤||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$lo = $enkidatron$elm_cldr$Generated$Lo$lo;
var $enkidatron$elm_cldr$Generated$Lt$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'lt',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Lt$lt = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Lt$dayPeriods, 'lt||||priešpiet|popiet|8|afternoon1|popietė|am|priešpiet|evening1|vakaras|midnight|vidurnaktis|morning1|rytas|night1|naktis|noon|perpiet|pm|popiet|priešpiet|popiet|8|afternoon1|popietė|am|priešpiet|evening1|vakaras|midnight|vidurnaktis|morning1|rytas|night1|naktis|noon|perpiet|pm|popiet|pr.\u202Fp.|pop.|8|afternoon1|popietė|am|pr.\u202Fp.|evening1|vakaras|midnight|vidurnaktis|morning1|rytas|night1|naktis|noon|perpiet|pm|pop.|y-MM-dd|y-MM-dd|y \u0027m\u0027. MMMM d \u0027d\u0027.|y \u0027m\u0027. MMMM d \u0027d\u0027., EEEE|saus.|vas.|kov.|bal.|geg.|birž.|liep.|rugp.|rugs.|spal.|lapkr.|gruod.|sausio|vasario|kovo|balandžio|gegužės|birželio|liepos|rugpjūčio|rugsėjo|spalio|lapkričio|gruodžio|S|V|K|B|G|B|L|R|R|S|L|G|1|saus.|vas.|kov.|bal.|geg.|birž.|liep.|rugp.|rugs.|spal.|lapkr.|gruod.|sausis|vasaris|kovas|balandis|gegužė|birželis|liepa|rugpjūtis|rugsėjis|spalis|lapkritis|gruodis|S|V|K|B|G|B|L|R|R|S|L|G|sk|pr|an|tr|kt|pn|št|sekmadienis|pirmadienis|antradienis|trečiadienis|ketvirtadienis|penktadienis|šeštadienis|S|P|A|T|K|P|Š|0|pr. Kr.|po Kr.|prieš Kristų|po Kristaus|pr. Kr.|po Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|dd|E|ccc|EBhm|h:mm B, E|EBhms|h:mm:ss B, E|Ed|d, E|Ehm|hh:mm\u202Fa, E|EHm|HH:mm, E|Ehms|hh:mm:ss\u202Fa, E|EHms|HH:mm:ss, E|Gy|y \u0027m\u0027. G|GyMd|y-MM-dd G|GyMMM|y-MM G|GyMMMd|y-MM-dd G|GyMMMEd|y-MM-dd G, E|GyMMMM|y \u0027m\u0027. G, LLLL|GyMMMMd|y \u0027m\u0027. G MMMM d \u0027d\u0027.|GyMMMMEd|y \u0027m\u0027. G MMMM d \u0027d\u0027., E|h|hh\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|hh:mm:ss\u202Fa; v|Hmsv|HH:mm:ss; v|hmv|hh:mm\u202Fa; v|Hmv|HH:mm; v|M|MM|Md|MM-d|MEd|MM-dd, E|MMdd|MM-dd|MMM|MM|MMMd|MM-dd|MMMEd|MM-dd, E|MMMM|LLLL|MMMMd|MMMM d \u0027d\u0027.|MMMMEd|MMMM d \u0027d\u0027., E|MMMMW-count-one|MMMM W \u0027sav\u0027.|MMMMW-count-few|MMMM W \u0027sav\u0027.|MMMMW-count-many|MMMM W \u0027sav\u0027.|MMMMW-count-other|MMMM W \u0027sav\u0027.|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y-MM|yMMMd|y-MM-dd|yMMMEd|y-MM-dd, E|yMMMM|y \u0027m\u0027. LLLL|yMMMMd|y \u0027m\u0027. MMMM d \u0027d\u0027.|yMMMMEd|y \u0027m\u0027. MMMM d \u0027d\u0027., E|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y w \u0027sav\u0027.|yw-count-few|Y w \u0027sav\u0027.|yw-count-many|Y w \u0027sav\u0027.|yw-count-other|Y w \u0027sav\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|BDT|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|KHR|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|LAK|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|MNT|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zl|PYG|Gs|RON|lei|RUB|rb|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|XPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$lt = $enkidatron$elm_cldr$Generated$Lt$lt;
var $enkidatron$elm_cldr$Generated$Lv$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'lv',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(23, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Lv$lv = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Lv$dayPeriods, 'lv||||priekšp.|pēcp.|8|afternoon1|pēcpusd.|am|priekšp.|evening1|vakarā|midnight|pusnaktī|morning1|no rīta|night1|naktī|noon|pusd.|pm|pēcp.|priekšpusdienā|pēcpusdienā|8|afternoon1|pēcpusdienā|am|priekšpusdienā|evening1|vakarā|midnight|pusnaktī|morning1|no rīta|night1|naktī|noon|pusdienlaikā|pm|pēcpusdienā|priekšp.|pēcp.|8|afternoon1|pēcpusd.|am|priekšp.|evening1|vakarā|midnight|pusnaktī|morning1|no rīta|night1|naktī|noon|pusd.|pm|pēcp.|dd.MM.yy|y. \u0027gada\u0027 d. MMM|y. \u0027gada\u0027 d. MMMM|EEEE, y. \u0027gada\u0027 d. MMMM|janv.|febr.|marts|apr.|maijs|jūn.|jūl.|aug.|sept.|okt.|nov.|dec.|janvāris|februāris|marts|aprīlis|maijs|jūnijs|jūlijs|augusts|septembris|oktobris|novembris|decembris|J|F|M|A|M|J|J|A|S|O|N|D|0|svētd.|pirmd.|otrd.|trešd.|ceturtd.|piektd.|sestd.|svētdiena|pirmdiena|otrdiena|trešdiena|ceturtdiena|piektdiena|sestdiena|S|P|O|T|C|P|S|1|Svētd.|Pirmd.|Otrd.|Trešd.|Ceturtd.|Piektd.|Sestd.|Svētdiena|Pirmdiena|Otrdiena|Trešdiena|Ceturtdiena|Piektdiena|Sestdiena|S|P|O|T|C|P|S|p.m.ē.|m.ē.|pirms mūsu ēras|mūsu ērā|p.m.ē.|m.ē.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|G y. \u0027g\u0027.|GyMd|GGGGG dd-MM-y|GyMMM|G y. \u0027g\u0027. MMM|GyMMMd|G y. \u0027g\u0027. d. MMM|GyMMMEd|E, G y. \u0027g\u0027. d. MMM|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM.|MEd|E, dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-zero|MMMM, W. \u0027nedēļa\u0027|MMMMW-count-one|MMMM, W. \u0027nedēļa\u0027|MMMMW-count-other|MMMM, W. \u0027nedēļa\u0027|mmss|mm:ss|ms|mm:ss|y|y. \u0027g\u0027.|yM|MM.y.|yMd|d.MM.y.|yMEd|E, d.MM.y.|yMMM|y. \u0027g\u0027. MMM|yMMMd|y. \u0027g\u0027. d. MMM|yMMMEd|E, y. \u0027g\u0027. d. MMM|yMMMM|y. \u0027g\u0027. MMMM|yQQQ|y. \u0027g\u0027. QQQ|yQQQQ|y. \u0027g\u0027. QQQQ|yw-count-zero|Y. \u0027g\u0027. w. \u0027nedēļa\u0027|yw-count-one|Y. \u0027g\u0027. w. \u0027nedēļa\u0027|yw-count-other|Y. \u0027g\u0027. w. \u0027nedēļa\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GHS|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$lv = $enkidatron$elm_cldr$Generated$Lv$lv;
var $enkidatron$elm_cldr$Generated$Mk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'mk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Mk$mk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Mk$dayPeriods, 'mk||||претпл.|попл.|9|afternoon1|попладне|am|претпл.|evening1|навечер|midnight|полноќ|morning1|наутро|morning2|претпладне|night1|ноќе|noon|напладне|pm|попл.|претпл.|попл.|9|afternoon1|попладне|am|претпл.|evening1|навечер|midnight|полноќ|morning1|наутро|morning2|претпладне|night1|ноќе|noon|напладне|pm|попл.|претпл.|попл.|9|afternoon1|попл.|am|претпл.|evening1|навечер|midnight|полн.|morning1|наутро|morning2|претпл.|night1|ноќе|noon|напл.|pm|попл.|d.M.yy|d.M.y|d MMMM y|EEEE, d MMMM y|јан.|фев.|мар.|апр.|мај|јун.|јул.|авг.|сеп.|окт.|ное.|дек.|јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед.|пон.|вто.|сре.|чет.|пет.|саб.|недела|понеделник|вторник|среда|четврток|петок|сабота|н|п|в|с|ч|п|с|0|п.н.е.|н.е.|пред нашата ера|од нашата ера|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M|Mdd|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W. \u0027седмица\u0027 \u0027од\u0027 MMMM|MMMMW-count-other|W. \u0027седмица\u0027 \u0027од\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|MMMM y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w. \u0027седмица\u0027 \u0027од\u0027 Y|yw-count-other|w. \u0027седмица\u0027 \u0027од\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MKD|ден.|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$mk = $enkidatron$elm_cldr$Generated$Mk$mk;
var $enkidatron$elm_cldr$Generated$Ml$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ml',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(15, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(15, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(19, 0),
					'evening2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ml$ml = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ml$dayPeriods, 'ml||||AM|PM|11|afternoon1|ഉച്ചയ്ക്ക്|afternoon2|ഉച്ചതിരിഞ്ഞ്|am|AM|evening1|വൈകുന്നേരം|evening2|സന്ധ്യ|midnight|അർദ്ധരാത്രി|morning1|പുലർച്ചെ|morning2|രാവിലെ|night1|രാത്രി|noon|ഉച്ച|pm|PM|AM|PM|11|afternoon1|ഉച്ചയ്ക്ക്|afternoon2|ഉച്ചതിരിഞ്ഞ്|am|AM|evening1|വൈകുന്നേരം|evening2|സന്ധ്യ|midnight|അർദ്ധരാത്രി|morning1|പുലർച്ചെ|morning2|രാവിലെ|night1|രാത്രി|noon|ഉച്ച|pm|PM|AM|PM|11|afternoon1|ഉച്ചയ്ക്ക്|afternoon2|ഉച്ചതിരിഞ്ഞ്|am|AM|evening1|വൈകുന്നേരം|evening2|സന്ധ്യ|midnight|അ|morning1|പുലർച്ചെ|morning2|രാവിലെ|night1|രാത്രി|noon|ഉച്ച|pm|PM|d/M/yy|y, MMM d|y, MMMM d|y, MMMM d, EEEE|ജനു|ഫെബ്രു|മാർ|ഏപ്രി|മേയ്|ജൂൺ|ജൂലൈ|ഓഗ|സെപ്റ്റം|ഒക്ടോ|നവം|ഡിസം|ജനുവരി|ഫെബ്രുവരി|മാർച്ച്|ഏപ്രിൽ|മേയ്|ജൂൺ|ജൂലൈ|ഓഗസ്റ്റ്|സെപ്റ്റംബർ|ഒക്\u200Cടോബർ|നവംബർ|ഡിസംബർ|ജ|ഫെ|മാ|ഏ|മെ|ജൂൺ|ജൂ|ഓ|സെ|ഒ|ന|ഡി|0|ഞായർ|തിങ്കൾ|ചൊവ്വ|ബുധൻ|വ്യാഴം|വെള്ളി|ശനി|ഞായറാഴ്\u200Cച|തിങ്കളാഴ്\u200Cച|ചൊവ്വാഴ്ച|ബുധനാഴ്\u200Cച|വ്യാഴാഴ്\u200Cച|വെള്ളിയാഴ്\u200Cച|ശനിയാഴ്\u200Cച|ഞ|തി|ചൊ|ബു|വ്യാ|വെ|ശ|1|ഞായർ|തിങ്കൾ|ചൊവ്വ|ബുധൻ|വ്യാഴം|വെള്ളി|ശനി|ഞായറാഴ്\u200Cച|തിങ്കളാഴ്\u200Cച|ചൊവ്വാഴ്\u200Cച|ബുധനാഴ്\u200Cച|വ്യാഴാഴ്\u200Cച|വെള്ളിയാഴ്\u200Cച|ശനിയാഴ്\u200Cച|ഞാ|തി|ചൊ|ബു|വ്യാ|വെ|ശ|ക്രി.മു.|എഡി|ക്രിസ്\u200Cതുവിന് മുമ്പ്|ആന്നോ ഡൊമിനി|ക്രി.മു.|എഡി|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/M, E|MMdd|dd/MM|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMEd|MMMM d, E|MMMMW-count-one|MMMM - ആഴ്ച W|MMMMW-count-other|MMMM - ആഴ്ച W|ms|mm:ss|y|y|yM|y-MM|yMd|d/M/y|yMEd|d-M-y, E|yMM|y-MM|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y-ലെ ആഴ്ച w|yw-count-other|Y-ലെ ആഴ്ച w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ml = $enkidatron$elm_cldr$Generated$Ml$ml;
var $enkidatron$elm_cldr$Generated$Mn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'mn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Mn$mn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Mn$dayPeriods, 'mn||||ү.ө.|ү.х.|8|afternoon1|өдөр|am|ү.ө.|evening1|орой|midnight|шөнө дунд|morning1|өглөө|night1|шөнө|noon|үд дунд|pm|ү.х.|ү.ө.|ү.х.|8|afternoon1|өдөр|am|ү.ө.|evening1|орой|midnight|шөнө дунд|morning1|өглөө|night1|шөнө|noon|үд дунд|pm|ү.х.|ү.ө.|ү.х.|8|afternoon1|өдөр|am|ү.ө.|evening1|орой|midnight|шөнө дунд|morning1|өглөө|night1|шөнө|noon|үд дунд|pm|ү.х.|y.MM.dd|y\u202F\u0027оны\u0027 MMM\u0027ын\u0027 d|y\u202F\u0027оны\u0027 MMMM\u0027ын\u0027 d|y\u202F\u0027оны\u0027 MMMM\u0027ын\u0027 d, EEEE \u0027гараг\u0027|1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар|нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар|I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|1|1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар|Нэгдүгээр сар|Хоёрдугаар сар|Гуравдугаар сар|Дөрөвдүгээр сар|Тавдугаар сар|Зургаадугаар сар|Долоодугаар сар|Наймдугаар сар|Есдүгээр сар|Аравдугаар сар|Арван нэгдүгээр сар|Арван хоёрдугаар сар|I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|Ня|Да|Мя|Лх|Пү|Ба|Бя|ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба|Ня|Да|Мя|Лх|Пү|Ба|Бя|1|Ня|Да|Мя|Лх|Пү|Ба|Бя|Ням|Даваа|Мягмар|Лхагва|Пүрэв|Баасан|Бямба|Ня|Да|Мя|Лх|Пү|Ба|Бя|МЭӨ|МЭ|манай эриний өмнөх|манай эриний|МЭӨ|МЭ|HH:mm|HH:mm:ss|HH:mm:ss (z)|HH:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h \u0027ц\u0027|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E. B h:mm|EBhms|E. B h:mm:ss|Ed|dd. E|Ehm|E. h:mm\u202Fa|EHm|E. HH:mm|Ehms|E. h:mm:ss\u202Fa|EHms|E. HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y\u202F\u0027оны\u0027 MMM|GyMMMd|G y\u202F\u0027оны\u0027 MMM\u0027ын\u0027 d|GyMMMEd|G y\u202F\u0027оны\u0027 MMM\u0027ын\u0027 d. E|h|h \u0027ц\u0027 a|H|HH \u0027ц\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|LLLLL|Md|MMMMM/dd|MEd|MMMMM/dd. E|MMM|LLL|MMMd|MMM\u0027ын\u0027 d|MMMEd|MMM\u0027ын\u0027 d. E|MMMMd|MMMM\u0027ын\u0027 d|MMMMW-count-one|MMMM\u0027ын\u0027 W-\u0027р\u0027 \u0027долоо\u0027 \u0027хоног\u0027|MMMMW-count-other|MMMM\u0027ын\u0027 W-\u0027р\u0027 \u0027долоо\u0027 \u0027хоног\u0027|ms|mm:ss|y|y|yM|y MMMMM|yMd|y.MM.dd|yMEd|y.MM.dd. E|yMMM|y\u202F\u0027оны\u0027 MMM|yMMMd|y\u202F\u0027оны\u0027 MMM\u0027ын\u0027 d|yMMMEd|y\u202F\u0027оны\u0027 MMM\u0027ын\u0027 d. E|yMMMM|y\u202F\u0027оны\u0027 MMMM|yQQQ|y\u202F\u0027оны\u0027 QQQ|yQQQQ|y\u202F\u0027оны\u0027 QQQQ|yw-count-one|Y \u0027оны\u0027 w-\u0027р\u0027 \u0027долоо\u0027 \u0027хоног\u0027|yw-count-other|Y \u0027оны\u0027 w-\u0027р\u0027 \u0027долоо\u0027 \u0027хоног\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|кр|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$mn = $enkidatron$elm_cldr$Generated$Mn$mn;
var $enkidatron$elm_cldr$Generated$Mr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'mr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Mr$mr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Mr$dayPeriods, 'mr||||AM|PM|9|afternoon1|दुपार|am|AM|evening1|संध्याकाळ|midnight|मध्यरात्र|morning1|पहाट|morning2|सकाळ|night1|रात्र|noon|मध्यान्ह|pm|PM|AM|PM|9|afternoon1|दुपार|am|AM|evening1|संध्याकाळ|midnight|मध्यरात्र|morning1|पहाट|morning2|सकाळ|night1|रात्र|noon|मध्यान्ह|pm|PM|a|p|9|afternoon1|दु|am|a|evening1|सं|midnight|म.रा.|morning1|प|morning2|स|night1|रा|noon|दु|pm|p|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|जाने|फेब्रु|मार्च|एप्रि|मे|जून|जुलै|ऑग|सप्टें|ऑक्टो|नोव्हें|डिसें|जानेवारी|फेब्रुवारी|मार्च|एप्रिल|मे|जून|जुलै|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|जा|फे|मा|ए|मे|जू|जु|ऑ|स|ऑ|नो|डि|0|रवि|सोम|मंगळ|बुध|गुरु|शुक्र|शनि|रविवार|सोमवार|मंगळवार|बुधवार|गुरुवार|शुक्रवार|शनिवार|र|सो|मं|बु|गु|शु|श|0|ई. स. पू.|इ. स.|ईसवीसनपूर्व|ईसवीसन|ई. स. पू.|इ. स.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG d/M/y|GyMMM|MMM G y|GyMMMd|d MMM, G y|GyMMMEd|E, d MMM, G y|h|h a|H|HH|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMM चा W रा आठवडा|MMMMW-count-other|MMMM चा W रा आठवडा|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d, MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y चा w वा आठवडा|yw-count-other|Y चा w वा आठवडा|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$mr = $enkidatron$elm_cldr$Generated$Mr$mr;
var $enkidatron$elm_cldr$Generated$Ms$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ms',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ms$ms = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ms$dayPeriods, 'ms||||PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|PTG|PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|tengah malam|morning2|pagi|night1|malam|pm|PTG|a|p|7|afternoon1|tengah hari|am|a|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|p|d/MM/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ogo|Sep|Okt|Nov|Dis|Januari|Februari|Mac|April|Mei|Jun|Julai|Ogos|September|Oktober|November|Disember|J|F|M|A|M|J|J|O|S|O|N|D|0|Ahd|Isn|Sel|Rab|Kha|Jum|Sab|Ahad|Isnin|Selasa|Rabu|Khamis|Jumaat|Sabtu|A|I|S|R|K|J|S|0|S.M.|TM|S.M.|TM|S.M.|TM|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E, d-M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ms = $enkidatron$elm_cldr$Generated$Ms$ms;
var $enkidatron$elm_cldr$Generated$My$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'my',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$My$my = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$My$dayPeriods, 'my||||နံနက်|ညနေ|8|afternoon1|နေ့လယ်|am|နံနက်|evening1|ညနေ|midnight|သန်းခေါင်ယံ|morning1|နံနက်|night1|ည|noon|မွန်းတည့်|pm|ညနေ|နံနက်|ညနေ|8|afternoon1|နေ့လယ်|am|နံနက်|evening1|ညနေ|midnight|သန်းခေါင်ယံ|morning1|နံနက်|night1|ည|noon|မွန်းတည့်|pm|ညနေ|နံနက်|ညနေ|8|afternoon1|နေ့လယ်|am|နံနက်|evening1|ညနေ|midnight|သန်းခေါင်ယံ|morning1|နံနက်|night1|ည|noon|မွန်းတည့်|pm|ညနေ|d/M/yy|y၊ MMM d|y၊ MMMM d|y၊ MMMM d၊ EEEE|ဇန်|ဖေ|မတ်|ဧ|မေ|ဇွန်|ဇူ|ဩ|စက်|အောက်|နို|ဒီ|ဇန်နဝါရီ|ဖေဖော်ဝါရီ|မတ်|ဧပြီ|မေ|ဇွန်|ဇူလိုင်|ဩဂုတ်|စက်တင်ဘာ|အောက်တိုဘာ|နိုဝင်ဘာ|ဒီဇင်ဘာ|ဇ|ဖ|မ|ဧ|မ|ဇ|ဇ|ဩ|စ|အ|န|ဒ|0|တနင်္ဂနွေ|တနင်္လာ|အင်္ဂါ|ဗုဒ္ဓဟူး|ကြာသပတေး|သောကြာ|စနေ|တနင်္ဂနွေ|တနင်္လာ|အင်္ဂါ|ဗုဒ္ဓဟူး|ကြာသပတေး|သောကြာ|စနေ|တ|တ|အ|ဗ|က|သ|စ|0|ဘီစီ|အဒေီ|ခရစ်တော် မပေါ်မီနှစ်|ခရစ်နှစ်|ဘီစီ|အဒေီ|H:mm|H:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d ရက် E|Ehm|E B h:mm|EHm|E HH:mm|Ehms|E B h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|G y/M/d|GyMMM|G y MMM|GyMMMd|G y၊ MMM d|GyMMMEd|G y၊ MMM d၊ E|h|B h|H|HH|hm|B h:mm|Hm|HH:mm|hms|B h:mm:ss|Hms|HH:mm:ss|hmsv|v a h:mm:ss|Hmsv|v HH:mm:ss|hmv|v a h:mm|Hmv|v HH:mm|M|L|Md|d/M|MEd|d/M၊ E|MMM|LLL|MMMd|d MMM|MMMEd|MMM d၊ E|MMMMd|MMMM d|MMMMEd|MMMM d ရက် E|MMMMW-count-other|MMMM လ W ပတ်မြောက်|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|d/M/y၊ E|yMMM|MMM y|yMMMd|y၊ MMM d|yMMMEd|y၊ MMM d၊ E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-other|Y ခု w ပတ်မြောက်|Hmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W,|.|-|%||%||%|110|AFN|؋|AMD|֏|ANG|NAf|AOA|Kz|ARS|$|AUD|A$|AWG|Afl|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|B$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HTG|G|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PAB|B/.|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$my = $enkidatron$elm_cldr$Generated$My$my;
var $enkidatron$elm_cldr$Generated$Nb$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'nb',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Nb$nb = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nb$dayPeriods, 'nb||||a.m.|p.m.|8|afternoon1|etterm.|am|a.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|p.m.|a.m.|p.m.|8|afternoon1|på ettermiddagen|am|a.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgenen|morning2|på formiddagen|night1|på natten|pm|p.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|søn.|man.|tir.|ons.|tor.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E \u0027kl\u0027. HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E \u0027kl\u0027. HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\u0027den\u0027 W. \u0027uken\u0027 \u0027i\u0027 MMMM|MMMMW-count-other|\u0027den\u0027 W. \u0027uken\u0027 \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027uke\u0027 w \u0027i\u0027 Y|yw-count-other|\u0027uke\u0027 w \u0027i\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nb = $enkidatron$elm_cldr$Generated$Nb$nb;
var $enkidatron$elm_cldr$Generated$Ne$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ne',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ne$ne = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ne$dayPeriods, 'ne||||पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|yy/M/d|y MMM d|y MMMM d|y MMMM d, EEEE|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जन|फेब|मार्च|अप्र|मे|जुन|जुल|अग|सेप|अक्टो|नोभे|डिसे|1|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जन|फेेब|मार्च|अप्र|मे|जुन|जुल|अग|सेप|अक्टो|नोभे|डिसे|आइत|सोम|मङ्गल|बुध|बिहि|शुक्र|शनि|आइतबार|सोमबार|मङ्गलबार|बुधबार|बिहिबार|शुक्रबार|शनिबार|आ|सो|म|बु|बि|शु|श|0|ईसा पूर्व|सन्|ईसा पूर्व|सन्|ईसा पूर्व|सन्|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-one|MMMM को W हप्ता|MMMMW-count-other|MMMM को W हप्ता|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y को w हप्ता|yw-count-other|Y को w हप्ता|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3I,|.|-||||||E2I,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|नेरू|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ne = $enkidatron$elm_cldr$Generated$Ne$ne;
var $enkidatron$elm_cldr$Generated$Nl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'nl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Nl$nl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl = $enkidatron$elm_cldr$Generated$Nl$nl;
var $enkidatron$elm_cldr$Generated$Nn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'nn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Nn$nn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nn$dayPeriods, 'nn||||f.m.|e.m.|8|afternoon1|etterm.|am|f.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|e.m.|f.m.|e.m.|8|afternoon1|på ettermiddagen|am|f.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgonen|morning2|på formiddagen|night1|på natta|pm|e.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|sø.|må.|ty.|on.|to.|fr.|la.|søndag|måndag|tysdag|onsdag|torsdag|fredag|laurdag|S|M|T|O|T|F|L|1|søn|mån|tys|ons|tor|fre|lau|søndag|måndag|tysdag|onsdag|torsdag|fredag|laurdag|S|M|T|O|T|F|L|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|\u0027kl\u0027. HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} \u0027kl\u0027. {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\u0027veke\u0027 W \u0027i\u0027 MMMM|MMMMW-count-other|\u0027veke\u0027 W \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027veke\u0027 w \u0027i\u0027 Y|yw-count-other|\u0027veke\u0027 w \u0027i\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nn = $enkidatron$elm_cldr$Generated$Nn$nn;
var $enkidatron$elm_cldr$Generated$No$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'no',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$No$no = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$No$dayPeriods, 'no||||a.m.|p.m.|8|afternoon1|etterm.|am|a.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|p.m.|a.m.|p.m.|8|afternoon1|på ettermiddagen|am|a.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgenen|morning2|på formiddagen|night1|på natten|pm|p.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|søn.|man.|tir.|ons.|tor.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E \u0027kl\u0027. HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E \u0027kl\u0027. HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\u0027den\u0027 W. \u0027uken\u0027 \u0027i\u0027 MMMM|MMMMW-count-other|\u0027den\u0027 W. \u0027uken\u0027 \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027uke\u0027 w \u0027i\u0027 Y|yw-count-other|\u0027uke\u0027 w \u0027i\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$no = $enkidatron$elm_cldr$Generated$No$no;
var $enkidatron$elm_cldr$Generated$Or$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Or$or = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Or$dayPeriods, 'or||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|ପୂ|ଅ|2|am|ପୂ|pm|ଅ|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|ଜାନୁଆରୀ|ଫେବୃଆରୀ|ମାର୍ଚ୍ଚ|ଅପ୍ରେଲ|ମଇ|ଜୁନ|ଜୁଲାଇ|ଅଗଷ୍ଟ|ସେପ୍ଟେମ୍ବର|ଅକ୍ଟୋବର|ନଭେମ୍ବର|ଡିସେମ୍ବର|ଜାନୁଆରୀ|ଫେବୃଆରୀ|ମାର୍ଚ୍ଚ|ଅପ୍ରେଲ|ମଇ|ଜୁନ|ଜୁଲାଇ|ଅଗଷ୍ଟ|ସେପ୍ଟେମ୍ବର|ଅକ୍ଟୋବର|ନଭେମ୍ବର|ଡିସେମ୍ବର|ଜା|ଫେ|ମା|ଅ|ମଇ|ଜୁ|ଜୁ|ଅ|ସେ|ଅ|ନ|ଡି|0|ରବି|ସୋମ|ମଙ୍ଗଳ|ବୁଧ|ଗୁରୁ|ଶୁକ୍ର|ଶନି|ରବିବାର|ସୋମବାର|ମଙ୍ଗଳବାର|ବୁଧବାର|ଗୁରୁବାର|ଶୁକ୍ରବାର|ଶନିବାର|ର|ସୋ|ମ|ବୁ|ଗୁ|ଶୁ|ଶ|0|BC|AD|ଖ୍ରୀଷ୍ଟପୂର୍ବ|ଖ୍ରୀଷ୍ଟାବ୍ଦ|BC|AD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|MMMM ର ସପ୍ତାହ W|MMMMW-count-other|MMMM ର ସପ୍ତାହ W|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMM|MM-y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ର ସପ୍ତାହ w|yw-count-other|Y ର ସପ୍ତାହ w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$or = $enkidatron$elm_cldr$Generated$Or$or;
var $enkidatron$elm_cldr$Generated$Pa$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'pa',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Pa$pa = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pa$dayPeriods, 'pa||||ਪੂ.ਦੁ.|ਬਾ.ਦੁ.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਪੂ.ਦੁ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਬਾ.ਦੁ.|ਪੂ.ਦੁ.|ਬਾ.ਦੁ.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਪੂ.ਦੁ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਬਾ.ਦੁ.|ਸ.|ਸ਼.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਸ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਸ਼.|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|ਜਨ|ਫ਼ਰ|ਮਾਰਚ|ਅਪ੍ਰੈ|ਮਈ|ਜੂਨ|ਜੁਲਾ|ਅਗ|ਸਤੰ|ਅਕਤੂ|ਨਵੰ|ਦਸੰ|ਜਨਵਰੀ|ਫ਼ਰਵਰੀ|ਮਾਰਚ|ਅਪ੍ਰੈਲ|ਮਈ|ਜੂਨ|ਜੁਲਾਈ|ਅਗਸਤ|ਸਤੰਬਰ|ਅਕਤੂਬਰ|ਨਵੰਬਰ|ਦਸੰਬਰ|ਜ|ਫ਼|ਮਾ|ਅ|ਮ|ਜੂ|ਜੁ|ਅ|ਸ|ਅ|ਨ|ਦ|0|ਐਤ|ਸੋਮ|ਮੰਗਲ|ਬੁੱਧ|ਵੀਰ|ਸ਼ੁੱਕਰ|ਸ਼ਨਿੱਚਰ|ਐਤਵਾਰ|ਸੋਮਵਾਰ|ਮੰਗਲਵਾਰ|ਬੁੱਧਵਾਰ|ਵੀਰਵਾਰ|ਸ਼ੁੱਕਰਵਾਰ|ਸ਼ਨਿੱਚਰਵਾਰ|ਐ|ਸੋ|ਮੰ|ਬੁੱ|ਵੀ|ਸ਼ੁੱ|ਸ਼|0|ਈ. ਪੂ.|ਸੰਨ|ਈਸਵੀ ਪੂਰਵ|ਈਸਵੀ ਸੰਨ|ਈ.ਪੂ.|ਸੰਨ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM, G y|GyMMMd|d MMM, G y|GyMMMEd|E d MMM, G y|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, dd-MM.|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|MMMM d|MMMMW-count-one|MMMM ਦਾ W ਹਫ਼ਤਾ|MMMMW-count-other|MMMM ਦਾ W ਹਫ਼ਤਾ|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ਦਾ w ਹਫ਼ਤਾ|yw-count-other|Y ਦਾ w ਹਫ਼ਤਾ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pa = $enkidatron$elm_cldr$Generated$Pa$pa;
var $enkidatron$elm_cldr$Generated$Pl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'pl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Pl$pl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pl$dayPeriods, 'pl||||AM|PM|9|afternoon1|po południu|am|AM|evening1|wieczorem|midnight|o północy|morning1|rano|morning2|przed południem|night1|w nocy|noon|w południe|pm|PM|AM|PM|9|afternoon1|po południu|am|AM|evening1|wieczorem|midnight|o północy|morning1|rano|morning2|przed południem|night1|w nocy|noon|w południe|pm|PM|a|p|9|afternoon1|po poł.|am|a|evening1|wiecz.|midnight|o półn.|morning1|rano|morning2|przed poł.|night1|w nocy|noon|w poł.|pm|p|d.MM.y|d MMM y|d MMMM y|EEEE, d MMMM y|sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|lis|gru|stycznia|lutego|marca|kwietnia|maja|czerwca|lipca|sierpnia|września|października|listopada|grudnia|s|l|m|k|m|c|l|s|w|p|l|g|1|sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|lis|gru|styczeń|luty|marzec|kwiecień|maj|czerwiec|lipiec|sierpień|wrzesień|październik|listopad|grudzień|S|L|M|K|M|C|L|S|W|P|L|G|niedz.|pon.|wt.|śr.|czw.|pt.|sob.|niedziela|poniedziałek|wtorek|środa|czwartek|piątek|sobota|n|p|w|ś|c|p|s|1|niedz.|pon.|wt.|śr.|czw.|pt.|sob.|niedziela|poniedziałek|wtorek|środa|czwartek|piątek|sobota|N|P|W|Ś|C|P|S|p.n.e.|n.e.|przed naszą erą|naszej ery|p.n.e.|n.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|LLLL y G|GyMMMMd|d MMMM y G|GyMMMMEd|E, d MMMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.MM|MEd|E, d.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|LLLL, \u0027tydz\u0027. W|MMMMW-count-few|LLLL, \u0027tydz\u0027. W|MMMMW-count-many|LLLL, \u0027tydz\u0027. W|MMMMW-count-other|LLLL, \u0027tydz\u0027. W|ms|mm:ss|y|y|yM|MM.y|yMd|d.MM.y|yMEd|E, d.MM.y|yMMM|LLL y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|LLLL y|yMMMMd|d MMMM y|yMMMMEd|E, d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y, \u0027tydz\u0027. w|yw-count-few|Y, \u0027tydz\u0027. w|yw-count-many|Y, \u0027tydz\u0027. w|yw-count-other|Y, \u0027tydz\u0027. w|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lej|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pl = $enkidatron$elm_cldr$Generated$Pl$pl;
var $enkidatron$elm_cldr$Generated$Ps$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ps$ps = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ps$dayPeriods, 'ps||||AM|PM|2|am|AM|pm|PM|غ.م.|غ.و.|2|am|غ.م.|pm|غ.و.|غ.م.|غ.و.|2|am|غ.م.|pm|غ.و.|y/M/d|y MMM d|y MMMM d|EEEE د y د MMMM d|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سېپتمبر|اکتوبر|نومبر|دسمبر|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سېپتمبر|اکتوبر|نومبر|دسمبر|ج|ف|م|ا|م|ج|ج|ا|س|ا|ن|د|1|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|اکتوبر|نومبر|دسمبر|جنوري|فېبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|اکتوبر|نومبر|دسمبر|1|2|3|4|5|6|7|8|9|10|11|12|يونۍ|دونۍ|درېنۍ|څلرنۍ|پينځنۍ|جمعه|اونۍ|يونۍ|دونۍ|درېنۍ|څلرنۍ|پينځنۍ|جمعه|اونۍ|S|M|T|W|T|F|S|0|له میلاد وړاندې|م.|له میلاد څخه وړاندې|له میلاد څخه وروسته|له میلاد وړاندې|م.|H:mm|H:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|اونۍ W د MMMM|MMMMW-count-other|اونۍ W د MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|اونۍ w د Y|yw-count-other|اونۍ w د Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|\u200E−||||||E2W.|,|\u200E−¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|\u200E−|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ps = $enkidatron$elm_cldr$Generated$Ps$ps;
var $enkidatron$elm_cldr$Generated$Pt$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'pt',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(19, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Pt$pt = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||||AM|PM|8|afternoon1|da tarde|am|AM|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|PM|AM|PM|8|afternoon1|da tarde|am|AM|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|PM|AM|PM|8|afternoon1|da tarde|am|AM|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|PM|dd/MM/y|d \u0027de\u0027 MMM \u0027de\u0027 y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|dom.|seg.|ter.|qua.|qui.|sex.|sáb.|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d \u0027de\u0027 MMM|MMMEd|E, d \u0027de\u0027 MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|W\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MMM \u0027de\u0027 y|yMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|Esc.|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|S£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt = $enkidatron$elm_cldr$Generated$Pt$pt;
var $enkidatron$elm_cldr$Generated$Ro$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ro',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ro$ro = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ro$dayPeriods, 'ro||||a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|miezul nopții|morning1|dimineața|night1|noaptea|noon|amiază|pm|p.m.|a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|la miezul nopții|morning1|dimineața|night1|noaptea|noon|la amiază|pm|p.m.|a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|miezul nopții|morning1|dimineața|night1|noaptea|noon|amiază|pm|p.m.|dd.MM.y|d MMM y|d MMMM y|EEEE, d MMMM y|ian.|feb.|mar.|apr.|mai|iun.|iul.|aug.|sept.|oct.|nov.|dec.|ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie|I|F|M|A|M|I|I|A|S|O|N|D|0|dum.|lun.|mar.|mie.|joi|vin.|sâm.|duminică|luni|marți|miercuri|joi|vineri|sâmbătă|D|L|M|M|J|V|S|0|î.Hr.|d.Hr.|înainte de Hristos|după Hristos|î.Hr.|d.Hr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027săptămâna\u0027 W \u0027din\u0027 MMMM|MMMMW-count-few|\u0027săptămâna\u0027 W \u0027din\u0027 MMMM|MMMMW-count-other|\u0027săptămâna\u0027 W \u0027din\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMM|MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027săptămâna\u0027 w \u0027din\u0027 Y|yw-count-few|\u0027săptămâna\u0027 w \u0027din\u0027 Y|yw-count-other|\u0027săptămâna\u0027 w \u0027din\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ro = $enkidatron$elm_cldr$Generated$Ro$ro;
var $enkidatron$elm_cldr$Generated$Ru$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ru',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ru$ru = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-few|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-many|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-other|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, dd.MM.y\u202F\u0027г\u0027.|yMM|MM.y|yMMM|LLL y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|LLLL y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-few|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-many|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-other|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru = $enkidatron$elm_cldr$Generated$Ru$ru;
var $enkidatron$elm_cldr$Generated$Sd$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Sd$sd = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sd$dayPeriods, 'sd||||صبح،\u202Fمنجهند|شام،\u202Fمنجهند|2|am|صبح،\u202Fمنجهند|pm|شام،\u202Fمنجهند|صبح، منجهند|منجهند، شام|2|am|صبح، منجهند|pm|منجهند، شام|صبح،\u202Fمنجهند|منجهند،\u202Fشام|2|am|صبح،\u202Fمنجهند|pm|منجهند،\u202Fشام|y-MM-dd|y MMM d|y MMMM d|EEEE, MMMM d, y|جنوري|فيبروري|مارچ|اپريل|مئي|جون|جولاءِ|آگسٽ|سيپٽمبر|آڪٽوبر|نومبر|ڊسمبر|جنوري|فيبروري|مارچ|اپريل|مئي|جون|جولاءِ|آگسٽ|سيپٽمبر|آڪٽوبر|نومبر|ڊسمبر|J|F|M|A|M|J|J|A|S|O|N|D|0|آچر|سومر|اڱارو|اربع|خميس|جمعو|ڇنڇر|آچر|سومر|اڱارو|اربع|خميس|جمعو|ڇنڇر|آچر|سو|اڱارو|اربع|خم|جمعو|ڇنڇر|0|BC|CD|قبل مسيح|عيسوي کان پهرين|BC|CD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-one|ھفتو W جو MMMM|MMMMW-count-other|ھفتو W جو MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|ھفتو w جو Y|yw-count-other|ھفتو w جو Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sd = $enkidatron$elm_cldr$Generated$Sd$sd;
var $enkidatron$elm_cldr$Generated$Si$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'si',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Si$si = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Si$dayPeriods, 'si||||පෙ.ව.|ප.ව.|10|afternoon1|දවල්|am|පෙ.ව.|evening1|හවස|midnight|මැදියම|morning1|පාන්දර|morning2|උදේ|night1|රෑ|night2|මැදියමට පසු|noon|මධ්\u200Dයාහ්නය|pm|ප.ව.|පෙ.ව.|ප.ව.|10|afternoon1|දවල්|am|පෙ.ව.|evening1|හවස|midnight|මැදියම|morning1|පාන්දර|morning2|උදේ|night1|රෑ|night2|මැදියමට පසු|noon|මධ්\u200Dයාහ්නය|pm|ප.ව.|පෙ|ප|10|afternoon1|ද|am|පෙ|evening1|හ|midnight|මැ|morning1|පා|morning2|උ|night1|රෑ|night2|මැ|noon|ම|pm|ප|y-MM-dd|y MMM d|y MMMM d|y MMMM d, EEEE|ජන|පෙබ|මාර්තු|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝ|සැප්|ඔක්|නොවැ|දෙසැ|ජනවාරි|පෙබරවාරි|මාර්තු|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝස්තු|සැප්තැම්බර්|ඔක්තෝබර්|නොවැම්බර්|දෙසැම්බර්|ජ|පෙ|මා|අ|මැ|ජූ|ජූ|අ|සැ|ඔ|නෙ|දෙ|1|ජන|පෙබ|මාර්|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝ|සැප්|ඔක්|නොවැ|දෙසැ|ජනවාරි|පෙබරවාරි|මාර්තු|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝස්තු|සැප්තැම්බර්|ඔක්තෝබර්|නොවැම්බර්|දෙසැම්බර්|ජ|පෙ|මා|අ|මැ|ජූ|ජූ|අ|සැ|ඔ|නෙ|දෙ|ඉරිදා|සඳුදා|අඟහ|බදාදා|බ්\u200Dරහස්|සිකු|සෙන|ඉරිදා|සඳුදා|අඟහරුවාදා|බදාදා|බ්\u200Dරහස්පතින්දා|සිකුරාදා|සෙනසුරාදා|ඉ|ස|අ|බ|බ්\u200Dර|සි|සෙ|0|ක්\u200Dරි.පූ.|ක්\u200Dරි.ව.|ක්\u200Dරිස්තු පූර්ව|ක්\u200Dරිස්තු වර්ෂ|ක්\u200Dරි.පූ.|ක්\u200Dරි.ව.|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E a h.mm|EHm|E HH.mm|Ehms|E a h.mm.ss|EHms|E HH.mm.ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h.mm|Hm|HH.mm|hms|a h.mm.ss|Hms|HH.mm.ss|hmsv|h.mm.ss a v|Hmsv|HH.mm.ss v|hmv|h.mm a v|Hmv|HH.mm v|M|L|Md|M-d|MEd|M-d, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d E|MMMMd|MMMM d|MMMMW-count-one|MMMM සතිය W|MMMMW-count-other|MMMM සතිය W|ms|mm.ss|y|y|yM|y-M|yMd|y-M-d|yMEd|y-M-d, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y සතිය w|yw-count-other|Y සතිය w|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|රු.|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|සිෆ්එ|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$si = $enkidatron$elm_cldr$Generated$Si$si;
var $enkidatron$elm_cldr$Generated$Sk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sk$sk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sk$dayPeriods, 'sk||||AM|PM|9|afternoon1|popol.|am|AM|evening1|večer|midnight|o poln.|morning1|ráno|morning2|dopol.|night1|v noci|noon|napol.|pm|PM|AM|PM|9|afternoon1|popoludní|am|AM|evening1|večer|midnight|o polnoci|morning1|ráno|morning2|dopoludnia|night1|v noci|noon|napoludnie|pm|PM|AM|PM|9|afternoon1|pop.|am|AM|evening1|več.|midnight|o poln.|morning1|ráno|morning2|dop.|night1|v n.|noon|nap.|pm|PM|d. M. y|d. M. y|d. MMMM y|EEEE d. MMMM y|jan|feb|mar|apr|máj|jún|júl|aug|sep|okt|nov|dec|januára|februára|marca|apríla|mája|júna|júla|augusta|septembra|októbra|novembra|decembra|j|f|m|a|m|j|j|a|s|o|n|d|1|jan|feb|mar|apr|máj|jún|júl|aug|sep|okt|nov|dec|január|február|marec|apríl|máj|jún|júl|august|september|október|november|december|j|f|m|a|m|j|j|a|s|o|n|d|ne|po|ut|st|št|pi|so|nedeľa|pondelok|utorok|streda|štvrtok|piatok|sobota|n|p|u|s|š|p|s|0|pred Kr.|po Kr.|pred Kristom|po Kristovi|pred Kr.|po Kr.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d. M. y GGGGG|GyMMM|LLLL y G|GyMMMd|d. M. y G|GyMMMEd|E d. M. y G|GyMMMMd|d. M. y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L.|Md|d. M.|MEd|E d. M.|MMM|LLL|MMMd|d. M.|MMMEd|E d. M.|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \u0027týždeň\u0027 MMMM|MMMMW-count-few|W. \u0027týždeň\u0027 MMMM|MMMMW-count-many|W. \u0027týždeň\u0027 MMMM|MMMMW-count-other|W. \u0027týždeň\u0027 MMMM|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d. M. y|yMEd|E d. M. y|yMMM|M/y|yMMMd|d. M. y|yMMMEd|E d. M. y|yMMMM|LLLL y|yMMMMd|d. MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \u0027týždeň\u0027 \u0027roka\u0027 Y|yw-count-few|w. \u0027týždeň\u0027 \u0027roka\u0027 Y|yw-count-many|w. \u0027týždeň\u0027 \u0027roka\u0027 Y|yw-count-other|w. \u0027týždeň\u0027 \u0027roka\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|NIS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sk = $enkidatron$elm_cldr$Generated$Sk$sk;
var $enkidatron$elm_cldr$Generated$Sl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sl$sl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sl$dayPeriods, 'sl||||dop.|pop.|9|afternoon1|pop.|am|dop.|evening1|zveč.|midnight|opoln.|morning1|zjut.|morning2|dop.|night1|ponoči|noon|opold.|pm|pop.|dop.|pop.|9|afternoon1|popoldan|am|dop.|evening1|zvečer|midnight|opolnoči|morning1|zjutraj|morning2|dopoldan|night1|ponoči|noon|opoldne|pm|pop.|d|p|9|afternoon1|p|am|d|evening1|zv|midnight|24.00|morning1|zj|morning2|d|night1|po|noon|12.00|pm|p|d. M. yy|d. MMM y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|mar.|apr.|maj|jun.|jul.|avg.|sep.|okt.|nov.|dec.|januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december|j|f|m|a|m|j|j|a|s|o|n|d|0|ned.|pon.|tor.|sre.|čet.|pet.|sob.|nedelja|ponedeljek|torek|sreda|četrtek|petek|sobota|n|p|t|s|č|p|s|0|pr. Kr.|po Kr.|pred Kristusom|po Kristusu|pr. Kr.|po Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyM|MMM y G|GyMd|d. M. y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|HH\u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMW-count-one|MMMM: W. \u0027teden\u0027|MMMMW-count-two|MMMM: W. \u0027teden\u0027|MMMMW-count-few|MMMM: W. \u0027teden\u0027|MMMMW-count-other|MMMM: W. \u0027teden\u0027|ms|mm:ss|y|y|yM|M/y|yMd|d. M. y|yMEd|E, d. M. y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \u0027teden\u0027 \u0027leta\u0027 Y|yw-count-two|w. \u0027teden\u0027 \u0027leta\u0027 Y|yw-count-few|w. \u0027teden\u0027 \u0027leta\u0027 Y|yw-count-other|w. \u0027teden\u0027 \u0027leta\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sl = $enkidatron$elm_cldr$Generated$Sl$sl;
var $enkidatron$elm_cldr$Generated$So$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$So$so = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$So$dayPeriods, 'so||||GH|GD|2|am|GH|pm|GD|GH|GD|2|am|GH|pm|GD|h|d|2|am|h|pm|d|dd/MM/yy|dd-MMM-y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Bisha Koobaad|Bisha Labaad|Bisha Saddexaad|Bisha Afraad|Bisha Shanaad|Bisha Lixaad|Bisha Todobaad|Bisha Sideedaad|Bisha Sagaalaad|Bisha Tobnaad|Bisha Kow iyo Tobnaad|Bisha Laba iyo Tobnaad|J|F|M|A|M|J|L|O|S|O|N|D|1|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Jannaayo|Febraayo|Maarso|Abriil|May|Juun|Luuliyo|Ogosto|Sebteembar|Oktoobar|Noofeembar|Diseembar|J|F|M|A|M|J|L|O|S|O|N|D|Axd|Isn|Tldo|Arbc|Khms|Jmc|Sbti|Axad|Isniin|Talaado|Arbaco|Khamiis|Jimco|Sabti|A|I|T|A|Kh|J|S|0|BC|AD|Ciise Hortii|Ciise Dabadii|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|MMMMW-count-other|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|yw-count-other|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|DBB|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SOS|S|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$so = $enkidatron$elm_cldr$Generated$So$so;
var $enkidatron$elm_cldr$Generated$Sq$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sq',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sq$sq = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sq$dayPeriods, 'sq||||p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|e paradites|e pasdites|9|afternoon1|e pasdites|am|e paradites|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|e pasdites|p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|d.M.yy|d MMM y|d MMMM y|EEEE, d MMMM y|jan|shk|mar|pri|maj|qer|korr|gush|sht|tet|nën|dhj|janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor|j|sh|m|p|m|q|k|g|sh|t|n|dh|0|die|hën|mar|mër|enj|pre|sht|e diel|e hënë|e martë|e mërkurë|e enjte|e premte|e shtunë|d|h|m|m|e|p|sh|0|p.K.|mb.K.|para Krishtit|mbas Krishtit|p.K.|mb.K.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa, z|h:mm:ss\u202Fa, zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa, v|Hmsv|HH:mm:ss, v|hmv|h:mm\u202Fa, v|Hmv|HH:mm, v|M|L|Md|d.M|MEd|E, d.M|MMdd|d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027java\u0027 W \u0027e\u0027 MMMM|MMMMW-count-other|\u0027java\u0027 W \u0027e\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ, y|yQQQQ|QQQQ, y|yw-count-one|\u0027java\u0027 w \u0027e\u0027 Y|yw-count-other|\u0027java\u0027 w \u0027e\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|AFN|ALL|Lekë|AMD|AMD|AOA|AOA|ARS|ARS|AUD|A$|AZN|AZN|BAM|BAM|BBD|BBD|BDT|BDT|BMD|BMD|BND|BND|BOB|BOB|BRL|BRL|BSD|BSD|BWP|BWP|BZD|BZD|CAD|CA$|CLP|CLP|CNY|CN¥|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CZK|CZK|DKK|DKK|DOP|DOP|EGP|EGP|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HK$|HNL|HNL|HRK|HRK|HUF|HUF|IDR|IDR|ILS|₪|INR|₹|ISK|ISK|JMD|JMD|JPY|JP¥|KGS|\u20C0|KHR|KHR|KMF|KMF|KPW|KPW|KRW|₩|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LTL|Lt|LVL|Ls|MGA|MGA|MMK|MMK|MNT|MNT|MUR|MUR|MXN|MX$|MYR|MYR|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZ$|PHP|PHP|PKR|PKR|PLN|PLN|PYG|PYG|RON|RON|RUB|RUB|RWF|RWF|SBD|SBD|SEK|SEK|SGD|SGD|SHP|SHP|SRD|SRD|SSP|SSP|STN|STN|SYP|SYP|THB|฿|TOP|TOP|TRY|TRY|TTD|TTD|TWD|NT$|UAH|UAH|USD|US$|UYU|UYU|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$sq = $enkidatron$elm_cldr$Generated$Sq$sq;
var $enkidatron$elm_cldr$Generated$Sr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sr$sr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr||||AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутру|night1|ноћу|noon|подне|pm|PM|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец|јануар|фебруар|март|април|мај|јун|јул|август|септембар|октобар|новембар|децембар|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед|пон|уто|сре|чет|пет|суб|недеља|понедељак|уторак|среда|четвртак|петак|субота|н|п|у|с|ч|п|с|0|п. н. е.|н. е.|пре нове ере|нове ере|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-few|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-other|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-few|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-other|w. \u0027седмица\u0027 \u0027у\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|КМ|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr = $enkidatron$elm_cldr$Generated$Sr$sr;
var $enkidatron$elm_cldr$Generated$Sv$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sv',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sv$sv = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sv$dayPeriods, 'sv||||fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|fm|em|8|afternoon1|på eftermiddagen|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morgonen|morning2|på förmiddagen|night1|på natten|pm|em|fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midn.|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|y-MM-dd|d MMM y|d MMMM y|EEEE d MMMM y|jan.|feb.|mars|apr.|maj|juni|juli|aug.|sep.|okt.|nov.|dec.|januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|sön|mån|tis|ons|tors|fre|lör|söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|före Kristus|efter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|y-MM-dd GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMd|d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\u0027vecka\u0027 W \u0027i\u0027 MMMM|MMMMW-count-other|\u0027vecka\u0027 W \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|E, y-MM-dd|yMM|y-MM|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027vecka\u0027 w, Y|yw-count-other|\u0027vecka\u0027 w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BM$|BND|$|BOB|Bs|BRL|BR$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|Dkr|DOP|RD$|EEK|Ekr|EGP|EG£|ESP|ESP|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|IE£|ILS|₪|INR|INR|ISK|Ikr|JMD|JM$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|Nkr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sv = $enkidatron$elm_cldr$Generated$Sv$sv;
var $enkidatron$elm_cldr$Generated$Sw$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sw',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(7, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(7, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sw$sw = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sw$dayPeriods, 'sw||||AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|adhuhuri|pm|PM|AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|saa sita za mchana|pm|PM|am|pm|9|afternoon1|mchana|am|am|evening1|jioni|midnight|usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|mchana|pm|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ago|Sep|Okt|Nov|Des|Januari|Februari|Machi|Aprili|Mei|Juni|Julai|Agosti|Septemba|Oktoba|Novemba|Desemba|J|F|M|A|M|J|J|A|S|O|N|D|0|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|S|M|T|W|T|F|S|0|KK|BK|Kabla ya Kristo|Baada ya Kristo|KK|BK|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|MMMMW-count-other|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|QQQQ y|yw-count-one|\u0027wiki\u0027 w \u0027ya\u0027 Y|yw-count-other|\u0027wiki\u0027 w \u0027ya\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|TZS|TSh|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sw = $enkidatron$elm_cldr$Generated$Sw$sw;
var $enkidatron$elm_cldr$Generated$Ta$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ta',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(16, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(5, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ta$ta = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ta$dayPeriods, 'ta||||AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|மு.ப|பி.ப|11|afternoon1|மதி.|afternoon2|பிற்.|am|மு.ப|evening1|மா.|evening2|அந்தி மா.|midnight|நள்.|morning1|அதி.|morning2|கா.|night1|இர.|noon|நண்.|pm|பி.ப|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.|ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்|ஜ|பி|மா|ஏ|மே|ஜூ|ஜூ|ஆ|செ|அ|ந|டி|0|ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி|ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி|ஞா|தி|செ|பு|வி|வெ|ச|0|கி.மு.|கி.பி.|கிறிஸ்துவுக்கு முன்|அன்னோ டோமினி|கி.மு.|கி.பி.|a h:mm|a h:mm:ss|a h:mm:ss z|a h:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|a h:mm:ss v|Hmsv|HH:mm:ss v|hmv|a h:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|dd-MM, E|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|d MMMM|MMMMW-count-one|MMMM W -ஆம் வாரம்|MMMMW-count-other|MMMM W -ஆம் வாரம்|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ஆம் ஆண்டின் w -ஆம் வாரம்|yw-count-other|Y ஆம் ஆண்டின் w -ஆம் வாரம்|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ta = $enkidatron$elm_cldr$Generated$Ta$ta;
var $enkidatron$elm_cldr$Generated$Te$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'te',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Te$te = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Te$dayPeriods, 'te||||AM|PM|7|afternoon1|మధ్యాహ్నం|am|AM|evening1|సాయంత్రం|midnight|అర్ధరాత్రి|morning1|ఉదయం|night1|రాత్రి|pm|PM|AM|PM|7|afternoon1|మధ్యాహ్నం|am|AM|evening1|సాయంత్రం|midnight|అర్ధరాత్రి|morning1|ఉదయం|night1|రాత్రి|pm|PM|ఉ|సా|7|afternoon1|మధ్యాహ్నం|am|ఉ|evening1|సాయంత్రం|midnight|అర్ధరాత్రి|morning1|ఉదయం|night1|రాత్రి|pm|సా|dd-MM-yy|d MMM, y|d MMMM, y|d, MMMM y, EEEE|జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్టెం|అక్టో|నవం|డిసెం|జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్|జ|ఫి|మా|ఏ|మే|జూ|జు|ఆ|సె|అ|న|డి|0|ఆది|సోమ|మంగళ|బుధ|గురు|శుక్ర|శని|ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం|ఆ|సో|మ|బు|గు|శు|శ|0|క్రీపూ|క్రీశ|క్రీస్తు పూర్వం|క్రీస్తు శకం|క్రీపూ|క్రీశ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G MMM y|GyMMMd|G d, MMM y|GyMMMEd|G, d MMM, y, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/M, E|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMMలో Wవ వారం|MMMMW-count-other|MMMMలో Wవ వారం|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|d/M/y, E|yMM|MM-y|yMMM|MMM y|yMMMd|d, MMM y|yMMMEd|d MMM, y, E|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Yలో wవ వారం|yw-count-other|Yలో wవ వారం|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$te = $enkidatron$elm_cldr$Generated$Te$te;
var $enkidatron$elm_cldr$Generated$Th$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'th',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(16, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Th$th = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Th$dayPeriods, 'th||||AM|PM|10|afternoon1|ในตอนบ่าย|afternoon2|บ่าย|am|AM|evening1|ในตอนเย็น|evening2|ค่ำ|midnight|เที่ยงคืน|morning1|ในตอนเช้า|night1|กลางคืน|noon|เที่ยง|pm|PM|ก่อนเที่ยง|หลังเที่ยง|10|afternoon1|ในตอนบ่าย|afternoon2|บ่าย|am|ก่อนเที่ยง|evening1|ในตอนเย็น|evening2|ค่ำ|midnight|เที่ยงคืน|morning1|ในตอนเช้า|night1|กลางคืน|noon|เที่ยง|pm|หลังเที่ยง|a|p|10|afternoon1|เที่ยง|afternoon2|บ่าย|am|a|evening1|เย็น|evening2|ค่ำ|midnight|เที่ยงคืน|morning1|เช้า|night1|กลางคืน|noon|เที่ยง|pm|p|d/M/yy|d MMM y|d MMMM G y|EEEEที่ d MMMM G y|ม.ค.|ก.พ.|มี.ค.|เม.ย.|พ.ค.|มิ.ย.|ก.ค.|ส.ค.|ก.ย.|ต.ค.|พ.ย.|ธ.ค.|มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม|ม.ค.|ก.พ.|มี.ค.|เม.ย.|พ.ค.|มิ.ย.|ก.ค.|ส.ค.|ก.ย.|ต.ค.|พ.ย.|ธ.ค.|0|อา.|จ.|อ.|พ.|พฤ.|ศ.|ส.|วันอาทิตย์|วันจันทร์|วันอังคาร|วันพุธ|วันพฤหัสบดี|วันศุกร์|วันเสาร์|อา|จ|อ|พ|พฤ|ศ|ส|0|ก่อน ค.ศ.|ค.ศ.|ปีก่อนคริสตกาล|คริสต์ศักราช|ก่อน ค.ศ.|ค.ศ.|HH:mm|HH:mm:ss|H นาฬิกา mm นาที ss วินาที z|H นาฬิกา mm นาที ss วินาที zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm น.|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM G y|GyMMMd|d MMM G y|GyMMMEd|E d MMM G y|GyMMMEEEEd|EEEEที่ d MMM G y|h|h a|H|HH|hm|h:mm a|Hm|HH:mm น.|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm น. a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMEEEEd|EEEEที่ d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMEEEEd|EEEEที่ d MMMM|MMMMW-count-other|สัปดาห์ที่ W ของเดือนMMMM|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMEEEEd|EEEEที่ d MMM y|yMMMM|MMMM y|yMMMMd|d MMMM y|yMMMMEd|E d MMMM y|yMMMMEEEEd|EEEEที่ d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ G y|yw-count-other|สัปดาห์ที่ w ของปี Y|HHmm|HHmmss|Hmmssz|Hmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$th = $enkidatron$elm_cldr$Generated$Th$th;
var $enkidatron$elm_cldr$Generated$Tk$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Tk$tk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Tk$dayPeriods, 'tk||||go.öň|go.soň|2|am|go.öň|pm|go.soň|günortadan öň|günortadan soň|2|am|günortadan öň|pm|günortadan soň|öň|soň|2|am|öň|pm|soň|dd.MM.y|d MMM y|d MMMM y|d MMMM y EEEE|ýan|few|mart|apr|maý|iýun|iýul|awg|sen|okt|noý|dek|ýanwar|fewral|mart|aprel|maý|iýun|iýul|awgust|sentýabr|oktýabr|noýabr|dekabr|Ý|F|M|A|M|I|I|A|S|O|N|D|1|Ýan|Few|Mar|Apr|Maý|Iýun|Iýul|Awg|Sen|Okt|Noý|Dek|Ýanwar|Fewral|Mart|Aprel|Maý|Iýun|Iýul|Awgust|Sentýabr|Oktýabr|Noýabr|Dekabr|Ý|F|M|A|M|I|I|A|S|O|N|D|ýek|duş|siş|çar|pen|ann|şen|ýekşenbe|duşenbe|sişenbe|çarşenbe|penşenbe|anna|şenbe|Ý|D|S|Ç|P|A|Ş|1|Ýek|Duş|Siş|Çar|Pen|Ann|Şen|Ýekşenbe|Duşenbe|Sişenbe|Çarşenbe|Penşenbe|Anna|Şenbe|Ý|D|S|Ç|P|A|Ş|B.e.öň|B.e.|Isadan öň|Isadan soň|B.e.öň|B.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG dd.MM.y|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM E|MMMMd|d MMMM|MMMMEd|d MMMM E|MMMMW-count-one|\u0027hepde\u0027 W, MMMM|MMMMW-count-other|\u0027hepde\u0027 W, MMMM|mmss|mm:ss|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|\u0027hepde\u0027 w, Y|yw-count-other|\u0027hepde\u0027 w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$tk = $enkidatron$elm_cldr$Generated$Tk$tk;
var $enkidatron$elm_cldr$Generated$Tr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'tr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(11, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(11, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Tr$tr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Tr$dayPeriods, 'tr||||ÖÖ|ÖS|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|ÖÖ|evening1|akşam|midnight|gece yarısı|morning1|sabah|morning2|öğleden önce|night1|gece|noon|öğle|pm|ÖS|ÖÖ|ÖS|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|ÖÖ|evening1|akşam|midnight|gece yarısı|morning1|sabah|morning2|öğleden önce|night1|gece|noon|öğle|pm|ÖS|öö|ös|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|öö|evening1|akşam|midnight|gece|morning1|sabah|morning2|öğleden önce|night1|gece|noon|ö|pm|ös|d.MM.y|d MMM y|d MMMM y|d MMMM y EEEE|Oca|Şub|Mar|Nis|May|Haz|Tem|Ağu|Eyl|Eki|Kas|Ara|Ocak|Şubat|Mart|Nisan|Mayıs|Haziran|Temmuz|Ağustos|Eylül|Ekim|Kasım|Aralık|O|Ş|M|N|M|H|T|A|E|E|K|A|0|Paz|Pzt|Sal|Çar|Per|Cum|Cmt|Pazar|Pazartesi|Salı|Çarşamba|Perşembe|Cuma|Cumartesi|P|P|S|Ç|P|C|C|0|MÖ|MS|Milattan Önce|Milattan Sonra|MÖ|MS|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a\u202Fh:mm|EHm|E HH:mm|Ehms|E a\u202Fh:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y E|h|a\u202Fh|H|HH|hm|a\u202Fh:mm|Hm|HH:mm|hms|a\u202Fh:mm:ss|Hms|HH:mm:ss|hmsv|a\u202Fh:mm:ss v|Hmsv|HH:mm:ss v|hmv|a\u202Fh:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/MM E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM E|MMMMd|d MMMM|MMMMEd|d MMMM E|MMMMW-count-one|MMMM \u0027ayının\u0027 W. \u0027haftası\u0027|MMMMW-count-other|MMMM \u0027ayının\u0027 W. \u0027haftası\u0027|mmss|mm:ss|ms|mm:ss|y|y|yM|MM/y|yMd|dd.MM.y|yMEd|d.M.y E|yMM|MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y \u0027yılının\u0027 w. \u0027haftası\u0027|yw-count-other|Y \u0027yılının\u0027 w. \u0027haftası\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-%||%||%||107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$tr = $enkidatron$elm_cldr$Generated$Tr$tr;
var $enkidatron$elm_cldr$Generated$Uk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'uk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Uk$uk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Uk$dayPeriods, 'uk||||дп|пп|8|afternoon1|дня|am|дп|evening1|вечора|midnight|опівночі|morning1|ранку|night1|ночі|noon|опівдні|pm|пп|дп|пп|8|afternoon1|дня|am|дп|evening1|вечора|midnight|опівночі|morning1|ранку|night1|ночі|noon|опівдні|pm|пп|дп|пп|8|afternoon1|дня|am|дп|evening1|вечора|midnight|ночі|morning1|ранку|night1|ночі|noon|дня|pm|пп|dd.MM.yy|d MMM y\u202F\u0027р\u0027.|d MMMM y\u202F\u0027р\u0027.|EEEE, d MMMM y\u202F\u0027р\u0027.|січ.|лют.|бер.|квіт.|трав.|черв.|лип.|серп.|вер.|жовт.|лист.|груд.|січня|лютого|березня|квітня|травня|червня|липня|серпня|вересня|жовтня|листопада|грудня|с|л|б|к|т|ч|л|с|в|ж|л|г|1|січ.|лют.|бер.|квіт.|трав.|черв.|лип.|серп.|вер.|жовт.|лист.|груд.|січень|лютий|березень|квітень|травень|червень|липень|серпень|вересень|жовтень|листопад|грудень|С|Л|Б|К|Т|Ч|Л|С|В|Ж|Л|Г|нд|пн|вт|ср|чт|пт|сб|неділю|понеділок|вівторок|середу|четвер|пʼятницю|суботу|Н|П|В|С|Ч|П|С|1|нд|пн|вт|ср|чт|пт|сб|неділя|понеділок|вівторок|середа|четвер|пʼятниця|субота|Н|П|В|С|Ч|П|С|до н. е.|н. е.|до нашої ери|нашої ери|до н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y\u202F\u0027р\u0027. G|GyMMMd|d MMM y\u202F\u0027р\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027р\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|LL|Md|dd.MM|MEd|E, dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W-\u0027й\u0027 \u0027тиж\u0027. MMMM|MMMMW-count-few|W-\u0027й\u0027 \u0027тиж\u0027. MMMM|MMMMW-count-many|W-\u0027й\u0027 \u0027тиж\u0027. MMMM|MMMMW-count-other|W-\u0027й\u0027 \u0027тиж\u0027. MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMMM|LLL y\u202F\u0027р\u0027.|yMMMd|d MMM y\u202F\u0027р\u0027.|yMMMEd|E, d MMM y\u202F\u0027р\u0027.|yMMMM|LLLL y\u202F\u0027р\u0027.|yQQQ|QQQ y|yQQQQ|QQQQ y\u202F\u0027р\u0027.|yw-count-one|w-\u0027й\u0027 \u0027тиж\u0027. Y \u0027р\u0027.|yw-count-few|w-\u0027й\u0027 \u0027тиж\u0027. Y \u0027р\u0027.|yw-count-many|w-\u0027й\u0027 \u0027тиж\u0027. Y \u0027р\u0027.|yw-count-other|w-\u0027й\u0027 \u0027тиж\u0027. Y \u0027р\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|UAK|крб.|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$uk = $enkidatron$elm_cldr$Generated$Uk$uk;
var $enkidatron$elm_cldr$Generated$Ur$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ur',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ur$ur = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ur$dayPeriods, 'ur||||AM|PM|8|afternoon1|دوپہر|afternoon2|سہ پہر|am|AM|evening1|شام|midnight|آدھی رات|morning1|صبح|night1|رات|pm|PM|AM|PM|8|afternoon1|دوپہر میں|afternoon2|سہ پہر|am|AM|evening1|شام میں|midnight|آدھی رات|morning1|صبح میں|night1|رات میں|pm|PM|a|p|8|afternoon1|دوپہر|afternoon2|سہ پہر|am|a|evening1|شام|midnight|آدھی رات|morning1|صبح|night1|رات|pm|p|d/M/yy|d MMM، y|d MMMM، y|EEEE، d MMMM، y|جنوری|فروری|مارچ|اپریل|مئی|جون|جولائی|اگست|ستمبر|اکتوبر|نومبر|دسمبر|جنوری|فروری|مارچ|اپریل|مئی|جون|جولائی|اگست|ستمبر|اکتوبر|نومبر|دسمبر|J|F|M|A|M|J|J|A|S|O|N|D|0|اتوار|پیر|منگل|بدھ|جمعرات|جمعہ|ہفتہ|اتوار|پیر|منگل|بدھ|جمعرات|جمعہ|ہفتہ|S|M|T|W|T|F|S|0|قبل مسیح|عیسوی|قبل مسیح|عیسوی|قبل مسیح|عیسوی|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM، y G|GyMMMEd|E، d MMM، y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E، d/M|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMM کا ہفتہ W|MMMMW-count-other|MMMM کا ہفتہ W|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E، d/M/y|yMMM|MMM y|yMMMd|d MMM، y|yMMMEd|E، d MMM، y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y کا w ہفتہ|yw-count-other|Y کا w ہفتہ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200E-¤||¤||¤||E0W,|.|\u200E-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ur = $enkidatron$elm_cldr$Generated$Ur$ur;
var $enkidatron$elm_cldr$Generated$Uz$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'uz',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(11, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(11, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Uz$uz = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Uz$dayPeriods, 'uz||||TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|dd/MM/yy|d-MMM, y|d-MMMM, y|EEEE, d-MMMM, y|yan|fev|mar|apr|may|iyn|iyl|avg|sen|okt|noy|dek|yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr|Y|F|M|A|M|I|I|A|S|O|N|D|1|Yan|Fev|Mar|Apr|May|Iyn|Iyl|Avg|Sen|Okt|Noy|Dek|Yanvar|Fevral|Mart|Aprel|May|Iyun|Iyul|Avgust|Sentabr|Oktabr|Noyabr|Dekabr|Y|F|M|A|M|I|I|A|S|O|N|D|Yak|Dush|Sesh|Chor|Pay|Jum|Shan|yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba|Y|D|S|C|P|J|S|0|m.a.|milodiy|miloddan avvalgi|milodiy|m.a.|milodiy|HH:mm|HH:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|G y|GyMd|dd.MM.y GGGGG|GyMMM|MMM, G y|GyMMMd|d-MMM, G y|GyMMMEd|E, d-MMM, G y|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|LL|Md|dd/MM|MEd|E, dd/MM|MMM|LLL|MMMd|d-MMM|MMMEd|E, d-MMM|MMMMd|d-MMMM|MMMMW-count-one|MMMM, W-\u0027hafta\u0027|MMMMW-count-other|MMMM, W-\u0027hafta\u0027|ms|mm:ss|y|y|yM|MM.y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM, y|yMMMd|d-MMM, y|yMMMEd|E, d-MMM, y|yMMMM|MMMM, y|yQQQ|y, QQQ|yQQQQ|y, QQQQ|yw-count-one|Y, w-\u0027hafta\u0027|yw-count-other|Y, w-\u0027hafta\u0027|HHmm|HHmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|UZS|soʻm|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$uz = $enkidatron$elm_cldr$Generated$Uz$uz;
var $enkidatron$elm_cldr$Generated$Vi$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'vi',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Vi$vi = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Vi$dayPeriods, 'vi||||SA|CH|8|afternoon1|chiều|am|SA|evening1|tối|midnight|nửa đêm|morning1|sáng|night1|đêm|noon|TR|pm|CH|SA|CH|8|afternoon1|chiều|am|SA|evening1|tối|midnight|nửa đêm|morning1|sáng|night1|đêm|noon|trưa|pm|CH|s|c|8|afternoon1|chiều|am|s|evening1|tối|midnight|nửa đêm|morning1|sáng|night1|đêm|noon|tr|pm|c|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|thg 1|thg 2|thg 3|thg 4|thg 5|thg 6|thg 7|thg 8|thg 9|thg 10|thg 11|thg 12|tháng 1|tháng 2|tháng 3|tháng 4|tháng 5|tháng 6|tháng 7|tháng 8|tháng 9|tháng 10|tháng 11|tháng 12|1|2|3|4|5|6|7|8|9|10|11|12|1|Tháng 1|Tháng 2|Tháng 3|Tháng 4|Tháng 5|Tháng 6|Tháng 7|Tháng 8|Tháng 9|Tháng 10|Tháng 11|Tháng 12|Tháng 1|Tháng 2|Tháng 3|Tháng 4|Tháng 5|Tháng 6|Tháng 7|Tháng 8|Tháng 9|Tháng 10|Tháng 11|Tháng 12|1|2|3|4|5|6|7|8|9|10|11|12|CN|Th 2|Th 3|Th 4|Th 5|Th 6|Th 7|Chủ Nhật|Thứ Hai|Thứ Ba|Thứ Tư|Thứ Năm|Thứ Sáu|Thứ Bảy|CN|T2|T3|T4|T5|T6|T7|0|TCN|SCN|Trước Chúa Giáng Sinh|Sau Công Nguyên|TCN|CN|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{0} {1}|{0} {1}|{0} {1}|{0} {1}|51|Bh|h \u0027giờ\u0027 B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|h:mm B E|EBhms|h:mm:ss B E|Ed|E, \u0027ngày\u0027 d|Ehm|h:mm\u202Fa E|EHm|HH:mm E|Ehms|h:mm:ss\u202Fa E|EHms|HH:mm:ss E|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM, y G|GyMMMEd|E, d MMM, y G|h|h\u202Fa|H|HH \u0027giờ\u0027|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-other|\u0027tuần\u0027 W \u0027của\u0027 \u0027tháng\u0027 M|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|\u0027tháng\u0027 MM, y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM \u0027năm\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027năm\u0027 y|yw-count-other|\u0027tuần\u0027 w \u0027của\u0027 \u0027năm\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$vi = $enkidatron$elm_cldr$Generated$Vi$vi;
var $enkidatron$elm_cldr$Generated$Yo$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Yo$yo = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yo$dayPeriods, 'yo||||Àárọ̀|Ọ̀sán|2|am|Àárọ̀|pm|Ọ̀sán|Àárọ̀|Ọ̀sán|2|am|Àárọ̀|pm|Ọ̀sán|Àárọ̀|Ọ̀sán|2|am|Àárọ̀|pm|Ọ̀sán|d/M/y|d MM y|d MMM y|EEEE, d MMM y|Ṣẹ́r|Èrèl|Ẹrẹ̀n|Ìgb|Ẹ̀bi|Òkú|Agẹ|Ògú|Owe|Ọ̀wà|Bél|Ọ̀pẹ|Oṣù Ṣẹ́rẹ́|Oṣù Èrèlè|Oṣù Ẹrẹ̀nà|Oṣù Ìgbé|Oṣù Ẹ̀bibi|Oṣù Òkúdu|Oṣù Agẹmọ|Oṣù Ògún|Oṣù Owewe|Oṣù Ọ̀wàrà|Oṣù Bélú|Oṣù Ọ̀pẹ̀|S|È|Ẹ|Ì|Ẹ̀|Ò|A|Ò|O|Ọ̀|B|Ọ̀|1|Ṣẹ́|Èr|Ẹr|Ìg|Ẹ̀b|Òk|Ag|Òg|Ow|Ọ̀w|Bé|Ọ̀p|Ṣẹ́rẹ́|Èrèlè|Ẹrẹ̀nà|Ìgbé|Ẹ̀bibi|Òkúdu|Agẹmọ|Ògún|Owewe|Ọ̀wàrà|Bélú|Ọ̀pẹ̀|S|È|Ẹ|Ì|Ẹ̀|Ò|A|Ò|O|Ọ̀|B|Ọ̀|Àìk|Aj|Ìsẹ́g|Ọjọ́r|Ọjọ́b|Ẹt|Àbám|Ọjọ́ Àìkú|Ọjọ́ Ajé|Ọjọ́ Ìsẹ́gun|Ọjọ́rú|Ọjọ́bọ|Ọjọ́ Ẹtì|Ọjọ́ Àbámẹ́ta|À|A|Ì|Ọ|Ọ|Ẹ|À|1|Àìk|Aj|Ìsẹ́g|Ọjọ́r|Ọjọ́b|Ẹt|Àbám|Àìkú|Ajé|Ìsẹ́gun|Ọjọ́rú|Ọjọ́bọ|Ẹtì|Àbámẹ́ta|À|A|Ì|Ọ|Ọ|Ẹ|À|BCE|AD|Saju Kristi|Lehin Kristi|BCE|AD|H:m|H:m:s|H:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMEd|d, MMMM E|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|d/M/y, E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM , y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|Hm|Hms|Hmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yo = $enkidatron$elm_cldr$Generated$Yo$yo;
var $enkidatron$elm_cldr$Generated$Zh$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'zh',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(8, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(8, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Zh$zh = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh||||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|HH:mm|HH:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|EBh:mm|EBhms|EBh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|M/d|MEd|M/dE|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMW-count-other|MMMM第W周|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/dE|yMEEEEd|y年M月d日EEEE|yMM|y年M月|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年第Q季度|yQQQQ|y年第Q季度|yw-count-other|Y年第w周|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILR|ILS|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh = $enkidatron$elm_cldr$Generated$Zh$zh;
var $enkidatron$elm_cldr$Generated$Zu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'zu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Zu$zu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zu$dayPeriods, 'zu||||AM|PM|7|afternoon1|emini|am|AM|evening1|ntambama|morning1|entathakusa|morning2|ekuseni|night1|ebusuku|pm|PM|AM|PM|7|afternoon1|emini|am|AM|evening1|ntambama|morning1|entathakusa|morning2|ekuseni|night1|ebusuku|pm|PM|a|p|7|afternoon1|emini|am|a|evening1|ntambama|morning1|entathakusa|morning2|ekuseni|night1|ebusuku|pm|p|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mas|Eph|Mey|Jun|Jul|Aga|Sep|Okt|Nov|Dis|Januwari|Februwari|Mashi|Ephreli|Meyi|Juni|Julayi|Agasti|Septhemba|Okthoba|Novemba|Disemba|J|F|M|E|M|J|J|A|S|O|N|D|1|Jan|Feb|Mas|Eph|Mey|Jun|Jul|Aga|Sep|Okt|Nov|Dis|Januwari|Februwari|Mashi|Ephreli|Meyi|Juni|Julayi|Agasti|Septhemba|Okthoba|Novemba|Disemba|J|F|M|A|M|J|J|A|S|O|N|D|Son|Mso|Bil|Tha|Sin|Hla|Mgq|ISonto|UMsombuluko|ULwesibili|ULwesithathu|ULwesine|ULwesihlanu|UMgqibelo|S|M|B|T|S|H|M|0|BC|AD|BC|AD|BC|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|P.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|Kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|Kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|Kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|Kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|Zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|Kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zu = $enkidatron$elm_cldr$Generated$Zu$zu;
var $enkidatron$elm_cldr$Generated$Chr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'chr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(24, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Chr$chr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Chr$dayPeriods, 'chr||||ᏌᎾᎴ|ᏒᎯᏱᎢ|5|afternoon1|ᏒᎯᏱᎢᏗᏢ|am|ᏌᎾᎴ|morning1|ᏌᎾᎴ|noon|ᎢᎦ|pm|ᏒᎯᏱᎢ|ᏌᎾᎴ|ᏒᎯᏱᎢᏗᏢ|5|afternoon1|ᏒᎯᏱᎢᏗᏢ|am|ᏌᎾᎴ|morning1|ᏌᎾᎴ|noon|ᎢᎦ|pm|ᏒᎯᏱᎢᏗᏢ|Ꮜ|Ꮢ|5|afternoon1|ᏒᎯᏱᎢᏗᏢ|am|Ꮜ|morning1|ᏌᎾᎴ|noon|Ꭲ|pm|Ꮢ|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|ᎤᏃ|ᎧᎦ|ᎠᏅ|ᎧᏬ|ᎠᏂ|ᏕᎭ|ᎫᏰ|ᎦᎶ|ᏚᎵ|ᏚᏂ|ᏅᏓ|ᎥᏍ|ᎤᏃᎸᏔᏅ|ᎧᎦᎵ|ᎠᏅᏱ|ᎧᏬᏂ|ᎠᏂᏍᎬᏘ|ᏕᎭᎷᏱ|ᎫᏰᏉᏂ|ᎦᎶᏂ|ᏚᎵᏍᏗ|ᏚᏂᏅᏗ|ᏅᏓᏕᏆ|ᎥᏍᎩᏱ|Ꭴ|Ꭷ|Ꭰ|Ꭷ|Ꭰ|Ꮥ|Ꭻ|Ꭶ|Ꮪ|Ꮪ|Ꮕ|Ꭵ|0|ᏆᏍᎬ|ᏉᏅᎯ|ᏔᎵᏁ|ᏦᎢᏁ|ᏅᎩᏁ|ᏧᎾᎩ|ᏈᏕᎾ|ᎤᎾᏙᏓᏆᏍᎬ|ᎤᎾᏙᏓᏉᏅᎯ|ᏔᎵᏁᎢᎦ|ᏦᎢᏁᎢᎦ|ᏅᎩᏁᎢᎦ|ᏧᎾᎩᎶᏍᏗ|ᎤᎾᏙᏓᏈᏕᎾ|Ꮖ|Ꮙ|Ꮤ|Ꮶ|Ꮕ|Ꮷ|Ꭴ|0|BC|AD|ᏧᏓᎷᎸ ᎤᎷᎯᏍᏗ ᎦᎶᏁᏛ|ᎠᏃ ᏙᎻᏂ|BC|AD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|ᏒᎾᏙᏓᏆᏍᏗ W ᎾᎿ MMMM|MMMMW-count-other|ᏒᎾᏙᏓᏆᏍᏗ W ᎾᎿ MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|’ᏒᎾᏙᏓᏆᏍᏗ’ w ’ᎾᎿ’ Y|yw-count-other|’ᏒᎾᏙᏓᏆᏍᏗ’ w ’ᎾᎿ’ Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$chr = $enkidatron$elm_cldr$Generated$Chr$chr;
var $enkidatron$elm_cldr$Generated$Dsb$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Dsb$dsb = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Dsb$dayPeriods, 'dsb||||dop.|wótp.|2|am|dop.|pm|wótp.|dopołdnja|wótpołdnja|2|am|dopołdnja|pm|wótpołdnja|dop.|wótp.|2|am|dop.|pm|wótp.|d.M.yy|d.M.y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|měr.|apr.|maj.|jun.|jul.|awg.|sep.|okt.|now.|dec.|januara|februara|měrca|apryla|maja|junija|julija|awgusta|septembra|oktobra|nowembra|decembra|j|f|m|a|m|j|j|a|s|o|n|d|1|jan|feb|měr|apr|maj|jun|jul|awg|sep|okt|now|dec|januar|februar|měrc|apryl|maj|junij|julij|awgust|september|oktober|nowember|december|j|f|m|a|m|j|j|a|s|o|n|d|nje|pón|wał|srj|stw|pět|sob|njeźela|pónjeźele|wałtora|srjoda|stwórtk|pětk|sobota|n|p|w|s|s|p|s|0|pś.Chr.n.|pó Chr.n.|pśed Kristusowym naroźenim|pó Kristusowem naroźenju|pś.Chr.n.|pó Chr.n.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, \u0027zeg\u0027. H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|\u0027zeg\u0027. H|hm|h:mm\u202Fa|Hm|\u0027zeg\u0027. H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMW-count-one|W. \u0027tyźeń\u0027 MMMM|MMMMW-count-two|W. \u0027tyźeń\u0027 MMMM|MMMMW-count-few|W. \u0027tyźeń\u0027 MMMM|MMMMW-count-other|W. \u0027tyźeń\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \u0027tyźeń\u0027 \u0027lěta\u0027 Y|yw-count-two|w. \u0027tyźeń\u0027 \u0027lěta\u0027 Y|yw-count-few|w. \u0027tyźeń\u0027 \u0027lěta\u0027 Y|yw-count-other|w. \u0027tyźeń\u0027 \u0027lěta\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$dsb = $enkidatron$elm_cldr$Generated$Dsb$dsb;
var $enkidatron$elm_cldr$Generated$Fil$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fil',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fil$fil = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fil$dayPeriods, 'fil||||AM|PM|9|afternoon1|tanghali|am|AM|evening1|ng gabi|midnight|hatinggabi|morning1|nang umaga|morning2|madaling-araw|night1|ng gabi|noon|tanghaling-tapat|pm|PM|AM|PM|9|afternoon1|tanghali|am|AM|evening1|ng gabi|midnight|hatinggabi|morning1|nang umaga|morning2|madaling-araw|night1|ng gabi|noon|tanghaling-tapat|pm|PM|am|pm|9|afternoon1|sa hapon|am|am|evening1|sa gabi|midnight|hatinggabi|morning1|umaga|morning2|madaling-araw|night1|ng gabi|noon|tanghaling-tapat|pm|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Ene|Peb|Mar|Abr|May|Hun|Hul|Ago|Set|Okt|Nob|Dis|Enero|Pebrero|Marso|Abril|Mayo|Hunyo|Hulyo|Agosto|Setyembre|Oktubre|Nobyembre|Disyembre|Ene|Peb|Mar|Abr|May|Hun|Hul|Ago|Set|Okt|Nob|Dis|1|Ene|Peb|Mar|Abr|May|Hun|Hul|Ago|Set|Okt|Nob|Dis|Enero|Pebrero|Marso|Abril|Mayo|Hunyo|Hulyo|Agosto|Setyembre|Oktubre|Nobyembre|Disyembre|E|P|M|A|M|Hun|Hul|Ago|Set|Okt|Nob|Dis|Lin|Lun|Mar|Miy|Huw|Biy|Sab|Linggo|Lunes|Martes|Miyerkules|Huwebes|Biyernes|Sabado|Lin|Lun|Mar|Miy|Huw|Biy|Sab|0|BC|AD|Before Christ|Anno Domini|BC|AD|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027ika\u0027-W \u0027linggo\u0027 \u0027ng\u0027 MMMM|MMMMW-count-other|\u0027linggo\u0027 W \u0027ng\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMM|MM/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027ika\u0027-w \u0027linggo\u0027 \u0027ng\u0027 Y|yw-count-other|\u0027linggo\u0027 w \u0027ng\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$fil = $enkidatron$elm_cldr$Generated$Fil$fil;
var $enkidatron$elm_cldr$Generated$Hsb$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Hsb$hsb = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hsb$dayPeriods, 'hsb||||dop.|pop.|2|am|dop.|pm|pop.|dopołdnja|popołdnju|2|am|dopołdnja|pm|popołdnju|dop.|pop.|2|am|dop.|pm|pop.|d.M.yy|d.M.y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|měr.|apr.|mej.|jun.|jul.|awg.|sep.|okt.|now.|dec.|januara|februara|měrca|apryla|meje|junija|julija|awgusta|septembra|oktobra|nowembra|decembra|j|f|m|a|m|j|j|a|s|o|n|d|1|jan|feb|měr|apr|mej|jun|jul|awg|sep|okt|now|dec|januar|februar|měrc|apryl|meja|junij|julij|awgust|september|oktober|nowember|december|j|f|m|a|m|j|j|a|s|o|n|d|nje|pón|wut|srj|štw|pja|sob|njedźela|póndźela|wutora|srjeda|štwórtk|pjatk|sobota|n|p|w|s|š|p|s|0|př.Chr.n.|po Chr.n.|před Chrystowym narodźenjom|po Chrystowym narodźenju|př.Chr.n.|po Chr.n.|H:mm \u0027hodź\u0027.|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, H:mm \u0027hodź\u0027.|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|H \u0027hodź\u0027.|hm|h:mm\u202Fa|Hm|H:mm \u0027hodź\u0027.|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMW-count-one|W. \u0027tydźeń\u0027 MMMM|MMMMW-count-two|W. \u0027tydźeń\u0027 MMMM|MMMMW-count-few|W. \u0027tydźeń\u0027 MMMM|MMMMW-count-other|W. \u0027tydźeń\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \u0027tydźeń\u0027 \u0027lěta\u0027 Y|yw-count-two|w. \u0027tydźeń\u0027 \u0027lěta\u0027 Y|yw-count-few|w. \u0027tydźeń\u0027 \u0027lěta\u0027 Y|yw-count-other|w. \u0027tydźeń\u0027 \u0027lěta\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hsb = $enkidatron$elm_cldr$Generated$Hsb$hsb;
var $enkidatron$elm_cldr$Generated$Kok$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Kok$kok = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Kok$dayPeriods, 'kok||||AM|PM|2|am|AM|pm|PM|सकाळ|सांज|2|am|सकाळ|pm|सांज|a|p|2|am|a|pm|p|d-M-yy|d-MMM-y|d MMMM y|EEEE d MMMM y|जानेवारी|फेब्रुवारी|मार्च|एप्रील|मे|जून|जुलय|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|जानेवारी|फेब्रुवारी|मार्च|एप्रील|मे|जून|जुलय|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|1|2|3|4|5|6|7|8|9|10|11|12|1|जाने|फेब्रु|मार्च|एप्री|मे|जून|जुल|ऑग|सप्टें|ऑक्टो|नो|डिसे|जानेवारी|फेब्रुवारी|मार्च|एप्रील|मे|जून|जुलय|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|1|2|3|4|5|6|7|8|9|10|11|12|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आ|सो|मं|बु|बि|शु|शे|1|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आ|सो|मं|बु|ब|शु|शे|क्रिस्तपूर्व|क्रि.श.|क्रिस्तपूर्व|क्रिस्तशक|क्रिस्तपूर्व|क्रि.श.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|d-M, E|MMM|LLL|MMMd|MMM d|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|d-M-y, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|MMMM, y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|रॉन|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$kok = $enkidatron$elm_cldr$Generated$Kok$kok;
var $enkidatron$elm_cldr$Generated$Yue$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'yue',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(8, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(8, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Yue$yue = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yue$dayPeriods, 'yue||||上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日 EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|星期日|星期一|星期二|星期三|星期四|星期五|星期六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|西元前|西元|西元前|西元|西元前|西元|ah:mm|ah:mm:ss|ah:mm:ss [z]|ah:mm:ss [zzzz]|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|Bh時|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d E|Ehm|E ah:mm|EHm|E HH:mm|Ehms|E ah:mm:ss|EHms|E HH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日 E|h|ah時|H|H時|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|ah:mm:ss [v]|Hmsv|HH:mm:ss [v]|hmv|ah:mm [v]|Hmv|HH:mm [v]|M|M月|Md|M/d|MEd|M/d（E）|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日 E|MMMMd|M月d日|MMMMW-count-other|M月第W個星期|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/d（E）|yMM|y/MM|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日 E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w個星期|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yue = $enkidatron$elm_cldr$Generated$Yue$yue;
var $enkidatron$elm_cldr$Generated$Root$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Root$root = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Root$dayPeriods, 'root||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|y-MM-dd|y MMM d|y MMMM d|y MMMM d, EEEE|M01|M02|M03|M04|M05|M06|M07|M08|M09|M10|M11|M12|M01|M02|M03|M04|M05|M06|M07|M08|M09|M10|M11|M12|1|2|3|4|5|6|7|8|9|10|11|12|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sun|Mon|Tue|Wed|Thu|Fri|Sat|S|M|T|W|T|F|S|0|BCE|CE|BCE|CE|BCE|CE|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$root = $enkidatron$elm_cldr$Generated$Root$root;
var $enkidatron$elm_cldr$Generated$Af$af_NA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Af$dayPeriods, 'af||NA||vm.|nm.|7|afternoon1|die middag|am|vm.|evening1|die aand|midnight|middernag|morning1|die oggend|night1|die nag|pm|nm.|vm.|nm.|7|afternoon1|die middag|am|vm.|evening1|die aand|midnight|middernag|morning1|die oggend|night1|die nag|pm|nm.|v|n|7|afternoon1|m|am|v|evening1|a|midnight|mn|morning1|o|night1|n|pm|n|y-MM-dd|dd MMM y|dd MMMM y|EEEE dd MMMM y|Jan.|Feb.|Mrt.|Apr.|Mei|Jun.|Jul.|Aug.|Sep.|Okt.|Nov.|Des.|Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|So.|Ma.|Di.|Wo.|Do.|Vr.|Sa.|Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag|S|M|D|W|D|V|S|0|v.C.|n.C.|voor Christus|na Christus|v.C.|n.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|ccc|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d|Ehm|E hh:mm\u202Fa|EHm|E HH:mm|Ehms|E hh:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|dd MMM y G|GyMMMEd|E dd MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|MM-y|yMd|y-MM-dd|yMEd|E y-MM-dd|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027van\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027van\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-¤||¤||¤||E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|leu|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$af_NA = $enkidatron$elm_cldr$Generated$Af$af_NA;
var $enkidatron$elm_cldr$Generated$Ar$ar_AE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||AE||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_AE = $enkidatron$elm_cldr$Generated$Ar$ar_AE;
var $enkidatron$elm_cldr$Generated$Ar$ar_BH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||BH||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_BH = $enkidatron$elm_cldr$Generated$Ar$ar_BH;
var $enkidatron$elm_cldr$Generated$Ar$ar_DJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||DJ||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|124|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DJF|Fdj|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_DJ = $enkidatron$elm_cldr$Generated$Ar$ar_DJ;
var $enkidatron$elm_cldr$Generated$Ar$ar_DZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||DZ||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر|جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ج|ف|م|أ|م|ج|ج|أ|س|أ|ن|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|\u200E-||||||E2W.|,|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W.|,|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_DZ = $enkidatron$elm_cldr$Generated$Ar$ar_DZ;
var $enkidatron$elm_cldr$Generated$Ar$ar_EG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||EG||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_EG = $enkidatron$elm_cldr$Generated$Ar$ar_EG;
var $enkidatron$elm_cldr$Generated$Ar$ar_EH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||EH||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_EH = $enkidatron$elm_cldr$Generated$Ar$ar_EH;
var $enkidatron$elm_cldr$Generated$Ar$ar_ER = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||ER||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|124|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ERN|Nfk|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_ER = $enkidatron$elm_cldr$Generated$Ar$ar_ER;
var $enkidatron$elm_cldr$Generated$Ar$ar_IL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||IL||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_IL = $enkidatron$elm_cldr$Generated$Ar$ar_IL;
var $enkidatron$elm_cldr$Generated$Ar$ar_IQ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||IQ||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين\u00A0الأول|تشرين الثاني|كانون الأول|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|ك|ش|آ|ن|أ|ح|ت|آ|أ|ت|ت|ك|1|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|ك|ش|آ|ن|أ|ح|ت|آ|أ|ت|ت|ك|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_IQ = $enkidatron$elm_cldr$Generated$Ar$ar_IQ;
var $enkidatron$elm_cldr$Generated$Ar$ar_JO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||JO||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|ك|ش|آ|ن|أ|ح|ت|آ|أ|ت|ت|ك|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_JO = $enkidatron$elm_cldr$Generated$Ar$ar_JO;
var $enkidatron$elm_cldr$Generated$Ar$ar_KM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||KM||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_KM = $enkidatron$elm_cldr$Generated$Ar$ar_KM;
var $enkidatron$elm_cldr$Generated$Ar$ar_KW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||KW||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_KW = $enkidatron$elm_cldr$Generated$Ar$ar_KW;
var $enkidatron$elm_cldr$Generated$Ar$ar_LB = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||LB||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|ك|ش|آ|ن|أ|ح|ت|آ|أ|ت|ت|ك|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|\u200E-||||||E2W.|,|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W.|,|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|SDG|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_LB = $enkidatron$elm_cldr$Generated$Ar$ar_LB;
var $enkidatron$elm_cldr$Generated$Ar$ar_LY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||LY||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ل|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|\u200E-||||||E2W.|,|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W.|,|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_LY = $enkidatron$elm_cldr$Generated$Ar$ar_LY;
var $enkidatron$elm_cldr$Generated$Ar$ar_MA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||MA||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|ماي|يونيو|يوليوز|غشت|شتنبر|أكتوبر|نونبر|دجنبر|يناير|فبراير|مارس|أبريل|ماي|يونيو|يوليوز|غشت|شتنبر|أكتوبر|نونبر|دجنبر|ي|ف|م|أ|م|ن|ل|غ|ش|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|\u200E-||||||E2W.|,|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W.|,|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_MA = $enkidatron$elm_cldr$Generated$Ar$ar_MA;
var $enkidatron$elm_cldr$Generated$Ar$ar_MR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||MR||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|إبريل|مايو|يونيو|يوليو|أغشت|شتمبر|أكتوبر|نوفمبر|دجمبر|يناير|فبراير|مارس|إبريل|مايو|يونيو|يوليو|أغشت|شتمبر|أكتوبر|نوفمبر|دجمبر|ي|ف|م|إ|و|ن|ل|غ|ش|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|\u200E-||||||E2W.|,|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W.|,|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_MR = $enkidatron$elm_cldr$Generated$Ar$ar_MR;
var $enkidatron$elm_cldr$Generated$Ar$ar_OM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||OM||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_OM = $enkidatron$elm_cldr$Generated$Ar$ar_OM;
var $enkidatron$elm_cldr$Generated$Ar$ar_PS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||PS||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|ك|ش|آ|ن|أ|ح|ت|آ|أ|ت|ت|ك|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_PS = $enkidatron$elm_cldr$Generated$Ar$ar_PS;
var $enkidatron$elm_cldr$Generated$Ar$ar_QA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||QA||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_QA = $enkidatron$elm_cldr$Generated$Ar$ar_QA;
var $enkidatron$elm_cldr$Generated$Ar$ar_SA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||SA||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ل|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_SA = $enkidatron$elm_cldr$Generated$Ar$ar_SA;
var $enkidatron$elm_cldr$Generated$Ar$ar_SD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||SD||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_SD = $enkidatron$elm_cldr$Generated$Ar$ar_SD;
var $enkidatron$elm_cldr$Generated$Ar$ar_SO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||SO||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|124|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SOS|S|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_SO = $enkidatron$elm_cldr$Generated$Ar$ar_SO;
var $enkidatron$elm_cldr$Generated$Ar$ar_SS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||SS||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|GB£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_SS = $enkidatron$elm_cldr$Generated$Ar$ar_SS;
var $enkidatron$elm_cldr$Generated$Ar$ar_SY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||SY||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|كانون الثاني|شباط|آذار|نيسان|أيار|حزيران|تموز|آب|أيلول|تشرين الأول|تشرين الثاني|كانون الأول|ك|ش|آ|ن|أ|ح|ت|آ|أ|ت|ت|ك|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_SY = $enkidatron$elm_cldr$Generated$Ar$ar_SY;
var $enkidatron$elm_cldr$Generated$Ar$ar_TD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||TD||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_TD = $enkidatron$elm_cldr$Generated$Ar$ar_TD;
var $enkidatron$elm_cldr$Generated$Ar$ar_TN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||TN||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر|جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ج|ف|م|أ|م|ج|ج|أ|س|أ|ن|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|\u200E-||||||E2W.|,|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W.|,|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_TN = $enkidatron$elm_cldr$Generated$Ar$ar_TN;
var $enkidatron$elm_cldr$Generated$Ar$ar_YE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||YE||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|123|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar_YE = $enkidatron$elm_cldr$Generated$Ar$ar_YE;
var $enkidatron$elm_cldr$Generated$Bn$bn_IN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bn$dayPeriods, 'bn||IN||AM|PM|8|afternoon1|দুপুর|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যা|morning1|ভোর|morning2|সকাল|night1|রাত্রি|pm|PM|AM|PM|8|afternoon1|দুপুরবেলায়|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যাবেলায়|morning1|ভোরবেলায়|morning2|সকালবেলায়|night1|রাত্রি|pm|PM|AM|PM|8|afternoon1|দুপুর|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যা|morning1|ভোর|morning2|সকাল|night1|রাত্রি|pm|PM|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|জানু|ফেব|মার্চ|এপ্রি|মে|জুন|জুল|আগ|সেপ্টেঃ|অক্টোঃ|নভেঃ|ডিসেঃ|জানুয়ারী|ফেব্রুয়ারী|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জা|ফে|মা|এ|মে|জুন|জুল|আ|সে|অ|ন|ডি|1|জানু|ফেব|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেঃ|অক্টোঃ|নভেঃ|ডিসেঃ|জানুয়ারী|ফেব্রুয়ারী|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জা|ফে|মা|এ|মে|জুন|জুল|আ|সে|অ|ন|ডি|রবি|সোম|মঙ্গল|বুধ|বৃহস্পতি|শুক্র|শনি|রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার|শুক্রবার|শনিবার|র|সো|ম|বু|বৃ|শু|শ|0|খ্রিঃপূঃ|খ্রিঃ|খ্রিঃপূঃ|খ্রিষ্টাব্দ|খ্রিঃপূঃ|খ্রিঃ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM, y G|GyMMMEd|E, d MMM, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d-M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|MMMM এর W নম্বর সপ্তাহ|MMMMW-count-other|MMMM এর W নম্বর সপ্তাহ|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y এর wতম সপ্তাহ|yw-count-other|Y এর wতম সপ্তাহ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bn_IN = $enkidatron$elm_cldr$Generated$Bn$bn_IN;
var $enkidatron$elm_cldr$Generated$Ca$ca_AD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ca$dayPeriods, 'ca||AD||a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u00A0m.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|mat.|morning2|matí|night1|nit|pm|p.\u202Fm.|d/M/yy|d MMM y|d MMMM \u0027del\u0027 y|EEEE, d MMMM \u0027del\u0027 y|de gen.|de febr.|de març|d’abr.|de maig|de juny|de jul.|d’ag.|de set.|d’oct.|de nov.|de des.|de gener|de febrer|de març|d’abril|de maig|de juny|de juliol|d’agost|de setembre|d’octubre|de novembre|de desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|1|gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.|gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|dg.|dl.|dt.|dc.|dj.|dv.|ds.|diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte|dg.|dl.|dt.|dc.|dj.|dv.|ds.|0|aC|dC|abans de Crist|després de Crist|aC|dC|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM \u0027del\u0027 y G|GyMMMEd|E, d MMM \u0027del\u0027 y G|GyMMMM|LLLL \u0027del\u0027 y G|GyMMMMd|d MMMM \u0027del\u0027 y G|GyMMMMEd|E, d MMMM \u0027del\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa (vvvv)|Hmvvvv|H:mm (vvvv)|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027setmana\u0027 W MMMM|MMMMW-count-other|\u0027setmana\u0027 W MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|LLL \u0027del\u0027 y|yMMMd|d MMM \u0027del\u0027 y|yMMMEd|E, d MMM y|yMMMM|LLLL \u0027del\u0027 y|yMMMMd|d MMMM \u0027del\u0027 y|yMMMMEd|E, d MMMM \u0027del\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027setmana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027setmana\u0027 w \u0027del\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs F|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ca_AD = $enkidatron$elm_cldr$Generated$Ca$ca_AD;
var $enkidatron$elm_cldr$Generated$Ca$ca_FR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ca$dayPeriods, 'ca||FR||a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u00A0m.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|mat.|morning2|matí|night1|nit|pm|p.\u202Fm.|d/M/yy|d MMM y|d MMMM \u0027del\u0027 y|EEEE, d MMMM \u0027del\u0027 y|de gen.|de febr.|de març|d’abr.|de maig|de juny|de jul.|d’ag.|de set.|d’oct.|de nov.|de des.|de gener|de febrer|de març|d’abril|de maig|de juny|de juliol|d’agost|de setembre|d’octubre|de novembre|de desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|1|gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.|gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|dg.|dl.|dt.|dc.|dj.|dv.|ds.|diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte|dg.|dl.|dt.|dc.|dj.|dv.|ds.|0|aC|dC|abans de Crist|després de Crist|aC|dC|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM \u0027del\u0027 y G|GyMMMEd|E, d MMM \u0027del\u0027 y G|GyMMMM|LLLL \u0027del\u0027 y G|GyMMMMd|d MMMM \u0027del\u0027 y G|GyMMMMEd|E, d MMMM \u0027del\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa (vvvv)|Hmvvvv|H:mm (vvvv)|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027setmana\u0027 W MMMM|MMMMW-count-other|\u0027setmana\u0027 W MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|LLL \u0027del\u0027 y|yMMMd|d MMM \u0027del\u0027 y|yMMMEd|E, d MMM y|yMMMM|LLLL \u0027del\u0027 y|yMMMMd|d MMMM \u0027del\u0027 y|yMMMMEd|E, d MMMM \u0027del\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027setmana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027setmana\u0027 w \u0027del\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|FRF|F|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs F|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ca_FR = $enkidatron$elm_cldr$Generated$Ca$ca_FR;
var $enkidatron$elm_cldr$Generated$Ca$ca_IT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ca$dayPeriods, 'ca||IT||a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u00A0m.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|mat.|morning2|matí|night1|nit|pm|p.\u202Fm.|d/M/yy|d MMM y|d MMMM \u0027del\u0027 y|EEEE, d MMMM \u0027del\u0027 y|de gen.|de febr.|de març|d’abr.|de maig|de juny|de jul.|d’ag.|de set.|d’oct.|de nov.|de des.|de gener|de febrer|de març|d’abril|de maig|de juny|de juliol|d’agost|de setembre|d’octubre|de novembre|de desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|1|gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.|gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|dg.|dl.|dt.|dc.|dj.|dv.|ds.|diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte|dg.|dl.|dt.|dc.|dj.|dv.|ds.|0|aC|dC|abans de Crist|després de Crist|aC|dC|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM \u0027del\u0027 y G|GyMMMEd|E, d MMM \u0027del\u0027 y G|GyMMMM|LLLL \u0027del\u0027 y G|GyMMMMd|d MMMM \u0027del\u0027 y G|GyMMMMEd|E, d MMMM \u0027del\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa (vvvv)|Hmvvvv|H:mm (vvvv)|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027setmana\u0027 W MMMM|MMMMW-count-other|\u0027setmana\u0027 W MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|LLL \u0027del\u0027 y|yMMMd|d MMM \u0027del\u0027 y|yMMMEd|E, d MMM y|yMMMM|LLLL \u0027del\u0027 y|yMMMMd|d MMMM \u0027del\u0027 y|yMMMMEd|E, d MMMM \u0027del\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027setmana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027setmana\u0027 w \u0027del\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs F|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ca_IT = $enkidatron$elm_cldr$Generated$Ca$ca_IT;
var $enkidatron$elm_cldr$Generated$Da$da_GL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Da$dayPeriods, 'da||GL||AM|PM|8|afternoon1|om eftermiddagen|am|AM|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|PM|AM|PM|8|afternoon1|om eftermiddagen|am|AM|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|PM|a|p|8|afternoon1|om eftermiddagen|am|a|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE \u0027den\u0027 d. MMMM y|jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.|januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|søn.|man.|tirs.|ons.|tors.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|efter Kristus|fKr|eKr|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d.|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E \u0027den\u0027 d.|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss\u202Fa v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|M|Md|d.M|MEd|E d.M|MMdd|dd.MM|MMM|MMM|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \u0027uge\u0027 \u0027i\u0027 MMMM|MMMMW-count-other|W. \u0027uge\u0027 \u0027i\u0027 MMMM|ms|mm.ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027uge\u0027 w \u0027i\u0027 Y|yw-count-other|\u0027uge\u0027 w \u0027i\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr.|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr.|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr.|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr.|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$da_GL = $enkidatron$elm_cldr$Generated$Da$da_GL;
var $enkidatron$elm_cldr$Generated$De$de_AT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||AT||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jän.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sep.|Okt.|Nov.|Dez.|Jänner|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jän|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Jänner|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \u0027Uhr\u0027 a|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|111|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de_AT = $enkidatron$elm_cldr$Generated$De$de_AT;
var $enkidatron$elm_cldr$Generated$De$de_BE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||BE||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jan.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sept.|Okt.|Nov.|Dez.|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \u0027Uhr\u0027 a|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|111|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de_BE = $enkidatron$elm_cldr$Generated$De$de_BE;
var $enkidatron$elm_cldr$Generated$De$de_CH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||CH||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jan.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sept.|Okt.|Nov.|Dez.|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \u0027Uhr\u0027 a|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W’|.|-||||||E2W’|.|¤-||¤\u00A0||¤\u00A0||E0W’|.|-|%||%||%|111|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de_CH = $enkidatron$elm_cldr$Generated$De$de_CH;
var $enkidatron$elm_cldr$Generated$De$de_IT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||IT||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jän.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sep.|Okt.|Nov.|Dez.|Jänner|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jän|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Jänner|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \u0027Uhr\u0027 a|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|111|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de_IT = $enkidatron$elm_cldr$Generated$De$de_IT;
var $enkidatron$elm_cldr$Generated$De$de_LI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||LI||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jan.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sept.|Okt.|Nov.|Dez.|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \u0027Uhr\u0027 a|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W’|.|-||||||E2W’|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W’|.|-|%||%||%|111|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de_LI = $enkidatron$elm_cldr$Generated$De$de_LI;
var $enkidatron$elm_cldr$Generated$De$de_LU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||LU||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|vorm.|nachm.|9|afternoon1|mittags|afternoon2|nachm.|am|vorm.|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|nachm.|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jan.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sept.|Okt.|Nov.|Dez.|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|HH \u0027Uhr\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\u0027Woche\u0027 W \u0027im\u0027 MMMM|MMMMW-count-other|\u0027Woche\u0027 W \u0027im\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|yw-count-other|\u0027Woche\u0027 w \u0027des\u0027 \u0027Jahres\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|112|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LUF|F|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de_LU = $enkidatron$elm_cldr$Generated$De$de_LU;
var $enkidatron$elm_cldr$Generated$El$el_CY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$El$dayPeriods, 'el||CY||π.μ.|μ.μ.|6|afternoon1|μεσημ.|am|π.μ.|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μ.μ.|π.μ.|μ.μ.|6|afternoon1|το μεσημέρι|am|π.μ.|evening1|το απόγευμα|morning1|το πρωί|night1|το βράδυ|pm|μ.μ.|πμ|μμ|6|afternoon1|μεσημ.|am|πμ|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μμ|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|Ιαν|Φεβ|Μαρ|Απρ|Μαΐ|Ιουν|Ιουλ|Αυγ|Σεπ|Οκτ|Νοε|Δεκ|Ιανουαρίου|Φεβρουαρίου|Μαρτίου|Απριλίου|Μαΐου|Ιουνίου|Ιουλίου|Αυγούστου|Σεπτεμβρίου|Οκτωβρίου|Νοεμβρίου|Δεκεμβρίου|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|1|Ιαν|Φεβ|Μάρ|Απρ|Μάι|Ιούν|Ιούλ|Αύγ|Σεπ|Οκτ|Νοέ|Δεκ|Ιανουάριος|Φεβρουάριος|Μάρτιος|Απρίλιος|Μάιος|Ιούνιος|Ιούλιος|Αύγουστος|Σεπτέμβριος|Οκτώβριος|Νοέμβριος|Δεκέμβριος|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|Κυρ|Δευ|Τρί|Τετ|Πέμ|Παρ|Σάβ|Κυριακή|Δευτέρα|Τρίτη|Τετάρτη|Πέμπτη|Παρασκευή|Σάββατο|Κ|Δ|Τ|Τ|Π|Π|Σ|0|π.Χ.|μ.Χ.|προ Χριστού|μετά Χριστόν|π.Χ.|μ.Χ.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} - {0}|{1} - {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|MMM|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|εβδομάδα W του MMMM|MMMMW-count-other|εβδομάδα W του MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|εβδομάδα w του Y|yw-count-other|εβδομάδα w του Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GRD|Δρχ|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$el_CY = $enkidatron$elm_cldr$Generated$El$el_CY;
var $enkidatron$elm_cldr$Generated$En$en_AE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||AE||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_AE = $enkidatron$elm_cldr$Generated$En$en_AE;
var $enkidatron$elm_cldr$Generated$En$en_AG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||AG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_AG = $enkidatron$elm_cldr$Generated$En$en_AG;
var $enkidatron$elm_cldr$Generated$En$en_AI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||AI||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_AI = $enkidatron$elm_cldr$Generated$En$en_AI;
var $enkidatron$elm_cldr$Generated$En$en_AS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||AS||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_AS = $enkidatron$elm_cldr$Generated$En$en_AS;
var $enkidatron$elm_cldr$Generated$En$en_AT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||AT||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_AT = $enkidatron$elm_cldr$Generated$En$en_AT;
var $enkidatron$elm_cldr$Generated$En$en_AU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||AU||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|midday|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|midday|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|midday|pm|pm|pm-alt-variant|pm|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|Jan|Feb|Mar|Apr|May|June|July|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Su.|M.|Tu.|W.|Th.|F.|Sa.|1|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMEEEEd|EEEE d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMEEEEd|EEEE d MMM|MMMMd|d MMMM|MMMMEEEEd|EEEE d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMEEEEd|EEEE d MMM y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|Tk|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|₱|CZK|Kč|DKK|kr|DOP|$|EGP|£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|Kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|Gs|RON|lei|RUB|₽|RWF|RF|SBD|$|SCR|Rs|SEK|Kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$U|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFP|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_AU = $enkidatron$elm_cldr$Generated$En$en_AU;
var $enkidatron$elm_cldr$Generated$En$en_BB = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BB||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BB = $enkidatron$elm_cldr$Generated$En$en_BB;
var $enkidatron$elm_cldr$Generated$En$en_BE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BE||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/yy|dd MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BE = $enkidatron$elm_cldr$Generated$En$en_BE;
var $enkidatron$elm_cldr$Generated$En$en_BI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BI||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BIF|FBu|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BI = $enkidatron$elm_cldr$Generated$En$en_BI;
var $enkidatron$elm_cldr$Generated$En$en_BM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BM = $enkidatron$elm_cldr$Generated$En$en_BM;
var $enkidatron$elm_cldr$Generated$En$en_BS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BS||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BS = $enkidatron$elm_cldr$Generated$En$en_BS;
var $enkidatron$elm_cldr$Generated$En$en_BW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BW||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/yy|dd MMM y|dd MMMM y|EEEE, dd MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|dd MMM y G|GyMMMEd|E, dd MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|dd MMM|MMMEd|E, dd MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|dd MMM y|yMMMEd|E, dd MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BW = $enkidatron$elm_cldr$Generated$En$en_BW;
var $enkidatron$elm_cldr$Generated$En$en_BZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||BZ||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/yy|dd-MMM-y|dd MMMM y|EEEE, dd MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|dd MMM|MMMEd|E, dd MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|dd MMM y|yMMMEd|E, dd MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_BZ = $enkidatron$elm_cldr$Generated$En$en_BZ;
var $enkidatron$elm_cldr$Generated$En$en_CA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CA||a.m.|p.m.|10|afternoon1|in the afternoon|am|a.m.|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|p.m.|pm-alt-variant|pm|a.m.|p.m.|10|afternoon1|in the afternoon|am|a.m.|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|p.m.|pm-alt-variant|pm|am|pm|10|afternoon1|aft|am|am|am-alt-variant|am|evening1|eve|midnight|mid|morning1|mor|night1|night|noon|n|pm|pm|pm-alt-variant|pm|y-MM-dd|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|Md-alt-variant|d/M|MEd|E, MM-dd|MEd-alt-variant|E, d/M|MMdd|MM-dd|MMdd-alt-variant|dd/MM|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMd-alt-variant|d/M/y|yMEd|E, y-MM-dd|yMEd-alt-variant|E, d/M/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CA = $enkidatron$elm_cldr$Generated$En$en_CA;
var $enkidatron$elm_cldr$Generated$En$en_CC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CC||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CC = $enkidatron$elm_cldr$Generated$En$en_CC;
var $enkidatron$elm_cldr$Generated$En$en_CH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CH||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd.MM.y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d.M.y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W’|.|-||||||E2W’|.|¤-||¤\u00A0||¤\u00A0||E0W’|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CH = $enkidatron$elm_cldr$Generated$En$en_CH;
var $enkidatron$elm_cldr$Generated$En$en_CK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CK||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CK = $enkidatron$elm_cldr$Generated$En$en_CK;
var $enkidatron$elm_cldr$Generated$En$en_CM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CM = $enkidatron$elm_cldr$Generated$En$en_CM;
var $enkidatron$elm_cldr$Generated$En$en_CX = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CX||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CX = $enkidatron$elm_cldr$Generated$En$en_CX;
var $enkidatron$elm_cldr$Generated$En$en_CY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||CY||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_CY = $enkidatron$elm_cldr$Generated$En$en_CY;
var $enkidatron$elm_cldr$Generated$En$en_DE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||DE||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_DE = $enkidatron$elm_cldr$Generated$En$en_DE;
var $enkidatron$elm_cldr$Generated$En$en_DG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||DG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_DG = $enkidatron$elm_cldr$Generated$En$en_DG;
var $enkidatron$elm_cldr$Generated$En$en_DK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||DK||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h.mm\u202Fa|Ehm-alt-ascii|E h.mm a|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|Ehms-alt-ascii|E h.mm.ss a|EHms|E HH.mm.ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h.mm\u202Fa|hm-alt-ascii|h.mm a|Hm|HH.mm|hms|h.mm.ss\u202Fa|hms-alt-ascii|h.mm.ss a|Hms|HH.mm.ss|hmsv|h.mm.ss\u202Fa v|hmsv-alt-ascii|h.mm.ss a v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|hmv-alt-ascii|h.mm a v|Hmv|HH.mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm.ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr.|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_DK = $enkidatron$elm_cldr$Generated$En$en_DK;
var $enkidatron$elm_cldr$Generated$En$en_DM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||DM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_DM = $enkidatron$elm_cldr$Generated$En$en_DM;
var $enkidatron$elm_cldr$Generated$En$en_ER = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||ER||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ERN|Nfk|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_ER = $enkidatron$elm_cldr$Generated$En$en_ER;
var $enkidatron$elm_cldr$Generated$En$en_FI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||FI||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|H.mm|H.mm.ss|H.mm.ss z|H.mm.ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h.mm\u202Fa|Ehm-alt-ascii|E h.mm a|EHm|E H.mm|Ehms|E h.mm.ss\u202Fa|Ehms-alt-ascii|E h.mm.ss a|EHms|E H.mm.ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h.mm\u202Fa|hm-alt-ascii|h.mm a|Hm|H.mm|hms|h.mm.ss\u202Fa|hms-alt-ascii|h.mm.ss a|Hms|H.mm.ss|hmsv|h.mm.ss\u202Fa v|hmsv-alt-ascii|h.mm.ss a v|Hmsv|H.mm.ss v|hmv|h.mm\u202Fa v|hmv-alt-ascii|h.mm a v|Hmv|H.mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm.ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_FI = $enkidatron$elm_cldr$Generated$En$en_FI;
var $enkidatron$elm_cldr$Generated$En$en_FJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||FJ||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_FJ = $enkidatron$elm_cldr$Generated$En$en_FJ;
var $enkidatron$elm_cldr$Generated$En$en_FK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||FK||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GB£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_FK = $enkidatron$elm_cldr$Generated$En$en_FK;
var $enkidatron$elm_cldr$Generated$En$en_FM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||FM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_FM = $enkidatron$elm_cldr$Generated$En$en_FM;
var $enkidatron$elm_cldr$Generated$En$en_GD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GD||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GD = $enkidatron$elm_cldr$Generated$En$en_GD;
var $enkidatron$elm_cldr$Generated$En$en_GG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GG = $enkidatron$elm_cldr$Generated$En$en_GG;
var $enkidatron$elm_cldr$Generated$En$en_GH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GH||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GH = $enkidatron$elm_cldr$Generated$En$en_GH;
var $enkidatron$elm_cldr$Generated$En$en_GI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GI||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GB£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GI = $enkidatron$elm_cldr$Generated$En$en_GI;
var $enkidatron$elm_cldr$Generated$En$en_GM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GMD|D|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GM = $enkidatron$elm_cldr$Generated$En$en_GM;
var $enkidatron$elm_cldr$Generated$En$en_GU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GU||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GU = $enkidatron$elm_cldr$Generated$En$en_GU;
var $enkidatron$elm_cldr$Generated$En$en_GY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||GY||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_GY = $enkidatron$elm_cldr$Generated$En$en_GY;
var $enkidatron$elm_cldr$Generated$En$en_HK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||HK||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|d/M/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|58|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|d/M/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_HK = $enkidatron$elm_cldr$Generated$En$en_HK;
var $enkidatron$elm_cldr$Generated$En$en_ID = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||ID||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E d|Ehm|E h.mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH.mm.ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h.mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH.mm|hms|h.mm.ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH.mm.ss|hmsv|h.mm.ss. a v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH.mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm.ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_ID = $enkidatron$elm_cldr$Generated$En$en_ID;
var $enkidatron$elm_cldr$Generated$En$en_IE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||IE||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a.m.|p.m.|10|afternoon1|in the afternoon|am|a.m.|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|p.m.|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_IE = $enkidatron$elm_cldr$Generated$En$en_IE;
var $enkidatron$elm_cldr$Generated$En$en_IL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||IL||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E H:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|H|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|H:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_IL = $enkidatron$elm_cldr$Generated$En$en_IL;
var $enkidatron$elm_cldr$Generated$En$en_IM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||IM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_IM = $enkidatron$elm_cldr$Generated$En$en_IM;
var $enkidatron$elm_cldr$Generated$En$en_IN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||IN||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/yy|d MMM y|d MMMM y|EEEE d MMMM, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|Ehm-alt-ascii|E, h:mm a|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|Ehms-alt-ascii|E, h:mm:ss a|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMEEEEd|EEEE d MMM, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMEEEEd|EEEE d MMM|MMMMd|d MMMM|MMMMEEEEd|EEEE d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM, y|yMMMEEEEd|EEEE d MMM, y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM, y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_IN = $enkidatron$elm_cldr$Generated$En$en_IN;
var $enkidatron$elm_cldr$Generated$En$en_IO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||IO||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_IO = $enkidatron$elm_cldr$Generated$En$en_IO;
var $enkidatron$elm_cldr$Generated$En$en_JE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||JE||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_JE = $enkidatron$elm_cldr$Generated$En$en_JE;
var $enkidatron$elm_cldr$Generated$En$en_JM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||JM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_JM = $enkidatron$elm_cldr$Generated$En$en_JM;
var $enkidatron$elm_cldr$Generated$En$en_KE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||KE||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_KE = $enkidatron$elm_cldr$Generated$En$en_KE;
var $enkidatron$elm_cldr$Generated$En$en_KI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||KI||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_KI = $enkidatron$elm_cldr$Generated$En$en_KI;
var $enkidatron$elm_cldr$Generated$En$en_KN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||KN||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_KN = $enkidatron$elm_cldr$Generated$En$en_KN;
var $enkidatron$elm_cldr$Generated$En$en_KY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||KY||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_KY = $enkidatron$elm_cldr$Generated$En$en_KY;
var $enkidatron$elm_cldr$Generated$En$en_LC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||LC||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_LC = $enkidatron$elm_cldr$Generated$En$en_LC;
var $enkidatron$elm_cldr$Generated$En$en_LR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||LR||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_LR = $enkidatron$elm_cldr$Generated$En$en_LR;
var $enkidatron$elm_cldr$Generated$En$en_LS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||LS||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_LS = $enkidatron$elm_cldr$Generated$En$en_LS;
var $enkidatron$elm_cldr$Generated$En$en_MG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MG = $enkidatron$elm_cldr$Generated$En$en_MG;
var $enkidatron$elm_cldr$Generated$En$en_MH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MH||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MH = $enkidatron$elm_cldr$Generated$En$en_MH;
var $enkidatron$elm_cldr$Generated$En$en_MO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MO||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MOP|MOP$|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MO = $enkidatron$elm_cldr$Generated$En$en_MO;
var $enkidatron$elm_cldr$Generated$En$en_MP = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MP||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MP = $enkidatron$elm_cldr$Generated$En$en_MP;
var $enkidatron$elm_cldr$Generated$En$en_MS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MS||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MS = $enkidatron$elm_cldr$Generated$En$en_MS;
var $enkidatron$elm_cldr$Generated$En$en_MT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MT||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|dd MMM y|dd MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|dd MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|dd MMM y|yMMMEd|E, dd MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GB£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MT = $enkidatron$elm_cldr$Generated$En$en_MT;
var $enkidatron$elm_cldr$Generated$En$en_MU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MU||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MU = $enkidatron$elm_cldr$Generated$En$en_MU;
var $enkidatron$elm_cldr$Generated$En$en_MV = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MV||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|d-M-yy|dd-MM-y|d MMMM y|EEEE d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MVR|Rf|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MV = $enkidatron$elm_cldr$Generated$En$en_MV;
var $enkidatron$elm_cldr$Generated$En$en_MW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MW||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MWK|MK|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MW = $enkidatron$elm_cldr$Generated$En$en_MW;
var $enkidatron$elm_cldr$Generated$En$en_MY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||MY||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_MY = $enkidatron$elm_cldr$Generated$En$en_MY;
var $enkidatron$elm_cldr$Generated$En$en_NA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NA||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NA = $enkidatron$elm_cldr$Generated$En$en_NA;
var $enkidatron$elm_cldr$Generated$En$en_NF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NF||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NF = $enkidatron$elm_cldr$Generated$En$en_NF;
var $enkidatron$elm_cldr$Generated$En$en_NG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NG = $enkidatron$elm_cldr$Generated$En$en_NG;
var $enkidatron$elm_cldr$Generated$En$en_NL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NL||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NL = $enkidatron$elm_cldr$Generated$En$en_NL;
var $enkidatron$elm_cldr$Generated$En$en_NR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NR||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NR = $enkidatron$elm_cldr$Generated$En$en_NR;
var $enkidatron$elm_cldr$Generated$En$en_NU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NU||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NU = $enkidatron$elm_cldr$Generated$En$en_NU;
var $enkidatron$elm_cldr$Generated$En$en_NZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||NZ||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|d/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_NZ = $enkidatron$elm_cldr$Generated$En$en_NZ;
var $enkidatron$elm_cldr$Generated$En$en_PG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||PG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PGK|K|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_PG = $enkidatron$elm_cldr$Generated$En$en_PG;
var $enkidatron$elm_cldr$Generated$En$en_PH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||PH||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_PH = $enkidatron$elm_cldr$Generated$En$en_PH;
var $enkidatron$elm_cldr$Generated$En$en_PK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||PK||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|dd-MMM-y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_PK = $enkidatron$elm_cldr$Generated$En$en_PK;
var $enkidatron$elm_cldr$Generated$En$en_PN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||PN||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_PN = $enkidatron$elm_cldr$Generated$En$en_PN;
var $enkidatron$elm_cldr$Generated$En$en_PR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||PR||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_PR = $enkidatron$elm_cldr$Generated$En$en_PR;
var $enkidatron$elm_cldr$Generated$En$en_PW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||PW||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_PW = $enkidatron$elm_cldr$Generated$En$en_PW;
var $enkidatron$elm_cldr$Generated$En$en_RW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||RW||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_RW = $enkidatron$elm_cldr$Generated$En$en_RW;
var $enkidatron$elm_cldr$Generated$En$en_SB = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SB||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SB = $enkidatron$elm_cldr$Generated$En$en_SB;
var $enkidatron$elm_cldr$Generated$En$en_SC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SC||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SCR|SR|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SC = $enkidatron$elm_cldr$Generated$En$en_SC;
var $enkidatron$elm_cldr$Generated$En$en_SD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SD||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SD = $enkidatron$elm_cldr$Generated$En$en_SD;
var $enkidatron$elm_cldr$Generated$En$en_SE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SE||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|y-MM-dd|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|E, y-MM-dd|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SE = $enkidatron$elm_cldr$Generated$En$en_SE;
var $enkidatron$elm_cldr$Generated$En$en_SG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SG = $enkidatron$elm_cldr$Generated$En$en_SG;
var $enkidatron$elm_cldr$Generated$En$en_SH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SH||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GB£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SH = $enkidatron$elm_cldr$Generated$En$en_SH;
var $enkidatron$elm_cldr$Generated$En$en_SI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SI||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SI = $enkidatron$elm_cldr$Generated$En$en_SI;
var $enkidatron$elm_cldr$Generated$En$en_SL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SL||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SLE|Le|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SL = $enkidatron$elm_cldr$Generated$En$en_SL;
var $enkidatron$elm_cldr$Generated$En$en_SS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SS||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GB£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SS = $enkidatron$elm_cldr$Generated$En$en_SS;
var $enkidatron$elm_cldr$Generated$En$en_SX = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SX||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|ANG|NAf.|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SX = $enkidatron$elm_cldr$Generated$En$en_SX;
var $enkidatron$elm_cldr$Generated$En$en_SZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||SZ||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|SZL|E|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_SZ = $enkidatron$elm_cldr$Generated$En$en_SZ;
var $enkidatron$elm_cldr$Generated$En$en_TC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||TC||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_TC = $enkidatron$elm_cldr$Generated$En$en_TC;
var $enkidatron$elm_cldr$Generated$En$en_TK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||TK||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_TK = $enkidatron$elm_cldr$Generated$En$en_TK;
var $enkidatron$elm_cldr$Generated$En$en_TO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||TO||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_TO = $enkidatron$elm_cldr$Generated$En$en_TO;
var $enkidatron$elm_cldr$Generated$En$en_TT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||TT||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_TT = $enkidatron$elm_cldr$Generated$En$en_TT;
var $enkidatron$elm_cldr$Generated$En$en_TV = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||TV||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_TV = $enkidatron$elm_cldr$Generated$En$en_TV;
var $enkidatron$elm_cldr$Generated$En$en_TZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||TZ||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|TZS|TSh|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_TZ = $enkidatron$elm_cldr$Generated$En$en_TZ;
var $enkidatron$elm_cldr$Generated$En$en_UG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||UG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|UGX|USh|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_UG = $enkidatron$elm_cldr$Generated$En$en_UG;
var $enkidatron$elm_cldr$Generated$En$en_UM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||UM||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_UM = $enkidatron$elm_cldr$Generated$En$en_UM;
var $enkidatron$elm_cldr$Generated$En$en_VC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||VC||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_VC = $enkidatron$elm_cldr$Generated$En$en_VC;
var $enkidatron$elm_cldr$Generated$En$en_VG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||VG||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_VG = $enkidatron$elm_cldr$Generated$En$en_VG;
var $enkidatron$elm_cldr$Generated$En$en_VI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||VI||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_VI = $enkidatron$elm_cldr$Generated$En$en_VI;
var $enkidatron$elm_cldr$Generated$En$en_VU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||VU||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|VUV|VT|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_VU = $enkidatron$elm_cldr$Generated$En$en_VU;
var $enkidatron$elm_cldr$Generated$En$en_WS = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||WS||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|WST|WS$|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_WS = $enkidatron$elm_cldr$Generated$En$en_WS;
var $enkidatron$elm_cldr$Generated$En$en_ZA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||ZA||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|y/MM/dd|dd MMM y|dd MMMM y|EEEE, dd MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|MM/dd|MEd|E, MM/dd|MMdd|dd/MM|MMM|LLL|MMMd|dd MMM|MMMEd|E, dd MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|y/MM/dd|yMEd|E, y/MM/dd|yMMM|MMM y|yMMMd|dd MMM y|yMMMEd|E, dd MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_ZA = $enkidatron$elm_cldr$Generated$En$en_ZA;
var $enkidatron$elm_cldr$Generated$En$en_ZM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||ZM||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_ZM = $enkidatron$elm_cldr$Generated$En$en_ZM;
var $enkidatron$elm_cldr$Generated$En$en_ZW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||ZW||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|d/M/y|dd MMM,y|dd MMMM y|EEEE, dd MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|dd MMM|MMMEd|E, dd MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|dd MMM, y|yMMMEd|E, dd MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_ZW = $enkidatron$elm_cldr$Generated$En$en_ZW;
var $enkidatron$elm_cldr$Generated$Es$es_AR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||AR||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|tarde|morning1|madrugada|morning2|mañana|night1|noche|noon|mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|tarde|morning1|madrugada|morning2|mañana|night1|noche|noon|mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|tarde|morning1|madrugada|morning2|mañana|night1|noche|noon|mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d-M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d/M/y|yMEd|E, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_AR = $enkidatron$elm_cldr$Generated$Es$es_AR;
var $enkidatron$elm_cldr$Generated$Es$es_BO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||BO||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM \u0027de\u0027 y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_BO = $enkidatron$elm_cldr$Generated$Es$es_BO;
var $enkidatron$elm_cldr$Generated$Es$es_BR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||BR||a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_BR = $enkidatron$elm_cldr$Generated$Es$es_BR;
var $enkidatron$elm_cldr$Generated$Es$es_BZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||BZ||a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_BZ = $enkidatron$elm_cldr$Generated$Es$es_BZ;
var $enkidatron$elm_cldr$Generated$Es$es_CL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||CL||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|dd-MM-yy|dd-MM-y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|1|ene.|feb.|mar.|abr.|may.|jun.|jul.|ago.|sept.|oct.|nov.|dic.|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|E, dd-MM|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM-y|yMd|dd-MM-y|yMEd|E dd-MM-y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|¤-||¤||¤||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_CL = $enkidatron$elm_cldr$Generated$Es$es_CL;
var $enkidatron$elm_cldr$Generated$Es$es_CO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||CO||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|m.|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|m.|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|m.|pm|p.\u202Fm.|d/MM/yy|d/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|1|ene.|feb.|mar.|abr.|may.|jun.|jul.|ago.|sept.|oct.|nov.|dic.|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|m|J|V|S|1|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|d|l|m|m|j|v|s|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM \u0027de\u0027 y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d \u0027de\u0027 MMM|MMMdd|d \u0027de\u0027 MMM|MMMEd|E, d \u0027de\u0027 MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM \u0027de\u0027 y|yMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_CO = $enkidatron$elm_cldr$Generated$Es$es_CO;
var $enkidatron$elm_cldr$Generated$Es$es_CR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||CR||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-¤||¤||¤||E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_CR = $enkidatron$elm_cldr$Generated$Es$es_CR;
var $enkidatron$elm_cldr$Generated$Es$es_CU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||CU||a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_CU = $enkidatron$elm_cldr$Generated$Es$es_CU;
var $enkidatron$elm_cldr$Generated$Es$es_DO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||DO||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|tarde|morning1|día|morning2|mañana|night1|noche|noon|mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM \u0027de\u0027 y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|RD$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_DO = $enkidatron$elm_cldr$Generated$Es$es_DO;
var $enkidatron$elm_cldr$Generated$Es$es_EA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||EA||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|X|J|V|S|0|a. C.|d. C.|antes de Cristo|después de Cristo|a. C.|d. C.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|EGP|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_EA = $enkidatron$elm_cldr$Generated$Es$es_EA;
var $enkidatron$elm_cldr$Generated$Es$es_EC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||EC||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|¤-||¤||¤||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_EC = $enkidatron$elm_cldr$Generated$Es$es_EC;
var $enkidatron$elm_cldr$Generated$Es$es_GQ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||GQ||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|X|J|V|S|0|a. C.|d. C.|antes de Cristo|después de Cristo|a. C.|d. C.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|EGP|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_GQ = $enkidatron$elm_cldr$Generated$Es$es_GQ;
var $enkidatron$elm_cldr$Generated$Es$es_GT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||GT||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/MM/yy|d/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_GT = $enkidatron$elm_cldr$Generated$Es$es_GT;
var $enkidatron$elm_cldr$Generated$Es$es_HN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||HN||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|dd \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE dd \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_HN = $enkidatron$elm_cldr$Generated$Es$es_HN;
var $enkidatron$elm_cldr$Generated$Es$es_IC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||IC||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|X|J|V|S|0|a. C.|d. C.|antes de Cristo|después de Cristo|a. C.|d. C.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|EGP|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_IC = $enkidatron$elm_cldr$Generated$Es$es_IC;
var $enkidatron$elm_cldr$Generated$Es$es_MX = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||MX||a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|dd/MM/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E d \u0027de\u0027 MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|p.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MRO|MRU|MRU|UM|MUR|Rs|MXN|$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_MX = $enkidatron$elm_cldr$Generated$Es$es_MX;
var $enkidatron$elm_cldr$Generated$Es$es_NI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||NI||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_NI = $enkidatron$elm_cldr$Generated$Es$es_NI;
var $enkidatron$elm_cldr$Generated$Es$es_PA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||PA||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|mediodía|pm|p.\u202Fm.|MM/dd/yy|MM/dd/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|MM/dd|MEd|E, MM/dd|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|MM/dd/y|yMEd|E MM/dd/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PAB|B/.|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_PA = $enkidatron$elm_cldr$Generated$Es$es_PA;
var $enkidatron$elm_cldr$Generated$Es$es_PE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||PE||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/MM/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene.|feb.|mar.|abr.|may.|jun.|jul.|ago.|set.|oct.|nov.|dic.|enero|febrero|marzo|abril|mayo|junio|julio|agosto|setiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|1|Ene.|Feb.|Mar.|Abr.|May.|Jun.|Jul.|Ago.|Set.|Oct.|Nov.|Dic.|Enero|Febrero|Marzo|Abril|Mayo|Junio|Julio|Agosto|Setiembre|Octubre|Noviembre|Diciembre|E|F|M|A|M|J|J|A|S|O|N|D|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PEN|S/|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_PE = $enkidatron$elm_cldr$Generated$Es$es_PE;
var $enkidatron$elm_cldr$Generated$Es$es_PH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||PH||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|X|J|V|S|0|a. C.|d. C.|antes de Cristo|después de Cristo|a. C.|d. C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|EGP|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_PH = $enkidatron$elm_cldr$Generated$Es$es_PH;
var $enkidatron$elm_cldr$Generated$Es$es_PR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||PR||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|MM/dd/yy|MM/dd/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|MM/dd|MEd|E, MM/dd|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|MM/dd/y|yMEd|E MM/dd/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_PR = $enkidatron$elm_cldr$Generated$Es$es_PR;
var $enkidatron$elm_cldr$Generated$Es$es_PY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||PY||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene.|feb.|mar.|abr.|may.|jun.|jul.|ago.|sept.|oct.|nov.|dic.|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|Gs.|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_PY = $enkidatron$elm_cldr$Generated$Es$es_PY;
var $enkidatron$elm_cldr$Generated$Es$es_SV = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||SV||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|$|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_SV = $enkidatron$elm_cldr$Generated$Es$es_SV;
var $enkidatron$elm_cldr$Generated$Es$es_US = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||US||a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|d/M/y|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d \u0027de\u0027 MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d \u0027de\u0027 MMM \u0027de\u0027 y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_US = $enkidatron$elm_cldr$Generated$Es$es_US;
var $enkidatron$elm_cldr$Generated$Es$es_UY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||UY||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene.|feb.|mar.|abr.|may.|jun.|jul.|ago.|set.|oct.|nov.|dic.|enero|febrero|marzo|abril|mayo|junio|julio|agosto|setiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|1|Ene.|Feb.|Mar.|Abr.|May.|Jun.|Jul.|Ago.|Set.|Oct.|Nov.|Dic.|Enero|Febrero|Marzo|Abril|Mayo|Junio|Julio|Agosto|Setiembre|Octubre|Noviembre|Diciembre|E|F|M|A|M|J|J|A|S|O|N|D|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|UYW|UP|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_UY = $enkidatron$elm_cldr$Generated$Es$es_UY;
var $enkidatron$elm_cldr$Generated$Es$es_VE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||VE||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene.|feb.|mar.|abr.|may.|jun.|jul.|ago.|sept.|oct.|nov.|dic.|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|¤-||¤||¤||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs.|VES|Bs.S|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_VE = $enkidatron$elm_cldr$Generated$Es$es_VE;
var $enkidatron$elm_cldr$Generated$Fa$fa_AF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fa$dayPeriods, 'fa||AF||ق.ظ.|ب.ظ.|8|afternoon1|ظهر|afternoon2|بعدازچاشت|am|ق.ظ.|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|ب.ظ.|قبل\u200Cازظهر|بعدازظهر|8|afternoon1|ظهر|afternoon2|بعدازچاشت|am|قبل\u200Cازظهر|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|بعدازظهر|ق|ب|8|afternoon1|ظ|afternoon2|ع|am|ق|morning1|ب|morning2|ص|night1|ش|night2|ن|pm|ب|y/M/d|d MMM y|d MMMM y|EEEE d MMMM y|جنو|فبروری|مارچ|اپریل|می|جون|جول|اگست|سپتمبر|اکتوبر|نومبر|دسم|جنوری|فبروری|مارچ|اپریل|می|جون|جولای|اگست|سپتمبر|اکتوبر|نومبر|دسمبر|ج|ف|م|ا|م|ج|ج|ا|س|ا|ن|د|1|جنوری|فبروری|مارچ|اپریل|می|جون|جولای|اگست|سپتمبر|اکتوبر|نومبر|دسمبر|جنوری|فبروری|مارچ|اپریل|می|جون|جولای|اگست|سپتمبر|اکتوبر|نومبر|دسمبر|ج|ف|م|ا|م|ج|ج|ا|س|ا|ن|د|یکشنبه|دوشنبه|سه\u200Cشنبه|چهارشنبه|پنجشنبه|جمعه|شنبه|یکشنبه|دوشنبه|سه\u200Cشنبه|چهارشنبه|پنجشنبه|جمعه|شنبه|ی|د|س|چ|پ|ج|ش|0|ق.م.|م.|قبل از میلاد|میلادی|ق|م|H:mm|H:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1}،\u200F {0}|{1}،\u200F {0}|{1}، ساعت {0}|{1}، ساعت {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|y/M/d GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|HHmmZ|HH:mm (Z)|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E d LLLL|MMMMW-count-one|هفتهٔ Wم LLLL|MMMMW-count-other|هفتهٔ Wم LLLL|mmss|mm:ss|ms|m:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|هفتهٔ wم Y|yw-count-other|هفتهٔ wم Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|\u200E−||||||E2W,|.|\u200E−¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|\u200E−|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|$CA|CLP|$|CNY|¥CN|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|$HK|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IRR|ریال|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|$MX|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$EC|XOF|فرانک\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$fa_AF = $enkidatron$elm_cldr$Generated$Fa$fa_AF;
var $enkidatron$elm_cldr$Generated$Fr$fr_BE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||BE||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|d/MM/yy|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|H \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|Hmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_BE = $enkidatron$elm_cldr$Generated$Fr$fr_BE;
var $enkidatron$elm_cldr$Generated$Fr$fr_BF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||BF||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_BF = $enkidatron$elm_cldr$Generated$Fr$fr_BF;
var $enkidatron$elm_cldr$Generated$Fr$fr_BI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||BI||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BIF|FBu|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_BI = $enkidatron$elm_cldr$Generated$Fr$fr_BI;
var $enkidatron$elm_cldr$Generated$Fr$fr_BJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||BJ||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_BJ = $enkidatron$elm_cldr$Generated$Fr$fr_BJ;
var $enkidatron$elm_cldr$Generated$Fr$fr_BL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||BL||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_BL = $enkidatron$elm_cldr$Generated$Fr$fr_BL;
var $enkidatron$elm_cldr$Generated$Fr$fr_CA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CA||a.m.|p.m.|8|afternoon1|après-midi|am|a.m.|evening1|du soir|midnight|minuit|morning1|du mat.|night1|du mat.|noon|midi|pm|p.m.|a.m.|p.m.|8|afternoon1|de l’après-midi|am|a.m.|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|p.m.|a|p|8|afternoon1|après-midi|am|a|evening1|du soir|midnight|minuit|morning1|mat.|night1|mat.|noon|midi|pm|p|y-MM-dd|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juill.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH \u0027h\u0027 mm|HH \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027|HH \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 z|HH \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|52|Bh|h \u0027h\u0027 B|Bhm|h \u0027h\u0027 mm B|Bhms|h \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 B|d|d|E|E|EBhm|E h \u0027h\u0027 mm B|EBhms|E h \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 B|Ed|E d|Ehm|E h \u0027h\u0027 mm\u202Fa|EHm|E HH \u0027h\u0027 mm|Ehms|E h \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 a|EHms|E HH \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027|Gy|y G|GyMd|y-MM-dd GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h \u0027h\u0027 a|H|HH \u0027h\u0027|hm|h \u0027h\u0027 mm\u202Fa|Hm|HH \u0027h\u0027 mm|hms|h \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 a|Hms|HH \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027|hmsv|h \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 a v|Hmsv|HH \u0027h\u0027 mm \u0027min\u0027 ss \u0027s\u0027 v|hmv|h \u0027h\u0027 mm\u202Fa v|Hmv|HH \u0027h\u0027 mm v|M|L|Md|MM-dd|MEd|E MM-dd|MMd|MM-dd|MMdd|MM-dd|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm \u0027min\u0027 ss \u0027s\u0027|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|E y-MM-dd|yMM|y-MM|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|ARS|AUD|$\u00A0AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|BMD|BND|BND|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br|BZD|BZD|CAD|$|CLP|CLP|CNY|CN¥|COP|COP|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|FRF|F|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|FG|GTQ|Q|GYD|$|HKD|$\u00A0HK|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|ILS|INR|INR|ISK|kr|ITL|₤IT|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|LBP|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|MXN|MYR|RM|NAD|NAD|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$\u00A0NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|SBD|SEK|kr|SGD|$\u00A0SG|SHP|£|SRD|SRD|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|TTD|TWD|TWD|UAH|₴|USD|$\u00A0US|UYU|UYU|VEF|Bs|VND|VND|WST|WST|XAF|XAF|XCD|XCD|XOF|XOF|XPF|XPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CA = $enkidatron$elm_cldr$Generated$Fr$fr_CA;
var $enkidatron$elm_cldr$Generated$Fr$fr_CD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CD||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|min.|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CDF|FC|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CD = $enkidatron$elm_cldr$Generated$Fr$fr_CD;
var $enkidatron$elm_cldr$Generated$Fr$fr_CF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CF||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CF = $enkidatron$elm_cldr$Generated$Fr$fr_CF;
var $enkidatron$elm_cldr$Generated$Fr$fr_CG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CG||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CG = $enkidatron$elm_cldr$Generated$Fr$fr_CG;
var $enkidatron$elm_cldr$Generated$Fr$fr_CH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CH||AM|PM|8|afternoon1|de l’ap.m.|am|AM|evening1|du soir|midnight|min.|morning1|du mat.|night1|du mat.|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’ap.m.|am|AM|evening1|du soir|midnight|min.|morning1|du mat.|night1|du mat.|noon|midi|pm|PM|dd.MM.yy|d MMM y|d MMMM y|EEEE, d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH.mm:ss \u0027h\u0027 zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM.|MEd|E, dd.MM.|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|%||%||%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CH = $enkidatron$elm_cldr$Generated$Fr$fr_CH;
var $enkidatron$elm_cldr$Generated$Fr$fr_CI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CI||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CI = $enkidatron$elm_cldr$Generated$Fr$fr_CI;
var $enkidatron$elm_cldr$Generated$Fr$fr_CM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||CM||mat.|soir|8|afternoon1|après-midi|am|mat.|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|soir|matin|soir|8|afternoon1|de l’après-midi|am|matin|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|soir|mat.|soir|8|afternoon1|ap.m.|am|mat.|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|soir|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm|EHm|E HH:mm|Ehms|E h:mm:ss|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h|H|HH \u0027h\u0027|hm|h:mm|Hm|HH:mm|hms|h:mm:ss|Hms|HH:mm:ss|hmsv|h:mm:ss v|Hmsv|HH:mm:ss v|hmv|h:mm v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_CM = $enkidatron$elm_cldr$Generated$Fr$fr_CM;
var $enkidatron$elm_cldr$Generated$Fr$fr_DJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||DJ||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DJF|Fdj|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_DJ = $enkidatron$elm_cldr$Generated$Fr$fr_DJ;
var $enkidatron$elm_cldr$Generated$Fr$fr_DZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||DZ||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|DZD|DA|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_DZ = $enkidatron$elm_cldr$Generated$Fr$fr_DZ;
var $enkidatron$elm_cldr$Generated$Fr$fr_GA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||GA||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_GA = $enkidatron$elm_cldr$Generated$Fr$fr_GA;
var $enkidatron$elm_cldr$Generated$Fr$fr_GF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||GF||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_GF = $enkidatron$elm_cldr$Generated$Fr$fr_GF;
var $enkidatron$elm_cldr$Generated$Fr$fr_GN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||GN||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_GN = $enkidatron$elm_cldr$Generated$Fr$fr_GN;
var $enkidatron$elm_cldr$Generated$Fr$fr_GP = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||GP||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_GP = $enkidatron$elm_cldr$Generated$Fr$fr_GP;
var $enkidatron$elm_cldr$Generated$Fr$fr_GQ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||GQ||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_GQ = $enkidatron$elm_cldr$Generated$Fr$fr_GQ;
var $enkidatron$elm_cldr$Generated$Fr$fr_HT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||HT||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|de la nuit|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HTG|G|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_HT = $enkidatron$elm_cldr$Generated$Fr$fr_HT;
var $enkidatron$elm_cldr$Generated$Fr$fr_KM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||KM||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_KM = $enkidatron$elm_cldr$Generated$Fr$fr_KM;
var $enkidatron$elm_cldr$Generated$Fr$fr_LU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||LU||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|FRF|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LUF|F|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_LU = $enkidatron$elm_cldr$Generated$Fr$fr_LU;
var $enkidatron$elm_cldr$Generated$Fr$fr_MA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MA||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|a.m.|p.m.|8|afternoon1|de l’après-midi|am|a.m.|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|p.m.|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|jan.|fév.|mar.|avr.|mai|jui.|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MA = $enkidatron$elm_cldr$Generated$Fr$fr_MA;
var $enkidatron$elm_cldr$Generated$Fr$fr_MC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MC||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MC = $enkidatron$elm_cldr$Generated$Fr$fr_MC;
var $enkidatron$elm_cldr$Generated$Fr$fr_MF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MF||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MF = $enkidatron$elm_cldr$Generated$Fr$fr_MF;
var $enkidatron$elm_cldr$Generated$Fr$fr_MG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MG||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MG = $enkidatron$elm_cldr$Generated$Fr$fr_MG;
var $enkidatron$elm_cldr$Generated$Fr$fr_ML = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||ML||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_ML = $enkidatron$elm_cldr$Generated$Fr$fr_ML;
var $enkidatron$elm_cldr$Generated$Fr$fr_MQ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MQ||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MQ = $enkidatron$elm_cldr$Generated$Fr$fr_MQ;
var $enkidatron$elm_cldr$Generated$Fr$fr_MR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MR||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MRU|UM|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MR = $enkidatron$elm_cldr$Generated$Fr$fr_MR;
var $enkidatron$elm_cldr$Generated$Fr$fr_MU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||MU||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_MU = $enkidatron$elm_cldr$Generated$Fr$fr_MU;
var $enkidatron$elm_cldr$Generated$Fr$fr_NC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||NC||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_NC = $enkidatron$elm_cldr$Generated$Fr$fr_NC;
var $enkidatron$elm_cldr$Generated$Fr$fr_NE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||NE||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_NE = $enkidatron$elm_cldr$Generated$Fr$fr_NE;
var $enkidatron$elm_cldr$Generated$Fr$fr_PF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||PF||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_PF = $enkidatron$elm_cldr$Generated$Fr$fr_PF;
var $enkidatron$elm_cldr$Generated$Fr$fr_PM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||PM||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_PM = $enkidatron$elm_cldr$Generated$Fr$fr_PM;
var $enkidatron$elm_cldr$Generated$Fr$fr_RE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||RE||AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|min.|morning1|mat.|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_RE = $enkidatron$elm_cldr$Generated$Fr$fr_RE;
var $enkidatron$elm_cldr$Generated$Fr$fr_RW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||RW||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|RF|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_RW = $enkidatron$elm_cldr$Generated$Fr$fr_RW;
var $enkidatron$elm_cldr$Generated$Fr$fr_SC = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||SC||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SCR|SR|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_SC = $enkidatron$elm_cldr$Generated$Fr$fr_SC;
var $enkidatron$elm_cldr$Generated$Fr$fr_SN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||SN||AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|min.|morning1|mat.|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_SN = $enkidatron$elm_cldr$Generated$Fr$fr_SN;
var $enkidatron$elm_cldr$Generated$Fr$fr_SY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||SY||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|LS|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_SY = $enkidatron$elm_cldr$Generated$Fr$fr_SY;
var $enkidatron$elm_cldr$Generated$Fr$fr_TD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||TD||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_TD = $enkidatron$elm_cldr$Generated$Fr$fr_TD;
var $enkidatron$elm_cldr$Generated$Fr$fr_TG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||TG||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_TG = $enkidatron$elm_cldr$Generated$Fr$fr_TG;
var $enkidatron$elm_cldr$Generated$Fr$fr_TN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||TN||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TND|DT|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_TN = $enkidatron$elm_cldr$Generated$Fr$fr_TN;
var $enkidatron$elm_cldr$Generated$Fr$fr_VU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||VU||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|VUV|VT|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_VU = $enkidatron$elm_cldr$Generated$Fr$fr_VU;
var $enkidatron$elm_cldr$Generated$Fr$fr_WF = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||WF||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_WF = $enkidatron$elm_cldr$Generated$Fr$fr_WF;
var $enkidatron$elm_cldr$Generated$Fr$fr_YT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||YT||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \u0027h\u0027|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027semaine\u0027 W (MMMM)|MMMMW-count-other|\u0027semaine\u0027 W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027semaine\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semaine\u0027 w \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|115|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr_YT = $enkidatron$elm_cldr$Generated$Fr$fr_YT;
var $enkidatron$elm_cldr$Generated$Ga$ga_GB = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ga$dayPeriods, 'ga||GB||r.n.|i.n.|2|am|r.n.|pm|i.n.|r.n.|i.n.|2|am|r.n.|pm|i.n.|r.n.|i.n.|2|am|r.n.|pm|i.n.|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|Ean|Feabh|Márta|Aib|Beal|Meith|Iúil|Lún|MFómh|DFómh|Samh|Noll|Eanáir|Feabhra|Márta|Aibreán|Bealtaine|Meitheamh|Iúil|Lúnasa|Meán Fómhair|Deireadh Fómhair|Samhain|Nollaig|E|F|M|A|B|M|I|L|M|D|S|N|0|Domh|Luan|Máirt|Céad|Déar|Aoine|Sath|Dé Domhnaigh|Dé Luain|Dé Máirt|Dé Céadaoin|Déardaoin|Dé hAoine|Dé Sathairn|D|L|M|C|D|A|S|0|RC|AD|Roimh Chríost|Anno Domini|RC|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|LL|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-two|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-few|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-many|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|MMMMW-count-other|\u0027seachtain\u0027 \u0027a\u0027 W \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-two|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-few|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-many|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027seachtain\u0027 \u0027a\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ga_GB = $enkidatron$elm_cldr$Generated$Ga$ga_GB;
var $enkidatron$elm_cldr$Generated$Ha$ha_GH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ha$dayPeriods, 'ha||GH||SF|YM|2|am|SF|pm|YM|Safiya|Yamma|2|am|Safiya|pm|Yamma|SF|YM|2|am|SF|pm|YM|d/M/yy|d MMM, y|d MMMM, y|EEEE d MMMM, y|Jan|Fab|Mar|Afi|May|Yun|Yul|Agu|Sat|Okt|Nuw|Dis|Janairu|Faburairu|Maris|Afirilu|Mayu|Yuni|Yuli|Agusta|Satumba|Oktoba|Nuwamba|Disamba|J|F|M|A|M|Y|Y|A|S|O|N|D|0|Lah|Lit|Tal|Lar|Alh|Jum|Asa|Lahadi|Litinin|Talata|Laraba|Alhamis|Jummaʼa|Asabar|L|L|T|L|A|J|A|0|K.H|BHAI|Kafin haihuwar annab|Bayan haihuwar annab|K.H|BHAI|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027satin\u0027 W \u0027cikin\u0027 MMMM|MMMMW-count-other|\u0027satin\u0027 W \u0027cikin\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|y-MM-dd|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|y MMM d, E|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027sati\u0027 w \u0027cikin\u0027 Y|yw-count-other|\u0027sati\u0027 w \u0027cikin\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ha_GH = $enkidatron$elm_cldr$Generated$Ha$ha_GH;
var $enkidatron$elm_cldr$Generated$Ha$ha_NE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ha$dayPeriods, 'ha||NE||SF|YM|2|am|SF|pm|YM|Safiya|Yamma|2|am|Safiya|pm|Yamma|SF|YM|2|am|SF|pm|YM|d/M/yy|d MMM, y|d MMMM, y|EEEE d MMMM, y|Jan|Fab|Mar|Afi|May|Yun|Yul|Agu|Sat|Okt|Nuw|Dis|Janairu|Faburairu|Maris|Afirilu|Mayu|Yuni|Yuli|Agusta|Satumba|Oktoba|Nuwamba|Disamba|J|F|M|A|M|Y|Y|A|S|O|N|D|0|Lah|Lit|Tal|Lar|Alh|Jum|Asa|Lahadi|Litinin|Talata|Laraba|Alhamis|Jummaʼa|Asabar|L|L|T|L|A|J|A|0|K.H|BHAI|Kafin haihuwar annab|Bayan haihuwar annab|K.H|BHAI|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027satin\u0027 W \u0027cikin\u0027 MMMM|MMMMW-count-other|\u0027satin\u0027 W \u0027cikin\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|y-MM-dd|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|y MMM d, E|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027sati\u0027 w \u0027cikin\u0027 Y|yw-count-other|\u0027sati\u0027 w \u0027cikin\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ha_NE = $enkidatron$elm_cldr$Generated$Ha$ha_NE;
var $enkidatron$elm_cldr$Generated$Hr$hr_BA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hr$dayPeriods, 'hr||BA||AM|PM|8|afternoon1|popodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|poslije podne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|popodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|d. M. yy.|d. MMM y.|d. MMMM y.|EEEE, d. MMMM y.|sij|velj|ožu|tra|svi|lip|srp|kol|ruj|lis|stu|pro|siječnja|veljače|ožujka|travnja|svibnja|lipnja|srpnja|kolovoza|rujna|listopada|studenoga|prosinca|1.|2.|3.|4.|5.|6.|7.|8.|9.|10.|11.|12.|1|sij|velj|ožu|tra|svi|lip|srp|kol|ruj|lis|stu|pro|siječanj|veljača|ožujak|travanj|svibanj|lipanj|srpanj|kolovoz|rujan|listopad|studeni|prosinac|1.|2.|3.|4.|5.|6.|7.|8.|9.|10.|11.|12.|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|N|P|U|S|Č|P|S|0|pr. Kr.|po. Kr.|prije Krista|poslije Krista|pr.n.e.|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d. M. y. GGGGG|GyMMM|LLL y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|dd. MM.|MEd|E, dd. MM.|MMdd|dd. MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027tjedan\u0027 MMMM|MMMMW-count-few|W. \u0027tjedan\u0027 MMMM|MMMMW-count-other|W. \u0027tjedan\u0027 MMMM|ms|mm:ss|y|y.|yM|MM. y.|yMd|dd. MM. y.|yMEd|E, dd. MM. y.|yMM|MM. y.|yMMM|LLL y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|LLLL y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027tjedan\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027tjedan\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027tjedan\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hr_BA = $enkidatron$elm_cldr$Generated$Hr$hr_BA;
var $enkidatron$elm_cldr$Generated$It$it_CH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$It$dayPeriods, 'it||CH||AM|PM|8|afternoon1|di pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|AM|PM|8|afternoon1|del pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|m.|p.|8|afternoon1|di pomeriggio|am|m.|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|p.|dd.MM.yy|d MMM y|d MMMM y|EEEE, d MMMM y|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic|gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|G|F|M|A|M|G|L|A|S|O|N|D|0|dom|lun|mar|mer|gio|ven|sab|domenica|lunedì|martedì|mercoledì|giovedì|venerdì|sabato|D|L|M|M|G|V|S|0|a.C.|d.C.|avanti Cristo|dopo Cristo|aC|dC|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027settimana\u0027 W \u0027di\u0027 MMMM|MMMMW-count-other|\u0027settimana\u0027 W \u0027di\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027settimana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027settimana\u0027 w \u0027del\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W’|.|-||||||E2W’|.|¤-||¤\u00A0||¤\u00A0||E0W’|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|NKr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$it_CH = $enkidatron$elm_cldr$Generated$It$it_CH;
var $enkidatron$elm_cldr$Generated$It$it_SM = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$It$dayPeriods, 'it||SM||AM|PM|8|afternoon1|di pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|AM|PM|8|afternoon1|del pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|m.|p.|8|afternoon1|di pomeriggio|am|m.|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|p.|dd/MM/yy|d MMM y|d MMMM y|EEEE d MMMM y|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic|gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|G|F|M|A|M|G|L|A|S|O|N|D|0|dom|lun|mar|mer|gio|ven|sab|domenica|lunedì|martedì|mercoledì|giovedì|venerdì|sabato|D|L|M|M|G|V|S|0|a.C.|d.C.|avanti Cristo|dopo Cristo|aC|dC|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027settimana\u0027 W \u0027di\u0027 MMMM|MMMMW-count-other|\u0027settimana\u0027 W \u0027di\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027settimana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027settimana\u0027 w \u0027del\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|NKr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$it_SM = $enkidatron$elm_cldr$Generated$It$it_SM;
var $enkidatron$elm_cldr$Generated$It$it_VA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$It$dayPeriods, 'it||VA||AM|PM|8|afternoon1|di pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|AM|PM|8|afternoon1|del pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|m.|p.|8|afternoon1|di pomeriggio|am|m.|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|p.|dd/MM/yy|d MMM y|d MMMM y|EEEE d MMMM y|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic|gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|G|F|M|A|M|G|L|A|S|O|N|D|0|dom|lun|mar|mer|gio|ven|sab|domenica|lunedì|martedì|mercoledì|giovedì|venerdì|sabato|D|L|M|M|G|V|S|0|a.C.|d.C.|avanti Cristo|dopo Cristo|aC|dC|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027settimana\u0027 W \u0027di\u0027 MMMM|MMMMW-count-other|\u0027settimana\u0027 W \u0027di\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027settimana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027settimana\u0027 w \u0027del\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|NKr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$it_VA = $enkidatron$elm_cldr$Generated$It$it_VA;
var $enkidatron$elm_cldr$Generated$Ko$ko_CN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ko$dayPeriods, 'ko||CN||AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|PM|오전|오후|9|afternoon1|오후|am|오전|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|오후|AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|PM|yy. M. d.|y. M. d.|y년 MMMM d일|y년 MMMM d일 EEEE|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|0|일|월|화|수|목|금|토|일요일|월요일|화요일|수요일|목요일|금요일|토요일|일|월|화|수|목|금|토|0|BC|AD|기원전|서기|BC|AD|HH:mm|HH:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|B h시|Bhm|B h:mm|Bhms|B h:mm:ss|d|d일|E|ccc|EBhm|(E) B h:mm|EBhms|(E) B h:mm:ss|Ed|d일 (E)|EEEEd|d일 EEEE|Ehm|(E) a h:mm|EHm|(E) HH:mm|Ehms|(E) a h:mm:ss|EHms|(E) HH:mm:ss|Gy|G y년|GyMd|GGGGG y/M/d|GyMMM|G y년 MMM|GyMMMd|G y년 MMM d일|GyMMMEd|G y년 MMM d일 (E)|GyMMMEEEEd|G y년 MMM d일 EEEE|h|a h시|H|H시|HHmmss|HH:mm:ss|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|H시 m분 s초|hmsv|a h:mm:ss v|Hmsv|H시 m분 s초 v|hmv|a h:mm v|Hmv|HH:mm v|M|M월|Md|M. d.|MEd|M. d. (E)|MEEEEd|M. d. EEEE|MMM|LLL|MMMd|MMM d일|MMMEd|MMM d일 (E)|MMMEEEEd|MMM d일 EEEE|MMMMd|MMMM d일|MMMMW-count-other|MMMM W번째 주|mmss|mm:ss|ms|mm:ss|y|y년|yM|y. M.|yMd|y. M. d.|yMEd|y. M. d. (E)|yMEEEEd|y. M. d. EEEE|yMM|y. M.|yMMM|y년 MMM|yMMMd|y년 MMM d일|yMMMEd|y년 MMM d일 (E)|yMMMEEEEd|y년 MMM d일 EEEE|yMMMM|y년 MMMM|yQQQ|y년 QQQ|yQQQQ|y년 QQQQ|yw-count-other|Y년 w번째 주|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ko_CN = $enkidatron$elm_cldr$Generated$Ko$ko_CN;
var $enkidatron$elm_cldr$Generated$Ko$ko_KP = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ko$dayPeriods, 'ko||KP||AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|PM|오전|오후|9|afternoon1|오후|am|오전|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|오후|AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|새벽|morning2|오전|night1|밤|noon|정오|pm|PM|yy. M. d.|y. M. d.|y년 MMMM d일|y년 MMMM d일 EEEE|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|0|일|월|화|수|목|금|토|일요일|월요일|화요일|수요일|목요일|금요일|토요일|일|월|화|수|목|금|토|0|BC|AD|기원전|서기|BC|AD|a h:mm|a h:mm:ss|a h시 m분 s초 z|a h시 m분 s초 zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|B h시|Bhm|B h:mm|Bhms|B h:mm:ss|d|d일|E|ccc|EBhm|(E) B h:mm|EBhms|(E) B h:mm:ss|Ed|d일 (E)|EEEEd|d일 EEEE|Ehm|(E) a h:mm|EHm|(E) HH:mm|Ehms|(E) a h:mm:ss|EHms|(E) HH:mm:ss|Gy|G y년|GyMd|GGGGG y/M/d|GyMMM|G y년 MMM|GyMMMd|G y년 MMM d일|GyMMMEd|G y년 MMM d일 (E)|GyMMMEEEEd|G y년 MMM d일 EEEE|h|a h시|H|H시|HHmmss|HH:mm:ss|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|H시 m분 s초|hmsv|a h:mm:ss v|Hmsv|H시 m분 s초 v|hmv|a h:mm v|Hmv|HH:mm v|M|M월|Md|M. d.|MEd|M. d. (E)|MEEEEd|M. d. EEEE|MMM|LLL|MMMd|MMM d일|MMMEd|MMM d일 (E)|MMMEEEEd|MMM d일 EEEE|MMMMd|MMMM d일|MMMMW-count-other|MMMM W번째 주|mmss|mm:ss|ms|mm:ss|y|y년|yM|y. M.|yMd|y. M. d.|yMEd|y. M. d. (E)|yMEEEEd|y. M. d. EEEE|yMM|y. M.|yMMM|y년 MMM|yMMMd|y년 MMM d일|yMMMEd|y년 MMM d일 (E)|yMMMEEEEd|y년 MMM d일 EEEE|yMMMM|y년 MMMM|yQQQ|y년 QQQ|yQQQQ|y년 QQQQ|yw-count-other|Y년 w번째 주|ahmm|ahmmss|ahmsz|ahmszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ko_KP = $enkidatron$elm_cldr$Generated$Ko$ko_KP;
var $enkidatron$elm_cldr$Generated$Ms$ms_BN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ms$dayPeriods, 'ms||BN||PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|PTG|PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|tengah malam|morning2|pagi|night1|malam|pm|PTG|a|p|7|afternoon1|tengah hari|am|a|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|p|d/MM/yy|d MMM y|d MMMM y|dd MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ogo|Sep|Okt|Nov|Dis|Januari|Februari|Mac|April|Mei|Jun|Julai|Ogos|September|Oktober|November|Disember|J|F|M|A|M|J|J|O|S|O|N|D|0|Ahd|Isn|Sel|Rab|Kha|Jum|Sab|Ahad|Isnin|Selasa|Rabu|Khamis|Jumaat|Sabtu|A|I|S|R|K|J|S|0|S.M.|TM|S.M.|TM|S.M.|TM|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E, d-M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ms_BN = $enkidatron$elm_cldr$Generated$Ms$ms_BN;
var $enkidatron$elm_cldr$Generated$Ms$ms_ID = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ms$dayPeriods, 'ms||ID||PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|PTG|PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|tengah malam|morning2|pagi|night1|malam|pm|PTG|a|p|7|afternoon1|tengah hari|am|a|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|p|dd/MM/yy|d MMM y|d MMMM y|EEEE, dd MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ogo|Sep|Okt|Nov|Dis|Januari|Februari|Mac|April|Mei|Jun|Julai|Ogos|September|Oktober|November|Disember|J|F|M|A|M|J|J|O|S|O|N|D|0|Ahd|Isn|Sel|Rab|Kha|Jum|Sab|Ahad|Isnin|Selasa|Rabu|Khamis|Jumaat|Sabtu|A|I|S|R|K|J|S|0|S.M.|TM|S.M.|TM|S.M.|TM|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|d E|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss. a v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|L|Md|d-M|MEd|E, d-M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ms_ID = $enkidatron$elm_cldr$Generated$Ms$ms_ID;
var $enkidatron$elm_cldr$Generated$Ms$ms_SG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ms$dayPeriods, 'ms||SG||PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|PTG|PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|tengah malam|morning2|pagi|night1|malam|pm|PTG|a|p|7|afternoon1|tengah hari|am|a|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|p|d/MM/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ogo|Sep|Okt|Nov|Dis|Januari|Februari|Mac|April|Mei|Jun|Julai|Ogos|September|Oktober|November|Disember|J|F|M|A|M|J|J|O|S|O|N|D|0|Ahd|Isn|Sel|Rab|Kha|Jum|Sab|Ahad|Isnin|Selasa|Rabu|Khamis|Jumaat|Sabtu|A|I|S|R|K|J|S|0|S.M.|TM|S.M.|TM|S.M.|TM|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E, d-M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ms_SG = $enkidatron$elm_cldr$Generated$Ms$ms_SG;
var $enkidatron$elm_cldr$Generated$Nb$nb_SJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nb$dayPeriods, 'nb||SJ||a.m.|p.m.|8|afternoon1|etterm.|am|a.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|p.m.|a.m.|p.m.|8|afternoon1|på ettermiddagen|am|a.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgenen|morning2|på formiddagen|night1|på natten|pm|p.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|søn.|man.|tir.|ons.|tor.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E \u0027kl\u0027. HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E \u0027kl\u0027. HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\u0027den\u0027 W. \u0027uken\u0027 \u0027i\u0027 MMMM|MMMMW-count-other|\u0027den\u0027 W. \u0027uken\u0027 \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027uke\u0027 w \u0027i\u0027 Y|yw-count-other|\u0027uke\u0027 w \u0027i\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nb_SJ = $enkidatron$elm_cldr$Generated$Nb$nb_SJ;
var $enkidatron$elm_cldr$Generated$Ne$ne_IN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ne$dayPeriods, 'ne||IN||पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|yy/M/d|y MMM d|y MMMM d|y MMMM d, EEEE|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जन|फेब|मार्च|अप्र|मे|जुन|जुल|अग|सेप|अक्टो|नोभे|डिसे|1|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जन|फेेब|मार्च|अप्र|मे|जुन|जुल|अग|सेप|अक्टो|नोभे|डिसे|आइत|सोम|मङ्गल|बुध|बिहि|शुक्र|शनि|आइतबार|सोमबार|मङ्गलबार|बुधबार|बिहिबार|शुक्रबार|शनिबार|आ|सो|म|बु|बि|शु|श|0|ईसा पूर्व|सन्|ईसा पूर्व|सन्|ईसा पूर्व|सन्|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-one|MMMM को W हप्ता|MMMMW-count-other|MMMM को W हप्ता|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y को w हप्ता|yw-count-other|Y को w हप्ता|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|नेरू|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ne_IN = $enkidatron$elm_cldr$Generated$Ne$ne_IN;
var $enkidatron$elm_cldr$Generated$Nl$nl_AW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||AW||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AWG|Afl.|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl_AW = $enkidatron$elm_cldr$Generated$Nl$nl_AW;
var $enkidatron$elm_cldr$Generated$Nl$nl_BE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||BE||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|d/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl_BE = $enkidatron$elm_cldr$Generated$Nl$nl_BE;
var $enkidatron$elm_cldr$Generated$Nl$nl_BQ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||BQ||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl_BQ = $enkidatron$elm_cldr$Generated$Nl$nl_BQ;
var $enkidatron$elm_cldr$Generated$Nl$nl_CW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||CW||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|ANG|NAf.|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl_CW = $enkidatron$elm_cldr$Generated$Nl$nl_CW;
var $enkidatron$elm_cldr$Generated$Nl$nl_SR = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||SR||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl_SR = $enkidatron$elm_cldr$Generated$Nl$nl_SR;
var $enkidatron$elm_cldr$Generated$Nl$nl_SX = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||SX||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027van\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027van\u0027 MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027in\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027in\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|ANG|NAf.|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl_SX = $enkidatron$elm_cldr$Generated$Nl$nl_SX;
var $enkidatron$elm_cldr$Generated$Ps$ps_PK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ps$dayPeriods, 'ps||PK||AM|PM|2|am|AM|pm|PM|غ.م.|غ.و.|2|am|غ.م.|pm|غ.و.|غ.م.|غ.و.|2|am|غ.م.|pm|غ.و.|y/M/d|y MMM d|y MMMM d|EEEE د y د MMMM d|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سېپتمبر|اکتوبر|نومبر|دسمبر|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سېپتمبر|اکتوبر|نومبر|دسمبر|ج|ف|م|ا|م|ج|ج|ا|س|ا|ن|د|1|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|اکتوبر|نومبر|دسمبر|جنوري|فېبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|اکتوبر|نومبر|دسمبر|1|2|3|4|5|6|7|8|9|10|11|12|يونۍ|دونۍ|درېنۍ|څلرنۍ|پينځنۍ|جمعه|اونۍ|يونۍ|دونۍ|درېنۍ|څلرنۍ|پينځنۍ|جمعه|اونۍ|S|M|T|W|T|F|S|0|له میلاد وړاندې|م.|له میلاد څخه وړاندې|له میلاد څخه وروسته|له میلاد وړاندې|م.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|اونۍ W د MMMM|MMMMW-count-other|اونۍ W د MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|اونۍ w د Y|yw-count-other|اونۍ w د Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|\u200E−||||||E2W.|,|\u200E−¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|\u200E−|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ps_PK = $enkidatron$elm_cldr$Generated$Ps$ps_PK;
var $enkidatron$elm_cldr$Generated$Pt$pt_AO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||AO||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_AO = $enkidatron$elm_cldr$Generated$Pt$pt_AO;
var $enkidatron$elm_cldr$Generated$Pt$pt_CH = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||CH||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_CH = $enkidatron$elm_cldr$Generated$Pt$pt_CH;
var $enkidatron$elm_cldr$Generated$Pt$pt_CV = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||CV||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CVE|\u200B|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|PTE|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_CV = $enkidatron$elm_cldr$Generated$Pt$pt_CV;
var $enkidatron$elm_cldr$Generated$Pt$pt_GQ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||GQ||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_GQ = $enkidatron$elm_cldr$Generated$Pt$pt_GQ;
var $enkidatron$elm_cldr$Generated$Pt$pt_GW = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||GW||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_GW = $enkidatron$elm_cldr$Generated$Pt$pt_GW;
var $enkidatron$elm_cldr$Generated$Pt$pt_LU = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||LU||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LUF|F|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_LU = $enkidatron$elm_cldr$Generated$Pt$pt_LU;
var $enkidatron$elm_cldr$Generated$Pt$pt_MO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||MO||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MOP|MOP$|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_MO = $enkidatron$elm_cldr$Generated$Pt$pt_MO;
var $enkidatron$elm_cldr$Generated$Pt$pt_MZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||MZ||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|MZN|MTn|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_MZ = $enkidatron$elm_cldr$Generated$Pt$pt_MZ;
var $enkidatron$elm_cldr$Generated$Pt$pt_PT = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||PT||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_PT = $enkidatron$elm_cldr$Generated$Pt$pt_PT;
var $enkidatron$elm_cldr$Generated$Pt$pt_ST = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||ST||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_ST = $enkidatron$elm_cldr$Generated$Pt$pt_ST;
var $enkidatron$elm_cldr$Generated$Pt$pt_TL = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||TL||a.m.|p.m.|8|afternoon1|da tarde|am|a.m.|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|p.m.|da manhã|da tarde|8|afternoon1|da tarde|am|da manhã|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|da tarde|a.m.|p.m.|8|afternoon1|tarde|am|a.m.|evening1|noite|midnight|meia-noite|morning1|manhã|night1|madrugada|noon|meio-dia|pm|p.m.|dd/MM/yy|dd/MM/y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|domingo|segunda|terça|quarta|quinta|sexta|sábado|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \u0027de\u0027 y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d \u0027de\u0027 MMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d/MM|MMMEd|E, d/MM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|ccc, d \u0027de\u0027 MMMM|MMMMW-count-one|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|MMMMW-count-other|W.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MM/y|yMMMd|d/MM/y|yMMMEd|E, d/MM/y|yMMMEEEEd|EEEE, d/MM/y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|ccc, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|yw-count-other|w.\u0027ª\u0027 \u0027semana\u0027 \u0027de\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|\u200B|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt_TL = $enkidatron$elm_cldr$Generated$Pt$pt_TL;
var $enkidatron$elm_cldr$Generated$Ro$ro_MD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ro$dayPeriods, 'ro||MD||a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|miezul nopții|morning1|dimineața|night1|noaptea|noon|amiază|pm|p.m.|a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|miezul nopții|morning1|dimineața|night1|noaptea|noon|amiază|pm|p.m.|a.m.|p.m.|8|afternoon1|după-amiază|am|a.m.|evening1|seară|midnight|miezul nopții|morning1|dimineață|night1|noapte|noon|amiază|pm|p.m.|dd.MM.y|d MMM y|d MMMM y|EEEE, d MMMM y|ian.|feb.|mar.|apr.|mai|iun.|iul.|aug.|sept.|oct.|nov.|dec.|ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie|I|F|M|A|M|I|I|A|S|O|N|D|0|Dum|Lun|Mar|Mie|Joi|Vin|Sâm|duminică|luni|marți|miercuri|joi|vineri|sâmbătă|D|L|Ma|Mi|J|V|S|0|î.Hr.|d.Hr.|înainte de Hristos|după Hristos|î.Hr.|d.Hr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027săptămâna\u0027 W \u0027din\u0027 MMMM|MMMMW-count-few|\u0027săptămâna\u0027 W \u0027din\u0027 MMMM|MMMMW-count-other|\u0027săptămâna\u0027 W \u0027din\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMM|MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027săptămâna\u0027 w \u0027din\u0027 Y|yw-count-few|\u0027săptămâna\u0027 w \u0027din\u0027 Y|yw-count-other|\u0027săptămâna\u0027 w \u0027din\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MDL|L|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ro_MD = $enkidatron$elm_cldr$Generated$Ro$ro_MD;
var $enkidatron$elm_cldr$Generated$Ru$ru_BY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||BY||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-few|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-many|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-other|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, dd.MM.y\u202F\u0027г\u0027.|yMM|MM.y|yMMM|LLL y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|LLLL y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-few|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-many|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-other|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|RUR|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru_BY = $enkidatron$elm_cldr$Generated$Ru$ru_BY;
var $enkidatron$elm_cldr$Generated$Ru$ru_KG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||KG||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-few|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-many|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-other|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, dd.MM.y\u202F\u0027г\u0027.|yMM|MM.y|yMMM|LLL y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|LLLL y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-few|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-many|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-other|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|сом|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru_KG = $enkidatron$elm_cldr$Generated$Ru$ru_KG;
var $enkidatron$elm_cldr$Generated$Ru$ru_KZ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||KZ||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-few|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-many|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-other|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, dd.MM.y\u202F\u0027г\u0027.|yMM|MM.y|yMMM|LLL y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|LLLL y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-few|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-many|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-other|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru_KZ = $enkidatron$elm_cldr$Generated$Ru$ru_KZ;
var $enkidatron$elm_cldr$Generated$Ru$ru_MD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||MD||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-few|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-many|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-other|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, dd.MM.y\u202F\u0027г\u0027.|yMM|MM.y|yMMM|LLL y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|LLLL y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-few|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-many|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-other|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MDL|L|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru_MD = $enkidatron$elm_cldr$Generated$Ru$ru_MD;
var $enkidatron$elm_cldr$Generated$Ru$ru_UA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||UA||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-few|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-many|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|MMMMW-count-other|W-\u0027я\u0027 \u0027неделя\u0027 MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, d.MM.y|yMM|MM.y|yMMM|LLL y\u202F\u0027г\u0027.|yMMMd|d MMM y\u202F\u0027г\u0027.|yMMMEd|E, d MMM y\u202F\u0027г\u0027.|yMMMM|LLLL y\u202F\u0027г\u0027.|yQQQ|QQQ y\u202F\u0027г\u0027.|yQQQQ|QQQQ y\u202F\u0027г\u0027.|yw-count-one|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-few|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-many|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|yw-count-other|w-\u0027я\u0027 \u0027неделя\u0027 Y \u0027г\u0027.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru_UA = $enkidatron$elm_cldr$Generated$Ru$ru_UA;
var $enkidatron$elm_cldr$Generated$So$so_DJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$So$dayPeriods, 'so||DJ||GH|GD|2|am|GH|pm|GD|GH|GD|2|am|GH|pm|GD|h|d|2|am|h|pm|d|dd/MM/yy|dd-MMM-y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Bisha Koobaad|Bisha Labaad|Bisha Saddexaad|Bisha Afraad|Bisha Shanaad|Bisha Lixaad|Bisha Todobaad|Bisha Sideedaad|Bisha Sagaalaad|Bisha Tobnaad|Bisha Kow iyo Tobnaad|Bisha Laba iyo Tobnaad|J|F|M|A|M|J|L|O|S|O|N|D|1|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Jannaayo|Febraayo|Maarso|Abriil|May|Juun|Luuliyo|Ogosto|Sebteembar|Oktoobar|Noofeembar|Diseembar|J|F|M|A|M|J|L|O|S|O|N|D|Axd|Isn|Tldo|Arbc|Khms|Jmc|Sbti|Axad|Isniin|Talaado|Arbaco|Khamiis|Jimco|Sabti|A|I|T|A|Kh|J|S|0|BC|AD|Ciise Hortii|Ciise Dabadii|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|MMMMW-count-other|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|yw-count-other|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|DBB|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DJF|Fdj|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SOS|S|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$so_DJ = $enkidatron$elm_cldr$Generated$So$so_DJ;
var $enkidatron$elm_cldr$Generated$So$so_ET = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$So$dayPeriods, 'so||ET||GH|GD|2|am|GH|pm|GD|GH|GD|2|am|GH|pm|GD|h|d|2|am|h|pm|d|dd/MM/yy|dd-MMM-y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Bisha Koobaad|Bisha Labaad|Bisha Saddexaad|Bisha Afraad|Bisha Shanaad|Bisha Lixaad|Bisha Todobaad|Bisha Sideedaad|Bisha Sagaalaad|Bisha Tobnaad|Bisha Kow iyo Tobnaad|Bisha Laba iyo Tobnaad|J|F|M|A|M|J|L|O|S|O|N|D|1|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Jannaayo|Febraayo|Maarso|Abriil|May|Juun|Luuliyo|Ogosto|Sebteembar|Oktoobar|Noofeembar|Diseembar|J|F|M|A|M|J|L|O|S|O|N|D|Axd|Isn|Tldo|Arbc|Khms|Jmc|Sbti|Axad|Isniin|Talaado|Arbaco|Khamiis|Jimco|Sabti|A|I|T|A|Kh|J|S|0|BC|AD|Ciise Hortii|Ciise Dabadii|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|MMMMW-count-other|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|yw-count-other|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|DBB|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|ETB|Br|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SOS|S|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$so_ET = $enkidatron$elm_cldr$Generated$So$so_ET;
var $enkidatron$elm_cldr$Generated$So$so_KE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$So$dayPeriods, 'so||KE||GH|GD|2|am|GH|pm|GD|GH|GD|2|am|GH|pm|GD|h|d|2|am|h|pm|d|dd/MM/yy|dd-MMM-y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Bisha Koobaad|Bisha Labaad|Bisha Saddexaad|Bisha Afraad|Bisha Shanaad|Bisha Lixaad|Bisha Todobaad|Bisha Sideedaad|Bisha Sagaalaad|Bisha Tobnaad|Bisha Kow iyo Tobnaad|Bisha Laba iyo Tobnaad|J|F|M|A|M|J|L|O|S|O|N|D|1|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Jannaayo|Febraayo|Maarso|Abriil|May|Juun|Luuliyo|Ogosto|Sebteembar|Oktoobar|Noofeembar|Diseembar|J|F|M|A|M|J|L|O|S|O|N|D|Axd|Isn|Tldo|Arbc|Khms|Jmc|Sbti|Axad|Isniin|Talaado|Arbaco|Khamiis|Jimco|Sabti|A|I|T|A|Kh|J|S|0|BC|AD|Ciise Hortii|Ciise Dabadii|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|MMMMW-count-other|\u0027toddobaadka\u0027 W \u0027ee\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|yw-count-other|\u0027toddobaadka\u0027 w \u0027ee\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|DBB|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SOS|S|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$so_KE = $enkidatron$elm_cldr$Generated$So$so_KE;
var $enkidatron$elm_cldr$Generated$Sq$sq_MK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sq$dayPeriods, 'sq||MK||p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|e paradites|e pasdites|9|afternoon1|e pasdites|am|e paradites|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|e pasdites|p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|d.M.yy|d MMM y|d MMMM y|EEEE, d MMMM y|jan|shk|mar|pri|maj|qer|korr|gush|sht|tet|nën|dhj|janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor|j|sh|m|p|m|q|k|g|sh|t|n|dh|0|die|hën|mar|mër|enj|pre|sht|e diel|e hënë|e martë|e mërkurë|e enjte|e premte|e shtunë|d|h|m|m|e|p|sh|0|p.K.|mb.K.|para Krishtit|mbas Krishtit|p.K.|mb.K.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa, v|Hmsv|HH:mm:ss, v|hmv|h:mm\u202Fa, v|Hmv|HH:mm, v|M|L|Md|d.M|MEd|E, d.M|MMdd|d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027java\u0027 W \u0027e\u0027 MMMM|MMMMW-count-other|\u0027java\u0027 W \u0027e\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ, y|yQQQQ|QQQQ, y|yw-count-one|\u0027java\u0027 w \u0027e\u0027 Y|yw-count-other|\u0027java\u0027 w \u0027e\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|AFN|ALL|Lekë|AMD|AMD|AOA|AOA|ARS|ARS|AUD|A$|AZN|AZN|BAM|BAM|BBD|BBD|BDT|BDT|BMD|BMD|BND|BND|BOB|BOB|BRL|BRL|BSD|BSD|BWP|BWP|BZD|BZD|CAD|CA$|CLP|CLP|CNY|CN¥|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CZK|CZK|DKK|DKK|DOP|DOP|EGP|EGP|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HK$|HNL|HNL|HRK|HRK|HUF|HUF|IDR|IDR|ILS|₪|INR|₹|ISK|ISK|JMD|JMD|JPY|JP¥|KGS|\u20C0|KHR|KHR|KMF|KMF|KPW|KPW|KRW|₩|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LTL|Lt|LVL|Ls|MGA|MGA|MKD|den|MMK|MMK|MNT|MNT|MUR|MUR|MXN|MX$|MYR|MYR|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZ$|PHP|PHP|PKR|PKR|PLN|PLN|PYG|PYG|RON|RON|RUB|RUB|RWF|RWF|SBD|SBD|SEK|SEK|SGD|SGD|SHP|SHP|SRD|SRD|SSP|SSP|STN|STN|SYP|SYP|THB|฿|TOP|TOP|TRY|TRY|TTD|TTD|TWD|NT$|UAH|UAH|USD|US$|UYU|UYU|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$sq_MK = $enkidatron$elm_cldr$Generated$Sq$sq_MK;
var $enkidatron$elm_cldr$Generated$Sq$sq_XK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sq$dayPeriods, 'sq||XK||p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|e paradites|e pasdites|9|afternoon1|e pasdites|am|e paradites|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|e pasdites|p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|d.M.yy|d MMM y|d MMMM y|EEEE, d MMMM y|jan|shk|mar|pri|maj|qer|korr|gush|sht|tet|nën|dhj|janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor|j|sh|m|p|m|q|k|g|sh|t|n|dh|0|die|hën|mar|mër|enj|pre|sht|e diel|e hënë|e martë|e mërkurë|e enjte|e premte|e shtunë|d|h|m|m|e|p|sh|0|p.K.|mb.K.|para Krishtit|mbas Krishtit|p.K.|mb.K.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa, v|Hmsv|HH:mm:ss, v|hmv|h:mm\u202Fa, v|Hmv|HH:mm, v|M|L|Md|d.M|MEd|E, d.M|MMdd|d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027java\u0027 W \u0027e\u0027 MMMM|MMMMW-count-other|\u0027java\u0027 W \u0027e\u0027 MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ, y|yQQQQ|QQQQ, y|yw-count-one|\u0027java\u0027 w \u0027e\u0027 Y|yw-count-other|\u0027java\u0027 w \u0027e\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|AFN|ALL|Lekë|AMD|AMD|AOA|AOA|ARS|ARS|AUD|A$|AZN|AZN|BAM|BAM|BBD|BBD|BDT|BDT|BMD|BMD|BND|BND|BOB|BOB|BRL|BRL|BSD|BSD|BWP|BWP|BZD|BZD|CAD|CA$|CLP|CLP|CNY|CN¥|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CZK|CZK|DKK|DKK|DOP|DOP|EGP|EGP|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HK$|HNL|HNL|HRK|HRK|HUF|HUF|IDR|IDR|ILS|₪|INR|₹|ISK|ISK|JMD|JMD|JPY|JP¥|KGS|\u20C0|KHR|KHR|KMF|KMF|KPW|KPW|KRW|₩|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LTL|Lt|LVL|Ls|MGA|MGA|MMK|MMK|MNT|MNT|MUR|MUR|MXN|MX$|MYR|MYR|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZ$|PHP|PHP|PKR|PKR|PLN|PLN|PYG|PYG|RON|RON|RUB|RUB|RWF|RWF|SBD|SBD|SEK|SEK|SGD|SGD|SHP|SHP|SRD|SRD|SSP|SSP|STN|STN|SYP|SYP|THB|฿|TOP|TOP|TRY|TRY|TTD|TTD|TWD|NT$|UAH|UAH|USD|US$|UYU|UYU|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$sq_XK = $enkidatron$elm_cldr$Generated$Sq$sq_XK;
var $enkidatron$elm_cldr$Generated$Sv$sv_AX = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sv$dayPeriods, 'sv||AX||fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|fm|em|8|afternoon1|på eftermiddagen|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morgonen|morning2|på förmiddagen|night1|på natten|pm|em|fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midn.|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|y-MM-dd|d MMM y|d MMMM y|EEEE d MMMM y|jan.|feb.|mars|apr.|maj|juni|juli|aug.|sep.|okt.|nov.|dec.|januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|sön|mån|tis|ons|tors|fre|lör|söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|före Kristus|efter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|y-MM-dd GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMd|d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\u0027vecka\u0027 W \u0027i\u0027 MMMM|MMMMW-count-other|\u0027vecka\u0027 W \u0027i\u0027 MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|E, y-MM-dd|yMM|y-MM|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027vecka\u0027 w, Y|yw-count-other|\u0027vecka\u0027 w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BM$|BND|$|BOB|Bs|BRL|BR$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|Dkr|DOP|RD$|EEK|Ekr|EGP|EG£|ESP|ESP|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|IE£|ILS|₪|INR|INR|ISK|Ikr|JMD|JM$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|Nkr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sv_AX = $enkidatron$elm_cldr$Generated$Sv$sv_AX;
var $enkidatron$elm_cldr$Generated$Sv$sv_FI = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sv$dayPeriods, 'sv||FI||fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|fm|em|8|afternoon1|på eftermiddagen|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morgonen|morning2|på förmiddagen|night1|på natten|pm|em|fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midn.|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|y-MM-dd|d MMM y|d MMMM y|EEEE d MMMM y|jan.|feb.|mars|apr.|maj|juni|juli|aug.|sep.|okt.|nov.|dec.|januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|sön|mån|tis|ons|tors|fre|lör|söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|före Kristus|efter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E d|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|y-MM-dd GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss\u202Fa v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|L|Md|d.M|MEd|E d.M|MMd|d.M|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\u0027vecka\u0027 W \u0027i\u0027 MMMM|MMMMW-count-other|\u0027vecka\u0027 W \u0027i\u0027 MMMM|ms|mm.ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|E, y-MM-dd|yMM|y-MM|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027vecka\u0027 w, Y|yw-count-other|\u0027vecka\u0027 w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BM$|BND|$|BOB|Bs|BRL|BR$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|Dkr|DOP|RD$|EEK|Ekr|EGP|EG£|ESP|ESP|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|IE£|ILS|₪|INR|INR|ISK|Ikr|JMD|JM$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|Nkr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sv_FI = $enkidatron$elm_cldr$Generated$Sv$sv_FI;
var $enkidatron$elm_cldr$Generated$Sw$sw_CD = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sw$dayPeriods, 'sw||CD||AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|adhuhuri|pm|PM|AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|saa sita za mchana|pm|PM|am|pm|9|afternoon1|mchana|am|am|evening1|jioni|midnight|usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|mchana|pm|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ago|Sep|Okt|Nov|Des|Januari|Februari|Machi|Aprili|Mei|Juni|Julai|Agosti|Septemba|Oktoba|Novemba|Desemba|J|F|M|A|M|J|J|A|S|O|N|D|0|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|S|M|T|W|T|F|S|0|KK|BK|Kabla ya Kristo|Baada ya Kristo|KK|BK|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|MMMMW-count-other|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|QQQQ y|yw-count-one|\u0027wiki\u0027 w \u0027ya\u0027 Y|yw-count-other|\u0027wiki\u0027 w \u0027ya\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CDF|FC|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|TZS|TSh|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sw_CD = $enkidatron$elm_cldr$Generated$Sw$sw_CD;
var $enkidatron$elm_cldr$Generated$Sw$sw_KE = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sw$dayPeriods, 'sw||KE||AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|adhuhuri|pm|PM|AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|saa sita za mchana|pm|PM|am|pm|9|afternoon1|mchana|am|am|evening1|jioni|midnight|usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|mchana|pm|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ago|Sep|Okt|Nov|Des|Januari|Februari|Machi|Aprili|Mei|Juni|Julai|Agosti|Septemba|Oktoba|Novemba|Desemba|J|F|M|A|M|J|J|A|S|O|N|D|0|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|S|M|T|W|T|F|S|0|KK|BK|Kabla ya Kristo|Baada ya Kristo|KK|BK|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|MMMMW-count-other|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|QQQQ y|yw-count-one|\u0027wiki\u0027 w \u0027ya\u0027 Y|yw-count-other|\u0027wiki\u0027 w \u0027ya\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|TZS|TSh|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sw_KE = $enkidatron$elm_cldr$Generated$Sw$sw_KE;
var $enkidatron$elm_cldr$Generated$Sw$sw_UG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sw$dayPeriods, 'sw||UG||AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|adhuhuri|pm|PM|AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|saa sita za mchana|pm|PM|am|pm|9|afternoon1|mchana|am|am|evening1|jioni|midnight|usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|mchana|pm|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ago|Sep|Okt|Nov|Des|Januari|Februari|Machi|Aprili|Mei|Juni|Julai|Agosti|Septemba|Oktoba|Novemba|Desemba|J|F|M|A|M|J|J|A|S|O|N|D|0|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|S|M|T|W|T|F|S|0|KK|BK|Kabla ya Kristo|Baada ya Kristo|KK|BK|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|MMMMW-count-other|\u0027wiki\u0027 W \u0027ya\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|QQQQ y|yw-count-one|\u0027wiki\u0027 w \u0027ya\u0027 Y|yw-count-other|\u0027wiki\u0027 w \u0027ya\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|TZS|TSh|UAH|₴|UGX|USh|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sw_UG = $enkidatron$elm_cldr$Generated$Sw$sw_UG;
var $enkidatron$elm_cldr$Generated$Ta$ta_LK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ta$dayPeriods, 'ta||LK||AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|மு.ப|பி.ப|11|afternoon1|மதி.|afternoon2|பிற்.|am|மு.ப|evening1|மா.|evening2|அந்தி மா.|midnight|நள்.|morning1|அதி.|morning2|கா.|night1|இர.|noon|நண்.|pm|பி.ப|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.|ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்|ஜ|பி|மா|ஏ|மே|ஜூ|ஜூ|ஆ|செ|அ|ந|டி|0|ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி|ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி|ஞா|தி|செ|பு|வி|வெ|ச|0|கி.மு.|கி.பி.|கிறிஸ்துவுக்கு முன்|அன்னோ டோமினி|கி.மு.|கி.பி.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|a h:mm:ss v|Hmsv|HH:mm:ss v|hmv|a h:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|dd-MM, E|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|d MMMM|MMMMW-count-one|MMMM W -ஆம் வாரம்|MMMMW-count-other|MMMM W -ஆம் வாரம்|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ஆம் ஆண்டின் w -ஆம் வாரம்|yw-count-other|Y ஆம் ஆண்டின் w -ஆம் வாரம்|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs.|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ta_LK = $enkidatron$elm_cldr$Generated$Ta$ta_LK;
var $enkidatron$elm_cldr$Generated$Ta$ta_MY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ta$dayPeriods, 'ta||MY||AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|மு.ப|பி.ப|11|afternoon1|மதி.|afternoon2|பிற்.|am|மு.ப|evening1|மா.|evening2|அந்தி மா.|midnight|நள்.|morning1|அதி.|morning2|கா.|night1|இர.|noon|நண்.|pm|பி.ப|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.|ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்|ஜ|பி|மா|ஏ|மே|ஜூ|ஜூ|ஆ|செ|அ|ந|டி|0|ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி|ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி|ஞா|தி|செ|பு|வி|வெ|ச|0|கி.மு.|கி.பி.|கிறிஸ்துவுக்கு முன்|அன்னோ டோமினி|கி.மு.|கி.பி.|a h:mm|a h:mm:ss|a h:mm:ss z|a h:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|a h:mm:ss v|Hmsv|HH:mm:ss v|hmv|a h:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|dd-MM, E|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|d MMMM|MMMMW-count-one|MMMM W -ஆம் வாரம்|MMMMW-count-other|MMMM W -ஆம் வாரம்|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ஆம் ஆண்டின் w -ஆம் வாரம்|yw-count-other|Y ஆம் ஆண்டின் w -ஆம் வாரம்|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|S$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ta_MY = $enkidatron$elm_cldr$Generated$Ta$ta_MY;
var $enkidatron$elm_cldr$Generated$Ta$ta_SG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ta$dayPeriods, 'ta||SG||AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|AM|பிற்பகல்|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|பிற்பகல்|மு.ப|பி.ப|11|afternoon1|மதி.|afternoon2|பிற்.|am|மு.ப|evening1|மா.|evening2|அந்தி மா.|midnight|நள்.|morning1|அதி.|morning2|கா.|night1|இர.|noon|நண்.|pm|பி.ப|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.|ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்|ஜ|பி|மா|ஏ|மே|ஜூ|ஜூ|ஆ|செ|அ|ந|டி|0|ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி|ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி|ஞா|தி|செ|பு|வி|வெ|ச|0|கி.மு.|கி.பி.|கிறிஸ்துவுக்கு முன்|அன்னோ டோமினி|கி.மு.|கி.பி.|a h:mm|a h:mm:ss|a h:mm:ss z|a h:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|a h:mm:ss v|Hmsv|HH:mm:ss v|hmv|a h:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|dd-MM, E|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|d MMMM|MMMMW-count-one|MMMM W -ஆம் வாரம்|MMMMW-count-other|MMMM W -ஆம் வாரம்|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ஆம் ஆண்டின் w -ஆம் வாரம்|yw-count-other|Y ஆம் ஆண்டின் w -ஆம் வாரம்|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ta_SG = $enkidatron$elm_cldr$Generated$Ta$ta_SG;
var $enkidatron$elm_cldr$Generated$Tr$tr_CY = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Tr$dayPeriods, 'tr||CY||ÖÖ|ÖS|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|ÖÖ|evening1|akşam|midnight|gece yarısı|morning1|sabah|morning2|öğleden önce|night1|gece|noon|öğle|pm|ÖS|ÖÖ|ÖS|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|ÖÖ|evening1|akşam|midnight|gece yarısı|morning1|sabah|morning2|öğleden önce|night1|gece|noon|öğle|pm|ÖS|öö|ös|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|öö|evening1|akşam|midnight|gece|morning1|sabah|morning2|öğleden önce|night1|gece|noon|ö|pm|ös|d.MM.y|d MMM y|d MMMM y|d MMMM y EEEE|Oca|Şub|Mar|Nis|May|Haz|Tem|Ağu|Eyl|Eki|Kas|Ara|Ocak|Şubat|Mart|Nisan|Mayıs|Haziran|Temmuz|Ağustos|Eylül|Ekim|Kasım|Aralık|O|Ş|M|N|M|H|T|A|E|E|K|A|0|Paz|Pzt|Sal|Çar|Per|Cum|Cmt|Pazar|Pazartesi|Salı|Çarşamba|Perşembe|Cuma|Cumartesi|P|P|S|Ç|P|C|C|0|MÖ|MS|Milattan Önce|Milattan Sonra|MÖ|MS|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a\u202Fh:mm|EHm|E HH:mm|Ehms|E a\u202Fh:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y E|h|a\u202Fh|H|HH|hm|a\u202Fh:mm|Hm|HH:mm|hms|a\u202Fh:mm:ss|Hms|HH:mm:ss|hmsv|a\u202Fh:mm:ss v|Hmsv|HH:mm:ss v|hmv|a\u202Fh:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/MM E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM E|MMMMd|d MMMM|MMMMEd|d MMMM E|MMMMW-count-one|MMMM \u0027ayının\u0027 W. \u0027haftası\u0027|MMMMW-count-other|MMMM \u0027ayının\u0027 W. \u0027haftası\u0027|mmss|mm:ss|ms|mm:ss|y|y|yM|MM/y|yMd|dd.MM.y|yMEd|d.M.y E|yMM|MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y \u0027yılının\u0027 w. \u0027haftası\u0027|yw-count-other|Y \u0027yılının\u0027 w. \u0027haftası\u0027|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-%||%||%||107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$tr_CY = $enkidatron$elm_cldr$Generated$Tr$tr_CY;
var $enkidatron$elm_cldr$Generated$Ur$ur_IN = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ur$dayPeriods, 'ur||IN||AM|PM|8|afternoon1|دوپہر|afternoon2|سہ پہر|am|AM|evening1|شام|midnight|آدھی رات|morning1|صبح|night1|رات|pm|PM|AM|PM|8|afternoon1|دوپہر میں|afternoon2|سہ پہر|am|AM|evening1|شام میں|midnight|آدھی رات|morning1|صبح میں|night1|رات میں|pm|PM|a|p|8|afternoon1|دوپہر|afternoon2|سہ پہر|am|a|evening1|شام|midnight|آدھی رات|morning1|صبح|night1|رات|pm|p|d/M/yy|d MMM، y|d MMMM، y|EEEE، d MMMM، y|جنوری|فروری|مارچ|اپریل|مئی|جون|جولائی|اگست|ستمبر|اکتوبر|نومبر|دسمبر|جنوری|فروری|مارچ|اپریل|مئی|جون|جولائی|اگست|ستمبر|اکتوبر|نومبر|دسمبر|J|F|M|A|M|J|J|A|S|O|N|D|0|اتوار|پیر|منگل|بدھ|جمعرات|جمعہ|ہفتہ|اتوار|پیر|منگل|بدھ|جمعرات|جمعہ|ہفتہ|S|M|T|W|T|F|S|0|قبل مسیح|عیسوی|قبل مسیح|عیسوی|قبل مسیح|عیسوی|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM، y G|GyMMMEd|E، d MMM، y G|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E، d/M|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMM کا ہفتہ W|MMMMW-count-other|MMMM کا ہفتہ W|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E، d/M/y|yMMM|MMM y|yMMMd|d MMM، y|yMMMEd|E، d MMM، y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y کا w ہفتہ|yw-count-other|Y کا w ہفتہ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200E-¤||¤||¤||E0W,|.|\u200E-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|PKR|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ur_IN = $enkidatron$elm_cldr$Generated$Ur$ur_IN;
var $enkidatron$elm_cldr$Generated$Yo$yo_BJ = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yo$dayPeriods, 'yo||BJ||Àárɔ̀|Ɔ̀sán|2|am|Àárɔ̀|pm|Ɔ̀sán|Àárɔ̀|Ɔ̀sán|2|am|Àárɔ̀|pm|Ɔ̀sán|Àárɔ̀|Ɔ̀sán|2|am|Àárɔ̀|pm|Ɔ̀sán|d/M/y|d MM y|d MMM y|EEEE, d MMM y|Shɛ́r|Èrèl|Ɛrɛ̀n|Ìgb|Ɛ̀bi|Òkú|Agɛ|Ògú|Owe|Ɔ̀wà|Bél|Ɔ̀pɛ|Oshù Shɛ́rɛ́|Oshù Èrèlè|Oshù Ɛrɛ̀nà|Oshù Ìgbé|Oshù Ɛ̀bibi|Oshù Òkúdu|Oshù Agɛmɔ|Oshù Ògún|Oshù Owewe|Oshù Ɔ̀wàrà|Oshù Bélú|Oshù Ɔ̀pɛ̀|S|È|Ɛ|Ì|Ɛ̀|Ò|A|Ò|O|Ɔ̀|B|Ɔ̀|1|Shɛ́|Èr|Ɛr|Ìg|Ɛ̀b|Òk|Ag|Òg|Ow|Ɔ̀w|Bé|Ɔ̀p|Shɛ́rɛ́|Èrèlè|Ɛrɛ̀nà|Ìgbé|Ɛ̀bibi|Òkúdu|Agɛmɔ|Ògún|Owewe|Ɔ̀wàrà|Bélú|Ɔ̀pɛ̀|S|È|Ɛ|Ì|Ɛ̀|Ò|A|Ò|O|Ɔ̀|B|Ɔ̀|Àìk|Aj|Ìsɛ́g|Ɔjɔ́r|Ɔjɔ́b|Ɛt|Àbám|Ɔjɔ́ Àìkú|Ɔjɔ́ Ajé|Ɔjɔ́ Ìsɛ́gun|Ɔjɔ́rú|Ɔjɔ́bɔ|Ɔjɔ́ Ɛtì|Ɔjɔ́ Àbámɛ́ta|À|A|Ì|Ɔ|Ɔ|Ɛ|À|1|Àìk|Aj|Ìsɛ́g|Ɔjɔ́r|Ɔjɔ́b|Ɛt|Àbám|Àìkú|Ajé|Ìsɛ́gun|Ɔjɔ́rú|Ɔjɔ́bɔ|Ɛtì|Àbámɛ́ta|À|A|Ì|Ɔ|Ɔ|Ɛ|À|BCE|AD|Saju Kristi|Lehin Kristi|BCE|AD|H:m|H:m:s|H:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMEd|d, MMMM E|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|d/M/y, E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM , y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|Hm|Hms|Hmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yo_BJ = $enkidatron$elm_cldr$Generated$Yo$yo_BJ;
var $enkidatron$elm_cldr$Generated$En$en_001 = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||001||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_001 = $enkidatron$elm_cldr$Generated$En$en_001;
var $enkidatron$elm_cldr$Generated$En$en_150 = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||150||am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|am|pm|10|afternoon1|in the afternoon|am|am|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|pm|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\u0027week\u0027 W \u0027of\u0027 MMMM|MMMMW-count-other|\u0027week\u0027 W \u0027of\u0027 MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027week\u0027 w \u0027of\u0027 Y|yw-count-other|\u0027week\u0027 w \u0027of\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_150 = $enkidatron$elm_cldr$Generated$En$en_150;
var $enkidatron$elm_cldr$Generated$Es$es_419 = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||419||a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|a.m.|p.m.|7|am|a.m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.m.|d/M/yy|d MMM y|d \u0027de\u0027 MMMM \u0027de\u0027 y|EEEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|M|J|V|S|0|a.C.|d.C.|antes de Cristo|después de Cristo|a.C.|d.C.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d \u0027de\u0027 MMM \u0027de\u0027 y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \u0027de\u0027 y G|GyMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y G|GyMMMMEd|E, d \u0027de\u0027 MMMM \u0027de\u0027 y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|HH:mm:ss vvvv|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMdd|dd-MMM|MMMEd|E, d MMM|MMMMd|d \u0027de\u0027 MMMM|MMMMEd|E, d \u0027de\u0027 MMMM|MMMMW-count-one|\u0027semana\u0027 W \u0027de\u0027 MMMM|MMMMW-count-other|\u0027semana\u0027 W \u0027de\u0027 MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM \u0027de\u0027 y|yMMMMd|d \u0027de\u0027 MMMM \u0027de\u0027 y|yMMMMEd|EEE, d \u0027de\u0027 MMMM \u0027de\u0027 y|yQQQ|QQQ \u0027de\u0027 y|yQQQQ|QQQQ \u0027de\u0027 y|yw-count-one|\u0027semana\u0027 w \u0027de\u0027 Y|yw-count-other|\u0027semana\u0027 w \u0027de\u0027 Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|FK£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|SD£|STN|Db|SYP|S£|THB|THB|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|BsF|VND|VND|XAF|XAF|XCD|XCD|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es_419 = $enkidatron$elm_cldr$Generated$Es$es_419;
var $enkidatron$elm_cldr$Generated$Az$az_Latn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Az$dayPeriods, 'az|Latn|||AM|PM|10|afternoon1|gündüz|am|AM|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|günorta|pm|PM|AM|PM|10|afternoon1|gündüz|am|AM|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|günorta|pm|PM|a|p|10|afternoon1|gündüz|am|a|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|g|pm|p|dd.MM.yy|d MMM y|d MMMM y|d MMMM y, EEEE|yan|fev|mar|apr|may|iyn|iyl|avq|sen|okt|noy|dek|yanvar|fevral|mart|aprel|may|iyun|iyul|avqust|sentyabr|oktyabr|noyabr|dekabr|1|2|3|4|5|6|7|8|9|10|11|12|0|B.|B.e.|Ç.a.|Ç.|C.a.|C.|Ş.|bazar|bazar ertəsi|çərşənbə axşamı|çərşənbə|cümə axşamı|cümə|şənbə|7|1|2|3|4|5|6|1|B.|B.E.|Ç.A.|Ç.|C.A.|C.|Ş.|bazar|bazar ertəsi|çərşənbə axşamı|çərşənbə|cümə axşamı|cümə|şənbə|7|1|2|3|4|5|6|e.ə.|y.e.|eramızdan əvvəl|yeni era|e.ə.|y.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG d MMM y|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMM, W \u0027həftə\u0027|MMMMW-count-other|MMMM, W \u0027həftə\u0027|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y, E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y, E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y, w \u0027həftə\u0027|yw-count-other|Y, w \u0027həftə\u0027|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|ley|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|S£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$az_Latn = $enkidatron$elm_cldr$Generated$Az$az_Latn;
var $enkidatron$elm_cldr$Generated$Bs$bs_Latn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bs$dayPeriods, 'bs|Latn|||AM|PM|8|afternoon1|poslijepodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|PM|prijepodne|popodne|8|afternoon1|poslijepodne|am|prijepodne|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|popodne|prijepodne|popodne|8|afternoon1|poslijepodne|am|prijepodne|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|popodne|d. M. y.|d. MMM y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec|januar|februar|mart|april|maj|juni|juli|august|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|N|P|U|S|Č|P|S|1|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|p. n. e.|n. e.|prije nove ere|nove ere|p.n.e.|n. e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d/M/y. G|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|L|Md|d.M.|MEd|E, d.M.|MMdd|d. M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027sedmica\u0027 \u0027mjesec\u0027 MMMM|MMMMW-count-few|W. \u0027sedmica\u0027 \u0027mjesec\u0027 MMMM|MMMMW-count-other|W. \u0027sedmica\u0027 \u0027mjesec\u0027 MMMM|ms|mm:ss|y|y.|yM|MM/y|yMd|d.M.y.|yMEd|E, d.M.y.|yMM|M/y|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|LLLL y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RSD|din.|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|XPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bs_Latn = $enkidatron$elm_cldr$Generated$Bs$bs_Latn;
var $enkidatron$elm_cldr$Generated$En$en_Latn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en|Latn|||AM|PM|10|afternoon1|dopahar|am|AM|am-alt-variant|am|evening1|shaam|midnight|midnight|morning1|subah|night1|raat|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|dopahar|am|AM|am-alt-variant|am|evening1|shaam|midnight|aadhi raat|morning1|subah|night1|raat|noon|Madhyanh|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|dopahar|am|a|am-alt-variant|am|evening1|shaam|midnight|mi|morning1|subah|night1|raat|noon|n|pm|p|pm-alt-variant|pm|dd/MM/y|dd MMM, y|d MMMM, y|EEEE d MMMM, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|Ravi|Som|Mangal|Budh|Guru|Shukra|Shani|Raviwaar|Somwaar|Mangalwaar|Budhwaar|Guruwaar|Shukrawaar|Shaniwaar|Ra|So|Ma|Bu|Gu|Sh|Sha|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|Ehm-alt-ascii|E, h:mm a|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|Ehms-alt-ascii|E, h:mm:ss a|EHms|E, HH:mm:ss|Gy|G y|GyMd|d/M/y G|GyMMM|G y MMM|GyMMMd|G y, d MMM|GyMMMEd|G y, dd MMM, E|GyMMMEEEEd|EEEE d MMM, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMEEEEd|EEEE d MMM|MMMMd|d MMMM|MMMMEEEEd|EEEE d MMMM|MMMMW-count-one|MMMM \u0027kaa\u0027 \u0027week\u0027 W|MMMMW-count-other|MMMM \u0027kaa\u0027 \u0027week\u0027 W|ms|mm:ss|y|y|yM|MM/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMEEEEd|EEEE d MMM, y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM, y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y \u0027kaa\u0027 \u0027week\u0027 w|yw-count-other|Y \u0027kaa\u0027 \u0027week\u0027 w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|105|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$en_Latn = $enkidatron$elm_cldr$Generated$En$en_Latn;
var $enkidatron$elm_cldr$Generated$Pa$pa_Guru = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pa$dayPeriods, 'pa|Guru|||ਪੂ.ਦੁ.|ਬਾ.ਦੁ.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਪੂ.ਦੁ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਬਾ.ਦੁ.|ਪੂ.ਦੁ.|ਬਾ.ਦੁ.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਪੂ.ਦੁ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਬਾ.ਦੁ.|ਸ.|ਸ਼.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਸ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਸ਼.|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|ਜਨ|ਫ਼ਰ|ਮਾਰਚ|ਅਪ੍ਰੈ|ਮਈ|ਜੂਨ|ਜੁਲਾ|ਅਗ|ਸਤੰ|ਅਕਤੂ|ਨਵੰ|ਦਸੰ|ਜਨਵਰੀ|ਫ਼ਰਵਰੀ|ਮਾਰਚ|ਅਪ੍ਰੈਲ|ਮਈ|ਜੂਨ|ਜੁਲਾਈ|ਅਗਸਤ|ਸਤੰਬਰ|ਅਕਤੂਬਰ|ਨਵੰਬਰ|ਦਸੰਬਰ|ਜ|ਫ਼|ਮਾ|ਅ|ਮ|ਜੂ|ਜੁ|ਅ|ਸ|ਅ|ਨ|ਦ|0|ਐਤ|ਸੋਮ|ਮੰਗਲ|ਬੁੱਧ|ਵੀਰ|ਸ਼ੁੱਕਰ|ਸ਼ਨਿੱਚਰ|ਐਤਵਾਰ|ਸੋਮਵਾਰ|ਮੰਗਲਵਾਰ|ਬੁੱਧਵਾਰ|ਵੀਰਵਾਰ|ਸ਼ੁੱਕਰਵਾਰ|ਸ਼ਨਿੱਚਰਵਾਰ|ਐ|ਸੋ|ਮੰ|ਬੁੱ|ਵੀ|ਸ਼ੁੱ|ਸ਼|0|ਈ. ਪੂ.|ਸੰਨ|ਈਸਵੀ ਪੂਰਵ|ਈਸਵੀ ਸੰਨ|ਈ.ਪੂ.|ਸੰਨ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM, G y|GyMMMd|d MMM, G y|GyMMMEd|E d MMM, G y|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, dd-MM.|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|MMMM d|MMMMW-count-one|MMMM ਦਾ W ਹਫ਼ਤਾ|MMMMW-count-other|MMMM ਦਾ W ਹਫ਼ਤਾ|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ਦਾ w ਹਫ਼ਤਾ|yw-count-other|Y ਦਾ w ਹਫ਼ਤਾ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pa_Guru = $enkidatron$elm_cldr$Generated$Pa$pa_Guru;
var $enkidatron$elm_cldr$Generated$Sd$sd_Arab = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sd$dayPeriods, 'sd|Arab|||صبح،\u202Fمنجهند|شام،\u202Fمنجهند|2|am|صبح،\u202Fمنجهند|pm|شام،\u202Fمنجهند|صبح، منجهند|منجهند، شام|2|am|صبح، منجهند|pm|منجهند، شام|صبح،\u202Fمنجهند|منجهند،\u202Fشام|2|am|صبح،\u202Fمنجهند|pm|منجهند،\u202Fشام|y-MM-dd|y MMM d|y MMMM d|EEEE, MMMM d, y|جنوري|فيبروري|مارچ|اپريل|مئي|جون|جولاءِ|آگسٽ|سيپٽمبر|آڪٽوبر|نومبر|ڊسمبر|جنوري|فيبروري|مارچ|اپريل|مئي|جون|جولاءِ|آگسٽ|سيپٽمبر|آڪٽوبر|نومبر|ڊسمبر|J|F|M|A|M|J|J|A|S|O|N|D|0|آچر|سومر|اڱارو|اربع|خميس|جمعو|ڇنڇر|آچر|سومر|اڱارو|اربع|خميس|جمعو|ڇنڇر|آچر|سو|اڱارو|اربع|خم|جمعو|ڇنڇر|0|BC|CD|قبل مسيح|عيسوي کان پهرين|BC|CD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h a|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-one|ھفتو W جو MMMM|MMMMW-count-other|ھفتو W جو MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|ھفتو w جو Y|yw-count-other|ھفتو w جو Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sd_Arab = $enkidatron$elm_cldr$Generated$Sd$sd_Arab;
var $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Cyrl|||AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутру|night1|ноћу|noon|подне|pm|PM|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец|јануар|фебруар|март|април|мај|јун|јул|август|септембар|октобар|новембар|децембар|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед|пон|уто|сре|чет|пет|суб|недеља|понедељак|уторак|среда|четвртак|петак|субота|н|п|у|с|ч|п|с|0|п. н. е.|н. е.|пре нове ере|нове ере|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-few|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-other|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-few|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-other|w. \u0027седмица\u0027 \u0027у\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|КМ|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl = $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl;
var $enkidatron$elm_cldr$Generated$Sr$sr_Latn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Latn|||AM|PM|8|afternoon1|po podne|am|AM|evening1|uveče|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|po podne|am|AM|evening1|uveče|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|po podne|am|AM|evening1|uveče|midnight|ponoć|morning1|ujutru|night1|noću|noon|podne|pm|PM|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec|januar|februar|mart|april|maj|jun|jul|avgust|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sre|čet|pet|sub|nedelja|ponedeljak|utorak|sreda|četvrtak|petak|subota|n|p|u|s|č|p|s|0|p. n. e.|n. e.|pre nove ere|nove ere|p.n.e.|n.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|MMMMW-count-few|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|MMMMW-count-other|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|r.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Latn = $enkidatron$elm_cldr$Generated$Sr$sr_Latn;
var $enkidatron$elm_cldr$Generated$Uz$uz_Latn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Uz$dayPeriods, 'uz|Latn|||TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|dd/MM/yy|d-MMM, y|d-MMMM, y|EEEE, d-MMMM, y|yan|fev|mar|apr|may|iyn|iyl|avg|sen|okt|noy|dek|yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr|Y|F|M|A|M|I|I|A|S|O|N|D|1|Yan|Fev|Mar|Apr|May|Iyn|Iyl|Avg|Sen|Okt|Noy|Dek|Yanvar|Fevral|Mart|Aprel|May|Iyun|Iyul|Avgust|Sentabr|Oktabr|Noyabr|Dekabr|Y|F|M|A|M|I|I|A|S|O|N|D|Yak|Dush|Sesh|Chor|Pay|Jum|Shan|yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba|Y|D|S|C|P|J|S|0|m.a.|milodiy|miloddan avvalgi|milodiy|m.a.|milodiy|HH:mm|HH:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|G y|GyMd|dd.MM.y GGGGG|GyMMM|MMM, G y|GyMMMd|d-MMM, G y|GyMMMEd|E, d-MMM, G y|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|LL|Md|dd/MM|MEd|E, dd/MM|MMM|LLL|MMMd|d-MMM|MMMEd|E, d-MMM|MMMMd|d-MMMM|MMMMW-count-one|MMMM, W-\u0027hafta\u0027|MMMMW-count-other|MMMM, W-\u0027hafta\u0027|ms|mm:ss|y|y|yM|MM.y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM, y|yMMMd|d-MMM, y|yMMMEd|E, d-MMM, y|yMMMM|MMMM, y|yQQQ|y, QQQ|yQQQQ|y, QQQQ|yw-count-one|Y, w-\u0027hafta\u0027|yw-count-other|Y, w-\u0027hafta\u0027|HHmm|HHmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|UZS|soʻm|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$uz_Latn = $enkidatron$elm_cldr$Generated$Uz$uz_Latn;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hans = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hans|||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|HH:mm|HH:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|EBh:mm|EBhms|EBh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|M/d|MEd|M/dE|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMW-count-other|MMMM第W周|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/dE|yMEEEEd|y年M月d日EEEE|yMM|y年M月|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年第Q季度|yQQQQ|y年第Q季度|yw-count-other|Y年第w周|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILR|ILS|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hans = $enkidatron$elm_cldr$Generated$Zh$zh_Hans;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hant = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hant|||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日 EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|週日|週一|週二|週三|週四|週五|週六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|西元前|西元|西元前|西元|西元前|西元|Bh:mm|Bh:mm:ss|Bh:mm:ss [z]|Bh:mm:ss [zzzz]|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|Bh時|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d E|Ehm|E Bh:mm|EHm|E HH:mm|Ehms|E Bh:mm:ss|EHms|E HH:mm:ss|Gy|Gy年|GyMd|G y/M/d|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日 E|h|Bh時|H|H時|hm|Bh:mm|Hm|HH:mm|hms|Bh:mm:ss|Hms|HH:mm:ss|hmsv|Bh:mm:ss [v]|Hmsv|HH:mm:ss [v]|hmv|Bh:mm [v]|Hmv|HH:mm [v]|M|M月|Md|M/d|MEd|M/d（E）|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日 E|MMMMd|M月d日|MMMMW-count-other|MMMM的第W週|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/d（E）|yMEEEEd|y年M月d日 EEEE|yMM|y/MM|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日 E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年的第w週|Bhmm|Bhmmss|Bhmmssz|Bhmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hant = $enkidatron$elm_cldr$Generated$Zh$zh_Hant;
var $enkidatron$elm_cldr$Generated$Yue$yue_Hans = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yue$dayPeriods, 'yue|Hans|||上午|下午|9|afternoon1|中午|afternoon2|下昼|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下昼|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下昼|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|西元前|西元|西元前|西元|西元前|西元|HH:mm|HH:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|M/d|MEd|M/dE|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMW-count-other|M月第W个星期|ms|mm:ss|y|y年|yM|y年M月|yMd|y/M/d|yMEd|y/M/dE|yMM|y年M月|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w个星期|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|￥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yue_Hans = $enkidatron$elm_cldr$Generated$Yue$yue_Hans;
var $enkidatron$elm_cldr$Generated$Yue$yue_Hant = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yue$dayPeriods, 'yue|Hant|||上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日 EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|星期日|星期一|星期二|星期三|星期四|星期五|星期六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|西元前|西元|西元前|西元|西元前|西元|ah:mm|ah:mm:ss|ah:mm:ss [z]|ah:mm:ss [zzzz]|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|Bh時|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d E|Ehm|E ah:mm|EHm|E HH:mm|Ehms|E ah:mm:ss|EHms|E HH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日 E|h|ah時|H|H時|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|ah:mm:ss [v]|Hmsv|HH:mm:ss [v]|hmv|ah:mm [v]|Hmv|HH:mm [v]|M|M月|Md|M/d|MEd|M/d（E）|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日 E|MMMMd|M月d日|MMMMW-count-other|M月第W個星期|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/d（E）|yMM|y/MM|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日 E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w個星期|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yue_Hant = $enkidatron$elm_cldr$Generated$Yue$yue_Hant;
var $enkidatron$elm_cldr$Generated$Be$be_TARASK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Be$dayPeriods, 'be|||TARASK|AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|am|pm|2|am|am|pm|pm|d.MM.yy|d MMM y\u202F\u0027г\u0027.|d MMMM y\u202F\u0027г\u0027.|EEEE, d MMMM y\u202F\u0027г\u0027.|сту|лют|сак|кра|мая|чэр|ліп|жні|вер|кас|ліс|сне|студзеня|лютага|сакавіка|красавіка|мая|чэрвеня|ліпеня|жніўня|верасня|кастрычніка|лістапада|снежня|с|л|с|к|м|ч|л|ж|в|к|л|с|1|сту|лют|сак|кра|май|чэр|ліп|жні|вер|кас|ліс|сне|студзень|люты|сакавік|красавік|май|чэрвень|ліпень|жнівень|верасень|кастрычнік|лістапад|снежань|с|л|с|к|м|ч|л|ж|в|к|л|с|нд|пн|аў|ср|чц|пт|сб|нядзеля|панядзелак|аўторак|серада|чацвер|пятніца|субота|н|п|а|с|ч|п|с|0|да н.э.|н.э.|да нараджэння Хрыстова|ад нараджэння Хрыстова|да н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss, zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\u0027г\u0027. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\u0027г\u0027. G|GyMMMd|d MMM y\u202F\u0027г\u0027. G|GyMMMEd|E, d MMM y\u202F\u0027г\u0027. G|h|hh\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W \u0027тыдзень\u0027 MMMM|MMMMW-count-few|W \u0027тыдзень\u0027 MMMM|MMMMW-count-many|W \u0027тыдзень\u0027 MMMM|MMMMW-count-other|W \u0027тыдзень\u0027 MMMM|ms|mm.ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|LLL y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w \u0027тыдзень\u0027 Y|yw-count-few|w \u0027тыдзень\u0027 Y|yw-count-many|w \u0027тыдзень\u0027 Y|yw-count-other|w \u0027тыдзень\u0027 Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BD$|BND|$|BOB|Bs|BRL|BRL|BSD|B$|BWP|P|BYN|Br|BZD|BZ$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|CUC$|CUP|$MN|CZK|Kč|DKK|kr|DOP|RD$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|FK£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|G$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|Íkr|JMD|J$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|CI$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|L$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|N$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|SI$|SEK|kr|SGD|S$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|$|UYU|$U|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$be_TARASK = $enkidatron$elm_cldr$Generated$Be$be_TARASK;
var $enkidatron$elm_cldr$Generated$As$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$As$locale_as = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$As$dayPeriods, 'as||||পূৰ্বাহ্ন|অপৰাহ্ন|2|am|পূৰ্বাহ্ন|pm|অপৰাহ্ন|পূৰ্বাহ্ন|অপৰাহ্ন|2|am|পূৰ্বাহ্ন|pm|অপৰাহ্ন|পূৰ্বাহ্ন|অপৰাহ্ন|2|am|পূৰ্বাহ্ন|pm|অপৰাহ্ন|d-M-y|dd-MM-y|d MMMM, y|EEEE, d MMMM, y|জানু|ফেব্ৰু|মাৰ্চ|এপ্ৰিল|মে’|জুন|জুলাই|আগ|ছেপ্তে|অক্টো|নৱে|ডিচে|জানুৱাৰী|ফেব্ৰুৱাৰী|মাৰ্চ|এপ্ৰিল|মে’|জুন|জুলাই|আগষ্ট|ছেপ্তেম্বৰ|অক্টোবৰ|নৱেম্বৰ|ডিচেম্বৰ|জ|ফ|ম|এ|ম|জ|জ|আ|ছ|অ|ন|ড|0|দেও|সোম|মঙ্গল|বুধ|বৃহ|শুক্ৰ|শনি|দেওবাৰ|সোমবাৰ|মঙ্গলবাৰ|বুধবাৰ|বৃহস্পতিবাৰ|শুক্ৰবাৰ|শনিবাৰ|দ|স|ম|ব|ব|শ|শ|0|খ্ৰীঃ পূঃ|খ্ৰীঃ|খ্ৰীষ্টপূৰ্ব|খ্ৰীষ্টাব্দ|খ্ৰীঃ পূঃ|খ্ৰীঃ|a h.mm|a h.mm.ss|a h.mm.ss z|a h.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|E d|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|a h:mm:ss v|Hmsv|HH:mm:ss v|hmv|a h:mm v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|E, dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMMৰ সপ্তাহ W|MMMMW-count-other|MMMMৰ সপ্তাহ W|ms|mm:ss|y|y|yM|MM-y|yMd|dd-MM-y|yMEd|E, dd-MM-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Yৰ সপ্তাহ w|yw-count-other|Yৰ সপ্তাহ w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0I,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$locale_as = $enkidatron$elm_cldr$Generated$As$locale_as;
var $enkidatron$elm_cldr$Generated$El$el_POLYTON = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$El$dayPeriods, 'el|||POLYTON|π.μ.|μ.μ.|6|afternoon1|μεσημ.|am|π.μ.|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μ.μ.|π.μ.|μ.μ.|6|afternoon1|το μεσημέρι|am|π.μ.|evening1|το απόγευμα|morning1|το πρωί|night1|το βράδυ|pm|μ.μ.|πμ|μμ|6|afternoon1|μεσημ.|am|πμ|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μμ|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|Ιαν|Φεβ|Μαρ|Απρ|Μαΐ|Ιουν|Ιουλ|Αὐγ|Σεπ|Ὀκτ|Νοε|Δεκ|Ιανουαρίου|Φεβρουαρίου|Μαρτίου|Απριλίου|Μαΐου|Ιουνίου|Ιουλίου|Αὐγούστου|Σεπτεμβρίου|Ὀκτωβρίου|Νοεμβρίου|Δεκεμβρίου|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|1|Ιαν|Φεβ|Μάρ|Απρ|Μάι|Ιούν|Ιούλ|Αύγ|Σεπ|Οκτ|Νοέ|Δεκ|Ιανουάριος|Φεβρουάριος|Μάρτιος|Απρίλιος|Μάιος|Ιούνιος|Ιούλιος|Αὔγουστος|Σεπτέμβριος|Ὀκτώβριος|Νοέμβριος|Δεκέμβριος|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|Κυρ|Δευ|Τρί|Τετ|Πέμ|Παρ|Σάβ|Κυριακή|Δευτέρα|Τρίτη|Τετάρτη|Πέμπτη|Παρασκευή|Σάββατο|Κ|Δ|Τ|Τ|Π|Π|Σ|0|π.Χ.|μ.Χ.|προ Χριστού|μετά Χριστόν|π.Χ.|μ.Χ.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} - {0}|{1} - {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|MMM|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|εβδομάδα W του MMMM|MMMMW-count-other|εβδομάδα W του MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|εβδομάδα w του Y|yw-count-other|εβδομάδα w του Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GRD|Δρχ|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$el_POLYTON = $enkidatron$elm_cldr$Generated$El$el_POLYTON;
var $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl_BA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Cyrl|BA||прије\u202Fподне|по\u202Fподне|8|afternoon1|по подне|am|прије\u202Fподне|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|по\u202Fподне|прије подне|по подне|8|afternoon1|по подне|am|прије подне|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|по подне|прије\u202Fподне|по\u202Fподне|8|afternoon1|по подне|am|прије\u202Fподне|evening1|увече|midnight|поноћ|morning1|ујутро|night1|ноћу|noon|подне|pm|по\u202Fподне|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец|јануар|фебруар|март|април|мај|јун|јул|август|септембар|октобар|новембар|децембар|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед|пон|уто|сри|чет|пет|суб|недјеља|понедјељак|уторак|сриједа|четвртак|петак|субота|н|п|у|с|ч|п|с|0|п. н. е.|н. е.|прије нове ере|нове ере|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-few|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-other|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-few|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-other|w. \u0027седмица\u0027 \u0027у\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|КМ|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl_BA = $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl_BA;
var $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl_ME = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Cyrl|ME||прије\u202Fподне|по\u202Fподне|8|afternoon1|по под.|am|прије\u202Fподне|evening1|вече|midnight|поноћ|morning1|јутро|night1|ноћу|noon|подне|pm|по\u202Fподне|прије подне|по подне|8|afternoon1|по под.|am|прије подне|evening1|вече|midnight|поноћ|morning1|јутро|night1|ноћу|noon|подне|pm|по подне|прије\u202Fподне|по\u202Fподне|8|afternoon1|по под.|am|прије\u202Fподне|evening1|вече|midnight|поноћ|morning1|јутро|night1|ноћ|noon|подне|pm|по\u202Fподне|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|јан|феб|март|апр|мај|јун|јул|авг|септ|окт|нов|дец|јануар|фебруар|март|април|мај|јун|јул|август|септембар|октобар|новембар|децембар|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед|пон|уто|сре|чет|пет|суб|недјеља|понедељак|уторак|сриједа|четвртак|петак|субота|н|п|у|с|ч|п|с|0|п. н. е.|н. е.|прије нове ере|нове ере|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027сједмица\u0027 \u0027у\u0027 MMMM|MMMMW-count-few|W. \u0027сједмица\u0027 \u0027у\u0027 MMMM|MMMMW-count-other|W. \u0027сједмица\u0027 \u0027у\u0027 MMMM|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027сједмица\u0027 \u0027у\u0027 Y.|yw-count-few|w. \u0027сједмица\u0027 \u0027у\u0027 Y.|yw-count-other|w. \u0027сједмица\u0027 \u0027у\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|КМ|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl_ME = $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl_ME;
var $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl_XK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Cyrl|XK||AM|PM|8|afternoon1|по под.|am|AM|evening1|увече|midnight|поноћ|morning1|јутро|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по под.|am|AM|evening1|увече|midnight|поноћ|morning1|јутро|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по под.|am|AM|evening1|вече|midnight|поноћ|morning1|јутро|night1|ноћ|noon|подне|pm|PM|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|јан|феб|март|апр|мај|јун|јул|авг|септ|окт|нов|дец|јануар|фебруар|март|април|мај|јун|јул|август|септембар|октобар|новембар|децембар|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед|пон|уто|сре|чет|пет|суб|недеља|понедељак|уторак|среда|четвртак|петак|субота|н|п|у|с|ч|п|с|0|п. н. е.|н. е.|пре нове ере|нове ере|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-few|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|MMMMW-count-other|W. \u0027седмица\u0027 \u0027у\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-few|w. \u0027седмица\u0027 \u0027у\u0027 Y.|yw-count-other|w. \u0027седмица\u0027 \u0027у\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|КМ|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl_XK = $enkidatron$elm_cldr$Generated$Sr$sr_Cyrl_XK;
var $enkidatron$elm_cldr$Generated$Sr$sr_Latn_BA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Latn|BA||prije\u202Fpodne|po\u202Fpodne|8|afternoon1|po podne|am|prije\u202Fpodne|evening1|uveče|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|po\u202Fpodne|prije podne|po podne|8|afternoon1|po podne|am|prije podne|evening1|uveče|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|po podne|prije\u202Fpodne|po\u202Fpodne|8|afternoon1|po podne|am|prije\u202Fpodne|evening1|uveče|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|po\u202Fpodne|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec|januar|februar|mart|april|maj|jun|jul|avgust|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|0|p. n. e.|n. e.|prije nove ere|nove ere|p.n.e.|n.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|MMMMW-count-few|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|MMMMW-count-other|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|r.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Latn_BA = $enkidatron$elm_cldr$Generated$Sr$sr_Latn_BA;
var $enkidatron$elm_cldr$Generated$Sr$sr_Latn_ME = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Latn|ME||prije\u202Fpodne|po\u202Fpodne|8|afternoon1|po pod.|am|prije\u202Fpodne|evening1|veče|midnight|ponoć|morning1|jutro|night1|noću|noon|podne|pm|po\u202Fpodne|prije podne|po podne|8|afternoon1|po pod.|am|prije podne|evening1|veče|midnight|ponoć|morning1|jutro|night1|noću|noon|podne|pm|po podne|prije\u202Fpodne|po\u202Fpodne|8|afternoon1|po pod.|am|prije\u202Fpodne|evening1|veče|midnight|ponoć|morning1|jutro|night1|noć|noon|podne|pm|po\u202Fpodne|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mart|apr|maj|jun|jul|avg|sept|okt|nov|dec|januar|februar|mart|april|maj|jun|jul|avgust|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sre|čet|pet|sub|nedjelja|ponedeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|0|p. n. e.|n. e.|prije nove ere|nove ere|p.n.e.|n.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027sjedmica\u0027 \u0027u\u0027 MMMM|MMMMW-count-few|W. \u0027sjedmica\u0027 \u0027u\u0027 MMMM|MMMMW-count-other|W. \u0027sjedmica\u0027 \u0027u\u0027 MMMM|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027sjedmica\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027sjedmica\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027sjedmica\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|r.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Latn_ME = $enkidatron$elm_cldr$Generated$Sr$sr_Latn_ME;
var $enkidatron$elm_cldr$Generated$Sr$sr_Latn_XK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr|Latn|XK||AM|PM|8|afternoon1|po pod.|am|AM|evening1|uveče|midnight|ponoć|morning1|jutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|po pod.|am|AM|evening1|uveče|midnight|ponoć|morning1|jutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|po pod.|am|AM|evening1|veče|midnight|ponoć|morning1|jutro|night1|noć|noon|podne|pm|PM|d.M.yy.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mart|apr|maj|jun|jul|avg|sept|okt|nov|dec|januar|februar|mart|april|maj|jun|jul|avgust|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sre|čet|pet|sub|nedelja|ponedeljak|utorak|sreda|četvrtak|petak|subota|n|p|u|s|č|p|s|0|p. n. e.|n. e.|pre nove ere|nove ere|p.n.e.|n.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|MMMMW-count-few|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|MMMMW-count-other|W. \u0027sedmica\u0027 \u0027u\u0027 MMMM.|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-few|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|yw-count-other|w. \u0027sedmica\u0027 \u0027u\u0027 Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|r.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr_Latn_XK = $enkidatron$elm_cldr$Generated$Sr$sr_Latn_XK;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hans_HK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hans|HK||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|d/M/yy|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|ah:mm|ah:mm:ss|z ah:mm:ss|zzzz ah:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|EBh:mm|EBhms|EBh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|HHmm|HH:mm|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMdd|M月d日|MMMMW-count-other|MMMM第W周|ms|mm:ss|y|y年|yM|M/y|yMd|d/M/y|yMEd|d/M/y（E）|yMEEEEd|y年M月d日EEEE|yMM|MM/y|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年第Q季度|yQQQQ|y年第Q季度|yw-count-other|Y年第w周|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILR|ILS|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hans_HK = $enkidatron$elm_cldr$Generated$Zh$zh_Hans_HK;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hans_MO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hans|MO||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|d/M/yy|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|ah:mm|ah:mm:ss|z ah:mm:ss|zzzz ah:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|EBh:mm|EBhms|EBh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMdd|M月d日|MMMMW-count-other|MMMM第W周|ms|mm:ss|y|y年|yM|y/M|yMd|y年M月d日|yMEd|y年M月d日，E|yMEEEEd|y年M月d日EEEE|yMM|y年M月|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年第Q季度|yQQQQ|y年第Q季度|yw-count-other|Y年第w周|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILR|ILS|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MOP|MOP$|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hans_MO = $enkidatron$elm_cldr$Generated$Zh$zh_Hans_MO;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hans_SG = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hans|SG||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|dd/MM/yy|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|ah:mm|ah:mm:ss|z ah:mm:ss|zzzz ah:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|EBh:mm|EBhms|EBh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|M-d|MEd|M-dE|MMdd|MM-dd|MMM|M月|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMdd|M月d日|MMMMW-count-other|MMMM第W周|ms|mm:ss|y|y年|yM|y/M|yMd|y年M月d日|yMEd|y年M月d日，E|yMEEEEd|y年M月d日EEEE|yMM|y年M月|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年第Q季度|yQQQQ|y年第Q季度|yw-count-other|Y年第w周|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILR|ILS|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hans_SG = $enkidatron$elm_cldr$Generated$Zh$zh_Hans_SG;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hant_HK = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hant|HK||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|d/M/y|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|週日|週一|週二|週三|週四|週五|週六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|ah:mm|ah:mm:ss|ah:mm:ss [z]|ah:mm:ss [zzzz]|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|Bh時|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d E|Ehm|E ah:mm|EHm|E HH:mm|Ehms|E ah:mm:ss|EHms|E HH:mm:ss|Gy|Gy年|GyMd|G y/M/d|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah時|H|H時|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|ah:mm:ss [v]|Hmsv|HH:mm:ss [v]|hmv|ah:mm [v]|Hmv|HH:mm [v]|M|M月|Md|d/M|MEd|d/M（E）|MMdd|dd/MM|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMW-count-other|M月第W週|ms|mm:ss|y|y年|yM|M/y|yMd|d/M/y|yMEd|d/M/y（E）|yMEEEEd|y年M月d日 EEEE|yMM|MM/y|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w週|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hant_HK = $enkidatron$elm_cldr$Generated$Zh$zh_Hant_HK;
var $enkidatron$elm_cldr$Generated$Zh$zh_Hant_MO = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh|Hant|MO||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|d/M/y|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|週日|週一|週二|週三|週四|週五|週六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|ah:mm|ah:mm:ss|ah:mm:ss [z]|ah:mm:ss [zzzz]|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|Bh時|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d E|Ehm|E ah:mm|EHm|E HH:mm|Ehms|E ah:mm:ss|EHms|E HH:mm:ss|Gy|Gy年|GyMd|G y/M/d|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah時|H|H時|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|ah:mm:ss [v]|Hmsv|HH:mm:ss [v]|hmv|ah:mm [v]|Hmv|HH:mm [v]|M|M月|Md|d/M|MEd|d/M（E）|MMdd|dd/MM|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMW-count-other|M月第W週|ms|mm:ss|y|y年|yM|M/y|yMd|d/M/y|yMEd|d/M/y（E）|yMEEEEd|y年M月d日 EEEE|yMM|MM/y|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w週|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MOP|MOP$|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh_Hant_MO = $enkidatron$elm_cldr$Generated$Zh$zh_Hant_MO;
var $enkidatron$elm_cldr$Generated$Ca$ca_ES_VALENCIA = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ca$dayPeriods, 'ca||ES|VALENCIA|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u00A0m.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|mat.|morning2|matí|night1|nit|pm|p.\u202Fm.|d/M/yy|d MMM y|d MMMM \u0027del\u0027 y|EEEE, d MMMM \u0027del\u0027 y|de gen.|de febr.|de març|d’abr.|de maig|de juny|de jul.|d’ag.|de set.|d’oct.|de nov.|de des.|de gener|de febrer|de març|d’abril|de maig|de juny|de juliol|d’agost|de setembre|d’octubre|de novembre|de desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|1|gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.|gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|dg.|dl.|dt.|dc.|dj.|dv.|ds.|diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte|dg.|dl.|dt.|dc.|dj.|dv.|ds.|0|aC|dC|abans de Crist|després de Crist|aC|dC|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM \u0027del\u0027 y G|GyMMMEd|E, d MMM \u0027del\u0027 y G|GyMMMM|LLLL \u0027del\u0027 y G|GyMMMMd|d MMMM \u0027del\u0027 y G|GyMMMMEd|E, d MMMM \u0027del\u0027 y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa (vvvv)|Hmvvvv|H:mm (vvvv)|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\u0027setmana\u0027 W MMMM|MMMMW-count-other|\u0027setmana\u0027 W MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|LLL \u0027del\u0027 y|yMMMd|d MMM \u0027del\u0027 y|yMMMEd|E, d MMM y|yMMMM|LLLL \u0027del\u0027 y|yMMMMd|d MMMM \u0027del\u0027 y|yMMMMEd|E, d MMMM \u0027del\u0027 y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\u0027setmana\u0027 w \u0027del\u0027 Y|yw-count-other|\u0027setmana\u0027 w \u0027del\u0027 Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs F|VND|₫|XAF|FCFA|XCD|XCD|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ca_ES_VALENCIA = $enkidatron$elm_cldr$Generated$Ca$ca_ES_VALENCIA;
var $enkidatron$elm_cldr$Cldr$Locale$allLocales = _List_fromArray(
	[$enkidatron$elm_cldr$Cldr$Locale$af, $enkidatron$elm_cldr$Cldr$Locale$af_NA, $enkidatron$elm_cldr$Cldr$Locale$am, $enkidatron$elm_cldr$Cldr$Locale$ar, $enkidatron$elm_cldr$Cldr$Locale$ar_AE, $enkidatron$elm_cldr$Cldr$Locale$ar_BH, $enkidatron$elm_cldr$Cldr$Locale$ar_DJ, $enkidatron$elm_cldr$Cldr$Locale$ar_DZ, $enkidatron$elm_cldr$Cldr$Locale$ar_EG, $enkidatron$elm_cldr$Cldr$Locale$ar_EH, $enkidatron$elm_cldr$Cldr$Locale$ar_ER, $enkidatron$elm_cldr$Cldr$Locale$ar_IL, $enkidatron$elm_cldr$Cldr$Locale$ar_IQ, $enkidatron$elm_cldr$Cldr$Locale$ar_JO, $enkidatron$elm_cldr$Cldr$Locale$ar_KM, $enkidatron$elm_cldr$Cldr$Locale$ar_KW, $enkidatron$elm_cldr$Cldr$Locale$ar_LB, $enkidatron$elm_cldr$Cldr$Locale$ar_LY, $enkidatron$elm_cldr$Cldr$Locale$ar_MA, $enkidatron$elm_cldr$Cldr$Locale$ar_MR, $enkidatron$elm_cldr$Cldr$Locale$ar_OM, $enkidatron$elm_cldr$Cldr$Locale$ar_PS, $enkidatron$elm_cldr$Cldr$Locale$ar_QA, $enkidatron$elm_cldr$Cldr$Locale$ar_SA, $enkidatron$elm_cldr$Cldr$Locale$ar_SD, $enkidatron$elm_cldr$Cldr$Locale$ar_SO, $enkidatron$elm_cldr$Cldr$Locale$ar_SS, $enkidatron$elm_cldr$Cldr$Locale$ar_SY, $enkidatron$elm_cldr$Cldr$Locale$ar_TD, $enkidatron$elm_cldr$Cldr$Locale$ar_TN, $enkidatron$elm_cldr$Cldr$Locale$ar_YE, $enkidatron$elm_cldr$Cldr$Locale$locale_as, $enkidatron$elm_cldr$Cldr$Locale$az, $enkidatron$elm_cldr$Cldr$Locale$az_Latn, $enkidatron$elm_cldr$Cldr$Locale$be, $enkidatron$elm_cldr$Cldr$Locale$be_TARASK, $enkidatron$elm_cldr$Cldr$Locale$bg, $enkidatron$elm_cldr$Cldr$Locale$bn, $enkidatron$elm_cldr$Cldr$Locale$bn_IN, $enkidatron$elm_cldr$Cldr$Locale$bs, $enkidatron$elm_cldr$Cldr$Locale$bs_Latn, $enkidatron$elm_cldr$Cldr$Locale$ca, $enkidatron$elm_cldr$Cldr$Locale$ca_AD, $enkidatron$elm_cldr$Cldr$Locale$ca_ES_VALENCIA, $enkidatron$elm_cldr$Cldr$Locale$ca_FR, $enkidatron$elm_cldr$Cldr$Locale$ca_IT, $enkidatron$elm_cldr$Cldr$Locale$chr, $enkidatron$elm_cldr$Cldr$Locale$cs, $enkidatron$elm_cldr$Cldr$Locale$cy, $enkidatron$elm_cldr$Cldr$Locale$da, $enkidatron$elm_cldr$Cldr$Locale$da_GL, $enkidatron$elm_cldr$Cldr$Locale$de, $enkidatron$elm_cldr$Cldr$Locale$de_AT, $enkidatron$elm_cldr$Cldr$Locale$de_BE, $enkidatron$elm_cldr$Cldr$Locale$de_CH, $enkidatron$elm_cldr$Cldr$Locale$de_IT, $enkidatron$elm_cldr$Cldr$Locale$de_LI, $enkidatron$elm_cldr$Cldr$Locale$de_LU, $enkidatron$elm_cldr$Cldr$Locale$dsb, $enkidatron$elm_cldr$Cldr$Locale$el, $enkidatron$elm_cldr$Cldr$Locale$el_CY, $enkidatron$elm_cldr$Cldr$Locale$el_POLYTON, $enkidatron$elm_cldr$Cldr$Locale$en, $enkidatron$elm_cldr$Cldr$Locale$en_001, $enkidatron$elm_cldr$Cldr$Locale$en_150, $enkidatron$elm_cldr$Cldr$Locale$en_AE, $enkidatron$elm_cldr$Cldr$Locale$en_AG, $enkidatron$elm_cldr$Cldr$Locale$en_AI, $enkidatron$elm_cldr$Cldr$Locale$en_AS, $enkidatron$elm_cldr$Cldr$Locale$en_AT, $enkidatron$elm_cldr$Cldr$Locale$en_AU, $enkidatron$elm_cldr$Cldr$Locale$en_BB, $enkidatron$elm_cldr$Cldr$Locale$en_BE, $enkidatron$elm_cldr$Cldr$Locale$en_BI, $enkidatron$elm_cldr$Cldr$Locale$en_BM, $enkidatron$elm_cldr$Cldr$Locale$en_BS, $enkidatron$elm_cldr$Cldr$Locale$en_BW, $enkidatron$elm_cldr$Cldr$Locale$en_BZ, $enkidatron$elm_cldr$Cldr$Locale$en_CA, $enkidatron$elm_cldr$Cldr$Locale$en_CC, $enkidatron$elm_cldr$Cldr$Locale$en_CH, $enkidatron$elm_cldr$Cldr$Locale$en_CK, $enkidatron$elm_cldr$Cldr$Locale$en_CM, $enkidatron$elm_cldr$Cldr$Locale$en_CX, $enkidatron$elm_cldr$Cldr$Locale$en_CY, $enkidatron$elm_cldr$Cldr$Locale$en_DE, $enkidatron$elm_cldr$Cldr$Locale$en_DG, $enkidatron$elm_cldr$Cldr$Locale$en_DK, $enkidatron$elm_cldr$Cldr$Locale$en_DM, $enkidatron$elm_cldr$Cldr$Locale$en_ER, $enkidatron$elm_cldr$Cldr$Locale$en_FI, $enkidatron$elm_cldr$Cldr$Locale$en_FJ, $enkidatron$elm_cldr$Cldr$Locale$en_FK, $enkidatron$elm_cldr$Cldr$Locale$en_FM, $enkidatron$elm_cldr$Cldr$Locale$en_GB, $enkidatron$elm_cldr$Cldr$Locale$en_GD, $enkidatron$elm_cldr$Cldr$Locale$en_GG, $enkidatron$elm_cldr$Cldr$Locale$en_GH, $enkidatron$elm_cldr$Cldr$Locale$en_GI, $enkidatron$elm_cldr$Cldr$Locale$en_GM, $enkidatron$elm_cldr$Cldr$Locale$en_GU, $enkidatron$elm_cldr$Cldr$Locale$en_GY, $enkidatron$elm_cldr$Cldr$Locale$en_HK, $enkidatron$elm_cldr$Cldr$Locale$en_ID, $enkidatron$elm_cldr$Cldr$Locale$en_IE, $enkidatron$elm_cldr$Cldr$Locale$en_IL, $enkidatron$elm_cldr$Cldr$Locale$en_IM, $enkidatron$elm_cldr$Cldr$Locale$en_IN, $enkidatron$elm_cldr$Cldr$Locale$en_IO, $enkidatron$elm_cldr$Cldr$Locale$en_JE, $enkidatron$elm_cldr$Cldr$Locale$en_JM, $enkidatron$elm_cldr$Cldr$Locale$en_KE, $enkidatron$elm_cldr$Cldr$Locale$en_KI, $enkidatron$elm_cldr$Cldr$Locale$en_KN, $enkidatron$elm_cldr$Cldr$Locale$en_KY, $enkidatron$elm_cldr$Cldr$Locale$en_LC, $enkidatron$elm_cldr$Cldr$Locale$en_LR, $enkidatron$elm_cldr$Cldr$Locale$en_LS, $enkidatron$elm_cldr$Cldr$Locale$en_MG, $enkidatron$elm_cldr$Cldr$Locale$en_MH, $enkidatron$elm_cldr$Cldr$Locale$en_MO, $enkidatron$elm_cldr$Cldr$Locale$en_MP, $enkidatron$elm_cldr$Cldr$Locale$en_MS, $enkidatron$elm_cldr$Cldr$Locale$en_MT, $enkidatron$elm_cldr$Cldr$Locale$en_MU, $enkidatron$elm_cldr$Cldr$Locale$en_MV, $enkidatron$elm_cldr$Cldr$Locale$en_MW, $enkidatron$elm_cldr$Cldr$Locale$en_MY, $enkidatron$elm_cldr$Cldr$Locale$en_NA, $enkidatron$elm_cldr$Cldr$Locale$en_NF, $enkidatron$elm_cldr$Cldr$Locale$en_NG, $enkidatron$elm_cldr$Cldr$Locale$en_NL, $enkidatron$elm_cldr$Cldr$Locale$en_NR, $enkidatron$elm_cldr$Cldr$Locale$en_NU, $enkidatron$elm_cldr$Cldr$Locale$en_NZ, $enkidatron$elm_cldr$Cldr$Locale$en_PG, $enkidatron$elm_cldr$Cldr$Locale$en_PH, $enkidatron$elm_cldr$Cldr$Locale$en_PK, $enkidatron$elm_cldr$Cldr$Locale$en_PN, $enkidatron$elm_cldr$Cldr$Locale$en_PR, $enkidatron$elm_cldr$Cldr$Locale$en_PW, $enkidatron$elm_cldr$Cldr$Locale$en_RW, $enkidatron$elm_cldr$Cldr$Locale$en_SB, $enkidatron$elm_cldr$Cldr$Locale$en_SC, $enkidatron$elm_cldr$Cldr$Locale$en_SD, $enkidatron$elm_cldr$Cldr$Locale$en_SE, $enkidatron$elm_cldr$Cldr$Locale$en_SG, $enkidatron$elm_cldr$Cldr$Locale$en_SH, $enkidatron$elm_cldr$Cldr$Locale$en_SI, $enkidatron$elm_cldr$Cldr$Locale$en_SL, $enkidatron$elm_cldr$Cldr$Locale$en_SS, $enkidatron$elm_cldr$Cldr$Locale$en_SX, $enkidatron$elm_cldr$Cldr$Locale$en_SZ, $enkidatron$elm_cldr$Cldr$Locale$en_TC, $enkidatron$elm_cldr$Cldr$Locale$en_TK, $enkidatron$elm_cldr$Cldr$Locale$en_TO, $enkidatron$elm_cldr$Cldr$Locale$en_TT, $enkidatron$elm_cldr$Cldr$Locale$en_TV, $enkidatron$elm_cldr$Cldr$Locale$en_TZ, $enkidatron$elm_cldr$Cldr$Locale$en_UG, $enkidatron$elm_cldr$Cldr$Locale$en_UM, $enkidatron$elm_cldr$Cldr$Locale$en_VC, $enkidatron$elm_cldr$Cldr$Locale$en_VG, $enkidatron$elm_cldr$Cldr$Locale$en_VI, $enkidatron$elm_cldr$Cldr$Locale$en_VU, $enkidatron$elm_cldr$Cldr$Locale$en_WS, $enkidatron$elm_cldr$Cldr$Locale$en_ZA, $enkidatron$elm_cldr$Cldr$Locale$en_ZM, $enkidatron$elm_cldr$Cldr$Locale$en_ZW, $enkidatron$elm_cldr$Cldr$Locale$en_Latn, $enkidatron$elm_cldr$Cldr$Locale$es, $enkidatron$elm_cldr$Cldr$Locale$es_419, $enkidatron$elm_cldr$Cldr$Locale$es_AR, $enkidatron$elm_cldr$Cldr$Locale$es_BO, $enkidatron$elm_cldr$Cldr$Locale$es_BR, $enkidatron$elm_cldr$Cldr$Locale$es_BZ, $enkidatron$elm_cldr$Cldr$Locale$es_CL, $enkidatron$elm_cldr$Cldr$Locale$es_CO, $enkidatron$elm_cldr$Cldr$Locale$es_CR, $enkidatron$elm_cldr$Cldr$Locale$es_CU, $enkidatron$elm_cldr$Cldr$Locale$es_DO, $enkidatron$elm_cldr$Cldr$Locale$es_EA, $enkidatron$elm_cldr$Cldr$Locale$es_EC, $enkidatron$elm_cldr$Cldr$Locale$es_GQ, $enkidatron$elm_cldr$Cldr$Locale$es_GT, $enkidatron$elm_cldr$Cldr$Locale$es_HN, $enkidatron$elm_cldr$Cldr$Locale$es_IC, $enkidatron$elm_cldr$Cldr$Locale$es_MX, $enkidatron$elm_cldr$Cldr$Locale$es_NI, $enkidatron$elm_cldr$Cldr$Locale$es_PA, $enkidatron$elm_cldr$Cldr$Locale$es_PE, $enkidatron$elm_cldr$Cldr$Locale$es_PH, $enkidatron$elm_cldr$Cldr$Locale$es_PR, $enkidatron$elm_cldr$Cldr$Locale$es_PY, $enkidatron$elm_cldr$Cldr$Locale$es_SV, $enkidatron$elm_cldr$Cldr$Locale$es_US, $enkidatron$elm_cldr$Cldr$Locale$es_UY, $enkidatron$elm_cldr$Cldr$Locale$es_VE, $enkidatron$elm_cldr$Cldr$Locale$et, $enkidatron$elm_cldr$Cldr$Locale$eu, $enkidatron$elm_cldr$Cldr$Locale$fa, $enkidatron$elm_cldr$Cldr$Locale$fa_AF, $enkidatron$elm_cldr$Cldr$Locale$fi, $enkidatron$elm_cldr$Cldr$Locale$fil, $enkidatron$elm_cldr$Cldr$Locale$fr, $enkidatron$elm_cldr$Cldr$Locale$fr_BE, $enkidatron$elm_cldr$Cldr$Locale$fr_BF, $enkidatron$elm_cldr$Cldr$Locale$fr_BI, $enkidatron$elm_cldr$Cldr$Locale$fr_BJ, $enkidatron$elm_cldr$Cldr$Locale$fr_BL, $enkidatron$elm_cldr$Cldr$Locale$fr_CA, $enkidatron$elm_cldr$Cldr$Locale$fr_CD, $enkidatron$elm_cldr$Cldr$Locale$fr_CF, $enkidatron$elm_cldr$Cldr$Locale$fr_CG, $enkidatron$elm_cldr$Cldr$Locale$fr_CH, $enkidatron$elm_cldr$Cldr$Locale$fr_CI, $enkidatron$elm_cldr$Cldr$Locale$fr_CM, $enkidatron$elm_cldr$Cldr$Locale$fr_DJ, $enkidatron$elm_cldr$Cldr$Locale$fr_DZ, $enkidatron$elm_cldr$Cldr$Locale$fr_GA, $enkidatron$elm_cldr$Cldr$Locale$fr_GF, $enkidatron$elm_cldr$Cldr$Locale$fr_GN, $enkidatron$elm_cldr$Cldr$Locale$fr_GP, $enkidatron$elm_cldr$Cldr$Locale$fr_GQ, $enkidatron$elm_cldr$Cldr$Locale$fr_HT, $enkidatron$elm_cldr$Cldr$Locale$fr_KM, $enkidatron$elm_cldr$Cldr$Locale$fr_LU, $enkidatron$elm_cldr$Cldr$Locale$fr_MA, $enkidatron$elm_cldr$Cldr$Locale$fr_MC, $enkidatron$elm_cldr$Cldr$Locale$fr_MF, $enkidatron$elm_cldr$Cldr$Locale$fr_MG, $enkidatron$elm_cldr$Cldr$Locale$fr_ML, $enkidatron$elm_cldr$Cldr$Locale$fr_MQ, $enkidatron$elm_cldr$Cldr$Locale$fr_MR, $enkidatron$elm_cldr$Cldr$Locale$fr_MU, $enkidatron$elm_cldr$Cldr$Locale$fr_NC, $enkidatron$elm_cldr$Cldr$Locale$fr_NE, $enkidatron$elm_cldr$Cldr$Locale$fr_PF, $enkidatron$elm_cldr$Cldr$Locale$fr_PM, $enkidatron$elm_cldr$Cldr$Locale$fr_RE, $enkidatron$elm_cldr$Cldr$Locale$fr_RW, $enkidatron$elm_cldr$Cldr$Locale$fr_SC, $enkidatron$elm_cldr$Cldr$Locale$fr_SN, $enkidatron$elm_cldr$Cldr$Locale$fr_SY, $enkidatron$elm_cldr$Cldr$Locale$fr_TD, $enkidatron$elm_cldr$Cldr$Locale$fr_TG, $enkidatron$elm_cldr$Cldr$Locale$fr_TN, $enkidatron$elm_cldr$Cldr$Locale$fr_VU, $enkidatron$elm_cldr$Cldr$Locale$fr_WF, $enkidatron$elm_cldr$Cldr$Locale$fr_YT, $enkidatron$elm_cldr$Cldr$Locale$ga, $enkidatron$elm_cldr$Cldr$Locale$ga_GB, $enkidatron$elm_cldr$Cldr$Locale$gd, $enkidatron$elm_cldr$Cldr$Locale$gl, $enkidatron$elm_cldr$Cldr$Locale$gu, $enkidatron$elm_cldr$Cldr$Locale$ha, $enkidatron$elm_cldr$Cldr$Locale$ha_GH, $enkidatron$elm_cldr$Cldr$Locale$ha_NE, $enkidatron$elm_cldr$Cldr$Locale$he, $enkidatron$elm_cldr$Cldr$Locale$hi, $enkidatron$elm_cldr$Cldr$Locale$hr, $enkidatron$elm_cldr$Cldr$Locale$hr_BA, $enkidatron$elm_cldr$Cldr$Locale$hsb, $enkidatron$elm_cldr$Cldr$Locale$hu, $enkidatron$elm_cldr$Cldr$Locale$hy, $enkidatron$elm_cldr$Cldr$Locale$id, $enkidatron$elm_cldr$Cldr$Locale$ig, $enkidatron$elm_cldr$Cldr$Locale$is, $enkidatron$elm_cldr$Cldr$Locale$it, $enkidatron$elm_cldr$Cldr$Locale$it_CH, $enkidatron$elm_cldr$Cldr$Locale$it_SM, $enkidatron$elm_cldr$Cldr$Locale$it_VA, $enkidatron$elm_cldr$Cldr$Locale$ja, $enkidatron$elm_cldr$Cldr$Locale$jv, $enkidatron$elm_cldr$Cldr$Locale$ka, $enkidatron$elm_cldr$Cldr$Locale$kk, $enkidatron$elm_cldr$Cldr$Locale$km, $enkidatron$elm_cldr$Cldr$Locale$kn, $enkidatron$elm_cldr$Cldr$Locale$ko, $enkidatron$elm_cldr$Cldr$Locale$ko_CN, $enkidatron$elm_cldr$Cldr$Locale$ko_KP, $enkidatron$elm_cldr$Cldr$Locale$kok, $enkidatron$elm_cldr$Cldr$Locale$ky, $enkidatron$elm_cldr$Cldr$Locale$lo, $enkidatron$elm_cldr$Cldr$Locale$lt, $enkidatron$elm_cldr$Cldr$Locale$lv, $enkidatron$elm_cldr$Cldr$Locale$mk, $enkidatron$elm_cldr$Cldr$Locale$ml, $enkidatron$elm_cldr$Cldr$Locale$mn, $enkidatron$elm_cldr$Cldr$Locale$mr, $enkidatron$elm_cldr$Cldr$Locale$ms, $enkidatron$elm_cldr$Cldr$Locale$ms_BN, $enkidatron$elm_cldr$Cldr$Locale$ms_ID, $enkidatron$elm_cldr$Cldr$Locale$ms_SG, $enkidatron$elm_cldr$Cldr$Locale$my, $enkidatron$elm_cldr$Cldr$Locale$nb, $enkidatron$elm_cldr$Cldr$Locale$nb_SJ, $enkidatron$elm_cldr$Cldr$Locale$ne, $enkidatron$elm_cldr$Cldr$Locale$ne_IN, $enkidatron$elm_cldr$Cldr$Locale$nl, $enkidatron$elm_cldr$Cldr$Locale$nl_AW, $enkidatron$elm_cldr$Cldr$Locale$nl_BE, $enkidatron$elm_cldr$Cldr$Locale$nl_BQ, $enkidatron$elm_cldr$Cldr$Locale$nl_CW, $enkidatron$elm_cldr$Cldr$Locale$nl_SR, $enkidatron$elm_cldr$Cldr$Locale$nl_SX, $enkidatron$elm_cldr$Cldr$Locale$nn, $enkidatron$elm_cldr$Cldr$Locale$no, $enkidatron$elm_cldr$Cldr$Locale$or, $enkidatron$elm_cldr$Cldr$Locale$pa, $enkidatron$elm_cldr$Cldr$Locale$pa_Guru, $enkidatron$elm_cldr$Cldr$Locale$pl, $enkidatron$elm_cldr$Cldr$Locale$ps, $enkidatron$elm_cldr$Cldr$Locale$ps_PK, $enkidatron$elm_cldr$Cldr$Locale$pt, $enkidatron$elm_cldr$Cldr$Locale$pt_AO, $enkidatron$elm_cldr$Cldr$Locale$pt_CH, $enkidatron$elm_cldr$Cldr$Locale$pt_CV, $enkidatron$elm_cldr$Cldr$Locale$pt_GQ, $enkidatron$elm_cldr$Cldr$Locale$pt_GW, $enkidatron$elm_cldr$Cldr$Locale$pt_LU, $enkidatron$elm_cldr$Cldr$Locale$pt_MO, $enkidatron$elm_cldr$Cldr$Locale$pt_MZ, $enkidatron$elm_cldr$Cldr$Locale$pt_PT, $enkidatron$elm_cldr$Cldr$Locale$pt_ST, $enkidatron$elm_cldr$Cldr$Locale$pt_TL, $enkidatron$elm_cldr$Cldr$Locale$ro, $enkidatron$elm_cldr$Cldr$Locale$ro_MD, $enkidatron$elm_cldr$Cldr$Locale$ru, $enkidatron$elm_cldr$Cldr$Locale$ru_BY, $enkidatron$elm_cldr$Cldr$Locale$ru_KG, $enkidatron$elm_cldr$Cldr$Locale$ru_KZ, $enkidatron$elm_cldr$Cldr$Locale$ru_MD, $enkidatron$elm_cldr$Cldr$Locale$ru_UA, $enkidatron$elm_cldr$Cldr$Locale$sd, $enkidatron$elm_cldr$Cldr$Locale$sd_Arab, $enkidatron$elm_cldr$Cldr$Locale$si, $enkidatron$elm_cldr$Cldr$Locale$sk, $enkidatron$elm_cldr$Cldr$Locale$sl, $enkidatron$elm_cldr$Cldr$Locale$so, $enkidatron$elm_cldr$Cldr$Locale$so_DJ, $enkidatron$elm_cldr$Cldr$Locale$so_ET, $enkidatron$elm_cldr$Cldr$Locale$so_KE, $enkidatron$elm_cldr$Cldr$Locale$sq, $enkidatron$elm_cldr$Cldr$Locale$sq_MK, $enkidatron$elm_cldr$Cldr$Locale$sq_XK, $enkidatron$elm_cldr$Cldr$Locale$sr, $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl, $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl_BA, $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl_ME, $enkidatron$elm_cldr$Cldr$Locale$sr_Cyrl_XK, $enkidatron$elm_cldr$Cldr$Locale$sr_Latn, $enkidatron$elm_cldr$Cldr$Locale$sr_Latn_BA, $enkidatron$elm_cldr$Cldr$Locale$sr_Latn_ME, $enkidatron$elm_cldr$Cldr$Locale$sr_Latn_XK, $enkidatron$elm_cldr$Cldr$Locale$sv, $enkidatron$elm_cldr$Cldr$Locale$sv_AX, $enkidatron$elm_cldr$Cldr$Locale$sv_FI, $enkidatron$elm_cldr$Cldr$Locale$sw, $enkidatron$elm_cldr$Cldr$Locale$sw_CD, $enkidatron$elm_cldr$Cldr$Locale$sw_KE, $enkidatron$elm_cldr$Cldr$Locale$sw_UG, $enkidatron$elm_cldr$Cldr$Locale$ta, $enkidatron$elm_cldr$Cldr$Locale$ta_LK, $enkidatron$elm_cldr$Cldr$Locale$ta_MY, $enkidatron$elm_cldr$Cldr$Locale$ta_SG, $enkidatron$elm_cldr$Cldr$Locale$te, $enkidatron$elm_cldr$Cldr$Locale$th, $enkidatron$elm_cldr$Cldr$Locale$tk, $enkidatron$elm_cldr$Cldr$Locale$tr, $enkidatron$elm_cldr$Cldr$Locale$tr_CY, $enkidatron$elm_cldr$Cldr$Locale$uk, $enkidatron$elm_cldr$Cldr$Locale$root, $enkidatron$elm_cldr$Cldr$Locale$ur, $enkidatron$elm_cldr$Cldr$Locale$ur_IN, $enkidatron$elm_cldr$Cldr$Locale$uz, $enkidatron$elm_cldr$Cldr$Locale$uz_Latn, $enkidatron$elm_cldr$Cldr$Locale$vi, $enkidatron$elm_cldr$Cldr$Locale$yo, $enkidatron$elm_cldr$Cldr$Locale$yo_BJ, $enkidatron$elm_cldr$Cldr$Locale$yue, $enkidatron$elm_cldr$Cldr$Locale$yue_Hans, $enkidatron$elm_cldr$Cldr$Locale$yue_Hant, $enkidatron$elm_cldr$Cldr$Locale$zh, $enkidatron$elm_cldr$Cldr$Locale$zh_Hans, $enkidatron$elm_cldr$Cldr$Locale$zh_Hans_HK, $enkidatron$elm_cldr$Cldr$Locale$zh_Hans_MO, $enkidatron$elm_cldr$Cldr$Locale$zh_Hans_SG, $enkidatron$elm_cldr$Cldr$Locale$zh_Hant, $enkidatron$elm_cldr$Cldr$Locale$zh_Hant_HK, $enkidatron$elm_cldr$Cldr$Locale$zh_Hant_MO, $enkidatron$elm_cldr$Cldr$Locale$zu]);
var $elm$core$List$sortBy = _List_sortBy;
var $enkidatron$elm_cldr$Internal$Locale$unwrapLocale = function (_v0) {
	var internal = _v0.a;
	return internal;
};
var $elm$core$Basics$pow = _Basics_pow;
var $enkidatron$elm_cldr$Internal$Locale$similarityHelper = F3(
	function (points, requested, checked) {
		var _v0 = _Utils_Tuple2(requested, checked);
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var req = _v0.a.a;
				var chck = _v0.b.a;
				return _Utils_eq(req, chck) ? (2 * points) : 0;
			} else {
				var _v3 = _v0.b;
				return points;
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return 2 * points;
			} else {
				var _v4 = _v0.a;
				return points;
			}
		}
	});
var $enkidatron$elm_cldr$Internal$Locale$languageIdSimilarity = F2(
	function (requested, checked) {
		var _v0 = _Utils_Tuple2(requested, checked);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Root') {
				if (_v0.b.$ === 'Root') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return (-1) * A2($elm$core$Basics$pow, 10, 4);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Lang') {
					var _v3 = _v0.a;
					var langTagA = _v3.a;
					var scriptTagA = _v3.b;
					var regionTagA = _v3.c;
					var variantTagA = _v3.d;
					var _v4 = _v0.b;
					var langTagB = _v4.a;
					var scriptTagB = _v4.b;
					var regionTagB = _v4.c;
					var variantTagB = _v4.d;
					var variantPoints = A3(
						$enkidatron$elm_cldr$Internal$Locale$similarityHelper,
						A2($elm$core$Basics$pow, 10, 1),
						variantTagA,
						variantTagB);
					var scriptPoints = A3(
						$enkidatron$elm_cldr$Internal$Locale$similarityHelper,
						A2($elm$core$Basics$pow, 10, 3),
						scriptTagA,
						scriptTagB);
					var regionPoints = A3(
						$enkidatron$elm_cldr$Internal$Locale$similarityHelper,
						A2($elm$core$Basics$pow, 10, 2),
						regionTagA,
						regionTagB);
					var langPoints = _Utils_eq(langTagA, langTagB) ? A2($elm$core$Basics$pow, 10, 4) : 0;
					return (((langPoints + scriptPoints) + regionPoints) + variantPoints) * (-1);
				} else {
					break _v0$2;
				}
			}
		}
		return 0;
	});
var $enkidatron$elm_cldr$Internal$Locale$languageIdNoConflicts = F2(
	function (langA, langB) {
		var _v0 = _Utils_Tuple2(langA, langB);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Root') {
				if (_v0.b.$ === 'Root') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Lang') {
					var _v3 = _v0.a;
					var tagA = _v3.a;
					var scriptTagA = _v3.b;
					var regionTagA = _v3.c;
					var variantTagA = _v3.d;
					var _v4 = _v0.b;
					var tagB = _v4.a;
					var scriptTagB = _v4.b;
					var regionTagB = _v4.c;
					var variantTagB = _v4.d;
					return _Utils_eq(tagA, tagB) && (A2(
						$elm$core$Maybe$withDefault,
						true,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, scriptTagA, scriptTagB)) && (A2(
						$elm$core$Maybe$withDefault,
						true,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, regionTagA, regionTagB)) && A2(
						$elm$core$Maybe$withDefault,
						true,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, variantTagA, variantTagB))));
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $enkidatron$elm_cldr$Internal$Locale$matchNearestLocale = F2(
	function (locales, langId) {
		var normalized = $enkidatron$elm_cldr$Internal$Locale$normalize(langId);
		return A2(
			$elm$core$Maybe$map,
			$enkidatron$elm_cldr$Internal$Locale$Locale,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.languageId;
						},
						$enkidatron$elm_cldr$Internal$Locale$languageIdSimilarity(normalized)),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.languageId;
							},
							$enkidatron$elm_cldr$Internal$Locale$languageIdNoConflicts(normalized)),
						A2($elm$core$List$map, $enkidatron$elm_cldr$Internal$Locale$unwrapLocale, locales)))));
	});
var $enkidatron$elm_cldr$Internal$Locale$maybeParse = function (innerParser) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$map, $elm$core$Maybe$Just, innerParser),
				$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
			]));
};
var $joneshf$elm_tagged$Tagged$tag = $joneshf$elm_tagged$Tagged$Tagged;
var $enkidatron$elm_cldr$Internal$Locale$langSubtagParser = A2(
	$elm$parser$Parser$keeper,
	$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
	A2(
		$elm$parser$Parser$andThen,
		function (words) {
			var len = $elm$core$String$length(words);
			return (((len >= 2) && (len <= 3)) || ((len >= 5) && (len <= 8))) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('a language subtag must have 2-3 or 5-8 characters');
		},
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha))));
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $enkidatron$elm_cldr$Internal$Locale$sepParser = $elm$parser$Parser$chompIf(
	function (_char) {
		return _Utils_eq(
			_char,
			_Utils_chr('-')) || _Utils_eq(
			_char,
			_Utils_chr('_'));
	});
var $enkidatron$elm_cldr$Internal$Locale$regionSubtagParser = $elm$parser$Parser$backtrackable(
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
			$enkidatron$elm_cldr$Internal$Locale$sepParser),
		A2(
			$elm$parser$Parser$andThen,
			function (words) {
				var len = $elm$core$String$length(words);
				return ((len === 2) && A2(
					$elm$core$List$all,
					$elm$core$Char$isAlpha,
					$elm$core$String$toList(words))) ? $elm$parser$Parser$succeed(words) : (((len === 3) && A2(
					$elm$core$List$all,
					$elm$core$Char$isDigit,
					$elm$core$String$toList(words))) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('a region subtag must have 2-3 characters'));
			},
			$elm$parser$Parser$getChompedString(
				$elm$parser$Parser$chompWhile($elm$core$Char$isAlphaNum)))));
var $enkidatron$elm_cldr$Internal$Locale$scriptSubtagParser = $elm$parser$Parser$backtrackable(
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
			$enkidatron$elm_cldr$Internal$Locale$sepParser),
		A2(
			$elm$parser$Parser$andThen,
			function (words) {
				return ($elm$core$String$length(words) === 4) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('a script subtag must have 4 characters');
			},
			$elm$parser$Parser$getChompedString(
				$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha)))));
var $enkidatron$elm_cldr$Internal$Locale$isValidVariant = function (words) {
	var _v0 = $elm$core$String$toList(words);
	if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
		var first = _v0.a;
		var _v1 = _v0.b;
		var second = _v1.a;
		var _v2 = _v1.b;
		var third = _v2.a;
		var _v3 = _v2.b;
		var fourth = _v3.a;
		return $elm$core$Char$isDigit(first) && A2(
			$elm$core$List$all,
			$elm$core$Char$isAlphaNum,
			_List_fromArray(
				[second, third, fourth]));
	} else {
		var length = $elm$core$String$length(words);
		return (length >= 5) && ((length <= 8) && A2(
			$elm$core$List$all,
			$elm$core$Char$isAlphaNum,
			$elm$core$String$toList(words)));
	}
};
var $enkidatron$elm_cldr$Internal$Locale$variantSubtagParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
		$enkidatron$elm_cldr$Internal$Locale$sepParser),
	A2(
		$elm$parser$Parser$andThen,
		function (words) {
			return $enkidatron$elm_cldr$Internal$Locale$isValidVariant(words) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('\u0027' + (words + '\u0027 is not a valid variantn subtag'));
		},
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha))));
var $enkidatron$elm_cldr$Internal$Locale$langParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Locale$Lang),
				$enkidatron$elm_cldr$Internal$Locale$langSubtagParser),
			$enkidatron$elm_cldr$Internal$Locale$maybeParse($enkidatron$elm_cldr$Internal$Locale$scriptSubtagParser)),
		$enkidatron$elm_cldr$Internal$Locale$maybeParse($enkidatron$elm_cldr$Internal$Locale$regionSubtagParser)),
	$enkidatron$elm_cldr$Internal$Locale$maybeParse($enkidatron$elm_cldr$Internal$Locale$variantSubtagParser));
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return (_Utils_eq(newOffset, -1) || (0 <= A3(
				$elm$parser$Parser$Advanced$isSubChar,
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || _Utils_eq(
						c,
						_Utils_chr('_'));
				},
				newOffset,
				s.src))) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, row: newRow, src: s.src, indent: s.indent, offset: newOffset, context: s.context});
		});
};
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 'ExpectingKeyword', a: a};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $enkidatron$elm_cldr$Internal$Locale$rootParser = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Locale$Root),
		$elm$parser$Parser$keyword('root')),
	$elm$parser$Parser$end);
var $enkidatron$elm_cldr$Internal$Locale$languageIdParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$enkidatron$elm_cldr$Internal$Locale$rootParser, $enkidatron$elm_cldr$Internal$Locale$langParser]));
var $enkidatron$elm_cldr$Internal$Locale$languageIdFromString = function (words) {
	return $elm$core$Result$toMaybe(
		A2($elm$parser$Parser$run, $enkidatron$elm_cldr$Internal$Locale$languageIdParser, words));
};
var $enkidatron$elm_cldr$Cldr$Locale$fromString = F2(
	function (candidateLocales, localeString) {
		return A2(
			$elm$core$Maybe$andThen,
			$enkidatron$elm_cldr$Internal$Locale$matchNearestLocale(candidateLocales),
			$enkidatron$elm_cldr$Internal$Locale$languageIdFromString(localeString));
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Data$Session$defaultFleet = F2(
	function (session, defId) {
		var def = A2(
			$elm$core$Maybe$andThen,
			function (i) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					function (f) {
						return _Utils_eq(f.fleetId, i);
					},
					session.fleets);
			},
			defId);
		if (def.$ === 'Just') {
			var d = def.a;
			return $elm$core$Maybe$Just(d);
		} else {
			return $elm$core$List$head(session.fleets);
		}
	});
var $tremlab$bugsnag_elm$BugsnagElm$BugsnagConfig = F5(
	function (apiKey, appVersion, releaseStage, enabledReleaseStages, user) {
		return {user: user, apiKey: apiKey, appVersion: appVersion, releaseStage: releaseStage, enabledReleaseStages: enabledReleaseStages};
	});
var $elm$http$Http$Request = function (a) {
	return {$: 'Request', a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {reqs: reqs, subs: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (cmd.$ === 'Cancel') {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 'Nothing') {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tracker;
							if (_v4.$ === 'Nothing') {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.subs)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 'Cancel', a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (cmd.$ === 'Cancel') {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					url: r.url,
					body: r.body,
					expect: A2(_Http_mapExpect, func, r.expect),
					method: r.method,
					headers: r.headers,
					timeout: r.timeout,
					tracker: r.tracker,
					allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 'MySub', a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{url: r.url, body: r.body, expect: r.expect, method: r.method, headers: r.headers, timeout: r.timeout, tracker: r.tracker, allowCookiesFromOtherDomains: false}));
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Data$Session$tokenToString = function (t) {
	var s = t.a;
	return s;
};
var $author$project$Http$Extra$authHeader = function (a) {
	return A2(
		$elm$http$Http$header,
		'Authorization',
		'Bearer ' + $author$project$Data$Session$tokenToString(a.token));
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Shared$OnRefreshFleet = function (a) {
	return {$: 'OnRefreshFleet', a: a};
};
var $author$project$Shared$refreshFleetCmd = F3(
	function (token, apiUrl, slug) {
		return $elm$http$Http$request(
			{
				url: A3(
					$elm$url$Url$Builder$crossOrigin,
					apiUrl,
					_List_fromArray(
						['fleet', slug]),
					_List_Nil),
				body: $elm$http$Http$emptyBody,
				expect: A2($elm$http$Http$expectJson, $author$project$Shared$OnRefreshFleet, $author$project$Data$Fleet$decode),
				method: 'GET',
				headers: _List_fromArray(
					[
						$author$project$Http$Extra$authHeader(token)
					]),
				timeout: $elm$core$Maybe$Nothing,
				tracker: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Geospatial$LatLong$LatLong = F2(
	function (lat, _long) {
		return {lat: lat, _long: _long};
	});
var $author$project$Geospatial$MapProjection$MapPosition = F2(
	function (centre, zoom) {
		return {zoom: zoom, centre: centre};
	});
var $author$project$Shared$mapPositionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Geospatial$MapProjection$MapPosition,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Geospatial$LatLong$LatLong,
		A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float)),
	A2($elm$json$Json$Decode$field, 'zoom', $elm$json$Json$Decode$float));
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Shared$bugsnagConfigDecoder = A6(
	$elm$json$Json$Decode$map5,
	$tremlab$bugsnag_elm$BugsnagElm$BugsnagConfig,
	A2($elm$json$Json$Decode$field, 'apiKey', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'appVersion', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'releaseStage', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'enabledReleaseStages',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing));
var $author$project$Data$User$accountIdToString = function (_v0) {
	var accountId = _v0.a;
	return accountId;
};
var $author$project$Shared$sessionToBugsnagUser = function (session) {
	return {
		id: $author$project$Data$User$accountIdToString(session.user.accountId),
		email: session.user.email,
		username: session.user.firstName + (' ' + session.user.lastName)
	};
};
var $author$project$Shared$init = F2(
	function (req, flags) {
		var showedNavigationWarning = A2(
			$elm$core$Maybe$withDefault,
			false,
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'showedNavigationWarning', $elm$json$Json$Decode$bool),
					flags)));
		var selectedFleetId = A2(
			$elm$core$Maybe$map,
			$author$project$Data$Fleet$FleetId,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$elm$core$Result$toMaybe(
					A2(
						$elm$json$Json$Decode$decodeValue,
						A2(
							$elm$json$Json$Decode$field,
							'selectedFleetId',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
						flags))));
		var trackDuration = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2(
						$elm$json$Json$Decode$field,
						'defaultTrackDuration',
						$elm$json$Json$Decode$maybe($author$project$Data$TrackDuration$decode)),
					flags)));
		var useNewServer = A2(
			$elm$core$Maybe$withDefault,
			false,
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'useNewServer', $elm$json$Json$Decode$bool),
					flags)));
		var mapPosition = $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'defaultMapPosition', $author$project$Shared$mapPositionDecoder),
				flags));
		var newApiUrl = A2(
			$elm$core$Maybe$withDefault,
			'http://localhost:5286',
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'newApiUrl', $elm$json$Json$Decode$string),
					flags)));
		var fleetUrl = A2(
			$elm$core$Maybe$withDefault,
			'http://localhost:8082',
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'fleetUrl', $elm$json$Json$Decode$string),
					flags)));
		var session = $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'session', $author$project$Data$Session$decode),
				flags));
		var bugsnagConfig = function (c) {
			return _Utils_update(
				c,
				{
					user: A2($elm$core$Maybe$map, $author$project$Shared$sessionToBugsnagUser, session)
				});
		}(
			A2(
				$elm$core$Maybe$withDefault,
				A5($tremlab$bugsnag_elm$BugsnagElm$BugsnagConfig, '', '', '', _List_Nil, $elm$core$Maybe$Nothing),
				$elm$core$Result$toMaybe(
					A2(
						$elm$json$Json$Decode$decodeValue,
						A2($elm$json$Json$Decode$field, 'bugsnagConfig', $author$project$Shared$bugsnagConfigDecoder),
						flags))));
		var locale = A2(
			$elm$core$Maybe$withDefault,
			$enkidatron$elm_cldr$Cldr$Locale$en_GB,
			A2(
				$elm$core$Maybe$andThen,
				$enkidatron$elm_cldr$Cldr$Locale$fromString($enkidatron$elm_cldr$Cldr$Locale$allLocales),
				$elm$core$Result$toMaybe(
					A2(
						$elm$json$Json$Decode$decodeValue,
						A2($elm$json$Json$Decode$field, 'language', $elm$json$Json$Decode$string),
						flags))));
		var featureDropState = A2(
			$elm$core$Maybe$map,
			$author$project$FeatureDrop$State$setLocale(locale),
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'featureDropState', $author$project$FeatureDrop$State$decoder),
					flags)));
		var apiUrl = A2(
			$elm$core$Maybe$withDefault,
			'http://localhost:8083',
			$elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string),
					flags)));
		if (session.$ === 'Just') {
			var s = session.a;
			var _v1 = A2($author$project$Data$Session$defaultFleet, s, selectedFleetId);
			if (_v1.$ === 'Just') {
				var f = _v1.a;
				return _Utils_Tuple2(
					{
						apiUrl: useNewServer ? newApiUrl : apiUrl,
						locale: locale,
						bugsnag: $tremlab$bugsnag_elm$BugsnagElm$start(bugsnagConfig),
						session: $elm$core$Maybe$Just(s),
						fleetUrl: fleetUrl,
						newApiUrl: newApiUrl,
						oldApiUrl: apiUrl,
						bugsnagConfig: bugsnagConfig,
						selectedFleetId: $elm$core$Maybe$Just(f.fleetId),
						featureDropState: featureDropState,
						defaultMapPosition: mapPosition,
						defaultTrackDuration: trackDuration,
						showedNavigationWarning: showedNavigationWarning
					},
					A3($author$project$Shared$refreshFleetCmd, s.authToken, apiUrl, f.slug));
			} else {
				return _Utils_Tuple2(
					{
						apiUrl: useNewServer ? newApiUrl : apiUrl,
						locale: locale,
						bugsnag: $tremlab$bugsnag_elm$BugsnagElm$start(bugsnagConfig),
						session: $elm$core$Maybe$Just(s),
						fleetUrl: fleetUrl,
						newApiUrl: newApiUrl,
						oldApiUrl: apiUrl,
						bugsnagConfig: bugsnagConfig,
						selectedFleetId: $elm$core$Maybe$Nothing,
						featureDropState: featureDropState,
						defaultMapPosition: mapPosition,
						defaultTrackDuration: trackDuration,
						showedNavigationWarning: false
					},
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req));
			}
		} else {
			return _Utils_Tuple2(
				{
					apiUrl: useNewServer ? newApiUrl : apiUrl,
					locale: $enkidatron$elm_cldr$Cldr$Locale$en,
					bugsnag: $tremlab$bugsnag_elm$BugsnagElm$start(bugsnagConfig),
					session: $elm$core$Maybe$Nothing,
					fleetUrl: fleetUrl,
					newApiUrl: newApiUrl,
					oldApiUrl: apiUrl,
					bugsnagConfig: bugsnagConfig,
					selectedFleetId: $elm$core$Maybe$Nothing,
					featureDropState: featureDropState,
					defaultMapPosition: $elm$core$Maybe$Nothing,
					defaultTrackDuration: trackDuration,
					showedNavigationWarning: false
				},
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Effect$None = {$: 'None'};
var $author$project$Effect$none = $author$project$Effect$None;
var $author$project$Effect$Batch = function (a) {
	return {$: 'Batch', a: a};
};
var $author$project$Effect$batch = $author$project$Effect$Batch;
var $author$project$Pages$Home_$empty = {error: $elm$core$Maybe$Nothing, apiUrl: '', fleets: _List_Nil};
var $author$project$Gen$Route$Fleet_ = function (a) {
	return {$: 'Fleet_', a: a};
};
var $author$project$Effect$Cmd = function (a) {
	return {$: 'Cmd', a: a};
};
var $author$project$Effect$fromCmd = $author$project$Effect$Cmd;
var $author$project$Gen$Route$Forbidden = {$: 'Forbidden'};
var $author$project$Effect$Shared = function (a) {
	return {$: 'Shared', a: a};
};
var $author$project$Effect$fromShared = $author$project$Effect$Shared;
var $author$project$Api$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $author$project$Api$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $author$project$Api$Timeout = {$: 'Timeout'};
var $author$project$Api$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $author$project$Api$NetworkError = {$: 'NetworkError'};
var $author$project$Api$expectJson = function (decoder) {
	return A2(
		$elm$http$Http$expectStringResponse,
		$elm$core$Basics$identity,
		function (response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Api$BadUrl(url));
				case 'Timeout_':
					return $elm$core$Result$Err($author$project$Api$Timeout);
				case 'NetworkError_':
					return $elm$core$Result$Err($author$project$Api$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					var body = response.b;
					var message = $elm$core$Result$toMaybe(
						A2(
							$elm$json$Json$Decode$decodeString,
							A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
							body));
					return $elm$core$Result$Err(
						$author$project$Api$BadStatus(
							_Utils_Tuple2(metadata.statusCode, message)));
				default:
					var body = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (_v1.$ === 'Ok') {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$author$project$Api$BadBody(
								$elm$json$Json$Decode$errorToString(err)));
					}
			}
		});
};
var $author$project$Effect$PageMsg = function (a) {
	return {$: 'PageMsg', a: a};
};
var $author$project$Shared$SignOut = {$: 'SignOut'};
var $author$project$Effect$SharedMsg = function (a) {
	return {$: 'SharedMsg', a: a};
};
var $author$project$Effect$PushUrl = function (a) {
	return {$: 'PushUrl', a: a};
};
var $author$project$Effect$EitherCmd = function (a) {
	return {$: 'EitherCmd', a: a};
};
var $author$project$Effect$ReplaceUrl = function (a) {
	return {$: 'ReplaceUrl', a: a};
};
var $author$project$Effect$mapOrShared = F2(
	function (fn, effect) {
		switch (effect.$) {
			case 'None':
				return $author$project$Effect$None;
			case 'Cmd':
				var cmd = effect.a;
				return $author$project$Effect$EitherCmd(
					A2($elm$core$Platform$Cmd$map, fn, cmd));
			case 'Shared':
				var msg = effect.a;
				return $author$project$Effect$Shared(msg);
			case 'EitherCmd':
				var cmd = effect.a;
				return $author$project$Effect$EitherCmd(
					A2(
						$elm$core$Platform$Cmd$map,
						function (e) {
							if (e.$ === 'PageMsg') {
								var m = e.a;
								return fn(m);
							} else {
								var m = e.a;
								return $author$project$Effect$SharedMsg(m);
							}
						},
						cmd));
			case 'Batch':
				var list = effect.a;
				return $author$project$Effect$Batch(
					A2(
						$elm$core$List$map,
						$author$project$Effect$mapOrShared(fn),
						list));
			case 'PushUrl':
				var url = effect.a;
				return $author$project$Effect$PushUrl(url);
			default:
				var url = effect.a;
				return $author$project$Effect$ReplaceUrl(url);
		}
	});
var $author$project$Api$logoutIf401 = F2(
	function (toMsg, c) {
		return A2(
			$author$project$Effect$mapOrShared,
			function (r) {
				if (((r.$ === 'Err') && (r.a.$ === 'BadStatus')) && (r.a.a.a === 401)) {
					var _v1 = r.a.a;
					return $author$project$Effect$SharedMsg($author$project$Shared$SignOut);
				} else {
					return $author$project$Effect$PageMsg(
						toMsg(r));
				}
			},
			$author$project$Effect$fromCmd(c));
	});
var $author$project$Api$fetchFleets = F3(
	function (token, apiUrl, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Fleet$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Data$User$isNeboAdmin = function (user) {
	return user.isAdmin;
};
var $author$project$Shared$UseNewServer = function (a) {
	return {$: 'UseNewServer', a: a};
};
var $author$project$Pages$Home_$OnFetchFleets = function (a) {
	return {$: 'OnFetchFleets', a: a};
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$startProgressBar = _Platform_outgoingPort(
	'startProgressBar',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$sendPageViewEvent = _Platform_outgoingPort(
	'sendPageViewEvent',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Pages$Home_$init = F6(
	function (session, apiUrl, oldApiUrl, newApiUrl, fId, req) {
		if ($author$project$Data$User$isNeboAdmin(session.user)) {
			var _v0 = function () {
				var _v1 = A2($elm$core$Dict$get, 'server', req.query);
				_v1$2:
				while (true) {
					if (_v1.$ === 'Just') {
						switch (_v1.a) {
							case 'new':
								return _Utils_Tuple2(
									newApiUrl,
									$author$project$Effect$fromShared(
										$author$project$Shared$UseNewServer(true)));
							case 'old':
								return _Utils_Tuple2(
									oldApiUrl,
									$author$project$Effect$fromShared(
										$author$project$Shared$UseNewServer(false)));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return _Utils_Tuple2(apiUrl, $author$project$Effect$none);
			}();
			var url = _v0.a;
			var switchServerEffect = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					$author$project$Pages$Home_$empty,
					{apiUrl: url}),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A3($author$project$Api$fetchFleets, session.authToken, url, $author$project$Pages$Home_$OnFetchFleets),
							switchServerEffect,
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, 'Fleets')))
						])));
		} else {
			var _v2 = A2($author$project$Data$Session$defaultFleet, session, fId);
			if (_v2.$ === 'Just') {
				var f = _v2.a;
				return _Utils_Tuple2(
					$author$project$Pages$Home_$empty,
					$author$project$Effect$fromCmd(
						A2(
							$author$project$Request$pushRoute,
							$author$project$Gen$Route$Fleet_(
								{fleet: f.slug}),
							req)));
			} else {
				return _Utils_Tuple2(
					$author$project$Pages$Home_$empty,
					$author$project$Effect$fromCmd(
						A2($author$project$Request$pushRoute, $author$project$Gen$Route$Forbidden, req)));
			}
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$div = _VirtualDom_node('div');
var $lattyware$elm_fontawesome$FontAwesome$Internal$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$present = function (icon) {
	return $lattyware$elm_fontawesome$FontAwesome$Internal$Icon(
		{id: $elm$core$Maybe$Nothing, icon: icon, role: 'img', outer: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing, attributes: _List_Nil, transforms: _List_Nil});
};
var $lattyware$elm_fontawesome$FontAwesome$IconDef = F4(
	function (prefix, name, size, paths) {
		return {name: name, size: size, paths: paths, prefix: prefix};
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$penToSquare = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'pen-to-square',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$penToSquare = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$penToSquare);
var $lattyware$elm_fontawesome$FontAwesome$Solid$edit = $lattyware$elm_fontawesome$FontAwesome$Solid$penToSquare;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$plus = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'plus',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$plus = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$plus);
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $lattyware$elm_fontawesome$FontAwesome$Svg$fill = _List_fromArray(
	[
		$elm$svg$Svg$Attributes$x('0'),
		$elm$svg$Svg$Attributes$y('0'),
		$elm$svg$Svg$Attributes$width('100%'),
		$elm$svg$Svg$Attributes$height('100%')
	]);
var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');
var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$maskUnits = _VirtualDom_attribute('maskUnits');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $lattyware$elm_fontawesome$FontAwesome$Svg$viewPath = F2(
	function (attrs, d) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$d(d),
				attrs),
			_List_Nil);
	});
var $lattyware$elm_fontawesome$FontAwesome$Svg$viewPaths = F2(
	function (attrs, _v0) {
		var paths = _v0.paths;
		if (paths.b.$ === 'Nothing') {
			var only = paths.a;
			var _v2 = paths.b;
			return A2($lattyware$elm_fontawesome$FontAwesome$Svg$viewPath, attrs, only);
		} else {
			var secondary = paths.a;
			var primary = paths.b.a;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('fa-group')
					]),
				_List_fromArray(
					[
						A2(
						$lattyware$elm_fontawesome$FontAwesome$Svg$viewPath,
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$class('fa-secondary'),
							attrs),
						secondary),
						A2(
						$lattyware$elm_fontawesome$FontAwesome$Svg$viewPath,
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$class('fa-primary'),
							attrs),
						primary)
					]));
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize = 16;
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg = F3(
	function (containerWidth, iconWidth, transform) {
		var innerTranslate = 'translate(' + ($elm$core$String$fromFloat(transform.x * 32) + (',' + ($elm$core$String$fromFloat(transform.y * 32) + ') ')));
		var innerRotate = 'rotate(' + ($elm$core$String$fromFloat(transform.rotate) + ' 0 0)');
		var outer = 'translate(' + ($elm$core$String$fromFloat(containerWidth / 2) + ' 256)');
		var flipY = transform.flipY ? (-1) : 1;
		var scaleY = (transform.size / $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize) * flipY;
		var flipX = transform.flipX ? (-1) : 1;
		var scaleX = (transform.size / $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize) * flipX;
		var innerScale = 'scale(' + ($elm$core$String$fromFloat(scaleX) + (', ' + ($elm$core$String$fromFloat(scaleY) + ') ')));
		var path = 'translate(' + ($elm$core$String$fromFloat((iconWidth / 2) * (-1)) + ' -256)');
		return {
			path: $elm$svg$Svg$Attributes$transform(path),
			inner: $elm$svg$Svg$Attributes$transform(
				_Utils_ap(
					innerTranslate,
					_Utils_ap(innerScale, innerRotate))),
			outer: $elm$svg$Svg$Attributes$transform(outer)
		};
	});
var $elm$svg$Svg$Attributes$maskContentUnits = _VirtualDom_attribute('maskContentUnits');
var $lattyware$elm_fontawesome$FontAwesome$Svg$viewWithTransform = F3(
	function (color, _v0, icon) {
		var path = _v0.path;
		var inner = _v0.inner;
		var outer = _v0.outer;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[outer]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[inner]),
					_List_fromArray(
						[
							A2(
							$lattyware$elm_fontawesome$FontAwesome$Svg$viewPaths,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fill(color),
									path
								]),
							icon)
						]))
				]));
	});
var $lattyware$elm_fontawesome$FontAwesome$Internal$topLevelDimensions = function (_v1) {
	var outer = _v1.a.outer;
	var icon = _v1.a.icon;
	return A2(
		$elm$core$Maybe$withDefault,
		icon.size,
		A2($elm$core$Maybe$map, $lattyware$elm_fontawesome$FontAwesome$Internal$topLevelDimensionsInternal, outer));
};
var $lattyware$elm_fontawesome$FontAwesome$Internal$topLevelDimensionsInternal = function (_v0) {
	var outer = _v0.a.outer;
	var icon = _v0.a.icon;
	return A2(
		$elm$core$Maybe$withDefault,
		icon.size,
		A2($elm$core$Maybe$map, $lattyware$elm_fontawesome$FontAwesome$Internal$topLevelDimensions, outer));
};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$add = F2(
	function (transform, combined) {
		switch (transform.$) {
			case 'Scale':
				var by = transform.a;
				return _Utils_update(
					combined,
					{size: combined.size + by});
			case 'Reposition':
				var axis = transform.a;
				var by = transform.b;
				var _v1 = function () {
					if (axis.$ === 'Vertical') {
						return _Utils_Tuple2(0, by);
					} else {
						return _Utils_Tuple2(by, 0);
					}
				}();
				var x = _v1.a;
				var y = _v1.b;
				return _Utils_update(
					combined,
					{x: combined.x + x, y: combined.y + y});
			case 'Rotate':
				var rotation = transform.a;
				return _Utils_update(
					combined,
					{rotate: combined.rotate + rotation});
			default:
				var axis = transform.a;
				if (axis.$ === 'Vertical') {
					return _Utils_update(
						combined,
						{flipY: !combined.flipY});
				} else {
					return _Utils_update(
						combined,
						{flipX: !combined.flipX});
				}
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform = {x: 0, y: 0, size: $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$baseSize, flipX: false, flipY: false, rotate: 0};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$combine = function (transforms) {
	return A3($elm$core$List$foldl, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$add, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform, transforms);
};
var $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaningfulTransform = function (transforms) {
	var combined = $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$combine(transforms);
	return _Utils_eq(combined, $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaninglessTransform) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(combined);
};
var $lattyware$elm_fontawesome$FontAwesome$Svg$viewInColor = F2(
	function (color, fullIcon) {
		var outer = fullIcon.a.outer;
		var id = fullIcon.a.id;
		var transforms = fullIcon.a.transforms;
		var icon = fullIcon.a.icon;
		var combinedTransforms = $lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$meaningfulTransform(transforms);
		var _v0 = $lattyware$elm_fontawesome$FontAwesome$Internal$topLevelDimensions(fullIcon);
		var topLevelWidth = _v0.a;
		var _v1 = icon.size;
		var width = _v1.a;
		if (combinedTransforms.$ === 'Just') {
			var meaningfulTransform = combinedTransforms.a;
			var svgTransform = A3($lattyware$elm_fontawesome$FontAwesome$Transforms$Internal$transformForSvg, topLevelWidth, width, meaningfulTransform);
			if (outer.$ === 'Just') {
				var outerIcon = outer.a;
				return A4($lattyware$elm_fontawesome$FontAwesome$Svg$viewMaskedWithTransform, color, svgTransform, icon, outerIcon);
			} else {
				return A3($lattyware$elm_fontawesome$FontAwesome$Svg$viewWithTransform, color, svgTransform, icon);
			}
		} else {
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$Svg$viewPaths,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill(color)
					]),
				icon);
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Svg$viewMaskedWithTransform = F4(
	function (color, transforms, exclude, include) {
		var id = include.a.id;
		var alwaysId = A2($elm$core$Maybe$withDefault, '', id);
		var maskId = 'mask-' + alwaysId;
		var maskTag = A2(
			$elm$svg$Svg$mask,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$id(maskId),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$maskContentUnits('userSpaceOnUse'),
						$lattyware$elm_fontawesome$FontAwesome$Svg$fill))),
			_List_fromArray(
				[
					A2($lattyware$elm_fontawesome$FontAwesome$Svg$viewInColor, 'white', include),
					A3($lattyware$elm_fontawesome$FontAwesome$Svg$viewWithTransform, 'black', transforms, exclude)
				]));
		var clipId = 'clip-' + alwaysId;
		var rect = A2(
			$elm$svg$Svg$rect,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$fill(color),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$mask('url(#' + (maskId + ')')),
					$lattyware$elm_fontawesome$FontAwesome$Svg$fill)),
			_List_Nil);
		var defs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[maskTag]));
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[defs, rect]));
	});
var $lattyware$elm_fontawesome$FontAwesome$Svg$view = $lattyware$elm_fontawesome$FontAwesome$Svg$viewInColor('currentColor');
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $lattyware$elm_fontawesome$FontAwesome$internalView = F2(
	function (fullIcon, extraAttributes) {
		var attributes = fullIcon.a.attributes;
		var outer = fullIcon.a.outer;
		var title = fullIcon.a.title;
		var id = fullIcon.a.id;
		var role = fullIcon.a.role;
		var transforms = fullIcon.a.transforms;
		var icon = fullIcon.a.icon;
		var _v0 = $lattyware$elm_fontawesome$FontAwesome$Internal$topLevelDimensions(fullIcon);
		var width = _v0.a;
		var height = _v0.b;
		var contents = $lattyware$elm_fontawesome$FontAwesome$Svg$view(fullIcon);
		var _v1 = function () {
			if (title.$ === 'Just') {
				var givenTitle = title.a;
				var titleId = A2($elm$core$Maybe$withDefault, '', id) + '-title';
				return _Utils_Tuple2(
					A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', titleId),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$title,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(titleId)
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(givenTitle)
								])),
							contents
						]));
			} else {
				return _Utils_Tuple2(
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
					_List_fromArray(
						[contents]));
			}
		}();
		var semantics = _v1.a;
		var potentiallyTitledContents = _v1.b;
		var aspectRatio = $elm$core$Basics$ceiling((width / height) * 16);
		var classes = _List_fromArray(
			[
				'svg-inline--fa',
				'fa-' + icon.name,
				'fa-w-' + $elm$core$String$fromInt(aspectRatio)
			]);
		return A2(
			$elm$svg$Svg$svg,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'role', role),
							A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
							$elm$svg$Svg$Attributes$viewBox(
							'0 0 ' + ($elm$core$String$fromInt(width) + (' ' + $elm$core$String$fromInt(height)))),
							semantics
						]),
						A2($elm$core$List$map, $elm$svg$Svg$Attributes$class, classes),
						A2(
						$elm$core$List$map,
						$elm$html$Html$Attributes$map($elm$core$Basics$never),
						attributes),
						extraAttributes
					])),
			potentiallyTitledContents);
	});
var $lattyware$elm_fontawesome$FontAwesome$view = function (presentation) {
	return A2($lattyware$elm_fontawesome$FontAwesome$internalView, presentation, _List_Nil);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Views$Alert$view = F2(
	function (a, close) {
		if (a.$ === 'Just') {
			var alert = a.a;
			var alertClass = function () {
				var _v1 = alert.type_;
				switch (_v1.$) {
					case 'Info':
						return 'alert-info';
					case 'Success':
						return 'alert-success';
					case 'Warning':
						return 'alert-warning';
					default:
						return 'alert-danger';
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert alert-dismissible fade show ' + alertClass),
						A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view(alert.icon),
								$elm$html$Html$text(' '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(alert.title)
									])),
								$elm$html$Html$text(' '),
								$elm$html$Html$text(alert.message)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn-close'),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
								$elm$html$Html$Events$onClick(close)
							]),
						_List_Nil)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invisible')
					]),
				_List_Nil);
		}
	});
var $author$project$Gen$Route$Home_ = {$: 'Home_'};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Pages$Home_$Logout = {$: 'Logout'};
var $lattyware$elm_fontawesome$FontAwesome$styled = F2(
	function (attributes, _v0) {
		var presentation = _v0.a;
		return $lattyware$elm_fontawesome$FontAwesome$Internal$Icon(
			_Utils_update(
				presentation,
				{
					attributes: _Utils_ap(presentation.attributes, attributes)
				}));
	});
var $author$project$Gen$Route$Register = {$: 'Register'};
var $author$project$Pages$Home_$CloseError = {$: 'CloseError'};
var $author$project$Gen$Route$Fleet___Edit = function (a) {
	return {$: 'Fleet___Edit', a: a};
};
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$house = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'house',
	_Utils_Tuple2(576, 512),
	_Utils_Tuple2('M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$house = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$house);
var $lattyware$elm_fontawesome$FontAwesome$Solid$home = $lattyware$elm_fontawesome$FontAwesome$Solid$house;
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$user = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'user',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$user = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$user);
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 'Nothing') {
		return false;
	} else {
		return true;
	}
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Views$NewDot$view = function (show) {
	return show ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('featuredrop-dot'),
				A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('visually-hidden')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('New feature')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Html$Layout$sidebarKeyFor = function (route) {
	switch (route.$) {
		case 'Fleet___Boats':
			return $elm$core$Maybe$Just('vessels');
		case 'Fleet___Geofences':
			return $elm$core$Maybe$Just('geofences');
		case 'Fleet___Places':
			return $elm$core$Maybe$Just('places');
		case 'Fleet___Routes':
			return $elm$core$Maybe$Just('routes');
		case 'Fleet___Summary':
			return $elm$core$Maybe$Just('fleet-usage-monthly');
		case 'Fleet___DateRangeSummary':
			return $elm$core$Maybe$Just('fleet-usage-range');
		case 'Fleet___MonthlyUtilisation':
			return $elm$core$Maybe$Just('utilisation-monthly');
		case 'Fleet___WeeklyUtilisation':
			return $elm$core$Maybe$Just('utilisation-weekly');
		case 'Fleet___OnTime':
			return $elm$core$Maybe$Just('on-time-report');
		case 'Fleet___Edit':
			return $elm$core$Maybe$Just('fleet-config');
		case 'Fleet___Discovery':
			return $elm$core$Maybe$Just('discovery');
		case 'Fleet___Users':
			return $elm$core$Maybe$Just('fleet-users');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Html$Layout$isNewRoute = F2(
	function (newKeys, route) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (key) {
					return A2($elm$core$Set$member, key, newKeys);
				},
				$author$project$Html$Layout$sidebarKeyFor(route)));
	});
var $author$project$Html$Layout$htmlNavItem = F4(
	function (newKeys, content, route, currentRoute) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'nav-link text-nowrap' + (_Utils_eq(
								currentRoute,
								$elm$core$Maybe$Just(route)) ? ' active' : '')),
							$elm$html$Html$Attributes$href(
							$author$project$Gen$Route$toHref(route)),
							A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'collapse'),
							A2($elm$html$Html$Attributes$attribute, 'data-bs-target', '.navbar-collapse.show')
						]),
					_List_fromArray(
						[
							content,
							$author$project$Views$NewDot$view(
							A2($author$project$Html$Layout$isNewRoute, newKeys, route))
						]))
				]));
	});
var $author$project$Html$Layout$navItem = F4(
	function (newKeys, title, route, currentRoute) {
		return A4(
			$author$project$Html$Layout$htmlNavItem,
			newKeys,
			$elm$html$Html$text(title),
			route,
			currentRoute);
	});
var $elm$html$Html$sup = _VirtualDom_node('sup');
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$bell = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'bell',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$bell = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$bell);
var $author$project$FeatureDrop$Changelog$Dismiss = function (a) {
	return {$: 'Dismiss', a: a};
};
var $enkidatron$elm_cldr$Cldr$Format$Length$Medium = {$: 'Medium'};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$unwrap = F2(
	function (fun, withLiteral) {
		if (withLiteral.$ === 'Literal') {
			var words = withLiteral.a;
			return words;
		} else {
			var a = withLiteral.a;
			return fun(a);
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0.a;
	var y = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd));
	return {
		year: y,
		ordinalDay: rd - $justinmimbs$date$Date$daysBeforeYear(y)
	};
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {day: d, year: y, month: m};
			}
		}
	});
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0.a;
	var date = $justinmimbs$date$Date$toOrdinalDate(
		$justinmimbs$date$Date$RD(rd));
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.year, $elm$time$Time$Jan, date.ordinalDay);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.day;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $enkidatron$elm_cldr$Internal$Format$number = F2(
	function (numberWidth, num) {
		if (numberWidth.$ === 'MinimumDigits') {
			return $elm$core$String$fromInt(num);
		} else {
			return A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				A2(
					$elm$core$String$right,
					2,
					$elm$core$String$fromInt(num)));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDay = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			$justinmimbs$date$Date$day(date));
	});
var $enkidatron$elm_cldr$Internal$Format$era = F2(
	function (eraNames, yr) {
		return (yr > 0) ? eraNames.ad : eraNames.bc;
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatEraHelper = F2(
	function (eraNames, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$era,
			eraNames,
			$justinmimbs$date$Date$year(date));
	});
var $enkidatron$elm_cldr$Internal$Structures$getPattern3 = F2(
	function (pattern, textWidth) {
		switch (textWidth.$) {
			case 'Abbreviated':
				return pattern.abbreviated;
			case 'Wide':
				return pattern.wide;
			default:
				return pattern.narrow;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper = F3(
	function (formatFun, patterns, textWidth) {
		return formatFun(
			A2($enkidatron$elm_cldr$Internal$Structures$getPattern3, patterns, textWidth));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatEra = $enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper($enkidatron$elm_cldr$Cldr$Format$Date$formatEraHelper);
var $enkidatron$elm_cldr$Internal$Format$year = F2(
	function (numberWidth, yr) {
		var yearNum = (yr > 0) ? yr : ((yr * (-1)) + 1);
		return A2($enkidatron$elm_cldr$Internal$Format$number, numberWidth, yearNum);
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatYear = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			$justinmimbs$date$Date$year(date));
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.month;
	});
var $enkidatron$elm_cldr$Internal$Format$month = F2(
	function (monthNames, mnth) {
		switch (mnth.$) {
			case 'Jan':
				return monthNames.jan;
			case 'Feb':
				return monthNames.feb;
			case 'Mar':
				return monthNames.mar;
			case 'Apr':
				return monthNames.apr;
			case 'May':
				return monthNames.may;
			case 'Jun':
				return monthNames.jun;
			case 'Jul':
				return monthNames.jul;
			case 'Aug':
				return monthNames.aug;
			case 'Sep':
				return monthNames.sep;
			case 'Oct':
				return monthNames.oct;
			case 'Nov':
				return monthNames.nov;
			default:
				return monthNames.dec;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthHelper = F2(
	function (monthNames, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$month,
			monthNames,
			$justinmimbs$date$Date$month(date));
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthNumberHelper = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			$justinmimbs$date$Date$monthNumber(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatMonth = F2(
	function (monthPattern3, width) {
		if (width.$ === 'Text') {
			var textWidth = width.a;
			return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthHelper, monthPattern3, textWidth);
		} else {
			var numberWidth = width.a;
			return $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthNumberHelper(numberWidth);
		}
	});
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Mon;
		case 2:
			return $elm$time$Time$Tue;
		case 3:
			return $elm$time$Time$Wed;
		case 4:
			return $elm$time$Time$Thu;
		case 5:
			return $elm$time$Time$Fri;
		case 6:
			return $elm$time$Time$Sat;
		default:
			return $elm$time$Time$Sun;
	}
};
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $enkidatron$elm_cldr$Internal$Format$weekday = F2(
	function (weekdayNames, wkday) {
		switch (wkday.$) {
			case 'Mon':
				return weekdayNames.mon;
			case 'Tue':
				return weekdayNames.tue;
			case 'Wed':
				return weekdayNames.wed;
			case 'Thu':
				return weekdayNames.thu;
			case 'Fri':
				return weekdayNames.fri;
			case 'Sat':
				return weekdayNames.sat;
			default:
				return weekdayNames.sun;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatWeekdayHelper = F2(
	function (weekdayNames, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$weekday,
			weekdayNames,
			$justinmimbs$date$Date$weekday(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatWeekday = $enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper($enkidatron$elm_cldr$Cldr$Format$Date$formatWeekdayHelper);
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0.a;
	var wdn = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(rd));
	var wy = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd + (4 - wdn)));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		weekday: $justinmimbs$date$Date$numberToWeekday(wdn),
		weekYear: wy,
		weekNumber: 1 + (((rd - week1Day1) / 7) | 0)
	};
};
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekYear;
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatYearOfWeek = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			$justinmimbs$date$Date$weekYear(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatSymbol = F3(
	function (internal, date, symbol) {
		switch (symbol.$) {
			case 'Era':
				var textWidth = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatEra, internal.eraNames, textWidth, date);
			case 'Year':
				var numberWidth = symbol.a;
				return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatYear, numberWidth, date);
			case 'YearOfWeek':
				var numberWidth = symbol.a;
				return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatYearOfWeek, numberWidth, date);
			case 'Month':
				var width = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatMonth, internal.monthFormatNames, width, date);
			case 'MonthStandalone':
				var width = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatMonth, internal.monthStandaloneNames, width, date);
			case 'Weekday':
				var textWidth = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatWeekday, internal.weekdayFormatNames, textWidth, date);
			case 'WeekdayStandalone':
				var textWidth = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatWeekday, internal.weekdayStandaloneNames, textWidth, date);
			default:
				var numberWidth = symbol.a;
				return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatDay, numberWidth, date);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDate = F3(
	function (internal, symbols, date) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$unwrap(
					A2($enkidatron$elm_cldr$Cldr$Format$Date$formatSymbol, internal, date)),
				symbols));
	});
var $enkidatron$elm_cldr$Internal$Structures$getPattern = F2(
	function (patterns, length) {
		switch (length.$) {
			case 'Short':
				return patterns._short;
			case 'Medium':
				return patterns.medium;
			case 'Long':
				return patterns._long;
			default:
				return patterns.full;
		}
	});
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $enkidatron$elm_cldr$Internal$Options$removalPenalty = -120;
var $enkidatron$elm_cldr$Internal$Options$additionPenalty = -20;
var $enkidatron$elm_cldr$Internal$Options$longLessPenalty = -8;
var $enkidatron$elm_cldr$Internal$Options$longMorePenalty = -6;
var $enkidatron$elm_cldr$Internal$Options$shortLessPenalty = -6;
var $enkidatron$elm_cldr$Internal$Options$shortMorePenalty = -3;
var $enkidatron$elm_cldr$Internal$Options$scoreForDistance = function (distance) {
	return (distance >= 2) ? $enkidatron$elm_cldr$Internal$Options$longMorePenalty : ((distance === 1) ? $enkidatron$elm_cldr$Internal$Options$shortMorePenalty : ((!distance) ? 0 : (_Utils_eq(distance, -1) ? $enkidatron$elm_cldr$Internal$Options$shortLessPenalty : $enkidatron$elm_cldr$Internal$Options$longLessPenalty)));
};
var $enkidatron$elm_cldr$Internal$Options$score = F3(
	function (scoreFun, requested, candidate) {
		var _v0 = _Utils_Tuple2(requested, candidate);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return 0;
			} else {
				var _v4 = _v0.a;
				return $enkidatron$elm_cldr$Internal$Options$additionPenalty;
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v3 = _v0.b;
				return $enkidatron$elm_cldr$Internal$Options$removalPenalty;
			} else {
				var req = _v0.a.a;
				var can = _v0.b.a;
				return $enkidatron$elm_cldr$Internal$Options$scoreForDistance(
					scoreFun(can) - scoreFun(req));
			}
		}
	});
var $enkidatron$elm_cldr$Internal$Options$rankText = function (opt) {
	switch (opt.$) {
		case 'Narrow':
			return 2;
		case 'Short':
			return 3;
		default:
			return 4;
	}
};
var $enkidatron$elm_cldr$Internal$Options$rankNumber = function (opt) {
	if (opt.$ === 'TwoDigit') {
		return 0;
	} else {
		return 1;
	}
};
var $enkidatron$elm_cldr$Internal$Options$rankNumberOrText = function (opt) {
	if (opt.$ === 'Text') {
		var textOpt = opt.a;
		return $enkidatron$elm_cldr$Internal$Options$rankText(textOpt);
	} else {
		var numOpt = opt.a;
		return $enkidatron$elm_cldr$Internal$Options$rankNumber(numOpt);
	}
};
var $enkidatron$elm_cldr$Internal$Options$dateMatchScore = F2(
	function (requested, candidate) {
		return $elm$core$List$sum(
			_List_fromArray(
				[
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.era, candidate.era),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.year, candidate.year),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumberOrText, requested.month, candidate.month),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.day, candidate.day),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.weekday, candidate.weekday)
				]));
	});
var $enkidatron$elm_cldr$Internal$Locale$toDateAvailableFormat = function (af) {
	switch (af.$) {
		case 'DateAF':
			var format = af.a;
			return $elm$core$Maybe$Just(format);
		case 'DateTimeAF':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth = function (opt) {
	switch (opt.$) {
		case 'Short':
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated;
		case 'Long':
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Wide;
		default:
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Narrow;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth = function (opt) {
	if (opt.$ === 'Numeric') {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits;
	} else {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$width = function (opt) {
	if (opt.$ === 'Text') {
		var text = opt.a;
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Text(
			$enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth(text));
	} else {
		var number = opt.a;
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Number(
			$enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth(number));
	}
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 'Nothing') {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date = F2(
	function (requested, symbol) {
		switch (symbol.$) {
			case 'Era':
				var era = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Era(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, era, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.era));
			case 'Year':
				var year = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Year(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, year, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.year));
			case 'YearOfWeek':
				var year = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$YearOfWeek(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, year, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.year));
			case 'Month':
				var month = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Month(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, month, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$width, requested.month));
			case 'MonthStandalone':
				var month = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$MonthStandalone(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, month, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$width, requested.month));
			case 'Weekday':
				var weekday = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Weekday(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, weekday, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.weekday));
			case 'WeekdayStandalone':
				var weekday = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, weekday, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.weekday));
			default:
				var day = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Day(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, day, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.day));
		}
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral = F2(
	function (fun, withLiteral) {
		if (withLiteral.$ === 'Literal') {
			var words = withLiteral.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Literal(words);
		} else {
			var a = withLiteral.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Symbol(
				fun(a));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$expandFormatDateSymbols = F2(
	function (requested, formatSymbols) {
		return A2(
			$elm$core$List$map,
			$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
				$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date(requested)),
			formatSymbols);
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsFromOptions = F2(
	function (internal, requestedOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.formatSymbols;
					},
					$enkidatron$elm_cldr$Cldr$Format$Date$expandFormatDateSymbols(requestedOptions)),
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$dateMatchScore(requestedOptions)),
					A2($elm$core$List$filterMap, $enkidatron$elm_cldr$Internal$Locale$toDateAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsForType = F2(
	function (internal, formatType) {
		if (formatType.$ === 'WithLength') {
			var length = formatType.a;
			return A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateSymbols, length);
		} else {
			var options = formatType.a;
			return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsFromOptions, internal, options);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$format = F2(
	function (formatType, _v0) {
		var internal = _v0.a;
		return A2(
			$enkidatron$elm_cldr$Cldr$Format$Date$formatDate,
			internal,
			A2($enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsForType, internal, formatType));
	});
var $author$project$FeatureDrop$Changelog$typeName = function (featureType) {
	switch (featureType.$) {
		case 'Feature':
			return 'feature';
		case 'Improvement':
			return 'improvement';
		case 'Fix':
			return 'fix';
		default:
			return 'breaking';
	}
};
var $enkidatron$elm_cldr$Cldr$Format$Date$WithLength = function (a) {
	return {$: 'WithLength', a: a};
};
var $author$project$FeatureDrop$Changelog$versionLabel = function (version) {
	return A2(
		$elm$core$Maybe$andThen,
		function (v) {
			if (v.$ === 'VersionString') {
				var s = v.a;
				return $elm$core$Maybe$Just(s);
			} else {
				var range = v.a;
				var _v1 = range.introduced;
				if (_v1.$ === 'Just') {
					var s = _v1.a;
					return $elm$core$Maybe$Just(s);
				} else {
					return range.showNewUntil;
				}
			}
		},
		version);
};
var $author$project$FeatureDrop$Changelog$metaBits = F2(
	function (locale, feature) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (t) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('badge text-bg-light')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$FeatureDrop$Changelog$typeName(t))
								]));
					},
					feature.type_),
					A2(
					$elm$core$Maybe$map,
					function (c) {
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(c)
								]));
					},
					feature.category),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3(
									$enkidatron$elm_cldr$Cldr$Format$Date$format,
									$enkidatron$elm_cldr$Cldr$Format$Date$WithLength($enkidatron$elm_cldr$Cldr$Format$Length$Medium),
									locale,
									feature.releasedAt))
							]))),
					A2(
					$elm$core$Maybe$map,
					function (v) {
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('v' + v)
								]));
					},
					$author$project$FeatureDrop$Changelog$versionLabel(feature.version))
				]));
	});
var $author$project$FeatureDrop$Changelog$maybeHtml = F2(
	function (toHtml, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return toHtml(value);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 'Html', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 'Link', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 'Text', a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 'Text', a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 'Cdata', a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v0 = A5(_Parser_findSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v0.a;
			var newRow = _v0.b;
			var newCol = _v0.c;
			var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.src) : newOffset;
			return A3(
				$elm$parser$Parser$Advanced$Good,
				_Utils_cmp(s.offset, adjustedOffset) < 0,
				_Utils_Tuple0,
				{col: newCol, row: newRow, src: s.src, indent: s.indent, offset: adjustedOffset, context: s.context});
		});
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 'Element', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 'Comment', a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 'Declaration', a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c.valueOf()) {
		case ' ':
			return true;
		case '\r':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c.valueOf()) {
		case ' ':
			return false;
		case '\r':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (mValue.$ === 'Just') {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'amp',
			_Utils_chr('&')),
			_Utils_Tuple2(
			'lt',
			_Utils_chr('<')),
			_Utils_Tuple2(
			'gt',
			_Utils_chr('>')),
			_Utils_Tuple2(
			'apos',
			_Utils_chr('\'')),
			_Utils_Tuple2(
			'quot',
			_Utils_chr('"'))
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (maybe.$ === 'Just') {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char.valueOf()) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\u0022' + (str + '\u0022'), 'is not a valid hexadecimal string because', err]));
		};
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \u0022&' + (s + ';\u0022 found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (!_Utils_eq(
			c,
			_Utils_chr(';')));
	};
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (_v0.$ === 'Ok') {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (!_Utils_eq(
			c,
			_Utils_chr('&')));
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\u0022')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString(
					_Utils_chr('"')),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\u0022'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\u0027')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString(
					_Utils_chr('\'')),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\u0027')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{name: key, value: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(_Utils_Tuple0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c.valueOf()) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar(
			_Utils_chr('<'))),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(_Utils_Tuple0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, _Utils_Tuple0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 'ProcessingInstruction', a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
try {
	var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
	$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
		return $dillonkearns$elm_markdown$HtmlParser$html;
	};
	var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
	$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
		return $dillonkearns$elm_markdown$HtmlParser$element;
	};
} catch ($) {
	throw 'Some top-level definitions from `HtmlParser` are causing infinite recursion:\n\n  ┌─────┐\n  │    html\n  │     ↓\n  │    element\n  │     ↓\n  │    children\n  │     ↓\n  │    childrenStepOptions\n  │     ↓\n  │    elementContinuation\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $elm$core$String$trim = _String_trim;
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 'Cdata', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 'Image', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 'Table', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 'Table', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 'Table', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.index, rfirst.index) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C`+)'));
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = {$: 'Escaped'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 'CodeToken', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = {$: 'NotEscaped'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				index: regMatch.index + backslashesLength,
				length: $elm$core$String$length(backtick),
				meaning: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken($dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken($dillonkearns$elm_markdown$Markdown$InlineParser$Escaped)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\u005C\u005C+)|( {2,}))\u005Cn'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 'HardLineBreakToken'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.a.$ === 'Just') {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{index: (regMatch.index + backslashesLength) - 1, length: 2, meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (_v0.b.a.$ === 'Just')) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							index: regMatch.index,
							length: $elm$core$String$length(regMatch.match),
							meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.a.$ === 'Just') {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{index: regMatch.index + backslashesLength, length: 1, meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{index: (regMatch.index + backslashesLength) - 1, length: 2, meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							index: regMatch.index,
							length: $elm$core$String$length(regMatch.match),
							meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\u005C\u005C+)|( *))\u005Cn'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens = F3(
	function (tokensL, tokensR, countL) {
		cleanAngleBracketTokens:
		while (true) {
			if (!tokensR.b) {
				return _List_Nil;
			} else {
				var hd1 = tokensR.a;
				var rest1 = tokensR.b;
				if (!tokensL.b) {
					if (countL > 1) {
						var $temp$tokensL = tokensL,
							$temp$tokensR = rest1,
							$temp$countL = countL - 1;
						tokensL = $temp$tokensL;
						tokensR = $temp$tokensR;
						countL = $temp$countL;
						continue cleanAngleBracketTokens;
					} else {
						if (countL === 1) {
							return A2(
								$elm$core$List$cons,
								hd1,
								A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, tokensL, rest1, countL - 1));
						} else {
							var $temp$tokensL = tokensL,
								$temp$tokensR = rest1,
								$temp$countL = 0;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						}
					}
				} else {
					var hd = tokensL.a;
					var rest = tokensL.b;
					if (_Utils_cmp(hd.index, hd1.index) < 0) {
						if (!countL) {
							return A2(
								$elm$core$List$cons,
								hd,
								A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, rest, tokensR, countL + 1));
						} else {
							var $temp$tokensL = rest,
								$temp$tokensR = tokensR,
								$temp$countL = countL + 1;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						}
					} else {
						if (countL > 1) {
							var $temp$tokensL = tokensL,
								$temp$tokensR = rest1,
								$temp$countL = countL - 1;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						} else {
							if (countL === 1) {
								return A2(
									$elm$core$List$cons,
									hd1,
									A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, tokensL, rest1, countL - 1));
							} else {
								var $temp$tokensL = tokensL,
									$temp$tokensR = rest1,
									$temp$countL = 0;
								tokensL = $temp$tokensL;
								tokensR = $temp$tokensR;
								countL = $temp$countL;
								continue cleanAngleBracketTokens;
							}
						}
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C<)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 'AngleBracketOpen'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{index: regMatch.index + backslashesLength, length: 1, meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 'AngleBracketClose', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				index: regMatch.index + backslashesLength,
				length: 1,
				meaning: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose($dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose($dillonkearns$elm_markdown$Markdown$InlineParser$Escaped)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C!)?(\u005C[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = {$: 'Active'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 'LinkOpenToken', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 'ImageOpenToken'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (_v0.b.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.index + backslashesLength) + 1) : (regMatch.index + backslashesLength);
		if (isEscaped) {
			if (maybeImageOpen.$ === 'Just') {
				return $elm$core$Maybe$Just(
					{
						index: index,
						length: 1,
						meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken($dillonkearns$elm_markdown$Markdown$InlineParser$Active)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (maybeImageOpen.$ === 'Just') {
				return $elm$core$Maybe$Just(
					{index: index, length: 2, meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						index: index,
						length: 1,
						meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken($dillonkearns$elm_markdown$Markdown$InlineParser$Active)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 'StrikethroughToken', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken($dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken($dillonkearns$elm_markdown$Markdown$InlineParser$Escaped));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{index: regMatch.index + backslashesLength, length: length, meaning: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 'SquareBracketClose'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{index: regMatch.index + backslashesLength, length: 1, meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 'EmphasisToken', a: a, b: b};
	});
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c.valueOf()) {
		case ' ':
			return true;
		case '\f':
			return true;
		case '\n':
			return true;
		case '\r':
			return true;
		case '\t':
			return true;
		case '\u000b':
			return true;
		case ' ':
			return true;
		case ' ':
			return true;
		case ' ':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c.valueOf()) {
		case '!':
			return true;
		case '"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (mstring.$ === 'Just') {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.submatches;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (_v0.b.b.a.$ === 'Just')) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var backslashesLength = function () {
				if (maybeBackslashes.$ === 'Just') {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var leftFringeLength = function () {
				if (maybeLeftFringe.$ === 'Just') {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var mLeftFringe = ((!(!regMatch.index)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.index - 1, regMatch.index, rawText)) : maybeLeftFringe;
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((mLeftFringe.$ === 'Just') && (mLeftFringe.a === '\u005C')) {
					return true;
				} else {
					return false;
				}
			}();
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			if ((delimiterLength <= 0) || (_Utils_eq(
				_char,
				_Utils_chr('_')) && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.index + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						index: index,
						length: delimiterLength,
						meaning: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{leftFringeRank: lFringeRank, rightFringeRank: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)([^*])?(\u005C*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken,
			_Utils_chr('*'),
			str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)([^_])?(\u005C_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken,
			_Utils_chr('_'),
			str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.index;
				},
				$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText)),
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.index;
				},
				$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText)),
			0),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
								$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = function (a) {
	return {$: 'Match', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			{end: childMatch.end - parentMatch.textStart, text: childMatch.text, start: childMatch.start - parentMatch.textStart, type_: childMatch.type_, matches: childMatch.matches, textEnd: childMatch.textEnd - parentMatch.textStart, textStart: childMatch.textStart - parentMatch.textStart});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			{
				end: parentMatch.end,
				text: parentMatch.text,
				start: parentMatch.start,
				type_: parentMatch.type_,
				matches: A2(
					$elm$core$List$cons,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
					parentMatch.matches),
				textEnd: parentMatch.textEnd,
				textStart: parentMatch.textStart
			});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v3 = A2(
		$elm$core$List$sortBy,
		function (_v4) {
			var match = _v4.a;
			return match.start;
		},
		matches);
	if (!_v3.b) {
		return _List_Nil;
	} else {
		var first = _v3.a;
		var rest = _v3.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v2) {
	var match = _v2.a;
	return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
		{
			end: match.end,
			text: match.text,
			start: match.start,
			type_: match.type_,
			matches: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.matches),
			textEnd: match.textEnd,
			textStart: match.textStart
		});
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0.a;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(
						$dillonkearns$elm_markdown$Markdown$InlineParser$Match(prevMatch)),
					matchesTail);
			} else {
				var match = remaining.a.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.end, match.start) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = $dillonkearns$elm_markdown$Markdown$InlineParser$Match(match),
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(
							$dillonkearns$elm_markdown$Markdown$InlineParser$Match(prevMatch)),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.start, match.start) < 0) && (_Utils_cmp(prevMatch.end, match.end) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = $dillonkearns$elm_markdown$Markdown$InlineParser$Match(prevMatch),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (result.$ === 'Ok') {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 'CodeType'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 'HtmlType', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = {$: 'Inactive'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 'LinkType', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 'ImageType', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 'HtmlToken', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.offset, s);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = {$: 'NotOpening'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0.a;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {length: endOffset - startOffset, htmlTag: htmlTag};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.start, rawText));
		if (parsed.$ === 'Ok') {
			var length = parsed.a.length;
			var htmlTag = parsed.a.htmlTag;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening, htmlTag);
			return $elm$core$Maybe$Just(
				{index: match.start, length: length, meaning: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 'EmphasisType', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			{end: token.index + token.length, text: '', start: token.index, type_: type_, matches: _List_Nil, textEnd: 0, textStart: 0});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 'HardLineBreakType'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F2(
	function (remaining, matches) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.meaning;
				if (_v1.$ === 'HardLineBreakToken') {
					var $temp$remaining = tokensTail,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches);
					remaining = $temp$remaining;
					matches = $temp$matches;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$matches = matches;
					remaining = $temp$remaining;
					matches = $temp$matches;
					continue lineBreakTTM;
				}
			}
		}
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\u005C-]{1,31}:[^<>\u005Cx00-\u005Cx20]*)$'));
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.match,
				$elm$url$Url$percentDecode(match.match));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 'AutolinkType', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0.a;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.text) ? $elm$core$Result$Ok(
		$dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				match,
				{
					type_: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
						_Utils_Tuple2(
							match.text,
							$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.text)))
				}))) : $elm$core$Result$Err(
		$dillonkearns$elm_markdown$Markdown$InlineParser$Match(match));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.meaning;
		if (_v0.$ === 'CodeToken') {
			if (_v0.a.$ === 'Escaped') {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.length - 1, closeToken.length);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.length, closeToken.length);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 'StrikethroughType'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.meaning;
		if (_v0.$ === 'EmphasisToken') {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.meaning;
			if (_v1.$ === 'EmphasisToken') {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.leftFringeRank, open.rightFringeRank) || _Utils_eq(close.leftFringeRank, close.rightFringeRank)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.length + openToken.length))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.length)) && (!A2($elm$core$Basics$modBy, 3, openToken.length)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.index, match.end) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\u0027*+\u005C/=?^_`{|}~\u005C-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\u005C-]{0,61}[a-zA-Z0-9])?(?:\u005C.[a-zA-Z0-9](?:[a-zA-Z0-9\u005C-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0.a;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.text) ? $elm$core$Result$Ok(
		$dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				match,
				{
					type_: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
						_Utils_Tuple2(
							match.text,
							'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.text)))
				}))) : $elm$core$Result$Err(
		$dillonkearns$elm_markdown$Markdown$InlineParser$Match(match));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = closeToken.meaning;
			if (_v1.$ === 'StrikethroughToken') {
				if (_v1.a.$ === 'Escaped') {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, closeToken.length - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, closeToken.length);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v0.a;
		var closeTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = openToken.meaning;
			if (_v5.$ === 'StrikethroughToken') {
				if (_v5.a.$ === 'Escaped') {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, openToken.length - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, openToken.length);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v4.a;
		var openTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.meaning;
	switch (_v0.$) {
		case 'LinkOpenToken':
			return true;
		case 'ImageOpenToken':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0.a;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1.a;
				return (_Utils_cmp(match.end, testMatch.start) > 0) && (_Utils_cmp(match.end, testMatch.end) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$List$cons,
				$dillonkearns$elm_markdown$Markdown$InlineParser$Match(match),
				remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\u005C[\u005C]\u005C\u005C]*(?:\u005C\u005C.[^\u005C[\u005C]\u005C\u005C]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\u005C[\u005Cs*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\u005Cs*\u005C]')));
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.submatches;
	if (_v0.b && (_v0.a.$ === 'Just')) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (_v1.$ === 'Just') {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.match;
		}
	} else {
		return match.match;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.submatches;
	if (_v0.b && (_v0.a.$ === 'Just')) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (_v1.$ === 'Just') {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.match;
		}
	} else {
		return match.match;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C+)([!\u0022#$%&\u005C\u0027()*+,./:;<=>?@[\u005C\u005C\u005C]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.submatches;
		if (((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\u005C'),
				escapedStr);
		} else {
			return regexMatch.match;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.submatches;
	if (_v0.b && (_v0.a.$ === 'Just')) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.match;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.text : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.text,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.submatches;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var regexMatchLength = function () {
				if (maybeRegexMatch.$ === 'Just') {
					var match = maybeRegexMatch.a.match;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			var type_ = function () {
				var _v2 = matchModel.type_;
				if (_v2.$ === 'ImageType') {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			return $elm$core$Maybe$Just(
				$dillonkearns$elm_markdown$Markdown$InlineParser$Match(
					_Utils_update(
						matchModel,
						{end: matchModel.end + regexMatchLength, type_: type_})));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0.a;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\u005Cf\u005Cv\u005Cr\u005Cn';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \u005Ct\u005Cf\u005Cv\u005Cr\u005Cn';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\u005C(\u005C)\u005C\u005C]*(?:\u005C\u005C.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\u005C(\u005C)\u005C\u005C]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\u0027([^\u0027\u005C\u005C]*(?:\u005C\u005C.[^\u0027\u005C\u005C]*)*)\u0027|' + ('\u0022([^\u0022\u005C\u005C]*(?:\u005C\u005C.[^\u0022\u005C\u005C]*)*)\u0022|' + '\u005C(([^\u005C)\u005C\u005C]*(?:\u005C\u005C.[^\u005C)\u005C\u005C]*)*)\u005C)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\u005C(\u005Cs*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\u005Cs*\u005C)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (maybeFound.$ === 'Just') {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.submatches;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
					_Utils_update(
						matchModel,
						{
							end: matchModel.end + $elm$core$String$length(regexMatch.match),
							type_: function () {
								var _v5 = matchModel.type_;
								if (_v5.$ === 'ImageType') {
									return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
								} else {
									return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
								}
							}()(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
						}));
			};
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0.a;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (_v2.$ === 'Just') {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3(
					$dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences,
					remainText,
					$dillonkearns$elm_markdown$Markdown$InlineParser$Match(tempMatch),
					refs);
			}
		} else {
			return A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences,
				remainText,
				$dillonkearns$elm_markdown$Markdown$InlineParser$Match(tempMatch),
				refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v45) {
		var openToken = _v45.a;
		var remainTokens = _v45.c;
		var updatedOpenToken = function () {
			var _v46 = openToken.meaning;
			if ((_v46.$ === 'CodeToken') && (_v46.a.$ === 'Escaped')) {
				var _v47 = _v46.a;
				return _Utils_update(
					openToken,
					{index: openToken.index + 1, length: openToken.length - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v40 = token.meaning;
				if (_v40.$ === 'EmphasisToken') {
					var _char = _v40.a;
					var rightFringeRank = _v40.b.rightFringeRank;
					var leftFringeRank = _v40.b.leftFringeRank;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((!_Utils_eq(
							_char,
							_Utils_chr('_'))) || (rightFringeRank === 1))) {
							var _v41 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (_v41.$ === 'Just') {
								var found = _v41.a;
								var _v42 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v42.a;
								var match = _v42.b;
								var newTokens = _v42.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v43 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (_v43.$ === 'Just') {
								var found = _v43.a;
								var _v44 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v44.a;
								var match = _v44.b;
								var newTokens = _v44.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v37 = token.meaning;
				if (_v37.$ === 'HtmlToken') {
					var isOpen = _v37.a;
					var htmlModel = _v37.b;
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
							token,
							$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
						matches),
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v35) {
		var openToken = _v35.a;
		var innerTokens = _v35.b;
		var remainTokens = _v35.c;
		var remainLength = openToken.length - closeToken.length;
		var updt = (!remainLength) ? {openToken: openToken, closeToken: closeToken, tokensTail: tokensTail, remainTokens: remainTokens} : ((remainLength > 0) ? {
			openToken: _Utils_update(
				openToken,
				{index: openToken.index + remainLength, length: closeToken.length}),
			closeToken: closeToken,
			tokensTail: tokensTail,
			remainTokens: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{length: remainLength}),
				remainTokens)
		} : {
			openToken: openToken,
			closeToken: _Utils_update(
				closeToken,
				{length: openToken.length}),
			tokensTail: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{index: closeToken.index + openToken.length, length: -remainLength}),
				tokensTail),
			remainTokens: remainTokens
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.openToken.length),
			updt.openToken,
			updt.closeToken,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.tokensTail, match, updt.remainTokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v31 = token.meaning;
				if (_v31.$ === 'SquareBracketClose') {
					var _v32 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (_v32.$ === 'Just') {
						var found = _v32.a;
						var _v33 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (_v33.$ === 'Just') {
							var _v34 = _v33.a;
							var x = _v34.a;
							var newMatches = _v34.b;
							var newTokens = _v34.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					matches);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v27 = token.meaning;
				if (_v27.$ === 'StrikethroughToken') {
					var _v28 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (_v28.$ === 'Just') {
						var content = _v28.a;
						var _v29 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v29.a;
						var newMatches = _v29.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.index + openToken.length;
		var textEnd = closeToken.index;
		var start = openToken.index;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var end = closeToken.index + closeToken.length;
		var match = {end: end, text: text, start: start, type_: type_, matches: _List_Nil, textEnd: textEnd, textStart: textStart};
		var matches = A2(
			$elm$core$List$map,
			function (_v25) {
				var matchModel = _v25.a;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			{end: end, text: text, start: start, type_: type_, matches: matches, textEnd: textEnd, textStart: textStart});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v21) {
		var openToken = _v21.a;
		var remainTokens = _v21.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 'Err') {
			var tempMatch = result.a;
			if (escaped.$ === 'NotEscaped') {
				var _v24 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (_v24.$ === 'Just') {
					var newToken = _v24.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v18) {
		var openToken = _v18.a;
		var remainTokens = _v18.c;
		var updatedOpenToken = function () {
			var _v19 = openToken.meaning;
			if ((_v19.$ === 'StrikethroughToken') && (_v19.a.$ === 'Escaped')) {
				var _v20 = _v19.a;
				return _Utils_update(
					openToken,
					{index: openToken.index + 1, length: openToken.length - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v9) {
		var openToken = _v9.a;
		var innerTokens = _v9.b;
		var remainTokens = _v9.c;
		var inactivateLinkOpenToken = function (token) {
			var _v17 = token.meaning;
			if (_v17.$ === 'LinkOpenToken') {
				return _Utils_update(
					token,
					{
						meaning: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken($dillonkearns$elm_markdown$Markdown$InlineParser$Inactive)
					});
			} else {
				return token;
			}
		};
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var remainText = A2($elm$core$String$dropLeft, closeToken.index + 1, rawText);
		var _v10 = openToken.meaning;
		switch (_v10.$) {
			case 'ImageOpenToken':
				var tempMatch = findTempMatch(false);
				var _v11 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v11.$ === 'Nothing') {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v11.a;
					var _v12 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (_v12.$ === 'Just') {
						var matches = _v12.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 'LinkOpenToken':
				if (_v10.a.$ === 'Active') {
					var _v13 = _v10.a;
					var tempMatch = findTempMatch(true);
					var _v14 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v14.$ === 'Nothing') {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v14.a;
						var _v15 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (_v15.$ === 'Just') {
							var matches = _v15.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v16 = _v10.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.meaning;
				switch (_v1.$) {
					case 'CodeToken':
						var _v2 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (_v2.$ === 'Just') {
							var code = _v2.a;
							var _v3 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v3.a;
							var newMatches = _v3.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 'AngleBracketClose':
						var isEscaped = _v1.a;
						var isAngleBracketOpen = function (_v8) {
							var meaning = _v8.meaning;
							if (meaning.$ === 'AngleBracketOpen') {
								return true;
							} else {
								return false;
							}
						};
						var _v4 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (_v4.$ === 'Just') {
							var found = _v4.a;
							var _v5 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (_v5.$ === 'Just') {
								var _v6 = _v5.a;
								var newTokens = _v6.a;
								var newMatches = _v6.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 'Link', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 'Text', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 'Image', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 'Emphasis', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 'CodeInline', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 'HtmlInline', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 'HardLineBreak'};
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 'Strikethrough', a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0.a;
	var _v1 = match.type_;
	switch (_v1.$) {
		case 'NormalType':
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.text);
		case 'HardLineBreakType':
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 'CodeType':
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.text);
		case 'AutolinkType':
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 'LinkType':
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
		case 'ImageType':
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
		case 'HtmlType':
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 'EmphasisType':
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 'NormalType'};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
		{
			end: 0,
			text: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
			start: 0,
			type_: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType,
			matches: _List_Nil,
			textEnd: 0,
			textStart: 0
		});
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2.a;
		var updtMatch = $dillonkearns$elm_markdown$Markdown$InlineParser$Match(
			{
				end: matchModel.end,
				text: matchModel.text,
				start: matchModel.start,
				type_: matchModel.type_,
				matches: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.text, _List_Nil, matchModel.matches),
				textEnd: matchModel.textEnd,
				textStart: matchModel.textStart
			});
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.end, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a.a;
			var _v4 = matchHead.type_;
			if (_v4.$ === 'NormalType') {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.end, matchHead.start) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.end, matchHead.start) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.end, matchHead.start, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a.a;
					return (matchModel.start > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.start, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = {$: 'NoTask'};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 'Strong', a: a};
};
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char.valueOf()) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u000A',
	$elm$parser$Parser$Expecting('a newline'));
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u000D',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
					])))
		]));
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = {$: 'ThematicBreak'};
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$ThematicBreak$ThematicBreak),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar(
			_Utils_chr('-')),
			$dillonkearns$elm_markdown$ThematicBreak$withChar(
			_Utils_chr('*')),
			$dillonkearns$elm_markdown$ThematicBreak$withChar(
			_Utils_chr('_'))
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u0009',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c.valueOf()) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return _Utils_eq(
			c,
			_Utils_chr(' ')) || (_Utils_eq(
			c,
			_Utils_chr('\n')) || _Utils_eq(
			c,
			_Utils_chr('\r')));
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 'Heading', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = function (a) {
	return {$: 'UnparsedInlines', a: a};
};
var $elm$core$String$trimRight = _String_trimRight;
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	dropTrailingHashes:
	while (true) {
		if (A2($elm$core$String$endsWith, '#', headingString)) {
			var $temp$headingString = A2($elm$core$String$dropRight, 1, headingString);
			headingString = $temp$headingString;
			continue dropTrailingHashes;
		} else {
			return headingString;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char.valueOf()) {
		case '\n':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\u0027s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines('')),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(
								$dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
									$elm$core$String$trim(headingText)));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {body: body, language: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.kind;
	if (_v0.$ === 'Backtick') {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (!_Utils_eq(
						c,
						_Utils_chr('`'))) && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = {$: 'Tilde'};
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {
	_char: _Utils_chr('~'),
	kind: $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde,
	token: $dillonkearns$elm_markdown$Parser$Token$tilde
};
var $elm$parser$Parser$Advanced$getCol = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.col, s);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = {$: 'Backtick'};
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \u0027`\u0027'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {
	_char: _Utils_chr('`'),
	kind: $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick,
	token: $dillonkearns$elm_markdown$Parser$Token$backtick
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.token)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter._char))));
	});
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
					]))),
			$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {length: length, indented: indent, character: character};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $elm$parser$Parser$Advanced$getSource = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.src, s);
	});
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(
	_Utils_chr(' '));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(_Utils_Tuple0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.length, fence.character))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.indented)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.character),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {col: col, row: row, context: context};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {col: s.col, row: s.row, src: s.src, indent: s.indent, offset: s.offset, context: newContext};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(
					A2(
						$elm$parser$Parser$Advanced$changeContext,
						A2(
							$elm$core$List$cons,
							A3($elm$parser$Parser$Advanced$Located, s0.row, s0.col, context),
							s0.context),
						s0));
				if (_v1.$ === 'Good') {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						a,
						A2($elm$parser$Parser$Advanced$changeContext, s0.context, s1));
				} else {
					var step = _v1;
					return step;
				}
			});
	});
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u0022',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u0027',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\u000A\u000A', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char.valueOf()) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000b':
			return true;
		case '\f':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{title: title, destination: destination});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 'Heading', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 'CodeSpan', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 'Emphasis', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 'ListItem', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 'BlankLine'};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 'CodeBlock', a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 'CodeBlock', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 'HtmlBlock', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 'Paragraph', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $dillonkearns$elm_markdown$Markdown$Block$H1 = {$: 'H1'};
var $dillonkearns$elm_markdown$Markdown$Block$H2 = {$: 'H2'};
var $dillonkearns$elm_markdown$Markdown$Block$H3 = {$: 'H3'};
var $dillonkearns$elm_markdown$Markdown$Block$H4 = {$: 'H4'};
var $dillonkearns$elm_markdown$Markdown$Block$H5 = {$: 'H5'};
var $dillonkearns$elm_markdown$Markdown$Block$H6 = {$: 'H6'};
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok($dillonkearns$elm_markdown$Markdown$Block$H1);
		case 2:
			return $elm$core$Result$Ok($dillonkearns$elm_markdown$Markdown$Block$H2);
		case 3:
			return $elm$core$Result$Ok($dillonkearns$elm_markdown$Markdown$Block$H3);
		case 4:
			return $elm$core$Result$Ok($dillonkearns$elm_markdown$Markdown$Block$H4);
		case 5:
			return $elm$core$Result$Ok($dillonkearns$elm_markdown$Markdown$Block$H5);
		case 6:
			return $elm$core$Result$Ok($dillonkearns$elm_markdown$Markdown$Block$H6);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\u0027s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 'BlockQuote', a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 'BlockQuote', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 'EmptyBlock'};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 'HtmlInline', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 'HtmlComment', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 'HtmlElement', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 'OrderedList', a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 'ParsedBlock', a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\u000A')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\u000A')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\u005C\u005C|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\u005C'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\u005C\u005C')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\u005C|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = function (a) {
	return {$: 'TableHeader', a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {label: headerCell, alignment: alignment};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				$dillonkearns$elm_markdown$Markdown$Table$TableHeader(
					headersWithAlignment(headers))) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (_v1.$ === 'Ok') {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (result.$ === 'Ok') {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			rawBlocks: state.rawBlocks,
			linkReferenceDefinitions: A2($elm$core$List$cons, linkRef, state.linkReferenceDefinitions)
		};
	});
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = {$: 'CompletedTask'};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 'HardLineBreak'};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 'InlineProblem', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 'Strikethrough', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 'ThematicBreak'};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 'ThematicBreak'};
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 'UnorderedList', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = {$: 'IncompleteTask'};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 'HtmlDeclaration', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 'Expecting':
			var string = problem.a;
			return 'Expecting ' + string;
		case 'ExpectingInt':
			return 'Expecting int';
		case 'ExpectingHex':
			return 'Expecting hex';
		case 'ExpectingOctal':
			return 'Expecting octal';
		case 'ExpectingBinary':
			return 'Expecting binary';
		case 'ExpectingFloat':
			return 'Expecting float';
		case 'ExpectingNumber':
			return 'Expecting number';
		case 'ExpectingVariable':
			return 'Expecting variable';
		case 'ExpectingSymbol':
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 'ExpectingKeyword':
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 'ExpectingEnd':
			return 'Expecting keyword end';
		case 'UnexpectedChar':
			return 'Unexpected char';
		case 'Problem':
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.row) + ('\u000A' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.problem)));
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 'OrderedListBlock', a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 'ParsedBlockQuote', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\u000A',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {body: body, order: order, marker: marker, intended: intended};
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = {$: 'Dot'};
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = {$: 'Paren'};
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$OrderedList$Dot),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$OrderedList$Paren),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.intended, item.marker, item.order, _List_Nil, item.body);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = {$: 'LevelOne'};
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = {$: 'LevelTwo'};
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 'SetextLine', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(
								setextLevel,
								$dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne,
								$dillonkearns$elm_markdown$Parser$Token$equals,
								_Utils_chr('=')),
								A3(
								setextLevel,
								$dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo,
								$dillonkearns$elm_markdown$Parser$Token$minus,
								_Utils_chr('-'))
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 'IndentedCodeBlock', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 'TableDelimiterRow', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \u0009',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \u0009',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 'UnorderedListBlock', a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 'TaskItem', a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 'EmptyItem'};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 'PlainItem', a: a};
};
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 'TaskItem':
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 'PlainItem':
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = {$: 'Plus'};
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = {$: 'Minus'};
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = {$: 'Asterisk'};
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$Minus),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$Plus),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = {$: 'Complete'};
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = {$: 'Incomplete'};
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$Complete),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$Complete),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$Incomplete),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F2(
		function (listmarker, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 'TaskItem':
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						body: body,
						task: $elm$core$Maybe$Just(
							function () {
								if (completion.$ === 'Complete') {
									return true;
								} else {
									return false;
								}
							}()),
						marker: listmarker
					};
				case 'PlainItem':
					var body = unparsedListItem.a;
					return {body: body, task: $elm$core$Maybe$Nothing, marker: listmarker};
				default:
					return {body: '', task: $elm$core$Maybe$Nothing, marker: listmarker};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A2(parseListItem, listmarker, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 'OpenBlockOrParagraph', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 'ProcessingInstruction', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\u000A' + string2);
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0.$) {
			case 'LT':
				return A2($elm$core$List$take, expectedLength, row);
			case 'EQ':
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = {$: 'Loose'};
var $dillonkearns$elm_markdown$Markdown$Block$Tight = {$: 'Tight'};
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? $dillonkearns$elm_markdown$Markdown$Block$Tight : $dillonkearns$elm_markdown$Markdown$Block$Loose;
};
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(rawLine));
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph = function (block) {
	endWithOpenBlockOrParagraph:
	while (true) {
		switch (block.$) {
			case 'OpenBlockOrParagraph':
				var str = block.a.a;
				return !A2($elm$core$String$endsWith, str, '\u000A');
			case 'ParsedBlockQuote':
				var blocks = block.a;
				if (blocks.b) {
					var last = blocks.a;
					var $temp$block = last;
					block = $temp$block;
					continue endWithOpenBlockOrParagraph;
				} else {
					return false;
				}
			case 'OrderedListBlock':
				var blockslist = block.e;
				if (blockslist.b) {
					var blocks = blockslist.a;
					if (blocks.b) {
						var last = blocks.a;
						var $temp$block = last;
						block = $temp$block;
						continue endWithOpenBlockOrParagraph;
					} else {
						return false;
					}
				} else {
					return false;
				}
			case 'Heading':
				return true;
			default:
				return false;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 'TableDelimiter', a: a};
};
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\u000A'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\u000A')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return _Utils_eq(
												c,
												_Utils_chr(':'));
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return _Utils_eq(
											c,
											_Utils_chr('-'));
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return _Utils_eq(
										c,
										_Utils_chr(':'));
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = {$: 'AlignLeft'};
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = {$: 'AlignRight'};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = {$: 'AlignCenter'};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Block$AlignCenter);
		} else {
			return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Block$AlignLeft);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Block$AlignRight);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.trimmed;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						raw: delimiterText,
						trimmed: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || _Utils_eq(
							c,
							_Utils_chr('-'));
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\u005C',
							$elm$parser$Parser$Expecting('\u005C'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
					$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(rawLine));
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v105 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v105.$ === 'Err') {
		var e = _v105.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v105.a;
		var _v106 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v106.$ === 'Err') {
			var e = _v106.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v106.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 'Paragraph') && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 'Text':
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 'HardLineBreak':
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 'CodeInline':
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 'Link':
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 'Image':
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 'HtmlInline':
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 'Emphasis':
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 'Heading':
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v93 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (_v93.$ === 'Ok') {
					var parsedLevel = _v93.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v93.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 'OpenBlockOrParagraph':
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 'Html':
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 'UnorderedListBlock':
				var tight = rawBlock.a;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (rawBlockTask.$ === 'Just') {
								if (!rawBlockTask.a) {
									return $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask;
								} else {
									return $dillonkearns$elm_markdown$Markdown$Block$CompletedTask;
								}
							} else {
								return $dillonkearns$elm_markdown$Markdown$Block$NoTask;
							}
						}();
						var blocks = function () {
							var _v94 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{rawBlocks: rawBlocks, linkReferenceDefinitions: linkReferences});
							if (_v94.$ === 'Ok') {
								var parsedBlocks = _v94.a;
								return parsedBlocks;
							} else {
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.task, item.body);
								},
								unparsedItems))));
			case 'OrderedListBlock':
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v96 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{rawBlocks: rawBlocks, linkReferenceDefinitions: linkReferences});
					if (_v96.$ === 'Ok') {
						var parsedBlocks = _v96.a;
						return parsedBlocks;
					} else {
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 'CodeBlock':
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 'ThematicBreak':
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 'BlankLine':
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 'BlockQuote':
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 'ParsedBlockQuote':
				var rawBlocks = rawBlock.a;
				var _v97 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{rawBlocks: rawBlocks, linkReferenceDefinitions: linkReferences});
				if (_v97.$ === 'Ok') {
					var parsedBlocks = _v97.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v97.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 'IndentedCodeBlock':
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{body: codeBlockBody, language: $elm$core$Maybe$Nothing}));
			case 'Table':
				var _v98 = rawBlock.a;
				var header = _v98.a;
				var rows = _v98.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 'TableDelimiter':
				var _v99 = rawBlock.a;
				var text = _v99.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2(
							$dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper,
							linkReferences,
							$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(text.raw))));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2(
							$dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper,
							linkReferences,
							$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(raw))));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v78) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v79 = revStmts.rawBlocks;
				_v79$6:
				while (true) {
					if (_v79.b) {
						switch (_v79.a.$) {
							case 'OpenBlockOrParagraph':
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 'Table':
								var table = _v79.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 'UnorderedListBlock':
								var _v80 = _v79.a;
								var tight = _v80.a;
								var intended = _v80.b;
								var closeListItems = _v80.c;
								var openListItem = _v80.d;
								var rest = _v79.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	body: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.body, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																body: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\u000A', openListItem.body, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v81) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\u000A');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 'OrderedListBlock':
								var _v86 = _v79.a;
								var tight = _v86.a;
								var intended = _v86.b;
								var marker = _v86.c;
								var order = _v86.d;
								var closeListItems = _v86.e;
								var openListItem = _v86.f;
								var rest = _v79.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\u000A' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\u000A' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v87) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\u000A');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 'BlankLine':
								if (_v79.b.b) {
									switch (_v79.b.a.$) {
										case 'UnorderedListBlock':
											var _v82 = _v79.a;
											var _v83 = _v79.b;
											var _v84 = _v83.a;
											var tight = _v84.a;
											var intended = _v84.b;
											var closeListItems = _v84.c;
											var openListItem = _v84.d;
											var rest = _v83.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															rawBlocks: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				body: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.body, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															rawBlocks: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			body: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\u000A', openListItem.body, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.body) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v85) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\u000A');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 'OrderedListBlock':
											var _v88 = _v79.a;
											var _v89 = _v79.b;
											var _v90 = _v89.a;
											var tight = _v90.a;
											var intended = _v90.b;
											var marker = _v90.c;
											var order = _v90.d;
											var closeListItems = _v90.e;
											var openListItem = _v90.f;
											var rest = _v89.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															rawBlocks: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\u000A' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															rawBlocks: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\u000A' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v91) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\u000A');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v79$6;
									}
								} else {
									break _v79$6;
								}
							default:
								break _v79$6;
						}
					} else {
						break _v79$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 'Element':
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v76 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (_v76.$ === 'Ok') {
					var childrenAsBlocks = _v76.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v76.a;
					return $elm$core$Result$Err(err);
				}
			case 'Text':
				var innerText = node.a;
				var _v77 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (_v77.$ === 'Ok') {
					var value = _v77.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v77.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\u000A',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 'Comment':
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 'Cdata':
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 'ProcessingInstruction':
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v61 = state.rawBlocks;
	_v61$5:
	while (true) {
		if (_v61.b) {
			switch (_v61.a.$) {
				case 'BlockQuote':
					var body2 = _v61.a.a;
					var rest = _v61.b;
					var _v62 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (_v62.$ === 'Ok') {
						var value = _v62.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								rawBlocks: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.rawBlocks),
									rest),
								linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
							});
					} else {
						var error = _v62.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 'UnorderedListBlock':
					var _v63 = _v61.a;
					var tight = _v63.a;
					var intended = _v63.b;
					var closeListItems = _v63.c;
					var openListItem = _v63.d;
					var rest = _v61.b;
					var _v64 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.body);
					if (_v64.$ === 'Ok') {
						var value = _v64.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								rawBlocks: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{body: value.rawBlocks, task: openListItem.task},
											closeListItems),
										openListItem),
									rest),
								linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
							});
					} else {
						var e = _v64.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 'OrderedListBlock':
					var _v69 = _v61.a;
					var tight = _v69.a;
					var intended = _v69.b;
					var marker = _v69.c;
					var order = _v69.d;
					var closeListItems = _v69.e;
					var openListItem = _v69.f;
					var rest = _v61.b;
					var _v70 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (_v70.$ === 'Ok') {
						var value = _v70.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								rawBlocks: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.rawBlocks, closeListItems),
										openListItem),
									rest),
								linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
							});
					} else {
						var e = _v70.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 'BlankLine':
					if (_v61.b.b) {
						switch (_v61.b.a.$) {
							case 'UnorderedListBlock':
								var _v65 = _v61.a;
								var _v66 = _v61.b;
								var _v67 = _v66.a;
								var tight = _v67.a;
								var intended = _v67.b;
								var closeListItems = _v67.c;
								var openListItem = _v67.d;
								var rest = _v66.b;
								var _v68 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.body);
								if (_v68.$ === 'Ok') {
									var value = _v68.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{body: value.rawBlocks, task: openListItem.task},
														closeListItems),
													openListItem),
												rest),
											linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
										});
								} else {
									var e = _v68.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 'OrderedListBlock':
								var _v71 = _v61.a;
								var _v72 = _v61.b;
								var _v73 = _v72.a;
								var tight = _v73.a;
								var intended = _v73.b;
								var marker = _v73.c;
								var order = _v73.d;
								var closeListItems = _v73.e;
								var openListItem = _v73.f;
								var rest = _v72.b;
								var _v74 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (_v74.$ === 'Ok') {
									var value = _v74.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.rawBlocks, closeListItems),
													openListItem),
												rest),
											linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
										});
								} else {
									var e = _v74.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v61$5;
						}
					} else {
						break _v61$5;
					}
				default:
					break _v61$5;
			}
		} else {
			break _v61$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 'Text':
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 'Element':
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 'Text') {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 'Comment':
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 'Cdata':
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 'ProcessingInstruction':
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.rawBlocks, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3(
							$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
							linkReferences,
							$elm$core$Basics$identity,
							$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(column));
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v57) {
		var unparsedInlines = _v57.a;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v58) {
						var title = _v58.title;
						var destination = _v58.destination;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v56 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (_v56.$ === 'Ok') {
					var newSoFar = _v56.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v56.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 'Text':
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
					$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(innerText)));
		case 'Element':
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v54 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (_v54.$ === 'Ok') {
				var parsedChildren = _v54.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v54.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 'Comment':
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 'Cdata':
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 'ProcessingInstruction':
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v52) {
				var alignment = _v52.alignment;
				var label = _v52.label;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {label: parsedHeaderLabel, alignment: alignment};
					},
					$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(label));
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v51 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.linkReferenceDefinitions, rawBlock);
				switch (_v51.$) {
					case 'ParsedBlock':
						var newParsedBlock = _v51.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 'EmptyBlock':
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v51.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v0 = _Utils_Tuple2(newRawBlock, state.rawBlocks);
		_v0$13:
		while (true) {
			if (_v0.b.b) {
				switch (_v0.b.a.$) {
					case 'CodeBlock':
						if (_v0.a.$ === 'CodeBlock') {
							var block1 = _v0.a.a;
							var _v1 = _v0.b;
							var block2 = _v1.a.a;
							var rest = _v1.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									rawBlocks: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												body: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.body, block1.body),
												language: $elm$core$Maybe$Nothing
											}),
										rest),
									linkReferenceDefinitions: state.linkReferenceDefinitions
								});
						} else {
							break _v0$13;
						}
					case 'IndentedCodeBlock':
						switch (_v0.a.$) {
							case 'IndentedCodeBlock':
								var block1 = _v0.a.a;
								var _v2 = _v0.b;
								var block2 = _v2.a.a;
								var rest = _v2.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										rawBlocks: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest),
										linkReferenceDefinitions: state.linkReferenceDefinitions
									});
							case 'BlankLine':
								var _v3 = _v0.a;
								var _v4 = _v0.b;
								var block = _v4.a.a;
								var rest = _v4.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										rawBlocks: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\u000A')),
											rest),
										linkReferenceDefinitions: state.linkReferenceDefinitions
									});
							default:
								break _v0$13;
						}
					case 'BlockQuote':
						var _v5 = _v0.b;
						var body2 = _v5.a.a;
						var rest = _v5.b;
						switch (newRawBlock.$) {
							case 'BlockQuote':
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										rawBlocks: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest),
										linkReferenceDefinitions: state.linkReferenceDefinitions
									});
							case 'OpenBlockOrParagraph':
								var body1 = newRawBlock.a.a;
								var _v7 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (_v7.$ === 'Ok') {
									var value = _v7.a;
									var _v8 = value.rawBlocks;
									if (_v8.b) {
										var last = _v8.a;
										if ($dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph(last) && (!A2($elm$core$String$endsWith, '\u000A', body2))) {
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
															A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
														rest),
													linkReferenceDefinitions: state.linkReferenceDefinitions
												});
										} else {
											var _v9 = A2(
												$elm$parser$Parser$Advanced$run,
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
												body2);
											if (_v9.$ === 'Ok') {
												var value1 = _v9.a;
												return $elm$parser$Parser$Advanced$succeed(
													{
														rawBlocks: A2(
															$elm$core$List$cons,
															newRawBlock,
															A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.rawBlocks),
																rest)),
														linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
													});
											} else {
												var e1 = _v9.a;
												return $elm$parser$Parser$Advanced$problem(
													$elm$parser$Parser$Problem(
														$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
											}
										}
									} else {
										var _v10 = A2(
											$elm$parser$Parser$Advanced$run,
											$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
											body2);
										if (_v10.$ === 'Ok') {
											var value1 = _v10.a;
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.rawBlocks),
															rest)),
													linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
												});
										} else {
											var e1 = _v10.a;
											return $elm$parser$Parser$Advanced$problem(
												$elm$parser$Parser$Problem(
													$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
										}
									}
								} else {
									var e = _v7.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 'IndentedCodeBlock':
								var body1 = newRawBlock.a;
								var _v11 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (_v11.$ === 'Ok') {
									var value = _v11.a;
									var _v12 = value.rawBlocks;
									if (_v12.b && (_v12.a.$ === 'OpenBlockOrParagraph')) {
										return $elm$parser$Parser$Advanced$succeed(
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
														A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, ' ', body2, body1)),
													rest),
												linkReferenceDefinitions: state.linkReferenceDefinitions
											});
									} else {
										var _v13 = A2(
											$elm$parser$Parser$Advanced$run,
											$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
											body2);
										if (_v13.$ === 'Ok') {
											var value1 = _v13.a;
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.rawBlocks),
															rest)),
													linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
												});
										} else {
											var e1 = _v13.a;
											return $elm$parser$Parser$Advanced$problem(
												$elm$parser$Parser$Problem(
													$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
										}
									}
								} else {
									var e = _v11.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								var _v14 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (_v14.$ === 'Ok') {
									var value = _v14.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.rawBlocks),
													rest)),
											linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
										});
								} else {
									var e = _v14.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 'UnorderedListBlock':
						var _v15 = _v0.b;
						var _v16 = _v15.a;
						var tight = _v16.a;
						var intended1 = _v16.b;
						var closeListItems2 = _v16.c;
						var openListItem2 = _v16.d;
						var rest = _v15.b;
						switch (newRawBlock.$) {
							case 'UnorderedListBlock':
								var intended2 = newRawBlock.b;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.marker, openListItem1.marker)) {
									var _v18 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.body);
									if (_v18.$ === 'Ok') {
										var value = _v18.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? $elm$parser$Parser$Advanced$succeed(
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{body: value.rawBlocks, task: openListItem2.task},
															closeListItems2),
														openListItem1),
													rest),
												linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{body: value.rawBlocks, task: openListItem2.task},
															closeListItems2),
														openListItem1),
													rest),
												linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
											});
									} else {
										var e = _v18.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v19 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.body);
									if (_v19.$ === 'Ok') {
										var value = _v19.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{body: value.rawBlocks, task: openListItem2.task},
																closeListItems2),
															openListItem1),
														rest)),
												linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
											});
									} else {
										var e = _v19.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 'OpenBlockOrParagraph':
								var body1 = newRawBlock.a.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										rawBlocks: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														body: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\u000A', openListItem2.body, body1)
													})),
											rest),
										linkReferenceDefinitions: state.linkReferenceDefinitions
									});
							default:
								var _v20 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.body);
								if (_v20.$ === 'Ok') {
									var value = _v20.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{body: value.rawBlocks, task: openListItem2.task},
															closeListItems2),
														openListItem2),
													rest)),
											linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
										});
								} else {
									var e = _v20.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 'OrderedListBlock':
						var _v21 = _v0.b;
						var _v22 = _v21.a;
						var tight = _v22.a;
						var intended1 = _v22.b;
						var marker = _v22.c;
						var order = _v22.d;
						var closeListItems2 = _v22.e;
						var openListItem2 = _v22.f;
						var rest = _v21.b;
						switch (newRawBlock.$) {
							case 'OrderedListBlock':
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v24 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (_v24.$ === 'Ok') {
										var value = _v24.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.rawBlocks, closeListItems2),
														openListItem1),
													rest),
												linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
											});
									} else {
										var e = _v24.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v25 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (_v25.$ === 'Ok') {
										var value = _v25.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												rawBlocks: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.rawBlocks, closeListItems2),
															openListItem2),
														rest)),
												linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
											});
									} else {
										var e = _v25.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 'OpenBlockOrParagraph':
								var body1 = newRawBlock.a.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										rawBlocks: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\u000A' + body1)),
											rest),
										linkReferenceDefinitions: state.linkReferenceDefinitions
									});
							default:
								var _v26 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (_v26.$ === 'Ok') {
									var value = _v26.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.rawBlocks) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.rawBlocks, closeListItems2),
														openListItem2),
													rest)),
											linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
										});
								} else {
									var e = _v26.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 'OpenBlockOrParagraph':
						switch (_v0.a.$) {
							case 'OpenBlockOrParagraph':
								var body1 = _v0.a.a.a;
								var _v27 = _v0.b;
								var body2 = _v27.a.a.a;
								var rest = _v27.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										rawBlocks: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\u000A', body2, body1))),
											rest),
										linkReferenceDefinitions: state.linkReferenceDefinitions
									});
							case 'SetextLine':
								if (_v0.a.a.$ === 'LevelOne') {
									var _v28 = _v0.a;
									var _v29 = _v28.a;
									var _v30 = _v0.b;
									var unparsedInlines = _v30.a.a;
									var rest = _v30.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest),
											linkReferenceDefinitions: state.linkReferenceDefinitions
										});
								} else {
									var _v31 = _v0.a;
									var _v32 = _v31.a;
									var _v33 = _v0.b;
									var unparsedInlines = _v33.a.a;
									var rest = _v33.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest),
											linkReferenceDefinitions: state.linkReferenceDefinitions
										});
								}
							case 'TableDelimiter':
								var _v34 = _v0.a.a;
								var text = _v34.a;
								var alignments = _v34.b;
								var _v35 = _v0.b;
								var rawHeaders = _v35.a.a.a;
								var rest = _v35.b;
								var _v36 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (_v36.$ === 'Ok') {
									var headers = _v36.a.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest),
											linkReferenceDefinitions: state.linkReferenceDefinitions
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											rawBlocks: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines(
														A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\u000A', rawHeaders, text.raw))),
												rest),
											linkReferenceDefinitions: state.linkReferenceDefinitions
										});
								}
							default:
								break _v0$13;
						}
					case 'Table':
						if (_v0.a.$ === 'Table') {
							var updatedTable = _v0.a.a;
							var _v37 = _v0.b;
							var rest = _v37.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									rawBlocks: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest),
									linkReferenceDefinitions: state.linkReferenceDefinitions
								});
						} else {
							break _v0$13;
						}
					case 'BlankLine':
						if (_v0.b.b.b) {
							switch (_v0.b.b.a.$) {
								case 'OrderedListBlock':
									var _v38 = _v0.b;
									var _v39 = _v38.a;
									var _v40 = _v38.b;
									var _v41 = _v40.a;
									var tight = _v41.a;
									var intended1 = _v41.b;
									var marker = _v41.c;
									var order = _v41.d;
									var closeListItems2 = _v41.e;
									var openListItem2 = _v41.f;
									var rest = _v40.b;
									var _v42 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (_v42.$ === 'Ok') {
										var value = _v42.a;
										if (newRawBlock.$ === 'OrderedListBlock') {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.rawBlocks, closeListItems2),
															openListItem),
														rest),
													linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.rawBlocks, closeListItems2),
																	openListItem2),
																rest))),
													linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
												});
										}
									} else {
										var e = _v42.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 'UnorderedListBlock':
									var _v44 = _v0.b;
									var _v45 = _v44.a;
									var _v46 = _v44.b;
									var _v47 = _v46.a;
									var tight = _v47.a;
									var intended1 = _v47.b;
									var closeListItems2 = _v47.c;
									var openListItem2 = _v47.d;
									var rest = _v46.b;
									var _v48 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.body);
									if (_v48.$ === 'Ok') {
										var value = _v48.a;
										if (newRawBlock.$ === 'UnorderedListBlock') {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{body: value.rawBlocks, task: openListItem2.task},
																closeListItems2),
															openListItem),
														rest),
													linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													rawBlocks: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{body: value.rawBlocks, task: openListItem2.task},
																		closeListItems2),
																	openListItem2),
																rest))),
													linkReferenceDefinitions: _Utils_ap(state.linkReferenceDefinitions, value.linkReferenceDefinitions)
												});
										}
									} else {
										var e = _v48.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v0$13;
							}
						} else {
							break _v0$13;
						}
					default:
						break _v0$13;
				}
			} else {
				break _v0$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				rawBlocks: A2($elm$core$List$cons, newRawBlock, state.rawBlocks),
				linkReferenceDefinitions: state.linkReferenceDefinitions
			});
	});
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v102) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v101) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v100) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{rawBlocks: _List_Nil, linkReferenceDefinitions: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
try {
	var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
	$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
		return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
	};
	var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
	$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
		return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
	};
	var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
	$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
		return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
	};
	var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
	$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
		return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
	};
	var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
	$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
		return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
	};
} catch ($) {
	throw 'Some top-level definitions from `Markdown.Parser` are causing infinite recursion:\n\n  ┌─────┐\n  │    parse\n  │     ↓\n  │    mapInline\n  │     ↓\n  │    mergeableBlockNotAfterOpenBlockOrParagraphParser\n  │     ↓\n  │    mergeableBlockAfterOpenBlockOrParagraphParser\n  │     ↓\n  │    mergeableBlockAfterList\n  │     ↓\n  │    htmlParser\n  │     ↓\n  │    parseInlines\n  │     ↓\n  │    rawBlockParser\n  │     ↓\n  │    stepRawBlock\n  │     ↓\n  │    childToBlocks\n  │     ↓\n  │    nodesToBlocks\n  │     ↓\n  │    completeBlocks\n  │     ↓\n  │    nodeToRawBlock\n  │     ↓\n  │    parseRawInline\n  │     ↓\n  │    parseAllInlines\n  │     ↓\n  │    parseRowInlines\n  │     ↓\n  │    textNodeToBlocks\n  │     ↓\n  │    inlineParseHelper\n  │     ↓\n  │    nodesToBlocksHelp\n  │     ↓\n  │    xmlNodeToHtmlNode\n  │     ↓\n  │    parseHeaderInlines\n  │     ↓\n  │    parseAllInlinesHelp\n  │     ↓\n  │    completeOrMergeBlocks\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 'Err') {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 'Err') {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (result.$ === 'Ok') {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0.a;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 'HtmlBlock':
						var html = block.a;
						if (html.$ === 'HtmlElement') {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 'UnorderedList':
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 'OrderedList':
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 'BlockQuote':
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 'Heading':
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 'Paragraph':
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 'Table':
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 'CodeBlock':
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 'Text':
				var str = inline.a;
				return _Utils_ap(text, str);
			case 'HardLineBreak':
				return text + ' ';
			case 'CodeSpan':
				var str = inline.a;
				return _Utils_ap(text, str);
			case 'Link':
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 'Image':
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 'HtmlInline':
				var html = inline.a;
				if (html.$ === 'HtmlElement') {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 'Strong':
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 'Emphasis':
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 'Paragraph':
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 'HtmlBlock':
			var html = block.a;
			if (html.$ === 'HtmlElement') {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 'UnorderedList':
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\u000A',
				A2(
					$elm$core$List$map,
					function (_v2) {
						var blocks = _v2.b;
						return A2(
							$elm$core$String$join,
							'\u000A',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 'OrderedList':
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\u000A',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\u000A',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 'BlockQuote':
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\u000A',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 'Heading':
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 'Table':
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\u000A',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.label;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 'CodeBlock':
			var body = block.a.body;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (_v12.$ === 'Just') {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.html,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 'Heading':
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.heading(
								{
									level: level,
									rawText: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content),
									children: children
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 'Paragraph':
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.paragraph,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 'HtmlBlock':
				var html = block.a;
				if (html.$ === 'HtmlElement') {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 'UnorderedList':
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.unorderedList(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a.$ === 'Tight') && (_v5.b.$ === 'Paragraph')) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 'OrderedList':
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.orderedList,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a.$ === 'Tight') && (_v8.b.$ === 'Paragraph')) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 'CodeBlock':
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.codeBlock(codeBlock)));
			case 'ThematicBreak':
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.thematicBreak));
			case 'BlockQuote':
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.blockQuote,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var alignment = _v11.alignment;
							var label = _v11.label;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.alignment;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.tableHeader(
							$elm$core$List$singleton(
								renderer.tableRow(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.tableHeaderCell, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.tableBody(r)
						]);
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.tableRow,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.tableCell,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.table(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 'Strong':
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.strong,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 'Emphasis':
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.emphasis,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 'Strikethrough':
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.strikethrough,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 'Image':
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.image(
							{
								alt: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								src: src,
								title: title
							})));
			case 'Text':
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.text(string)));
			case 'CodeSpan':
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.codeSpan(string)));
			case 'Link':
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.link,
									{title: title, destination: destination},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 'HardLineBreak':
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.hardLineBreak));
			default:
				var html = inline.a;
				if (html.$ === 'HtmlElement') {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$FeatureDrop$Changelog$substituteFleet = function (fleetSlug) {
	return A2($elm$core$String$replace, '{fleet}', fleetSlug);
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$input = _VirtualDom_node('input');
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 'Err') {
			var singleError = ra.a;
			if (rb.$ === 'Ok') {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var value = _v0.value;
				var name = _v0.name;
				return name + ('=\u0022' + (value + '\u0022'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = function (a) {
	return {$: 'HtmlRenderer', a: a};
};
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v4) {
			var rawDecoder = _v4.a;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer(
			F3(
				function (tagName, attributes, innerBlocks) {
					return A2(
						$elm$core$Result$mapError,
						function (errors) {
							if (!errors.b) {
								return 'Ran into a oneOf with no possibilities!';
							} else {
								if (!errors.b.b) {
									var singleError = errors.a;
									return 'Problem with the given value:\u000A\u000A' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\u000A\u000A' + (singleError + '\u000A')));
								} else {
									return 'oneOf failed parsing this value:\u000A    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\u000A\u000AParsing failed in the following 2 ways:\u000A\u000A\u000A' + (A2(
										$elm$core$String$join,
										'\u000A\u000A',
										A2(
											$elm$core$List$indexedMap,
											F2(
												function (index, error) {
													return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
												}),
											errors)) + '\u000A')));
								}
							}
						},
						A3(rawDecoder, tagName, attributes, innerBlocks));
				}));
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (_v0, _v1, _v2) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$core$String$words = _String_words;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	html: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	link: F2(
		function (link, content) {
			var _v0 = link.title;
			if (_v0.$ === 'Just') {
				var title = _v0.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.destination),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.destination)
						]),
					content);
			}
		}),
	text: $elm$html$Html$text,
	image: function (imageInfo) {
		var _v1 = imageInfo.title;
		if (_v1.$ === 'Just') {
			var title = _v1.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.src),
						$elm$html$Html$Attributes$alt(imageInfo.alt),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.src),
						$elm$html$Html$Attributes$alt(imageInfo.alt)
					]),
				_List_Nil);
		}
	},
	table: $elm$html$Html$table(_List_Nil),
	strong: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	heading: function (_v2) {
		var children = _v2.children;
		var level = _v2.level;
		switch (level.$) {
			case 'H1':
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 'H2':
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 'H3':
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 'H4':
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 'H5':
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	codeSpan: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	emphasis: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	tableRow: $elm$html$Html$tr(_List_Nil),
	codeBlock: function (_v4) {
		var language = _v4.language;
		var body = _v4.body;
		var classes = function () {
			var _v5 = A2($elm$core$Maybe$map, $elm$core$String$words, language);
			if ((_v5.$ === 'Just') && _v5.a.b) {
				var _v6 = _v5.a;
				var actualLanguage = _v6.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + actualLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	paragraph: $elm$html$Html$p(_List_Nil),
	tableBody: $elm$html$Html$tbody(_List_Nil),
	tableCell: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment.$) {
								case 'AlignLeft':
									return 'left';
								case 'AlignCenter':
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$td(attrs);
	},
	blockQuote: $elm$html$Html$blockquote(_List_Nil),
	orderedList: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	tableHeader: $elm$html$Html$thead(_List_Nil),
	hardLineBreak: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	strikethrough: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	thematicBreak: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	unorderedList: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task.$) {
							case 'NoTask':
								return $elm$html$Html$text('');
							case 'IncompleteTask':
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	},
	tableHeaderCell: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment.$) {
								case 'AlignLeft':
									return 'left';
								case 'AlignCenter':
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	}
};
var $author$project$FeatureDrop$Changelog$markdownBody = F2(
	function (fleetSlug, rawMarkdown) {
		var markdown = A2($author$project$FeatureDrop$Changelog$substituteFleet, fleetSlug, rawMarkdown);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small text-muted mb-1')
				]),
			A2(
				$elm$core$Result$withDefault,
				_List_fromArray(
					[
						$elm$html$Html$text(markdown)
					]),
				A2(
					$elm$core$Result$andThen,
					$dillonkearns$elm_markdown$Markdown$Renderer$render($dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer),
					A2(
						$elm$core$Result$mapError,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString),
							$elm$core$String$join('\u000A')),
						$dillonkearns$elm_markdown$Markdown$Parser$parse(markdown)))));
	});
var $author$project$FeatureDrop$Changelog$FeatureClicked = function (a) {
	return {$: 'FeatureClicked', a: a};
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $author$project$FeatureDrop$Changelog$onClickKeepOpen = function (action) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(action, true)));
};
var $author$project$FeatureDrop$Changelog$viewEntryBody = F2(
	function (config, feature) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown-item-text mb-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex justify-content-between align-items-start mb-1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(feature.label)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('btn btn-sm btn-outline-secondary ms-2'),
									A2($elm$html$Html$Attributes$attribute, 'style', '--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .65rem; --bs-btn-font-size: .65rem;'),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Dismiss ' + feature.label),
									$author$project$FeatureDrop$Changelog$onClickKeepOpen(
									$author$project$FeatureDrop$Changelog$Dismiss(feature.id))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Dismiss')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small text-muted d-flex flex-wrap gap-2 mb-2')
						]),
					A2($author$project$FeatureDrop$Changelog$metaBits, config.locale, feature)),
					A2(
					$author$project$FeatureDrop$Changelog$maybeHtml,
					$author$project$FeatureDrop$Changelog$markdownBody(config.fleetSlug),
					feature.description),
					function () {
					var _v0 = feature.cta;
					if (_v0.$ === 'Just') {
						var cta = _v0.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-primary mt-1'),
									A2($elm$html$Html$Attributes$attribute, 'style', '--bs-btn-padding-y: .5rem; --bs-btn-padding-x: .75rem; --bs-btn-font-size: .75rem;'),
									$elm$html$Html$Attributes$href(
									A2($author$project$FeatureDrop$Changelog$substituteFleet, config.fleetSlug, cta.url)),
									$elm$html$Html$Events$onClick(
									$author$project$FeatureDrop$Changelog$FeatureClicked(feature.id))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(cta.label)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$FeatureDrop$Changelog$viewEntry = F2(
	function (config, feature) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($elm$core$Set$member, feature.id, config.dismissing) ? 'featuredrop-entry dismissing' : 'featuredrop-entry')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$FeatureDrop$Changelog$viewEntryBody, config, feature)
						]))
				]));
	});
var $author$project$FeatureDrop$Changelog$viewFeed = function (config) {
	return $elm$core$List$isEmpty(config.features) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-item-text text-muted')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.emptyLabel)
						]))
				]))
		]) : A2(
		$elm$core$List$map,
		$author$project$FeatureDrop$Changelog$viewEntry(config),
		config.features);
};
var $author$project$FeatureDrop$Changelog$DismissAll = {$: 'DismissAll'};
var $author$project$FeatureDrop$Changelog$viewHeader = function (config) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-header d-flex justify-content-between align-items-center gap-3')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$h6,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.title)
							])),
					$elm$core$List$isEmpty(config.features) ? _List_Nil : _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('btn btn-sm btn-outline-secondary'),
									A2($elm$html$Html$Attributes$attribute, 'style', '--bs-btn-padding-y: .5rem; --bs-btn-padding-x: .75rem; --bs-btn-font-size: .75rem;'),
									$author$project$FeatureDrop$Changelog$onClickKeepOpen($author$project$FeatureDrop$Changelog$DismissAll)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Dismiss all')
								]))
						])))
			]));
};
var $author$project$FeatureDrop$Changelog$viewFullLogLink = function (config) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-divider')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-item text-center small'),
							$elm$html$Html$Attributes$href(config.fullChangelogHref)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('View full change log')
						]))
				]))
		]);
};
var $author$project$FeatureDrop$Changelog$navItem = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('nav-item dropdown')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class('nav-link dropdown-toggle'),
						A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'dropdown'),
						A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false')
					]),
				A2(
					$elm$core$List$cons,
					$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$bell),
					(config.showCount && (config.count > 0)) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$sup,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('badge rounded-pill text-bg-success')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(config.count))
								]))
						]) : _List_Nil)),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu dropdown-menu-end featuredrop-changelog-menu navbar-scrollable-menu')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$FeatureDrop$Changelog$viewHeader(config),
					_Utils_ap(
						$author$project$FeatureDrop$Changelog$viewFeed(config),
						$author$project$FeatureDrop$Changelog$viewFullLogLink(config))))
			]));
};
var $author$project$Gen$Route$Changelog = {$: 'Changelog'};
var $author$project$Html$Layout$navDropDownItem = F4(
	function (newKeys, title, route, currentRoute) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'dropdown-item' + (_Utils_eq(
								currentRoute,
								$elm$core$Maybe$Just(route)) ? ' active' : '')),
							$elm$html$Html$Attributes$href(
							$author$project$Gen$Route$toHref(route)),
							A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'collapse'),
							A2($elm$html$Html$Attributes$attribute, 'data-bs-target', '.navbar-collapse.show')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title),
							$author$project$Views$NewDot$view(
							A2($author$project$Html$Layout$isNewRoute, newKeys, route))
						]))
				]));
	});
var $author$project$Html$Layout$navDropDown = F5(
	function (newKeys, title, end, items, currentRoute) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item dropdown')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nav-link dropdown-toggle text-nowrap'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
							A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'dropdown'),
							A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title),
							$author$project$Views$NewDot$view(
							A2(
								$elm$core$List$any,
								function (_v0) {
									var r = _v0.b;
									return A2($author$project$Html$Layout$isNewRoute, newKeys, r);
								},
								items))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'dropdown-menu' + (end ? ' dropdown-menu-end' : ''))
						]),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var t = _v1.a;
							var r = _v1.b;
							return A4($author$project$Html$Layout$navDropDownItem, newKeys, t, r, currentRoute);
						},
						items))
				]));
	});
var $author$project$Data$User$isFleetAdmin = F2(
	function (slug, user) {
		var _v0 = A2($elm$core$Dict$get, slug, user.roles);
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'Administrator')) {
			var _v1 = _v0.a;
			return true;
		} else {
			return false;
		}
	});
var $author$project$Gen$Route$Fleet___Boats = function (a) {
	return {$: 'Fleet___Boats', a: a};
};
var $author$project$Gen$Route$Fleet___Users = function (a) {
	return {$: 'Fleet___Users', a: a};
};
var $author$project$Data$User$roleForFleet = F2(
	function (slug, user) {
		return A2($elm$core$Dict$get, slug, user.roles);
	});
var $author$project$Data$User$effectiveRoleForFleet = F2(
	function (slug, user) {
		return $author$project$Data$User$isNeboAdmin(user) ? $elm$core$Maybe$Just($author$project$Data$User$Administrator) : A2($author$project$Data$User$roleForFleet, slug, user);
	});
var $author$project$Html$Layout$fleetAudience = F2(
	function (fleet, user) {
		return {
			fleetRole: A2($author$project$Data$User$effectiveRoleForFleet, fleet.slug, user),
			fleetType: $elm$core$Maybe$Just(fleet.fleetType)
		};
	});
var $author$project$Gen$Route$Fleet___OnTime = function (a) {
	return {$: 'Fleet___OnTime', a: a};
};
var $author$project$Gen$Route$Fleet___Places = function (a) {
	return {$: 'Fleet___Places', a: a};
};
var $author$project$Gen$Route$Fleet___Public = function (a) {
	return {$: 'Fleet___Public', a: a};
};
var $author$project$Gen$Route$Fleet___Routes = function (a) {
	return {$: 'Fleet___Routes', a: a};
};
var $author$project$FeatureDrop$State$newSidebarKeys = function (state) {
	return $elm$core$Set$fromList(
		A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.sidebarKey;
			},
			state.newFeatures));
};
var $author$project$Gen$Route$Fleet___Summary = function (a) {
	return {$: 'Fleet___Summary', a: a};
};
var $author$project$FeatureDrop$Changelog$customAllows = F3(
	function (key, value, feature) {
		if (value.$ === 'Nothing') {
			return true;
		} else {
			var v = value.a;
			return A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Decode$decodeValue(
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$map(
								$elm$core$List$member(v)),
							$elm$core$Result$withDefault(true))),
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$Dict$get(key),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.custom;
							},
							feature.audience))));
		}
	});
var $author$project$Data$User$roleToString = function (role) {
	if (role.$ === 'Administrator') {
		return 'administrator';
	} else {
		return 'user';
	}
};
var $author$project$Data$Fleet$fleetTypeToString = function (ft) {
	switch (ft.$) {
		case 'Tourism':
			return 'tourism';
		case 'Workboats':
			return 'workboats';
		case 'Rescue':
			return 'rescue';
		case 'Commuter':
			return 'commuter';
		default:
			return 'vehicles';
	}
};
var $author$project$FeatureDrop$Changelog$matchesAudience = F2(
	function (_v0, feature) {
		var fleetRole = _v0.fleetRole;
		var fleetType = _v0.fleetType;
		return A3(
			$author$project$FeatureDrop$Changelog$customAllows,
			'fleetType',
			A2($elm$core$Maybe$map, $author$project$Data$Fleet$fleetTypeToString, fleetType),
			feature) && A3(
			$author$project$FeatureDrop$Changelog$customAllows,
			'fleetRole',
			A2($elm$core$Maybe$map, $author$project$Data$User$roleToString, fleetRole),
			feature);
	});
var $author$project$Gen$Route$Fleet___Discovery = function (a) {
	return {$: 'Fleet___Discovery', a: a};
};
var $author$project$Gen$Route$Fleet___Geofences = function (a) {
	return {$: 'Fleet___Geofences', a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$arrowUpRightFromSquare = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'arrow-up-right-from-square',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$arrowUpRightFromSquare = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$arrowUpRightFromSquare);
var $author$project$Gen$Route$Fleet___DateRangeSummary = function (a) {
	return {$: 'Fleet___DateRangeSummary', a: a};
};
var $author$project$Gen$Route$Fleet___WeeklyUtilisation = function (a) {
	return {$: 'Fleet___WeeklyUtilisation', a: a};
};
var $author$project$Gen$Route$Fleet___MonthlyUtilisation = function (a) {
	return {$: 'Fleet___MonthlyUtilisation', a: a};
};
var $author$project$Html$Layout$navBar = function (model) {
	var newKeys = A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Set$empty,
		A2($elm$core$Maybe$map, $author$project$FeatureDrop$State$newSidebarKeys, model.featureDropState));
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar navbar-expand-lg navbar-dark bg-dark')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-fluid')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-brand'),
								$elm$html$Html$Attributes$href('/')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/images/nebofleet.svg'),
										$elm$html$Html$Attributes$alt('nebo fleet'),
										$elm$html$Html$Attributes$height(26)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-toggler'),
								$elm$html$Html$Attributes$type_('button'),
								A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'collapse'),
								A2($elm$html$Html$Attributes$attribute, 'data-bs-target', '#navbarSupportedContent'),
								A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'navbarSupportedContent'),
								A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false'),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Toggle navigation')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-toggler-icon')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('collapse navbar-collapse'),
								$elm$html$Html$Attributes$id('navbarSupportedContent')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-nav mb-2 mb-lg-0')
									]),
								function () {
									var _v0 = model.selectedFleet;
									if (_v0.$ === 'Nothing') {
										return _List_Nil;
									} else {
										var fleet = _v0.a;
										return _List_fromArray(
											[
												A4(
												$author$project$Html$Layout$htmlNavItem,
												newKeys,
												A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$lattyware$elm_fontawesome$FontAwesome$view(
															A2(
																$lattyware$elm_fontawesome$FontAwesome$styled,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$class('me-2')
																	]),
																$lattyware$elm_fontawesome$FontAwesome$Solid$home)),
															$elm$html$Html$text(fleet.name)
														])),
												$author$project$Gen$Route$Fleet_(
													{fleet: fleet.slug}),
												model.currentRoute),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('vr bg-white mx-3 d-none d-lg-block')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$hr,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-white my-1 d-lg-none')
													]),
												_List_Nil),
												A4(
												$author$project$Html$Layout$navItem,
												newKeys,
												'Vessels',
												$author$project$Gen$Route$Fleet___Boats(
													{fleet: fleet.slug}),
												model.currentRoute),
												(A2($author$project$Data$User$isFleetAdmin, fleet.slug, model.user) || $author$project$Data$User$isNeboAdmin(model.user)) ? A4(
												$author$project$Html$Layout$navItem,
												newKeys,
												'Geofences',
												$author$project$Gen$Route$Fleet___Geofences(
													{fleet: fleet.slug}),
												model.currentRoute) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
												A5(
												$author$project$Html$Layout$navDropDown,
												newKeys,
												'Reports',
												false,
												_Utils_ap(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'Fleet Usage (Monthly)',
															$author$project$Gen$Route$Fleet___Summary(
																{fleet: fleet.slug})),
															_Utils_Tuple2(
															'Fleet Usage (Date Range)',
															$author$project$Gen$Route$Fleet___DateRangeSummary(
																{fleet: fleet.slug})),
															_Utils_Tuple2(
															'Utilisation (Monthly)',
															$author$project$Gen$Route$Fleet___MonthlyUtilisation(
																{fleet: fleet.slug})),
															_Utils_Tuple2(
															'Utilisation (Weekly)',
															$author$project$Gen$Route$Fleet___WeeklyUtilisation(
																{fleet: fleet.slug}))
														]),
													((A2($author$project$Data$User$isFleetAdmin, fleet.slug, model.user) || $author$project$Data$User$isNeboAdmin(model.user)) && (fleet.slug === 'rottnestexpress')) ? _List_fromArray(
														[
															_Utils_Tuple2(
															'On Time Report',
															$author$project$Gen$Route$Fleet___OnTime(
																{fleet: fleet.slug}))
														]) : _List_Nil),
												model.currentRoute),
												((A2($author$project$Data$User$isFleetAdmin, fleet.slug, model.user) || $author$project$Data$User$isNeboAdmin(model.user)) && $elm_community$maybe_extra$Maybe$Extra$isJust(fleet.guestViewConfiguration)) ? A5(
												$author$project$Html$Layout$navDropDown,
												newKeys,
												'Nebo Discovery',
												false,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'Places',
														$author$project$Gen$Route$Fleet___Places(
															{fleet: fleet.slug})),
														_Utils_Tuple2(
														'Routes',
														$author$project$Gen$Route$Fleet___Routes(
															{fleet: fleet.slug})),
														_Utils_Tuple2(
														'Settings',
														$author$project$Gen$Route$Fleet___Discovery(
															{fleet: fleet.slug}))
													]),
												model.currentRoute) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-nav ms-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('nav-item')
											]),
										function () {
											var _v1 = _Utils_Tuple2(
												model.selectedFleet,
												A2(
													$elm$core$Maybe$andThen,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.guestViewConfiguration;
														},
														$elm$core$Maybe$map(
															function ($) {
																return $.dashboardKey;
															})),
													model.selectedFleet));
											if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
												var fleet = _v1.a.a;
												var k = _v1.b.a;
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('nav-link text-nowrap'),
																A2($elm$html$Html$Attributes$attribute, 'aria-current', 'page'),
																$elm$html$Html$Attributes$href(
																$author$project$Gen$Route$toHref(
																	$author$project$Gen$Route$Fleet___Public(
																		{fleet: fleet.slug})) + ('?key=' + k)),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Public Fleet View'),
																$lattyware$elm_fontawesome$FontAwesome$view(
																A2(
																	$lattyware$elm_fontawesome$FontAwesome$styled,
																	_List_fromArray(
																		[
																			$elm$svg$Svg$Attributes$class('mx-2')
																		]),
																	$lattyware$elm_fontawesome$FontAwesome$Solid$arrowUpRightFromSquare))
															]))
													]);
											} else {
												return _List_Nil;
											}
										}()),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('vr bg-white mx-3 d-none d-lg-block')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('nav-item')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('nav-link text-nowrap'),
														$elm$html$Html$Attributes$href('https://www.nebofleet.com/knowledge-base'),
														$elm$html$Html$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Help'),
														$lattyware$elm_fontawesome$FontAwesome$view(
														A2(
															$lattyware$elm_fontawesome$FontAwesome$styled,
															_List_fromArray(
																[
																	$elm$svg$Svg$Attributes$class('mx-2')
																]),
															$lattyware$elm_fontawesome$FontAwesome$Solid$arrowUpRightFromSquare))
													]))
											])),
										function () {
										var _v2 = model.selectedFleet;
										if (_v2.$ === 'Just') {
											var fleet = _v2.a;
											return (A2($author$project$Data$User$isFleetAdmin, fleet.slug, model.user) || $author$project$Data$User$isNeboAdmin(model.user)) ? A5(
												$author$project$Html$Layout$navDropDown,
												newKeys,
												'Settings',
												true,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'Fleet Configuration',
														$author$project$Gen$Route$Fleet___Edit(
															{fleet: fleet.slug})),
														_Utils_Tuple2(
														'Users',
														$author$project$Gen$Route$Fleet___Users(
															{fleet: fleet.slug}))
													]),
												model.currentRoute) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
										} else {
											return A2($elm$html$Html$span, _List_Nil, _List_Nil);
										}
									}(),
										function () {
										var _v3 = _Utils_Tuple2(model.selectedFleet, model.featureDropState);
										if ((_v3.a.$ === 'Just') && (_v3.b.$ === 'Just')) {
											var fleet = _v3.a.a;
											var featureDropState = _v3.b.a;
											var features = A2(
												$elm$core$List$filter,
												$author$project$FeatureDrop$Changelog$matchesAudience(
													A2($author$project$Html$Layout$fleetAudience, fleet, model.user)),
												featureDropState.newFeaturesSorted);
											return A2(
												$elm$html$Html$map,
												model.changelogAction,
												$author$project$FeatureDrop$Changelog$navItem(
													{
														count: $elm$core$List$length(features),
														title: 'What\u0027s New',
														locale: featureDropState.locale,
														features: features,
														fleetSlug: fleet.slug,
														showCount: true,
														dismissing: featureDropState.dismissing,
														emptyLabel: 'You\u0027re all caught up!',
														fullChangelogHref: $author$project$Gen$Route$toHref($author$project$Gen$Route$Changelog)
													}));
										} else {
											return A2($elm$html$Html$span, _List_Nil, _List_Nil);
										}
									}(),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('nav-item dropdown')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('nav-link dropdown-toggle link-light ms-2'),
														A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
														A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'dropdown'),
														A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false')
													]),
												_List_fromArray(
													[
														function () {
														var _v4 = model.user.profilePhoto;
														if (_v4.$ === 'Just') {
															var ph = _v4.a;
															return A2(
																$elm$html$Html$img,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$src(ph),
																		$elm$html$Html$Attributes$alt(model.user.firstName),
																		$elm$html$Html$Attributes$width(22),
																		$elm$html$Html$Attributes$height(22),
																		$elm$html$Html$Attributes$class('rounded-circle')
																	]),
																_List_Nil);
														} else {
															return $lattyware$elm_fontawesome$FontAwesome$view(
																A2(
																	$lattyware$elm_fontawesome$FontAwesome$styled,
																	_List_fromArray(
																		[
																			$elm$svg$Svg$Attributes$class('fa-lg')
																		]),
																	$lattyware$elm_fontawesome$FontAwesome$Solid$user));
														}
													}()
													])),
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('dropdown-menu dropdown-menu-end text-small navbar-scrollable-menu')
													]),
												$elm$core$List$concat(
													_List_fromArray(
														[
															A2(
															$elm$core$List$map,
															function (f) {
																return A2(
																	$elm$html$Html$li,
																	_List_Nil,
																	_Utils_eq(
																		model.selectedFleet,
																		$elm$core$Maybe$Just(f)) ? _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$span,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('dropdown-item active'),
																					A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'collapse'),
																					A2($elm$html$Html$Attributes$attribute, 'data-bs-target', '.navbar-collapse.show')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(f.name)
																				]))
																		]) : _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$a,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('dropdown-item'),
																					$elm$html$Html$Attributes$href(
																					$author$project$Gen$Route$toHref(
																						$author$project$Gen$Route$Fleet_(
																							{fleet: f.slug}))),
																					A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'collapse'),
																					A2($elm$html$Html$Attributes$attribute, 'data-bs-target', '.navbar-collapse.show')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(f.name)
																				]))
																		]));
															},
															A2(
																$elm$core$List$sortBy,
																function ($) {
																	return $.name;
																},
																model.fleets)),
															_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$hr,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('dropdown-divider')
																			]),
																		_List_Nil)
																	]))
															]),
															$author$project$Data$User$isNeboAdmin(model.user) ? _List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$a,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('dropdown-item'),
																				$elm$html$Html$Attributes$href(
																				$author$project$Gen$Route$toHref($author$project$Gen$Route$Home_))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Fleet List')
																			]))
																	]))
															]) : _List_Nil,
															_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$a,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('dropdown-item'),
																				$elm$html$Html$Events$onClick(model.logout)
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Sign out')
																			]))
																	]))
															])
														])))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$FeatureDrop$Announcement$image = F2(
	function (label, url) {
		return A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(url),
					$elm$html$Html$Attributes$alt(label),
					$elm$html$Html$Attributes$class('img-fluid rounded mb-3')
				]),
			_List_Nil);
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$FeatureDrop$Announcement$titleId = 'featuredrop-announcement-title';
var $author$project$FeatureDrop$Announcement$modal = F4(
	function (locale, fleetSlug, isClosing, feature) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					isClosing ? 'featuredrop-announcement closing' : 'featuredrop-announcement')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-backdrop show')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal show'),
							A2($elm$html$Html$Attributes$style, 'display', 'block'),
							A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'dialog'),
							A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true'),
							A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', $author$project$FeatureDrop$Announcement$titleId)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-dialog modal-dialog-centered modal-dialog-scrollable')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('modal-content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('modal-header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h5,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('modal-title'),
															$elm$html$Html$Attributes$id($author$project$FeatureDrop$Announcement$titleId)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(feature.label)
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Attributes$class('btn-close'),
															A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
															$elm$html$Html$Events$onClick(
															$author$project$FeatureDrop$Changelog$Dismiss(feature.id))
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('modal-body')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$FeatureDrop$Changelog$maybeHtml,
													$author$project$FeatureDrop$Announcement$image(feature.label),
													feature.image),
													A2(
													$author$project$FeatureDrop$Changelog$maybeHtml,
													$author$project$FeatureDrop$Changelog$markdownBody(fleetSlug),
													feature.description),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small text-muted d-flex flex-wrap gap-2 mt-2')
														]),
													A2($author$project$FeatureDrop$Changelog$metaBits, locale, feature))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('modal-footer')
												]),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Attributes$class('btn btn-outline-secondary'),
															$elm$html$Html$Events$onClick(
															$author$project$FeatureDrop$Changelog$Dismiss(feature.id))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Dismiss')
														])),
												function () {
													var _v0 = feature.cta;
													if (_v0.$ === 'Just') {
														var cta = _v0.a;
														return _List_fromArray(
															[
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('btn btn-primary'),
																		$elm$html$Html$Attributes$href(
																		A2($author$project$FeatureDrop$Changelog$substituteFleet, fleetSlug, cta.url)),
																		$elm$html$Html$Events$onClick(
																		$author$project$FeatureDrop$Changelog$FeatureClicked(feature.id))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(cta.label)
																	]))
															]);
													} else {
														return _List_Nil;
													}
												}()))
										]))
								]))
						]))
				]));
	});
var $author$project$FeatureDrop$Announcement$isTriggered = function (feature) {
	return !_Utils_eq(feature.trigger, $elm$core$Maybe$Nothing);
};
var $author$project$FeatureDrop$Announcement$view = F2(
	function (_v0, state) {
		var audience = _v0.audience;
		var fleetSlug = _v0.fleetSlug;
		var _v1 = A2(
			$elm$core$List$filter,
			$author$project$FeatureDrop$Announcement$isTriggered,
			A2(
				$elm$core$List$filter,
				$author$project$FeatureDrop$Changelog$matchesAudience(audience),
				state.newFeaturesSorted));
		if (_v1.b) {
			var feature = _v1.a;
			return A4(
				$author$project$FeatureDrop$Announcement$modal,
				state.locale,
				fleetSlug,
				A2($elm$core$Set$member, feature.id, state.dismissing),
				feature);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Html$Layout$announcement = function (model) {
	var _v0 = _Utils_Tuple2(model.selectedFleet, model.featureDropState);
	if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
		var fleet = _v0.a.a;
		var state = _v0.b.a;
		return A2(
			$elm$html$Html$map,
			model.changelogAction,
			A2(
				$author$project$FeatureDrop$Announcement$view,
				{
					audience: A2($author$project$Html$Layout$fleetAudience, fleet, model.user),
					fleetSlug: fleet.slug
				},
				state));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Html$Layout$scrollWindow = F2(
	function (model, content) {
		return _List_fromArray(
			[
				$author$project$Html$Layout$navBar(model),
				$author$project$Html$Layout$announcement(model),
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-fluid')
					]),
				content)
			]);
	});
var $author$project$Html$Layout$createNavModel = F6(
	function (session, fleet, route, featureDropState, changelogAction, logout) {
		return {user: session.user, fleets: session.fleets, logout: logout, currentRoute: route, selectedFleet: fleet, changelogAction: changelogAction, featureDropState: featureDropState};
	});
var $author$project$Pages$Home_$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Home_$view = F3(
	function (session, featureDropState, model) {
		var headerCell = function (field) {
			return A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(field)
							]))
					]));
		};
		var row = function (f) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Gen$Route$toHref(
											$author$project$Gen$Route$Fleet_(
												{fleet: f.slug})))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(f.name)
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-primary'),
										$elm$html$Html$Attributes$href(
										$author$project$Gen$Route$toHref(
											$author$project$Gen$Route$Fleet___Edit(
												{fleet: f.slug})))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('me-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$edit)),
										$elm$html$Html$text('Edit')
									]))
							]))
					]));
		};
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just($author$project$Gen$Route$Home_),
					featureDropState,
					$author$project$Pages$Home_$ChangelogAction,
					$author$project$Pages$Home_$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex justify-content-between align-items-center py-3 px-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Fleets')
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-light'),
												$elm$html$Html$Attributes$href(
												$author$project$Gen$Route$toHref($author$project$Gen$Route$Register))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Register New Fleet'),
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('ms-1')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$plus))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('table-responsive-lg')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														A2(
															$elm$core$List$map,
															headerCell,
															_List_fromArray(
																['Name', ''])))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													row,
													A2(
														$elm$core$List$sortBy,
														function ($) {
															return $.name;
														},
														model.fleets)))
											]))
									])),
								A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Home_$CloseError)
							]))
					])),
			title: 'neboFleet Administration'
		};
	});
var $author$project$Views$Alert$Danger = {$: 'Danger'};
var $author$project$Api$errorString = function (e) {
	_v0$5:
	while (true) {
		switch (e.$) {
			case 'BadUrl':
				var u = e.a;
				return 'Invalid URL: ' + u;
			case 'Timeout':
				return 'The server is not responding (Timeout)';
			case 'NetworkError':
				return 'The server can’t be reached (NetworkError)';
			case 'BadStatus':
				switch (e.a.a) {
					case 403:
						var _v1 = e.a;
						return 'You are not authorised to perform this action';
					case 400:
						if (e.a.b.$ === 'Just') {
							var _v2 = e.a;
							var message = _v2.b.a;
							return 'The server returned an error (400): ' + message;
						} else {
							break _v0$5;
						}
					default:
						break _v0$5;
				}
			default:
				return 'The server returned an invalid response';
		}
	}
	var _v3 = e.a;
	var code = _v3.a;
	return 'The server returned an error status (' + ($elm$core$String$fromInt(code) + ')');
};
var $author$project$Shared$UpdateFleets = function (a) {
	return {$: 'UpdateFleets', a: a};
};
var $author$project$Shared$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Ports$completeProgressBar = _Platform_outgoingPort(
	'completeProgressBar',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$triangleExclamation = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'triangle-exclamation',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$triangleExclamation);
var $author$project$Pages$Home_$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnFetchFleets':
				if (msg.a.$ === 'Ok') {
					var fleets = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fleets: fleets}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									$author$project$Effect$fromCmd(
									$author$project$Ports$completeProgressBar(_Utils_Tuple0)),
									$author$project$Effect$fromShared(
									$author$project$Shared$UpdateFleets(fleets))
								])));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $ryan_haskell$elm_spa$ElmSpa$Page$Page = function (a) {
	return {$: 'Page', a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $ryan_haskell$elm_spa$ElmSpa$Page$adapters = {
	_static: F2(
		function (none, page) {
			return {
				init: function (_v0) {
					return _Utils_Tuple2(_Utils_Tuple0, none);
				},
				view: function (_v1) {
					return page.view;
				},
				update: F2(
					function (_v2, _v3) {
						return _Utils_Tuple2(_Utils_Tuple0, none);
					}),
				subscriptions: function (_v4) {
					return $elm$core$Platform$Sub$none;
				}
			};
		}),
	element: F2(
		function (fromCmd, page) {
			return {
				init: function (_v5) {
					return A2($elm$core$Tuple$mapSecond, fromCmd, page.init);
				},
				view: page.view,
				update: F2(
					function (msg, model) {
						return A2(
							$elm$core$Tuple$mapSecond,
							fromCmd,
							A2(page.update, msg, model));
					}),
				subscriptions: page.subscriptions
			};
		}),
	sandbox: F2(
		function (none, page) {
			return {
				init: function (_v6) {
					return _Utils_Tuple2(page.init, none);
				},
				view: page.view,
				update: F2(
					function (msg, model) {
						return _Utils_Tuple2(
							A2(page.update, msg, model),
							none);
					}),
				subscriptions: function (_v7) {
					return $elm$core$Platform$Sub$none;
				}
			};
		}),
	advanced: function (page) {
		return {
			init: $elm$core$Basics$always(page.init),
			view: page.view,
			update: page.update,
			subscriptions: page.subscriptions
		};
	}
};
var $ryan_haskell$elm_spa$ElmSpa$Page$protected = function (options) {
	var protect = F2(
		function (toPage, toRecord) {
			return $ryan_haskell$elm_spa$ElmSpa$Page$Page(
				F2(
					function (shared, req) {
						var _v0 = A2(options.beforeInit, shared, req);
						if (_v0.$ === 'Provide') {
							var user = _v0.a;
							return $elm$core$Result$Ok(
								toPage(
									toRecord(user)));
						} else {
							var route = _v0.a;
							return $elm$core$Result$Err(route);
						}
					}));
		});
	return {
		_static: protect(
			$ryan_haskell$elm_spa$ElmSpa$Page$adapters._static(options.effectNone)),
		element: protect(
			$ryan_haskell$elm_spa$ElmSpa$Page$adapters.element(options.fromCmd)),
		sandbox: protect(
			$ryan_haskell$elm_spa$ElmSpa$Page$adapters.sandbox(options.effectNone)),
		advanced: protect($ryan_haskell$elm_spa$ElmSpa$Page$adapters.advanced)
	};
};
var $author$project$Gen$Route$Login = {$: 'Login'};
var $ryan_haskell$elm_spa$ElmSpa$Page$Provide = function (a) {
	return {$: 'Provide', a: a};
};
var $ryan_haskell$elm_spa$ElmSpa$Page$RedirectTo = function (a) {
	return {$: 'RedirectTo', a: a};
};
var $author$project$Auth$beforeProtectedInit = F2(
	function (shared, _v0) {
		var _v1 = shared.session;
		if (_v1.$ === 'Just') {
			var session = _v1.a;
			return $ryan_haskell$elm_spa$ElmSpa$Page$Provide(session);
		} else {
			return $ryan_haskell$elm_spa$ElmSpa$Page$RedirectTo($author$project$Gen$Route$Login);
		}
	});
var $author$project$Page$protected = $ryan_haskell$elm_spa$ElmSpa$Page$protected(
	{fromCmd: $author$project$Effect$fromCmd, beforeInit: $author$project$Auth$beforeProtectedInit, effectNone: $author$project$Effect$none});
var $author$project$Pages$Home_$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Home_$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A6($author$project$Pages$Home_$init, session, shared.apiUrl, shared.oldApiUrl, shared.newApiUrl, shared.selectedFleetId, req),
					view: A2($author$project$Pages$Home_$view, session, shared.featureDropState),
					update: $author$project$Pages$Home_$update,
					subscriptions: $author$project$Pages$Home_$subscriptions
				};
			});
	});
var $author$project$Pages$Login$init = function (apiUrl) {
	return _Utils_Tuple2(
		{email: '', apiUrl: apiUrl, errors: _List_Nil, password: '', isLoading: false, resetSent: false, forgotPassword: false},
		$author$project$Effect$fromCmd(
			$author$project$Ports$sendPageViewEvent(
				_Utils_Tuple2(
					$author$project$Gen$Route$toHref($author$project$Gen$Route$Login),
					'Login'))));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $lattyware$elm_fontawesome$FontAwesome$Attributes$spin = $elm$svg$Svg$Attributes$class('fa-spin');
var $author$project$Html$Layout$login = function (content) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('login-container')
				]),
			_Utils_ap(
				content,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$nav,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar fixed-bottom bg-light')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container-fluid')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('navbar-text me-auto')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('©️ 2026 Nebo Global Pty Ltd')
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('navbar-text me-2'),
												$elm$html$Html$Attributes$href('https://www.nebo.global/privacy-policy')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Privacy Policy')
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('navbar-text'),
												$elm$html$Html$Attributes$href('https://www.nebo.global/terms-of-use')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Terms')
											]))
									]))
							]))
					])))
		]);
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pages$Login$Submit = {$: 'Submit'};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Pages$Login$SetEmail = function (a) {
	return {$: 'SetEmail', a: a};
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Pages$Login$ResetForm = {$: 'ResetForm'};
var $author$project$Pages$Login$SetPassword = function (a) {
	return {$: 'SetPassword', a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$circleNotch = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'circle-notch',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$circleNotch);
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$chevronRight = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'chevron-right',
	_Utils_Tuple2(320, 512),
	_Utils_Tuple2('M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$chevronRight);
var $author$project$Pages$Login$ResetPassword = {$: 'ResetPassword'};
var $author$project$Pages$Login$ForgotPassword = {$: 'ForgotPassword'};
var $author$project$Pages$Login$view = function (model) {
	return {
		body: $author$project$Html$Layout$login(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-signin w-100 m-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/nebofleet-blue.svg'),
									$elm$html$Html$Attributes$alt('nebo fleet'),
									$elm$html$Html$Attributes$class('mb-3'),
									$elm$html$Html$Attributes$height(36)
								]),
							_List_Nil),
							function () {
							var _v0 = model.errors;
							if (!_v0.b) {
								return A2($elm$html$Html$div, _List_Nil, _List_Nil);
							} else {
								var errs = _v0;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('alert alert-danger')
										]),
									A2(
										$elm$core$List$intersperse,
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$core$List$map, $elm$html$Html$text, errs)));
							}
						}(),
							model.resetSent ? A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('alert alert-success')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Password reset email sent - please check your mailbox')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('my-3 text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													$author$project$Gen$Route$toHref($author$project$Gen$Route$Login)),
													$elm$html$Html$Events$onClick($author$project$Pages$Login$ResetForm)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Return to login')
												]))
										]))
								])) : (model.forgotPassword ? A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Events$onSubmit($author$project$Pages$Login$ResetPassword)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lead py-3')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Send password reset')
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('email'),
											$elm$html$Html$Attributes$class('form-control form-control-sm py-3'),
											$elm$html$Html$Attributes$id('email'),
											A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'username'),
											$elm$html$Html$Attributes$placeholder('Email address'),
											$elm$html$Html$Events$onInput($author$project$Pages$Login$SetEmail),
											$elm$html$Html$Attributes$value(model.email)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('d-flex justify-content-between py-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-link'),
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Events$onClick($author$project$Pages$Login$ResetForm)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-primary text-white'),
													$elm$html$Html$Attributes$type_('submit')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Send Reset Email'),
													model.isLoading ? $lattyware$elm_fontawesome$FontAwesome$view(
													A2(
														$lattyware$elm_fontawesome$FontAwesome$styled,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$class('ms-2'),
																$lattyware$elm_fontawesome$FontAwesome$Attributes$spin
															]),
														$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
												]))
										]))
								])) : A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Events$onSubmit($author$project$Pages$Login$Submit)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lead py-3')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sign in to your account')
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('email'),
											$elm$html$Html$Attributes$class('form-control form-control-sm py-3'),
											$elm$html$Html$Attributes$id('email'),
											A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'username'),
											$elm$html$Html$Attributes$placeholder('Email address'),
											$elm$html$Html$Events$onInput($author$project$Pages$Login$SetEmail),
											$elm$html$Html$Attributes$value(model.email)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('password'),
											$elm$html$Html$Attributes$class('form-control form-control-sm py-3'),
											A2($elm$html$Html$Attributes$style, 'margin-top', '-1px'),
											$elm$html$Html$Attributes$id('password'),
											A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'current-password'),
											$elm$html$Html$Attributes$placeholder('Password'),
											$elm$html$Html$Events$onInput($author$project$Pages$Login$SetPassword),
											$elm$html$Html$Attributes$value(model.password)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('d-flex justify-content-between py-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-link'),
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Events$onClick($author$project$Pages$Login$ForgotPassword)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Forgot Password?')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-primary text-white'),
													$elm$html$Html$Attributes$type_('submit')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sign In'),
													model.isLoading ? $lattyware$elm_fontawesome$FontAwesome$view(
													A2(
														$lattyware$elm_fontawesome$FontAwesome$styled,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$class('ms-2'),
																$lattyware$elm_fontawesome$FontAwesome$Attributes$spin
															]),
														$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : $lattyware$elm_fontawesome$FontAwesome$view(
													A2(
														$lattyware$elm_fontawesome$FontAwesome$styled,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$class('ms-2')
															]),
														$lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight))
												]))
										]))
								])))
						]))
				])),
		title: 'Login'
	};
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{url: r.url, body: r.body, expect: r.expect, method: 'POST', headers: _List_Nil, timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing});
};
var $author$project$Api$login = F4(
	function (apiUrl, email, password, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$post(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', 'login']),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email)),
									_Utils_Tuple2(
									'password',
									$elm$json$Json$Encode$string(password))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$Session$decode)
				}));
	});
var $author$project$Shared$SignIn = function (a) {
	return {$: 'SignIn', a: a};
};
var $author$project$Pages$Login$OnLogin = function (a) {
	return {$: 'OnLogin', a: a};
};
var $author$project$Api$expectWhatever = A2(
	$elm$http$Http$expectStringResponse,
	$elm$core$Basics$identity,
	function (response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Api$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($author$project$Api$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($author$project$Api$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				var body = response.b;
				var message = $elm$core$Result$toMaybe(
					A2(
						$elm$json$Json$Decode$decodeString,
						A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
						body));
				return $elm$core$Result$Err(
					$author$project$Api$BadStatus(
						_Utils_Tuple2(metadata.statusCode, message)));
			default:
				return $elm$core$Result$Ok(_Utils_Tuple0);
		}
	});
var $author$project$Api$resetPassword = F3(
	function (apiUrl, email, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$post(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', 'resetpassword']),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]))),
					expect: $author$project$Api$expectWhatever
				}));
	});
var $author$project$Pages$Login$OnResetPassword = function (a) {
	return {$: 'OnResetPassword', a: a};
};
var $author$project$Pages$Login$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'SetEmail':
				var e = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{email: e}),
					$author$project$Effect$none);
			case 'SetPassword':
				var p = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{password: p}),
					$author$project$Effect$none);
			case 'Submit':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{errors: _List_Nil, isLoading: true}),
					$author$project$Effect$fromCmd(
						A4($author$project$Api$login, model.apiUrl, model.email, model.password, $author$project$Pages$Login$OnLogin)));
			case 'ForgotPassword':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{forgotPassword: true}),
					$author$project$Effect$none);
			case 'ResetPassword':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{errors: _List_Nil, isLoading: true}),
					$author$project$Effect$fromCmd(
						A3($author$project$Api$resetPassword, model.apiUrl, model.email, $author$project$Pages$Login$OnResetPassword)));
			case 'OnResetPassword':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{errors: _List_Nil, isLoading: false, resetSent: true}),
						$author$project$Effect$none);
				} else {
					var err = msg.a.a;
					if ((err.$ === 'BadStatus') && (err.a.a === 400)) {
						var _v2 = err.a;
						var s = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errors: _List_fromArray(
										[
											A2($elm$core$Maybe$withDefault, 'There was an error signing in', s)
										]),
									isLoading: false
								}),
							$author$project$Effect$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errors: _List_fromArray(
										[
											$author$project$Api$errorString(err)
										]),
									isLoading: false
								}),
							$author$project$Effect$none);
					}
				}
			case 'OnLogin':
				if (msg.a.$ === 'Ok') {
					var s = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{errors: _List_Nil, isLoading: false}),
						$author$project$Effect$fromShared(
							$author$project$Shared$SignIn(s)));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								errors: _List_fromArray(
									[
										$author$project$Api$errorString(err)
									]),
								isLoading: false
							}),
						$author$project$Effect$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{email: '', errors: _List_Nil, password: '', resetSent: false, forgotPassword: false}),
					$author$project$Effect$none);
		}
	});
var $ryan_haskell$elm_spa$ElmSpa$Page$advanced = function (page) {
	return $ryan_haskell$elm_spa$ElmSpa$Page$Page(
		F2(
			function (_v0, _v1) {
				return $elm$core$Result$Ok(
					$ryan_haskell$elm_spa$ElmSpa$Page$adapters.advanced(page));
			}));
};
var $author$project$Page$advanced = $ryan_haskell$elm_spa$ElmSpa$Page$advanced;
var $author$project$Pages$Login$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Login$page = F2(
	function (shared, _v0) {
		return $author$project$Page$advanced(
			{
				init: $author$project$Pages$Login$init(shared.apiUrl),
				view: $author$project$Pages$Login$view,
				update: $author$project$Pages$Login$update,
				subscriptions: $author$project$Pages$Login$subscriptions
			});
	});
var $elm$time$Time$Name = function (a) {
	return {$: 'Name', a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 'Offset', a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$here = _Time_here(_Utils_Tuple0);
var $author$project$Data$Fleet$empty = {
	name: '',
	slug: '',
	zoom: 0,
	fleetId: $author$project$Data$Fleet$FleetId(''),
	latitude: 0,
	fleetType: $author$project$Data$Fleet$Tourism,
	isPrivate: false,
	longitude: 0,
	speedUnit: $author$project$Data$SpeedUnit$Knots,
	timeZoneId: 'UTC',
	isSeaRescue: false,
	isHelmEnabled: false,
	watermarkImage: $elm$core$Maybe$Nothing,
	longDistanceUnit: $author$project$Data$DistanceUnit$NauticalMiles,
	helmConfiguration: $elm$core$Maybe$Nothing,
	shortDistanceUnit: $author$project$Data$DistanceUnit$Metres,
	notificationGroups: _List_Nil,
	speedAlertsEnabled: false,
	guestViewConfiguration: $elm$core$Maybe$Nothing
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Pages$Fleet_$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Shared$SelectFleet = function (a) {
	return {$: 'SelectFleet', a: a};
};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $mdgriffith$elm_animator$Internal$Timeline$Timeline = function (a) {
	return {$: 'Timeline', a: a};
};
var $ianmackenzie$elm_units$Quantity$Quantity = function (a) {
	return {$: 'Quantity', a: a};
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $mdgriffith$elm_animator$Internal$Time$absolute = function (posix) {
	return $ianmackenzie$elm_units$Quantity$Quantity(
		$elm$time$Time$posixToMillis(posix));
};
var $mdgriffith$elm_animator$Internal$Timeline$Timetable = function (a) {
	return {$: 'Timetable', a: a};
};
var $mdgriffith$elm_animator$Animator$init = function (first) {
	return $mdgriffith$elm_animator$Internal$Timeline$Timeline(
		{
			now: $mdgriffith$elm_animator$Internal$Time$absolute(
				$elm$time$Time$millisToPosix(0)),
			events: $mdgriffith$elm_animator$Internal$Timeline$Timetable(_List_Nil),
			queued: $elm$core$Maybe$Nothing,
			initial: first,
			running: true,
			interruption: _List_Nil
		});
};
var $zaboco$elm_draggable$Draggable$State = function (a) {
	return {$: 'State', a: a};
};
var $zaboco$elm_draggable$Internal$NotDragging = {$: 'NotDragging'};
var $zaboco$elm_draggable$Draggable$init = $zaboco$elm_draggable$Draggable$State($zaboco$elm_draggable$Internal$NotDragging);
var $author$project$Views$SidebarSheet$init = {
	drag: $zaboco$elm_draggable$Draggable$init,
	sheetActive: false,
	sheetHeight: $mdgriffith$elm_animator$Animator$init(54),
	sidebarPage: $mdgriffith$elm_animator$Animator$init(0)
};
var $author$project$Views$Mapbox$Satellite = {$: 'Satellite'};
var $author$project$Pages$Fleet_$SortByName = {$: 'SortByName'};
var $author$project$Pages$Fleet_$initialModel = F3(
	function (_v0, shared, fleet) {
		var fleetDefaultPosition = {
			zoom: fleet.zoom,
			centre: {lat: fleet.latitude, _long: fleet.longitude}
		};
		var mapPosition = (!_Utils_eq(
			shared.selectedFleetId,
			$elm$core$Maybe$Just(fleet.fleetId))) ? fleetDefaultPosition : A2($elm$core$Maybe$withDefault, fleetDefaultPosition, shared.defaultMapPosition);
		return {
			boats: _List_Nil,
			error: $elm$core$Maybe$Nothing,
			fleet: fleet,
			sheet: $author$project$Views$SidebarSheet$init,
			apiUrl: shared.apiUrl,
			locale: shared.locale,
			places: _List_Nil,
			tracks: _List_Nil,
			mapSize: _Utils_Tuple2(350, 850),
			boatSort: $author$project$Pages$Fleet_$SortByName,
			fleetUrl: shared.fleetUrl,
			mapStyle: $author$project$Views$Mapbox$Satellite,
			timeZone: $elm$time$Time$utc,
			geofences: _List_Nil,
			boatSearch: '',
			boatsLoaded: false,
			currentTime: $elm$time$Time$millisToPosix(0),
			mapPosition: mapPosition,
			measureLine: _List_Nil,
			selectedBoat: $elm$core$Maybe$Nothing,
			trackDuration: A2($elm$core$Maybe$withDefault, $author$project$Data$TrackDuration$LastTripToday, shared.defaultTrackDuration),
			measureModeActive: false
		};
	});
var $author$project$Pages$Fleet_$InitialiseMap = {$: 'InitialiseMap'};
var $author$project$Pages$Fleet_$OnGetMapElement = function (a) {
	return {$: 'OnGetMapElement', a: a};
};
var $author$project$Pages$Fleet_$StartServerEvents = {$: 'StartServerEvents'};
var $author$project$Pages$Fleet_$init = F3(
	function (session, shared, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			var initial = A3($author$project$Pages$Fleet_$initialModel, session, shared, f);
			return _Utils_Tuple2(
				initial,
				$author$project$Effect$batch(
					_List_fromArray(
						[
							(!_Utils_eq(
							shared.selectedFleetId,
							$elm$core$Maybe$Just(f.fleetId))) ? $author$project$Effect$fromShared(
							$author$project$Shared$SelectFleet(f.fleetId)) : $author$project$Effect$none,
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always($author$project$Pages$Fleet_$StartServerEvents),
								$elm$core$Process$sleep(100))),
							$author$project$Effect$fromCmd(
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Task$perform, $author$project$Pages$Fleet_$GotZone, $elm$time$Time$here),
										A2($elm$core$Task$perform, $author$project$Pages$Fleet_$OnTick, $elm$time$Time$now),
										A2(
										$elm$core$Task$attempt,
										$author$project$Pages$Fleet_$OnGetMapElement,
										$elm$browser$Browser$Dom$getElement('map')),
										A2(
										$elm$core$Task$perform,
										$elm$core$Basics$always($author$project$Pages$Fleet_$InitialiseMap),
										$elm$core$Process$sleep(10)),
										$author$project$Ports$sendPageViewEvent(
										_Utils_Tuple2(req.url.path, f.name + ': Home'))
									])))
						])));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$initialModel, session, shared, $author$project$Data$Fleet$empty),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$NoOp = {$: 'NoOp'};
var $author$project$Views$Mapbox$emptyGeoJSON = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$string('FeatureCollection')),
			_Utils_Tuple2(
			'features',
			A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil))
		]));
var $author$project$Views$Mapbox$init = F3(
	function (pos, baseUrl, noOp) {
		return {
			noOp: noOp,
			onIdle: $elm$core$Basics$always(noOp),
			baseUrl: baseUrl,
			onClick: $elm$core$Basics$always(noOp),
			sources: _List_fromArray(
				[
					_Utils_Tuple2('geofences', $author$project$Views$Mapbox$emptyGeoJSON),
					_Utils_Tuple2('geofence-labels', $author$project$Views$Mapbox$emptyGeoJSON),
					_Utils_Tuple2('ruler', $author$project$Views$Mapbox$emptyGeoJSON),
					_Utils_Tuple2('tracks', $author$project$Views$Mapbox$emptyGeoJSON),
					_Utils_Tuple2('hovered-track', $author$project$Views$Mapbox$emptyGeoJSON),
					_Utils_Tuple2('track-markers', $author$project$Views$Mapbox$emptyGeoJSON),
					_Utils_Tuple2('routes', $author$project$Views$Mapbox$emptyGeoJSON)
				]),
			onDragEnd: $elm$core$Maybe$Nothing,
			drawConfig: $elm$core$Maybe$Nothing,
			defaultZoom: pos.zoom,
			onMouseMove: $elm$core$Maybe$Nothing,
			rulerActive: false,
			showHeatmap: false,
			centerActive: false,
			onManualMove: $elm$core$Maybe$Nothing,
			onRulerClick: $elm$core$Maybe$Nothing,
			onStyleSelect: $elm$core$Maybe$Nothing,
			selectedStyle: $author$project$Views$Mapbox$Satellite,
			defaultLatLong: pos.centre,
			onClickFeature: $elm$core$Basics$always(noOp),
			watermarkImage: $elm$core$Maybe$Nothing,
			showTrackMarkers: false,
			onRouteButtonClick: $elm$core$Maybe$Nothing,
			onCenterButtonClick: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Mapbox$Element$MapboxAttr = function (a) {
	return {$: 'MapboxAttr', a: a};
};
var $author$project$Mapbox$Element$id = A2(
	$elm$core$Basics$composeR,
	$elm$html$Html$Attributes$attribute('id'),
	$author$project$Mapbox$Element$MapboxAttr);
var $author$project$Mapbox$Element$on = F2(
	function (type_, decoder) {
		return $author$project$Mapbox$Element$MapboxAttr(
			A2($elm$html$Html$Events$on, type_, decoder));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Mapbox$Source$getId = function (_v0) {
	var k = _v0.a;
	return k;
};
var $author$project$Mapbox$Layer$encode = function (_v0) {
	var value = _v0.a;
	return value;
};
var $author$project$Mapbox$Source$encode = function (_v0) {
	var value = _v0.b;
	return value;
};
var $author$project$Mapbox$Expression$encode = function (_v0) {
	var value = _v0.a;
	return value;
};
var $author$project$Mapbox$Style$encodeLight = function (_v0) {
	var intensity = _v0.intensity;
	var color = _v0.color;
	var position = _v0.position;
	var anchor = _v0.anchor;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'anchor',
				$author$project$Mapbox$Expression$encode(anchor)),
				_Utils_Tuple2(
				'position',
				$author$project$Mapbox$Expression$encode(position)),
				_Utils_Tuple2(
				'color',
				$author$project$Mapbox$Expression$encode(color)),
				_Utils_Tuple2(
				'intensity',
				$author$project$Mapbox$Expression$encode(intensity))
			]));
};
var $author$project$Mapbox$Style$encodeTransition = function (_v0) {
	var delay = _v0.delay;
	var duration = _v0.duration;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'duration',
				$elm$json$Json$Encode$int(duration)),
				_Utils_Tuple2(
				'delay',
				$elm$json$Json$Encode$int(delay))
			]));
};
var $author$project$Mapbox$Style$encode = function (style) {
	if (style.$ === 'Style') {
		var styleDef = style.a;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(8)),
						_Utils_Tuple2(
						'transition',
						$author$project$Mapbox$Style$encodeTransition(styleDef.transition)),
						_Utils_Tuple2(
						'light',
						$author$project$Mapbox$Style$encodeLight(styleDef.light)),
						_Utils_Tuple2(
						'sources',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$map,
								function (source) {
									return _Utils_Tuple2(
										$author$project$Mapbox$Source$getId(source),
										$author$project$Mapbox$Source$encode(source));
								},
								styleDef.sources))),
						_Utils_Tuple2(
						'layers',
						A2($elm$json$Json$Encode$list, $author$project$Mapbox$Layer$encode, styleDef.layers))
					]),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var value = _v1.b;
						return _Utils_Tuple2(key, value);
					},
					styleDef.misc)));
	} else {
		var s = style.a;
		return $elm$json$Json$Encode$string(s);
	}
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Mapbox$Element$map = F3(
	function (attrs, style, children) {
		var props = A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$Attributes$property,
				'mapboxStyle',
				$author$project$Mapbox$Style$encode(style)),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var attr = _v0.a;
					return attr;
				},
				attrs));
		return A3($elm$html$Html$node, 'elm-mapbox-map', props, children);
	});
var $author$project$Views$Mapbox$Chart = {$: 'Chart'};
var $author$project$Mapbox$Style$Style = function (a) {
	return {$: 'Style', a: a};
};
var $author$project$Mapbox$Element$Trash = {$: 'Trash'};
var $elm$html$Html$figure = _VirtualDom_node('figure');
var $author$project$Mapbox$Style$MiscAttr = F2(
	function (a, b) {
		return {$: 'MiscAttr', a: a, b: b};
	});
var $author$project$Mapbox$Style$glyphs = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$string,
	$author$project$Mapbox$Style$MiscAttr('glyphs'));
var $author$project$Mapbox$Element$MapEvent = F5(
	function (center, zoom, bearing, pitch, bounds) {
		return {zoom: zoom, pitch: pitch, bounds: bounds, center: center, bearing: bearing};
	});
var $author$project$LngLat$LngLat = F2(
	function (lng, lat) {
		return {lat: lat, lng: lng};
	});
var $author$project$LngLat$decodeFromObject = A3(
	$elm$json$Json$Decode$map2,
	$author$project$LngLat$LngLat,
	A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float));
var $author$project$Mapbox$Element$decodeMapEvent = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Mapbox$Element$MapEvent,
	A2($elm$json$Json$Decode$field, 'center', $author$project$LngLat$decodeFromObject),
	A2($elm$json$Json$Decode$field, 'zoom', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'bearing', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pitch', $elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$field,
		'bounds',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (sw, ne) {
					return {ne: ne, sw: sw};
				}),
			A2($elm$json$Json$Decode$field, 'sw', $author$project$LngLat$decodeFromObject),
			A2($elm$json$Json$Decode$field, 'ne', $author$project$LngLat$decodeFromObject))));
var $author$project$Mapbox$Element$onIdle = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'idle',
			A2($elm$json$Json$Decode$map, tagger, $author$project$Mapbox$Element$decodeMapEvent)));
};
var $author$project$Mapbox$Style$sprite = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$string,
	$author$project$Mapbox$Style$MiscAttr('sprite'));
var $author$project$Views$Mapbox$Standard = {$: 'Standard'};
var $author$project$Views$Mapbox$styles = _List_fromArray(
	[$author$project$Views$Mapbox$Satellite, $author$project$Views$Mapbox$Standard, $author$project$Views$Mapbox$Chart]);
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Mapbox$Style$imports = function (importRefs) {
	var encodeImport = function (_v0) {
		var config = _v0.config;
		var url = _v0.url;
		var id = _v0.id;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id)),
						_Utils_Tuple2(
						'url',
						$elm$json$Json$Encode$string(url))
					]),
				$elm$core$List$isEmpty(config) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(
						'config',
						$elm$json$Json$Encode$object(config))
					])));
	};
	return A2(
		$author$project$Mapbox$Style$MiscAttr,
		'imports',
		A2($elm$json$Json$Encode$list, encodeImport, importRefs));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Mapbox$Element$maxZoom = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$Attributes$property('maxZoom'),
		$author$project$Mapbox$Element$MapboxAttr));
var $author$project$Mapbox$Element$minZoom = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$Attributes$property('minZoom'),
		$author$project$Mapbox$Element$MapboxAttr));
var $author$project$Mapbox$Element$EventData = F3(
	function (point, lngLat, renderedFeatures) {
		return {point: point, lngLat: lngLat, renderedFeatures: renderedFeatures};
	});
var $author$project$Mapbox$Element$decodePoint = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(
				$elm$core$Basics$round(a),
				$elm$core$Basics$round(b));
		}),
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float));
var $author$project$Mapbox$Element$decodeEventData = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Mapbox$Element$EventData,
	A2($elm$json$Json$Decode$field, 'point', $author$project$Mapbox$Element$decodePoint),
	A2($elm$json$Json$Decode$field, 'lngLat', $author$project$LngLat$decodeFromObject),
	A2(
		$elm$json$Json$Decode$field,
		'features',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$value)));
var $author$project$Mapbox$Element$onClick = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'click',
			A2($elm$json$Json$Decode$map, tagger, $author$project$Mapbox$Element$decodeEventData)));
};
var $author$project$Mapbox$Element$TopRight = {$: 'TopRight'};
var $author$project$Mapbox$Element$controls = function (cs) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Attributes$property,
			'controlConfigs',
			A2(
				$elm$json$Json$Encode$list,
				function (_v0) {
					var v = _v0.a;
					return v;
				},
				cs)));
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Mapbox$Element$touchZoom = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$bool,
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$Attributes$property('touchZoom'),
		$author$project$Mapbox$Element$MapboxAttr));
var $author$project$Mapbox$Element$dragRotate = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$bool,
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$Attributes$property('dragRotate'),
		$author$project$Mapbox$Element$MapboxAttr));
var $author$project$Mapbox$Element$BottomRight = {$: 'BottomRight'};
var $author$project$Mapbox$Element$Control = function (a) {
	return {$: 'Control', a: a};
};
var $author$project$Mapbox$Element$Point = {$: 'Point'};
var $author$project$Mapbox$Element$Polygon = {$: 'Polygon'};
var $author$project$Mapbox$Element$LineString = {$: 'LineString'};
var $author$project$Mapbox$Element$CombineFeatures = {$: 'CombineFeatures'};
var $author$project$Mapbox$Element$UncombineFeatures = {$: 'UncombineFeatures'};
var $author$project$Mapbox$Element$allControls = _List_fromArray(
	[$author$project$Mapbox$Element$Point, $author$project$Mapbox$Element$LineString, $author$project$Mapbox$Element$Polygon, $author$project$Mapbox$Element$Trash, $author$project$Mapbox$Element$CombineFeatures, $author$project$Mapbox$Element$UncombineFeatures]);
var $author$project$Mapbox$Element$drawControlToString = function (control) {
	switch (control.$) {
		case 'Point':
			return 'point';
		case 'LineString':
			return 'line_string';
		case 'Polygon':
			return 'polygon';
		case 'Trash':
			return 'trash';
		case 'CombineFeatures':
			return 'combine_features';
		default:
			return 'uncombine_features';
	}
};
var $author$project$Mapbox$Element$controlPositionToString = function (cp) {
	switch (cp.$) {
		case 'TopLeft':
			return 'top-left';
		case 'Top':
			return 'top';
		case 'TopRight':
			return 'top-right';
		case 'Right':
			return 'right';
		case 'BottomRight':
			return 'bottom-right';
		case 'Bottom':
			return 'bottom';
		case 'BottomLeft':
			return 'bottom-left';
		default:
			return 'left';
	}
};
var $author$project$Mapbox$Element$drawControl = F3(
	function (position, controlId, options) {
		var defaultModeAttribute = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (mode) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'defaultMode',
							$elm$json$Json$Encode$string(mode))
						]);
				},
				options.defaultMode));
		var stylesAttribute = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (styles) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'styles',
							A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, styles))
						]);
				},
				options.styles));
		var modesAttribute = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (modes) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'modeKeys',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, modes))
						]);
				},
				options.modes));
		var controlsList = $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (control) {
					return _Utils_Tuple2(
						$author$project$Mapbox$Element$drawControlToString(control),
						$elm$json$Json$Encode$bool(
							A2($elm$core$List$member, control, options.controls)));
				},
				$author$project$Mapbox$Element$allControls));
		return $author$project$Mapbox$Element$Control(
			$elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('draw')),
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(controlId)),
							_Utils_Tuple2(
							'position',
							$elm$json$Json$Encode$string(
								$author$project$Mapbox$Element$controlPositionToString(position))),
							_Utils_Tuple2(
							'options',
							$elm$json$Json$Encode$object(
								_Utils_ap(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'displayControlsDefault',
											$elm$json$Json$Encode$bool(options.displayControlsDefault)),
											_Utils_Tuple2(
											'keybindings',
											$elm$json$Json$Encode$bool(options.keybindings)),
											_Utils_Tuple2(
											'touchEnabled',
											$elm$json$Json$Encode$bool(options.touchEnabled)),
											_Utils_Tuple2(
											'boxSelect',
											$elm$json$Json$Encode$bool(options.boxSelect)),
											_Utils_Tuple2(
											'clickBuffer',
											$elm$json$Json$Encode$int(options.clickBuffer)),
											_Utils_Tuple2(
											'touchBuffer',
											$elm$json$Json$Encode$int(options.touchBuffer)),
											_Utils_Tuple2('controls', controlsList),
											_Utils_Tuple2(
											'userProperties',
											$elm$json$Json$Encode$bool(options.userProperties))
										]),
									_Utils_ap(stylesAttribute, defaultModeAttribute))))
						]),
					modesAttribute)));
	});
var $author$project$Mapbox$Element$onMouseMove = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'mousemove',
			A2($elm$json$Json$Decode$map, tagger, $author$project$Mapbox$Element$decodeEventData)));
};
var $author$project$Mapbox$Element$onMoveStart = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'movestart',
			A2(
				$elm$json$Json$Decode$map,
				tagger,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(false),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'manualMove', $elm$json$Json$Decode$bool))))));
};
var $author$project$Mapbox$Element$touchRotate = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$bool,
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$Attributes$property('touchRotate'),
		$author$project$Mapbox$Element$MapboxAttr));
var $author$project$Internal$Expression = function (a) {
	return {$: 'Expression', a: a};
};
var $author$project$Mapbox$Expression$rgba = F4(
	function (r, g, b, a) {
		return $author$project$Internal$Expression(
			$elm$json$Json$Encode$string(
				'rgba(' + ($elm$core$String$fromFloat(r) + (', ' + ($elm$core$String$fromFloat(g) + (', ' + ($elm$core$String$fromFloat(b) + (', ' + ($elm$core$String$fromFloat(a) + ')')))))))));
	});
var $author$project$Mapbox$Expression$float = function (number) {
	return $author$project$Internal$Expression(
		$elm$json$Json$Encode$float(number));
};
var $author$project$Mapbox$Expression$call = F2(
	function (name, args) {
		return $author$project$Internal$Expression(
			A2(
				$elm$json$Json$Encode$list,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$cons,
					$elm$json$Json$Encode$string(name),
					args)));
	});
var $author$project$Mapbox$Expression$call1 = F2(
	function (n, _v0) {
		var a = _v0.a;
		return A2(
			$author$project$Mapbox$Expression$call,
			n,
			_List_fromArray(
				[a]));
	});
var $author$project$Mapbox$Expression$list = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$list($author$project$Mapbox$Expression$encode),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Internal$Expression,
		$author$project$Mapbox$Expression$call1('literal')));
var $author$project$Mapbox$Expression$floats = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Mapbox$Expression$float),
	$author$project$Mapbox$Expression$list);
var $author$project$Mapbox$Expression$viewport = $author$project$Internal$Expression(
	$elm$json$Json$Encode$string('viewport'));
var $author$project$Mapbox$Style$defaultLight = {
	color: A4($author$project$Mapbox$Expression$rgba, 255, 255, 255, 1),
	anchor: $author$project$Mapbox$Expression$viewport,
	position: $author$project$Mapbox$Expression$floats(
		_List_fromArray(
			[1.15, 210, 30])),
	intensity: $author$project$Mapbox$Expression$float(0.5)
};
var $author$project$Mapbox$Element$Move = {$: 'Move'};
var $author$project$Mapbox$Element$ChangeCoordinates = {$: 'ChangeCoordinates'};
var $author$project$Mapbox$Element$drawActionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'move':
				return $elm$json$Json$Decode$succeed($author$project$Mapbox$Element$Move);
			case 'change_coordinates':
				return $elm$json$Json$Decode$succeed($author$project$Mapbox$Element$ChangeCoordinates);
			default:
				return $elm$json$Json$Decode$fail('Unrecognised draw action ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Mapbox$Element$updateDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (fs, a) {
			return {action: a, features: fs};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'features',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
	A2($elm$json$Json$Decode$field, 'action', $author$project$Mapbox$Element$drawActionDecoder));
var $author$project$Mapbox$Element$onDrawUpdate = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'draw.update',
			A2($elm$json$Json$Decode$map, tagger, $author$project$Mapbox$Element$updateDecoder)));
};
var $author$project$LngLat$encodeAsPair = function (_v0) {
	var lat = _v0.lat;
	var lng = _v0.lng;
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$float,
		_List_fromArray(
			[lng, lat]));
};
var $author$project$Mapbox$Style$defaultCenter = A2(
	$elm$core$Basics$composeR,
	$author$project$LngLat$encodeAsPair,
	$author$project$Mapbox$Style$MiscAttr('center'));
var $author$project$Mapbox$Element$onControlClick = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'controlclick',
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (controlId, value) {
						return tagger(
							_Utils_Tuple2(controlId, value));
					}),
				A2(
					$elm$json$Json$Decode$field,
					'detail',
					A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				A2(
					$elm$json$Json$Decode$field,
					'detail',
					A2(
						$elm$json$Json$Decode$field,
						'value',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))))));
};
var $author$project$Views$Mapbox$decodeFeatureId = function (value) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$field,
				'properties',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'markerId', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'geofenceId', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'routeId', $elm$json$Json$Decode$string)
						]))),
			value));
};
var $author$project$Mapbox$Style$defaultZoomLevel = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	$author$project$Mapbox$Style$MiscAttr('zoom'));
var $author$project$Mapbox$Source$Source = F2(
	function (a, b) {
		return {$: 'Source', a: a, b: b};
	});
var $author$project$Mapbox$Source$geoJSONFromValue = F3(
	function (id, options, data) {
		return A2(
			$author$project$Mapbox$Source$Source,
			id,
			$elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('data', data),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('geojson')),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var k = _v0.a;
								var v = _v0.b;
								return _Utils_Tuple2(k, v);
							},
							options)))));
	});
var $author$project$Views$Mapbox$mapStyleToString = function (style) {
	switch (style.$) {
		case 'Satellite':
			return 'Satellite';
		case 'Standard':
			return 'Standard';
		default:
			return 'Chart';
	}
};
var $author$project$Mapbox$Expression$calln = F2(
	function (n, expressions) {
		return A2(
			$author$project$Mapbox$Expression$call,
			n,
			A2($elm$core$List$map, $author$project$Mapbox$Expression$encode, expressions));
	});
var $author$project$Mapbox$Expression$all = $author$project$Mapbox$Expression$calln('all');
var $author$project$Mapbox$Expression$any = $author$project$Mapbox$Expression$calln('any');
var $author$project$Mapbox$Expression$int = function (number) {
	return $author$project$Internal$Expression(
		$elm$json$Json$Encode$int(number));
};
var $author$project$Mapbox$Expression$str = function (s) {
	return $author$project$Internal$Expression(
		$elm$json$Json$Encode$string(s));
};
var $author$project$Mapbox$Layer$Internal$Layer = function (a) {
	return {$: 'Layer', a: a};
};
var $author$project$Mapbox$Layer$Internal$encodeAttrs = function (attrs) {
	var _v0 = A3(
		$elm$core$List$foldl,
		F2(
			function (attr, lists) {
				switch (attr.$) {
					case 'Top':
						var key = attr.a;
						var val = attr.b;
						return _Utils_update(
							lists,
							{
								top: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(key, val),
									lists.top)
							});
					case 'Paint':
						var key = attr.a;
						var val = attr.b;
						return _Utils_update(
							lists,
							{
								paint: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(key, val),
									lists.paint)
							});
					default:
						var key = attr.a;
						var val = attr.b;
						return _Utils_update(
							lists,
							{
								layout: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(key, val),
									lists.layout)
							});
				}
			}),
		{top: _List_Nil, paint: _List_Nil, layout: _List_Nil},
		attrs);
	var paint = _v0.paint;
	var layout = _v0.layout;
	var top = _v0.top;
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			'layout',
			$elm$json$Json$Encode$object(layout)),
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'paint',
				$elm$json$Json$Encode$object(paint)),
			top));
};
var $author$project$Mapbox$DrawLayer$drawLayerImpl = F3(
	function (tipe, id, attrs) {
		return $author$project$Mapbox$Layer$Internal$Layer(
			$elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(tipe)),
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(id))
						]),
					$author$project$Mapbox$Layer$Internal$encodeAttrs(attrs))));
	});
var $author$project$Mapbox$DrawLayer$fill = F2(
	function (id, attrs) {
		return A3($author$project$Mapbox$DrawLayer$drawLayerImpl, 'fill', id, attrs);
	});
var $author$project$Mapbox$DrawLayer$line = F2(
	function (id, attrs) {
		return A3($author$project$Mapbox$DrawLayer$drawLayerImpl, 'line', id, attrs);
	});
var $author$project$Mapbox$Expression$color = function (s) {
	return $author$project$Internal$Expression(
		$elm$json$Json$Encode$string(s));
};
var $author$project$Mapbox$DrawLayer$circle = F2(
	function (id, attrs) {
		return A3($author$project$Mapbox$DrawLayer$drawLayerImpl, 'circle', id, attrs);
	});
var $author$project$Mapbox$Layer$Internal$Top = F2(
	function (a, b) {
		return {$: 'Top', a: a, b: b};
	});
var $author$project$Mapbox$Layer$filter = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Top('filter'));
var $author$project$Mapbox$Expression$call3 = F4(
	function (n, _v0, _v1, _v2) {
		var a = _v0.a;
		var b = _v1.a;
		var c = _v2.a;
		return A2(
			$author$project$Mapbox$Expression$call,
			n,
			_List_fromArray(
				[a, b, c]));
	});
var $author$project$Mapbox$Expression$ifElse = $author$project$Mapbox$Expression$call3('case');
var $author$project$Mapbox$Expression$call2 = F3(
	function (n, _v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return A2(
			$author$project$Mapbox$Expression$call,
			n,
			_List_fromArray(
				[a, b]));
	});
var $author$project$Mapbox$Expression$isEqual = $author$project$Mapbox$Expression$call2('==');
var $author$project$Mapbox$Expression$notEqual = $author$project$Mapbox$Expression$call2('!=');
var $author$project$Mapbox$Layer$Internal$Paint = F2(
	function (a, b) {
		return {$: 'Paint', a: a, b: b};
	});
var $author$project$Mapbox$Layer$fillColor = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('fill-color'));
var $author$project$Mapbox$Layer$lineColor = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('line-color'));
var $author$project$Mapbox$Layer$lineWidth = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('line-width'));
var $author$project$Views$Mapbox$greenColor = '#17C988';
var $author$project$Mapbox$Expression$matchesStr = F3(
	function (options, _v0, _v1) {
		var _default = _v0.a;
		var input = _v1.a;
		var properOptions = A2(
			$elm$core$List$concatMap,
			function (_v2) {
				var label = _v2.a;
				var output = _v2.b.a;
				return _List_fromArray(
					[
						$elm$json$Json$Encode$string(label),
						output
					]);
			},
			options);
		return A2(
			$author$project$Mapbox$Expression$call,
			'match',
			A2(
				$elm$core$List$cons,
				input,
				_Utils_ap(
					properOptions,
					_List_fromArray(
						[_default]))));
	});
var $author$project$Mapbox$Layer$circleColor = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('circle-color'));
var $author$project$Mapbox$Layer$fillOpacity = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('fill-opacity'));
var $author$project$Mapbox$Expression$getProperty = $author$project$Mapbox$Expression$call1('get');
var $author$project$Mapbox$Layer$circleRadius = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('circle-radius'));
var $author$project$Mapbox$Expression$call0 = function (n) {
	return A2($author$project$Mapbox$Expression$call, n, _List_Nil);
};
var $author$project$Mapbox$Expression$geometryType = $author$project$Mapbox$Expression$call0('geometry-type');
var $author$project$Mapbox$Layer$lineDasharray = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('line-dasharray'));
var $author$project$Views$Mapbox$mapboxDrawStyles = function () {
	var geofenceColor = A3(
		$author$project$Mapbox$Expression$ifElse,
		$author$project$Mapbox$Expression$getProperty(
			$author$project$Mapbox$Expression$str('user_isRoute')),
		$author$project$Mapbox$Expression$color($author$project$Views$Mapbox$greenColor),
		A3(
			$author$project$Mapbox$Expression$matchesStr,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'restricted',
					$author$project$Mapbox$Expression$color('red')),
					_Utils_Tuple2(
					'speed_restricted',
					$author$project$Mapbox$Expression$color('red')),
					_Utils_Tuple2(
					'notify_entry',
					$author$project$Mapbox$Expression$color('yellow')),
					_Utils_Tuple2(
					'notify_exit',
					$author$project$Mapbox$Expression$color('yellow')),
					_Utils_Tuple2(
					'notify_both',
					$author$project$Mapbox$Expression$color('yellow')),
					_Utils_Tuple2(
					'notify_crossed',
					$author$project$Mapbox$Expression$color('yellow'))
				]),
			$author$project$Mapbox$Expression$color('white'),
			$author$project$Mapbox$Expression$getProperty(
				$author$project$Mapbox$Expression$str('user_geofenceType'))));
	var vertexFilter = $author$project$Mapbox$Expression$all(
		_List_fromArray(
			[
				A2(
				$author$project$Mapbox$Expression$isEqual,
				$author$project$Mapbox$Expression$geometryType,
				$author$project$Mapbox$Expression$str('Point')),
				A2(
				$author$project$Mapbox$Expression$isEqual,
				$author$project$Mapbox$Expression$getProperty(
					$author$project$Mapbox$Expression$str('meta')),
				$author$project$Mapbox$Expression$str('vertex')),
				A2(
				$author$project$Mapbox$Expression$notEqual,
				$author$project$Mapbox$Expression$getProperty(
					$author$project$Mapbox$Expression$str('mode')),
				$author$project$Mapbox$Expression$str('simple_select'))
			]));
	var isActive = A2(
		$author$project$Mapbox$Expression$isEqual,
		$author$project$Mapbox$Expression$getProperty(
			$author$project$Mapbox$Expression$str('active')),
		$author$project$Mapbox$Expression$str('true'));
	var activeInt = F2(
		function (active, inactive) {
			return A3(
				$author$project$Mapbox$Expression$ifElse,
				isActive,
				$author$project$Mapbox$Expression$int(active),
				$author$project$Mapbox$Expression$int(inactive));
		});
	return A2(
		$elm$core$List$map,
		$author$project$Mapbox$Layer$encode,
		_List_fromArray(
			[
				A2(
				$author$project$Mapbox$DrawLayer$fill,
				'gl-draw-polygon-fill',
				_List_fromArray(
					[
						$author$project$Mapbox$Layer$filter(
						A2(
							$author$project$Mapbox$Expression$isEqual,
							$author$project$Mapbox$Expression$geometryType,
							$author$project$Mapbox$Expression$str('Polygon'))),
						$author$project$Mapbox$Layer$fillColor(geofenceColor),
						$author$project$Mapbox$Layer$fillOpacity(
						$author$project$Mapbox$Expression$float(0.3))
					])),
				A2(
				$author$project$Mapbox$DrawLayer$line,
				'gl-draw-lines',
				_List_fromArray(
					[
						$author$project$Mapbox$Layer$filter(
						$author$project$Mapbox$Expression$any(
							_List_fromArray(
								[
									A2(
									$author$project$Mapbox$Expression$isEqual,
									$author$project$Mapbox$Expression$geometryType,
									$author$project$Mapbox$Expression$str('LineString')),
									A2(
									$author$project$Mapbox$Expression$isEqual,
									$author$project$Mapbox$Expression$geometryType,
									$author$project$Mapbox$Expression$str('Polygon'))
								]))),
						$author$project$Mapbox$Layer$lineColor(geofenceColor),
						$author$project$Mapbox$Layer$lineDasharray(
						$author$project$Mapbox$Expression$floats(
							_List_fromArray(
								[1, 1]))),
						$author$project$Mapbox$Layer$lineWidth(
						A3(
							$author$project$Mapbox$Expression$ifElse,
							$author$project$Mapbox$Expression$getProperty(
								$author$project$Mapbox$Expression$str('user_isRoute')),
							$author$project$Mapbox$Expression$int(5),
							$author$project$Mapbox$Expression$int(2)))
					])),
				A2(
				$author$project$Mapbox$DrawLayer$circle,
				'gl-draw-vertex-outer',
				_List_fromArray(
					[
						$author$project$Mapbox$Layer$filter(vertexFilter),
						$author$project$Mapbox$Layer$circleRadius(
						A2(activeInt, 7, 5)),
						$author$project$Mapbox$Layer$circleColor(
						$author$project$Mapbox$Expression$color('#FFFFFF'))
					])),
				A2(
				$author$project$Mapbox$DrawLayer$circle,
				'gl-draw-vertex-inner',
				_List_fromArray(
					[
						$author$project$Mapbox$Layer$filter(vertexFilter),
						$author$project$Mapbox$Layer$circleRadius(
						A2(activeInt, 5, 3)),
						$author$project$Mapbox$Layer$circleColor(
						$author$project$Mapbox$Expression$color('#FFA500'))
					])),
				A2(
				$author$project$Mapbox$DrawLayer$circle,
				'gl-draw-midpoint',
				_List_fromArray(
					[
						$author$project$Mapbox$Layer$filter(
						A2(
							$author$project$Mapbox$Expression$isEqual,
							$author$project$Mapbox$Expression$getProperty(
								$author$project$Mapbox$Expression$str('meta')),
							$author$project$Mapbox$Expression$str('midpoint'))),
						$author$project$Mapbox$Layer$circleRadius(
						$author$project$Mapbox$Expression$int(3)),
						$author$project$Mapbox$Layer$circleColor(
						$author$project$Mapbox$Expression$color('#FFA500'))
					]))
			]));
}();
var $author$project$Mapbox$Layer$layerImpl = F4(
	function (tipe, id, source, attrs) {
		return $author$project$Mapbox$Layer$Internal$Layer(
			$elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(tipe)),
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(id)),
							_Utils_Tuple2(
							'source',
							$elm$json$Json$Encode$string(source))
						]),
					$author$project$Mapbox$Layer$Internal$encodeAttrs(attrs))));
	});
var $author$project$Mapbox$Layer$line = $author$project$Mapbox$Layer$layerImpl('line');
var $author$project$Mapbox$Expression$line = $author$project$Internal$Expression(
	$elm$json$Json$Encode$string('line'));
var $author$project$Mapbox$Layer$symbol = $author$project$Mapbox$Layer$layerImpl('symbol');
var $author$project$Mapbox$Layer$iconColor = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('icon-color'));
var $author$project$Mapbox$Layer$Internal$Layout = F2(
	function (a, b) {
		return {$: 'Layout', a: a, b: b};
	});
var $author$project$Mapbox$Layer$iconImage = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('icon-image'));
var $author$project$Mapbox$Layer$iconRotate = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('icon-rotate'));
var $author$project$Mapbox$Layer$symbolSpacing = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('symbol-spacing'));
var $author$project$Mapbox$Layer$symbolPlacement = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('symbol-placement'));
var $author$project$Views$Mapbox$routeLayerStyles = _List_fromArray(
	[
		A3(
		$author$project$Mapbox$Layer$line,
		'routes-track',
		'routes',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$lineColor(
				$author$project$Mapbox$Expression$color($author$project$Views$Mapbox$greenColor)),
				$author$project$Mapbox$Layer$lineWidth(
				$author$project$Mapbox$Expression$float(5)),
				$author$project$Mapbox$Layer$lineDasharray(
				$author$project$Mapbox$Expression$floats(
					_List_fromArray(
						[0.75, 1])))
			])),
		A3(
		$author$project$Mapbox$Layer$symbol,
		'routes-arrows',
		'routes',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$iconColor(
				$author$project$Mapbox$Expression$color($author$project$Views$Mapbox$greenColor)),
				$author$project$Mapbox$Layer$iconImage(
				$author$project$Mapbox$Expression$str('track-marker')),
				$author$project$Mapbox$Layer$iconRotate(
				$author$project$Mapbox$Expression$float(90)),
				$author$project$Mapbox$Layer$symbolPlacement($author$project$Mapbox$Expression$line),
				$author$project$Mapbox$Layer$symbolSpacing(
				$author$project$Mapbox$Expression$float(100))
			]))
	]);
var $author$project$Mapbox$Layer$circle = $author$project$Mapbox$Layer$layerImpl('circle');
var $author$project$Mapbox$Layer$textSize = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('text-size'));
var $author$project$Mapbox$Layer$textColor = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('text-color'));
var $author$project$Mapbox$Layer$textField = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('text-field'));
var $author$project$Mapbox$Layer$textOffset = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('text-offset'));
var $author$project$Mapbox$Layer$textHaloBlur = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('text-halo-blur'));
var $author$project$Mapbox$Layer$textHaloColor = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('text-halo-color'));
var $author$project$Mapbox$Layer$textHaloWidth = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('text-halo-width'));
var $author$project$Views$Mapbox$rulerLayerStyles = _List_fromArray(
	[
		A3(
		$author$project$Mapbox$Layer$line,
		'ruler-line',
		'ruler',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$lineColor(
				A4($author$project$Mapbox$Expression$rgba, 211, 211, 211, 1)),
				$author$project$Mapbox$Layer$lineWidth(
				$author$project$Mapbox$Expression$float(3)),
				$author$project$Mapbox$Layer$lineDasharray(
				$author$project$Mapbox$Expression$floats(
					_List_fromArray(
						[0.75, 1])))
			])),
		A3(
		$author$project$Mapbox$Layer$circle,
		'ruler-points',
		'ruler',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$circleColor(
				A4($author$project$Mapbox$Expression$rgba, 211, 211, 211, 1)),
				$author$project$Mapbox$Layer$circleRadius(
				$author$project$Mapbox$Expression$float(5))
			])),
		A3(
		$author$project$Mapbox$Layer$symbol,
		'ruler-label',
		'ruler',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$textField(
				$author$project$Mapbox$Expression$getProperty(
					$author$project$Mapbox$Expression$str('distance'))),
				$author$project$Mapbox$Layer$textSize(
				$author$project$Mapbox$Expression$float(12)),
				$author$project$Mapbox$Layer$textColor(
				A4($author$project$Mapbox$Expression$rgba, 255, 255, 255, 1)),
				$author$project$Mapbox$Layer$textOffset(
				$author$project$Mapbox$Expression$floats(
					_List_fromArray(
						[0, -1]))),
				$author$project$Mapbox$Layer$textHaloColor(
				A4($author$project$Mapbox$Expression$rgba, 0, 0, 0, 1)),
				$author$project$Mapbox$Layer$textHaloWidth(
				$author$project$Mapbox$Expression$float(0.5)),
				$author$project$Mapbox$Layer$textHaloBlur(
				$author$project$Mapbox$Expression$float(0.5))
			]))
	]);
var $author$project$Mapbox$Expression$bool = function (b) {
	return $author$project$Internal$Expression(
		$elm$json$Json$Encode$bool(b));
};
var $author$project$Mapbox$Layer$lineCap = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('line-cap'));
var $author$project$Mapbox$Expression$rounded = $author$project$Internal$Expression(
	$elm$json$Json$Encode$string('round'));
var $author$project$Mapbox$Layer$lineJoin = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('line-join'));
var $author$project$Views$Mapbox$goldColor = '#FFD042';
var $author$project$Views$Mapbox$coralColor = '#FF595E';
var $author$project$Views$Mapbox$trackColor = function (style) {
	switch (style.$) {
		case 'Satellite':
			return $author$project$Views$Mapbox$goldColor;
		case 'Standard':
			return $author$project$Views$Mapbox$coralColor;
		default:
			return $author$project$Views$Mapbox$coralColor;
	}
};
var $author$project$Mapbox$Expression$hasProperty = $author$project$Mapbox$Expression$call1('has');
var $author$project$Mapbox$Layer$iconAllowOverlap = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Layout('icon-allow-overlap'));
var $author$project$Views$Mapbox$trackLayerStyles = F2(
	function (style, showMarkers) {
		var baseWidth = _Utils_eq(style, $author$project$Views$Mapbox$Satellite) ? 3 : 5;
		return _Utils_ap(
			_List_fromArray(
				[
					A3(
					$author$project$Mapbox$Layer$line,
					'tracks-id',
					'tracks',
					_List_fromArray(
						[
							$author$project$Mapbox$Layer$lineColor(
							$author$project$Mapbox$Expression$color(
								$author$project$Views$Mapbox$trackColor(style))),
							$author$project$Mapbox$Layer$lineWidth(
							$author$project$Mapbox$Expression$float(baseWidth)),
							$author$project$Mapbox$Layer$lineDasharray(
							$author$project$Mapbox$Expression$floats(
								_List_fromArray(
									[0.75, 1])))
						])),
					A3(
					$author$project$Mapbox$Layer$line,
					'hovered-track-id',
					'hovered-track',
					_List_fromArray(
						[
							$author$project$Mapbox$Layer$lineColor(
							$author$project$Mapbox$Expression$color('#FFFFFF')),
							$author$project$Mapbox$Layer$lineWidth(
							$author$project$Mapbox$Expression$float(baseWidth + 2)),
							$author$project$Mapbox$Layer$lineCap($author$project$Mapbox$Expression$rounded),
							$author$project$Mapbox$Layer$lineJoin($author$project$Mapbox$Expression$rounded)
						]))
				]),
			showMarkers ? _List_fromArray(
				[
					A3(
					$author$project$Mapbox$Layer$symbol,
					'track-markers-id',
					'track-markers',
					_List_fromArray(
						[
							$author$project$Mapbox$Layer$filter(
							$author$project$Mapbox$Expression$hasProperty(
								$author$project$Mapbox$Expression$str('heading'))),
							$author$project$Mapbox$Layer$iconColor(
							A3(
								$author$project$Mapbox$Expression$ifElse,
								$author$project$Mapbox$Expression$getProperty(
									$author$project$Mapbox$Expression$str('selected')),
								$author$project$Mapbox$Expression$color($author$project$Views$Mapbox$greenColor),
								A3(
									$author$project$Mapbox$Expression$ifElse,
									$author$project$Mapbox$Expression$getProperty(
										$author$project$Mapbox$Expression$str('hovered')),
									$author$project$Mapbox$Expression$color('#FFFFFF'),
									$author$project$Mapbox$Expression$color(
										$author$project$Views$Mapbox$trackColor(style))))),
							$author$project$Mapbox$Layer$iconImage(
							$author$project$Mapbox$Expression$str('track-marker')),
							$author$project$Mapbox$Layer$iconRotate(
							$author$project$Mapbox$Expression$getProperty(
								$author$project$Mapbox$Expression$str('heading'))),
							$author$project$Mapbox$Layer$iconAllowOverlap(
							$author$project$Mapbox$Expression$bool(true))
						]))
				]) : _List_Nil);
	});
var $author$project$Data$Geofence$Line = function (a) {
	return {$: 'Line', a: a};
};
var $author$project$Data$Geofence$Circle = function (a) {
	return {$: 'Circle', a: a};
};
var $author$project$Data$Geofence$Polygon = function (a) {
	return {$: 'Polygon', a: a};
};
var $author$project$Views$Mapbox$geoJSONLatLongDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (ls) {
		if (ls.b && ls.b.b) {
			var _long = ls.a;
			var _v1 = ls.b;
			var lat = _v1.a;
			return $elm$json$Json$Decode$succeed(
				{lat: lat, _long: _long});
		} else {
			return $elm$json$Json$Decode$fail('Invalid GeoJSON Coordinates');
		}
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$float));
var $author$project$Views$Mapbox$decodeDrawFeature = function () {
	var geometryDecoder = A2(
		$elm$json$Json$Decode$field,
		'geometry',
		A2(
			$elm$json$Json$Decode$andThen,
			function (t) {
				switch (t) {
					case 'Polygon':
						return A2(
							$elm$json$Json$Decode$andThen,
							function (css) {
								if (css.b && (!css.b.b)) {
									var cs = css.a;
									return $elm$json$Json$Decode$succeed(
										$author$project$Data$Geofence$Polygon(cs));
								} else {
									return $elm$json$Json$Decode$fail('Invalid Polygon coordinates');
								}
							},
							A2(
								$elm$json$Json$Decode$field,
								'coordinates',
								$elm$json$Json$Decode$list(
									$elm$json$Json$Decode$list($author$project$Views$Mapbox$geoJSONLatLongDecoder))));
					case 'LineString':
						return A2(
							$elm$json$Json$Decode$andThen,
							function (cs) {
								if (cs.b && cs.b.b) {
									var _v3 = cs.b;
									return $elm$json$Json$Decode$succeed(
										$author$project$Data$Geofence$Line(cs));
								} else {
									return $elm$json$Json$Decode$fail('Invalid LineString coordinates');
								}
							},
							A2(
								$elm$json$Json$Decode$field,
								'coordinates',
								$elm$json$Json$Decode$list($author$project$Views$Mapbox$geoJSONLatLongDecoder)));
					default:
						return $elm$json$Json$Decode$fail('Unsupported geometry type ' + t);
				}
			},
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)));
	var circleDecoder = A2(
		$elm$json$Json$Decode$field,
		'properties',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (center, radiusInKm) {
					return $author$project$Data$Geofence$Circle(
						_Utils_Tuple2(center, radiusInKm * 1000.0));
				}),
			A2($elm$json$Json$Decode$field, 'center', $author$project$Views$Mapbox$geoJSONLatLongDecoder),
			A2($elm$json$Json$Decode$field, 'radiusInKm', $elm$json$Json$Decode$float)));
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (i, g) {
				return {id: i, geometry: g};
			}),
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[circleDecoder, geometryDecoder])));
}();
var $author$project$Mapbox$Style$defaultTransition = {delay: 0, duration: 300};
var $author$project$Mapbox$Expression$zoom = $author$project$Mapbox$Expression$call0('zoom');
var $author$project$Mapbox$Layer$heatmap = $author$project$Mapbox$Layer$layerImpl('heatmap');
var $author$project$Mapbox$Expression$Exponential = function (a) {
	return {$: 'Exponential', a: a};
};
var $author$project$Mapbox$Expression$encodeInterpolation = function (interpolation) {
	switch (interpolation.$) {
		case 'Linear':
			return $author$project$Mapbox$Expression$call0('linear');
		case 'Exponential':
			var base = interpolation.a;
			return A2(
				$author$project$Mapbox$Expression$call,
				'exponential',
				_List_fromArray(
					[
						$elm$json$Json$Encode$float(base)
					]));
		default:
			var _v1 = interpolation.a;
			var x1 = _v1.a;
			var y1 = _v1.b;
			var _v2 = interpolation.b;
			var x2 = _v2.a;
			var y2 = _v2.b;
			return A2(
				$author$project$Mapbox$Expression$call,
				'cubic-bezier',
				_List_fromArray(
					[
						$elm$json$Json$Encode$float(x1),
						$elm$json$Json$Encode$float(y1),
						$elm$json$Json$Encode$float(x2),
						$elm$json$Json$Encode$float(y2)
					]));
	}
};
var $author$project$Mapbox$Expression$interpolate = F3(
	function (interpolation, stops, _v0) {
		var input = _v0.a;
		return A2(
			$author$project$Mapbox$Expression$call,
			'interpolate',
			A2(
				$elm$core$List$cons,
				$author$project$Mapbox$Expression$encode(
					$author$project$Mapbox$Expression$encodeInterpolation(interpolation)),
				A2(
					$elm$core$List$cons,
					input,
					A2(
						$elm$core$List$concatMap,
						function (_v1) {
							var stop = _v1.a;
							var res = _v1.b.a;
							return _List_fromArray(
								[
									$elm$json$Json$Encode$float(stop),
									res
								]);
						},
						stops))));
	});
var $author$project$Mapbox$Layer$heatmapRadius = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('heatmap-radius'));
var $author$project$Mapbox$Layer$heatmapOpacity = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('heatmap-opacity'));
var $author$project$Mapbox$Layer$heatmapIntensity = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('heatmap-intensity'));
var $author$project$Views$Mapbox$heatmapLayerStyle = A3(
	$author$project$Mapbox$Layer$heatmap,
	'track-heatmap-id',
	'track-markers',
	_List_fromArray(
		[
			$author$project$Mapbox$Layer$heatmapOpacity(
			$author$project$Mapbox$Expression$float(0.6)),
			$author$project$Mapbox$Layer$heatmapIntensity(
			A3(
				$author$project$Mapbox$Expression$interpolate,
				$author$project$Mapbox$Expression$Exponential(2),
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						$author$project$Mapbox$Expression$float(0.01)),
						_Utils_Tuple2(
						22,
						$author$project$Mapbox$Expression$float(50))
					]),
				$author$project$Mapbox$Expression$zoom)),
			$author$project$Mapbox$Layer$heatmapRadius(
			A3(
				$author$project$Mapbox$Expression$interpolate,
				$author$project$Mapbox$Expression$Exponential(2),
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						$author$project$Mapbox$Expression$float(15)),
						_Utils_Tuple2(
						22,
						$author$project$Mapbox$Expression$float(200))
					]),
				$author$project$Mapbox$Expression$zoom))
		]));
var $author$project$Mapbox$Element$iconButtonControl = F3(
	function (position, controlId, className) {
		return $author$project$Mapbox$Element$Control(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('icon-button')),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(controlId)),
						_Utils_Tuple2(
						'position',
						$elm$json$Json$Encode$string(
							$author$project$Mapbox$Element$controlPositionToString(position))),
						_Utils_Tuple2(
						'options',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'buttonClassName',
									$elm$json$Json$Encode$string(className))
								])))
					])));
	});
var $author$project$Mapbox$Element$navigationControl = F4(
	function (position, showCompass, showZoom, visualizePitch) {
		return $author$project$Mapbox$Element$Control(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('navigation')),
						_Utils_Tuple2(
						'position',
						$elm$json$Json$Encode$string(
							$author$project$Mapbox$Element$controlPositionToString(position))),
						_Utils_Tuple2(
						'options',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'showCompass',
									$elm$json$Json$Encode$bool(showCompass)),
									_Utils_Tuple2(
									'showZoom',
									$elm$json$Json$Encode$bool(showZoom)),
									_Utils_Tuple2(
									'visualizePitch',
									$elm$json$Json$Encode$bool(visualizePitch))
								])))
					])));
	});
var $author$project$Mapbox$Element$buttonGroupControl = F4(
	function (position, controlId, selectedValue, buttons) {
		var buttonOptions = A2(
			$elm$json$Json$Encode$list,
			function (opt) {
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'textContent',
							$elm$json$Json$Encode$string(opt.textContent)),
							_Utils_Tuple2(
							'disabled',
							$elm$json$Json$Encode$bool(opt.disabled)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(opt.value))
						]));
			},
			buttons);
		return $author$project$Mapbox$Element$Control(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('button-group')),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(controlId)),
						_Utils_Tuple2(
						'position',
						$elm$json$Json$Encode$string(
							$author$project$Mapbox$Element$controlPositionToString(position))),
						_Utils_Tuple2(
						'options',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2('buttons', buttonOptions),
									_Utils_Tuple2(
									'selectedValue',
									function () {
										if (selectedValue.$ === 'Just') {
											var v = selectedValue.a;
											return $elm$json$Json$Encode$string(v);
										} else {
											return $elm$json$Json$Encode$null;
										}
									}())
								])))
					])));
	});
var $author$project$Mapbox$Element$defaultDrawOptions = {modes: $elm$core$Maybe$Nothing, styles: $elm$core$Maybe$Nothing, controls: $author$project$Mapbox$Element$allControls, boxSelect: true, clickBuffer: 2, defaultMode: $elm$core$Maybe$Nothing, keybindings: true, touchBuffer: 25, touchEnabled: true, userProperties: false, displayControlsDefault: true};
var $author$project$Views$Mapbox$mapStyleFromString = function (str) {
	switch (str) {
		case 'Satellite':
			return $elm$core$Maybe$Just($author$project$Views$Mapbox$Satellite);
		case 'Standard':
			return $elm$core$Maybe$Just($author$project$Views$Mapbox$Standard);
		case 'Chart':
			return $elm$core$Maybe$Just($author$project$Views$Mapbox$Chart);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Mapbox$Element$eventFeaturesLayers = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
	A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$Attributes$property('eventFeaturesLayers'),
		$author$project$Mapbox$Element$MapboxAttr));
var $author$project$Mapbox$Layer$fill = $author$project$Mapbox$Layer$layerImpl('fill');
var $author$project$Mapbox$Layer$minzoom = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	$author$project$Mapbox$Layer$Internal$Top('minzoom'));
var $author$project$Mapbox$Expression$multiply = $author$project$Mapbox$Expression$call2('*');
var $author$project$Mapbox$Layer$circleOpacity = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Expression$encode,
	$author$project$Mapbox$Layer$Internal$Paint('circle-opacity'));
var $author$project$Views$Mapbox$geofenceTypeToColorExpression = A2(
	$author$project$Mapbox$Expression$matchesStr,
	_List_fromArray(
		[
			_Utils_Tuple2(
			'restricted',
			$author$project$Mapbox$Expression$color('red')),
			_Utils_Tuple2(
			'log',
			$author$project$Mapbox$Expression$color('white')),
			_Utils_Tuple2(
			'notify_entry',
			$author$project$Mapbox$Expression$color('yellow')),
			_Utils_Tuple2(
			'notify_exit',
			$author$project$Mapbox$Expression$color('yellow')),
			_Utils_Tuple2(
			'notify_both',
			$author$project$Mapbox$Expression$color('yellow')),
			_Utils_Tuple2(
			'notify_crossed',
			$author$project$Mapbox$Expression$color('yellow')),
			_Utils_Tuple2(
			'speed_restricted',
			$author$project$Mapbox$Expression$color('red'))
		]),
	$author$project$Mapbox$Expression$color('white'));
var $author$project$Views$Mapbox$geofenceLayerStyles = _List_fromArray(
	[
		A3(
		$author$project$Mapbox$Layer$line,
		'geofences-lines',
		'geofences',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$lineColor(
				$author$project$Views$Mapbox$geofenceTypeToColorExpression(
					$author$project$Mapbox$Expression$getProperty(
						$author$project$Mapbox$Expression$str('geofenceType')))),
				$author$project$Mapbox$Layer$filter(
				A2(
					$author$project$Mapbox$Expression$isEqual,
					$author$project$Mapbox$Expression$geometryType,
					$author$project$Mapbox$Expression$str('LineString'))),
				$author$project$Mapbox$Layer$lineWidth(
				$author$project$Mapbox$Expression$float(2))
			])),
		A3(
		$author$project$Mapbox$Layer$fill,
		'geofences-fill',
		'geofences',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$fillColor(
				$author$project$Views$Mapbox$geofenceTypeToColorExpression(
					$author$project$Mapbox$Expression$getProperty(
						$author$project$Mapbox$Expression$str('geofenceType')))),
				$author$project$Mapbox$Layer$filter(
				A2(
					$author$project$Mapbox$Expression$isEqual,
					$author$project$Mapbox$Expression$geometryType,
					$author$project$Mapbox$Expression$str('Polygon'))),
				$author$project$Mapbox$Layer$fillOpacity(
				$author$project$Mapbox$Expression$float(0.3))
			])),
		A3(
		$author$project$Mapbox$Layer$circle,
		'geofences-circles',
		'geofences',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$circleColor(
				$author$project$Views$Mapbox$geofenceTypeToColorExpression(
					$author$project$Mapbox$Expression$getProperty(
						$author$project$Mapbox$Expression$str('geofenceType')))),
				$author$project$Mapbox$Layer$filter(
				A2(
					$author$project$Mapbox$Expression$isEqual,
					$author$project$Mapbox$Expression$geometryType,
					$author$project$Mapbox$Expression$str('Point'))),
				$author$project$Mapbox$Layer$circleRadius(
				A3(
					$author$project$Mapbox$Expression$interpolate,
					$author$project$Mapbox$Expression$Exponential(2),
					_List_fromArray(
						[
							_Utils_Tuple2(
							0,
							A2(
								$author$project$Mapbox$Expression$multiply,
								$author$project$Mapbox$Expression$getProperty(
									$author$project$Mapbox$Expression$str('radiusPixels')),
								$author$project$Mapbox$Expression$float(
									A2($elm$core$Basics$pow, 2, -22)))),
							_Utils_Tuple2(
							22,
							$author$project$Mapbox$Expression$getProperty(
								$author$project$Mapbox$Expression$str('radiusPixels')))
						]),
					$author$project$Mapbox$Expression$zoom)),
				$author$project$Mapbox$Layer$circleOpacity(
				$author$project$Mapbox$Expression$float(0.3))
			])),
		A3(
		$author$project$Mapbox$Layer$symbol,
		'geofences-labels',
		'geofence-labels',
		_List_fromArray(
			[
				$author$project$Mapbox$Layer$textField(
				$author$project$Mapbox$Expression$getProperty(
					$author$project$Mapbox$Expression$str('name'))),
				$author$project$Mapbox$Layer$filter(
				A2(
					$author$project$Mapbox$Expression$notEqual,
					$author$project$Mapbox$Expression$geometryType,
					$author$project$Mapbox$Expression$str('LineString'))),
				$author$project$Mapbox$Layer$minzoom(14),
				$author$project$Mapbox$Layer$textSize(
				$author$project$Mapbox$Expression$float(12)),
				$author$project$Mapbox$Layer$textColor(
				A4($author$project$Mapbox$Expression$rgba, 255, 255, 255, 1)),
				$author$project$Mapbox$Layer$textHaloColor(
				A4($author$project$Mapbox$Expression$rgba, 0, 0, 0, 1)),
				$author$project$Mapbox$Layer$textHaloWidth(
				$author$project$Mapbox$Expression$float(0.5)),
				$author$project$Mapbox$Layer$textHaloBlur(
				$author$project$Mapbox$Expression$float(0.5))
			]))
	]);
var $author$project$Mapbox$Element$featuresDecoder = A2(
	$elm$json$Json$Decode$map,
	function (fs) {
		return {features: fs};
	},
	A2(
		$elm$json$Json$Decode$field,
		'features',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$value)));
var $author$project$Mapbox$Element$onDrawSelectionChange = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'draw.selectionchange',
			A2($elm$json$Json$Decode$map, tagger, $author$project$Mapbox$Element$featuresDecoder)));
};
var $author$project$Views$Mapbox$view = F2(
	function (config, children) {
		var eventFeatureLayers = _Utils_ap(
			_List_fromArray(
				['geofences-circles', 'geofences-fill', 'geofences-lines', 'routes-track']),
			config.showTrackMarkers ? _List_fromArray(
				['track-markers-id']) : _List_Nil);
		var watermark = function () {
			var _v18 = config.watermarkImage;
			if (_v18.$ === 'Just') {
				var imageUrl = _v18.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('map-watermark')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(imageUrl),
									A2($elm$html$Html$Attributes$style, 'max-height', '60px'),
									A2($elm$html$Html$Attributes$style, 'width', 'auto'),
									A2($elm$html$Html$Attributes$style, 'max-width', '100px'),
									A2($elm$html$Html$Attributes$style, 'object-fit', 'contain')
								]),
							_List_Nil)
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$figure,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('map-container'),
					A2($elm$html$Html$Attributes$style, 'height', '100%'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('mapbox'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'top', '0'),
							A2($elm$html$Html$Attributes$style, 'left', '0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('ruler-active', config.rulerActive)
								]))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Mapbox$Element$map,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Mapbox$Element$maxZoom(22),
										$author$project$Mapbox$Element$minZoom(1),
										$author$project$Mapbox$Element$dragRotate(false),
										$author$project$Mapbox$Element$touchZoom(true),
										$author$project$Mapbox$Element$touchRotate(false),
										$author$project$Mapbox$Element$controls(
										A2(
											$elm$core$List$cons,
											A4($author$project$Mapbox$Element$navigationControl, $author$project$Mapbox$Element$BottomRight, false, true, false),
											_Utils_ap(
												function () {
													var _v0 = config.onStyleSelect;
													if (_v0.$ === 'Just') {
														return _List_fromArray(
															[
																A4(
																$author$project$Mapbox$Element$buttonGroupControl,
																$author$project$Mapbox$Element$TopRight,
																'styles-control',
																$elm$core$Maybe$Just(
																	$author$project$Views$Mapbox$mapStyleToString(config.selectedStyle)),
																A2(
																	$elm$core$List$map,
																	function (style) {
																		return {
																			value: $author$project$Views$Mapbox$mapStyleToString(style),
																			disabled: false,
																			textContent: $author$project$Views$Mapbox$mapStyleToString(style)
																		};
																	},
																	$author$project$Views$Mapbox$styles))
															]);
													} else {
														return _List_Nil;
													}
												}(),
												_Utils_ap(
													function () {
														var _v1 = config.onRulerClick;
														if (_v1.$ === 'Just') {
															return _List_fromArray(
																[
																	A3(
																	$author$project$Mapbox$Element$iconButtonControl,
																	$author$project$Mapbox$Element$BottomRight,
																	'ruler-control',
																	config.rulerActive ? 'mapboxgl-ctrl-ruler -active' : 'mapboxgl-ctrl-ruler')
																]);
														} else {
															return _List_Nil;
														}
													}(),
													_Utils_ap(
														function () {
															var _v2 = config.onCenterButtonClick;
															if (_v2.$ === 'Just') {
																return _List_fromArray(
																	[
																		A3(
																		$author$project$Mapbox$Element$iconButtonControl,
																		$author$project$Mapbox$Element$BottomRight,
																		'center-control',
																		config.centerActive ? 'mapboxgl-ctrl-center -active' : 'mapboxgl-ctrl-center')
																	]);
															} else {
																return _List_Nil;
															}
														}(),
														_Utils_ap(
															function () {
																var _v3 = config.onRouteButtonClick;
																if (_v3.$ === 'Just') {
																	return _List_fromArray(
																		[
																			A3($author$project$Mapbox$Element$iconButtonControl, $author$project$Mapbox$Element$TopRight, 'route-control', 'mapboxgl-ctrl-route')
																		]);
																} else {
																	return _List_Nil;
																}
															}(),
															function () {
																var _v4 = config.drawConfig;
																if (_v4.$ === 'Just') {
																	return _List_fromArray(
																		[
																			A3(
																			$author$project$Mapbox$Element$drawControl,
																			$author$project$Mapbox$Element$TopRight,
																			'draw-control',
																			_Utils_update(
																				$author$project$Mapbox$Element$defaultDrawOptions,
																				{
																					modes: $elm$core$Maybe$Just(
																						_List_fromArray(
																							['simple_select', 'direct_select', 'draw_polygon', 'draw_line_string'])),
																					styles: $elm$core$Maybe$Just($author$project$Views$Mapbox$mapboxDrawStyles),
																					controls: _List_fromArray(
																						[$author$project$Mapbox$Element$Trash]),
																					defaultMode: $elm$core$Maybe$Just('simple_select'),
																					userProperties: true,
																					displayControlsDefault: false
																				}))
																		]);
																} else {
																	return _List_Nil;
																}
															}())))))),
										$author$project$Mapbox$Element$id('mapbox-map'),
										$author$project$Mapbox$Element$eventFeaturesLayers(eventFeatureLayers),
										$author$project$Mapbox$Element$onClick(
										function (e) {
											var _v5 = e.renderedFeatures;
											if (!_v5.b) {
												return config.onClick(
													{lat: e.lngLat.lat, _long: e.lngLat.lng});
											} else {
												var f = _v5.a;
												var _v6 = $author$project$Views$Mapbox$decodeFeatureId(f);
												if (_v6.$ === 'Just') {
													var id = _v6.a;
													return config.onClickFeature(id);
												} else {
													return config.onClick(
														{lat: e.lngLat.lat, _long: e.lngLat.lng});
												}
											}
										}),
										$author$project$Mapbox$Element$onIdle(
										function (e) {
											return config.onIdle(
												_Utils_Tuple3(
													{lat: e.center.lat, _long: e.center.lng},
													e.zoom,
													{
														ne: {lat: e.bounds.ne.lat, _long: e.bounds.ne.lng},
														sw: {lat: e.bounds.sw.lat, _long: e.bounds.sw.lng}
													}));
										}),
										$author$project$Mapbox$Element$onDrawUpdate(
										function (e) {
											var _v7 = config.drawConfig;
											if (_v7.$ === 'Just') {
												var c = _v7.a;
												return A2(
													$elm$core$Maybe$withDefault,
													config.noOp,
													A2(
														$elm$core$Maybe$map,
														function (fs) {
															var feats = A2(
																$elm$core$List$map,
																function (_v9) {
																	var geometry = _v9.geometry;
																	var id = _v9.id;
																	return _Utils_Tuple2(id, geometry);
																},
																fs);
															var _v8 = e.action;
															if (_v8.$ === 'Move') {
																return c.onMove(feats);
															} else {
																return c.onChangeCoordinates(feats);
															}
														},
														$elm$core$Result$toMaybe(
															$elm_community$result_extra$Result$Extra$combine(
																A2(
																	$elm$core$List$map,
																	$elm$json$Json$Decode$decodeValue($author$project$Views$Mapbox$decodeDrawFeature),
																	e.features)))));
											} else {
												return config.noOp;
											}
										}),
										$author$project$Mapbox$Element$onDrawSelectionChange(
										function (e) {
											var _v10 = config.drawConfig;
											if (_v10.$ === 'Just') {
												var c = _v10.a;
												return A2(
													$elm$core$Maybe$withDefault,
													config.noOp,
													A2(
														$elm$core$Maybe$map,
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$map(
																function (_v11) {
																	var id = _v11.id;
																	return id;
																}),
															c.onSelectionChange),
														$elm$core$Result$toMaybe(
															$elm_community$result_extra$Result$Extra$combine(
																A2(
																	$elm$core$List$map,
																	$elm$json$Json$Decode$decodeValue($author$project$Views$Mapbox$decodeDrawFeature),
																	e.features)))));
											} else {
												return config.noOp;
											}
										}),
										$author$project$Mapbox$Element$onControlClick(
										function (_v12) {
											var controlId = _v12.a;
											var value = _v12.b;
											return (controlId === 'styles-control') ? A3(
												$elm$core$Maybe$withDefault,
												$elm$core$Basics$always(config.noOp),
												config.onStyleSelect,
												A2(
													$elm$core$Maybe$withDefault,
													$author$project$Views$Mapbox$Satellite,
													A2($elm$core$Maybe$andThen, $author$project$Views$Mapbox$mapStyleFromString, value))) : ((controlId === 'ruler-control') ? A2($elm$core$Maybe$withDefault, config.noOp, config.onRulerClick) : ((controlId === 'center-control') ? A2($elm$core$Maybe$withDefault, config.noOp, config.onCenterButtonClick) : ((controlId === 'route-control') ? A2($elm$core$Maybe$withDefault, config.noOp, config.onRouteButtonClick) : config.noOp)));
										}),
										$author$project$Mapbox$Element$onMoveStart(
										function () {
											var _v13 = config.onManualMove;
											if (_v13.$ === 'Just') {
												var msg = _v13.a;
												return function (manual) {
													return manual ? msg : config.noOp;
												};
											} else {
												return $elm$core$Basics$always(config.noOp);
											}
										}())
									]),
								_Utils_ap(
									function () {
										var _v14 = config.onMouseMove;
										if (_v14.$ === 'Just') {
											var fn = _v14.a;
											return _List_fromArray(
												[
													$author$project$Mapbox$Element$onMouseMove(
													function (e) {
														return fn(
															{lat: e.lngLat.lat, _long: e.lngLat.lng});
													})
												]);
										} else {
											return _List_Nil;
										}
									}(),
									function () {
										var _v15 = config.onDragEnd;
										if (_v15.$ === 'Just') {
											var fn = _v15.a;
											return _List_fromArray(
												[
													A2(
													$author$project$Mapbox$Element$on,
													'dragend',
													$elm$json$Json$Decode$succeed(fn))
												]);
										} else {
											return _List_Nil;
										}
									}())),
							$author$project$Mapbox$Style$Style(
								{
									misc: _List_fromArray(
										[
											$author$project$Mapbox$Style$imports(
											function () {
												var _v16 = config.selectedStyle;
												switch (_v16.$) {
													case 'Satellite':
														return _List_fromArray(
															[
																{
																id: 'standard-satellite',
																url: 'mapbox://styles/mapbox/standard-satellite',
																config: _List_fromArray(
																	[
																		_Utils_Tuple2(
																		'showPointOfInterestLabels',
																		$elm$json$Json$Encode$bool(false)),
																		_Utils_Tuple2(
																		'showRoadsAndTransit',
																		$elm$json$Json$Encode$bool(false)),
																		_Utils_Tuple2(
																		'showRoadLabels',
																		$elm$json$Json$Encode$bool(false)),
																		_Utils_Tuple2(
																		'showTransitLabels',
																		$elm$json$Json$Encode$bool(false))
																	])
															}
															]);
													case 'Standard':
														return _List_fromArray(
															[
																{
																id: 'standard',
																url: 'mapbox://styles/mapbox/standard',
																config: _List_fromArray(
																	[
																		_Utils_Tuple2(
																		'showPointOfInterestLabels',
																		$elm$json$Json$Encode$bool(false)),
																		_Utils_Tuple2(
																		'showRoadsAndTransit',
																		$elm$json$Json$Encode$bool(false)),
																		_Utils_Tuple2(
																		'showRoadLabels',
																		$elm$json$Json$Encode$bool(false)),
																		_Utils_Tuple2(
																		'showTransitLabels',
																		$elm$json$Json$Encode$bool(false))
																	])
															}
															]);
													default:
														return _List_fromArray(
															[
																{id: 'vector-charts', url: 'https://api.vectorcharts.com/api/v1/styles/base.json?token=3305be421aba490a951aec4430d25e38', config: _List_Nil}
															]);
												}
											}()),
											$author$project$Mapbox$Style$defaultCenter(
											{lat: config.defaultLatLong.lat, lng: config.defaultLatLong._long}),
											$author$project$Mapbox$Style$defaultZoomLevel(config.defaultZoom),
											$author$project$Mapbox$Style$glyphs(
											_Utils_eq(config.selectedStyle, $author$project$Views$Mapbox$Chart) ? 'https://api.vectorcharts.com/api/v1/static/glyphs/{fontstack}/{range}.pbf' : 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf'),
											$author$project$Mapbox$Style$sprite(config.baseUrl + '/images/icons')
										]),
									light: $author$project$Mapbox$Style$defaultLight,
									layers: _Utils_ap(
										$author$project$Views$Mapbox$geofenceLayerStyles,
										_Utils_ap(
											config.showHeatmap ? _List_fromArray(
												[$author$project$Views$Mapbox$heatmapLayerStyle]) : A2($author$project$Views$Mapbox$trackLayerStyles, config.selectedStyle, config.showTrackMarkers),
											_Utils_ap($author$project$Views$Mapbox$rulerLayerStyles, $author$project$Views$Mapbox$routeLayerStyles))),
									sources: A2(
										$elm$core$List$map,
										function (_v17) {
											var id = _v17.a;
											var val = _v17.b;
											return A3($author$project$Mapbox$Source$geoJSONFromValue, id, _List_Nil, val);
										},
										config.sources),
									transition: $author$project$Mapbox$Style$defaultTransition
								}),
							children)
						])),
					watermark
				]));
	});
var $author$project$Pages$Fleet_$Logout = {$: 'Logout'};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Pages$Fleet_$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$core$Basics$asin = _Basics_asin;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $author$project$Geospatial$LatLong$haversine = F2(
	function (p1, p2) {
		var dLon = $elm$core$Basics$degrees(p2._long - p1._long);
		var dLat = $elm$core$Basics$degrees(p2.lat - p1.lat);
		var r = 6371088.0;
		var a = A2(
			$elm$core$Basics$pow,
			$elm$core$Basics$sin(dLat / 2),
			2) + ((A2(
			$elm$core$Basics$pow,
			$elm$core$Basics$sin(dLon / 2),
			2) * $elm$core$Basics$cos(
			$elm$core$Basics$degrees(p1.lat))) * $elm$core$Basics$cos(
			$elm$core$Basics$degrees(p2.lat)));
		return (r * 2) * $elm$core$Basics$asin(
			$elm$core$Basics$sqrt(a));
	});
var $author$project$Geospatial$LatLong$distance = function (points) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, acc) {
				var p1 = _v0.a;
				var p2 = _v0.b;
				return acc + A2($author$project$Geospatial$LatLong$haversine, p1, p2);
			}),
		0.0,
		A2(
			$elm_community$list_extra$List$Extra$zip,
			points,
			A2($elm$core$List$drop, 1, points)));
};
var $author$project$Html$Layout$fitWindow = F2(
	function (model, content) {
		return _List_fromArray(
			[
				$author$project$Html$Layout$navBar(model),
				$author$project$Html$Layout$announcement(model),
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fit-window-height navbar-top-padding')
					]),
				content)
			]);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (!_Utils_eq(
					c,
					_Utils_chr('0'))) && (!_Utils_eq(
					c,
					_Utils_chr('.')));
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$reverse = _String_reverse;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3(
				$elm$core$String$padRight,
				e + 1,
				_Utils_chr('0'),
				total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (_Utils_eq(
		head,
		_Utils_chr('9'))) {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 'Nothing') {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				_Utils_chr('0'),
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var signed = fl < 0;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					_Utils_chr('0'),
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3(
					$elm$core$String$padRight,
					s,
					_Utils_chr('0'),
					after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 'Nothing') {
				return false;
			} else {
				if ('5' === _v0.a.a.valueOf()) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$Data$DistanceUnit$convertTo = F2(
	function (unit, metres) {
		switch (unit.$) {
			case 'Metres':
				return metres;
			case 'Yards':
				return metres * 1.09361;
			case 'NauticalMiles':
				return metres / 1852.0;
			case 'Kilometres':
				return metres / 1000.0;
			default:
				return metres / 1609.34;
		}
	});
var $author$project$Data$DistanceUnit$abbreviation = function (unit) {
	switch (unit.$) {
		case 'Metres':
			return 'm';
		case 'Yards':
			return 'yd';
		case 'NauticalMiles':
			return 'nm';
		case 'Kilometres':
			return 'km';
		default:
			return 'mi';
	}
};
var $author$project$Data$DistanceUnit$formatDistance = F2(
	function (u, d) {
		return A2(
			$myrho$elm_round$Round$round,
			1,
			A2($author$project$Data$DistanceUnit$convertTo, u, d)) + (' ' + $author$project$Data$DistanceUnit$abbreviation(u));
	});
var $author$project$Views$Mapbox$latLongToGeoJSON = function (ll) {
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$float,
		_List_fromArray(
			[ll._long, ll.lat]));
};
var $author$project$Views$Mapbox$rulerToLayer = F2(
	function (line, unit) {
		var dropLast = function (list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					return _List_Nil;
				} else {
					return A2(
						$elm$core$List$take,
						$elm$core$List$length(list) - 1,
						list);
				}
			}
		};
		var filteredLine = dropLast(line);
		var lineFeature = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Feature')),
					_Utils_Tuple2(
					'geometry',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('LineString')),
								_Utils_Tuple2(
								'coordinates',
								A2($elm$json$Json$Encode$list, $author$project$Views$Mapbox$latLongToGeoJSON, filteredLine))
							])))
				]));
		var labelFeatures = A2(
			$elm$core$List$indexedMap,
			F2(
				function (idx, ll) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('Feature')),
								_Utils_Tuple2(
								'properties',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'distance',
											$elm$json$Json$Encode$string(
												A2(
													$author$project$Data$DistanceUnit$formatDistance,
													unit,
													$author$project$Geospatial$LatLong$distance(
														A2($elm$core$List$take, idx + 1, filteredLine)))))
										]))),
								_Utils_Tuple2(
								'geometry',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('Point')),
											_Utils_Tuple2(
											'coordinates',
											$author$project$Views$Mapbox$latLongToGeoJSON(ll))
										])))
							]));
				}),
			filteredLine);
		return _Utils_Tuple2(
			'ruler',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('FeatureCollection')),
						_Utils_Tuple2(
						'features',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							A2($elm$core$List$cons, lineFeature, labelFeatures)))
					])));
	});
var $author$project$Views$Mapbox$addOrReplaceSource = F2(
	function (source, sources) {
		var key = source.a;
		return A2(
			$elm$core$List$cons,
			source,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var k = _v0.a;
					return !_Utils_eq(k, key);
				},
				sources));
	});
var $author$project$Views$Mapbox$withRuler = F5(
	function (line, unit, active, onClick, config) {
		return _Utils_update(
			config,
			{
				sources: A2(
					$author$project$Views$Mapbox$addOrReplaceSource,
					A2($author$project$Views$Mapbox$rulerToLayer, line, unit),
					config.sources),
				rulerActive: active,
				onRulerClick: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pages$Fleet_$MapClicked = function (a) {
	return {$: 'MapClicked', a: a};
};
var $author$project$Pages$Fleet_$SelectBoat = function (a) {
	return {$: 'SelectBoat', a: a};
};
var $author$project$LngLat$encodeAsObject = function (_v0) {
	var lat = _v0.lat;
	var lng = _v0.lng;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lng',
				$elm$json$Json$Encode$float(lng)),
				_Utils_Tuple2(
				'lat',
				$elm$json$Json$Encode$float(lat))
			]));
};
var $author$project$Mapbox$Element$marker = F4(
	function (position, isDraggable, attributes, content) {
		return A3(
			$elm$html$Html$node,
			'elm-mapbox-marker',
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$property,
						'lngLat',
						$author$project$LngLat$encodeAsObject(position)),
						A2(
						$elm$html$Html$Attributes$property,
						'draggable',
						$elm$json$Json$Encode$bool(isDraggable)),
						A2($elm$html$Html$Attributes$style, 'display', 'none')
					]),
				attributes),
			content);
	});
var $author$project$FontAwesome$Internal$alert = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'alert',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 9 18 C 13.9705 18 18 13.9706 18 9 C 18 4.0294 13.9705 0 9 0 C 4.0294 0 -0 4.0294 -0 9 C -0 13.9706 4.0294 18 9 18 Z M 9 3.125 C 9.4112 3.125 9.8224 3.3631 10.0389 3.731 L 14.3244 10.7653 C 14.4542 10.9817 14.5408 11.2198 14.5408 11.4795 C 14.5408 12.2154 13.9348 12.8214 13.1772 12.8214 L 4.8011 12.8214 C 4.0652 12.8214 3.4591 12.2154 3.4591 11.4795 C 3.4591 11.2198 3.5241 10.9817 3.6539 10.7653 L 7.9394 3.731 C 8.1559 3.3631 8.5671 3.125 9 3.125 z M 4.5413 11.3064 C 4.4981 11.3713 4.4981 11.4146 4.4981 11.4795 C 4.4981 11.6527 4.6279 11.7825 4.8011 11.7825 L 13.1772 11.7825 C 13.3504 11.7825 13.5019 11.6527 13.5019 11.4795 C 13.5019 11.4146 13.4802 11.3713 13.437 11.3064 L 9.1515 4.2721 C 9.1298 4.2072 9.0649 4.1639 9 4.1639 C 8.9134 4.1639 8.8701 4.2072 8.8268 4.2721 L 4.5413 11.3064 z M 9.5194 8.4927 C 9.5194 8.7957 9.2813 9.0121 9 9.0121 C 8.6969 9.0121 8.4805 8.7957 8.4805 8.4927 L 8.4805 6.4149 C 8.4805 6.1335 8.6969 5.8954 9 5.8954 C 9.2813 5.8954 9.5194 6.1335 9.5194 6.4149 L 9.5194 8.4927 z M 9 11.0899 C 8.6104 11.0899 8.3074 10.7869 8.3074 10.3973 C 8.3074 10.0294 8.6104 9.7047 9 9.7047 C 9.3679 9.7047 9.6926 10.0294 9.6926 10.3973 C 9.6926 10.7869 9.3679 11.0899 9 11.0899 z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$alert = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$alert);
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$clock = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'clock',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$clock = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$clock);
var $author$project$FontAwesome$Internal$gauge = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'gauge',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 0 8.9824 C 0 5.7832 1.6875 2.8301 4.5 1.2129 C 7.2774 -0.4043 10.6875 -0.4043 13.5 1.2129 C 16.2773 2.8301 18 5.7832 18 8.9824 C 18 12.2168 16.2773 15.1699 13.5 16.7871 C 10.6875 18.4043 7.2774 18.4043 4.5 16.7871 C 1.6875 15.1699 0 12.2168 0 8.9824 Z M 11.25 12.3574 C 11.25 12.2519 11.2148 12.1113 11.2148 12.0058 L 15.3281 9.4394 C 15.7148 9.1933 15.8555 8.666 15.6094 8.2793 C 15.3633 7.8926 14.8359 7.7519 14.4492 7.998 L 10.3008 10.5644 C 9.9492 10.2832 9.4922 10.1074 9 10.1074 C 7.7344 10.1074 6.75 11.1269 6.75 12.3574 C 6.75 13.623 7.7344 14.6074 9 14.6074 C 10.2305 14.6074 11.25 13.623 11.25 12.3574 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$gauge = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$gauge);
var $author$project$FontAwesome$Internal$noEntry = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'no-entry',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M9 18.000011C13.970554 18.000011 17.999954 13.970611 17.999954 9C17.999954 4.029441 13.970554 0 9 0C4.029434 0 0 4.029441 0 9C0 13.970611 4.029434 18.000011 9 18.000011ZM15.878354 7.939171L15.878354 10.585611L1.984794 10.585611L1.984794 7.939171L15.878354 7.939171z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$noEntry = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$noEntry);
var $author$project$FontAwesome$Internal$highWater = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'high-water',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 2 7 L 2 5.6667 C 2.4433 5.6667 2.7729 5.5556 2.9888 5.3333 C 3.2046 5.1111 3.6567 5 4.345 5 C 5.01 5 5.4562 5.1111 5.6837 5.3333 C 5.9112 5.5556 6.235 5.6667 6.655 5.6667 C 7.0983 5.6667 7.4279 5.5556 7.6437 5.3333 C 7.8596 5.1111 8.3117 5 9 5 C 9.665 5 10.1142 5.1111 10.3475 5.3333 C 10.5808 5.5556 10.9017 5.6667 11.31 5.6667 C 11.7533 5.6667 12.0829 5.5556 12.2988 5.3333 C 12.5146 5.1111 12.9667 5 13.655 5 C 14.32 5 14.7721 5.1111 15.0113 5.3333 C 15.2504 5.5556 15.58 5.6667 16 5.6667 L 16 7 C 15.3117 7 14.8537 6.8889 14.6263 6.6667 C 14.3987 6.4444 14.075 6.3333 13.655 6.3333 S 12.9171 6.4444 12.7012 6.6667 C 12.4854 6.8889 12.0333 7 11.345 7 C 10.68 7 10.2279 6.8889 9.9887 6.6667 C 9.7496 6.4444 9.42 6.3333 9 6.3333 C 8.5567 6.3333 8.2329 6.4444 8.0288 6.6667 C 7.8246 6.8889 7.3783 7 6.69 7 C 6.0017 7 5.5438 6.8889 5.3163 6.6667 C 5.0888 6.4444 4.765 6.3333 4.345 6.3333 S 3.5954 6.4444 3.3563 6.6667 C 3.1171 6.8889 2.665 7 2 7 Z M 2 10 L 2 8.6667 C 2.4433 8.6667 2.7729 8.5556 2.9888 8.3333 C 3.2046 8.1111 3.6567 8 4.345 8 C 5.01 8 5.4562 8.1111 5.6837 8.3333 C 5.9112 8.5556 6.235 8.6667 6.655 8.6667 C 7.0983 8.6667 7.4279 8.5556 7.6437 8.3333 C 7.8596 8.1111 8.3117 8 9 8 C 9.665 8 10.1142 8.1111 10.3475 8.3333 C 10.5808 8.5556 10.9017 8.6667 11.31 8.6667 C 11.7533 8.6667 12.0829 8.5556 12.2988 8.3333 C 12.5146 8.1111 12.9667 8 13.655 8 C 14.32 8 14.7721 8.1111 15.0113 8.3333 C 15.2504 8.5556 15.58 8.6667 16 8.6667 L 16 10 C 15.3117 10 14.8537 9.8889 14.6263 9.6667 C 14.3987 9.4444 14.075 9.3333 13.655 9.3333 S 12.9171 9.4444 12.7012 9.6667 C 12.4854 9.8889 12.0333 10 11.345 10 C 10.68 10 10.2279 9.8889 9.9887 9.6667 C 9.7496 9.4444 9.42 9.3333 9 9.3333 C 8.5567 9.3333 8.2329 9.4444 8.0288 9.6667 C 7.8246 9.8889 7.3783 10 6.69 10 C 6.0017 10 5.5438 9.8889 5.3163 9.6667 C 5.0888 9.4444 4.765 9.3333 4.345 9.3333 S 3.5954 9.4444 3.3563 9.6667 C 3.1171 9.8889 2.665 10 2 10 Z M 2 13 L 2 11.6667 C 2.4433 11.6667 2.7729 11.5556 2.9888 11.3333 C 3.2046 11.1111 3.6567 11 4.345 11 C 5.01 11 5.4562 11.1111 5.6837 11.3333 C 5.9112 11.5556 6.235 11.6667 6.655 11.6667 C 7.0983 11.6667 7.4279 11.5556 7.6437 11.3333 C 7.8596 11.1111 8.3117 11 9 11 C 9.665 11 10.1142 11.1111 10.3475 11.3333 C 10.5808 11.5556 10.9017 11.6667 11.31 11.6667 C 11.7533 11.6667 12.0829 11.5556 12.2988 11.3333 C 12.5146 11.1111 12.9667 11 13.655 11 C 14.32 11 14.7721 11.1111 15.0113 11.3333 C 15.2504 11.5556 15.58 11.6667 16 11.6667 L 16 13 C 15.3117 13 14.8537 12.8889 14.6263 12.6667 C 14.3987 12.4444 14.075 12.3333 13.655 12.3333 S 12.9171 12.4444 12.7012 12.6667 C 12.4854 12.8889 12.0333 13 11.345 13 C 10.68 13 10.2279 12.8889 9.9887 12.6667 C 9.7496 12.4444 9.42 12.3333 9 12.3333 C 8.5567 12.3333 8.2329 12.4444 8.0288 12.6667 C 7.8246 12.8889 7.3783 13 6.69 13 C 6.0017 13 5.5438 12.8889 5.3163 12.6667 C 5.0888 12.4444 4.765 12.3333 4.345 12.3333 S 3.5954 12.4444 3.3563 12.6667 C 3.1171 12.8889 2.665 13 2 13 Z M 9 18 C 13.9706 18 18 13.9706 18 9 C 18 4.0294 13.9706 -0 9 -0 C 4.0294 -0 0 4.0294 0 9 C 0 13.9706 4.0294 18 9 18 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$highWater = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$highWater);
var $author$project$FontAwesome$Internal$lowBattery = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'low-battery',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 9 18 C 13.9706 18 18 13.9706 18 9 C 18 4.0294 13.9706 0 9 0 C 4.0295 0 0 4.0294 0 9 C 0 13.9706 4.0295 18 9 18 Z M 12.4284 5.6339 C 13.2855 5.6339 13.9868 6.3913 13.9868 7.317 L 13.9868 7.6536 C 14.3179 7.6536 14.6101 7.9691 14.6101 8.3268 L 14.6101 9.6732 C 14.6101 10.0519 14.3179 10.3464 13.9868 10.3464 L 13.9868 10.683 C 13.9868 11.6297 13.2855 12.3661 12.4284 12.3661 L 4.9483 12.3661 C 4.0717 12.3661 3.3899 11.6297 3.3899 10.683 L 3.3899 7.317 C 3.3899 6.3913 4.0717 5.6339 4.9483 5.6339 L 12.4284 5.6339 z M 4.9483 6.6437 C 4.5976 6.6437 4.3249 6.9593 4.3249 7.317 L 4.3249 10.683 C 4.3249 11.0617 4.5976 11.3563 4.9483 11.3563 L 12.4284 11.3563 C 12.7596 11.3563 13.0518 11.0617 13.0518 10.683 L 13.0518 7.317 C 13.0518 6.9593 12.7596 6.6437 12.4284 6.6437 L 4.9483 6.6437 z M 5.2599 10.3464 L 5.2599 7.6536 L 6.5066 7.6536 L 6.5066 10.3464 L 5.2599 10.3464 z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$lowBattery = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$lowBattery);
var $author$project$Views$Mapbox$alertIcon = function (alertType) {
	switch (alertType.$) {
		case 'CapsizeAlert':
			return $lattyware$elm_fontawesome$FontAwesome$view(
				A2(
					$lattyware$elm_fontawesome$FontAwesome$styled,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-danger fs-4')
						]),
					$author$project$FontAwesome$Custom$alert));
		case 'RestrictedZone':
			return $lattyware$elm_fontawesome$FontAwesome$view(
				A2(
					$lattyware$elm_fontawesome$FontAwesome$styled,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-danger fs-4')
						]),
					$author$project$FontAwesome$Custom$noEntry));
		case 'OverSpeed':
			return $lattyware$elm_fontawesome$FontAwesome$view(
				A2(
					$lattyware$elm_fontawesome$FontAwesome$styled,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-danger fs-4')
						]),
					$author$project$FontAwesome$Custom$gauge));
		case 'LowBattery':
			return $lattyware$elm_fontawesome$FontAwesome$view(
				A2(
					$lattyware$elm_fontawesome$FontAwesome$styled,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-danger fs-4')
						]),
					$author$project$FontAwesome$Custom$lowBattery));
		case 'HighWater':
			return $lattyware$elm_fontawesome$FontAwesome$view(
				A2(
					$lattyware$elm_fontawesome$FontAwesome$styled,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-danger fs-4')
						]),
					$author$project$FontAwesome$Custom$highWater));
		default:
			return $lattyware$elm_fontawesome$FontAwesome$view(
				A2(
					$lattyware$elm_fontawesome$FontAwesome$styled,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-danger fs-4')
						]),
					$lattyware$elm_fontawesome$FontAwesome$Solid$clock));
	}
};
var $author$project$FontAwesome$Internal$stopped = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'stopped',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M9 0C4.02943725 0 0 4.02943725 0 9C0 13.9705627 4.02943725 18 9 18C13.9705627 18 18 13.9705627 18 9C18 4.02943725 13.9705627 0 9 0zM11.25454 6.54544C11.3649969 6.54544 11.45454 6.63498305 11.45454 6.74544L11.45454 11.25453C11.45454 11.3649869 11.3649969 11.45453 11.25454 11.45453L6.74545 11.45453C6.63499305 11.45453 6.54545 11.3649869 6.54545 11.25453L6.54545 6.74544C6.54545 6.63498305 6.63499305 6.54544 6.74545 6.54544L11.25454 6.54544z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$stopped = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$stopped);
var $author$project$FontAwesome$Internal$underway = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'underway',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M4.29682,5.80149 C4.03258,5.85015 3.84772,6.08164 3.84772,6.35033 L3.84772,11.56109 C3.84772,11.83079 4.03389,12.06279 4.29925,12.11059 C5.40124,12.30919 8.27394,12.73459 10.13346,12.17269 C11.95096,11.62339 14.07846,9.74457 14.68116,9.18807 C14.77426,9.10207 14.77656,8.95911 14.68586,8.8705 C14.09296,8.29092 11.97786,6.31543 10.13346,5.74085 C8.27751,5.16268 5.39802,5.59872 4.29682,5.80149 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$underway = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$underway);
var $author$project$FontAwesome$Internal$stoppedOffline = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'stopped-offline',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 11.8543 15.938 L 12.4255 17.3249 C 11.3481 17.7687 10.1895 18 9 18 L 9 16.5 C 9.9927 16.5 10.9572 16.3075 11.8543 15.938 Z M 8.7122 16.4946 C 8.8061 16.4981 8.9003 16.4999 8.9946 16.5 L 8.9936 18 C 8.8807 17.9999 8.7681 17.9978 8.6558 17.9935 L 8.7122 16.4946 Z M 3.5219 14.1226 C 4.1906 14.8374 4.9929 15.4164 5.8825 15.8236 L 5.2583 17.1875 C 4.1904 16.6988 3.2283 16.0044 2.4265 15.1473 L 3.5219 14.1226 Z M 15.9103 11.9207 L 17.2916 12.5053 C 16.8337 13.5872 16.1671 14.5687 15.3332 15.3946 L 14.2776 14.3289 C 14.9731 13.64 15.5289 12.8219 15.9103 11.9207 Z M 0.0036 8.7414 L 1.5031 8.7838 C 1.5011 8.8543 1.5 8.9249 1.5 8.9952 C 1.5 9.9184 1.6648 10.8135 1.983 11.6542 L 0.5801 12.1852 C 0.1979 11.1754 0 10.1004 0 8.9948 C 0 8.9102 0.0013 8.8258 0.0036 8.7414 Z M 11.2546 6.5455 C 11.365 6.5455 11.4546 6.635 11.4546 6.7455 L 11.4546 11.2546 C 11.4546 11.365 11.365 11.4546 11.2546 11.4546 L 6.7455 11.4546 C 6.635 11.4546 6.5455 11.365 6.5455 11.2546 L 6.5455 6.7455 C 6.5455 6.635 6.635 6.5455 6.7455 6.5455 L 11.2546 6.5455 Z M 17.3576 5.6547 C 17.7802 6.7098 18 7.8403 18 9.0013 L 17.9996 9.0858 L 16.4997 9.0717 L 16.5 9.0012 C 16.5 8.0322 16.317 7.0909 15.9651 6.2125 L 17.3576 5.6547 Z M 2.7902 2.4856 L 3.8253 3.5711 C 3.1168 4.2467 2.5454 5.0544 2.1468 5.948 L 0.7769 5.337 C 1.2554 4.2642 1.9407 3.2955 2.7902 2.4856 Z M 12.5845 0.7423 C 13.6618 1.2106 14.6369 1.8865 15.4548 2.7282 L 14.3791 3.7736 C 13.6969 3.0716 12.884 2.5081 11.9866 2.118 L 12.5845 0.7423 Z M 9.1093 0.0007 L 9.1718 0.0016 L 9.1437 1.5013 L 9.1136 1.5009 L 9.0027 1.5 C 8.0569 1.5 7.1386 1.6738 6.279 2.0086 L 5.7346 0.6109 C 6.7671 0.2087 7.8699 0 9.0029 0 L 9.1093 0.0007 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$stoppedOffline = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$stoppedOffline);
var $author$project$FontAwesome$Internal$underwayOffline = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'underway-offline',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 11.8543 15.938 L 12.4255 17.3249 C 11.3481 17.7687 10.1895 18 9 18 L 9 16.5 C 9.9927 16.5 10.9572 16.3075 11.8543 15.938 Z M 8.7122 16.4946 C 8.8061 16.4981 8.9003 16.4999 8.9946 16.5 L 8.9936 18 C 8.8807 17.9999 8.7681 17.9978 8.6558 17.9935 L 8.7122 16.4946 Z M 3.5219 14.1226 C 4.1906 14.8374 4.9929 15.4164 5.8825 15.8236 L 5.2583 17.1875 C 4.1904 16.6988 3.2283 16.0044 2.4265 15.1473 L 3.5219 14.1226 Z M 15.9103 11.9207 L 17.2916 12.5053 C 16.8337 13.5872 16.1671 14.5687 15.3332 15.3946 L 14.2776 14.3289 C 14.9731 13.64 15.5289 12.8219 15.9103 11.9207 Z M 10.5499 5.7557 C 12.4102 6.3352 14.5432 8.3255 15.146 8.9145 C 15.2391 9.0054 15.2367 9.1525 15.1411 9.2407 C 14.5283 9.8063 12.383 11.6991 10.5499 12.253 C 8.6757 12.8195 5.7824 12.3929 4.6638 12.1917 C 4.3914 12.1427 4.2002 11.9045 4.2002 11.6278 L 4.2002 6.3788 C 4.2002 6.103 4.39 5.8654 4.6612 5.8156 C 5.7791 5.6102 8.6793 5.1729 10.5499 5.7557 Z M 0.0036 8.7414 L 1.5031 8.7838 C 1.5011 8.8543 1.5 8.9249 1.5 8.9952 C 1.5 9.9184 1.6648 10.8135 1.983 11.6542 L 0.5801 12.1852 C 0.1979 11.1754 0 10.1004 0 8.9948 C 0 8.9102 0.0013 8.8258 0.0036 8.7414 Z M 17.3576 5.6547 C 17.7802 6.7098 18 7.8403 18 9.0013 L 17.9996 9.0858 L 16.4997 9.0717 L 16.5 9.0012 C 16.5 8.0322 16.317 7.0909 15.9651 6.2125 L 17.3576 5.6547 Z M 2.7902 2.4856 L 3.8253 3.5711 C 3.1168 4.2467 2.5454 5.0544 2.1468 5.948 L 0.7769 5.337 C 1.2554 4.2642 1.9407 3.2955 2.7902 2.4856 Z M 12.5845 0.7423 C 13.6618 1.2106 14.6369 1.8865 15.4548 2.7282 L 14.3791 3.7736 C 13.6969 3.0716 12.884 2.5081 11.9866 2.118 L 12.5845 0.7423 Z M 9.1093 0.0007 L 9.1718 0.0016 L 9.1437 1.5013 L 9.1136 1.5009 L 9.0027 1.5 C 8.0569 1.5 7.1386 1.6738 6.279 2.0086 L 5.7346 0.6109 C 6.7671 0.2087 7.8699 0 9.0029 0 L 9.1093 0.0007 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$underwayOffline = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$underwayOffline);
var $author$project$Views$Mapbox$statusIcon = F2(
	function (isOffline, status) {
		if (isOffline) {
			if (status.$ === 'Underway') {
				return $lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('text-secondary fs-4')
							]),
						$author$project$FontAwesome$Custom$underwayOffline));
			} else {
				return $lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('text-secondary fs-4')
							]),
						$author$project$FontAwesome$Custom$stoppedOffline));
			}
		} else {
			if (status.$ === 'Underway') {
				return $lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('text-success fs-4')
							]),
						$author$project$FontAwesome$Custom$underway));
			} else {
				return $lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('text-success fs-4')
							]),
						$author$project$FontAwesome$Custom$stopped));
			}
		}
	});
var $author$project$Views$Mapbox$boatLabel = F4(
	function (name, alertTypes, isOffline, status) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marker-label'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '50%'),
					A2($elm$html$Html$Attributes$style, 'left', '50%'),
					A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -150%)')
				]),
			A2(
				$elm$core$List$append,
				A2($elm$core$List$map, $author$project$Views$Mapbox$alertIcon, alertTypes),
				_List_fromArray(
					[
						$elm$html$Html$text(name),
						A2($author$project$Views$Mapbox$statusIcon, isOffline, status)
					])));
	});
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $author$project$Views$Mapbox$markerColor = function (style) {
	switch (style.$) {
		case 'Satellite':
			return $author$project$Views$Mapbox$goldColor;
		case 'Chart':
			return $author$project$Views$Mapbox$coralColor;
		default:
			return $author$project$Views$Mapbox$coralColor;
	}
};
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $author$project$Views$Mapbox$stoppedBoatImage = F3(
	function (style, isOffline, isSelected) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('-6 -6 12 12'),
					$elm$svg$Svg$Attributes$width('12'),
					$elm$svg$Svg$Attributes$height('12')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0'),
							$elm$svg$Svg$Attributes$fill(
							isSelected ? $author$project$Views$Mapbox$greenColor : $author$project$Views$Mapbox$markerColor(style)),
							$elm$svg$Svg$Attributes$fillOpacity(
							isOffline ? '0.5' : '1'),
							$elm$svg$Svg$Attributes$strokeWidth(
							(isOffline || (!_Utils_eq(style, $author$project$Views$Mapbox$Satellite))) ? '1' : '0'),
							$elm$svg$Svg$Attributes$stroke(
							_Utils_eq(style, $author$project$Views$Mapbox$Satellite) ? (isSelected ? $author$project$Views$Mapbox$greenColor : $author$project$Views$Mapbox$goldColor) : 'white'),
							$elm$svg$Svg$Attributes$strokeOpacity(
							isOffline ? '0.75' : '1')
						]),
					_List_Nil)
				]));
	});
var $author$project$Views$Mapbox$underwayBoatImage = F4(
	function (style, isOffline, heading, isSelected) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('-5 -8 10 16'),
					$elm$svg$Svg$Attributes$width('20'),
					$elm$svg$Svg$Attributes$height('20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$transform(
							'scale(0.75) rotate(' + ($elm$core$String$fromFloat(heading) + ' 0 0)')),
							$elm$svg$Svg$Attributes$d('M 4.3867 8 L -4.3743 8 C -4.3743 8 -5.6265 2.2516 -4.588 -1.1429 C -3.6223 -4.2989 0 -8 0 -8 C 0 -8 3.6756 -4.2584 4.6003 -1.1429 C 5.6107 2.2613 4.3867 8 4.3867 8 Z'),
							$elm$svg$Svg$Attributes$fill(
							isSelected ? $author$project$Views$Mapbox$greenColor : $author$project$Views$Mapbox$markerColor(style)),
							$elm$svg$Svg$Attributes$fillOpacity(
							isOffline ? '0.5' : '1'),
							$elm$svg$Svg$Attributes$strokeWidth(
							(isOffline || (!_Utils_eq(style, $author$project$Views$Mapbox$Satellite))) ? '1' : '0'),
							$elm$svg$Svg$Attributes$stroke(
							_Utils_eq(style, $author$project$Views$Mapbox$Satellite) ? (isSelected ? $author$project$Views$Mapbox$greenColor : $author$project$Views$Mapbox$goldColor) : 'white'),
							$elm$svg$Svg$Attributes$strokeOpacity(
							isOffline ? '0.75' : '1')
						]),
					_List_Nil)
				]));
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Data$Boat$uniqueActiveAlerts = function (boat) {
	return A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		function ($) {
			return $.type_;
		},
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.timestamp;
				},
				A2(
					$elm$core$Basics$composeR,
					$jweir$elm_iso8601$ISO8601$toPosix,
					A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$Basics$negate))),
			boat.activeAlerts));
};
var $author$project$Views$Mapbox$boatMarker = F5(
	function (boat, mapStyle, isSelected, hideLabel, onClick) {
		var _v0 = boat.latLong;
		if (_v0.$ === 'Just') {
			var ll = _v0.a;
			return A4(
				$author$project$Mapbox$Element$marker,
				{lat: ll.lat, lng: ll._long},
				false,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(onClick)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'padding', '0'),
								A2($elm$html$Html$Attributes$style, 'margin', '0'),
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
							]),
						_List_fromArray(
							[
								(isSelected || hideLabel) ? A2($elm$html$Html$span, _List_Nil, _List_Nil) : A4(
								$author$project$Views$Mapbox$boatLabel,
								boat.name,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.type_;
									},
									$author$project$Data$Boat$uniqueActiveAlerts(boat)),
								boat.isOffline,
								boat.status),
								function () {
								var _v1 = boat.heading;
								if (_v1.$ === 'Just') {
									var b = _v1.a;
									return A4($author$project$Views$Mapbox$underwayBoatImage, mapStyle, boat.isOffline, b, isSelected);
								} else {
									return A3($author$project$Views$Mapbox$stoppedBoatImage, mapStyle, boat.isOffline, isSelected);
								}
							}()
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Mapbox$tracksToLayer = function (ts) {
	var trackFeature = function (t) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Feature')),
					_Utils_Tuple2(
					'properties',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'trackId',
								$elm$json$Json$Encode$string(t.trackId))
							]))),
					_Utils_Tuple2(
					'geometry',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('LineString')),
								_Utils_Tuple2(
								'coordinates',
								A2(
									$elm$json$Json$Encode$list,
									$author$project$Views$Mapbox$latLongToGeoJSON,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.latLong;
										},
										t.points)))
							])))
				]));
	};
	return _Utils_Tuple2(
		'tracks',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('FeatureCollection')),
					_Utils_Tuple2(
					'features',
					A2($elm$json$Json$Encode$list, trackFeature, ts))
				])));
};
var $author$project$Views$Mapbox$withTracks = F2(
	function (tracks, config) {
		return _Utils_update(
			config,
			{
				sources: A2(
					$author$project$Views$Mapbox$addOrReplaceSource,
					$author$project$Views$Mapbox$tracksToLayer(tracks),
					config.sources)
			});
	});
var $author$project$Pages$Fleet_$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $mdgriffith$elm_animator$Internal$Timeline$Line = F3(
	function (a, b, c) {
		return {$: 'Line', a: a, b: b, c: c};
	});
var $mdgriffith$elm_animator$Internal$Timeline$endTime = function (_v0) {
	var end = _v0.c;
	return end;
};
var $mdgriffith$elm_animator$Internal$Timeline$getEvent = function (_v0) {
	var ev = _v0.a;
	return ev;
};
var $mdgriffith$elm_animator$Internal$Timeline$startTime = function (_v0) {
	var time = _v0.b;
	return time;
};
var $ianmackenzie$elm_units$Quantity$greaterThan = F2(
	function (_v0, _v1) {
		var y = _v0.a;
		var x = _v1.a;
		return _Utils_cmp(x, y) > 0;
	});
var $ianmackenzie$elm_units$Duration$seconds = function (numSeconds) {
	return $ianmackenzie$elm_units$Quantity$Quantity(numSeconds);
};
var $ianmackenzie$elm_units$Duration$milliseconds = function (numMilliseconds) {
	return $ianmackenzie$elm_units$Duration$seconds(0.001 * numMilliseconds);
};
var $mdgriffith$elm_animator$Internal$Time$inMilliseconds = function (_v0) {
	var ms = _v0.a;
	return ms;
};
var $mdgriffith$elm_animator$Internal$Time$duration = F2(
	function (one, two) {
		return A2($ianmackenzie$elm_units$Quantity$greaterThan, two, one) ? $ianmackenzie$elm_units$Duration$milliseconds(
			A2(
				$elm$core$Basics$max,
				0,
				$mdgriffith$elm_animator$Internal$Time$inMilliseconds(one) - $mdgriffith$elm_animator$Internal$Time$inMilliseconds(two))) : $ianmackenzie$elm_units$Duration$milliseconds(
			A2(
				$elm$core$Basics$max,
				0,
				$mdgriffith$elm_animator$Internal$Time$inMilliseconds(two) - $mdgriffith$elm_animator$Internal$Time$inMilliseconds(one)));
	});
var $mdgriffith$elm_animator$Internal$Timeline$Occurring = F3(
	function (a, b, c) {
		return {$: 'Occurring', a: a, b: b, c: c};
	});
var $ianmackenzie$elm_units$Quantity$plus = F2(
	function (_v0, _v1) {
		var y = _v0.a;
		var x = _v1.a;
		return $ianmackenzie$elm_units$Quantity$Quantity(x + y);
	});
var $ianmackenzie$elm_units$Duration$inSeconds = function (_v0) {
	var numSeconds = _v0.a;
	return numSeconds;
};
var $ianmackenzie$elm_units$Duration$inMilliseconds = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) * 1000;
};
var $mdgriffith$elm_animator$Internal$Time$advanceBy = F2(
	function (dur, time) {
		return A2(
			$ianmackenzie$elm_units$Quantity$plus,
			time,
			$ianmackenzie$elm_units$Quantity$Quantity(
				$ianmackenzie$elm_units$Duration$inMilliseconds(dur)));
	});
var $ianmackenzie$elm_units$Quantity$multiplyBy = F2(
	function (scale, _v0) {
		var value = _v0.a;
		return $ianmackenzie$elm_units$Quantity$Quantity(scale * value);
	});
var $mdgriffith$elm_animator$Internal$Timeline$adjustTime = F4(
	function (lookup, getPersonality, unmodified, upcomingOccurring) {
		var event = unmodified.a;
		var start = unmodified.b;
		var eventEnd = unmodified.c;
		if (!upcomingOccurring.b) {
			return unmodified;
		} else {
			var _v1 = upcomingOccurring.a;
			var next = _v1.a;
			var nextStartTime = _v1.b;
			var personality = getPersonality(
				lookup(event));
			if (!(!personality.departLate)) {
				var nextPersonality = getPersonality(
					lookup(next));
				var totalPortions = A2($elm$core$Basics$max, personality.departLate + nextPersonality.arriveEarly, 1);
				var totalDuration = A2($mdgriffith$elm_animator$Internal$Time$duration, eventEnd, nextStartTime);
				var lateBy = A2($ianmackenzie$elm_units$Quantity$multiplyBy, personality.departLate / totalPortions, totalDuration);
				return A3(
					$mdgriffith$elm_animator$Internal$Timeline$Occurring,
					event,
					start,
					A2($mdgriffith$elm_animator$Internal$Time$advanceBy, lateBy, eventEnd));
			} else {
				return unmodified;
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Time$thisBeforeThat = F2(
	function (_v0, _v1) {
		var _this = _v0.a;
		var that = _v1.a;
		return (_this - that) < 0;
	});
var $mdgriffith$elm_animator$Internal$Timeline$hasDwell = function (_v0) {
	var start = _v0.b.a;
	var end = _v0.c.a;
	return !(!(start - end));
};
var $ianmackenzie$elm_units$Quantity$minus = F2(
	function (_v0, _v1) {
		var y = _v0.a;
		var x = _v1.a;
		return $ianmackenzie$elm_units$Quantity$Quantity(x - y);
	});
var $mdgriffith$elm_animator$Internal$Time$rollbackBy = F2(
	function (dur, time) {
		return A2(
			$ianmackenzie$elm_units$Quantity$minus,
			$ianmackenzie$elm_units$Quantity$Quantity(
				$ianmackenzie$elm_units$Duration$inMilliseconds(dur)),
			time);
	});
var $mdgriffith$elm_animator$Internal$Time$zeroDuration = function (_v0) {
	var dur = _v0.a;
	return !dur;
};
var $mdgriffith$elm_animator$Internal$Timeline$adjustTimeWithPrevious = F5(
	function (lookup, getPersonality, _v0, unmodified, upcomingOccurring) {
		var prev = _v0.a;
		var prevStart = _v0.b;
		var prevEnd = _v0.c;
		var event = unmodified.a;
		var start = unmodified.b;
		var eventEnd = unmodified.c;
		var totalPrevDuration = A2($mdgriffith$elm_animator$Internal$Time$duration, prevEnd, start);
		var prevPersonality = getPersonality(
			lookup(prev));
		var personality = getPersonality(
			lookup(event));
		var totalPrevPortions = A2($elm$core$Basics$max, prevPersonality.departLate + personality.arriveEarly, 1);
		var earlyBy = A2($ianmackenzie$elm_units$Quantity$multiplyBy, personality.arriveEarly / totalPrevPortions, totalPrevDuration);
		if (!upcomingOccurring.b) {
			return $mdgriffith$elm_animator$Internal$Time$zeroDuration(earlyBy) ? unmodified : A3(
				$mdgriffith$elm_animator$Internal$Timeline$Occurring,
				event,
				A2($mdgriffith$elm_animator$Internal$Time$rollbackBy, earlyBy, start),
				eventEnd);
		} else {
			var _v2 = upcomingOccurring.a;
			var next = _v2.a;
			var nextStartTime = _v2.b;
			if (!(!personality.departLate)) {
				var nextPersonality = getPersonality(
					lookup(next));
				var totalPortions = A2($elm$core$Basics$max, personality.departLate + nextPersonality.arriveEarly, 1);
				var totalDuration = A2($mdgriffith$elm_animator$Internal$Time$duration, eventEnd, nextStartTime);
				var lateBy = A2($ianmackenzie$elm_units$Quantity$multiplyBy, personality.departLate / totalPortions, totalDuration);
				return A3(
					$mdgriffith$elm_animator$Internal$Timeline$Occurring,
					event,
					A2($mdgriffith$elm_animator$Internal$Time$rollbackBy, earlyBy, start),
					A2($mdgriffith$elm_animator$Internal$Time$advanceBy, lateBy, eventEnd));
			} else {
				if ($mdgriffith$elm_animator$Internal$Time$zeroDuration(earlyBy)) {
					return unmodified;
				} else {
					return A3(
						$mdgriffith$elm_animator$Internal$Timeline$Occurring,
						event,
						A2($mdgriffith$elm_animator$Internal$Time$rollbackBy, earlyBy, start),
						eventEnd);
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$createLookAhead = F4(
	function (fn, lookup, currentEvent, upcomingEvents) {
		if (!upcomingEvents.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var unadjustedUpcoming = upcomingEvents.a;
			var remain = upcomingEvents.b;
			var upcomingOccurring = A5($mdgriffith$elm_animator$Internal$Timeline$adjustTimeWithPrevious, lookup, fn.adjustor, currentEvent, unadjustedUpcoming, remain);
			return $elm$core$Maybe$Just(
				{
					time: $mdgriffith$elm_animator$Internal$Time$inMilliseconds(
						$mdgriffith$elm_animator$Internal$Timeline$startTime(upcomingOccurring)),
					anchor: lookup(
						$mdgriffith$elm_animator$Internal$Timeline$getEvent(upcomingOccurring)),
					resting: $mdgriffith$elm_animator$Internal$Timeline$hasDwell(upcomingOccurring)
				});
		}
	});
var $mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat = F2(
	function (_v0, _v1) {
		var _this = _v0.a;
		var that = _v1.a;
		return (_this - that) <= 0;
	});
var $mdgriffith$elm_animator$Internal$Timeline$overLines = F7(
	function (fn, lookup, details, maybePreviousEvent, _v0, futureLines, state) {
		overLines:
		while (true) {
			var lineStart = _v0.a;
			var unadjustedStartEvent = _v0.b;
			var lineRemain = _v0.c;
			var lineStartEv = function () {
				if (maybePreviousEvent.$ === 'Nothing') {
					return A4($mdgriffith$elm_animator$Internal$Timeline$adjustTime, lookup, fn.adjustor, unadjustedStartEvent, lineRemain);
				} else {
					var prev = maybePreviousEvent.a;
					return A5($mdgriffith$elm_animator$Internal$Timeline$adjustTimeWithPrevious, lookup, fn.adjustor, prev, unadjustedStartEvent, lineRemain);
				}
			}();
			var transition = function (newState) {
				if (!futureLines.b) {
					return newState;
				} else {
					var future = futureLines.a;
					var futureStart = future.a;
					var futureStartEv = future.b;
					var futureRemain = future.c;
					var restOfFuture = futureLines.b;
					return A2($mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat, futureStart, details.now) ? A7($mdgriffith$elm_animator$Internal$Timeline$overLines, fn, lookup, details, $elm$core$Maybe$Nothing, future, restOfFuture, newState) : newState;
				}
			};
			var now = function () {
				if (!futureLines.b) {
					return details.now;
				} else {
					var _v4 = futureLines.a;
					var futureStart = _v4.a;
					var futureStartEv = _v4.b;
					var futureRemain = _v4.c;
					var restOfFuture = futureLines.b;
					return A2($mdgriffith$elm_animator$Internal$Time$thisBeforeThat, futureStart, details.now) ? futureStart : details.now;
				}
			}();
			if (A2(
				$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
				now,
				$mdgriffith$elm_animator$Internal$Timeline$startTime(lineStartEv))) {
				return transition(
					A7(
						fn.lerp,
						$mdgriffith$elm_animator$Internal$Time$inMilliseconds(lineStart),
						$elm$core$Maybe$Just(
							lookup(details.initial)),
						lookup(
							$mdgriffith$elm_animator$Internal$Timeline$getEvent(lineStartEv)),
						$mdgriffith$elm_animator$Internal$Time$inMilliseconds(
							$mdgriffith$elm_animator$Internal$Timeline$startTime(lineStartEv)),
						$mdgriffith$elm_animator$Internal$Time$inMilliseconds(now),
						A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedStartEvent, lineRemain),
						state));
			} else {
				if (A2(
					$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
					now,
					$mdgriffith$elm_animator$Internal$Timeline$endTime(lineStartEv))) {
					return transition(
						A5(
							fn.visit,
							lookup,
							lineStartEv,
							now,
							A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedStartEvent, lineRemain),
							state));
				} else {
					if (!lineRemain.b) {
						return transition(
							A5(fn.visit, lookup, lineStartEv, now, $elm$core$Maybe$Nothing, state));
					} else {
						var unadjustedNext = lineRemain.a;
						var lineRemain2 = lineRemain.b;
						var next = A5($mdgriffith$elm_animator$Internal$Timeline$adjustTimeWithPrevious, lookup, fn.adjustor, unadjustedStartEvent, unadjustedNext, lineRemain2);
						if (A2(
							$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
							now,
							$mdgriffith$elm_animator$Internal$Timeline$startTime(next))) {
							return transition(
								A7(
									fn.lerp,
									$mdgriffith$elm_animator$Internal$Time$inMilliseconds(
										$mdgriffith$elm_animator$Internal$Timeline$endTime(lineStartEv)),
									$elm$core$Maybe$Just(
										lookup(
											$mdgriffith$elm_animator$Internal$Timeline$getEvent(lineStartEv))),
									lookup(
										$mdgriffith$elm_animator$Internal$Timeline$getEvent(next)),
									$mdgriffith$elm_animator$Internal$Time$inMilliseconds(
										$mdgriffith$elm_animator$Internal$Timeline$startTime(next)),
									$mdgriffith$elm_animator$Internal$Time$inMilliseconds(now),
									A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedNext, lineRemain2),
									A5(
										fn.visit,
										lookup,
										lineStartEv,
										now,
										A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedStartEvent, lineRemain),
										state)));
						} else {
							if (A2(
								$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
								now,
								$mdgriffith$elm_animator$Internal$Timeline$endTime(next))) {
								return transition(
									A5(
										fn.visit,
										lookup,
										next,
										now,
										A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedNext, lineRemain2),
										state));
							} else {
								if (!lineRemain2.b) {
									return transition(
										A5(fn.visit, lookup, next, now, $elm$core$Maybe$Nothing, state));
								} else {
									var unadjustedNext2 = lineRemain2.a;
									var lineRemain3 = lineRemain2.b;
									var next2 = A5($mdgriffith$elm_animator$Internal$Timeline$adjustTimeWithPrevious, lookup, fn.adjustor, unadjustedNext, unadjustedNext2, lineRemain3);
									if (A2(
										$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
										now,
										$mdgriffith$elm_animator$Internal$Timeline$startTime(next2))) {
										var after = A5(
											fn.visit,
											lookup,
											next,
											now,
											A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedNext, lineRemain2),
											state);
										return transition(
											A7(
												fn.lerp,
												$mdgriffith$elm_animator$Internal$Time$inMilliseconds(
													$mdgriffith$elm_animator$Internal$Timeline$endTime(next)),
												$elm$core$Maybe$Just(
													lookup(
														$mdgriffith$elm_animator$Internal$Timeline$getEvent(next))),
												lookup(
													$mdgriffith$elm_animator$Internal$Timeline$getEvent(next2)),
												$mdgriffith$elm_animator$Internal$Time$inMilliseconds(
													$mdgriffith$elm_animator$Internal$Timeline$startTime(next2)),
												$mdgriffith$elm_animator$Internal$Time$inMilliseconds(now),
												A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedNext2, lineRemain3),
												after));
									} else {
										if (A2(
											$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
											now,
											$mdgriffith$elm_animator$Internal$Timeline$endTime(next2))) {
											return transition(
												A5(
													fn.visit,
													lookup,
													next2,
													now,
													A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedNext2, lineRemain3),
													state));
										} else {
											var after = A5(
												fn.visit,
												lookup,
												next2,
												now,
												A4($mdgriffith$elm_animator$Internal$Timeline$createLookAhead, fn, lookup, unadjustedNext2, lineRemain3),
												state);
											var $temp$fn = fn,
												$temp$lookup = lookup,
												$temp$details = details,
												$temp$maybePreviousEvent = $elm$core$Maybe$Just(next),
												$temp$_v0 = A3(
												$mdgriffith$elm_animator$Internal$Timeline$Line,
												$mdgriffith$elm_animator$Internal$Timeline$endTime(next),
												unadjustedNext2,
												lineRemain3),
												$temp$futureLines = futureLines,
												$temp$state = after;
											fn = $temp$fn;
											lookup = $temp$lookup;
											details = $temp$details;
											maybePreviousEvent = $temp$maybePreviousEvent;
											_v0 = $temp$_v0;
											futureLines = $temp$futureLines;
											state = $temp$state;
											continue overLines;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$foldp = F3(
	function (lookup, fn, _v0) {
		var timelineDetails = _v0.a;
		var _v1 = timelineDetails.events;
		var timetable = _v1.a;
		var start = fn.start(
			lookup(timelineDetails.initial));
		if (!timetable.b) {
			return start;
		} else {
			var firstLine = timetable.a;
			var remainingLines = timetable.b;
			return A7($mdgriffith$elm_animator$Internal$Timeline$overLines, fn, lookup, timelineDetails, $elm$core$Maybe$Nothing, firstLine, remainingLines, start);
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$linearDefault = {departLate: 0, wobbliness: 0, arriveEarly: 0, arriveSlowly: 0, departSlowly: 0};
var $mdgriffith$elm_animator$Internal$Timeline$current = function (timeline) {
	var details = timeline.a;
	return A3(
		$mdgriffith$elm_animator$Internal$Timeline$foldp,
		$elm$core$Basics$identity,
		{
			lerp: F7(
				function (_v0, _v1, target, _v2, _v3, _v4, _v5) {
					return target;
				}),
			start: function (_v6) {
				return details.initial;
			},
			visit: F5(
				function (lookup, target, targetTime, maybeLookAhead, state) {
					return $mdgriffith$elm_animator$Internal$Timeline$getEvent(target);
				}),
			adjustor: function (_v7) {
				return $mdgriffith$elm_animator$Internal$Timeline$linearDefault;
			},
			dwellPeriod: function (_v8) {
				return $elm$core$Maybe$Nothing;
			}
		},
		timeline);
};
var $mdgriffith$elm_animator$Animator$current = $mdgriffith$elm_animator$Internal$Timeline$current;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $zaboco$elm_draggable$Draggable$Msg = function (a) {
	return {$: 'Msg', a: a};
};
var $zaboco$elm_draggable$Internal$StartDragging = F2(
	function (a, b) {
		return {$: 'StartDragging', a: a, b: b};
	});
var $zaboco$elm_draggable$Internal$Position = F2(
	function (x, y) {
		return {x: x, y: y};
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $zaboco$elm_draggable$Draggable$positionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$zaboco$elm_draggable$Internal$Position,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$truncate,
		A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$truncate,
		A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float)));
var $zaboco$elm_draggable$Draggable$baseDecoder = function (key) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeL,
			$zaboco$elm_draggable$Draggable$Msg,
			$zaboco$elm_draggable$Internal$StartDragging(key)),
		$zaboco$elm_draggable$Draggable$positionDecoder);
};
var $zaboco$elm_draggable$Draggable$whenLeftMouseButtonPressed = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			if (!button) {
				return decoder;
			} else {
				return $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
			}
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $zaboco$elm_draggable$Draggable$alwaysPreventDefaultAndStopPropagation = function (msg) {
	return {message: msg, preventDefault: true, stopPropagation: true};
};
var $zaboco$elm_draggable$Draggable$mouseTrigger = F2(
	function (key, envelope) {
		return A2(
			$elm$html$Html$Events$custom,
			'mousedown',
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $zaboco$elm_draggable$Draggable$alwaysPreventDefaultAndStopPropagation, envelope),
				$zaboco$elm_draggable$Draggable$whenLeftMouseButtonPressed(
					$zaboco$elm_draggable$Draggable$baseDecoder(key))));
	});
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F3(
	function (alt, ctrl, shift) {
		return {alt: alt, ctrl: ctrl, shift: shift};
	});
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A4(
	$elm$json$Json$Decode$map3,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event = F4(
	function (keys, changedTouches, targetTouches, touches) {
		return {keys: keys, touches: touches, targetTouches: targetTouches, changedTouches: changedTouches};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch = F4(
	function (identifier, clientPos, pagePos, screenPos) {
		return {pagePos: pagePos, clientPos: clientPos, screenPos: screenPos, identifier: identifier};
	});
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch,
	A2($elm$json$Json$Decode$field, 'identifier', $elm$json$Json$Decode$int),
	$mpizenberg$elm_pointer_events$Internal$Decode$clientPos,
	$mpizenberg$elm_pointer_events$Internal$Decode$pagePos,
	$mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Internal$Decode$all = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf = function (itemDecoder) {
	var decodeOne = function (n) {
		return A2(
			$elm$json$Json$Decode$field,
			$elm$core$String$fromInt(n),
			itemDecoder);
	};
	var decodeN = function (n) {
		return $mpizenberg$elm_pointer_events$Internal$Decode$all(
			A2(
				$elm$core$List$map,
				decodeOne,
				A2($elm$core$List$range, 0, n - 1)));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeN,
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder = $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event,
	$mpizenberg$elm_pointer_events$Internal$Decode$keys,
	A2(
		$elm$json$Json$Decode$field,
		'changedTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'targetTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'touches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions = F3(
	function (event, options, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						message: tag(ev),
						preventDefault: options.preventDefault,
						stopPropagation: options.stopPropagation
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions = {preventDefault: true, stopPropagation: false};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onEnd = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchend', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $zaboco$elm_draggable$Internal$DragAt = function (a) {
	return {$: 'DragAt', a: a};
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onMove = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchmove', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchstart', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $zaboco$elm_draggable$Internal$StopDragging = {$: 'StopDragging'};
var $zaboco$elm_draggable$Draggable$touchTriggers = F2(
	function (key, envelope) {
		var touchToMouse = function (touchEvent) {
			return function (_v1) {
				var clientX = _v1.a;
				var clientY = _v1.b;
				return A2(
					$zaboco$elm_draggable$Internal$Position,
					$elm$core$Basics$round(clientX),
					$elm$core$Basics$round(clientY));
			}(
				A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(0, 0),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.clientPos;
						},
						$elm$core$List$head(touchEvent.changedTouches))));
		};
		var mouseToEnv = function (internal) {
			return A2(
				$elm$core$Basics$composeR,
				touchToMouse,
				A2(
					$elm$core$Basics$composeR,
					internal,
					A2($elm$core$Basics$composeR, $zaboco$elm_draggable$Draggable$Msg, envelope)));
		};
		return _List_fromArray(
			[
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart(
				mouseToEnv(
					$zaboco$elm_draggable$Internal$StartDragging(key))),
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onMove(
				mouseToEnv($zaboco$elm_draggable$Internal$DragAt)),
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onEnd(
				mouseToEnv(
					function (_v0) {
						return $zaboco$elm_draggable$Internal$StopDragging;
					}))
			]);
	});
var $author$project$Views$BottomSheet$view = F5(
	function (height, dragMsg, title, customAttrs, content) {
		return A2(
			$elm$html$Html$div,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'stretch')
						]),
						$elm_community$maybe_extra$Maybe$Extra$toList(
						A2(
							$elm$core$Maybe$map,
							function (h) {
								return A2(
									$elm$html$Html$Attributes$style,
									'height',
									$elm$core$String$fromFloat(
										$mdgriffith$elm_animator$Animator$current(h)) + 'px');
							},
							height)),
						customAttrs
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sheet-header'),
								A2($elm$html$Html$Attributes$style, 'flex-shrink', '0'),
								A2($zaboco$elm_draggable$Draggable$mouseTrigger, _Utils_Tuple0, dragMsg)
							]),
						A2($zaboco$elm_draggable$Draggable$touchTriggers, _Utils_Tuple0, dragMsg)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grab-handle')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sheet-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', title))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'flex-grow', '1'),
							A2($elm$html$Html$Attributes$style, 'height', 'calc(100% - 50px')
						]),
					content)
				]));
	});
var $mdgriffith$elm_animator$Internal$Interpolate$Position = F2(
	function (a, b) {
		return {$: 'Position', a: a, b: b};
	});
var $mdgriffith$elm_animator$Internal$Interpolate$FullDefault = {$: 'FullDefault'};
var $mdgriffith$elm_animator$Animator$at = $mdgriffith$elm_animator$Internal$Interpolate$Position($mdgriffith$elm_animator$Internal$Interpolate$FullDefault);
var $mdgriffith$elm_animator$Animator$Css$stylesheet = function (str) {
	return A3(
		$elm$html$Html$node,
		'style',
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $ianmackenzie$elm_units$Pixels$inPixels = function (_v0) {
	var numPixels = _v0.a;
	return numPixels;
};
var $ianmackenzie$elm_units$Pixels$inPixelsPerSecond = function (_v0) {
	var numPixelsPerSecond = _v0.a;
	return numPixelsPerSecond;
};
var $ianmackenzie$elm_units$Pixels$pixels = function (numPixels) {
	return $ianmackenzie$elm_units$Quantity$Quantity(numPixels);
};
var $mdgriffith$elm_animator$Internal$Interpolate$guessTime = F2(
	function (now, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v0.c;
		var four = _v0.d;
		return (!(four.x - one.x)) ? 0.5 : ((now - one.x) / (four.x - one.x));
	});
var $mdgriffith$elm_animator$Internal$Interpolate$Spline = F4(
	function (a, b, c, d) {
		return {$: 'Spline', a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_animator$Internal$Interpolate$zeroPoint = {x: 0, y: 0};
var $mdgriffith$elm_animator$Internal$Interpolate$createSpline = function (config) {
	var totalX = config.end.x - config.start.x;
	var endVelScale = 1 / (config.endVelocity.x / totalX);
	var endVelocity = (!config.arrival.arriveSlowly) ? {x: 0, y: 0} : (((!(config.endVelocity.x - $mdgriffith$elm_animator$Internal$Interpolate$zeroPoint.x)) && (!(config.endVelocity.y - $mdgriffith$elm_animator$Internal$Interpolate$zeroPoint.y))) ? {x: totalX * (config.arrival.arriveSlowly * 3), y: 0} : {x: (endVelScale * config.endVelocity.x) * (config.arrival.arriveSlowly * 3), y: (endVelScale * config.endVelocity.y) * (config.arrival.arriveSlowly * 3)});
	var startVelScale = 1 / (config.startVelocity.x / totalX);
	var startVelocity = (!config.departure.departSlowly) ? {x: 0, y: 0} : (((!(config.startVelocity.x - $mdgriffith$elm_animator$Internal$Interpolate$zeroPoint.x)) && (!(config.startVelocity.y - $mdgriffith$elm_animator$Internal$Interpolate$zeroPoint.y))) ? {x: totalX * (config.departure.departSlowly * 3), y: 0} : {x: (startVelScale * config.startVelocity.x) * (config.departure.departSlowly * 3), y: (startVelScale * config.startVelocity.y) * (config.departure.departSlowly * 3)});
	return A4(
		$mdgriffith$elm_animator$Internal$Interpolate$Spline,
		config.start,
		{x: config.start.x + ((1 / 3) * startVelocity.x), y: config.start.y + ((1 / 3) * startVelocity.y)},
		{x: config.end.x + (((-1) / 3) * endVelocity.x), y: config.end.y + (((-1) / 3) * endVelocity.y)},
		config.end);
};
var $mdgriffith$elm_animator$Internal$Interpolate$linearDefault = {departLate: 0, wobbliness: 0, arriveEarly: 0, arriveSlowly: 0, departSlowly: 0};
var $mdgriffith$elm_animator$Internal$Interpolate$findAtXOnSpline = F6(
	function (spline, desiredX, tolerance, jumpSize, t, depth) {
		findAtXOnSpline:
		while (true) {
			var p1 = spline.a;
			var p2 = spline.b;
			var p3 = spline.c;
			var p4 = spline.d;
			var point = function () {
				if (t <= 0.5) {
					var q3 = {x: p3.x + (t * (p4.x - p3.x)), y: p3.y + (t * (p4.y - p3.y))};
					var q2 = {x: p2.x + (t * (p3.x - p2.x)), y: p2.y + (t * (p3.y - p2.y))};
					var r2 = {x: q2.x + (t * (q3.x - q2.x)), y: q2.y + (t * (q3.y - q2.y))};
					var q1 = {x: p1.x + (t * (p2.x - p1.x)), y: p1.y + (t * (p2.y - p1.y))};
					var r1 = {x: q1.x + (t * (q2.x - q1.x)), y: q1.y + (t * (q2.y - q1.y))};
					return {x: r1.x + (t * (r2.x - r1.x)), y: r1.y + (t * (r2.y - r1.y))};
				} else {
					var q3 = {x: p4.x + ((1 - t) * (p3.x - p4.x)), y: p4.y + ((1 - t) * (p3.y - p4.y))};
					var q2 = {x: p3.x + ((1 - t) * (p2.x - p3.x)), y: p3.y + ((1 - t) * (p2.y - p3.y))};
					var r2 = {x: q3.x + ((1 - t) * (q2.x - q3.x)), y: q3.y + ((1 - t) * (q2.y - q3.y))};
					var q1 = {x: p2.x + ((1 - t) * (p1.x - p2.x)), y: p2.y + ((1 - t) * (p1.y - p2.y))};
					var r1 = {x: q2.x + ((1 - t) * (q1.x - q2.x)), y: q2.y + ((1 - t) * (q1.y - q2.y))};
					return {x: r2.x + ((1 - t) * (r1.x - r2.x)), y: r2.y + ((1 - t) * (r1.y - r2.y))};
				}
			}();
			if (depth === 10) {
				return {t: t, point: point};
			} else {
				if (($elm$core$Basics$abs(point.x - desiredX) < 1) && ($elm$core$Basics$abs(point.x - desiredX) >= 0)) {
					return {t: t, point: point};
				} else {
					if ((point.x - desiredX) > 0) {
						var $temp$spline = spline,
							$temp$desiredX = desiredX,
							$temp$tolerance = tolerance,
							$temp$jumpSize = jumpSize / 2,
							$temp$t = t - jumpSize,
							$temp$depth = depth + 1;
						spline = $temp$spline;
						desiredX = $temp$desiredX;
						tolerance = $temp$tolerance;
						jumpSize = $temp$jumpSize;
						t = $temp$t;
						depth = $temp$depth;
						continue findAtXOnSpline;
					} else {
						var $temp$spline = spline,
							$temp$desiredX = desiredX,
							$temp$tolerance = tolerance,
							$temp$jumpSize = jumpSize / 2,
							$temp$t = t + jumpSize,
							$temp$depth = depth + 1;
						spline = $temp$spline;
						desiredX = $temp$desiredX;
						tolerance = $temp$tolerance;
						jumpSize = $temp$jumpSize;
						t = $temp$t;
						depth = $temp$depth;
						continue findAtXOnSpline;
					}
				}
			}
		}
	});
var $ianmackenzie$elm_units$Pixels$pixelsPerSecond = function (numPixelsPerSecond) {
	return $ianmackenzie$elm_units$Quantity$Quantity(numPixelsPerSecond);
};
var $mdgriffith$elm_animator$Internal$Time$millis = function (ms) {
	return $ianmackenzie$elm_units$Quantity$Quantity(ms);
};
var $ianmackenzie$elm_units$Quantity$per = F2(
	function (_v0, _v1) {
		var independentValue = _v0.a;
		var dependentValue = _v1.a;
		return $ianmackenzie$elm_units$Quantity$Quantity(dependentValue / independentValue);
	});
var $ianmackenzie$elm_units$Quantity$zero = $ianmackenzie$elm_units$Quantity$Quantity(0);
var $ianmackenzie$elm_units$Quantity$isNaN = function (_v0) {
	var value = _v0.a;
	return $elm$core$Basics$isNaN(value);
};
var $ianmackenzie$elm_units$Quantity$isInfinite = function (_v0) {
	var value = _v0.a;
	return $elm$core$Basics$isInfinite(value);
};
var $mdgriffith$elm_animator$Internal$Interpolate$velocityBetween = F4(
	function (one, oneTime, two, twoTime) {
		var duration = A2($mdgriffith$elm_animator$Internal$Time$duration, oneTime, twoTime);
		var distance = A2($ianmackenzie$elm_units$Quantity$minus, one, two);
		var vel = A2($ianmackenzie$elm_units$Quantity$per, duration, distance);
		return ($ianmackenzie$elm_units$Quantity$isNaN(vel) || $ianmackenzie$elm_units$Quantity$isInfinite(vel)) ? $ianmackenzie$elm_units$Quantity$zero : vel;
	});
var $ianmackenzie$elm_units$Quantity$divideBy = F2(
	function (divisor, _v0) {
		var value = _v0.a;
		return $ianmackenzie$elm_units$Quantity$Quantity(value / divisor);
	});
var $mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing = F3(
	function (ease, period, target) {
		var targetPixels = $ianmackenzie$elm_units$Pixels$pixels(
			ease(target));
		var sampleSize = 16;
		var deltaSample = sampleSize / $ianmackenzie$elm_units$Duration$inMilliseconds(period);
		var prev = $ianmackenzie$elm_units$Pixels$pixels(
			ease(target - deltaSample));
		var next = $ianmackenzie$elm_units$Pixels$pixels(
			ease(target + deltaSample));
		var dx2 = A2($ianmackenzie$elm_units$Quantity$minus, targetPixels, next);
		var dx1 = A2($ianmackenzie$elm_units$Quantity$minus, prev, targetPixels);
		var dx = A2(
			$ianmackenzie$elm_units$Quantity$divideBy,
			2,
			A2($ianmackenzie$elm_units$Quantity$plus, dx1, dx2));
		return A2(
			$ianmackenzie$elm_units$Quantity$per,
			$ianmackenzie$elm_units$Duration$milliseconds(sampleSize),
			dx);
	});
var $mdgriffith$elm_animator$Internal$Interpolate$newVelocityAtTarget = F3(
	function (target, targetTime, maybeLookAhead) {
		if (maybeLookAhead.$ === 'Nothing') {
			if (target.$ === 'Pos') {
				return $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0);
			} else {
				var period = target.b;
				var toX = target.c;
				if (period.$ === 'Loop') {
					var periodDuration = period.a;
					return A3($mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing, toX, periodDuration, 0);
				} else {
					var n = period.a;
					var periodDuration = period.b;
					return A3($mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing, toX, periodDuration, 0);
				}
			}
		} else {
			var lookAhead = maybeLookAhead.a;
			var targetPosition = function () {
				if (target.$ === 'Osc') {
					var toX = target.c;
					return $ianmackenzie$elm_units$Pixels$pixels(
						toX(0));
				} else {
					var x = target.b;
					return $ianmackenzie$elm_units$Pixels$pixels(x);
				}
			}();
			var _v3 = lookAhead.anchor;
			if (_v3.$ === 'Pos') {
				var aheadPosition = _v3.b;
				return A4(
					$mdgriffith$elm_animator$Internal$Interpolate$velocityBetween,
					targetPosition,
					$mdgriffith$elm_animator$Internal$Time$millis(targetTime),
					$ianmackenzie$elm_units$Pixels$pixels(aheadPosition),
					$mdgriffith$elm_animator$Internal$Time$millis(lookAhead.time));
			} else {
				var period = _v3.b;
				var toX = _v3.c;
				if (lookAhead.resting) {
					if (period.$ === 'Loop') {
						var periodDuration = period.a;
						return A3($mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing, toX, periodDuration, 0);
					} else {
						var n = period.a;
						var periodDuration = period.b;
						return A3($mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing, toX, periodDuration, 0);
					}
				} else {
					return A4(
						$mdgriffith$elm_animator$Internal$Interpolate$velocityBetween,
						targetPosition,
						$mdgriffith$elm_animator$Internal$Time$millis(targetTime),
						$ianmackenzie$elm_units$Pixels$pixels(
							toX(0)),
						$mdgriffith$elm_animator$Internal$Time$millis(lookAhead.time));
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Interpolate$interpolateValue = F3(
	function (start, end, t) {
		return (t <= 0.5) ? (start + (t * (end - start))) : (end + ((1 - t) * (start - end)));
	});
var $mdgriffith$elm_animator$Internal$Interpolate$firstDerivativeOnSpline = F2(
	function (_v0, proportion) {
		var p1 = _v0.a;
		var p2 = _v0.b;
		var p3 = _v0.c;
		var p4 = _v0.d;
		var vy3 = p4.y - p3.y;
		var vy2 = p3.y - p2.y;
		var wy2 = A3($mdgriffith$elm_animator$Internal$Interpolate$interpolateValue, vy2, vy3, proportion);
		var vy1 = p2.y - p1.y;
		var wy1 = A3($mdgriffith$elm_animator$Internal$Interpolate$interpolateValue, vy1, vy2, proportion);
		var vx3 = p4.x - p3.x;
		var vx2 = p3.x - p2.x;
		var wx2 = A3($mdgriffith$elm_animator$Internal$Interpolate$interpolateValue, vx2, vx3, proportion);
		var vx1 = p2.x - p1.x;
		var wx1 = A3($mdgriffith$elm_animator$Internal$Interpolate$interpolateValue, vx1, vx2, proportion);
		return {
			x: 3 * A3($mdgriffith$elm_animator$Internal$Interpolate$interpolateValue, wx1, wx2, proportion),
			y: 3 * A3($mdgriffith$elm_animator$Internal$Interpolate$interpolateValue, wy1, wy2, proportion)
		};
	});
var $mdgriffith$elm_animator$Internal$Interpolate$interpolateBetween = F7(
	function (startTimeInMs, maybePrevious, target, targetTimeInMs, now, maybeLookAhead, state) {
		var targetVelocity = $ianmackenzie$elm_units$Pixels$inPixelsPerSecond(
			A3($mdgriffith$elm_animator$Internal$Interpolate$newVelocityAtTarget, target, targetTimeInMs, maybeLookAhead));
		var targetPosition = function () {
			if (target.$ === 'Osc') {
				var toX = target.c;
				return $ianmackenzie$elm_units$Pixels$pixels(
					toX(0));
			} else {
				var x = target.b;
				return $ianmackenzie$elm_units$Pixels$pixels(x);
			}
		}();
		var curve = $mdgriffith$elm_animator$Internal$Interpolate$createSpline(
			{
				end: {
					x: targetTimeInMs,
					y: $ianmackenzie$elm_units$Pixels$inPixels(targetPosition)
				},
				start: {
					x: startTimeInMs,
					y: $ianmackenzie$elm_units$Pixels$inPixels(state.position)
				},
				arrival: function () {
					if (target.$ === 'Pos') {
						var personality = target.a;
						return personality;
					} else {
						var personality = target.a;
						return personality;
					}
				}(),
				departure: function () {
					if (maybePrevious.$ === 'Nothing') {
						return $mdgriffith$elm_animator$Internal$Interpolate$linearDefault;
					} else {
						if (maybePrevious.a.$ === 'Pos') {
							var _v2 = maybePrevious.a;
							var personality = _v2.a;
							return personality;
						} else {
							var _v3 = maybePrevious.a;
							var personality = _v3.a;
							return personality;
						}
					}
				}(),
				endVelocity: {x: 1000, y: targetVelocity},
				startVelocity: {
					x: 1000,
					y: $ianmackenzie$elm_units$Pixels$inPixelsPerSecond(state.velocity)
				}
			});
		var current = A6(
			$mdgriffith$elm_animator$Internal$Interpolate$findAtXOnSpline,
			curve,
			now,
			1,
			0.25,
			A2($mdgriffith$elm_animator$Internal$Interpolate$guessTime, now, curve),
			0);
		var firstDerivative = A2($mdgriffith$elm_animator$Internal$Interpolate$firstDerivativeOnSpline, curve, current.t);
		return {
			position: $ianmackenzie$elm_units$Pixels$pixels(current.point.y),
			velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(1000 * (firstDerivative.y / firstDerivative.x))
		};
	});
var $mdgriffith$elm_animator$Internal$Spring$criticalDamping = F2(
	function (k, m) {
		return 2 * $elm$core$Basics$sqrt(k * m);
	});
var $elm$core$Basics$e = _Basics_e;
var $mdgriffith$elm_animator$Internal$Spring$toleranceForSpringSettleTimeCalculation = (-1) * A2($elm$core$Basics$logBase, $elm$core$Basics$e, 0.005);
var $mdgriffith$elm_animator$Internal$Spring$settlesAt = function (_v0) {
	var mass = _v0.mass;
	var damping = _v0.damping;
	var stiffness = _v0.stiffness;
	var m = mass;
	var k = stiffness;
	var cCritical = A2($mdgriffith$elm_animator$Internal$Spring$criticalDamping, k, m);
	var springAspect = $elm$core$Basics$sqrt(k / m);
	var c = damping;
	if (_Utils_eq(
		$elm$core$Basics$round(c),
		$elm$core$Basics$round(cCritical))) {
		return 1000 * (8.5 / springAspect);
	} else {
		if ((c - cCritical) > 0) {
			var dampingAspect = c / cCritical;
			return 1000 * ($mdgriffith$elm_animator$Internal$Spring$toleranceForSpringSettleTimeCalculation / (dampingAspect * springAspect));
		} else {
			var dampingAspect = c / cCritical;
			return 1000 * ($mdgriffith$elm_animator$Internal$Spring$toleranceForSpringSettleTimeCalculation / (dampingAspect * springAspect));
		}
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $mdgriffith$elm_animator$Internal$Spring$mapToRange = F3(
	function (minimum, maximum, x) {
		var total = maximum - minimum;
		return minimum + (x * total);
	});
var $mdgriffith$elm_animator$Internal$Spring$wobble2Ratio = F2(
	function (wobble, duration) {
		var bounded = A2(
			$elm$core$Basics$min,
			1,
			A2($elm$core$Basics$max, 0, wobble));
		var ms = $ianmackenzie$elm_units$Duration$inMilliseconds(duration);
		var scalingBelowDur = ms / 350;
		var top = A2(
			$elm$core$Basics$max,
			0.43,
			0.8 * A2($elm$core$Basics$min, 1, scalingBelowDur));
		return A3($mdgriffith$elm_animator$Internal$Spring$mapToRange, 0.43, top, 1 - bounded);
	});
var $mdgriffith$elm_animator$Internal$Spring$wobble2Damping = F4(
	function (wobble, k, m, duration) {
		return A2($mdgriffith$elm_animator$Internal$Spring$wobble2Ratio, wobble, duration) * A2($mdgriffith$elm_animator$Internal$Spring$criticalDamping, k, m);
	});
var $mdgriffith$elm_animator$Internal$Spring$select = F2(
	function (wobbliness, duration) {
		var durMS = $ianmackenzie$elm_units$Duration$inMilliseconds(duration);
		var k = 150;
		var damping = A4($mdgriffith$elm_animator$Internal$Spring$wobble2Damping, wobbliness, k, 1, duration);
		var initiallySettlesAt = $mdgriffith$elm_animator$Internal$Spring$settlesAt(
			{mass: 1, damping: damping, stiffness: k});
		var newCritical = A2($mdgriffith$elm_animator$Internal$Spring$criticalDamping, k, durMS / initiallySettlesAt);
		return {mass: durMS / initiallySettlesAt, damping: damping, stiffness: k};
	});
var $mdgriffith$elm_animator$Internal$Spring$step = F4(
	function (target, _v0, dtms, motion) {
		var mass = _v0.mass;
		var damping = _v0.damping;
		var stiffness = _v0.stiffness;
		var fspring = stiffness * (target - motion.position);
		var fdamper = ((-1) * damping) * motion.velocity;
		var dt = dtms / 1000;
		var a = (fspring + fdamper) / mass;
		var newVelocity = motion.velocity + (a * dt);
		var newPos = motion.position + (newVelocity * dt);
		return {position: newPos, velocity: newVelocity};
	});
var $mdgriffith$elm_animator$Internal$Spring$stepOver = F4(
	function (duration, params, target, state) {
		var durMS = $ianmackenzie$elm_units$Duration$inMilliseconds(duration);
		var frames = durMS / 16;
		var remainder = 16 * (frames - $elm$core$Basics$floor(frames));
		var steps = (remainder > 0) ? A2(
			$elm$core$List$cons,
			remainder,
			A2(
				$elm$core$List$repeat,
				($elm$core$Basics$floor(durMS) / 16) | 0,
				16)) : A2(
			$elm$core$List$repeat,
			($elm$core$Basics$floor(durMS) / 16) | 0,
			16);
		return A3(
			$elm$core$List$foldl,
			A2($mdgriffith$elm_animator$Internal$Spring$step, target, params),
			state,
			steps);
	});
var $mdgriffith$elm_animator$Internal$Interpolate$springInterpolation = F7(
	function (prevEndTime, _v0, target, targetTime, now, _v1, state) {
		var targetPos = function () {
			if (target.$ === 'Osc') {
				var toX = target.c;
				return toX(0);
			} else {
				var x = target.b;
				return x;
			}
		}();
		var duration = A2(
			$mdgriffith$elm_animator$Internal$Time$duration,
			$mdgriffith$elm_animator$Internal$Time$millis(prevEndTime),
			$mdgriffith$elm_animator$Internal$Time$millis(targetTime));
		var wobble = function () {
			if (target.$ === 'Osc') {
				var personality = target.a;
				return personality.wobbliness;
			} else {
				var personality = target.a;
				return personality.wobbliness;
			}
		}();
		var params = A2($mdgriffith$elm_animator$Internal$Spring$select, wobble, duration);
		var _new = A4(
			$mdgriffith$elm_animator$Internal$Spring$stepOver,
			A2(
				$mdgriffith$elm_animator$Internal$Time$duration,
				$mdgriffith$elm_animator$Internal$Time$millis(prevEndTime),
				$mdgriffith$elm_animator$Internal$Time$millis(now)),
			params,
			targetPos,
			{
				position: $ianmackenzie$elm_units$Pixels$inPixels(state.position),
				velocity: $ianmackenzie$elm_units$Pixels$inPixelsPerSecond(state.velocity)
			});
		return {
			position: $ianmackenzie$elm_units$Pixels$pixels(_new.position),
			velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(_new.velocity)
		};
	});
var $mdgriffith$elm_animator$Internal$Interpolate$lerp = F7(
	function (prevEndTime, maybePrev, target, targetTime, now, maybeLookAhead, state) {
		var nothingHappened = function () {
			if (target.$ === 'Osc') {
				return false;
			} else {
				var x = target.b;
				return _Utils_eq(
					x,
					$ianmackenzie$elm_units$Pixels$inPixels(state.position)) && (!$ianmackenzie$elm_units$Pixels$inPixelsPerSecond(state.velocity));
			}
		}();
		var wobble = function () {
			if (target.$ === 'Osc') {
				var personality = target.a;
				return personality.wobbliness;
			} else {
				var personality = target.a;
				return personality.wobbliness;
			}
		}();
		if (nothingHappened) {
			return state;
		} else {
			if (maybeLookAhead.$ === 'Nothing') {
				return (!(!wobble)) ? A7($mdgriffith$elm_animator$Internal$Interpolate$springInterpolation, prevEndTime, maybePrev, target, targetTime, now, maybeLookAhead, state) : A7($mdgriffith$elm_animator$Internal$Interpolate$interpolateBetween, prevEndTime, maybePrev, target, targetTime, now, maybeLookAhead, state);
			} else {
				return A7($mdgriffith$elm_animator$Internal$Interpolate$interpolateBetween, prevEndTime, maybePrev, target, targetTime, now, maybeLookAhead, state);
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Time$earliest = F2(
	function (oneQty, twoQty) {
		var one = oneQty.a;
		var two = twoQty.a;
		return ((one - two) >= 0) ? twoQty : oneQty;
	});
var $mdgriffith$elm_animator$Internal$Interpolate$wrapUnitAfter = F2(
	function (dur, total) {
		var periodDuration = $elm$core$Basics$round(
			$ianmackenzie$elm_units$Duration$inMilliseconds(dur));
		var totalDuration = $elm$core$Basics$round(
			$ianmackenzie$elm_units$Duration$inMilliseconds(total));
		if ((!periodDuration) || (!totalDuration)) {
			return 0;
		} else {
			var remaining = A2($elm$core$Basics$modBy, periodDuration, totalDuration);
			return (!remaining) ? 1 : (remaining / periodDuration);
		}
	});
var $mdgriffith$elm_animator$Internal$Interpolate$visit = F5(
	function (lookup, occurring, now, maybeLookAhead, state) {
		var event = occurring.a;
		var start = occurring.b;
		var eventEnd = occurring.c;
		var dwellTime = function () {
			if (maybeLookAhead.$ === 'Nothing') {
				return A2($mdgriffith$elm_animator$Internal$Time$duration, start, now);
			} else {
				return A2(
					$mdgriffith$elm_animator$Internal$Time$duration,
					start,
					A2($mdgriffith$elm_animator$Internal$Time$earliest, now, eventEnd));
			}
		}();
		if ($mdgriffith$elm_animator$Internal$Time$zeroDuration(dwellTime)) {
			return {
				position: function () {
					var _v0 = lookup(event);
					if (_v0.$ === 'Osc') {
						var period = _v0.b;
						var toX = _v0.c;
						return $ianmackenzie$elm_units$Pixels$pixels(
							toX(0));
					} else {
						var x = _v0.b;
						return $ianmackenzie$elm_units$Pixels$pixels(x);
					}
				}(),
				velocity: A3(
					$mdgriffith$elm_animator$Internal$Interpolate$newVelocityAtTarget,
					lookup(event),
					$mdgriffith$elm_animator$Internal$Time$inMilliseconds(start),
					maybeLookAhead)
			};
		} else {
			var _v1 = lookup(event);
			if (_v1.$ === 'Pos') {
				var pos = _v1.b;
				return {
					position: $ianmackenzie$elm_units$Pixels$pixels(pos),
					velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
				};
			} else {
				var period = _v1.b;
				var toX = _v1.c;
				if (period.$ === 'Loop') {
					var periodDuration = period.a;
					var progress = A2($mdgriffith$elm_animator$Internal$Interpolate$wrapUnitAfter, periodDuration, dwellTime);
					return {
						position: $ianmackenzie$elm_units$Pixels$pixels(
							toX(progress)),
						velocity: A3($mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing, toX, periodDuration, progress)
					};
				} else {
					var n = period.a;
					var periodDuration = period.b;
					var iterationTimeMS = $ianmackenzie$elm_units$Duration$inMilliseconds(periodDuration);
					var totalMS = $ianmackenzie$elm_units$Duration$inMilliseconds(dwellTime);
					var iteration = $elm$core$Basics$floor(totalMS / iterationTimeMS);
					if (_Utils_cmp(iteration, n) > -1) {
						return {
							position: $ianmackenzie$elm_units$Pixels$pixels(
								toX(1)),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						};
					} else {
						var progress = A2($mdgriffith$elm_animator$Internal$Interpolate$wrapUnitAfter, periodDuration, dwellTime);
						return {
							position: $ianmackenzie$elm_units$Pixels$pixels(
								toX(progress)),
							velocity: A3($mdgriffith$elm_animator$Internal$Interpolate$derivativeOfEasing, toX, periodDuration, progress)
						};
					}
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Interpolate$dwellPeriod = function (movement) {
	if (movement.$ === 'Pos') {
		return $elm$core$Maybe$Nothing;
	} else {
		var period = movement.b;
		return $elm$core$Maybe$Just(period);
	}
};
var $mdgriffith$elm_animator$Internal$Interpolate$startMoving = function (movement) {
	return {
		position: function () {
			if (movement.$ === 'Osc') {
				var toX = movement.c;
				return $ianmackenzie$elm_units$Pixels$pixels(
					toX(0));
			} else {
				var x = movement.b;
				return $ianmackenzie$elm_units$Pixels$pixels(x);
			}
		}(),
		velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
	};
};
var $mdgriffith$elm_animator$Internal$Interpolate$getPersonality = function (m) {
	if (m.$ === 'Osc') {
		var personality = m.a;
		return personality;
	} else {
		var personality = m.a;
		return personality;
	}
};
var $mdgriffith$elm_animator$Internal$Interpolate$moving = {lerp: $mdgriffith$elm_animator$Internal$Interpolate$lerp, start: $mdgriffith$elm_animator$Internal$Interpolate$startMoving, visit: $mdgriffith$elm_animator$Internal$Interpolate$visit, adjustor: $mdgriffith$elm_animator$Internal$Interpolate$getPersonality, dwellPeriod: $mdgriffith$elm_animator$Internal$Interpolate$dwellPeriod};
var $mdgriffith$elm_animator$Internal$Timeline$Frame = F2(
	function (a, b) {
		return {$: 'Frame', a: a, b: b};
	});
var $mdgriffith$elm_animator$Internal$Time$progress = F3(
	function (_v0, _v1, _v2) {
		var start = _v0.a;
		var end = _v1.a;
		var current = _v2.a;
		var total = $elm$core$Basics$abs(end - start);
		return (!total) ? 0 : A2(
			$elm$core$Basics$min,
			1,
			A2($elm$core$Basics$max, 0, (current - start) / total));
	});
var $mdgriffith$elm_animator$Internal$Timeline$getFrames = F4(
	function (currentTime, config, fn, newFrames) {
		getFrames:
		while (true) {
			if (A2($mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat, currentTime, config.startTime)) {
				if (!newFrames.b) {
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_animator$Internal$Timeline$Frame,
							0,
							fn(config.startTime)),
							A2(
							$mdgriffith$elm_animator$Internal$Timeline$Frame,
							1,
							fn(config.endTime))
						]);
				} else {
					return A2(
						$elm$core$List$cons,
						A2(
							$mdgriffith$elm_animator$Internal$Timeline$Frame,
							0,
							fn(config.startTime)),
						newFrames);
				}
			} else {
				var _new = A2(
					$mdgriffith$elm_animator$Internal$Timeline$Frame,
					A3($mdgriffith$elm_animator$Internal$Time$progress, config.startTime, config.endTime, currentTime),
					fn(currentTime));
				var $temp$currentTime = A2($mdgriffith$elm_animator$Internal$Time$rollbackBy, config.perFrame, currentTime),
					$temp$config = config,
					$temp$fn = fn,
					$temp$newFrames = A2($elm$core$List$cons, _new, newFrames);
				currentTime = $temp$currentTime;
				config = $temp$config;
				fn = $temp$fn;
				newFrames = $temp$newFrames;
				continue getFrames;
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$zeroDuration = $ianmackenzie$elm_units$Duration$milliseconds(0);
var $mdgriffith$elm_animator$Internal$Time$thisAfterThat = F2(
	function (_v0, _v1) {
		var _this = _v0.a;
		var that = _v1.a;
		return (_this - that) > 0;
	});
var $mdgriffith$elm_animator$Internal$Time$numberOfFrames = F4(
	function (fps, lastFrameTime, startAt, endAt) {
		var millisecondsPerFrame = 1000 / fps;
		var framesSinceLastFrame = A2(
			$elm$core$Basics$max,
			0,
			$ianmackenzie$elm_units$Duration$inMilliseconds(
				A2($mdgriffith$elm_animator$Internal$Time$duration, lastFrameTime, startAt))) / millisecondsPerFrame;
		var totalDurationInMs = $ianmackenzie$elm_units$Duration$inMilliseconds(
			A2($mdgriffith$elm_animator$Internal$Time$duration, startAt, endAt));
		var offset = 1 - (framesSinceLastFrame - $elm$core$Basics$floor(framesSinceLastFrame));
		return _Utils_Tuple2(
			offset * millisecondsPerFrame,
			A2(
				$elm$core$Basics$max,
				1,
				$elm$core$Basics$round(totalDurationInMs / millisecondsPerFrame)));
	});
var $mdgriffith$elm_animator$Internal$Timeline$getLastEvent = F2(
	function (head, rest) {
		getLastEvent:
		while (true) {
			if (!rest.b) {
				return head;
			} else {
				var top = rest.a;
				var tail = rest.b;
				var $temp$head = top,
					$temp$rest = tail;
				head = $temp$head;
				rest = $temp$rest;
				continue getLastEvent;
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$findLastEventInLines = F2(
	function (first, remaining) {
		findLastEventInLines:
		while (true) {
			if (!remaining.b) {
				var startEv = first.b;
				var rem = first.c;
				return A2($mdgriffith$elm_animator$Internal$Timeline$getLastEvent, startEv, rem);
			} else {
				var r1 = remaining.a;
				var r1Remain = remaining.b;
				var $temp$first = r1,
					$temp$remaining = r1Remain;
				first = $temp$first;
				remaining = $temp$remaining;
				continue findLastEventInLines;
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$capture = F4(
	function (fps, lookup, fn, _v0) {
		var timelineDetails = _v0.a;
		var _v1 = timelineDetails.events;
		var timetable = _v1.a;
		var start = fn.start(
			lookup(timelineDetails.initial));
		if (!timetable.b) {
			return {
				dwell: $elm$core$Maybe$Nothing,
				frames: _List_fromArray(
					[
						A2($mdgriffith$elm_animator$Internal$Timeline$Frame, 1, start)
					]),
				duration: $mdgriffith$elm_animator$Internal$Timeline$zeroDuration
			};
		} else {
			var firstLine = timetable.a;
			var remainingLines = timetable.b;
			var millisecondsPerFrame = 1000 / fps;
			var lastEvent = A2($mdgriffith$elm_animator$Internal$Timeline$findLastEventInLines, firstLine, remainingLines);
			var _v3 = A2(
				$mdgriffith$elm_animator$Internal$Time$thisAfterThat,
				timelineDetails.now,
				$mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent)) ? _Utils_Tuple2(0, 1) : A4(
				$mdgriffith$elm_animator$Internal$Time$numberOfFrames,
				fps,
				timelineDetails.now,
				timelineDetails.now,
				$mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent));
			var numberOfFrames = _v3.b;
			var frames = A4(
				$mdgriffith$elm_animator$Internal$Timeline$getFrames,
				$mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent),
				{
					offset: 0,
					endTime: $mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent),
					perFrame: $ianmackenzie$elm_units$Duration$milliseconds(millisecondsPerFrame),
					startTime: timelineDetails.now
				},
				function (currentTime) {
					return A7(
						$mdgriffith$elm_animator$Internal$Timeline$overLines,
						fn,
						lookup,
						_Utils_update(
							timelineDetails,
							{now: currentTime}),
						$elm$core$Maybe$Nothing,
						firstLine,
						remainingLines,
						start);
				},
				_List_Nil);
			return {
				dwell: function () {
					var _v4 = fn.dwellPeriod(
						lookup(
							$mdgriffith$elm_animator$Internal$Timeline$getEvent(lastEvent)));
					if (_v4.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var period = _v4.a;
						var dwellStartTime = $mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent);
						var lastConcreteState = A7(
							$mdgriffith$elm_animator$Internal$Timeline$overLines,
							fn,
							lookup,
							_Utils_update(
								timelineDetails,
								{now: dwellStartTime}),
							$elm$core$Maybe$Nothing,
							firstLine,
							remainingLines,
							start);
						var lastEventEv = lookup(
							$mdgriffith$elm_animator$Internal$Timeline$getEvent(lastEvent));
						var endAt = function () {
							if (period.$ === 'Repeat') {
								var n = period.a;
								var totalDur = period.b;
								return A2($mdgriffith$elm_animator$Internal$Time$advanceBy, totalDur, dwellStartTime);
							} else {
								var totalDur = period.a;
								return A2($mdgriffith$elm_animator$Internal$Time$advanceBy, totalDur, dwellStartTime);
							}
						}();
						var _v5 = A4($mdgriffith$elm_animator$Internal$Time$numberOfFrames, fps, dwellStartTime, dwellStartTime, endAt);
						var dwellOffset = _v5.a;
						var numberOfDwellFrames = _v5.b;
						var dwellFrames = A4(
							$mdgriffith$elm_animator$Internal$Timeline$getFrames,
							endAt,
							{
								offset: dwellOffset,
								endTime: endAt,
								perFrame: $ianmackenzie$elm_units$Duration$milliseconds(millisecondsPerFrame),
								startTime: dwellStartTime
							},
							function (currentTime) {
								return A5(fn.visit, lookup, lastEvent, currentTime, $elm$core$Maybe$Nothing, lastConcreteState);
							},
							_List_Nil);
						return $elm$core$Maybe$Just(
							{frames: dwellFrames, period: period});
					}
				}(),
				frames: frames,
				duration: A2(
					$mdgriffith$elm_animator$Internal$Time$thisAfterThat,
					timelineDetails.now,
					$mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent)) ? $mdgriffith$elm_animator$Internal$Timeline$zeroDuration : A2(
					$mdgriffith$elm_animator$Internal$Time$duration,
					timelineDetails.now,
					$mdgriffith$elm_animator$Internal$Timeline$startTime(lastEvent))
			};
		}
	});
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 'RgbaSpace', a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {red: r, blue: b, alpha: a, green: g};
};
var $mdgriffith$elm_animator$Internal$Interpolate$average = F3(
	function (x, y, progress) {
		return $elm$core$Basics$sqrt(((x * x) * (1 - progress)) + ((y * y) * progress));
	});
var $mdgriffith$elm_animator$Internal$Interpolate$lerpColor = F7(
	function (prevEndTime, maybePrev, target, targetTime, now, maybeLookAhead, state) {
		var progress = A3(
			$mdgriffith$elm_animator$Internal$Time$progress,
			$mdgriffith$elm_animator$Internal$Time$millis(prevEndTime),
			$mdgriffith$elm_animator$Internal$Time$millis(targetTime),
			$mdgriffith$elm_animator$Internal$Time$millis(now));
		var two = $avh4$elm_color$Color$toRgba(target);
		var one = $avh4$elm_color$Color$toRgba(state);
		return A4(
			$avh4$elm_color$Color$rgba,
			A3($mdgriffith$elm_animator$Internal$Interpolate$average, one.red, two.red, progress),
			A3($mdgriffith$elm_animator$Internal$Interpolate$average, one.green, two.green, progress),
			A3($mdgriffith$elm_animator$Internal$Interpolate$average, one.blue, two.blue, progress),
			A3($mdgriffith$elm_animator$Internal$Interpolate$average, one.alpha, two.alpha, progress));
	});
var $mdgriffith$elm_animator$Internal$Interpolate$coloring = {
	lerp: $mdgriffith$elm_animator$Internal$Interpolate$lerpColor,
	start: $elm$core$Basics$identity,
	visit: F5(
		function (lookup, target, targetTime, maybeLookAhead, state) {
			return lookup(
				$mdgriffith$elm_animator$Internal$Timeline$getEvent(target));
		}),
	adjustor: function (_v0) {
		return $mdgriffith$elm_animator$Internal$Interpolate$linearDefault;
	},
	dwellPeriod: function (_v1) {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_animator$Animator$Css$stubFloat = function (f) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(f * 1000));
};
var $mdgriffith$elm_animator$Animator$Css$stubColor = function (clr) {
	var _v0 = $avh4$elm_color$Color$toRgba(clr);
	var alpha = _v0.alpha;
	var blue = _v0.blue;
	var green = _v0.green;
	var red = _v0.red;
	return _Utils_ap(
		$mdgriffith$elm_animator$Animator$Css$stubFloat(red) + '-',
		_Utils_ap(
			$mdgriffith$elm_animator$Animator$Css$stubFloat(green) + '-',
			_Utils_ap(
				$mdgriffith$elm_animator$Animator$Css$stubFloat(blue) + '-',
				$mdgriffith$elm_animator$Animator$Css$stubFloat(alpha))));
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $mdgriffith$elm_animator$Animator$Css$toTransform = function (options) {
	return function (rendered) {
		return function (x) {
			return function (y) {
				return function (z) {
					return function (rotation) {
						return function (scaleX) {
							return function (scaleY) {
								return function (scaleZ) {
									return function (facingX) {
										return function (facingY) {
											return function (facingZ) {
												toTransform:
												while (true) {
													if (!x.b) {
														return rendered;
													} else {
														var _v1 = x.a;
														var percent = _v1.a;
														var topX = _v1.b;
														var rX = x.b;
														if (!y.b) {
															return rendered;
														} else {
															var _v3 = y.a;
															var topY = _v3.b;
															var rY = y.b;
															if (!z.b) {
																return rendered;
															} else {
																var _v5 = z.a;
																var topZ = _v5.b;
																var rZ = z.b;
																if (!rotation.b) {
																	return rendered;
																} else {
																	var _v7 = rotation.a;
																	var topR = _v7.b;
																	var rR = rotation.b;
																	if (!scaleX.b) {
																		return rendered;
																	} else {
																		var _v9 = scaleX.a;
																		var topSx = _v9.b;
																		var rsx = scaleX.b;
																		if (!scaleY.b) {
																			return rendered;
																		} else {
																			var _v11 = scaleY.a;
																			var topSy = _v11.b;
																			var rsy = scaleY.b;
																			if (!scaleZ.b) {
																				return rendered;
																			} else {
																				var _v13 = scaleZ.a;
																				var topSz = _v13.b;
																				var rsz = scaleZ.b;
																				if (!facingX.b) {
																					return rendered;
																				} else {
																					var _v15 = facingX.a;
																					var topFx = _v15.b;
																					var rfx = facingX.b;
																					if (!facingY.b) {
																						return rendered;
																					} else {
																						var _v17 = facingY.a;
																						var topFy = _v17.b;
																						var rfy = facingY.b;
																						if (!facingZ.b) {
																							return rendered;
																						} else {
																							var _v19 = facingZ.a;
																							var topFz = _v19.b;
																							var rfz = facingZ.b;
																							var $temp$options = options,
																								$temp$rendered = A2(
																								$elm$core$List$cons,
																								A2(
																									$mdgriffith$elm_animator$Internal$Timeline$Frame,
																									percent,
																									{x: topX, y: topY, z: topZ, scaleX: topSx, scaleY: topSy, scaleZ: topSz, aroundX: options.rotationAxis.x, aroundY: options.rotationAxis.y, aroundZ: options.rotationAxis.z, facingX: topFx, facingY: topFy, facingZ: topFz, rotation: topR}),
																								rendered),
																								$temp$x = rX,
																								$temp$y = rY,
																								$temp$z = rZ,
																								$temp$rotation = rR,
																								$temp$scaleX = rsx,
																								$temp$scaleY = rsy,
																								$temp$scaleZ = rsz,
																								$temp$facingX = rfx,
																								$temp$facingY = rfy,
																								$temp$facingZ = rfz;
																							options = $temp$options;
																							rendered = $temp$rendered;
																							x = $temp$x;
																							y = $temp$y;
																							z = $temp$z;
																							rotation = $temp$rotation;
																							scaleX = $temp$scaleX;
																							scaleY = $temp$scaleY;
																							scaleZ = $temp$scaleZ;
																							facingX = $temp$facingX;
																							facingY = $temp$facingY;
																							facingZ = $temp$facingZ;
																							continue toTransform;
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $mdgriffith$elm_animator$Animator$Css$expand = F2(
	function (_v0, _v1) {
		var lastFrame = _v0.b;
		var percent = _v1.a;
		var rotation = _v1.b;
		return A2(
			$mdgriffith$elm_animator$Internal$Timeline$Frame,
			percent,
			{x: lastFrame.x, y: lastFrame.y, z: lastFrame.z, scaleX: lastFrame.scaleX, scaleY: lastFrame.scaleY, scaleZ: lastFrame.scaleZ, aroundX: lastFrame.aroundX, aroundY: lastFrame.aroundY, aroundZ: lastFrame.aroundZ, facingX: lastFrame.facingX, facingY: lastFrame.facingY, facingZ: lastFrame.facingZ, rotation: rotation});
	});
var $mdgriffith$elm_animator$Animator$Css$mapDwellFrames = F2(
	function (combinedFrames, dwell) {
		var lastFrame = function () {
			if (!combinedFrames.b) {
				return A2(
					$mdgriffith$elm_animator$Internal$Timeline$Frame,
					1,
					{
						x: {
							position: $ianmackenzie$elm_units$Pixels$pixels(0),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						y: {
							position: $ianmackenzie$elm_units$Pixels$pixels(0),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						z: {
							position: $ianmackenzie$elm_units$Pixels$pixels(0),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						scaleX: {
							position: $ianmackenzie$elm_units$Pixels$pixels(1),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						scaleY: {
							position: $ianmackenzie$elm_units$Pixels$pixels(1),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						scaleZ: {
							position: $ianmackenzie$elm_units$Pixels$pixels(1),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						aroundX: 0,
						aroundY: 0,
						aroundZ: 1,
						facingX: {
							position: $ianmackenzie$elm_units$Pixels$pixels(0),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						facingY: {
							position: $ianmackenzie$elm_units$Pixels$pixels(0),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						facingZ: {
							position: $ianmackenzie$elm_units$Pixels$pixels(1),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						},
						rotation: {
							position: $ianmackenzie$elm_units$Pixels$pixels(0),
							velocity: $ianmackenzie$elm_units$Pixels$pixelsPerSecond(0)
						}
					});
			} else {
				var last = combinedFrames.a;
				return last;
			}
		}();
		return {
			frames: A2(
				$elm$core$List$map,
				$mdgriffith$elm_animator$Animator$Css$expand(lastFrame),
				dwell.frames),
			period: dwell.period
		};
	});
var $mdgriffith$elm_animator$Animator$Css$LoopAnim = {$: 'LoopAnim'};
var $mdgriffith$elm_animator$Animator$Css$RepeatAnim = function (a) {
	return {$: 'RepeatAnim', a: a};
};
var $mdgriffith$elm_animator$Animator$Css$renderFrame = F8(
	function (i, total, name, frames, renderer, stubber, rendered, stub) {
		renderFrame:
		while (true) {
			if (!frames.b) {
				return {frames: rendered, uniqueName: stub};
			} else {
				var _v1 = frames.a;
				var percent = _v1.a;
				var frm = _v1.b;
				var remain = frames.b;
				if (total === 1) {
					var keyframe = ('0% {' + (name + (': ' + (renderer(frm) + ';}\u000A')))) + ('100% {' + (name + (': ' + (renderer(frm) + ';}\u000A'))));
					return {
						frames: keyframe,
						uniqueName: stubber(frm)
					};
				} else {
					var keyframe = $elm$core$String$fromFloat(100 * percent) + ('% {' + (name + (': ' + (renderer(frm) + ';}\u000A'))));
					var $temp$i = i + 1,
						$temp$total = total,
						$temp$name = name,
						$temp$frames = remain,
						$temp$renderer = renderer,
						$temp$stubber = stubber,
						$temp$rendered = _Utils_ap(rendered, keyframe),
						$temp$stub = _Utils_ap(
						stub,
						stubber(frm));
					i = $temp$i;
					total = $temp$total;
					name = $temp$name;
					frames = $temp$frames;
					renderer = $temp$renderer;
					stubber = $temp$stubber;
					rendered = $temp$rendered;
					stub = $temp$stub;
					continue renderFrame;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$LinearTiming = {$: 'LinearTiming'};
var $mdgriffith$elm_animator$Animator$Css$renderAnimation = F6(
	function (now, attrName, frames, renderer, stubber, anims) {
		var rendered = A8(
			$mdgriffith$elm_animator$Animator$Css$renderFrame,
			0,
			$elm$core$List$length(frames.frames),
			attrName,
			frames.frames,
			renderer,
			stubber,
			'',
			'');
		var duration = $ianmackenzie$elm_units$Duration$inMilliseconds(frames.duration);
		var name = attrName + ('-' + ($elm$core$String$fromInt(
			$elm$core$Basics$floor(
				$mdgriffith$elm_animator$Internal$Time$inMilliseconds(now))) + ('-' + rendered.uniqueName)));
		var newKeyFrames = '@keyframes ' + (name + (' {\u000A' + (rendered.frames + '\u000A}')));
		var anim = {
			name: name,
			delay: 0,
			repeat: $mdgriffith$elm_animator$Animator$Css$RepeatAnim(1),
			duration: duration,
			timingFn: $mdgriffith$elm_animator$Animator$Css$LinearTiming,
			keyframes: newKeyFrames
		};
		var _v0 = frames.dwell;
		if (_v0.$ === 'Nothing') {
			return A2($elm$core$List$cons, anim, anims);
		} else {
			var details = _v0.a;
			var dwellFrames = A8(
				$mdgriffith$elm_animator$Animator$Css$renderFrame,
				0,
				$elm$core$List$length(details.frames),
				attrName,
				details.frames,
				renderer,
				stubber,
				'',
				'');
			var dwell = {
				name: name + '-dwell',
				delay: duration,
				repeat: function () {
					var _v1 = details.period;
					if (_v1.$ === 'Repeat') {
						var n = _v1.a;
						return $mdgriffith$elm_animator$Animator$Css$RepeatAnim(n);
					} else {
						return $mdgriffith$elm_animator$Animator$Css$LoopAnim;
					}
				}(),
				duration: function () {
					var _v2 = details.period;
					if (_v2.$ === 'Repeat') {
						var dwellDur = _v2.b;
						return $ianmackenzie$elm_units$Duration$inMilliseconds(dwellDur);
					} else {
						var dwellDur = _v2.a;
						return $ianmackenzie$elm_units$Duration$inMilliseconds(dwellDur);
					}
				}(),
				timingFn: $mdgriffith$elm_animator$Animator$Css$LinearTiming,
				keyframes: '@keyframes ' + (name + ('-dwell' + (' {\u000A' + (dwellFrames.frames + '\u000A}'))))
			};
			return A2(
				$elm$core$List$cons,
				dwell,
				A2($elm$core$List$cons, anim, anims));
		}
	});
var $elm$core$Basics$atan2 = _Basics_atan2;
var $elm$core$Basics$toPolar = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return _Utils_Tuple2(
		$elm$core$Basics$sqrt((x * x) + (y * y)),
		A2($elm$core$Basics$atan2, y, x));
};
var $mdgriffith$elm_animator$Animator$Css$transformToStub = function (details) {
	var _v0 = $elm$core$Basics$toPolar(
		_Utils_Tuple2(
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingZ.position),
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingX.position)));
	var rotationAroundY = _v0.b;
	var _v1 = $elm$core$Basics$toPolar(
		_Utils_Tuple2(
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingZ.position),
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingY.position)));
	var rotationAroundX = _v1.b;
	return $mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.x.position)) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.y.position)) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.z.position)) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(rotationAroundY) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(rotationAroundX) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(details.aroundX) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(details.aroundY) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(details.aroundZ) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.rotation.position)) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.scaleX.position)) + ('-' + ($mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.scaleY.position)) + ('-' + $mdgriffith$elm_animator$Animator$Css$stubFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.scaleZ.position)))))))))))))))))))))));
};
var $mdgriffith$elm_animator$Animator$Css$transformToString = function (details) {
	var _v0 = $elm$core$Basics$toPolar(
		_Utils_Tuple2(
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingZ.position),
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingX.position)));
	var rotationAroundY = _v0.b;
	var _v1 = $elm$core$Basics$toPolar(
		_Utils_Tuple2(
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingZ.position),
			$ianmackenzie$elm_units$Pixels$inPixels(details.facingY.position)));
	var rotationAroundX = _v1.b;
	return ('translate3d(' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.x.position)) + ('px, ' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.y.position)) + ('px, ' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.z.position)) + 'px)')))))) + ((' rotate3d(0, 1, 0, ' + ($elm$core$String$fromFloat(rotationAroundY) + 'rad)')) + ((' rotate3d(1, 0, 0, ' + ($elm$core$String$fromFloat(rotationAroundX) + 'rad)')) + ((' rotate3d(' + ($elm$core$String$fromFloat(details.aroundX) + (', ' + ($elm$core$String$fromFloat(details.aroundY) + (', ' + ($elm$core$String$fromFloat(details.aroundZ) + (', ' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.rotation.position)) + 'rad)')))))))) + (' scale3d(' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.scaleX.position)) + (', ' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.scaleY.position)) + (', ' + ($elm$core$String$fromFloat(
		$ianmackenzie$elm_units$Pixels$inPixels(details.scaleZ.position)) + ')')))))))));
};
var $mdgriffith$elm_animator$Internal$Interpolate$Osc = F3(
	function (a, b, c) {
		return {$: 'Osc', a: a, b: b, c: c};
	});
var $mdgriffith$elm_animator$Internal$Interpolate$Pos = F2(
	function (a, b) {
		return {$: 'Pos', a: a, b: b};
	});
var $mdgriffith$elm_animator$Internal$Interpolate$withDefault = F2(
	function (def, defaultOr) {
		if (defaultOr.$ === 'Default') {
			return def;
		} else {
			var specified = defaultOr.a;
			return specified;
		}
	});
var $mdgriffith$elm_animator$Internal$Interpolate$fillDefaults = F2(
	function (builtInDefault, specified) {
		if (specified.$ === 'FullDefault') {
			return builtInDefault;
		} else {
			var partial = specified.a;
			return {
				departLate: A2($mdgriffith$elm_animator$Internal$Interpolate$withDefault, builtInDefault.departLate, partial.departLate),
				wobbliness: A2($mdgriffith$elm_animator$Internal$Interpolate$withDefault, builtInDefault.wobbliness, partial.wobbliness),
				arriveEarly: A2($mdgriffith$elm_animator$Internal$Interpolate$withDefault, builtInDefault.arriveEarly, partial.arriveEarly),
				arriveSlowly: A2($mdgriffith$elm_animator$Internal$Interpolate$withDefault, builtInDefault.arriveSlowly, partial.arriveSlowly),
				departSlowly: A2($mdgriffith$elm_animator$Internal$Interpolate$withDefault, builtInDefault.departSlowly, partial.departSlowly)
			};
		}
	});
var $mdgriffith$elm_animator$Internal$Interpolate$withLinearDefault = function (defMovement) {
	if (defMovement.$ === 'Oscillate') {
		var specifiedPersonality = defMovement.a;
		var period = defMovement.b;
		var fn = defMovement.c;
		var personality = A2($mdgriffith$elm_animator$Internal$Interpolate$fillDefaults, $mdgriffith$elm_animator$Internal$Interpolate$linearDefault, specifiedPersonality);
		return A3($mdgriffith$elm_animator$Internal$Interpolate$Osc, personality, period, fn);
	} else {
		var specifiedPersonality = defMovement.a;
		var p = defMovement.b;
		var personality = A2($mdgriffith$elm_animator$Internal$Interpolate$fillDefaults, $mdgriffith$elm_animator$Internal$Interpolate$linearDefault, specifiedPersonality);
		return A2($mdgriffith$elm_animator$Internal$Interpolate$Pos, personality, p);
	}
};
var $mdgriffith$elm_animator$Internal$Interpolate$standardDefault = {departLate: 0, wobbliness: 0, arriveEarly: 0, arriveSlowly: 0.8, departSlowly: 0.4};
var $mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault = function (defMovement) {
	if (defMovement.$ === 'Oscillate') {
		var specifiedPersonality = defMovement.a;
		var period = defMovement.b;
		var fn = defMovement.c;
		var personality = A2($mdgriffith$elm_animator$Internal$Interpolate$fillDefaults, $mdgriffith$elm_animator$Internal$Interpolate$standardDefault, specifiedPersonality);
		return A3($mdgriffith$elm_animator$Internal$Interpolate$Osc, personality, period, fn);
	} else {
		var specifiedPersonality = defMovement.a;
		var p = defMovement.b;
		var personality = A2($mdgriffith$elm_animator$Internal$Interpolate$fillDefaults, $mdgriffith$elm_animator$Internal$Interpolate$standardDefault, specifiedPersonality);
		return A2($mdgriffith$elm_animator$Internal$Interpolate$Pos, personality, p);
	}
};
var $mdgriffith$elm_animator$Animator$Css$renderAttrs = F3(
	function (timeline, attr, anim) {
		var details = timeline.a;
		switch (attr.$) {
			case 'Explain':
				return anim;
			case 'ColorAttribute':
				var attrName = attr.a;
				var lookup = attr.b;
				return A6(
					$mdgriffith$elm_animator$Animator$Css$renderAnimation,
					details.now,
					attrName,
					A4($mdgriffith$elm_animator$Internal$Timeline$capture, 60, lookup, $mdgriffith$elm_animator$Internal$Interpolate$coloring, timeline),
					$avh4$elm_color$Color$toCssString,
					$mdgriffith$elm_animator$Animator$Css$stubColor,
					anim);
			case 'Linear':
				var attrName = attr.a;
				var lookup = attr.b;
				var toString = attr.c;
				return A6(
					$mdgriffith$elm_animator$Animator$Css$renderAnimation,
					details.now,
					attrName,
					A4(
						$mdgriffith$elm_animator$Internal$Timeline$capture,
						60,
						A2($elm$core$Basics$composeR, lookup, $mdgriffith$elm_animator$Internal$Interpolate$withLinearDefault),
						$mdgriffith$elm_animator$Internal$Interpolate$moving,
						timeline),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.position;
						},
						A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Pixels$inPixels, toString)),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.position;
						},
						A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Pixels$inPixels, $mdgriffith$elm_animator$Animator$Css$stubFloat)),
					anim);
			case 'Movement':
				var attrName = attr.a;
				var lookup = attr.b;
				var toString = attr.c;
				return A6(
					$mdgriffith$elm_animator$Animator$Css$renderAnimation,
					details.now,
					attrName,
					A4(
						$mdgriffith$elm_animator$Internal$Timeline$capture,
						60,
						A2($elm$core$Basics$composeR, lookup, $mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault),
						$mdgriffith$elm_animator$Internal$Interpolate$moving,
						timeline),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.position;
						},
						A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Pixels$inPixels, toString)),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.position;
						},
						A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Pixels$inPixels, $mdgriffith$elm_animator$Animator$Css$stubFloat)),
					anim);
			default:
				var options = attr.a;
				var lookupTransform = attr.b;
				var lookup = function (state) {
					var _v1 = lookupTransform(state);
					var deets = _v1.a;
					return deets;
				};
				var scaleX = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.scaleX;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var scaleY = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.scaleY;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var scaleZ = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.scaleZ;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var facingX = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.facing;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.x;
								},
								$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault))),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var facingY = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.facing;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.y;
								},
								$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault))),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var facingZ = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.facing;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.z;
								},
								$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault))),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var rotation = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.rotate;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withLinearDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var z = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.z;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var y = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.y;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var x = A4(
					$mdgriffith$elm_animator$Internal$Timeline$capture,
					60,
					A2(
						$elm$core$Basics$composeR,
						lookup,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.x;
							},
							$mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault)),
					$mdgriffith$elm_animator$Internal$Interpolate$moving,
					timeline);
				var combined = $mdgriffith$elm_animator$Animator$Css$toTransform(options)(_List_Nil)(x.frames)(y.frames)(z.frames)(rotation.frames)(scaleX.frames)(scaleY.frames)(scaleZ.frames)(facingX.frames)(facingY.frames)(facingZ.frames);
				return A6(
					$mdgriffith$elm_animator$Animator$Css$renderAnimation,
					details.now,
					'transform',
					{
						dwell: A2(
							$elm$core$Maybe$map,
							$mdgriffith$elm_animator$Animator$Css$mapDwellFrames(combined),
							rotation.dwell),
						frames: $elm$core$List$reverse(combined),
						duration: x.duration
					},
					$mdgriffith$elm_animator$Animator$Css$transformToString,
					$mdgriffith$elm_animator$Animator$Css$transformToStub,
					anim);
		}
	});
var $mdgriffith$elm_animator$Animator$Css$explainActive = function (attrs) {
	explainActive:
	while (true) {
		if (!attrs.b) {
			return false;
		} else {
			if (attrs.a.$ === 'Explain') {
				var on = attrs.a.a;
				var others = attrs.b;
				return on;
			} else {
				var skip = attrs.a;
				var others = attrs.b;
				var $temp$attrs = others;
				attrs = $temp$attrs;
				continue explainActive;
			}
		}
	}
};
var $mdgriffith$elm_animator$Animator$Css$viewAxes = function (options) {
	var _v0 = function () {
		var _v1 = options.origin;
		if (_v1.$ === 'Center') {
			return A2($elm$core$Tuple$pair, 0, 0);
		} else {
			var ox = _v1.a;
			var oy = _v1.b;
			return A2($elm$core$Tuple$pair, ox, oy);
		}
	}();
	var x = _v0.a;
	var y = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'width', '0px'),
				A2($elm$html$Html$Attributes$style, 'height', '0px'),
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				'calc(50% + ' + ($elm$core$String$fromFloat(x) + 'px - 3px)')),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				'calc(50% + ' + ($elm$core$String$fromFloat(y) + 'px - 3px)'))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '10px'),
						A2($elm$html$Html$Attributes$style, 'left', '-1px'),
						A2($elm$html$Html$Attributes$style, 'width', '2px'),
						A2($elm$html$Html$Attributes$style, 'height', '50px'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'black')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'bottom', '-5px'),
								A2($elm$html$Html$Attributes$style, 'left', '-3px'),
								A2($elm$html$Html$Attributes$style, 'width', '0'),
								A2($elm$html$Html$Attributes$style, 'height', '0'),
								A2($elm$html$Html$Attributes$style, 'border-left', '4px solid transparent'),
								A2($elm$html$Html$Attributes$style, 'border-right', '4px solid transparent'),
								A2($elm$html$Html$Attributes$style, 'border-top', '8px solid black')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'right', '-3px'),
								A2($elm$html$Html$Attributes$style, 'bottom', '-22px'),
								A2($elm$html$Html$Attributes$style, 'font-size', '12px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Y')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '-1px'),
						A2($elm$html$Html$Attributes$style, 'left', '10px'),
						A2($elm$html$Html$Attributes$style, 'width', '50px'),
						A2($elm$html$Html$Attributes$style, 'height', '2px'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'black')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'right', '-5px'),
								A2($elm$html$Html$Attributes$style, 'top', '-3px'),
								A2($elm$html$Html$Attributes$style, 'width', '0'),
								A2($elm$html$Html$Attributes$style, 'height', '0'),
								A2($elm$html$Html$Attributes$style, 'border-top', '4px solid transparent'),
								A2($elm$html$Html$Attributes$style, 'border-bottom', '4px solid transparent'),
								A2($elm$html$Html$Attributes$style, 'border-left', '8px solid black')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'right', '-14px'),
								A2($elm$html$Html$Attributes$style, 'top', '-6px'),
								A2($elm$html$Html$Attributes$style, 'font-size', '12px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('X')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'width', '6px'),
						A2($elm$html$Html$Attributes$style, 'height', '6px'),
						A2($elm$html$Html$Attributes$style, 'left', '-3px'),
						A2($elm$html$Html$Attributes$style, 'top', '-3px'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'red'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '3px')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'width', '12px'),
						A2($elm$html$Html$Attributes$style, 'height', '12px'),
						A2($elm$html$Html$Attributes$style, 'left', '-7px'),
						A2($elm$html$Html$Attributes$style, 'top', '-7px'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '7px'),
						A2($elm$html$Html$Attributes$style, 'border', '1px solid red')
					]),
				_List_Nil)
			]));
};
var $mdgriffith$elm_animator$Animator$Css$explainElement = function (transformOptions) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%'),
				A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(238, 238, 238, 0.4)'),
				A2($elm$html$Html$Attributes$style, 'border', '2px solid #DDD'),
				A2($elm$html$Html$Attributes$style, 'z-index', '10')
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_animator$Animator$Css$viewAxes(transformOptions)
			]));
};
var $mdgriffith$elm_animator$Animator$Css$renderClassName = F2(
	function (str, anim) {
		renderClassName:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				if (!anim.b.b) {
					var top = anim.a;
					return (str === '') ? top.name : _Utils_ap(str, top.name);
				} else {
					var top = anim.a;
					var _v1 = anim.b;
					var next = _v1.a;
					var remaining = _v1.b;
					var $temp$str = str + (top.name + '-'),
						$temp$anim = A2($elm$core$List$cons, next, remaining);
					str = $temp$str;
					anim = $temp$anim;
					continue renderClassName;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$renderName = F2(
	function (str, anim) {
		renderName:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				if (!anim.b.b) {
					var top = anim.a;
					return (str === '') ? top.name : _Utils_ap(str, top.name);
				} else {
					var top = anim.a;
					var _v1 = anim.b;
					var next = _v1.a;
					var remaining = _v1.b;
					var $temp$str = str + (top.name + ', '),
						$temp$anim = A2($elm$core$List$cons, next, remaining);
					str = $temp$str;
					anim = $temp$anim;
					continue renderName;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$renderDelay = F2(
	function (str, anim) {
		renderDelay:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				if (!anim.b.b) {
					var top = anim.a;
					return (str === '') ? ($elm$core$String$fromFloat(top.delay) + 'ms') : (str + ($elm$core$String$fromFloat(top.delay) + 'ms'));
				} else {
					var top = anim.a;
					var _v1 = anim.b;
					var next = _v1.a;
					var remaining = _v1.b;
					var $temp$str = str + ($elm$core$String$fromFloat(top.delay) + 'ms, '),
						$temp$anim = A2($elm$core$List$cons, next, remaining);
					str = $temp$str;
					anim = $temp$anim;
					continue renderDelay;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$timingFnName = function (fn) {
	return 'linear';
};
var $mdgriffith$elm_animator$Animator$Css$renderTiming = F2(
	function (str, anim) {
		renderTiming:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				if (!anim.b.b) {
					var top = anim.a;
					return (str === '') ? $mdgriffith$elm_animator$Animator$Css$timingFnName(top.timingFn) : _Utils_ap(
						str,
						$mdgriffith$elm_animator$Animator$Css$timingFnName(top.timingFn));
				} else {
					var top = anim.a;
					var _v1 = anim.b;
					var next = _v1.a;
					var remaining = _v1.b;
					var $temp$str = str + ($mdgriffith$elm_animator$Animator$Css$timingFnName(top.timingFn) + ', '),
						$temp$anim = A2($elm$core$List$cons, next, remaining);
					str = $temp$str;
					anim = $temp$anim;
					continue renderTiming;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$renderDuration = F2(
	function (str, anim) {
		renderDuration:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				if (!anim.b.b) {
					var top = anim.a;
					return (str === '') ? ($elm$core$String$fromFloat(top.duration) + 'ms') : (str + ($elm$core$String$fromFloat(top.duration) + 'ms'));
				} else {
					var top = anim.a;
					var _v1 = anim.b;
					var next = _v1.a;
					var remaining = _v1.b;
					var $temp$str = str + ($elm$core$String$fromFloat(top.duration) + 'ms, '),
						$temp$anim = A2($elm$core$List$cons, next, remaining);
					str = $temp$str;
					anim = $temp$anim;
					continue renderDuration;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$renderKeyframes = F2(
	function (str, anim) {
		renderKeyframes:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				var top = anim.a;
				var remain = anim.b;
				var $temp$str = str + ('\u000A' + top.keyframes),
					$temp$anim = remain;
				str = $temp$str;
				anim = $temp$anim;
				continue renderKeyframes;
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$repeatToString = function (rep) {
	if (rep.$ === 'LoopAnim') {
		return 'infinite';
	} else {
		var n = rep.a;
		return $elm$core$String$fromInt(n);
	}
};
var $mdgriffith$elm_animator$Animator$Css$renderIterations = F2(
	function (str, anim) {
		renderIterations:
		while (true) {
			if (!anim.b) {
				return str;
			} else {
				if (!anim.b.b) {
					var top = anim.a;
					return (str === '') ? $mdgriffith$elm_animator$Animator$Css$repeatToString(top.repeat) : _Utils_ap(
						str,
						$mdgriffith$elm_animator$Animator$Css$repeatToString(top.repeat));
				} else {
					var top = anim.a;
					var _v1 = anim.b;
					var next = _v1.a;
					var remaining = _v1.b;
					var $temp$str = str + ($mdgriffith$elm_animator$Animator$Css$repeatToString(top.repeat) + ', '),
						$temp$anim = A2($elm$core$List$cons, next, remaining);
					str = $temp$str;
					anim = $temp$anim;
					continue renderIterations;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$Css$renderAnimations = function (animations) {
	return A2($mdgriffith$elm_animator$Animator$Css$renderKeyframes, '', animations) + ('\u000A.' + (A2($mdgriffith$elm_animator$Animator$Css$renderClassName, '', animations) + ('{\u000A            animation-name: ' + (A2($mdgriffith$elm_animator$Animator$Css$renderName, '', animations) + (';\u000A            animation-delay: ' + (A2($mdgriffith$elm_animator$Animator$Css$renderDelay, '', animations) + (';\u000A            animation-duration: ' + (A2($mdgriffith$elm_animator$Animator$Css$renderDuration, '', animations) + (';\u000A            animation-timing-function: ' + (A2($mdgriffith$elm_animator$Animator$Css$renderTiming, '', animations) + (';\u000A            animation-fill-mode: forwards;\u000A            animation-iteration-count: ' + (A2($mdgriffith$elm_animator$Animator$Css$renderIterations, '', animations) + ';\u000A        }\u000A        '))))))))))));
};
var $mdgriffith$elm_animator$Animator$Css$getTransformOptions = function (attrs) {
	getTransformOptions:
	while (true) {
		if (!attrs.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (attrs.a.$ === 'TransformAttr') {
				var _v1 = attrs.a;
				var opts = _v1.a;
				return $elm$core$Maybe$Just(opts);
			} else {
				var rest = attrs.b;
				var $temp$attrs = rest;
				attrs = $temp$attrs;
				continue getTransformOptions;
			}
		}
	}
};
var $mdgriffith$elm_animator$Animator$Css$renderTransformOptions = function (opts) {
	return A2(
		$elm$html$Html$Attributes$style,
		'transform-origin',
		function () {
			var _v0 = opts.origin;
			if (_v0.$ === 'Center') {
				return 'center';
			} else {
				var x = _v0.a;
				var y = _v0.b;
				return ('calc(50% + ' + ($elm$core$String$fromFloat(x) + 'px) calc(50% + ')) + ($elm$core$String$fromFloat(y) + 'px)');
			}
		}());
};
var $mdgriffith$elm_animator$Animator$Css$Center = {$: 'Center'};
var $mdgriffith$elm_animator$Animator$Css$defaultTransformOptions = {
	origin: $mdgriffith$elm_animator$Animator$Css$Center,
	rotationAxis: {x: 0, y: 0, z: 1}
};
var $mdgriffith$elm_animator$Animator$Css$node = F5(
	function (name, timeline, divAttrs, attrs, children) {
		var transformOptions = A2(
			$elm$core$Maybe$withDefault,
			$mdgriffith$elm_animator$Animator$Css$defaultTransformOptions,
			$mdgriffith$elm_animator$Animator$Css$getTransformOptions(divAttrs));
		var explainIsOn = $mdgriffith$elm_animator$Animator$Css$explainActive(divAttrs);
		var possiblyExplainAttr = explainIsOn ? A2($elm$html$Html$Attributes$style, 'position', 'relative') : A2($elm$html$Html$Attributes$style, '', '');
		var animations = $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_animator$Animator$Css$renderAttrs(timeline),
				_List_Nil,
				divAttrs));
		return A3(
			$elm$html$Html$node,
			name,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(
					A2($mdgriffith$elm_animator$Animator$Css$renderClassName, '', animations)),
				A2(
					$elm$core$List$cons,
					possiblyExplainAttr,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_animator$Animator$Css$renderTransformOptions(transformOptions),
						attrs))),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_animator$Animator$Css$stylesheet(
					$mdgriffith$elm_animator$Animator$Css$renderAnimations(animations)),
				A2(
					$elm$core$List$cons,
					explainIsOn ? $mdgriffith$elm_animator$Animator$Css$explainElement(transformOptions) : $elm$html$Html$text(''),
					children)));
	});
var $mdgriffith$elm_animator$Animator$Css$div = $mdgriffith$elm_animator$Animator$Css$node('div');
var $mdgriffith$elm_animator$Animator$Css$Movement = F3(
	function (a, b, c) {
		return {$: 'Movement', a: a, b: b, c: c};
	});
var $mdgriffith$elm_animator$Animator$Css$style = F3(
	function (name, toString, lookup) {
		return A3($mdgriffith$elm_animator$Animator$Css$Movement, name, lookup, toString);
	});
var $author$project$Views$NavigationStack$view = F3(
	function (selectedPage, attributes, pages) {
		var xOffset = function (current) {
			return (-current) * 100;
		};
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', 'var(--navigation-width)'),
						A2($elm$html$Html$Attributes$style, 'overflow-x', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'row'),
						A2($elm$html$Html$Attributes$style, 'flex-wrap', 'nowrap'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-start'),
						A2($elm$html$Html$Attributes$style, 'height', '100%')
					]),
				attributes),
			A2(
				$elm$core$List$map,
				function (page) {
					return A4(
						$mdgriffith$elm_animator$Animator$Css$div,
						selectedPage,
						_List_fromArray(
							[
								A3(
								$mdgriffith$elm_animator$Animator$Css$style,
								'transform',
								function (_float) {
									return 'translate(' + ($elm$core$String$fromFloat(_float) + '%, 0px)');
								},
								function (current) {
									return $mdgriffith$elm_animator$Animator$at(
										xOffset(current));
								})
							]),
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', 'var(--navigation-width)'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[page]));
				},
				pages));
	});
var $author$project$Views$SidebarSheet$DragMsg = function (a) {
	return {$: 'DragMsg', a: a};
};
var $author$project$Views$SidebarSheet$view = F5(
	function (state, toMsg, title, customAttrs, pages) {
		return A5(
			$author$project$Views$BottomSheet$view,
			state.sheetActive ? $elm$core$Maybe$Just(state.sheetHeight) : $elm$core$Maybe$Nothing,
			A2($elm$core$Basics$composeR, $author$project$Views$SidebarSheet$DragMsg, toMsg),
			title,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidebar-sheet')
					]),
				customAttrs),
			_List_fromArray(
				[
					A3($author$project$Views$NavigationStack$view, state.sidebarPage, _List_Nil, pages)
				]));
	});
var $author$project$Pages$Fleet_$SheetMsg = function (a) {
	return {$: 'SheetMsg', a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$Attributes$fa2x1 = $elm$svg$Svg$Attributes$class('fa-2x1');
var $author$project$Data$AlertType$icon = function (t) {
	switch (t.$) {
		case 'CapsizeAlert':
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-danger')
					]),
				$author$project$FontAwesome$Custom$alert);
		case 'RestrictedZone':
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-danger')
					]),
				$author$project$FontAwesome$Custom$noEntry);
		case 'OverSpeed':
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-danger')
					]),
				$author$project$FontAwesome$Custom$gauge);
		case 'LowBattery':
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-danger')
					]),
				$author$project$FontAwesome$Custom$lowBattery);
		case 'HighWater':
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-danger')
					]),
				$author$project$FontAwesome$Custom$highWater);
		default:
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-danger')
					]),
				$lattyware$elm_fontawesome$FontAwesome$Solid$clock);
	}
};
var $author$project$Data$Boat$statusIcon = function (boat) {
	if (boat.isOffline) {
		var _v0 = boat.status;
		if (_v0.$ === 'Underway') {
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-secondary')
					]),
				$author$project$FontAwesome$Custom$underwayOffline);
		} else {
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-secondary')
					]),
				$author$project$FontAwesome$Custom$stoppedOffline);
		}
	} else {
		var _v1 = boat.status;
		if (_v1.$ === 'Underway') {
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-success')
					]),
				$author$project$FontAwesome$Custom$underway);
		} else {
			return A2(
				$lattyware$elm_fontawesome$FontAwesome$styled,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-success')
					]),
				$author$project$FontAwesome$Custom$stopped);
		}
	}
};
var $author$project$Data$SpeedUnit$convertTo = F2(
	function (unit, metresPerSecond) {
		switch (unit.$) {
			case 'Knots':
				return metresPerSecond * 1.94384;
			case 'KilometresPerHour':
				return metresPerSecond * 3.6;
			default:
				return metresPerSecond * 2.23694;
		}
	});
var $author$project$Data$SpeedUnit$abbreviation = function (unit) {
	switch (unit.$) {
		case 'Knots':
			return 'knots';
		case 'KilometresPerHour':
			return 'km/h';
		default:
			return 'mph';
	}
};
var $author$project$Data$SpeedUnit$formatSpeed = F2(
	function (u, s) {
		return A2(
			$myrho$elm_round$Round$round,
			1,
			A2($author$project$Data$SpeedUnit$convertTo, u, s)) + (' ' + $author$project$Data$SpeedUnit$abbreviation(u));
	});
var $author$project$Data$Boat$displaySpeed = F2(
	function (b, u) {
		var _v0 = b.status;
		if (_v0.$ === 'Underway') {
			var _v1 = b.speed;
			if (_v1.$ === 'Just') {
				var s = _v1.a;
				return (s < 0.01) ? ('0 ' + $author$project$Data$SpeedUnit$abbreviation(u)) : A2($author$project$Data$SpeedUnit$formatSpeed, u, s);
			} else {
				return '0 ' + $author$project$Data$SpeedUnit$abbreviation(u);
			}
		} else {
			return '';
		}
	});
var $author$project$Data$Boat$statusToString = function (status) {
	switch (status.$) {
		case 'Unknown':
			return 'Unknown';
		case 'Underway':
			return 'Underway';
		case 'InPen':
			return 'In Pen';
		case 'OnMooring':
			return 'On Mooring';
		case 'AtAnchor':
			return 'At Anchor';
		case 'AtJetty':
			return 'At Jetty';
		case 'RaftedUp':
			return 'Rafted Up';
		case 'OutOfWater':
			return 'Out of Water';
		case 'Stopped':
			return 'Stopped';
		default:
			var desc = status.a;
			return A2($elm$core$Maybe$withDefault, 'Other', desc);
	}
};
var $author$project$Data$Boat$statusOrSpeed = F2(
	function (unit, boat) {
		if (boat.isOffline) {
			return 'Offline';
		} else {
			var _v0 = boat.status;
			if (_v0.$ === 'Underway') {
				return A2($author$project$Data$Boat$displaySpeed, boat, unit);
			} else {
				var s = _v0;
				return $author$project$Data$Boat$statusToString(s);
			}
		}
	});
var $author$project$Pages$Fleet_$boatStatus = F2(
	function (boat, speedUnit) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('d-flex align-items-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small text-secondary mx-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Data$Boat$statusOrSpeed, speedUnit, boat))
						])),
					$lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('fs-4')
							]),
						$author$project$Data$Boat$statusIcon(boat)))
				]));
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchHour = {$: 'MatchHour'};
var $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchMinute = {$: 'MatchMinute'};
var $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchSecond = {$: 'MatchSecond'};
var $enkidatron$elm_cldr$Internal$DayPeriodRule$granularityHelper = F2(
	function (granSoFar, symbols) {
		granularityHelper:
		while (true) {
			_v0$3:
			while (true) {
				if (!symbols.b) {
					return granSoFar;
				} else {
					if ((symbols.a.$ === 'Symbol') && (symbols.a.a.$ === 'Time')) {
						switch (symbols.a.a.a.$) {
							case 'Minute':
								var rest = symbols.b;
								var $temp$granSoFar = $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchMinute,
									$temp$symbols = rest;
								granSoFar = $temp$granSoFar;
								symbols = $temp$symbols;
								continue granularityHelper;
							case 'Second':
								return $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchSecond;
							default:
								break _v0$3;
						}
					} else {
						break _v0$3;
					}
				}
			}
			var rest = symbols.b;
			var $temp$granSoFar = granSoFar,
				$temp$symbols = rest;
			granSoFar = $temp$granSoFar;
			symbols = $temp$symbols;
			continue granularityHelper;
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$granularity = $enkidatron$elm_cldr$Internal$DayPeriodRule$granularityHelper($enkidatron$elm_cldr$Internal$DayPeriodRule$MatchHour);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var year = yearOfEra + (era * 400);
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		year: year + ((month <= 2) ? 1 : 0),
		month: month
	};
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatDay = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).year;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatEra = F3(
	function (eraNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$era,
			eraNames,
			A2($elm$time$Time$toYear, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatYear = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			A2($elm$time$Time$toYear, zone, posix));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthHelper = F3(
	function (monthNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$month,
			monthNames,
			A2($elm$time$Time$toMonth, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper = F3(
	function (formatFun, patterns, textWidth) {
		return formatFun(
			A2($enkidatron$elm_cldr$Internal$Structures$getPattern3, patterns, textWidth));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthNumberHelper = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			$justinmimbs$date$Date$monthToNumber(
				A2($elm$time$Time$toMonth, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonth = F2(
	function (monthPattern3, width) {
		if (width.$ === 'Text') {
			var textWidth = width.a;
			return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthHelper, monthPattern3, textWidth);
		} else {
			var numberWidth = width.a;
			return $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthNumberHelper(numberWidth);
		}
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMinute = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toMinute, zone, posix));
	});
var $enkidatron$elm_cldr$Internal$Format$period = F2(
	function (periodNames, hour) {
		return (hour > 11) ? periodNames.pm : periodNames.am;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatPeriod = F3(
	function (periodNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$period,
			periodNames,
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSecond = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toSecond, zone, posix));
	});
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return $elm$time$Time$Thu;
			case 1:
				return $elm$time$Time$Fri;
			case 2:
				return $elm$time$Time$Sat;
			case 3:
				return $elm$time$Time$Sun;
			case 4:
				return $elm$time$Time$Mon;
			case 5:
				return $elm$time$Time$Tue;
			default:
				return $elm$time$Time$Wed;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatWeekday = F3(
	function (weekdayNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$weekday,
			weekdayNames,
			A2($elm$time$Time$toWeekday, zone, posix));
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
				$elm$core$Basics$clamp,
				1,
				A2($justinmimbs$date$Date$daysInMonth, y, m),
				d));
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatYearOfWeek = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			$justinmimbs$date$Date$weekYear(
				A2($justinmimbs$date$Date$fromPosix, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From0 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2(
				$elm$core$Basics$modBy,
				12,
				A2($elm$time$Time$toHour, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$replaceZeroWith = F2(
	function (_default, num) {
		return (!num) ? _default : num;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From1 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2(
				$enkidatron$elm_cldr$Cldr$Format$DateTime$replaceZeroWith,
				12,
				A2(
					$elm$core$Basics$modBy,
					12,
					A2($elm$time$Time$toHour, zone, posix))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From0 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toHour, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From1 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2(
				$enkidatron$elm_cldr$Cldr$Format$DateTime$replaceZeroWith,
				24,
				A2($elm$time$Time$toHour, zone, posix)));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0.a;
	return rd;
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$getOffsets = F2(
	function (zone, posix) {
		var rataDieOffset = $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) - $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, posix));
		var secondOffset = A2($elm$time$Time$toSecond, zone, posix) - A2($elm$time$Time$toSecond, $elm$time$Time$utc, posix);
		var minuteOffset = A2($elm$time$Time$toMinute, zone, posix) - A2($elm$time$Time$toMinute, $elm$time$Time$utc, posix);
		var hourOffset = A2($elm$time$Time$toHour, zone, posix) - A2($elm$time$Time$toHour, $elm$time$Time$utc, posix);
		var totalSecondsOffset = (((((rataDieOffset * 24) * 60) * 60) + ((hourOffset * 60) * 60)) + (minuteOffset * 60)) + secondOffset;
		return {
			hours: $elm$core$Basics$abs((totalSecondsOffset / 3600) | 0),
			minutes: $elm$core$Basics$abs(((totalSecondsOffset % 3600) / 60) | 0),
			seconds: $elm$core$Basics$abs(totalSecondsOffset % 60),
			offsetIsPositive: totalSecondsOffset >= 0
		};
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$gmtFormatOffsets = F2(
	function (nameWidth, offsets) {
		var showSeconds = !(!offsets.seconds);
		var showMinutes = (!(!offsets.minutes)) || ((!(!offsets.seconds)) || ((!(!offsets.hours)) && _Utils_eq(nameWidth, $enkidatron$elm_cldr$Internal$FormatSymbols$Long)));
		var showHours = (!(!offsets.hours)) || ((!(!offsets.minutes)) || (!(!offsets.seconds)));
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					$elm$core$Tuple$first,
					_List_fromArray(
						[
							_Utils_Tuple2(true, 'GMT'),
							_Utils_Tuple2(showHours && offsets.offsetIsPositive, '+'),
							_Utils_Tuple2(showHours && (!offsets.offsetIsPositive), '-'),
							_Utils_Tuple2(
							showHours,
							$elm$core$String$fromInt(offsets.hours)),
							_Utils_Tuple2(showMinutes, ':'),
							_Utils_Tuple2(
							showMinutes,
							A3(
								$elm$core$String$padLeft,
								2,
								_Utils_chr('0'),
								$elm$core$String$fromInt(offsets.minutes))),
							_Utils_Tuple2(showSeconds, ':'),
							_Utils_Tuple2(
							showSeconds,
							A3(
								$elm$core$String$padLeft,
								2,
								_Utils_chr('0'),
								$elm$core$String$fromInt(offsets.seconds)))
						]))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat = F3(
	function (nameWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$gmtFormatOffsets,
			nameWidth,
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$getOffsets, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$iso8601BasicFormatOffsets = function (offsets) {
	var showSeconds = !(!offsets.seconds);
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(offsets.offsetIsPositive, '+'),
						_Utils_Tuple2(
						true,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(offsets.hours))),
						_Utils_Tuple2(
						true,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(offsets.minutes))),
						_Utils_Tuple2(
						showSeconds,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(offsets.seconds)))
					]))));
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$foramtZoneIso8601Basic = F2(
	function (zone, posix) {
		return $enkidatron$elm_cldr$Cldr$Format$DateTime$iso8601BasicFormatOffsets(
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$getOffsets, zone, posix));
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper = F4(
	function (gran, _v0, zone, posix) {
		var hour = _v0.a;
		var minute = _v0.b;
		switch (gran.$) {
			case 'MatchHour':
				return A2(
					$elm$core$Basics$compare,
					A2($elm$time$Time$toHour, zone, posix),
					hour);
			case 'MatchMinute':
				return A2(
					$elm$core$Basics$compare,
					_Utils_Tuple2(
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix)),
					_Utils_Tuple2(hour, minute));
			default:
				return A2(
					$elm$core$Basics$compare,
					_Utils_Tuple3(
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix)),
					_Utils_Tuple3(hour, minute, 0));
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$isMatch = F4(
	function (gran, zone, posix, rule) {
		if (rule.$ === 'At') {
			var at = rule.a;
			return _Utils_eq(
				A4($enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper, gran, at, zone, posix),
				$elm$core$Basics$EQ);
		} else {
			var from = rule.a;
			var before = rule.b;
			return (!_Utils_eq(
				A4($enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper, gran, from, zone, posix),
				$elm$core$Basics$LT)) && _Utils_eq(
				A4($enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper, gran, before, zone, posix),
				$elm$core$Basics$LT);
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$bestMatch = F2(
	function (ruleA, ruleB) {
		var _v0 = _Utils_Tuple2(ruleA, ruleB);
		if (_v0.a.$ === 'At') {
			if (_v0.b.$ === 'At') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Basics$EQ;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $elm$core$Basics$GT;
			}
		} else {
			if (_v0.b.$ === 'At') {
				var _v5 = _v0.a;
				var _v6 = _v0.b;
				return $elm$core$Basics$LT;
			} else {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				return $elm$core$Basics$EQ;
			}
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$dayPeriod = function (rule) {
	if (rule.$ === 'At') {
		var name = rule.b;
		return name;
	} else {
		var name = rule.c;
		return name;
	}
};
var $elm_community$list_extra$List$Extra$foldl1 = F2(
	function (func, list) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list.a;
			var xs = list.b;
			return $elm$core$Maybe$Just(
				A3($elm$core$List$foldl, func, x, xs));
		}
	});
var $elm_community$list_extra$List$Extra$maximumWith = F2(
	function (comparator, list) {
		return A2(
			$elm_community$list_extra$List$Extra$foldl1,
			F2(
				function (x, y) {
					var _v0 = A2(comparator, x, y);
					if (_v0.$ === 'GT') {
						return x;
					} else {
						return y;
					}
				}),
			list);
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatFlexibleDayPeriod = F5(
	function (rules, granularity, periodNames, zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatPeriod, periodNames, zone, posix),
			A2(
				$elm$core$Maybe$andThen,
				function (dayPeriod) {
					return A2($elm$core$Dict$get, dayPeriod, periodNames.dayPeriods);
				},
				A2(
					$elm$core$Maybe$map,
					$enkidatron$elm_cldr$Internal$DayPeriodRule$dayPeriod,
					A2(
						$elm_community$list_extra$List$Extra$maximumWith,
						$enkidatron$elm_cldr$Internal$DayPeriodRule$bestMatch,
						A2(
							$elm$core$List$filter,
							A3($enkidatron$elm_cldr$Internal$DayPeriodRule$isMatch, granularity, zone, posix),
							rules)))));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$doThreeDigitRounding = F2(
	function (decimals, millis) {
		return $elm$core$Basics$round(
			millis / A2($elm$core$Basics$pow, 10, 3 - decimals));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatFractionalSeconds = F3(
	function (decimals, zone, posix) {
		return $elm$core$String$fromInt(
			A2(
				$enkidatron$elm_cldr$Cldr$Format$DateTime$doThreeDigitRounding,
				decimals,
				A2($elm$time$Time$toMillis, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneNonLocationFormat = $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat;
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGenericNonLocationFormat = $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat;
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbol = F5(
	function (granularity, internal, zone, posix, symbol) {
		if (symbol.$ === 'Date') {
			switch (symbol.a.$) {
				case 'Era':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatEra, internal.eraNames, textWidth, zone, posix);
				case 'Year':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatYear, numberWidth, zone, posix);
				case 'YearOfWeek':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatYearOfWeek, numberWidth, zone, posix);
				case 'Month':
					var width = symbol.a.a;
					return A4($enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonth, internal.monthFormatNames, width, zone, posix);
				case 'MonthStandalone':
					var width = symbol.a.a;
					return A4($enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonth, internal.monthStandaloneNames, width, zone, posix);
				case 'Weekday':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatWeekday, internal.weekdayFormatNames, textWidth, zone, posix);
				case 'WeekdayStandalone':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatWeekday, internal.weekdayStandaloneNames, textWidth, zone, posix);
				default:
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatDay, numberWidth, zone, posix);
			}
		} else {
			switch (symbol.a.$) {
				case 'Period':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatPeriod, internal.periodNames, textWidth, zone, posix);
				case 'FlexibleDayPeriod':
					var textWidth = symbol.a.a;
					return A5(
						$enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper,
						A2($enkidatron$elm_cldr$Cldr$Format$DateTime$formatFlexibleDayPeriod, internal.dayPeriodRuleSet, granularity),
						internal.periodNames,
						textWidth,
						zone,
						posix);
				case 'Hour12From1':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From1, numberWidth, zone, posix);
				case 'Hour24From0':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From0, numberWidth, zone, posix);
				case 'Hour12From0':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From0, numberWidth, zone, posix);
				case 'Hour24From1':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From1, numberWidth, zone, posix);
				case 'Minute':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatMinute, numberWidth, zone, posix);
				case 'Second':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatSecond, numberWidth, zone, posix);
				case 'FractionalSeconds':
					var decimals = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatFractionalSeconds, decimals, zone, posix);
				case 'ZoneNonLocationFormat':
					var nameWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneNonLocationFormat, nameWidth, zone, posix);
				case 'ZoneIso8601Basic':
					var _v1 = symbol.a;
					return A2($enkidatron$elm_cldr$Cldr$Format$DateTime$foramtZoneIso8601Basic, zone, posix);
				case 'ZoneGmtFormat':
					var nameWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat, nameWidth, zone, posix);
				default:
					var nameWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGenericNonLocationFormat, nameWidth, zone, posix);
			}
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatDateTime = F4(
	function (internal, symbols, zone, posix) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$unwrap(
					A4(
						$enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbol,
						$enkidatron$elm_cldr$Internal$DayPeriodRule$granularity(symbols),
						internal,
						zone,
						posix)),
				symbols));
	});
var $enkidatron$elm_cldr$Internal$Options$rankName = function (name) {
	if (name.$ === 'ShortName') {
		return 4;
	} else {
		return 5;
	}
};
var $enkidatron$elm_cldr$Internal$Options$scoreHour12 = F2(
	function (requested, candidate) {
		var _v0 = _Utils_Tuple2(requested, candidate);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var req = _v0.a.a;
			var can = _v0.b.a;
			return (!_Utils_eq(req, can)) ? (-1000) : 0;
		} else {
			return 0;
		}
	});
var $enkidatron$elm_cldr$Internal$Options$rankFractionalDigits = function (digits) {
	switch (digits.$) {
		case 'One':
			return 1;
		case 'Two':
			return 2;
		default:
			return 3;
	}
};
var $enkidatron$elm_cldr$Internal$Options$timeMatchScore = F2(
	function (requested, candidate) {
		return $elm$core$List$sum(
			_List_fromArray(
				[
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.period, candidate.period),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.hour, candidate.hour),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.minute, candidate.minute),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.second, candidate.second),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankFractionalDigits, requested.fractionalSecondDigits, candidate.fractionalSecondDigits),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankName, requested.zone, candidate.zone),
					A2($enkidatron$elm_cldr$Internal$Options$scoreHour12, requested.hour12, candidate.hour12)
				]));
	});
var $enkidatron$elm_cldr$Internal$Options$dateTimeMatchScore = F2(
	function (requested, candidate) {
		return A2($enkidatron$elm_cldr$Internal$Options$dateMatchScore, requested, candidate) + A2($enkidatron$elm_cldr$Internal$Options$timeMatchScore, requested, candidate);
	});
var $enkidatron$elm_cldr$Internal$Options$dateToDateTime = function (opts) {
	return {day: opts.day, era: opts.era, hour: $elm$core$Maybe$Nothing, year: opts.year, zone: $elm$core$Maybe$Nothing, month: opts.month, hour12: $elm$core$Maybe$Nothing, minute: $elm$core$Maybe$Nothing, period: $elm$core$Maybe$Nothing, second: $elm$core$Maybe$Nothing, weekday: opts.weekday, dayPeriod: $elm$core$Maybe$Nothing, fractionalSecondDigits: $elm$core$Maybe$Nothing};
};
var $enkidatron$elm_cldr$Internal$Options$timeToDateTime = function (opts) {
	return {day: $elm$core$Maybe$Nothing, era: $elm$core$Maybe$Nothing, hour: opts.hour, year: $elm$core$Maybe$Nothing, zone: opts.zone, month: $elm$core$Maybe$Nothing, hour12: opts.hour12, minute: opts.minute, period: opts.period, second: opts.second, weekday: $elm$core$Maybe$Nothing, dayPeriod: opts.dayPeriod, fractionalSecondDigits: opts.fractionalSecondDigits};
};
var $enkidatron$elm_cldr$Internal$Locale$toDateTimeAvailableFormat = function (af) {
	switch (af.$) {
		case 'DateTimeAF':
			var format = af.a;
			return format;
		case 'TimeAF':
			var formatSymbols = af.a.formatSymbols;
			var options = af.a.options;
			return {
				options: $enkidatron$elm_cldr$Internal$Options$timeToDateTime(options),
				formatSymbols: A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Time),
					formatSymbols)
			};
		default:
			var formatSymbols = af.a.formatSymbols;
			var options = af.a.options;
			return {
				options: $enkidatron$elm_cldr$Internal$Options$dateToDateTime(options),
				formatSymbols: A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Date),
					formatSymbols)
			};
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth = function (opt) {
	if (opt.$ === 'LongName') {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Long;
	} else {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Short;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper = F4(
	function (requestedHourType, info, currentWidth, requested) {
		var width = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, currentWidth, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested);
		if (requestedHourType.$ === 'Just') {
			if (requestedHourType.a.$ === 'Hour12') {
				var _v1 = requestedHourType.a;
				return info.hour12(width);
			} else {
				var _v2 = requestedHourType.a;
				return info.hour24(width);
			}
		} else {
			return info._default(width);
		}
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$fractionalSeconds = function (opt) {
	switch (opt.$) {
		case 'One':
			return 1;
		case 'Two':
			return 2;
		default:
			return 3;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Expand$time = F2(
	function (requested, symbol) {
		switch (symbol.$) {
			case 'Period':
				var period = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Period(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, period, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.period));
			case 'FlexibleDayPeriod':
				var flexDayPeriod = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$FlexibleDayPeriod(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, flexDayPeriod, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.dayPeriod));
			case 'Hour12From1':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1, _default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1},
					hour,
					requested.hour);
			case 'Hour24From0':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0, _default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0},
					hour,
					requested.hour);
			case 'Hour12From0':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0, _default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0},
					hour,
					requested.hour);
			case 'Hour24From1':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1, _default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1},
					hour,
					requested.hour);
			case 'Minute':
				var minute = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Minute(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, minute, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.minute));
			case 'Second':
				var second = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Second(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, second, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.second));
			case 'FractionalSeconds':
				var frac = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, frac, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$fractionalSeconds, requested.fractionalSecondDigits));
			case 'ZoneNonLocationFormat':
				var zone = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, zone, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth, requested.zone));
			case 'ZoneIso8601Basic':
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneIso8601Basic;
			case 'ZoneGmtFormat':
				var zone = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, zone, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth, requested.zone));
			default:
				var zone = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, zone, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth, requested.zone));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$expandSymbol = F2(
	function (requested, symbol) {
		if (symbol.$ === 'Date') {
			var dateSymbol = symbol.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Date(
				A2($enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date, requested, dateSymbol));
		} else {
			var timeSymbol = symbol.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Time(
				A2($enkidatron$elm_cldr$Internal$FormatSymbols$Expand$time, requested, timeSymbol));
		}
	});
var $enkidatron$elm_cldr$Internal$Options$splitOptions = function (fullOptions) {
	return ($enkidatron$elm_cldr$Internal$Options$hasDateFields(fullOptions) && $enkidatron$elm_cldr$Internal$Options$hasTimeFields(fullOptions)) ? $elm$core$Maybe$Just(
		_Utils_Tuple2(
			$enkidatron$elm_cldr$Internal$Options$dateSubset(fullOptions),
			$enkidatron$elm_cldr$Internal$Options$timeSubset(fullOptions))) : $elm$core$Maybe$Nothing;
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe = F2(
	function (left, right) {
		var _v0 = _Utils_Tuple2(left, right);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Just') {
				if (_v0.b.$ === 'Just') {
					return true;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Nothing') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$fieldsDoNotMatch = F2(
	function (a, b) {
		return !A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.era, b.era),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.year, b.year),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.month, b.month),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.day, b.day),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.weekday, b.weekday),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.period, b.period),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.hour, b.hour),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.minute, b.minute),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.second, b.second),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.fractionalSecondDigits, b.fractionalSecondDigits),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.zone, b.zone)
				]));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundNeither = {$: 'FoundNeither'};
var $enkidatron$elm_cldr$Cldr$Format$Length$Full = {$: 'Full'};
var $enkidatron$elm_cldr$Cldr$Format$Length$Long = {$: 'Long'};
var $enkidatron$elm_cldr$Cldr$Format$Length$Short = {$: 'Short'};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWeekday = {$: 'FoundWeekday'};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWideMonth = {$: 'FoundWideMonth'};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePatternHelper = F2(
	function (foundSoFar, symbols) {
		lengthForDatePatternHelper:
		while (true) {
			var _v0 = _Utils_Tuple2(foundSoFar, symbols);
			_v0$7:
			while (true) {
				if (!_v0.b.b) {
					if (_v0.a.$ === 'FoundWideMonth') {
						var _v1 = _v0.a;
						return $enkidatron$elm_cldr$Cldr$Format$Length$Long;
					} else {
						return $enkidatron$elm_cldr$Cldr$Format$Length$Short;
					}
				} else {
					if (_v0.b.a.$ === 'Symbol') {
						switch (_v0.b.a.a.$) {
							case 'Weekday':
								if (_v0.a.$ === 'FoundWideMonth') {
									var _v7 = _v0.a;
									var _v8 = _v0.b;
									return $enkidatron$elm_cldr$Cldr$Format$Length$Full;
								} else {
									var _v9 = _v0.b;
									var rest = _v9.b;
									var $temp$foundSoFar = $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWeekday,
										$temp$symbols = rest;
									foundSoFar = $temp$foundSoFar;
									symbols = $temp$symbols;
									continue lengthForDatePatternHelper;
								}
							case 'Month':
								if (_v0.b.a.a.a.$ === 'Text') {
									switch (_v0.b.a.a.a.a.$) {
										case 'Wide':
											if (_v0.a.$ === 'FoundWeekday') {
												var _v2 = _v0.a;
												var _v3 = _v0.b;
												var _v4 = _v3.a.a.a.a;
												return $enkidatron$elm_cldr$Cldr$Format$Length$Full;
											} else {
												var _v5 = _v0.b;
												var _v6 = _v5.a.a.a.a;
												var rest = _v5.b;
												var $temp$foundSoFar = $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWideMonth,
													$temp$symbols = rest;
												foundSoFar = $temp$foundSoFar;
												symbols = $temp$symbols;
												continue lengthForDatePatternHelper;
											}
										case 'Abbreviated':
											var _v10 = _v0.b;
											var _v11 = _v10.a.a.a.a;
											return $enkidatron$elm_cldr$Cldr$Format$Length$Medium;
										default:
											break _v0$7;
									}
								} else {
									break _v0$7;
								}
							default:
								break _v0$7;
						}
					} else {
						break _v0$7;
					}
				}
			}
			var _v12 = _v0.b;
			var rest = _v12.b;
			var $temp$foundSoFar = foundSoFar,
				$temp$symbols = rest;
			foundSoFar = $temp$foundSoFar;
			symbols = $temp$symbols;
			continue lengthForDatePatternHelper;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePattern = $enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePatternHelper($enkidatron$elm_cldr$Cldr$Format$DateTime$FoundNeither);
var $enkidatron$elm_cldr$Cldr$Format$DateTime$expandDateTimeTokenToFormatSymbols = F3(
	function (dateSymbols, timeSymbols, token) {
		switch (token.$) {
			case 'DateGoesHere':
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Date),
					dateSymbols);
			case 'TimeGoesHere':
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Time),
					timeSymbols);
			default:
				var words = token.a;
				return _List_fromArray(
					[
						$enkidatron$elm_cldr$Internal$FormatSymbols$Literal(words)
					]);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$combineBestFormats = F3(
	function (internal, dateSymbols, timeSymbols) {
		return A2(
			$elm$core$List$concatMap,
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$expandDateTimeTokenToFormatSymbols, dateSymbols, timeSymbols),
			A2(
				$enkidatron$elm_cldr$Internal$Structures$getPattern,
				internal.dateTimeTokens,
				$enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePattern(dateSymbols)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$findBestDateFormat = F2(
	function (internal, requestedDateOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.formatSymbols;
				},
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$dateMatchScore(requestedDateOptions)),
					A2($elm$core$List$filterMap, $enkidatron$elm_cldr$Internal$Locale$toDateAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Internal$Locale$toTimeAvailableFormat = function (af) {
	switch (af.$) {
		case 'TimeAF':
			var format = af.a;
			return $elm$core$Maybe$Just(format);
		case 'DateTimeAF':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$findBestTimeFormat = F2(
	function (internal, requestedTimeOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.formatSymbols;
				},
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$timeMatchScore(requestedTimeOptions)),
					A2($elm$core$List$filterMap, $enkidatron$elm_cldr$Internal$Locale$toTimeAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$findAndCombineBestFormats = F3(
	function (internal, dateOptions, timeOptions) {
		return A3(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$combineBestFormats,
			internal,
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date(dateOptions)),
				A2($enkidatron$elm_cldr$Cldr$Format$DateTime$findBestDateFormat, internal, dateOptions)),
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$time(timeOptions)),
				A2($enkidatron$elm_cldr$Cldr$Format$DateTime$findBestTimeFormat, internal, timeOptions)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$useCombinedFormatsIfNecessary = F3(
	function (internal, requestedOptions, bestMatch) {
		var _v0 = _Utils_Tuple2(
			$enkidatron$elm_cldr$Internal$Options$splitOptions(requestedOptions),
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$fieldsDoNotMatch, requestedOptions, bestMatch.options));
		if ((_v0.a.$ === 'Just') && _v0.b) {
			var _v1 = _v0.a.a;
			var dateOptions = _v1.a;
			var timeOptions = _v1.b;
			return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$findAndCombineBestFormats, internal, dateOptions, timeOptions);
		} else {
			return A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
					$enkidatron$elm_cldr$Cldr$Format$DateTime$expandSymbol(requestedOptions)),
				bestMatch.formatSymbols);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsFromOptions = F2(
	function (internal, requestedOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($enkidatron$elm_cldr$Cldr$Format$DateTime$useCombinedFormatsIfNecessary, internal, requestedOptions),
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$dateTimeMatchScore(requestedOptions)),
					A2($elm$core$List$map, $enkidatron$elm_cldr$Internal$Locale$toDateTimeAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Internal$Options$toHourType = function (hour12ByDefault) {
	return hour12ByDefault ? $enkidatron$elm_cldr$Cldr$Format$Options$Hour12 : $enkidatron$elm_cldr$Cldr$Format$Options$Hour24;
};
var $enkidatron$elm_cldr$Internal$Options$setLocaleDefaultHourType = F2(
	function (hour12ByDefault, opts) {
		return _Utils_update(
			opts,
			{
				hour12: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						$enkidatron$elm_cldr$Internal$Options$toHourType(hour12ByDefault),
						opts.hour12))
			});
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsForType = F2(
	function (internal, formatType) {
		switch (formatType.$) {
			case 'DateOnly':
				var length = formatType.a;
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Date),
					A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateSymbols, length));
			case 'TimeOnly':
				var length = formatType.a;
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Time),
					A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.timeSymbols, length));
			case 'DateAndTime':
				var time = formatType.a.time;
				var date = formatType.a.date;
				return A2(
					$elm$core$List$concatMap,
					A2(
						$enkidatron$elm_cldr$Cldr$Format$DateTime$expandDateTimeTokenToFormatSymbols,
						A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateSymbols, date),
						A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.timeSymbols, time)),
					A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateTimeTokens, date));
			default:
				var options = formatType.a;
				return A2(
					$enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsFromOptions,
					internal,
					A2($enkidatron$elm_cldr$Internal$Options$setLocaleDefaultHourType, internal.hour12ByDefault, options));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$format = F2(
	function (formatType, _v0) {
		var internal = _v0.a;
		return A2(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$formatDateTime,
			internal,
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsForType, internal, formatType));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$WithOptions = function (a) {
	return {$: 'WithOptions', a: a};
};
var $author$project$ISO8601$Extra$addShortDate = function (options) {
	return _Utils_update(
		options,
		{
			day: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$Numeric),
			year: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$Numeric),
			month: $elm$core$Maybe$Just(
				$enkidatron$elm_cldr$Cldr$Format$Options$Number($enkidatron$elm_cldr$Cldr$Format$Options$Numeric))
		});
};
var $author$project$ISO8601$Extra$addShortTime = function (options) {
	return _Utils_update(
		options,
		{
			hour: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			hour12: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$Hour24),
			minute: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit)
		});
};
var $enkidatron$elm_cldr$Cldr$Format$Options$defaultDateTimeOptions = {day: $elm$core$Maybe$Nothing, era: $elm$core$Maybe$Nothing, hour: $elm$core$Maybe$Nothing, year: $elm$core$Maybe$Nothing, zone: $elm$core$Maybe$Nothing, month: $elm$core$Maybe$Nothing, hour12: $elm$core$Maybe$Nothing, minute: $elm$core$Maybe$Nothing, period: $elm$core$Maybe$Nothing, second: $elm$core$Maybe$Nothing, weekday: $elm$core$Maybe$Nothing, dayPeriod: $elm$core$Maybe$Nothing, fractionalSecondDigits: $elm$core$Maybe$Nothing};
var $author$project$ISO8601$Extra$toFormattedDateTime = F3(
	function (locale, browserZone, dto) {
		return A4(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$format,
			$enkidatron$elm_cldr$Cldr$Format$DateTime$WithOptions(
				$author$project$ISO8601$Extra$addShortTime(
					$author$project$ISO8601$Extra$addShortDate($enkidatron$elm_cldr$Cldr$Format$Options$defaultDateTimeOptions))),
			locale,
			browserZone,
			$jweir$elm_iso8601$ISO8601$toPosix(dto));
	});
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$FontAwesome$Internal$batteryIsolated = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'battery-isolated',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M9,18 C4.0295,18 0,13.9706 0,9 C0,4.0294 4.0295,0 9,0 C13.9706,0 18,4.0294 18,9 C18,13.9706 13.9706,18 9,18 Z M4.388,3.7105 L6.5983,6.6437 L10.1495,11.3563 L12.8134,14.8914 L13.612,14.2895 L11.4017,11.3563 L7.8505,6.6437 L5.1866,3.1086 Z M12.4284,5.6339 L8.353,5.633 L9.1145,6.6437 L12.4284,6.6437 C12.7596,6.6437 13.0518,6.9593 13.0518,7.317 L13.0518,10.683 C13.0518,10.9796 12.8725,11.2247 12.6356,11.3169 L13.242,12.1218 C13.688,11.8294 13.9868,11.301 13.9868,10.683 L13.9868,10.3464 C14.3179,10.3464 14.6101,10.0519 14.6101,9.6732 L14.6101,8.3268 C14.6101,7.9691 14.3179,7.6536 13.9868,7.6536 L13.9868,7.317 C13.9868,6.3913 13.2855,5.6339 12.4284,5.6339 Z M4.6254,5.6692 C3.9098,5.8286 3.3899,6.5086 3.3899,7.317 L3.3899,10.683 C3.3899,11.6297 4.0717,12.3661 4.9483,12.3661 L9.671,12.366 L8.9102,11.3563 L4.9483,11.3563 C4.5976,11.3563 4.3249,11.0617 4.3249,10.683 L4.3249,7.317 C4.3249,6.9593 4.5976,6.6437 4.9483,6.6437 L5.3596,6.6437 Z M6.12,7.653 L5.2599,7.6536 L5.2599,10.3464 L8.149,10.346 Z M12,7.6536 L9.875,7.653 L10.2972,8.2133 L11.9041,10.346 L12,10.3464 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$batteryIsolated = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$batteryIsolated);
var $author$project$FontAwesome$Internal$batteryConnected = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'battery-connected',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 9 18 C 13.9706 18 18 13.9706 18 9 C 18 4.0294 13.9706 0 9 0 C 4.0295 0 0 4.0294 0 9 C 0 13.9706 4.0295 18 9 18 Z M 12.4284 5.6339 C 13.2855 5.6339 13.9868 6.3913 13.9868 7.317 L 13.9868 7.6536 C 14.3179 7.6536 14.6101 7.9691 14.6101 8.3268 L 14.6101 9.6732 C 14.6101 10.0519 14.3179 10.3464 13.9868 10.3464 L 13.9868 10.683 C 13.9868 11.6297 13.2855 12.3661 12.4284 12.3661 L 4.9483 12.3661 C 4.0717 12.3661 3.3899 11.6297 3.3899 10.683 L 3.3899 7.317 C 3.3899 6.3913 4.0717 5.6339 4.9483 5.6339 L 12.4284 5.6339 z M 4.9483 6.6437 C 4.5976 6.6437 4.3249 6.9593 4.3249 7.317 L 4.3249 10.683 C 4.3249 11.0617 4.5976 11.3563 4.9483 11.3563 L 12.4284 11.3563 C 12.7596 11.3563 13.0518 11.0617 13.0518 10.683 L 13.0518 7.317 C 13.0518 6.9593 12.7596 6.6437 12.4284 6.6437 L 4.9483 6.6437 z M 5.2599 10.3464 L 5.2599 7.6536 L 12 7.6536 L 12 10.3464 L 5.2599 10.3464 z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$batteryConnected = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$batteryConnected);
var $author$project$Pages$Fleet_$batteryIsolationIcon = F2(
	function (isNeboAdmin, boat) {
		var icon = F3(
			function (label, colour, i) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$title(label)
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$view(
							A2(
								$lattyware$elm_fontawesome$FontAwesome$styled,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('mx-1'),
										$elm$svg$Svg$Attributes$style('color: ' + colour)
									]),
								i))
						]));
			});
		var _v0 = _Utils_Tuple2(isNeboAdmin, boat.batteryIsolated);
		if (_v0.a && (_v0.b.$ === 'Just')) {
			if (_v0.b.a) {
				return A3(icon, 'Battery isolated', 'var(--bs-orange)', $author$project$FontAwesome$Custom$batteryIsolated);
			} else {
				return A3(icon, 'Battery connected', 'var(--bs-blue)', $author$project$FontAwesome$Custom$batteryConnected);
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Fleet_$boatListItem = F5(
	function (isNeboAdmin, boat, unit, locale, tz) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group-item list-group-item-action py-3 lh-sm'),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Fleet_$SelectBoat(boat.boatId))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex w-100 align-items-center justify-content-between mb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(boat.name)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-light btn-sm btn-circle ms-2'),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Fleet_$SelectBoat(boat.boatId))
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow-1')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2($author$project$Pages$Fleet_$batteryIsolationIcon, isNeboAdmin, boat),
								A2(
									$elm$core$List$map,
									function (a) {
										return $lattyware$elm_fontawesome$FontAwesome$view(
											A2(
												$lattyware$elm_fontawesome$FontAwesome$styled,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('mx-1')
													]),
												$author$project$Data$AlertType$icon(a.type_)));
									},
									$author$project$Data$Boat$uniqueActiveAlerts(boat)))),
							A2($author$project$Pages$Fleet_$boatStatus, boat, unit)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('extra-small text-secondary')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Last update: '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-danger', boat.isOffline)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'never',
										A2(
											$elm$core$Maybe$map,
											A2($author$project$ISO8601$Extra$toFormattedDateTime, locale, tz),
											boat.lastUpdate)))
								]))
						]))
				]));
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$IntChunk = function (a) {
	return {$: 'IntChunk', a: a};
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$intToChunk = function (_int) {
	return $elm$core$Basics$isNaN(_int) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$mcordova47$elm_natural_ordering$NaturalOrdering$IntChunk(_int));
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$StringChunk = function (a) {
	return {$: 'StringChunk', a: a};
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$toChunk = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		$mcordova47$elm_natural_ordering$NaturalOrdering$StringChunk(str),
		A2(
			$elm$core$Maybe$andThen,
			$mcordova47$elm_natural_ordering$NaturalOrdering$intToChunk,
			$elm$core$String$toInt(str)));
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$chunkRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[0-9]+|[^0-9]+'));
var $mcordova47$elm_natural_ordering$NaturalOrdering$toChunks = function (str) {
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeL,
			$mcordova47$elm_natural_ordering$NaturalOrdering$toChunk,
			function ($) {
				return $.match;
			}),
		A2($elm$regex$Regex$find, $mcordova47$elm_natural_ordering$NaturalOrdering$chunkRegex, str));
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_chr('Ⓐ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ａ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('À'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Á'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Â'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ầ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ấ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẫ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẩ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ã'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ā'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ă'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ằ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ắ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẵ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẳ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ȧ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǡ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ä'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǟ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ả'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Å'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǻ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǎ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ȁ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ȃ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ạ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ậ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ặ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ḁ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ą'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ⱥ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ɐ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ꜳ'),
		'AA'),
		_Utils_Tuple2(
		_Utils_chr('Æ'),
		'AE'),
		_Utils_Tuple2(
		_Utils_chr('Ǽ'),
		'AE'),
		_Utils_Tuple2(
		_Utils_chr('Ǣ'),
		'AE'),
		_Utils_Tuple2(
		_Utils_chr('Ꜵ'),
		'AO'),
		_Utils_Tuple2(
		_Utils_chr('Ꜷ'),
		'AU'),
		_Utils_Tuple2(
		_Utils_chr('Ꜹ'),
		'AV'),
		_Utils_Tuple2(
		_Utils_chr('Ꜻ'),
		'AV'),
		_Utils_Tuple2(
		_Utils_chr('Ꜽ'),
		'AY'),
		_Utils_Tuple2(
		_Utils_chr('Ⓑ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ｂ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ḃ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ḅ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ḇ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ƀ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ƃ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ɓ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ⓒ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ｃ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ć'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ĉ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ċ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Č'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ç'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ḉ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ƈ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ȼ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ꜿ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ⓓ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ｄ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḋ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ď'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḍ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḑ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḓ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḏ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Đ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ƌ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ɗ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ɖ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ꝺ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ǳ'),
		'DZ'),
		_Utils_Tuple2(
		_Utils_chr('Ǆ'),
		'DZ'),
		_Utils_Tuple2(
		_Utils_chr('ǲ'),
		'Dz'),
		_Utils_Tuple2(
		_Utils_chr('ǅ'),
		'Dz'),
		_Utils_Tuple2(
		_Utils_chr('Ⓔ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ｅ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('È'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('É'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ê'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ề'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ế'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ễ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ể'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ẽ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ē'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḕ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḗ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ĕ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ė'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ë'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ẻ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ě'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ȅ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ȇ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ẹ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ệ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ȩ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḝ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ę'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḙ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḛ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ɛ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ǝ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ⓕ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ｆ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ḟ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ƒ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ꝼ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ⓖ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ｇ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ǵ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ĝ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ḡ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ğ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ġ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ǧ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ģ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ǥ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ɠ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ꞡ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ᵹ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ꝿ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ⓗ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ｈ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ĥ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḣ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḧ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ȟ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḥ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḩ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḫ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ħ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ⱨ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ⱶ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ɥ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ⓘ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ｉ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ì'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Í'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Î'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ĩ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ī'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ĭ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('İ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ï'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ḯ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ỉ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ǐ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ȉ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ȋ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ị'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Į'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ḭ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ɨ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ⓙ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ｊ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ĵ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ɉ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ⓚ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ｋ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ḱ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ǩ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ḳ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ķ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ḵ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ƙ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ⱪ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꝁ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꝃ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꝅ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꞣ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ⓛ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ｌ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ŀ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ĺ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ľ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḷ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḹ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ļ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḽ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḻ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ł'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ƚ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ɫ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ⱡ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ꝉ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ꝇ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ꞁ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ǉ'),
		'LJ'),
		_Utils_Tuple2(
		_Utils_chr('ǈ'),
		'Lj'),
		_Utils_Tuple2(
		_Utils_chr('Ⓜ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ｍ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ḿ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ṁ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ṃ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ɱ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ɯ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ⓝ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ｎ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ǹ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ń'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ñ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṅ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ň'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṇ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ņ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṋ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṉ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ƞ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ɲ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ꞑ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ꞥ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ǌ'),
		'NJ'),
		_Utils_Tuple2(
		_Utils_chr('ǋ'),
		'Nj'),
		_Utils_Tuple2(
		_Utils_chr('Ⓞ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ｏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ò'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ó'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ô'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ồ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ố'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ỗ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ổ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Õ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṍ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȭ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ō'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṑ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṓ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ŏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȯ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȱ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ö'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȫ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ỏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ő'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǒ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȍ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ơ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ờ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ớ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ỡ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ở'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ợ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ọ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ộ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǫ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǭ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ø'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǿ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ɔ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ɵ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ꝋ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ꝍ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ƣ'),
		'OI'),
		_Utils_Tuple2(
		_Utils_chr('Ꝏ'),
		'OO'),
		_Utils_Tuple2(
		_Utils_chr('Ȣ'),
		'OU'),
		_Utils_Tuple2(
		_Utils_chr(''),
		'OE'),
		_Utils_Tuple2(
		_Utils_chr('Œ'),
		'OE'),
		_Utils_Tuple2(
		_Utils_chr(''),
		'oe'),
		_Utils_Tuple2(
		_Utils_chr('œ'),
		'oe'),
		_Utils_Tuple2(
		_Utils_chr('Ⓟ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ｐ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ṕ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ṗ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ƥ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ᵽ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ꝑ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ꝓ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ꝕ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ⓠ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ｑ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ꝗ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ꝙ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ɋ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ⓡ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ｒ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ŕ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṙ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ř'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ȑ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ȓ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṛ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṝ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ŗ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṟ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ɍ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ɽ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ꝛ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ꞧ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ꞃ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ⓢ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ｓ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('ẞ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ś'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṥ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ŝ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṡ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Š'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṧ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṣ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṩ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ș'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ş'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ȿ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ꞩ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ꞅ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ⓣ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ｔ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṫ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ť'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṭ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ț'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ţ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṱ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṯ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ŧ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ƭ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ʈ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ⱦ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ꞇ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ꜩ'),
		'TZ'),
		_Utils_Tuple2(
		_Utils_chr('Ⓤ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ｕ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ù'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ú'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Û'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ũ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṹ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ū'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṻ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ŭ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ü'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǜ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǘ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǖ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǚ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ủ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ů'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ű'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǔ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ȕ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ȗ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ư'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ừ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ứ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ữ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ử'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ự'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ụ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṳ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ų'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṷ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṵ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ʉ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ⓥ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ｖ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ṽ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ṿ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ʋ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ꝟ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ʌ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ꝡ'),
		'VY'),
		_Utils_Tuple2(
		_Utils_chr('Ⓦ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ｗ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẁ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẃ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ŵ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẇ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẅ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẉ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ⱳ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ⓧ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ｘ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ẋ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ẍ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ⓨ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ｙ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỳ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ý'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ŷ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỹ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ȳ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ẏ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ÿ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỷ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỵ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ƴ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ɏ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỿ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ⓩ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ｚ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ź'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ẑ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ż'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ž'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ẓ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ẕ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ƶ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ȥ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ɀ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ⱬ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ꝣ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('ⓐ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ａ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẚ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('à'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('á'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('â'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ầ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ấ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẫ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẩ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ã'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ā'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ă'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ằ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ắ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẵ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẳ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ȧ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǡ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ä'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǟ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ả'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('å'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǻ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǎ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ȁ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ȃ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ạ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ậ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ặ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ḁ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ą'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ⱥ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ɐ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ꜳ'),
		'aa'),
		_Utils_Tuple2(
		_Utils_chr('æ'),
		'ae'),
		_Utils_Tuple2(
		_Utils_chr('ǽ'),
		'ae'),
		_Utils_Tuple2(
		_Utils_chr('ǣ'),
		'ae'),
		_Utils_Tuple2(
		_Utils_chr('ꜵ'),
		'ao'),
		_Utils_Tuple2(
		_Utils_chr('ꜷ'),
		'au'),
		_Utils_Tuple2(
		_Utils_chr('ꜹ'),
		'av'),
		_Utils_Tuple2(
		_Utils_chr('ꜻ'),
		'av'),
		_Utils_Tuple2(
		_Utils_chr('ꜽ'),
		'ay'),
		_Utils_Tuple2(
		_Utils_chr('ⓑ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ｂ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ḃ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ḅ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ḇ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ƀ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ƃ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ɓ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ⓒ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ｃ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ć'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ĉ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ċ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('č'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ç'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ḉ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ƈ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ȼ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ꜿ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ↄ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ⓓ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ｄ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḋ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ď'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḍ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḑ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḓ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḏ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('đ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ƌ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ɖ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ɗ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ꝺ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ǳ'),
		'dz'),
		_Utils_Tuple2(
		_Utils_chr('ǆ'),
		'dz'),
		_Utils_Tuple2(
		_Utils_chr('ⓔ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ｅ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('è'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('é'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ê'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ề'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ế'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ễ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ể'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ẽ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ē'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḕ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḗ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ĕ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ė'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ë'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ẻ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ě'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ȅ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ȇ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ẹ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ệ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ȩ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḝ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ę'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḙ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḛ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ɇ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ɛ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ǝ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ⓕ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ｆ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ḟ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ƒ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ꝼ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ⓖ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ｇ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ǵ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ĝ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ḡ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ğ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ġ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ǧ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ģ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ǥ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ɠ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ꞡ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ᵹ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ꝿ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ⓗ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ｈ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ĥ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḣ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḧ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ȟ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḥ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḩ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḫ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ẖ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ħ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ⱨ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ⱶ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ɥ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ƕ'),
		'hv'),
		_Utils_Tuple2(
		_Utils_chr('ⓘ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ｉ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ì'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('í'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('î'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ĩ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ī'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ĭ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ï'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ḯ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ỉ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ǐ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ȉ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ȋ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ị'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('į'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ḭ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ɨ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ı'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ⓙ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ｊ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ĵ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ǰ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ɉ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ⓚ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ｋ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ḱ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ǩ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ḳ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ķ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ḵ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ƙ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ⱪ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꝁ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꝃ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꝅ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꞣ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ⓛ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ｌ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ŀ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ĺ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ľ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḷ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḹ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ļ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḽ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḻ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ſ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ł'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ƚ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ɫ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ⱡ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ꝉ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ꞁ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ꝇ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ǉ'),
		'lj'),
		_Utils_Tuple2(
		_Utils_chr('ⓜ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ｍ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ḿ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ṁ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ṃ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ɱ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ɯ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ⓝ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ｎ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ǹ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ń'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ñ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṅ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ň'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṇ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ņ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṋ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṉ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ƞ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ɲ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ŉ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ꞑ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ꞥ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ǌ'),
		'nj'),
		_Utils_Tuple2(
		_Utils_chr('ⓞ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ｏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ò'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ó'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ô'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ồ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ố'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ỗ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ổ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('õ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṍ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȭ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ō'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṑ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṓ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ŏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȯ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȱ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ö'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȫ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ỏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ő'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǒ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȍ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ơ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ờ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ớ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ỡ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ở'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ợ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ọ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ộ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǫ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǭ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ø'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǿ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ɔ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ꝋ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ꝍ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ɵ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ƣ'),
		'oi'),
		_Utils_Tuple2(
		_Utils_chr('ȣ'),
		'ou'),
		_Utils_Tuple2(
		_Utils_chr('ꝏ'),
		'oo'),
		_Utils_Tuple2(
		_Utils_chr('ⓟ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ｐ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ṕ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ṗ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ƥ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ᵽ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ꝑ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ꝓ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ꝕ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ⓠ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ｑ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ɋ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ꝗ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ꝙ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ⓡ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ｒ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ŕ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṙ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ř'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ȑ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ȓ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṛ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṝ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ŗ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṟ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ɍ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ɽ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ꝛ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ꞧ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ꞃ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ⓢ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ｓ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ß'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ś'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṥ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ŝ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṡ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('š'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṧ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṣ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṩ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ș'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ş'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ȿ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ꞩ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ꞅ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ẛ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ⓣ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ｔ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṫ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ẗ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ť'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṭ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ț'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ţ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṱ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṯ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ŧ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ƭ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ʈ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ⱦ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ꞇ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ꜩ'),
		'tz'),
		_Utils_Tuple2(
		_Utils_chr('ⓤ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ｕ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ù'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ú'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('û'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ũ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṹ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ū'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṻ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ŭ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ü'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǜ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǘ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǖ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǚ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ủ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ů'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ű'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǔ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ȕ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ȗ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ư'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ừ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ứ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ữ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ử'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ự'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ụ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṳ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ų'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṷ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṵ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ʉ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ⓥ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ｖ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ṽ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ṿ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ʋ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ꝟ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ʌ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ꝡ'),
		'vy'),
		_Utils_Tuple2(
		_Utils_chr('ⓦ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ｗ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẁ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẃ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ŵ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẇ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẅ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẘ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẉ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ⱳ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ⓧ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ｘ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ẋ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ẍ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ⓨ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ｙ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỳ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ý'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ŷ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỹ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ȳ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ẏ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ÿ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỷ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ẙ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỵ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ƴ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ɏ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỿ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ⓩ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ｚ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ź'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ẑ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ż'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ž'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ẓ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ẕ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ƶ'),
		'z')
	]);
var $kuon$elm_string_normalize$String$Normalize$Diacritics$minCode = A2(
	$elm$core$Maybe$withDefault,
	0,
	$elm$core$List$minimum(
		A2(
			$elm$core$List$map,
			$elm$core$Char$toCode,
			A2($elm$core$List$map, $elm$core$Tuple$first, $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList))));
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $kuon$elm_string_normalize$String$Normalize$Diacritics$maxUnicode = 1114111;
var $kuon$elm_string_normalize$String$Normalize$Diacritics$maxCode = A2(
	$elm$core$Maybe$withDefault,
	$kuon$elm_string_normalize$String$Normalize$Diacritics$maxUnicode,
	$elm$core$List$maximum(
		A2(
			$elm$core$List$map,
			$elm$core$Char$toCode,
			A2($elm$core$List$map, $elm$core$Tuple$first, $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList))));
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupTable = $elm$core$Dict$fromList($kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList);
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupArray = $elm$core$Array$fromList(
	A2(
		$elm$core$List$map,
		function (i) {
			var _v0 = A2(
				$elm$core$Dict$get,
				$elm$core$Char$fromCode(i),
				$kuon$elm_string_normalize$String$Normalize$Diacritics$lookupTable);
			if (_v0.$ === 'Nothing') {
				return $elm$core$String$fromChar(
					$elm$core$Char$fromCode(i));
			} else {
				var str = _v0.a;
				return str;
			}
		},
		A2($elm$core$List$range, 0, $kuon$elm_string_normalize$String$Normalize$Diacritics$maxCode)));
var $kuon$elm_string_normalize$String$Normalize$removeDiacritics = function (str) {
	var replace = F2(
		function (c, result) {
			if (_Utils_cmp(
				$elm$core$Char$toCode(c),
				$kuon$elm_string_normalize$String$Normalize$Diacritics$minCode) < 0) {
				return _Utils_ap(
					result,
					$elm$core$String$fromChar(c));
			} else {
				var _v0 = A2(
					$elm$core$Array$get,
					$elm$core$Char$toCode(c),
					$kuon$elm_string_normalize$String$Normalize$Diacritics$lookupArray);
				if (_v0.$ === 'Just') {
					var candidate = _v0.a;
					return _Utils_ap(result, candidate);
				} else {
					return _Utils_ap(
						result,
						$elm$core$String$fromChar(c));
				}
			}
		});
	return A3($elm$core$String$foldl, replace, '', str);
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$toComparableString = A2($elm$core$Basics$composeL, $elm$core$String$toLower, $kuon$elm_string_normalize$String$Normalize$removeDiacritics);
var $mcordova47$elm_natural_ordering$NaturalOrdering$compareChunks = F2(
	function (chunk1, chunk2) {
		var _v0 = _Utils_Tuple2(chunk1, chunk2);
		if (_v0.a.$ === 'StringChunk') {
			if (_v0.b.$ === 'StringChunk') {
				var str1 = _v0.a.a;
				var str2 = _v0.b.a;
				return A2(
					$elm$core$Basics$compare,
					$mcordova47$elm_natural_ordering$NaturalOrdering$toComparableString(str1),
					$mcordova47$elm_natural_ordering$NaturalOrdering$toComparableString(str2));
			} else {
				return $elm$core$Basics$GT;
			}
		} else {
			if (_v0.b.$ === 'StringChunk') {
				return $elm$core$Basics$LT;
			} else {
				var int1 = _v0.a.a;
				var int2 = _v0.b.a;
				return A2($elm$core$Basics$compare, int1, int2);
			}
		}
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$compareChunkLists = F2(
	function (chunkList1, chunkList2) {
		compareChunkLists:
		while (true) {
			var _v0 = _Utils_Tuple2(chunkList1, chunkList2);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return $elm$core$Basics$EQ;
				} else {
					var _v1 = _v0.b;
					return $elm$core$Basics$LT;
				}
			} else {
				if (!_v0.b.b) {
					var _v2 = _v0.a;
					return $elm$core$Basics$GT;
				} else {
					var _v3 = _v0.a;
					var chunk1 = _v3.a;
					var chunks1 = _v3.b;
					var _v4 = _v0.b;
					var chunk2 = _v4.a;
					var chunks2 = _v4.b;
					var _v5 = A2($mcordova47$elm_natural_ordering$NaturalOrdering$compareChunks, chunk1, chunk2);
					if (_v5.$ === 'EQ') {
						var $temp$chunkList1 = chunks1,
							$temp$chunkList2 = chunks2;
						chunkList1 = $temp$chunkList1;
						chunkList2 = $temp$chunkList2;
						continue compareChunkLists;
					} else {
						var ord = _v5;
						return ord;
					}
				}
			}
		}
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$compareOn = F3(
	function (f, x, y) {
		return A2(
			$mcordova47$elm_natural_ordering$NaturalOrdering$compareChunkLists,
			$mcordova47$elm_natural_ordering$NaturalOrdering$toChunks(
				f(x)),
			$mcordova47$elm_natural_ordering$NaturalOrdering$toChunks(
				f(y)));
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$compare = $mcordova47$elm_natural_ordering$NaturalOrdering$compareOn($elm$core$Basics$identity);
var $author$project$Data$Boat$sort = $elm$core$List$sortWith(
	F2(
		function (b1, b2) {
			return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, b1.name, b2.name);
		}));
var $author$project$Data$Boat$hasAlerts = function (boat) {
	return !$elm$core$List$isEmpty(boat.activeAlerts);
};
var $author$project$Pages$Fleet_$alertsRank = function (boat) {
	return $author$project$Data$Boat$hasAlerts(boat) ? 0 : 1;
};
var $author$project$Pages$Fleet_$statusRank = function (boat) {
	if (boat.isOffline) {
		return 2;
	} else {
		var _v0 = boat.status;
		if (_v0.$ === 'Underway') {
			return 0;
		} else {
			return 1;
		}
	}
};
var $author$project$Pages$Fleet_$lastUpdateMillis = function (boat) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $jweir$elm_iso8601$ISO8601$toPosix, $elm$time$Time$posixToMillis),
			boat.lastUpdate));
};
var $author$project$Pages$Fleet_$visibleBoats = F3(
	function (search, sortOption, boats) {
		var needle = $elm$core$String$toLower(
			$elm$core$String$trim(search));
		var filtered = $elm$core$String$isEmpty(needle) ? boats : A2(
			$elm$core$List$filter,
			function (b) {
				return A2(
					$elm$core$String$contains,
					needle,
					$elm$core$String$toLower(b.name));
			},
			boats);
		var byName = $author$project$Data$Boat$sort(filtered);
		switch (sortOption.$) {
			case 'SortByName':
				return byName;
			case 'SortByStatus':
				return A2($elm$core$List$sortBy, $author$project$Pages$Fleet_$statusRank, byName);
			case 'SortByAlerts':
				return A2($elm$core$List$sortBy, $author$project$Pages$Fleet_$alertsRank, byName);
			default:
				return A2(
					$elm$core$List$sortBy,
					A2($elm$core$Basics$composeR, $author$project$Pages$Fleet_$lastUpdateMillis, $elm$core$Basics$negate),
					byName);
		}
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Pages$Fleet_$SelectBoatSort = function (a) {
	return {$: 'SelectBoatSort', a: a};
};
var $author$project$Pages$Fleet_$SortByAlerts = {$: 'SortByAlerts'};
var $author$project$Pages$Fleet_$SortByStatus = {$: 'SortByStatus'};
var $author$project$Pages$Fleet_$SortByLastUpdate = {$: 'SortByLastUpdate'};
var $author$project$Pages$Fleet_$boatSortOptions = _List_fromArray(
	[
		_Utils_Tuple2($author$project$Pages$Fleet_$SortByName, 'Name'),
		_Utils_Tuple2($author$project$Pages$Fleet_$SortByStatus, 'Status'),
		_Utils_Tuple2($author$project$Pages$Fleet_$SortByAlerts, 'Alerts first'),
		_Utils_Tuple2($author$project$Pages$Fleet_$SortByLastUpdate, 'Last update')
	]);
var $author$project$Pages$Fleet_$UpdateBoatSearch = function (a) {
	return {$: 'UpdateBoatSearch', a: a};
};
var $author$project$Pages$Fleet_$boatSortToString = function (s) {
	switch (s.$) {
		case 'SortByName':
			return 'name';
		case 'SortByStatus':
			return 'status';
		case 'SortByAlerts':
			return 'alerts';
		default:
			return 'lastUpdate';
	}
};
var $author$project$Pages$Fleet_$boatSortFromString = function (s) {
	switch (s) {
		case 'name':
			return $elm$core$Maybe$Just($author$project$Pages$Fleet_$SortByName);
		case 'status':
			return $elm$core$Maybe$Just($author$project$Pages$Fleet_$SortByStatus);
		case 'alerts':
			return $elm$core$Maybe$Just($author$project$Pages$Fleet_$SortByAlerts);
		case 'lastUpdate':
			return $elm$core$Maybe$Just($author$project$Pages$Fleet_$SortByLastUpdate);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Fleet_$boatListToolbar = F2(
	function (search, sortOption) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-3 pb-2 d-flex gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('form-control form-control-sm'),
							$elm$html$Html$Attributes$placeholder('Search vessels…'),
							$elm$html$Html$Attributes$value(search),
							$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$UpdateBoatSearch)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('input-group input-group-sm'),
							A2($elm$html$Html$Attributes$style, 'width', 'auto'),
							A2($elm$html$Html$Attributes$style, 'flex-shrink', '0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('input-group-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sort by')
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-select'),
									$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										$author$project$Pages$Fleet_$boatSortFromString,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$map($author$project$Pages$Fleet_$SelectBoatSort),
											$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$NoOp))))
								]),
							A2(
								$elm$core$List$map,
								function (_v0) {
									var option_ = _v0.a;
									var label_ = _v0.b;
									return A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(
												$author$project$Pages$Fleet_$boatSortToString(option_)),
												$elm$html$Html$Attributes$selected(
												_Utils_eq(sortOption, option_))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(label_)
											]));
								},
								$author$project$Pages$Fleet_$boatSortOptions))
						]))
				]));
	});
var $author$project$Pages$Fleet_$boatList = F9(
	function (isNeboAdmin, fleet, boats, boatsLoaded, search, sortOption, unit, locale, tz) {
		var shown = A3($author$project$Pages$Fleet_$visibleBoats, search, sortOption, boats);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page flex-column align-items-stretch flex-shrink-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-3 d-none d-md-block')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(fleet.name)
						])),
					A2($author$project$Pages$Fleet_$boatListToolbar, search, sortOption),
					(!boatsLoaded) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-4 text-center')
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$view(
							A2(
								$lattyware$elm_fontawesome$FontAwesome$styled,
								_List_fromArray(
									[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin, $lattyware$elm_fontawesome$FontAwesome$Attributes$fa2x1]),
								$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch))
						])) : ($elm$core$List$isEmpty(shown) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-secondary text-center p-4 small')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$isEmpty(
								$elm$core$String$trim(search)) ? 'No vessels in this fleet yet.' : 'No vessels match your search.')
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group list-group-flush border-bottom scrollarea')
						]),
					A2(
						$elm$core$List$map,
						function (b) {
							return A5($author$project$Pages$Fleet_$boatListItem, isNeboAdmin, b, unit, locale, tz);
						},
						shown)))
				]));
	});
var $author$project$Data$TrackDuration$all = _List_fromArray(
	[$author$project$Data$TrackDuration$LastTripToday, $author$project$Data$TrackDuration$LastHour, $author$project$Data$TrackDuration$Last24Hours, $author$project$Data$TrackDuration$Last7Days, $author$project$Data$TrackDuration$Last14Days, $author$project$Data$TrackDuration$Last30Days]);
var $author$project$FeatureDrop$State$isNew = F2(
	function (sidebarKey, state) {
		return A2(
			$elm$core$List$any,
			function (feature) {
				return _Utils_eq(
					feature.sidebarKey,
					$elm$core$Maybe$Just(sidebarKey));
			},
			state.newFeatures);
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $jweir$elm_iso8601$ISO8601$fmt = function (n) {
	return (n < 10) ? ('0' + $elm$core$String$fromInt(n)) : $elm$core$String$fromInt(n);
};
var $jweir$elm_iso8601$ISO8601$fmtMs = function (n) {
	return (!n) ? '' : ((n < 10) ? ('.00' + $elm$core$String$fromInt(n)) : ((n < 100) ? ('.0' + $elm$core$String$fromInt(n)) : ('.' + $elm$core$String$fromInt(n))));
};
var $jweir$elm_iso8601$ISO8601$fmtYear = function (n) {
	var s = $elm$core$String$fromInt(n);
	return (n < 10) ? ('000' + s) : ((n < 100) ? ('00' + s) : ((n < 1000) ? ('0' + s) : s));
};
var $jweir$elm_iso8601$ISO8601$fmtOffset = function (minutes) {
	if (!minutes) {
		return 'Z';
	} else {
		var symbol = (minutes >= 0) ? '+' : '-';
		var m = $elm$core$Basics$abs(minutes % 60);
		var h = (minutes / 60) | 0;
		return _Utils_ap(
			symbol,
			_Utils_ap(
				$jweir$elm_iso8601$ISO8601$fmt(
					$elm$core$Basics$abs(h)),
				$jweir$elm_iso8601$ISO8601$fmt(m)));
	}
};
var $jweir$elm_iso8601$ISO8601$toString = function (time) {
	return A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				$jweir$elm_iso8601$ISO8601$fmtYear(time.year),
				'-',
				$jweir$elm_iso8601$ISO8601$fmt(time.month),
				'-',
				$jweir$elm_iso8601$ISO8601$fmt(time.day),
				'T',
				$jweir$elm_iso8601$ISO8601$fmt(time.hour),
				':',
				$jweir$elm_iso8601$ISO8601$fmt(time.minute),
				':',
				$jweir$elm_iso8601$ISO8601$fmt(time.second),
				$jweir$elm_iso8601$ISO8601$fmtMs(time.millisecond),
				$jweir$elm_iso8601$ISO8601$fmtOffset(time.offset)
			]));
};
var $author$project$Data$TrackDuration$toString = function (r) {
	switch (r.$) {
		case 'LastTripToday':
			return 'last';
		case 'LastHour':
			return 'hour';
		case 'Last24Hours':
			return 'day';
		case 'Last7Days':
			return 'week';
		case 'Last14Days':
			return 'fortnight';
		default:
			return 'month';
	}
};
var $jweir$elm_iso8601$ISO8601$Extras$After = {$: 'After'};
var $jweir$elm_iso8601$ISO8601$Extras$Before = {$: 'Before'};
var $jweir$elm_iso8601$ISO8601$Extras$daysToYears = F3(
	function (rel, startYear, remainingDays) {
		daysToYears:
		while (true) {
			if (rel.$ === 'After') {
				var remainingDays_ = remainingDays - $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear);
				if (remainingDays_ > 0) {
					var $temp$rel = $jweir$elm_iso8601$ISO8601$Extras$After,
						$temp$startYear = startYear + 1,
						$temp$remainingDays = remainingDays_;
					rel = $temp$rel;
					startYear = $temp$startYear;
					remainingDays = $temp$remainingDays;
					continue daysToYears;
				} else {
					if (!remainingDays_) {
						return _Utils_Tuple2(startYear + 1, 0);
					} else {
						return _Utils_Tuple2(startYear, remainingDays);
					}
				}
			} else {
				var remainingDays_ = remainingDays + $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear);
				if (remainingDays_ < 0) {
					var $temp$rel = $jweir$elm_iso8601$ISO8601$Extras$Before,
						$temp$startYear = startYear - 1,
						$temp$remainingDays = remainingDays_;
					rel = $temp$rel;
					startYear = $temp$startYear;
					remainingDays = $temp$remainingDays;
					continue daysToYears;
				} else {
					return _Utils_Tuple2(
						startYear,
						$jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear) + remainingDays);
				}
			}
		}
	});
var $jweir$elm_iso8601$ISO8601$defaultTime = {day: 1, hour: 0, year: 0, month: 1, minute: 0, offset: 0, second: 0, millisecond: 0};
var $jweir$elm_iso8601$ISO8601$Extras$daysToMonths = F3(
	function (year, startMonth, remainingDays) {
		daysToMonths:
		while (true) {
			var remainingDays_ = remainingDays - A2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth, year, startMonth);
			if (remainingDays_ > 0) {
				var $temp$year = year,
					$temp$startMonth = startMonth + 1,
					$temp$remainingDays = remainingDays_;
				year = $temp$year;
				startMonth = $temp$startMonth;
				remainingDays = $temp$remainingDays;
				continue daysToMonths;
			} else {
				return _Utils_Tuple2(startMonth, remainingDays);
			}
		}
	});
var $jweir$elm_iso8601$ISO8601$fromTime = function (msFloat) {
	var ms = msFloat;
	var milliseconds = A2($elm$core$Basics$modBy, $jweir$elm_iso8601$ISO8601$isec, ms);
	var v = (ms >= 0) ? $jweir$elm_iso8601$ISO8601$Extras$After : $jweir$elm_iso8601$ISO8601$Extras$Before;
	if (v.$ === 'After') {
		var seconds = A2(
			$elm$core$Basics$modBy,
			60,
			$elm$core$Basics$floor(ms / $jweir$elm_iso8601$ISO8601$isec));
		var minutes = A2($elm$core$Basics$modBy, 60, (ms / $jweir$elm_iso8601$ISO8601$imin) | 0);
		var hours = A2($elm$core$Basics$modBy, 24, (ms / $jweir$elm_iso8601$ISO8601$ihour) | 0);
		var days = (ms / $jweir$elm_iso8601$ISO8601$iday) | 0;
		var _v1 = A3($jweir$elm_iso8601$ISO8601$Extras$daysToYears, $jweir$elm_iso8601$ISO8601$Extras$After, 1970, days);
		var years = _v1.a;
		var remainingDays = _v1.b;
		var _v2 = A3($jweir$elm_iso8601$ISO8601$Extras$daysToMonths, years, 1, remainingDays + 1);
		var months = _v2.a;
		var daysInMonth = _v2.b;
		return _Utils_update(
			$jweir$elm_iso8601$ISO8601$defaultTime,
			{day: daysInMonth, hour: hours, year: years, month: months, minute: minutes, second: seconds, millisecond: milliseconds});
	} else {
		var totalDays = (ms / $jweir$elm_iso8601$ISO8601$iday) | 0;
		var rem = A2($elm$core$Basics$modBy, $jweir$elm_iso8601$ISO8601$iday, ms);
		var hours = A2($elm$core$Basics$modBy, 24, (rem / $jweir$elm_iso8601$ISO8601$ihour) | 0);
		var minutes = A2($elm$core$Basics$modBy, 60, (rem / $jweir$elm_iso8601$ISO8601$imin) | 0);
		var seconds = A2($elm$core$Basics$modBy, 60, (rem / $jweir$elm_iso8601$ISO8601$isec) | 0);
		var _v3 = (!rem) ? A3($jweir$elm_iso8601$ISO8601$Extras$daysToYears, $jweir$elm_iso8601$ISO8601$Extras$Before, 1969, totalDays + 1) : A3($jweir$elm_iso8601$ISO8601$Extras$daysToYears, $jweir$elm_iso8601$ISO8601$Extras$Before, 1969, totalDays);
		var years = _v3.a;
		var remainingDays = _v3.b;
		var _v4 = A3($jweir$elm_iso8601$ISO8601$Extras$daysToMonths, years, 1, remainingDays);
		var months = _v4.a;
		var daysInMonth = _v4.b;
		return _Utils_update(
			$jweir$elm_iso8601$ISO8601$defaultTime,
			{day: daysInMonth, hour: hours, year: years, month: months, minute: minutes, second: seconds, millisecond: milliseconds});
	}
};
var $jweir$elm_iso8601$ISO8601$fromPosix = function (posix) {
	return $jweir$elm_iso8601$ISO8601$fromTime(
		$elm$time$Time$posixToMillis(posix));
};
var $justinmimbs$time_extra$Time$Extra$Day = {$: 'Day'};
var $justinmimbs$date$Date$Months = {$: 'Months'};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0.a;
		switch (unit.$) {
			case 'Years':
				return A3(
					$justinmimbs$date$Date$add,
					$justinmimbs$date$Date$Months,
					12 * n,
					$justinmimbs$date$Date$RD(rd));
			case 'Months':
				var date = $justinmimbs$date$Date$toCalendarDate(
					$justinmimbs$date$Date$RD(rd));
				var wholeMonths = ((12 * (date.year - 1)) + ($justinmimbs$date$Date$monthToNumber(date.month) - 1)) + n;
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				return $justinmimbs$date$Date$RD(
					($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
						$elm$core$Basics$min,
						date.day,
						A2($justinmimbs$date$Date$daysInMonth, y, m)));
			case 'Weeks':
				return $justinmimbs$date$Date$RD(rd + (7 * n));
			default:
				return $justinmimbs$date$Date$RD(rd + n);
		}
	});
var $justinmimbs$date$Date$Days = {$: 'Days'};
var $justinmimbs$time_extra$Time$Extra$Month = {$: 'Month'};
var $justinmimbs$time_extra$Time$Extra$Millisecond = {$: 'Millisecond'};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		var millis = $elm$time$Time$posixToMillis(posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval.$) {
				case 'Millisecond':
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 'Second':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Millisecond,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Minute':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Millisecond,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Hour':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Millisecond,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Day':
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							$justinmimbs$date$Date$Days,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 'Month':
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							$justinmimbs$date$Date$Months,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 'Year':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Month,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Quarter':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Month,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Week':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Day,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Day,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$Hour = {$: 'Hour'};
var $justinmimbs$date$Date$Day = {$: 'Day'};
var $justinmimbs$date$Date$Week = {$: 'Week'};
var $justinmimbs$date$Date$Year = {$: 'Year'};
var $justinmimbs$date$Date$Month = {$: 'Month'};
var $justinmimbs$date$Date$Friday = {$: 'Friday'};
var $justinmimbs$date$Date$Monday = {$: 'Monday'};
var $justinmimbs$date$Date$Sunday = {$: 'Sunday'};
var $justinmimbs$date$Date$Quarter = {$: 'Quarter'};
var $justinmimbs$date$Date$Tuesday = {$: 'Tuesday'};
var $justinmimbs$date$Date$Saturday = {$: 'Saturday'};
var $justinmimbs$date$Date$Thursday = {$: 'Thursday'};
var $justinmimbs$date$Date$Wednesday = {$: 'Wednesday'};
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1);
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date.a;
		switch (interval.$) {
			case 'Year':
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 'Quarter':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 'Month':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 'Week':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Monday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Tuesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Tue, date));
			case 'Wednesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Wed, date));
			case 'Thursday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Thu, date));
			case 'Friday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Fri, date));
			case 'Saturday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sat, date));
			case 'Sunday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sun, date));
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval.$) {
			case 'Millisecond':
				return posix;
			case 'Second':
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 'Minute':
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 'Hour':
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 'Day':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Day, zone, posix);
			case 'Month':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Month, zone, posix);
			case 'Year':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Year, zone, posix);
			case 'Quarter':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Quarter, zone, posix);
			case 'Week':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Week, zone, posix);
			case 'Monday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Monday, zone, posix);
			case 'Tuesday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Tuesday, zone, posix);
			case 'Wednesday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Wednesday, zone, posix);
			case 'Thursday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Thursday, zone, posix);
			case 'Friday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Friday, zone, posix);
			case 'Saturday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Saturday, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Sunday, zone, posix);
		}
	});
var $author$project$Data$TrackDuration$toStartEnd = F3(
	function (now, zone, r) {
		switch (r.$) {
			case 'LastTripToday':
				return _Utils_Tuple2(
					A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, zone, now),
					now);
			case 'LastHour':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, -1, zone, now),
					now);
			case 'Last24Hours':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, -24, zone, now),
					now);
			case 'Last7Days':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Day, -7, zone, now),
					now);
			case 'Last14Days':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Day, -14, zone, now),
					now);
			default:
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Day, -30, zone, now),
					now);
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$chevronLeft = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'chevron-left',
	_Utils_Tuple2(320, 512),
	_Utils_Tuple2('M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$chevronLeft);
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$locationDot = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'location-dot',
	_Utils_Tuple2(384, 512),
	_Utils_Tuple2('M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$locationDot = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$locationDot);
var $author$project$Pages$Fleet_$DeselectBoat = {$: 'DeselectBoat'};
var $author$project$Data$Boat$boatIdToString = function (_v0) {
	var boatId = _v0.a;
	return boatId;
};
var $author$project$Data$TrackDuration$toDisplayString = function (r) {
	switch (r.$) {
		case 'LastTripToday':
			return 'Last Trip Today';
		case 'LastHour':
			return 'One Hour';
		case 'Last24Hours':
			return '24 Hours';
		case 'Last7Days':
			return '7 Days';
		case 'Last14Days':
			return '14 Days';
		default:
			return '30 Days';
	}
};
var $author$project$Pages$Fleet_$SelectTrackDuration = function (a) {
	return {$: 'SelectTrackDuration', a: a};
};
var $author$project$Geospatial$LatLong$roundToPlaces = F2(
	function (n, f) {
		var exp = A2($elm$core$Basics$pow, 10.0, n);
		return $elm$core$Basics$round(f * exp) / exp;
	});
var $author$project$Geospatial$LatLong$decimalMinutesString = function (latLong) {
	var _v0 = _Utils_Tuple2(latLong.lat | 0, latLong._long | 0);
	var latDegrees = _v0.a;
	var longDegrees = _v0.b;
	var longDirection = (latLong._long < 0.0) ? 'W' : 'E';
	var latDirection = (latLong.lat < 0.0) ? 'S' : 'N';
	var longMinutes = A2(
		$author$project$Geospatial$LatLong$roundToPlaces,
		3,
		$elm$core$Basics$abs((latLong._long - longDegrees) * 60.0));
	var latMinutes = A2(
		$author$project$Geospatial$LatLong$roundToPlaces,
		3,
		$elm$core$Basics$abs((latLong.lat - latDegrees) * 60.0));
	return $elm$core$String$fromInt(
		$elm$core$Basics$abs(latDegrees)) + ('° ' + ($elm$core$String$fromFloat(latMinutes) + ('\u0027 ' + (latDirection + (', ' + ($elm$core$String$fromInt(
		$elm$core$Basics$abs(longDegrees)) + ('° ' + ($elm$core$String$fromFloat(longMinutes) + ('\u0027 ' + longDirection)))))))));
};
var $author$project$Data$Boat$trackerIdToDisplayString = function (t) {
	switch (t.$) {
		case 'DMT':
			var i = t.a;
			return 'DMT (' + ($elm$core$String$fromInt(i) + ')');
		case 'Sensar':
			var i = t.a;
			return 'Sensar (' + (i + ')');
		default:
			var i = t.a;
			return 'LAD (' + ($elm$core$String$fromInt(i) + ')');
	}
};
var $author$project$Gen$Route$Fleet___Boats__BoatId___Logs = function (a) {
	return {$: 'Fleet___Boats__BoatId___Logs', a: a};
};
var $author$project$Data$Boat$positionAccuracyDisplayString = function (acc) {
	return (acc <= 5) ? 'Great' : ((acc <= 7) ? 'OK' : 'Poor');
};
var $author$project$Data$Boat$gsmSignalStrengthDisplayString = function (strength) {
	return (strength === 99) ? 'Unknown' : ((strength <= 11) ? 'Poor' : ((strength <= 15) ? 'OK' : 'Great'));
};
var $author$project$Pages$Fleet_$boatDetail = F9(
	function (isNeboAdmin, fleet, boat, unit, currentTime, locale, tz, trackDuration, featureDropState) {
		var specificRows = function () {
			var _v2 = boat.trackerId;
			if (_v2.$ === 'Just') {
				switch (_v2.a.$) {
					case 'DMT':
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Battery Voltage')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2(
														$elm$core$Maybe$map,
														function (v) {
															return A2($myrho$elm_round$Round$round, 1, v) + 'v';
														},
														boat.batteryVoltage)))
											]))
									])),
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('External Voltage')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2(
														$elm$core$Maybe$map,
														function (v) {
															return A2($myrho$elm_round$Round$round, 1, v) + 'v';
														},
														boat.externalVoltage)))
											]))
									])),
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cell Signal Strength')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2($elm$core$Maybe$map, $author$project$Data$Boat$gsmSignalStrengthDisplayString, boat.gsmSignalStrength)))
											]))
									])),
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Position Accuracy')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2($elm$core$Maybe$map, $author$project$Data$Boat$positionAccuracyDisplayString, boat.positionAccuracy)))
											]))
									]))
							]);
					case 'Sensar':
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('External Voltage')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2(
														$elm$core$Maybe$map,
														function (v) {
															return A2($myrho$elm_round$Round$round, 1, v) + 'v';
														},
														boat.externalVoltage)))
											]))
									]))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('External Voltage')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2(
														$elm$core$Maybe$map,
														function (v) {
															return A2($myrho$elm_round$Round$round, 1, v) + 'v';
														},
														boat.externalVoltage)))
											]))
									])),
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Radio')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '-', boat.radio))
											]))
									])),
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Bars')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'-',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, boat.gsmSignalStrength)))
											]))
									]))
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var headerRows = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-light btn-sm btn-circle me-2'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$DeselectBoat)
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small fw-medium')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex w-100 align-items-center justify-content-between mb-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(boat.name)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-1')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2($author$project$Pages$Fleet_$batteryIsolationIcon, isNeboAdmin, boat),
							A2(
								$elm$core$List$map,
								function (a) {
									return $lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('mx-1')
												]),
											$author$project$Data$AlertType$icon(a.type_)));
								},
								$author$project$Data$Boat$uniqueActiveAlerts(boat)))),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fw-semibold')
							]),
						_List_fromArray(
							[
								A2($author$project$Pages$Fleet_$boatStatus, boat, unit)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-secondary')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Updated: ')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('fw-semibold', true),
										_Utils_Tuple2('text-danger', boat.isOffline)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'never',
									A2(
										$elm$core$Maybe$map,
										A2($author$project$ISO8601$Extra$toFormattedDateTime, locale, tz),
										boat.lastUpdate)))
							]))
					])),
				A2(
				$elm$html$Html$hr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-3')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small')
					]),
				_List_fromArray(
					[
						$lattyware$elm_fontawesome$FontAwesome$view(
						A2(
							$lattyware$elm_fontawesome$FontAwesome$styled,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('me-3 text-success')
								]),
							$lattyware$elm_fontawesome$FontAwesome$Solid$locationDot)),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'Unknown',
									A2($elm$core$Maybe$map, $author$project$Geospatial$LatLong$decimalMinutesString, boat.latLong)))
							]))
					])),
				A2(
				$elm$html$Html$hr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-3')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-secondary')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('nebolink Serial #')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'not set',
									A2($elm$core$Maybe$map, $author$project$Data$Boat$trackerIdToDisplayString, boat.trackerId)))
							]))
					]))
			]);
		var footerRows = function () {
			var _v0 = A3(
				$elm$core$Tuple$mapBoth,
				A2($elm$core$Basics$composeR, $jweir$elm_iso8601$ISO8601$fromPosix, $jweir$elm_iso8601$ISO8601$toString),
				A2($elm$core$Basics$composeR, $jweir$elm_iso8601$ISO8601$fromPosix, $jweir$elm_iso8601$ISO8601$toString),
				A3($author$project$Data$TrackDuration$toStartEnd, currentTime, tz, trackDuration));
			var start = _v0.a;
			var end = _v0.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-2')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small d-flex justify-content-between flex-row align-items-baseline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-secondary text-nowrap me-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Track Length')
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-select form-select-sm'),
									$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										$author$project$Data$TrackDuration$parse,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$map($author$project$Pages$Fleet_$SelectTrackDuration),
											$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$NoOp))))
								]),
							A2(
								$elm$core$List$map,
								function (d) {
									return A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$selected(
												_Utils_eq(trackDuration, d)),
												$elm$html$Html$Attributes$value(
												$author$project$Data$TrackDuration$toString(d))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Data$TrackDuration$toDisplayString(d))
											]));
								},
								$author$project$Data$TrackDuration$all))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-3 d-flex flex-column gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-light'),
									$elm$html$Html$Attributes$href(
									$author$project$Gen$Route$toHref(
										$author$project$Gen$Route$Fleet___Boats__BoatId___Logs(
											{
												fleet: fleet.slug,
												boatId: $author$project$Data$Boat$boatIdToString(boat.boatId)
											})) + ('?start=' + (start + ('&end=' + end))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Vessel Logs'),
									$author$project$Views$NewDot$view(
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											$author$project$FeatureDrop$State$isNew('vessel-logs'),
											featureDropState))),
									$lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('ms-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = boat.photo;
							if (_v1.$ === 'Just') {
								var p = _v1.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
											$elm$html$Html$Attributes$src(p)
										]),
									_List_Nil);
							} else {
								return A2($elm$html$Html$p, _List_Nil, _List_Nil);
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-light btn-sm btn-circle me-2'),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$DeselectBoat)
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small fw-medium')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Back')
								]))
						]))
				]);
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page flex-column align-items-stretch flex-shrink-0 p-3')
				]),
			_Utils_ap(
				headerRows,
				_Utils_ap(specificRows, footerRows)));
	});
var $author$project$Pages$Fleet_$boatSidebar = function (isNeboAdmin) {
	return function (sheet) {
		return function (fleet) {
			return function (boats) {
				return function (boatsLoaded) {
					return function (search) {
						return function (sortOption) {
							return function (selectedBoat) {
								return function (unit) {
									return function (currentTime) {
										return function (locale) {
											return function (tz) {
												return function (trackDuration) {
													return function (featureDropState) {
														return A5(
															$author$project$Views$SidebarSheet$view,
															sheet,
															$author$project$Pages$Fleet_$SheetMsg,
															$elm$core$Maybe$Just(fleet.name),
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex-shrink-0')
																]),
															function () {
																if (selectedBoat.$ === 'Just') {
																	var selected = selectedBoat.a;
																	return _List_fromArray(
																		[
																			A9($author$project$Pages$Fleet_$boatList, isNeboAdmin, fleet, boats, boatsLoaded, search, sortOption, unit, locale, tz),
																			A9($author$project$Pages$Fleet_$boatDetail, isNeboAdmin, fleet, selected, unit, currentTime, locale, tz, trackDuration, featureDropState)
																		]);
																} else {
																	return _List_fromArray(
																		[
																			A9($author$project$Pages$Fleet_$boatList, isNeboAdmin, fleet, boats, boatsLoaded, search, sortOption, unit, locale, tz),
																			A2($elm$html$Html$div, _List_Nil, _List_Nil)
																		]);
																}
															}());
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Boat$isOverspeed = function (boat) {
	return A2(
		$elm$core$List$any,
		function (a) {
			return _Utils_eq(a.type_, $author$project$Data$AlertType$OverSpeed);
		},
		boat.activeAlerts);
};
var $author$project$Views$Mapbox$withIdleMsg = F2(
	function (msg, config) {
		return _Utils_update(
			config,
			{onIdle: msg});
	});
var $author$project$Pages$Fleet_$MapMouseMove = function (a) {
	return {$: 'MapMouseMove', a: a};
};
var $author$project$Data$Boat$isRestricted = function (boat) {
	return A2(
		$elm$core$List$any,
		function (a) {
			return _Utils_eq(a.type_, $author$project$Data$AlertType$RestrictedZone);
		},
		boat.activeAlerts);
};
var $author$project$Data$GeofenceType$toString = function (t) {
	switch (t.$) {
		case 'Restricted':
			return 'restricted';
		case 'Log':
			return 'log';
		case 'Notify':
			switch (t.a.$) {
				case 'Entry':
					var _v1 = t.a;
					return 'notify_entry';
				case 'Exit':
					var _v2 = t.a;
					return 'notify_exit';
				case 'Both':
					var _v3 = t.a;
					return 'notify_both';
				default:
					var _v4 = t.a;
					return 'notify_crossed';
			}
		default:
			return 'speed_restricted';
	}
};
var $author$project$Geospatial$MapProjection$tileSize = 512;
var $author$project$Geospatial$MapProjection$equatorialRadius = 6378137.0;
var $author$project$Geospatial$MapProjection$initialResolution = ((2 * $elm$core$Basics$pi) * $author$project$Geospatial$MapProjection$equatorialRadius) / $author$project$Geospatial$MapProjection$tileSize;
var $author$project$Geospatial$MapProjection$metersPerPixel = F2(
	function (lat, zoom) {
		return ($author$project$Geospatial$MapProjection$initialResolution * $elm$core$Basics$cos(
			$elm$core$Basics$degrees(lat))) / A2($elm$core$Basics$pow, 2.0, zoom);
	});
var $author$project$Views$Mapbox$geofencesToLayer = function (geofences) {
	var radiusAtMaxZoom = F2(
		function (lat, r) {
			return r / A2($author$project$Geospatial$MapProjection$metersPerPixel, lat, 22);
		});
	return _Utils_Tuple2(
		'geofences',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('FeatureCollection')),
					_Utils_Tuple2(
					'features',
					A2(
						$elm$json$Json$Encode$list,
						function (geofence) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('Feature')),
										_Utils_Tuple2(
										'properties',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'geofenceId',
													$elm$json$Json$Encode$string(geofence.fenceId)),
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(geofence.name)),
													_Utils_Tuple2(
													'geofenceType',
													$elm$json$Json$Encode$string(
														$author$project$Data$GeofenceType$toString(geofence.type_))),
													_Utils_Tuple2(
													'radiusPixels',
													function () {
														var _v0 = geofence.geometry;
														if (_v0.$ === 'Circle') {
															var _v1 = _v0.a;
															var ll = _v1.a;
															var r = _v1.b;
															return $elm$json$Json$Encode$float(
																A2(radiusAtMaxZoom, ll.lat, r));
														} else {
															return $elm$json$Json$Encode$null;
														}
													}())
												]))),
										_Utils_Tuple2(
										'geometry',
										function () {
											var _v2 = geofence.geometry;
											switch (_v2.$) {
												case 'Polygon':
													var points = _v2.a;
													return $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'type',
																$elm$json$Json$Encode$string('Polygon')),
																_Utils_Tuple2(
																'coordinates',
																A2(
																	$elm$json$Json$Encode$list,
																	$elm$json$Json$Encode$list($author$project$Views$Mapbox$latLongToGeoJSON),
																	_List_fromArray(
																		[points])))
															]));
												case 'Circle':
													var _v3 = _v2.a;
													var center = _v3.a;
													return $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'type',
																$elm$json$Json$Encode$string('Point')),
																_Utils_Tuple2(
																'coordinates',
																$author$project$Views$Mapbox$latLongToGeoJSON(center))
															]));
												default:
													var points = _v2.a;
													return $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'type',
																$elm$json$Json$Encode$string('LineString')),
																_Utils_Tuple2(
																'coordinates',
																A2($elm$json$Json$Encode$list, $author$project$Views$Mapbox$latLongToGeoJSON, points))
															]));
											}
										}())
									]));
						},
						geofences))
				])));
};
var $author$project$Geospatial$LatLong$centroid = function (points) {
	if (!points.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v1 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, _v3) {
					var _long = _v2._long;
					var lat = _v2.lat;
					var accLat = _v3.a;
					var accLong = _v3.b;
					var accCount = _v3.c;
					return _Utils_Tuple3(accLat + lat, accLong + _long, accCount + 1);
				}),
			_Utils_Tuple3(0.0, 0.0, 0),
			points);
		var sumLat = _v1.a;
		var sumLong = _v1.b;
		var count = _v1.c;
		return $elm$core$Maybe$Just(
			{lat: sumLat / count, _long: sumLong / count});
	}
};
var $author$project$Views$Mapbox$geofenceLabelsToLayer = function (geofences) {
	return _Utils_Tuple2(
		'geofence-labels',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('FeatureCollection')),
					_Utils_Tuple2(
					'features',
					A2(
						$elm$json$Json$Encode$list,
						function (geofence) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('Feature')),
										_Utils_Tuple2(
										'properties',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'geofenceId',
													$elm$json$Json$Encode$string(geofence.fenceId)),
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(geofence.name)),
													_Utils_Tuple2(
													'geofenceType',
													$elm$json$Json$Encode$string(
														$author$project$Data$GeofenceType$toString(geofence.type_)))
												]))),
										_Utils_Tuple2(
										'geometry',
										function () {
											var _v0 = geofence.geometry;
											switch (_v0.$) {
												case 'Polygon':
													var points = _v0.a;
													return $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'type',
																$elm$json$Json$Encode$string('Point')),
																_Utils_Tuple2(
																'coordinates',
																A2(
																	$elm$core$Maybe$withDefault,
																	$elm$json$Json$Encode$null,
																	A2(
																		$elm$core$Maybe$map,
																		$author$project$Views$Mapbox$latLongToGeoJSON,
																		$author$project$Geospatial$LatLong$centroid(points))))
															]));
												case 'Circle':
													var _v1 = _v0.a;
													var center = _v1.a;
													return $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'type',
																$elm$json$Json$Encode$string('Point')),
																_Utils_Tuple2(
																'coordinates',
																$author$project$Views$Mapbox$latLongToGeoJSON(center))
															]));
												default:
													var points = _v0.a;
													return $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'type',
																$elm$json$Json$Encode$string('Point')),
																_Utils_Tuple2(
																'coordinates',
																A2(
																	$elm$core$Maybe$withDefault,
																	$elm$json$Json$Encode$null,
																	A2(
																		$elm$core$Maybe$map,
																		$author$project$Views$Mapbox$latLongToGeoJSON,
																		$author$project$Geospatial$LatLong$centroid(points))))
															]));
											}
										}())
									]));
						},
						geofences))
				])));
};
var $author$project$Views$Mapbox$withGeofences = F2(
	function (geofences, config) {
		return _Utils_update(
			config,
			{
				sources: A2(
					$author$project$Views$Mapbox$addOrReplaceSource,
					$author$project$Views$Mapbox$geofenceLabelsToLayer(geofences),
					A2(
						$author$project$Views$Mapbox$addOrReplaceSource,
						$author$project$Views$Mapbox$geofencesToLayer(geofences),
						config.sources))
			});
	});
var $author$project$Pages$Fleet_$ControlClicked = function (a) {
	return {$: 'ControlClicked', a: a};
};
var $author$project$Data$Boat$toBoatLocation = function (boat) {
	var _v0 = _Utils_Tuple2(boat.lastUpdate, boat.latLong);
	if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
		var ts = _v0.a.a;
		var ll = _v0.b.a;
		return $elm$core$Maybe$Just(
			{
				speed: boat.speed,
				heading: boat.heading,
				latLong: ll,
				accuracy: $elm$core$Maybe$Nothing,
				timestamp: $jweir$elm_iso8601$ISO8601$toPosix(ts)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Fleet_$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Views$Mapbox$withMapClickMsg = F2(
	function (onClick, config) {
		return _Utils_update(
			config,
			{onClick: onClick});
	});
var $author$project$Views$Mapbox$withStyleSelect = F3(
	function (style, onStyleSelect, config) {
		return _Utils_update(
			config,
			{
				onStyleSelect: $elm$core$Maybe$Just(onStyleSelect),
				selectedStyle: style
			});
	});
var $author$project$Views$Mapbox$withMouseMoveMsg = F2(
	function (onMouseMove, config) {
		return _Utils_update(
			config,
			{onMouseMove: onMouseMove});
	});
var $author$project$Mapbox$Element$popup = F3(
	function (position, attributes, content) {
		return A3(
			$elm$html$Html$node,
			'elm-mapbox-popup',
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$property,
						'lngLat',
						$author$project$LngLat$encodeAsObject(position)),
						A2($elm$html$Html$Attributes$style, 'display', 'none')
					]),
				attributes),
			content);
	});
var $author$project$FontAwesome$Internal$mapPin = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'map-pin',
	_Utils_Tuple2(14, 18),
	_Utils_Tuple2('M 7.5697 17.604 C 9.4005 15.3155 13.5198 9.8582 13.5198 6.7599 C 13.5198 3.0279 10.4919 0 6.7599 0 C 3.0279 0 0 3.0279 0 6.7599 C 0 9.8582 4.1193 15.3155 5.9149 17.604 C 6.3374 18.1321 7.1472 18.1321 7.5697 17.604 z M 6.7599 4.5066 C 7.5345 4.5066 8.2738 4.9643 8.6963 5.6333 C 9.0836 6.3375 9.0836 7.2176 8.6963 7.8866 C 8.2738 8.5908 7.5345 9.0132 6.7599 9.0132 C 5.9501 9.0132 5.2108 8.5908 4.7883 7.8866 C 4.401 7.2176 4.401 6.3375 4.7883 5.6333 C 5.2108 4.9643 5.9501 4.5066 6.7599 4.5066 z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$mapPin = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$mapPin);
var $author$project$Mapbox$Element$offset = function (n) {
	return A2(
		$elm$html$Html$Attributes$property,
		'offset',
		$elm$json$Json$Encode$float(n));
};
var $author$project$FontAwesome$Internal$heading = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'heading',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 9.0176 18 C 12.2168 18 15.1699 16.3125 16.7871 13.5 C 18.4043 10.7226 18.4043 7.3125 16.7871 4.5 C 15.1699 1.7226 12.2168 -0 9.0176 -0 C 5.7832 -0 2.8301 1.7226 1.2129 4.5 C -0.4043 7.3125 -0.4043 10.7226 1.2129 13.5 C 2.8301 16.3125 5.7832 18 9.0176 18 z M 10.7754 11.4609 L 5.7129 13.3945 C 5.0449 13.6758 4.3418 12.9726 4.6231 12.3047 L 6.5566 7.2422 C 6.6973 6.9258 6.9082 6.7148 7.2246 6.5742 L 12.2871 4.6406 C 12.9902 4.3594 13.6582 5.0273 13.377 5.7305 L 11.4434 10.7929 C 11.3027 11.1094 11.0918 11.3203 10.7754 11.4609 z M 10.1426 9 C 10.1426 8.4023 9.6152 7.875 9.0176 7.875 C 8.3848 7.875 7.8926 8.4023 7.8926 9 C 7.8926 9.6328 8.3848 10.125 9.0176 10.125 C 9.6152 10.125 10.1426 9.6328 10.1426 9 z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$heading = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$heading);
var $author$project$Data$BoatLocation$toMarkerId = function (b) {
	return 'location-' + $jweir$elm_iso8601$ISO8601$toString(
		$jweir$elm_iso8601$ISO8601$fromPosix(b.timestamp));
};
var $author$project$Mapbox$Element$closeButton = function (b) {
	return A2(
		$elm$html$Html$Attributes$property,
		'closeButton',
		$elm$json$Json$Encode$bool(b));
};
var $author$project$Mapbox$Element$closeOnClick = function (b) {
	return A2(
		$elm$html$Html$Attributes$property,
		'closeOnClick',
		$elm$json$Json$Encode$bool(b));
};
var $author$project$Data$Boat$formatHeading = function (h) {
	return A2($myrho$elm_round$Round$round, 1, h) + '°';
};
var $author$project$ISO8601$Extra$addMediumTime = function (options) {
	return _Utils_update(
		options,
		{
			hour: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			hour12: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$Hour24),
			minute: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			second: $elm$core$Maybe$Just($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit)
		});
};
var $author$project$ISO8601$Extra$toFormattedTimestamp = F3(
	function (locale, browserZone, dto) {
		return A4(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$format,
			$enkidatron$elm_cldr$Cldr$Format$DateTime$WithOptions(
				$author$project$ISO8601$Extra$addMediumTime(
					$author$project$ISO8601$Extra$addShortDate($enkidatron$elm_cldr$Cldr$Format$Options$defaultDateTimeOptions))),
			locale,
			browserZone,
			$jweir$elm_iso8601$ISO8601$toPosix(dto));
	});
var $author$project$Views$Mapbox$locationPopupContent = F7(
	function (locale, tz, unit, boat, loc, isRestricted, isOverspeed) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var n = _v1.a;
					var s = _v1.b;
					var o = _v1.c;
					return _Utils_Tuple3(
						$elm$core$Maybe$Just(n),
						$elm$core$Maybe$Just(s),
						$elm$core$Maybe$Just(o));
				},
				boat));
		var name = _v0.a;
		var status = _v0.b;
		var offline = _v0.c;
		return A3(
			$author$project$Mapbox$Element$popup,
			{lat: loc.latLong.lat, lng: loc.latLong._long},
			_List_fromArray(
				[
					$author$project$Mapbox$Element$closeButton(false),
					$author$project$Mapbox$Element$offset(15),
					$author$project$Mapbox$Element$closeOnClick(false)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Data$BoatLocation$toMarkerId(loc)),
							A2($elm$html$Html$Attributes$style, 'font-family', 'Inter')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('d-flex justify-content-between')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('d-flex align-items-start flex-column')
												]),
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$withDefault,
													A2($elm$html$Html$span, _List_Nil, _List_Nil),
													A2(
														$elm$core$Maybe$map,
														function (n) {
															return A2(
																$elm$html$Html$h4,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(n)
																	]));
														},
														name)),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small fw-semibold mb-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3(
																$author$project$ISO8601$Extra$toFormattedTimestamp,
																locale,
																tz,
																$jweir$elm_iso8601$ISO8601$fromPosix(loc.timestamp)))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$withDefault,
													A2($elm$html$Html$span, _List_Nil, _List_Nil),
													A3(
														$elm$core$Maybe$map2,
														F2(
															function (s, o) {
																return A2($author$project$Views$Mapbox$statusIcon, o, s);
															}),
														status,
														offline))
												]))
										])),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table table-sm mb-0 fw-light')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('border-bottom')
														]),
													_List_fromArray(
														[
															isRestricted ? $lattyware$elm_fontawesome$FontAwesome$view(
															A2(
																$lattyware$elm_fontawesome$FontAwesome$styled,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$class('text-danger fs-3')
																	]),
																$author$project$FontAwesome$Custom$noEntry)) : $lattyware$elm_fontawesome$FontAwesome$view(
															A2(
																$lattyware$elm_fontawesome$FontAwesome$styled,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$class('text-success fs-3')
																	]),
																$author$project$FontAwesome$Custom$mapPin))
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small align-middle border-bottom')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Geospatial$LatLong$decimalMinutesString(loc.latLong))
														]))
												])),
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('border-bottom')
														]),
													_List_fromArray(
														[
															$lattyware$elm_fontawesome$FontAwesome$view(
															A2(
																$lattyware$elm_fontawesome$FontAwesome$styled,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$class(
																		isOverspeed ? 'text-danger fs-5' : 'text-success fs-5')
																	]),
																$author$project$FontAwesome$Custom$gauge))
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small align-middle border-bottom')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'-',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Data$SpeedUnit$formatSpeed(unit),
																	loc.speed)))
														]))
												])),
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('border-bottom-0')
														]),
													_List_fromArray(
														[
															$lattyware$elm_fontawesome$FontAwesome$view(
															A2(
																$lattyware$elm_fontawesome$FontAwesome$styled,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$class('text-secondary fs-5')
																	]),
																$author$project$FontAwesome$Custom$heading))
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small border-bottom-0 align-middle')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'-',
																A2($elm$core$Maybe$map, $author$project$Data$Boat$formatHeading, loc.heading)))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$Mapbox$distanceLocationLabel = F2(
	function (latLong, distance) {
		return A4(
			$author$project$Mapbox$Element$marker,
			{lat: latLong.lat, lng: latLong._long},
			false,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('marker-label'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'top', '50%'),
							A2($elm$html$Html$Attributes$style, 'left', '50%'),
							A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -150%)')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							distance + (' - ' + $author$project$Geospatial$LatLong$decimalMinutesString(latLong)))
						]))
				]));
	});
var $author$project$Pages$Fleet_$view = F4(
	function (session, req, featureDropState, model) {
		var measureLabel = function () {
			if (model.measureModeActive && ($elm$core$List$length(model.measureLine) >= 2)) {
				var lastPoint = $elm$core$List$head(
					$elm$core$List$reverse(model.measureLine));
				var dist = A2(
					$author$project$Data$DistanceUnit$formatDistance,
					model.fleet.longDistanceUnit,
					$author$project$Geospatial$LatLong$distance(model.measureLine));
				return A2(
					$elm$core$Maybe$map,
					function (ll) {
						return A2($author$project$Views$Mapbox$distanceLocationLabel, ll, dist);
					},
					lastPoint);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var boatMarkers = A2(
			$elm$core$List$map,
			function (b) {
				return A5(
					$author$project$Views$Mapbox$boatMarker,
					b,
					model.mapStyle,
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.boatId;
							},
							model.selectedBoat),
						$elm$core$Maybe$Just(b.boatId)),
					false,
					$author$project$Pages$Fleet_$SelectBoat(b.boatId));
			},
			model.boats);
		var mapConfig = A2(
			$author$project$Views$Mapbox$withGeofences,
			model.geofences,
			A2(
				$author$project$Views$Mapbox$withTracks,
				model.tracks,
				A2(
					$author$project$Views$Mapbox$withIdleMsg,
					function (_v0) {
						var c = _v0.a;
						var z = _v0.b;
						var bounds = _v0.c;
						return $author$project$Pages$Fleet_$MapIdle(
							{
								zoom: z,
								bounds: {northEast: bounds.ne, southWest: bounds.sw},
								centre: c
							});
					},
					A5(
						$author$project$Views$Mapbox$withRuler,
						model.measureLine,
						model.fleet.longDistanceUnit,
						model.measureModeActive,
						$author$project$Pages$Fleet_$ControlClicked('measure'),
						A2(
							$author$project$Views$Mapbox$withMouseMoveMsg,
							model.measureModeActive ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$MapMouseMove) : $elm$core$Maybe$Nothing,
							A2(
								$author$project$Views$Mapbox$withMapClickMsg,
								$author$project$Pages$Fleet_$MapClicked,
								A3(
									$author$project$Views$Mapbox$withStyleSelect,
									model.mapStyle,
									$author$project$Pages$Fleet_$SelectStyle,
									A3($author$project$Views$Mapbox$init, model.mapPosition, model.fleetUrl, $author$project$Pages$Fleet_$NoOp))))))));
		var boatPopup = A3(
			$elm$core$Maybe$map2,
			F2(
				function (b, bl) {
					return A7(
						$author$project$Views$Mapbox$locationPopupContent,
						model.locale,
						model.timeZone,
						model.fleet.speedUnit,
						$elm$core$Maybe$Just(
							_Utils_Tuple3(b.name, b.status, b.isOffline)),
						bl,
						$author$project$Data$Boat$isRestricted(b),
						$author$project$Data$Boat$isOverspeed(b));
				}),
			model.selectedBoat,
			A2($elm$core$Maybe$andThen, $author$project$Data$Boat$toBoatLocation, model.selectedBoat));
		return {
			body: A2(
				$author$project$Html$Layout$fitWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(req.route),
					featureDropState,
					$author$project$Pages$Fleet_$ChangelogAction,
					$author$project$Pages$Fleet_$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex no-wrap'),
								A2($elm$html$Html$Attributes$style, 'overflow-x', 'auto'),
								A2($elm$html$Html$Attributes$style, 'overflow-y', 'hidden'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								$author$project$Pages$Fleet_$boatSidebar(
								$author$project$Data$User$isNeboAdmin(session.user))(model.sheet)(model.fleet)(model.boats)(model.boatsLoaded)(model.boatSearch)(model.boatSort)(model.selectedBoat)(model.fleet.speedUnit)(model.currentTime)(model.locale)(model.timeZone)(model.trackDuration)(featureDropState),
								A2(
								$author$project$Views$Mapbox$view,
								mapConfig,
								_Utils_ap(
									boatMarkers,
									_Utils_ap(
										$elm_community$maybe_extra$Maybe$Extra$toList(boatPopup),
										$elm_community$maybe_extra$Maybe$Extra$toList(measureLabel))))
							]))
					])),
			title: model.fleet.name
		};
	});
var $author$project$Mapbox$Cmd$Internal$Option = F2(
	function (a, b) {
		return {$: 'Option', a: a, b: b};
	});
var $author$project$Mapbox$Cmd$Option$zoom = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	$author$project$Mapbox$Cmd$Internal$Option('zoom'));
var $author$project$MapCommands$id = 'mapbox-map';
var $author$project$Mapbox$Cmd$Template$makeCmd = F4(
	function (prt, id, command, params) {
		return prt(
			$elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'command',
						$elm$json$Json$Encode$string(command)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'target',
							$elm$json$Json$Encode$string(id)),
						params))));
	});
var $author$project$Mapbox$Cmd$Template$encodeOptions = function (opts) {
	return _Utils_Tuple2(
		'options',
		$elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var key = _v0.a;
					var val = _v0.b;
					return _Utils_Tuple2(key, val);
				},
				opts)));
};
var $author$project$Mapbox$Cmd$Template$flyTo = F3(
	function (prt, id, options) {
		return A4(
			$author$project$Mapbox$Cmd$Template$makeCmd,
			prt,
			id,
			'flyTo',
			_List_fromArray(
				[
					$author$project$Mapbox$Cmd$Template$encodeOptions(options)
				]));
	});
var $author$project$Ports$elmMapboxOutgoing = _Platform_outgoingPort('elmMapboxOutgoing', $elm$core$Basics$identity);
var $author$project$MapCommands$flyTo = A2($author$project$Mapbox$Cmd$Template$flyTo, $author$project$Ports$elmMapboxOutgoing, $author$project$MapCommands$id);
var $author$project$Mapbox$Cmd$Option$speed = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	$author$project$Mapbox$Cmd$Internal$Option('speed'));
var $author$project$Mapbox$Cmd$Option$center = A2(
	$elm$core$Basics$composeR,
	$author$project$LngLat$encodeAsPair,
	$author$project$Mapbox$Cmd$Internal$Option('center'));
var $author$project$Data$Boat$Boat = function (boatId) {
	return function (ownerId) {
		return function (name) {
			return function (makeModel) {
				return function (length) {
					return function (beam) {
						return function (draft) {
							return function (yearLaunched) {
								return function (homePort) {
									return function (callSign) {
										return function (photo) {
											return function (boatType) {
												return function (boatTypeDescription) {
													return function (status) {
														return function (latLong) {
															return function (lastUpdate) {
																return function (speed) {
																	return function (heading) {
																		return function (trackerId) {
																			return function (batteryVoltage) {
																				return function (externalVoltage) {
																					return function (gsmSignalStrength) {
																						return function (positionAccuracy) {
																							return function (radio) {
																								return function (isOffline) {
																									return function (isTrailerBoat) {
																										return function (maxSpeed) {
																											return function (lowBatteryAlertThreshold) {
																												return function (highWaterAlertSettings) {
																													return function (movementAlertSettings) {
																														return function (batteryIsolationEnabled) {
																															return function (batteryIsolated) {
																																return function (activeAlerts) {
																																	return function (helmVesselId) {
																																		return {beam: beam, name: name, draft: draft, photo: photo, radio: radio, speed: speed, boatId: boatId, length: length, status: status, heading: heading, latLong: latLong, ownerId: ownerId, boatType: boatType, callSign: callSign, homePort: homePort, maxSpeed: maxSpeed, isOffline: isOffline, makeModel: makeModel, trackerId: trackerId, lastUpdate: lastUpdate, activeAlerts: activeAlerts, helmVesselId: helmVesselId, yearLaunched: yearLaunched, isTrailerBoat: isTrailerBoat, batteryVoltage: batteryVoltage, batteryIsolated: batteryIsolated, externalVoltage: externalVoltage, positionAccuracy: positionAccuracy, gsmSignalStrength: gsmSignalStrength, boatTypeDescription: boatTypeDescription, movementAlertSettings: movementAlertSettings, highWaterAlertSettings: highWaterAlertSettings, batteryIsolationEnabled: batteryIsolationEnabled, lowBatteryAlertThreshold: lowBatteryAlertThreshold};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$AlertType$CapsizeAlert = {$: 'CapsizeAlert'};
var $author$project$Data$AlertType$fromString = function (s) {
	switch (s) {
		case 'capsizeAlert':
			return $elm$core$Maybe$Just($author$project$Data$AlertType$CapsizeAlert);
		case 'restrictedZone':
			return $elm$core$Maybe$Just($author$project$Data$AlertType$RestrictedZone);
		case 'overSpeed':
			return $elm$core$Maybe$Just($author$project$Data$AlertType$OverSpeed);
		case 'lowBattery':
			return $elm$core$Maybe$Just($author$project$Data$AlertType$LowBattery);
		case 'highWater':
			return $elm$core$Maybe$Just($author$project$Data$AlertType$HighWater);
		case 'afterHoursMovement':
			return $elm$core$Maybe$Just($author$project$Data$AlertType$AfterHoursMovement);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$AlertType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$AlertType$fromString(s);
		if (_v0.$ === 'Just') {
			var t = _v0.a;
			return $elm$json$Json$Decode$succeed(t);
		} else {
			return $elm$json$Json$Decode$fail('Unknown AlertType ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$ActiveAlert$ActiveAlert = F3(
	function (alertId, timestamp, type_) {
		return {type_: type_, alertId: alertId, timestamp: timestamp};
	});
var $author$project$Data$ActiveAlert$AlertId = function (a) {
	return {$: 'AlertId', a: a};
};
var $author$project$Data$ActiveAlert$alertIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$ActiveAlert$AlertId, $elm$json$Json$Decode$string);
var $author$project$Data$ActiveAlert$decode = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$ActiveAlert$ActiveAlert,
	A2($elm$json$Json$Decode$field, 'alertId', $author$project$Data$ActiveAlert$alertIdDecoder),
	A2($elm$json$Json$Decode$field, 'timestamp', $jweir$elm_iso8601$ISO8601$decode),
	A2($elm$json$Json$Decode$field, 'type', $author$project$Data$AlertType$decode));
var $author$project$Data$Boat$BoatId = function (a) {
	return {$: 'BoatId', a: a};
};
var $author$project$Data$Boat$boatIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Boat$BoatId, $elm$json$Json$Decode$string);
var $author$project$Data$Boat$DMT = function (a) {
	return {$: 'DMT', a: a};
};
var $author$project$Data$Boat$LAD = function (a) {
	return {$: 'LAD', a: a};
};
var $author$project$Data$Boat$Sensar = function (a) {
	return {$: 'Sensar', a: a};
};
var $author$project$Data$Boat$trackerIdDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = A2($elm$core$String$split, '-', s);
		_v0$3:
		while (true) {
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				switch (_v0.a) {
					case 'dmt':
						var _v1 = _v0.b;
						var i = _v1.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Invalid DMT tracker id: ' + i),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Data$Boat$DMT, $elm$json$Json$Decode$succeed),
								$elm$core$String$toInt(i)));
					case 'sensar':
						var _v2 = _v0.b;
						var i = _v2.a;
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Boat$Sensar(i));
					case 'lad':
						var _v3 = _v0.b;
						var i = _v3.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Invalid LAD tracker id: ' + i),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Data$Boat$LAD, $elm$json$Json$Decode$succeed),
								$elm$core$String$toInt(i)));
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$json$Json$Decode$fail('Unknown tracker id format: ' + s);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Boat$InPen = {$: 'InPen'};
var $author$project$Data$Boat$Other = function (a) {
	return {$: 'Other', a: a};
};
var $author$project$Data$Boat$AtJetty = {$: 'AtJetty'};
var $author$project$Data$Boat$Stopped = {$: 'Stopped'};
var $author$project$Data$Boat$Unknown = {$: 'Unknown'};
var $author$project$Data$Boat$AtAnchor = {$: 'AtAnchor'};
var $author$project$Data$Boat$RaftedUp = {$: 'RaftedUp'};
var $author$project$Data$Boat$Underway = {$: 'Underway'};
var $author$project$Data$Boat$OnMooring = {$: 'OnMooring'};
var $author$project$Data$Boat$OutOfWater = {$: 'OutOfWater'};
var $author$project$Data$Boat$boatStatusDecoder = function () {
	var fromString = function (s) {
		switch (s) {
			case 'unknown':
				return $elm$core$Result$Ok($author$project$Data$Boat$Unknown);
			case 'underway':
				return $elm$core$Result$Ok($author$project$Data$Boat$Underway);
			case 'inPen':
				return $elm$core$Result$Ok($author$project$Data$Boat$InPen);
			case 'onMooring':
				return $elm$core$Result$Ok($author$project$Data$Boat$OnMooring);
			case 'atAnchor':
				return $elm$core$Result$Ok($author$project$Data$Boat$AtAnchor);
			case 'atJetty':
				return $elm$core$Result$Ok($author$project$Data$Boat$AtJetty);
			case 'raftedUp':
				return $elm$core$Result$Ok($author$project$Data$Boat$RaftedUp);
			case 'outOfWater':
				return $elm$core$Result$Ok($author$project$Data$Boat$OutOfWater);
			case 'stopped':
				return $elm$core$Result$Ok($author$project$Data$Boat$Stopped);
			default:
				return $elm$core$Result$Err('Unknown status type: ' + s);
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		function (t) {
			return (t === 'other') ? A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Boat$Other,
				A2(
					$elm$json$Json$Decode$field,
					'description',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))) : A3($elm$core$Basics$composeR, fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult, t);
		},
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}();
var $author$project$Data$Duration$Seconds = function (a) {
	return {$: 'Seconds', a: a};
};
var $author$project$Data$Duration$parse = function (str) {
	var _v0 = A2($elm$core$String$split, ':', str);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var hoursStr = _v0.a;
		var _v1 = _v0.b;
		var minutesStr = _v1.a;
		var _v2 = _v1.b;
		var secondsStr = _v2.a;
		var seconds = $elm$core$String$toInt(secondsStr);
		var minutes = $elm$core$String$toInt(minutesStr);
		var hours = $elm$core$String$toInt(hoursStr);
		var _v3 = _Utils_Tuple3(hours, minutes, seconds);
		if (((_v3.a.$ === 'Just') && (_v3.b.$ === 'Just')) && (_v3.c.$ === 'Just')) {
			var h = _v3.a.a;
			var m = _v3.b.a;
			var s = _v3.c.a;
			return $elm$core$Maybe$Just(
				$author$project$Data$Duration$Seconds(((h * 3600) + (m * 60)) + s));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Duration$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$Duration$parse(s);
		if (_v0.$ === 'Just') {
			var duration = _v0.a;
			return $elm$json$Json$Decode$succeed(duration);
		} else {
			return $elm$json$Json$Decode$fail('Invalid duration format: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Boat$FixedHours = function (a) {
	return {$: 'FixedHours', a: a};
};
var $author$project$Data$Boat$TimePeriod = F2(
	function (start, end) {
		return {end: end, start: start};
	});
var $author$project$Data$Boat$DaylightHours = function (a) {
	return {$: 'DaylightHours', a: a};
};
var $author$project$Data$Boat$legacyMovementAlertSettingsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Boat$FixedHours,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'activeHoursEnd',
		$author$project$Data$Duration$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'activeHoursStart',
			$author$project$Data$Duration$decode,
			$elm$json$Json$Decode$succeed($author$project$Data$Boat$TimePeriod))));
var $author$project$Data$Boat$movementAlertSettingsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Data$Boat$legacyMovementAlertSettingsDecoder,
			A2(
			$elm$json$Json$Decode$field,
			'fixedHours',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Boat$FixedHours,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Data$Boat$TimePeriod,
					A2($elm$json$Json$Decode$field, 'activeHoursStart', $author$project$Data$Duration$decode),
					A2($elm$json$Json$Decode$field, 'activeHoursEnd', $author$project$Data$Duration$decode)))),
			A2(
			$elm$json$Json$Decode$field,
			'daylightHours',
			A2($elm$json$Json$Decode$map, $author$project$Data$Boat$DaylightHours, $elm$json$Json$Decode$int)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (str) {
				return (str === 'daylightHours') ? $elm$json$Json$Decode$succeed(
					$author$project$Data$Boat$DaylightHours(0)) : $elm$json$Json$Decode$fail('Invalid MovementAlertSettings');
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$Data$Boat$Never = {$: 'Never'};
var $author$project$Data$Boat$Always = {$: 'Always'};
var $author$project$Data$Boat$ActivationFrequency = function (a) {
	return {$: 'ActivationFrequency', a: a};
};
var $author$project$Data$Boat$highWaterAlertSettingsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Boat$ActivationFrequency,
			A2($elm$json$Json$Decode$field, 'activationFrequency', $elm$json$Json$Decode$int)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (s) {
				return (s === 'never') ? $elm$json$Json$Decode$succeed($author$project$Data$Boat$Never) : ((s === 'always') ? $elm$json$Json$Decode$succeed($author$project$Data$Boat$Always) : $elm$json$Json$Decode$fail('Unknown HighWaterAlertSettings: ' + s));
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$Data$Boat$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'helmVesselId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'activeAlerts',
		$elm$json$Json$Decode$list($author$project$Data$ActiveAlert$decode),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'batteryIsolated',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'batteryIsolationEnabled',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'movementAlertSettings',
					$elm$json$Json$Decode$nullable($author$project$Data$Boat$movementAlertSettingsDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'highWaterAlertSettings',
						$elm$json$Json$Decode$nullable($author$project$Data$Boat$highWaterAlertSettingsDecoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lowBatteryAlertThreshold',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'maxSpeed',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'isTrailerBoat',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'isOffline',
										$elm$json$Json$Decode$bool,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'radio',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'positionAccuracy',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'gsmSignalStrength',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'externalVoltage',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'batteryVoltage',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'trackerId',
																$elm$json$Json$Decode$nullable($author$project$Data$Boat$trackerIdDecoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'heading',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'speed',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'lastUpdate',
																			$elm$json$Json$Decode$nullable($jweir$elm_iso8601$ISO8601$decode),
																			A2(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																				A3(
																					$elm$json$Json$Decode$map2,
																					$elm$core$Maybe$map2($author$project$Geospatial$LatLong$LatLong),
																					A2(
																						$elm$json$Json$Decode$field,
																						'latitude',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float)),
																					A2(
																						$elm$json$Json$Decode$field,
																						'longitude',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float))),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'status',
																					$author$project$Data$Boat$boatStatusDecoder,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'boatTypeDescription',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'boatType',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'photo',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'callSign',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'homePort',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'yearLaunched',
																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'draft',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'beam',
																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'length',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'makeModel',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'name',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'ownerId',
																																	$author$project$Data$User$accountIdDecoder,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'boatId',
																																		$author$project$Data$Boat$boatIdDecoder,
																																		$elm$json$Json$Decode$succeed($author$project$Data$Boat$Boat)))))))))))))))))))))))))))))))))));
var $author$project$Data$Place$Place = F9(
	function (placeId, name, type_, location, geometry, url, photos, audio, description) {
		return {url: url, name: name, audio: audio, type_: type_, photos: photos, placeId: placeId, geometry: geometry, location: location, description: description};
	});
var $author$project$Data$Image$Server = function (a) {
	return {$: 'Server', a: a};
};
var $author$project$Data$Image$decode = A2($elm$json$Json$Decode$map, $author$project$Data$Image$Server, $elm$json$Json$Decode$string);
var $author$project$Data$PlaceType$Beach = {$: 'Beach'};
var $author$project$Data$PlaceType$Danger = {$: 'Danger'};
var $author$project$Data$PlaceType$Marina = {$: 'Marina'};
var $author$project$Data$PlaceType$Mooring = {$: 'Mooring'};
var $author$project$Data$PlaceType$Anchorage = {$: 'Anchorage'};
var $author$project$Data$PlaceType$Restrooms = {$: 'Restrooms'};
var $author$project$Data$PlaceType$ScenicView = {$: 'ScenicView'};
var $author$project$Data$PlaceType$SelfieSpot = {$: 'SelfieSpot'};
var $author$project$Data$PlaceType$FishingSpot = {$: 'FishingSpot'};
var $author$project$Data$PlaceType$Information = {$: 'Information'};
var $author$project$Data$PlaceType$WaterskiArea = {$: 'WaterskiArea'};
var $author$project$Data$PlaceType$CafeRestaurant = {$: 'CafeRestaurant'};
var $author$project$Data$PlaceType$TurnaroundPoint = {$: 'TurnaroundPoint'};
var $author$project$Data$PlaceType$CulturalLocation = {$: 'CulturalLocation'};
var $author$project$Data$PlaceType$HistoricLocation = {$: 'HistoricLocation'};
var $author$project$Data$PlaceType$parse = function (s) {
	switch (s) {
		case 'anchorage':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Anchorage);
		case 'culturalLocation':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$CulturalLocation);
		case 'danger':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Danger);
		case 'historicLocation':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$HistoricLocation);
		case 'marina':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Marina);
		case 'mooring':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Mooring);
		case 'scenicView':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$ScenicView);
		case 'selfieSpot':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$SelfieSpot);
		case 'turnaroundPoint':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$TurnaroundPoint);
		case 'information':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Information);
		case 'waterskiArea':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$WaterskiArea);
		case 'restrooms':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Restrooms);
		case 'fishingSpot':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$FishingSpot);
		case 'cafeRestaurant':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$CafeRestaurant);
		case 'beach':
			return $elm$core$Maybe$Just($author$project$Data$PlaceType$Beach);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$PlaceType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$PlaceType$parse(s);
		if (_v0.$ === 'Just') {
			var t = _v0.a;
			return $elm$json$Json$Decode$succeed(t);
		} else {
			return $elm$json$Json$Decode$succeed($author$project$Data$PlaceType$Information);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Geofence$latLongDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Geospatial$LatLong$LatLong,
	A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float));
var $author$project$Data$Geofence$geometryDecoder = function () {
	var polygon = A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Geofence$Polygon,
		A2(
			$elm$json$Json$Decode$field,
			'paths',
			$elm$json$Json$Decode$list($author$project$Data$Geofence$latLongDecoder)));
	var circle = A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Geofence$Circle,
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'center', $author$project$Data$Geofence$latLongDecoder),
			A2($elm$json$Json$Decode$field, 'radius', $elm$json$Json$Decode$float)));
	var line = A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Geofence$Line,
		A2(
			$elm$json$Json$Decode$field,
			'path',
			$elm$json$Json$Decode$list($author$project$Data$Geofence$latLongDecoder)));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'circle', circle),
				A2($elm$json$Json$Decode$field, 'polygon', polygon),
				A2($elm$json$Json$Decode$field, 'line', line)
			]));
}();
var $author$project$Data$Place$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'audio',
		$elm$json$Json$Decode$nullable($author$project$Data$Image$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'photos',
			$elm$json$Json$Decode$list($author$project$Data$Image$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'url',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'geometry',
					$elm$json$Json$Decode$maybe($author$project$Data$Geofence$geometryDecoder),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A3(
							$elm$json$Json$Decode$map2,
							$author$project$Geospatial$LatLong$LatLong,
							A2($elm$json$Json$Decode$field, 'latitude', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'longitude', $elm$json$Json$Decode$float)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$author$project$Data$PlaceType$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'placeId',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Data$Place$Place))))))))));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Data$GeofenceType$Log = {$: 'Log'};
var $author$project$Data$GeofenceType$Both = {$: 'Both'};
var $author$project$Data$GeofenceType$Exit = {$: 'Exit'};
var $author$project$Data$GeofenceType$Entry = {$: 'Entry'};
var $author$project$Data$GeofenceType$Notify = function (a) {
	return {$: 'Notify', a: a};
};
var $author$project$Data$GeofenceType$Crossed = {$: 'Crossed'};
var $author$project$Data$GeofenceType$Restricted = {$: 'Restricted'};
var $author$project$Data$GeofenceType$SpeedRestricted = {$: 'SpeedRestricted'};
var $author$project$Data$GeofenceType$fromString = function (s) {
	switch (s) {
		case 'restricted':
			return $elm$core$Maybe$Just($author$project$Data$GeofenceType$Restricted);
		case 'log':
			return $elm$core$Maybe$Just($author$project$Data$GeofenceType$Log);
		case 'notify_entry':
			return $elm$core$Maybe$Just(
				$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Entry));
		case 'notify_exit':
			return $elm$core$Maybe$Just(
				$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Exit));
		case 'notify_both':
			return $elm$core$Maybe$Just(
				$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Both));
		case 'notify_crossed':
			return $elm$core$Maybe$Just(
				$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Crossed));
		case 'speed_restricted':
			return $elm$core$Maybe$Just($author$project$Data$GeofenceType$SpeedRestricted);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$GeofenceType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Data$GeofenceType$fromString(s);
		if (_v0.$ === 'Just') {
			var t = _v0.a;
			return $elm$json$Json$Decode$succeed(t);
		} else {
			return $elm$json$Json$Decode$fail('Unknown GeofenceType ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Geofence$Geofence = F6(
	function (fenceId, name, geometry, type_, crossingType, maxSpeed) {
		return {name: name, type_: type_, fenceId: fenceId, geometry: geometry, maxSpeed: maxSpeed, crossingType: crossingType};
	});
var $elm_community$json_extra$Json$Decode$Extra$optionalNullableField = F2(
	function (fieldName, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				fieldName,
				$elm$json$Json$Decode$nullable(decoder)));
	});
var $author$project$Data$Geofence$decode = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Geofence$Geofence,
	A2($elm$json$Json$Decode$field, 'fenceId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'geometry', $author$project$Data$Geofence$geometryDecoder),
	A2($elm$json$Json$Decode$field, 'type', $author$project$Data$GeofenceType$decode),
	A2(
		$elm$json$Json$Decode$field,
		'crossingType',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'maxSpeed', $elm$json$Json$Decode$float));
var $author$project$Mapbox$Cmd$Template$jumpTo = F3(
	function (prt, id, options) {
		return A4(
			$author$project$Mapbox$Cmd$Template$makeCmd,
			prt,
			id,
			'jumpTo',
			_List_fromArray(
				[
					$author$project$Mapbox$Cmd$Template$encodeOptions(options)
				]));
	});
var $author$project$MapCommands$jumpTo = A2($author$project$Mapbox$Cmd$Template$jumpTo, $author$project$Ports$elmMapboxOutgoing, $author$project$MapCommands$id);
var $mdgriffith$elm_animator$Animator$TransitionTo = F2(
	function (a, b) {
		return {$: 'TransitionTo', a: a, b: b};
	});
var $mdgriffith$elm_animator$Animator$event = $mdgriffith$elm_animator$Animator$TransitionTo;
var $mdgriffith$elm_animator$Animator$millis = $ianmackenzie$elm_units$Duration$milliseconds;
var $mdgriffith$elm_animator$Internal$Timeline$Event = F3(
	function (a, b, c) {
		return {$: 'Event', a: a, b: b, c: c};
	});
var $mdgriffith$elm_animator$Internal$Timeline$Schedule = F3(
	function (a, b, c) {
		return {$: 'Schedule', a: a, b: b, c: c};
	});
var $mdgriffith$elm_animator$Internal$Timeline$addToDwell = F2(
	function (duration, maybeDwell) {
		if (!$ianmackenzie$elm_units$Duration$inMilliseconds(duration)) {
			return maybeDwell;
		} else {
			if (maybeDwell.$ === 'Nothing') {
				return $elm$core$Maybe$Just(duration);
			} else {
				var existing = maybeDwell.a;
				return $elm$core$Maybe$Just(
					A2($ianmackenzie$elm_units$Quantity$plus, duration, existing));
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$extendEventDwell = F2(
	function (extendBy, thisEvent) {
		var at = thisEvent.a;
		var ev = thisEvent.b;
		var maybeDwell = thisEvent.c;
		return (!$ianmackenzie$elm_units$Duration$inMilliseconds(extendBy)) ? thisEvent : A3(
			$mdgriffith$elm_animator$Internal$Timeline$Event,
			at,
			ev,
			A2($mdgriffith$elm_animator$Internal$Timeline$addToDwell, extendBy, maybeDwell));
	});
var $mdgriffith$elm_animator$Animator$stepsToEvents = F2(
	function (currentStep, _v0) {
		var delay = _v0.a;
		var startEvent = _v0.b;
		var events = _v0.c;
		if (!events.b) {
			if (currentStep.$ === 'Wait') {
				var waiting = currentStep.a;
				return A3(
					$mdgriffith$elm_animator$Internal$Timeline$Schedule,
					delay,
					A2($mdgriffith$elm_animator$Internal$Timeline$extendEventDwell, waiting, startEvent),
					events);
			} else {
				var dur = currentStep.a;
				var checkpoint = currentStep.b;
				return A3(
					$mdgriffith$elm_animator$Internal$Timeline$Schedule,
					delay,
					startEvent,
					_List_fromArray(
						[
							A3($mdgriffith$elm_animator$Internal$Timeline$Event, dur, checkpoint, $elm$core$Maybe$Nothing)
						]));
			}
		} else {
			var _v3 = events.a;
			var durationTo = _v3.a;
			var recentEvent = _v3.b;
			var maybeDwell = _v3.c;
			var remaining = events.b;
			if (currentStep.$ === 'Wait') {
				var dur = currentStep.a;
				return A3(
					$mdgriffith$elm_animator$Internal$Timeline$Schedule,
					delay,
					startEvent,
					A2(
						$elm$core$List$cons,
						A3(
							$mdgriffith$elm_animator$Internal$Timeline$Event,
							durationTo,
							recentEvent,
							A2($mdgriffith$elm_animator$Internal$Timeline$addToDwell, dur, maybeDwell)),
						remaining));
			} else {
				var dur = currentStep.a;
				var checkpoint = currentStep.b;
				return _Utils_eq(checkpoint, recentEvent) ? A3(
					$mdgriffith$elm_animator$Internal$Timeline$Schedule,
					delay,
					startEvent,
					A2(
						$elm$core$List$cons,
						A3(
							$mdgriffith$elm_animator$Internal$Timeline$Event,
							durationTo,
							recentEvent,
							A2($mdgriffith$elm_animator$Internal$Timeline$addToDwell, dur, maybeDwell)),
						remaining)) : A3(
					$mdgriffith$elm_animator$Internal$Timeline$Schedule,
					delay,
					startEvent,
					A2(
						$elm$core$List$cons,
						A3($mdgriffith$elm_animator$Internal$Timeline$Event, dur, checkpoint, $elm$core$Maybe$Nothing),
						events));
			}
		}
	});
var $mdgriffith$elm_animator$Animator$initializeSchedule = F2(
	function (waiting, steps) {
		initializeSchedule:
		while (true) {
			if (!steps.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				if (steps.a.$ === 'Wait') {
					var additionalWait = steps.a.a;
					var moreSteps = steps.b;
					var $temp$waiting = A2($ianmackenzie$elm_units$Quantity$plus, waiting, additionalWait),
						$temp$steps = moreSteps;
					waiting = $temp$waiting;
					steps = $temp$steps;
					continue initializeSchedule;
				} else {
					var _v1 = steps.a;
					var dur = _v1.a;
					var checkpoint = _v1.b;
					var moreSteps = steps.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A3(
								$mdgriffith$elm_animator$Internal$Timeline$Schedule,
								waiting,
								A3($mdgriffith$elm_animator$Internal$Timeline$Event, dur, checkpoint, $elm$core$Maybe$Nothing),
								_List_Nil),
							moreSteps));
				}
			}
		}
	});
var $mdgriffith$elm_animator$Animator$interrupt = F2(
	function (steps, _v0) {
		var tl = _v0.a;
		return $mdgriffith$elm_animator$Internal$Timeline$Timeline(
			_Utils_update(
				tl,
				{
					running: true,
					interruption: function () {
						var _v1 = A2(
							$mdgriffith$elm_animator$Animator$initializeSchedule,
							$mdgriffith$elm_animator$Animator$millis(0),
							steps);
						if (_v1.$ === 'Nothing') {
							return tl.interruption;
						} else {
							var _v2 = _v1.a;
							var schedule = _v2.a;
							var otherSteps = _v2.b;
							return A2(
								$elm$core$List$cons,
								A3($elm$core$List$foldl, $mdgriffith$elm_animator$Animator$stepsToEvents, schedule, otherSteps),
								tl.interruption);
						}
					}()
				}));
	});
var $mdgriffith$elm_animator$Animator$go = F3(
	function (duration, ev, timeline) {
		return A2(
			$mdgriffith$elm_animator$Animator$interrupt,
			_List_fromArray(
				[
					A2($mdgriffith$elm_animator$Animator$event, duration, ev)
				]),
			timeline);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $mdgriffith$elm_animator$Animator$update = F3(
	function (newTime, _v0, model) {
		var updateModel = _v0.b;
		return A2(updateModel, newTime, model);
	});
var $zaboco$elm_draggable$Internal$Dragging = function (a) {
	return {$: 'Dragging', a: a};
};
var $zaboco$elm_draggable$Internal$distanceTo = F2(
	function (end, start) {
		return _Utils_Tuple2(end.x - start.x, end.y - start.y);
	});
var $zaboco$elm_draggable$Internal$DraggingTentative = F2(
	function (a, b) {
		return {$: 'DraggingTentative', a: a, b: b};
	});
var $zaboco$elm_draggable$Internal$updateAndEmit = F3(
	function (config, msg, drag) {
		var _v0 = _Utils_Tuple2(drag, msg);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 'NotDragging':
					if (_v0.b.$ === 'StartDragging') {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var key = _v2.a;
						var initialPosition = _v2.b;
						return _Utils_Tuple2(
							A2($zaboco$elm_draggable$Internal$DraggingTentative, key, initialPosition),
							config.onMouseDown(key));
					} else {
						break _v0$5;
					}
				case 'DraggingTentative':
					switch (_v0.b.$) {
						case 'DragAt':
							var _v3 = _v0.a;
							var key = _v3.a;
							var oldPosition = _v3.b;
							return _Utils_Tuple2(
								$zaboco$elm_draggable$Internal$Dragging(oldPosition),
								config.onDragStart(key));
						case 'StopDragging':
							var _v4 = _v0.a;
							var key = _v4.a;
							var _v5 = _v0.b;
							return _Utils_Tuple2(
								$zaboco$elm_draggable$Internal$NotDragging,
								config.onClick(key));
						default:
							break _v0$5;
					}
				default:
					switch (_v0.b.$) {
						case 'DragAt':
							var oldPosition = _v0.a.a;
							var newPosition = _v0.b.a;
							return _Utils_Tuple2(
								$zaboco$elm_draggable$Internal$Dragging(newPosition),
								config.onDragBy(
									A2($zaboco$elm_draggable$Internal$distanceTo, newPosition, oldPosition)));
						case 'StopDragging':
							var _v6 = _v0.b;
							return _Utils_Tuple2($zaboco$elm_draggable$Internal$NotDragging, config.onDragEnd);
						default:
							break _v0$5;
					}
			}
		}
		return _Utils_Tuple2(drag, $elm$core$Maybe$Nothing);
	});
var $zaboco$elm_draggable$Cmd$Extra$message = function (x) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(x));
};
var $zaboco$elm_draggable$Cmd$Extra$optionalMessage = function (msgMaybe) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2($elm$core$Maybe$map, $zaboco$elm_draggable$Cmd$Extra$message, msgMaybe));
};
var $zaboco$elm_draggable$Draggable$updateDraggable = F3(
	function (_v0, _v1, _v2) {
		var config = _v0.a;
		var msg = _v1.a;
		var drag = _v2.a;
		var _v3 = A3($zaboco$elm_draggable$Internal$updateAndEmit, config, msg, drag);
		var newDrag = _v3.a;
		var newMsgMaybe = _v3.b;
		return _Utils_Tuple2(
			$zaboco$elm_draggable$Draggable$State(newDrag),
			$zaboco$elm_draggable$Cmd$Extra$optionalMessage(newMsgMaybe));
	});
var $zaboco$elm_draggable$Draggable$update = F3(
	function (config, msg, model) {
		var _v0 = A3($zaboco$elm_draggable$Draggable$updateDraggable, config, msg, model.drag);
		var dragState = _v0.a;
		var dragCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{drag: dragState}),
			dragCmd);
	});
var $mdgriffith$elm_animator$Animator$quickly = $mdgriffith$elm_animator$Animator$millis(200);
var $mdgriffith$elm_animator$Internal$Timeline$Animator = F2(
	function (a, b) {
		return {$: 'Animator', a: a, b: b};
	});
var $mdgriffith$elm_animator$Animator$animator = A2(
	$mdgriffith$elm_animator$Internal$Timeline$Animator,
	$elm$core$Basics$always(false),
	F2(
		function (now, model) {
			return model;
		}));
var $ianmackenzie$elm_units$Quantity$max = F2(
	function (_v0, _v1) {
		var x = _v0.a;
		var y = _v1.a;
		return $ianmackenzie$elm_units$Quantity$Quantity(
			A2($elm$core$Basics$max, x, y));
	});
var $mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat = F2(
	function (_v0, _v1) {
		var _this = _v0.a;
		var that = _v1.a;
		return (_this - that) >= 0;
	});
var $mdgriffith$elm_animator$Internal$Timeline$linesAreActive = F2(
	function (now, lines) {
		linesAreActive:
		while (true) {
			if (!lines.b) {
				return false;
			} else {
				var _v1 = lines.a;
				var startAt = _v1.a;
				var startingEvent = _v1.b;
				var events = _v1.c;
				var remaining = lines.b;
				if (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, startAt, now)) {
					return true;
				} else {
					var maybeInterruption = function () {
						var _v5 = $elm$core$List$head(remaining);
						if (_v5.$ === 'Nothing') {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v6 = _v5.a;
							var interruptionTime = _v6.a;
							return $elm$core$Maybe$Just(interruptionTime);
						}
					}();
					var last = A2(
						$elm$core$Maybe$withDefault,
						startingEvent,
						$elm$core$List$head(
							$elm$core$List$reverse(events)));
					if (maybeInterruption.$ === 'Just') {
						var interruptTime = maybeInterruption.a;
						if (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, interruptTime, now)) {
							return true;
						} else {
							var time = last.b;
							if (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, time, now)) {
								return true;
							} else {
								var $temp$now = now,
									$temp$lines = remaining;
								now = $temp$now;
								lines = $temp$lines;
								continue linesAreActive;
							}
						}
					} else {
						var time = last.b;
						if (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, time, now)) {
							return true;
						} else {
							var $temp$now = now,
								$temp$lines = remaining;
							now = $temp$now;
							lines = $temp$lines;
							continue linesAreActive;
						}
					}
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$Captured = function (a) {
	return {$: 'Captured', a: a};
};
var $mdgriffith$elm_animator$Internal$Timeline$dwellingAt = F2(
	function (now, event) {
		var eventStartTime = $mdgriffith$elm_animator$Internal$Timeline$startTime(event);
		var eventEndTime = $mdgriffith$elm_animator$Internal$Timeline$endTime(event);
		return A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, now, eventStartTime) && A2($mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat, now, eventEndTime);
	});
var $mdgriffith$elm_animator$Internal$Timeline$NothingCaptured = {$: 'NothingCaptured'};
var $mdgriffith$elm_animator$Internal$Timeline$hewLine = F2(
	function (now, events) {
		hewLine:
		while (true) {
			if (!events.b) {
				return $mdgriffith$elm_animator$Internal$Timeline$NothingCaptured;
			} else {
				var top = events.a;
				var remaining = events.b;
				if (A2($mdgriffith$elm_animator$Internal$Timeline$dwellingAt, now, top)) {
					return $mdgriffith$elm_animator$Internal$Timeline$Captured(
						A3(
							$mdgriffith$elm_animator$Internal$Timeline$Line,
							$mdgriffith$elm_animator$Internal$Timeline$startTime(top),
							top,
							remaining));
				} else {
					if (A2(
						$mdgriffith$elm_animator$Internal$Time$thisAfterThat,
						now,
						$mdgriffith$elm_animator$Internal$Timeline$endTime(top))) {
						var $temp$now = now,
							$temp$events = remaining;
						now = $temp$now;
						events = $temp$events;
						continue hewLine;
					} else {
						return $mdgriffith$elm_animator$Internal$Timeline$NothingCaptured;
					}
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$lineStartTime = function (_v0) {
	var start = _v0.a;
	return start;
};
var $mdgriffith$elm_animator$Internal$Timeline$garbageCollectOldEvents = F3(
	function (now, droppable, lines) {
		garbageCollectOldEvents:
		while (true) {
			if (!lines.b) {
				return $elm$core$List$reverse(droppable);
			} else {
				var _v1 = lines.a;
				var startAt = _v1.a;
				var startingEvent = _v1.b;
				var events = _v1.c;
				var remaining = lines.b;
				if (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, startAt, now)) {
					return _Utils_ap(
						$elm$core$List$reverse(droppable),
						lines);
				} else {
					if (A2($mdgriffith$elm_animator$Internal$Timeline$dwellingAt, now, startingEvent)) {
						return lines;
					} else {
						var maybeInterruptionTime = A2(
							$elm$core$Maybe$map,
							$mdgriffith$elm_animator$Internal$Timeline$lineStartTime,
							$elm$core$List$head(remaining));
						var interrupted = function () {
							if (maybeInterruptionTime.$ === 'Nothing') {
								return false;
							} else {
								var interruptionTime = maybeInterruptionTime.a;
								return A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, now, interruptionTime);
							}
						}();
						if (interrupted) {
							var $temp$now = now,
								$temp$droppable = A2(
								$elm$core$List$cons,
								A3($mdgriffith$elm_animator$Internal$Timeline$Line, startAt, startingEvent, events),
								droppable),
								$temp$lines = remaining;
							now = $temp$now;
							droppable = $temp$droppable;
							lines = $temp$lines;
							continue garbageCollectOldEvents;
						} else {
							var _v2 = A2($mdgriffith$elm_animator$Internal$Timeline$hewLine, now, events);
							if (_v2.$ === 'NothingCaptured') {
								return _Utils_ap(
									$elm$core$List$reverse(droppable),
									lines);
							} else {
								var capturedLine = _v2.a;
								return A2($elm$core$List$cons, capturedLine, remaining);
							}
						}
					}
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$clean = F2(
	function (runGC, details) {
		var running = function () {
			var _v1 = details.events;
			var lines = _v1.a;
			return A2($mdgriffith$elm_animator$Internal$Timeline$linesAreActive, details.now, lines);
		}();
		var events = function () {
			var _v0 = details.events;
			var evs = _v0.a;
			return evs;
		}();
		return _Utils_update(
			details,
			{
				events: runGC ? $mdgriffith$elm_animator$Internal$Timeline$Timetable(
					A3($mdgriffith$elm_animator$Internal$Timeline$garbageCollectOldEvents, details.now, _List_Nil, events)) : details.events,
				running: running
			});
	});
var $mdgriffith$elm_animator$Internal$Timeline$toOccurring = F2(
	function (_v0, _v1) {
		var duration = _v0.a;
		var event = _v0.b;
		var maybeDwell = _v0.c;
		var now = _v1.a;
		var events = _v1.b;
		var occursAt = A2($mdgriffith$elm_animator$Internal$Time$advanceBy, duration, now);
		var endsAt = function () {
			if (maybeDwell.$ === 'Nothing') {
				return occursAt;
			} else {
				var dwell = maybeDwell.a;
				return A2($mdgriffith$elm_animator$Internal$Time$advanceBy, dwell, occursAt);
			}
		}();
		return _Utils_Tuple2(
			endsAt,
			A2(
				$elm$core$List$cons,
				A3($mdgriffith$elm_animator$Internal$Timeline$Occurring, event, occursAt, endsAt),
				events));
	});
var $mdgriffith$elm_animator$Internal$Timeline$createLine = F2(
	function (now, scheduled) {
		var _v0 = scheduled.b;
		var dur = _v0.a;
		var startEvent = _v0.b;
		var maybeDwell = _v0.c;
		var reverseQueued = scheduled.c;
		var start = A2($mdgriffith$elm_animator$Internal$Time$advanceBy, dur, now);
		var startNextEvent = function () {
			if (maybeDwell.$ === 'Nothing') {
				return start;
			} else {
				var dwell = maybeDwell.a;
				return A2($mdgriffith$elm_animator$Internal$Time$advanceBy, dwell, start);
			}
		}();
		var events = $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_animator$Internal$Timeline$toOccurring,
				_Utils_Tuple2(startNextEvent, _List_Nil),
				$elm$core$List$reverse(reverseQueued)).b);
		return A3(
			$mdgriffith$elm_animator$Internal$Timeline$Line,
			now,
			A3($mdgriffith$elm_animator$Internal$Timeline$Occurring, startEvent, start, startNextEvent),
			events);
	});
var $mdgriffith$elm_animator$Internal$Time$latest = F2(
	function (oneQty, twoQty) {
		var one = oneQty.a;
		var two = twoQty.a;
		return ((one - two) <= 0) ? twoQty : oneQty;
	});
var $mdgriffith$elm_animator$Internal$Timeline$addEventsToLine = F4(
	function (now, scheduled, existing, lines) {
		var delay = scheduled.a;
		var scheduledStartingEvent = scheduled.b;
		var reverseQueued = scheduled.c;
		var startLineAt = existing.a;
		var startingEvent = existing.b;
		var events = existing.c;
		var start = A2($mdgriffith$elm_animator$Internal$Time$advanceBy, delay, now);
		var _v0 = $elm$core$List$reverse(events);
		if (!_v0.b) {
			var startingEventWithDwell = function () {
				var ev = startingEvent.a;
				var lastEventTime = startingEvent.b;
				return A2($mdgriffith$elm_animator$Internal$Time$thisAfterThat, start, lastEventTime) ? A3($mdgriffith$elm_animator$Internal$Timeline$Occurring, ev, lastEventTime, start) : A3($mdgriffith$elm_animator$Internal$Timeline$Occurring, ev, lastEventTime, lastEventTime);
			}();
			var startNewEventsAt = A2(
				$mdgriffith$elm_animator$Internal$Time$latest,
				A2(
					$mdgriffith$elm_animator$Internal$Time$advanceBy,
					delay,
					$mdgriffith$elm_animator$Internal$Timeline$endTime(startingEvent)),
				start);
			var newLine = A2($mdgriffith$elm_animator$Internal$Timeline$createLine, startNewEventsAt, scheduled);
			return A2(
				$elm$core$List$cons,
				A3($mdgriffith$elm_animator$Internal$Timeline$Line, startLineAt, startingEventWithDwell, _List_Nil),
				A2($elm$core$List$cons, newLine, lines));
		} else {
			var _v2 = _v0.a;
			var lastEvent = _v2.a;
			var lastEventTime = _v2.b;
			var lastEventFinish = _v2.c;
			var eventTail = _v0.b;
			var startNewEventsAt = A2(
				$mdgriffith$elm_animator$Internal$Time$latest,
				A2($mdgriffith$elm_animator$Internal$Time$advanceBy, delay, lastEventFinish),
				start);
			var newLastEvent = A3($mdgriffith$elm_animator$Internal$Timeline$Occurring, lastEvent, lastEventTime, startNewEventsAt);
			var newLine = A2($mdgriffith$elm_animator$Internal$Timeline$createLine, startNewEventsAt, scheduled);
			return A2(
				$elm$core$List$cons,
				A3(
					$mdgriffith$elm_animator$Internal$Timeline$Line,
					startLineAt,
					startingEvent,
					$elm$core$List$reverse(
						A2($elm$core$List$cons, newLastEvent, eventTail))),
				A2($elm$core$List$cons, newLine, lines));
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$addToCurrentLine = F3(
	function (now, scheduled, lines) {
		if (!lines.b) {
			return _List_fromArray(
				[
					A2($mdgriffith$elm_animator$Internal$Timeline$createLine, now, scheduled)
				]);
		} else {
			if (!lines.b.b) {
				var line = lines.a;
				return A4($mdgriffith$elm_animator$Internal$Timeline$addEventsToLine, now, scheduled, line, _List_Nil);
			} else {
				var _v1 = lines.a;
				var startOne = _v1.a;
				var startEventOne = _v1.b;
				var one = _v1.c;
				var _v2 = lines.b;
				var _v3 = _v2.a;
				var startTwo = _v3.a;
				var startEventTwo = _v3.b;
				var two = _v3.c;
				var remaining = _v2.b;
				return (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, now, startOne) && A2($mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat, now, startTwo)) ? A4(
					$mdgriffith$elm_animator$Internal$Timeline$addEventsToLine,
					now,
					scheduled,
					A3($mdgriffith$elm_animator$Internal$Timeline$Line, startOne, startEventOne, one),
					A2(
						$elm$core$List$cons,
						A3($mdgriffith$elm_animator$Internal$Timeline$Line, startTwo, startEventTwo, two),
						remaining)) : A2(
					$elm$core$List$cons,
					A3($mdgriffith$elm_animator$Internal$Timeline$Line, startOne, startEventOne, one),
					A3(
						$mdgriffith$elm_animator$Internal$Timeline$addToCurrentLine,
						now,
						scheduled,
						A2(
							$elm$core$List$cons,
							A3($mdgriffith$elm_animator$Internal$Timeline$Line, startTwo, startEventTwo, two),
							remaining)));
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$enqueue = F3(
	function (timeline, now, scheduled) {
		var _v0 = timeline.events;
		var lines = _v0.a;
		return $mdgriffith$elm_animator$Internal$Timeline$Timetable(
			A3($mdgriffith$elm_animator$Internal$Timeline$addToCurrentLine, now, scheduled, lines));
	});
var $mdgriffith$elm_animator$Internal$Timeline$applyQueued = function (timeline) {
	var _v0 = timeline.queued;
	if (_v0.$ === 'Nothing') {
		return timeline;
	} else {
		var queued = _v0.a;
		return _Utils_update(
			timeline,
			{
				events: A3($mdgriffith$elm_animator$Internal$Timeline$enqueue, timeline, timeline.now, queued),
				queued: $elm$core$Maybe$Nothing
			});
	}
};
var $mdgriffith$elm_animator$Internal$Timeline$LastTwoEvents = F4(
	function (a, b, c, d) {
		return {$: 'LastTwoEvents', a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_animator$Internal$Timeline$beforeEventEnd = F2(
	function (time, events) {
		beforeEventEnd:
		while (true) {
			if (!events.b) {
				return false;
			} else {
				var top = events.a;
				var remain = events.b;
				if (A2(
					$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
					time,
					$mdgriffith$elm_animator$Internal$Timeline$endTime(top))) {
					return true;
				} else {
					var $temp$time = time,
						$temp$events = remain;
					time = $temp$time;
					events = $temp$events;
					continue beforeEventEnd;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$beforeLineEnd = F2(
	function (time, _v0) {
		var lineStartAt = _v0.a;
		var startingEvent = _v0.b;
		var trailing = _v0.c;
		if (A2($mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat, time, lineStartAt)) {
			return true;
		} else {
			if (!trailing.b) {
				return A2(
					$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
					time,
					$mdgriffith$elm_animator$Internal$Timeline$endTime(startingEvent));
			} else {
				return A2($mdgriffith$elm_animator$Internal$Timeline$beforeEventEnd, time, trailing);
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$getTransitionAt = F3(
	function (interruptionTime, prev, trailing) {
		getTransitionAt:
		while (true) {
			if (!trailing.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var next = trailing.a;
				var remain = trailing.b;
				if (A2(
					$mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat,
					interruptionTime,
					$mdgriffith$elm_animator$Internal$Timeline$endTime(prev)) && A2(
					$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
					interruptionTime,
					$mdgriffith$elm_animator$Internal$Timeline$startTime(next))) {
					return $elm$core$Maybe$Just(
						A4(
							$mdgriffith$elm_animator$Internal$Timeline$LastTwoEvents,
							$mdgriffith$elm_animator$Internal$Timeline$endTime(prev),
							$mdgriffith$elm_animator$Internal$Timeline$getEvent(prev),
							$mdgriffith$elm_animator$Internal$Timeline$startTime(next),
							$mdgriffith$elm_animator$Internal$Timeline$getEvent(next)));
				} else {
					var $temp$interruptionTime = interruptionTime,
						$temp$prev = next,
						$temp$trailing = remain;
					interruptionTime = $temp$interruptionTime;
					prev = $temp$prev;
					trailing = $temp$trailing;
					continue getTransitionAt;
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$getScheduledEvent = function (_v0) {
	var ev = _v0.b;
	return ev;
};
var $mdgriffith$elm_animator$Internal$Timeline$adjustScheduledDuration = F2(
	function (fn, _v0) {
		var dur = _v0.a;
		var ev = _v0.b;
		var maybeDwell = _v0.c;
		return A3(
			$mdgriffith$elm_animator$Internal$Timeline$Event,
			fn(dur),
			ev,
			maybeDwell);
	});
var $mdgriffith$elm_animator$Internal$Timeline$interruptAtExactly = F3(
	function (startInterruption, scheduled, last) {
		var penultimateTime = last.a;
		var penultimate = last.b;
		var lastEventTime = last.c;
		var lastEvent = last.d;
		var delay_ = scheduled.a;
		var startingEvent = scheduled.b;
		var reverseQueued = scheduled.c;
		var amountProgress = A3($mdgriffith$elm_animator$Internal$Time$progress, penultimateTime, lastEventTime, startInterruption);
		var newStartingEvent = _Utils_eq(
			penultimate,
			$mdgriffith$elm_animator$Internal$Timeline$getScheduledEvent(startingEvent)) ? A2(
			$mdgriffith$elm_animator$Internal$Timeline$adjustScheduledDuration,
			$ianmackenzie$elm_units$Quantity$multiplyBy(amountProgress),
			startingEvent) : startingEvent;
		return A2(
			$mdgriffith$elm_animator$Internal$Timeline$createLine,
			startInterruption,
			A3($mdgriffith$elm_animator$Internal$Timeline$Schedule, delay_, newStartingEvent, reverseQueued));
	});
var $mdgriffith$elm_animator$Internal$Timeline$interruptLine = F4(
	function (startInterruption, scheduled, line, future) {
		var start = line.a;
		var startEvent = line.b;
		var trailing = line.c;
		if (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, startInterruption, start)) {
			if (!future.b) {
				var _v2 = A3($mdgriffith$elm_animator$Internal$Timeline$getTransitionAt, startInterruption, startEvent, trailing);
				if (_v2.$ === 'Nothing') {
					return A2($mdgriffith$elm_animator$Internal$Timeline$beforeLineEnd, startInterruption, line) ? $elm$core$Maybe$Just(
						_List_fromArray(
							[
								A2($mdgriffith$elm_animator$Internal$Timeline$createLine, startInterruption, scheduled)
							])) : $elm$core$Maybe$Nothing;
				} else {
					var last2Events = _v2.a;
					return $elm$core$Maybe$Just(
						_List_fromArray(
							[
								A3($mdgriffith$elm_animator$Internal$Timeline$interruptAtExactly, startInterruption, scheduled, last2Events)
							]));
				}
			} else {
				var _v3 = future.a;
				var nextStart = _v3.a;
				var next = _v3.b;
				var nextEvents = _v3.c;
				var futureRemaining = future.b;
				return (A2($mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat, startInterruption, nextStart) && A2(
					$mdgriffith$elm_animator$Internal$Time$thisBeforeOrEqualThat,
					startInterruption,
					$mdgriffith$elm_animator$Internal$Timeline$startTime(next))) ? $elm$core$Maybe$Just(
					A2(
						$elm$core$List$cons,
						A3($mdgriffith$elm_animator$Internal$Timeline$Line, nextStart, next, nextEvents),
						A2(
							$elm$core$List$cons,
							A3(
								$mdgriffith$elm_animator$Internal$Timeline$interruptAtExactly,
								startInterruption,
								scheduled,
								A4(
									$mdgriffith$elm_animator$Internal$Timeline$LastTwoEvents,
									$mdgriffith$elm_animator$Internal$Timeline$endTime(startEvent),
									$mdgriffith$elm_animator$Internal$Timeline$getEvent(startEvent),
									$mdgriffith$elm_animator$Internal$Timeline$startTime(next),
									$mdgriffith$elm_animator$Internal$Timeline$getEvent(next))),
							futureRemaining))) : $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$interruptionHappensLater = F2(
	function (startInterruption, remaining) {
		if (!remaining.b) {
			return false;
		} else {
			var top = remaining.a;
			return A2(
				$mdgriffith$elm_animator$Internal$Time$thisAfterOrEqualThat,
				startInterruption,
				$mdgriffith$elm_animator$Internal$Timeline$lineStartTime(top));
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$interruptLines = F5(
	function (now, startInterruption, scheduled, pastLines, lines) {
		interruptLines:
		while (true) {
			if (!lines.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var startLine = lines.a;
				var remaining = lines.b;
				if (A2($mdgriffith$elm_animator$Internal$Timeline$interruptionHappensLater, startInterruption, remaining)) {
					var $temp$now = now,
						$temp$startInterruption = startInterruption,
						$temp$scheduled = scheduled,
						$temp$pastLines = A2($elm$core$List$cons, startLine, pastLines),
						$temp$lines = remaining;
					now = $temp$now;
					startInterruption = $temp$startInterruption;
					scheduled = $temp$scheduled;
					pastLines = $temp$pastLines;
					lines = $temp$lines;
					continue interruptLines;
				} else {
					var _v1 = A4($mdgriffith$elm_animator$Internal$Timeline$interruptLine, startInterruption, scheduled, startLine, remaining);
					if (_v1.$ === 'Nothing') {
						var $temp$now = now,
							$temp$startInterruption = startInterruption,
							$temp$scheduled = scheduled,
							$temp$pastLines = A2($elm$core$List$cons, startLine, pastLines),
							$temp$lines = remaining;
						now = $temp$now;
						startInterruption = $temp$startInterruption;
						scheduled = $temp$scheduled;
						pastLines = $temp$pastLines;
						lines = $temp$lines;
						continue interruptLines;
					} else {
						var interruption = _v1.a;
						return (_Utils_eq(
							startInterruption,
							$mdgriffith$elm_animator$Internal$Timeline$lineStartTime(startLine)) && A2($mdgriffith$elm_animator$Internal$Time$thisAfterThat, startInterruption, now)) ? $elm$core$Maybe$Just(
							_Utils_ap(
								$elm$core$List$reverse(pastLines),
								interruption)) : $elm$core$Maybe$Just(
							_Utils_ap(
								$elm$core$List$reverse(pastLines),
								A2($elm$core$List$cons, startLine, interruption)));
					}
				}
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$interrupt = F3(
	function (details, startAt, scheduled) {
		var _v0 = details.events;
		var lines = _v0.a;
		var _v1 = A5($mdgriffith$elm_animator$Internal$Timeline$interruptLines, details.now, startAt, scheduled, _List_Nil, lines);
		if (_v1.$ === 'Nothing') {
			return A3($mdgriffith$elm_animator$Internal$Timeline$enqueue, details, startAt, scheduled);
		} else {
			var interrupted = _v1.a;
			return $mdgriffith$elm_animator$Internal$Timeline$Timetable(interrupted);
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$applyInterruptionHelper = F2(
	function (interrupts, timeline) {
		applyInterruptionHelper:
		while (true) {
			if (!interrupts.b) {
				return timeline;
			} else {
				var inter = interrupts.a;
				var remaining = interrupts.b;
				var delay = function () {
					var d = inter.a;
					return d;
				}();
				var newEvents = A3(
					$mdgriffith$elm_animator$Internal$Timeline$interrupt,
					timeline,
					A2($mdgriffith$elm_animator$Internal$Time$advanceBy, delay, timeline.now),
					inter);
				var $temp$interrupts = remaining,
					$temp$timeline = _Utils_update(
					timeline,
					{events: newEvents});
				interrupts = $temp$interrupts;
				timeline = $temp$timeline;
				continue applyInterruptionHelper;
			}
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$applyInterruptions = function (timeline) {
	var _v0 = timeline.interruption;
	if (!_v0.b) {
		return timeline;
	} else {
		return A2(
			$mdgriffith$elm_animator$Internal$Timeline$applyInterruptionHelper,
			$elm$core$List$reverse(timeline.interruption),
			_Utils_update(
				timeline,
				{interruption: _List_Nil}));
	}
};
var $mdgriffith$elm_animator$Internal$Timeline$updateWith = F3(
	function (withGC, possiblyNow, _v0) {
		var timeline = _v0.a;
		var now = A2(
			$ianmackenzie$elm_units$Quantity$max,
			$mdgriffith$elm_animator$Internal$Time$absolute(possiblyNow),
			timeline.now);
		return _Utils_eq(
			timeline.events,
			$mdgriffith$elm_animator$Internal$Timeline$Timetable(_List_Nil)) ? $mdgriffith$elm_animator$Internal$Timeline$Timeline(
			A2(
				$mdgriffith$elm_animator$Internal$Timeline$clean,
				withGC,
				$mdgriffith$elm_animator$Internal$Timeline$applyInterruptions(
					$mdgriffith$elm_animator$Internal$Timeline$applyQueued(
						_Utils_update(
							timeline,
							{
								now: now,
								events: function () {
									var firstOccurring = A3($mdgriffith$elm_animator$Internal$Timeline$Occurring, timeline.initial, now, now);
									return $mdgriffith$elm_animator$Internal$Timeline$Timetable(
										_List_fromArray(
											[
												A3($mdgriffith$elm_animator$Internal$Timeline$Line, now, firstOccurring, _List_Nil)
											]));
								}()
							}))))) : $mdgriffith$elm_animator$Internal$Timeline$Timeline(
			A2(
				$mdgriffith$elm_animator$Internal$Timeline$clean,
				withGC,
				$mdgriffith$elm_animator$Internal$Timeline$applyInterruptions(
					$mdgriffith$elm_animator$Internal$Timeline$applyQueued(
						_Utils_update(
							timeline,
							{now: now})))));
	});
var $mdgriffith$elm_animator$Internal$Timeline$update = $mdgriffith$elm_animator$Internal$Timeline$updateWith(true);
var $mdgriffith$elm_animator$Internal$Timeline$hasChanged = function (_v0) {
	var timeline = _v0.a;
	var _v1 = timeline.queued;
	if (_v1.$ === 'Nothing') {
		var _v2 = timeline.interruption;
		if (!_v2.b) {
			return false;
		} else {
			return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_animator$Internal$Timeline$justInitialized = function (_v0) {
	var timeline = _v0.a;
	var _v1 = timeline.now;
	var qty = _v1.a;
	return !qty;
};
var $mdgriffith$elm_animator$Animator$Css$watching = F3(
	function (get, set, _v0) {
		var isRunning = _v0.a;
		var updateModel = _v0.b;
		return A2(
			$mdgriffith$elm_animator$Internal$Timeline$Animator,
			function (model) {
				if (isRunning(model)) {
					return true;
				} else {
					var tl = get(model);
					return $mdgriffith$elm_animator$Internal$Timeline$hasChanged(tl) || $mdgriffith$elm_animator$Internal$Timeline$justInitialized(tl);
				}
			},
			F2(
				function (now, model) {
					var newModel = A2(updateModel, now, model);
					return A2(
						set,
						A2(
							$mdgriffith$elm_animator$Internal$Timeline$update,
							now,
							get(newModel)),
						newModel);
				}));
	});
var $author$project$Views$SidebarSheet$animator = A3(
	$mdgriffith$elm_animator$Animator$Css$watching,
	function ($) {
		return $.sheetHeight;
	},
	F2(
		function (newHeight, model) {
			return _Utils_update(
				model,
				{sheetHeight: newHeight});
		}),
	A3(
		$mdgriffith$elm_animator$Animator$Css$watching,
		function ($) {
			return $.sidebarPage;
		},
		F2(
			function (newPage, model) {
				return _Utils_update(
					model,
					{sidebarPage: newPage});
			}),
		$mdgriffith$elm_animator$Animator$animator));
var $mdgriffith$elm_animator$Internal$Timeline$onMaybe = F2(
	function (fn, maybe) {
		if (maybe.$ === 'Nothing') {
			return false;
		} else {
			var thing = maybe.a;
			return fn(thing);
		}
	});
var $mdgriffith$elm_animator$Internal$Timeline$matchesEvent = F2(
	function (matches, _v0) {
		var event = _v0.b;
		return matches(event);
	});
var $mdgriffith$elm_animator$Internal$Timeline$anyScheduled = F2(
	function (matches, _v0) {
		var dur = _v0.a;
		var startEvent = _v0.b;
		var remainingEvents = _v0.c;
		return A2($mdgriffith$elm_animator$Internal$Timeline$matchesEvent, matches, startEvent) ? true : A2(
			$elm$core$List$any,
			$mdgriffith$elm_animator$Internal$Timeline$matchesEvent(matches),
			remainingEvents);
	});
var $mdgriffith$elm_animator$Internal$Timeline$upcoming = F2(
	function (matches, _v0) {
		var details = _v0.a;
		return A2(
			$mdgriffith$elm_animator$Internal$Timeline$onMaybe,
			$mdgriffith$elm_animator$Internal$Timeline$anyScheduled(matches),
			details.queued) ? true : (A2(
			$elm$core$List$any,
			$mdgriffith$elm_animator$Internal$Timeline$anyScheduled(matches),
			details.interruption) ? true : A3(
			$mdgriffith$elm_animator$Internal$Timeline$foldp,
			$elm$core$Basics$identity,
			{
				lerp: F7(
					function (_v1, _v2, target, targetTime, _v3, _v4, state) {
						return state || (matches(target) && A2(
							$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
							details.now,
							$mdgriffith$elm_animator$Internal$Time$millis(targetTime)));
					}),
				start: function (_v5) {
					return false;
				},
				visit: F5(
					function (lookup, target, _v6, maybeLookAhead, state) {
						return matches(
							$mdgriffith$elm_animator$Internal$Timeline$getEvent(target)) && A2(
							$mdgriffith$elm_animator$Internal$Time$thisBeforeThat,
							details.now,
							$mdgriffith$elm_animator$Internal$Timeline$startTime(target));
					}),
				adjustor: function (_v7) {
					return $mdgriffith$elm_animator$Internal$Timeline$linearDefault;
				},
				dwellPeriod: function (_v8) {
					return $elm$core$Maybe$Nothing;
				}
			},
			$mdgriffith$elm_animator$Internal$Timeline$Timeline(
				_Utils_update(
					details,
					{
						now: $mdgriffith$elm_animator$Internal$Time$millis(1 / 0)
					}))));
	});
var $mdgriffith$elm_animator$Animator$upcoming = function (state) {
	return $mdgriffith$elm_animator$Internal$Timeline$upcoming(
		$elm$core$Basics$eq(state));
};
var $elm_community$list_extra$List$Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) < 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						minBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Views$SidebarSheet$OnClick = {$: 'OnClick'};
var $zaboco$elm_draggable$Draggable$Events$onClick = F2(
	function (toMsg, config) {
		return _Utils_update(
			config,
			{
				onClick: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, toMsg)
			});
	});
var $author$project$Views$SidebarSheet$OnDragBy = function (a) {
	return {$: 'OnDragBy', a: a};
};
var $zaboco$elm_draggable$Draggable$Events$onDragBy = F2(
	function (toMsg, config) {
		return _Utils_update(
			config,
			{
				onDragBy: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, toMsg)
			});
	});
var $author$project$Views$SidebarSheet$OnDragEnd = {$: 'OnDragEnd'};
var $zaboco$elm_draggable$Draggable$Events$onDragEnd = F2(
	function (toMsg, config) {
		return _Utils_update(
			config,
			{
				onDragEnd: $elm$core$Maybe$Just(toMsg)
			});
	});
var $zaboco$elm_draggable$Draggable$Config = function (a) {
	return {$: 'Config', a: a};
};
var $zaboco$elm_draggable$Internal$defaultConfig = {
	onClick: function (_v0) {
		return $elm$core$Maybe$Nothing;
	},
	onDragBy: function (_v1) {
		return $elm$core$Maybe$Nothing;
	},
	onDragEnd: $elm$core$Maybe$Nothing,
	onDragStart: function (_v2) {
		return $elm$core$Maybe$Nothing;
	},
	onMouseDown: function (_v3) {
		return $elm$core$Maybe$Nothing;
	}
};
var $zaboco$elm_draggable$Draggable$customConfig = function (events) {
	return $zaboco$elm_draggable$Draggable$Config(
		A3($elm$core$List$foldl, $elm$core$Basics$apL, $zaboco$elm_draggable$Internal$defaultConfig, events));
};
var $author$project$Views$SidebarSheet$dragConfig = $zaboco$elm_draggable$Draggable$customConfig(
	_List_fromArray(
		[
			$zaboco$elm_draggable$Draggable$Events$onDragEnd($author$project$Views$SidebarSheet$OnDragEnd),
			$zaboco$elm_draggable$Draggable$Events$onDragBy($author$project$Views$SidebarSheet$OnDragBy),
			$zaboco$elm_draggable$Draggable$Events$onClick(
			$elm$core$Basics$always($author$project$Views$SidebarSheet$OnClick))
		]));
var $author$project$Views$SidebarSheet$sheetBreakpoint = 768;
var $author$project$Views$SidebarSheet$update = F3(
	function (config, msg, state) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					A3($mdgriffith$elm_animator$Animator$update, t, $author$project$Views$SidebarSheet$animator, state),
					$elm$core$Platform$Cmd$none);
			case 'OnResizeWindow':
				var width = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							sheetActive: _Utils_cmp(width, $author$project$Views$SidebarSheet$sheetBreakpoint) < 0
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnClick':
				var newHeight = _Utils_eq(
					$elm$core$Maybe$Just(
						$elm$core$Basics$round(
							$mdgriffith$elm_animator$Animator$current(state.sheetHeight))),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$round,
						$elm$core$List$head(config.detents))) ? $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						$mdgriffith$elm_animator$Animator$current(state.sheetHeight),
						$elm_community$list_extra$List$Extra$last(config.detents))) : (_Utils_eq(
					$elm$core$Maybe$Just(
						$elm$core$Basics$round(
							$mdgriffith$elm_animator$Animator$current(state.sheetHeight))),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$round,
						$elm_community$list_extra$List$Extra$last(config.detents))) ? $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						$mdgriffith$elm_animator$Animator$current(state.sheetHeight),
						$elm$core$List$head(config.detents))) : $elm$core$Maybe$Nothing);
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							sheetActive: true,
							sheetHeight: A2(
								$elm$core$Maybe$withDefault,
								state.sheetHeight,
								A2(
									$elm$core$Maybe$map,
									function (h) {
										return A3($mdgriffith$elm_animator$Animator$go, $mdgriffith$elm_animator$Animator$quickly, h, state.sheetHeight);
									},
									newHeight))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragBy':
				var _v1 = msg.a;
				var dy = _v1.b;
				var height = $mdgriffith$elm_animator$Animator$init(
					$mdgriffith$elm_animator$Animator$current(state.sheetHeight) - dy);
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{sheetActive: true, sheetHeight: height}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragEnd':
				var detentHeight = A2(
					$elm$core$Maybe$withDefault,
					54,
					A2(
						$elm_community$list_extra$List$Extra$minimumBy,
						function (d) {
							return $elm$core$Basics$abs(
								$mdgriffith$elm_animator$Animator$current(state.sheetHeight) - d);
						},
						config.detents));
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							sheetActive: true,
							sheetHeight: A3($mdgriffith$elm_animator$Animator$go, $mdgriffith$elm_animator$Animator$quickly, detentHeight, state.sheetHeight)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var dragMsg = msg.a;
				var _v2 = A3($zaboco$elm_draggable$Draggable$update, $author$project$Views$SidebarSheet$dragConfig, dragMsg, state);
				var updatedState = _v2.a;
				var cmd = _v2.b;
				return A2(
					$elm$core$List$any,
					function (d) {
						return A2($mdgriffith$elm_animator$Animator$upcoming, d, state.sheetHeight);
					},
					A2(
						$elm$core$List$filter,
						function (d) {
							return !_Utils_eq(
								$mdgriffith$elm_animator$Animator$current(state.sheetHeight),
								d);
						},
						config.detents)) ? _Utils_Tuple2(state, cmd) : _Utils_Tuple2(updatedState, cmd);
		}
	});
var $author$project$Pages$Fleet_$dropLast = function (list) {
	if (!list.b) {
		return _List_Nil;
	} else {
		if (!list.b.b) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$take,
				$elm$core$List$length(list) - 1,
				list);
		}
	}
};
var $author$project$Views$SidebarSheet$showPage = F2(
	function (page, state) {
		return _Utils_update(
			state,
			{
				sidebarPage: A3($mdgriffith$elm_animator$Animator$go, $mdgriffith$elm_animator$Animator$quickly, page, state.sidebarPage)
			});
	});
var $author$project$Pages$Fleet_$boatWithId = F2(
	function (id, bs) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (b) {
					return _Utils_eq(b.boatId, id);
				},
				bs));
	});
var $author$project$Pages$Fleet_$sheetConfig = function (model) {
	var _v0 = model.mapSize;
	var h = _v0.b;
	return {
		detents: _List_fromArray(
			[54, h * 0.4, h - 90])
	};
};
var $author$project$Geospatial$MapProjection$fmod = F2(
	function (n, d) {
		var tquot = (n / d) | 0;
		return n - (tquot * d);
	});
var $author$project$Geospatial$MapProjection$normaliseLatLong = function (ll) {
	return {
		lat: ll.lat,
		_long: A2($author$project$Geospatial$MapProjection$fmod, ll._long + 180.0, 360.0) - 180.0
	};
};
var $author$project$Geospatial$MapProjection$normaliseBounds = function (b) {
	return {
		zoom: b.zoom,
		bounds: {
			northEast: $author$project$Geospatial$MapProjection$normaliseLatLong(b.bounds.northEast),
			southWest: $author$project$Geospatial$MapProjection$normaliseLatLong(b.bounds.southWest)
		},
		centre: $author$project$Geospatial$MapProjection$normaliseLatLong(b.centre)
	};
};
var $author$project$Geospatial$MapProjection$positionFromBounds = function (b) {
	return {zoom: b.zoom, centre: b.centre};
};
var $author$project$Ports$requestEventStream = _Platform_outgoingPort(
	'requestEventStream',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Shared$UpdateTrackDuration = function (a) {
	return {$: 'UpdateTrackDuration', a: a};
};
var $mdgriffith$elm_animator$Animator$immediately = $mdgriffith$elm_animator$Animator$millis(0);
var $author$project$Views$SidebarSheet$showPageImmediately = F2(
	function (page, state) {
		return _Utils_update(
			state,
			{
				sidebarPage: A3($mdgriffith$elm_animator$Animator$go, $mdgriffith$elm_animator$Animator$immediately, page, state.sidebarPage)
			});
	});
var $author$project$Shared$SetDefaultMapPosition = function (a) {
	return {$: 'SetDefaultMapPosition', a: a};
};
var $author$project$Data$Track$Track = F2(
	function (trackId, points) {
		return {points: points, trackId: trackId};
	});
var $author$project$Data$Track$TrackPoint = F2(
	function (latLong, timestamp) {
		return {latLong: latLong, timestamp: timestamp};
	});
var $author$project$Data$Track$trackPointDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Track$TrackPoint,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Geospatial$LatLong$LatLong,
		A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'long', $elm$json$Json$Decode$float)),
	A2($elm$json$Json$Decode$field, 'timestamp', $jweir$elm_iso8601$ISO8601$decode));
var $author$project$Data$Track$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Track$Track,
	A2($elm$json$Json$Decode$field, 'trackId', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'points',
		$elm$json$Json$Decode$list($author$project$Data$Track$trackPointDecoder)));
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 'QueryParameter', a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Api$fetchTracks = F7(
	function (token, apiUrl, fleet, bId, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'boats',
								$author$project$Data$Boat$boatIdToString(bId),
								'track'
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
							$elm_community$maybe_extra$Maybe$Extra$toList(
								A2(
									$elm$core$Maybe$map,
									function (e) {
										return A2(
											$elm$url$Url$Builder$string,
											'end',
											$jweir$elm_iso8601$ISO8601$toString(e));
									},
									end)))),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Track$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$OnLoadTracks = function (a) {
	return {$: 'OnLoadTracks', a: a};
};
var $author$project$Data$TrackDuration$lastTripOnly = function (r) {
	if (r.$ === 'LastTripToday') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$fetchLastTrack = F6(
	function (token, apiUrl, fleet, bId, start, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'boats',
								$author$project$Data$Boat$boatIdToString(bId),
								'track'
							]),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2($elm$url$Url$Builder$string, 'lastOnly', 'true')
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Track$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$fetchTracksForSelectedBoat = F2(
	function (session, model) {
		var _v0 = model.selectedBoat;
		if (_v0.$ === 'Just') {
			var b = _v0.a;
			var _v1 = A3($author$project$Data$TrackDuration$toStartEnd, model.currentTime, model.timeZone, model.trackDuration);
			var start = _v1.a;
			return $author$project$Data$TrackDuration$lastTripOnly(model.trackDuration) ? A6(
				$author$project$Api$fetchLastTrack,
				session.authToken,
				model.apiUrl,
				model.fleet.slug,
				b.boatId,
				$jweir$elm_iso8601$ISO8601$fromPosix(start),
				$author$project$Pages$Fleet_$OnLoadTracks) : A7(
				$author$project$Api$fetchTracks,
				session.authToken,
				model.apiUrl,
				model.fleet.slug,
				b.boatId,
				$jweir$elm_iso8601$ISO8601$fromPosix(start),
				$elm$core$Maybe$Nothing,
				$author$project$Pages$Fleet_$OnLoadTracks);
		} else {
			return $author$project$Effect$none;
		}
	});
var $author$project$Pages$Fleet_$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Effect$none);
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'OnResizeWindow':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Fleet_$OnGetMapElement,
							$elm$browser$Browser$Dom$getElement('map'))));
			case 'OnGetMapElement':
				if (msg.a.$ === 'Ok') {
					var element = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mapSize: _Utils_Tuple2(element.element.width, element.element.height)
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'InitialiseMap':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$MapCommands$jumpTo(
									_List_fromArray(
										[
											$author$project$Mapbox$Cmd$Option$center(
											{lat: model.mapPosition.centre.lat, lng: model.mapPosition.centre._long}),
											$author$project$Mapbox$Cmd$Option$zoom(model.mapPosition.zoom)
										]))
								]))));
			case 'MapIdle':
				var b = msg.a;
				var pos = $author$project$Geospatial$MapProjection$positionFromBounds(
					$author$project$Geospatial$MapProjection$normaliseBounds(b));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapPosition: pos}),
					$author$project$Effect$fromShared(
						$author$project$Shared$SetDefaultMapPosition(
							$elm$core$Maybe$Just(pos))));
			case 'SelectBoat':
				var boatId = msg.a;
				var newZoom = A2($elm$core$Basics$max, model.mapPosition.zoom, 15.0);
				var boat = A2($author$project$Pages$Fleet_$boatWithId, boatId, model.boats);
				var newMapPosition = A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return A2(
							$elm$core$Maybe$map,
							function (ll) {
								return {
									zoom: newZoom,
									centre: {lat: ll.lat, _long: ll._long}
								};
							},
							b.latLong);
					},
					boat);
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 1, model.sheet),
						tracks: _List_Nil,
						mapPosition: A2($elm$core$Maybe$withDefault, model.mapPosition, newMapPosition),
						selectedBoat: boat
					});
				var selectBoatEffect = function () {
					if (boat.$ === 'Just') {
						return $author$project$Effect$batch(
							_List_fromArray(
								[
									A2($author$project$Pages$Fleet_$fetchTracksForSelectedBoat, session, updatedModel),
									$author$project$Effect$fromCmd(
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Ports$startProgressBar(_Utils_Tuple0),
												A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Platform$Cmd$none,
												A2(
													$elm$core$Maybe$map,
													function (p) {
														return $author$project$MapCommands$flyTo(
															_List_fromArray(
																[
																	$author$project$Mapbox$Cmd$Option$center(
																	{lat: p.centre.lat, lng: p.centre._long}),
																	$author$project$Mapbox$Cmd$Option$zoom(p.zoom),
																	$author$project$Mapbox$Cmd$Option$speed(2.0)
																]));
													},
													newMapPosition))
											])))
								]));
					} else {
						return $author$project$Effect$none;
					}
				}();
				return _Utils_Tuple2(updatedModel, selectBoatEffect);
			case 'DeselectBoat':
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
						tracks: _List_Nil,
						selectedBoat: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'SelectTrackDuration':
				var duration = msg.a;
				var updatedModel = _Utils_update(
					model,
					{trackDuration: duration});
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromShared(
								$author$project$Shared$UpdateTrackDuration(duration)),
								A2($author$project$Pages$Fleet_$fetchTracksForSelectedBoat, session, updatedModel)
							])));
			case 'MapClicked':
				var latLong = msg.a;
				var updatedModel = model.measureModeActive ? _Utils_update(
					model,
					{
						measureLine: _Utils_ap(
							model.measureLine,
							_List_fromArray(
								[
									{lat: latLong.lat, _long: latLong._long},
									{lat: latLong.lat, _long: latLong._long}
								]))
					}) : _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
						tracks: _List_Nil,
						selectedBoat: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'MapMouseMove':
				var latLong = msg.a;
				if (model.measureModeActive) {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: _Utils_ap(
								$author$project$Pages$Fleet_$dropLast(model.measureLine),
								_List_fromArray(
									[
										{lat: latLong.lat, _long: latLong._long}
									]))
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'OnLoadTracks':
				if (msg.a.$ === 'Ok') {
					var t = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{tracks: t});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchGeofences':
				if (msg.a.$ === 'Ok') {
					var gs = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{geofences: gs});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'ControlClicked':
				var id = msg.a;
				if (id === 'measure') {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: model.measureModeActive ? _List_Nil : model.measureLine,
							measureModeActive: !model.measureModeActive
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'StartServerEvents':
				var updatedModel = _Utils_update(
					model,
					{
						boats: _List_Nil,
						sheet: A2($author$project$Views$SidebarSheet$showPageImmediately, 0, model.sheet),
						boatsLoaded: false,
						selectedBoat: $elm$core$Maybe$Nothing
					});
				var startCmd = $author$project$Effect$fromCmd(
					$author$project$Ports$requestEventStream(
						_Utils_Tuple2(
							A3(
								$elm$url$Url$Builder$crossOrigin,
								model.apiUrl,
								_List_fromArray(
									['fleet', model.fleet.slug, 'server-events']),
								_List_Nil),
							$author$project$Data$Session$tokenToString(session.authToken.token))));
				return _Utils_Tuple2(updatedModel, startCmd);
			case 'OnServerEventError':
				var _v3 = msg.a;
				var code = _v3.a;
				if (code === 401) {
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromShared($author$project$Shared$SignOut));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: 'Server Error (' + ($elm$core$String$fromInt(code) + ')')
									})
							}),
						$author$project$Effect$none);
				}
			case 'OnReceiveServerEvent':
				var e = msg.a;
				var updatedGeofences = function () {
					var _v12 = e.event;
					_v12$3:
					while (true) {
						if (_v12.$ === 'Just') {
							switch (_v12.a) {
								case 'refreshGeofences':
									return A2(
										$elm$core$Maybe$withDefault,
										model.geofences,
										$elm$core$Result$toMaybe(
											A2(
												$elm$json$Json$Decode$decodeString,
												$elm$json$Json$Decode$list($author$project$Data$Geofence$decode),
												e.data)));
								case 'updateGeofence':
									return A2(
										$elm$core$Maybe$withDefault,
										model.geofences,
										A2(
											$elm$core$Maybe$map,
											function (gf) {
												return A2(
													$elm$core$List$cons,
													gf,
													A2(
														$elm$core$List$filter,
														function (f) {
															return !_Utils_eq(f.fenceId, gf.fenceId);
														},
														model.geofences));
											},
											$elm$core$Result$toMaybe(
												A2($elm$json$Json$Decode$decodeString, $author$project$Data$Geofence$decode, e.data))));
								case 'deleteGeofence':
									return A2(
										$elm$core$Maybe$withDefault,
										model.geofences,
										A2(
											$elm$core$Maybe$map,
											function (i) {
												return A2(
													$elm$core$List$filter,
													function (f) {
														return !_Utils_eq(f.fenceId, i);
													},
													model.geofences);
											},
											$elm$core$Result$toMaybe(
												A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$string, e.data))));
								default:
									break _v12$3;
							}
						} else {
							break _v12$3;
						}
					}
					return model.geofences;
				}();
				var refreshedBoats = function () {
					var _v11 = e.event;
					if ((_v11.$ === 'Just') && (_v11.a === 'refreshBoats')) {
						return $elm$core$Result$toMaybe(
							A2(
								$elm$json$Json$Decode$decodeString,
								$elm$json$Json$Decode$list($author$project$Data$Boat$decode),
								e.data));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var updatedPlaces = function () {
					var _v10 = e.event;
					_v10$3:
					while (true) {
						if (_v10.$ === 'Just') {
							switch (_v10.a) {
								case 'refreshPlaces':
									return A2(
										$elm$core$Maybe$withDefault,
										model.places,
										$elm$core$Result$toMaybe(
											A2(
												$elm$json$Json$Decode$decodeString,
												$elm$json$Json$Decode$list($author$project$Data$Place$decode),
												e.data)));
								case 'updatePlace':
									return A2(
										$elm$core$Maybe$withDefault,
										model.places,
										A2(
											$elm$core$Maybe$map,
											function (pl) {
												return A2(
													$elm$core$List$cons,
													pl,
													A2(
														$elm$core$List$filter,
														function (p) {
															return !_Utils_eq(p.placeId, pl.placeId);
														},
														model.places));
											},
											$elm$core$Result$toMaybe(
												A2($elm$json$Json$Decode$decodeString, $author$project$Data$Place$decode, e.data))));
								case 'deletePlace':
									return A2(
										$elm$core$Maybe$withDefault,
										model.places,
										A2(
											$elm$core$Maybe$map,
											function (i) {
												return A2(
													$elm$core$List$filter,
													function (p) {
														return !_Utils_eq(p.placeId, i);
													},
													model.places);
											},
											$elm$core$Result$toMaybe(
												A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$string, e.data))));
								default:
									break _v10$3;
							}
						} else {
							break _v10$3;
						}
					}
					return model.places;
				}();
				var updatedFleet = function () {
					var _v9 = e.event;
					if ((_v9.$ === 'Just') && (_v9.a === 'fleetUpdated')) {
						return A2(
							$elm$core$Maybe$withDefault,
							model.fleet,
							$elm$core$Result$toMaybe(
								A2($elm$json$Json$Decode$decodeString, $author$project$Data$Fleet$decode, e.data)));
					} else {
						return model.fleet;
					}
				}();
				var updatedBoats = $author$project$Data$Boat$sort(
					function () {
						var _v8 = e.event;
						_v8$3:
						while (true) {
							if (_v8.$ === 'Just') {
								switch (_v8.a) {
									case 'refreshBoats':
										return A2($elm$core$Maybe$withDefault, model.boats, refreshedBoats);
									case 'boatUpdated':
										return A2(
											$elm$core$Maybe$withDefault,
											model.boats,
											A2(
												$elm$core$Maybe$map,
												function (bt) {
													return A2(
														$elm$core$List$cons,
														bt,
														A2(
															$elm$core$List$filter,
															function (b) {
																return !_Utils_eq(b.boatId, bt.boatId);
															},
															model.boats));
												},
												$elm$core$Result$toMaybe(
													A2($elm$json$Json$Decode$decodeString, $author$project$Data$Boat$decode, e.data))));
									case 'boatRemoved':
										return A2(
											$elm$core$Maybe$withDefault,
											model.boats,
											A2(
												$elm$core$Maybe$map,
												function (i) {
													return A2(
														$elm$core$List$filter,
														function (b) {
															return !_Utils_eq(b.boatId, i);
														},
														model.boats);
												},
												$elm$core$Result$toMaybe(
													A2($elm$json$Json$Decode$decodeString, $author$project$Data$Boat$boatIdDecoder, e.data))));
									default:
										break _v8$3;
								}
							} else {
								break _v8$3;
							}
						}
						return model.boats;
					}());
				var updatedSelectedBoat = A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return A2($author$project$Pages$Fleet_$boatWithId, b.boatId, updatedBoats);
					},
					model.selectedBoat);
				var updatedSheet = function () {
					var _v5 = _Utils_Tuple2(model.selectedBoat, updatedSelectedBoat);
					_v5$2:
					while (true) {
						if (_v5.a.$ === 'Just') {
							if (_v5.b.$ === 'Nothing') {
								var _v6 = _v5.b;
								return A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet);
							} else {
								break _v5$2;
							}
						} else {
							if (_v5.b.$ === 'Just') {
								var _v7 = _v5.a;
								return A2($author$project$Views$SidebarSheet$showPage, 1, model.sheet);
							} else {
								break _v5$2;
							}
						}
					}
					return model.sheet;
				}();
				var updatedModel = _Utils_update(
					model,
					{
						boats: updatedBoats,
						fleet: updatedFleet,
						sheet: updatedSheet,
						places: updatedPlaces,
						geofences: updatedGeofences,
						boatsLoaded: model.boatsLoaded || $elm_community$maybe_extra$Maybe$Extra$isJust(refreshedBoats),
						selectedBoat: updatedSelectedBoat
					});
				return _Utils_Tuple2(
					updatedModel,
					_Utils_eq(model.selectedBoat, updatedSelectedBoat) ? $author$project$Effect$none : A2($author$project$Pages$Fleet_$fetchTracksForSelectedBoat, session, updatedModel));
			case 'UpdateBoatSearch':
				var search = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{boatSearch: search}),
					$author$project$Effect$none);
			case 'SelectBoatSort':
				var sortOption = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{boatSort: sortOption}),
					$author$project$Effect$none);
			case 'SheetMsg':
				var sheetMsg = msg.a;
				var _v13 = A3(
					$author$project$Views$SidebarSheet$update,
					$author$project$Pages$Fleet_$sheetConfig(model),
					sheetMsg,
					model.sheet);
				var updatedSheet = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sheet: updatedSheet}),
					$author$project$Effect$fromCmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$SheetMsg, cmd)));
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			case 'Logout':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 'Every', a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {taggers: taggers, processes: processes};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 'Nothing') {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.processes;
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(_Utils_Tuple0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.taggers);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 'MySub', a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {pids: pids, subs: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {key: key, event: event};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (node.$ === 'Document') {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (node.$ === 'Document') {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.pids,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var event = _v0.event;
		var key = _v0.key;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.subs);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$Window = {$: 'Window'};
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		$elm$browser$Browser$Events$Window,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Views$SidebarSheet$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $elm$browser$Browser$Events$Document = {$: 'Document'};
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mouseup');
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mousemove');
var $zaboco$elm_draggable$Draggable$subscriptions = F2(
	function (envelope, _v0) {
		var drag = _v0.a;
		if (drag.$ === 'NotDragging') {
			return $elm$core$Platform$Sub$none;
		} else {
			return A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, envelope, $zaboco$elm_draggable$Draggable$Msg),
				$elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2($elm$json$Json$Decode$map, $zaboco$elm_draggable$Internal$DragAt, $zaboco$elm_draggable$Draggable$positionDecoder)),
							$elm$browser$Browser$Events$onMouseUp(
							$elm$json$Json$Decode$succeed($zaboco$elm_draggable$Internal$StopDragging))
						])));
		}
	});
var $author$project$Views$SidebarSheet$OnResizeWindow = F2(
	function (a, b) {
		return {$: 'OnResizeWindow', a: a, b: b};
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 'Time', a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {subs: subs, oldTime: oldTime, request: request};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(_Utils_Tuple0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(_Utils_Tuple0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var oldTime = _v0.oldTime;
		var request = _v0.request;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 'Nothing') {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var oldTime = _v0.oldTime;
		var subs = _v0.subs;
		var send = function (sub) {
			if (sub.$ === 'Time') {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 'Delta', a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (sub.$ === 'Time') {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $mdgriffith$elm_animator$Animator$toSubscription = F3(
	function (toMsg, model, _v0) {
		var isRunning = _v0.a;
		return isRunning(model) ? $elm$browser$Browser$Events$onAnimationFrame(toMsg) : $elm$core$Platform$Sub$none;
	});
var $author$project$Views$SidebarSheet$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($zaboco$elm_draggable$Draggable$subscriptions, $author$project$Views$SidebarSheet$DragMsg, model.drag),
				$elm$browser$Browser$Events$onResize($author$project$Views$SidebarSheet$OnResizeWindow),
				A3($mdgriffith$elm_animator$Animator$toSubscription, $author$project$Views$SidebarSheet$OnTick, model, $author$project$Views$SidebarSheet$animator)
			]));
};
var $author$project$Pages$Fleet_$OnResizeWindow = F2(
	function (a, b) {
		return {$: 'OnResizeWindow', a: a, b: b};
	});
var $author$project$Pages$Fleet_$OnServerEventError = function (a) {
	return {$: 'OnServerEventError', a: a};
};
var $author$project$Ports$receiveServerEvent = _Platform_incomingPort(
	'receiveServerEvent',
	A2(
		$elm$json$Json$Decode$andThen,
		function (event) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (data) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (id) {
							return $elm$json$Json$Decode$succeed(
								{id: id, data: data, event: event});
						},
						A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'event',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))));
var $author$project$Pages$Fleet_$OnReceiveServerEvent = function (a) {
	return {$: 'OnReceiveServerEvent', a: a};
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Ports$serverEventConnectionError = _Platform_incomingPort(
	'serverEventConnectionError',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int)));
var $author$project$Pages$Fleet_$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 30 * 1000, $author$project$Pages$Fleet_$OnTick),
				$author$project$Ports$receiveServerEvent($author$project$Pages$Fleet_$OnReceiveServerEvent),
				$author$project$Ports$serverEventConnectionError($author$project$Pages$Fleet_$OnServerEventError),
				$elm$browser$Browser$Events$onResize($author$project$Pages$Fleet_$OnResizeWindow),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Fleet_$SheetMsg,
				$author$project$Views$SidebarSheet$subscriptions(model.sheet))
			]));
};
var $author$project$Pages$Fleet_$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$init, session, shared, req),
					view: A3($author$project$Pages$Fleet_$view, session, req, shared.featureDropState),
					update: $author$project$Pages$Fleet_$update(session),
					subscriptions: $author$project$Pages$Fleet_$subscriptions
				};
			});
	});
var $author$project$Views$DropZone$Model = F3(
	function (hover, existingImage, preview) {
		return {hover: hover, preview: preview, existingImage: existingImage};
	});
var $author$project$Views$DropZone$init = function (existingImage) {
	return A3($author$project$Views$DropZone$Model, false, existingImage, $elm$core$Maybe$Nothing);
};
var $enbala$elm_form$Form$F = function (a) {
	return {$: 'F', a: a};
};
var $enbala$elm_form$Form$Tree$Group = function (a) {
	return {$: 'Group', a: a};
};
var $enbala$elm_form$Form$Tree$group = function (items) {
	return $enbala$elm_form$Form$Tree$Group(
		$elm$core$Dict$fromList(items));
};
var $enbala$elm_form$Form$updateValidate = F2(
	function (validation, model) {
		var _v0 = validation(model.fields);
		if (_v0.$ === 'Ok') {
			var output = _v0.a;
			return _Utils_update(
				model,
				{
					errors: $enbala$elm_form$Form$Tree$group(_List_Nil),
					output: $elm$core$Maybe$Just(output)
				});
		} else {
			var error = _v0.a;
			return _Utils_update(
				model,
				{errors: error, output: $elm$core$Maybe$Nothing});
		}
	});
var $enbala$elm_form$Form$initial = F2(
	function (initialFields, validation) {
		var model = {
			focus: $elm$core$Maybe$Nothing,
			errors: $enbala$elm_form$Form$Tree$group(_List_Nil),
			fields: $enbala$elm_form$Form$Tree$group(initialFields),
			output: $elm$core$Maybe$Nothing,
			dirtyFields: $elm$core$Set$empty,
			isSubmitted: false,
			changedFields: $elm$core$Set$empty,
			originalValues: $elm$core$Dict$empty
		};
		return $enbala$elm_form$Form$F(
			A2($enbala$elm_form$Form$updateValidate, validation, model));
	});
var $author$project$Views$FleetForm$initial = {
	name: '',
	slug: '',
	fleetType: $author$project$Data$Fleet$Tourism,
	isPrivate: false,
	speedUnit: $author$project$Data$SpeedUnit$Knots,
	helmApiKey: $elm$core$Maybe$Nothing,
	timeZoneId: 'Australia/Perth',
	isSeaRescue: false,
	mapPosition: {
		zoom: 16.0,
		centre: {lat: -32.06173, _long: 115.74144}
	},
	helmTenantId: $elm$core$Maybe$Nothing,
	helmEventTypeId: $elm$core$Maybe$Nothing,
	longDistanceUnit: $author$project$Data$DistanceUnit$NauticalMiles,
	shortDistanceUnit: $author$project$Data$DistanceUnit$Metres,
	isDashboardEnabled: false,
	notificationGroups: _List_Nil,
	speedAlertsEnabled: false
};
var $enbala$elm_form$Form$Validate$map = F3(
	function (f, validation, validationField) {
		return A2(
			$elm$core$Result$map,
			f,
			validation(validationField));
	});
var $enbala$elm_form$Form$Field$asBool = function (field) {
	if ((field.$ === 'Value') && (field.a.$ === 'Bool')) {
		var b = field.a.a;
		return $elm$core$Maybe$Just(b);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $enbala$elm_form$Form$Validate$bool = function (v) {
	var _v0 = $enbala$elm_form$Form$Field$asBool(v);
	if (_v0.$ === 'Just') {
		var b = _v0.a;
		return $elm$core$Result$Ok(b);
	} else {
		return $elm$core$Result$Ok(false);
	}
};
var $enbala$elm_form$Form$Validate$fail = F2(
	function (error, validationField) {
		return $elm$core$Result$Err(error);
	});
var $enbala$elm_form$Form$Tree$Value = function (a) {
	return {$: 'Value', a: a};
};
var $enbala$elm_form$Form$Tree$getAtName = F2(
	function (name, value) {
		if (value.$ === 'Group') {
			var items = value.a;
			return A2($elm$core$Dict$get, name, items);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $enbala$elm_form$Form$Field$EmptyField = {$: 'EmptyField'};
var $enbala$elm_form$Form$Validate$field = F3(
	function (key, validation, validationField) {
		return A2(
			$elm$core$Result$mapError,
			function (e) {
				return $enbala$elm_form$Form$Tree$group(
					_List_fromArray(
						[
							_Utils_Tuple2(key, e)
						]));
			},
			validation(
				A2(
					$elm$core$Maybe$withDefault,
					$enbala$elm_form$Form$Tree$Value($enbala$elm_form$Form$Field$EmptyField),
					A2($enbala$elm_form$Form$Tree$getAtName, key, validationField))));
	});
var $enbala$elm_form$Form$Error$Empty = {$: 'Empty'};
var $enbala$elm_form$Form$Error$value = $enbala$elm_form$Form$Tree$Value;
var $enbala$elm_form$Form$Validate$oneOf = F2(
	function (validations, validationField) {
		var walkResults = F2(
			function (result, combined) {
				var _v0 = _Utils_Tuple2(combined, result);
				if (_v0.a.$ === 'Ok') {
					return combined;
				} else {
					return result;
				}
			});
		var results = A2(
			$elm$core$List$map,
			function (v) {
				return v(validationField);
			},
			validations);
		return A3(
			$elm$core$List$foldl,
			walkResults,
			$elm$core$Result$Err(
				$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$Empty)),
			results);
	});
var $enbala$elm_form$Form$Validate$errMaybe = function (res) {
	if (res.$ === 'Ok') {
		return $elm$core$Maybe$Nothing;
	} else {
		var e = res.a;
		return $elm$core$Maybe$Just(e);
	}
};
var $enbala$elm_form$Form$Validate$groupErrorsUnion = F2(
	function (e1, e2) {
		var _v0 = _Utils_Tuple2(e1, e2);
		if ((_v0.a.$ === 'Group') && (_v0.b.$ === 'Group')) {
			var g1 = _v0.a.a;
			var g2 = _v0.b.a;
			return $enbala$elm_form$Form$Tree$Group(
				A2($elm$core$Dict$union, g1, g2));
		} else {
			return e2;
		}
	});
var $enbala$elm_form$Form$Validate$mergeMany = function (errors) {
	return A3(
		$elm$core$List$foldl,
		$enbala$elm_form$Form$Validate$groupErrorsUnion,
		$enbala$elm_form$Form$Tree$group(_List_Nil),
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, errors));
};
var $enbala$elm_form$Form$Validate$andMap = F3(
	function (aValidation, partialValidation, validationField) {
		var _v0 = _Utils_Tuple2(
			partialValidation(validationField),
			aValidation(validationField));
		if ((_v0.a.$ === 'Ok') && (_v0.b.$ === 'Ok')) {
			var partial = _v0.a.a;
			var a = _v0.b.a;
			return $elm$core$Result$Ok(
				partial(a));
		} else {
			var partialResult = _v0.a;
			var aResult = _v0.b;
			return $elm$core$Result$Err(
				$enbala$elm_form$Form$Validate$mergeMany(
					_List_fromArray(
						[
							$enbala$elm_form$Form$Validate$errMaybe(partialResult),
							$enbala$elm_form$Form$Validate$errMaybe(aResult)
						])));
		}
	});
var $enbala$elm_form$Form$Field$asString = function (field) {
	if ((field.$ === 'Value') && (field.a.$ === 'String')) {
		var s = field.a.a;
		return $elm$core$Maybe$Just(s);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $enbala$elm_form$Form$Error$InvalidString = {$: 'InvalidString'};
var $enbala$elm_form$Form$Validate$string = function (v) {
	var _v0 = $enbala$elm_form$Form$Field$asString(v);
	if (_v0.$ === 'Just') {
		var s = _v0.a;
		return $elm$core$String$isEmpty(s) ? $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$Empty)) : $elm$core$Result$Ok(s);
	} else {
		return $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidString));
	}
};
var $enbala$elm_form$Form$Validate$andThen = F3(
	function (callback, validation, validationField) {
		return A2(
			$elm$core$Result$andThen,
			function (next) {
				return A2(callback, next, validationField);
			},
			validation(validationField));
	});
var $enbala$elm_form$Form$Validate$succeed = F2(
	function (a, validationField) {
		return $elm$core$Result$Ok(a);
	});
var $enbala$elm_form$Form$Validate$nonEmpty = F2(
	function (s, validationField) {
		return $elm$core$String$isEmpty(s) ? $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$Empty)) : $elm$core$Result$Ok(s);
	});
var $author$project$Views$FleetForm$FleetForm = function (name) {
	return function (slug) {
		return function (isPrivate) {
			return function (timeZoneId) {
				return function (mapPosition) {
					return function (shortDistanceUnit) {
						return function (longDistanceUnit) {
							return function (speedUnit) {
								return function (isDashboardEnabled) {
									return function (isSeaRescue) {
										return function (fleetType) {
											return function (speedAlertsEnabled) {
												return function (notificationGroups) {
													return function (helmTenantId) {
														return function (helmApiKey) {
															return function (helmEventTypeId) {
																return {name: name, slug: slug, fleetType: fleetType, isPrivate: isPrivate, speedUnit: speedUnit, helmApiKey: helmApiKey, timeZoneId: timeZoneId, isSeaRescue: isSeaRescue, mapPosition: mapPosition, helmTenantId: helmTenantId, helmEventTypeId: helmEventTypeId, longDistanceUnit: longDistanceUnit, shortDistanceUnit: shortDistanceUnit, isDashboardEnabled: isDashboardEnabled, notificationGroups: notificationGroups, speedAlertsEnabled: speedAlertsEnabled};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $enbala$elm_form$Form$Error$NotIncludedIn = {$: 'NotIncludedIn'};
var $enbala$elm_form$Form$Validate$includedIn = F3(
	function (items, s, validationField) {
		return A2($elm$core$List$member, s, items) ? $elm$core$Result$Ok(s) : $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$NotIncludedIn));
	});
var $enbala$elm_form$Form$Error$CustomError = function (a) {
	return {$: 'CustomError', a: a};
};
var $enbala$elm_form$Form$Validate$customError = A2($elm$core$Basics$composeR, $enbala$elm_form$Form$Error$CustomError, $enbala$elm_form$Form$Error$value);
var $enbala$elm_form$Form$Validate$emptyString = function (v) {
	var _v0 = $enbala$elm_form$Form$Field$asString(v);
	if (_v0.$ === 'Just') {
		var s = _v0.a;
		return $elm$core$String$isEmpty(s) ? $elm$core$Result$Ok(s) : $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidString));
	} else {
		return $elm$core$Result$Ok('');
	}
};
var $enbala$elm_form$Form$Validate$customValidation = F3(
	function (validation, callback, validationField) {
		return A2(
			$elm$core$Result$andThen,
			callback,
			validation(validationField));
	});
var $author$project$Views$FleetForm$validateGuid = function () {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$'));
	return A2(
		$enbala$elm_form$Form$Validate$customValidation,
		$enbala$elm_form$Form$Validate$string,
		function (s) {
			return A2($elm$regex$Regex$contains, regex, s) ? $elm$core$Result$Ok(s) : $elm$core$Result$Err(
				$enbala$elm_form$Form$Validate$customError('Invalid GUID'));
		});
}();
var $author$project$Views$FleetForm$validateSlug = function () {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^(?:[a-z]|[0-9]|\u005C-|_)+$'));
	return A2(
		$enbala$elm_form$Form$Validate$customValidation,
		$enbala$elm_form$Form$Validate$string,
		function (s) {
			return A2($elm$regex$Regex$contains, regex, s) ? $elm$core$Result$Ok(s) : $elm$core$Result$Err(
				$enbala$elm_form$Form$Validate$customError('URL Slug must be a valid URL path segment'));
		});
}();
var $author$project$Views$FleetForm$validateTenantId = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	function (s) {
		return A2($elm$core$String$endsWith, '.helmconnect.com', s) ? $elm$core$Result$Ok(
			A3($elm$core$String$replace, '.helmconnect.com', '', s)) : $elm$core$Result$Ok(s);
	});
var $author$project$Data$Fleet$fleetTypeFromString = function (s) {
	switch (s) {
		case 'tourism':
			return $elm$core$Maybe$Just($author$project$Data$Fleet$Tourism);
		case 'workboats':
			return $elm$core$Maybe$Just($author$project$Data$Fleet$Workboats);
		case 'rescue':
			return $elm$core$Maybe$Just($author$project$Data$Fleet$Rescue);
		case 'commuter':
			return $elm$core$Maybe$Just($author$project$Data$Fleet$Commuter);
		case 'vehicles':
			return $elm$core$Maybe$Just($author$project$Data$Fleet$Vehicles);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$FleetForm$validateFleetType = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$Fleet$fleetTypeFromString,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Invalid fleet type'))));
var $author$project$Views$FleetForm$validateSpeedUnit = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$SpeedUnit$parse,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Invalid speed unit'))));
var $author$project$Views$FleetForm$parseMapPosition = function (s) {
	var _v0 = A2($elm$core$String$split, ', ', s);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var latS = _v0.a;
		var _v1 = _v0.b;
		var longS = _v1.a;
		var _v2 = _v1.b;
		var zoomS = _v2.a;
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (lat, _long) {
					return {
						zoom: A2(
							$elm$core$Maybe$withDefault,
							15,
							$elm$core$String$toFloat(
								A2($elm$core$String$dropRight, 1, zoomS))),
						centre: {lat: lat, _long: _long}
					};
				}),
			$elm$core$String$toFloat(latS),
			$elm$core$String$toFloat(longS));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$FleetForm$validateMapPosition = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	function (s) {
		var _v0 = $author$project$Views$FleetForm$parseMapPosition(s);
		if (_v0.$ === 'Just') {
			var p = _v0.a;
			return $elm$core$Result$Ok(p);
		} else {
			return $elm$core$Result$Err(
				$enbala$elm_form$Form$Validate$customError('Invalid map position. Please enter in format \u0027lat, long, zoom\u0027 (e.g. \u0027-32.06173, 115.74144, 16z\u0027)'));
		}
	});
var $author$project$Views$FleetForm$validateDistanceUnit = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$DistanceUnit$parse,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Invalid distance unit'))));
var $enbala$elm_form$Form$Validate$list = F2(
	function (validation, validationField) {
		if (validationField.$ === 'List') {
			var items = validationField.a;
			var indexedErrMaybe = F2(
				function (index, res) {
					if (res.$ === 'Ok') {
						return $elm$core$Maybe$Nothing;
					} else {
						var e = res.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$elm$core$String$fromInt(index),
								e));
					}
				});
			var results = A2($elm$core$List$map, validation, items);
			var errors = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2($elm$core$List$indexedMap, indexedErrMaybe, results));
			return $elm$core$List$isEmpty(errors) ? $elm$core$Result$Ok(
				A2($elm$core$List$filterMap, $elm$core$Result$toMaybe, results)) : $elm$core$Result$Err(
				$enbala$elm_form$Form$Tree$group(errors));
		} else {
			return $elm$core$Result$Ok(_List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$allDifferentBy = F2(
	function (f, list) {
		return _Utils_eq(
			$elm$core$List$length(list),
			$elm$core$List$length(
				A2($elm_community$list_extra$List$Extra$uniqueBy, f, list)));
	});
var $elm_community$list_extra$List$Extra$allDifferent = function (list) {
	return A2($elm_community$list_extra$List$Extra$allDifferentBy, $elm$core$Basics$identity, list);
};
var $author$project$Views$FleetForm$parseSMS = function (s) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^\u005C+\u005Cd{1,3}[- ]?\u005Cd{8,10}$'));
	return A2($elm$regex$Regex$contains, regex, s) ? $elm$core$Result$Ok(
		$author$project$Data$Fleet$SMS(s)) : $elm$core$Result$Err('Invalid SMS \u0027' + (s + '\u0027: must be a valid phone number with country code (e.g. +61412345678)'));
};
var $author$project$Views$FleetForm$parseEmail = function (s) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[a-zA-Z0-9.!#$%&\u0027*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\u005C.[a-zA-Z0-9-]+)*$'));
	return A2($elm$regex$Regex$contains, regex, s) ? $elm$core$Result$Ok(
		$author$project$Data$Fleet$Email(s)) : $elm$core$Result$Err('Invalid Email \u0027' + (s + '\u0027'));
};
var $author$project$Views$FleetForm$parseNotificationRecipient = function (s) {
	return A2($elm$core$String$contains, '@', s) ? $author$project$Views$FleetForm$parseEmail(s) : $author$project$Views$FleetForm$parseSMS(s);
};
var $author$project$Views$FleetForm$validateNotificationRecipients = $enbala$elm_form$Form$Validate$oneOf(
	_List_fromArray(
		[
			A2(
			$enbala$elm_form$Form$Validate$map,
			function (_v0) {
				return _List_Nil;
			},
			$enbala$elm_form$Form$Validate$emptyString),
			A2(
			$enbala$elm_form$Form$Validate$customValidation,
			$enbala$elm_form$Form$Validate$string,
			function (s) {
				return $elm_community$result_extra$Result$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Views$FleetForm$parseNotificationRecipient,
							$elm$core$Result$mapError($enbala$elm_form$Form$Validate$customError)),
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
							A2(
								$elm$core$List$map,
								$elm$core$String$trim,
								A2($elm$core$String$split, ',', s)))));
			})
		]));
var $enbala$elm_form$Form$Validate$map2 = F3(
	function (func, v1, v2) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			v2,
			A2($enbala$elm_form$Form$Validate$map, func, v1));
	});
var $enbala$elm_form$Form$Validate$sequence = function (validations) {
	return A3(
		$elm$core$List$foldr,
		$enbala$elm_form$Form$Validate$map2($elm$core$List$cons),
		$enbala$elm_form$Form$Validate$succeed(_List_Nil),
		validations);
};
var $author$project$Views$FleetForm$validateNotificationSubscriptions = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (all) {
		return all ? $enbala$elm_form$Form$Validate$succeed(
			_List_fromArray(
				[$author$project$Data$Fleet$AllNotifications])) : A2(
			$enbala$elm_form$Form$Validate$andThen,
			function (subs) {
				return $elm$core$List$isEmpty(subs) ? $enbala$elm_form$Form$Validate$fail(
					$enbala$elm_form$Form$Validate$customError('Select at least one notification type')) : $enbala$elm_form$Form$Validate$succeed(subs);
			},
			A2(
				$enbala$elm_form$Form$Validate$map,
				$elm$core$List$filterMap($elm$core$Basics$identity),
				$enbala$elm_form$Form$Validate$sequence(
					A2(
						$elm$core$List$map,
						function (sub) {
							return A2(
								$enbala$elm_form$Form$Validate$map,
								function (checked) {
									return checked ? $elm$core$Maybe$Just(sub) : $elm$core$Maybe$Nothing;
								},
								A2(
									$enbala$elm_form$Form$Validate$field,
									$author$project$Data$Fleet$notificationSubscriptionToString(sub),
									$enbala$elm_form$Form$Validate$bool));
						},
						$author$project$Data$Fleet$notificationSubscriptions))));
	},
	A2(
		$enbala$elm_form$Form$Validate$field,
		$author$project$Data$Fleet$notificationSubscriptionToString($author$project$Data$Fleet$AllNotifications),
		$enbala$elm_form$Form$Validate$bool));
var $author$project$Views$FleetForm$validateNotificationGroup = A2(
	$enbala$elm_form$Form$Validate$andMap,
	A2($enbala$elm_form$Form$Validate$field, 'subscriptions', $author$project$Views$FleetForm$validateNotificationSubscriptions),
	A2(
		$enbala$elm_form$Form$Validate$andMap,
		A2($enbala$elm_form$Form$Validate$field, 'recipients', $author$project$Views$FleetForm$validateNotificationRecipients),
		A2(
			$enbala$elm_form$Form$Validate$andMap,
			A2(
				$enbala$elm_form$Form$Validate$field,
				'name',
				A2(
					$enbala$elm_form$Form$Validate$andThen,
					$enbala$elm_form$Form$Validate$nonEmpty,
					A2($enbala$elm_form$Form$Validate$map, $elm$core$String$trim, $enbala$elm_form$Form$Validate$string))),
			$enbala$elm_form$Form$Validate$succeed($author$project$Data$Fleet$NotificationGroup))));
var $author$project$Views$FleetForm$validateNotificationGroups = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (groups) {
		return $elm_community$list_extra$List$Extra$allDifferent(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.name;
					},
					$elm$core$String$toLower),
				groups)) ? $enbala$elm_form$Form$Validate$succeed(groups) : $enbala$elm_form$Form$Validate$fail(
			$enbala$elm_form$Form$Validate$customError('Notification group names must be unique'));
	},
	$enbala$elm_form$Form$Validate$list($author$project$Views$FleetForm$validateNotificationGroup));
var $author$project$Views$FleetForm$validate = function (timezones) {
	return A2(
		$enbala$elm_form$Form$Validate$andThen,
		function (f) {
			var _v0 = _Utils_Tuple3(f.helmTenantId, f.helmApiKey, f.helmEventTypeId);
			if (_v0.a.$ === 'Just') {
				if ((_v0.b.$ === 'Just') && (_v0.c.$ === 'Just')) {
					return $enbala$elm_form$Form$Validate$succeed(f);
				} else {
					return $enbala$elm_form$Form$Validate$fail(
						$enbala$elm_form$Form$Validate$customError('Must specify Helm Tenant ID, API Key and Event Type ID'));
				}
			} else {
				var _v1 = _v0.a;
				return $enbala$elm_form$Form$Validate$succeed(f);
			}
		},
		A2(
			$enbala$elm_form$Form$Validate$andMap,
			A2(
				$enbala$elm_form$Form$Validate$field,
				'helmEventTypeId',
				$enbala$elm_form$Form$Validate$oneOf(
					_List_fromArray(
						[
							A2(
							$enbala$elm_form$Form$Validate$map,
							$elm$core$Basics$always($elm$core$Maybe$Nothing),
							$enbala$elm_form$Form$Validate$emptyString),
							A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $author$project$Views$FleetForm$validateGuid)
						]))),
			A2(
				$enbala$elm_form$Form$Validate$andMap,
				A2(
					$enbala$elm_form$Form$Validate$field,
					'helmApiKey',
					$enbala$elm_form$Form$Validate$oneOf(
						_List_fromArray(
							[
								A2(
								$enbala$elm_form$Form$Validate$map,
								$elm$core$Basics$always($elm$core$Maybe$Nothing),
								$enbala$elm_form$Form$Validate$emptyString),
								A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $enbala$elm_form$Form$Validate$string)
							]))),
				A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2(
						$enbala$elm_form$Form$Validate$field,
						'helmTenantId',
						$enbala$elm_form$Form$Validate$oneOf(
							_List_fromArray(
								[
									A2(
									$enbala$elm_form$Form$Validate$map,
									$elm$core$Basics$always($elm$core$Maybe$Nothing),
									$enbala$elm_form$Form$Validate$emptyString),
									A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $author$project$Views$FleetForm$validateTenantId)
								]))),
					A2(
						$enbala$elm_form$Form$Validate$andMap,
						A2($enbala$elm_form$Form$Validate$field, 'notificationGroups', $author$project$Views$FleetForm$validateNotificationGroups),
						A2(
							$enbala$elm_form$Form$Validate$andMap,
							A2($enbala$elm_form$Form$Validate$field, 'speedAlertsEnabled', $enbala$elm_form$Form$Validate$bool),
							A2(
								$enbala$elm_form$Form$Validate$andMap,
								A2($enbala$elm_form$Form$Validate$field, 'fleetType', $author$project$Views$FleetForm$validateFleetType),
								A2(
									$enbala$elm_form$Form$Validate$andMap,
									A2($enbala$elm_form$Form$Validate$field, 'isSeaRescue', $enbala$elm_form$Form$Validate$bool),
									A2(
										$enbala$elm_form$Form$Validate$andMap,
										A2($enbala$elm_form$Form$Validate$field, 'isDashboardEnabled', $enbala$elm_form$Form$Validate$bool),
										A2(
											$enbala$elm_form$Form$Validate$andMap,
											A2($enbala$elm_form$Form$Validate$field, 'speedUnit', $author$project$Views$FleetForm$validateSpeedUnit),
											A2(
												$enbala$elm_form$Form$Validate$andMap,
												A2($enbala$elm_form$Form$Validate$field, 'longDistanceUnit', $author$project$Views$FleetForm$validateDistanceUnit),
												A2(
													$enbala$elm_form$Form$Validate$andMap,
													A2($enbala$elm_form$Form$Validate$field, 'shortDistanceUnit', $author$project$Views$FleetForm$validateDistanceUnit),
													A2(
														$enbala$elm_form$Form$Validate$andMap,
														A2($enbala$elm_form$Form$Validate$field, 'mapPosition', $author$project$Views$FleetForm$validateMapPosition),
														A2(
															$enbala$elm_form$Form$Validate$andMap,
															A2(
																$enbala$elm_form$Form$Validate$field,
																'timeZoneId',
																A2(
																	$enbala$elm_form$Form$Validate$andThen,
																	$enbala$elm_form$Form$Validate$includedIn(
																		A2(
																			$elm$core$List$map,
																			function ($) {
																				return $.id;
																			},
																			timezones)),
																	$enbala$elm_form$Form$Validate$string)),
															A2(
																$enbala$elm_form$Form$Validate$andMap,
																A2($enbala$elm_form$Form$Validate$field, 'isPrivate', $enbala$elm_form$Form$Validate$bool),
																A2(
																	$enbala$elm_form$Form$Validate$andMap,
																	A2($enbala$elm_form$Form$Validate$field, 'slug', $author$project$Views$FleetForm$validateSlug),
																	A2(
																		$enbala$elm_form$Form$Validate$andMap,
																		A2(
																			$enbala$elm_form$Form$Validate$field,
																			'name',
																			A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
																		$enbala$elm_form$Form$Validate$succeed($author$project$Views$FleetForm$FleetForm))))))))))))))))));
};
var $author$project$Views$FleetForm$fromFleet = function (fleet) {
	return $author$project$Views$FleetForm$FleetForm(fleet.name)(fleet.slug)(fleet.isPrivate)(fleet.timeZoneId)(
		{
			zoom: fleet.zoom,
			centre: {lat: fleet.latitude, _long: fleet.longitude}
		})(fleet.shortDistanceUnit)(fleet.longDistanceUnit)(fleet.speedUnit)(
		$elm_community$maybe_extra$Maybe$Extra$isJust(fleet.guestViewConfiguration))(fleet.isSeaRescue)(fleet.fleetType)(fleet.speedAlertsEnabled)(fleet.notificationGroups)(
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.tenantId;
			},
			fleet.helmConfiguration))(
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.apiKey;
			},
			fleet.helmConfiguration))(
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.eventTypeId;
			},
			fleet.helmConfiguration));
};
var $enbala$elm_form$Form$Field$Bool = function (a) {
	return {$: 'Bool', a: a};
};
var $enbala$elm_form$Form$Field$bool = A2($elm$core$Basics$composeR, $enbala$elm_form$Form$Field$Bool, $enbala$elm_form$Form$Tree$Value);
var $enbala$elm_form$Form$Tree$List = function (a) {
	return {$: 'List', a: a};
};
var $enbala$elm_form$Form$Field$list = $enbala$elm_form$Form$Tree$List;
var $enbala$elm_form$Form$Field$String = function (a) {
	return {$: 'String', a: a};
};
var $enbala$elm_form$Form$Field$string = A2($elm$core$Basics$composeR, $enbala$elm_form$Form$Field$String, $enbala$elm_form$Form$Tree$Value);
var $author$project$Data$SpeedUnit$toString = function (u) {
	switch (u.$) {
		case 'Knots':
			return 'knots';
		case 'KilometresPerHour':
			return 'kilometersPerHour';
		default:
			return 'milesPerHour';
	}
};
var $author$project$Data$DistanceUnit$toString = function (u) {
	switch (u.$) {
		case 'Metres':
			return 'meters';
		case 'Yards':
			return 'yards';
		case 'NauticalMiles':
			return 'nauticalMiles';
		case 'Kilometres':
			return 'kilometers';
		default:
			return 'miles';
	}
};
var $author$project$Views$FleetForm$mapPositionToString = function (mapPos) {
	return $elm$core$String$fromFloat(mapPos.centre.lat) + (', ' + ($elm$core$String$fromFloat(mapPos.centre._long) + (', ' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(mapPos.zoom)) + 'z'))));
};
var $enbala$elm_form$Form$Field$group = $enbala$elm_form$Form$Tree$group;
var $author$project$Views$FleetForm$notificationRecipientToString = function (r) {
	if (r.$ === 'SMS') {
		var n = r.a;
		return n;
	} else {
		var n = r.a;
		return n;
	}
};
var $author$project$Views$FleetForm$notificationGroupField = function (g) {
	return $enbala$elm_form$Form$Field$group(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$enbala$elm_form$Form$Field$string(g.name)),
				_Utils_Tuple2(
				'recipients',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$String$join,
						', ',
						A2($elm$core$List$map, $author$project$Views$FleetForm$notificationRecipientToString, g.recipients)))),
				_Utils_Tuple2(
				'subscriptions',
				$enbala$elm_form$Form$Field$group(
					A2(
						$elm$core$List$map,
						function (sub) {
							return _Utils_Tuple2(
								$author$project$Data$Fleet$notificationSubscriptionToString(sub),
								$enbala$elm_form$Form$Field$bool(
									A2($elm$core$List$member, sub, g.subscriptions)));
						},
						A2($elm$core$List$cons, $author$project$Data$Fleet$AllNotifications, $author$project$Data$Fleet$notificationSubscriptions))))
			]));
};
var $author$project$Views$FleetForm$fleetFields = function (fleet) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$enbala$elm_form$Form$Field$string(fleet.name)),
			_Utils_Tuple2(
			'slug',
			$enbala$elm_form$Form$Field$string(fleet.slug)),
			_Utils_Tuple2(
			'isPrivate',
			$enbala$elm_form$Form$Field$bool(fleet.isPrivate)),
			_Utils_Tuple2(
			'timeZoneId',
			$enbala$elm_form$Form$Field$string(fleet.timeZoneId)),
			_Utils_Tuple2(
			'mapPosition',
			$enbala$elm_form$Form$Field$string(
				$author$project$Views$FleetForm$mapPositionToString(fleet.mapPosition))),
			_Utils_Tuple2(
			'shortDistanceUnit',
			$enbala$elm_form$Form$Field$string(
				$author$project$Data$DistanceUnit$toString(fleet.shortDistanceUnit))),
			_Utils_Tuple2(
			'longDistanceUnit',
			$enbala$elm_form$Form$Field$string(
				$author$project$Data$DistanceUnit$toString(fleet.longDistanceUnit))),
			_Utils_Tuple2(
			'speedUnit',
			$enbala$elm_form$Form$Field$string(
				$author$project$Data$SpeedUnit$toString(fleet.speedUnit))),
			_Utils_Tuple2(
			'isDashboardEnabled',
			$enbala$elm_form$Form$Field$bool(fleet.isDashboardEnabled)),
			_Utils_Tuple2(
			'isSeaRescue',
			$enbala$elm_form$Form$Field$bool(fleet.isSeaRescue)),
			_Utils_Tuple2(
			'fleetType',
			$enbala$elm_form$Form$Field$string(
				$author$project$Data$Fleet$fleetTypeToString(fleet.fleetType))),
			_Utils_Tuple2(
			'speedAlertsEnabled',
			$enbala$elm_form$Form$Field$bool(fleet.speedAlertsEnabled)),
			_Utils_Tuple2(
			'notificationGroups',
			$enbala$elm_form$Form$Field$list(
				A2($elm$core$List$map, $author$project$Views$FleetForm$notificationGroupField, fleet.notificationGroups))),
			_Utils_Tuple2(
			'helmTenantId',
			$enbala$elm_form$Form$Field$string(
				A2($elm$core$Maybe$withDefault, '', fleet.helmTenantId))),
			_Utils_Tuple2(
			'helmApiKey',
			$enbala$elm_form$Form$Field$string(
				A2($elm$core$Maybe$withDefault, '', fleet.helmApiKey))),
			_Utils_Tuple2(
			'helmEventTypeId',
			$enbala$elm_form$Form$Field$string(
				A2($elm$core$Maybe$withDefault, '', fleet.helmEventTypeId)))
		]);
};
var $author$project$Views$FleetForm$init = F2(
	function (timezones, f) {
		var watermarkImage = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.watermarkImage;
			},
			f);
		return {
			form: A2(
				$enbala$elm_form$Form$initial,
				$author$project$Views$FleetForm$fleetFields(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Views$FleetForm$initial,
						A2($elm$core$Maybe$map, $author$project$Views$FleetForm$fromFleet, f))),
				$author$project$Views$FleetForm$validate(timezones)),
			isUpdate: $elm_community$maybe_extra$Maybe$Extra$isJust(f),
			timezones: timezones,
			dropZoneState: $author$project$Views$DropZone$init(watermarkImage),
			renamingGroup: $elm$core$Maybe$Nothing,
			watermarkFile: $elm$core$Maybe$Nothing,
			watermarkImage: watermarkImage,
			savedGroupCount: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.notificationGroups;
						},
						$elm$core$List$length),
					f)),
			watermarkPreview: $elm$core$Maybe$Nothing,
			pendingGroupRemoval: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Data$TimeZoneInfo$TimeZoneInfo = F2(
	function (id, displayName) {
		return {id: id, displayName: displayName};
	});
var $author$project$Data$TimeZoneInfo$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$TimeZoneInfo$TimeZoneInfo,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string));
var $author$project$Api$fetchTimezones = F3(
	function (token, apiUrl, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', 'timezones']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$TimeZoneInfo$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Register$OnFetchTimeZones = function (a) {
	return {$: 'OnFetchTimeZones', a: a};
};
var $author$project$Pages$Register$init = F3(
	function (shared, req, session) {
		return $author$project$Data$User$isNeboAdmin(session.user) ? _Utils_Tuple2(
			{
				form: A2($author$project$Views$FleetForm$init, _List_Nil, $elm$core$Maybe$Nothing),
				error: $elm$core$Maybe$Nothing,
				apiUrl: shared.apiUrl
			},
			$author$project$Effect$batch(
				_List_fromArray(
					[
						A3($author$project$Api$fetchTimezones, session.authToken, shared.apiUrl, $author$project$Pages$Register$OnFetchTimeZones),
						$author$project$Effect$fromCmd(
						$author$project$Ports$sendPageViewEvent(
							_Utils_Tuple2(req.url.path, 'Register Fleet')))
					]))) : _Utils_Tuple2(
			{
				form: A2($author$project$Views$FleetForm$init, _List_Nil, $elm$core$Maybe$Nothing),
				error: $elm$core$Maybe$Nothing,
				apiUrl: shared.apiUrl
			},
			$author$project$Effect$fromCmd(
				A2($author$project$Request$pushRoute, $author$project$Gen$Route$Forbidden, req)));
	});
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $enbala$elm_form$Form$Text = {$: 'Text'};
var $author$project$Views$DropZone$Pick = {$: 'Pick'};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$trash = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'trash',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$trash = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$trash);
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 'Nothing') {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Views$DropZone$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Views$DropZone$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Views$DropZone$hijack, decoder));
	});
var $author$project$Views$DropZone$DragEnter = {$: 'DragEnter'};
var $author$project$Views$DropZone$DragLeave = {$: 'DragLeave'};
var $author$project$Views$DropZone$RemoveImage = {$: 'RemoveImage'};
var $elm$file$File$mime = _File_mime;
var $author$project$Views$DropZone$GotFile = function (a) {
	return {$: 'GotFile', a: a};
};
var $elm$file$File$decoder = _File_decoder;
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Views$DropZone$dropDecoder = function (acceptedMimeTypes) {
	var keepFirstFile = F2(
		function (firstFile, _v0) {
			return firstFile;
		});
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Views$DropZone$GotFile,
		A2(
			$elm$json$Json$Decode$andThen,
			function (file) {
				return A2(
					$elm$core$List$member,
					$elm$file$File$mime(file),
					acceptedMimeTypes) ? $elm$json$Json$Decode$succeed(file) : $elm$json$Json$Decode$fail(
					'Unsupported file type: ' + $elm$file$File$mime(file));
			},
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'files']),
						A2($elm$json$Json$Decode$oneOrMore, keepFirstFile, $elm$file$File$decoder)),
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['dataTransfer', 'files']),
						A2($elm$json$Json$Decode$oneOrMore, keepFirstFile, $elm$file$File$decoder))
					]))));
};
var $author$project$Views$DropZone$view = F3(
	function (acceptedMimeTypes, model, attributes) {
		var deleteButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-sm btn-danger'),
					A2($elm$html$Html$Attributes$style, 'margin', '5px 5px 0 0'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '0'),
					A2($elm$html$Html$Attributes$style, 'right', '0'),
					A2($elm$html$Html$Attributes$style, 'opacity', '0.7'),
					$elm$html$Html$Events$onClick($author$project$Views$DropZone$RemoveImage)
				]),
			_List_fromArray(
				[
					$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$trash)
				]));
		var image = A2($elm_community$maybe_extra$Maybe$Extra$orElse, model.preview, model.existingImage);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'border',
						model.hover ? '6px dashed purple' : '6px dashed #ccc'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '20px'),
						A2($elm$html$Html$Attributes$style, 'width', '100px'),
						A2($elm$html$Html$Attributes$style, 'padding', '5px 100px'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2(
						$author$project$Views$DropZone$hijackOn,
						'dragenter',
						$elm$json$Json$Decode$succeed($author$project$Views$DropZone$DragEnter)),
						A2(
						$author$project$Views$DropZone$hijackOn,
						'dragover',
						$elm$json$Json$Decode$succeed($author$project$Views$DropZone$DragEnter)),
						A2(
						$author$project$Views$DropZone$hijackOn,
						'dragleave',
						$elm$json$Json$Decode$succeed($author$project$Views$DropZone$DragLeave)),
						A2(
						$author$project$Views$DropZone$hijackOn,
						'drop',
						$author$project$Views$DropZone$dropDecoder(acceptedMimeTypes))
					]),
				attributes),
			_List_fromArray(
				[
					function () {
					if (image.$ === 'Nothing') {
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-secondary'),
									$elm$html$Html$Events$onClick($author$project$Views$DropZone$Pick)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Select Photo')
								]));
					} else {
						var imageUrl = image.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
									A2($elm$html$Html$Attributes$style, 'height', '100px'),
									A2($elm$html$Html$Attributes$style, 'padding', '20px'),
									A2($elm$html$Html$Attributes$style, 'position', 'relative')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(imageUrl),
											A2($elm$html$Html$Attributes$style, 'object-fit', 'contain'),
											A2($elm$html$Html$Attributes$style, 'max-width', '100px'),
											A2($elm$html$Html$Attributes$style, 'max-height', '100px')
										]),
									_List_Nil),
									deleteButton
								]));
					}
				}()
				]));
	});
var $enbala$elm_form$Form$Input = F3(
	function (a, b, c) {
		return {$: 'Input', a: a, b: b, c: c};
	});
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Views$FleetForm$Submit = {$: 'Submit'};
var $author$project$Mapbox$Element$onMove = function (tagger) {
	return $author$project$Mapbox$Element$MapboxAttr(
		A2(
			$elm$html$Html$Events$on,
			'move',
			A2($elm$json$Json$Decode$map, tagger, $author$project$Mapbox$Element$decodeMapEvent)));
};
var $author$project$Views$FleetForm$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === 'RBEmpty_elm_builtin') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $enbala$elm_form$Form$Tree$valuesWithPath = function (tree) {
	var walkTree = F2(
		function (path, value) {
			switch (value.$) {
				case 'Group':
					var items = value.a;
					return A2(
						$elm$core$List$concatMap,
						mapGroupItem(path),
						$elm$core$Dict$toList(items));
				case 'List':
					var items = value.a;
					return A2(
						$elm$core$List$concatMap,
						mapGroupItem(path),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, item) {
									return _Utils_Tuple2(
										$elm$core$String$fromInt(index),
										item);
								}),
							items));
				default:
					var item = value.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							A2($elm$core$String$join, '.', path),
							item)
						]);
			}
		});
	var mapGroupItem = F2(
		function (path, _v0) {
			var name = _v0.a;
			var error = _v0.b;
			return A2(
				walkTree,
				_Utils_ap(
					path,
					_List_fromArray(
						[name])),
				error);
		});
	return A2(walkTree, _List_Nil, tree);
};
var $enbala$elm_form$Form$getErrors = function (_v0) {
	var model = _v0.a;
	return $enbala$elm_form$Form$Tree$valuesWithPath(model.errors);
};
var $enbala$elm_form$Form$getOutput = function (_v0) {
	var model = _v0.a;
	return model.output;
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 'Nothing') {
		return true;
	} else {
		return false;
	}
};
var $enbala$elm_form$Form$Blur = function (a) {
	return {$: 'Blur', a: a};
};
var $enbala$elm_form$Form$Focus = function (a) {
	return {$: 'Focus', a: a};
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $enbala$elm_form$Form$Input$baseInput = F5(
	function (t, toFieldValue, inputType, state, attrs) {
		var formAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_(t),
				$elm$html$Html$Attributes$value(
				A2($elm$core$Maybe$withDefault, '', state.value)),
				$elm$html$Html$Events$onInput(
				A2(
					$elm$core$Basics$composeR,
					toFieldValue,
					A2($enbala$elm_form$Form$Input, state.path, inputType))),
				$elm$html$Html$Events$onFocus(
				$enbala$elm_form$Form$Focus(state.path)),
				$elm$html$Html$Events$onBlur(
				$enbala$elm_form$Form$Blur(state.path))
			]);
		return A2(
			$elm$html$Html$input,
			_Utils_ap(formAttrs, attrs),
			_List_Nil);
	});
var $enbala$elm_form$Form$Input$textInput = A3($enbala$elm_form$Form$Input$baseInput, 'text', $enbala$elm_form$Form$Field$String, $enbala$elm_form$Form$Text);
var $author$project$Data$Fleet$fleetTypeToDisplayString = function (ft) {
	switch (ft.$) {
		case 'Tourism':
			return 'Tourism';
		case 'Workboats':
			return 'Workboats';
		case 'Rescue':
			return 'Rescue';
		case 'Commuter':
			return 'Commuter';
		default:
			return 'Vehicles';
	}
};
var $author$project$Data$Fleet$fleetTypes = A2(
	$elm$core$List$map,
	function (ft) {
		return _Utils_Tuple2(
			$author$project$Data$Fleet$fleetTypeToString(ft),
			$author$project$Data$Fleet$fleetTypeToDisplayString(ft));
	},
	_List_fromArray(
		[$author$project$Data$Fleet$Tourism, $author$project$Data$Fleet$Workboats, $author$project$Data$Fleet$Rescue, $author$project$Data$Fleet$Commuter, $author$project$Data$Fleet$Vehicles]));
var $elm$html$Html$b = _VirtualDom_node('b');
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Data$FleetApiKey$scopes = _List_fromArray(
	[
		_Utils_Tuple2('vessels:read', 'Read vessels')
	]);
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$Views$FleetForm$RevokeApiKey = function (a) {
	return {$: 'RevokeApiKey', a: a};
};
var $author$project$Views$FleetForm$GenerateApiKey = {$: 'GenerateApiKey'};
var $author$project$Views$FleetForm$CopyIssuedApiKey = {$: 'CopyIssuedApiKey'};
var $author$project$Data$FleetApiKey$scopeDisplayName = function (scope) {
	return A2(
		$elm$core$Maybe$withDefault,
		scope,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var s = _v0.a;
						return _Utils_eq(s, scope);
					},
					$author$project$Data$FleetApiKey$scopes))));
};
var $author$project$Views$FleetForm$ApiKeyNameChanged = function (a) {
	return {$: 'ApiKeyNameChanged', a: a};
};
var $author$project$Views$FleetForm$ToggleApiKeyScope = F2(
	function (a, b) {
		return {$: 'ToggleApiKeyScope', a: a, b: b};
	});
var $author$project$Views$FleetForm$CancelRevokeApiKey = {$: 'CancelRevokeApiKey'};
var $author$project$Views$FleetForm$DismissIssuedApiKey = {$: 'DismissIssuedApiKey'};
var $author$project$Views$FleetForm$apiKeysView = function (keys) {
	var canGenerate = (!keys.busy) && ((!$elm$core$String$isEmpty(
		$elm$core$String$trim(keys.newName))) && (!$elm$core$Set$isEmpty(keys.newScopes)));
	var issuedView = function (issued) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert alert-success')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Copy the key for '),
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(issued.apiKey.name)
								])),
							$elm$html$Html$text(' now. It can\u0027t be shown again.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('input-group input-group-sm mb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-control font-monospace'),
									$elm$html$Html$Attributes$readonly(true),
									$elm$html$Html$Attributes$value(issued.key),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'New API key')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('btn btn-outline-secondary'),
									$elm$html$Html$Events$onClick($author$project$Views$FleetForm$CopyIssuedApiKey)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									keys.issuedCopied ? 'Copied' : 'Copy')
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('btn btn-sm btn-success'),
							$elm$html$Html$Events$onClick($author$project$Views$FleetForm$DismissIssuedApiKey)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Done')
						]))
				]));
	};
	var keyRow = function (k) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group-item px-0 d-flex align-items-start gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-grow-1'),
							A2($elm$html$Html$Attributes$style, 'min-width', '0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fw-semibold text-truncate')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(k.name)
								])),
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-secondary')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$code,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(k.keyId)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (s) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('badge text-bg-light border me-1')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Data$FleetApiKey$scopeDisplayName(s))
											]));
								},
								k.scopes))
						])),
					_Utils_eq(
					keys.pendingRevoke,
					$elm$core$Maybe$Just(k.keyId)) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex gap-1 flex-shrink-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('btn btn-sm btn-danger'),
									$elm$html$Html$Attributes$disabled(keys.busy),
									$elm$html$Html$Events$onClick(
									$author$project$Views$FleetForm$RevokeApiKey(k.keyId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Confirm revoke')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('btn btn-sm btn-light'),
									$elm$html$Html$Attributes$disabled(keys.busy),
									$elm$html$Html$Events$onClick($author$project$Views$FleetForm$CancelRevokeApiKey)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						])) : A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('btn btn-sm btn-outline-danger flex-shrink-0'),
							$elm$html$Html$Attributes$disabled(keys.busy),
							$elm$html$Html$Events$onClick(
							$author$project$Views$FleetForm$RevokeApiKey(k.keyId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revoke')
						]))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex align-items-baseline justify-content-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Fleet API Keys')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(keys.docsUrl),
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$rel('noopener'),
								$elm$html$Html$Attributes$class('small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('API docs')
							]))
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2($elm$core$Maybe$map, issuedView, keys.issued)),
				function () {
				var _v0 = keys.keys;
				if (_v0.$ === 'Nothing') {
					return $elm_community$maybe_extra$Maybe$Extra$isJust(keys.error) ? $elm$html$Html$text('') : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-2')
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch))
							]));
				} else {
					if (!_v0.a.b) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small text-secondary mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No keys have been issued for this fleet.')
								]));
					} else {
						var ks = _v0.a;
						return A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group list-group-flush mb-2')
								]),
							A2($elm$core$List$map, keyRow, ks));
					}
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (e) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-text text-danger mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(e)
								]));
					},
					keys.error)),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('newApiKeyName'),
						$elm$html$Html$Attributes$class('form-label small mb-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('New key')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-group input-group-sm mb-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('newApiKeyName'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$placeholder('Name, e.g. the integration using it'),
								$elm$html$Html$Attributes$value(keys.newName),
								$elm$html$Html$Events$onInput($author$project$Views$FleetForm$ApiKeyNameChanged)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn btn-outline-primary'),
								$elm$html$Html$Attributes$disabled(!canGenerate),
								$elm$html$Html$Events$onClick($author$project$Views$FleetForm$GenerateApiKey)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Generate')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var scope = _v1.a;
						var name = _v1.b;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-check form-check-inline small')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$class('form-check-input'),
											$elm$html$Html$Attributes$id('apiKeyScope-' + scope),
											$elm$html$Html$Attributes$checked(
											A2($elm$core$Set$member, scope, keys.newScopes)),
											$elm$html$Html$Events$onCheck(
											$author$project$Views$FleetForm$ToggleApiKeyScope(scope))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('apiKeyScope-' + scope),
											$elm$html$Html$Attributes$class('form-check-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								]));
					},
					$author$project$Data$FleetApiKey$scopes))
			]));
};
var $author$project$Form$Extra$getErrorFor = F2(
	function (name, form) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var n = _v0.a;
						return _Utils_eq(n, name);
					},
					$enbala$elm_form$Form$getErrors(form))));
	});
var $enbala$elm_form$Form$Select = {$: 'Select'};
var $enbala$elm_form$Form$Input$selectInput = F3(
	function (options, state, attrs) {
		var buildOption = function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(k),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(
							state.value,
							$elm$core$Maybe$Just(k)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(v)
					]));
		};
		var formAttrs = _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'change',
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						$enbala$elm_form$Form$Field$String,
						A2($enbala$elm_form$Form$Input, state.path, $enbala$elm_form$Form$Select)),
					$elm$html$Html$Events$targetValue)),
				$elm$html$Html$Events$onFocus(
				$enbala$elm_form$Form$Focus(state.path)),
				$elm$html$Html$Events$onBlur(
				$enbala$elm_form$Form$Blur(state.path))
			]);
		return A2(
			$elm$html$Html$select,
			_Utils_ap(formAttrs, attrs),
			A2($elm$core$List$map, buildOption, options));
	});
var $enbala$elm_form$Form$Checkbox = {$: 'Checkbox'};
var $enbala$elm_form$Form$Input$checkboxInput = F2(
	function (state, attrs) {
		var formAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$checked(
				A2($elm$core$Maybe$withDefault, false, state.value)),
				$elm$html$Html$Events$onCheck(
				A2(
					$elm$core$Basics$composeR,
					$enbala$elm_form$Form$Field$Bool,
					A2($enbala$elm_form$Form$Input, state.path, $enbala$elm_form$Form$Checkbox))),
				$elm$html$Html$Events$onFocus(
				$enbala$elm_form$Form$Focus(state.path)),
				$elm$html$Html$Events$onBlur(
				$enbala$elm_form$Form$Blur(state.path))
			]);
		return A2(
			$elm$html$Html$input,
			_Utils_ap(formAttrs, attrs),
			_List_Nil);
	});
var $author$project$Form$Extra$errorToString = function (error) {
	switch (error.$) {
		case 'Empty':
			return 'Must not be empty';
		case 'InvalidString':
			return 'Value is invalid';
		case 'InvalidEmail':
			return 'Email is invalid';
		case 'InvalidFormat':
			return 'Format is invalid';
		case 'InvalidInt':
			return 'Not a valid integer';
		case 'InvalidFloat':
			return 'Not a valid number';
		case 'InvalidBool':
			return 'Not a valid boolean';
		case 'SmallerIntThan':
			var i = error.a;
			return 'Value must be greater than ' + $elm$core$String$fromInt(i);
		case 'GreaterIntThan':
			var i = error.a;
			return 'Value must be less than ' + $elm$core$String$fromInt(i);
		case 'SmallerFloatThan':
			var f = error.a;
			return 'Value must be greater than ' + $elm$core$String$fromFloat(f);
		case 'GreaterFloatThan':
			var f = error.a;
			return 'Value must be less than ' + $elm$core$String$fromFloat(f);
		case 'ShorterStringThan':
			var c = error.a;
			return 'String must be at least ' + ($elm$core$String$fromInt(c) + ' characters');
		case 'LongerStringThan':
			var c = error.a;
			return 'String must be less than ' + ($elm$core$String$fromInt(c) + ' characters');
		case 'NotIncludedIn':
			return 'Value is invalid';
		default:
			var s = error.a;
			return s;
	}
};
var $enbala$elm_form$Form$getFocus = function (_v0) {
	var model = _v0.a;
	return model.focus;
};
var $enbala$elm_form$Form$isDirtyAt = F2(
	function (qualifiedName, _v0) {
		var model = _v0.a;
		return A2($elm$core$Set$member, qualifiedName, model.dirtyFields);
	});
var $enbala$elm_form$Form$Tree$asValue = function (node) {
	if (node.$ === 'Value') {
		var value = node.a;
		return $elm$core$Maybe$Just(value);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $enbala$elm_form$Form$Tree$getAtIndex = F2(
	function (index, value) {
		switch (value.$) {
			case 'List':
				var items = value.a;
				return $elm$core$List$head(
					A2($elm$core$List$drop, index, items));
			case 'Group':
				var items = value.a;
				return A2(
					$elm$core$Dict$get,
					$elm$core$String$fromInt(index),
					items);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $enbala$elm_form$Form$Tree$IntFragment = function (a) {
	return {$: 'IntFragment', a: a};
};
var $enbala$elm_form$Form$Tree$StringFragment = function (a) {
	return {$: 'StringFragment', a: a};
};
var $enbala$elm_form$Form$Tree$toFragment = function (s) {
	return A2(
		$elm$core$Maybe$withDefault,
		$enbala$elm_form$Form$Tree$StringFragment(s),
		A2(
			$elm$core$Maybe$map,
			$enbala$elm_form$Form$Tree$IntFragment,
			$elm$core$String$toInt(s)));
};
var $enbala$elm_form$Form$Tree$extractFragments = function (name) {
	return A2(
		$elm$core$List$map,
		$enbala$elm_form$Form$Tree$toFragment,
		A2($elm$core$String$split, '.', name));
};
var $enbala$elm_form$Form$Tree$getAtPath = F2(
	function (path, tree) {
		var walkPath = F2(
			function (fragment, maybeField) {
				if (fragment.$ === 'IntFragment') {
					var index = fragment.a;
					return A2(
						$elm$core$Maybe$andThen,
						$enbala$elm_form$Form$Tree$getAtIndex(index),
						maybeField);
				} else {
					var name = fragment.a;
					return A2(
						$elm$core$Maybe$andThen,
						$enbala$elm_form$Form$Tree$getAtName(name),
						maybeField);
				}
			});
		return A3(
			$elm$core$List$foldl,
			walkPath,
			$elm$core$Maybe$Just(tree),
			$enbala$elm_form$Form$Tree$extractFragments(path));
	});
var $enbala$elm_form$Form$getErrorAt = F2(
	function (path, _v0) {
		var model = _v0.a;
		return A2(
			$elm$core$Maybe$andThen,
			$enbala$elm_form$Form$Tree$asValue,
			A2($enbala$elm_form$Form$Tree$getAtPath, path, model.errors));
	});
var $enbala$elm_form$Form$isChangedAt = F2(
	function (qualifiedName, _v0) {
		var model = _v0.a;
		return A2($elm$core$Set$member, qualifiedName, model.changedFields);
	});
var $enbala$elm_form$Form$isSubmitted = function (_v0) {
	var model = _v0.a;
	return model.isSubmitted;
};
var $enbala$elm_form$Form$getLiveErrorAt = F2(
	function (name, form) {
		return ($enbala$elm_form$Form$isSubmitted(form) || (A2($enbala$elm_form$Form$isChangedAt, name, form) && (!A2($enbala$elm_form$Form$isDirtyAt, name, form)))) ? A2($enbala$elm_form$Form$getErrorAt, name, form) : $elm$core$Maybe$Nothing;
	});
var $enbala$elm_form$Form$getField = F3(
	function (getValue, path, form) {
		return {
			path: path,
			error: A2($enbala$elm_form$Form$getErrorAt, path, form),
			value: A2(getValue, path, form),
			isDirty: A2($enbala$elm_form$Form$isDirtyAt, path, form),
			hasFocus: _Utils_eq(
				$enbala$elm_form$Form$getFocus(form),
				$elm$core$Maybe$Just(path)),
			isChanged: A2($enbala$elm_form$Form$isChangedAt, path, form),
			liveError: A2($enbala$elm_form$Form$getLiveErrorAt, path, form)
		};
	});
var $enbala$elm_form$Form$getFieldAt = F2(
	function (qualifiedName, model) {
		return A2($enbala$elm_form$Form$Tree$getAtPath, qualifiedName, model.fields);
	});
var $enbala$elm_form$Form$getBoolAt = F2(
	function (name, _v0) {
		var model = _v0.a;
		return A2(
			$elm$core$Maybe$andThen,
			$enbala$elm_form$Form$Field$asBool,
			A2($enbala$elm_form$Form$getFieldAt, name, model));
	});
var $enbala$elm_form$Form$getFieldAsBool = $enbala$elm_form$Form$getField($enbala$elm_form$Form$getBoolAt);
var $author$project$Data$SpeedUnit$toDisplayString = function (u) {
	switch (u.$) {
		case 'KilometresPerHour':
			return 'Kilometres Per Hour';
		case 'MilesPerHour':
			return 'Miles Per Hour';
		default:
			return 'Knots';
	}
};
var $author$project$Views$FleetForm$validSpeedUnits = A2(
	$elm$core$List$map,
	function (u) {
		return _Utils_Tuple2(
			$author$project$Data$SpeedUnit$toString(u),
			$author$project$Data$SpeedUnit$toDisplayString(u));
	},
	_List_fromArray(
		[$author$project$Data$SpeedUnit$Knots, $author$project$Data$SpeedUnit$KilometresPerHour, $author$project$Data$SpeedUnit$MilesPerHour]));
var $enbala$elm_form$Form$getChangedFields = function (_v0) {
	var model = _v0.a;
	return model.changedFields;
};
var $enbala$elm_form$Form$getStringAt = F2(
	function (name, _v0) {
		var model = _v0.a;
		return A2(
			$elm$core$Maybe$andThen,
			$enbala$elm_form$Form$Field$asString,
			A2($enbala$elm_form$Form$getFieldAt, name, model));
	});
var $enbala$elm_form$Form$getFieldAsString = $enbala$elm_form$Form$getField($enbala$elm_form$Form$getStringAt);
var $author$project$Data$DistanceUnit$toDisplayString = function (u) {
	switch (u.$) {
		case 'Metres':
			return 'Metres';
		case 'Yards':
			return 'Yards';
		case 'NauticalMiles':
			return 'Nautical Miles';
		case 'Kilometres':
			return 'Kilometres';
		default:
			return 'Miles';
	}
};
var $author$project$Views$FleetForm$longDistanceUnits = A2(
	$elm$core$List$map,
	function (u) {
		return _Utils_Tuple2(
			$author$project$Data$DistanceUnit$toString(u),
			$author$project$Data$DistanceUnit$toDisplayString(u));
	},
	_List_fromArray(
		[$author$project$Data$DistanceUnit$NauticalMiles, $author$project$Data$DistanceUnit$Kilometres, $author$project$Data$DistanceUnit$Miles]));
var $author$project$Views$FleetForm$shortDistanceUnits = A2(
	$elm$core$List$map,
	function (u) {
		return _Utils_Tuple2(
			$author$project$Data$DistanceUnit$toString(u),
			$author$project$Data$DistanceUnit$toDisplayString(u));
	},
	_List_fromArray(
		[$author$project$Data$DistanceUnit$Metres, $author$project$Data$DistanceUnit$Yards]));
var $author$project$Views$FleetForm$WatermarkDropZoneMsg = function (a) {
	return {$: 'WatermarkDropZoneMsg', a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$pen = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'pen',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$pen = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$pen);
var $enbala$elm_form$Form$Append = function (a) {
	return {$: 'Append', a: a};
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $enbala$elm_form$Form$Tree$asList = function (value) {
	if (value.$ === 'List') {
		var items = value.a;
		return items;
	} else {
		return _List_Nil;
	}
};
var $enbala$elm_form$Form$getListIndexes = F2(
	function (path, _v0) {
		var model = _v0.a;
		var length = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $enbala$elm_form$Form$Tree$asList, $elm$core$List$length),
				A2($enbala$elm_form$Form$getFieldAt, path, model)));
		return A2($elm$core$List$range, 0, length - 1);
	});
var $author$project$Views$FleetForm$groupNameInputId = function (i) {
	return 'notification-group-name-' + $elm$core$String$fromInt(i);
};
var $author$project$Form$Extra$inputValidationClass = F2(
	function (name, form) {
		return ($elm_community$maybe_extra$Maybe$Extra$isNothing(
			A2($author$project$Form$Extra$getErrorFor, name, form)) || $elm$core$Set$isEmpty(
			$enbala$elm_form$Form$getChangedFields(form))) ? '' : ' is-invalid';
	});
var $author$project$Views$FleetForm$RemoveNotificationGroup = function (a) {
	return {$: 'RemoveNotificationGroup', a: a};
};
var $author$project$Views$FleetForm$RenameNotificationGroup = function (a) {
	return {$: 'RenameNotificationGroup', a: a};
};
var $author$project$Views$FleetForm$CancelRemoveNotificationGroup = {$: 'CancelRemoveNotificationGroup'};
var $author$project$Views$FleetForm$ToggleNotificationSubscription = F2(
	function (a, b) {
		return {$: 'ToggleNotificationSubscription', a: a, b: b};
	});
var $author$project$Data$AlertType$toDisplayString = function (t) {
	switch (t.$) {
		case 'CapsizeAlert':
			return 'Capsized';
		case 'RestrictedZone':
			return 'In Restricted Zone';
		case 'OverSpeed':
			return 'Over Speed';
		case 'LowBattery':
			return 'Low Battery';
		case 'HighWater':
			return 'High Water';
		default:
			return 'After Hours Movement';
	}
};
var $author$project$Data$Fleet$notificationSubscriptionToDisplayString = function (s) {
	switch (s.$) {
		case 'AllNotifications':
			return 'All notifications';
		case 'GeofenceNotification':
			return 'Geofence notifications';
		default:
			var t = s.a;
			return $author$project$Data$AlertType$toDisplayString(t);
	}
};
var $author$project$Views$FleetForm$notificationGroupsView = function (_v0) {
	var renamingGroup = _v0.renamingGroup;
	var savedGroupCount = _v0.savedGroupCount;
	var pendingGroupRemoval = _v0.pendingGroupRemoval;
	var form = _v0.form;
	var errorText = function (name) {
		return $elm$core$Set$isEmpty(
			$enbala$elm_form$Form$getChangedFields(form)) ? $elm$html$Html$text('') : A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-text text-danger')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Form$Extra$errorToString(e))
							]));
				},
				A2($author$project$Form$Extra$getErrorFor, name, form)));
	};
	var groupView = function (i) {
		var removeButton = function () {
			var attrs = _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(
					$author$project$Views$FleetForm$RemoveNotificationGroup(i)),
					$elm$html$Html$Events$onBlur($author$project$Views$FleetForm$CancelRemoveNotificationGroup),
					$elm$html$Html$Events$onMouseLeave($author$project$Views$FleetForm$CancelRemoveNotificationGroup)
				]);
			return _Utils_eq(
				pendingGroupRemoval,
				$elm$core$Maybe$Just(i)) ? A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('btn btn-sm btn-danger ms-auto'),
					attrs),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove?')
					])) : A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('btn btn-sm btn-link text-secondary ms-auto'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'title', 'Remove group'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Remove group'),
							attrs))),
				_List_fromArray(
					[
						$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$trash)
					]));
		}();
		var path = function (name) {
			return 'notificationGroups.' + ($elm$core$String$fromInt(i) + ('.' + name));
		};
		var groupName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$enbala$elm_form$Form$getFieldAsString,
				path('name'),
				form).value);
		var subscriptionPath = function (sub) {
			return _Utils_ap(
				path('subscriptions.'),
				$author$project$Data$Fleet$notificationSubscriptionToString(sub));
		};
		var subscriptionButton = function (sub) {
			var checked = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$enbala$elm_form$Form$getFieldAsBool,
					subscriptionPath(sub),
					form).value);
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class(
						checked ? 'btn btn-xs btn-primary' : 'btn btn-xs btn-outline-secondary'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'aria-pressed',
						checked ? 'true' : 'false'),
						$elm$html$Html$Events$onClick(
						A2($author$project$Views$FleetForm$ToggleNotificationSubscription, i, sub))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Data$Fleet$notificationSubscriptionToDisplayString(sub))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row g-2 align-items-start py-3 border-bottom border-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-12')
						]),
					_List_fromArray(
						[
							((_Utils_cmp(i, savedGroupCount) < 0) && (!_Utils_eq(
							renamingGroup,
							$elm$core$Maybe$Just(i)))) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('d-flex align-items-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fs-5 fw-semibold text-truncate')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(groupName)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn btn-sm btn-link text-secondary py-0 ps-1'),
											A2($elm$html$Html$Attributes$attribute, 'title', 'Rename group'),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Rename group'),
											$elm$html$Html$Events$onClick(
											$author$project$Views$FleetForm$RenameNotificationGroup(i))
										]),
									_List_fromArray(
										[
											$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$pen)
										]))
								])) : A2(
							$elm$html$Html$map,
							$author$project$Views$FleetForm$FormMsg,
							A2(
								$enbala$elm_form$Form$Input$textInput,
								A2(
									$enbala$elm_form$Form$getFieldAsString,
									path('name'),
									form),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(
										$author$project$Views$FleetForm$groupNameInputId(i)),
										$elm$html$Html$Attributes$class(
										'form-control' + A2(
											$author$project$Form$Extra$inputValidationClass,
											path('name'),
											form)),
										$elm$html$Html$Attributes$placeholder('Group name'),
										A2($elm$html$Html$Attributes$style, 'max-width', '20rem')
									]))),
							errorText(
							path('name'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-12')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Views$FleetForm$FormMsg,
							A2(
								$enbala$elm_form$Form$Input$textInput,
								A2(
									$enbala$elm_form$Form$getFieldAsString,
									path('recipients'),
									form),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'form-control form-control-sm' + A2(
											$author$project$Form$Extra$inputValidationClass,
											path('recipients'),
											form)),
										$elm$html$Html$Attributes$placeholder('Recipients: email@example.com, +61412345678')
									]))),
							errorText(
							path('recipients'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-12')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('d-flex flex-wrap gap-1 align-items-center')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									subscriptionButton,
									A2($elm$core$List$cons, $author$project$Data$Fleet$AllNotifications, $author$project$Data$Fleet$notificationSubscriptions)),
								_List_fromArray(
									[removeButton]))),
							errorText(
							path('subscriptions'))
						]))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-12 col-xxl-9 my-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border p-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Notification Groups')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-muted small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Each group\u0027s recipients get the notification types it subscribes to. Anyone in several groups is only notified once.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-2')
							]),
						A2(
							$elm$core$List$map,
							groupView,
							A2($enbala$elm_form$Form$getListIndexes, 'notificationGroups', form))),
						errorText('notificationGroups'),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn btn-sm btn-outline-primary mt-2'),
								$elm$html$Html$Events$onClick(
								$author$project$Views$FleetForm$FormMsg(
									$enbala$elm_form$Form$Append('notificationGroups')))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add group')
							]))
					]))
			]));
};
var $author$project$Views$FleetForm$mapPositionToDisplayString = function (mapPos) {
	return $author$project$Geospatial$LatLong$decimalMinutesString(mapPos.centre) + (', ' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(mapPos.zoom)) + 'z'));
};
var $author$project$Views$FleetForm$view = F3(
	function (isNeboAdmin, apiKeys, model) {
		var timezones = model.timezones;
		var form = model.form;
		var getErrorAt = function (fieldName) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var n = _v0.a;
						return _Utils_eq(n, fieldName);
					},
					$enbala$elm_form$Form$getErrors(form)));
		};
		var mapPosition = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Views$FleetForm$initial.mapPosition,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Views$FleetForm$parseMapPosition,
				A2($enbala$elm_form$Form$getFieldAsString, 'mapPosition', form).value));
		var inputValidationClass = function (fieldName) {
			return ($elm_community$maybe_extra$Maybe$Extra$isNothing(
				getErrorAt(fieldName)) || $elm$core$Set$isEmpty(
				$enbala$elm_form$Form$getChangedFields(form))) ? '' : ' is-invalid';
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-lg-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Name')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A2(
										$enbala$elm_form$Form$Input$textInput,
										A2($enbala$elm_form$Form$getFieldAsString, 'name', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'form-control' + inputValidationClass('name')),
												$elm$html$Html$Attributes$placeholder('Name')
											])))
								])),
							((!model.isUpdate) && isNeboAdmin) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('slug')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('URL Slug (lowercase, digits, hyphens, underscores only. Can\u0027t be changed once created)')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A2(
										$enbala$elm_form$Form$Input$textInput,
										A2($enbala$elm_form$Form$getFieldAsString, 'slug', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'form-control' + inputValidationClass('slug')),
												$elm$html$Html$Attributes$placeholder('URL Slug')
											])))
								])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('timeZoneId')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Time Zone')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A3(
										$enbala$elm_form$Form$Input$selectInput,
										A2(
											$elm$core$List$map,
											function (z) {
												return _Utils_Tuple2(z.id, z.displayName);
											},
											timezones),
										A2($enbala$elm_form$Form$getFieldAsString, 'timeZoneId', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'form-select' + inputValidationClass('timeZoneId'))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('shortDistanceUnit')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Short Distance Unit')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A3(
										$enbala$elm_form$Form$Input$selectInput,
										$author$project$Views$FleetForm$shortDistanceUnits,
										A2($enbala$elm_form$Form$getFieldAsString, 'shortDistanceUnit', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'form-select' + inputValidationClass('shortDistanceUnit'))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('longDistanceUnit')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Long Distance Unit')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A3(
										$enbala$elm_form$Form$Input$selectInput,
										$author$project$Views$FleetForm$longDistanceUnits,
										A2($enbala$elm_form$Form$getFieldAsString, 'longDistanceUnit', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'form-select' + inputValidationClass('longDistanceUnit'))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('speedUnit')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Speed Unit')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A3(
										$enbala$elm_form$Form$Input$selectInput,
										$author$project$Views$FleetForm$validSpeedUnits,
										A2($enbala$elm_form$Form$getFieldAsString, 'speedUnit', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'form-select' + inputValidationClass('speedUnit'))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3 form-check')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('speedAlertsEnabled'),
											$elm$html$Html$Attributes$class('form-check-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Enable global speed alerts (outside geofences)')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A2(
										$enbala$elm_form$Form$Input$checkboxInput,
										A2($enbala$elm_form$Form$getFieldAsBool, 'speedAlertsEnabled', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-check-input')
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3 form-check')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('isPrivate'),
											$elm$html$Html$Attributes$class('form-check-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Private (vessels not visible in the recreational app)')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$FleetForm$FormMsg,
									A2(
										$enbala$elm_form$Form$Input$checkboxInput,
										A2($enbala$elm_form$Form$getFieldAsBool, 'isPrivate', form),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-check-input')
											])))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-lg-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('my-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Default Map Location')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'height', '500px')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$figure,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('map-container'),
											A2($elm$html$Html$Attributes$style, 'height', '100%'),
											A2($elm$html$Html$Attributes$style, 'width', '100%'),
											A2($elm$html$Html$Attributes$style, 'position', 'relative')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('mapbox'),
													A2($elm$html$Html$Attributes$style, 'height', '100%'),
													A2($elm$html$Html$Attributes$style, 'width', '100%'),
													A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'left', '0')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Mapbox$Element$map,
													_List_fromArray(
														[
															$author$project$Mapbox$Element$maxZoom(22),
															$author$project$Mapbox$Element$minZoom(1),
															$author$project$Mapbox$Element$dragRotate(false),
															$author$project$Mapbox$Element$touchZoom(true),
															$author$project$Mapbox$Element$touchRotate(false),
															$author$project$Mapbox$Element$controls(
															_List_fromArray(
																[
																	A4($author$project$Mapbox$Element$navigationControl, $author$project$Mapbox$Element$BottomRight, false, true, false)
																])),
															$author$project$Mapbox$Element$id('mapbox-map'),
															$author$project$Mapbox$Element$onMove(
															function (e) {
																return $author$project$Views$FleetForm$FormMsg(
																	A3(
																		$enbala$elm_form$Form$Input,
																		'mapPosition',
																		$enbala$elm_form$Form$Text,
																		$enbala$elm_form$Form$Field$String(
																			$author$project$Views$FleetForm$mapPositionToString(
																				{
																					zoom: e.zoom + 1,
																					centre: {lat: e.center.lat, _long: e.center.lng}
																				}))));
															})
														]),
													$author$project$Mapbox$Style$Style(
														{
															misc: _List_fromArray(
																[
																	$author$project$Mapbox$Style$imports(
																	_List_fromArray(
																		[
																			{
																			id: 'standard-satellite',
																			url: 'mapbox://styles/mapbox/standard-satellite',
																			config: _List_fromArray(
																				[
																					_Utils_Tuple2(
																					'showPointOfInterestLabels',
																					$elm$json$Json$Encode$bool(false)),
																					_Utils_Tuple2(
																					'showRoadsAndTransit',
																					$elm$json$Json$Encode$bool(false)),
																					_Utils_Tuple2(
																					'showRoadLabels',
																					$elm$json$Json$Encode$bool(false)),
																					_Utils_Tuple2(
																					'showTransitLabels',
																					$elm$json$Json$Encode$bool(false))
																				])
																		}
																		])),
																	$author$project$Mapbox$Style$defaultCenter(
																	{lat: mapPosition.centre.lat, lng: mapPosition.centre._long}),
																	$author$project$Mapbox$Style$defaultZoomLevel(mapPosition.zoom - 1)
																]),
															light: $author$project$Mapbox$Style$defaultLight,
															layers: _List_Nil,
															sources: _List_Nil,
															transition: $author$project$Mapbox$Style$defaultTransition
														}),
													_List_Nil)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Views$FleetForm$mapPositionToDisplayString(mapPosition))
								]))
						])),
					isNeboAdmin ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-lg-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border p-3 h-100')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Admin Settings')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3 form-check')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('isDashboardEnabled'),
													$elm$html$Html$Attributes$class('form-check-label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Dashboard Enabled' + ((A2(
														$elm$core$Maybe$withDefault,
														false,
														A2($enbala$elm_form$Form$getFieldAsBool, 'isDashboardEnabled', form).value) && (!A2(
														$elm$core$Set$member,
														'isDashboardEnabled',
														$enbala$elm_form$Form$getChangedFields(form)))) ? ' (do not untick)' : ''))
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Views$FleetForm$FormMsg,
											A2(
												$enbala$elm_form$Form$Input$checkboxInput,
												A2($enbala$elm_form$Form$getFieldAsBool, 'isDashboardEnabled', form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-check-input')
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3 form-check')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('isSeaRescue'),
													$elm$html$Html$Attributes$class('form-check-label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sea Rescue')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Views$FleetForm$FormMsg,
											A2(
												$enbala$elm_form$Form$Input$checkboxInput,
												A2($enbala$elm_form$Form$getFieldAsBool, 'isSeaRescue', form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-check-input')
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('fleetType')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Fleet Type')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Views$FleetForm$FormMsg,
											A3(
												$enbala$elm_form$Form$Input$selectInput,
												$author$project$Data$Fleet$fleetTypes,
												A2($enbala$elm_form$Form$getFieldAsString, 'fleetType', form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class(
														'form-select' + inputValidationClass('fleetType'))
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('helmTenantId')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Helm Tenant ID')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('input-group')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('input-group-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('https://')
														])),
													A2(
													$elm$html$Html$map,
													$author$project$Views$FleetForm$FormMsg,
													A2(
														$enbala$elm_form$Form$Input$textInput,
														A2($enbala$elm_form$Form$getFieldAsString, 'helmTenantId', form),
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(
																'form-control' + inputValidationClass('helmTenantId'))
															]))),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('input-group-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('.helmconnect.com')
														]))
												]))
										])),
									(!$elm$core$String$isEmpty(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($enbala$elm_form$Form$getFieldAsString, 'helmTenantId', form).value))) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('helmApiKey')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Helm API Key')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Views$FleetForm$FormMsg,
											A2(
												$enbala$elm_form$Form$Input$textInput,
												A2($enbala$elm_form$Form$getFieldAsString, 'helmApiKey', form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class(
														'form-control' + inputValidationClass('helmApiKey'))
													])))
										])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
									(!$elm$core$String$isEmpty(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($enbala$elm_form$Form$getFieldAsString, 'helmTenantId', form).value))) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('helmEventTypeId')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Helm Event Type Id')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Views$FleetForm$FormMsg,
											A2(
												$enbala$elm_form$Form$Input$textInput,
												A2($enbala$elm_form$Form$getFieldAsString, 'helmEventTypeId', form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class(
														'form-control' + inputValidationClass('helmEventTypeId'))
													])))
										])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Watermark Logo')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Views$FleetForm$WatermarkDropZoneMsg,
											A3(
												$author$project$Views$DropZone$view,
												_List_fromArray(
													['image/png', 'image/jpeg']),
												model.dropZoneState,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'background', 'darkblue')
													]))),
											A2(
											$elm$html$Html$small,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-muted d-block mt-1')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mb-1')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Image requirements:')
														])),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mb-0')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('PNG format with transparency')
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('No more than 500px in width or height')
																]))
														]))
												]))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2($elm$core$Maybe$map, $author$project$Views$FleetForm$apiKeysView, apiKeys))
								]))
						])) : $elm$html$Html$text(''),
					$author$project$Views$FleetForm$notificationGroupsView(model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							A2($elm$html$Html$span, _List_Nil, _List_Nil),
							A2(
								$elm_community$maybe_extra$Maybe$Extra$orElse,
								A2(
									$elm$core$Maybe$map,
									function (e) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-text form-text-sm text-danger')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Form$Extra$errorToString(e))
												]));
									},
									A2($author$project$Form$Extra$getErrorFor, '', form)),
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$always(
										A2($elm$html$Html$span, _List_Nil, _List_Nil)),
									$enbala$elm_form$Form$getOutput(form)))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											'btn btn-primary' + ($elm$core$List$isEmpty(
												$enbala$elm_form$Form$getErrors(form)) ? '' : ' disabled')),
											$elm$html$Html$Events$onClick($author$project$Views$FleetForm$Submit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Register$Logout = {$: 'Logout'};
var $author$project$Pages$Register$CloseError = {$: 'CloseError'};
var $author$project$Pages$Register$FleetFormMsg = function (a) {
	return {$: 'FleetFormMsg', a: a};
};
var $author$project$Pages$Register$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Register$view = F3(
	function (session, featureDropState, model) {
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just($author$project$Gen$Route$Register),
					featureDropState,
					$author$project$Pages$Register$ChangelogAction,
					$author$project$Pages$Register$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Register New Fleet')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container-fluid'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Register$FleetFormMsg,
								A3($author$project$Views$FleetForm$view, true, $elm$core$Maybe$Nothing, model.form)),
								A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Register$CloseError)
							]))
					])),
			title: 'Register New Fleet'
		};
	});
var $author$project$Views$FleetForm$NoOp = {$: 'NoOp'};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$file$File$toUrl = _File_toUrl;
var $enbala$elm_form$Form$Submit = {$: 'Submit'};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$filter = F2(
	function (isGood, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v1) {
						return isGood(key);
					}),
				dict));
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$remove, key, dict));
	});
var $enbala$elm_form$Form$Tree$merge = F2(
	function (t1, t2) {
		var _v0 = _Utils_Tuple2(t1, t2);
		if ((_v0.a.$ === 'Group') && (_v0.b.$ === 'Group')) {
			var g1 = _v0.a.a;
			var g2 = _v0.b.a;
			return $enbala$elm_form$Form$Tree$Group(
				A2($elm$core$Dict$union, g1, g2));
		} else {
			return t1;
		}
	});
var $enbala$elm_form$Form$Tree$updateListAtIndex = F2(
	function (index, updater) {
		return $elm$core$List$indexedMap(
			F2(
				function (i, f) {
					return _Utils_eq(i, index) ? updater(f) : f;
				}));
	});
var $enbala$elm_form$Form$Tree$recursiveSet = F3(
	function (fragments, node, tree) {
		if (fragments.b) {
			var head = fragments.a;
			var rest = fragments.b;
			if (head.$ === 'IntFragment') {
				var index = head.a;
				return $enbala$elm_form$Form$Tree$List(
					A3(
						$enbala$elm_form$Form$Tree$updateListAtIndex,
						index,
						A2($enbala$elm_form$Form$Tree$recursiveSet, rest, node),
						$enbala$elm_form$Form$Tree$asList(tree)));
			} else {
				var name = head.a;
				var target = A2(
					$elm$core$Maybe$withDefault,
					$enbala$elm_form$Form$Tree$Group($elm$core$Dict$empty),
					A2($enbala$elm_form$Form$Tree$getAtName, name, tree));
				var childNode = A3($enbala$elm_form$Form$Tree$recursiveSet, rest, node, target);
				return A2(
					$enbala$elm_form$Form$Tree$merge,
					$enbala$elm_form$Form$Tree$Group(
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(name, childNode)
								]))),
					tree);
			}
		} else {
			return node;
		}
	});
var $enbala$elm_form$Form$Tree$setAtPath = F3(
	function (path, node, tree) {
		return A3(
			$enbala$elm_form$Form$Tree$recursiveSet,
			$enbala$elm_form$Form$Tree$extractFragments(path),
			node,
			tree);
	});
var $enbala$elm_form$Form$setFieldAt = F3(
	function (path, field, model) {
		return A3($enbala$elm_form$Form$Tree$setAtPath, path, field, model.fields);
	});
var $enbala$elm_form$Form$update = F3(
	function (validation, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'NoOp':
				return $enbala$elm_form$Form$F(model);
			case 'Focus':
				var name = msg.a;
				var newModel = _Utils_update(
					model,
					{
						focus: $elm$core$Maybe$Just(name)
					});
				return $enbala$elm_form$Form$F(newModel);
			case 'Blur':
				var name = msg.a;
				var newDirtyFields = A2($elm$core$Set$remove, name, model.dirtyFields);
				var newModel = _Utils_update(
					model,
					{focus: $elm$core$Maybe$Nothing, dirtyFields: newDirtyFields});
				return $enbala$elm_form$Form$F(
					A2($enbala$elm_form$Form$updateValidate, validation, newModel));
			case 'Input':
				var name = msg.a;
				var inputType = msg.b;
				var fieldValue = msg.c;
				var _v2 = function () {
					if (A2($elm$core$Set$member, name, model.changedFields)) {
						var shouldBeNothing = function (v) {
							_v4$2:
							while (true) {
								switch (v.$) {
									case 'String':
										if (v.a === '') {
											return true;
										} else {
											break _v4$2;
										}
									case 'Bool':
										if (!v.a) {
											return true;
										} else {
											break _v4$2;
										}
									default:
										break _v4$2;
								}
							}
							return false;
						};
						var storedValue = A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2($elm$core$Dict$get, name, model.originalValues));
						var sameAsOriginal = function () {
							if (storedValue.$ === 'Just') {
								var v = storedValue.a;
								return _Utils_eq(v, fieldValue);
							} else {
								return shouldBeNothing(fieldValue);
							}
						}();
						var changedFields = sameAsOriginal ? A2($elm$core$Set$remove, name, model.changedFields) : model.changedFields;
						return _Utils_Tuple2(changedFields, model.originalValues);
					} else {
						var originalValue = A2(
							$elm$core$Maybe$andThen,
							$enbala$elm_form$Form$Tree$asValue,
							A2($enbala$elm_form$Form$getFieldAt, name, model));
						return _Utils_Tuple2(
							A2($elm$core$Set$insert, name, model.changedFields),
							A3($elm$core$Dict$insert, name, originalValue, model.originalValues));
					}
				}();
				var newChangedFields = _v2.a;
				var newOriginalValues = _v2.b;
				var newFields = A3(
					$enbala$elm_form$Form$setFieldAt,
					name,
					$enbala$elm_form$Form$Tree$Value(fieldValue),
					model);
				var isDirty = function () {
					switch (inputType.$) {
						case 'Text':
							return true;
						case 'Textarea':
							return true;
						default:
							return false;
					}
				}();
				var newDirtyFields = isDirty ? A2($elm$core$Set$insert, name, model.dirtyFields) : model.dirtyFields;
				var newModel = _Utils_update(
					model,
					{fields: newFields, dirtyFields: newDirtyFields, changedFields: newChangedFields, originalValues: newOriginalValues});
				return $enbala$elm_form$Form$F(
					A2($enbala$elm_form$Form$updateValidate, validation, newModel));
			case 'Append':
				var listName = msg.a;
				var listFields = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$enbala$elm_form$Form$Tree$asList,
						A2($enbala$elm_form$Form$getFieldAt, listName, model)));
				var newListFields = _Utils_ap(
					listFields,
					_List_fromArray(
						[
							$enbala$elm_form$Form$Tree$Value($enbala$elm_form$Form$Field$EmptyField)
						]));
				var newModel = _Utils_update(
					model,
					{
						fields: A3(
							$enbala$elm_form$Form$setFieldAt,
							listName,
							$enbala$elm_form$Form$Tree$List(newListFields),
							model)
					});
				return $enbala$elm_form$Form$F(newModel);
			case 'RemoveItem':
				var listName = msg.a;
				var index = msg.b;
				var fieldNamePattern = _Utils_ap(
					listName,
					$elm$core$String$fromInt(index));
				var filterChangedFields = $elm$core$Set$filter(
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						$elm$core$String$startsWith(fieldNamePattern)));
				var filterOriginalValue = $elm$core$Dict$filter(
					F2(
						function (c, _v6) {
							return !A2($elm$core$String$startsWith, fieldNamePattern, c);
						}));
				var listFields = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$enbala$elm_form$Form$Tree$asList,
						A2($enbala$elm_form$Form$getFieldAt, listName, model)));
				var newListFields = _Utils_ap(
					A2($elm$core$List$take, index, listFields),
					A2($elm$core$List$drop, index + 1, listFields));
				var newModel = _Utils_update(
					model,
					{
						fields: A3(
							$enbala$elm_form$Form$setFieldAt,
							listName,
							$enbala$elm_form$Form$Tree$List(newListFields),
							model),
						changedFields: filterChangedFields(model.changedFields),
						originalValues: filterOriginalValue(model.originalValues)
					});
				return $enbala$elm_form$Form$F(
					A2($enbala$elm_form$Form$updateValidate, validation, newModel));
			case 'Submit':
				var validatedModel = A2($enbala$elm_form$Form$updateValidate, validation, model);
				return $enbala$elm_form$Form$F(
					_Utils_update(
						validatedModel,
						{isSubmitted: true}));
			case 'Validate':
				return $enbala$elm_form$Form$F(
					A2($enbala$elm_form$Form$updateValidate, validation, model));
			default:
				var fields = msg.a;
				var newModel = _Utils_update(
					model,
					{
						fields: $enbala$elm_form$Form$Tree$group(fields),
						dirtyFields: $elm$core$Set$empty,
						isSubmitted: false,
						changedFields: $elm$core$Set$empty,
						originalValues: $elm$core$Dict$empty
					});
				return $enbala$elm_form$Form$F(
					A2($enbala$elm_form$Form$updateValidate, validation, newModel));
		}
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Views$DropZone$GotPreview = function (a) {
	return {$: 'GotPreview', a: a};
};
var $author$project$Views$DropZone$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'Pick':
				return _Utils_Tuple3(
					model,
					$elm$core$Maybe$Nothing,
					A2($elm$file$File$Select$file, config.acceptedMimeTypes, $author$project$Views$DropZone$GotFile));
			case 'DragEnter':
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hover: true}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'DragLeave':
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hover: false}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'GotFile':
				var file = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hover: false}),
					$elm$core$Maybe$Just(
						config.droppedFile(file)),
					config.generatePreview ? A2(
						$elm$core$Task$perform,
						$author$project$Views$DropZone$GotPreview,
						$elm$file$File$toUrl(file)) : $elm$core$Platform$Cmd$none);
			case 'GotPreview':
				var url = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							preview: $elm$core$Maybe$Just(url)
						}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{preview: $elm$core$Maybe$Nothing, existingImage: $elm$core$Maybe$Nothing}),
					config.removeImage,
					$elm$core$Platform$Cmd$none);
		}
	});
var $enbala$elm_form$Form$RemoveItem = F2(
	function (a, b) {
		return {$: 'RemoveItem', a: a, b: b};
	});
var $author$project$Views$FleetForm$GotWatermarkPreview = function (a) {
	return {$: 'GotWatermarkPreview', a: a};
};
var $author$project$Views$FleetForm$RemoveWatermarkImage = {$: 'RemoveWatermarkImage'};
var $author$project$Views$FleetForm$WatermarkFileSelected = function (a) {
	return {$: 'WatermarkFileSelected', a: a};
};
var $author$project$Views$FleetForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'FormMsg':
				var formMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: A3(
								$enbala$elm_form$Form$update,
								$author$project$Views$FleetForm$validate(model.timezones),
								formMsg,
								model.form),
							pendingGroupRemoval: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 'Submit':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: A3(
								$enbala$elm_form$Form$update,
								$author$project$Views$FleetForm$validate(model.timezones),
								$enbala$elm_form$Form$Submit,
								model.form)
						}),
					$elm$core$Platform$Cmd$none);
			case 'WatermarkFileSelected':
				var f = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							watermarkFile: $elm$core$Maybe$Just(f)
						}),
					A2(
						$elm$core$Task$perform,
						$author$project$Views$FleetForm$GotWatermarkPreview,
						$elm$file$File$toUrl(f)));
			case 'GotWatermarkPreview':
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							watermarkPreview: $elm$core$Maybe$Just(url)
						}),
					$elm$core$Platform$Cmd$none);
			case 'WatermarkDropZoneMsg':
				var dzmsg = msg.a;
				var _v1 = A3(
					$author$project$Views$DropZone$update,
					{
						droppedFile: $author$project$Views$FleetForm$WatermarkFileSelected,
						removeImage: $elm$core$Maybe$Just($author$project$Views$FleetForm$RemoveWatermarkImage),
						generatePreview: true,
						acceptedMimeTypes: _List_fromArray(
							['image/png', 'image/jpeg'])
					},
					dzmsg,
					model.dropZoneState);
				var state = _v1.a;
				var maybeMsg = _v1.b;
				var cmd = _v1.c;
				var updatedModel = _Utils_update(
					model,
					{dropZoneState: state});
				if (maybeMsg.$ === 'Just') {
					var m = maybeMsg.a;
					var _v3 = A2($author$project$Views$FleetForm$update, m, updatedModel);
					var newModel = _v3.a;
					var newCmd = _v3.b;
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Views$FleetForm$WatermarkDropZoneMsg, cmd),
									newCmd
								])));
				} else {
					return _Utils_Tuple2(
						updatedModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Views$FleetForm$WatermarkDropZoneMsg, cmd));
				}
			case 'ToggleNotificationSubscription':
				var i = msg.a;
				var sub = msg.b;
				var path = function (s) {
					return 'notificationGroups.' + ($elm$core$String$fromInt(i) + ('.subscriptions.' + $author$project$Data$Fleet$notificationSubscriptionToString(s)));
				};
				var isChecked = function (s) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$enbala$elm_form$Form$getFieldAsBool,
							path(s),
							model.form).value);
				};
				var set = F2(
					function (s, b) {
						return A3(
							$enbala$elm_form$Form$Input,
							path(s),
							$enbala$elm_form$Form$Checkbox,
							$enbala$elm_form$Form$Field$Bool(b));
					});
				var inputs = _Utils_eq(sub, $author$project$Data$Fleet$AllNotifications) ? A2(
					$elm$core$List$cons,
					A2(
						set,
						$author$project$Data$Fleet$AllNotifications,
						!isChecked($author$project$Data$Fleet$AllNotifications)),
					A2(
						$elm$core$List$map,
						function (s) {
							return A2(set, s, false);
						},
						$author$project$Data$Fleet$notificationSubscriptions)) : _List_fromArray(
					[
						A2(set, $author$project$Data$Fleet$AllNotifications, false),
						A2(
						set,
						sub,
						!isChecked(sub))
					]);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: A3(
								$elm$core$List$foldl,
								$enbala$elm_form$Form$update(
									$author$project$Views$FleetForm$validate(model.timezones)),
								model.form,
								inputs)
						}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveNotificationGroup':
				var i = msg.a;
				var isBlank = function (name) {
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$enbala$elm_form$Form$getFieldAsString,
									'notificationGroups.' + ($elm$core$String$fromInt(i) + ('.' + name)),
									model.form).value)));
				};
				if (_Utils_eq(
					model.pendingGroupRemoval,
					$elm$core$Maybe$Just(i)) || (isBlank('name') && isBlank('recipients'))) {
					var _v4 = A2(
						$author$project$Views$FleetForm$update,
						$author$project$Views$FleetForm$FormMsg(
							A2($enbala$elm_form$Form$RemoveItem, 'notificationGroups', i)),
						model);
					var removed = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							removed,
							{
								renamingGroup: $elm$core$Maybe$Nothing,
								savedGroupCount: (_Utils_cmp(i, model.savedGroupCount) < 0) ? (model.savedGroupCount - 1) : model.savedGroupCount
							}),
						cmd);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pendingGroupRemoval: $elm$core$Maybe$Just(i)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'CancelRemoveNotificationGroup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pendingGroupRemoval: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'RenameNotificationGroup':
				var i = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							renamingGroup: $elm$core$Maybe$Just(i)
						}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Views$FleetForm$NoOp),
						$elm$browser$Browser$Dom$focus(
							$author$project$Views$FleetForm$groupNameInputId(i))));
			case 'ApiKeyNameChanged':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'CopyIssuedApiKey':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'ToggleApiKeyScope':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'GenerateApiKey':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'RevokeApiKey':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'CancelRevokeApiKey':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'DismissIssuedApiKey':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dropZoneState: $author$project$Views$DropZone$init($elm$core$Maybe$Nothing),
							watermarkFile: $elm$core$Maybe$Nothing,
							watermarkImage: $elm$core$Maybe$Nothing,
							watermarkPreview: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Views$FleetForm$getOutput = function (model) {
	return $enbala$elm_form$Form$getOutput(model.form);
};
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Data$SpeedUnit$encode = function (u) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$SpeedUnit$toString(u));
};
var $author$project$Data$DistanceUnit$encode = function (u) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$DistanceUnit$toString(u));
};
var $author$project$Data$Fleet$notificationRecipientEncoder = function (r) {
	return $elm$json$Json$Encode$object(
		function () {
			if (r.$ === 'Email') {
				var e = r.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(e))
					]);
			} else {
				var n = r.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'sms',
						$elm$json$Json$Encode$string(n))
					]);
			}
		}());
};
var $author$project$Data$Fleet$notificationGroupEncoder = function (g) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(g.name)),
				_Utils_Tuple2(
				'recipients',
				A2($elm$json$Json$Encode$list, $author$project$Data$Fleet$notificationRecipientEncoder, g.recipients)),
				_Utils_Tuple2(
				'subscriptions',
				A2(
					$elm$json$Json$Encode$list,
					A2($elm$core$Basics$composeR, $author$project$Data$Fleet$notificationSubscriptionToString, $elm$json$Json$Encode$string),
					g.subscriptions))
			]));
};
var $author$project$Views$FleetForm$encode = F2(
	function (model, watermarkImage) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(model.name)),
					_Utils_Tuple2(
					'slug',
					$elm$json$Json$Encode$string(model.slug)),
					_Utils_Tuple2(
					'isPrivate',
					$elm$json$Json$Encode$bool(model.isPrivate)),
					_Utils_Tuple2(
					'timeZoneId',
					$elm$json$Json$Encode$string(model.timeZoneId)),
					_Utils_Tuple2(
					'latitude',
					$elm$json$Json$Encode$float(model.mapPosition.centre.lat)),
					_Utils_Tuple2(
					'longitude',
					$elm$json$Json$Encode$float(model.mapPosition.centre._long)),
					_Utils_Tuple2(
					'zoom',
					$elm$json$Json$Encode$float(model.mapPosition.zoom)),
					_Utils_Tuple2(
					'shortDistanceUnit',
					$author$project$Data$DistanceUnit$encode(model.shortDistanceUnit)),
					_Utils_Tuple2(
					'longDistanceUnit',
					$author$project$Data$DistanceUnit$encode(model.longDistanceUnit)),
					_Utils_Tuple2(
					'speedUnit',
					$author$project$Data$SpeedUnit$encode(model.speedUnit)),
					_Utils_Tuple2(
					'isDashboardEnabled',
					$elm$json$Json$Encode$bool(model.isDashboardEnabled)),
					_Utils_Tuple2(
					'isSeaRescue',
					$elm$json$Json$Encode$bool(model.isSeaRescue)),
					_Utils_Tuple2(
					'fleetType',
					$elm$json$Json$Encode$string(
						$author$project$Data$Fleet$fleetTypeToString(model.fleetType))),
					_Utils_Tuple2(
					'speedAlertsEnabled',
					$elm$json$Json$Encode$bool(model.speedAlertsEnabled)),
					_Utils_Tuple2(
					'notificationGroups',
					A2($elm$json$Json$Encode$list, $author$project$Data$Fleet$notificationGroupEncoder, model.notificationGroups)),
					_Utils_Tuple2(
					'helmConfiguration',
					A2(
						$elm_community$json_extra$Json$Encode$Extra$maybe,
						function (_v0) {
							var tenantId = _v0.a;
							var apiKey = _v0.b;
							var eventTypeId = _v0.c;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'tenantId',
										$elm$json$Json$Encode$string(tenantId)),
										_Utils_Tuple2(
										'apiKey',
										$elm$json$Json$Encode$string(apiKey)),
										_Utils_Tuple2(
										'eventTypeId',
										$elm$json$Json$Encode$string(eventTypeId))
									]));
						},
						A4(
							$elm$core$Maybe$map3,
							F3(
								function (a, b, c) {
									return _Utils_Tuple3(a, b, c);
								}),
							model.helmTenantId,
							model.helmApiKey,
							model.helmEventTypeId))),
					_Utils_Tuple2(
					'watermarkImage',
					A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, watermarkImage))
				]));
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$stringPart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$postFleet = F6(
	function (token, apiUrl, fleet, watermarkImage, watermarkFile, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet']),
						_List_Nil),
					body: $elm$http$Http$multipartBody(
						A2(
							$elm$core$List$cons,
							A2(
								$elm$http$Http$stringPart,
								'fleet',
								A2(
									$elm$json$Json$Encode$encode,
									2,
									A2($author$project$Views$FleetForm$encode, fleet, watermarkImage))),
							$elm_community$maybe_extra$Maybe$Extra$toList(
								A2(
									$elm$core$Maybe$map,
									$elm$http$Http$filePart('watermark'),
									watermarkFile)))),
					expect: $author$project$Api$expectJson($author$project$Data$Fleet$decode),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Register$OnCreateFleet = function (a) {
	return {$: 'OnCreateFleet', a: a};
};
var $author$project$Views$FleetForm$updateTimezones = F2(
	function (zs, model) {
		return _Utils_update(
			model,
			{timezones: zs});
	});
var $author$project$Views$FleetForm$updateDefaultLocation = F3(
	function (latLong, zoom, model) {
		var updatedForm = A3(
			$elm$core$List$foldl,
			$enbala$elm_form$Form$update(
				$author$project$Views$FleetForm$validate(model.timezones)),
			model.form,
			_List_fromArray(
				[
					A3(
					$enbala$elm_form$Form$Input,
					'latitude',
					$enbala$elm_form$Form$Text,
					$enbala$elm_form$Form$Field$String(
						$elm$core$String$fromFloat(latLong.lat))),
					A3(
					$enbala$elm_form$Form$Input,
					'longitude',
					$enbala$elm_form$Form$Text,
					$enbala$elm_form$Form$Field$String(
						$elm$core$String$fromFloat(latLong._long))),
					A3(
					$enbala$elm_form$Form$Input,
					'zoom',
					$enbala$elm_form$Form$Text,
					$enbala$elm_form$Form$Field$String(
						$elm$core$String$fromFloat(zoom)))
				]));
		return _Utils_update(
			model,
			{form: updatedForm});
	});
var $author$project$Pages$Register$update = F4(
	function (session, req, msg, model) {
		switch (msg.$) {
			case 'OnFetchTimeZones':
				if (msg.a.$ === 'Ok') {
					var zs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: A2($author$project$Views$FleetForm$updateTimezones, zs, model.form)
							}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'MapIdle':
				var bounds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: A3(
								$author$project$Views$FleetForm$updateDefaultLocation,
								{lat: bounds.centre.lat, _long: bounds.centre._long},
								bounds.zoom + 1,
								model.form)
						}),
					$author$project$Effect$none);
			case 'FleetFormMsg':
				var fMsg = msg.a;
				var _v1 = A2($author$project$Views$FleetForm$update, fMsg, model.form);
				var updatedForm = _v1.a;
				var formCmd = _v1.b;
				if (fMsg.$ === 'Submit') {
					var _v3 = $author$project$Views$FleetForm$getOutput(updatedForm);
					if (_v3.$ === 'Just') {
						var fleet = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{form: updatedForm}),
							$author$project$Effect$batch(
								_List_fromArray(
									[
										$author$project$Effect$fromCmd(
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Register$FleetFormMsg, formCmd)),
										A6($author$project$Api$postFleet, session.authToken, model.apiUrl, fleet, model.form.watermarkImage, model.form.watermarkFile, $author$project$Pages$Register$OnCreateFleet)
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{form: updatedForm}),
							$author$project$Effect$fromCmd(
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Register$FleetFormMsg, formCmd)));
					}
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{form: updatedForm}),
						$author$project$Effect$fromCmd(
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Register$FleetFormMsg, formCmd)));
				}
			case 'OnCreateFleet':
				if (msg.a.$ === 'Ok') {
					var f = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: A2($author$project$Views$FleetForm$init, _List_Nil, $elm$core$Maybe$Nothing),
								error: $elm$core$Maybe$Nothing
							}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									$author$project$Effect$fromCmd(
									A2($author$project$Request$pushRoute, $author$project$Gen$Route$Home_, req)),
									$author$project$Effect$fromShared(
									$author$project$Shared$OnRefreshFleet(
										$elm$core$Result$Ok(f)))
								])));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Register$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Register$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Register$init, shared, req, session),
					view: A2($author$project$Pages$Register$view, session, shared.featureDropState),
					update: A2($author$project$Pages$Register$update, session, req),
					subscriptions: $author$project$Pages$Register$subscriptions
				};
			});
	});
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $author$project$Pages$Changelog$GotDate = function (a) {
	return {$: 'GotDate', a: a};
};
var $author$project$Pages$Changelog$init = function (req) {
	return _Utils_Tuple2(
		{today: $elm$core$Maybe$Nothing},
		$author$project$Effect$batch(
			_List_fromArray(
				[
					$author$project$Effect$fromCmd(
					A2($elm$core$Task$perform, $author$project$Pages$Changelog$GotDate, $justinmimbs$date$Date$today)),
					$author$project$Effect$fromCmd(
					$author$project$Ports$sendPageViewEvent(
						_Utils_Tuple2(req.url.path, 'Changelog')))
				])));
};
var $author$project$Pages$Changelog$Logout = {$: 'Logout'};
var $author$project$FeatureDrop$Changelog$fullLogEntry = F4(
	function (locale, fleetSlug, unreadIds, feature) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group-item px-0 py-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex justify-content-between align-items-start gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(feature.label)
								])),
							A2($elm$core$Set$member, feature.id, unreadIds) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('badge text-bg-success')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New')
								])) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('badge text-bg-light text-muted')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Read')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small text-muted d-flex flex-wrap gap-2 mb-2')
						]),
					A2($author$project$FeatureDrop$Changelog$metaBits, locale, feature)),
					A2(
					$author$project$FeatureDrop$Changelog$maybeHtml,
					$author$project$FeatureDrop$Changelog$markdownBody(fleetSlug),
					feature.description),
					function () {
					var _v0 = feature.cta;
					if (_v0.$ === 'Just') {
						var cta = _v0.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-primary mt-1'),
									$elm$html$Html$Attributes$href(
									A2($author$project$FeatureDrop$Changelog$substituteFleet, fleetSlug, cta.url))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(cta.label)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$FeatureDrop$Changelog$fullLog = F2(
	function (_v0, features) {
		var locale = _v0.locale;
		var unreadIds = _v0.unreadIds;
		var fleetSlug = _v0.fleetSlug;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group list-group-flush')
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$FeatureDrop$Changelog$fullLogEntry, locale, fleetSlug, unreadIds),
				features));
	});
var $author$project$FeatureDrop$Changelog$publishedBy = F2(
	function (today, publishAt) {
		var _v0 = _Utils_Tuple2(publishAt, today);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var at = _v0.a.a;
			var t = _v0.b.a;
			return !_Utils_eq(
				A2($justinmimbs$date$Date$compare, at, t),
				$elm$core$Basics$GT);
		} else {
			return true;
		}
	});
var $author$project$FeatureDrop$Changelog$deprecatedFor = F2(
	function (appVersion, version) {
		if ((version.$ === 'Just') && (version.a.$ === 'VersionRange')) {
			var range = version.a.a;
			var _v1 = range.deprecatedAt;
			if (_v1.$ === 'Just') {
				var at = _v1.a;
				return (appVersion !== '') && (!_Utils_eq(
					A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, appVersion, at),
					$elm$core$Basics$LT));
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$FeatureDrop$Changelog$isVisible = F2(
	function (_v0, feature) {
		var audience = _v0.audience;
		var appVersion = _v0.appVersion;
		var today = _v0.today;
		return A2($author$project$FeatureDrop$Changelog$publishedBy, today, feature.publishAt) && ((!A2($author$project$FeatureDrop$Changelog$deprecatedFor, appVersion, feature.version)) && A2($author$project$FeatureDrop$Changelog$matchesAudience, audience, feature));
	});
var $author$project$Pages$Changelog$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Changelog$view = F3(
	function (session, shared, model) {
		var currentFleet = A2($author$project$Data$Session$defaultFleet, session, shared.selectedFleetId);
		var fleetSlug = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.slug;
				},
				currentFleet));
		var content = function () {
			var _v0 = shared.featureDropState;
			if (_v0.$ === 'Just') {
				var state = _v0.a;
				var unreadIds = $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.id;
						},
						state.newFeatures));
				var features = $elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.releasedAt;
							},
							$justinmimbs$date$Date$toRataDie),
						A2(
							$elm$core$List$filter,
							$author$project$FeatureDrop$Changelog$isVisible(
								{
									today: model.today,
									audience: {
										fleetRole: A2(
											$elm$core$Maybe$andThen,
											function (f) {
												return A2($author$project$Data$User$effectiveRoleForFleet, f.slug, session.user);
											},
											currentFleet),
										fleetType: A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.fleetType;
											},
											currentFleet)
									},
									appVersion: shared.bugsnagConfig.appVersion
								}),
							state.manifest)));
				return $elm$core$List$isEmpty(features) ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-muted')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No features have been published yet.')
						])) : A2(
					$author$project$FeatureDrop$Changelog$fullLog,
					{locale: shared.locale, fleetSlug: fleetSlug, unreadIds: unreadIds},
					features);
			} else {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-muted')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('The change log is currently unavailable.')
						]));
			}
		}();
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					currentFleet,
					$elm$core$Maybe$Just($author$project$Gen$Route$Changelog),
					shared.featureDropState,
					$author$project$Pages$Changelog$ChangelogAction,
					$author$project$Pages$Changelog$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container py-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Change Log')
									])),
								content
							]))
					])),
			title: 'Change Log'
		};
	});
var $author$project$Pages$Changelog$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'GotDate':
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							today: $elm$core$Maybe$Just(date)
						}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Changelog$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: $author$project$Pages$Changelog$init(req),
					view: A2($author$project$Pages$Changelog$view, session, shared),
					update: $author$project$Pages$Changelog$update,
					subscriptions: function (_v0) {
						return $elm$core$Platform$Sub$none;
					}
				};
			});
	});
var $author$project$View$placeholder = function (str) {
	return {
		body: _List_fromArray(
			[
				$elm$html$Html$text(str)
			]),
		title: str
	};
};
var $author$project$Pages$Forbidden$view = $author$project$View$placeholder('You do not have access to this page');
var $ryan_haskell$elm_spa$ElmSpa$Page$static = F2(
	function (none, page) {
		return $ryan_haskell$elm_spa$ElmSpa$Page$Page(
			F2(
				function (_v0, _v1) {
					return $elm$core$Result$Ok(
						A2($ryan_haskell$elm_spa$ElmSpa$Page$adapters._static, none, page));
				}));
	});
var $author$project$Page$static = $ryan_haskell$elm_spa$ElmSpa$Page$static($author$project$Effect$none);
var $author$project$Pages$Forbidden$page = F2(
	function (_v0, _v1) {
		return $author$project$Page$static(
			{view: $author$project$Pages$Forbidden$view});
	});
var $author$project$Views$FleetForm$initApiKeys = function (apiUrl) {
	return {
		busy: false,
		keys: $elm$core$Maybe$Nothing,
		error: $elm$core$Maybe$Nothing,
		issued: $elm$core$Maybe$Nothing,
		docsUrl: apiUrl + '/fleet-api/v1/docs',
		newName: '',
		newScopes: $elm$core$Set$fromList(
			A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Data$FleetApiKey$scopes)),
		issuedCopied: false,
		pendingRevoke: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pages$Fleet_$Edit$initial = F3(
	function (shared, slug, fleet) {
		return {
			form: A2($author$project$Views$FleetForm$init, _List_Nil, $elm$core$Maybe$Nothing),
			error: $elm$core$Maybe$Nothing,
			fleet: $elm$core$Maybe$Nothing,
			apiUrl: shared.apiUrl,
			apiKeys: $author$project$Views$FleetForm$initApiKeys(shared.apiUrl),
			fleetSlug: slug,
			cachedFleet: fleet
		};
	});
var $author$project$Api$fetchFleet = F4(
	function (token, apiUrl, fleetId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetId]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson($author$project$Data$Fleet$decode),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Edit$OnFetchFleet = function (a) {
	return {$: 'OnFetchFleet', a: a};
};
var $author$project$Pages$Fleet_$Edit$OnFetchApiKeys = function (a) {
	return {$: 'OnFetchApiKeys', a: a};
};
var $author$project$Pages$Fleet_$Edit$OnFetchTimeZones = function (a) {
	return {$: 'OnFetchTimeZones', a: a};
};
var $author$project$Data$FleetApiKey$FleetApiKey = F3(
	function (keyId, name, scopes) {
		return {name: name, keyId: keyId, scopes: scopes};
	});
var $author$project$Data$FleetApiKey$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'scopes',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'keyId',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$FleetApiKey$FleetApiKey))));
var $author$project$Api$fetchFleetApiKeys = F4(
	function (token, apiUrl, fleetSlug, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetSlug, 'apikeys']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$FleetApiKey$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Edit$init = F3(
	function (shared, session, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return (A2($author$project$Data$User$isFleetAdmin, f.slug, session.user) || $author$project$Data$User$isNeboAdmin(session.user)) ? _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Edit$initial, shared, req.params.fleet, f),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchFleet, session.authToken, shared.apiUrl, req.params.fleet, $author$project$Pages$Fleet_$Edit$OnFetchFleet),
							A3($author$project$Api$fetchTimezones, session.authToken, shared.apiUrl, $author$project$Pages$Fleet_$Edit$OnFetchTimeZones),
							$author$project$Data$User$isNeboAdmin(session.user) ? A4($author$project$Api$fetchFleetApiKeys, session.authToken, shared.apiUrl, req.params.fleet, $author$project$Pages$Fleet_$Edit$OnFetchApiKeys) : $author$project$Effect$none,
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Fleet Settings')))
						]))) : _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Edit$initial, shared, req.params.fleet, $author$project$Data$Fleet$empty),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$Forbidden, req)));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Edit$initial, shared, req.params.fleet, $author$project$Data$Fleet$empty),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Edit$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Edit$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Edit$FleetFormMsg = function (a) {
	return {$: 'FleetFormMsg', a: a};
};
var $author$project$Pages$Fleet_$Edit$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Edit$view = F3(
	function (session, featureDropState, model) {
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					model.fleet,
					$elm$core$Maybe$Just(
						$author$project$Gen$Route$Fleet___Edit(
							{fleet: model.fleetSlug})),
					featureDropState,
					$author$project$Pages$Fleet_$Edit$ChangelogAction,
					$author$project$Pages$Fleet_$Edit$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Fleet Settings')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container-fluid'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								$elm_community$maybe_extra$Maybe$Extra$isJust(model.fleet) ? A2(
								$elm$html$Html$map,
								$author$project$Pages$Fleet_$Edit$FleetFormMsg,
								A3(
									$author$project$Views$FleetForm$view,
									$author$project$Data$User$isNeboAdmin(session.user),
									$author$project$Data$User$isNeboAdmin(session.user) ? $elm$core$Maybe$Just(model.apiKeys) : $elm$core$Maybe$Nothing,
									model.form)) : $lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('ms-2'),
											$lattyware$elm_fontawesome$FontAwesome$Attributes$spin
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)),
								A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Edit$CloseError)
							]))
					])),
			title: 'Edit Fleet Settings'
		};
	});
var $author$project$Views$Alert$Success = {$: 'Success'};
var $author$project$Api$putFleet = F6(
	function (token, apiUrl, fleet, watermarkImage, watermarkFile, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug]),
						_List_Nil),
					body: $elm$http$Http$multipartBody(
						A2(
							$elm$core$List$cons,
							A2(
								$elm$http$Http$stringPart,
								'fleet',
								A2(
									$elm$json$Json$Encode$encode,
									2,
									A2($author$project$Views$FleetForm$encode, fleet, watermarkImage))),
							$elm_community$maybe_extra$Maybe$Extra$toList(
								A2(
									$elm$core$Maybe$map,
									$elm$http$Http$filePart('watermark'),
									watermarkFile)))),
					expect: $author$project$Api$expectJson($author$project$Data$Fleet$decode),
					method: 'PUT',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$circleCheck = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'circle-check',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$circleCheck = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$circleCheck);
var $lattyware$elm_fontawesome$FontAwesome$Solid$checkCircle = $lattyware$elm_fontawesome$FontAwesome$Solid$circleCheck;
var $author$project$Views$FleetForm$apiKeyIssued = F2(
	function (result, keys) {
		if (result.$ === 'Ok') {
			var issued = result.a;
			return _Utils_update(
				keys,
				{
					busy: false,
					keys: A2(
						$elm$core$Maybe$map,
						function (ks) {
							return _Utils_ap(
								ks,
								_List_fromArray(
									[issued.apiKey]));
						},
						keys.keys),
					issued: $elm$core$Maybe$Just(issued),
					newName: '',
					issuedCopied: false
				});
		} else {
			var e = result.a;
			return _Utils_update(
				keys,
				{
					busy: false,
					error: $elm$core$Maybe$Just(e)
				});
		}
	});
var $author$project$Pages$Fleet_$Edit$OnUpdateFleet = function (a) {
	return {$: 'OnUpdateFleet', a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		if (m.$ === 'Just') {
			var a = m.a;
			return f(a) ? m : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Views$FleetForm$apiKeyRevoked = F3(
	function (keyId, result, keys) {
		if (result.$ === 'Ok') {
			return _Utils_update(
				keys,
				{
					busy: false,
					keys: A2(
						$elm$core$Maybe$map,
						$elm$core$List$filter(
							function (k) {
								return !_Utils_eq(k.keyId, keyId);
							}),
						keys.keys),
					issued: A2(
						$elm_community$maybe_extra$Maybe$Extra$filter,
						function (i) {
							return !_Utils_eq(i.apiKey.keyId, keyId);
						},
						keys.issued),
					pendingRevoke: $elm$core$Maybe$Nothing
				});
		} else {
			var e = result.a;
			return _Utils_update(
				keys,
				{
					busy: false,
					error: $elm$core$Maybe$Just(e),
					pendingRevoke: $elm$core$Maybe$Nothing
				});
		}
	});
var $author$project$Views$FleetForm$CopyApiKey = function (a) {
	return {$: 'CopyApiKey', a: a};
};
var $author$project$Views$FleetForm$CreateApiKey = function (a) {
	return {$: 'CreateApiKey', a: a};
};
var $author$project$Views$FleetForm$DeleteApiKey = function (a) {
	return {$: 'DeleteApiKey', a: a};
};
var $author$project$Views$FleetForm$updateApiKeys = F2(
	function (msg, keys) {
		switch (msg.$) {
			case 'ApiKeyNameChanged':
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						keys,
						{newName: name}),
					$elm$core$Maybe$Nothing);
			case 'ToggleApiKeyScope':
				var scope = msg.a;
				var on = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						keys,
						{
							newScopes: on ? A2($elm$core$Set$insert, scope, keys.newScopes) : A2($elm$core$Set$remove, scope, keys.newScopes)
						}),
					$elm$core$Maybe$Nothing);
			case 'GenerateApiKey':
				return (keys.busy || ($elm$core$String$isEmpty(
					$elm$core$String$trim(keys.newName)) || $elm$core$Set$isEmpty(keys.newScopes))) ? _Utils_Tuple2(keys, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
					_Utils_update(
						keys,
						{busy: true, error: $elm$core$Maybe$Nothing, pendingRevoke: $elm$core$Maybe$Nothing}),
					$elm$core$Maybe$Just(
						$author$project$Views$FleetForm$CreateApiKey(
							{
								name: $elm$core$String$trim(keys.newName),
								scopes: $elm$core$Set$toList(keys.newScopes)
							})));
			case 'RevokeApiKey':
				var keyId = msg.a;
				return keys.busy ? _Utils_Tuple2(keys, $elm$core$Maybe$Nothing) : (_Utils_eq(
					keys.pendingRevoke,
					$elm$core$Maybe$Just(keyId)) ? _Utils_Tuple2(
					_Utils_update(
						keys,
						{busy: true, error: $elm$core$Maybe$Nothing}),
					$elm$core$Maybe$Just(
						$author$project$Views$FleetForm$DeleteApiKey(keyId))) : _Utils_Tuple2(
					_Utils_update(
						keys,
						{
							pendingRevoke: $elm$core$Maybe$Just(keyId)
						}),
					$elm$core$Maybe$Nothing));
			case 'CancelRevokeApiKey':
				return _Utils_Tuple2(
					_Utils_update(
						keys,
						{pendingRevoke: $elm$core$Maybe$Nothing}),
					$elm$core$Maybe$Nothing);
			case 'CopyIssuedApiKey':
				return _Utils_Tuple2(
					_Utils_update(
						keys,
						{issuedCopied: true}),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.key;
							},
							$author$project$Views$FleetForm$CopyApiKey),
						keys.issued));
			case 'DismissIssuedApiKey':
				return _Utils_Tuple2(
					_Utils_update(
						keys,
						{issued: $elm$core$Maybe$Nothing, issuedCopied: false}),
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple2(keys, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Pages$Fleet_$Edit$OnCreateApiKey = function (a) {
	return {$: 'OnCreateApiKey', a: a};
};
var $author$project$Pages$Fleet_$Edit$OnRevokeApiKey = F2(
	function (a, b) {
		return {$: 'OnRevokeApiKey', a: a, b: b};
	});
var $author$project$Views$FleetForm$apiKeysFetched = F2(
	function (result, keys) {
		if (result.$ === 'Ok') {
			var ks = result.a;
			return _Utils_update(
				keys,
				{
					keys: $elm$core$Maybe$Just(ks),
					error: $elm$core$Maybe$Nothing
				});
		} else {
			var e = result.a;
			return _Utils_update(
				keys,
				{
					error: $elm$core$Maybe$Just(e)
				});
		}
	});
var $author$project$Ports$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Data$FleetApiKey$IssuedFleetApiKey = F2(
	function (apiKey, key) {
		return {key: key, apiKey: apiKey};
	});
var $author$project$Data$FleetApiKey$decodeIssued = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$FleetApiKey$IssuedFleetApiKey,
	$author$project$Data$FleetApiKey$decode,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $author$project$Api$postFleetApiKey = F5(
	function (token, apiUrl, fleetSlug, req, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetSlug, 'apikeys']),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(req.name)),
									_Utils_Tuple2(
									'scopes',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, req.scopes))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$FleetApiKey$decodeIssued),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Api$deleteFleetApiKey = F5(
	function (token, apiUrl, fleetSlug, keyId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetSlug, 'apikeys', keyId]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectWhatever,
					method: 'DELETE',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Edit$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnFetchFleet':
				if (msg.a.$ === 'Ok') {
					var fleet = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: A2(
									$author$project$Views$FleetForm$init,
									model.form.timezones,
									$elm$core$Maybe$Just(fleet)),
								error: $elm$core$Maybe$Nothing,
								fleet: $elm$core$Maybe$Just(fleet)
							}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'OnFetchTimeZones':
				if (msg.a.$ === 'Ok') {
					var zs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: A2($author$project$Views$FleetForm$updateTimezones, zs, model.form)
							}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'MapIdle':
				var bounds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: A3(
								$author$project$Views$FleetForm$updateDefaultLocation,
								{lat: bounds.centre.lat, _long: bounds.centre._long},
								bounds.zoom + 1,
								model.form)
						}),
					$author$project$Effect$none);
			case 'FleetFormMsg':
				var fMsg = msg.a;
				var _v1 = A2($author$project$Views$FleetForm$updateApiKeys, fMsg, model.apiKeys);
				var apiKeys = _v1.a;
				var apiKeyRequest = _v1.b;
				var apiKeyEffect = function () {
					if (apiKeyRequest.$ === 'Just') {
						switch (apiKeyRequest.a.$) {
							case 'CreateApiKey':
								var req = apiKeyRequest.a.a;
								return A5($author$project$Api$postFleetApiKey, session.authToken, model.apiUrl, model.fleetSlug, req, $author$project$Pages$Fleet_$Edit$OnCreateApiKey);
							case 'DeleteApiKey':
								var keyId = apiKeyRequest.a.a;
								return A5(
									$author$project$Api$deleteFleetApiKey,
									session.authToken,
									model.apiUrl,
									model.fleetSlug,
									keyId,
									$author$project$Pages$Fleet_$Edit$OnRevokeApiKey(keyId));
							default:
								var key = apiKeyRequest.a.a;
								return $author$project$Effect$fromCmd(
									$author$project$Ports$copyToClipboard(key));
						}
					} else {
						return $author$project$Effect$none;
					}
				}();
				var _v2 = A2($author$project$Views$FleetForm$update, fMsg, model.form);
				var updatedForm = _v2.a;
				var formCmd = _v2.b;
				var _v3 = function () {
					if (fMsg.$ === 'Submit') {
						var _v5 = $author$project$Views$FleetForm$getOutput(updatedForm);
						if (_v5.$ === 'Just') {
							var fleet = _v5.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{form: updatedForm}),
								$author$project$Effect$batch(
									_List_fromArray(
										[
											$author$project$Effect$fromCmd(
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Edit$FleetFormMsg, formCmd)),
											A6($author$project$Api$putFleet, session.authToken, model.apiUrl, fleet, model.form.watermarkImage, model.form.watermarkFile, $author$project$Pages$Fleet_$Edit$OnUpdateFleet)
										])));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{form: updatedForm}),
								$author$project$Effect$fromCmd(
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Edit$FleetFormMsg, formCmd)));
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{form: updatedForm}),
							$author$project$Effect$fromCmd(
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Edit$FleetFormMsg, formCmd)));
					}
				}();
				var formModel = _v3.a;
				var formEffect = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						formModel,
						{apiKeys: apiKeys}),
					$author$project$Effect$batch(
						_List_fromArray(
							[formEffect, apiKeyEffect])));
			case 'OnUpdateFleet':
				if (msg.a.$ === 'Ok') {
					var f = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: A2(
									$author$project$Views$FleetForm$init,
									model.form.timezones,
									$elm$core$Maybe$Just(f)),
								error: $elm$core$Maybe$Just(
									{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$checkCircle, title: 'Success', type_: $author$project$Views$Alert$Success, message: 'Updated fleet settings'})
							}),
						$author$project$Effect$fromShared(
							$author$project$Shared$OnRefreshFleet(
								$elm$core$Result$Ok(f))));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'OnFetchApiKeys':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							apiKeys: A2(
								$author$project$Views$FleetForm$apiKeysFetched,
								A2($elm$core$Result$mapError, $author$project$Api$errorString, result),
								model.apiKeys)
						}),
					$author$project$Effect$none);
			case 'OnCreateApiKey':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							apiKeys: A2(
								$author$project$Views$FleetForm$apiKeyIssued,
								A2($elm$core$Result$mapError, $author$project$Api$errorString, result),
								model.apiKeys)
						}),
					$author$project$Effect$none);
			case 'OnRevokeApiKey':
				var keyId = msg.a;
				var result = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							apiKeys: A3(
								$author$project$Views$FleetForm$apiKeyRevoked,
								keyId,
								A2($elm$core$Result$mapError, $author$project$Api$errorString, result),
								model.apiKeys)
						}),
					$author$project$Effect$none);
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$Edit$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$Edit$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$Edit$init, shared, session, req),
					view: A2($author$project$Pages$Fleet_$Edit$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Edit$update(session),
					subscriptions: $author$project$Pages$Fleet_$Edit$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Boats$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Boats$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Api$fetchBoats = F4(
	function (token, apiUrl, fleet, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'boats']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Boat$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$OnFetchBoats = function (a) {
	return {$: 'OnFetchBoats', a: a};
};
var $author$project$Api$fetchArchivedBoats = F4(
	function (token, apiUrl, fleet, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'boats', 'archived']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Boat$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$OnFetchArchivedBoats = function (a) {
	return {$: 'OnFetchArchivedBoats', a: a};
};
var $author$project$Pages$Fleet_$Boats$init = F5(
	function (session, apiUrl, fleetUrl, locale, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					boats: _List_Nil,
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					apiUrl: apiUrl,
					locale: locale,
					fleetUrl: fleetUrl,
					timeZone: $elm$time$Time$utc,
					wifiEdit: $elm$core$Maybe$Nothing,
					currentTime: $elm$time$Time$millisToPosix(0),
					archivedBoats: _List_Nil
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchBoats, session.authToken, apiUrl, f, $author$project$Pages$Fleet_$Boats$OnFetchBoats),
							A4($author$project$Api$fetchArchivedBoats, session.authToken, apiUrl, f, $author$project$Pages$Fleet_$Boats$OnFetchArchivedBoats),
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Boats$GotZone, $elm$time$Time$here)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Boats$OnTick, $elm$time$Time$now)),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Vessels')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					boats: _List_Nil,
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					apiUrl: apiUrl,
					locale: locale,
					fleetUrl: fleetUrl,
					timeZone: $elm$time$Time$utc,
					wifiEdit: $elm$core$Maybe$Nothing,
					currentTime: $elm$time$Time$millisToPosix(0),
					archivedBoats: _List_Nil
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$copy = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'copy',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$copy = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$copy);
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$wifi = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'wifi',
	_Utils_Tuple2(640, 512),
	_Utils_Tuple2('M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$wifi = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$wifi);
var $author$project$Pages$Fleet_$Boats$Logout = {$: 'Logout'};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$download = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'download',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$download = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$download);
var $author$project$Pages$Fleet_$Boats$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Boats$CopyBoatID = function (a) {
	return {$: 'CopyBoatID', a: a};
};
var $author$project$Pages$Fleet_$Boats$EditLADWifi = function (a) {
	return {$: 'EditLADWifi', a: a};
};
var $author$project$Pages$Fleet_$Boats$guestViewUrl = F2(
	function (model, boat) {
		return A2(
			$elm$core$Maybe$map,
			function (config) {
				return A3(
					$elm$url$Url$Builder$crossOrigin,
					model.fleetUrl,
					_List_fromArray(
						[
							model.fleet.slug,
							'public',
							$author$project$Data$Boat$boatIdToString(boat.boatId)
						]),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'key', config.dashboardKey)
						]));
			},
			model.fleet.guestViewConfiguration);
	});
var $author$project$Views$Dialog$empty = A2($elm$html$Html$span, _List_Nil, _List_Nil);
var $author$project$Views$Dialog$maybe = F3(
	function (_default, f, value) {
		if (value.$ === 'Just') {
			var value_ = value.a;
			return f(value_);
		} else {
			return _default;
		}
	});
var $author$project$Views$Dialog$isJust = function (m) {
	if (m.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Views$Dialog$backdrop = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'modal-backdrop in',
						$author$project$Views$Dialog$isJust(config))
					]))
			]),
		_List_Nil);
};
var $author$project$Views$Dialog$wrapBody = function (body) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-body')
			]),
		_List_fromArray(
			[body]));
};
var $author$project$Views$Dialog$wrapFooter = function (footer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-footer')
			]),
		_List_fromArray(
			[footer]));
};
var $author$project$Views$Dialog$closeButton = function (closeMessage) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn-close'),
				$elm$html$Html$Events$onClick(closeMessage)
			]),
		_List_Nil);
};
var $author$project$Views$Dialog$wrapHeader = F2(
	function (closeMessage, header) {
		return (_Utils_eq(closeMessage, $elm$core$Maybe$Nothing) && _Utils_eq(header, $elm$core$Maybe$Nothing)) ? $author$project$Views$Dialog$empty : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-header')
				]),
			_List_fromArray(
				[
					A2($elm$core$Maybe$withDefault, $author$project$Views$Dialog$empty, header),
					A3($author$project$Views$Dialog$maybe, $author$project$Views$Dialog$empty, $author$project$Views$Dialog$closeButton, closeMessage)
				]));
	});
var $author$project$Views$Dialog$view = function (maybeConfig) {
	var displayed = $author$project$Views$Dialog$isJust(maybeConfig);
	return A2(
		$elm$html$Html$div,
		function () {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.containerClass;
				},
				maybeConfig);
			if (_v0.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var containerClass = _v0.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class(containerClass)
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('in', displayed)
							])),
						A2(
						$elm$html$Html$Attributes$style,
						'display',
						displayed ? 'block' : 'none')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog modal-dialog-centered')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-content')
									]),
								function () {
									if (maybeConfig.$ === 'Nothing') {
										return _List_fromArray(
											[$author$project$Views$Dialog$empty]);
									} else {
										var config = maybeConfig.a;
										return _List_fromArray(
											[
												A2($author$project$Views$Dialog$wrapHeader, config.closeMessage, config.header),
												A3($author$project$Views$Dialog$maybe, $author$project$Views$Dialog$empty, $author$project$Views$Dialog$wrapBody, config.body),
												A3($author$project$Views$Dialog$maybe, $author$project$Views$Dialog$empty, $author$project$Views$Dialog$wrapFooter, config.footer)
											]);
									}
								}())
							]))
					])),
				$author$project$Views$Dialog$backdrop(maybeConfig)
			]));
};
var $author$project$Pages$Fleet_$Boats$SetSSID = function (a) {
	return {$: 'SetSSID', a: a};
};
var $author$project$Pages$Fleet_$Boats$SaveLADWifi = {$: 'SaveLADWifi'};
var $author$project$Pages$Fleet_$Boats$SetPassword = function (a) {
	return {$: 'SetPassword', a: a};
};
var $author$project$Pages$Fleet_$Boats$DismissModal = {$: 'DismissModal'};
var $author$project$Pages$Fleet_$Boats$ladWifiPopup = function (e) {
	return $author$project$Views$Dialog$view(
		A2(
			$elm$core$Maybe$map,
			function (edit) {
				return {
					body: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('wifiSsid'),
													$elm$html$Html$Attributes$class('form-label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('SSID')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$class('form-control'),
													$elm$html$Html$Attributes$id('wifiSsid'),
													$elm$html$Html$Attributes$value(edit.ssid),
													$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Boats$SetSSID)
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('wifiPassword'),
													$elm$html$Html$Attributes$class('form-label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Password')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('password'),
													$elm$html$Html$Attributes$class('form-control'),
													$elm$html$Html$Attributes$id('wifiPassword'),
													$elm$html$Html$Attributes$value(edit.password),
													$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Boats$SetPassword)
												]),
											_List_Nil)
										])),
									function () {
									var _v0 = edit.error;
									if (_v0.$ === 'Just') {
										var err = _v0.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-danger')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(err)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								]))),
					footer: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn btn-secondary me-2'),
											$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$DismissModal)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Close')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn btn-primary'),
											$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$SaveLADWifi),
											$elm$html$Html$Attributes$disabled(edit.saving)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set Wifi'),
											edit.saving ? $lattyware$elm_fontawesome$FontAwesome$view(
											A2(
												$lattyware$elm_fontawesome$FontAwesome$styled,
												_List_fromArray(
													[
														$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
														$lattyware$elm_fontawesome$FontAwesome$Attributes$fa2x1,
														$elm$svg$Svg$Attributes$class('ms-2')
													]),
												$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : $elm$html$Html$text('')
										]))
								]))),
					header: $elm$core$Maybe$Just(
						$elm$html$Html$text('Configure Tracker Wifi')),
					closeMessage: $elm$core$Maybe$Just($author$project$Pages$Fleet_$Boats$DismissModal),
					containerClass: $elm$core$Maybe$Just('modal-dialog-centered')
				};
			},
			e));
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$trashArrowUp = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'trash-arrow-up',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0L394.8 467c-1.6 25.3-22.6 45-47.9 45l-245.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$trashArrowUp = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$trashArrowUp);
var $author$project$Pages$Fleet_$Boats$UnarchiveBoat = function (a) {
	return {$: 'UnarchiveBoat', a: a};
};
var $author$project$Pages$Fleet_$Boats$DownloadQRCode = function (a) {
	return {$: 'DownloadQRCode', a: a};
};
var $author$project$Pages$Fleet_$Boats$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Gen$Route$Fleet___NewBoat = function (a) {
	return {$: 'Fleet___NewBoat', a: a};
};
var $author$project$Gen$Route$Fleet___Boats__BoatId___Edit = function (a) {
	return {$: 'Fleet___Boats__BoatId___Edit', a: a};
};
var $author$project$Pages$Fleet_$Boats$view = F3(
	function (session, featureDropState, model) {
		var archivedRow = function (b) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(b.name),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('badge text-bg-warning ms-2 align-middle')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Archived')
											]))
									]))
							])),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						A2($author$project$Data$User$isFleetAdmin, model.fleet.slug, session.user) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-secondary'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Fleet_$Boats$UnarchiveBoat(b.boatId))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('me-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$trashArrowUp)),
										$elm$html$Html$text('Unarchive')
									]))
							]) : _List_Nil)
					]));
		};
		var headerCell = function (field) {
			return A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(field)
							]))
					]));
		};
		var row = function (b) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						A2($author$project$Data$User$isFleetAdmin, model.fleet.slug, session.user) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(b.name)
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Gen$Route$toHref(
											$author$project$Gen$Route$Fleet___Boats__BoatId___Edit(
												{
													fleet: model.fleet.slug,
													boatId: $author$project$Data$Boat$boatIdToString(b.boatId)
												})))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('ms-2 text-secondary')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$edit))
									]))
							]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(b.name)
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-danger', b.isOffline)
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												A2($author$project$ISO8601$Extra$toFormattedDateTime, model.locale, model.timeZone),
												b.lastUpdate)))
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('me-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Data$Boat$statusToString(b.status))
									])),
								$lattyware$elm_fontawesome$FontAwesome$view(
								$author$project$Data$Boat$statusIcon(b)),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (a) {
										return $lattyware$elm_fontawesome$FontAwesome$view(
											A2(
												$lattyware$elm_fontawesome$FontAwesome$styled,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('mx-1')
													]),
												$author$project$Data$AlertType$icon(a.type_)));
									},
									$author$project$Data$Boat$uniqueActiveAlerts(b)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						function () {
							var _v0 = A2($author$project$Pages$Fleet_$Boats$guestViewUrl, model, b);
							if (_v0.$ === 'Just') {
								var url = _v0.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(url),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View Map'),
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('ms-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$arrowUpRightFromSquare))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						function () {
							var _v1 = A2($author$project$Pages$Fleet_$Boats$guestViewUrl, model, b);
							if (_v1.$ === 'Just') {
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-anchor text-secondary'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Fleet_$Boats$DownloadQRCode(b))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Download PNG'),
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('ms-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('nebolink: ')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fw-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Data$Boat$trackerIdToDisplayString, b.trackerId)))
											])),
										function () {
										var _v2 = b.trackerId;
										if ((_v2.$ === 'Just') && (_v2.a.$ === 'LAD')) {
											return A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('btn btn-anchor text-secondary'),
														$elm$html$Html$Events$onClick(
														$author$project$Pages$Fleet_$Boats$EditLADWifi(b.boatId))
													]),
												_List_fromArray(
													[
														$lattyware$elm_fontawesome$FontAwesome$view(
														A2(
															$lattyware$elm_fontawesome$FontAwesome$styled,
															_List_fromArray(
																[
																	$elm$svg$Svg$Attributes$class('mx-2')
																]),
															$lattyware$elm_fontawesome$FontAwesome$Solid$wifi))
													]));
										} else {
											return $elm$html$Html$text('');
										}
									}()
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-secondary')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('ID: ')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fw-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Data$Boat$boatIdToString(b.boatId))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-anchor text-secondary'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Fleet_$Boats$CopyBoatID(b.boatId))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('mx-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$copy))
									]))
							]))
					]));
		};
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(
						$author$project$Gen$Route$Fleet___Boats(
							{fleet: model.fleet.slug})),
					featureDropState,
					$author$project$Pages$Fleet_$Boats$ChangelogAction,
					$author$project$Pages$Fleet_$Boats$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex justify-content-between align-items-center py-3 px-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Vessels')
											])),
										A2($author$project$Data$User$isFleetAdmin, model.fleet.slug, session.user) ? A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-light btn'),
												$elm$html$Html$Attributes$href(
												$author$project$Gen$Route$toHref(
													$author$project$Gen$Route$Fleet___NewBoat(
														{fleet: model.fleet.slug})))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add New Vessel'),
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('ms-1')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$plus))
											])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('table-responsive-lg')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														A2(
															$elm$core$List$map,
															headerCell,
															_List_fromArray(
																['Vessel Name', 'Updated', 'Status', 'Guest Map', 'QR Code', 'Identity'])))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												_Utils_ap(
													A2($elm$core$List$map, row, model.boats),
													($elm$core$List$isEmpty(model.archivedBoats) || (!A2($author$project$Data$User$isFleetAdmin, model.fleet.slug, session.user))) ? _List_Nil : A2($elm$core$List$map, archivedRow, model.archivedBoats)))
											]))
									]))
							])),
						$author$project$Pages$Fleet_$Boats$ladWifiPopup(model.wifiEdit),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Boats$CloseError)
					])),
			title: 'Vessels'
		};
	});
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Api$postLADWifi = F7(
	function (token, apiUrl, fleet, boatId, ssid, password, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'boats',
								$author$project$Data$Boat$boatIdToString(boatId),
								'ladwifi'
							]),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'ssid',
									$elm$json$Json$Encode$string(ssid)),
									_Utils_Tuple2(
									'password',
									$elm$json$Json$Encode$string(password))
								]))),
					expect: $author$project$Api$expectWhatever,
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$OnSaveLADWifi = function (a) {
	return {$: 'OnSaveLADWifi', a: a};
};
var $author$project$Api$unarchiveBoat = F5(
	function (token, apiUrl, fleet, boatId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'boats',
								$author$project$Data$Boat$boatIdToString(boatId),
								'unarchive'
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectWhatever,
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$OnUnarchiveBoat = function (a) {
	return {$: 'OnUnarchiveBoat', a: a};
};
var $elm$bytes$Bytes$LE = {$: 'LE'};
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 'I8':
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 'I16':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_i16,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'I32':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_i32,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'U8':
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 'U16':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_u16,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'U32':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_u32,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'F32':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_f32,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'F64':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_f64,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'Seq':
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 'Utf8':
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 'I8':
			return 1;
		case 'I16':
			return 2;
		case 'I32':
			return 4;
		case 'U8':
			return 1;
		case 'U16':
			return 2;
		case 'U32':
			return 4;
		case 'F32':
			return 4;
		case 'F64':
			return 8;
		case 'Seq':
			var w = builder.a;
			return w;
		case 'Utf8':
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 'Seq', a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $justgook$elm_image$Image$Internal$ImageData$toArray2d = function (image) {
	toArray2d:
	while (true) {
		if (image.$ === 'ImageRaw') {
			var arr = image.b;
			return arr;
		} else {
			var meta = image.a;
			var fn = image.b;
			var _v1 = fn(meta);
			if (_v1.$ === 'Lazy') {
				return $elm$core$Array$empty;
			} else {
				var newData = _v1;
				var $temp$image = newData;
				image = $temp$image;
				continue toArray2d;
			}
		}
	}
};
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 'Bytes', a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $folkertdev$elm_flate$Flate$Dynamic = function (a) {
	return {$: 'Dynamic', a: a};
};
var $folkertdev$elm_flate$LZ77$max_distance = 32768;
var $folkertdev$elm_flate$LZ77$maxWindowSize = $folkertdev$elm_flate$LZ77$max_distance;
var $folkertdev$elm_flate$Flate$WithWindowSize = function (a) {
	return {$: 'WithWindowSize', a: a};
};
var $elm$bytes$Bytes$BE = {$: 'BE'};
var $elm$core$Bitwise$or = _Bitwise_or;
var $folkertdev$elm_flate$Checksum$Adler32$a32 = {base: 65521, nmax: 5552};
var $elm$bytes$Bytes$width = _Bytes_width;
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0.a;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = function (a) {
	return {$: 'Decoder', a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0.a;
		return $elm$bytes$Bytes$Decode$Decoder(
			F2(
				function (bites, offset) {
					var _v1 = A2(decodeA, bites, offset);
					var aOffset = _v1.a;
					var a = _v1.b;
					return _Utils_Tuple2(
						aOffset,
						func(a));
				}));
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0.a;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (step.$ === 'Loop') {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return $elm$bytes$Bytes$Decode$Decoder(
			A2($elm$bytes$Bytes$Decode$loopHelp, state, callback));
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return $elm$bytes$Bytes$Decode$Decoder(
		F2(
			function (_v0, offset) {
				return _Utils_Tuple2(offset, a);
			}));
};
var $elm$bytes$Bytes$Decode$map2 = F3(
	function (func, _v0, _v1) {
		var decodeA = _v0.a;
		var decodeB = _v1.a;
		return $elm$bytes$Bytes$Decode$Decoder(
			F2(
				function (bites, offset) {
					var _v2 = A2(decodeA, bites, offset);
					var aOffset = _v2.a;
					var a = _v2.b;
					var _v3 = A2(decodeB, bites, aOffset);
					var bOffset = _v3.a;
					var b = _v3.b;
					return _Utils_Tuple2(
						bOffset,
						A2(func, a, b));
				}));
	});
var $folkertdev$elm_flate$Checksum$Adler32$step8Bytes = F5(
	function (remaining, s1, s2, word1, word2) {
		var byte8 = 255 & word2;
		var byte7 = 255 & (word2 >>> 8);
		var byte6 = 255 & (word2 >>> 16);
		var byte5 = 255 & (word2 >>> 24);
		var byte4 = 255 & word1;
		var byte3 = 255 & (word1 >>> 8);
		var byte2 = 255 & (word1 >>> 16);
		var byte1 = 255 & (word1 >>> 24);
		var s1a_1 = s1 + byte1;
		var s1a_2 = s1a_1 + byte2;
		var s1a_3 = s1a_2 + byte3;
		var s1a_4 = s1a_3 + byte4;
		var s2a_1 = s2 + s1a_1;
		var s2a_2 = s2a_1 + s1a_2;
		var s2a_3 = s2a_2 + s1a_3;
		var s2a_4 = s2a_3 + s1a_4;
		var s1b_1 = s1a_4 + byte5;
		var s1b_2 = s1b_1 + byte6;
		var s1b_3 = s1b_2 + byte7;
		var s1b_4 = s1b_3 + byte8;
		var s2b_1 = s2a_4 + s1b_1;
		var s2b_2 = s2b_1 + s1b_2;
		var s2b_3 = s2b_2 + s1b_3;
		var s2b_4 = s2b_3 + s1b_4;
		return $elm$bytes$Bytes$Decode$Loop(
			{s1: s1b_4, s2: s2b_4, remaining: remaining - 8});
	});
var $elm$bytes$Bytes$Decode$unsignedInt8 = $elm$bytes$Bytes$Decode$Decoder(_Bytes_read_u8);
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return $elm$bytes$Bytes$Decode$Decoder(
		_Bytes_read_u32(
			_Utils_eq(endianness, $elm$bytes$Bytes$LE)));
};
var $folkertdev$elm_flate$Checksum$Adler32$processChunkHelp = function (_v0) {
	var s2 = _v0.s2;
	var s1 = _v0.s1;
	var remaining = _v0.remaining;
	return (remaining >= 8) ? A3(
		$elm$bytes$Bytes$Decode$map2,
		A3($folkertdev$elm_flate$Checksum$Adler32$step8Bytes, remaining, s1, s2),
		$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
		$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_byte) {
			return $elm$bytes$Bytes$Decode$Loop(
				{s1: s1 + _byte, s2: (s1 + _byte) + s2, remaining: remaining - 1});
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			{s1: s1 % $folkertdev$elm_flate$Checksum$Adler32$a32.base, s2: s2 % $folkertdev$elm_flate$Checksum$Adler32$a32.base})));
};
var $folkertdev$elm_flate$Checksum$Adler32$processChunk = function (config) {
	return A2($elm$bytes$Bytes$Decode$loop, config, $folkertdev$elm_flate$Checksum$Adler32$processChunkHelp);
};
var $folkertdev$elm_flate$Checksum$Adler32$chunkedFold = function (_v0) {
	var maxBlockSize = _v0.maxBlockSize;
	var bufferSize = _v0.bufferSize;
	var go = function (_v1) {
		var s2 = _v1.s2;
		var s1 = _v1.s1;
		var remainingLength = _v1.remainingLength;
		return (!remainingLength) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(
				{s1: s1, s2: s2})) : ((_Utils_cmp(remainingLength, maxBlockSize) < 0) ? A2(
			$elm$bytes$Bytes$Decode$map,
			$elm$bytes$Bytes$Decode$Done,
			$folkertdev$elm_flate$Checksum$Adler32$processChunk(
				{s1: s1, s2: s2, remaining: remainingLength})) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (result) {
				return $elm$bytes$Bytes$Decode$Loop(
					{s1: result.s1, s2: result.s2, remainingLength: remainingLength - maxBlockSize});
			},
			$folkertdev$elm_flate$Checksum$Adler32$processChunk(
				{s1: s1, s2: s2, remaining: maxBlockSize})));
	};
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		{s1: 1, s2: 0, remainingLength: bufferSize},
		go);
};
var $folkertdev$elm_flate$Checksum$Adler32$adler32 = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$Checksum$Adler32$chunkedFold(
			{
				bufferSize: $elm$bytes$Bytes$width(buffer),
				maxBlockSize: $folkertdev$elm_flate$Checksum$Adler32$a32.nmax
			}),
		buffer);
	if (_v0.$ === 'Nothing') {
		return 0;
	} else {
		var s2 = _v0.a.s2;
		var s1 = _v0.a.s1;
		return ((s2 << 16) | s1) >>> 0;
	}
};
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 'U8', a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 'U32', a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $folkertdev$elm_flate$Deflate$BitWriter$run = function (state) {
	return $elm$core$List$reverse(state.encoders);
};
var $folkertdev$elm_flate$Deflate$BitWriter$empty = {tag: 0, encoders: _List_Nil, bitsWritten: 0};
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return $elm$bytes$Bytes$Decode$Decoder(
		_Bytes_read_bytes(n));
};
var $folkertdev$elm_flate$Deflate$Internal$chunksHelp = F2(
	function (chunkSize, _v0) {
		var sizeRemaining = _v0.a;
		var accum = _v0.b;
		return (!sizeRemaining) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(_List_Nil)) : ((_Utils_cmp(chunkSize, sizeRemaining) > -1) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Done(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(true, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(sizeRemaining)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						sizeRemaining - chunkSize,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(false, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(chunkSize)));
	});
var $folkertdev$elm_flate$Deflate$Internal$chunks = F2(
	function (chunkSize, buffer) {
		var _v0 = A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				_Utils_Tuple2(
					$elm$bytes$Bytes$width(buffer),
					_List_Nil),
				$folkertdev$elm_flate$Deflate$Internal$chunksHelp(chunkSize)),
			buffer);
		if (_v0.$ === 'Nothing') {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					true,
					$elm$bytes$Bytes$Encode$encode(
						$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
				]);
		} else {
			if (!_v0.a.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						true,
						$elm$bytes$Bytes$Encode$encode(
							$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
					]);
			} else {
				var value = _v0.a;
				return value;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$BitWriter$flushLoop = F3(
	function (tag, bitsWritten, encoders) {
		flushLoop:
		while (true) {
			if (bitsWritten > 0) {
				var $temp$tag = tag >> 8,
					$temp$bitsWritten = A2($elm$core$Basics$max, 0, bitsWritten - 8),
					$temp$encoders = A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(tag),
					encoders);
				tag = $temp$tag;
				bitsWritten = $temp$bitsWritten;
				encoders = $temp$encoders;
				continue flushLoop;
			} else {
				return {tag: tag, encoders: encoders, bitsWritten: bitsWritten};
			}
		}
	});
var $folkertdev$elm_flate$Deflate$BitWriter$flush = function (state) {
	return A3($folkertdev$elm_flate$Deflate$BitWriter$flushLoop, state.tag, state.bitsWritten, state.encoders);
};
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.tail, tail);
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.tail)) - tailLen;
		return (notAppended < 0) ? {
			tail: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail),
			nodeList: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.nodeList),
			nodeListSize: builder.nodeListSize + 1
		} : ((!notAppended) ? {
			tail: $elm$core$Elm$JsArray$empty,
			nodeList: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.nodeList),
			nodeListSize: builder.nodeListSize + 1
		} : {tail: appended, nodeList: builder.nodeList, nodeListSize: builder.nodeListSize});
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (node.$ === 'SubTree') {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						tail: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head),
						nodeList: _List_Nil,
						nodeListSize: 0
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (_v0.$ === 'SubTree') {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (_v0.$ === 'SubTree') {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 'U16', a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $folkertdev$elm_flate$ByteArray$fasterEncodeR = function (_v0) {
	var bytesOnAccum = _v0.a;
	var accum = _v0.b;
	var otherEncoders = _v0.c;
	var encoders = function () {
		switch (bytesOnAccum) {
			case 0:
				return otherEncoders;
			case 1:
				return A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(accum),
					otherEncoders);
			case 2:
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, $elm$bytes$Bytes$BE, accum),
					otherEncoders);
			default:
				var otherBytes = accum >> 8;
				var firstByte = 255 & accum;
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, $elm$bytes$Bytes$BE, otherBytes),
					A2(
						$elm$core$List$cons,
						$elm$bytes$Bytes$Encode$unsignedInt8(firstByte),
						otherEncoders));
		}
	}();
	return encoders;
};
var $folkertdev$elm_flate$ByteArray$fasterEncodeFolderR = F2(
	function (_byte, _v0) {
		var bytesOnAccum = _v0.a;
		var accum = _v0.b;
		var encoders = _v0.c;
		switch (bytesOnAccum) {
			case 0:
				var value = 255 & _byte;
				return _Utils_Tuple3(1, value, encoders);
			case 1:
				var value = accum | ((255 & _byte) << 8);
				return _Utils_Tuple3(2, value, encoders);
			case 2:
				var value = accum | ((255 & _byte) << 16);
				return _Utils_Tuple3(3, value, encoders);
			default:
				var value = accum | ((255 & _byte) << 24);
				return _Utils_Tuple3(
					0,
					0,
					A2(
						$elm$core$List$cons,
						A2($elm$bytes$Bytes$Encode$unsignedInt32, $elm$bytes$Bytes$BE, value),
						encoders));
		}
	});
var $folkertdev$elm_flate$ByteArray$toBytes = function (array) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$ByteArray$fasterEncodeR(
				A3(
					$elm$core$Array$foldr,
					$folkertdev$elm_flate$ByteArray$fasterEncodeFolderR,
					_Utils_Tuple3(0, 0, _List_Nil),
					array))));
};
var $folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded = F3(
	function (tag, bitsWritten, encoders) {
		return (bitsWritten >= 16) ? {
			tag: tag >> 16,
			encoders: A2(
				$elm$core$List$cons,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, $elm$bytes$Bytes$LE, tag),
				encoders),
			bitsWritten: bitsWritten - 16
		} : {tag: tag, encoders: encoders, bitsWritten: bitsWritten};
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBits = F3(
	function (bitwidth, bits, state) {
		return A3($folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded, state.tag | (bits << state.bitsWritten), state.bitsWritten + bitwidth, state.encoders);
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBit = function (b) {
	if (!b) {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 0);
	} else {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 1);
	}
};
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (value.$ === 'SubTree') {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $folkertdev$elm_flate$ByteArray$decodeByteArrayHelp = function (_v0) {
	var remaining = _v0.a;
	var accum = _v0.b;
	return (remaining >= 4) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			var byte4 = 255 & (_new >>> 0);
			var byte3 = 255 & ((_new >> 8) >>> 0);
			var byte2 = 255 & ((_new >> 16) >>> 0);
			var byte1 = 255 & ((_new >> 24) >>> 0);
			var newAccum = A2(
				$elm$core$Array$push,
				byte4,
				A2(
					$elm$core$Array$push,
					byte3,
					A2(
						$elm$core$Array$push,
						byte2,
						A2($elm$core$Array$push, byte1, accum))));
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(remaining - 4, newAccum));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($elm$core$Array$push, _new, accum)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(accum)));
};
var $folkertdev$elm_flate$ByteArray$decoder = function (n) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(n, $elm$core$Array$empty),
		$folkertdev$elm_flate$ByteArray$decodeByteArrayHelp);
};
var $folkertdev$elm_flate$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$ByteArray$decoder(
			$elm$bytes$Bytes$width(buffer)),
		buffer);
	if (_v0.$ === 'Nothing') {
		return $elm$core$Array$empty;
	} else {
		var value = _v0.a;
		return value;
	}
};
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $folkertdev$elm_flate$Deflate$BitWriter$writeEncoder = F2(
	function (encoder, state) {
		return {
			tag: state.tag,
			encoders: A2($elm$core$List$cons, encoder, state.encoders),
			bitsWritten: state.bitsWritten
		};
	});
var $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size = 65535;
var $folkertdev$elm_flate$Deflate$Internal$encodeRawBlock = F2(
	function (_v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		var byteArray = $folkertdev$elm_flate$ByteArray$fromBytes(buffer);
		var size = A2(
			$elm$core$Basics$min,
			$elm$core$Array$length(byteArray),
			$folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size);
		var sliced = A3($elm$core$Array$slice, 0, size, byteArray);
		return A2(
			$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
			$elm$bytes$Bytes$Encode$bytes(
				$folkertdev$elm_flate$ByteArray$toBytes(sliced)),
			A2(
				$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, $elm$bytes$Bytes$LE, ~size),
				A2(
					$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, $elm$bytes$Bytes$LE, size),
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							2,
							0,
							A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter))))));
	});
var $folkertdev$elm_flate$Deflate$Internal$default_block_size = 1024 * 1024;
var $folkertdev$elm_flate$Deflate$Internal$encodeRaw = function (buffer) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$Deflate$BitWriter$run(
				A3(
					$elm$core$List$foldl,
					F2(
						function (chunk, first) {
							return A2($folkertdev$elm_flate$Deflate$Internal$encodeRawBlock, chunk, first);
						}),
					$folkertdev$elm_flate$Deflate$BitWriter$empty,
					A2(
						$folkertdev$elm_flate$Deflate$Internal$chunks,
						A2($elm$core$Basics$min, $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size, $folkertdev$elm_flate$Deflate$Internal$default_block_size),
						buffer)))));
};
var $folkertdev$elm_flate$Deflate$Symbol$code = function (symbol) {
	switch (symbol.$) {
		case 'Literal':
			var _byte = symbol.a;
			return _byte;
		case 'EndOfBlock':
			return 256;
		default:
			var length = symbol.a;
			return ((length >= 3) && (length <= 10)) ? ((257 + length) - 3) : (((length >= 11) && (length <= 18)) ? (265 + (((length - 11) / 2) | 0)) : (((length >= 19) && (length <= 34)) ? (269 + (((length - 19) / 4) | 0)) : (((length >= 35) && (length <= 66)) ? (273 + (((length - 35) / 8) | 0)) : (((length >= 67) && (length <= 130)) ? (277 + (((length - 67) / 16) | 0)) : (((length >= 131) && (length <= 257)) ? (281 + (((length - 131) / 32) | 0)) : ((length === 258) ? 285 : (-1)))))));
	}
};
var $folkertdev$elm_flate$Huffman$encode = F2(
	function (symbol, _v0) {
		var table = _v0.a;
		var _v1 = A2($elm$core$Array$get, symbol, table);
		if (_v1.$ === 'Nothing') {
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 0, 0);
		} else {
			var bits = _v1.a.a.bits;
			var width = _v1.a.a.width;
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, width, bits);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$distance = function (symbol) {
	if (symbol.$ === 'Share') {
		var distance_ = symbol.b;
		if (distance_ <= 4) {
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(distance_ - 1, 0, 0));
		} else {
			var go = F3(
				function (extraBits, code_, base) {
					go:
					while (true) {
						if (_Utils_cmp(base * 2, distance_) < 0) {
							var $temp$extraBits = extraBits + 1,
								$temp$code_ = code_ + 2,
								$temp$base = base * 2;
							extraBits = $temp$extraBits;
							code_ = $temp$code_;
							base = $temp$base;
							continue go;
						} else {
							return _Utils_Tuple3(extraBits, code_, base);
						}
					}
				});
			var _v1 = A3(go, 1, 4, 4);
			var extraBits = _v1.a;
			var code_ = _v1.b;
			var base = _v1.c;
			var half = (base / 2) | 0;
			var delta = (distance_ - base) - 1;
			return (_Utils_cmp(distance_, base + half) < 1) ? $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta))) : $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_ + 1,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta)));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$extraLength = function (symbol) {
	if (symbol.$ === 'Share') {
		var length = symbol.a;
		return (((length >= 3) && (length <= 10)) || (length === 258)) ? $elm$core$Maybe$Nothing : (((length >= 11) && (length <= 18)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				1,
				A2($elm$core$Basics$modBy, 2, length - 11))) : (((length >= 19) && (length <= 34)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				2,
				A2($elm$core$Basics$modBy, 4, length - 19))) : (((length >= 35) && (length <= 66)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				3,
				A2($elm$core$Basics$modBy, 8, length - 35))) : (((length >= 67) && (length <= 130)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				4,
				A2($elm$core$Basics$modBy, 16, length - 67))) : (((length >= 131) && (length <= 257)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				5,
				A2($elm$core$Basics$modBy, 32, length - 131))) : $elm$core$Maybe$Nothing)))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$encode = F3(
	function (symbol, htrees, bitWriter) {
		var maybeDistance = function () {
			var _v2 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
			if (_v2.$ === 'Nothing') {
				return $elm$core$Basics$identity;
			} else {
				var _v3 = _v2.a;
				var code_ = _v3.a;
				var bits = _v3.b;
				var extra = _v3.c;
				return A2(
					$elm$core$Basics$composeR,
					A2($folkertdev$elm_flate$Huffman$encode, code_, htrees.distance),
					(bits > 0) ? A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra) : $elm$core$Basics$identity);
			}
		}();
		var maybeExtra = function () {
			var _v0 = $folkertdev$elm_flate$Deflate$Symbol$extraLength(symbol);
			if (_v0.$ === 'Nothing') {
				return $elm$core$Basics$identity;
			} else {
				var _v1 = _v0.a;
				var bits = _v1.a;
				var extra = _v1.b;
				return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra);
			}
		}();
		return maybeDistance(
			maybeExtra(
				A3(
					$folkertdev$elm_flate$Huffman$encode,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					htrees.literal,
					bitWriter)));
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (node.$ === 'SubTree') {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $folkertdev$elm_flate$Deflate$Symbol$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $folkertdev$elm_flate$Deflate$Symbol$EndOfBlock = {$: 'EndOfBlock'};
var $folkertdev$elm_flate$Deflate$Symbol$Share = F2(
	function (a, b) {
		return {$: 'Share', a: a, b: b};
	});
var $folkertdev$elm_flate$Deflate$Internal$codeToSymbol = function (code) {
	if (code.$ === 'Literal') {
		var v = code.a;
		return $folkertdev$elm_flate$Deflate$Symbol$Literal(v);
	} else {
		var length = code.a;
		var backwardDistance = code.b;
		return A2($folkertdev$elm_flate$Deflate$Symbol$Share, length, backwardDistance);
	}
};
var $folkertdev$elm_flate$PrefixTable$Large = function (a) {
	return {$: 'Large', a: a};
};
var $folkertdev$elm_flate$PrefixTable$Small = function (a) {
	return {$: 'Small', a: a};
};
var $folkertdev$elm_flate$PrefixTable$max_distance = 32768;
var $folkertdev$elm_flate$PrefixTable$max_window_size = $folkertdev$elm_flate$PrefixTable$max_distance;
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $folkertdev$elm_flate$PrefixTable$LargePrefixTable = function (a) {
	return {$: 'LargePrefixTable', a: a};
};
var $folkertdev$elm_flate$PrefixTable$newLargePrefixTable = $folkertdev$elm_flate$PrefixTable$LargePrefixTable(
	A2($elm$core$Array$repeat, 65535, _List_Nil));
var $folkertdev$elm_flate$PrefixTable$new = function (nbytes) {
	return (_Utils_cmp(nbytes, $folkertdev$elm_flate$PrefixTable$max_window_size) < 0) ? $folkertdev$elm_flate$PrefixTable$Small($elm$core$Dict$empty) : $folkertdev$elm_flate$PrefixTable$Large($folkertdev$elm_flate$PrefixTable$newLargePrefixTable);
};
var $folkertdev$elm_flate$Experimental$ByteArray$length = function (_v0) {
	var array = _v0.a;
	var finalSize = _v0.b;
	var finalBytes = _v0.c;
	var _v1 = $elm$core$Array$length(array) * 4;
	if (!_v1) {
		return finalSize;
	} else {
		var l = _v1;
		return l + finalSize;
	}
};
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (_v0.$ === 'SubTree') {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $folkertdev$elm_flate$PrefixTable$insertInList = F6(
	function (i, array, p2, position, remaining, accum) {
		insertInList:
		while (true) {
			if (!remaining.b) {
				var newPositions = A2(
					$elm$core$List$cons,
					_Utils_Tuple2(p2, position),
					accum);
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Large(
						$folkertdev$elm_flate$PrefixTable$LargePrefixTable(
							A3($elm$core$Array$set, i, newPositions, array))),
					$elm$core$Maybe$Nothing);
			} else {
				var current = remaining.a;
				var key = current.a;
				var oldValue = current.b;
				var rest = remaining.b;
				if (!(key - p2)) {
					var newPositions = _Utils_ap(
						accum,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(key, position),
							rest));
					return _Utils_Tuple2(
						$folkertdev$elm_flate$PrefixTable$Large(
							$folkertdev$elm_flate$PrefixTable$LargePrefixTable(
								A3($elm$core$Array$set, i, newPositions, array))),
						$elm$core$Maybe$Just(oldValue));
				} else {
					var $temp$i = i,
						$temp$array = array,
						$temp$p2 = p2,
						$temp$position = position,
						$temp$remaining = rest,
						$temp$accum = A2($elm$core$List$cons, current, accum);
					i = $temp$i;
					array = $temp$array;
					p2 = $temp$p2;
					position = $temp$position;
					remaining = $temp$remaining;
					accum = $temp$accum;
					continue insertInList;
				}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$insert = F3(
	function (_v0, position, ptable) {
		var prefix_ = _v0.a;
		var prefix = 16777215 & (prefix_ >>> 0);
		if (ptable.$ === 'Small') {
			var dict = ptable.a;
			var _v2 = A2($elm$core$Dict$get, prefix, dict);
			if (_v2.$ === 'Nothing') {
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Nothing);
			} else {
				var oldValue = _v2.a;
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Just(oldValue));
			}
		} else {
			var array = ptable.a.a;
			var index = prefix >> 8;
			var _v3 = A2($elm$core$Array$get, index, array);
			if (_v3.$ === 'Nothing') {
				return _Utils_Tuple2(ptable, $elm$core$Maybe$Nothing);
			} else {
				var positions = _v3.a;
				return A6($folkertdev$elm_flate$PrefixTable$insertInList, index, array, 255 & prefix, position, positions, _List_Nil);
			}
		}
	});
var $folkertdev$elm_flate$LZ77$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $folkertdev$elm_flate$LZ77$Pointer = F2(
	function (a, b) {
		return {$: 'Pointer', a: a, b: b};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$get = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalSize = _v0.b;
		var finalBytes = _v0.c;
		var offset = index % 4;
		if (_Utils_cmp(
			index,
			($elm$core$Array$length(array) * 4) + finalSize) > -1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_cmp(
				index,
				$elm$core$Array$length(array) * 4) > -1) {
				return $elm$core$Maybe$Just(255 & (finalBytes >>> (8 * (3 - offset))));
			} else {
				var internalIndex = (index / 4) | 0;
				var _v1 = A2($elm$core$Array$get, internalIndex, array);
				if (_v1.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var int32 = _v1.a;
					return $elm$core$Maybe$Just(255 & (int32 >>> (8 * (3 - offset))));
				}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$Prefix = F2(
	function (a, b) {
		return {$: 'Prefix', a: a, b: b};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$getInt32 = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalBytes = _v0.c;
		var size = $elm$core$Array$length(array);
		return (!(index - size)) ? $elm$core$Maybe$Just(finalBytes) : A2($elm$core$Array$get, index, array);
	});
var $folkertdev$elm_flate$PrefixTable$Trailing1 = function (a) {
	return {$: 'Trailing1', a: a};
};
var $folkertdev$elm_flate$PrefixTable$Trailing2 = F2(
	function (a, b) {
		return {$: 'Trailing2', a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$PrefixCode = function (a) {
	return {$: 'PrefixCode', a: a};
};
var $folkertdev$elm_flate$PrefixTable$OutOfBounds = {$: 'OutOfBounds'};
var $folkertdev$elm_flate$PrefixTable$prefixAt = F2(
	function (k, input) {
		var size = $folkertdev$elm_flate$Experimental$ByteArray$length(input);
		if (_Utils_cmp(k + 2, size) > -1) {
			if (_Utils_cmp(k, size) > -1) {
				return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
			} else {
				if (_Utils_cmp(k + 1, size) > -1) {
					var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v0.$ === 'Nothing') {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var value = _v0.a;
						return $folkertdev$elm_flate$PrefixTable$Trailing1(value);
					}
				} else {
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v1.$ === 'Nothing') {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var v1 = _v1.a;
						var _v2 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k + 1, input);
						if (_v2.$ === 'Nothing') {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var v2 = _v2.a;
							return A2($folkertdev$elm_flate$PrefixTable$Trailing2, v1, v2);
						}
					}
				}
			}
		} else {
			var internalIndex = (k / 4) | 0;
			var offset = k % 4;
			switch (offset) {
				case 0:
					var _v4 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v4.$ === 'Nothing') {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v4.a;
						var first = 255 & ((int32 >> 24) >>> 0);
						var code = int32 >> 8;
						return A2(
							$folkertdev$elm_flate$PrefixTable$Prefix,
							first,
							$folkertdev$elm_flate$PrefixTable$PrefixCode(code));
					}
				case 1:
					var _v5 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v5.$ === 'Nothing') {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v5.a;
						var first = 255 & ((255 & (int32 >> 16)) >>> 0);
						var code = 16777215 & int32;
						return A2(
							$folkertdev$elm_flate$PrefixTable$Prefix,
							first,
							$folkertdev$elm_flate$PrefixTable$PrefixCode(code));
					}
				case 2:
					var _v6 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v6.$ === 'Nothing') {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v6.a;
						var _v7 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v7.$ === 'Nothing') {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v7.a;
							var first = 255 & ((255 & (int32 >> 8)) >>> 0);
							var code = 16777215 & (((255 & (nextInt32 >> 24)) | ((65535 & int32) << 8)) >>> 0);
							return A2(
								$folkertdev$elm_flate$PrefixTable$Prefix,
								first,
								$folkertdev$elm_flate$PrefixTable$PrefixCode(code));
						}
					}
				default:
					var _v8 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v8.$ === 'Nothing') {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v8.a;
						var _v9 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v9.$ === 'Nothing') {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v9.a;
							var first = 255 & ((255 & int32) >>> 0);
							var code = (65535 & (nextInt32 >> 16)) | ((255 & int32) << 16);
							return A2(
								$folkertdev$elm_flate$PrefixTable$Prefix,
								first,
								$folkertdev$elm_flate$PrefixTable$PrefixCode(code));
						}
					}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$max_length = 258;
var $folkertdev$elm_flate$LZ77$longestCommonPrefixLoop = F5(
	function (i, j, limit, accum, array) {
		longestCommonPrefixLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, i, array);
				if (_v0.$ === 'Nothing') {
					return accum;
				} else {
					var value1 = _v0.a;
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, j, array);
					if (_v1.$ === 'Nothing') {
						return accum;
					} else {
						var value2 = _v1.a;
						if (!(value1 - value2)) {
							var $temp$i = i + 1,
								$temp$j = j + 1,
								$temp$limit = limit,
								$temp$accum = accum + 1,
								$temp$array = array;
							i = $temp$i;
							j = $temp$j;
							limit = $temp$limit;
							accum = $temp$accum;
							array = $temp$array;
							continue longestCommonPrefixLoop;
						} else {
							return accum;
						}
					}
				}
			} else {
				return accum;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$longestCommonPrefix = F3(
	function (i, j, array) {
		var remaining = A2(
			$elm$core$Basics$min,
			$folkertdev$elm_flate$LZ77$max_length - 3,
			$folkertdev$elm_flate$Experimental$ByteArray$length(array) - j);
		return A5($folkertdev$elm_flate$LZ77$longestCommonPrefixLoop, i, j, i + remaining, 0, array);
	});
var $folkertdev$elm_flate$LZ77$updatePrefixTableLoop = F4(
	function (k, limit, buffer, prefixTable) {
		updatePrefixTableLoop:
		while (true) {
			if (_Utils_cmp(k, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, k, buffer);
				if (_v0.$ === 'Prefix') {
					var code = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, code, k, prefixTable);
					var newPrefixTable = _v1.a;
					var $temp$k = k + 1,
						$temp$limit = limit,
						$temp$buffer = buffer,
						$temp$prefixTable = newPrefixTable;
					k = $temp$k;
					limit = $temp$limit;
					buffer = $temp$buffer;
					prefixTable = $temp$prefixTable;
					continue updatePrefixTableLoop;
				} else {
					return prefixTable;
				}
			} else {
				return prefixTable;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$flushLoop = F5(
	function (i, windowSize, buffer, prefixTable, encoders) {
		flushLoop:
		while (true) {
			var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, i, buffer);
			switch (_v0.$) {
				case 'OutOfBounds':
					return encoders;
				case 'Trailing1':
					var p1 = _v0.a;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p1),
						encoders);
				case 'Trailing2':
					var p1 = _v0.a;
					var p2 = _v0.b;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p2),
						A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders));
				default:
					var p1 = _v0.a;
					var key = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, key, i, prefixTable);
					var newPrefixTable = _v1.a;
					var matched = _v1.b;
					if (matched.$ === 'Just') {
						var j = matched.a;
						var distance = i - j;
						if ((distance - windowSize) <= 0) {
							var length = 3 + A3($folkertdev$elm_flate$LZ77$longestCommonPrefix, i + 3, j + 3, buffer);
							var newEncoders = A2(
								$elm$core$Array$push,
								A2($folkertdev$elm_flate$LZ77$Pointer, length, distance),
								encoders);
							var newerPrefixTable = A4($folkertdev$elm_flate$LZ77$updatePrefixTableLoop, i + 1, i + length, buffer, newPrefixTable);
							var $temp$i = i + length,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newerPrefixTable,
								$temp$encoders = newEncoders;
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						} else {
							var $temp$i = i + 1,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newPrefixTable,
								$temp$encoders = A2(
								$elm$core$Array$push,
								$folkertdev$elm_flate$LZ77$Literal(p1),
								encoders);
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						}
					} else {
						var $temp$i = i + 1,
							$temp$windowSize = windowSize,
							$temp$buffer = buffer,
							$temp$prefixTable = newPrefixTable,
							$temp$encoders = A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders);
						i = $temp$i;
						windowSize = $temp$windowSize;
						buffer = $temp$buffer;
						prefixTable = $temp$prefixTable;
						encoders = $temp$encoders;
						continue flushLoop;
					}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$flush = F2(
	function (windowSize, buffer) {
		var codes = A5(
			$folkertdev$elm_flate$LZ77$flushLoop,
			0,
			windowSize,
			buffer,
			$folkertdev$elm_flate$PrefixTable$new(
				$folkertdev$elm_flate$Experimental$ByteArray$length(buffer)),
			$elm$core$Array$empty);
		return codes;
	});
var $folkertdev$elm_flate$Experimental$ByteArray$ByteArray = F3(
	function (a, b, c) {
		return {$: 'ByteArray', a: a, b: b, c: c};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$empty = A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, $elm$core$Array$empty, 0, 0);
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0.a;
		var decodeB = _v1.a;
		var decodeC = _v2.a;
		var decodeD = _v3.a;
		var decodeE = _v4.a;
		return $elm$bytes$Bytes$Decode$Decoder(
			F2(
				function (bites, offset) {
					var _v5 = A2(decodeA, bites, offset);
					var aOffset = _v5.a;
					var a = _v5.b;
					var _v6 = A2(decodeB, bites, aOffset);
					var bOffset = _v6.a;
					var b = _v6.b;
					var _v7 = A2(decodeC, bites, bOffset);
					var cOffset = _v7.a;
					var c = _v7.b;
					var _v8 = A2(decodeD, bites, cOffset);
					var dOffset = _v8.a;
					var d = _v8.b;
					var _v9 = A2(decodeE, bites, dOffset);
					var eOffset = _v9.a;
					var e = _v9.b;
					return _Utils_Tuple2(
						eOffset,
						A5(func, a, b, c, d, e));
				}));
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (node.$ === 'SubTree') {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		tail: tail,
		nodeList: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		nodeListSize: (len / $elm$core$Array$branchFactor) | 0
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (node.$ === 'SubTree') {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (node.$ === 'SubTree') {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0.a;
		return $elm$bytes$Bytes$Decode$Decoder(
			F2(
				function (bites, offset) {
					var _v1 = A2(decodeA, bites, offset);
					var newOffset = _v1.a;
					var a = _v1.b;
					var _v2 = callback(a);
					var decodeB = _v2.a;
					return A2(decodeB, bites, newOffset);
				}));
	});
var $elm$bytes$Bytes$Decode$unsignedInt16 = function (endianness) {
	return $elm$bytes$Bytes$Decode$Decoder(
		_Bytes_read_u16(
			_Utils_eq(endianness, $elm$bytes$Bytes$LE)));
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp = function (_v0) {
	var remaining = _v0.a;
	var array = _v0.b;
	if (remaining >= 40) {
		return A2(
			$elm$bytes$Bytes$Decode$andThen,
			$elm$core$Basics$identity,
			A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return A6(
							$elm$bytes$Bytes$Decode$map5,
							F5(
								function (f, g, h, i, j) {
									return $elm$bytes$Bytes$Decode$Loop(
										_Utils_Tuple2(
											remaining - 40,
											A2(
												$elm$core$Array$append,
												array,
												$elm$core$Array$fromList(
													_List_fromArray(
														[a, b, c, d, e, f, g, h, i, j])))));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
							$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
							$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
							$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
							$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE)));
	} else {
		if (remaining >= 20) {
			return A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 20,
								A2(
									$elm$core$Array$push,
									e,
									A2(
										$elm$core$Array$push,
										d,
										A2(
											$elm$core$Array$push,
											c,
											A2(
												$elm$core$Array$push,
												b,
												A2($elm$core$Array$push, a, array)))))));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE));
		} else {
			if (remaining >= 4) {
				return A2(
					$elm$bytes$Bytes$Decode$map,
					function (a) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 4,
								A2($elm$core$Array$push, a, array)));
					},
					$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE));
			} else {
				switch (remaining) {
					case 0:
						return $elm$bytes$Bytes$Decode$succeed(
							$elm$bytes$Bytes$Decode$Done(
								_Utils_Tuple3(0, 0, array)));
					case 1:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(1, _byte << 24, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt8);
					case 2:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(2, _byte << 16, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE));
					default:
						return A3(
							$elm$bytes$Bytes$Decode$map2,
							F2(
								function (bytes, _byte) {
									return $elm$bytes$Bytes$Decode$Done(
										_Utils_Tuple3(3, (bytes << 16) | (_byte << 8), array));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE),
							$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(
				$elm$bytes$Bytes$width(buffer),
				$elm$core$Array$empty),
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp),
		buffer);
	if (_v0.$ === 'Nothing') {
		return $folkertdev$elm_flate$Experimental$ByteArray$empty;
	} else {
		var _v1 = _v0.a;
		var finalSize = _v1.a;
		var finalBytes = _v1.b;
		var array = _v1.c;
		return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
	}
};
var $folkertdev$elm_flate$LZ77$encodeWithOptions = F2(
	function (_v0, buffer) {
		var windowSize = _v0.windowSize;
		return A2(
			$folkertdev$elm_flate$LZ77$flush,
			windowSize,
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytes(buffer));
	});
var $folkertdev$elm_flate$Deflate$Internal$compress = F2(
	function (maybeWindowSize, buf) {
		if (maybeWindowSize.$ === 'Nothing') {
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Symbol$Literal,
					$folkertdev$elm_flate$ByteArray$fromBytes(buf)));
		} else {
			var windowSize = maybeWindowSize.a;
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Internal$codeToSymbol,
					A2(
						$folkertdev$elm_flate$LZ77$encodeWithOptions,
						{windowSize: windowSize},
						buf)));
		}
	});
var $folkertdev$elm_flate$Huffman$Tree = function (a) {
	return {$: 'Tree', a: a};
};
var $folkertdev$elm_flate$Huffman$Code = function (a) {
	return {$: 'Code', a: a};
};
var $folkertdev$elm_flate$Huffman$codeFromRecord = $folkertdev$elm_flate$Huffman$Code;
var $folkertdev$elm_flate$Huffman$fromList = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $folkertdev$elm_flate$Huffman$Tree, $elm$core$Array$fromList),
	$elm$core$List$map($folkertdev$elm_flate$Huffman$codeFromRecord));
var $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree = {
	literal: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{bits: 12, width: 8},
				{bits: 140, width: 8},
				{bits: 76, width: 8},
				{bits: 204, width: 8},
				{bits: 44, width: 8},
				{bits: 172, width: 8},
				{bits: 108, width: 8},
				{bits: 236, width: 8},
				{bits: 28, width: 8},
				{bits: 156, width: 8},
				{bits: 92, width: 8},
				{bits: 220, width: 8},
				{bits: 60, width: 8},
				{bits: 188, width: 8},
				{bits: 124, width: 8},
				{bits: 252, width: 8},
				{bits: 2, width: 8},
				{bits: 130, width: 8},
				{bits: 66, width: 8},
				{bits: 194, width: 8},
				{bits: 34, width: 8},
				{bits: 162, width: 8},
				{bits: 98, width: 8},
				{bits: 226, width: 8},
				{bits: 18, width: 8},
				{bits: 146, width: 8},
				{bits: 82, width: 8},
				{bits: 210, width: 8},
				{bits: 50, width: 8},
				{bits: 178, width: 8},
				{bits: 114, width: 8},
				{bits: 242, width: 8},
				{bits: 10, width: 8},
				{bits: 138, width: 8},
				{bits: 74, width: 8},
				{bits: 202, width: 8},
				{bits: 42, width: 8},
				{bits: 170, width: 8},
				{bits: 106, width: 8},
				{bits: 234, width: 8},
				{bits: 26, width: 8},
				{bits: 154, width: 8},
				{bits: 90, width: 8},
				{bits: 218, width: 8},
				{bits: 58, width: 8},
				{bits: 186, width: 8},
				{bits: 122, width: 8},
				{bits: 250, width: 8},
				{bits: 6, width: 8},
				{bits: 134, width: 8},
				{bits: 70, width: 8},
				{bits: 198, width: 8},
				{bits: 38, width: 8},
				{bits: 166, width: 8},
				{bits: 102, width: 8},
				{bits: 230, width: 8},
				{bits: 22, width: 8},
				{bits: 150, width: 8},
				{bits: 86, width: 8},
				{bits: 214, width: 8},
				{bits: 54, width: 8},
				{bits: 182, width: 8},
				{bits: 118, width: 8},
				{bits: 246, width: 8},
				{bits: 14, width: 8},
				{bits: 142, width: 8},
				{bits: 78, width: 8},
				{bits: 206, width: 8},
				{bits: 46, width: 8},
				{bits: 174, width: 8},
				{bits: 110, width: 8},
				{bits: 238, width: 8},
				{bits: 30, width: 8},
				{bits: 158, width: 8},
				{bits: 94, width: 8},
				{bits: 222, width: 8},
				{bits: 62, width: 8},
				{bits: 190, width: 8},
				{bits: 126, width: 8},
				{bits: 254, width: 8},
				{bits: 1, width: 8},
				{bits: 129, width: 8},
				{bits: 65, width: 8},
				{bits: 193, width: 8},
				{bits: 33, width: 8},
				{bits: 161, width: 8},
				{bits: 97, width: 8},
				{bits: 225, width: 8},
				{bits: 17, width: 8},
				{bits: 145, width: 8},
				{bits: 81, width: 8},
				{bits: 209, width: 8},
				{bits: 49, width: 8},
				{bits: 177, width: 8},
				{bits: 113, width: 8},
				{bits: 241, width: 8},
				{bits: 9, width: 8},
				{bits: 137, width: 8},
				{bits: 73, width: 8},
				{bits: 201, width: 8},
				{bits: 41, width: 8},
				{bits: 169, width: 8},
				{bits: 105, width: 8},
				{bits: 233, width: 8},
				{bits: 25, width: 8},
				{bits: 153, width: 8},
				{bits: 89, width: 8},
				{bits: 217, width: 8},
				{bits: 57, width: 8},
				{bits: 185, width: 8},
				{bits: 121, width: 8},
				{bits: 249, width: 8},
				{bits: 5, width: 8},
				{bits: 133, width: 8},
				{bits: 69, width: 8},
				{bits: 197, width: 8},
				{bits: 37, width: 8},
				{bits: 165, width: 8},
				{bits: 101, width: 8},
				{bits: 229, width: 8},
				{bits: 21, width: 8},
				{bits: 149, width: 8},
				{bits: 85, width: 8},
				{bits: 213, width: 8},
				{bits: 53, width: 8},
				{bits: 181, width: 8},
				{bits: 117, width: 8},
				{bits: 245, width: 8},
				{bits: 13, width: 8},
				{bits: 141, width: 8},
				{bits: 77, width: 8},
				{bits: 205, width: 8},
				{bits: 45, width: 8},
				{bits: 173, width: 8},
				{bits: 109, width: 8},
				{bits: 237, width: 8},
				{bits: 29, width: 8},
				{bits: 157, width: 8},
				{bits: 93, width: 8},
				{bits: 221, width: 8},
				{bits: 61, width: 8},
				{bits: 189, width: 8},
				{bits: 125, width: 8},
				{bits: 253, width: 8},
				{bits: 19, width: 9},
				{bits: 275, width: 9},
				{bits: 147, width: 9},
				{bits: 403, width: 9},
				{bits: 83, width: 9},
				{bits: 339, width: 9},
				{bits: 211, width: 9},
				{bits: 467, width: 9},
				{bits: 51, width: 9},
				{bits: 307, width: 9},
				{bits: 179, width: 9},
				{bits: 435, width: 9},
				{bits: 115, width: 9},
				{bits: 371, width: 9},
				{bits: 243, width: 9},
				{bits: 499, width: 9},
				{bits: 11, width: 9},
				{bits: 267, width: 9},
				{bits: 139, width: 9},
				{bits: 395, width: 9},
				{bits: 75, width: 9},
				{bits: 331, width: 9},
				{bits: 203, width: 9},
				{bits: 459, width: 9},
				{bits: 43, width: 9},
				{bits: 299, width: 9},
				{bits: 171, width: 9},
				{bits: 427, width: 9},
				{bits: 107, width: 9},
				{bits: 363, width: 9},
				{bits: 235, width: 9},
				{bits: 491, width: 9},
				{bits: 27, width: 9},
				{bits: 283, width: 9},
				{bits: 155, width: 9},
				{bits: 411, width: 9},
				{bits: 91, width: 9},
				{bits: 347, width: 9},
				{bits: 219, width: 9},
				{bits: 475, width: 9},
				{bits: 59, width: 9},
				{bits: 315, width: 9},
				{bits: 187, width: 9},
				{bits: 443, width: 9},
				{bits: 123, width: 9},
				{bits: 379, width: 9},
				{bits: 251, width: 9},
				{bits: 507, width: 9},
				{bits: 7, width: 9},
				{bits: 263, width: 9},
				{bits: 135, width: 9},
				{bits: 391, width: 9},
				{bits: 71, width: 9},
				{bits: 327, width: 9},
				{bits: 199, width: 9},
				{bits: 455, width: 9},
				{bits: 39, width: 9},
				{bits: 295, width: 9},
				{bits: 167, width: 9},
				{bits: 423, width: 9},
				{bits: 103, width: 9},
				{bits: 359, width: 9},
				{bits: 231, width: 9},
				{bits: 487, width: 9},
				{bits: 23, width: 9},
				{bits: 279, width: 9},
				{bits: 151, width: 9},
				{bits: 407, width: 9},
				{bits: 87, width: 9},
				{bits: 343, width: 9},
				{bits: 215, width: 9},
				{bits: 471, width: 9},
				{bits: 55, width: 9},
				{bits: 311, width: 9},
				{bits: 183, width: 9},
				{bits: 439, width: 9},
				{bits: 119, width: 9},
				{bits: 375, width: 9},
				{bits: 247, width: 9},
				{bits: 503, width: 9},
				{bits: 15, width: 9},
				{bits: 271, width: 9},
				{bits: 143, width: 9},
				{bits: 399, width: 9},
				{bits: 79, width: 9},
				{bits: 335, width: 9},
				{bits: 207, width: 9},
				{bits: 463, width: 9},
				{bits: 47, width: 9},
				{bits: 303, width: 9},
				{bits: 175, width: 9},
				{bits: 431, width: 9},
				{bits: 111, width: 9},
				{bits: 367, width: 9},
				{bits: 239, width: 9},
				{bits: 495, width: 9},
				{bits: 31, width: 9},
				{bits: 287, width: 9},
				{bits: 159, width: 9},
				{bits: 415, width: 9},
				{bits: 95, width: 9},
				{bits: 351, width: 9},
				{bits: 223, width: 9},
				{bits: 479, width: 9},
				{bits: 63, width: 9},
				{bits: 319, width: 9},
				{bits: 191, width: 9},
				{bits: 447, width: 9},
				{bits: 127, width: 9},
				{bits: 383, width: 9},
				{bits: 255, width: 9},
				{bits: 511, width: 9},
				{bits: 0, width: 7},
				{bits: 64, width: 7},
				{bits: 32, width: 7},
				{bits: 96, width: 7},
				{bits: 16, width: 7},
				{bits: 80, width: 7},
				{bits: 48, width: 7},
				{bits: 112, width: 7},
				{bits: 8, width: 7},
				{bits: 72, width: 7},
				{bits: 40, width: 7},
				{bits: 104, width: 7},
				{bits: 24, width: 7},
				{bits: 88, width: 7},
				{bits: 56, width: 7},
				{bits: 120, width: 7},
				{bits: 4, width: 7},
				{bits: 68, width: 7},
				{bits: 36, width: 7},
				{bits: 100, width: 7},
				{bits: 20, width: 7},
				{bits: 84, width: 7},
				{bits: 52, width: 7},
				{bits: 116, width: 7},
				{bits: 3, width: 8},
				{bits: 131, width: 8},
				{bits: 67, width: 8},
				{bits: 195, width: 8},
				{bits: 35, width: 8},
				{bits: 163, width: 8},
				{bits: 99, width: 8},
				{bits: 227, width: 8}
			])),
	distance: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{bits: 0, width: 5},
				{bits: 16, width: 5},
				{bits: 8, width: 5},
				{bits: 24, width: 5},
				{bits: 4, width: 5},
				{bits: 20, width: 5},
				{bits: 12, width: 5},
				{bits: 28, width: 5},
				{bits: 2, width: 5},
				{bits: 18, width: 5},
				{bits: 10, width: 5},
				{bits: 26, width: 5},
				{bits: 6, width: 5},
				{bits: 22, width: 5},
				{bits: 14, width: 5},
				{bits: 30, width: 5},
				{bits: 1, width: 5},
				{bits: 17, width: 5},
				{bits: 9, width: 5},
				{bits: 25, width: 5},
				{bits: 5, width: 5},
				{bits: 21, width: 5},
				{bits: 13, width: 5},
				{bits: 29, width: 5},
				{bits: 3, width: 5},
				{bits: 19, width: 5},
				{bits: 11, width: 5},
				{bits: 27, width: 5},
				{bits: 7, width: 5},
				{bits: 23, width: 5}
			]))
};
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var huffmanTrees = $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree;
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTrees, first);
				}),
			bitWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				1,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStatic = F2(
	function (windowSize, buffer) {
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return A3($folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock, windowSize, chunk, first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer))))));
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop = F3(
	function (xarr, yarr, accum) {
		mergeLoop:
		while (true) {
			var _v0 = _Utils_Tuple2(xarr, yarr);
			if (!_v0.a.b) {
				return A2(
					$elm$core$Array$append,
					accum,
					$elm$core$Array$fromList(yarr));
			} else {
				if (!_v0.b.b) {
					return A2(
						$elm$core$Array$append,
						accum,
						$elm$core$Array$fromList(xarr));
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xrest = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var yrest = _v2.b;
					if (_Utils_cmp(x.weight, y.weight) < 0) {
						var $temp$xarr = xrest,
							$temp$yarr = yarr,
							$temp$accum = A2($elm$core$Array$push, x, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					} else {
						var $temp$xarr = xarr,
							$temp$yarr = yrest,
							$temp$accum = A2($elm$core$Array$push, y, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					}
				}
			}
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge = F2(
	function (x, y) {
		return A3(
			$folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop,
			$elm$core$Array$toList(x),
			$elm$core$Array$toList(y),
			$elm$core$Array$empty);
	});
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 'Nothing') {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes = F2(
	function (node1, node2) {
		return {
			weight: node1.weight + node2.weight,
			symbols: A2($elm$core$Array$append, node1.symbols, node2.symbols)
		};
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$package = function (nodes) {
	if ($elm$core$Array$length(nodes) >= 2) {
		var newLen = ($elm$core$Array$length(nodes) / 2) | 0;
		var loop = F2(
			function (currentNodes, accum) {
				loop:
				while (true) {
					if (currentNodes.b && currentNodes.b.b) {
						var self = currentNodes.a;
						var _v1 = currentNodes.b;
						var other = _v1.a;
						var rest = _v1.b;
						var $temp$currentNodes = rest,
							$temp$accum = A2(
							$elm$core$List$cons,
							A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes, self, other),
							accum);
						currentNodes = $temp$currentNodes;
						accum = $temp$accum;
						continue loop;
					} else {
						return $elm$core$Array$fromList(
							$elm$core$List$reverse(accum));
					}
				}
			});
		return A2(
			loop,
			$elm$core$Array$toList(nodes),
			_List_Nil);
	} else {
		return nodes;
	}
};
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			tail: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail),
			nodeList: _List_Nil,
			nodeListSize: 0
		};
		var helper = F2(
			function (node, builder) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.nodeListSize * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						tail: builder.tail,
						nodeList: A2($elm$core$List$cons, mappedLeaf, builder.nodeList),
						nodeListSize: builder.nodeListSize + 1
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode = F2(
	function (symbol, weight) {
		return {
			weight: weight,
			symbols: A2($elm$core$Array$repeat, 1, symbol)
		};
	});
var $elm_community$list_extra$List$Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_v1, _v2) {
				var a1 = _v1.a;
				var i1 = _v1.b;
				var a2 = _v2.a;
				var i2 = _v2.b;
				var result = A2(pred, a1, a2);
				if (result.$ === 'EQ') {
					return A2($elm$core$Basics$compare, i1, i2);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, a) {
					return _Utils_Tuple2(a, i);
				}),
			list);
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($elm$core$List$sortWith, predWithIndex, listWithIndex));
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate = F2(
	function (maxBitWidth, frequencies) {
		var source = $elm$core$Array$fromList(
			A2(
				$elm_community$list_extra$List$Extra$stableSortWith,
				F2(
					function (a, b) {
						return A2($elm$core$Basics$compare, a.weight, b.weight);
					}),
				$elm$core$Array$toList(
					A2(
						$elm$core$Array$map,
						function (_v3) {
							var symbol = _v3.a;
							var weight = _v3.b;
							return A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode, symbol, weight);
						},
						A2(
							$elm$core$Array$filter,
							function (_v2) {
								var f = _v2.b;
								return f > 0;
							},
							A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, frequencies))))));
		var weighted = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, w) {
					return A2(
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge,
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(w),
						source);
				}),
			source,
			A2($elm$core$List$range, 0, maxBitWidth - 2));
		var allSymbols = A2(
			$elm$core$List$concatMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.symbols;
				},
				$elm$core$Array$toList),
			$elm$core$Array$toList(
				$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(weighted)));
		var loop = F2(
			function (symbols, accum) {
				loop:
				while (true) {
					if (!symbols.b) {
						return accum;
					} else {
						var symbol = symbols.a;
						var rest = symbols.b;
						var $temp$symbols = rest,
							$temp$accum = A3(
							$folkertdev$elm_flate$LengthLimitedHuffmanCodes$update,
							symbol,
							function (v) {
								return v + 1;
							},
							accum);
						symbols = $temp$symbols;
						accum = $temp$accum;
						continue loop;
					}
				}
			});
		return A2(
			loop,
			allSymbols,
			A2(
				$elm$core$Array$repeat,
				$elm$core$Array$length(frequencies),
				0));
	});
var $folkertdev$elm_flate$Huffman$new = function (n) {
	return $folkertdev$elm_flate$Huffman$Tree(
		A2(
			$elm$core$Array$repeat,
			n,
			$folkertdev$elm_flate$Huffman$codeFromRecord(
				{bits: 0, width: 0})));
};
var $folkertdev$elm_flate$Huffman$inverseEndianLoop = F4(
	function (i, limit, f, t) {
		inverseEndianLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var $temp$i = i + 1,
					$temp$limit = limit,
					$temp$f = f >> 1,
					$temp$t = (f & 1) | (t << 1);
				i = $temp$i;
				limit = $temp$limit;
				f = $temp$f;
				t = $temp$t;
				continue inverseEndianLoop;
			} else {
				return t;
			}
		}
	});
var $folkertdev$elm_flate$Huffman$inverseEndian = function (_v0) {
	var bits = _v0.a.bits;
	var width = _v0.a.width;
	var inverseBits = A4($folkertdev$elm_flate$Huffman$inverseEndianLoop, 0, width, bits, 0);
	return $folkertdev$elm_flate$Huffman$Code(
		{bits: inverseBits, width: width});
};
var $folkertdev$elm_flate$Huffman$setMapping = F3(
	function (symbol, code, _v0) {
		var array = _v0.a;
		return $folkertdev$elm_flate$Huffman$Tree(
			A3(
				$elm$core$Array$set,
				symbol,
				$folkertdev$elm_flate$Huffman$inverseEndian(code),
				array));
	});
var $folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes = F2(
	function (bitWidths, tree) {
		var symbols = A2(
			$elm_community$list_extra$List$Extra$stableSortWith,
			F2(
				function (_v4, _v5) {
					var a = _v4.b;
					var b = _v5.b;
					return A2($elm$core$Basics$compare, a, b);
				}),
			$elm$core$Array$toList(
				A2(
					$elm$core$Array$filter,
					function (_v3) {
						var codeBitWidth = _v3.b;
						return codeBitWidth > 0;
					},
					A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))));
		var loop = F2(
			function (_v1, _v2) {
				var symbol = _v1.a;
				var bitWidth = _v1.b;
				var code = _v2.a;
				var prevWidth = _v2.b;
				var currentTree = _v2.c;
				var newBits = code << (bitWidth - prevWidth);
				var nextCode = $folkertdev$elm_flate$Huffman$Code(
					{bits: newBits, width: bitWidth});
				return _Utils_Tuple3(
					newBits + 1,
					bitWidth,
					A3($folkertdev$elm_flate$Huffman$setMapping, symbol, nextCode, currentTree));
			});
		return function (_v0) {
			var x = _v0.c;
			return x;
		}(
			A3(
				$elm$core$List$foldl,
				loop,
				_Utils_Tuple3(0, 0, tree),
				symbols));
	});
var $folkertdev$elm_flate$Huffman$fromBitWidths = function (bitWidths) {
	var symbolCount = function (v) {
		return v + 1;
	}(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				function (a) {
					return A2(
						$elm$core$Array$get,
						$elm$core$Array$length(a) - 1,
						a);
				}(
					A2(
						$elm$core$Array$filter,
						function (e) {
							return e.b > 0;
						},
						A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))))));
	return A2(
		$folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes,
		bitWidths,
		$folkertdev$elm_flate$Huffman$new(symbolCount));
};
var $folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth = function (frequencies) {
	var heapModificationLoop = function (heap) {
		heapModificationLoop:
		while (true) {
			if (!heap.b) {
				return 0;
			} else {
				if (!heap.b.b) {
					var _v1 = heap.a;
					var value = _v1.b;
					return A2($elm$core$Basics$max, 1, value);
				} else {
					var _v2 = heap.a;
					var weight1 = _v2.a;
					var width1 = _v2.b;
					var _v3 = heap.b;
					var _v4 = _v3.a;
					var weight2 = _v4.a;
					var width2 = _v4.b;
					var rest = _v3.b;
					var $temp$heap = A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, b, a);
							}),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								weight1 + weight2,
								1 + A2($elm$core$Basics$max, width1, width2)),
							rest));
					heap = $temp$heap;
					continue heapModificationLoop;
				}
			}
		}
	};
	var createHeapFolder = F2(
		function (freq, heap) {
			return (freq > 0) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(-freq, 0),
				heap) : heap;
		});
	var createHeap = A3($elm$core$Array$foldl, createHeapFolder, _List_Nil, frequencies);
	return heapModificationLoop(createHeap);
};
var $folkertdev$elm_flate$Huffman$fromFrequencies = F2(
	function (symbolFrequencies, maxBitWidth_) {
		var maxBitWidth = A2(
			$elm$core$Basics$min,
			maxBitWidth_,
			$folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth(symbolFrequencies));
		var codeBitWidhts = A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate, maxBitWidth, symbolFrequencies);
		return $folkertdev$elm_flate$Huffman$fromBitWidths(codeBitWidhts);
	});
var $folkertdev$elm_flate$Deflate$Symbol$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 'Nothing') {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies = F2(
	function (symbol, _v0) {
		var literalCounts = _v0.a;
		var distanceCounts = _v0.b;
		var emptyDistanceCount = _v0.c;
		var _v1 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
		if (_v1.$ === 'Nothing') {
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				distanceCounts,
				emptyDistanceCount);
		} else {
			var _v2 = _v1.a;
			var d = _v2.a;
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					d,
					function (v) {
						return v + 1;
					},
					distanceCounts),
				false);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec = function (symbols) {
	var _v0 = A3(
		$elm$core$Array$foldl,
		$folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies,
		_Utils_Tuple3(
			A2($elm$core$Array$repeat, 286, 0),
			A2($elm$core$Array$repeat, 30, 0),
			true),
		symbols);
	var literalCounts = _v0.a;
	var distanceCounts = _v0.b;
	var emptyDistanceCount = _v0.c;
	return {
		literal: A2($folkertdev$elm_flate$Huffman$fromFrequencies, literalCounts, 15),
		distance: emptyDistanceCount ? A2(
			$folkertdev$elm_flate$Huffman$fromFrequencies,
			A3($elm$core$Array$set, 0, 1, distanceCounts),
			15) : A2($folkertdev$elm_flate$Huffman$fromFrequencies, distanceCounts, 15)
	};
};
var $folkertdev$elm_flate$Huffman$lookup = F2(
	function (symbol, _v0) {
		var array = _v0.a;
		return A2($elm$core$Array$get, symbol, array);
	});
var $folkertdev$elm_flate$Huffman$getWidth = function (_v0) {
	var width = _v0.a.width;
	return width;
};
var $folkertdev$elm_flate$Deflate$Symbol$positionLoop = F3(
	function (predicate, i, elements) {
		positionLoop:
		while (true) {
			if (!elements.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = elements.a;
				var xs = elements.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(i);
				} else {
					var $temp$predicate = predicate,
						$temp$i = i + 1,
						$temp$elements = xs;
					predicate = $temp$predicate;
					i = $temp$i;
					elements = $temp$elements;
					continue positionLoop;
				}
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$position = F2(
	function (predicate, elements) {
		return A3($folkertdev$elm_flate$Deflate$Symbol$positionLoop, predicate, 0, elements);
	});
var $folkertdev$elm_flate$Huffman$positionFromTheEnd = F2(
	function (predicated, array) {
		var finalIndex = $elm$core$Array$length(array) - 1;
		var folder = F2(
			function (element, _v1) {
				var index = _v1.a;
				var accum = _v1.b;
				if (accum.$ === 'Just') {
					return _Utils_Tuple2(index, accum);
				} else {
					return predicated(element) ? _Utils_Tuple2(
						index,
						$elm$core$Maybe$Just(index)) : _Utils_Tuple2(index - 1, $elm$core$Maybe$Nothing);
				}
			});
		return A2(
			$elm$core$Maybe$map,
			function (v) {
				return finalIndex - v;
			},
			A3(
				$elm$core$Array$foldr,
				folder,
				_Utils_Tuple2(finalIndex, $elm$core$Maybe$Nothing),
				array).b);
	});
var $folkertdev$elm_flate$Huffman$usedMaxSymbol = function (_v0) {
	var array = _v0.a;
	return A2(
		$elm$core$Maybe$map,
		function (trailingZeros) {
			return ($elm$core$Array$length(array) - 1) - trailingZeros;
		},
		A2(
			$folkertdev$elm_flate$Huffman$positionFromTheEnd,
			function (_v1) {
				var value = _v1.a;
				return value.width > 0;
			},
			array));
};
var $folkertdev$elm_flate$Deflate$Symbol$calculateCodes = function (runLengths) {
	var loop2 = F3(
		function (r, c, codes) {
			loop2:
			while (true) {
				if (c >= 3) {
					var n = A2($elm$core$Basics$min, 6, c);
					var $temp$r = r,
						$temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(16, 2, n - 3),
						codes);
					r = $temp$r;
					c = $temp$c;
					codes = $temp$codes;
					continue loop2;
				} else {
					return A2(
						$elm$core$Array$append,
						codes,
						A2(
							$elm$core$Array$repeat,
							c,
							_Utils_Tuple3(r.value, 0, 0)));
				}
			}
		});
	var loop1 = F2(
		function (c, codes) {
			loop1:
			while (true) {
				if (c >= 11) {
					var n = A2($elm$core$Basics$min, 138, c);
					var $temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(18, 7, n - 11),
						codes);
					c = $temp$c;
					codes = $temp$codes;
					continue loop1;
				} else {
					if (c >= 3) {
						return A2(
							$elm$core$Array$push,
							_Utils_Tuple3(17, 3, c - 3),
							codes);
					} else {
						return A2(
							$elm$core$Array$append,
							codes,
							A2(
								$elm$core$Array$repeat,
								c,
								_Utils_Tuple3(0, 0, 0)));
					}
				}
			}
		});
	var folder = F2(
		function (r, codes) {
			return (!r.value) ? A2(loop1, r.count, codes) : A3(
				loop2,
				r,
				r.count - 1,
				A2(
					$elm$core$Array$push,
					_Utils_Tuple3(r.value, 0, 0),
					codes));
		});
	return A3($elm$core$Array$foldl, folder, $elm$core$Array$empty, runLengths);
};
var $folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths = F2(
	function (lengths, accum) {
		calculateRunLengths:
		while (true) {
			if (!lengths.b) {
				return A3($elm$core$List$foldr, $elm$core$Array$push, $elm$core$Array$empty, accum);
			} else {
				var _v1 = lengths.a;
				var e = _v1.a;
				var size = _v1.b;
				var rest = lengths.b;
				var folder = F2(
					function (_v3, runLengths) {
						var i = _v3.a;
						var c = _v3.b;
						if (!runLengths.b) {
							return A2(
								$elm$core$List$cons,
								{count: 1, value: c},
								runLengths);
						} else {
							var last = runLengths.a;
							var remaining = runLengths.b;
							return _Utils_eq(last.value, c) ? A2(
								$elm$core$List$cons,
								{count: last.count + 1, value: last.value},
								remaining) : A2(
								$elm$core$List$cons,
								{count: 1, value: c},
								runLengths);
						}
					});
				var list = A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					A2(
						$elm$core$List$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$folkertdev$elm_flate$Huffman$getWidth,
									A2($folkertdev$elm_flate$Huffman$lookup, x, e)));
						},
						A2($elm$core$List$range, 0, size - 1)));
				var $temp$lengths = rest,
					$temp$accum = A3($elm$core$List$foldl, folder, accum, list);
				lengths = $temp$lengths;
				accum = $temp$accum;
				continue calculateRunLengths;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes = F3(
	function (literalCodeCount, distanceCodeCount, trees) {
		var runLengths = A2(
			$folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths,
			_List_fromArray(
				[
					_Utils_Tuple2(trees.literal, literalCodeCount),
					_Utils_Tuple2(trees.distance, distanceCodeCount)
				]),
			_List_Nil);
		return $folkertdev$elm_flate$Deflate$Symbol$calculateCodes(runLengths);
	});
var $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order = _List_fromArray(
	[16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var $folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec = F2(
	function (trees, bitWriter) {
		var distance_code_count = A2(
			$elm$core$Basics$max,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.distance)) + 1);
		var literal_code_count = A2(
			$elm$core$Basics$max,
			257,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.literal)) + 1);
		var codes = A3(
			$folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes,
			literal_code_count,
			distance_code_count,
			{literal: trees.literal, distance: trees.distance});
		var codeCounts = A3(
			$elm$core$Array$foldl,
			function (_v2) {
				var i = _v2.a;
				return A2(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					i,
					function (v) {
						return v + 1;
					});
			},
			A2($elm$core$Array$repeat, 19, 0),
			codes);
		var bitWidthEncoder = A2($folkertdev$elm_flate$Huffman$fromFrequencies, codeCounts, 7);
		var bitwidthCodeCount = A2(
			$elm$core$Basics$max,
			4,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function (trailingZeros) {
						return 19 - trailingZeros;
					},
					A2(
						$folkertdev$elm_flate$Deflate$Symbol$position,
						function (i) {
							var _v1 = A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder);
							if (_v1.$ === 'Nothing') {
								return false;
							} else {
								var value = _v1.a;
								return $folkertdev$elm_flate$Huffman$getWidth(value) > 0;
							}
						},
						$elm$core$List$reverse($folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order)))));
		var v2 = function (writer) {
			return A3(
				$elm$core$Array$foldl,
				F2(
					function (_v0, current) {
						var code_ = _v0.a;
						var bits = _v0.b;
						var extra = _v0.c;
						return (bits > 0) ? A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							bits,
							extra,
							A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current)) : A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current);
					}),
				writer,
				codes);
		};
		var v1 = function (writer) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (i, current) {
						var width = _Utils_eq(
							A2($elm$core$Array$get, i, codeCounts),
							$elm$core$Maybe$Just(0)) ? 0 : A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								$folkertdev$elm_flate$Huffman$getWidth,
								A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder)));
						return A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 3, width, current);
					}),
				writer,
				A2($elm$core$List$take, bitwidthCodeCount, $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order));
		};
		return v2(
			v1(
				A3(
					$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
					4,
					bitwidthCodeCount - 4,
					A3(
						$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
						5,
						distance_code_count - 1,
						A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 5, literal_code_count - 257, bitWriter)))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		var huffmanTree = $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec(compressed);
		var huffmanTreeWriter = A2($folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec, huffmanTree, bitWriter);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTree, first);
				}),
			huffmanTreeWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				2,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamic = F2(
	function (windowSize, buffer) {
		var encodedChunks = A2(
			$elm$core$List$map,
			$folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock(windowSize),
			A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer));
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return chunk(first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							encodedChunks)))));
	});
var $folkertdev$elm_flate$Flate$deflateWithOptions = F2(
	function (encoding, buffer) {
		switch (encoding.$) {
			case 'Raw':
				return $folkertdev$elm_flate$Deflate$Internal$encodeRaw(buffer);
			case 'Static':
				if (encoding.a.$ === 'NoCompression') {
					var _v1 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeStatic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeStatic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
			default:
				if (encoding.a.$ === 'NoCompression') {
					var _v2 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeDynamic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeDynamic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
		}
	});
var $folkertdev$elm_flate$Flate$deflateZlibWithOptions = F2(
	function (encoding, buffer) {
		var compressionLevel = 2;
		var windowSizeHelp = function (size) {
			var kb = 1024;
			return (size <= 256) ? 0 : ((size <= 512) ? 1 : ((_Utils_cmp(size, 1 * kb) < 1) ? 2 : ((_Utils_cmp(size, 2 * kb) < 1) ? 3 : ((_Utils_cmp(size, 4 * kb) < 1) ? 4 : ((_Utils_cmp(size, 8 * kb) < 1) ? 5 : ((_Utils_cmp(size, 16 * kb) < 1) ? 6 : ((_Utils_cmp(size, 32 * kb) < 1) ? 7 : 0)))))));
		};
		var encodedTrailer = _List_fromArray(
			[
				A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				$elm$bytes$Bytes$BE,
				$folkertdev$elm_flate$Checksum$Adler32$adler32(buffer))
			]);
		var windowSize = function () {
			switch (encoding.$) {
				case 'Raw':
					return 0;
				case 'Static':
					if (encoding.a.$ === 'NoCompression') {
						var _v1 = encoding.a;
						return 0;
					} else {
						var size = encoding.a.a;
						return windowSizeHelp(size);
					}
				default:
					if (encoding.a.$ === 'NoCompression') {
						var _v2 = encoding.a;
						return 0;
					} else {
						var size = encoding.a.a;
						return windowSizeHelp(size);
					}
			}
		}();
		var mask16 = function (value) {
			return value & (A2($elm$core$Basics$pow, 2, 16) - 1);
		};
		var data = A2($folkertdev$elm_flate$Flate$deflateWithOptions, encoding, buffer);
		var cmf = (windowSize << 4) | 8;
		var check = (cmf << 8) + (compressionLevel << 6);
		var flag = (!(!A2($elm$core$Basics$modBy, 31, check))) ? ((compressionLevel << 6) + (31 - A2($elm$core$Basics$modBy, 31, check))) : (compressionLevel << 6);
		var encodedHeader = _List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(cmf),
				$elm$bytes$Bytes$Encode$unsignedInt8(flag)
			]);
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_Utils_ap(
					encodedHeader,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$bytes$Bytes$Encode$bytes(data)
							]),
						encodedTrailer))));
	});
var $folkertdev$elm_flate$Flate$deflateZlib = $folkertdev$elm_flate$Flate$deflateZlibWithOptions(
	$folkertdev$elm_flate$Flate$Dynamic(
		$folkertdev$elm_flate$Flate$WithWindowSize($folkertdev$elm_flate$LZ77$maxWindowSize)));
var $justgook$elm_image$Image$Internal$PNG$packIntoInt32 = F4(
	function (r, g, b, a) {
		return (((255 & r) << 24) | ((255 & g) << 16)) | (((255 & b) << 8) | (255 & a));
	});
var $justgook$elm_image$Image$Internal$PNG$encodePixel32 = F2(
	function (px, prev) {
		var prevR = prev >>> 24;
		var prevG = 255 & (prev >> 16);
		var prevB = 255 & (prev >> 8);
		var prevA = 255 & prev;
		var r = px >>> 24;
		var g = 255 & (px >> 16);
		var b = 255 & (px >> 8);
		var a = 255 & px;
		return A2(
			$elm$bytes$Bytes$Encode$unsignedInt32,
			$elm$bytes$Bytes$BE,
			A4($justgook$elm_image$Image$Internal$PNG$packIntoInt32, r - prevR, g - prevG, b - prevB, a - prevA));
	});
var $justgook$elm_image$Image$Internal$PNG$encodeIDAT = F2(
	function (_v0, arr) {
		var order = _v0.order;
		var scanLineFilter = $elm$bytes$Bytes$Encode$unsignedInt8(1);
		var _v1 = function () {
			switch (order.$) {
				case 'RightDown':
					return _Utils_Tuple2($elm$core$Array$foldl, $elm$core$Array$foldl);
				case 'RightUp':
					return _Utils_Tuple2($elm$core$Array$foldr, $elm$core$Array$foldl);
				case 'LeftDown':
					return _Utils_Tuple2($elm$core$Array$foldl, $elm$core$Array$foldr);
				default:
					return _Utils_Tuple2($elm$core$Array$foldr, $elm$core$Array$foldr);
			}
		}();
		var fold1 = _v1.a;
		var fold2 = _v1.b;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$List$reverse,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$concatMap($elm$core$List$reverse),
				A2(
					$elm$core$Basics$composeR,
					$elm$bytes$Bytes$Encode$sequence,
					A2(
						$elm$core$Basics$composeR,
						$elm$bytes$Bytes$Encode$encode,
						A2($elm$core$Basics$composeR, $folkertdev$elm_flate$Flate$deflateZlib, $elm$bytes$Bytes$Encode$bytes)))),
			A3(
				fold1,
				F2(
					function (sArr, acc) {
						return function (_v4) {
							var line = _v4.b;
							return A2($elm$core$List$cons, line, acc);
						}(
							A3(
								fold2,
								F2(
									function (px, _v3) {
										var prev = _v3.a;
										var acc2 = _v3.b;
										var packed = A2($justgook$elm_image$Image$Internal$PNG$encodePixel32, px, prev);
										return _Utils_Tuple2(
											px,
											A2($elm$core$List$cons, packed, acc2));
									}),
								_Utils_Tuple2(
									0,
									_List_fromArray(
										[scanLineFilter])),
								sArr));
					}),
				_List_Nil,
				arr));
	});
var $justgook$elm_image$Image$Internal$PNG$encodeIHDR = F3(
	function (width, height, _v0) {
		var format = _v0.format;
		var interlace = 0;
		var _v1 = function () {
			switch (format.$) {
				case 'RGBA':
					return _Utils_Tuple2(8, 6);
				case 'RGB':
					return _Utils_Tuple2(8, 2);
				case 'LUMINANCE_ALPHA':
					return _Utils_Tuple2(16, 0);
				default:
					return _Utils_Tuple2(8, 0);
			}
		}();
		var depth = _v1.a;
		var color = _v1.b;
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2($elm$bytes$Bytes$Encode$unsignedInt32, $elm$bytes$Bytes$BE, width),
					A2($elm$bytes$Bytes$Encode$unsignedInt32, $elm$bytes$Bytes$BE, height),
					$elm$bytes$Bytes$Encode$unsignedInt8(depth),
					$elm$bytes$Bytes$Encode$unsignedInt8(color),
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$elm$bytes$Bytes$Encode$unsignedInt8(interlace)
				]));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case = function (i) {
	switch (i) {
		case 0:
			return 0;
		case 1:
			return 498536548;
		case 2:
			return 997073096;
		case 3:
			return 651767980;
		case 4:
			return 1994146192;
		case 5:
			return 1802195444;
		case 6:
			return 1303535960;
		case 7:
			return 1342533948;
		case 8:
			return 3988292384;
		case 9:
			return 4027552580;
		case 10:
			return 3604390888;
		case 11:
			return 3412177804;
		case 12:
			return 2607071920;
		case 13:
			return 2262029012;
		case 14:
			return 2685067896;
		default:
			return 3183342108;
	}
};
var $folkertdev$elm_flate$Checksum$Crc32$step = F2(
	function (_byte, crc) {
		var a = (crc ^ _byte) >>> 0;
		var b = ((a >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(a & 15)) >>> 0;
		var c = (b >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(b & 15);
		return c;
	});
var $folkertdev$elm_flate$Checksum$Crc32$crc32Help = function (_v0) {
	var crc = _v0.crc;
	var remaining = _v0.remaining;
	return (remaining >= 8) ? A3(
		$elm$bytes$Bytes$Decode$map2,
		F2(
			function (word1, word2) {
				var byte8 = 255 & word2;
				var byte7 = 255 & (word2 >>> 8);
				var byte6 = 255 & (word2 >>> 16);
				var byte5 = 255 & (word2 >>> 24);
				var byte4 = 255 & word1;
				var byte3 = 255 & (word1 >>> 8);
				var byte2 = 255 & (word1 >>> 16);
				var byte1 = 255 & (word1 >>> 24);
				return $elm$bytes$Bytes$Decode$Loop(
					{
						crc: A2(
							$folkertdev$elm_flate$Checksum$Crc32$step,
							byte8,
							A2(
								$folkertdev$elm_flate$Checksum$Crc32$step,
								byte7,
								A2(
									$folkertdev$elm_flate$Checksum$Crc32$step,
									byte6,
									A2(
										$folkertdev$elm_flate$Checksum$Crc32$step,
										byte5,
										A2(
											$folkertdev$elm_flate$Checksum$Crc32$step,
											byte4,
											A2(
												$folkertdev$elm_flate$Checksum$Crc32$step,
												byte3,
												A2(
													$folkertdev$elm_flate$Checksum$Crc32$step,
													byte2,
													A2($folkertdev$elm_flate$Checksum$Crc32$step, byte1, crc)))))))),
						remaining: remaining - 8
					});
			}),
		$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
		$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_byte) {
			return $elm$bytes$Bytes$Decode$Loop(
				{
					crc: A2($folkertdev$elm_flate$Checksum$Crc32$step, _byte, crc),
					remaining: remaining - 1
				});
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done((crc ^ 4294967295) >>> 0)));
};
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32 = function (buffer) {
	var initialCrc = 4294967295;
	var length = $elm$bytes$Bytes$width(buffer);
	return (!length) ? 0 : A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				{crc: initialCrc, remaining: length},
				$folkertdev$elm_flate$Checksum$Crc32$crc32Help),
			buffer));
};
var $folkertdev$elm_flate$Checksum$Crc32$crc32 = $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32;
var $folkertdev$elm_flate$Flate$crc32 = $folkertdev$elm_flate$Checksum$Crc32$crc32;
var $justgook$elm_image$Image$Internal$PNG$encodeChunk = F2(
	function (kind, data) {
		var kindAndData = $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_List_fromArray(
					[
						A2($elm$bytes$Bytes$Encode$unsignedInt32, $elm$bytes$Bytes$BE, kind),
						$elm$bytes$Bytes$Encode$bytes(data)
					])));
		var length = $elm$bytes$Bytes$width(data);
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2($elm$bytes$Bytes$Encode$unsignedInt32, $elm$bytes$Bytes$BE, length),
					$elm$bytes$Bytes$Encode$bytes(kindAndData),
					A2(
					$elm$bytes$Bytes$Encode$unsignedInt32,
					$elm$bytes$Bytes$BE,
					$folkertdev$elm_flate$Flate$crc32(kindAndData))
				]));
	});
var $justgook$elm_image$Image$Internal$ImageData$RGBA = {$: 'RGBA'};
var $justgook$elm_image$Image$Internal$ImageData$RightDown = {$: 'RightDown'};
var $justgook$elm_image$Image$Internal$ImageData$defaultOptions = {order: $justgook$elm_image$Image$Internal$ImageData$RightDown, format: $justgook$elm_image$Image$Internal$ImageData$RGBA};
var $justgook$elm_image$Image$Internal$PNG$encodeSignature = $elm$bytes$Bytes$Encode$sequence(
	_List_fromArray(
		[
			$elm$bytes$Bytes$Encode$unsignedInt8(137),
			$elm$bytes$Bytes$Encode$unsignedInt8(80),
			$elm$bytes$Bytes$Encode$unsignedInt8(78),
			$elm$bytes$Bytes$Encode$unsignedInt8(71),
			$elm$bytes$Bytes$Encode$unsignedInt8(13),
			$elm$bytes$Bytes$Encode$unsignedInt8(10),
			$elm$bytes$Bytes$Encode$unsignedInt8(26),
			$elm$bytes$Bytes$Encode$unsignedInt8(10)
		]));
var $justgook$elm_image$Image$Internal$PNG$encode = function (imgData) {
	var chunkIEND = A2(
		$justgook$elm_image$Image$Internal$PNG$encodeChunk,
		1229278788,
		$elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(_List_Nil)));
	var opt = $justgook$elm_image$Image$Internal$ImageData$defaultOptions;
	var arr = $justgook$elm_image$Image$Internal$ImageData$toArray2d(imgData);
	var width = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Array$length,
			A2($elm$core$Array$get, 0, arr)));
	var height = $elm$core$Array$length(arr);
	var chunkIHDR = A2(
		$justgook$elm_image$Image$Internal$PNG$encodeChunk,
		1229472850,
		$elm$bytes$Bytes$Encode$encode(
			A3($justgook$elm_image$Image$Internal$PNG$encodeIHDR, width, height, opt)));
	var chunkIDAT = A2(
		$justgook$elm_image$Image$Internal$PNG$encodeChunk,
		1229209940,
		$elm$bytes$Bytes$Encode$encode(
			A2($justgook$elm_image$Image$Internal$PNG$encodeIDAT, opt, arr)));
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[$justgook$elm_image$Image$Internal$PNG$encodeSignature, chunkIHDR, chunkIDAT, chunkIEND])));
};
var $justgook$elm_image$Image$Internal$ImageData$ImageRaw = F2(
	function (a, b) {
		return {$: 'ImageRaw', a: a, b: b};
	});
var $justgook$elm_image$Image$Internal$ImageData$map = F2(
	function (fn, image) {
		map:
		while (true) {
			if (image.$ === 'ImageRaw') {
				var meta = image.a;
				var arr = image.b;
				return A2(
					$justgook$elm_image$Image$Internal$ImageData$ImageRaw,
					meta,
					A2(
						$elm$core$Array$map,
						$elm$core$Array$map(fn),
						arr));
			} else {
				var meta = image.a;
				var fn_ = image.b;
				var _v1 = fn_(meta);
				if (_v1.$ === 'Lazy') {
					return image;
				} else {
					var newData = _v1;
					var $temp$fn = fn,
						$temp$image = newData;
					fn = $temp$fn;
					image = $temp$image;
					continue map;
				}
			}
		}
	});
var $justgook$elm_image$Image$Internal$ImageData$getInfo = function (image) {
	if (image.$ === 'ImageRaw') {
		var meta = image.a;
		return meta;
	} else {
		var meta = image.a;
		return meta;
	}
};
var $justgook$elm_image$Image$Internal$Pixel$px8to32 = function (px) {
	return 255 + ((px + ((px + ((px + (px << 8)) << 8)) << 8)) << 8);
};
var $justgook$elm_image$Image$Internal$Pixel$px8AlphaTo32 = function (px_) {
	var px = px_ >>> 8;
	return (255 & px_) + ((px + ((px + ((px + (px << 8)) << 8)) << 8)) << 8);
};
var $justgook$elm_image$Image$Internal$Pixel$addAlphaChannel = $justgook$elm_image$Image$Internal$ImageData$map(
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Bitwise$shiftLeftBy(8),
		$elm$core$Basics$add(255)));
var $justgook$elm_image$Image$Internal$Pixel$toBit32 = function (image) {
	var _v0 = $justgook$elm_image$Image$Internal$ImageData$getInfo(image);
	switch (_v0.$) {
		case 'Png':
			var color = _v0.a.color;
			switch (color.$) {
				case 'Greyscale':
					return image;
				case 'TrueColour':
					return image;
				case 'IndexedColour':
					return image;
				case 'GreyscaleAlpha':
					return A2($justgook$elm_image$Image$Internal$ImageData$map, $justgook$elm_image$Image$Internal$Pixel$px8AlphaTo32, image);
				default:
					return image;
			}
		case 'Bmp':
			var bitsPerPixel = _v0.a.bitsPerPixel;
			switch (bitsPerPixel.$) {
				case 'BmpBitsPerPixel8':
					return A2($justgook$elm_image$Image$Internal$ImageData$map, $justgook$elm_image$Image$Internal$Pixel$px8to32, image);
				case 'BmpBitsPerPixel16':
					return image;
				case 'BmpBitsPerPixel24':
					return $justgook$elm_image$Image$Internal$Pixel$addAlphaChannel(image);
				default:
					return image;
			}
		case 'Gif':
			return image;
		default:
			var color = _v0.a.color;
			switch (color.$) {
				case 'FromDataChannel1':
					return image;
				case 'FromDataChannel2':
					return image;
				case 'FromDataChannel3':
					return image;
				default:
					return image;
			}
	}
};
var $justgook$elm_image$Image$Advanced$toPng32 = A2($elm$core$Basics$composeR, $justgook$elm_image$Image$Internal$Pixel$toBit32, $justgook$elm_image$Image$Internal$PNG$encode);
var $justgook$elm_image$Image$toPng = $justgook$elm_image$Image$Advanced$toPng32;
var $justgook$elm_image$Image$Internal$Meta$FromData = function (a) {
	return {$: 'FromData', a: a};
};
var $justgook$elm_image$Image$Internal$Array2d$fromList2D = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Array$fromList, $elm$core$Array$push),
	$elm$core$Array$empty);
var $justgook$elm_image$Image$Internal$Meta$FromDataChannel4 = function (a) {
	return {$: 'FromDataChannel4', a: a};
};
var $justgook$elm_image$Image$Internal$Meta$FromDataBitDepth8 = {$: 'FromDataBitDepth8'};
var $justgook$elm_image$Image$fromList2d = function (l) {
	return A2(
		$justgook$elm_image$Image$Internal$ImageData$ImageRaw,
		$justgook$elm_image$Image$Internal$Meta$FromData(
			{
				color: $justgook$elm_image$Image$Internal$Meta$FromDataChannel4($justgook$elm_image$Image$Internal$Meta$FromDataBitDepth8),
				width: A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$length,
						$elm$core$List$head(l))),
				height: $elm$core$List$length(l)
			}),
		$justgook$elm_image$Image$Internal$Array2d$fromList2D(l));
};
var $pablohirafuji$elm_qrcode$QRCode$Render$Raster$addQuietZone = F2(
	function (quietZoneSize, matrix) {
		if (quietZoneSize <= 0) {
			return matrix;
		} else {
			var matrixWithQZLength = $elm$core$List$length(matrix) + (2 * quietZoneSize);
			var rows = A2(
				$elm$core$List$repeat,
				quietZoneSize,
				A2($elm$core$List$repeat, matrixWithQZLength, false));
			var cols = A2($elm$core$List$repeat, quietZoneSize, false);
			return _Utils_ap(
				rows,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (row) {
							return _Utils_ap(
								cols,
								_Utils_ap(row, cols));
						},
						matrix),
					rows));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Raster$moduleToPixel = F2(
	function (options, isDark) {
		return isDark ? options.darkColor : options.lightColor;
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Raster$toImageWithOptions = F2(
	function (options, matrix) {
		var moduleSize = A2($elm$core$Basics$max, 1, options.moduleSize);
		return $justgook$elm_image$Image$fromList2d(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2(
								$elm$core$Basics$composeR,
								$pablohirafuji$elm_qrcode$QRCode$Render$Raster$moduleToPixel(options),
								$elm$core$List$repeat(moduleSize))),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$concat,
							$elm$core$List$repeat(moduleSize))),
					A2($pablohirafuji$elm_qrcode$QRCode$Render$Raster$addQuietZone, options.quietZoneSize, matrix))));
	});
var $pablohirafuji$elm_qrcode$QRCode$toImageWithOptions = F2(
	function (config, _v0) {
		var matrix = _v0.a.matrix;
		return A2($pablohirafuji$elm_qrcode$QRCode$Render$Raster$toImageWithOptions, config, matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$defaultImageOptions = {darkColor: 255, lightColor: 4294967295, moduleSize: 5, quietZoneSize: 4};
var $pablohirafuji$elm_qrcode$QRCode$toImage = $pablohirafuji$elm_qrcode$QRCode$toImageWithOptions($pablohirafuji$elm_qrcode$QRCode$defaultImageOptions);
var $pablohirafuji$elm_qrcode$QRCode$Quartile = {$: 'Quartile'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'Just')) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var isUp = placement.isUp;
	var isRight = placement.isRight;
	var col = placement.col;
	var row = placement.row;
	return isRight ? _Utils_update(
		placement,
		{col: col - 1, isRight: false}) : (isUp ? _Utils_update(
		placement,
		{col: col + 1, row: row - 1, isRight: true}) : _Utils_update(
		placement,
		{col: col + 1, row: row + 1, isRight: true}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return (1 & (_byte >> (7 - offset))) === 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var col = _v0.col;
		var row = _v0.row;
		var size = _v0.size;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var col = placement.col;
			var row = placement.row;
			var size = placement.size;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{col: col - 1, isRight: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{col: col - 2, row: 0, isUp: false, isRight: true}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{col: col - 2, row: size - 1, isUp: true, isRight: true}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset + 1,
										$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {col: size + 1, row: size + 1, isUp: true, size: size, isRight: true};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = {$: 'Pattern0'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = {$: 'Pattern1'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = {$: 'Pattern2'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = {$: 'Pattern3'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = {$: 'Pattern4'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = {$: 'Pattern5'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = {$: 'Pattern6'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = {$: 'Pattern7'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[$pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6, $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask.$) {
		case 'Pattern0':
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 'Pattern1':
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 'Pattern2':
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 'Pattern3':
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 'Pattern4':
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 'Pattern5':
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 'Pattern6':
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((maybeModule.$ === 'Just') && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		rule1Score_:
		while (true) {
			var last = _v0.a;
			var partialScore = _v0.b;
			var score = _v0.c;
			if (!simplifiedList.b) {
				return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
			} else {
				var head = simplifiedList.a;
				var tail = simplifiedList.b;
				if (_Utils_eq(last, head)) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					if (partialScore >= 5) {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					} else {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, score);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score + 3;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		rule2Score:
		while (true) {
			if (list.b && list.b.b) {
				var head1 = list.a;
				var _v1 = list.b;
				var head2 = _v1.a;
				var tail = _v1.b;
				var $temp$list = tail,
					$temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
				list = $temp$list;
				score = $temp$score;
				continue rule2Score;
			} else {
				return score;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
		var prevMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setFormatInfo_:
		while (true) {
			if (count < 15) {
				var isBlack = isBlackFn(count);
				var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
				var x2 = _v0.a;
				var y2 = _v0.b;
				var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
				var x1 = _v1.a;
				var y1 = _v1.b;
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setFormatInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask.$) {
		case 'Pattern0':
			return 0;
		case 'Pattern1':
			return 1;
		case 'Pattern2':
			return 2;
		case 'Pattern3':
			return 3;
		case 'Pattern4':
			return 4;
		case 'Pattern5':
			return 5;
		case 'Pattern6':
			return 6;
		default:
			return 7;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel.$) {
		case 'L':
			return 1;
		case 'M':
			return 0;
		case 'Q':
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var helper = function (d_) {
			helper:
			while (true) {
				if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
					var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
					d_ = $temp$d_;
					continue helper;
				} else {
					return g15Mask ^ (d_ | (formatInfoInt << 10));
				}
			}
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return A3(
			$elm$core$List$foldl,
			function (b) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
			},
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range),
			range);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setVersionInfo_:
		while (true) {
			if (count < 18) {
				var bottomLeft = _Utils_Tuple2(
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
					$elm$core$Basics$floor(count / 3));
				var topRight = _Utils_Tuple2(
					$elm$core$Basics$floor(count / 3),
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
				var isBlack = isBlackFn(count);
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setVersionInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return (1 & (bits_ >> count)) === 1;
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 'AlignmentPatternNotFound'};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var groupInfo = _v0.a.groupInfo;
	var ecLevel = _v0.a.ecLevel;
	var bytes = _v0.b;
	var version = groupInfo.version;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$QRCode = function (a) {
	return {$: 'QRCode', a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 'Utf8', a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 'InvalidUTF8Char'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $elm$core$String$fromList = _String_fromList;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 'InvalidNumericChar'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			_Utils_chr('0'),
			0),
			_Utils_Tuple2(
			_Utils_chr('1'),
			1),
			_Utils_Tuple2(
			_Utils_chr('2'),
			2),
			_Utils_Tuple2(
			_Utils_chr('3'),
			3),
			_Utils_Tuple2(
			_Utils_chr('4'),
			4),
			_Utils_Tuple2(
			_Utils_chr('5'),
			5),
			_Utils_Tuple2(
			_Utils_chr('6'),
			6),
			_Utils_Tuple2(
			_Utils_chr('7'),
			7),
			_Utils_Tuple2(
			_Utils_chr('8'),
			8),
			_Utils_Tuple2(
			_Utils_chr('9'),
			9),
			_Utils_Tuple2(
			_Utils_chr('A'),
			10),
			_Utils_Tuple2(
			_Utils_chr('B'),
			11),
			_Utils_Tuple2(
			_Utils_chr('C'),
			12),
			_Utils_Tuple2(
			_Utils_chr('D'),
			13),
			_Utils_Tuple2(
			_Utils_chr('E'),
			14),
			_Utils_Tuple2(
			_Utils_chr('F'),
			15),
			_Utils_Tuple2(
			_Utils_chr('G'),
			16),
			_Utils_Tuple2(
			_Utils_chr('H'),
			17),
			_Utils_Tuple2(
			_Utils_chr('I'),
			18),
			_Utils_Tuple2(
			_Utils_chr('J'),
			19),
			_Utils_Tuple2(
			_Utils_chr('K'),
			20),
			_Utils_Tuple2(
			_Utils_chr('L'),
			21),
			_Utils_Tuple2(
			_Utils_chr('M'),
			22),
			_Utils_Tuple2(
			_Utils_chr('N'),
			23),
			_Utils_Tuple2(
			_Utils_chr('O'),
			24),
			_Utils_Tuple2(
			_Utils_chr('P'),
			25),
			_Utils_Tuple2(
			_Utils_chr('Q'),
			26),
			_Utils_Tuple2(
			_Utils_chr('R'),
			27),
			_Utils_Tuple2(
			_Utils_chr('S'),
			28),
			_Utils_Tuple2(
			_Utils_chr('T'),
			29),
			_Utils_Tuple2(
			_Utils_chr('U'),
			30),
			_Utils_Tuple2(
			_Utils_chr('V'),
			31),
			_Utils_Tuple2(
			_Utils_chr('W'),
			32),
			_Utils_Tuple2(
			_Utils_chr('X'),
			33),
			_Utils_Tuple2(
			_Utils_chr('Y'),
			34),
			_Utils_Tuple2(
			_Utils_chr('Z'),
			35),
			_Utils_Tuple2(
			_Utils_chr(' '),
			36),
			_Utils_Tuple2(
			_Utils_chr('$'),
			37),
			_Utils_Tuple2(
			_Utils_chr('%'),
			38),
			_Utils_Tuple2(
			_Utils_chr('*'),
			39),
			_Utils_Tuple2(
			_Utils_chr('+'),
			40),
			_Utils_Tuple2(
			_Utils_chr('-'),
			41),
			_Utils_Tuple2(
			_Utils_chr('.'),
			42),
			_Utils_Tuple2(
			_Utils_chr('/'),
			43),
			_Utils_Tuple2(
			_Utils_chr(':'),
			44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 'InvalidAlphanumericChar'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode.$) {
		case 'Numeric':
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 'Alphanumeric':
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 'Byte':
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 'InputLengthOverflow'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		breakList:
		while (true) {
			var times = _v0.a;
			var itemCount = _v0.b;
			var byteList = _v1.a;
			var progress = _v1.b;
			if (times > 0) {
				var remainList = A2($elm$core$List$drop, itemCount, byteList);
				var block = A2($elm$core$List$take, itemCount, byteList);
				var $temp$checkFinish = checkFinish,
					$temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
					$temp$_v1 = _Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress));
				checkFinish = $temp$checkFinish;
				_v0 = $temp$_v0;
				_v1 = $temp$_v1;
				continue breakList;
			} else {
				if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
					return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
				} else {
					return $elm$core$Result$Ok(
						_Utils_Tuple2(byteList, progress));
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.groupInfo;
	var byteList = _v0.b;
	var _v1 = groupInfo.maybeGroup2;
	if (_v1.$ === 'Just') {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.group1,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.group1,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = {$: 'Byte'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = {$: 'UTF8'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = {$: 'Numeric'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{multiline: false, caseInsensitive: false},
	'^[\u005Cu0000-\u005Cu00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{multiline: false, caseInsensitive: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{multiline: false, caseInsensitive: false},
	'^[0-9A-Z $%*+\u005C-.\u005C/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = {$: 'Alphanumeric'};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? $pablohirafuji$elm_qrcode$QRCode$Encode$Byte : $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8));
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (maybeGroup2.$ === 'Just') {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			group1: group1,
			version: version,
			capacity: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			ecPerBlock: ecPerBlock,
			maybeGroup2: maybeGroup2
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel.$) {
		case 'L':
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 'M':
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 'Q':
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode.$) {
				case 'Numeric':
					return 10;
				case 'Alphanumeric':
					return 9;
				case 'Byte':
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode.$) {
					case 'Numeric':
						return 12;
					case 'Alphanumeric':
						return 11;
					case 'Byte':
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode.$) {
					case 'Numeric':
						return 14;
					case 'Alphanumeric':
						return 13;
					case 'Byte':
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var capacity = _v0.capacity;
		var version = _v0.version;
		return _Utils_cmp(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength,
			capacity) < 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.capacity;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			mode: mode,
			ecLevel: ecLevel,
			inputStr: inputStr,
			bitsCount: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.version),
			groupInfo: groupInfo
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 'LogTableException', a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var numArray = $elm$core$Array$fromList(num);
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 'PolynomialModException'};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1),
				rsPoly));
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 'PolynomialMultiplyException'};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = A2(
						$elm$core$Result$andThen,
						function (a) {
							return A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
								a,
								A2(
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.groupInfo.ecPerBlock, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		var ns = $elm$core$List$concat(
			A2(
				$elm$core$List$repeat,
				(fillerLength / 2) | 0,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
		return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
			bytes,
			_Utils_ap(
				ns,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		bitsToBytes1:
		while (true) {
			var _v1 = _v0.a;
			var remBits = _v1.a;
			var remLength = _v1.b;
			var bytes = _v0.b;
			if (bits.b) {
				var head = bits.a;
				var tail = bits.b;
				var $temp$bits = tail,
					$temp$_v0 = A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes));
				bits = $temp$bits;
				_v0 = $temp$_v0;
				continue bitsToBytes1;
			} else {
				return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
					A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A2($elm$core$Basics$min, 4, capacity - bitsCount))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode.$) {
		case 'Numeric':
			return 1;
		case 'Alphanumeric':
			return 2;
		case 'Byte':
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var mode = _v0.mode;
		var inputStr = _v0.inputStr;
		var groupInfo = _v0.groupInfo;
		var charCount = _Utils_eq(mode, $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.version);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.groupInfo.capacity,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.groupInfo.capacity,
					model.bitsCount,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.mode),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = {$: 'H'};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = {$: 'L'};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = {$: 'M'};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = {$: 'Q'};
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec.$) {
		case 'Low':
			return $pablohirafuji$elm_qrcode$QRCode$ECLevel$L;
		case 'Medium':
			return $pablohirafuji$elm_qrcode$QRCode$ECLevel$M;
		case 'Quartile':
			return $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$ECLevel$H;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 'InvalidUTF8Char'};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 'LogTableException', a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 'InvalidNumericChar'};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 'InputLengthOverflow'};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 'PolynomialModException'};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 'InvalidAlphanumericChar'};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 'AlignmentPatternNotFound'};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 'PolynomialMultiplyException'};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 'AlignmentPatternNotFound':
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 'InvalidNumericChar':
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 'InvalidAlphanumericChar':
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 'InvalidUTF8Char':
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 'LogTableException':
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 'PolynomialMultiplyException':
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 'PolynomialModException':
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$andThen,
				function (_v0) {
					var encodeModel = _v0.a;
					var encodedData = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (matrix) {
							return $pablohirafuji$elm_qrcode$QRCode$QRCode(
								{matrix: matrix, version: encodeModel.groupInfo.version});
						},
						$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
							_Utils_Tuple2(encodeModel, encodedData)));
				},
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
					input,
					$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromString = $pablohirafuji$elm_qrcode$QRCode$fromStringWith($pablohirafuji$elm_qrcode$QRCode$Quartile);
var $author$project$Pages$Fleet_$Boats$generateQRCodeImage = function (msg) {
	return A2(
		$elm$core$Result$mapError,
		$elm$core$Basics$always('Could not generate a QR Code'),
		A2(
			$elm$core$Result$map,
			$justgook$elm_image$Image$toPng,
			A2(
				$elm$core$Result$map,
				$pablohirafuji$elm_qrcode$QRCode$toImage,
				$pablohirafuji$elm_qrcode$QRCode$fromString(msg))));
};
var $author$project$Pages$Fleet_$Boats$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Effect$none);
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'OnFetchBoats':
				if (msg.a.$ === 'Ok') {
					var bs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								boats: A2(
									$elm$core$List$sortWith,
									$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
										function ($) {
											return $.name;
										}),
									bs)
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchArchivedBoats':
				if (msg.a.$ === 'Ok') {
					var bs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								archivedBoats: A2(
									$elm$core$List$sortWith,
									$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
										function ($) {
											return $.name;
										}),
									bs)
							}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'CopyBoatID':
				var boatId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$author$project$Ports$copyToClipboard(
							$author$project$Data$Boat$boatIdToString(boatId))));
			case 'DownloadQRCode':
				var boat = msg.a;
				var url = A2(
					$elm$core$Result$fromMaybe,
					'This fleet does not support Guest View',
					A2($author$project$Pages$Fleet_$Boats$guestViewUrl, model, boat));
				var qrCode = A2($elm$core$Result$andThen, $author$project$Pages$Fleet_$Boats$generateQRCodeImage, url);
				if (qrCode.$ === 'Ok') {
					var img = qrCode.a;
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							A3(
								$elm$file$File$Download$bytes,
								A3($elm$core$String$replace, ' ', '_', boat.name) + '_qrcode.png',
								'image/png',
								img)));
				} else {
					var e = qrCode.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: e})
							}),
						$author$project$Effect$none);
				}
			case 'UnarchiveBoat':
				var boatId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$batch(
						_List_fromArray(
							[
								A5($author$project$Api$unarchiveBoat, session.authToken, model.apiUrl, model.fleet, boatId, $author$project$Pages$Fleet_$Boats$OnUnarchiveBoat),
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0))
							])));
			case 'OnUnarchiveBoat':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$author$project$Effect$batch(
							_List_fromArray(
								[
									A4($author$project$Api$fetchBoats, session.authToken, model.apiUrl, model.fleet, $author$project$Pages$Fleet_$Boats$OnFetchBoats),
									A4($author$project$Api$fetchArchivedBoats, session.authToken, model.apiUrl, model.fleet, $author$project$Pages$Fleet_$Boats$OnFetchArchivedBoats)
								])));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'EditLADWifi':
				var boatId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							wifiEdit: $elm$core$Maybe$Just(
								{ssid: '', error: $elm$core$Maybe$Nothing, boatId: boatId, saving: false, password: ''})
						}),
					$author$project$Effect$none);
			case 'DismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{wifiEdit: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'SetSSID':
				var ssid = msg.a;
				return _Utils_Tuple2(
					function () {
						var _v2 = model.wifiEdit;
						if (_v2.$ === 'Just') {
							var edit = _v2.a;
							return _Utils_update(
								model,
								{
									wifiEdit: $elm$core$Maybe$Just(
										_Utils_update(
											edit,
											{ssid: ssid}))
								});
						} else {
							return model;
						}
					}(),
					$author$project$Effect$none);
			case 'SetPassword':
				var password = msg.a;
				return _Utils_Tuple2(
					function () {
						var _v3 = model.wifiEdit;
						if (_v3.$ === 'Just') {
							var edit = _v3.a;
							return _Utils_update(
								model,
								{
									wifiEdit: $elm$core$Maybe$Just(
										_Utils_update(
											edit,
											{password: password}))
								});
						} else {
							return model;
						}
					}(),
					$author$project$Effect$none);
			case 'SaveLADWifi':
				var _v4 = model.wifiEdit;
				if (_v4.$ === 'Just') {
					var edit = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								wifiEdit: $elm$core$Maybe$Just(
									_Utils_update(
										edit,
										{error: $elm$core$Maybe$Nothing, saving: true}))
							}),
						A7($author$project$Api$postLADWifi, session.authToken, model.apiUrl, model.fleet, edit.boatId, edit.ssid, edit.password, $author$project$Pages$Fleet_$Boats$OnSaveLADWifi));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnSaveLADWifi':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{wifiEdit: $elm$core$Maybe$Nothing}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						function () {
							var _v5 = model.wifiEdit;
							if (_v5.$ === 'Just') {
								var edit = _v5.a;
								return _Utils_update(
									model,
									{
										wifiEdit: $elm$core$Maybe$Just(
											_Utils_update(
												edit,
												{
													error: $elm$core$Maybe$Just(
														$author$project$Api$errorString(e)),
													saving: false
												}))
									});
							} else {
								return model;
							}
						}(),
						$author$project$Effect$none);
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$Boats$subscriptions = function (_v0) {
	return A2($elm$time$Time$every, 30 * 1000, $author$project$Pages$Fleet_$Boats$OnTick);
};
var $author$project$Pages$Fleet_$Boats$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A5($author$project$Pages$Fleet_$Boats$init, session, shared.apiUrl, shared.fleetUrl, shared.locale, req),
					view: A2($author$project$Pages$Fleet_$Boats$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Boats$update(session),
					subscriptions: $author$project$Pages$Fleet_$Boats$subscriptions
				};
			});
	});
var $author$project$Api$getLogins = F4(
	function (token, apiUrl, fleet, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'logins']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$User$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Users$OnFetchUsers = function (a) {
	return {$: 'OnFetchUsers', a: a};
};
var $enbala$elm_form$Form$Validate$map3 = F4(
	function (func, v1, v2, v3) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			v3,
			A3($enbala$elm_form$Form$Validate$map2, func, v1, v2));
	});
var $enbala$elm_form$Form$Validate$map4 = F5(
	function (func, v1, v2, v3, v4) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			v4,
			A4($enbala$elm_form$Form$Validate$map3, func, v1, v2, v3));
	});
var $enbala$elm_form$Form$Validate$map5 = F6(
	function (func, v1, v2, v3, v4, v5) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			v5,
			A5($enbala$elm_form$Form$Validate$map4, func, v1, v2, v3, v4));
	});
var $enbala$elm_form$Form$Validate$map6 = F7(
	function (func, v1, v2, v3, v4, v5, v6) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			v6,
			A6($enbala$elm_form$Form$Validate$map5, func, v1, v2, v3, v4, v5));
	});
var $enbala$elm_form$Form$Error$InvalidFormat = {$: 'InvalidFormat'};
var $enbala$elm_form$Form$Validate$format = F3(
	function (regex, s, validationField) {
		return A2($elm$regex$Regex$contains, regex, s) ? $elm$core$Result$Ok(s) : $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidFormat));
	});
var $enbala$elm_form$Form$Validate$mapError = F2(
	function (f, validation) {
		return function (validationField) {
			return A2(
				$elm$core$Result$mapError,
				f,
				validation(validationField));
		};
	});
var $enbala$elm_form$Form$Error$InvalidEmail = {$: 'InvalidEmail'};
var $enbala$elm_form$Form$Validate$validEmailPattern = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{multiline: false, caseInsensitive: true},
		'^[a-zA-Z0-9.!#$%&\u0027*+\u005C/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\u005C.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
var $enbala$elm_form$Form$Validate$email = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (s) {
		return A2(
			$enbala$elm_form$Form$Validate$mapError,
			function (_v0) {
				return $enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidEmail);
			},
			A2($enbala$elm_form$Form$Validate$format, $enbala$elm_form$Form$Validate$validEmailPattern, s));
	},
	$enbala$elm_form$Form$Validate$string);
var $enbala$elm_form$Form$Validate$maybe = F2(
	function (validation, validationField) {
		return $elm$core$Result$Ok(
			$elm$core$Result$toMaybe(
				validation(validationField)));
	});
var $author$project$Pages$Fleet_$Users$NewUser = F6(
	function (accountId, email, firstName, lastName, role, password) {
		return {role: role, email: email, lastName: lastName, password: password, accountId: accountId, firstName: firstName};
	});
var $author$project$Pages$Fleet_$Users$validateRole = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$User$parseRole,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Invalid role'))));
var $author$project$Pages$Fleet_$Users$validateUser = $enbala$elm_form$Form$Validate$oneOf(
	_List_fromArray(
		[
			A7(
			$enbala$elm_form$Form$Validate$map6,
			$author$project$Pages$Fleet_$Users$NewUser,
			A2(
				$enbala$elm_form$Form$Validate$map,
				$elm$core$Basics$always($elm$core$Maybe$Nothing),
				A2($enbala$elm_form$Form$Validate$field, 'accountId', $enbala$elm_form$Form$Validate$emptyString)),
			A2($enbala$elm_form$Form$Validate$field, 'email', $enbala$elm_form$Form$Validate$email),
			A2(
				$enbala$elm_form$Form$Validate$field,
				'firstName',
				A2(
					$enbala$elm_form$Form$Validate$map,
					$elm$core$Maybe$Just,
					A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string))),
			A2(
				$enbala$elm_form$Form$Validate$field,
				'lastName',
				A2(
					$enbala$elm_form$Form$Validate$map,
					$elm$core$Maybe$Just,
					A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string))),
			A2($enbala$elm_form$Form$Validate$field, 'role', $author$project$Pages$Fleet_$Users$validateRole),
			A2(
				$enbala$elm_form$Form$Validate$field,
				'password',
				A2(
					$enbala$elm_form$Form$Validate$map,
					$elm$core$Maybe$Just,
					A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)))),
			A7(
			$enbala$elm_form$Form$Validate$map6,
			$author$project$Pages$Fleet_$Users$NewUser,
			A2(
				$enbala$elm_form$Form$Validate$field,
				'accountId',
				A2(
					$enbala$elm_form$Form$Validate$map,
					A2($elm$core$Basics$composeR, $author$project$Data$User$AccountId, $elm$core$Maybe$Just),
					A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string))),
			A2($enbala$elm_form$Form$Validate$field, 'email', $enbala$elm_form$Form$Validate$email),
			A2(
				$enbala$elm_form$Form$Validate$field,
				'firstName',
				$enbala$elm_form$Form$Validate$maybe($enbala$elm_form$Form$Validate$string)),
			A2(
				$enbala$elm_form$Form$Validate$field,
				'lastName',
				$enbala$elm_form$Form$Validate$maybe($enbala$elm_form$Form$Validate$string)),
			A2($enbala$elm_form$Form$Validate$field, 'role', $author$project$Pages$Fleet_$Users$validateRole),
			A2(
				$enbala$elm_form$Form$Validate$field,
				'password',
				$enbala$elm_form$Form$Validate$maybe($enbala$elm_form$Form$Validate$string)))
		]));
var $author$project$Pages$Fleet_$Users$initialFields = _List_fromArray(
	[
		_Utils_Tuple2(
		'accountId',
		$enbala$elm_form$Form$Field$string('')),
		_Utils_Tuple2(
		'email',
		$enbala$elm_form$Form$Field$string('')),
		_Utils_Tuple2(
		'firstName',
		$enbala$elm_form$Form$Field$string('')),
		_Utils_Tuple2(
		'lastName',
		$enbala$elm_form$Form$Field$string('')),
		_Utils_Tuple2(
		'role',
		$enbala$elm_form$Form$Field$string('user')),
		_Utils_Tuple2(
		'password',
		$enbala$elm_form$Form$Field$string(''))
	]);
var $author$project$Pages$Fleet_$Users$init = F4(
	function (session, apiUrl, fleetUrl, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					users: _List_Nil,
					apiUrl: apiUrl,
					fleetUrl: fleetUrl,
					addingRole: $elm$core$Maybe$Nothing,
					newUserForm: A2($enbala$elm_form$Form$initial, $author$project$Pages$Fleet_$Users$initialFields, $author$project$Pages$Fleet_$Users$validateUser),
					removingAccountId: $elm$core$Maybe$Nothing
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$getLogins, session.authToken, apiUrl, f, $author$project$Pages$Fleet_$Users$OnFetchUsers),
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Users')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					users: _List_Nil,
					apiUrl: apiUrl,
					fleetUrl: fleetUrl,
					addingRole: $elm$core$Maybe$Nothing,
					newUserForm: A2($enbala$elm_form$Form$initial, $author$project$Pages$Fleet_$Users$initialFields, $author$project$Pages$Fleet_$Users$validateUser),
					removingAccountId: $elm$core$Maybe$Nothing
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Users$NoOp = {$: 'NoOp'};
var $author$project$Pages$Fleet_$Users$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Users$AddRole = function (a) {
	return {$: 'AddRole', a: a};
};
var $author$project$Pages$Fleet_$Users$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Users$RemoveRole = function (a) {
	return {$: 'RemoveRole', a: a};
};
var $enbala$elm_form$Form$Input$passwordInput = A3($enbala$elm_form$Form$Input$baseInput, 'password', $enbala$elm_form$Form$Field$String, $enbala$elm_form$Form$Text);
var $author$project$Pages$Fleet_$Users$NewUserFormMsg = function (a) {
	return {$: 'NewUserFormMsg', a: a};
};
var $author$project$Data$User$roleToDisplayString = function (role) {
	if (role.$ === 'Administrator') {
		return 'Administrator';
	} else {
		return 'User';
	}
};
var $author$project$Pages$Fleet_$Users$roleSelectList = A2(
	$elm$core$List$map,
	function (r) {
		return _Utils_Tuple2(
			$author$project$Data$User$roleToString(r),
			$author$project$Data$User$roleToDisplayString(r));
	},
	_List_fromArray(
		[$author$project$Data$User$Administrator, $author$project$Data$User$FleetUser]));
var $author$project$Pages$Fleet_$Users$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Users$view = F3(
	function (session, featureDropState, model) {
		var headerCell = function (field) {
			return A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(field)
					]));
		};
		var getErrorAt = function (name) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v2) {
						var n = _v2.a;
						return _Utils_eq(n, name);
					},
					$enbala$elm_form$Form$getErrors(model.newUserForm)));
		};
		var inputValidationClass = function (name) {
			return ($elm_community$maybe_extra$Maybe$Extra$isNothing(
				getErrorAt(name)) || $elm$core$Set$isEmpty(
				$enbala$elm_form$Form$getChangedFields(model.newUserForm))) ? '' : ' is-invalid';
		};
		var accountId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($enbala$elm_form$Form$getFieldAsString, 'accountId', model.newUserForm).value);
		var formRow = A2(
			$elm$html$Html$map,
			$author$project$Pages$Fleet_$Users$NewUserFormMsg,
			A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$enbala$elm_form$Form$Input$textInput,
								A2($enbala$elm_form$Form$getFieldAsString, 'email', model.newUserForm),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'form-control' + inputValidationClass('email')),
										$elm$html$Html$Attributes$placeholder('Email')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$enbala$elm_form$Form$Input$textInput,
								A2($enbala$elm_form$Form$getFieldAsString, 'firstName', model.newUserForm),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'form-control' + inputValidationClass('firstName')),
										$elm$html$Html$Attributes$placeholder('First Name'),
										$elm$html$Html$Attributes$disabled(accountId !== '')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$enbala$elm_form$Form$Input$textInput,
								A2($enbala$elm_form$Form$getFieldAsString, 'lastName', model.newUserForm),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'form-control' + inputValidationClass('lastName')),
										$elm$html$Html$Attributes$placeholder('Last Name'),
										$elm$html$Html$Attributes$disabled(accountId !== '')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$enbala$elm_form$Form$Input$selectInput,
								$author$project$Pages$Fleet_$Users$roleSelectList,
								A2($enbala$elm_form$Form$getFieldAsString, 'role', model.newUserForm),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'form-control' + inputValidationClass('role'))
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$enbala$elm_form$Form$Input$passwordInput,
								A2($enbala$elm_form$Form$getFieldAsString, 'password', model.newUserForm),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'form-control' + inputValidationClass('password')),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$disabled(accountId !== '')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'btn btn-light btn-sm' + ($elm$core$List$isEmpty(
											$enbala$elm_form$Form$getErrors(model.newUserForm)) ? '' : ' disabled')),
										$elm$html$Html$Events$onClick($enbala$elm_form$Form$Submit)
									]),
								_List_fromArray(
									[
										$enbala$elm_form$Form$isSubmitted(model.newUserForm) ? $lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : $elm$html$Html$text('Add')
									]))
							]))
					])));
		var row = function (u) {
			var isLoggedUser = _Utils_eq(u.accountId, session.user.accountId);
			var role = A2($author$project$Data$User$roleForFleet, model.fleet.slug, u);
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(u.email)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(u.firstName)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(u.lastName)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input-group input-group-sm')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-select'),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeR,
													$author$project$Data$User$parseRole,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Maybe$map(
															function (r) {
																return $author$project$Pages$Fleet_$Users$AddRole(
																	_Utils_Tuple2(u.accountId, r));
															}),
														$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Users$NoOp)))),
												$elm$html$Html$Attributes$disabled(isLoggedUser)
											]),
										A2(
											$elm$core$List$map,
											function (r) {
												return A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$value(
															$author$project$Data$User$roleToString(r)),
															$elm$html$Html$Attributes$selected(
															_Utils_eq(
																role,
																$elm$core$Maybe$Just(r)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Data$User$roleToDisplayString(r))
														]));
											},
											_List_fromArray(
												[$author$project$Data$User$FleetUser, $author$project$Data$User$Administrator]))),
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('input-group-text')
											]),
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												false,
												A2(
													$elm$core$Maybe$map,
													function (_v0) {
														var id = _v0.a;
														var r = _v0.b;
														return _Utils_eq(id, u.accountId) && (!_Utils_eq(
															$elm$core$Maybe$Just(r),
															role));
													},
													model.addingRole)) ? $lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'width', '1em')
													]),
												_List_Nil)
											]))
									]))
							])),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								if (role.$ === 'Just') {
									var r = role.a;
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-danger btn-sm text-white'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Fleet_$Users$RemoveRole(
													_Utils_Tuple2(u.accountId, r))),
												$elm$html$Html$Attributes$disabled(isLoggedUser)
											]),
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												false,
												A2(
													$elm$core$Maybe$map,
													function (a) {
														return _Utils_eq(a, u.accountId);
													},
													model.removingAccountId)) ? $lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : $lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$trash)
											]));
								} else {
									return A2($elm$html$Html$span, _List_Nil, _List_Nil);
								}
							}()
							]))
					]));
		};
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(
						$author$project$Gen$Route$Fleet___Users(
							{fleet: model.fleet.slug})),
					featureDropState,
					$author$project$Pages$Fleet_$Users$ChangelogAction,
					$author$project$Pages$Fleet_$Users$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container-fluid')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex justify-content-between py-3 px-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Users')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('table-responsive-md')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														A2(
															$elm$core$List$map,
															headerCell,
															_List_fromArray(
																['Email', 'First Name', 'Last Name', 'Role', '', ''])))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												$elm$core$List$concat(
													_List_fromArray(
														[
															A2($elm$core$List$map, row, model.users),
															_List_fromArray(
															[formRow])
														])))
											]))
									]))
							])),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Users$CloseError)
					])),
			title: 'Users'
		};
	});
var $author$project$Api$addRole = F6(
	function (token, apiUrl, fleet, accountId, role, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'logins',
								$author$project$Data$User$accountIdToString(accountId),
								$author$project$Data$User$roleToString(role)
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson($author$project$Data$User$decode),
					method: 'PUT',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Data$User$roleEncoder = function (role) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$User$roleToString(role));
};
var $author$project$Api$addLogin = F9(
	function (token, apiUrl, fleet, email, first, last, password, role, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'logins']),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email)),
									_Utils_Tuple2(
									'firstName',
									$elm$json$Json$Encode$string(first)),
									_Utils_Tuple2(
									'lastName',
									$elm$json$Json$Encode$string(last)),
									_Utils_Tuple2(
									'password',
									$elm$json$Json$Encode$string(password)),
									_Utils_Tuple2(
									'role',
									$author$project$Data$User$roleEncoder(role))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$User$decode),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Api$removeRole = F6(
	function (token, apiUrl, fleet, accountId, role, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'logins',
								$author$project$Data$User$accountIdToString(accountId),
								$author$project$Data$User$roleToString(role)
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson($author$project$Data$User$decode),
					method: 'DELETE',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Api$searchLogin = F5(
	function (token, apiUrl, fleet, email, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'logins', 'search']),
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'email', email)
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$maybe($author$project$Data$User$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Users$OnUpdateUser = function (a) {
	return {$: 'OnUpdateUser', a: a};
};
var $author$project$Pages$Fleet_$Users$OnSearchEmail = function (a) {
	return {$: 'OnSearchEmail', a: a};
};
var $author$project$Pages$Fleet_$Users$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnFetchUsers':
				if (msg.a.$ === 'Ok') {
					var us = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								users: A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.lastName;
									},
									A2(
										$elm$core$List$filter,
										function (o) {
											return $elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Data$User$roleForFleet, model.fleet.slug, o));
										},
										us))
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'NewUserFormMsg':
				var m = msg.a;
				var updatedForm = A3($enbala$elm_form$Form$update, $author$project$Pages$Fleet_$Users$validateUser, m, model.newUserForm);
				var _v1 = _Utils_Tuple2(
					m,
					$enbala$elm_form$Form$getOutput(updatedForm));
				_v1$2:
				while (true) {
					switch (_v1.a.$) {
						case 'Submit':
							if (_v1.b.$ === 'Just') {
								var _v2 = _v1.a;
								var user = _v1.b.a;
								var _v3 = user.accountId;
								if (_v3.$ === 'Just') {
									var id = _v3.a;
									return _Utils_Tuple2(
										model,
										A6($author$project$Api$addRole, session.authToken, model.apiUrl, model.fleet, id, user.role, $author$project$Pages$Fleet_$Users$OnUpdateUser));
								} else {
									var _v4 = _Utils_Tuple3(user.firstName, user.lastName, user.password);
									if (((_v4.a.$ === 'Just') && (_v4.b.$ === 'Just')) && (_v4.c.$ === 'Just')) {
										var fn = _v4.a.a;
										var ln = _v4.b.a;
										var pw = _v4.c.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{newUserForm: updatedForm}),
											A9($author$project$Api$addLogin, session.authToken, model.apiUrl, model.fleet, user.email, fn, ln, pw, user.role, $author$project$Pages$Fleet_$Users$OnUpdateUser));
									} else {
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{newUserForm: updatedForm}),
											$author$project$Effect$none);
									}
								}
							} else {
								break _v1$2;
							}
						case 'Input':
							if (((_v1.a.a === 'email') && (_v1.a.b.$ === 'Text')) && (_v1.a.c.$ === 'String')) {
								var _v5 = _v1.a;
								var _v6 = _v5.b;
								var email = _v5.c.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{newUserForm: updatedForm}),
									A5($author$project$Api$searchLogin, session.authToken, model.apiUrl, model.fleet, email, $author$project$Pages$Fleet_$Users$OnSearchEmail));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newUserForm: updatedForm}),
					$author$project$Effect$none);
			case 'SearchEmail':
				var e = msg.a;
				return _Utils_Tuple2(
					model,
					A5($author$project$Api$searchLogin, session.authToken, model.apiUrl, model.fleet, e, $author$project$Pages$Fleet_$Users$OnSearchEmail));
			case 'OnSearchEmail':
				if (msg.a.$ === 'Ok') {
					if (msg.a.a.$ === 'Just') {
						var u = msg.a.a.a;
						var updatedForm = A3(
							$enbala$elm_form$Form$update,
							$author$project$Pages$Fleet_$Users$validateUser,
							A3($enbala$elm_form$Form$Input, 'password', $enbala$elm_form$Form$Text, $enbala$elm_form$Form$Field$EmptyField),
							A3(
								$enbala$elm_form$Form$update,
								$author$project$Pages$Fleet_$Users$validateUser,
								A3(
									$enbala$elm_form$Form$Input,
									'lastName',
									$enbala$elm_form$Form$Text,
									$enbala$elm_form$Form$Field$String(u.lastName)),
								A3(
									$enbala$elm_form$Form$update,
									$author$project$Pages$Fleet_$Users$validateUser,
									A3(
										$enbala$elm_form$Form$Input,
										'firstName',
										$enbala$elm_form$Form$Text,
										$enbala$elm_form$Form$Field$String(u.firstName)),
									A3(
										$enbala$elm_form$Form$update,
										$author$project$Pages$Fleet_$Users$validateUser,
										A3(
											$enbala$elm_form$Form$Input,
											'accountId',
											$enbala$elm_form$Form$Text,
											$enbala$elm_form$Form$Field$String(
												$author$project$Data$User$accountIdToString(u.accountId))),
										model.newUserForm))));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{newUserForm: updatedForm}),
							$author$project$Effect$none);
					} else {
						var _v7 = msg.a.a;
						var updatedForm = A3(
							$enbala$elm_form$Form$update,
							$author$project$Pages$Fleet_$Users$validateUser,
							A3($enbala$elm_form$Form$Input, 'accountId', $enbala$elm_form$Form$Text, $enbala$elm_form$Form$Field$EmptyField),
							model.newUserForm);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{newUserForm: updatedForm}),
							$author$project$Effect$none);
					}
				} else {
					var e = msg.a.a;
					var updatedForm = A3(
						$enbala$elm_form$Form$update,
						$author$project$Pages$Fleet_$Users$validateUser,
						A3($enbala$elm_form$Form$Input, 'accountId', $enbala$elm_form$Form$Text, $enbala$elm_form$Form$Field$EmptyField),
						model.newUserForm);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									}),
								newUserForm: updatedForm
							}),
						$author$project$Effect$none);
				}
			case 'AddRole':
				var _v8 = msg.a;
				var id = _v8.a;
				var r = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addingRole: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, r))
						}),
					A6($author$project$Api$addRole, session.authToken, model.apiUrl, model.fleet, id, r, $author$project$Pages$Fleet_$Users$OnUpdateUser));
			case 'RemoveRole':
				var _v9 = msg.a;
				var id = _v9.a;
				var r = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							removingAccountId: $elm$core$Maybe$Just(id)
						}),
					A6($author$project$Api$removeRole, session.authToken, model.apiUrl, model.fleet, id, r, $author$project$Pages$Fleet_$Users$OnUpdateUser));
			case 'OnUpdateUser':
				if (msg.a.$ === 'Ok') {
					var u = msg.a.a;
					var newUsers = A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.lastName;
						},
						A2(
							$elm$core$List$filter,
							function (o) {
								return $elm_community$maybe_extra$Maybe$Extra$isJust(
									A2($author$project$Data$User$roleForFleet, model.fleet.slug, o));
							},
							A2(
								$elm$core$List$append,
								_List_fromArray(
									[u]),
								A2(
									$elm$core$List$filter,
									function (o) {
										return !_Utils_eq(o.accountId, u.accountId);
									},
									model.users))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								users: newUsers,
								addingRole: $elm$core$Maybe$Nothing,
								newUserForm: A2($enbala$elm_form$Form$initial, $author$project$Pages$Fleet_$Users$initialFields, $author$project$Pages$Fleet_$Users$validateUser),
								removingAccountId: $elm$core$Maybe$Nothing
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									}),
								addingRole: $elm$core$Maybe$Nothing,
								newUserForm: A2($enbala$elm_form$Form$initial, $author$project$Pages$Fleet_$Users$initialFields, $author$project$Pages$Fleet_$Users$validateUser),
								removingAccountId: $elm$core$Maybe$Nothing
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			case 'Logout':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Users$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$Users$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A4($author$project$Pages$Fleet_$Users$init, session, shared.apiUrl, shared.fleetUrl, req),
					view: A2($author$project$Pages$Fleet_$Users$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Users$update(session),
					subscriptions: $author$project$Pages$Fleet_$Users$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Video$Idle = {$: 'Idle'};
var $author$project$Views$DropZone$empty = A3($author$project$Views$DropZone$Model, false, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Pages$Fleet_$Video$Loading = {$: 'Loading'};
var $author$project$Pages$Fleet_$Video$LoadError = function (a) {
	return {$: 'LoadError', a: a};
};
var $author$project$Pages$Fleet_$Video$GotTimezone = function (a) {
	return {$: 'GotTimezone', a: a};
};
var $author$project$Pages$Fleet_$Video$GotVideoData = function (a) {
	return {$: 'GotVideoData', a: a};
};
var $author$project$Data$Boat$boatIdFromString = function (str) {
	return $author$project$Data$Boat$BoatId(str);
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{url: r.url, body: $elm$http$Http$emptyBody, expect: r.expect, method: 'GET', headers: _List_Nil, timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing});
};
var $author$project$Data$Video$Video = function (boatId) {
	return function (boatName) {
		return function (boatPhoto) {
			return function (start) {
				return function (end) {
					return function (fleetName) {
						return function (shortDistanceUnit) {
							return function (longDistanceUnit) {
								return function (speedUnit) {
									return function (watermarkImage) {
										return function (boatLocations) {
											return {end: end, start: start, boatId: boatId, boatName: boatName, boatPhoto: boatPhoto, fleetName: fleetName, speedUnit: speedUnit, boatLocations: boatLocations, watermarkImage: watermarkImage, longDistanceUnit: longDistanceUnit, shortDistanceUnit: shortDistanceUnit};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$BoatLocation$BoatLocation = F5(
	function (timestamp, latLong, accuracy, speed, heading) {
		return {speed: speed, heading: heading, latLong: latLong, accuracy: accuracy, timestamp: timestamp};
	});
var $author$project$Data$BoatLocation$decode = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$BoatLocation$BoatLocation,
	A2(
		$elm$json$Json$Decode$map,
		$jweir$elm_iso8601$ISO8601$toPosix,
		A2($elm$json$Json$Decode$field, 'timestamp', $jweir$elm_iso8601$ISO8601$decode)),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Geospatial$LatLong$LatLong,
		A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'long', $elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$field,
		'accuracy',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$field,
		'speed',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$field,
		'heading',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)));
var $author$project$Data$Video$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'boatLocations',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($author$project$Data$BoatLocation$decode)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'watermarkImage',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'speedUnit',
			$author$project$Data$SpeedUnit$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'longDistanceUnit',
				$author$project$Data$DistanceUnit$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'shortDistanceUnit',
					$author$project$Data$DistanceUnit$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'fleetName',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'end',
							A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$toPosix, $jweir$elm_iso8601$ISO8601$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'start',
								A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$toPosix, $jweir$elm_iso8601$ISO8601$decode),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'boatPhoto',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'boatName',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'boatId',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Data$Video$Video))))))))))));
var $author$project$Api$fetchVideoDataPublic = F6(
	function (apiUrl, fleet, boatId, start, end, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$get(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'public', 'video']),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'boatId',
								$author$project$Data$Boat$boatIdToString(boatId)),
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(
									$jweir$elm_iso8601$ISO8601$fromPosix(start))),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(
									$jweir$elm_iso8601$ISO8601$fromPosix(end)))
							])),
					expect: $author$project$Api$expectJson($author$project$Data$Video$decode)
				}));
	});
var $author$project$Pages$Fleet_$Video$init = F2(
	function (shared, req) {
		var maybeBoatId = A2(
			$elm$core$Maybe$map,
			$author$project$Data$Boat$boatIdFromString,
			A2($elm$core$Dict$get, 'boat', req.query));
		var maybeStart = A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeR, $jweir$elm_iso8601$ISO8601$fromString, $elm$core$Result$toMaybe),
			A2($elm$core$Dict$get, 'start', req.query));
		var maybeEnd = A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeR, $jweir$elm_iso8601$ISO8601$fromString, $elm$core$Result$toMaybe),
			A2($elm$core$Dict$get, 'end', req.query));
		var _v0 = A4(
			$elm$core$Maybe$map3,
			F3(
				function (b, s, e) {
					return _Utils_Tuple3(b, s, e);
				}),
			maybeBoatId,
			maybeStart,
			maybeEnd);
		if (_v0.$ === 'Just') {
			var _v1 = _v0.a;
			var boatId = _v1.a;
			var startIso = _v1.b;
			var endIso = _v1.c;
			var startTime = $jweir$elm_iso8601$ISO8601$toPosix(startIso);
			var endTime = $jweir$elm_iso8601$ISO8601$toPosix(endIso);
			return _Utils_Tuple2(
				{date: '', zone: $elm$time$Time$utc, error: $elm$core$Maybe$Nothing, title: '', apiUrl: shared.apiUrl, boatId: boatId, photos: _List_Nil, endTime: endTime, subtitle: '', fleetSlug: req.params.fleet, isPlaying: false, loadState: $author$project$Pages$Fleet_$Video$Loading, startTime: startTime, cameraMode: 'follow', totalFrames: 0, currentFrame: 0, exportStatus: $author$project$Pages$Fleet_$Video$Idle, dropZoneState: $author$project$Views$DropZone$empty, photoPreviews: $elm$core$Dict$empty, terrainEnabled: false, targetDurationSeconds: 30},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							A6($author$project$Api$fetchVideoDataPublic, shared.apiUrl, req.params.fleet, boatId, startTime, endTime, $author$project$Pages$Fleet_$Video$GotVideoData)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Video$GotTimezone, $elm$time$Time$here)),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, req.params.fleet + ': Replay Settings')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					date: '',
					zone: $elm$time$Time$utc,
					error: $elm$core$Maybe$Nothing,
					title: '',
					apiUrl: shared.apiUrl,
					boatId: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Data$Boat$boatIdFromString(''),
						maybeBoatId),
					photos: _List_Nil,
					endTime: $elm$time$Time$millisToPosix(0),
					subtitle: '',
					fleetSlug: req.params.fleet,
					isPlaying: false,
					loadState: $author$project$Pages$Fleet_$Video$LoadError('Missing or invalid URL parameters. Expected: ?boat=<id>&start=<ms>&end=<ms>'),
					startTime: $elm$time$Time$millisToPosix(0),
					cameraMode: 'follow',
					totalFrames: 0,
					currentFrame: 0,
					exportStatus: $author$project$Pages$Fleet_$Video$Idle,
					dropZoneState: $author$project$Views$DropZone$empty,
					photoPreviews: $elm$core$Dict$empty,
					terrainEnabled: false,
					targetDurationSeconds: 30
				},
				$author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Video$viewNav = function (model) {
	var _v0 = function () {
		var _v1 = model.loadState;
		if (_v1.$ === 'Loaded') {
			var video = _v1.a;
			return _Utils_Tuple2(video.watermarkImage, video.fleetName);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
		}
	}();
	var watermarkImage = _v0.a;
	var fleetLabel = _v0.b;
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar navbar-expand-lg navbar-dark bg-dark')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-fluid d-flex justify-content-between align-items-center')
					]),
				_List_fromArray(
					[
						function () {
						if (watermarkImage.$ === 'Just') {
							var url = watermarkImage.a;
							return A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(url),
										$elm$html$Html$Attributes$alt(fleetLabel),
										$elm$html$Html$Attributes$height(32),
										$elm$html$Html$Attributes$class('me-2')
									]),
								_List_Nil);
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-brand mb-0 text-white fw-semibold d-flex align-items-center gap-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(fleetLabel)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-text text-white-50 small d-flex align-items-center gap-2 mb-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Powered by'),
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/images/nebofleet.svg'),
										$elm$html$Html$Attributes$alt('nebo fleet'),
										$elm$html$Html$Attributes$height(16),
										A2($elm$html$Html$Attributes$style, 'opacity', '0.85')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Video$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Video$encodeConfig = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'targetDurationSeconds',
				$elm$json$Json$Encode$int(model.targetDurationSeconds)),
				_Utils_Tuple2(
				'cameraMode',
				$elm$json$Json$Encode$string(model.cameraMode)),
				_Utils_Tuple2(
				'terrainEnabled',
				$elm$json$Json$Encode$bool(model.terrainEnabled)),
				_Utils_Tuple2(
				'trimStartSeconds',
				$elm$json$Json$Encode$int(0)),
				_Utils_Tuple2(
				'trimEndSeconds',
				$elm$json$Json$Encode$int(0))
			]));
};
var $author$project$Pages$Fleet_$Video$GotVideoEvent = function (a) {
	return {$: 'GotVideoEvent', a: a};
};
var $author$project$Data$Duration$add = F2(
	function (_v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return $author$project$Data$Duration$Seconds(a + b);
	});
var $author$project$Data$Duration$zero = $author$project$Data$Duration$Seconds(0);
var $author$project$Data$Duration$toSeconds = function (_v0) {
	var seconds = _v0.a;
	return seconds;
};
var $author$project$Pages$Fleet_$Video$encodeMaybe = F2(
	function (enc, val) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, enc, val));
	});
var $author$project$Pages$Fleet_$Video$encodePoint = function (loc) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lat',
				$elm$json$Json$Encode$float(loc.latLong.lat)),
				_Utils_Tuple2(
				'lon',
				$elm$json$Json$Encode$float(loc.latLong._long)),
				_Utils_Tuple2(
				'timestamp',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(loc.timestamp))),
				_Utils_Tuple2(
				'speed',
				A2($author$project$Pages$Fleet_$Video$encodeMaybe, $elm$json$Json$Encode$float, loc.speed)),
				_Utils_Tuple2(
				'heading',
				A2($author$project$Pages$Fleet_$Video$encodeMaybe, $elm$json$Json$Encode$float, loc.heading))
			]));
};
var $elm$file$File$name = _File_name;
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var millisecond = _v0.millisecond;
		var second = _v0.second;
		var minute = _v0.minute;
		var hour = _v0.hour;
		var day = _v0.day;
		var month = _v0.month;
		var year = _v0.year;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Pages$Fleet_$Video$exifDateTimeToPosix = F2(
	function (zone, dt) {
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			{
				day: dt.day,
				hour: dt.hour,
				year: dt.year,
				month: $justinmimbs$date$Date$numberToMonth(dt.month),
				minute: dt.minute,
				second: dt.second,
				millisecond: 0
			});
	});
var $author$project$Pages$Fleet_$Video$encodePhotos = function (model) {
	return A2(
		$elm$core$List$filterMap,
		function (photo) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (dataUrl, dt) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'dataUrl',
									$elm$json$Json$Encode$string(dataUrl)),
									_Utils_Tuple2(
									'timestamp',
									$elm$json$Json$Encode$int(
										$elm$time$Time$posixToMillis(
											A2($author$project$Pages$Fleet_$Video$exifDateTimeToPosix, model.zone, dt))))
								]));
					}),
				A2(
					$elm$core$Dict$get,
					$elm$file$File$name(photo.file),
					model.photoPreviews),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.dateTimeOriginal;
					},
					photo.exif));
		},
		model.photos);
};
var $author$project$Data$BoatLocation$distance = F2(
	function (a, b) {
		return A2($author$project$Geospatial$LatLong$haversine, a.latLong, b.latLong);
	});
var $author$project$Data$BoatLocation$trackDistance = function (locations) {
	if (!locations.b) {
		return 0;
	} else {
		if (!locations.b.b) {
			return 0;
		} else {
			var fst = locations.a;
			var _v1 = locations.b;
			var snd = _v1.a;
			var locs = _v1.b;
			var distances = A3(
				$elm$core$List$map2,
				$author$project$Data$BoatLocation$distance,
				A2(
					$elm$core$List$cons,
					fst,
					A2($elm$core$List$cons, snd, locs)),
				A2($elm$core$List$cons, snd, locs));
			return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, distances);
		}
	}
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Data$Duration$fromSeconds = function (seconds) {
	return $author$project$Data$Duration$Seconds(seconds);
};
var $author$project$Data$BoatLocation$trackDuration = function (locations) {
	if ($elm$core$List$length(locations) < 3) {
		return $author$project$Data$Duration$zero;
	} else {
		var _v0 = _Utils_Tuple2(
			A2($elm_community$list_extra$List$Extra$getAt, 1, locations),
			$elm_community$list_extra$List$Extra$last(locations));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var start = _v0.a.a;
			var end = _v0.b.a;
			return $author$project$Data$Duration$fromSeconds(
				(($elm$time$Time$posixToMillis(end.timestamp) - $elm$time$Time$posixToMillis(start.timestamp)) / 1000) | 0);
		} else {
			return $author$project$Data$Duration$zero;
		}
	}
};
var $author$project$Pages$Fleet_$Video$encodeTripData = F2(
	function (video, model) {
		var underwayDurationSec = $author$project$Data$Duration$toSeconds(
			A3(
				$elm$core$List$foldl,
				$author$project$Data$Duration$add,
				$author$project$Data$Duration$zero,
				A2($elm$core$List$map, $author$project$Data$BoatLocation$trackDuration, video.boatLocations)));
		var distanceM = $elm$core$List$sum(
			A2($elm$core$List$map, $author$project$Data$BoatLocation$trackDistance, video.boatLocations));
		var avgSpeedMps = (underwayDurationSec > 0) ? (distanceM / underwayDurationSec) : 0;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(model.title)),
					_Utils_Tuple2(
					'subtitle',
					$elm$json$Json$Encode$string(model.subtitle)),
					_Utils_Tuple2(
					'dateLabel',
					$elm$json$Json$Encode$string(model.date)),
					_Utils_Tuple2(
					'boatName',
					$elm$json$Json$Encode$string(video.boatName)),
					_Utils_Tuple2(
					'boatPhoto',
					A2($author$project$Pages$Fleet_$Video$encodeMaybe, $elm$json$Json$Encode$string, video.boatPhoto)),
					_Utils_Tuple2(
					'fleetSlug',
					$elm$json$Json$Encode$string(model.fleetSlug)),
					_Utils_Tuple2(
					'watermarkImage',
					A2($author$project$Pages$Fleet_$Video$encodeMaybe, $elm$json$Json$Encode$string, video.watermarkImage)),
					_Utils_Tuple2(
					'speedUnit',
					$author$project$Data$SpeedUnit$encode(video.speedUnit)),
					_Utils_Tuple2(
					'distanceUnit',
					$author$project$Data$DistanceUnit$encode(video.longDistanceUnit)),
					_Utils_Tuple2(
					'points',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$list($author$project$Pages$Fleet_$Video$encodePoint),
						video.boatLocations)),
					_Utils_Tuple2(
					'startTime',
					$elm$json$Json$Encode$int(
						$elm$time$Time$posixToMillis(model.startTime))),
					_Utils_Tuple2(
					'endTime',
					$elm$json$Json$Encode$int(
						$elm$time$Time$posixToMillis(model.endTime))),
					_Utils_Tuple2(
					'totalDistanceM',
					$elm$json$Json$Encode$float(distanceM)),
					_Utils_Tuple2(
					'avgSpeedMps',
					$elm$json$Json$Encode$float(avgSpeedMps)),
					_Utils_Tuple2(
					'underwayDurationSeconds',
					$elm$json$Json$Encode$int(underwayDurationSec)),
					_Utils_Tuple2(
					'photos',
					A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						$author$project$Pages$Fleet_$Video$encodePhotos(model)))
				]));
	});
var $author$project$Pages$Fleet_$Video$frameEventAsValue = function (eventType) {
	return A2(
		$elm$json$Json$Decode$field,
		'detail',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (frame, total) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(eventType)),
								_Utils_Tuple2(
								'frame',
								$elm$json$Json$Encode$int(frame)),
								_Utils_Tuple2(
								'total',
								$elm$json$Json$Encode$int(total))
							]));
				}),
			A2($elm$json$Json$Decode$field, 'frame', $elm$json$Json$Decode$int),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int)))));
};
var $author$project$Pages$Fleet_$Video$exportEventAsValue = function (eventType) {
	return A2(
		$elm$json$Json$Decode$field,
		'detail',
		A6(
			$elm$json$Json$Decode$map5,
			F5(
				function (status, progress, url, err, _v0) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(eventType)),
								_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string(status)),
								_Utils_Tuple2(
								'progress',
								$elm$json$Json$Encode$float(
									A2($elm$core$Maybe$withDefault, 0, progress))),
								_Utils_Tuple2(
								'downloadUrl',
								A2($author$project$Pages$Fleet_$Video$encodeMaybe, $elm$json$Json$Encode$string, url)),
								_Utils_Tuple2(
								'errorMessage',
								A2($author$project$Pages$Fleet_$Video$encodeMaybe, $elm$json$Json$Encode$string, err))
							]));
				}),
			A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'progress', $elm$json$Json$Decode$float)),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'downloadUrl', $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed(_Utils_Tuple0)));
};
var $author$project$Pages$Fleet_$Video$viewPlayer = F2(
	function (video, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'background', '#0a1628'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '0.5rem'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'min-height', '200px'),
					A2($elm$html$Html$Attributes$style, 'aspect-ratio', '9/16')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'aspect-ratio', '9/16')
						]),
					_List_fromArray(
						[
							A3(
							$elm$html$Html$node,
							'nebo-trip-video',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$property,
									'tripData',
									A2($author$project$Pages$Fleet_$Video$encodeTripData, video, model)),
									A2(
									$elm$html$Html$Attributes$property,
									'config',
									$author$project$Pages$Fleet_$Video$encodeConfig(model)),
									A2(
									$elm$html$Html$Events$on,
									'export-status',
									A2(
										$elm$json$Json$Decode$map,
										$author$project$Pages$Fleet_$Video$GotVideoEvent,
										$author$project$Pages$Fleet_$Video$exportEventAsValue('export-status'))),
									A2(
									$elm$html$Html$Events$on,
									'frame-change',
									A2(
										$elm$json$Json$Decode$map,
										$author$project$Pages$Fleet_$Video$GotVideoEvent,
										$author$project$Pages$Fleet_$Video$frameEventAsValue('frame-change'))),
									A2($elm$html$Html$Attributes$style, 'display', 'block'),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'height', '100%')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Fleet_$Video$SetDate = function (a) {
	return {$: 'SetDate', a: a};
};
var $author$project$Pages$Fleet_$Video$SetTitle = function (a) {
	return {$: 'SetTitle', a: a};
};
var $author$project$Pages$Fleet_$Video$maxPhotos = 5;
var $author$project$Pages$Fleet_$Video$DropZoneMsg = function (a) {
	return {$: 'DropZoneMsg', a: a};
};
var $author$project$Pages$Fleet_$Video$photoMimeTypes = _List_fromArray(
	['image/png', 'image/jpeg', 'image/heic', 'image/heif']);
var $author$project$Pages$Fleet_$Video$RemovePhoto = function (a) {
	return {$: 'RemovePhoto', a: a};
};
var $author$project$Pages$Fleet_$Video$viewPhotoThumbnail = F2(
	function (previews, photo) {
		var url = A2(
			$elm$core$Maybe$withDefault,
			'/placeholder.svg',
			A2(
				$elm$core$Dict$get,
				$elm$file$File$name(photo.file),
				previews));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url),
							$elm$html$Html$Attributes$class('img-thumbnail'),
							A2($elm$html$Html$Attributes$style, 'object-fit', 'contain'),
							A2($elm$html$Html$Attributes$style, 'max-width', '100px'),
							A2($elm$html$Html$Attributes$style, 'max-height', '100px')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-sm btn-danger'),
							A2($elm$html$Html$Attributes$style, 'margin', '5px 5px 0 0'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'top', '0'),
							A2($elm$html$Html$Attributes$style, 'right', '0'),
							A2($elm$html$Html$Attributes$style, 'opacity', '0.7'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Fleet_$Video$RemovePhoto(photo.file))
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$trash)
						]))
				]));
	});
var $author$project$Pages$Fleet_$Video$viewPhotos = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-label fw-semibold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Photos (up to ' + ($elm$core$String$fromInt($author$project$Pages$Fleet_$Video$maxPhotos) + ')'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex flex-row flex-wrap gap-2')
					]),
				A2(
					$elm$core$List$append,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Fleet_$Video$viewPhotoThumbnail(model.photoPreviews),
						model.photos),
					(_Utils_cmp(
						$elm$core$List$length(model.photos),
						$author$project$Pages$Fleet_$Video$maxPhotos) < 0) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Fleet_$Video$DropZoneMsg,
							A3($author$project$Views$DropZone$view, $author$project$Pages$Fleet_$Video$photoMimeTypes, model.dropZoneState, _List_Nil))
						]) : _List_Nil))
			]));
};
var $author$project$Pages$Fleet_$Video$SetDuration = function (a) {
	return {$: 'SetDuration', a: a};
};
var $author$project$Pages$Fleet_$Video$SetSubtitle = function (a) {
	return {$: 'SetSubtitle', a: a};
};
var $author$project$Pages$Fleet_$Video$SetCameraMode = function (a) {
	return {$: 'SetCameraMode', a: a};
};
var $author$project$Pages$Fleet_$Video$cameraButton = F3(
	function (model, mode, label_) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class(
					'btn flex-fill ' + (_Utils_eq(model.cameraMode, mode) ? 'btn-primary' : 'btn-outline-primary')),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Fleet_$Video$SetCameraMode(mode))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label_)
				]));
	});
var $author$project$Pages$Fleet_$Video$SetTerrainEnabled = function (a) {
	return {$: 'SetTerrainEnabled', a: a};
};
var $author$project$Pages$Fleet_$Video$viewConfig = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('title'),
								$elm$html$Html$Attributes$class('form-label fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Video Title')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('title'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(model.title),
								$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Video$SetTitle)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('subtitle'),
								$elm$html$Html$Attributes$class('form-label fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Subtitle')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('subtitle'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(model.subtitle),
								$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Video$SetSubtitle)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('date'),
								$elm$html$Html$Attributes$class('form-label fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Date')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('date'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(model.date),
								$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Video$SetDate)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('duration-select'),
								$elm$html$Html$Attributes$class('form-label fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Video Duration')
							])),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('duration-select'),
								$elm$html$Html$Attributes$class('form-select'),
								$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Video$SetDuration),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(model.targetDurationSeconds))
							]),
						A2(
							$elm$core$List$map,
							function (s) {
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											$elm$core$String$fromInt(s)),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(s, model.targetDurationSeconds))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(s) + 's')
										]));
							},
							_List_fromArray(
								[20, 30, 45, 60])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Camera Mode')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn-group d-flex'),
								A2($elm$html$Html$Attributes$attribute, 'role', 'group')
							]),
						_List_fromArray(
							[
								A3($author$project$Pages$Fleet_$Video$cameraButton, model, 'follow', 'Follow Boat'),
								A3($author$project$Pages$Fleet_$Video$cameraButton, model, 'overview', 'Overview')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3 form-check form-switch')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('terrain-enabled'),
								$elm$html$Html$Attributes$class('form-check-input'),
								$elm$html$Html$Attributes$type_('checkbox'),
								A2($elm$html$Html$Attributes$attribute, 'role', 'switch'),
								$elm$html$Html$Attributes$checked(model.terrainEnabled),
								$elm$html$Html$Events$onCheck($author$project$Pages$Fleet_$Video$SetTerrainEnabled)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('terrain-enabled'),
								$elm$html$Html$Attributes$class('form-check-label fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('3D Terrain')
							]))
					])),
				$author$project$Pages$Fleet_$Video$viewPhotos(model)
			]));
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$Pages$Fleet_$Video$OnScrub = function (a) {
	return {$: 'OnScrub', a: a};
};
var $author$project$Pages$Fleet_$Video$ClickedPlay = {$: 'ClickedPlay'};
var $author$project$Pages$Fleet_$Video$ClickedPause = {$: 'ClickedPause'};
var $author$project$Pages$Fleet_$Video$frameToTimecode = function (frame) {
	var totalSeconds = (frame / 30) | 0;
	var seconds = A2($elm$core$Basics$modBy, 60, totalSeconds);
	var minutes = (totalSeconds / 60) | 0;
	return A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(minutes)) + (':' + A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(seconds)));
};
var $author$project$Pages$Fleet_$Video$viewScrubber = function (model) {
	var maxFrame = A2($elm$core$Basics$max, 1, model.totalFrames - 1);
	var ready = model.totalFrames > 0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex align-items-center gap-2 mb-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label fw-semibold mb-0 me-auto')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Timeline')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn btn-sm btn-outline-secondary'),
								$elm$html$Html$Attributes$disabled(!ready),
								$elm$html$Html$Events$onClick(
								model.isPlaying ? $author$project$Pages$Fleet_$Video$ClickedPause : $author$project$Pages$Fleet_$Video$ClickedPlay)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.isPlaying ? '⏸ Pause' : '▶ Play Preview')
							]))
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$class('form-range'),
						$elm$html$Html$Attributes$min('0'),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromInt(maxFrame)),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromInt(model.currentFrame)),
						$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Video$OnScrub),
						$elm$html$Html$Attributes$disabled(!ready)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex justify-content-between text-muted small mt-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Pages$Fleet_$Video$frameToTimecode(model.currentFrame))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Pages$Fleet_$Video$frameToTimecode(model.totalFrames))
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Video$viewProgress = F2(
	function (label_, progress) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex justify-content-between mb-1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label_)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($myrho$elm_round$Round$round, 0, progress * 100) + '%')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('progress')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('progress-bar progress-bar-striped progress-bar-animated'),
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									$elm$core$String$fromFloat(progress * 100) + '%'),
									A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Fleet_$Video$ClickedExport = {$: 'ClickedExport'};
var $author$project$Pages$Fleet_$Video$ClickedDownload = function (a) {
	return {$: 'ClickedDownload', a: a};
};
var $author$project$Pages$Fleet_$Video$viewExportButton = function (model) {
	var _v0 = model.exportStatus;
	switch (_v0.$) {
		case 'Idle':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('btn btn-primary w-100'),
						$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Video$ClickedExport)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Generate Video')
					]));
		case 'Recording':
			var progress = _v0.a;
			return A2($author$project$Pages$Fleet_$Video$viewProgress, 'Recording…', progress);
		case 'Encoding':
			var progress = _v0.a;
			return A2($author$project$Pages$Fleet_$Video$viewProgress, 'Encoding MP4…', progress);
		case 'ExportComplete':
			var url = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert alert-success mb-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Video ready!')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-success w-100'),
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Fleet_$Video$ClickedDownload(url))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Download MP4')
							]))
					]));
		default:
			var err = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert alert-danger mb-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(err)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-primary w-100'),
								$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Video$ClickedExport)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Try Again')
							]))
					]));
	}
};
var $author$project$Pages$Fleet_$Video$viewSidebar = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Nebo Replay'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge bg-warning text-dark ms-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Beta')
							]))
					])),
				$author$project$Pages$Fleet_$Video$viewConfig(model),
				$author$project$Pages$Fleet_$Video$viewScrubber(model),
				$author$project$Pages$Fleet_$Video$viewExportButton(model)
			]));
};
var $author$project$Pages$Fleet_$Video$viewFullPageMessage = function (content) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container-fluid')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex justify-content-center align-items-center'),
						A2($elm$html$Html$Attributes$style, 'min-height', '70vh')
					]),
				_List_fromArray(
					[content]))
			]));
};
var $author$project$Pages$Fleet_$Video$view = function (model) {
	return {
		body: _List_fromArray(
			[
				$author$project$Pages$Fleet_$Video$viewNav(model),
				function () {
				var _v0 = model.loadState;
				switch (_v0.$) {
					case 'Loading':
						return $author$project$Pages$Fleet_$Video$viewFullPageMessage(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('spinner-border text-light'),
										A2($elm$html$Html$Attributes$attribute, 'role', 'status')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('visually-hidden')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Loading…')
											]))
									])));
					case 'LoadError':
						var err = _v0.a;
						return $author$project$Pages$Fleet_$Video$viewFullPageMessage(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('alert alert-danger mb-0')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									])));
					default:
						var video = _v0.a;
						return A2(
							$elm$html$Html$main_,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container-fluid')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container py-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('row justify-content-center g-4 align-items-start')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-12 col-md-5 col-xl-4')
														]),
													_List_fromArray(
														[
															A2($author$project$Pages$Fleet_$Video$viewPlayer, video, model)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-12 col-md-5 col-xl-4')
														]),
													_List_fromArray(
														[
															$author$project$Pages$Fleet_$Video$viewSidebar(model)
														]))
												]))
										]))
								]));
				}
			}(),
				A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Video$CloseError)
			]),
		title: 'Nebo Replay'
	};
};
var $author$project$Pages$Fleet_$Video$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $elm$file$File$toBytes = _File_toBytes;
var $author$project$File$Extra$extractRange = F3(
	function (offset, length, bytes) {
		return A2(
			$elm$bytes$Bytes$Decode$decode,
			A3(
				$elm$bytes$Bytes$Decode$map2,
				F2(
					function (_v0, content) {
						return content;
					}),
				$elm$bytes$Bytes$Decode$bytes(offset),
				$elm$bytes$Bytes$Decode$bytes(length)),
			bytes);
	});
var $author$project$File$Extra$findBox = F2(
	function (targetType, boxes) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var t = _v0.a;
						return _Utils_eq(t, targetType);
					},
					boxes)));
	});
var $author$project$File$Extra$dropBytes = F2(
	function (n, bytes) {
		return A2(
			$elm$bytes$Bytes$Decode$decode,
			A3(
				$elm$bytes$Bytes$Decode$map2,
				F2(
					function (_v0, rest) {
						return rest;
					}),
				$elm$bytes$Bytes$Decode$bytes(n),
				$elm$bytes$Bytes$Decode$bytes(
					$elm$bytes$Bytes$width(bytes) - n)),
			bytes);
	});
var $elm$bytes$Bytes$Decode$string = function (n) {
	return $elm$bytes$Bytes$Decode$Decoder(
		_Bytes_read_string(n));
};
var $author$project$File$Extra$boxListStep = F2(
	function (width, _v0) {
		var consumed = _v0.a;
		var acc = _v0.b;
		return (_Utils_cmp(consumed + 8, width) > 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(
				$elm$core$List$reverse(acc))) : A2(
			$elm$bytes$Bytes$Decode$andThen,
			function (_v1) {
				var size = _v1.a;
				var boxType = _v1.b;
				if (size === 1) {
					return $elm$bytes$Bytes$Decode$succeed(
						$elm$bytes$Bytes$Decode$Done(
							$elm$core$List$reverse(acc)));
				} else {
					var contentSize = (!size) ? A2($elm$core$Basics$max, 0, (width - consumed) - 8) : A2($elm$core$Basics$max, 0, size - 8);
					return A2(
						$elm$bytes$Bytes$Decode$map,
						function (content) {
							return $elm$bytes$Bytes$Decode$Loop(
								_Utils_Tuple2(
									(consumed + 8) + contentSize,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(boxType, content),
										acc)));
						},
						$elm$bytes$Bytes$Decode$bytes(contentSize));
				}
			},
			A3(
				$elm$bytes$Bytes$Decode$map2,
				$elm$core$Tuple$pair,
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
				$elm$bytes$Bytes$Decode$string(4)));
	});
var $author$project$File$Extra$listBoxes = F2(
	function (width, bytes) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$bytes$Bytes$Decode$decode,
				A2(
					$elm$bytes$Bytes$Decode$loop,
					_Utils_Tuple2(0, _List_Nil),
					$author$project$File$Extra$boxListStep(width)),
				bytes));
	});
var $elm$bytes$Bytes$Decode$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var decodeA = _v0.a;
		var decodeB = _v1.a;
		var decodeC = _v2.a;
		return $elm$bytes$Bytes$Decode$Decoder(
			F2(
				function (bites, offset) {
					var _v3 = A2(decodeA, bites, offset);
					var aOffset = _v3.a;
					var a = _v3.b;
					var _v4 = A2(decodeB, bites, aOffset);
					var bOffset = _v4.a;
					var b = _v4.b;
					var _v5 = A2(decodeC, bites, bOffset);
					var cOffset = _v5.a;
					var c = _v5.b;
					return _Utils_Tuple2(
						cOffset,
						A3(func, a, b, c));
				}));
	});
var $author$project$File$Extra$readUIntNStep = function (_v0) {
	var remaining = _v0.a;
	var acc = _v0.b;
	return (remaining <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(acc)) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (b) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(remaining - 1, (acc * 256) + b));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$File$Extra$readUIntN = function (n) {
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(0) : A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(n, 0),
		$author$project$File$Extra$readUIntNStep);
};
var $author$project$File$Extra$ilocExtentStep = F5(
	function (version, offsetSize, lengthSize, indexSize, _v0) {
		var remaining = _v0.a;
		var firstExtent = _v0.b;
		return (remaining <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(firstExtent)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (extent) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						remaining - 1,
						function () {
							if (firstExtent.$ === 'Just') {
								return firstExtent;
							} else {
								return $elm$core$Maybe$Just(extent);
							}
						}()));
			},
			A4(
				$elm$bytes$Bytes$Decode$map3,
				F3(
					function (_v1, extentOffset, extentLength) {
						return _Utils_Tuple2(extentOffset, extentLength);
					}),
				(((version === 1) || (version === 2)) && (indexSize > 0)) ? $author$project$File$Extra$readUIntN(indexSize) : $elm$bytes$Bytes$Decode$succeed(0),
				$author$project$File$Extra$readUIntN(offsetSize),
				$author$project$File$Extra$readUIntN(lengthSize)));
	});
var $author$project$File$Extra$versionSizedInt = function (version) {
	return (version < 2) ? $elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE) : $elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE);
};
var $author$project$File$Extra$constructionMethodField = function (version) {
	return ((version === 1) || (version === 2)) ? $elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE) : $elm$bytes$Bytes$Decode$succeed(0);
};
var $author$project$File$Extra$ilocItemStep = F6(
	function (version, offsetSize, lengthSize, baseOffsetSize, indexSize, _v0) {
		var remaining = _v0.a;
		var acc = _v0.b;
		return (remaining <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(
				$elm$core$List$reverse(acc))) : A2(
			$elm$bytes$Bytes$Decode$andThen,
			function (_v3) {
				var itemId = _v3.a;
				var baseOffset = _v3.b;
				return A2(
					$elm$bytes$Bytes$Decode$andThen,
					function (extentCount) {
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (firstExtent) {
								var newAcc = function () {
									if (firstExtent.$ === 'Just') {
										var _v5 = firstExtent.a;
										var extentOffset = _v5.a;
										var extentLength = _v5.b;
										return A2(
											$elm$core$List$cons,
											{itemId: itemId, length: extentLength, offset: baseOffset + extentOffset},
											acc);
									} else {
										return acc;
									}
								}();
								return $elm$bytes$Bytes$Decode$Loop(
									_Utils_Tuple2(remaining - 1, newAcc));
							},
							A2(
								$elm$bytes$Bytes$Decode$loop,
								_Utils_Tuple2(extentCount, $elm$core$Maybe$Nothing),
								A4($author$project$File$Extra$ilocExtentStep, version, offsetSize, lengthSize, indexSize)));
					},
					$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE));
			},
			A4(
				$elm$bytes$Bytes$Decode$map3,
				F3(
					function (itemId, _v1, baseOffset) {
						return _Utils_Tuple2(itemId, baseOffset);
					}),
				$author$project$File$Extra$versionSizedInt(version),
				$author$project$File$Extra$constructionMethodField(version),
				A3(
					$elm$bytes$Bytes$Decode$map2,
					F2(
						function (_v2, base) {
							return base;
						}),
					$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE),
					$author$project$File$Extra$readUIntN(baseOffsetSize))));
	});
var $author$project$File$Extra$fullBoxVersion = A3(
	$elm$bytes$Bytes$Decode$map2,
	F2(
		function (version, _v0) {
			return version;
		}),
	$elm$bytes$Bytes$Decode$unsignedInt8,
	$elm$bytes$Bytes$Decode$bytes(3));
var $author$project$File$Extra$ilocDecoder = A2(
	$elm$bytes$Bytes$Decode$andThen,
	function (version) {
		return A2(
			$elm$bytes$Bytes$Decode$andThen,
			function (_v0) {
				var sizesByte1 = _v0.a;
				var sizesByte2 = _v0.b;
				var baseOffsetSize = (sizesByte2 / 16) | 0;
				var offsetSize = (sizesByte1 / 16) | 0;
				var lengthSize = A2($elm$core$Basics$modBy, 16, sizesByte1);
				var indexSize = A2($elm$core$Basics$modBy, 16, sizesByte2);
				return A2(
					$elm$bytes$Bytes$Decode$andThen,
					function (itemCount) {
						return A2(
							$elm$bytes$Bytes$Decode$loop,
							_Utils_Tuple2(itemCount, _List_Nil),
							A5($author$project$File$Extra$ilocItemStep, version, offsetSize, lengthSize, baseOffsetSize, indexSize));
					},
					$author$project$File$Extra$versionSizedInt(version));
			},
			A3($elm$bytes$Bytes$Decode$map2, $elm$core$Tuple$pair, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8));
	},
	$author$project$File$Extra$fullBoxVersion);
var $author$project$File$Extra$parseIloc = function (content) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$bytes$Bytes$Decode$decode, $author$project$File$Extra$ilocDecoder, content));
};
var $author$project$File$Extra$firstByte = function (bytes) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$bytes$Bytes$Decode$decode, $elm$bytes$Bytes$Decode$unsignedInt8, bytes));
};
var $elm$bytes$Bytes$Decode$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var decodeA = _v0.a;
		var decodeB = _v1.a;
		var decodeC = _v2.a;
		var decodeD = _v3.a;
		return $elm$bytes$Bytes$Decode$Decoder(
			F2(
				function (bites, offset) {
					var _v4 = A2(decodeA, bites, offset);
					var aOffset = _v4.a;
					var a = _v4.b;
					var _v5 = A2(decodeB, bites, aOffset);
					var bOffset = _v5.a;
					var b = _v5.b;
					var _v6 = A2(decodeC, bites, bOffset);
					var cOffset = _v6.a;
					var c = _v6.b;
					var _v7 = A2(decodeD, bites, cOffset);
					var dOffset = _v7.a;
					var d = _v7.b;
					return _Utils_Tuple2(
						dOffset,
						A4(func, a, b, c, d));
				}));
	});
var $author$project$File$Extra$parseInfeItem = function (content) {
	var _v0 = $author$project$File$Extra$firstByte(content);
	switch (_v0) {
		case 2:
			return A2(
				$elm$bytes$Bytes$Decode$decode,
				A5(
					$elm$bytes$Bytes$Decode$map4,
					F4(
						function (_v1, itemId, _v2, itemType) {
							return _Utils_Tuple2(itemId, itemType);
						}),
					$elm$bytes$Bytes$Decode$bytes(4),
					$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE),
					$elm$bytes$Bytes$Decode$bytes(2),
					$elm$bytes$Bytes$Decode$string(4)),
				content);
		case 3:
			return A2(
				$elm$bytes$Bytes$Decode$decode,
				A5(
					$elm$bytes$Bytes$Decode$map4,
					F4(
						function (_v3, itemId, _v4, itemType) {
							return _Utils_Tuple2(itemId, itemType);
						}),
					$elm$bytes$Bytes$Decode$bytes(4),
					$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE),
					$elm$bytes$Bytes$Decode$bytes(2),
					$elm$bytes$Bytes$Decode$string(4)),
				content);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$File$Extra$findExifItemId = function (iinfContent) {
	var entryCountWidth = (!$author$project$File$Extra$firstByte(iinfContent)) ? 2 : 4;
	var infeItems = A2(
		$elm$core$List$filterMap,
		function (_v1) {
			var t = _v1.a;
			var content = _v1.b;
			return (t === 'infe') ? $author$project$File$Extra$parseInfeItem(content) : $elm$core$Maybe$Nothing;
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (rest) {
					return A2(
						$author$project$File$Extra$listBoxes,
						$elm$bytes$Bytes$width(rest),
						rest);
				},
				A2($author$project$File$Extra$dropBytes, 4 + entryCountWidth, iinfContent))));
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var itemType = _v0.b;
					return itemType === 'Exif';
				},
				infeItems)));
};
var $author$project$File$Extra$findExifExtent = function (bytes) {
	return A2(
		$elm$core$Maybe$andThen,
		function (metaContent) {
			var metaBoxes = A2(
				$author$project$File$Extra$listBoxes,
				$elm$bytes$Bytes$width(metaContent),
				metaContent);
			var exifItemId = A2(
				$elm$core$Maybe$andThen,
				$author$project$File$Extra$findExifItemId,
				A2($author$project$File$Extra$findBox, 'iinf', metaBoxes));
			var ilocEntries = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$author$project$File$Extra$parseIloc,
					A2($author$project$File$Extra$findBox, 'iloc', metaBoxes)));
			return A2(
				$elm$core$Maybe$andThen,
				function (itemId) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (e) {
								return _Utils_eq(e.itemId, itemId);
							},
							ilocEntries));
				},
				exifItemId);
		},
		A2(
			$elm$core$Maybe$andThen,
			$author$project$File$Extra$dropBytes(4),
			A2(
				$author$project$File$Extra$findBox,
				'meta',
				A2(
					$author$project$File$Extra$listBoxes,
					$elm$bytes$Bytes$width(bytes),
					bytes))));
};
var $author$project$File$Extra$byteAt = F2(
	function (data, offset) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, offset, data));
	});
var $author$project$File$Extra$uint32 = F3(
	function (endian, data, offset) {
		var b3 = A2($author$project$File$Extra$byteAt, data, offset + 3);
		var b2 = A2($author$project$File$Extra$byteAt, data, offset + 2);
		var b1 = A2($author$project$File$Extra$byteAt, data, offset + 1);
		var b0 = A2($author$project$File$Extra$byteAt, data, offset);
		if (endian.$ === 'LE') {
			return ((b0 + (b1 * 256)) + (b2 * 65536)) + (b3 * 16777216);
		} else {
			return (((b0 * 16777216) + (b1 * 65536)) + (b2 * 256)) + b3;
		}
	});
var $author$project$File$Extra$findEntry = F2(
	function (entries, tag) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (e) {
					return _Utils_eq(e.tag, tag);
				},
				entries));
	});
var $author$project$File$Extra$longValue = F3(
	function (endian, data, entry) {
		return A3($author$project$File$Extra$uint32, endian, data, entry.valueFieldOffset);
	});
var $author$project$File$Extra$uint16 = F3(
	function (endian, data, offset) {
		var b1 = A2($author$project$File$Extra$byteAt, data, offset + 1);
		var b0 = A2($author$project$File$Extra$byteAt, data, offset);
		if (endian.$ === 'LE') {
			return b0 + (b1 * 256);
		} else {
			return (b0 * 256) + b1;
		}
	});
var $author$project$File$Extra$readIfdEntries = F3(
	function (endian, data, ifdOffset) {
		if (ifdOffset <= 0) {
			return _List_Nil;
		} else {
			var entryCount = A3($author$project$File$Extra$uint16, endian, data, ifdOffset);
			var readEntry = function (i) {
				var entryOffset = (ifdOffset + 2) + (i * 12);
				return {
					tag: A3($author$project$File$Extra$uint16, endian, data, entryOffset),
					count: A3($author$project$File$Extra$uint32, endian, data, entryOffset + 4),
					fieldType: A3($author$project$File$Extra$uint16, endian, data, entryOffset + 2),
					valueFieldOffset: entryOffset + 8
				};
			};
			return A2(
				$elm$core$List$map,
				readEntry,
				A2($elm$core$List$range, 0, entryCount - 1));
		}
	});
var $author$project$File$Extra$gpsSign = F2(
	function (ref, negativeRef) {
		return _Utils_eq(ref, negativeRef) ? (-1) : 1;
	});
var $author$project$File$Extra$rational = F3(
	function (endian, data, offset) {
		var denominator = A3($author$project$File$Extra$uint32, endian, data, offset + 4);
		var numerator = A3($author$project$File$Extra$uint32, endian, data, offset);
		return (!denominator) ? 0 : (numerator / denominator);
	});
var $author$project$File$Extra$dmsToDecimal = F3(
	function (endian, data, entry) {
		var base = A3($author$project$File$Extra$uint32, endian, data, entry.valueFieldOffset);
		return (A3($author$project$File$Extra$rational, endian, data, base) + (A3($author$project$File$Extra$rational, endian, data, base + 8) / 60)) + (A3($author$project$File$Extra$rational, endian, data, base + 16) / 3600);
	});
var $author$project$File$Extra$inlineAsciiChar = F2(
	function (data, entry) {
		return $elm$core$Char$fromCode(
			A2($author$project$File$Extra$byteAt, data, entry.valueFieldOffset));
	});
var $author$project$File$Extra$readGpsCoordinates = F3(
	function (endian, data, entries) {
		var _v0 = A2(
			$elm$core$List$map,
			$author$project$File$Extra$findEntry(entries),
			_List_fromArray(
				[2, 1, 4, 3]));
		if ((((((((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) && (_v0.b.a.$ === 'Just')) && _v0.b.b.b) && (_v0.b.b.a.$ === 'Just')) && _v0.b.b.b.b) && (_v0.b.b.b.a.$ === 'Just')) && (!_v0.b.b.b.b.b)) {
			var latEntry = _v0.a.a;
			var _v1 = _v0.b;
			var latRefEntry = _v1.a.a;
			var _v2 = _v1.b;
			var lonEntry = _v2.a.a;
			var _v3 = _v2.b;
			var lonRefEntry = _v3.a.a;
			return $elm$core$Maybe$Just(
				{
					lat: A3($author$project$File$Extra$dmsToDecimal, endian, data, latEntry) * A2(
						$author$project$File$Extra$gpsSign,
						A2($author$project$File$Extra$inlineAsciiChar, data, latRefEntry),
						_Utils_chr('S')),
					_long: A3($author$project$File$Extra$dmsToDecimal, endian, data, lonEntry) * A2(
						$author$project$File$Extra$gpsSign,
						A2($author$project$File$Extra$inlineAsciiChar, data, lonRefEntry),
						_Utils_chr('W'))
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$File$Extra$asciiString = F3(
	function (data, offset, length) {
		return $elm$core$String$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Char$fromCode,
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(0),
					A2(
						$elm$core$List$map,
						$author$project$File$Extra$byteAt(data),
						A2($elm$core$List$range, offset, (offset + length) - 1)))));
	});
var $author$project$File$Extra$ExifDateTime = F6(
	function (year, month, day, hour, minute, second) {
		return {day: day, hour: hour, year: year, month: month, minute: minute, second: second};
	});
var $author$project$File$Extra$parseExifDateTime = function (raw) {
	var _v0 = A2($elm$core$String$split, ' ', raw);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var datePart = _v0.a;
		var _v1 = _v0.b;
		var timePart = _v1.a;
		var _v2 = A2(
			$elm$core$List$map,
			$elm$core$String$toInt,
			_Utils_ap(
				A2($elm$core$String$split, ':', datePart),
				A2($elm$core$String$split, ':', timePart)));
		if ((((((((((((_v2.b && (_v2.a.$ === 'Just')) && _v2.b.b) && (_v2.b.a.$ === 'Just')) && _v2.b.b.b) && (_v2.b.b.a.$ === 'Just')) && _v2.b.b.b.b) && (_v2.b.b.b.a.$ === 'Just')) && _v2.b.b.b.b.b) && (_v2.b.b.b.b.a.$ === 'Just')) && _v2.b.b.b.b.b.b) && (_v2.b.b.b.b.b.a.$ === 'Just')) && (!_v2.b.b.b.b.b.b.b)) {
			var year = _v2.a.a;
			var _v3 = _v2.b;
			var month = _v3.a.a;
			var _v4 = _v3.b;
			var day = _v4.a.a;
			var _v5 = _v4.b;
			var hour = _v5.a.a;
			var _v6 = _v5.b;
			var minute = _v6.a.a;
			var _v7 = _v6.b;
			var second = _v7.a.a;
			return $elm$core$Maybe$Just(
				A6($author$project$File$Extra$ExifDateTime, year, month, day, hour, minute, second));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$File$Extra$findDateTimeOriginal = F3(
	function (endian, data, entries) {
		return A2(
			$elm$core$Maybe$andThen,
			function (entry) {
				var strOffset = A3($author$project$File$Extra$uint32, endian, data, entry.valueFieldOffset);
				return $author$project$File$Extra$parseExifDateTime(
					A3($author$project$File$Extra$asciiString, data, strOffset, entry.count));
			},
			A2($author$project$File$Extra$findEntry, entries, 36867));
	});
var $author$project$File$Extra$parseTiffWithEndian = F2(
	function (endian, data) {
		var ifd0Offset = A3($author$project$File$Extra$uint32, endian, data, 4);
		var ifd0Entries = A3($author$project$File$Extra$readIfdEntries, endian, data, ifd0Offset);
		var dateTimeOriginal = A2(
			$elm$core$Maybe$andThen,
			A2($author$project$File$Extra$findDateTimeOriginal, endian, data),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$File$Extra$readIfdEntries, endian, data),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$File$Extra$longValue, endian, data),
					A2($author$project$File$Extra$findEntry, ifd0Entries, 34665))));
		var gps = A2(
			$elm$core$Maybe$andThen,
			A2($author$project$File$Extra$readGpsCoordinates, endian, data),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$File$Extra$readIfdEntries, endian, data),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$File$Extra$longValue, endian, data),
					A2($author$project$File$Extra$findEntry, ifd0Entries, 34853))));
		var _v0 = _Utils_Tuple2(dateTimeOriginal, gps);
		if ((_v0.a.$ === 'Nothing') && (_v0.b.$ === 'Nothing')) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				{gps: gps, dateTimeOriginal: dateTimeOriginal});
		}
	});
var $author$project$File$Extra$parseTiff = function (data) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$Array$get, 0, data),
		A2($elm$core$Array$get, 1, data));
	_v0$2:
	while (true) {
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			switch (_v0.a.a) {
				case 73:
					if (_v0.b.a === 73) {
						return A2($author$project$File$Extra$parseTiffWithEndian, $elm$bytes$Bytes$LE, data);
					} else {
						break _v0$2;
					}
				case 77:
					if (_v0.b.a === 77) {
						return A2($author$project$File$Extra$parseTiffWithEndian, $elm$bytes$Bytes$BE, data);
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$File$Extra$arrayStep = function (_v0) {
	var remaining = _v0.a;
	var acc = _v0.b;
	return (remaining <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(acc)) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (b) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($elm$core$Array$push, b, acc)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$File$Extra$arrayDecoder = function (n) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(n, $elm$core$Array$empty),
		$author$project$File$Extra$arrayStep);
};
var $author$project$File$Extra$bytesToIntArray = function (bytes) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Array$empty,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			$author$project$File$Extra$arrayDecoder(
				$elm$bytes$Bytes$width(bytes)),
			bytes));
};
var $author$project$File$Extra$parseHeicExifItem = function (raw) {
	return A2(
		$elm$core$Maybe$andThen,
		A2($elm$core$Basics$composeR, $author$project$File$Extra$bytesToIntArray, $author$project$File$Extra$parseTiff),
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$andThen,
				function (tiffHeaderOffset) {
					return A3(
						$elm$bytes$Bytes$Decode$map2,
						F2(
							function (_v0, tiffBytes) {
								return tiffBytes;
							}),
						$elm$bytes$Bytes$Decode$bytes(tiffHeaderOffset),
						$elm$bytes$Bytes$Decode$bytes(
							($elm$bytes$Bytes$width(raw) - 4) - tiffHeaderOffset));
				},
				$elm$bytes$Bytes$Decode$unsignedInt32($elm$bytes$Bytes$BE)),
			raw));
};
var $author$project$File$Extra$decodeHeic = function (bytes) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$File$Extra$parseHeicExifItem,
		A2(
			$elm$core$Maybe$andThen,
			function (extent) {
				return A3($author$project$File$Extra$extractRange, extent.offset, extent.length, bytes);
			},
			$author$project$File$Extra$findExifExtent(bytes)));
};
var $author$project$File$Extra$exifPayload = function (payload) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Basics$identity,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$andThen,
				function (header) {
					return (header === 'Exif\u0000\u0000') ? A2(
						$elm$bytes$Bytes$Decode$map,
						$elm$core$Maybe$Just,
						$elm$bytes$Bytes$Decode$bytes(
							$elm$bytes$Bytes$width(payload) - 6)) : $elm$bytes$Bytes$Decode$succeed($elm$core$Maybe$Nothing);
				},
				$elm$bytes$Bytes$Decode$string(6)),
			payload));
};
var $author$project$File$Extra$scanSegments = function (_v0) {
	return A2(
		$elm$bytes$Bytes$Decode$andThen,
		function (marker) {
			return ((marker === 65497) || (marker === 65498)) ? $elm$bytes$Bytes$Decode$succeed(
				$elm$bytes$Bytes$Decode$Done($elm$core$Maybe$Nothing)) : (((marker === 65496) || ((marker === 65281) || ((marker >= 65488) && (marker <= 65495)))) ? $elm$bytes$Bytes$Decode$succeed(
				$elm$bytes$Bytes$Decode$Loop(_Utils_Tuple0)) : ((marker < 65280) ? $elm$bytes$Bytes$Decode$succeed(
				$elm$bytes$Bytes$Decode$Done($elm$core$Maybe$Nothing)) : A2(
				$elm$bytes$Bytes$Decode$andThen,
				function (length) {
					var payloadLength = A2($elm$core$Basics$max, 0, length - 2);
					return (marker === 65505) ? A2(
						$elm$bytes$Bytes$Decode$map,
						function (payload) {
							var _v1 = $author$project$File$Extra$exifPayload(payload);
							if (_v1.$ === 'Just') {
								var tiffBytes = _v1.a;
								return $elm$bytes$Bytes$Decode$Done(
									$elm$core$Maybe$Just(tiffBytes));
							} else {
								return $elm$bytes$Bytes$Decode$Loop(_Utils_Tuple0);
							}
						},
						$elm$bytes$Bytes$Decode$bytes(payloadLength)) : A2(
						$elm$bytes$Bytes$Decode$map,
						function (_v2) {
							return $elm$bytes$Bytes$Decode$Loop(_Utils_Tuple0);
						},
						$elm$bytes$Bytes$Decode$bytes(payloadLength));
				},
				$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE))));
		},
		$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE));
};
var $author$project$File$Extra$findExifSegment = A2(
	$elm$bytes$Bytes$Decode$andThen,
	function (soi) {
		return (soi === 65496) ? A2($elm$bytes$Bytes$Decode$loop, _Utils_Tuple0, $author$project$File$Extra$scanSegments) : $elm$bytes$Bytes$Decode$succeed($elm$core$Maybe$Nothing);
	},
	$elm$bytes$Bytes$Decode$unsignedInt16($elm$bytes$Bytes$BE));
var $author$project$File$Extra$decodeJpeg = function (bytes) {
	return A2(
		$elm$core$Maybe$andThen,
		A2($elm$core$Basics$composeR, $author$project$File$Extra$bytesToIntArray, $author$project$File$Extra$parseTiff),
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2($elm$bytes$Bytes$Decode$decode, $author$project$File$Extra$findExifSegment, bytes)));
};
var $author$project$File$Extra$decodeExif = function (bytes) {
	var _v0 = $author$project$File$Extra$decodeJpeg(bytes);
	if (_v0.$ === 'Just') {
		var exifData = _v0.a;
		return $elm$core$Maybe$Just(exifData);
	} else {
		return $author$project$File$Extra$decodeHeic(bytes);
	}
};
var $author$project$File$Extra$readExif = function (file) {
	return A2(
		$elm$core$Task$map,
		$author$project$File$Extra$decodeExif,
		$elm$file$File$toBytes(file));
};
var $author$project$Pages$Fleet_$Video$Recording = function (a) {
	return {$: 'Recording', a: a};
};
var $author$project$Pages$Fleet_$Video$isHeicMime = function (mime) {
	return (mime === 'image/heic') || (mime === 'image/heif');
};
var $author$project$Pages$Fleet_$Video$resetIfDone = function (status) {
	switch (status.$) {
		case 'ExportComplete':
			return $author$project$Pages$Fleet_$Video$Idle;
		case 'ExportError':
			return $author$project$Pages$Fleet_$Video$Idle;
		default:
			return status;
	}
};
var $author$project$Pages$Fleet_$Video$GotPhotoExif = F2(
	function (a, b) {
		return {$: 'GotPhotoExif', a: a, b: b};
	});
var $author$project$Pages$Fleet_$Video$SelectedPhoto = function (a) {
	return {$: 'SelectedPhoto', a: a};
};
var $author$project$Pages$Fleet_$Video$GotPhotoDataUrl = F2(
	function (a, b) {
		return {$: 'GotPhotoDataUrl', a: a, b: b};
	});
var $author$project$Pages$Fleet_$Video$applyVideoEvent = F2(
	function (model, event) {
		if (event.$ === 'FrameChanged') {
			var frame = event.a;
			var total = event.b;
			var playerResetToStart = (!model.isPlaying) && ((!frame) && (_Utils_cmp(model.currentFrame, total - 2) > -1));
			var reachedEnd = (total > 0) && (_Utils_cmp(frame, total - 1) > -1);
			return _Utils_update(
				model,
				{
					isPlaying: reachedEnd ? false : model.isPlaying,
					totalFrames: total,
					currentFrame: playerResetToStart ? model.currentFrame : frame
				});
		} else {
			var status = event.a;
			return _Utils_update(
				model,
				{exportStatus: status});
		}
	});
var $author$project$Pages$Fleet_$Video$monthToString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $author$project$Pages$Fleet_$Video$computeDateLabel = F3(
	function (zone, startTime, endTime) {
		var startMonth = A2($elm$time$Time$toMonth, zone, startTime);
		var startYear = A2($elm$time$Time$toYear, zone, startTime);
		var startDay = A2($elm$time$Time$toDay, zone, startTime);
		var monthStr = $author$project$Pages$Fleet_$Video$monthToString(startMonth);
		var endMonth = A2($elm$time$Time$toMonth, zone, endTime);
		var endYear = A2($elm$time$Time$toYear, zone, endTime);
		var endDay = A2($elm$time$Time$toDay, zone, endTime);
		return (_Utils_eq(startYear, endYear) && (_Utils_eq(startMonth, endMonth) && _Utils_eq(startDay, endDay))) ? ($elm$core$String$fromInt(startDay) + (' ' + (monthStr + (' ' + $elm$core$String$fromInt(startYear))))) : (monthStr + (' ' + $elm$core$String$fromInt(startYear)));
	});
var $author$project$Ports$convertHeicPhoto = _Platform_outgoingPort(
	'convertHeicPhoto',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Pages$Fleet_$Video$validatePhotoExif = F4(
	function (zone, startTime, endTime, maybeExif) {
		if (maybeExif.$ === 'Nothing') {
			return $elm$core$Result$Err('no date/time metadata could be found in this photo');
		} else {
			var exif = maybeExif.a;
			var _v1 = exif.dateTimeOriginal;
			if (_v1.$ === 'Nothing') {
				return $elm$core$Result$Err('no date/time metadata could be found in this photo');
			} else {
				var dt = _v1.a;
				var millis = $elm$time$Time$posixToMillis(
					A2($author$project$Pages$Fleet_$Video$exifDateTimeToPosix, zone, dt));
				return ((_Utils_cmp(
					millis,
					$elm$time$Time$posixToMillis(startTime)) > -1) && (_Utils_cmp(
					millis,
					$elm$time$Time$posixToMillis(endTime)) < 1)) ? $elm$core$Result$Ok(exif) : $elm$core$Result$Err('this photo\u0027s timestamp is outside the trip\u0027s time range');
			}
		}
	});
var $author$project$Pages$Fleet_$Video$FrameChanged = F2(
	function (a, b) {
		return {$: 'FrameChanged', a: a, b: b};
	});
var $author$project$Pages$Fleet_$Video$ExportStatusEvent = function (a) {
	return {$: 'ExportStatusEvent', a: a};
};
var $author$project$Pages$Fleet_$Video$Encoding = function (a) {
	return {$: 'Encoding', a: a};
};
var $author$project$Pages$Fleet_$Video$ExportError = function (a) {
	return {$: 'ExportError', a: a};
};
var $author$project$Pages$Fleet_$Video$ExportComplete = function (a) {
	return {$: 'ExportComplete', a: a};
};
var $author$project$Pages$Fleet_$Video$exportStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'recording':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$Fleet_$Video$Recording,
					A2($elm$json$Json$Decode$field, 'progress', $elm$json$Json$Decode$float));
			case 'encoding':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$Fleet_$Video$Encoding,
					A2($elm$json$Json$Decode$field, 'progress', $elm$json$Json$Decode$float));
			case 'complete':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$Fleet_$Video$ExportComplete,
					A2($elm$json$Json$Decode$field, 'downloadUrl', $elm$json$Json$Decode$string));
			case 'error':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Pages$Fleet_$Video$ExportError,
					A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$succeed($author$project$Pages$Fleet_$Video$Idle);
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $author$project$Pages$Fleet_$Video$videoEventDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (t) {
		switch (t) {
			case 'frame-change':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Pages$Fleet_$Video$FrameChanged,
					A2($elm$json$Json$Decode$field, 'frame', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
			case 'export-status':
				return A2($elm$json$Json$Decode$map, $author$project$Pages$Fleet_$Video$ExportStatusEvent, $author$project$Pages$Fleet_$Video$exportStatusDecoder);
			default:
				return $elm$json$Json$Decode$fail('Unknown event: ' + t);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Ports$videoPlayerCommand = _Platform_outgoingPort('videoPlayerCommand', $elm$core$Basics$identity);
var $author$project$Pages$Fleet_$Video$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'GotVideoData':
				if (msg.a.$ === 'Ok') {
					var video = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								title: function () {
									var _v1 = model.title;
									if (_v1 === '') {
										return video.boatName;
									} else {
										var other = _v1;
										return other;
									}
								}(),
								loadState: $author$project$Pages$Fleet_$Video$Loaded(video)
							}),
						$author$project$Effect$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loadState: $author$project$Pages$Fleet_$Video$LoadError(
									$author$project$Api$errorString(err))
							}),
						$author$project$Effect$none);
				}
			case 'GotTimezone':
				var zone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							date: A3($author$project$Pages$Fleet_$Video$computeDateLabel, zone, model.startTime, model.endTime),
							zone: zone
						}),
					$author$project$Effect$none);
			case 'SetTitle':
				var title = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							title: title,
							exportStatus: $author$project$Pages$Fleet_$Video$resetIfDone(model.exportStatus)
						}),
					$author$project$Effect$none);
			case 'SetSubtitle':
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							subtitle: s,
							exportStatus: $author$project$Pages$Fleet_$Video$resetIfDone(model.exportStatus)
						}),
					$author$project$Effect$none);
			case 'SetDate':
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							date: s,
							exportStatus: $author$project$Pages$Fleet_$Video$resetIfDone(model.exportStatus)
						}),
					$author$project$Effect$none);
			case 'SetDuration':
				var s = msg.a;
				var duration = A2(
					$elm$core$Maybe$withDefault,
					model.targetDurationSeconds,
					$elm$core$String$toInt(s));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							exportStatus: $author$project$Pages$Fleet_$Video$resetIfDone(model.exportStatus),
							targetDurationSeconds: duration
						}),
					$author$project$Effect$none);
			case 'SetCameraMode':
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cameraMode: mode,
							exportStatus: $author$project$Pages$Fleet_$Video$resetIfDone(model.exportStatus)
						}),
					$author$project$Effect$none);
			case 'SetTerrainEnabled':
				var enabled = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							exportStatus: $author$project$Pages$Fleet_$Video$resetIfDone(model.exportStatus),
							terrainEnabled: enabled
						}),
					$author$project$Effect$none);
			case 'ClickedPlay':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isPlaying: true}),
					$author$project$Effect$fromCmd(
						$author$project$Ports$videoPlayerCommand(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('play'))
									])))));
			case 'ClickedPause':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isPlaying: false}),
					$author$project$Effect$fromCmd(
						$author$project$Ports$videoPlayerCommand(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('pause'))
									])))));
			case 'ClickedExport':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							exportStatus: $author$project$Pages$Fleet_$Video$Recording(0)
						}),
					$author$project$Effect$fromCmd(
						$author$project$Ports$videoPlayerCommand(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('export'))
									])))));
			case 'ClickedDownload':
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$author$project$Ports$videoPlayerCommand(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('download')),
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string(url))
									])))));
			case 'OnScrub':
				var s = msg.a;
				var frame = A2(
					$elm$core$Maybe$withDefault,
					model.currentFrame,
					$elm$core$String$toInt(s));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isPlaying: false, currentFrame: frame}),
					$author$project$Effect$fromCmd(
						$author$project$Ports$videoPlayerCommand(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('seek')),
										_Utils_Tuple2(
										'frame',
										$elm$json$Json$Encode$int(frame))
									])))));
			case 'GotVideoEvent':
				var raw = msg.a;
				var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Pages$Fleet_$Video$videoEventDecoder, raw);
				if (_v2.$ === 'Ok') {
					var event = _v2.a;
					return _Utils_Tuple2(
						A2($author$project$Pages$Fleet_$Video$applyVideoEvent, model, event),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectedPhoto':
				var file = msg.a;
				return (_Utils_cmp(
					$elm$core$List$length(model.photos),
					$author$project$Pages$Fleet_$Video$maxPhotos) > -1) ? _Utils_Tuple2(model, $author$project$Effect$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							photos: _Utils_ap(
								model.photos,
								_List_fromArray(
									[
										{exif: $elm$core$Maybe$Nothing, file: file}
									]))
						}),
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromCmd(
								A2(
									$elm$core$Task$perform,
									$author$project$Pages$Fleet_$Video$GotPhotoDataUrl(file),
									$elm$file$File$toUrl(file))),
								$author$project$Effect$fromCmd(
								A2(
									$elm$core$Task$perform,
									$author$project$Pages$Fleet_$Video$GotPhotoExif(file),
									$author$project$File$Extra$readExif(file)))
							])));
			case 'DropZoneMsg':
				var dzmsg = msg.a;
				var _v3 = A3(
					$author$project$Views$DropZone$update,
					{droppedFile: $author$project$Pages$Fleet_$Video$SelectedPhoto, removeImage: $elm$core$Maybe$Nothing, generatePreview: false, acceptedMimeTypes: $author$project$Pages$Fleet_$Video$photoMimeTypes},
					dzmsg,
					model.dropZoneState);
				var state = _v3.a;
				var maybeMsg = _v3.b;
				var cmd = _v3.c;
				var updatedModel = _Utils_update(
					model,
					{dropZoneState: state});
				var dropZoneEffect = $author$project$Effect$fromCmd(
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Video$DropZoneMsg, cmd));
				if (maybeMsg.$ === 'Just') {
					var selectedMsg = maybeMsg.a;
					var _v5 = A2($author$project$Pages$Fleet_$Video$update, selectedMsg, updatedModel);
					var newModel = _v5.a;
					var effect = _v5.b;
					return _Utils_Tuple2(
						newModel,
						$author$project$Effect$batch(
							_List_fromArray(
								[dropZoneEffect, effect])));
				} else {
					return _Utils_Tuple2(updatedModel, dropZoneEffect);
				}
			case 'GotPhotoDataUrl':
				var file = msg.a;
				var url = msg.b;
				return $author$project$Pages$Fleet_$Video$isHeicMime(
					$elm$file$File$mime(file)) ? _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$author$project$Ports$convertHeicPhoto(
							_Utils_Tuple2(
								$elm$file$File$name(file),
								url)))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							photoPreviews: A3(
								$elm$core$Dict$insert,
								$elm$file$File$name(file),
								url,
								model.photoPreviews)
						}),
					$author$project$Effect$none);
			case 'HeicPhotoConverted':
				var _v6 = msg.a;
				var name = _v6.a;
				var url = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							photoPreviews: A3($elm$core$Dict$insert, name, url, model.photoPreviews)
						}),
					$author$project$Effect$none);
			case 'GotPhotoExif':
				var file = msg.a;
				var exif = msg.b;
				var _v7 = A4($author$project$Pages$Fleet_$Video$validatePhotoExif, model.zone, model.startTime, model.endTime, exif);
				if (_v7.$ === 'Ok') {
					var validExif = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								photos: A2(
									$elm$core$List$map,
									function (photo) {
										return _Utils_eq(photo.file, file) ? _Utils_update(
											photo,
											{
												exif: $elm$core$Maybe$Just(validExif)
											}) : photo;
									},
									model.photos)
							}),
						$author$project$Effect$none);
				} else {
					var reason = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Photo rejected',
										type_: $author$project$Views$Alert$Danger,
										message: $elm$file$File$name(file) + (': ' + reason)
									}),
								photos: A2(
									$elm$core$List$filter,
									function (photo) {
										return !_Utils_eq(photo.file, file);
									},
									model.photos),
								photoPreviews: A2(
									$elm$core$Dict$remove,
									$elm$file$File$name(file),
									model.photoPreviews)
							}),
						$author$project$Effect$none);
				}
			case 'RemovePhoto':
				var file = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							photos: A2(
								$elm$core$List$filter,
								function (photo) {
									return !_Utils_eq(photo.file, file);
								},
								model.photos),
							photoPreviews: A2(
								$elm$core$Dict$remove,
								$elm$file$File$name(file),
								model.photoPreviews)
						}),
					$author$project$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Video$HeicPhotoConverted = function (a) {
	return {$: 'HeicPhotoConverted', a: a};
};
var $author$project$Ports$heicPhotoConverted = _Platform_incomingPort(
	'heicPhotoConverted',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Pages$Fleet_$Video$subscriptions = function (_v0) {
	return $author$project$Ports$heicPhotoConverted($author$project$Pages$Fleet_$Video$HeicPhotoConverted);
};
var $author$project$Pages$Fleet_$Video$page = F2(
	function (shared, req) {
		return $author$project$Page$advanced(
			{
				init: A2($author$project$Pages$Fleet_$Video$init, shared, req),
				view: $author$project$Pages$Fleet_$Video$view,
				update: $author$project$Pages$Fleet_$Video$update,
				subscriptions: $author$project$Pages$Fleet_$Video$subscriptions
			});
	});
var $author$project$Pages$Fleet_$OnTime$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$Closed = {$: 'Closed'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker = function (a) {
	return {$: 'DatePicker', a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$InsideHierarchy = {$: 'InsideHierarchy'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$init = function (internalMsg) {
	return $mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
		{status: $mercurymedia$elm_datetime_picker$DurationDatePicker$Closed, hovered: $elm$core$Maybe$Nothing, viewOffset: 0, domLocation: $mercurymedia$elm_datetime_picker$DatePicker$Utilities$InsideHierarchy, internalMsg: internalMsg, endSelectionTuple: $elm$core$Maybe$Nothing, startSelectionTuple: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Fleet_$OnTime$UpdateDatePicker = function (a) {
	return {$: 'UpdateDatePicker', a: a};
};
var $author$project$Pages$Fleet_$OnTime$initialModel = F4(
	function (apiUrl, locale, fleet, r) {
		return {
			error: $elm$core$Maybe$Nothing,
			fleet: fleet,
			apiUrl: apiUrl,
			locale: locale,
			endDate: $elm$core$Maybe$Nothing,
			arrivals: _List_Nil,
			startDate: $elm$core$Maybe$Nothing,
			currentTime: $elm$time$Time$millisToPosix(0),
			currentZone: $elm$time$Time$utc,
			currentRoute: r,
			durationDatePicker: $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$OnTime$UpdateDatePicker)
		};
	});
var $author$project$Pages$Fleet_$OnTime$init = F4(
	function (session, apiUrl, locale, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				A4($author$project$Pages$Fleet_$OnTime$initialModel, apiUrl, locale, f, req.route),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Fleet_$OnTime$OnTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (t, z) {
											return _Utils_Tuple2(t, z);
										}),
									$elm$time$Time$now,
									$elm$time$Time$here))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': On Time Report')))
						])));
		} else {
			return _Utils_Tuple2(
				A4($author$project$Pages$Fleet_$OnTime$initialModel, apiUrl, locale, $author$project$Data$Fleet$empty, $author$project$Gen$Route$NotFound),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\u000A' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\u000A' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (accumulatedStyles.$ === 'UnscopedStyles') {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\u000A' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (maybeNonce.$ === 'Just') {
							var nonce = maybeNonce.a.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 'UnscopedStyles', a: a};
};
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return _Utils_chr('0');
			case 1:
				return _Utils_chr('1');
			case 2:
				return _Utils_chr('2');
			case 3:
				return _Utils_chr('3');
			case 4:
				return _Utils_chr('4');
			case 5:
				return _Utils_chr('5');
			case 6:
				return _Utils_chr('6');
			case 7:
				return _Utils_chr('7');
			case 8:
				return _Utils_chr('8');
			case 9:
				return _Utils_chr('9');
			case 10:
				return _Utils_chr('a');
			case 11:
				return _Utils_chr('b');
			case 12:
				return _Utils_chr('c');
			case 13:
				return _Utils_chr('d');
			case 14:
				return _Utils_chr('e');
			case 15:
				return _Utils_chr('f');
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			_Utils_chr('-'),
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {hash: hash, seed: seed, shift: shift, charsProcessed: charsProcessed};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.hash)) ? (data.seed ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.hash)))) : data.seed;
	var h0 = acc ^ data.charsProcessed;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.hash | ((255 & $elm$core$Char$toCode(c)) << data.shift);
		var _v0 = data.shift;
		if (_v0 === 24) {
			return {
				hash: 0,
				seed: A2($robinheghan$murmur3$Murmur3$mix, data.seed, res),
				shift: 0,
				charsProcessed: data.charsProcessed + 1
			};
		} else {
			return {hash: res, seed: data.seed, shift: data.shift + 8, charsProcessed: data.charsProcessed + 1};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		_Utils_chr('_'),
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (_v1.$ === 'Just') {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (_v1.$ === 'Just') {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (_v1.$ === 'Just') {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v7) {
		var nodes = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 'Unstyled':
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 'Node':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 'NodeNS':
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 'KeyedNode':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v0, _v1) {
		var key = _v0.a;
		var html = _v0.b;
		var pairs = _v1.a;
		var styles = _v1.b;
		switch (html.$) {
			case 'Unstyled':
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 'Node':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 'NodeNS':
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 'KeyedNode':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v6 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v6.a;
				var finalStyles = _v6.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 'Unstyled':
			var plainNode = vdom.a;
			return plainNode;
		case 'Node':
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 'NodeNS':
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 'KeyedNode':
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 'Unstyled', a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 'Attribute', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType.$) {
		case 'Print':
			return 'print';
		case 'Screen':
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.feature + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.value)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 'AllQuery':
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 'OnlyQuery':
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 'NotQuery':
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \u0022' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\u0022'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\u000A',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \u0022' + (str + '\u0022');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\u0022' + (str + '\u0022')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0.a;
			return prop + ';';
		},
		'',
		properties);
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0.a;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator.$) {
		case 'AdjacentSibling':
			return '+';
		case 'GeneralSibling':
			return '~';
		case 'Child':
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 'ClassSelector':
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 'IdSelector':
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 'PseudoClassSelector':
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 'TypeSelectorSequence':
			var str = simpleSelectorSequence.a.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 'UniversalSelectorSequence':
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 'StyleBlockDeclaration':
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 'MediaRule':
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\u000A', styleBlocks);
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 'SupportsRule':
			return 'TODO';
		case 'DocumentRule':
			return 'TODO';
		case 'PageRule':
			return 'TODO';
		case 'FontFace':
			return 'TODO';
		case 'Keyframes':
			var declaration = decl.a.declaration;
			var name = decl.a.name;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 'Viewport':
			return 'TODO';
		case 'CounterStyle':
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var declarations = _v0.declarations;
	var namespaces = _v0.namespaces;
	var imports = _v0.imports;
	var charset = _v0.charset;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\u000A', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\u000A', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\u000A', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 'Nothing') {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 'FontFace', a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 'PageRule', a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = function (a) {
	return {$: 'Property', a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 'Selector', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 'Viewport', a: a};
};
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 'Keyframes', a: a};
};
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 'StyleBlock', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 'MediaRule', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 'SupportsRule', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 'StyleBlockDeclaration':
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 'MediaRule':
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 'SupportsRule':
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 'DocumentRule':
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 'PageRule':
				return declaration;
			case 'FontFace':
				return declaration;
			case 'Keyframes':
				return declaration;
			case 'Viewport':
				return declaration;
			case 'CounterStyle':
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 'CounterStyle', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0.a;
	return declarations;
};
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 'StyleBlockDeclaration', a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 'StyleBlockDeclaration':
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 'MediaRule':
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (declaration.$ === 'StyleBlockDeclaration') {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (declarations.a.$ === 'StyleBlockDeclaration') {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (declaration.$ === 'StyleBlockDeclaration') {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 'MediaRule':
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 'MediaRule')) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 'SupportsRule':
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 'DocumentRule':
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 'PageRule':
							return declarations;
						case 'FontFace':
							return declarations;
						case 'Keyframes':
							return declarations;
						case 'Viewport':
							return declarations;
						case 'CounterStyle':
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 'FontFeatureValues', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newFirst = f(first);
			var newRest = A2($elm$core$List$map, f, rest);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 'CustomSelector', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 'TypeSelectorSequence', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 'UniversalSelectorSequence', a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 'TypeSelectorSequence':
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 'UniversalSelectorSequence':
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 'AppendProperty':
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 'ExtendSelector':
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 'NestSnippet':
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 'StyleBlockDeclaration':
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 'MediaRule':
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 'SupportsRule':
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 'DocumentRule':
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 'PageRule':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 'FontFace':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 'Viewport':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 'CounterStyle':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 'WithPseudoElement':
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 'WithKeyframes':
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = $rtfeldman$elm_css$Css$Structure$Property('animation-name:' + name);
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{name: name, declaration: str})
							]));
				case 'WithMedia':
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 'StyleBlockDeclaration':
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 'MediaRule':
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 'SupportsRule':
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 'DocumentRule':
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 'PageRule':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 'FontFace':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 'Viewport':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 'CounterStyle':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v1) {
	var firstSelector = _v1.a;
	var otherSelectors = _v1.b;
	var styles = _v1.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v0 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
				var nextResultParent = _v0.a.a;
				var originalParent = _v0.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var snippets = _v0.snippets;
	var namespaces = _v0.namespaces;
	var imports = _v0.imports;
	var charset = _v0.charset;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {charset: charset, imports: imports, namespaces: namespaces, declarations: declarations};
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 'StyleBlockDeclaration':
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'MediaRule':
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'SupportsRule':
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'DocumentRule':
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'PageRule':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'FontFace':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'Keyframes':
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
					declarations);
			case 'Viewport':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'CounterStyle':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{name: name, declaration: decl});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var declarations = _v0.declarations;
	var namespaces = _v0.namespaces;
	var imports = _v0.imports;
	var charset = _v0.charset;
	return {
		charset: charset,
		imports: imports,
		namespaces: namespaces,
		declarations: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations)
	};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {charset: $elm$core$Maybe$Nothing, imports: _List_Nil, snippets: snippets, namespaces: _List_Nil};
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
	return {$: 'Snippet', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 'StyleBlock', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 'StyleBlockDeclaration', a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return $rtfeldman$elm_css$Css$Preprocess$Snippet(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
					A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
				]));
	});
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 'ClassSelector', a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 'Node', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $mercurymedia$elm_datetime_picker$DurationDatePicker$Left = {$: 'Left'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$Right = {$: 'Right'};
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $mercurymedia$elm_datetime_picker$DurationDatePicker$End = {$: 'End'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$Start = {$: 'Start'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$SetHour = F2(
	function (a, b) {
		return {$: 'SetHour', a: a, b: b};
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$SetMinute = F2(
	function (a, b) {
		return {$: 'SetMinute', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
var $rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			calc: $rtfeldman$elm_css$Css$Structure$Compatible,
			units: units,
			value: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel),
			length: $rtfeldman$elm_css$Css$Structure$Compatible,
			fontSize: $rtfeldman$elm_css$Css$Structure$Compatible,
			flexBasis: $rtfeldman$elm_css$Css$Structure$Compatible,
			unitLabel: unitLabel,
			lineHeight: $rtfeldman$elm_css$Css$Structure$Compatible,
			textIndent: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: numericValue,
			absoluteLength: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$PxUnits, 'px');
var $rtfeldman$elm_css$Css$UnitlessFloat = {$: 'UnitlessFloat'};
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		units: $rtfeldman$elm_css$Css$UnitlessFloat,
		value: $elm$core$String$fromFloat(val),
		number: $rtfeldman$elm_css$Css$Structure$Compatible,
		unitLabel: '',
		lineHeight: $rtfeldman$elm_css$Css$Structure$Compatible,
		numericValue: val,
		lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible,
		numberOrInfinite: $rtfeldman$elm_css$Css$Structure$Compatible,
		lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible
	};
};
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 'AppendProperty', a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(
			$rtfeldman$elm_css$Css$Structure$Property(key + (':' + value)));
	});
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.value);
};
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.value);
	});
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$flexGrow = $rtfeldman$elm_css$Css$prop1('flex-grow');
var $rtfeldman$elm_css$Css$flexBasis = $rtfeldman$elm_css$Css$prop1('flex-basis');
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(
			$rtfeldman$elm_css$Css$Structure$Property(key + (':' + value)));
	});
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 'ApplyStyles', a: a};
};
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 'AppendProperty':
					var str = style.a.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 'ExtendSelector':
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 'NestSnippet':
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 'WithPseudoElement':
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 'WithMedia':
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 'WithKeyframes':
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix = F2(
	function (prefix, className) {
		return prefix + ('--' + className);
	});
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$letterSpacing = $rtfeldman$elm_css$Css$prop1('letter-spacing');
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewEmpty = function (theme) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$letterSpacing(
						$rtfeldman$elm_css$Css$px(3)),
						$rtfeldman$elm_css$Css$color(theme.color.text.disabled),
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$num(1)),
						$rtfeldman$elm_css$Css$flexBasis(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$minHeight(theme.size.iconButton)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
				A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-empty'))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('––.––.––––')
			]));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$defaultAttributes = function (name) {
	return {
		size: 24,
		_class: $elm$core$Maybe$Just('feather feather-' + name),
		viewBox: '0 0 24 24',
		sizeUnit: '',
		strokeWidth: 2
	};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder = F2(
	function (name, src) {
		return $mercurymedia$elm_datetime_picker$DatePicker$Icons$Icon(
			{
				src: src,
				attrs: $mercurymedia$elm_datetime_picker$DatePicker$Icons$defaultAttributes(name)
			});
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$edit = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'edit',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$check = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'check',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('20 6 9 17 4 12')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$clock = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'clock',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12 6 12 12 16 14')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml = F2(
	function (attributes, _v0) {
		var attrs = _v0.a.attrs;
		var src = _v0.a.src;
		var strSize = $elm$core$String$fromFloat(attrs.size);
		var baseAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height(
				_Utils_ap(strSize, attrs.sizeUnit)),
				$elm$svg$Svg$Attributes$width(
				_Utils_ap(strSize, attrs.sizeUnit)),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(attrs.strokeWidth)),
				$elm$svg$Svg$Attributes$viewBox(attrs.viewBox)
			]);
		var combinedAttributes = _Utils_ap(
			function () {
				var _v1 = attrs._class;
				if (_v1.$ === 'Just') {
					var c = _v1.a;
					return A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$class(c),
						baseAttributes);
				} else {
					return baseAttributes;
				}
			}(),
			attributes);
		return A2(
			$elm$svg$Svg$svg,
			combinedAttributes,
			A2(
				$elm$core$List$map,
				$elm$svg$Svg$map($elm$core$Basics$never),
				src));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$calendar = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'clock',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('3'),
					$elm$svg$Svg$Attributes$y('4'),
					$elm$svg$Svg$Attributes$width('18'),
					$elm$svg$Svg$Attributes$height('18'),
					$elm$svg$Svg$Attributes$rx('2'),
					$elm$svg$Svg$Attributes$ry('2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('16'),
					$elm$svg$Svg$Attributes$y1('2'),
					$elm$svg$Svg$Attributes$x2('16'),
					$elm$svg$Svg$Attributes$y2('6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('8'),
					$elm$svg$Svg$Attributes$y1('2'),
					$elm$svg$Svg$Attributes$x2('8'),
					$elm$svg$Svg$Attributes$y2('6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('3'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('21'),
					$elm$svg$Svg$Attributes$y2('10')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize = F2(
	function (size, _v0) {
		var src = _v0.a.src;
		var attrs = _v0.a.attrs;
		return $mercurymedia$elm_datetime_picker$DatePicker$Icons$Icon(
			{
				src: src,
				attrs: _Utils_update(
					attrs,
					{size: size})
			});
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewDate = F2(
	function (theme, dateTimeString) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							A2($rtfeldman$elm_css$Css$property, 'gap', '0.5rem'),
							$rtfeldman$elm_css$Css$minHeight(theme.size.iconButton)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-selected-date'))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(
					A2(
						$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
						_List_Nil,
						A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$calendar))),
					$rtfeldman$elm_css$Html$Styled$text(dateTimeString)
				]));
	});
var $rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$PercentageUnits, '%');
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 'ExtendSelector', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 'PseudoClassSelector', a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$pointer = {value: 'pointer', cursor: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$inlineFlex = {value: 'inline-flex', display: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.value);
};
var $rtfeldman$elm_css$Css$Transitions$Color = {$: 'Color'};
var $rtfeldman$elm_css$Css$Transitions$Transition = function (a) {
	return {$: 'Transition', a: a};
};
var $rtfeldman$elm_css$Css$Transitions$fullTransition = F4(
	function (animation, duration, delay, timing) {
		return $rtfeldman$elm_css$Css$Transitions$Transition(
			{
				delay: $elm$core$Maybe$Just(delay),
				timing: $elm$core$Maybe$Just(timing),
				duration: duration,
				animation: animation
			});
	});
var $rtfeldman$elm_css$Css$Transitions$color3 = $rtfeldman$elm_css$Css$Transitions$fullTransition($rtfeldman$elm_css$Css$Transitions$Color);
var $rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
	switch (prop.$) {
		case 'Background':
			return 'background';
		case 'BackgroundColor':
			return 'background-color';
		case 'BackgroundPosition':
			return 'background-position';
		case 'BackgroundSize':
			return 'background-size';
		case 'Border':
			return 'border';
		case 'BorderBottom':
			return 'border-bottom';
		case 'BorderBottomColor':
			return 'border-bottom-color';
		case 'BorderBottomLeftRadius':
			return 'border-bottom-left-radius';
		case 'BorderBottomRightRadius':
			return 'border-bottom-right-radius';
		case 'BorderBottomWidth':
			return 'border-bottom-width';
		case 'BorderColor':
			return 'border-color';
		case 'BorderLeft':
			return 'border-left';
		case 'BorderLeftColor':
			return 'border-left-color';
		case 'BorderLeftWidth':
			return 'border-left-width';
		case 'BorderRadius':
			return 'border-radius';
		case 'BorderRight':
			return 'border-right';
		case 'BorderRightColor':
			return 'border-right-color';
		case 'BorderRightWidth':
			return 'border-right-width';
		case 'BorderTop':
			return 'border-top';
		case 'BorderTopColor':
			return 'border-top-color';
		case 'BorderTopLeftRadius':
			return 'border-top-left-radius';
		case 'BorderTopRightRadius':
			return 'border-top-right-radius';
		case 'BorderTopWidth':
			return 'border-top-width';
		case 'BorderWidth':
			return 'border-width';
		case 'Bottom':
			return 'bottom';
		case 'BoxShadow':
			return 'box-shadow';
		case 'CaretColor':
			return 'caret-color';
		case 'Clip':
			return 'clip';
		case 'ClipPath':
			return 'clip-path';
		case 'Color':
			return 'color';
		case 'ColumnCount':
			return 'column-count';
		case 'ColumnGap':
			return 'column-gap';
		case 'ColumnRule':
			return 'column-rule';
		case 'ColumnRuleColor':
			return 'column-rule-color';
		case 'ColumnRuleWidth':
			return 'column-rule-width';
		case 'ColumnWidth':
			return 'column-width';
		case 'Columns':
			return 'columns';
		case 'Filter':
			return 'filter';
		case 'Flex':
			return 'flex';
		case 'FlexBasis':
			return 'flex-basis';
		case 'FlexGrow':
			return 'flex-grow';
		case 'FlexShrink':
			return 'flex-shrink';
		case 'Font':
			return 'font';
		case 'FontSize':
			return 'font-size';
		case 'FontSizeAdjust':
			return 'font-size-adjust';
		case 'FontStretch':
			return 'font-stretch';
		case 'FontVariationSettings':
			return 'font-variation-settings';
		case 'FontWeight':
			return 'font-weight';
		case 'GridColumnGap':
			return 'grid-column-gap';
		case 'GridGap':
			return 'grid-gap';
		case 'GridRowGap':
			return 'grid-row-gap';
		case 'Height':
			return 'height';
		case 'Left':
			return 'left';
		case 'LetterSpacing':
			return 'letter-spacing';
		case 'LineHeight':
			return 'line-height';
		case 'Margin':
			return 'margin';
		case 'MarginBottom':
			return 'margin-bottom';
		case 'MarginLeft':
			return 'margin-left';
		case 'MarginRight':
			return 'margin-right';
		case 'MarginTop':
			return 'margin-top';
		case 'Mask':
			return 'mask';
		case 'MaskPosition':
			return 'mask-position';
		case 'MaskSize':
			return 'mask-size';
		case 'MaxHeight':
			return 'max-height';
		case 'MaxWidth':
			return 'max-width';
		case 'MinHeight':
			return 'min-height';
		case 'MinWidth':
			return 'min-width';
		case 'ObjectPosition':
			return 'object-position';
		case 'Offset':
			return 'offset';
		case 'OffsetAnchor':
			return 'offset-anchor';
		case 'OffsetDistance':
			return 'offset-distance';
		case 'OffsetPath':
			return 'offset-path';
		case 'OffsetRotate':
			return 'offset-rotate';
		case 'Opacity':
			return 'opacity';
		case 'Order':
			return 'order';
		case 'Outline':
			return 'outline';
		case 'OutlineColor':
			return 'outline-color';
		case 'OutlineOffset':
			return 'outline-offset';
		case 'OutlineWidth':
			return 'outline-width';
		case 'Padding':
			return 'padding';
		case 'PaddingBottom':
			return 'padding-bottom';
		case 'PaddingLeft':
			return 'padding-left';
		case 'PaddingRight':
			return 'padding-right';
		case 'PaddingTop':
			return 'padding-top';
		case 'Right':
			return 'right';
		case 'TabSize':
			return 'tab-size';
		case 'TextIndent':
			return 'text-indent';
		case 'TextShadow':
			return 'text-shadow';
		case 'Top':
			return 'top';
		case 'Transform':
			return 'transform';
		case 'TransformOrigin':
			return 'transform-origin';
		case 'VerticalAlign':
			return 'vertical-align';
		case 'Visibility':
			return 'visibility';
		case 'Width':
			return 'width';
		case 'WordSpacing':
			return 'word-spacing';
		default:
			return 'z-index';
	}
};
var $rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
	return $elm$core$String$fromFloat(time) + 'ms';
};
var $rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
	switch (tf.$) {
		case 'Ease':
			return 'ease';
		case 'Linear':
			return 'linear';
		case 'EaseIn':
			return 'ease-in';
		case 'EaseOut':
			return 'ease-out';
		case 'EaseInOut':
			return 'ease-in-out';
		case 'StepStart':
			return 'step-start';
		case 'StepEnd':
			return 'step-end';
		default:
			var _float = tf.a;
			var float2 = tf.b;
			var float3 = tf.c;
			var float4 = tf.d;
			return 'cubic-bezier(' + ($elm$core$String$fromFloat(_float) + (' , ' + ($elm$core$String$fromFloat(float2) + (' , ' + ($elm$core$String$fromFloat(float3) + (' , ' + ($elm$core$String$fromFloat(float4) + ')')))))));
	}
};
var $rtfeldman$elm_css$Css$Transitions$transition = function (options) {
	var v = A3(
		$elm$core$String$slice,
		0,
		-1,
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, s) {
					var timing = _v0.a.timing;
					var delay = _v0.a.delay;
					var duration = _v0.a.duration;
					var animation = _v0.a.animation;
					return s + ($rtfeldman$elm_css$Css$Transitions$propToString(animation) + (' ' + ($rtfeldman$elm_css$Css$Transitions$timeToString(duration) + (' ' + (A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timeToString, delay)) + (' ' + (A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing)) + ',')))))));
				}),
			'',
			options));
	return A2($rtfeldman$elm_css$Css$property, 'transition', v);
};
var $rtfeldman$elm_css$Css$Transitions$CubicBezier = F4(
	function (a, b, c, d) {
		return {$: 'CubicBezier', a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$Css$Transitions$cubicBezier = F4(
	function (f1, f2, f3, f4) {
		return A4($rtfeldman$elm_css$Css$Transitions$CubicBezier, f1, f2, f3, f4);
	});
var $rtfeldman$elm_css$Css$Transitions$BackgroundColor = {$: 'BackgroundColor'};
var $rtfeldman$elm_css$Css$Transitions$backgroundColor3 = $rtfeldman$elm_css$Css$Transitions$fullTransition($rtfeldman$elm_css$Css$Transitions$BackgroundColor);
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$colorsTransition = function (theme) {
	return $rtfeldman$elm_css$Css$Transitions$transition(
		_List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Css$Transitions$backgroundColor3,
				theme.transition.duration,
				0,
				A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.4, 0, 0.2, 1)),
				A3(
				$rtfeldman$elm_css$Css$Transitions$color3,
				theme.transition.duration,
				0,
				A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.4, 0, 0.2, 1))
			]));
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewIconButton = F3(
	function (theme, attributes, _v0) {
		var variant = _v0.variant;
		var icon = _v0.icon;
		var variantStyles = function () {
			if (variant.$ === 'PrimaryIconButton') {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(theme.color.primary.main),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$backgroundColor(theme.color.action.hover)
							]))
					]);
			} else {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(theme.color.text.secondary),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$backgroundColor(theme.color.action.hover)
							]))
					]);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$width(theme.size.iconButton),
							$rtfeldman$elm_css$Css$height(theme.size.iconButton),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$colorsTransition(theme),
							$rtfeldman$elm_css$Css$batch(variantStyles)
						])),
				attributes),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(
					A2(
						$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
						_List_Nil,
						A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, icon)))
				]));
	});
var $rtfeldman$elm_css$Css$RemUnits = {$: 'RemUnits'};
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$RemUnits, 'rem');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.value + (' ' + argB.value));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$none = {none: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'none', cursor: $rtfeldman$elm_css$Css$Structure$Compatible, resize: $rtfeldman$elm_css$Css$Structure$Compatible, display: $rtfeldman$elm_css$Css$Structure$Compatible, outline: $rtfeldman$elm_css$Css$Structure$Compatible, keyframes: $rtfeldman$elm_css$Css$Structure$Compatible, transform: $rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, touchAction: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: $rtfeldman$elm_css$Css$Structure$Compatible, pointerDevice: $rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: $rtfeldman$elm_css$Css$Structure$Compatible, textTransform: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundImage: $rtfeldman$elm_css$Css$Structure$Compatible, hoverCapability: $rtfeldman$elm_css$Css$Structure$Compatible, updateFrequency: $rtfeldman$elm_css$Css$Structure$Compatible, scriptingSupport: $rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
var $rtfeldman$elm_css$Css$zero = {units: $rtfeldman$elm_css$Css$UnitlessInteger, value: '0', length: $rtfeldman$elm_css$Css$Structure$Compatible, number: $rtfeldman$elm_css$Css$Structure$Compatible, outline: $rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$solid = {value: 'solid', borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$normal = {value: 'normal', fontStyle: $rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible, lineHeight: $rtfeldman$elm_css$Css$Structure$Compatible, whiteSpace: $rtfeldman$elm_css$Css$Structure$Compatible, overflowWrap: $rtfeldman$elm_css$Css$Structure$Compatible, featureTagValue: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.value + (' ' + (argB.value + (' ' + argC.value))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$outline = $rtfeldman$elm_css$Css$prop1('outline');
var $rtfeldman$elm_css$Css$absolute = {value: 'absolute', position: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.value + (' ' + (argB.value + (' ' + (argC.value + (' ' + argD.value))))));
	});
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$relative = {value: 'relative', position: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.value;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronDown = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevron-down',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('6 9 12 15 18 9')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$pointerEvents = $rtfeldman$elm_css$Css$prop1('pointer-events');
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewSelect = F3(
	function (theme, attributes, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-select'))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$borderRadius(theme.borderRadius.base),
									$rtfeldman$elm_css$Css$height(theme.size.iconButton),
									$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
									$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
									A3($rtfeldman$elm_css$Css$border3, theme.borderWidth, $rtfeldman$elm_css$Css$solid, theme.color.border),
									A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
									A4(
									$rtfeldman$elm_css$Css$padding4,
									$rtfeldman$elm_css$Css$px(0),
									$rtfeldman$elm_css$Css$px(24),
									$rtfeldman$elm_css$Css$px(0),
									$rtfeldman$elm_css$Css$px(4))
								])),
						attributes),
					content),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$px(4)),
									$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none),
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$fromUnstyled(
							A2(
								$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
								_List_Nil,
								A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronDown)))
						]))
				]));
	});
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$addLeadingZero = function (value) {
	var string = $elm$core$String$fromInt(value);
	return ($elm$core$String$length(string) === 1) ? ('0' + string) : string;
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateHourOptions = F3(
	function (zone, selectionTuple, selectableHours) {
		var isSelected = function (h) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var selection = _v0.b;
						return _Utils_eq(
							A2($elm$time$Time$toHour, zone, selection),
							h);
					},
					selectionTuple));
		};
		return A2(
			$elm$core$List$map,
			function (hour) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							$elm$core$String$fromInt(hour)),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							isSelected(hour))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$mercurymedia$elm_datetime_picker$DatePicker$Utilities$addLeadingZero(hour))
						]));
			},
			selectableHours);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateMinuteOptions = F3(
	function (zone, selectionTuple, selectableMinutes) {
		var isSelected = function (m) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var selection = _v0.b;
						return _Utils_eq(
							A2($elm$time$Time$toMinute, zone, selection),
							m);
					},
					selectionTuple));
		};
		return A2(
			$elm$core$List$map,
			function (minute) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							$elm$core$String$fromInt(minute)),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							isSelected(minute))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$mercurymedia$elm_datetime_picker$DatePicker$Utilities$addLeadingZero(minute))
						]));
			},
			selectableMinutes);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewTimePicker = F2(
	function (theme, _v0) {
		var selectableMinutes = _v0.selectableMinutes;
		var selectableHours = _v0.selectableHours;
		var onMinuteChangeDecoder = _v0.onMinuteChangeDecoder;
		var onHourChangeDecoder = _v0.onHourChangeDecoder;
		var selectionTuple = _v0.selectionTuple;
		var zone = _v0.zone;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'time-picker'))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex)
								])),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'time-picker-select-container'))
						]),
					_List_fromArray(
						[
							A3(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewSelect,
							theme,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('hour-select'),
									A2($rtfeldman$elm_css$Html$Styled$Events$on, 'change', onHourChangeDecoder)
								]),
							A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateHourOptions, zone, selectionTuple, selectableHours)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
											$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
											A2(
											$rtfeldman$elm_css$Css$padding2,
											$rtfeldman$elm_css$Css$px(0),
											$rtfeldman$elm_css$Css$rem(0.25)),
											A2($rtfeldman$elm_css$Css$property, 'user-select', 'none')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(':')
								])),
							A3(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewSelect,
							theme,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('minute-select'),
									A2($rtfeldman$elm_css$Html$Styled$Events$on, 'change', onMinuteChangeDecoder)
								]),
							A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateMinuteOptions, zone, selectionTuple, selectableMinutes))
						]))
				]));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$PrimaryIconButton = {$: 'PrimaryIconButton'};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewFooterBody = F2(
	function (theme, _v0) {
		var dateTimeString = _v0.dateTimeString;
		var onTimePickerToggleMsg = _v0.onTimePickerToggleMsg;
		var selection = _v0.selection;
		var timePickerVisibility = _v0.timePickerVisibility;
		var isTimePickerVisible = _v0.isTimePickerVisible;
		var timePickerProps = _v0.timePickerProps;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							A2($rtfeldman$elm_css$Css$property, 'gap', '1rem'),
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$num(1)),
							$rtfeldman$elm_css$Css$flexBasis(
							$rtfeldman$elm_css$Css$px(0))
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-body'))
				]),
			_List_fromArray(
				[
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewDate, theme, dateTimeString),
					function () {
					switch (timePickerVisibility.$) {
						case 'NeverVisible':
							return $rtfeldman$elm_css$Html$Styled$text('');
						case 'Toggleable':
							var timePickerSettings = timePickerVisibility.a;
							var _v2 = isTimePickerVisible ? _Utils_Tuple2(
								A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewTimePicker, theme, timePickerProps),
								$mercurymedia$elm_datetime_picker$DatePicker$Icons$check) : _Utils_Tuple2(
								$rtfeldman$elm_css$Html$Styled$text(
									A2(timePickerSettings.timeStringFn, timePickerProps.zone, selection)),
								$mercurymedia$elm_datetime_picker$DatePicker$Icons$edit);
							var viewToggleView = _v2.a;
							var toggleIcon = _v2.b;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
												A2($rtfeldman$elm_css$Css$property, 'gap', '0.5rem')
											])),
										$rtfeldman$elm_css$Html$Styled$Attributes$class(
										A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-time'))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$fromUnstyled(
										A2(
											$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
											_List_Nil,
											A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$clock))),
										viewToggleView,
										A3(
										$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewIconButton,
										theme,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onClick(onTimePickerToggleMsg),
												$rtfeldman$elm_css$Html$Styled$Attributes$class(
												A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-time-picker-toggle'))
											]),
										{icon: toggleIcon, variant: $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$PrimaryIconButton})
									]));
						default:
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
												A2($rtfeldman$elm_css$Css$property, 'gap', '0.5rem')
											])),
										$rtfeldman$elm_css$Html$Styled$Attributes$class(
										A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-selected-time'))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$fromUnstyled(
										A2(
											$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
											_List_Nil,
											A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$clock))),
										A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewTimePicker, theme, timePickerProps)
									]));
					}
				}()
				]));
	});
var $elm_community$html_extra$Html$Events$Extra$customDecoder = F2(
	function (d, f) {
		var resultDecoder = function (x) {
			if (x.$ === 'Ok') {
				var a = x.a;
				return $elm$json$Json$Decode$succeed(a);
			} else {
				var e = x.a;
				return $elm$json$Json$Decode$fail(e);
			}
		};
		return A2(
			$elm$json$Json$Decode$andThen,
			resultDecoder,
			A2($elm$json$Json$Decode$map, f, d));
	});
var $elm_community$html_extra$Html$Events$Extra$maybeStringToResult = $elm$core$Result$fromMaybe('could not convert string');
var $elm_community$html_extra$Html$Events$Extra$targetValueIntParse = A2(
	$elm_community$html_extra$Html$Events$Extra$customDecoder,
	$elm$html$Html$Events$targetValue,
	A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm_community$html_extra$Html$Events$Extra$maybeStringToResult));
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$borderTop3 = $rtfeldman$elm_css$Css$prop3('border-top');
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewFooterContainer = F3(
	function (theme, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$backgroundColor(theme.color.background.footer),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$fontSize(theme.fontSize.sm),
								A3($rtfeldman$elm_css$Css$borderTop3, theme.borderWidth, $rtfeldman$elm_css$Css$solid, theme.color.border),
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$rem(1))
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'footer-container'))
					]),
				attributes),
			children);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix = F2(
	function (zone, posix) {
		return _Utils_Tuple2(
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute = F2(
	function (zone, _v0) {
		var pickerDay = _v0.a;
		var selection = _v0.b;
		var _v1 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.start);
		var startBoundaryHour = _v1.a;
		var startBoundaryMinute = _v1.b;
		var _v2 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.end);
		var endBoundaryHour = _v2.a;
		var endBoundaryMinute = _v2.b;
		var _v3 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, selection);
		var selectedMinute = _v3.b;
		var latestSelectableHour = (_Utils_cmp(selectedMinute, endBoundaryMinute) > 0) ? (endBoundaryHour - 1) : endBoundaryHour;
		var earliestSelectableHour = (_Utils_cmp(selectedMinute, startBoundaryMinute) < 0) ? (startBoundaryHour + 1) : startBoundaryHour;
		return _Utils_Tuple2(earliestSelectableHour, latestSelectableHour);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectableHours = F3(
	function (zone, _v0, _v1) {
		var startPickerDay = _v0.a;
		var startSelection = _v0.b;
		var endPickerDay = _v1.a;
		var endSelection = _v1.b;
		var _v2 = A2(
			$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
			zone,
			_Utils_Tuple2(startPickerDay, startSelection));
		var earliestSelectableStartHour = _v2.a;
		var latestSelectableStartHour = _v2.b;
		var _v3 = A2(
			$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
			zone,
			_Utils_Tuple2(endPickerDay, endSelection));
		var earliestSelectableEndHour = _v3.a;
		var latestSelectableEndHour = _v3.b;
		var selectedStartHour = A2($elm$time$Time$toHour, zone, startSelection);
		var selectedEndHour = A2($elm$time$Time$toHour, zone, endSelection);
		return _Utils_eq(startPickerDay, endPickerDay) ? _Utils_Tuple2(
			A2($elm$core$List$range, earliestSelectableStartHour, selectedEndHour),
			A2($elm$core$List$range, selectedStartHour, latestSelectableEndHour)) : _Utils_Tuple2(
			A2($elm$core$List$range, earliestSelectableStartHour, latestSelectableStartHour),
			A2($elm$core$List$range, earliestSelectableEndHour, latestSelectableEndHour));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour = F2(
	function (zone, _v0) {
		var pickerDay = _v0.a;
		var selection = _v0.b;
		var _v1 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.start);
		var startBoundaryHour = _v1.a;
		var startBoundaryMinute = _v1.b;
		var _v2 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.end);
		var endBoundaryHour = _v2.a;
		var endBoundaryMinute = _v2.b;
		var _v3 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, selection);
		var selectedHour = _v3.a;
		var selectedMinute = _v3.b;
		var latestSelectableMinute = _Utils_eq(endBoundaryHour, selectedHour) ? endBoundaryMinute : 59;
		var earliestSelectableMinute = _Utils_eq(startBoundaryHour, selectedHour) ? startBoundaryMinute : 0;
		return _Utils_Tuple2(earliestSelectableMinute, latestSelectableMinute);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectableMinutes = F3(
	function (zone, _v0, _v1) {
		var startPickerDay = _v0.a;
		var startSelection = _v0.b;
		var endPickerDay = _v1.a;
		var endSelection = _v1.b;
		var _v2 = A2(
			$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
			zone,
			_Utils_Tuple2(startPickerDay, startSelection));
		var earliestSelectableStartMinute = _v2.a;
		var latestSelectableStartMinute = _v2.b;
		var _v3 = A2(
			$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
			zone,
			_Utils_Tuple2(endPickerDay, endSelection));
		var earliestSelectableEndMinute = _v3.a;
		var latestSelectableEndMinute = _v3.b;
		var _v4 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, startSelection);
		var selectedStartHour = _v4.a;
		var selectedStartMinute = _v4.b;
		var _v5 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, endSelection);
		var selectedEndHour = _v5.a;
		var selectedEndMinute = _v5.b;
		return (_Utils_eq(startPickerDay, endPickerDay) && _Utils_eq(selectedStartHour, selectedEndHour)) ? _Utils_Tuple2(
			A2($elm$core$List$range, earliestSelectableStartMinute, selectedEndMinute),
			A2($elm$core$List$range, selectedStartMinute, latestSelectableEndMinute)) : _Utils_Tuple2(
			A2($elm$core$List$range, earliestSelectableStartMinute, latestSelectableStartMinute),
			A2($elm$core$List$range, earliestSelectableEndMinute, latestSelectableEndMinute));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$filterSelectableTimes = F4(
	function (zone, baseDay, startSelectionTuple, endSelectionTuple) {
		var _v0 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var _v1 = _v0.a.a;
				var startPickerDay = _v1.a;
				var startSelection = _v1.b;
				var _v2 = _v0.b.a;
				var endPickerDay = _v2.a;
				var endSelection = _v2.b;
				var _v3 = A3(
					$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectableMinutes,
					zone,
					_Utils_Tuple2(startPickerDay, startSelection),
					_Utils_Tuple2(endPickerDay, endSelection));
				var selectableStartMinutes = _v3.a;
				var selectableEndMinutes = _v3.b;
				var _v4 = A3(
					$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectableHours,
					zone,
					_Utils_Tuple2(startPickerDay, startSelection),
					_Utils_Tuple2(endPickerDay, endSelection));
				var selectableStartHours = _v4.a;
				var selectableEndHours = _v4.b;
				return {selectableEndHours: selectableEndHours, selectableEndMinutes: selectableEndMinutes, selectableStartHours: selectableStartHours, selectableStartMinutes: selectableStartMinutes};
			} else {
				var _v5 = _v0.a.a;
				var startPickerDay = _v5.a;
				var startSelection = _v5.b;
				var _v6 = _v0.b;
				var _v7 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
					zone,
					_Utils_Tuple2(startPickerDay, startSelection));
				var earliestSelectableStartMinute = _v7.a;
				var latestSelectableStartMinute = _v7.b;
				var _v8 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
					zone,
					_Utils_Tuple2(startPickerDay, startSelection));
				var earliestSelectableStartHour = _v8.a;
				var latestSelectableStartHour = _v8.b;
				var _v9 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, startSelection);
				var selectedStartHour = _v9.a;
				var selectedStartMinute = _v9.b;
				return {
					selectableEndHours: A2($elm$core$List$range, selectedStartHour, latestSelectableStartHour),
					selectableEndMinutes: A2($elm$core$List$range, selectedStartMinute, latestSelectableStartMinute),
					selectableStartHours: A2($elm$core$List$range, earliestSelectableStartHour, latestSelectableStartHour),
					selectableStartMinutes: A2($elm$core$List$range, earliestSelectableStartMinute, latestSelectableStartMinute)
				};
			}
		} else {
			if (_v0.b.$ === 'Just') {
				var _v10 = _v0.a;
				var _v11 = _v0.b.a;
				var endPickerDay = _v11.a;
				var endSelection = _v11.b;
				var _v12 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
					zone,
					_Utils_Tuple2(endPickerDay, endSelection));
				var earliestSelectableEndMinute = _v12.a;
				var latestSelectableEndMinute = _v12.b;
				var _v13 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
					zone,
					_Utils_Tuple2(endPickerDay, endSelection));
				var earliestSelectableEndHour = _v13.a;
				var latestSelectableEndHour = _v13.b;
				var _v14 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, endSelection);
				var selectedEndHour = _v14.a;
				var selectedEndMinute = _v14.b;
				return {
					selectableEndHours: A2($elm$core$List$range, earliestSelectableEndHour, latestSelectableEndHour),
					selectableEndMinutes: A2($elm$core$List$range, earliestSelectableEndMinute, latestSelectableEndMinute),
					selectableStartHours: A2($elm$core$List$range, earliestSelectableEndHour, selectedEndHour),
					selectableStartMinutes: A2($elm$core$List$range, earliestSelectableEndMinute, selectedEndMinute)
				};
			} else {
				var _v15 = _v0.a;
				var _v16 = _v0.b;
				var _v17 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
					zone,
					_Utils_Tuple2(baseDay, baseDay.start));
				var earliestSelectableMinute = _v17.a;
				var latestSelectableMinute = _v17.b;
				var _v18 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
					zone,
					_Utils_Tuple2(baseDay, baseDay.start));
				var earliestSelectableHour = _v18.a;
				var latestSelectableHour = _v18.b;
				return {
					selectableEndHours: A2($elm$core$List$range, earliestSelectableHour, latestSelectableHour),
					selectableEndMinutes: A2($elm$core$List$range, earliestSelectableMinute, latestSelectableMinute),
					selectableStartHours: A2($elm$core$List$range, earliestSelectableHour, latestSelectableHour),
					selectableStartMinutes: A2($elm$core$List$range, earliestSelectableMinute, latestSelectableMinute)
				};
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			day: A2($elm$time$Time$toDay, zone, posix),
			hour: A2($elm$time$Time$toHour, zone, posix),
			year: A2($elm$time$Time$toYear, zone, posix),
			month: A2($elm$time$Time$toMonth, zone, posix),
			minute: A2($elm$time$Time$toMinute, zone, posix),
			second: A2($elm$time$Time$toSecond, zone, posix),
			millisecond: A2($elm$time$Time$toMillis, zone, posix)
		};
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay = F5(
	function (zone, hour, minute, second, timeToUpdate) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);
		var newParts = _Utils_update(
			parts,
			{hour: hour, minute: minute, second: second});
		return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries = F3(
	function (zone, pickerDay, selection) {
		var _v0 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, selection);
		var selectionHour = _v0.a;
		var selectionMinute = _v0.b;
		var _v1 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.start);
		var startHour = _v1.a;
		var startMinute = _v1.b;
		var _v2 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.end);
		var endHour = _v2.a;
		var endMinute = _v2.b;
		return (_Utils_eq(startHour, selectionHour) && (_Utils_cmp(startMinute, selectionMinute) < 1)) || (((_Utils_cmp(startHour, selectionHour) < 0) && (_Utils_cmp(selectionHour, endHour) < 0)) || (_Utils_eq(selectionHour, endHour) && (_Utils_cmp(selectionMinute, endMinute) < 1)));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectDay = F4(
	function (zone, previousStartSelectionTuple, previousEndSelectionTuple, selectedPickerDay) {
		if (selectedPickerDay.disabled) {
			return _Utils_Tuple2(previousStartSelectionTuple, previousEndSelectionTuple);
		} else {
			var _v0 = _Utils_Tuple2(previousStartSelectionTuple, previousEndSelectionTuple);
			if (_v0.a.$ === 'Just') {
				if (_v0.b.$ === 'Just') {
					var _v1 = _v0.a.a;
					var startPickerDay = _v1.a;
					var previousSelectionStart = _v1.b;
					var _v2 = _v0.b.a;
					var endPickerDay = _v2.a;
					var previousSelectionEnd = _v2.b;
					return (_Utils_eq(startPickerDay, selectedPickerDay) && _Utils_eq(selectedPickerDay, endPickerDay)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(startPickerDay, previousSelectionStart)),
						$elm$core$Maybe$Nothing) : (_Utils_eq(startPickerDay, selectedPickerDay) ? _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(endPickerDay, previousSelectionEnd))) : (_Utils_eq(endPickerDay, selectedPickerDay) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(startPickerDay, previousSelectionStart)),
						$elm$core$Maybe$Nothing) : _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(selectedPickerDay, selectedPickerDay.start)),
						$elm$core$Maybe$Nothing)));
				} else {
					var _v3 = _v0.a.a;
					var startPickerDay = _v3.a;
					var selectionStart = _v3.b;
					var _v4 = _v0.b;
					return (_Utils_eq(startPickerDay, selectedPickerDay) || (_Utils_cmp(
						$elm$time$Time$posixToMillis(startPickerDay.start),
						$elm$time$Time$posixToMillis(selectedPickerDay.start)) < 0)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(startPickerDay, selectionStart)),
						$elm$core$Maybe$Just(
							_Utils_Tuple2(selectedPickerDay, selectedPickerDay.end))) : (A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries, zone, selectedPickerDay, selectionStart) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(
								selectedPickerDay,
								A5(
									$mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay,
									zone,
									A2($elm$time$Time$toHour, zone, selectionStart),
									A2($elm$time$Time$toMinute, zone, selectionStart),
									0,
									selectedPickerDay.start))),
						$elm$core$Maybe$Just(
							_Utils_Tuple2(startPickerDay, startPickerDay.end))) : _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(selectedPickerDay, selectedPickerDay.start)),
						$elm$core$Maybe$Just(
							_Utils_Tuple2(startPickerDay, startPickerDay.end))));
				}
			} else {
				if (_v0.b.$ === 'Just') {
					var _v5 = _v0.a;
					var _v6 = _v0.b.a;
					var endPickerDay = _v6.a;
					var selectionEnd = _v6.b;
					return (_Utils_eq(endPickerDay, selectedPickerDay) || (_Utils_cmp(
						$elm$time$Time$posixToMillis(endPickerDay.start),
						$elm$time$Time$posixToMillis(selectedPickerDay.end)) > 0)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(selectedPickerDay, selectedPickerDay.start)),
						$elm$core$Maybe$Just(
							_Utils_Tuple2(endPickerDay, selectionEnd))) : (A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries, zone, selectedPickerDay, selectionEnd) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(endPickerDay, endPickerDay.start)),
						$elm$core$Maybe$Just(
							_Utils_Tuple2(
								selectedPickerDay,
								A5(
									$mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay,
									zone,
									A2($elm$time$Time$toHour, zone, selectionEnd),
									A2($elm$time$Time$toMinute, zone, selectionEnd),
									59,
									selectedPickerDay.end)))) : _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(endPickerDay, endPickerDay.start)),
						$elm$core$Maybe$Just(
							_Utils_Tuple2(selectedPickerDay, selectedPickerDay.end))));
				} else {
					var _v7 = _v0.a;
					var _v8 = _v0.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(selectedPickerDay, selectedPickerDay.start)),
						$elm$core$Maybe$Nothing);
				}
			}
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$previewSelection = F4(
	function (zone, previousStartSelectionTuple, previousEndSelectionTuple, hoveredPickerDay) {
		var _v0 = _Utils_Tuple2(previousStartSelectionTuple, previousEndSelectionTuple);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var startSelectionTuple = _v0.a.a;
			var endSelectionTuple = _v0.b.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(startSelectionTuple),
				$elm$core$Maybe$Just(endSelectionTuple));
		} else {
			return A4($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectDay, zone, previousStartSelectionTuple, previousEndSelectionTuple, hoveredPickerDay);
		}
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$showHoveredIfEnabled = function (hovered) {
	return hovered.disabled ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(hovered);
};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$determineDateTimeRange = F4(
	function (zone, startSelectionTuple, endSelectionTuple, hoveredDay) {
		var hovered = A2($elm$core$Maybe$andThen, $mercurymedia$elm_datetime_picker$DurationDatePicker$showHoveredIfEnabled, hoveredDay);
		if (hovered.$ === 'Just') {
			var h = hovered.a;
			return A4($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$previewSelection, zone, startSelectionTuple, endSelectionTuple, h);
		} else {
			return _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$arrowRight = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'arrow-right',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('5'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('19'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12 5 19 12 12 19')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DurationDatePicker$viewDateTimesSeparator = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$fromUnstyled(
			A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
				_List_Nil,
				A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$arrowRight)))
		]));
var $mercurymedia$elm_datetime_picker$DurationDatePicker$ToggleTimePickerVisibility = {$: 'ToggleTimePickerVisibility'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$viewFooter = F4(
	function (settings, timePickerVisible, baseDay, model) {
		var _v0 = A4($mercurymedia$elm_datetime_picker$DurationDatePicker$determineDateTimeRange, settings.zone, model.startSelectionTuple, model.endSelectionTuple, model.hovered);
		var startSelectionTuple = _v0.a;
		var endSelectionTuple = _v0.b;
		var _v1 = A4($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$filterSelectableTimes, settings.zone, baseDay, startSelectionTuple, endSelectionTuple);
		var selectableEndMinutes = _v1.selectableEndMinutes;
		var selectableEndHours = _v1.selectableEndHours;
		var selectableStartMinutes = _v1.selectableStartMinutes;
		var selectableStartHours = _v1.selectableStartHours;
		return A3(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewFooterContainer,
			settings.theme,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (startSelectionTuple.$ === 'Just') {
						var _v3 = startSelectionTuple.a;
						var startSelection = _v3.b;
						var dateTimeString = A2(settings.dateStringFn, settings.zone, startSelection);
						return A2(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewFooterBody,
							settings.theme,
							{
								selection: startSelection,
								dateTimeString: dateTimeString,
								timePickerProps: {
									zone: settings.zone,
									selectionTuple: startSelectionTuple,
									selectableHours: selectableStartHours,
									selectableMinutes: selectableStartMinutes,
									onHourChangeDecoder: A2(
										$elm$json$Json$Decode$map,
										model.internalMsg,
										A2(
											$elm$json$Json$Decode$map,
											$mercurymedia$elm_datetime_picker$DurationDatePicker$SetHour($mercurymedia$elm_datetime_picker$DurationDatePicker$Start),
											$elm_community$html_extra$Html$Events$Extra$targetValueIntParse)),
									onMinuteChangeDecoder: A2(
										$elm$json$Json$Decode$map,
										model.internalMsg,
										A2(
											$elm$json$Json$Decode$map,
											$mercurymedia$elm_datetime_picker$DurationDatePicker$SetMinute($mercurymedia$elm_datetime_picker$DurationDatePicker$Start),
											$elm_community$html_extra$Html$Events$Extra$targetValueIntParse))
								},
								isTimePickerVisible: timePickerVisible,
								timePickerVisibility: settings.timePickerVisibility,
								onTimePickerToggleMsg: model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$ToggleTimePickerVisibility)
							});
					} else {
						return $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewEmpty(settings.theme);
					}
				}(),
					$mercurymedia$elm_datetime_picker$DurationDatePicker$viewDateTimesSeparator,
					function () {
					if (endSelectionTuple.$ === 'Just') {
						var _v5 = endSelectionTuple.a;
						var endSelection = _v5.b;
						var dateTimeString = A2(settings.dateStringFn, settings.zone, endSelection);
						return A2(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewFooterBody,
							settings.theme,
							{
								selection: endSelection,
								dateTimeString: dateTimeString,
								timePickerProps: {
									zone: settings.zone,
									selectionTuple: endSelectionTuple,
									selectableHours: selectableEndHours,
									selectableMinutes: selectableEndMinutes,
									onHourChangeDecoder: A2(
										$elm$json$Json$Decode$map,
										model.internalMsg,
										A2(
											$elm$json$Json$Decode$map,
											$mercurymedia$elm_datetime_picker$DurationDatePicker$SetHour($mercurymedia$elm_datetime_picker$DurationDatePicker$End),
											$elm_community$html_extra$Html$Events$Extra$targetValueIntParse)),
									onMinuteChangeDecoder: A2(
										$elm$json$Json$Decode$map,
										model.internalMsg,
										A2(
											$elm$json$Json$Decode$map,
											$mercurymedia$elm_datetime_picker$DurationDatePicker$SetMinute($mercurymedia$elm_datetime_picker$DurationDatePicker$End),
											$elm_community$html_extra$Html$Events$Extra$targetValueIntParse))
								},
								isTimePickerVisible: timePickerVisible,
								timePickerVisibility: settings.timePickerVisibility,
								onTimePickerToggleMsg: model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$ToggleTimePickerVisibility)
							});
					} else {
						return $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewEmpty(settings.theme);
					}
				}()
				]));
	});
var $rtfeldman$elm_css$Css$default = {value: 'default', cursor: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewPresetTab = F3(
	function (theme, attributes, _v0) {
		var onClickMsg = _v0.onClickMsg;
		var active = _v0.active;
		var title = _v0.title;
		var defaultStyles = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$rem(0.65),
				$rtfeldman$elm_css$Css$rem(0.75)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$num(1.25)),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$borderRadius(theme.borderRadius.base),
				$rtfeldman$elm_css$Css$fontSize(theme.fontSize.sm),
				$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$colorsTransition(theme),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor(theme.color.action.hover)
					]))
			]);
		var activeStyles = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color(theme.color.primary.contrastText),
				$rtfeldman$elm_css$Css$backgroundColor(theme.color.primary.main),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor(theme.color.primary.main)
					])),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
			]);
		var _v1 = active ? _Utils_Tuple2(
			_Utils_ap(defaultStyles, activeStyles),
			A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'preset-tab') + (' ' + 'active')) : _Utils_Tuple2(
			defaultStyles,
			A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'preset-tab'));
		var styles = _v1.a;
		var classes = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(styles),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(onClickMsg),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(classes)
					]),
				attributes),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(title)
				]));
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$SetPresetRange = function (a) {
	return {$: 'SetPresetRange', a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix = F4(
	function (zone, isDisabledFn, allowableTimesFn, posix) {
		var flooredPosix = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, zone, posix);
		var allowableTimes = A2(
			$elm$core$Maybe$withDefault,
			{endHour: 23, endMinute: 59, startHour: 0, startMinute: 0},
			A2(
				$elm$core$Maybe$map,
				function (fn) {
					return A2(fn, zone, flooredPosix);
				},
				allowableTimesFn));
		return {
			end: A5($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay, zone, allowableTimes.endHour, allowableTimes.endMinute, 59, flooredPosix),
			start: A5($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay, zone, allowableTimes.startHour, allowableTimes.startMinute, 0, flooredPosix),
			disabled: A2(
				isDisabledFn,
				zone,
				A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, zone, flooredPosix))
		};
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$getTimePickerSettings = function (settings) {
	var _v0 = settings.timePickerVisibility;
	switch (_v0.$) {
		case 'NeverVisible':
			return $elm$core$Maybe$Nothing;
		case 'Toggleable':
			var timePickerSettings = _v0.a;
			return $elm$core$Maybe$Just(timePickerSettings);
		default:
			var timePickerSettings = _v0.a;
			return $elm$core$Maybe$Just(timePickerSettings);
	}
};
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay = F2(
	function (settings, time) {
		return A2(
			$elm$core$Maybe$withDefault,
			A4($mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix, settings.zone, settings.isDayDisabled, $elm$core$Maybe$Nothing, time),
			A2(
				$elm$core$Maybe$map,
				function (timePickerSettings) {
					return A4(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix,
						settings.zone,
						settings.isDayDisabled,
						$elm$core$Maybe$Just(timePickerSettings.allowedTimesOfDay),
						time);
				},
				$mercurymedia$elm_datetime_picker$DatePicker$Settings$getTimePickerSettings(settings)));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$isPresetRangeActive = F4(
	function (settings, startSelectionTuple, endSelectionTuple, _v0) {
		var range = _v0.range;
		var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
		if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
			var _v2 = _v1.a.a;
			var startPickerDay = _v2.a;
			var _v3 = _v1.b.a;
			var endPickerDay = _v3.a;
			var presetStartPickerDay = A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, range.start);
			var presetEndPickerDay = A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, range.end);
			return (_Utils_eq(presetStartPickerDay, startPickerDay) && _Utils_eq(presetEndPickerDay, endPickerDay)) ? true : false;
		} else {
			return false;
		}
	});
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		units: $rtfeldman$elm_css$Css$UnitlessInteger,
		value: $elm$core$String$fromInt(val),
		number: $rtfeldman$elm_css$Css$Structure$Compatible,
		intOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible,
		unitLabel: '',
		fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible,
		numericValue: val,
		lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible,
		numberOrInfinite: $rtfeldman$elm_css$Css$Structure$Compatible,
		lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible
	};
};
var $rtfeldman$elm_css$Css$row = {value: 'row', flexDirection: $rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{value: 'column'});
var $rtfeldman$elm_css$Css$flexShrink = $rtfeldman$elm_css$Css$prop1('flex-shrink');
var $rtfeldman$elm_css$Css$borderRight3 = $rtfeldman$elm_css$Css$prop3('border-right');
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewPresetsContainer = F3(
	function (theme, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$rem(0.75)),
								A3($rtfeldman$elm_css$Css$borderRight3, theme.borderWidth, $rtfeldman$elm_css$Css$solid, theme.color.border),
								$rtfeldman$elm_css$Css$backgroundColor(theme.color.background.presets),
								$rtfeldman$elm_css$Css$width(theme.size.presetsContainer),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$flexShrink(
								$rtfeldman$elm_css$Css$int(0))
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'presets-container'))
					]),
				attributes),
			children);
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$viewPresets = F2(
	function (settings, model) {
		return ($elm$core$List$length(settings.presets) > 0) ? A3(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewPresetsContainer,
			settings.theme,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (preset) {
					if (preset.$ === 'PresetRange') {
						var config = preset.a;
						return A3(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewPresetTab,
							settings.theme,
							_List_Nil,
							{
								title: config.title,
								active: A4($mercurymedia$elm_datetime_picker$DatePicker$Settings$isPresetRangeActive, settings, model.startSelectionTuple, model.endSelectionTuple, config),
								onClickMsg: model.internalMsg(
									$mercurymedia$elm_datetime_picker$DurationDatePicker$SetPresetRange(config))
							});
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				},
				settings.presets)) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$NextYear = {$: 'NextYear'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$PrevYear = {$: 'PrevYear'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$SetRange = function (a) {
	return {$: 'SetRange', a: a};
};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$NextMonth = {$: 'NextMonth'};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$PrevMonth = {$: 'PrevMonth'};
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $justinmimbs$time_extra$Time$Extra$rangeHelp = F6(
	function (interval, step, zone, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$time$Time$posixToMillis(current),
				$elm$time$Time$posixToMillis(until)) < 0) {
				var $temp$interval = interval,
					$temp$step = step,
					$temp$zone = zone,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = A4($justinmimbs$time_extra$Time$Extra$add, interval, step, zone, current);
				interval = $temp$interval;
				step = $temp$step;
				zone = $temp$zone;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$range = F5(
	function (interval, step, zone, start, until) {
		return A6(
			$justinmimbs$time_extra$Time$Extra$rangeHelp,
			interval,
			A2($elm$core$Basics$max, 1, step),
			zone,
			until,
			_List_Nil,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, start));
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateListOfWeekDay = function (firstWeekDay) {
	switch (firstWeekDay.$) {
		case 'Mon':
			return _List_fromArray(
				[$elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat, $elm$time$Time$Sun]);
		case 'Tue':
			return _List_fromArray(
				[$elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat, $elm$time$Time$Sun, $elm$time$Time$Mon]);
		case 'Wed':
			return _List_fromArray(
				[$elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat, $elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue]);
		case 'Thu':
			return _List_fromArray(
				[$elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat, $elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed]);
		case 'Fri':
			return _List_fromArray(
				[$elm$time$Time$Fri, $elm$time$Time$Sat, $elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu]);
		case 'Sat':
			return _List_fromArray(
				[$elm$time$Time$Sat, $elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri]);
		default:
			return _List_fromArray(
				[$elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat]);
	}
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePad = F3(
	function (firstWeekDay, monthStartDay, isFrontPad) {
		var listOfWeekday = $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateListOfWeekDay(firstWeekDay);
		var calculatedPadInt = function () {
			var _v0 = A2($elm_community$list_extra$List$Extra$elemIndex, monthStartDay, listOfWeekday);
			if (_v0.$ === 'Just') {
				var val = _v0.a;
				return isFrontPad ? (-val) : (7 - val);
			} else {
				return 0;
			}
		}();
		return calculatedPadInt;
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$splitIntoWeeks = F2(
	function (weeks, days) {
		splitIntoWeeks:
		while (true) {
			if ($elm$core$List$length(days) <= 7) {
				return A2($elm$core$List$cons, days, weeks);
			} else {
				var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, 7, days);
				var week = _v0.a;
				var restOfDays = _v0.b;
				var newWeeks = A2($elm$core$List$cons, week, weeks);
				var $temp$weeks = newWeeks,
					$temp$days = restOfDays;
				weeks = $temp$weeks;
				days = $temp$days;
				continue splitIntoWeeks;
			}
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthDataToPickerDays = F4(
	function (zone, isDisabledFn, allowableTimesFn, posixList) {
		return A2(
			$elm$core$List$map,
			function (posix) {
				return A4($mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix, zone, isDisabledFn, allowableTimesFn, posix);
			},
			posixList);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthData = F5(
	function (zone, isDisabledFn, firstWeekDay, allowableTimesFn, time) {
		var monthStart = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Month, zone, time);
		var monthStartDay = A2($elm$time$Time$toWeekday, zone, monthStart);
		var monthEnd = A4(
			$justinmimbs$time_extra$Time$Extra$add,
			$justinmimbs$time_extra$Time$Extra$Day,
			-1,
			zone,
			A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Month, 1, zone, monthStart));
		var monthEndDay = A2($elm$time$Time$toWeekday, zone, monthEnd);
		var frontPad = A5(
			$justinmimbs$time_extra$Time$Extra$range,
			$justinmimbs$time_extra$Time$Extra$Day,
			1,
			zone,
			A4(
				$justinmimbs$time_extra$Time$Extra$add,
				$justinmimbs$time_extra$Time$Extra$Day,
				A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePad, firstWeekDay, monthStartDay, true),
				zone,
				monthStart),
			monthStart);
		var endPad = A5(
			$justinmimbs$time_extra$Time$Extra$range,
			$justinmimbs$time_extra$Time$Extra$Day,
			1,
			zone,
			monthEnd,
			A4(
				$justinmimbs$time_extra$Time$Extra$add,
				$justinmimbs$time_extra$Time$Extra$Day,
				A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePad, firstWeekDay, monthEndDay, false),
				zone,
				monthEnd));
		return $elm$core$List$reverse(
			A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$splitIntoWeeks,
				_List_Nil,
				A4(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthDataToPickerDays,
					zone,
					isDisabledFn,
					allowableTimesFn,
					_Utils_ap(
						frontPad,
						_Utils_ap(
							A5($justinmimbs$time_extra$Time$Extra$range, $justinmimbs$time_extra$Time$Extra$Day, 1, zone, monthStart, monthEnd),
							endPad)))));
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$SetHoveredDay = function (a) {
	return {$: 'SetHoveredDay', a: a};
};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$ClearHoveredDay = {$: 'ClearHoveredDay'};
var $rtfeldman$elm_css$Css$Structure$PseudoElement = function (a) {
	return {$: 'PseudoElement', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 'WithPseudoElement', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(
		$rtfeldman$elm_css$Css$Structure$PseudoElement(element));
};
var $rtfeldman$elm_css$Css$after = $rtfeldman$elm_css$Css$pseudoElement('after');
var $rtfeldman$elm_css$Css$block = {value: 'block', display: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$hidden = {value: 'hidden', overflow: $rtfeldman$elm_css$Css$Structure$Compatible, visibility: $rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$visibility = $rtfeldman$elm_css$Css$prop1('visibility');
var $rtfeldman$elm_css$Css$transparent = {color: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'transparent'};
var $rtfeldman$elm_css$Css$currentColor = {color: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'currentColor'};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$dayStyles = function (theme) {
	return {
		today: _List_fromArray(
			[
				A3($rtfeldman$elm_css$Css$border3, theme.borderWidth, $rtfeldman$elm_css$Css$solid, theme.color.text.disabled)
			]),
		common: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$height(theme.size.day),
				$rtfeldman$elm_css$Css$width(theme.size.day),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$rtfeldman$elm_css$Css$fontSize(theme.fontSize.xs),
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
				$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$padding(
				$rtfeldman$elm_css$Css$px(0)),
				$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$colorsTransition(theme),
				A3($rtfeldman$elm_css$Css$border3, theme.borderWidth, $rtfeldman$elm_css$Css$solid, $rtfeldman$elm_css$Css$transparent),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor(theme.color.action.hover)
					])),
				$rtfeldman$elm_css$Css$borderRadius(theme.borderRadius.lg),
				$rtfeldman$elm_css$Css$backgroundColor(theme.color.background.container)
			]),
		hidden: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden)
			]),
		picked: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$backgroundColor(theme.color.primary.main),
				$rtfeldman$elm_css$Css$color(theme.color.primary.contrastText),
				$rtfeldman$elm_css$Css$borderRadius(theme.borderRadius.lg),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor(theme.color.primary.main),
						$rtfeldman$elm_css$Css$color(theme.color.primary.contrastText)
					]))
			]),
		disabled: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none),
				A2($rtfeldman$elm_css$Css$property, 'filter', 'grayscale(1)'),
				$rtfeldman$elm_css$Css$color(theme.color.text.disabled),
				$rtfeldman$elm_css$Css$after(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$width(theme.fontSize.xs),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(1)),
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$currentColor),
						A2($rtfeldman$elm_css$Css$property, 'content', '\u0027\u0027'),
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block)
					]))
			])
	};
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$styleList = function (list) {
	return $rtfeldman$elm_css$Css$batch(
		A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$first,
			A2($elm$core$List$filter, $elm$core$Tuple$second, list)));
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationDayStyles = F6(
	function (theme, isHidden, isDisabled, isPicked, isToday, isBetween) {
		var _v0 = $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$dayStyles(theme);
		var hidden = _v0.hidden;
		var disabled = _v0.disabled;
		var picked = _v0.picked;
		var today = _v0.today;
		var common = _v0.common;
		var between = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$backgroundColor(theme.color.primary.light),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(0))
			]);
		return $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$batch(common),
					$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$styleList(
					_List_fromArray(
						[
							_Utils_Tuple2(today, isToday),
							_Utils_Tuple2(between, isBetween),
							_Utils_Tuple2(picked, isPicked),
							_Utils_Tuple2(disabled, isDisabled),
							_Utils_Tuple2(hidden, isHidden)
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOut = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewDay = F2(
	function (theme, _v0) {
		var day = _v0.day;
		var dayProps = _v0.dayProps;
		var zone = _v0.zone;
		var _v1 = dayProps.dayStylesFn(day);
		var styles = _v1.a;
		var classes = _v1.b;
		var dayParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, day.start);
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(day.disabled),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[styles])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					dayProps.onDayClickMsg(day)),
					$rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
					dayProps.onDayMouseOverMsg(day)),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(classes)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(dayParts.day))
				]));
	});
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekNumber;
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarWeek = F2(
	function (theme, _v0) {
		var dayProps = _v0.dayProps;
		var showCalendarWeekNumbers = _v0.showCalendarWeekNumbers;
		var zone = _v0.zone;
		var week = _v0.week;
		var firstDateOfWeek = A2(
			$elm$core$Maybe$map,
			function (day) {
				return A2($justinmimbs$date$Date$fromPosix, zone, day.start);
			},
			$elm$core$List$head(week));
		var dateWeekNumber = function () {
			if (firstDateOfWeek.$ === 'Just') {
				var date = firstDateOfWeek.a;
				return $elm$core$String$fromInt(
					$justinmimbs$date$Date$weekNumber(date));
			} else {
				return '';
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$rtfeldman$elm_css$Css$displayFlex])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-week'))
				]),
			A2(
				$elm$core$List$cons,
				showCalendarWeekNumbers ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(theme.size.day),
									$rtfeldman$elm_css$Css$height(theme.size.day),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$fontSize(theme.fontSize.xs),
									$rtfeldman$elm_css$Css$color(theme.color.text.secondary),
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0.5))
								])),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-week-number'))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(dateWeekNumber)
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$List$map,
					function (day) {
						return A2(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewDay,
							theme,
							{day: day, zone: zone, dayProps: dayProps});
					},
					week)));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarMonth = F2(
	function (theme, _v0) {
		var zone = _v0.zone;
		var showCalendarWeekNumbers = _v0.showCalendarWeekNumbers;
		var dayProps = _v0.dayProps;
		var onMouseOutMsg = _v0.onMouseOutMsg;
		var weeks = _v0.weeks;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onMouseOut(onMouseOutMsg),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-month'))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									A2($rtfeldman$elm_css$Css$property, 'gap', '2px')
								]))
						]),
					A2(
						$elm$core$List$map,
						function (week) {
							return A2(
								$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarWeek,
								theme,
								{week: week, zone: zone, dayProps: dayProps, showCalendarWeekNumbers: showCalendarWeekNumbers});
						},
						weeks))
				]));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isDayBetweenDates = F3(
	function (day, dateOne, dateTwo) {
		return ((_Utils_cmp(
			$elm$time$Time$posixToMillis(dateOne.start),
			$elm$time$Time$posixToMillis(day.end)) > 0) && (_Utils_cmp(
			$elm$time$Time$posixToMillis(day.start),
			$elm$time$Time$posixToMillis(dateTwo.end)) > 0)) || ((_Utils_cmp(
			$elm$time$Time$posixToMillis(dateOne.end),
			$elm$time$Time$posixToMillis(day.start)) < 0) && (_Utils_cmp(
			$elm$time$Time$posixToMillis(day.end),
			$elm$time$Time$posixToMillis(dateTwo.start)) < 0));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$dayPickedOrBetween = F4(
	function (zone, day, hovered, _v0) {
		var startSelectionTuple = _v0.a;
		var endSelectionTuple = _v0.b;
		var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
		if (_v1.a.$ === 'Nothing') {
			if (_v1.b.$ === 'Nothing') {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				return _Utils_Tuple2(false, false);
			} else {
				var _v6 = _v1.a;
				var _v7 = _v1.b.a;
				var endPickerDay = _v7.a;
				var between = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (h) {
							return A3($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isDayBetweenDates, day, endPickerDay, h);
						},
						hovered));
				return _Utils_Tuple2(
					_Utils_eq(day, endPickerDay),
					between);
			}
		} else {
			if (_v1.b.$ === 'Nothing') {
				var _v4 = _v1.a.a;
				var startPickerDay = _v4.a;
				var _v5 = _v1.b;
				var between = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (h) {
							return A3($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isDayBetweenDates, day, startPickerDay, h);
						},
						hovered));
				return _Utils_Tuple2(
					_Utils_eq(day, startPickerDay),
					between);
			} else {
				var _v8 = _v1.a.a;
				var startPickerDay = _v8.a;
				var _v9 = _v1.b.a;
				var endPickerDay = _v9.a;
				return _Utils_Tuple2(
					_Utils_eq(day, startPickerDay) || _Utils_eq(day, endPickerDay),
					A3($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isDayBetweenDates, day, startPickerDay, endPickerDay));
			}
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classList = function (list) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($elm$core$List$filter, $elm$core$Tuple$second, list)));
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$dayClasses = function (theme) {
	return {
		today: A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'today'),
		common: A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-day'),
		hidden: A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'hidden'),
		picked: A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'picked'),
		disabled: A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'disabled')
	};
};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationDayClasses = F6(
	function (theme, isHidden, isDisabled, isPicked, isToday, isBetween) {
		var _v0 = $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$dayClasses(theme);
		var hidden = _v0.hidden;
		var disabled = _v0.disabled;
		var picked = _v0.picked;
		var today = _v0.today;
		var common = _v0.common;
		return $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classList(
			_List_fromArray(
				[
					_Utils_Tuple2(common, true),
					_Utils_Tuple2(today, isToday),
					_Utils_Tuple2(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'between'),
					isBetween),
					_Utils_Tuple2(picked, isPicked),
					_Utils_Tuple2(disabled, isDisabled),
					_Utils_Tuple2(hidden, isHidden)
				]));
	});
var $rtfeldman$elm_css$Css$bold = {value: 'bold', fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$NextNav = {$: 'NextNav'};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$PreviousNav = {$: 'PreviousNav'};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewHeaderDay = F3(
	function (theme, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$width(theme.size.day),
								$rtfeldman$elm_css$Css$height(theme.size.day)
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('calendar-header-day')
					]),
				attributes),
			children);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewWeekHeader = F2(
	function (theme, _v0) {
		var showCalendarWeekNumbers = _v0.showCalendarWeekNumbers;
		var firstWeekDay = _v0.firstWeekDay;
		var formattedDay = _v0.formattedDay;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$color(theme.color.text.secondary),
							$rtfeldman$elm_css$Css$fontSize(theme.fontSize.xxs),
							$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-week'))
				]),
			A2(
				$elm$core$List$cons,
				showCalendarWeekNumbers ? A3(
					$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewHeaderDay,
					theme,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-day-week-number'))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('#')
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$List$map,
					function (day) {
						return A3(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewHeaderDay,
							theme,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									formattedDay(day))
								]));
					},
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateListOfWeekDay(firstWeekDay))));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$YearScale = {$: 'YearScale'};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$MonthScale = {$: 'MonthScale'};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronLeft = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevron-left',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('15 18 9 12 15 6')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronRight = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevron-right',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('9 18 15 12 9 6')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsLeft = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevrons-left',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('11 17 6 12 11 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('18 17 13 12 18 7')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsRight = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevrons-right',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('13 17 18 12 13 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('6 17 11 12 6 7')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$SecondaryIconButton = {$: 'SecondaryIconButton'};
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewNavigationButton = F2(
	function (theme, _v0) {
		var onClickMsg = _v0.onClickMsg;
		var scale = _v0.scale;
		var direction = _v0.direction;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(direction, scale);
			if (_v2.a.$ === 'PreviousNav') {
				if (_v2.b.$ === 'YearScale') {
					var _v3 = _v2.a;
					var _v4 = _v2.b;
					return _Utils_Tuple2($mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsLeft, 'previous-year');
				} else {
					var _v5 = _v2.a;
					var _v6 = _v2.b;
					return _Utils_Tuple2($mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronLeft, 'previous-month');
				}
			} else {
				if (_v2.b.$ === 'YearScale') {
					var _v7 = _v2.a;
					var _v8 = _v2.b;
					return _Utils_Tuple2($mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsRight, 'next-year');
				} else {
					var _v9 = _v2.a;
					var _v10 = _v2.b;
					return _Utils_Tuple2($mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronRight, 'next-month');
				}
			}
		}();
		var icon = _v1.a;
		var identifier = _v1.b;
		var attrs = function () {
			if (onClickMsg.$ === 'Just') {
				var msg = onClickMsg.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
					]);
			} else {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden)
							]))
					]);
			}
		}();
		return A3(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewIconButton,
			theme,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-navigation-button')),
						$rtfeldman$elm_css$Html$Styled$Attributes$id(identifier)
					]),
				attrs),
			{icon: icon, variant: $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$SecondaryIconButton});
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarHeaderNavigation = F3(
	function (theme, attributes, _v0) {
		var monthMsg = _v0.monthMsg;
		var yearMsg = _v0.yearMsg;
		var direction = _v0.direction;
		var monthButton = A2(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewNavigationButton,
			theme,
			{scale: $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$MonthScale, direction: direction, onClickMsg: monthMsg});
		var yearButton = A2(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewNavigationButton,
			theme,
			{scale: $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$YearScale, direction: direction, onClickMsg: yearMsg});
		var children = function () {
			if (direction.$ === 'PreviousNav') {
				return _List_fromArray(
					[yearButton, monthButton]);
			} else {
				return _List_fromArray(
					[monthButton, yearButton]);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-navigation')),
				attributes),
			children);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarHeader = F2(
	function (theme, _v0) {
		var showCalendarWeekNumbers = _v0.showCalendarWeekNumbers;
		var firstWeekDay = _v0.firstWeekDay;
		var formattedDay = _v0.formattedDay;
		var yearText = _v0.yearText;
		var monthText = _v0.monthText;
		var nextMonthMsg = _v0.nextMonthMsg;
		var nextYearMsg = _v0.nextYearMsg;
		var previousMonthMsg = _v0.previousMonthMsg;
		var previousYearMsg = _v0.previousYearMsg;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							A2($rtfeldman$elm_css$Css$property, 'gap', '0.5rem')
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header'))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
								])),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-row'))
						]),
					_List_fromArray(
						[
							A3(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarHeaderNavigation,
							theme,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-navigation--previous'))
								]),
							{yearMsg: previousYearMsg, monthMsg: previousMonthMsg, direction: $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$PreviousNav}),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
											$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
											A2($rtfeldman$elm_css$Css$property, 'user-select', 'none')
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$class('calendar-header-text')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class(
													A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-text-month')),
													$rtfeldman$elm_css$Html$Styled$Attributes$id('month')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(monthText)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(' ')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class(
													A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-text-year')),
													$rtfeldman$elm_css$Html$Styled$Attributes$id('year')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(yearText)
												]))
										]))
								])),
							A3(
							$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarHeaderNavigation,
							theme,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-header-navigation--next'))
								]),
							{yearMsg: nextYearMsg, monthMsg: nextMonthMsg, direction: $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$NextNav})
						])),
					A2(
					$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewWeekHeader,
					theme,
					{firstWeekDay: firstWeekDay, formattedDay: formattedDay, showCalendarWeekNumbers: showCalendarWeekNumbers})
				]));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarContainer = F3(
	function (theme, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$rem(1))
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'calendar-container'))
					]),
				attributes),
			children);
	});
var $rtfeldman$elm_css$Css$borderTopLeftRadius = $rtfeldman$elm_css$Css$prop1('border-top-left-radius');
var $rtfeldman$elm_css$Css$borderTopRightRadius = $rtfeldman$elm_css$Css$prop1('border-top-right-radius');
var $rtfeldman$elm_css$Css$borderBottomLeftRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
var $rtfeldman$elm_css$Css$borderBottomRightRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationStartOrEndStyles = F3(
	function (theme, isStart, isEnd) {
		var startStyles = $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderTopRightRadius(
					$rtfeldman$elm_css$Css$px(0)),
					$rtfeldman$elm_css$Css$borderBottomRightRadius(
					$rtfeldman$elm_css$Css$px(0))
				]));
		var endStyles = $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderTopLeftRadius(
					$rtfeldman$elm_css$Css$px(0)),
					$rtfeldman$elm_css$Css$borderBottomLeftRadius(
					$rtfeldman$elm_css$Css$px(0))
				]));
		return (isStart && (!isEnd)) ? startStyles : ((isEnd && (!isStart)) ? endStyles : $rtfeldman$elm_css$Css$batch(_List_Nil));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationStartOrEndClasses = F3(
	function (theme, isStart, isEnd) {
		return (isStart && (!isEnd)) ? A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'start') : ((isEnd && (!isStart)) ? A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'end') : '');
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isPickedDaySelectionTuple = F2(
	function (day, selectionTuple) {
		if (selectionTuple.$ === 'Just') {
			var _v1 = selectionTuple.a;
			var pickerDay = _v1.a;
			return _Utils_eq(pickerDay, day);
		} else {
			return false;
		}
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$viewCalendar = F5(
	function (attrs, settings, model, viewTime, side) {
		var allowedTimesOfDayFn = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.allowedTimesOfDay;
			},
			$mercurymedia$elm_datetime_picker$DatePicker$Settings$getTimePickerSettings(settings));
		var _v0 = function () {
			if (side.$ === 'Left') {
				return _Utils_Tuple2(
					_Utils_Tuple2(
						$elm$core$Maybe$Just(
							model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$PrevYear)),
						$elm$core$Maybe$Just(
							model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$PrevMonth))),
					_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
			} else {
				return _Utils_Tuple2(
					_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					_Utils_Tuple2(
						$elm$core$Maybe$Just(
							model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$NextYear)),
						$elm$core$Maybe$Just(
							model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$NextMonth))));
			}
		}();
		var _v1 = _v0.a;
		var previousYearMsg = _v1.a;
		var previousMonthMsg = _v1.b;
		var _v2 = _v0.b;
		var nextYearMsg = _v2.a;
		var nextMonthMsg = _v2.b;
		var currentMonth = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.zone, viewTime).month;
		var dayStylesFn = function (day) {
			var startOrEndClasses = A3(
				$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationStartOrEndClasses,
				settings.theme,
				A2($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isPickedDaySelectionTuple, day, model.startSelectionTuple),
				A2($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isPickedDaySelectionTuple, day, model.endSelectionTuple));
			var startOrEndStyles = A3(
				$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationStartOrEndStyles,
				settings.theme,
				A2($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isPickedDaySelectionTuple, day, model.startSelectionTuple),
				A2($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$isPickedDaySelectionTuple, day, model.endSelectionTuple));
			var _v4 = A4(
				$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$dayPickedOrBetween,
				settings.zone,
				day,
				model.hovered,
				_Utils_Tuple2(model.startSelectionTuple, model.endSelectionTuple));
			var isPicked = _v4.a;
			var isBetween = _v4.b;
			var isFocused = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (fday) {
						return _Utils_eq(
							A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, fday),
							day);
					},
					settings.focusedDate));
			var dayParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.zone, day.start);
			var dayStyles = A6(
				$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationDayStyles,
				settings.theme,
				!_Utils_eq(dayParts.month, currentMonth),
				day.disabled,
				isPicked,
				isFocused,
				isBetween);
			var dayClasses = A6(
				$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$durationDayClasses,
				settings.theme,
				!_Utils_eq(dayParts.month, currentMonth),
				day.disabled,
				isPicked,
				isFocused,
				isBetween);
			var classes = dayClasses + (' ' + startOrEndClasses);
			return _Utils_Tuple2(
				$rtfeldman$elm_css$Css$batch(
					_List_fromArray(
						[dayStyles, startOrEndStyles])),
				classes);
		};
		var monthName = settings.formattedMonth(
			A2($elm$time$Time$toMonth, settings.zone, viewTime));
		var weeks = A5($mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthData, settings.zone, settings.isDayDisabled, settings.firstWeekDay, allowedTimesOfDayFn, viewTime);
		var year = $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, settings.zone, viewTime));
		return A3(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarContainer,
			settings.theme,
			attrs,
			_List_fromArray(
				[
					A2(
					$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarHeader,
					settings.theme,
					{yearText: year, monthText: monthName, nextYearMsg: nextYearMsg, firstWeekDay: settings.firstWeekDay, formattedDay: settings.formattedDay, nextMonthMsg: nextMonthMsg, previousYearMsg: previousYearMsg, previousMonthMsg: previousMonthMsg, showCalendarWeekNumbers: settings.showCalendarWeekNumbers}),
					A2(
					$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewCalendarMonth,
					settings.theme,
					{
						zone: settings.zone,
						weeks: weeks,
						dayProps: {
							dayStylesFn: dayStylesFn,
							onDayClickMsg: function (day) {
								return model.internalMsg(
									$mercurymedia$elm_datetime_picker$DurationDatePicker$SetRange(day));
							},
							onDayMouseOverMsg: function (day) {
								return model.internalMsg(
									$mercurymedia$elm_datetime_picker$DurationDatePicker$SetHoveredDay(day));
							}
						},
						onMouseOutMsg: model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$ClearHoveredDay),
						showCalendarWeekNumbers: settings.showCalendarWeekNumbers
					})
				]));
	});
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Css$prop5 = F6(
	function (key, argA, argB, argC, argD, argE) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.value + (' ' + (argB.value + (' ' + (argC.value + (' ' + (argD.value + (' ' + argE.value))))))));
	});
var $rtfeldman$elm_css$Css$boxShadow5 = $rtfeldman$elm_css$Css$prop5('box-shadow');
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewContainer = F3(
	function (theme, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$backgroundColor(theme.color.background.container),
								$rtfeldman$elm_css$Css$zIndex(
								$rtfeldman$elm_css$Css$int(theme.zIndex)),
								$rtfeldman$elm_css$Css$color(theme.color.text.primary),
								$rtfeldman$elm_css$Css$fontSize(theme.fontSize.base),
								A5($rtfeldman$elm_css$Css$boxShadow5, theme.boxShadow.offsetX, theme.boxShadow.offsetY, theme.boxShadow.blurRadius, theme.boxShadow.spreadRadius, theme.boxShadow.color),
								$rtfeldman$elm_css$Css$borderRadius(theme.borderRadius.lg),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute)
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'container')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('elm-css')
					]),
				attributes),
			children);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewPickerContainer = F3(
	function (theme, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$flexShrink(
								$rtfeldman$elm_css$Css$num(0)),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
							])),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, theme.classNamePrefix, 'picker-container'))
					]),
				attributes),
			children);
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$viewPicker = F5(
	function (attributes, settings, timePickerVisible, baseDay, model) {
		var rightViewTime = A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Month, model.viewOffset + 1, settings.zone, baseDay.start);
		var leftViewTime = A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Month, model.viewOffset, settings.zone, baseDay.start);
		return A3(
			$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewContainer,
			settings.theme,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id(settings.id),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, settings.theme.classNamePrefix, 'duration'))
					]),
				attributes),
			_List_fromArray(
				[
					A2($mercurymedia$elm_datetime_picker$DurationDatePicker$viewPresets, settings, model),
					A3(
					$mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$viewPickerContainer,
					settings.theme,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A5(
									$mercurymedia$elm_datetime_picker$DurationDatePicker$viewCalendar,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, settings.theme.classNamePrefix, 'left-calendar'))
										]),
									settings,
									model,
									leftViewTime,
									$mercurymedia$elm_datetime_picker$DurationDatePicker$Left),
									A5(
									$mercurymedia$elm_datetime_picker$DurationDatePicker$viewCalendar,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											A2($mercurymedia$elm_datetime_picker$DatePicker$ViewComponents$classPrefix, settings.theme.classNamePrefix, 'right-calendar'))
										]),
									settings,
									model,
									rightViewTime,
									$mercurymedia$elm_datetime_picker$DurationDatePicker$Right)
								])),
							A4($mercurymedia$elm_datetime_picker$DurationDatePicker$viewFooter, settings, timePickerVisible, baseDay, model)
						]))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateCoordinates = function (_v0) {
	var pickerHeight = _v0.pickerHeight;
	var pickerWidth = _v0.pickerWidth;
	var triggerHeight = _v0.triggerHeight;
	var triggerWidth = _v0.triggerWidth;
	var triggerY = _v0.triggerY;
	var triggerX = _v0.triggerX;
	var viewPortHeight = _v0.viewPortHeight;
	var viewPortWidth = _v0.viewPortWidth;
	var alignCenterOfTrigger = (triggerX + (triggerWidth / 2)) - (pickerWidth / 2);
	var alignRightOfTrigger = (triggerX + triggerWidth) - pickerWidth;
	var alignLeftOfTrigger = triggerX;
	var minOffset = 10;
	var posY = (_Utils_cmp((triggerY + triggerHeight) + pickerHeight, viewPortHeight) > 0) ? (triggerY - pickerHeight) : (triggerY + triggerHeight);
	var posX = (_Utils_cmp(triggerX + pickerWidth, viewPortWidth - minOffset) < 1) ? alignLeftOfTrigger : ((_Utils_cmp(alignRightOfTrigger, minOffset) > -1) ? alignRightOfTrigger : ((_Utils_cmp(alignCenterOfTrigger, minOffset) > -1) ? alignCenterOfTrigger : minOffset));
	return {x: posX, y: posY};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePositionStyles = function (_v0) {
	var pickerEl = _v0.pickerEl;
	var triggerEl = _v0.triggerEl;
	var _v1 = _Utils_Tuple2(triggerEl.viewport.width, triggerEl.viewport.height);
	var viewPortWidth = _v1.a;
	var viewPortHeight = _v1.b;
	var _v2 = _Utils_Tuple2(triggerEl.element.width, triggerEl.element.height);
	var triggerWidth = _v2.a;
	var triggerHeight = _v2.b;
	var _v3 = _Utils_Tuple2(pickerEl.element.width, pickerEl.element.height);
	var pickerWidth = _v3.a;
	var pickerHeight = _v3.b;
	var _v4 = _Utils_Tuple2(triggerEl.element.x, triggerEl.element.y);
	var triggerX = _v4.a;
	var triggerY = _v4.b;
	var coords = $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateCoordinates(
		{triggerX: triggerX, triggerY: triggerY, pickerWidth: pickerWidth, pickerHeight: pickerHeight, triggerWidth: triggerWidth, triggerHeight: triggerHeight, viewPortWidth: viewPortWidth, viewPortHeight: viewPortHeight});
	return _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'fixed'),
			A2(
			$rtfeldman$elm_css$Html$Styled$Attributes$style,
			'left',
			$elm$core$String$fromFloat(coords.x) + 'px'),
			A2(
			$rtfeldman$elm_css$Html$Styled$Attributes$style,
			'top',
			$elm$core$String$fromFloat(coords.y) + 'px')
		]);
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$outsideHierarchyStyles = function (_v0) {
	var pickerDomElement = _v0.pickerDomElement;
	var triggerDomElement = _v0.triggerDomElement;
	var _v1 = _Utils_Tuple2(triggerDomElement.element, pickerDomElement.element);
	if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
		var triggerElement = _v1.a.a;
		var pickerElement = _v1.b.a;
		return $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePositionStyles(
			{pickerEl: pickerElement, triggerEl: triggerElement});
	} else {
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'visibility', 'hidden')
			]);
	}
};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$viewStyled = F2(
	function (settings, _v0) {
		var model = _v0.a;
		var _v1 = _Utils_Tuple2(model.domLocation, model.status);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 'InsideHierarchy') {
				if (_v1.b.$ === 'Open') {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					var timePickerVisible = _v3.a;
					var baseDay = _v3.b;
					return A5($mercurymedia$elm_datetime_picker$DurationDatePicker$viewPicker, _List_Nil, settings, timePickerVisible, baseDay, model);
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b.$ === 'Open') {
					var elements = _v1.a.a;
					var _v4 = _v1.b;
					var timePickerVisible = _v4.a;
					var baseDay = _v4.b;
					return A5(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$viewPicker,
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$outsideHierarchyStyles(elements),
						settings,
						timePickerVisible,
						baseDay,
						model);
				} else {
					break _v1$2;
				}
			}
		}
		return $rtfeldman$elm_css$Html$Styled$text('');
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$view = F2(
	function (settings, _v0) {
		var model = _v0.a;
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				$mercurymedia$elm_datetime_picker$DurationDatePicker$viewStyled,
				settings,
				$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(model)));
	});
var $author$project$Pages$Fleet_$OnTime$Logout = {$: 'Logout'};
var $author$project$Time$RelativeDateRange$LastWeek = {$: 'LastWeek'};
var $author$project$Time$RelativeDateRange$toString = function (r) {
	switch (r.$) {
		case 'OneHour':
			return '1 Hour';
		case 'TwoHours':
			return '2 Hours';
		case 'Today':
			return 'Today';
		case 'Yesterday':
			return 'Yesterday';
		case 'ThisWeek':
			return 'This Week';
		case 'LastWeek':
			return 'Last Week';
		case 'ThisMonth':
			return 'This Month';
		case 'LastMonth':
			return 'Last Month';
		case 'ThisQuarter':
			return 'This Quarter';
		case 'LastQuarter':
			return 'Last Quarter';
		case 'ThisYear':
			return 'This Year';
		default:
			return 'Last Year';
	}
};
var $justinmimbs$time_extra$Time$Extra$Week = {$: 'Week'};
var $justinmimbs$time_extra$Time$Extra$Year = {$: 'Year'};
var $justinmimbs$time_extra$Time$Extra$Minute = {$: 'Minute'};
var $justinmimbs$time_extra$Time$Extra$Quarter = {$: 'Quarter'};
var $author$project$Time$RelativeDateRange$toStartEnd = F3(
	function (now, zone, range) {
		var startOfWeek = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Week, zone, now);
		var startOfDay = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, zone, now);
		switch (range.$) {
			case 'OneHour':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, -1, zone, now),
					now);
			case 'TwoHours':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, -2, zone, now),
					now);
			case 'Today':
				return _Utils_Tuple2(startOfDay, now);
			case 'Yesterday':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Day, -1, zone, startOfDay),
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Minute, -1, zone, startOfDay));
			case 'ThisWeek':
				return _Utils_Tuple2(startOfWeek, now);
			case 'LastWeek':
				return _Utils_Tuple2(
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Week, -1, zone, startOfWeek),
					A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Minute, -1, zone, startOfWeek));
			case 'ThisMonth':
				return _Utils_Tuple2(
					A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Month, zone, now),
					now);
			case 'LastMonth':
				return _Utils_Tuple2(
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						$justinmimbs$time_extra$Time$Extra$Month,
						-1,
						zone,
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Month, zone, now)),
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						$justinmimbs$time_extra$Time$Extra$Minute,
						-1,
						zone,
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Month, zone, now)));
			case 'ThisQuarter':
				return _Utils_Tuple2(
					A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Quarter, zone, now),
					now);
			case 'LastQuarter':
				return _Utils_Tuple2(
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						$justinmimbs$time_extra$Time$Extra$Quarter,
						-1,
						zone,
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Quarter, zone, now)),
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						$justinmimbs$time_extra$Time$Extra$Minute,
						-1,
						zone,
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Quarter, zone, now)));
			case 'ThisYear':
				return _Utils_Tuple2(
					A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Year, zone, now),
					now);
			default:
				return _Utils_Tuple2(
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						$justinmimbs$time_extra$Time$Extra$Year,
						-1,
						zone,
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Year, zone, now)),
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						$justinmimbs$time_extra$Time$Extra$Minute,
						-1,
						zone,
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Year, zone, now)));
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$PresetRange = function (a) {
	return {$: 'PresetRange', a: a};
};
var $author$project$Time$RelativeDateRange$toPreset = F3(
	function (now, zone, range) {
		var _v0 = A3($author$project$Time$RelativeDateRange$toStartEnd, now, zone, range);
		var start = _v0.a;
		var end = _v0.b;
		return $mercurymedia$elm_datetime_picker$DatePicker$Settings$PresetRange(
			{
				range: {end: end, start: start},
				title: $author$project$Time$RelativeDateRange$toString(range)
			});
	});
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2(
		$elm$core$String$cons,
		_Utils_chr('#'),
		str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		red: 0,
		blue: 0,
		alpha: 1,
		color: $rtfeldman$elm_css$Css$Structure$Compatible,
		green: 0,
		value: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				red: red,
				blue: blue,
				alpha: alpha / 255,
				color: $rtfeldman$elm_css$Css$Structure$Compatible,
				green: green,
				value: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2(
						_Utils_chr('f'),
						_Utils_chr('f')));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2(
									_Utils_chr('f'),
									_Utils_chr('f')));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			red: r,
			blue: b,
			alpha: alpha,
			color: $rtfeldman$elm_css$Css$Structure$Compatible,
			green: g,
			value: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultTheme = {
	size: {
		day: $rtfeldman$elm_css$Css$px(36),
		iconButton: $rtfeldman$elm_css$Css$px(32),
		presetsContainer: $rtfeldman$elm_css$Css$px(150)
	},
	color: {
		text: {
			primary: $rtfeldman$elm_css$Css$hex('22292f'),
			disabled: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.25),
			secondary: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.5)
		},
		action: {
			hover: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.08)
		},
		border: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.1),
		primary: {
			main: $rtfeldman$elm_css$Css$hex('3490dc'),
			light: A4($rtfeldman$elm_css$Css$rgba, 52, 144, 220, 0.1),
			contrastText: $rtfeldman$elm_css$Css$hex('ffffff')
		},
		background: {
			footer: $rtfeldman$elm_css$Css$hex('ffffff'),
			presets: $rtfeldman$elm_css$Css$hex('ffffff'),
			container: $rtfeldman$elm_css$Css$hex('ffffff')
		}
	},
	zIndex: 100,
	fontSize: {
		sm: $rtfeldman$elm_css$Css$px(14),
		xs: $rtfeldman$elm_css$Css$px(12),
		xxs: $rtfeldman$elm_css$Css$px(10),
		base: $rtfeldman$elm_css$Css$px(16)
	},
	boxShadow: {
		color: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.25),
		offsetX: $rtfeldman$elm_css$Css$px(0),
		offsetY: $rtfeldman$elm_css$Css$px(0),
		blurRadius: $rtfeldman$elm_css$Css$px(5),
		spreadRadius: $rtfeldman$elm_css$Css$px(0)
	},
	transition: {duration: 300},
	borderWidth: $rtfeldman$elm_css$Css$px(1),
	borderRadius: {
		lg: $rtfeldman$elm_css$Css$px(6),
		base: $rtfeldman$elm_css$Css$px(3)
	},
	classNamePrefix: 'elm-datetimepicker'
};
var $author$project$DatePicker$Extra$neboTheme = _Utils_update(
	$mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultTheme,
	{
		size: {
			day: $rtfeldman$elm_css$Css$px(28),
			iconButton: $rtfeldman$elm_css$Css$px(28),
			presetsContainer: $rtfeldman$elm_css$Css$px(150)
		},
		color: {
			text: {
				primary: $rtfeldman$elm_css$Css$hex('102A43'),
				disabled: $rtfeldman$elm_css$Css$hex('486581'),
				secondary: $rtfeldman$elm_css$Css$hex('486581')
			},
			action: {
				hover: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.08)
			},
			border: A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.1),
			primary: {
				main: $rtfeldman$elm_css$Css$hex('102A43'),
				light: $rtfeldman$elm_css$Css$hex('D9E2EC'),
				contrastText: $rtfeldman$elm_css$Css$hex('ffffff')
			},
			background: {
				footer: $rtfeldman$elm_css$Css$hex('ffffff'),
				presets: $rtfeldman$elm_css$Css$hex('ffffff'),
				container: $rtfeldman$elm_css$Css$hex('ffffff')
			}
		},
		fontSize: {
			sm: $rtfeldman$elm_css$Css$px(14),
			xs: $rtfeldman$elm_css$Css$px(14),
			xxs: $rtfeldman$elm_css$Css$px(12),
			base: $rtfeldman$elm_css$Css$px(14)
		},
		borderRadius: {
			lg: $rtfeldman$elm_css$Css$px(0),
			base: $rtfeldman$elm_css$Css$px(0)
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$NeverVisible = {$: 'NeverVisible'};
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$AlwaysVisible = function (a) {
	return {$: 'AlwaysVisible', a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$dayToNameString = function (day) {
	switch (day.$) {
		case 'Mon':
			return 'Mo';
		case 'Tue':
			return 'Tu';
		case 'Wed':
			return 'We';
		case 'Thu':
			return 'Th';
		case 'Fri':
			return 'Fr';
		case 'Sat':
			return 'Sa';
		default:
			return 'Su';
	}
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthToNameString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultTimePickerSettings = {
	timeStringFn: F2(
		function (_v0, _v1) {
			return '';
		}),
	allowedTimesOfDay: F2(
		function (_v2, _v3) {
			return {endHour: 23, endMinute: 59, startHour: 0, startMinute: 0};
		})
};
var $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultSettings = function (zone) {
	return {
		id: 'date-picker-component',
		zone: zone,
		theme: $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultTheme,
		presets: _List_Nil,
		focusedDate: $elm$core$Maybe$Nothing,
		dateStringFn: F2(
			function (_v0, _v1) {
				return '';
			}),
		firstWeekDay: $elm$time$Time$Mon,
		formattedDay: $mercurymedia$elm_datetime_picker$DatePicker$Utilities$dayToNameString,
		isDayDisabled: F2(
			function (_v2, _v3) {
				return false;
			}),
		formattedMonth: $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthToNameString,
		timePickerVisibility: $mercurymedia$elm_datetime_picker$DatePicker$Settings$AlwaysVisible($mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultTimePickerSettings),
		showCalendarWeekNumbers: false
	};
};
var $author$project$ISO8601$Extra$toFormattedDate = F3(
	function (locale, browserZone, dto) {
		return A4(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$format,
			$enkidatron$elm_cldr$Cldr$Format$DateTime$WithOptions(
				$author$project$ISO8601$Extra$addShortDate($enkidatron$elm_cldr$Cldr$Format$Options$defaultDateTimeOptions)),
			locale,
			browserZone,
			$jweir$elm_iso8601$ISO8601$toPosix(dto));
	});
var $author$project$Pages$Fleet_$OnTime$settings = function (model) {
	var s = $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultSettings(model.currentZone);
	return _Utils_update(
		s,
		{
			theme: $author$project$DatePicker$Extra$neboTheme,
			presets: A2(
				$elm$core$List$map,
				A2($author$project$Time$RelativeDateRange$toPreset, model.currentTime, model.currentZone),
				_List_fromArray(
					[$author$project$Time$RelativeDateRange$LastWeek])),
			dateStringFn: F2(
				function (z, p) {
					return A3(
						$author$project$ISO8601$Extra$toFormattedDate,
						model.locale,
						z,
						$jweir$elm_iso8601$ISO8601$fromPosix(p));
				}),
			isDayDisabled: F2(
				function (_v0, t) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(t),
						$elm$time$Time$posixToMillis(model.currentTime)) > 0;
				}),
			timePickerVisibility: $mercurymedia$elm_datetime_picker$DatePicker$Settings$NeverVisible
		});
};
var $author$project$Pages$Fleet_$OnTime$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$OnTime$OpenPicker = {$: 'OpenPicker'};
var $author$project$Pages$Fleet_$OnTime$DownloadCsv = {$: 'DownloadCsv'};
var $author$project$Pages$Fleet_$OnTime$FetchArrivals = {$: 'FetchArrivals'};
var $author$project$Pages$Fleet_$OnTime$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$ISO8601$Extra$toFormattedTime = F3(
	function (locale, browserZone, dto) {
		return A4(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$format,
			$enkidatron$elm_cldr$Cldr$Format$DateTime$WithOptions(
				$author$project$ISO8601$Extra$addShortTime($enkidatron$elm_cldr$Cldr$Format$Options$defaultDateTimeOptions)),
			locale,
			browserZone,
			$jweir$elm_iso8601$ISO8601$toPosix(dto));
	});
var $author$project$Pages$Fleet_$OnTime$view = F3(
	function (session, featureDropState, model) {
		var headerCell = F2(
			function (classes, field) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h2 ' + classes)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field)
						]));
			});
		var row = function (a) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3(
									$author$project$ISO8601$Extra$toFormattedDate,
									model.locale,
									model.currentZone,
									$jweir$elm_iso8601$ISO8601$fromPosix(a.departureTime)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(a.boatName)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(a.departureGeofence)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3(
									$author$project$ISO8601$Extra$toFormattedTime,
									model.locale,
									model.currentZone,
									$jweir$elm_iso8601$ISO8601$fromPosix(a.departureTime)))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(a.arrivalGeofence)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3(
									$author$project$ISO8601$Extra$toFormattedTime,
									model.locale,
									model.currentZone,
									$jweir$elm_iso8601$ISO8601$fromPosix(a.arrivalTime)))
							]))
					]));
		};
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(model.currentRoute),
					featureDropState,
					$author$project$Pages$Fleet_$OnTime$ChangelogAction,
					$author$project$Pages$Fleet_$OnTime$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reports | On Time Report')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column flex-lg-row align-items-center py-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('m-1')
									]),
								_List_fromArray(
									[
										A2(
										$mercurymedia$elm_datetime_picker$DurationDatePicker$view,
										$author$project$Pages$Fleet_$OnTime$settings(model),
										model.durationDatePicker),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('input-group input-group-sm flex-nowrap')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('input-group-text'),
														$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$OnTime$OpenPicker)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'No dates selected',
															A3(
																$elm$core$Maybe$map2,
																F2(
																	function (s, e) {
																		return A3($author$project$ISO8601$Extra$toFormattedDate, model.locale, model.currentZone, s) + (' to ' + A3($author$project$ISO8601$Extra$toFormattedDate, model.locale, model.currentZone, e));
																	}),
																model.startDate,
																model.endDate)))
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('btn btn-outline-secondary'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$OnTime$FetchArrivals)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Go')
													]))
											]))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex-grow-1')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$OnTime$DownloadCsv),
										$elm$html$Html$Attributes$class('btn btn-anchor text-secondary text-nowrap'),
										$elm$html$Html$Attributes$disabled(
										$elm$core$List$isEmpty(model.arrivals))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('me-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
										$elm$html$Html$text('Download CSV')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-responsive-md')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(headerCell, 'text-end', 'Date'),
														A2(headerCell, '', 'Vessel Name'),
														A2(headerCell, '', 'From'),
														A2(headerCell, 'text-end', 'Departure Time'),
														A2(headerCell, '', 'To'),
														A2(headerCell, 'text-end', 'Arrival Time')
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2($elm$core$List$map, row, model.arrivals))
									]))
							])),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$OnTime$CloseError)
					])),
			title: model.fleet.name + ' On Time Report'
		};
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2(
	function (encoder, rows) {
		if (encoder.$ === 'WithFieldNames') {
			var convert = encoder.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				F2(
					function (row, _v2) {
						var converted_ = _v2.a;
						var names = _v2.b;
						var convertedRow = convert(row);
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								$elm$core$Dict$fromList(convertedRow),
								converted_),
							A3(
								$elm$core$List$foldl,
								F2(
									function (_v3, _v4) {
										var name = _v3.a;
										var soFar = _v4.a;
										var column = _v4.b;
										return _Utils_Tuple2(
											A3(
												$elm$core$Dict$update,
												name,
												function (value) {
													if (value.$ === 'Just') {
														var columns = value.a;
														return $elm$core$Maybe$Just(
															A2($elm$core$List$cons, column, columns));
													} else {
														return $elm$core$Maybe$Just(
															_List_fromArray(
																[column]));
													}
												},
												soFar),
											column + 1);
									}),
								_Utils_Tuple2(names, 0),
								convertedRow).a);
					}),
				_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty),
				rows);
			var converted = _v1.a;
			var namePositions = _v1.b;
			var ordering = A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					$elm$core$Dict$toList(
						A2(
							$elm$core$Dict$map,
							F2(
								function (_v6, positions) {
									return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
								}),
							namePositions))));
			return A2(
				$elm$core$List$cons,
				ordering,
				A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$elm$core$List$map,
							function (field) {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, field, row));
							},
							ordering);
					},
					converted));
		} else {
			var convert = encoder.a;
			return A2($elm$core$List$map, convert, rows);
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2(
	function (fieldSeparator, value) {
		return (A2($elm$core$String$contains, '\u0022', value) || (A2($elm$core$String$contains, fieldSeparator, value) || (A2($elm$core$String$contains, '\u000D\u000A', value) || A2($elm$core$String$contains, '\u000A', value)))) ? ('\u0022' + (A3($elm$core$String$replace, '\u0022', '\u0022\u0022', value) + '\u0022')) : value;
	});
var $BrianHicks$elm_csv$Csv$Encode$encode = F2(
	function (_v0, items) {
		var fieldSeparator = _v0.fieldSeparator;
		var encoder = _v0.encoder;
		var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
		return A2(
			$elm$core$String$join,
			'\u000D\u000A',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$String$join(fieldSeparatorString),
					$elm$core$List$map(
						$BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))),
				A2($BrianHicks$elm_csv$Csv$Encode$encodeItems, encoder, items)));
	});
var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function (a) {
	return {$: 'WithFieldNames', a: a};
};
var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
var $author$project$Data$GeofenceArrival$csvEncode = F2(
	function (locale, zone) {
		return $BrianHicks$elm_csv$Csv$Encode$withFieldNames(
			function (l) {
				return _List_fromArray(
					[
						_Utils_Tuple2('Vessel Name', l.boatName),
						_Utils_Tuple2('From', l.departureGeofence),
						_Utils_Tuple2(
						'Departure Time',
						A3(
							$author$project$ISO8601$Extra$toFormattedTime,
							locale,
							zone,
							$jweir$elm_iso8601$ISO8601$fromPosix(l.departureTime))),
						_Utils_Tuple2('To', l.arrivalGeofence),
						_Utils_Tuple2(
						'Arrival Time',
						A3(
							$author$project$ISO8601$Extra$toFormattedTime,
							locale,
							zone,
							$jweir$elm_iso8601$ISO8601$fromPosix(l.arrivalTime)))
					]);
			});
	});
var $author$project$Data$GeofenceArrival$toCsv = F3(
	function (locale, zone, ls) {
		return A2(
			$BrianHicks$elm_csv$Csv$Encode$encode,
			{
				encoder: A2($author$project$Data$GeofenceArrival$csvEncode, locale, zone),
				fieldSeparator: _Utils_chr(',')
			},
			ls);
	});
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$Open = F2(
	function (a, b) {
		return {$: 'Open', a: a, b: b};
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay = F3(
	function (zone, hour, timeToUpdate) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);
		var newParts = _Utils_update(
			parts,
			{hour: hour});
		return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay = F3(
	function (zone, minute, timeToUpdate) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);
		var newParts = _Utils_update(
			parts,
			{minute: minute});
		return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$doDaysMatch = F3(
	function (zone, dateTimeOne, dateTimeTwo) {
		var twoParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, dateTimeTwo);
		var oneParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, dateTimeOne);
		return _Utils_eq(oneParts.day, twoParts.day) && (_Utils_eq(oneParts.month, twoParts.month) && _Utils_eq(oneParts.year, twoParts.year));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault = F3(
	function (zone, _default, _v0) {
		var selectionPickerDay = _v0.a;
		var selection = _v0.b;
		var selectionDayEqualsPickerDay = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$doDaysMatch, zone, selection, selectionPickerDay.start);
		return (A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries, zone, selectionPickerDay, selection) && ((!selectionPickerDay.disabled) && selectionDayEqualsPickerDay)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(selectionPickerDay, selection)) : _default;
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$validDurationSelectionOrDefault = F2(
	function (_v0, _v1) {
		var previousStart = _v0.a;
		var previousEnd = _v0.b;
		var newStart = _v1.a;
		var newEnd = _v1.b;
		var _v2 = _Utils_Tuple2(newStart, newEnd);
		if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Just')) {
			var _v3 = _v2.a.a;
			var startSelection = _v3.b;
			var _v4 = _v2.b.a;
			var endSelection = _v4.b;
			return (_Utils_cmp(
				$elm$time$Time$posixToMillis(startSelection),
				$elm$time$Time$posixToMillis(endSelection)) < 0) ? _Utils_Tuple2(newStart, newEnd) : _Utils_Tuple2(previousStart, previousEnd);
		} else {
			return _Utils_Tuple2(newStart, newEnd);
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectEndHour = F5(
	function (zone, basePickerDay, startSelectionTuple, endSelectionTuple, newEndHour) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
			if (_v1.b.$ === 'Just') {
				var _v2 = _v1.b.a;
				var endPickerDay = _v2.a;
				var endSelection = _v2.b;
				var updatedHourSelection = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newEndHour, endSelection);
				var _v3 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
					zone,
					_Utils_Tuple2(endPickerDay, updatedHourSelection));
				var latestSelectableMinute = _v3.b;
				return (_Utils_cmp(
					A2($elm$time$Time$toMinute, zone, endSelection),
					latestSelectableMinute) > 0) ? _Utils_Tuple2(
					endPickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, latestSelectableMinute, updatedHourSelection)) : _Utils_Tuple2(endPickerDay, updatedHourSelection);
			} else {
				if (_v1.a.$ === 'Just') {
					var _v4 = _v1.a.a;
					var startPickerDay = _v4.a;
					var startSelection = _v4.b;
					var _v5 = _v1.b;
					var updatedHourSelection = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newEndHour, startPickerDay.end);
					var _v6 = A2(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
						zone,
						_Utils_Tuple2(startPickerDay, updatedHourSelection));
					var latestSelectableMinute = _v6.b;
					return _Utils_Tuple2(
						startPickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, latestSelectableMinute, updatedHourSelection));
				} else {
					var _v7 = _v1.a;
					var _v8 = _v1.b;
					var updatedHourSelection = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newEndHour, basePickerDay.end);
					var _v9 = A2(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
						zone,
						_Utils_Tuple2(basePickerDay, updatedHourSelection));
					var latestSelectableMinute = _v9.b;
					return _Utils_Tuple2(
						basePickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, latestSelectableMinute, updatedHourSelection));
				}
			}
		}();
		var selectedPickerDay = _v0.a;
		var selection = _v0.b;
		return function (subjectSelection) {
			return A2(
				$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$validDurationSelectionOrDefault,
				_Utils_Tuple2(startSelectionTuple, endSelectionTuple),
				_Utils_Tuple2(startSelectionTuple, subjectSelection));
		}(
			A3(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault,
				zone,
				endSelectionTuple,
				_Utils_Tuple2(selectedPickerDay, selection)));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectEndMinute = F5(
	function (zone, basePickerDay, startSelectionTuple, endSelectionTuple, newEndMinute) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
			if (_v1.b.$ === 'Just') {
				var _v2 = _v1.b.a;
				var endPickerDay = _v2.a;
				var endSelection = _v2.b;
				return _Utils_Tuple2(
					endPickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newEndMinute, endSelection));
			} else {
				if (_v1.a.$ === 'Just') {
					var _v3 = _v1.a.a;
					var startPickerDay = _v3.a;
					var startSelection = _v3.b;
					var _v4 = _v1.b;
					return _Utils_Tuple2(
						startPickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newEndMinute, startPickerDay.end));
				} else {
					var _v5 = _v1.a;
					var _v6 = _v1.b;
					return _Utils_Tuple2(
						basePickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newEndMinute, basePickerDay.end));
				}
			}
		}();
		var selectedPickerDay = _v0.a;
		var selection = _v0.b;
		return function (subjectSelection) {
			return A2(
				$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$validDurationSelectionOrDefault,
				_Utils_Tuple2(startSelectionTuple, endSelectionTuple),
				_Utils_Tuple2(startSelectionTuple, subjectSelection));
		}(
			A3(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault,
				zone,
				endSelectionTuple,
				_Utils_Tuple2(selectedPickerDay, selection)));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectStartHour = F5(
	function (zone, basePickerDay, startSelectionTuple, endSelectionTuple, newStartHour) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
			if (_v1.a.$ === 'Just') {
				var _v2 = _v1.a.a;
				var startPickerDay = _v2.a;
				var startSelection = _v2.b;
				var updatedHourSelection = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newStartHour, startSelection);
				var _v3 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
					zone,
					_Utils_Tuple2(startPickerDay, updatedHourSelection));
				var earliestSelectableMinute = _v3.a;
				return (_Utils_cmp(
					A2($elm$time$Time$toMinute, zone, startSelection),
					earliestSelectableMinute) < 0) ? _Utils_Tuple2(
					startPickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, earliestSelectableMinute, updatedHourSelection)) : _Utils_Tuple2(startPickerDay, updatedHourSelection);
			} else {
				if (_v1.b.$ === 'Just') {
					var _v4 = _v1.a;
					var _v5 = _v1.b.a;
					var endPickerDay = _v5.a;
					var endSelection = _v5.b;
					var updatedHourSelection = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newStartHour, endSelection);
					var _v6 = A2(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
						zone,
						_Utils_Tuple2(endPickerDay, updatedHourSelection));
					var earliestSelectableMinute = _v6.a;
					return _Utils_Tuple2(
						endPickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, earliestSelectableMinute, updatedHourSelection));
				} else {
					var _v7 = _v1.a;
					var _v8 = _v1.b;
					var updatedHourSelection = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newStartHour, basePickerDay.start);
					var _v9 = A2(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
						zone,
						_Utils_Tuple2(basePickerDay, updatedHourSelection));
					var earliestSelectableMinute = _v9.a;
					return _Utils_Tuple2(
						basePickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, earliestSelectableMinute, updatedHourSelection));
				}
			}
		}();
		var selectedPickerDay = _v0.a;
		var selection = _v0.b;
		return function (subjectSelection) {
			return A2(
				$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$validDurationSelectionOrDefault,
				_Utils_Tuple2(startSelectionTuple, endSelectionTuple),
				_Utils_Tuple2(subjectSelection, endSelectionTuple));
		}(
			A3(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault,
				zone,
				startSelectionTuple,
				_Utils_Tuple2(selectedPickerDay, selection)));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$OutsideHierarchy = function (a) {
	return {$: 'OutsideHierarchy', a: a};
};
var $mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection = F2(
	function (model, _v0) {
		var startSelectionTuple = _v0.a;
		var endSelectionTuple = _v0.b;
		var newDuration = A3(
			$elm$core$Maybe$map2,
			F2(
				function (_v1, _v2) {
					var startSelection = _v1.b;
					var endSelection = _v2.b;
					return _Utils_Tuple2(startSelection, endSelection);
				}),
			startSelectionTuple,
			endSelectionTuple);
		return _Utils_Tuple2(
			$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
				_Utils_update(
					model,
					{endSelectionTuple: endSelectionTuple, startSelectionTuple: startSelectionTuple})),
			newDuration);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectStartMinute = F5(
	function (zone, basePickerDay, startSelectionTuple, endSelectionTuple, newStartMinute) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(startSelectionTuple, endSelectionTuple);
			if (_v1.a.$ === 'Just') {
				var _v2 = _v1.a.a;
				var startPickerDay = _v2.a;
				var startSelection = _v2.b;
				return _Utils_Tuple2(
					startPickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newStartMinute, startSelection));
			} else {
				if (_v1.b.$ === 'Just') {
					var _v3 = _v1.a;
					var _v4 = _v1.b.a;
					var endPickerDay = _v4.a;
					var endSelection = _v4.b;
					return _Utils_Tuple2(
						endPickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newStartMinute, endPickerDay.start));
				} else {
					var _v5 = _v1.a;
					var _v6 = _v1.b;
					return _Utils_Tuple2(
						basePickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newStartMinute, basePickerDay.start));
				}
			}
		}();
		var selectedPickerDay = _v0.a;
		var selection = _v0.b;
		return function (subjectSelection) {
			return A2(
				$mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$validDurationSelectionOrDefault,
				_Utils_Tuple2(startSelectionTuple, endSelectionTuple),
				_Utils_Tuple2(subjectSelection, endSelectionTuple));
		}(
			A3(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault,
				zone,
				startSelectionTuple,
				_Utils_Tuple2(selectedPickerDay, selection)));
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval.$) {
				case 'Millisecond':
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 'Second':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Millisecond, zone, posix1, posix2) / 1000) | 0;
				case 'Minute':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Millisecond, zone, posix1, posix2) / 60000) | 0;
				case 'Hour':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Millisecond, zone, posix1, posix2) / 3600000) | 0;
				case 'Day':
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 'Month':
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 'Year':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Month, zone, posix1, posix2) / 12) | 0;
				case 'Quarter':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Month, zone, posix1, posix2) / 3) | 0;
				case 'Week':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Day, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Week,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateViewOffset = F3(
	function (zone, referenceTime, subjectTime) {
		var flooredReference = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Month, zone, referenceTime);
		if (subjectTime.$ === 'Nothing') {
			return 0;
		} else {
			var time = subjectTime.a;
			var flooredSubject = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Month, zone, time);
			return (_Utils_cmp(
				$elm$time$Time$posixToMillis(flooredReference),
				$elm$time$Time$posixToMillis(flooredSubject)) < 1) ? A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Month, zone, flooredReference, flooredSubject) : (0 - A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Month, zone, flooredSubject, flooredReference));
		}
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0.a;
		var _v1 = model.status;
		if (_v1.$ === 'Open') {
			var timePickerVisible = _v1.a;
			var baseDay = _v1.b;
			switch (msg.$) {
				case 'NextMonth':
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{viewOffset: model.viewOffset + 1})),
						$elm$core$Maybe$Nothing);
				case 'PrevMonth':
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{viewOffset: model.viewOffset - 1})),
						$elm$core$Maybe$Nothing);
				case 'NextYear':
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{viewOffset: model.viewOffset + 12})),
						$elm$core$Maybe$Nothing);
				case 'PrevYear':
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{viewOffset: model.viewOffset - 12})),
						$elm$core$Maybe$Nothing);
				case 'SetHoveredDay':
					var pickerDay = msg.a;
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{
									hovered: $elm$core$Maybe$Just(pickerDay)
								})),
						$elm$core$Maybe$Nothing);
				case 'ClearHoveredDay':
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{hovered: $elm$core$Maybe$Nothing})),
						$elm$core$Maybe$Nothing);
				case 'SetRange':
					var pickerDay = msg.a;
					return A2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection,
						model,
						A4($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectDay, settings.zone, model.startSelectionTuple, model.endSelectionTuple, pickerDay));
				case 'ToggleTimePickerVisibility':
					var _v3 = settings.timePickerVisibility;
					if (_v3.$ === 'Toggleable') {
						return _Utils_Tuple2(
							$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
								_Utils_update(
									model,
									{
										status: A2($mercurymedia$elm_datetime_picker$DurationDatePicker$Open, !timePickerVisible, baseDay)
									})),
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(
							$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(model),
							$elm$core$Maybe$Nothing);
					}
				case 'SetHour':
					var startOrEnd = msg.a;
					var hour = msg.b;
					if (startOrEnd.$ === 'Start') {
						return A2(
							$mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection,
							model,
							A5($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectStartHour, settings.zone, baseDay, model.startSelectionTuple, model.endSelectionTuple, hour));
					} else {
						return A2(
							$mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection,
							model,
							A5($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectEndHour, settings.zone, baseDay, model.startSelectionTuple, model.endSelectionTuple, hour));
					}
				case 'SetMinute':
					var startOrEnd = msg.a;
					var minute = msg.b;
					if (startOrEnd.$ === 'Start') {
						return A2(
							$mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection,
							model,
							A5($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectStartMinute, settings.zone, baseDay, model.startSelectionTuple, model.endSelectionTuple, minute));
					} else {
						return A2(
							$mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection,
							model,
							A5($mercurymedia$elm_datetime_picker$DatePicker$DurationUtilities$selectEndMinute, settings.zone, baseDay, model.startSelectionTuple, model.endSelectionTuple, minute));
					}
				case 'Close':
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{status: $mercurymedia$elm_datetime_picker$DurationDatePicker$Closed})),
						$elm$core$Maybe$Nothing);
				case 'SetDomElements':
					var newDomElements = msg.a;
					var updatedDomLocation = function () {
						var _v6 = model.domLocation;
						if (_v6.$ === 'OutsideHierarchy') {
							var domElements = _v6.a;
							var pickerDomElement = domElements.pickerDomElement;
							var triggerDomElement = domElements.triggerDomElement;
							return $mercurymedia$elm_datetime_picker$DatePicker$Utilities$OutsideHierarchy(
								_Utils_update(
									domElements,
									{
										pickerDomElement: _Utils_update(
											pickerDomElement,
											{
												element: $elm$core$Maybe$Just(newDomElements.pickerDomElement)
											}),
										triggerDomElement: _Utils_update(
											triggerDomElement,
											{
												element: $elm$core$Maybe$Just(newDomElements.triggerDomElement)
											})
									}));
						} else {
							return $mercurymedia$elm_datetime_picker$DatePicker$Utilities$InsideHierarchy;
						}
					}();
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
							_Utils_update(
								model,
								{domLocation: updatedDomLocation})),
						$elm$core$Maybe$Nothing);
				case 'SetPresetRange':
					var range = msg.a.range;
					var startPickerDay = A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, range.start);
					var endPickerDay = A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, range.end);
					var viewOffset = A3(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateViewOffset,
						settings.zone,
						baseDay.start,
						$elm$core$Maybe$Just(startPickerDay.start));
					return A2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$processSelection,
						_Utils_update(
							model,
							{viewOffset: viewOffset}),
						_Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(startPickerDay, startPickerDay.start)),
							$elm$core$Maybe$Just(
								_Utils_Tuple2(endPickerDay, endPickerDay.end))));
				default:
					return _Utils_Tuple2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(model),
						$elm$core$Maybe$Nothing);
			}
		} else {
			return _Utils_Tuple2(
				$mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(model),
				$elm$core$Maybe$Nothing);
		}
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$openPicker = F5(
	function (settings, baseTime, start, end, _v0) {
		var model = _v0.a;
		var startSelectionTuple = A2(
			$elm$core$Maybe$map,
			function (s) {
				return _Utils_Tuple2(
					A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, s),
					s);
			},
			start);
		var timePickerVisible = function () {
			var _v1 = settings.timePickerVisibility;
			switch (_v1.$) {
				case 'NeverVisible':
					return false;
				case 'Toggleable':
					return false;
				default:
					return true;
			}
		}();
		var endSelectionTuple = A2(
			$elm$core$Maybe$map,
			function (e) {
				return _Utils_Tuple2(
					A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, e),
					e);
			},
			end);
		var viewOffset = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateViewOffset, settings.zone, baseTime, start);
		return $mercurymedia$elm_datetime_picker$DurationDatePicker$DatePicker(
			_Utils_update(
				model,
				{
					status: A2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$Open,
						timePickerVisible,
						A2($mercurymedia$elm_datetime_picker$DatePicker$Settings$generatePickerDay, settings, baseTime)),
					viewOffset: viewOffset,
					endSelectionTuple: endSelectionTuple,
					startSelectionTuple: startSelectionTuple
				}));
	});
var $danhandrea$elm_date_format$DateFormat$English = {$: 'English'};
var $danhandrea$elm_date_format$DateFormat$group_ = F2(
	function (acc, fmt) {
		group_:
		while (true) {
			if (!fmt.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var a = fmt.a;
				var bs = fmt.b;
				if (!acc.b) {
					var $temp$acc = _List_fromArray(
						[
							_List_fromArray(
							[a])
						]),
						$temp$fmt = bs;
					acc = $temp$acc;
					fmt = $temp$fmt;
					continue group_;
				} else {
					if (acc.a.b) {
						var _v2 = acc.a;
						var y = _v2.a;
						var ys = _v2.b;
						var xs = acc.b;
						if (_Utils_eq(a, y)) {
							var $temp$acc = A2(
								$elm$core$List$cons,
								A2(
									$elm$core$List$cons,
									a,
									A2($elm$core$List$cons, y, ys)),
								xs),
								$temp$fmt = bs;
							acc = $temp$acc;
							fmt = $temp$fmt;
							continue group_;
						} else {
							var $temp$acc = A2(
								$elm$core$List$cons,
								_List_fromArray(
									[a]),
								A2(
									$elm$core$List$cons,
									A2($elm$core$List$cons, y, ys),
									xs)),
								$temp$fmt = bs;
							acc = $temp$acc;
							fmt = $temp$fmt;
							continue group_;
						}
					} else {
						return acc;
					}
				}
			}
		}
	});
var $danhandrea$elm_date_format$DateFormat$group = $danhandrea$elm_date_format$DateFormat$group_(_List_Nil);
var $danhandrea$elm_date_format$DateFormat$Full = {$: 'Full'};
var $danhandrea$elm_date_format$DateFormat$monthToInt = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $danhandrea$elm_date_format$DateFormat$Abbreviated = {$: 'Abbreviated'};
var $danhandrea$elm_date_format$I18n$Dutch$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Januari';
		case 'Feb':
			return 'Februari';
		case 'Mar':
			return 'Maart';
		case 'Apr':
			return 'April';
		case 'May':
			return 'Mei';
		case 'Jun':
			return 'Juni';
		case 'Jul':
			return 'Juli';
		case 'Aug':
			return 'Augustus';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'Oktober';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $danhandrea$elm_date_format$I18n$Greek$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Ιανουάριος';
		case 'Feb':
			return 'Φεβρουάριος';
		case 'Mar':
			return 'Μάρτιος';
		case 'Apr':
			return 'Απρίλιος';
		case 'May':
			return 'Μάιος';
		case 'Jun':
			return 'Ιούνιος';
		case 'Jul':
			return 'Ιούλιος';
		case 'Aug':
			return 'Αύγουστος';
		case 'Sep':
			return 'Σεπτέμβριος';
		case 'Oct':
			return 'Οκτώβριος';
		case 'Nov':
			return 'Νοέμβριος';
		default:
			return 'Δεκέμβριος';
	}
};
var $danhandrea$elm_date_format$I18n$French$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Janvier';
		case 'Feb':
			return 'Février';
		case 'Mar':
			return 'Mars';
		case 'Apr':
			return 'Avril';
		case 'May':
			return 'Mai';
		case 'Jun':
			return 'Juin';
		case 'Jul':
			return 'Juillet';
		case 'Aug':
			return 'Aout';
		case 'Sep':
			return 'Septembre';
		case 'Oct':
			return 'Octobre';
		case 'Nov':
			return 'Novembre';
		default:
			return 'Décembre';
	}
};
var $danhandrea$elm_date_format$I18n$German$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Januar';
		case 'Feb':
			return 'Februar';
		case 'Mar':
			return 'März';
		case 'Apr':
			return 'April';
		case 'May':
			return 'Mai';
		case 'Jun':
			return 'Juni';
		case 'Jul':
			return 'Juli';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'Oktober';
		case 'Nov':
			return 'November';
		default:
			return 'Dezember';
	}
};
var $danhandrea$elm_date_format$I18n$English$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $danhandrea$elm_date_format$I18n$Finnish$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Tammikuu';
		case 'Feb':
			return 'Helmikuu';
		case 'Mar':
			return 'Maaliskuu';
		case 'Apr':
			return 'Huhtikuu';
		case 'May':
			return 'Toukokuu';
		case 'Jun':
			return 'Kesäkuu';
		case 'Jul':
			return 'Heinäkuu';
		case 'Aug':
			return 'Elokuu';
		case 'Sep':
			return 'Syyskuu';
		case 'Oct':
			return 'Lokakuu';
		case 'Nov':
			return 'Marraskuu';
		default:
			return 'Joulukuu';
	}
};
var $danhandrea$elm_date_format$I18n$Italian$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Gennaio';
		case 'Feb':
			return 'Febbraio';
		case 'Mar':
			return 'Marzo';
		case 'Apr':
			return 'Aprile';
		case 'May':
			return 'Maggio';
		case 'Jun':
			return 'Giugno';
		case 'Jul':
			return 'Luglio';
		case 'Aug':
			return 'Agosto';
		case 'Sep':
			return 'Settembre';
		case 'Oct':
			return 'Ottobre';
		case 'Nov':
			return 'Novembre';
		default:
			return 'Dicembre';
	}
};
var $danhandrea$elm_date_format$I18n$Russian$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Январь';
		case 'Feb':
			return 'Февраль';
		case 'Mar':
			return 'Март';
		case 'Apr':
			return 'Апрель';
		case 'May':
			return 'Май';
		case 'Jun':
			return 'Июнь';
		case 'Jul':
			return 'Июль';
		case 'Aug':
			return 'Август';
		case 'Sep':
			return 'Сентябрь';
		case 'Oct':
			return 'Октябрь';
		case 'Nov':
			return 'Ноябрь';
		default:
			return 'Декабрь';
	}
};
var $danhandrea$elm_date_format$I18n$Spanish$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Enero';
		case 'Feb':
			return 'Febrero';
		case 'Mar':
			return 'Marzo';
		case 'Apr':
			return 'Abril';
		case 'May':
			return 'Mayo';
		case 'Jun':
			return 'Junio';
		case 'Jul':
			return 'Julio';
		case 'Aug':
			return 'Agosto';
		case 'Sep':
			return 'Septiembre';
		case 'Oct':
			return 'Octubre';
		case 'Nov':
			return 'Noviembre';
		default:
			return 'Diciembre';
	}
};
var $danhandrea$elm_date_format$I18n$Swedish$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Januari';
		case 'Feb':
			return 'Februari';
		case 'Mar':
			return 'Mars';
		case 'Apr':
			return 'April';
		case 'May':
			return 'Maj';
		case 'Jun':
			return 'Juni';
		case 'Jul':
			return 'Juli';
		case 'Aug':
			return 'Augusti';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'Oktober';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $danhandrea$elm_date_format$I18n$Norwegian$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Januar';
		case 'Feb':
			return 'Februar';
		case 'Mar':
			return 'Mars';
		case 'Apr':
			return 'April';
		case 'May':
			return 'Mai';
		case 'Jun':
			return 'Juni';
		case 'Jul':
			return 'Juli';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'Oktober';
		case 'Nov':
			return 'November';
		default:
			return 'Desember';
	}
};
var $danhandrea$elm_date_format$I18n$Portuguese$month = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Janeiro';
		case 'Feb':
			return 'Fevereiro';
		case 'Mar':
			return 'Março';
		case 'Apr':
			return 'Abril';
		case 'May':
			return 'Maio';
		case 'Jun':
			return 'Junho';
		case 'Jul':
			return 'Julho';
		case 'Aug':
			return 'Agosto';
		case 'Sep':
			return 'Setembro';
		case 'Oct':
			return 'Outubro';
		case 'Nov':
			return 'Novembro';
		default:
			return 'Dezembro';
	}
};
var $danhandrea$elm_date_format$DateFormat$toAbberviated = function (full) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$take,
			3,
			A2($elm$core$String$split, '', full)));
};
var $danhandrea$elm_date_format$DateFormat$monthToString = F3(
	function (lang, fmt, month) {
		var full = function () {
			switch (lang.$) {
				case 'English':
					return $danhandrea$elm_date_format$I18n$English$month(month);
				case 'French':
					return $danhandrea$elm_date_format$I18n$French$month(month);
				case 'Spanish':
					return $danhandrea$elm_date_format$I18n$Spanish$month(month);
				case 'Dutch':
					return $danhandrea$elm_date_format$I18n$Dutch$month(month);
				case 'Finnish':
					return $danhandrea$elm_date_format$I18n$Finnish$month(month);
				case 'Greek':
					return $danhandrea$elm_date_format$I18n$Greek$month(month);
				case 'Italian':
					return $danhandrea$elm_date_format$I18n$Italian$month(month);
				case 'Norwegian':
					return $danhandrea$elm_date_format$I18n$Norwegian$month(month);
				case 'Portuguese':
					return $danhandrea$elm_date_format$I18n$Portuguese$month(month);
				case 'Swedish':
					return $danhandrea$elm_date_format$I18n$Swedish$month(month);
				case 'German':
					return $danhandrea$elm_date_format$I18n$German$month(month);
				default:
					return $danhandrea$elm_date_format$I18n$Russian$month(month);
			}
		}();
		if (fmt.$ === 'Abbreviated') {
			return $danhandrea$elm_date_format$DateFormat$toAbberviated(full);
		} else {
			return full;
		}
	});
var $danhandrea$elm_date_format$I18n$Dutch$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Maandag';
		case 'Tue':
			return 'Dinsdag';
		case 'Wed':
			return 'Woensdag';
		case 'Thu':
			return 'Donderdag';
		case 'Fri':
			return 'Vrijdag';
		case 'Sat':
			return 'Zaterdag';
		default:
			return 'Zondag';
	}
};
var $danhandrea$elm_date_format$I18n$Greek$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Δευτέρα';
		case 'Tue':
			return 'Τρίτη';
		case 'Wed':
			return 'Τετάρτη';
		case 'Thu':
			return 'Πέμπτη';
		case 'Fri':
			return 'Παρασκευή';
		case 'Sat':
			return 'Σάββατο';
		default:
			return 'Κυριακή';
	}
};
var $danhandrea$elm_date_format$I18n$French$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Lundi';
		case 'Tue':
			return 'Mardi';
		case 'Wed':
			return 'Mercredi';
		case 'Thu':
			return 'Jeudi';
		case 'Fri':
			return 'Vendredi';
		case 'Sat':
			return 'Samedi';
		default:
			return 'Dimanche';
	}
};
var $danhandrea$elm_date_format$I18n$German$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Montag';
		case 'Tue':
			return 'Dienstag';
		case 'Wed':
			return 'Mittwoch';
		case 'Thu':
			return 'Donnerstag';
		case 'Fri':
			return 'Freitag';
		case 'Sat':
			return 'Samstag';
		default:
			return 'Sonntag';
	}
};
var $danhandrea$elm_date_format$I18n$English$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $danhandrea$elm_date_format$I18n$Finnish$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Maanantai';
		case 'Tue':
			return 'Tiistai';
		case 'Wed':
			return 'Keskiviikko';
		case 'Thu':
			return 'Torstai';
		case 'Fri':
			return 'Perjantai';
		case 'Sat':
			return 'Lauantai';
		default:
			return 'Sunnuntai';
	}
};
var $danhandrea$elm_date_format$I18n$Italian$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Lunedì';
		case 'Tue':
			return 'Martedì';
		case 'Wed':
			return 'Mercoledì';
		case 'Thu':
			return 'Giovedì';
		case 'Fri':
			return 'Venerdì';
		case 'Sat':
			return 'Sabato';
		default:
			return 'Domenica';
	}
};
var $danhandrea$elm_date_format$I18n$Russian$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'понедельник';
		case 'Tue':
			return 'вторник';
		case 'Wed':
			return 'среда';
		case 'Thu':
			return 'четверг';
		case 'Fri':
			return 'пятница';
		case 'Sat':
			return 'суббота';
		default:
			return 'воскресенье';
	}
};
var $danhandrea$elm_date_format$I18n$Spanish$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Lunes';
		case 'Tue':
			return 'Martes';
		case 'Wed':
			return 'Miércoles';
		case 'Thu':
			return 'Jueves';
		case 'Fri':
			return 'Viernes';
		case 'Sat':
			return 'Sábado';
		default:
			return 'Domingo';
	}
};
var $danhandrea$elm_date_format$I18n$Swedish$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Måndag';
		case 'Tue':
			return 'Tisdag';
		case 'Wed':
			return 'Onsdag';
		case 'Thu':
			return 'Torsdag';
		case 'Fri':
			return 'Fredag';
		case 'Sat':
			return 'Lördag';
		default:
			return 'Söndag';
	}
};
var $danhandrea$elm_date_format$I18n$Norwegian$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Mandag';
		case 'Tue':
			return 'Tirsdag';
		case 'Wed':
			return 'Onsdag';
		case 'Thu':
			return 'Torsdag';
		case 'Fri':
			return 'Fredag';
		case 'Sat':
			return 'Lørdag';
		default:
			return 'Søndag';
	}
};
var $danhandrea$elm_date_format$I18n$Portuguese$weekday = function (w) {
	switch (w.$) {
		case 'Mon':
			return 'Segunda-feira';
		case 'Tue':
			return 'Terça-feira';
		case 'Wed':
			return 'Quarta-feira';
		case 'Thu':
			return 'Quinta-feira';
		case 'Fri':
			return 'Sexta-feira';
		case 'Sat':
			return 'Sábado';
		default:
			return 'Domingo';
	}
};
var $danhandrea$elm_date_format$DateFormat$weekdayToString = F3(
	function (lang, fmt, weekday) {
		var full = function () {
			switch (lang.$) {
				case 'English':
					return $danhandrea$elm_date_format$I18n$English$weekday(weekday);
				case 'French':
					return $danhandrea$elm_date_format$I18n$French$weekday(weekday);
				case 'Spanish':
					return $danhandrea$elm_date_format$I18n$Spanish$weekday(weekday);
				case 'Dutch':
					return $danhandrea$elm_date_format$I18n$Dutch$weekday(weekday);
				case 'Finnish':
					return $danhandrea$elm_date_format$I18n$Finnish$weekday(weekday);
				case 'Greek':
					return $danhandrea$elm_date_format$I18n$Greek$weekday(weekday);
				case 'Italian':
					return $danhandrea$elm_date_format$I18n$Italian$weekday(weekday);
				case 'Norwegian':
					return $danhandrea$elm_date_format$I18n$Norwegian$weekday(weekday);
				case 'Portuguese':
					return $danhandrea$elm_date_format$I18n$Portuguese$weekday(weekday);
				case 'Swedish':
					return $danhandrea$elm_date_format$I18n$Swedish$weekday(weekday);
				case 'German':
					return $danhandrea$elm_date_format$I18n$German$weekday(weekday);
				default:
					return $danhandrea$elm_date_format$I18n$Russian$weekday(weekday);
			}
		}();
		if (fmt.$ === 'Abbreviated') {
			return $danhandrea$elm_date_format$DateFormat$toAbberviated(full);
		} else {
			return full;
		}
	});
var $danhandrea$elm_date_format$DateFormat$formatPart = F4(
	function (zone, time, lang, part) {
		var stringPadLeft20 = function (i) {
			return A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(i));
		};
		var stringTake = F2(
			function (n, i) {
				return $elm$core$String$concat(
					A2(
						$elm$core$List$take,
						n,
						A2(
							$elm$core$String$split,
							'',
							$elm$core$String$fromInt(i))));
			});
		var to12hour = function (n) {
			return (n === 12) ? 12 : A2($elm$core$Basics$modBy, 12, n);
		};
		switch (part) {
			case 'd':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toDay, zone, time));
			case 'dd':
				return stringPadLeft20(
					A2($elm$time$Time$toDay, zone, time));
			case 'ddd':
				return A3(
					$danhandrea$elm_date_format$DateFormat$weekdayToString,
					lang,
					$danhandrea$elm_date_format$DateFormat$Abbreviated,
					A2($elm$time$Time$toWeekday, zone, time));
			case 'dddd':
				return A3(
					$danhandrea$elm_date_format$DateFormat$weekdayToString,
					lang,
					$danhandrea$elm_date_format$DateFormat$Full,
					A2($elm$time$Time$toWeekday, zone, time));
			case 'h':
				return $elm$core$String$fromInt(
					to12hour(
						A2($elm$time$Time$toHour, zone, time)));
			case 'hh':
				return stringPadLeft20(
					to12hour(
						A2($elm$time$Time$toHour, zone, time)));
			case 'H':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, time));
			case 'HH':
				return stringPadLeft20(
					A2($elm$time$Time$toHour, zone, time));
			case 'm':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, time));
			case 'mm':
				return stringPadLeft20(
					A2($elm$time$Time$toMinute, zone, time));
			case 'M':
				return $elm$core$String$fromInt(
					$danhandrea$elm_date_format$DateFormat$monthToInt(
						A2($elm$time$Time$toMonth, zone, time)));
			case 'MM':
				return stringPadLeft20(
					$danhandrea$elm_date_format$DateFormat$monthToInt(
						A2($elm$time$Time$toMonth, zone, time)));
			case 'MMM':
				return A3(
					$danhandrea$elm_date_format$DateFormat$monthToString,
					lang,
					$danhandrea$elm_date_format$DateFormat$Abbreviated,
					A2($elm$time$Time$toMonth, zone, time));
			case 'MMMM':
				return A3(
					$danhandrea$elm_date_format$DateFormat$monthToString,
					lang,
					$danhandrea$elm_date_format$DateFormat$Full,
					A2($elm$time$Time$toMonth, zone, time));
			case 's':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, time));
			case 'ss':
				return stringPadLeft20(
					A2($elm$time$Time$toSecond, zone, time));
			case 't':
				return (A2($elm$time$Time$toHour, zone, time) < 12) ? 'A' : 'P';
			case 'tt':
				return (A2($elm$time$Time$toHour, zone, time) < 12) ? 'AM' : 'PM';
			case 'yy':
				return stringPadLeft20(
					A2(
						$elm$core$Basics$modBy,
						100,
						A2($elm$time$Time$toYear, zone, time)));
			case 'yyyy':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toYear, zone, time));
			case 'f':
				return A2(
					stringTake,
					1,
					A2($elm$time$Time$toMillis, zone, time));
			case 'ff':
				return A2(
					stringTake,
					2,
					A2($elm$time$Time$toMillis, zone, time));
			case 'fff':
				return A2(
					stringTake,
					3,
					A2($elm$time$Time$toMillis, zone, time));
			default:
				var a = part;
				return a;
		}
	});
var $danhandrea$elm_date_format$DateFormat$formatI18n = F4(
	function (lang, fmt, zone, time) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				A3($danhandrea$elm_date_format$DateFormat$formatPart, zone, time, lang),
				A2(
					$elm$core$List$map,
					$elm$core$String$concat,
					$danhandrea$elm_date_format$DateFormat$group(
						A2($elm$core$String$split, '', fmt)))));
	});
var $danhandrea$elm_date_format$DateFormat$format = F3(
	function (fmt, zone, time) {
		return A4($danhandrea$elm_date_format$DateFormat$formatI18n, $danhandrea$elm_date_format$DateFormat$English, fmt, zone, time);
	});
var $author$project$ISO8601$Extra$toDateString = F2(
	function (zone, dto) {
		return A3(
			$danhandrea$elm_date_format$DateFormat$format,
			'yyyy-MM-dd',
			zone,
			$jweir$elm_iso8601$ISO8601$toPosix(dto));
	});
var $author$project$Pages$Fleet_$OnTime$OnFetchArrivals = function (a) {
	return {$: 'OnFetchArrivals', a: a};
};
var $author$project$Data$GeofenceArrival$GeofenceArrival = F5(
	function (boatName, departureGeofence, departureTime, arrivalGeofence, arrivalTime) {
		return {boatName: boatName, arrivalTime: arrivalTime, departureTime: departureTime, arrivalGeofence: arrivalGeofence, departureGeofence: departureGeofence};
	});
var $author$project$Data$GeofenceArrival$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'arrivalTime',
	A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$toPosix, $jweir$elm_iso8601$ISO8601$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'arrivalGeofence',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'departureTime',
			A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$toPosix, $jweir$elm_iso8601$ISO8601$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'departureGeofence',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'boatName',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Data$GeofenceArrival$GeofenceArrival))))));
var $author$project$Api$fetchOnTimeReport = F6(
	function (token, apiUrl, fleet, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'ontimereport']),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$GeofenceArrival$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$OnTime$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OpenPicker':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							durationDatePicker: A5(
								$mercurymedia$elm_datetime_picker$DurationDatePicker$openPicker,
								$author$project$Pages$Fleet_$OnTime$settings(model),
								model.currentTime,
								A2($elm$core$Maybe$map, $jweir$elm_iso8601$ISO8601$toPosix, model.startDate),
								A2($elm$core$Maybe$map, $jweir$elm_iso8601$ISO8601$toPosix, model.endDate),
								model.durationDatePicker)
						}),
					$author$project$Effect$none);
			case 'UpdateDatePicker':
				var m = msg.a;
				var _v1 = A3(
					$mercurymedia$elm_datetime_picker$DurationDatePicker$update,
					$author$project$Pages$Fleet_$OnTime$settings(model),
					m,
					model.durationDatePicker);
				var newPicker = _v1.a;
				var dates = _v1.b;
				if (dates.$ === 'Just') {
					var _v3 = dates.a;
					var start = _v3.a;
					var end = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								endDate: $elm$core$Maybe$Just(
									$jweir$elm_iso8601$ISO8601$fromPosix(end)),
								startDate: $elm$core$Maybe$Just(
									$jweir$elm_iso8601$ISO8601$fromPosix(start)),
								durationDatePicker: newPicker
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{durationDatePicker: newPicker}),
						$author$project$Effect$none);
				}
			case 'OnTime':
				var _v4 = msg.a;
				var t = _v4.a;
				var z = _v4.b;
				var _v5 = A3($author$project$Time$RelativeDateRange$toStartEnd, t, z, $author$project$Time$RelativeDateRange$LastWeek);
				var defaultStart = _v5.a;
				var defaultEnd = _v5.b;
				var _v6 = _Utils_Tuple3(
					A2(
						$elm$core$Maybe$withDefault,
						$jweir$elm_iso8601$ISO8601$fromPosix(defaultStart),
						model.startDate),
					A2(
						$elm$core$Maybe$withDefault,
						$jweir$elm_iso8601$ISO8601$fromPosix(defaultEnd),
						model.endDate),
					$elm_community$maybe_extra$Maybe$Extra$isNothing(model.startDate));
				var startDate = _v6.a;
				var endDate = _v6.b;
				var fetch = _v6.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							endDate: $elm$core$Maybe$Just(endDate),
							startDate: $elm$core$Maybe$Just(startDate),
							currentTime: t,
							currentZone: z,
							durationDatePicker: $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$OnTime$UpdateDatePicker)
						}),
					fetch ? $author$project$Effect$batch(
						_List_fromArray(
							[
								A6($author$project$Api$fetchOnTimeReport, session.authToken, model.apiUrl, model.fleet.slug, startDate, endDate, $author$project$Pages$Fleet_$OnTime$OnFetchArrivals),
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0))
							])) : $author$project$Effect$none);
			case 'FetchArrivals':
				var _v7 = _Utils_Tuple2(model.startDate, model.endDate);
				if ((_v7.a.$ === 'Just') && (_v7.b.$ === 'Just')) {
					var startDate = _v7.a.a;
					var endDate = _v7.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								durationDatePicker: $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$OnTime$UpdateDatePicker)
							}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									$author$project$Effect$fromCmd(
									$author$project$Ports$startProgressBar(_Utils_Tuple0)),
									A6($author$project$Api$fetchOnTimeReport, session.authToken, model.apiUrl, model.fleet.slug, startDate, endDate, $author$project$Pages$Fleet_$OnTime$OnFetchArrivals)
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchArrivals':
				if (msg.a.$ === 'Ok') {
					var arrivals = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								arrivals: A2(
									$elm$core$List$sortWith,
									F2(
										function (s1, s2) {
											return A2(
												$elm$core$Basics$compare,
												$elm$time$Time$posixToMillis(s1.arrivalTime),
												$elm$time$Time$posixToMillis(s2.arrivalTime));
										}),
									arrivals)
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'DownloadCsv':
				var _v8 = _Utils_Tuple3(model.arrivals, model.startDate, model.endDate);
				if (!_v8.a.b) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					if ((_v8.b.$ === 'Just') && (_v8.c.$ === 'Just')) {
						var ss = _v8.a;
						var start = _v8.b.a;
						var end = _v8.c.a;
						var filename = model.fleet.slug + ('_on_time_' + (A2($author$project$ISO8601$Extra$toDateString, model.currentZone, start) + ('_' + (A2($author$project$ISO8601$Extra$toDateString, model.currentZone, end) + '.csv'))));
						return _Utils_Tuple2(
							model,
							$author$project$Effect$fromCmd(
								A3(
									$elm$file$File$Download$string,
									filename,
									'text/csv',
									A3($author$project$Data$GeofenceArrival$toCsv, model.locale, model.currentZone, ss))));
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$Close = {$: 'Close'};
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mousedown');
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(_Utils_Tuple0));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$eventIsOutsideComponent = function (componentId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return _Utils_eq(componentId, id) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('check parent node');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$eventIsOutsideComponent(componentId));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$clickedOutsidePicker = F2(
	function (componentId, msg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('inside component');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$eventIsOutsideComponent(componentId)));
	});
var $mercurymedia$elm_datetime_picker$DurationDatePicker$subscriptions = F2(
	function (settings, _v0) {
		var model = _v0.a;
		var _v1 = model.status;
		if (_v1.$ === 'Open') {
			return $elm$browser$Browser$Events$onMouseDown(
				A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$clickedOutsidePicker,
					settings.id,
					model.internalMsg($mercurymedia$elm_datetime_picker$DurationDatePicker$Close)));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Pages$Fleet_$OnTime$subscriptions = function (model) {
	return A2(
		$mercurymedia$elm_datetime_picker$DurationDatePicker$subscriptions,
		$author$project$Pages$Fleet_$OnTime$settings(model),
		model.durationDatePicker);
};
var $author$project$Pages$Fleet_$OnTime$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A4($author$project$Pages$Fleet_$OnTime$init, session, shared.apiUrl, shared.locale, req),
					view: A2($author$project$Pages$Fleet_$OnTime$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$OnTime$update(session),
					subscriptions: $author$project$Pages$Fleet_$OnTime$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Places$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Places$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Api$fetchPlaces = F4(
	function (token, apiUrl, fleet, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'places']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Place$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Places$OnFetchPlaces = function (a) {
	return {$: 'OnFetchPlaces', a: a};
};
var $author$project$Pages$Fleet_$Places$OnGetMapElement = function (a) {
	return {$: 'OnGetMapElement', a: a};
};
var $author$project$Pages$Fleet_$Places$init = F4(
	function (session, apiUrl, fleetUrl, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					sheet: $author$project$Views$SidebarSheet$init,
					apiUrl: apiUrl,
					places: _List_Nil,
					mapSize: _Utils_Tuple2(350, 850),
					fleetUrl: fleetUrl,
					isSaving: false,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					isDeleting: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: f.zoom,
						centre: {lat: f.latitude, _long: f.longitude}
					},
					measureLine: _List_Nil,
					editingPlace: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					showPlaceDeleteWarning: false
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchPlaces, session.authToken, apiUrl, f, $author$project$Pages$Fleet_$Places$OnFetchPlaces),
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Places$GotZone, $elm$time$Time$here)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Places$OnTick, $elm$time$Time$now)),
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Fleet_$Places$OnGetMapElement,
								$elm$browser$Browser$Dom$getElement('map'))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Edit Places')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					sheet: $author$project$Views$SidebarSheet$init,
					apiUrl: apiUrl,
					places: _List_Nil,
					mapSize: _Utils_Tuple2(350, 850),
					fleetUrl: fleetUrl,
					isSaving: false,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					isDeleting: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: 12,
						centre: {lat: -32.0620287, _long: 115.7388788}
					},
					measureLine: _List_Nil,
					editingPlace: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					showPlaceDeleteWarning: false
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Places$NoOp = {$: 'NoOp'};
var $author$project$Pages$Fleet_$Places$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Places$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $author$project$Pages$Fleet_$Places$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Places$DragMarker = function (a) {
	return {$: 'DragMarker', a: a};
};
var $author$project$Pages$Fleet_$Places$MapClicked = function (a) {
	return {$: 'MapClicked', a: a};
};
var $author$project$Pages$Fleet_$Places$SelectPlace = function (a) {
	return {$: 'SelectPlace', a: a};
};
var $author$project$Pages$Fleet_$Places$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Data$PlaceType$toImage = function (t) {
	switch (t.$) {
		case 'Anchorage':
			return 'anchor.svg';
		case 'CulturalLocation':
			return 'info.svg';
		case 'Danger':
			return 'danger.svg';
		case 'HistoricLocation':
			return 'landmark.svg';
		case 'Marina':
			return 'anchor.svg';
		case 'Mooring':
			return 'anchor.svg';
		case 'ScenicView':
			return 'camera.svg';
		case 'SelfieSpot':
			return 'camera.svg';
		case 'TurnaroundPoint':
			return 'turnaround.svg';
		case 'Information':
			return 'info.svg';
		case 'WaterskiArea':
			return 'waterski.svg';
		case 'Restrooms':
			return 'toilets.svg';
		case 'FishingSpot':
			return 'fish.svg';
		case 'CafeRestaurant':
			return 'restaurant.svg';
		default:
			return 'beach.svg';
	}
};
var $author$project$Views$Mapbox$placeMarker = F3(
	function (place, onClick, onDrag) {
		return A4(
			$author$project$Mapbox$Element$marker,
			{lat: place.location.lat, lng: place.location._long},
			$elm_community$maybe_extra$Maybe$Extra$isJust(onDrag),
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(onClick),
						A2(
						$elm$html$Html$Attributes$style,
						'zIndex',
						$elm_community$maybe_extra$Maybe$Extra$isJust(onDrag) ? '100' : '')
					]),
				$elm_community$maybe_extra$Maybe$Extra$toList(
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return A2(
								$elm$html$Html$Events$on,
								'drag',
								A2(
									$elm$json$Json$Decode$map,
									f,
									A2($elm$json$Json$Decode$field, 'lngLat', $author$project$Views$Mapbox$geoJSONLatLongDecoder)));
						},
						onDrag))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'relative'),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'margin', '0'),
							A2($elm$html$Html$Attributes$style, 'filter', 'drop-shadow(5px 5px 3px)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									'/images/' + $author$project$Data$PlaceType$toImage(place.type_)),
									A2($elm$html$Html$Attributes$style, 'max-height', '40px')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Fleet_$Places$MapMouseMove = function (a) {
	return {$: 'MapMouseMove', a: a};
};
var $author$project$Pages$Fleet_$Places$SheetMsg = function (a) {
	return {$: 'SheetMsg', a: a};
};
var $author$project$Pages$Fleet_$Places$AddPlace = {$: 'AddPlace'};
var $author$project$Pages$Fleet_$Places$placeListItem = function (place) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group-item py-3 lh-sm')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex w-100 align-items-center justify-content-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(
								'/images/' + $author$project$Data$PlaceType$toImage(place.type_)),
								A2($elm$html$Html$Attributes$style, 'max-height', '25px'),
								$elm$html$Html$Attributes$class('me-2')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(place.name)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-1')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Fleet_$Places$SelectPlace(place.placeId)),
								$elm$html$Html$Attributes$title('Edit Place')
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('text-secondary small')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$edit))
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Places$placeList = F2(
	function (places, disableAdd) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('d-flex flex-column align-items-stretch sidebar-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-3 mx-1 row align-items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col d-none d-md-block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Places')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown col-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn btn-sm btn-light'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$disabled(disableAdd),
											$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Places$AddPlace)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add New'),
											$lattyware$elm_fontawesome$FontAwesome$view(
											A2(
												$lattyware$elm_fontawesome$FontAwesome$styled,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('ms-2')
													]),
												$lattyware$elm_fontawesome$FontAwesome$Solid$plus))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group list-group-flush border-bottom scrollarea')
						]),
					A2($elm$core$List$map, $author$project$Pages$Fleet_$Places$placeListItem, places))
				]));
	});
var $author$project$Views$PlaceForm$Cancel = {$: 'Cancel'};
var $author$project$Views$PlaceForm$Delete = {$: 'Delete'};
var $author$project$Views$PlaceForm$Submit = function (a) {
	return {$: 'Submit', a: a};
};
var $author$project$Views$PlaceForm$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Data$PlaceType$toDisplayString = function (t) {
	switch (t.$) {
		case 'Anchorage':
			return 'Anchorage';
		case 'CulturalLocation':
			return 'Cultural Location';
		case 'Danger':
			return 'Danger';
		case 'HistoricLocation':
			return 'Historic Location';
		case 'Marina':
			return 'Marina';
		case 'Mooring':
			return 'Mooring';
		case 'ScenicView':
			return 'Scenic View';
		case 'SelfieSpot':
			return 'Selfie Spot';
		case 'TurnaroundPoint':
			return 'Turnaround Point';
		case 'Information':
			return 'Information';
		case 'WaterskiArea':
			return 'Waterski Area';
		case 'Restrooms':
			return 'Public Restrooms';
		case 'FishingSpot':
			return 'Fishing Spot';
		case 'CafeRestaurant':
			return 'Cafe/Restaurant';
		default:
			return 'Beach';
	}
};
var $author$project$Data$PlaceType$allTypes = A2(
	$elm$core$List$sortBy,
	$author$project$Data$PlaceType$toDisplayString,
	_List_fromArray(
		[$author$project$Data$PlaceType$Anchorage, $author$project$Data$PlaceType$Beach, $author$project$Data$PlaceType$CulturalLocation, $author$project$Data$PlaceType$Danger, $author$project$Data$PlaceType$HistoricLocation, $author$project$Data$PlaceType$Marina, $author$project$Data$PlaceType$Mooring, $author$project$Data$PlaceType$ScenicView, $author$project$Data$PlaceType$SelfieSpot, $author$project$Data$PlaceType$TurnaroundPoint, $author$project$Data$PlaceType$Information, $author$project$Data$PlaceType$WaterskiArea, $author$project$Data$PlaceType$Restrooms, $author$project$Data$PlaceType$FishingSpot, $author$project$Data$PlaceType$CafeRestaurant]));
var $enbala$elm_form$Form$Textarea = {$: 'Textarea'};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $enbala$elm_form$Form$Input$textArea = F2(
	function (state, attrs) {
		var formAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$value(
				A2($elm$core$Maybe$withDefault, '', state.value)),
				$elm$html$Html$Events$onInput(
				A2(
					$elm$core$Basics$composeR,
					$enbala$elm_form$Form$Field$String,
					A2($enbala$elm_form$Form$Input, state.path, $enbala$elm_form$Form$Textarea))),
				$elm$html$Html$Events$onFocus(
				$enbala$elm_form$Form$Focus(state.path)),
				$elm$html$Html$Events$onBlur(
				$enbala$elm_form$Form$Blur(state.path))
			]);
		return A2(
			$elm$html$Html$textarea,
			_Utils_ap(formAttrs, attrs),
			_List_Nil);
	});
var $author$project$Data$PlaceType$toString = function (t) {
	switch (t.$) {
		case 'Anchorage':
			return 'anchorage';
		case 'CulturalLocation':
			return 'culturalLocation';
		case 'Danger':
			return 'danger';
		case 'HistoricLocation':
			return 'historicLocation';
		case 'Marina':
			return 'marina';
		case 'Mooring':
			return 'mooring';
		case 'ScenicView':
			return 'scenicView';
		case 'SelfieSpot':
			return 'selfieSpot';
		case 'TurnaroundPoint':
			return 'turnaroundPoint';
		case 'Information':
			return 'information';
		case 'WaterskiArea':
			return 'waterskiArea';
		case 'Restrooms':
			return 'restrooms';
		case 'FishingSpot':
			return 'fishingSpot';
		case 'CafeRestaurant':
			return 'cafeRestaurant';
		default:
			return 'beach';
	}
};
var $elm$html$Html$audio = _VirtualDom_node('audio');
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$music = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'music',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7l0 72 0 264c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L448 147 192 223.8 192 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L128 200l0-72c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$music = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$music);
var $author$project$Data$Image$toFile = function (i) {
	if (i.$ === 'Server') {
		return $elm$core$Maybe$Nothing;
	} else {
		var f = i.a;
		return $elm$core$Maybe$Just(f);
	}
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $author$project$Views$PlaceForm$PickAudio = {$: 'PickAudio'};
var $author$project$Views$PlaceForm$RemoveAudio = {$: 'RemoveAudio'};
var $author$project$Views$PlaceForm$audioView = function (model) {
	var previewUrl = function () {
		var _v2 = model.audio;
		if ((_v2.$ === 'Just') && (_v2.a.$ === 'Server')) {
			var u = _v2.a.a;
			return $elm$core$Maybe$Just(u);
		} else {
			return model.audioPreview;
		}
	}();
	var _v0 = model.audio;
	if (_v0.$ === 'Just') {
		var a = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('d-flex flex-row align-items-center gap-2')
				]),
			_List_fromArray(
				[
					function () {
					if (previewUrl.$ === 'Just') {
						var u = previewUrl.a;
						return A2(
							$elm$html$Html$audio,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(u),
									$elm$html$Html$Attributes$controls(true),
									$elm$html$Html$Attributes$class('flex-grow-1'),
									A2($elm$html$Html$Attributes$style, 'min-width', '0')
								]),
							_List_Nil);
					} else {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow-1 small text-truncate')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$elm$file$File$name,
											$author$project$Data$Image$toFile(a))))
								]));
					}
				}(),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-sm btn-danger'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$title('Remove audio'),
							$elm$html$Html$Events$onClick($author$project$Views$PlaceForm$RemoveAudio)
						]),
					_List_fromArray(
						[
							$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$trash)
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-sm btn-outline-secondary'),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick($author$project$Views$PlaceForm$PickAudio)
				]),
			_List_fromArray(
				[
					$lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('me-2')
							]),
						$lattyware$elm_fontawesome$FontAwesome$Solid$music)),
					$elm$html$Html$text('Choose audio file')
				]));
	}
};
var $author$project$Views$PlaceForm$getOutput = function (model) {
	var _v0 = $enbala$elm_form$Form$getErrors(model.form);
	if (!_v0.b) {
		return A2(
			$elm$core$Maybe$map,
			function (p) {
				return _Utils_update(
					p,
					{audio: model.audio, photos: model.photos});
			},
			$enbala$elm_form$Form$getOutput(model.form));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$PlaceForm$DropZoneMsg = function (a) {
	return {$: 'DropZoneMsg', a: a};
};
var $author$project$Views$PlaceForm$RemovePhoto = function (a) {
	return {$: 'RemovePhoto', a: a};
};
var $author$project$Views$PlaceForm$imageToHtml = F2(
	function (previews, img) {
		var deleteButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-sm btn-danger'),
					A2($elm$html$Html$Attributes$style, 'margin', '5px 5px 0 0'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '0'),
					A2($elm$html$Html$Attributes$style, 'right', '0'),
					A2($elm$html$Html$Attributes$style, 'opacity', '0.7'),
					$elm$html$Html$Events$onClick(
					$author$project$Views$PlaceForm$RemovePhoto(img))
				]),
			_List_fromArray(
				[
					$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$trash)
				]));
		var url = function () {
			if (img.$ === 'Server') {
				var u = img.a;
				return u;
			} else {
				var f = img.a;
				var _v1 = A2(
					$elm$core$Dict$get,
					$elm$file$File$name(f),
					previews);
				if (_v1.$ === 'Just') {
					var u = _v1.a;
					return u;
				} else {
					return '/placeholder.svg';
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url),
							$elm$html$Html$Attributes$class('img-thumbnail'),
							A2($elm$html$Html$Attributes$style, 'object-fit', 'contain'),
							A2($elm$html$Html$Attributes$style, 'max-width', '100px'),
							A2($elm$html$Html$Attributes$style, 'max-height', '100px')
						]),
					_List_Nil),
					deleteButton
				]));
	});
var $author$project$Views$PlaceForm$view = F3(
	function (fleetSlug, model, isSaving) {
		var audioEnabledForFleet = A2(
			$elm$core$List$member,
			fleetSlug,
			_List_fromArray(
				['goboat-canberra', 'nebotestfleet']));
		var form = model.form;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Views$PlaceForm$FormMsg,
						A2(
							$enbala$elm_form$Form$Input$textInput,
							A2($enbala$elm_form$Form$getFieldAsString, 'name', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-control form-control-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'name', form)))
										]))
								])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('center')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Location')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Views$PlaceForm$FormMsg,
						A2(
							$enbala$elm_form$Form$Input$textInput,
							A2($enbala$elm_form$Form$getFieldAsString, 'location', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-control form-control-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'location', form)))
										]))
								])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('type')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Type')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Views$PlaceForm$FormMsg,
						A3(
							$enbala$elm_form$Form$Input$selectInput,
							A2(
								$elm$core$List$map,
								function (t) {
									return _Utils_Tuple2(
										$author$project$Data$PlaceType$toString(t),
										$author$project$Data$PlaceType$toDisplayString(t));
								},
								$author$project$Data$PlaceType$allTypes),
							A2($enbala$elm_form$Form$getFieldAsString, 'type', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-select form-select-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'type', form)))
										]))
								])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('url')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('URL')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Views$PlaceForm$FormMsg,
						A2(
							$enbala$elm_form$Form$Input$textInput,
							A2($enbala$elm_form$Form$getFieldAsString, 'url', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-control form-control-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'url', form)))
										]))
								])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Description (markdown)')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Views$PlaceForm$FormMsg,
						A2(
							$enbala$elm_form$Form$Input$textArea,
							A2($enbala$elm_form$Form$getFieldAsString, 'description', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-control form-control-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'description', form)))
										]))
								])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Photos')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-row flex-wrap')
							]),
						A2(
							$elm$core$List$append,
							A2(
								$elm$core$List$map,
								$author$project$Views$PlaceForm$imageToHtml(model.previews),
								model.photos),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Views$PlaceForm$DropZoneMsg,
									A3(
										$author$project$Views$DropZone$view,
										_List_fromArray(
											['image/png', 'image/jpeg']),
										model.dropZoneState,
										_List_Nil))
								])))
					])),
				audioEnabledForFleet ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Audio')
							])),
						$author$project$Views$PlaceForm$audioView(model)
					])) : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex flex-row my-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-sm btn-link mx-1'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick($author$project$Views$PlaceForm$Cancel)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-sm btn-light mx-1'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick($author$project$Views$PlaceForm$Delete)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete'),
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('ms-2')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$trash))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-1')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								'btn btn-sm btn-primary mx-1' + ($elm$core$List$isEmpty(
									$enbala$elm_form$Form$getErrors(form)) ? '' : ' disabled')),
								$elm$html$Html$Events$onClick(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Views$PlaceForm$FormMsg($enbala$elm_form$Form$Submit),
									A2(
										$elm$core$Maybe$map,
										$author$project$Views$PlaceForm$Submit,
										$author$project$Views$PlaceForm$getOutput(model))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save'),
								isSaving ? $lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
											$elm$svg$Svg$Attributes$class('mx-2')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
							]))
					]))
			]);
	});
var $author$project$Pages$Fleet_$Places$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Pages$Fleet_$Places$CancelEdit = {$: 'CancelEdit'};
var $author$project$Pages$Fleet_$Places$placeEditForm = F3(
	function (fleetSlug, editing, isSaving) {
		var _v0 = editing;
		var form = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page flex-column align-items-stretch flex-shrink-0 p-3')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn btn-light btn-sm btn-circle me-2'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Places$CancelEdit)
										]),
									_List_fromArray(
										[
											$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small fw-medium')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Back')
										]))
								])),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Edit Place')
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]),
						A2(
						$elm$core$List$map,
						$elm$html$Html$map($author$project$Pages$Fleet_$Places$FormMsg),
						A3($author$project$Views$PlaceForm$view, fleetSlug, form, isSaving)),
						_List_fromArray(
						[
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						])
					])));
	});
var $author$project$Pages$Fleet_$Places$placeSidebar = F5(
	function (fleetSlug, sheet, places, placeForm, isSaving) {
		return A5(
			$author$project$Views$SidebarSheet$view,
			sheet,
			$author$project$Pages$Fleet_$Places$SheetMsg,
			$elm$core$Maybe$Just('Places'),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-sheet-425')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Fleet_$Places$placeList,
					places,
					$elm_community$maybe_extra$Maybe$Extra$isJust(placeForm)),
					function () {
					if (placeForm.$ === 'Just') {
						var form = placeForm.a;
						return A3($author$project$Pages$Fleet_$Places$placeEditForm, fleetSlug, form, isSaving);
					} else {
						return A2($elm$html$Html$span, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Pages$Fleet_$Places$ControlClicked = function (a) {
	return {$: 'ControlClicked', a: a};
};
var $author$project$Pages$Fleet_$Places$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Places$consolidatedPlaces = function (model) {
	var _v0 = model.editingPlace;
	if (_v0.$ === 'Nothing') {
		return model.places;
	} else {
		var _v1 = _v0.a;
		var editing = _v1.b;
		return A2(
			$elm$core$List$all,
			function (p) {
				return !_Utils_eq(p.placeId, editing.placeId);
			},
			model.places) ? A2(
			$elm$core$List$append,
			_List_fromArray(
				[editing]),
			model.places) : A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_eq(p.placeId, editing.placeId) ? editing : p;
			},
			model.places);
	}
};
var $author$project$Pages$Fleet_$Places$DeletePlace = {$: 'DeletePlace'};
var $author$project$Pages$Fleet_$Places$DismissModal = {$: 'DismissModal'};
var $author$project$Pages$Fleet_$Places$confirmDeleteDialog = F2(
	function (showDialog, isDeleting) {
		return $author$project$Views$Dialog$view(
			showDialog ? $elm$core$Maybe$Just(
				{
					body: $elm$core$Maybe$Just(
						$elm$html$Html$text('Are you sure you want to delete this place? This action cannot be undone.')),
					footer: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-danger'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Places$DeletePlace)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete'),
									isDeleting ? $lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
												$elm$svg$Svg$Attributes$class('mx-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
								]))),
					header: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Delete Place')
								]))),
					closeMessage: $elm$core$Maybe$Just($author$project$Pages$Fleet_$Places$DismissModal),
					containerClass: $elm$core$Maybe$Nothing
				}) : $elm$core$Maybe$Nothing);
	});
var $author$project$Pages$Fleet_$Places$view = F4(
	function (session, req, featureDropState, model) {
		var measureLabel = model.measureModeActive ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('map-control-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Click to add points, move mouse to adjust')
					]))) : $elm$core$Maybe$Nothing;
		var mapConfig = A2(
			$author$project$Views$Mapbox$withIdleMsg,
			function (_v0) {
				var c = _v0.a;
				var z = _v0.b;
				var bounds = _v0.c;
				return $author$project$Pages$Fleet_$Places$MapIdle(
					{
						zoom: z,
						bounds: {northEast: bounds.ne, southWest: bounds.sw},
						centre: c
					});
			},
			A5(
				$author$project$Views$Mapbox$withRuler,
				model.measureLine,
				model.fleet.longDistanceUnit,
				model.measureModeActive,
				$author$project$Pages$Fleet_$Places$ControlClicked('measure'),
				A2(
					$author$project$Views$Mapbox$withMouseMoveMsg,
					model.measureModeActive ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$Places$MapMouseMove) : $elm$core$Maybe$Nothing,
					A2(
						$author$project$Views$Mapbox$withMapClickMsg,
						$author$project$Pages$Fleet_$Places$MapClicked,
						A3(
							$author$project$Views$Mapbox$withStyleSelect,
							model.mapStyle,
							$author$project$Pages$Fleet_$Places$SelectStyle,
							A3($author$project$Views$Mapbox$init, model.mapPosition, model.fleetUrl, $author$project$Pages$Fleet_$Places$NoOp))))));
		var markers = A2(
			$elm$core$List$map,
			function (p) {
				return A3(
					$author$project$Views$Mapbox$placeMarker,
					p,
					$author$project$Pages$Fleet_$Places$SelectPlace(p.placeId),
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.placeId;
							},
							A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.editingPlace)),
						$elm$core$Maybe$Just(p.placeId)) ? $elm$core$Maybe$Just(
						function (ll) {
							return $author$project$Pages$Fleet_$Places$DragMarker(
								_Utils_Tuple2(
									p.placeId,
									{lat: ll.lat, _long: ll._long}));
						}) : $elm$core$Maybe$Nothing);
			},
			$author$project$Pages$Fleet_$Places$consolidatedPlaces(model));
		return {
			body: A2(
				$author$project$Html$Layout$fitWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(req.route),
					featureDropState,
					$author$project$Pages$Fleet_$Places$ChangelogAction,
					$author$project$Pages$Fleet_$Places$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column-reverse flex-md-row  no-wrap'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Views$Mapbox$view,
								mapConfig,
								_Utils_ap(
									$elm_community$maybe_extra$Maybe$Extra$toList(measureLabel),
									markers)),
								A5(
								$author$project$Pages$Fleet_$Places$placeSidebar,
								model.fleet.slug,
								model.sheet,
								$author$project$Pages$Fleet_$Places$consolidatedPlaces(model),
								model.editingPlace,
								model.isSaving),
								A2($author$project$Pages$Fleet_$Places$confirmDeleteDialog, model.showPlaceDeleteWarning, model.isDeleting),
								A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Places$CloseError)
							]))
					])),
			title: 'Places'
		};
	});
var $author$project$Geospatial$LatLong$decimalString = function (latLong) {
	return A2($myrho$elm_round$Round$round, 5, latLong.lat) + (', ' + A2($myrho$elm_round$Round$round, 5, latLong._long));
};
var $author$project$Views$GeofenceForm$fromGeometry = function (g) {
	switch (g.$) {
		case 'Circle':
			var _v1 = g.a;
			var c = _v1.a;
			var r = _v1.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'geometryType',
					$enbala$elm_form$Form$Field$string('circle')),
					_Utils_Tuple2(
					'center',
					$enbala$elm_form$Form$Field$string(
						$author$project$Geospatial$LatLong$decimalMinutesString(c))),
					_Utils_Tuple2(
					'radius',
					$enbala$elm_form$Form$Field$string(
						A2($author$project$Data$DistanceUnit$formatDistance, $author$project$Data$DistanceUnit$Metres, r)))
				]);
		case 'Polygon':
			var ps = g.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'geometryType',
					$enbala$elm_form$Form$Field$string('polygon')),
					_Utils_Tuple2(
					'points',
					$enbala$elm_form$Form$Field$list(
						A2(
							$elm$core$List$map,
							$enbala$elm_form$Form$Field$string,
							A2($elm$core$List$map, $author$project$Geospatial$LatLong$decimalString, ps))))
				]);
		default:
			var ps = g.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'geometryType',
					$enbala$elm_form$Form$Field$string('line')),
					_Utils_Tuple2(
					'points',
					$enbala$elm_form$Form$Field$list(
						A2(
							$elm$core$List$map,
							$enbala$elm_form$Form$Field$string,
							A2($elm$core$List$map, $author$project$Geospatial$LatLong$decimalString, ps))))
				]);
	}
};
var $author$project$Views$PlaceForm$fromPlace = function (place) {
	return A2(
		$elm$core$List$append,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Views$GeofenceForm$fromGeometry, place.geometry)),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'placeId',
				$enbala$elm_form$Form$Field$string(place.placeId)),
				_Utils_Tuple2(
				'name',
				$enbala$elm_form$Form$Field$string(place.name)),
				_Utils_Tuple2(
				'type',
				$enbala$elm_form$Form$Field$string(
					$author$project$Data$PlaceType$toString(place.type_))),
				_Utils_Tuple2(
				'location',
				$enbala$elm_form$Form$Field$string(
					$author$project$Geospatial$LatLong$decimalMinutesString(place.location))),
				_Utils_Tuple2(
				'url',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', place.url))),
				_Utils_Tuple2(
				'description',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', place.description)))
			]));
};
var $author$project$Views$PlaceForm$validateUrl = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	function (s) {
		return A2(
			$elm$core$Result$map,
			$elm$core$Basics$always(s),
			A2(
				$elm$core$Result$fromMaybe,
				$enbala$elm_form$Form$Validate$customError('Please enter a valid URL'),
				$elm$url$Url$fromString(s)));
	});
var $elm$parser$Parser$spaces = $elm$parser$Parser$Advanced$spaces;
var $elm$parser$Parser$Advanced$float = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				hex: $elm$core$Result$Err(invalid),
				_int: $elm$core$Result$Ok($elm$core$Basics$toFloat),
				_float: $elm$core$Result$Ok($elm$core$Basics$identity),
				octal: $elm$core$Result$Err(invalid),
				binary: $elm$core$Result$Err(invalid),
				invalid: invalid,
				expecting: expecting
			});
	});
var $elm$parser$Parser$ExpectingFloat = {$: 'ExpectingFloat'};
var $elm$parser$Parser$float = A2($elm$parser$Parser$Advanced$float, $elm$parser$Parser$ExpectingFloat, $elm$parser$Parser$ExpectingFloat);
var $author$project$Geospatial$LatLong$sigNum = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (_v0) {
				return -1.0;
			},
			$elm$parser$Parser$symbol('-')),
			A2(
			$elm$parser$Parser$map,
			function (_v1) {
				return 1.0;
			},
			$elm$parser$Parser$symbol('+')),
			$elm$parser$Parser$succeed(1.0)
		]));
var $author$project$Geospatial$LatLong$signedFloat = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$mul),
		$author$project$Geospatial$LatLong$sigNum),
	$elm$parser$Parser$float);
var $author$project$Geospatial$LatLong$decimalParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($author$project$Geospatial$LatLong$LatLong),
			$elm$parser$Parser$spaces),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2($elm$parser$Parser$ignorer, $author$project$Geospatial$LatLong$signedFloat, $elm$parser$Parser$spaces),
				$elm$parser$Parser$symbol(',')),
			$elm$parser$Parser$spaces)),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$ignorer, $author$project$Geospatial$LatLong$signedFloat, $elm$parser$Parser$spaces),
		$elm$parser$Parser$end));
var $author$project$Geospatial$LatLong$E = {$: 'E'};
var $author$project$Geospatial$LatLong$N = {$: 'N'};
var $author$project$Geospatial$LatLong$fromDecimalMinutes = F6(
	function (latDeg, latMin, latDir, longDeg, longMin, longDir) {
		var _long = (longDeg + (longMin / 60.0)) * (_Utils_eq(longDir, $author$project$Geospatial$LatLong$E) ? 1.0 : (-1.0));
		var lat = (latDeg + (latMin / 60.0)) * (_Utils_eq(latDir, $author$project$Geospatial$LatLong$N) ? 1.0 : (-1.0));
		return {lat: lat, _long: _long};
	});
var $author$project$Geospatial$LatLong$S = {$: 'S'};
var $author$project$Geospatial$LatLong$latDirectionParser = A2(
	$elm$parser$Parser$andThen,
	function (s) {
		switch (s) {
			case 'S':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$S);
			case 's':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$S);
			case 'N':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$N);
			case 'n':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$N);
			default:
				return $elm$parser$Parser$problem('Unexpected lat direction ' + s);
		}
	},
	$elm$parser$Parser$variable(
		{
			inner: function (_v0) {
				return false;
			},
			start: function (c) {
				return _Utils_eq(
					c,
					_Utils_chr('N')) || (_Utils_eq(
					c,
					_Utils_chr('S')) || (_Utils_eq(
					c,
					_Utils_chr('n')) || _Utils_eq(
					c,
					_Utils_chr('s'))));
			},
			reserved: $elm$core$Set$empty
		}));
var $author$project$Geospatial$LatLong$W = {$: 'W'};
var $author$project$Geospatial$LatLong$longDirectionParser = A2(
	$elm$parser$Parser$andThen,
	function (s) {
		switch (s) {
			case 'E':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$E);
			case 'e':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$E);
			case 'W':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$W);
			case 'w':
				return $elm$parser$Parser$succeed($author$project$Geospatial$LatLong$W);
			default:
				return $elm$parser$Parser$problem('Unexpected long direction ' + s);
		}
	},
	$elm$parser$Parser$variable(
		{
			inner: function (_v0) {
				return false;
			},
			start: function (c) {
				return _Utils_eq(
					c,
					_Utils_chr('E')) || (_Utils_eq(
					c,
					_Utils_chr('W')) || (_Utils_eq(
					c,
					_Utils_chr('e')) || _Utils_eq(
					c,
					_Utils_chr('w'))));
			},
			reserved: $elm$core$Set$empty
		}));
var $author$project$Geospatial$LatLong$decimalMinutesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($author$project$Geospatial$LatLong$fromDecimalMinutes),
							$elm$parser$Parser$spaces),
						A2(
							$elm$parser$Parser$ignorer,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$int,
								$elm$parser$Parser$symbol('°')),
							$elm$parser$Parser$spaces)),
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$float,
							$elm$parser$Parser$symbol('\u0027')),
						$elm$parser$Parser$spaces)),
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						A2($elm$parser$Parser$ignorer, $author$project$Geospatial$LatLong$latDirectionParser, $elm$parser$Parser$spaces),
						$elm$parser$Parser$symbol(',')),
					$elm$parser$Parser$spaces)),
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$int,
					$elm$parser$Parser$symbol('°')),
				$elm$parser$Parser$spaces)),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$float,
				$elm$parser$Parser$symbol('\u0027')),
			$elm$parser$Parser$spaces)),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$ignorer, $author$project$Geospatial$LatLong$longDirectionParser, $elm$parser$Parser$spaces),
		$elm$parser$Parser$end));
var $author$project$Geospatial$LatLong$parse = function (s) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$parser$Parser$run,
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable($author$project$Geospatial$LatLong$decimalParser),
						$elm$parser$Parser$backtrackable($author$project$Geospatial$LatLong$decimalMinutesParser)
					])),
			s));
};
var $author$project$Views$PlaceForm$validateLatLong = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Geospatial$LatLong$parse,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Please enter a valid lat/long in decimal or decimal minutes format'))));
var $author$project$Data$DistanceUnit$unitParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always($author$project$Data$DistanceUnit$Miles),
			$elm$parser$Parser$symbol('mi')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always($author$project$Data$DistanceUnit$NauticalMiles),
			$elm$parser$Parser$symbol('nm')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always($author$project$Data$DistanceUnit$Kilometres),
			$elm$parser$Parser$symbol('km')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always($author$project$Data$DistanceUnit$Yards),
			$elm$parser$Parser$symbol('yd')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always($author$project$Data$DistanceUnit$Metres),
			$elm$parser$Parser$symbol('m'))
		]));
var $author$project$Data$DistanceUnit$convertFrom = F2(
	function (unit, distance) {
		switch (unit.$) {
			case 'Metres':
				return distance;
			case 'Yards':
				return distance / 1.09361;
			case 'NauticalMiles':
				return distance * 1852.0;
			case 'Kilometres':
				return distance * 1000.0;
			default:
				return distance * 1609.34;
		}
	});
var $author$project$Data$DistanceUnit$distanceParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(
				F2(
					function (d, u) {
						return A2($author$project$Data$DistanceUnit$convertFrom, u, d);
					})),
			$elm$parser$Parser$spaces),
		A2($elm$parser$Parser$ignorer, $elm$parser$Parser$float, $elm$parser$Parser$spaces)),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$ignorer, $author$project$Data$DistanceUnit$unitParser, $elm$parser$Parser$spaces),
		$elm$parser$Parser$end));
var $author$project$Data$DistanceUnit$parseDistance = function (s) {
	return $elm$core$Result$toMaybe(
		A2($elm$parser$Parser$run, $author$project$Data$DistanceUnit$distanceParser, s));
};
var $author$project$Views$GeofenceForm$validateRadius = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$DistanceUnit$parseDistance,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Please enter a valid distance in metres'))));
var $author$project$Views$GeofenceForm$validateLatLong = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Geospatial$LatLong$parse,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Please enter a valid lat/long in decimal or decimal minutes format'))));
var $author$project$Views$GeofenceForm$validateGeometry = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (gt) {
		switch (gt) {
			case 'circle':
				return A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2($enbala$elm_form$Form$Validate$field, 'radius', $author$project$Views$GeofenceForm$validateRadius),
					A2(
						$enbala$elm_form$Form$Validate$andMap,
						A2($enbala$elm_form$Form$Validate$field, 'center', $author$project$Views$GeofenceForm$validateLatLong),
						$enbala$elm_form$Form$Validate$succeed(
							F2(
								function (c, r) {
									return $author$project$Data$Geofence$Circle(
										_Utils_Tuple2(c, r));
								}))));
			case 'polygon':
				return A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2(
						$enbala$elm_form$Form$Validate$field,
						'points',
						$enbala$elm_form$Form$Validate$list($author$project$Views$GeofenceForm$validateLatLong)),
					$enbala$elm_form$Form$Validate$succeed($author$project$Data$Geofence$Polygon));
			case 'line':
				return A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2(
						$enbala$elm_form$Form$Validate$field,
						'points',
						$enbala$elm_form$Form$Validate$list($author$project$Views$GeofenceForm$validateLatLong)),
					$enbala$elm_form$Form$Validate$succeed($author$project$Data$Geofence$Line));
			default:
				return $enbala$elm_form$Form$Validate$fail(
					$enbala$elm_form$Form$Validate$customError('Invalid Geofence Type ' + gt));
		}
	},
	A2($enbala$elm_form$Form$Validate$field, 'geometryType', $enbala$elm_form$Form$Validate$string));
var $author$project$Views$PlaceForm$validateMarkdown = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	function (s) {
		var _v0 = $dillonkearns$elm_markdown$Markdown$Parser$parse(s);
		if (_v0.$ === 'Ok') {
			return $elm$core$Result$Ok(s);
		} else {
			var es = _v0.a;
			return $elm$core$Result$Err(
				$enbala$elm_form$Form$Validate$customError(
					'Invalid markdown: ' + A2(
						$elm$core$String$join,
						'\u000A',
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, es))));
		}
	});
var $author$project$Views$PlaceForm$validatePlaceType = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$PlaceType$parse,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Please enter a valid place type'))));
var $author$project$Views$PlaceForm$validatePlace = F2(
	function (photos, audio) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			A2(
				$enbala$elm_form$Form$Validate$field,
				'description',
				$enbala$elm_form$Form$Validate$oneOf(
					_List_fromArray(
						[
							A2(
							$enbala$elm_form$Form$Validate$map,
							$elm$core$Basics$always($elm$core$Maybe$Nothing),
							$enbala$elm_form$Form$Validate$emptyString),
							A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $author$project$Views$PlaceForm$validateMarkdown)
						]))),
			A2(
				$enbala$elm_form$Form$Validate$andMap,
				$enbala$elm_form$Form$Validate$succeed(audio),
				A2(
					$enbala$elm_form$Form$Validate$andMap,
					$enbala$elm_form$Form$Validate$succeed(photos),
					A2(
						$enbala$elm_form$Form$Validate$andMap,
						A2(
							$enbala$elm_form$Form$Validate$field,
							'url',
							$enbala$elm_form$Form$Validate$oneOf(
								_List_fromArray(
									[
										A2(
										$enbala$elm_form$Form$Validate$map,
										$elm$core$Basics$always($elm$core$Maybe$Nothing),
										$enbala$elm_form$Form$Validate$emptyString),
										A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $author$project$Views$PlaceForm$validateUrl)
									]))),
						A2(
							$enbala$elm_form$Form$Validate$andMap,
							$enbala$elm_form$Form$Validate$oneOf(
								_List_fromArray(
									[
										A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $author$project$Views$GeofenceForm$validateGeometry),
										$enbala$elm_form$Form$Validate$succeed($elm$core$Maybe$Nothing)
									])),
							A2(
								$enbala$elm_form$Form$Validate$andMap,
								A2($enbala$elm_form$Form$Validate$field, 'location', $author$project$Views$PlaceForm$validateLatLong),
								A2(
									$enbala$elm_form$Form$Validate$andMap,
									A2($enbala$elm_form$Form$Validate$field, 'type', $author$project$Views$PlaceForm$validatePlaceType),
									A2(
										$enbala$elm_form$Form$Validate$andMap,
										A2(
											$enbala$elm_form$Form$Validate$field,
											'name',
											A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
										A2(
											$enbala$elm_form$Form$Validate$andMap,
											A2(
												$enbala$elm_form$Form$Validate$field,
												'placeId',
												A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
											$enbala$elm_form$Form$Validate$succeed($author$project$Data$Place$Place))))))))));
	});
var $author$project$Views$PlaceForm$init = function (p) {
	return {
		form: A2(
			$enbala$elm_form$Form$initial,
			$author$project$Views$PlaceForm$fromPlace(p),
			A2($author$project$Views$PlaceForm$validatePlace, p.photos, p.audio)),
		audio: p.audio,
		photos: p.photos,
		previews: $elm$core$Dict$empty,
		audioPreview: $elm$core$Maybe$Nothing,
		dropZoneState: $author$project$Views$DropZone$empty
	};
};
var $author$project$Data$Image$Local = function (a) {
	return {$: 'Local', a: a};
};
var $author$project$Views$PlaceForm$SelectedFile = function (a) {
	return {$: 'SelectedFile', a: a};
};
var $author$project$Views$PlaceForm$SelectedAudio = function (a) {
	return {$: 'SelectedAudio', a: a};
};
var $author$project$Views$PlaceForm$audioMimeTypes = _List_fromArray(
	['audio/mpeg', 'audio/mp4', 'audio/x-m4a', 'audio/aac', 'audio/wav', 'audio/x-wav', 'audio/ogg', 'audio/webm']);
var $author$project$Views$PlaceForm$GeneratedPreview = function (a) {
	return {$: 'GeneratedPreview', a: a};
};
var $author$project$Views$PlaceForm$GeneratedAudioPreview = function (a) {
	return {$: 'GeneratedAudioPreview', a: a};
};
var $author$project$Views$PlaceForm$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'FormMsg':
				var m = msg.a;
				var newForm = A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$PlaceForm$validatePlace, model.photos, model.audio),
					m,
					model.form);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{form: newForm}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'SelectedFile':
				var f = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							photos: A2(
								$elm$core$List$append,
								model.photos,
								_List_fromArray(
									[
										$author$project$Data$Image$Local(f)
									])),
							dropZoneState: $author$project$Views$DropZone$empty
						}),
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Task$perform,
						function (p) {
							return $author$project$Views$PlaceForm$GeneratedPreview(
								_Utils_Tuple2(
									$elm$file$File$name(f),
									p));
						},
						$elm$file$File$toUrl(f)));
			case 'DropZoneMsg':
				var dzmsg = msg.a;
				var _v1 = A3(
					$author$project$Views$DropZone$update,
					{
						droppedFile: $author$project$Views$PlaceForm$SelectedFile,
						removeImage: $elm$core$Maybe$Nothing,
						generatePreview: false,
						acceptedMimeTypes: _List_fromArray(
							['image/png', 'image/jpeg'])
					},
					dzmsg,
					model.dropZoneState);
				var state = _v1.a;
				var maybeMsg = _v1.b;
				var cmd = _v1.c;
				var updatedModel = _Utils_update(
					model,
					{dropZoneState: state});
				var updatedCmd = A2($elm$core$Platform$Cmd$map, $author$project$Views$PlaceForm$DropZoneMsg, cmd);
				if (maybeMsg.$ === 'Just') {
					var dzm = maybeMsg.a;
					var _v3 = A3($author$project$Views$PlaceForm$update, config, dzm, updatedModel);
					var newModel = _v3.a;
					var maybeParentMsg = _v3.b;
					var newCmd = _v3.c;
					return _Utils_Tuple3(
						newModel,
						maybeParentMsg,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[updatedCmd, newCmd])));
				} else {
					return _Utils_Tuple3(updatedModel, $elm$core$Maybe$Nothing, updatedCmd);
				}
			case 'GeneratedPreview':
				var _v4 = msg.a;
				var name = _v4.a;
				var url = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							previews: A3($elm$core$Dict$insert, name, url, model.previews)
						}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'RemovePhoto':
				var img = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							photos: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(img),
								model.photos)
						}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'PickAudio':
				return _Utils_Tuple3(
					model,
					$elm$core$Maybe$Nothing,
					A2($elm$file$File$Select$file, $author$project$Views$PlaceForm$audioMimeTypes, $author$project$Views$PlaceForm$SelectedAudio));
			case 'SelectedAudio':
				var f = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							audio: $elm$core$Maybe$Just(
								$author$project$Data$Image$Local(f)),
							audioPreview: $elm$core$Maybe$Nothing
						}),
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Task$perform,
						$author$project$Views$PlaceForm$GeneratedAudioPreview,
						$elm$file$File$toUrl(f)));
			case 'GeneratedAudioPreview':
				var url = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							audioPreview: $elm$core$Maybe$Just(url)
						}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'RemoveAudio':
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{audio: $elm$core$Maybe$Nothing, audioPreview: $elm$core$Maybe$Nothing}),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			case 'Delete':
				return _Utils_Tuple3(
					model,
					$elm$core$Maybe$Just(config._delete),
					$elm$core$Platform$Cmd$none);
			case 'Cancel':
				return _Utils_Tuple3(
					model,
					$elm$core$Maybe$Just(config.cancel),
					$elm$core$Platform$Cmd$none);
			default:
				var p = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Maybe$Just(
						config.submit(p)),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Fleet_$Places$dropLast = function (list) {
	if (!list.b) {
		return _List_Nil;
	} else {
		if (!list.b.b) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$take,
				$elm$core$List$length(list) - 1,
				list);
		}
	}
};
var $author$project$Data$Image$encodeUpdate = function (c) {
	if (c.$ === 'Server') {
		var u = c.a;
		return $elm$json$Json$Encode$string(u);
	} else {
		var f = c.a;
		return $elm$json$Json$Encode$string(
			$elm$file$File$name(f));
	}
};
var $author$project$Data$Geofence$geometryEncoder = function (g) {
	var latLongEncoder = function (ll) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lat',
					$elm$json$Json$Encode$float(ll.lat)),
					_Utils_Tuple2(
					'lng',
					$elm$json$Json$Encode$float(ll._long))
				]));
	};
	switch (g.$) {
		case 'Circle':
			var _v1 = g.a;
			var c = _v1.a;
			var r = _v1.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'circle',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'center',
									latLongEncoder(c)),
									_Utils_Tuple2(
									'radius',
									$elm$json$Json$Encode$float(r))
								])))
					]));
		case 'Polygon':
			var ps = g.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'polygon',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'paths',
									A2($elm$json$Json$Encode$list, latLongEncoder, ps))
								])))
					]));
		default:
			var ps = g.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'line',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'path',
									A2($elm$json$Json$Encode$list, latLongEncoder, ps))
								])))
					]));
	}
};
var $author$project$Data$Place$encodeUpdate = function (place) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(place.name)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Data$PlaceType$toString(place.type_))),
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(place.location.lat)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(place.location._long)),
				_Utils_Tuple2(
				'geometry',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Geofence$geometryEncoder, place.geometry)),
				_Utils_Tuple2(
				'url',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, place.url)),
				_Utils_Tuple2(
				'photos',
				A2($elm$json$Json$Encode$list, $author$project$Data$Image$encodeUpdate, place.photos)),
				_Utils_Tuple2(
				'audio',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Image$encodeUpdate, place.audio)),
				_Utils_Tuple2(
				'description',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, place.description))
			]));
};
var $author$project$Api$putPlace = F5(
	function (token, apiUrl, fleet, place, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'places', place.placeId]),
						_List_Nil),
					body: $elm$http$Http$multipartBody(
						A2(
							$elm$core$List$append,
							A2(
								$elm$core$List$map,
								function (f) {
									return A2(
										$elm$http$Http$filePart,
										$elm$file$File$name(f),
										f);
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$Data$Image$toFile,
									_Utils_ap(
										place.photos,
										$elm_community$maybe_extra$Maybe$Extra$toList(place.audio)))),
							_List_fromArray(
								[
									A2(
									$elm$http$Http$stringPart,
									'place',
									A2(
										$elm$json$Json$Encode$encode,
										2,
										$author$project$Data$Place$encodeUpdate(place)))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$Place$decode),
					method: 'PUT',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Places$SavePlace = function (a) {
	return {$: 'SavePlace', a: a};
};
var $author$project$Api$postPlace = F5(
	function (token, apiUrl, fleet, place, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'places']),
						_List_Nil),
					body: $elm$http$Http$multipartBody(
						A2(
							$elm$core$List$append,
							A2(
								$elm$core$List$map,
								function (f) {
									return A2(
										$elm$http$Http$filePart,
										$elm$file$File$name(f),
										f);
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$Data$Image$toFile,
									_Utils_ap(
										place.photos,
										$elm_community$maybe_extra$Maybe$Extra$toList(place.audio)))),
							_List_fromArray(
								[
									A2(
									$elm$http$Http$stringPart,
									'place',
									A2(
										$elm$json$Json$Encode$encode,
										2,
										$author$project$Data$Place$encodeUpdate(place)))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$Place$decode),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Places$newPlaceId = 'new';
var $author$project$Pages$Fleet_$Places$OnSavePlace = function (a) {
	return {$: 'OnSavePlace', a: a};
};
var $author$project$Api$deletePlace = F5(
	function (token, apiUrl, fleet, placeId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'places', placeId]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectWhatever,
					method: 'DELETE',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Places$sheetConfig = function (model) {
	var _v0 = model.mapSize;
	var h = _v0.b;
	return {
		detents: _List_fromArray(
			[54, h * 0.4, h - 90])
	};
};
var $enbala$elm_form$Form$Reset = function (a) {
	return {$: 'Reset', a: a};
};
var $author$project$Views$PlaceForm$updatePlace = F2(
	function (p, model) {
		return _Utils_update(
			model,
			{
				form: A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$PlaceForm$validatePlace, p.photos, p.audio),
					$enbala$elm_form$Form$Reset(
						$author$project$Views$PlaceForm$fromPlace(p)),
					model.form)
			});
	});
var $author$project$Pages$Fleet_$Places$replacePlace = F2(
	function (p, ps) {
		return A2(
			$elm$core$List$sortWith,
			$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
				function ($) {
					return $.name;
				}),
			A2(
				$elm$core$List$cons,
				p,
				A2(
					$elm$core$List$filter,
					function (p1) {
						return !_Utils_eq(p1.placeId, p.placeId);
					},
					ps)));
	});
var $author$project$Pages$Fleet_$Places$OnDeletePlace = function (a) {
	return {$: 'OnDeletePlace', a: a};
};
var $author$project$Pages$Fleet_$Places$PromptForDeletion = {$: 'PromptForDeletion'};
var $author$project$Pages$Fleet_$Places$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Effect$none);
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'OnResizeWindow':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Fleet_$Places$OnGetMapElement,
							$elm$browser$Browser$Dom$getElement('map'))));
			case 'OnGetMapElement':
				if (msg.a.$ === 'Ok') {
					var element = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mapSize: _Utils_Tuple2(element.element.width, element.element.height)
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'MapIdle':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(b))
						}),
					$author$project$Effect$none);
			case 'MapClicked':
				var latLong = msg.a;
				var updatedModel = model.measureModeActive ? _Utils_update(
					model,
					{
						measureLine: _Utils_ap(
							model.measureLine,
							_List_fromArray(
								[
									{lat: latLong.lat, _long: latLong._long},
									{lat: latLong.lat, _long: latLong._long}
								]))
					}) : model;
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'MapMouseMove':
				var latLong = msg.a;
				if (model.measureModeActive) {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: _Utils_ap(
								$author$project$Pages$Fleet_$Places$dropLast(model.measureLine),
								_List_fromArray(
									[
										{lat: latLong.lat, _long: latLong._long}
									]))
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'ControlClicked':
				var id = msg.a;
				if (id === 'measure') {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: model.measureModeActive ? _List_Nil : model.measureLine,
							measureModeActive: !model.measureModeActive
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'OnFetchPlaces':
				if (msg.a.$ === 'Ok') {
					var ps = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							places: A2(
								$elm$core$List$sortWith,
								$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
									function ($) {
										return $.name;
									}),
								ps)
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'AddPlace':
				var _new = {
					url: $elm$core$Maybe$Nothing,
					name: '',
					audio: $elm$core$Maybe$Nothing,
					type_: $author$project$Data$PlaceType$Information,
					photos: _List_Nil,
					placeId: $author$project$Pages$Fleet_$Places$newPlaceId,
					geometry: $elm$core$Maybe$Nothing,
					location: {lat: model.mapPosition.centre.lat, _long: model.mapPosition.centre._long},
					description: $elm$core$Maybe$Nothing
				};
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 1, model.sheet),
						editingPlace: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$author$project$Views$PlaceForm$init(_new),
								_new))
					});
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'SelectPlace':
				var id = msg.a;
				if (_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							function ($) {
								return $.placeId;
							}),
						model.editingPlace),
					$elm$core$Maybe$Just(id))) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					var updatedModel = _Utils_update(
						model,
						{
							sheet: A2($author$project$Views$SidebarSheet$showPage, 1, model.sheet),
							editingPlace: A2(
								$elm$core$Maybe$map,
								function (p) {
									return _Utils_Tuple2(
										$author$project$Views$PlaceForm$init(p),
										p);
								},
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (p) {
										return _Utils_eq(p.placeId, id);
									},
									model.places))
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				}
			case 'DragMarker':
				var _v2 = msg.a;
				var id = _v2.a;
				var ll = _v2.b;
				var _v3 = model.editingPlace;
				if (_v3.$ === 'Just') {
					var _v4 = _v3.a;
					var form = _v4.a;
					var place = _v4.b;
					if (_Utils_eq(place.placeId, id)) {
						var updatedPlace = _Utils_update(
							place,
							{location: ll});
						var updatedForm = A2($author$project$Views$PlaceForm$updatePlace, updatedPlace, form);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editingPlace: $elm$core$Maybe$Just(
										_Utils_Tuple2(updatedForm, updatedPlace))
								}),
							$author$project$Effect$none);
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'FormMsg':
				var m = msg.a;
				var _v5 = model.editingPlace;
				if (_v5.$ === 'Just') {
					var _v6 = _v5.a;
					var form = _v6.a;
					var place = _v6.b;
					var _v7 = A3(
						$author$project$Views$PlaceForm$update,
						{cancel: $author$project$Pages$Fleet_$Places$CancelEdit, _delete: $author$project$Pages$Fleet_$Places$PromptForDeletion, submit: $author$project$Pages$Fleet_$Places$SavePlace},
						m,
						form);
					var updatedForm = _v7.a;
					var maybeMsg = _v7.b;
					var formCmd = _v7.c;
					var updatedPlace = A2(
						$elm$core$Maybe$withDefault,
						place,
						$author$project$Views$PlaceForm$getOutput(updatedForm));
					var updatedModel = _Utils_update(
						model,
						{
							editingPlace: $elm$core$Maybe$Just(
								_Utils_Tuple2(updatedForm, updatedPlace))
						});
					var formEffect = $author$project$Effect$fromCmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Places$FormMsg, formCmd));
					if (maybeMsg.$ === 'Just') {
						var fMsg = maybeMsg.a;
						var _v9 = A3($author$project$Pages$Fleet_$Places$update, session, fMsg, updatedModel);
						var nestedModel = _v9.a;
						var nestedEffect = _v9.b;
						return _Utils_Tuple2(
							nestedModel,
							$author$project$Effect$batch(
								_List_fromArray(
									[formEffect, nestedEffect])));
					} else {
						return _Utils_Tuple2(updatedModel, formEffect);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'CancelEdit':
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
						editingPlace: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'SavePlace':
				var place = msg.a;
				var updatedModel = _Utils_update(
					model,
					{isSaving: true});
				return _Utils_eq(place.placeId, $author$project$Pages$Fleet_$Places$newPlaceId) ? _Utils_Tuple2(
					updatedModel,
					A5($author$project$Api$postPlace, session.authToken, model.apiUrl, model.fleet, place, $author$project$Pages$Fleet_$Places$OnSavePlace)) : _Utils_Tuple2(
					updatedModel,
					A5($author$project$Api$putPlace, session.authToken, model.apiUrl, model.fleet, place, $author$project$Pages$Fleet_$Places$OnSavePlace));
			case 'OnSavePlace':
				if (msg.a.$ === 'Ok') {
					var place = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
							places: A2($author$project$Pages$Fleet_$Places$replacePlace, place, model.places),
							isSaving: false,
							editingPlace: $elm$core$Maybe$Nothing
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					var e = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							error: $elm$core$Maybe$Just(
								{
									icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
									title: 'Error',
									type_: $author$project$Views$Alert$Danger,
									message: $author$project$Api$errorString(e)
								}),
							isSaving: false
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				}
			case 'PromptForDeletion':
				var _v10 = model.editingPlace;
				if (_v10.$ === 'Just') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isDeleting: false, showPlaceDeleteWarning: true}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'DeletePlace':
				var _v11 = model.editingPlace;
				if (_v11.$ === 'Just') {
					var _v12 = _v11.a;
					var p = _v12.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isDeleting: true, showPlaceDeleteWarning: true}),
						A5($author$project$Api$deletePlace, session.authToken, model.apiUrl, model.fleet, p.placeId, $author$project$Pages$Fleet_$Places$OnDeletePlace));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnDeletePlace':
				if (msg.a.$ === 'Ok') {
					var _v13 = model.editingPlace;
					if (_v13.$ === 'Just') {
						var _v14 = _v13.a;
						var f = _v14.b;
						var updatedModel = _Utils_update(
							model,
							{
								sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
								places: A2(
									$elm$core$List$filter,
									function (g) {
										return !_Utils_eq(g.placeId, f.placeId);
									},
									model.places),
								isDeleting: false,
								editingPlace: $elm$core$Maybe$Nothing,
								showPlaceDeleteWarning: false
							});
						return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isDeleting: false, showPlaceDeleteWarning: false}),
							$author$project$Effect$none);
					}
				} else {
					var e = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							error: $elm$core$Maybe$Just(
								{
									icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
									title: 'Error',
									type_: $author$project$Views$Alert$Danger,
									message: $author$project$Api$errorString(e)
								}),
							isDeleting: false,
							showPlaceDeleteWarning: false
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				}
			case 'SheetMsg':
				var sheetMsg = msg.a;
				var _v15 = A3(
					$author$project$Views$SidebarSheet$update,
					$author$project$Pages$Fleet_$Places$sheetConfig(model),
					sheetMsg,
					model.sheet);
				var updatedSheet = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sheet: updatedSheet}),
					$author$project$Effect$fromCmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Places$SheetMsg, cmd)));
			case 'DismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showPlaceDeleteWarning: false}),
					$author$project$Effect$none);
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			case 'Logout':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Places$OnResizeWindow = F2(
	function (a, b) {
		return {$: 'OnResizeWindow', a: a, b: b};
	});
var $author$project$Pages$Fleet_$Places$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onResize($author$project$Pages$Fleet_$Places$OnResizeWindow),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Fleet_$Places$SheetMsg,
				$author$project$Views$SidebarSheet$subscriptions(model.sheet))
			]));
};
var $author$project$Pages$Fleet_$Places$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A4($author$project$Pages$Fleet_$Places$init, session, shared.apiUrl, shared.fleetUrl, req),
					view: A3($author$project$Pages$Fleet_$Places$view, session, req, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Places$update(session),
					subscriptions: $author$project$Pages$Fleet_$Places$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Public$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Public$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Pages$Fleet_$Public$OnFetchBoats = function (a) {
	return {$: 'OnFetchBoats', a: a};
};
var $author$project$Pages$Fleet_$Public$initialModel = F4(
	function (apiUrl, fleetUrl, fleet, key) {
		return {
			key: key,
			boats: _List_Nil,
			apiUrl: apiUrl,
			fleetUrl: fleetUrl,
			mapStyle: $author$project$Views$Mapbox$Satellite,
			timeZone: $elm$time$Time$utc,
			fleetSlug: fleet,
			geofences: _List_Nil,
			currentTime: $elm$time$Time$millisToPosix(0),
			mapPosition: {
				zoom: 12,
				centre: {lat: -32.0620287, _long: 115.7388788}
			}
		};
	});
var $author$project$Pages$Fleet_$Public$OnFetchGeofences = function (a) {
	return {$: 'OnFetchGeofences', a: a};
};
var $author$project$Api$fetchBoatsPublic = F4(
	function (apiUrl, key, fleet, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$get(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'public']),
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'key', key)
							])),
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Boat$decode))
				}));
	});
var $author$project$Api$fetchGeofencesPublic = F4(
	function (apiUrl, key, fleet, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$get(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'public', 'geofences']),
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'key', key)
							])),
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Geofence$decode))
				}));
	});
var $author$project$Pages$Fleet_$Public$init = F4(
	function (apiUrl, fleetUrl, fleet, key) {
		return _Utils_Tuple2(
			A4($author$project$Pages$Fleet_$Public$initialModel, apiUrl, fleetUrl, fleet, key),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$fetchBoatsPublic, apiUrl, key, fleet, $author$project$Pages$Fleet_$Public$OnFetchBoats),
						A4($author$project$Api$fetchGeofencesPublic, apiUrl, key, fleet, $author$project$Pages$Fleet_$Public$OnFetchGeofences),
						A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Public$GotZone, $elm$time$Time$here),
						A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Public$OnTick, $elm$time$Time$now),
						$author$project$Ports$sendPageViewEvent(
						_Utils_Tuple2(
							$author$project$Gen$Route$toHref(
								$author$project$Gen$Route$Fleet___Public(
									{fleet: fleet})),
							fleet + ': Public Dashboard'))
					])));
	});
var $author$project$Pages$Fleet_$Public$NoOp = {$: 'NoOp'};
var $author$project$Pages$Fleet_$Public$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $author$project$Pages$Fleet_$Public$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Html$Layout$fitWindowNoMenu = function (content) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fit-window-height')
				]),
			content)
		]);
};
var $author$project$Pages$Fleet_$Public$view = function (model) {
	var boatMarkers = A2(
		$elm$core$List$map,
		function (b) {
			return A5($author$project$Views$Mapbox$boatMarker, b, model.mapStyle, false, false, $author$project$Pages$Fleet_$Public$NoOp);
		},
		model.boats);
	var mapConfig = A2(
		$author$project$Views$Mapbox$withGeofences,
		model.geofences,
		A2(
			$author$project$Views$Mapbox$withIdleMsg,
			function (_v0) {
				var c = _v0.a;
				var z = _v0.b;
				var bounds = _v0.c;
				return $author$project$Pages$Fleet_$Public$MapIdle(
					{
						zoom: z,
						bounds: {northEast: bounds.ne, southWest: bounds.sw},
						centre: c
					});
			},
			A3(
				$author$project$Views$Mapbox$withStyleSelect,
				model.mapStyle,
				$author$project$Pages$Fleet_$Public$SelectStyle,
				A3($author$project$Views$Mapbox$init, model.mapPosition, model.fleetUrl, $author$project$Pages$Fleet_$Public$NoOp))));
	return {
		body: $author$project$Html$Layout$fitWindowNoMenu(
			_List_fromArray(
				[
					A2($author$project$Views$Mapbox$view, mapConfig, boatMarkers)
				])),
		title: 'Dashboard'
	};
};
var $author$project$Mapbox$Cmd$Option$animate = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$bool,
	$author$project$Mapbox$Cmd$Internal$Option('animate'));
var $author$project$Mapbox$Cmd$Option$encodePadding = function (_v0) {
	var left = _v0.left;
	var bottom = _v0.bottom;
	var right = _v0.right;
	var top = _v0.top;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'top',
				$elm$json$Json$Encode$int(top)),
				_Utils_Tuple2(
				'right',
				$elm$json$Json$Encode$int(right)),
				_Utils_Tuple2(
				'bottom',
				$elm$json$Json$Encode$int(bottom)),
				_Utils_Tuple2(
				'left',
				$elm$json$Json$Encode$int(left))
			]));
};
var $author$project$Mapbox$Cmd$Option$padding = A2(
	$elm$core$Basics$composeR,
	$author$project$Mapbox$Cmd$Option$encodePadding,
	$author$project$Mapbox$Cmd$Internal$Option('padding'));
var $author$project$Mapbox$Helpers$encodePair = F2(
	function (encoder, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(
			$elm$json$Json$Encode$list,
			encoder,
			_List_fromArray(
				[a, b]));
	});
var $author$project$Mapbox$Cmd$Template$fitBounds = F4(
	function (prt, id, options, bounds) {
		return A4(
			$author$project$Mapbox$Cmd$Template$makeCmd,
			prt,
			id,
			'fitBounds',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'bounds',
					A2($author$project$Mapbox$Helpers$encodePair, $author$project$LngLat$encodeAsPair, bounds)),
					$author$project$Mapbox$Cmd$Template$encodeOptions(options)
				]));
	});
var $author$project$MapCommands$fitBounds = A2($author$project$Mapbox$Cmd$Template$fitBounds, $author$project$Ports$elmMapboxOutgoing, $author$project$MapCommands$id);
var $author$project$Pages$Fleet_$Public$fetchBoats = function (model) {
	return A4($author$project$Api$fetchBoatsPublic, model.apiUrl, model.key, model.fleetSlug, $author$project$Pages$Fleet_$Public$OnFetchBoats);
};
var $author$project$Geospatial$BoundingBox$BoundingBox = F2(
	function (northEast, southWest) {
		return {northEast: northEast, southWest: southWest};
	});
var $author$project$Geospatial$BoundingBox$fromLatLongs = function (ps) {
	var minLong = $elm$core$List$minimum(
		A2(
			$elm$core$List$map,
			function (p) {
				return p._long;
			},
			ps));
	var maxLong = $elm$core$List$maximum(
		A2(
			$elm$core$List$map,
			function (p) {
				return p._long;
			},
			ps));
	var minLat = $elm$core$List$minimum(
		A2(
			$elm$core$List$map,
			function (p) {
				return p.lat;
			},
			ps));
	var southWest = A3($elm$core$Maybe$map2, $author$project$Geospatial$LatLong$LatLong, minLat, minLong);
	var maxLat = $elm$core$List$maximum(
		A2(
			$elm$core$List$map,
			function (p) {
				return p.lat;
			},
			ps));
	var northEast = A3($elm$core$Maybe$map2, $author$project$Geospatial$LatLong$LatLong, maxLat, maxLong);
	return A3($elm$core$Maybe$map2, $author$project$Geospatial$BoundingBox$BoundingBox, northEast, southWest);
};
var $author$project$Geospatial$BoundingBox$centroid = function (bb) {
	var centreLong = bb.southWest._long + ((bb.northEast._long - bb.southWest._long) / 2.0);
	var centreLat = bb.southWest.lat + ((bb.northEast.lat - bb.southWest.lat) / 2.0);
	return {lat: centreLat, _long: centreLong};
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Geospatial$MapProjection$zoomScalesForLat = function (lat) {
	return A2(
		$elm$core$List$map,
		function (z) {
			return _Utils_Tuple2(
				z,
				A2($author$project$Geospatial$MapProjection$metersPerPixel, lat, z));
		},
		A2($elm$core$List$range, 1, 20));
};
var $author$project$Geospatial$MapProjection$zoomToFitPoints = F2(
	function (p1, p2) {
		var mapHeight = 1200.0;
		var mapWidth = 1920.0;
		var heightM = A2(
			$author$project$Geospatial$LatLong$haversine,
			{lat: p1.lat, _long: p1._long},
			{lat: p2.lat, _long: p1._long});
		var widthM = A2(
			$author$project$Geospatial$LatLong$haversine,
			{lat: p1.lat, _long: p1._long},
			{lat: p1.lat, _long: p2._long});
		return A2(
			$elm$core$Maybe$withDefault,
			13,
			$elm_community$list_extra$List$Extra$last(
				$elm$core$List$sort(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var s = _v0.b;
								return (_Utils_cmp(widthM, mapWidth * s) < 0) && (_Utils_cmp(heightM, mapHeight * s) < 0);
							},
							$author$project$Geospatial$MapProjection$zoomScalesForLat(p1.lat))))));
	});
var $author$project$Geospatial$MapProjection$calculateBoundingBox = function (ps) {
	var boundingBox = $author$project$Geospatial$BoundingBox$fromLatLongs(ps);
	var centroid = A2($elm$core$Maybe$map, $author$project$Geospatial$BoundingBox$centroid, boundingBox);
	var zoom = A2(
		$elm$core$Maybe$map,
		function (bb) {
			return A2($author$project$Geospatial$MapProjection$zoomToFitPoints, bb.northEast, bb.southWest);
		},
		boundingBox);
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (ll, z) {
				return _Utils_Tuple3(ll.lat, ll._long, z);
			}),
		centroid,
		A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, zoom));
};
var $author$project$Pages$Fleet_$Public$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Pages$Fleet_$Public$fetchBoats(model));
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$elm$core$Platform$Cmd$none);
			case 'MapIdle':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(b))
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$elm$core$Platform$Cmd$none);
			case 'OnFetchBoats':
				if (msg.a.$ === 'Ok') {
					var bs = msg.a.a;
					var boundingBox = $author$project$Geospatial$BoundingBox$fromLatLongs(
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.latLong;
							},
							bs));
					var mapPos = A2(
						$elm$core$Maybe$withDefault,
						model.mapPosition,
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var la = _v1.a;
								var lo = _v1.b;
								var z = _v1.c;
								return A2(
									$author$project$Geospatial$MapProjection$MapPosition,
									A2($author$project$Geospatial$LatLong$LatLong, la, lo),
									z);
							},
							$author$project$Geospatial$MapProjection$calculateBoundingBox(
								A2(
									$elm$core$List$filterMap,
									function ($) {
										return $.latLong;
									},
									bs))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{boats: bs, mapPosition: mapPos}),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (b) {
									return A2(
										$author$project$MapCommands$fitBounds,
										_List_fromArray(
											[
												$author$project$Mapbox$Cmd$Option$padding(
												{top: 50, left: 50, right: 50, bottom: 50}),
												$author$project$Mapbox$Cmd$Option$animate(false)
											]),
										_Utils_Tuple2(
											{lat: b.southWest.lat, lng: b.southWest._long},
											{lat: b.northEast.lat, lng: b.northEast._long}));
								},
								boundingBox)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnFetchGeofences':
				if (msg.a.$ === 'Ok') {
					var gs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								geofences: A2(
									$elm$core$List$filter,
									function (f) {
										return _Utils_eq(f.type_, $author$project$Data$GeofenceType$Restricted);
									},
									gs)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $ryan_haskell$elm_spa$ElmSpa$Page$element = F2(
	function (fromCmd, page) {
		return $ryan_haskell$elm_spa$ElmSpa$Page$Page(
			F2(
				function (_v0, _v1) {
					return $elm$core$Result$Ok(
						A2($ryan_haskell$elm_spa$ElmSpa$Page$adapters.element, fromCmd, page));
				}));
	});
var $author$project$Page$element = $ryan_haskell$elm_spa$ElmSpa$Page$element($author$project$Effect$fromCmd);
var $author$project$Pages$Fleet_$Public$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 30 * 1000, $author$project$Pages$Fleet_$Public$OnTick)
			]));
};
var $author$project$Pages$Fleet_$Public$page = F2(
	function (shared, req) {
		return $author$project$Page$element(
			{
				init: A4(
					$author$project$Pages$Fleet_$Public$init,
					shared.apiUrl,
					shared.fleetUrl,
					req.params.fleet,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, 'key', req.query))),
				view: $author$project$Pages$Fleet_$Public$view,
				update: $author$project$Pages$Fleet_$Public$update,
				subscriptions: $author$project$Pages$Fleet_$Public$subscriptions
			});
	});
var $author$project$Pages$Fleet_$Routes$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Routes$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Data$Route$Route = F3(
	function (routeId, name, track) {
		return {name: name, track: track, routeId: routeId};
	});
var $author$project$Data$Route$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'track',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Geospatial$LatLong$LatLong,
			A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'long', $elm$json$Json$Decode$float))),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'routeId',
			$author$project$Data$Route$routeIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Route$Route))));
var $author$project$Api$fetchRoutes = F4(
	function (token, apiUrl, fleetSlug, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetSlug, 'routes']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Route$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Routes$OnFetchRoutes = function (a) {
	return {$: 'OnFetchRoutes', a: a};
};
var $author$project$Api$fetchGeofences = F4(
	function (token, apiUrl, fleet, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'geofences']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Geofence$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Routes$OnGetMapElement = function (a) {
	return {$: 'OnGetMapElement', a: a};
};
var $author$project$Pages$Fleet_$Routes$OnFetchGeofences = function (a) {
	return {$: 'OnFetchGeofences', a: a};
};
var $author$project$Pages$Fleet_$Routes$init = F4(
	function (session, apiUrl, fleetUrl, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					sheet: $author$project$Views$SidebarSheet$init,
					apiUrl: apiUrl,
					routes: _List_Nil,
					mapSize: _Utils_Tuple2(350, 850),
					fleetUrl: fleetUrl,
					isSaving: false,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					geofences: _List_Nil,
					isDeleting: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: f.zoom,
						centre: {lat: f.latitude, _long: f.longitude}
					},
					measureLine: _List_Nil,
					editingRoute: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					showRouteDeleteWarning: false
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchGeofences, session.authToken, apiUrl, f, $author$project$Pages$Fleet_$Routes$OnFetchGeofences),
							A4($author$project$Api$fetchRoutes, session.authToken, apiUrl, f.slug, $author$project$Pages$Fleet_$Routes$OnFetchRoutes),
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Routes$GotZone, $elm$time$Time$here)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Routes$OnTick, $elm$time$Time$now)),
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Fleet_$Routes$OnGetMapElement,
								$elm$browser$Browser$Dom$getElement('map'))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Edit Routes')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					sheet: $author$project$Views$SidebarSheet$init,
					apiUrl: apiUrl,
					routes: _List_Nil,
					mapSize: _Utils_Tuple2(350, 850),
					fleetUrl: fleetUrl,
					isSaving: false,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					geofences: _List_Nil,
					isDeleting: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: 12,
						centre: {lat: -32.0620287, _long: 115.7388788}
					},
					measureLine: _List_Nil,
					editingRoute: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					showRouteDeleteWarning: false
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Routes$NoOp = {$: 'NoOp'};
var $author$project$Pages$Fleet_$Routes$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Routes$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $author$project$Pages$Fleet_$Routes$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Routes$MapClicked = function (a) {
	return {$: 'MapClicked', a: a};
};
var $author$project$Data$Route$routeIdToString = function (_v0) {
	var id = _v0.a;
	return id;
};
var $author$project$Views$Mapbox$routesToLayer = function (rs) {
	var routeFeature = function (r) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Feature')),
					_Utils_Tuple2(
					'properties',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'routeId',
								$elm$json$Json$Encode$string(
									$author$project$Data$Route$routeIdToString(r.routeId)))
							]))),
					_Utils_Tuple2(
					'geometry',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('LineString')),
								_Utils_Tuple2(
								'coordinates',
								A2($elm$json$Json$Encode$list, $author$project$Views$Mapbox$latLongToGeoJSON, r.track))
							])))
				]));
	};
	return _Utils_Tuple2(
		'routes',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('FeatureCollection')),
					_Utils_Tuple2(
					'features',
					A2($elm$json$Json$Encode$list, routeFeature, rs))
				])));
};
var $author$project$Views$Mapbox$withRoutes = F2(
	function (routes, config) {
		return _Utils_update(
			config,
			{
				sources: A2(
					$author$project$Views$Mapbox$addOrReplaceSource,
					$author$project$Views$Mapbox$routesToLayer(routes),
					config.sources)
			});
	});
var $author$project$Pages$Fleet_$Routes$SelectRoute = function (a) {
	return {$: 'SelectRoute', a: a};
};
var $author$project$Pages$Fleet_$Routes$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Pages$Fleet_$Routes$MapMouseMove = function (a) {
	return {$: 'MapMouseMove', a: a};
};
var $author$project$Pages$Fleet_$Routes$SheetMsg = function (a) {
	return {$: 'SheetMsg', a: a};
};
var $author$project$Pages$Fleet_$Routes$AddRoute = {$: 'AddRoute'};
var $author$project$Pages$Fleet_$Routes$routeListItem = function (route) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group-item py-3 lh-sm')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex w-100 align-items-center justify-content-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-primary small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(route.name)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-1')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Fleet_$Routes$SelectRoute(route.routeId)),
								$elm$html$Html$Attributes$title('Edit Route')
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('text-secondary small')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$edit))
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Routes$routeList = F2(
	function (routes, disableAdd) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-3 mx-1 d-flex justify-content-between  align-items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col d-none d-md-block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Routes')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-light'),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Routes$AddRoute),
									$elm$html$Html$Attributes$disabled(disableAdd)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add new Route'),
									$lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('ms-1')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$plus))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group list-group-flush border-bottom scrollarea')
						]),
					A2($elm$core$List$map, $author$project$Pages$Fleet_$Routes$routeListItem, routes))
				]));
	});
var $author$project$Views$RouteForm$Submit = {$: 'Submit'};
var $author$project$Views$RouteForm$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Form$Extra$validationFeedback = F2(
	function (form, name) {
		if (!$elm$core$Set$isEmpty(
			$enbala$elm_form$Form$getChangedFields(form))) {
			var _v0 = A2($author$project$Form$Extra$getErrorFor, name, form);
			if (_v0.$ === 'Nothing') {
				return A2($elm$html$Html$span, _List_Nil, _List_Nil);
			} else {
				var error = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invalid-feedback')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Form$Extra$errorToString(error))
						]));
			}
		} else {
			return A2($elm$html$Html$span, _List_Nil, _List_Nil);
		}
	});
var $author$project$Form$Extra$fieldView = F4(
	function (form, name, prompt, plcHolder) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(name)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(prompt)
						])),
					A2(
					$enbala$elm_form$Form$Input$textInput,
					A2($enbala$elm_form$Form$getFieldAsString, name, form),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'form-control ' + A2($author$project$Form$Extra$inputValidationClass, name, form)),
							$elm$html$Html$Attributes$placeholder(
							A2($elm$core$Maybe$withDefault, '', plcHolder))
						])),
					A2($author$project$Form$Extra$validationFeedback, form, name)
				]));
	});
var $author$project$Views$RouteForm$CancelEdit = {$: 'CancelEdit'};
var $author$project$Views$RouteForm$SelectFile = {$: 'SelectFile'};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$fileArrowUp = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'file-arrow-up',
	_Utils_Tuple2(384, 512),
	_Utils_Tuple2('M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$fileArrowUp = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$fileArrowUp);
var $lattyware$elm_fontawesome$FontAwesome$Solid$fileUpload = $lattyware$elm_fontawesome$FontAwesome$Solid$fileArrowUp;
var $author$project$Data$Route$routeIdFromString = function (id) {
	return $author$project$Data$Route$RouteId(id);
};
var $author$project$Views$RouteForm$newRouteId = $author$project$Data$Route$routeIdFromString('new');
var $author$project$Views$RouteForm$DeleteRoute = {$: 'DeleteRoute'};
var $author$project$Views$RouteForm$ReverseTrack = {$: 'ReverseTrack'};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$arrowRightArrowLeft = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'arrow-right-arrow-left',
	_Utils_Tuple2(448, 512),
	_Utils_Tuple2('M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$arrowRightArrowLeft = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$arrowRightArrowLeft);
var $author$project$Views$RouteForm$view = F2(
	function (model, isSaving) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex my-3 flex-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-secondary mx-1'),
									$elm$html$Html$Events$onClick($author$project$Views$RouteForm$ReverseTrack)
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('me-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$arrowRightArrowLeft)),
									$elm$html$Html$text('Reverse')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-link btn-secondary mx-1 px-2'),
									$elm$html$Html$Events$onClick($author$project$Views$RouteForm$SelectFile)
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('me-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$fileUpload)),
									$elm$html$Html$text('Upload GPX')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Views$RouteForm$FormMsg,
					A4($author$project$Form$Extra$fieldView, model.form, 'name', 'Name', $elm$core$Maybe$Nothing)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('d-flex my-3 flex-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-link col-auto mx-1'),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Events$onClick($author$project$Views$RouteForm$CancelEdit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							(!_Utils_eq(model.routeId, $author$project$Views$RouteForm$newRouteId)) ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-sm btn-danger mx-1'),
									$elm$html$Html$Events$onClick($author$project$Views$RouteForm$DeleteRoute)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow-1')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn btn-sm btn-primary col-auto mx-1' + ($elm$core$List$isEmpty(
										$enbala$elm_form$Form$getErrors(model.form)) ? '' : ' disabled')),
									$elm$html$Html$Events$onClick($author$project$Views$RouteForm$Submit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save'),
									isSaving ? $lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
												$elm$svg$Svg$Attributes$class('mx-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : $elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Pages$Fleet_$Routes$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Pages$Fleet_$Routes$CancelEdit = {$: 'CancelEdit'};
var $author$project$Pages$Fleet_$Routes$routeEditForm = F2(
	function (routeForm, isSaving) {
		var _v0 = routeForm;
		var form = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page flex-column align-items-stretch flex-shrink-0 p-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-light btn-sm btn-circle me-2'),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Routes$CancelEdit)
								]),
							_List_fromArray(
								[
									$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small fw-medium')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Back')
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Edit Route')
						])),
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-0')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Fleet_$Routes$FormMsg,
					A2($author$project$Views$RouteForm$view, form, isSaving)),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Fleet_$Routes$routeSidebar = F4(
	function (sheet, routes, routeForm, isSaving) {
		return A5(
			$author$project$Views$SidebarSheet$view,
			sheet,
			$author$project$Pages$Fleet_$Routes$SheetMsg,
			$elm$core$Maybe$Just('Routes'),
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Fleet_$Routes$routeList,
					routes,
					$elm_community$maybe_extra$Maybe$Extra$isJust(routeForm)),
					function () {
					if (routeForm.$ === 'Just') {
						var form = routeForm.a;
						return A2($author$project$Pages$Fleet_$Routes$routeEditForm, form, isSaving);
					} else {
						return A2($elm$html$Html$span, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Pages$Fleet_$Routes$ChangeGeometry = function (a) {
	return {$: 'ChangeGeometry', a: a};
};
var $author$project$Pages$Fleet_$Routes$ControlClicked = function (a) {
	return {$: 'ControlClicked', a: a};
};
var $author$project$Views$Mapbox$withDrawConfig = F2(
	function (drawConfig, config) {
		return _Utils_update(
			config,
			{
				drawConfig: $elm$core$Maybe$Just(drawConfig)
			});
	});
var $author$project$Pages$Fleet_$Routes$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Routes$consolidatedRoutes = function (model) {
	var _v0 = model.editingRoute;
	if (_v0.$ === 'Nothing') {
		return model.routes;
	} else {
		var _v1 = _v0.a;
		var editing = _v1.b;
		return A2(
			$elm$core$List$all,
			function (r) {
				return !_Utils_eq(r.routeId, editing.routeId);
			},
			model.routes) ? A2(
			$elm$core$List$append,
			_List_fromArray(
				[editing]),
			model.routes) : A2(
			$elm$core$List$map,
			function (r) {
				return _Utils_eq(r.routeId, editing.routeId) ? editing : r;
			},
			model.routes);
	}
};
var $author$project$Pages$Fleet_$Routes$DeleteRoute = {$: 'DeleteRoute'};
var $author$project$Pages$Fleet_$Routes$DismissModal = {$: 'DismissModal'};
var $author$project$Pages$Fleet_$Routes$confirmDeleteDialog = F2(
	function (showDialog, isDeleting) {
		return $author$project$Views$Dialog$view(
			showDialog ? $elm$core$Maybe$Just(
				{
					body: $elm$core$Maybe$Just(
						$elm$html$Html$text('Are you sure you want to delete this route? This action cannot be undone.')),
					footer: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-danger'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Routes$DeleteRoute)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete'),
									isDeleting ? $lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
												$elm$svg$Svg$Attributes$class('ms-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
								]))),
					header: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Delete Route')
								]))),
					closeMessage: $elm$core$Maybe$Just($author$project$Pages$Fleet_$Routes$DismissModal),
					containerClass: $elm$core$Maybe$Nothing
				}) : $elm$core$Maybe$Nothing);
	});
var $author$project$Pages$Fleet_$Routes$routesExceptEditing = function (model) {
	var _v0 = model.editingRoute;
	if (_v0.$ === 'Nothing') {
		return model.routes;
	} else {
		var _v1 = _v0.a;
		var editing = _v1.b;
		return A2(
			$elm$core$List$filter,
			function (r) {
				return !_Utils_eq(r.routeId, editing.routeId);
			},
			model.routes);
	}
};
var $author$project$Views$Mapbox$withFeatureClickMsg = F2(
	function (onClickFeature, config) {
		return _Utils_update(
			config,
			{onClickFeature: onClickFeature});
	});
var $author$project$Pages$Fleet_$Routes$view = F4(
	function (session, req, featureDropState, model) {
		var measureLabel = function () {
			if (model.measureModeActive && ($elm$core$List$length(model.measureLine) >= 2)) {
				var lastPoint = $elm$core$List$head(
					$elm$core$List$reverse(model.measureLine));
				var dist = A2(
					$author$project$Data$DistanceUnit$formatDistance,
					model.fleet.longDistanceUnit,
					$author$project$Geospatial$LatLong$distance(model.measureLine));
				return A2(
					$elm$core$Maybe$map,
					function (ll) {
						return A2($author$project$Views$Mapbox$distanceLocationLabel, ll, dist);
					},
					lastPoint);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var mapConfig = A2(
			$author$project$Views$Mapbox$withDrawConfig,
			{
				onMove: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Pages$Fleet_$Routes$ChangeGeometry),
						$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Routes$NoOp))),
				onSelectionChange: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							A2($elm$core$Basics$composeR, $author$project$Data$Route$routeIdFromString, $author$project$Pages$Fleet_$Routes$SelectRoute)),
						$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Routes$NoOp))),
				onChangeCoordinates: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Pages$Fleet_$Routes$ChangeGeometry),
						$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Routes$NoOp)))
			},
			A2(
				$author$project$Views$Mapbox$withRoutes,
				$author$project$Pages$Fleet_$Routes$routesExceptEditing(model),
				A2(
					$author$project$Views$Mapbox$withGeofences,
					model.geofences,
					A2(
						$author$project$Views$Mapbox$withIdleMsg,
						function (_v0) {
							var c = _v0.a;
							var z = _v0.b;
							var bounds = _v0.c;
							return $author$project$Pages$Fleet_$Routes$MapIdle(
								{
									zoom: z,
									bounds: {northEast: bounds.ne, southWest: bounds.sw},
									centre: c
								});
						},
						A5(
							$author$project$Views$Mapbox$withRuler,
							model.measureLine,
							model.fleet.longDistanceUnit,
							model.measureModeActive,
							$author$project$Pages$Fleet_$Routes$ControlClicked('measure'),
							A2(
								$author$project$Views$Mapbox$withFeatureClickMsg,
								function (i) {
									return $elm_community$maybe_extra$Maybe$Extra$isJust(model.editingRoute) ? $author$project$Pages$Fleet_$Routes$NoOp : $author$project$Pages$Fleet_$Routes$SelectRoute(
										$author$project$Data$Route$routeIdFromString(i));
								},
								A2(
									$author$project$Views$Mapbox$withMouseMoveMsg,
									model.measureModeActive ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$Routes$MapMouseMove) : $elm$core$Maybe$Nothing,
									A2(
										$author$project$Views$Mapbox$withMapClickMsg,
										$author$project$Pages$Fleet_$Routes$MapClicked,
										A3(
											$author$project$Views$Mapbox$withStyleSelect,
											model.mapStyle,
											$author$project$Pages$Fleet_$Routes$SelectStyle,
											A3($author$project$Views$Mapbox$init, model.mapPosition, model.fleetUrl, $author$project$Pages$Fleet_$Routes$NoOp))))))))));
		return {
			body: A2(
				$author$project$Html$Layout$fitWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(req.route),
					featureDropState,
					$author$project$Pages$Fleet_$Routes$ChangelogAction,
					$author$project$Pages$Fleet_$Routes$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column-reverse flex-md-row no-wrap'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Views$Mapbox$view,
								mapConfig,
								$elm_community$maybe_extra$Maybe$Extra$toList(measureLabel)),
								A4(
								$author$project$Pages$Fleet_$Routes$routeSidebar,
								model.sheet,
								$author$project$Pages$Fleet_$Routes$consolidatedRoutes(model),
								model.editingRoute,
								model.isSaving),
								A2($author$project$Pages$Fleet_$Routes$confirmDeleteDialog, model.showRouteDeleteWarning, model.isDeleting),
								A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Routes$CloseError)
							]))
					])),
			title: 'Routes'
		};
	});
var $author$project$Views$RouteForm$toFormValues = function (route) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$enbala$elm_form$Form$Field$string(route.name)),
			_Utils_Tuple2(
			'track',
			$enbala$elm_form$Form$Field$list(
				A2(
					$elm$core$List$map,
					function (ll) {
						return $enbala$elm_form$Form$Field$string(
							$author$project$Geospatial$LatLong$decimalString(ll));
					},
					route.track)))
		]);
};
var $author$project$Views$RouteForm$validateRoute = F2(
	function (routeId, track) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			$enbala$elm_form$Form$Validate$succeed(track),
			A2(
				$enbala$elm_form$Form$Validate$andMap,
				A2(
					$enbala$elm_form$Form$Validate$field,
					'name',
					A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
				$enbala$elm_form$Form$Validate$succeed(
					$author$project$Data$Route$Route(routeId))));
	});
var $author$project$Views$RouteForm$init = function (r) {
	return {
		form: A2(
			$enbala$elm_form$Form$initial,
			$author$project$Views$RouteForm$toFormValues(r),
			A2($author$project$Views$RouteForm$validateRoute, r.routeId, r.track)),
		track: r.track,
		routeId: r.routeId
	};
};
var $author$project$Views$RouteForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'FormMsg':
				var m = msg.a;
				var updatedForm = A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$RouteForm$validateRoute, model.routeId, model.track),
					m,
					model.form);
				return _Utils_update(
					model,
					{form: updatedForm});
			case 'DeleteRoute':
				return model;
			case 'SelectFile':
				return model;
			case 'CancelEdit':
				return model;
			case 'ReverseTrack':
				return _Utils_update(
					model,
					{
						track: $elm$core$List$reverse(model.track)
					});
			default:
				var updatedForm = A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$RouteForm$validateRoute, model.routeId, model.track),
					$enbala$elm_form$Form$Submit,
					model.form);
				return _Utils_update(
					model,
					{form: updatedForm});
		}
	});
var $author$project$Mapbox$Cmd$Option$maxZoom = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$float,
	$author$project$Mapbox$Cmd$Internal$Option('maxZoom'));
var $author$project$Pages$Fleet_$Routes$dropLast = function (list) {
	if (!list.b) {
		return _List_Nil;
	} else {
		if (!list.b.b) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$take,
				$elm$core$List$length(list) - 1,
				list);
		}
	}
};
var $author$project$Data$Route$routeIdEncoder = function (_v0) {
	var id = _v0.a;
	return $elm$json$Json$Encode$string(id);
};
var $author$project$Data$Route$encode = function (route) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'routeId',
				$author$project$Data$Route$routeIdEncoder(route.routeId)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(route.name)),
				_Utils_Tuple2(
				'track',
				A2(
					$elm$json$Json$Encode$list,
					function (latLong) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'lat',
									$elm$json$Json$Encode$float(latLong.lat)),
									_Utils_Tuple2(
									'long',
									$elm$json$Json$Encode$float(latLong._long))
								]));
					},
					route.track))
			]));
};
var $author$project$Api$putRoute = F5(
	function (token, apiUrl, fleetSlug, route, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleetSlug,
								'routes',
								$author$project$Data$Route$routeIdToString(route.routeId)
							]),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$author$project$Data$Route$encode(route)),
					expect: $author$project$Api$expectJson($author$project$Data$Route$decode),
					method: 'PUT',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $elm$file$File$toString = _File_toString;
var $author$project$Views$RouteForm$getOutput = function (model) {
	return $enbala$elm_form$Form$getOutput(model.form);
};
var $author$project$Api$postRoute = F5(
	function (token, apiUrl, fleetSlug, route, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetSlug, 'routes']),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$author$project$Data$Route$encode(route)),
					expect: $author$project$Api$expectJson($author$project$Data$Route$decode),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Routes$OnSaveRoute = function (a) {
	return {$: 'OnSaveRoute', a: a};
};
var $author$project$Api$deleteRoute = F5(
	function (token, apiUrl, fleetSlug, routeId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleetSlug,
								'routes',
								$author$project$Data$Route$routeIdToString(routeId)
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectWhatever,
					method: 'DELETE',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Routes$sheetConfig = function (model) {
	var _v0 = model.mapSize;
	var h = _v0.b;
	return {
		detents: _List_fromArray(
			[54, h * 0.4, h - 90])
	};
};
var $author$project$Views$RouteForm$updateTrack = F2(
	function (track, model) {
		return _Utils_update(
			model,
			{track: track});
	});
var $author$project$Pages$Fleet_$Routes$OnSelectFile = function (a) {
	return {$: 'OnSelectFile', a: a};
};
var $author$project$Gpx$Decode$Gpx = F3(
	function (routes, waypoints, tracks) {
		return {routes: routes, tracks: tracks, waypoints: waypoints};
	});
var $ymtszw$elm_xml_decode$Xml$Decode$Decoder = function (a) {
	return {$: 'Decoder', a: a};
};
var $ymtszw$elm_xml_decode$Xml$Decode$listImpl = F3(
	function (_v0, acc, _v1) {
		listImpl:
		while (true) {
			var decoder = _v0.a;
			var nodes = _v1.a;
			var ancestor = _v1.b;
			if (!nodes.b) {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(acc));
			} else {
				var n = nodes.a;
				var ns = nodes.b;
				var _v3 = decoder(n);
				if (_v3.$ === 'Ok') {
					var item = _v3.a;
					var $temp$_v0 = $ymtszw$elm_xml_decode$Xml$Decode$Decoder(decoder),
						$temp$acc = A2($elm$core$List$cons, item, acc),
						$temp$_v1 = _Utils_Tuple2(ns, ancestor);
					_v0 = $temp$_v0;
					acc = $temp$acc;
					_v1 = $temp$_v1;
					continue listImpl;
				} else {
					var e = _v3.a;
					return $elm$core$Result$Err(e);
				}
			}
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$ListDecoder = function (a) {
	return {$: 'ListDecoder', a: a};
};
var $ymtszw$elm_xml_decode$Xml$Decode$list = function (decoder) {
	return $ymtszw$elm_xml_decode$Xml$Decode$ListDecoder(
		A2($ymtszw$elm_xml_decode$Xml$Decode$listImpl, decoder, _List_Nil));
};
var $ymtszw$elm_xml_decode$Xml$Decode$succeed = function (a) {
	return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
		function (_v0) {
			return $elm$core$Result$Ok(a);
		});
};
var $ymtszw$elm_xml_decode$Xml$Decode$map2Impl = F4(
	function (valueGen, _v0, _v1, aNode) {
		var decoderA = _v0.a;
		var decoderB = _v1.a;
		return A3(
			$elm$core$Result$map2,
			valueGen,
			decoderA(aNode),
			decoderB(aNode));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$map2 = F3(
	function (valueGen, decoderA, decoderB) {
		return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
			A3($ymtszw$elm_xml_decode$Xml$Decode$map2Impl, valueGen, decoderA, decoderB));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$hasName = F2(
	function (name, aNode) {
		if (aNode.$ === 'Element') {
			var nodeName = aNode.a;
			return _Utils_eq(name, nodeName);
		} else {
			return false;
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$children = function (aNode) {
	if (aNode.$ === 'Element') {
		var nodes = aNode.c;
		return nodes;
	} else {
		return _List_Nil;
	}
};
var $ymtszw$elm_xml_decode$Xml$Decode$query = F3(
	function (path_, ancestor, collected) {
		query:
		while (true) {
			if (!path_.b) {
				return _Utils_Tuple2(collected, ancestor);
			} else {
				if (!path_.b.b) {
					var segment = path_.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$List$filter,
							$ymtszw$elm_xml_decode$Xml$Decode$hasName(segment),
							collected),
						ancestor);
				} else {
					var segment = path_.a;
					var ss = path_.b;
					var _v1 = A2(
						$elm$core$List$filter,
						$ymtszw$elm_xml_decode$Xml$Decode$hasName(segment),
						collected);
					if (!_v1.b) {
						return _Utils_Tuple2(_List_Nil, ancestor);
					} else {
						if (!_v1.b.b) {
							var onlyOne = _v1.a;
							var $temp$path_ = ss,
								$temp$ancestor = onlyOne,
								$temp$collected = $ymtszw$elm_xml_decode$Xml$Decode$children(onlyOne);
							path_ = $temp$path_;
							ancestor = $temp$ancestor;
							collected = $temp$collected;
							continue query;
						} else {
							var many = _v1;
							var $temp$path_ = ss,
								$temp$ancestor = ancestor,
								$temp$collected = A2($elm$core$List$concatMap, $ymtszw$elm_xml_decode$Xml$Decode$children, many);
							path_ = $temp$path_;
							ancestor = $temp$ancestor;
							collected = $temp$collected;
							continue query;
						}
					}
				}
			}
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$Path = F2(
	function (a, b) {
		return {$: 'Path', a: a, b: b};
	});
var $ymtszw$elm_xml_decode$Xml$Decode$concatPath = F2(
	function (path_, error) {
		if (error.$ === 'Path') {
			var innerPath = error.a;
			var innerError = error.b;
			return A2(
				$ymtszw$elm_xml_decode$Xml$Decode$Path,
				_Utils_ap(path_, innerPath),
				innerError);
		} else {
			var otherwise = error;
			return A2($ymtszw$elm_xml_decode$Xml$Decode$Path, path_, otherwise);
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$pathImpl = F3(
	function (path_, _v0, aNode) {
		var listDecoder = _v0.a;
		return A2(
			$elm$core$Result$mapError,
			$ymtszw$elm_xml_decode$Xml$Decode$concatPath(path_),
			listDecoder(
				A3(
					$ymtszw$elm_xml_decode$Xml$Decode$query,
					path_,
					aNode,
					$ymtszw$elm_xml_decode$Xml$Decode$children(aNode))));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$path = F2(
	function (path_, listDecoder) {
		return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
			A2($ymtszw$elm_xml_decode$Xml$Decode$pathImpl, path_, listDecoder));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $ymtszw$elm_xml_decode$Xml$Decode$oneOfImpl = F3(
	function (decoders, errors, aNode) {
		oneOfImpl:
		while (true) {
			if (!decoders.b) {
				return $elm$core$Result$Err(
					$ymtszw$elm_xml_decode$Xml$Decode$OneOf(
						$elm$core$List$reverse(errors)));
			} else {
				var d = decoders.a.a;
				var ds = decoders.b;
				var _v1 = d(aNode);
				if (_v1.$ === 'Ok') {
					var val = _v1.a;
					return $elm$core$Result$Ok(val);
				} else {
					var e = _v1.a;
					var $temp$decoders = ds,
						$temp$errors = A2($elm$core$List$cons, e, errors),
						$temp$aNode = aNode;
					decoders = $temp$decoders;
					errors = $temp$errors;
					aNode = $temp$aNode;
					continue oneOfImpl;
				}
			}
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$oneOf = function (decoders) {
	return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
		A2($ymtszw$elm_xml_decode$Xml$Decode$oneOfImpl, decoders, _List_Nil));
};
var $ymtszw$elm_xml_decode$Xml$Decode$withDefault = F2(
	function (_default, decoder) {
		return $ymtszw$elm_xml_decode$Xml$Decode$oneOf(
			_List_fromArray(
				[
					decoder,
					$ymtszw$elm_xml_decode$Xml$Decode$succeed(_default)
				]));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$optionalPath = F3(
	function (path_, listDecoderA, _default) {
		return A2(
			$ymtszw$elm_xml_decode$Xml$Decode$map2,
			$elm$core$Basics$apR,
			A2(
				$ymtszw$elm_xml_decode$Xml$Decode$withDefault,
				_default,
				A2($ymtszw$elm_xml_decode$Xml$Decode$path, path_, listDecoderA)));
	});
var $author$project$Gpx$Decode$Route = F2(
	function (name, points) {
		return {name: name, points: points};
	});
var $ymtszw$elm_xml_decode$Xml$Decode$mapImpl = F3(
	function (valueGen, _v0, aNode) {
		var decoder = _v0.a;
		return A2(
			$elm$core$Result$map,
			valueGen,
			decoder(aNode));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$map = F2(
	function (valueGen, decoder) {
		return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
			A2($ymtszw$elm_xml_decode$Xml$Decode$mapImpl, valueGen, decoder));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$maybe = function (decoder) {
	return $ymtszw$elm_xml_decode$Xml$Decode$oneOf(
		_List_fromArray(
			[
				A2($ymtszw$elm_xml_decode$Xml$Decode$map, $elm$core$Maybe$Just, decoder),
				$ymtszw$elm_xml_decode$Xml$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $ymtszw$elm_xml_decode$Xml$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $ymtszw$elm_xml_decode$Xml$Decode$singleImpl = F2(
	function (_v0, _v1) {
		var decoder = _v0.a;
		var nodes = _v1.a;
		var ancestor = _v1.b;
		if (!nodes.b) {
			return $elm$core$Result$Err(
				A2($ymtszw$elm_xml_decode$Xml$Decode$Failure, 'Node not found.', ancestor));
		} else {
			if (!nodes.b.b) {
				var singleton_ = nodes.a;
				return decoder(singleton_);
			} else {
				return $elm$core$Result$Err(
					A2($ymtszw$elm_xml_decode$Xml$Decode$Failure, 'Multiple nodes found.', ancestor));
			}
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$single = function (decoder) {
	return $ymtszw$elm_xml_decode$Xml$Decode$ListDecoder(
		$ymtszw$elm_xml_decode$Xml$Decode$singleImpl(decoder));
};
var $ymtszw$elm_xml_decode$Xml$Decode$cdataImpl = F2(
	function (generator, aNode) {
		var unparsable = function (message) {
			return A2($ymtszw$elm_xml_decode$Xml$Decode$Failure, message, aNode);
		};
		var gen = A2(
			$elm$core$Basics$composeR,
			generator,
			$elm$core$Result$mapError(unparsable));
		if (aNode.$ === 'Text') {
			var str = aNode.a;
			return gen(str);
		} else {
			if (!aNode.c.b) {
				return gen('');
			} else {
				if ((aNode.c.a.$ === 'Text') && (!aNode.c.b.b)) {
					var _v1 = aNode.c;
					var str = _v1.a.a;
					return gen(str);
				} else {
					return $elm$core$Result$Err(
						unparsable('The node is not a simple text node.'));
				}
			}
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$cdata = function (generator) {
	return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
		$ymtszw$elm_xml_decode$Xml$Decode$cdataImpl(generator));
};
var $ymtszw$elm_xml_decode$Xml$Decode$string = $ymtszw$elm_xml_decode$Xml$Decode$cdata($elm$core$Result$Ok);
var $ymtszw$elm_xml_decode$Xml$Decode$fetchAttributeValue = F2(
	function (name_, attrs) {
		fetchAttributeValue:
		while (true) {
			if (!attrs.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var value = attrs.a.value;
				var name = attrs.a.name;
				var tl = attrs.b;
				if (_Utils_eq(name, name_)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$name_ = name_,
						$temp$attrs = tl;
					name_ = $temp$name_;
					attrs = $temp$attrs;
					continue fetchAttributeValue;
				}
			}
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$cdataAttrImpl = F3(
	function (name_, generator, aNode) {
		var notFound = A2($ymtszw$elm_xml_decode$Xml$Decode$Failure, 'Attribute \u0027' + (name_ + '\u0027 not found.'), aNode);
		var gen = A2(
			$elm$core$Basics$composeR,
			generator,
			$elm$core$Result$mapError(
				function (message) {
					return A2($ymtszw$elm_xml_decode$Xml$Decode$Failure, message, aNode);
				}));
		if (aNode.$ === 'Text') {
			return $elm$core$Result$Err(notFound);
		} else {
			var attrs = aNode.b;
			return A2(
				$elm$core$Result$andThen,
				gen,
				A2(
					$elm$core$Result$fromMaybe,
					notFound,
					A2($ymtszw$elm_xml_decode$Xml$Decode$fetchAttributeValue, name_, attrs)));
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$cdataAttr = F2(
	function (name_, generator) {
		return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
			A2($ymtszw$elm_xml_decode$Xml$Decode$cdataAttrImpl, name_, generator));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$convertCdata = F3(
	function (toType, typeStr, raw) {
		var _v0 = toType(raw);
		if (_v0.$ === 'Just') {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			return $elm$core$Result$Err('could not convert string \u0027' + (raw + ('\u0027 to ' + typeStr)));
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$floatAttr = function (name_) {
	return A2(
		$ymtszw$elm_xml_decode$Xml$Decode$cdataAttr,
		name_,
		A2($ymtszw$elm_xml_decode$Xml$Decode$convertCdata, $elm$core$String$toFloat, 'a Float'));
};
var $author$project$Gpx$Decode$latLongDecoder = A3(
	$ymtszw$elm_xml_decode$Xml$Decode$map2,
	$author$project$Geospatial$LatLong$LatLong,
	$ymtszw$elm_xml_decode$Xml$Decode$floatAttr('lat'),
	$ymtszw$elm_xml_decode$Xml$Decode$floatAttr('lon'));
var $author$project$Gpx$Decode$routeDecoder = A3(
	$ymtszw$elm_xml_decode$Xml$Decode$map2,
	$author$project$Gpx$Decode$Route,
	A2(
		$ymtszw$elm_xml_decode$Xml$Decode$path,
		_List_fromArray(
			['name']),
		$ymtszw$elm_xml_decode$Xml$Decode$single(
			$ymtszw$elm_xml_decode$Xml$Decode$maybe($ymtszw$elm_xml_decode$Xml$Decode$string))),
	A2(
		$ymtszw$elm_xml_decode$Xml$Decode$path,
		_List_fromArray(
			['rtept']),
		$ymtszw$elm_xml_decode$Xml$Decode$list($author$project$Gpx$Decode$latLongDecoder)));
var $author$project$Gpx$Decode$Track = F2(
	function (name, segments) {
		return {name: name, segments: segments};
	});
var $ymtszw$elm_xml_decode$Xml$Decode$failImpl = F2(
	function (message, aNode) {
		return $elm$core$Result$Err(
			A2($ymtszw$elm_xml_decode$Xml$Decode$Failure, message, aNode));
	});
var $ymtszw$elm_xml_decode$Xml$Decode$fail = function (message) {
	return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
		$ymtszw$elm_xml_decode$Xml$Decode$failImpl(message));
};
var $ymtszw$elm_xml_decode$Xml$Decode$andThenImpl = F3(
	function (decoderBGen, _v0, aNode) {
		var decoderA = _v0.a;
		var _v1 = decoderA(aNode);
		if (_v1.$ === 'Ok') {
			var valA = _v1.a;
			var _v2 = decoderBGen(valA);
			var decoderB = _v2.a;
			return decoderB(aNode);
		} else {
			var e = _v1.a;
			return $elm$core$Result$Err(e);
		}
	});
var $ymtszw$elm_xml_decode$Xml$Decode$andThen = F2(
	function (decoderBGen, decoderA) {
		return $ymtszw$elm_xml_decode$Xml$Decode$Decoder(
			A2($ymtszw$elm_xml_decode$Xml$Decode$andThenImpl, decoderBGen, decoderA));
	});
var $author$project$Gpx$Decode$TrackPoint = F2(
	function (point, time) {
		return {time: time, point: point};
	});
var $author$project$Gpx$Decode$trackPointDecoder = A3(
	$ymtszw$elm_xml_decode$Xml$Decode$map2,
	$author$project$Gpx$Decode$TrackPoint,
	$author$project$Gpx$Decode$latLongDecoder,
	A2(
		$ymtszw$elm_xml_decode$Xml$Decode$path,
		_List_fromArray(
			['time']),
		$ymtszw$elm_xml_decode$Xml$Decode$single(
			A2(
				$ymtszw$elm_xml_decode$Xml$Decode$andThen,
				function (s) {
					var _v0 = $jweir$elm_iso8601$ISO8601$fromString(s);
					if (_v0.$ === 'Ok') {
						var t = _v0.a;
						return $ymtszw$elm_xml_decode$Xml$Decode$succeed(
							$jweir$elm_iso8601$ISO8601$toPosix(t));
					} else {
						var e = _v0.a;
						return $ymtszw$elm_xml_decode$Xml$Decode$fail(e);
					}
				},
				$ymtszw$elm_xml_decode$Xml$Decode$string))));
var $author$project$Gpx$Decode$trackDecoder = A3(
	$ymtszw$elm_xml_decode$Xml$Decode$map2,
	$author$project$Gpx$Decode$Track,
	A2(
		$ymtszw$elm_xml_decode$Xml$Decode$path,
		_List_fromArray(
			['name']),
		$ymtszw$elm_xml_decode$Xml$Decode$single(
			$ymtszw$elm_xml_decode$Xml$Decode$maybe($ymtszw$elm_xml_decode$Xml$Decode$string))),
	A2(
		$ymtszw$elm_xml_decode$Xml$Decode$path,
		_List_fromArray(
			['trkseg']),
		$ymtszw$elm_xml_decode$Xml$Decode$list(
			A2(
				$ymtszw$elm_xml_decode$Xml$Decode$path,
				_List_fromArray(
					['trkpt']),
				$ymtszw$elm_xml_decode$Xml$Decode$list($author$project$Gpx$Decode$trackPointDecoder)))));
var $author$project$Gpx$Decode$Waypoint = F2(
	function (name, point) {
		return {name: name, point: point};
	});
var $author$project$Gpx$Decode$waypointDecoder = A3(
	$ymtszw$elm_xml_decode$Xml$Decode$map2,
	$author$project$Gpx$Decode$Waypoint,
	A2(
		$ymtszw$elm_xml_decode$Xml$Decode$path,
		_List_fromArray(
			['name']),
		$ymtszw$elm_xml_decode$Xml$Decode$single(
			$ymtszw$elm_xml_decode$Xml$Decode$maybe($ymtszw$elm_xml_decode$Xml$Decode$string))),
	$author$project$Gpx$Decode$latLongDecoder);
var $author$project$Gpx$Decode$decoder = A4(
	$ymtszw$elm_xml_decode$Xml$Decode$optionalPath,
	_List_fromArray(
		['trk']),
	$ymtszw$elm_xml_decode$Xml$Decode$list($author$project$Gpx$Decode$trackDecoder),
	_List_Nil,
	A4(
		$ymtszw$elm_xml_decode$Xml$Decode$optionalPath,
		_List_fromArray(
			['wpt']),
		$ymtszw$elm_xml_decode$Xml$Decode$list($author$project$Gpx$Decode$waypointDecoder),
		_List_Nil,
		A4(
			$ymtszw$elm_xml_decode$Xml$Decode$optionalPath,
			_List_fromArray(
				['rte']),
			$ymtszw$elm_xml_decode$Xml$Decode$list($author$project$Gpx$Decode$routeDecoder),
			_List_Nil,
			$ymtszw$elm_xml_decode$Xml$Decode$succeed($author$project$Gpx$Decode$Gpx))));
var $miniBill$elm_xml_parser$Common$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $miniBill$elm_xml_parser$Common$maybe = function (parser) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $elm$core$Maybe$Just, parser),
				$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$parser$Parser$BadRepeat = {$: 'BadRepeat'};
var $miniBill$elm_xml_parser$Common$repeat = F2(
	function (count, parser) {
		var n = count.a;
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (results) {
				return (_Utils_cmp(
					n,
					$elm$core$List$length(results)) < 1) ? $elm$parser$Parser$Advanced$succeed(results) : $elm$parser$Parser$Advanced$problem($elm$parser$Parser$BadRepeat);
			},
			A2(
				$elm$parser$Parser$Advanced$loop,
				_List_Nil,
				function (state) {
					return $elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$Advanced$map,
								function (r) {
									return $elm$parser$Parser$Advanced$Loop(
										A2(
											$elm$core$List$append,
											state,
											_List_fromArray(
												[r])));
								},
								parser),
								A2(
								$elm$parser$Parser$Advanced$map,
								function (_v1) {
									return $elm$parser$Parser$Advanced$Done(state);
								},
								$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0))
							]));
				}));
	});
var $miniBill$elm_xml_parser$Common$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $miniBill$elm_xml_parser$Common$comment = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0),
			$elm$parser$Parser$Advanced$token(
				$miniBill$elm_xml_parser$Common$toToken('<!--'))),
		$elm$parser$Parser$Advanced$chompUntil(
			$miniBill$elm_xml_parser$Common$toToken('-->'))),
	$elm$parser$Parser$Advanced$token(
		$miniBill$elm_xml_parser$Common$toToken('-->')));
var $miniBill$elm_xml_parser$Common$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $miniBill$elm_xml_parser$Common$keep = F2(
	function (count, predicate) {
		var n = count.a;
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (str) {
				return (_Utils_cmp(
					n,
					$elm$core$String$length(str)) < 1) ? $elm$parser$Parser$Advanced$succeed(str) : $elm$parser$Parser$Advanced$problem($elm$parser$Parser$BadRepeat);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0),
					$elm$parser$Parser$Advanced$chompWhile(predicate))));
	});
var $miniBill$elm_xml_parser$Common$AtLeast = function (a) {
	return {$: 'AtLeast', a: a};
};
var $miniBill$elm_xml_parser$Common$oneOrMore = $miniBill$elm_xml_parser$Common$AtLeast(1);
var $miniBill$elm_xml_parser$XmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$inContext,
	'tagName',
	A2(
		$miniBill$elm_xml_parser$Common$keep,
		$miniBill$elm_xml_parser$Common$oneOrMore,
		function (c) {
			switch (c.valueOf()) {
				case '/':
					return false;
				case '<':
					return false;
				case '>':
					return false;
				case '"':
					return false;
				case '\'':
					return false;
				case '=':
					return false;
				case ' ':
					return false;
				case '\r':
					return false;
				case '\n':
					return false;
				case '\t':
					return false;
				default:
					return true;
			}
		}));
var $miniBill$elm_xml_parser$Common$ignore = F2(
	function (count, predicate) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			A2($miniBill$elm_xml_parser$Common$keep, count, predicate));
	});
var $miniBill$elm_xml_parser$Common$zeroOrMore = $miniBill$elm_xml_parser$Common$AtLeast(0);
var $miniBill$elm_xml_parser$Common$isWhitespace = function (c) {
	switch (c.valueOf()) {
		case ' ':
			return true;
		case '\r':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $miniBill$elm_xml_parser$Common$whiteSpace = A2($miniBill$elm_xml_parser$Common$ignore, $miniBill$elm_xml_parser$Common$zeroOrMore, $miniBill$elm_xml_parser$Common$isWhitespace);
var $miniBill$elm_xml_parser$DtdParser$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $miniBill$elm_xml_parser$DtdParser$Public = F3(
	function (a, b, c) {
		return {$: 'Public', a: a, b: b, c: c};
	});
var $miniBill$elm_xml_parser$DtdParser$System = F2(
	function (a, b) {
		return {$: 'System', a: a, b: b};
	});
var $miniBill$elm_xml_parser$Common$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $miniBill$elm_xml_parser$XmlParser$singleOrDoubleQuote = A2(
	$elm$parser$Parser$Advanced$inContext,
	'singleOrDoubleQuote',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					_Utils_chr('"')),
				$miniBill$elm_xml_parser$Common$symbol('\u0022')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					_Utils_chr('\'')),
				$miniBill$elm_xml_parser$Common$symbol('\u0027'))
			])));
var $miniBill$elm_xml_parser$XmlParser$quotedString = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (quoteChar) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$miniBill$elm_xml_parser$Common$keep,
					$miniBill$elm_xml_parser$Common$zeroOrMore,
					function (c) {
						return !_Utils_eq(c, quoteChar);
					}),
				$miniBill$elm_xml_parser$Common$symbol(
					$elm$core$String$fromChar(quoteChar))));
	},
	$miniBill$elm_xml_parser$XmlParser$singleOrDoubleQuote);
var $miniBill$elm_xml_parser$XmlParser$publicIdentifier = A2($elm$parser$Parser$Advanced$inContext, 'publicIdentifier', $miniBill$elm_xml_parser$XmlParser$quotedString);
var $miniBill$elm_xml_parser$XmlParser$docTypeExternalSubset = A2($elm$parser$Parser$Advanced$inContext, 'docTypeExternalSubset', $miniBill$elm_xml_parser$XmlParser$quotedString);
var $miniBill$elm_xml_parser$Common$whiteSpace1 = A2($miniBill$elm_xml_parser$Common$ignore, $miniBill$elm_xml_parser$Common$oneOrMore, $miniBill$elm_xml_parser$Common$isWhitespace);
var $miniBill$elm_xml_parser$DtdParser$Entity = F2(
	function (a, b) {
		return {$: 'Entity', a: a, b: b};
	});
var $miniBill$elm_xml_parser$Common$attributeName = A2(
	$elm$parser$Parser$Advanced$inContext,
	'attributeName',
	A2(
		$miniBill$elm_xml_parser$Common$keep,
		$miniBill$elm_xml_parser$Common$oneOrMore,
		function (c) {
			switch (c.valueOf()) {
				case '/':
					return false;
				case '<':
					return false;
				case '>':
					return false;
				case '"':
					return false;
				case '\'':
					return false;
				case '=':
					return false;
				case ' ':
					return false;
				case '\r':
					return false;
				case '\n':
					return false;
				case '\t':
					return false;
				default:
					return true;
			}
		}));
var $miniBill$elm_xml_parser$Common$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $miniBill$elm_xml_parser$Common$decodeEscape = F2(
	function (entities, s) {
		if (A2($elm$core$String$startsWith, '#x', s)) {
			var _v0 = $rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s));
			if (_v0.$ === 'Ok') {
				var code = _v0.a;
				return $elm$core$Result$Ok(
					$elm$core$String$fromChar(
						$elm$core$Char$fromCode(code)));
			} else {
				var e = _v0.a;
				return $elm$core$Result$Err(
					$elm$parser$Parser$Problem(e));
			}
		} else {
			if (A2($elm$core$String$startsWith, '#', s)) {
				var _v1 = $elm$core$String$toInt(
					A2($elm$core$String$dropLeft, 1, s));
				if (_v1.$ === 'Just') {
					var code = _v1.a;
					return $elm$core$Result$Ok(
						$elm$core$String$fromChar(
							$elm$core$Char$fromCode(code)));
				} else {
					return $elm$core$Result$Err(
						$elm$parser$Parser$Problem('Invalid escaped character: ' + s));
				}
			} else {
				var _v2 = A2($elm$core$Dict$get, s, entities);
				if (_v2.$ === 'Just') {
					var entity = _v2.a;
					return $elm$core$Result$Ok(entity);
				} else {
					return $elm$core$Result$Err(
						$elm$parser$Parser$Problem('No entity named \u0022&' + (s + ';\u0022 found.')));
				}
			}
		}
	});
var $miniBill$elm_xml_parser$Common$escapedChar = F2(
	function (entities, end_) {
		var endCode = $elm$core$Char$toCode(end_);
		return A2(
			$elm$parser$Parser$Advanced$inContext,
			'escapedChar',
			A2(
				$elm$parser$Parser$Advanced$andThen,
				function (s) {
					return $elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$Advanced$andThen,
								function (_v1) {
									var _v2 = A2($miniBill$elm_xml_parser$Common$decodeEscape, entities, s);
									if (_v2.$ === 'Ok') {
										var c = _v2.a;
										return $elm$parser$Parser$Advanced$succeed(c);
									} else {
										var e = _v2.a;
										return $elm$parser$Parser$Advanced$problem(e);
									}
								},
								$miniBill$elm_xml_parser$Common$symbol(';')),
								$miniBill$elm_xml_parser$Common$fail('Entities must end_ with \u0022;\u0022: &' + s)
							]));
				},
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$miniBill$elm_xml_parser$Common$symbol('&')),
					A2(
						$miniBill$elm_xml_parser$Common$keep,
						$miniBill$elm_xml_parser$Common$oneOrMore,
						function (c) {
							if (';' === c.valueOf()) {
								return false;
							} else {
								return !(!($elm$core$Char$toCode(c) - endCode));
							}
						}))));
	});
var $miniBill$elm_xml_parser$Common$textString = F2(
	function (entities, end_) {
		var endCode = $elm$core$Char$toCode(end_);
		return A2(
			$elm$parser$Parser$Advanced$inContext,
			'textString',
			A2(
				$elm$parser$Parser$Advanced$loop,
				_List_Nil,
				function (acc) {
					return $elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$Advanced$keeper,
								$elm$parser$Parser$Advanced$succeed(
									function (c) {
										return $elm$parser$Parser$Advanced$Loop(
											A2($elm$core$List$cons, c, acc));
									}),
								A2($miniBill$elm_xml_parser$Common$escapedChar, entities, end_)),
								A2(
								$elm$parser$Parser$Advanced$keeper,
								$elm$parser$Parser$Advanced$succeed(
									function (s) {
										return $elm$parser$Parser$Advanced$Loop(
											A2($elm$core$List$cons, s, acc));
									}),
								A2(
									$miniBill$elm_xml_parser$Common$keep,
									$miniBill$elm_xml_parser$Common$oneOrMore,
									function (c) {
										if ('&' === c.valueOf()) {
											return false;
										} else {
											return !(!($elm$core$Char$toCode(c) - endCode));
										}
									})),
								$elm$parser$Parser$Advanced$succeed(
								$elm$parser$Parser$Advanced$Done(
									$elm$core$String$concat(
										$elm$core$List$reverse(acc))))
							]));
				}));
	});
var $miniBill$elm_xml_parser$Common$attributeValue = function (entities) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'attributeValue',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$miniBill$elm_xml_parser$Common$symbol('\u0022')),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$miniBill$elm_xml_parser$Common$textString,
							entities,
							_Utils_chr('"')),
						$miniBill$elm_xml_parser$Common$symbol('\u0022'))),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$miniBill$elm_xml_parser$Common$symbol('\u0027')),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$miniBill$elm_xml_parser$Common$textString,
							entities,
							_Utils_chr('\'')),
						$miniBill$elm_xml_parser$Common$symbol('\u0027')))
				])));
};
var $miniBill$elm_xml_parser$Common$defaultEntities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\u0027'),
			_Utils_Tuple2('quot', '\u0022')
		]));
var $miniBill$elm_xml_parser$DtdParser$entityParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'entity',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$DtdParser$Entity),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$miniBill$elm_xml_parser$Common$attributeName,
				A2($elm$parser$Parser$Advanced$inContext, 'spacer', $miniBill$elm_xml_parser$Common$whiteSpace1))),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$miniBill$elm_xml_parser$Common$attributeValue($miniBill$elm_xml_parser$Common$defaultEntities),
			$miniBill$elm_xml_parser$Common$whiteSpace)));
var $miniBill$elm_xml_parser$DtdParser$Unimplemented = F2(
	function (a, b) {
		return {$: 'Unimplemented', a: a, b: b};
	});
var $miniBill$elm_xml_parser$DtdParser$elementParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'element',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2(
					$miniBill$elm_xml_parser$Common$repeat,
					$miniBill$elm_xml_parser$Common$zeroOrMore,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[$miniBill$elm_xml_parser$Common$whiteSpace1, $miniBill$elm_xml_parser$Common$comment])))),
			$miniBill$elm_xml_parser$Common$symbol('<!')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
									$miniBill$elm_xml_parser$Common$keyword('ENTITY')),
								$miniBill$elm_xml_parser$Common$whiteSpace1),
							$miniBill$elm_xml_parser$DtdParser$entityParser),
							A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$keeper,
								$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$DtdParser$Unimplemented),
								A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$Common$attributeName, $miniBill$elm_xml_parser$Common$whiteSpace1)),
							$elm$parser$Parser$Advanced$getChompedString(
								$elm$parser$Parser$Advanced$chompUntil(
									$miniBill$elm_xml_parser$Common$toToken('>'))))
						])),
				$miniBill$elm_xml_parser$Common$symbol('>')),
			A2(
				$miniBill$elm_xml_parser$Common$repeat,
				$miniBill$elm_xml_parser$Common$zeroOrMore,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[$miniBill$elm_xml_parser$Common$whiteSpace1, $miniBill$elm_xml_parser$Common$comment]))))));
var $miniBill$elm_xml_parser$DtdParser$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'dtd',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		A2($miniBill$elm_xml_parser$Common$repeat, $miniBill$elm_xml_parser$Common$zeroOrMore, $miniBill$elm_xml_parser$DtdParser$elementParser)));
var $miniBill$elm_xml_parser$XmlParser$docTypeInternalSubset = A2(
	$elm$parser$Parser$Advanced$inContext,
	'docTypeInternalSubset',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$miniBill$elm_xml_parser$Common$symbol('[')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$miniBill$elm_xml_parser$DtdParser$parser,
			$miniBill$elm_xml_parser$Common$symbol(']'))));
var $miniBill$elm_xml_parser$XmlParser$docTypeDefinition = A2(
	$elm$parser$Parser$Advanced$inContext,
	'docTypeDefinition',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$DtdParser$Public),
								$miniBill$elm_xml_parser$Common$keyword('PUBLIC')),
							$miniBill$elm_xml_parser$Common$whiteSpace),
						A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$XmlParser$publicIdentifier, $miniBill$elm_xml_parser$Common$whiteSpace)),
					A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$XmlParser$docTypeExternalSubset, $miniBill$elm_xml_parser$Common$whiteSpace)),
				$miniBill$elm_xml_parser$Common$maybe($miniBill$elm_xml_parser$XmlParser$docTypeInternalSubset)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$DtdParser$System),
							$miniBill$elm_xml_parser$Common$keyword('SYSTEM')),
						$miniBill$elm_xml_parser$Common$whiteSpace),
					A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$XmlParser$docTypeExternalSubset, $miniBill$elm_xml_parser$Common$whiteSpace)),
				$miniBill$elm_xml_parser$Common$maybe($miniBill$elm_xml_parser$XmlParser$docTypeInternalSubset)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$DtdParser$Custom),
				$miniBill$elm_xml_parser$XmlParser$docTypeInternalSubset)
			])));
var $miniBill$elm_xml_parser$XmlParser$docType = A2(
	$elm$parser$Parser$Advanced$inContext,
	'docType',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F2(
							function (rootElementName, definition) {
								return {definition: definition, rootElementName: rootElementName};
							})),
					$miniBill$elm_xml_parser$Common$symbol('<!DOCTYPE')),
				$miniBill$elm_xml_parser$Common$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$XmlParser$tagName, $miniBill$elm_xml_parser$Common$whiteSpace)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$XmlParser$docTypeDefinition, $miniBill$elm_xml_parser$Common$whiteSpace),
			$miniBill$elm_xml_parser$Common$symbol('>'))));
var $miniBill$elm_xml_parser$XmlParser$Text = function (a) {
	return {$: 'Text', a: a};
};
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v0 = thunk(_Utils_Tuple0);
			var parse = _v0.a;
			return parse(s);
		});
};
var $miniBill$elm_xml_parser$XmlParser$Element = F3(
	function (a, b, c) {
		return {$: 'Element', a: a, b: b, c: c};
	});
var $miniBill$elm_xml_parser$XmlParser$Attribute = F2(
	function (name, value) {
		return {name: name, value: value};
	});
var $miniBill$elm_xml_parser$XmlParser$attribute = function (entities) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'attribute',
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$XmlParser$Attribute),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$Common$attributeName, $miniBill$elm_xml_parser$Common$whiteSpace),
						$miniBill$elm_xml_parser$Common$symbol('=')),
					$miniBill$elm_xml_parser$Common$whiteSpace)),
			$miniBill$elm_xml_parser$Common$attributeValue(entities)));
};
var $miniBill$elm_xml_parser$XmlParser$attributes = function (entities) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'attributes',
		A2(
			$elm$parser$Parser$Advanced$loop,
			_Utils_Tuple2($elm$core$Set$empty, _List_Nil),
			function (_v0) {
				var keys = _v0.a;
				var acc = _v0.b;
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$andThen,
							function (attr) {
								return A2($elm$core$Set$member, attr.name, keys) ? $miniBill$elm_xml_parser$Common$fail('attribute ' + (attr.name + ' is duplicated')) : A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(
										$elm$parser$Parser$Advanced$Loop(
											_Utils_Tuple2(
												A2($elm$core$Set$insert, attr.name, keys),
												A2($elm$core$List$cons, attr, acc)))),
									$miniBill$elm_xml_parser$Common$whiteSpace);
							},
							$miniBill$elm_xml_parser$XmlParser$attribute(entities)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(acc)))
						]));
			}));
};
var $miniBill$elm_xml_parser$XmlParser$closingTag = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'closingTag',
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0),
							$miniBill$elm_xml_parser$Common$symbol('</')),
						$miniBill$elm_xml_parser$Common$whiteSpace),
					A2(
						$elm$parser$Parser$Advanced$andThen,
						function (endTagName) {
							return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(_Utils_Tuple0) : $miniBill$elm_xml_parser$Common$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
						},
						$miniBill$elm_xml_parser$XmlParser$tagName)),
				$miniBill$elm_xml_parser$Common$whiteSpace),
			$miniBill$elm_xml_parser$Common$symbol('>')));
};
var $miniBill$elm_xml_parser$XmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$inContext,
	'cdata',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$miniBill$elm_xml_parser$Common$symbol('<![CDATA[')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompUntil(
					$miniBill$elm_xml_parser$Common$toToken(']]>'))),
			$miniBill$elm_xml_parser$Common$symbol(']]>'))));
var $miniBill$elm_xml_parser$XmlParser$textNodeString = function (entities) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'textNodeString',
		A2(
			$elm$parser$Parser$Advanced$loop,
			$elm$core$Maybe$Nothing,
			function (acc) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$keeper,
							$elm$parser$Parser$Advanced$succeed(
								function (c) {
									return $elm$parser$Parser$Advanced$Loop(
										$elm$core$Maybe$Just(
											A2(
												$elm$core$List$cons,
												c,
												A2($elm$core$Maybe$withDefault, _List_Nil, acc))));
								}),
							A2(
								$miniBill$elm_xml_parser$Common$escapedChar,
								entities,
								_Utils_chr('<'))),
							A2(
							$elm$parser$Parser$Advanced$keeper,
							$elm$parser$Parser$Advanced$succeed(
								function (s) {
									return $elm$parser$Parser$Advanced$Loop(
										$elm$core$String$isEmpty(s) ? acc : $elm$core$Maybe$Just(
											A2(
												$elm$core$List$cons,
												s,
												A2($elm$core$Maybe$withDefault, _List_Nil, acc))));
								}),
							$miniBill$elm_xml_parser$XmlParser$cdata),
							A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed(
								$elm$parser$Parser$Advanced$Loop(acc)),
							$miniBill$elm_xml_parser$Common$comment),
							A2(
							$elm$parser$Parser$Advanced$keeper,
							$elm$parser$Parser$Advanced$succeed(
								function (s) {
									return $elm$parser$Parser$Advanced$Loop(
										$elm$core$Maybe$Just(
											A2(
												$elm$core$List$cons,
												s,
												A2($elm$core$Maybe$withDefault, _List_Nil, acc))));
								}),
							A2(
								$miniBill$elm_xml_parser$Common$keep,
								$miniBill$elm_xml_parser$Common$oneOrMore,
								function (c) {
									switch (c.valueOf()) {
										case '<':
											return false;
										case '&':
											return false;
										default:
											return true;
									}
								})),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								A2(
									$elm$core$Maybe$map,
									function (segments) {
										return $elm$core$String$concat(
											$elm$core$List$reverse(segments));
									},
									acc)))
						]));
			}));
};
var $miniBill$elm_xml_parser$XmlParser$element = function (entities) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'element',
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$miniBill$elm_xml_parser$Common$symbol('<')),
			A2(
				$elm$parser$Parser$Advanced$andThen,
				function (startTagName) {
					return A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(
									$miniBill$elm_xml_parser$XmlParser$Element(startTagName)),
								$miniBill$elm_xml_parser$Common$whiteSpace),
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$miniBill$elm_xml_parser$XmlParser$attributes(entities),
								$miniBill$elm_xml_parser$Common$whiteSpace)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(_List_Nil),
									$miniBill$elm_xml_parser$Common$symbol('/>')),
									A2(
									$elm$parser$Parser$Advanced$keeper,
									A2(
										$elm$parser$Parser$Advanced$ignorer,
										$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
										$miniBill$elm_xml_parser$Common$symbol('>')),
									$elm$parser$Parser$Advanced$lazy(
										function (_v2) {
											return A2($miniBill$elm_xml_parser$XmlParser$children, entities, startTagName);
										}))
								])));
				},
				$miniBill$elm_xml_parser$XmlParser$tagName)));
};
var $miniBill$elm_xml_parser$XmlParser$children = F2(
	function (entities, startTagName) {
		return A2(
			$elm$parser$Parser$Advanced$inContext,
			'children',
			A2(
				$elm$parser$Parser$Advanced$loop,
				_List_Nil,
				function (acc) {
					return $elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Done(
										$elm$core$List$reverse(acc))),
								$miniBill$elm_xml_parser$XmlParser$closingTag(startTagName)),
								A2(
								$elm$parser$Parser$Advanced$andThen,
								function (maybeString) {
									if (maybeString.$ === 'Just') {
										var s = maybeString.a;
										return $elm$parser$Parser$Advanced$succeed(
											$elm$parser$Parser$Advanced$Loop(
												A2(
													$elm$core$List$cons,
													$miniBill$elm_xml_parser$XmlParser$Text(s),
													acc)));
									} else {
										return A2(
											$elm$parser$Parser$Advanced$ignorer,
											$elm$parser$Parser$Advanced$succeed(
												$elm$parser$Parser$Advanced$Done(
													$elm$core$List$reverse(acc))),
											$miniBill$elm_xml_parser$XmlParser$closingTag(startTagName));
									}
								},
								$miniBill$elm_xml_parser$XmlParser$textNodeString(entities)),
								$elm$parser$Parser$Advanced$lazy(
								function (_v1) {
									return A2(
										$elm$parser$Parser$Advanced$keeper,
										$elm$parser$Parser$Advanced$succeed(
											function (e) {
												return $elm$parser$Parser$Advanced$Loop(
													A2($elm$core$List$cons, e, acc));
											}),
										$miniBill$elm_xml_parser$XmlParser$element(entities));
								})
							]));
				}));
	});
var $miniBill$elm_xml_parser$XmlParser$ProcessingInstruction = F2(
	function (name, value) {
		return {name: name, value: value};
	});
var $miniBill$elm_xml_parser$XmlParser$processingInstructionName = A2(
	$elm$parser$Parser$Advanced$inContext,
	'processingInstructionName',
	A2(
		$miniBill$elm_xml_parser$Common$keep,
		$miniBill$elm_xml_parser$Common$oneOrMore,
		function (c) {
			if (' ' === c.valueOf()) {
				return false;
			} else {
				return true;
			}
		}));
function $miniBill$elm_xml_parser$XmlParser$cyclic$processingInstructionValue() {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'processingInstructionValue',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(''),
					$miniBill$elm_xml_parser$Common$symbol('?>')),
					A2(
					$elm$parser$Parser$Advanced$andThen,
					function (_v0) {
						return A2(
							$elm$parser$Parser$Advanced$map,
							function (tail) {
								return '?' + tail;
							},
							$miniBill$elm_xml_parser$XmlParser$cyclic$processingInstructionValue());
					},
					$miniBill$elm_xml_parser$Common$symbol('?')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$append),
						A2(
							$miniBill$elm_xml_parser$Common$keep,
							$miniBill$elm_xml_parser$Common$zeroOrMore,
							function (c) {
								if ('?' === c.valueOf()) {
									return false;
								} else {
									return true;
								}
							})),
					$elm$parser$Parser$Advanced$lazy(
						function (_v2) {
							return $miniBill$elm_xml_parser$XmlParser$cyclic$processingInstructionValue();
						}))
				])));
}
try {
	var $miniBill$elm_xml_parser$XmlParser$processingInstructionValue = $miniBill$elm_xml_parser$XmlParser$cyclic$processingInstructionValue();
	$miniBill$elm_xml_parser$XmlParser$cyclic$processingInstructionValue = function () {
		return $miniBill$elm_xml_parser$XmlParser$processingInstructionValue;
	};
} catch ($) {
	throw 'Some top-level definitions from `XmlParser` are causing infinite recursion:\n\n  ┌─────┐\n  │    processingInstructionValue\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $miniBill$elm_xml_parser$XmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$inContext,
	'processingInstruction',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($miniBill$elm_xml_parser$XmlParser$ProcessingInstruction),
				$miniBill$elm_xml_parser$Common$symbol('<?')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$miniBill$elm_xml_parser$XmlParser$processingInstructionName,
				$miniBill$elm_xml_parser$Common$symbol(' '))),
		$miniBill$elm_xml_parser$XmlParser$processingInstructionValue));
var $miniBill$elm_xml_parser$XmlParser$xml = function () {
	var headerParser = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (processingInstructions, maybeDocType) {
						return {maybeDocType: maybeDocType, processingInstructions: processingInstructions};
					})),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$miniBill$elm_xml_parser$Common$repeat,
					$miniBill$elm_xml_parser$Common$zeroOrMore,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						A2($elm$parser$Parser$Advanced$ignorer, $miniBill$elm_xml_parser$XmlParser$processingInstruction, $miniBill$elm_xml_parser$Common$whiteSpace))),
				A2(
					$miniBill$elm_xml_parser$Common$repeat,
					$miniBill$elm_xml_parser$Common$zeroOrMore,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[$miniBill$elm_xml_parser$Common$whiteSpace1, $miniBill$elm_xml_parser$Common$comment]))))),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$miniBill$elm_xml_parser$Common$maybe($miniBill$elm_xml_parser$XmlParser$docType),
			A2(
				$miniBill$elm_xml_parser$Common$repeat,
				$miniBill$elm_xml_parser$Common$zeroOrMore,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[$miniBill$elm_xml_parser$Common$whiteSpace1, $miniBill$elm_xml_parser$Common$comment])))));
	var bodyParser = function (_v9) {
		var maybeDocType = _v9.maybeDocType;
		var processingInstructions = _v9.processingInstructions;
		var go = function (dtd) {
			return A3(
				$elm$core$List$foldl,
				function (_v8) {
					var k = _v8.a;
					var v = _v8.b;
					return A2($elm$core$Dict$insert, k, v);
				},
				$miniBill$elm_xml_parser$Common$defaultEntities,
				A2(
					$elm$core$List$filterMap,
					function (d) {
						if (d.$ === 'Entity') {
							var k = d.a;
							var v = d.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(k, v));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					dtd));
		};
		var entities = function () {
			var _v0 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.definition;
				},
				maybeDocType);
			if (_v0.$ === 'Just') {
				switch (_v0.a.$) {
					case 'Custom':
						var dtd = _v0.a.a;
						return go(dtd);
					case 'Public':
						if (_v0.a.c.$ === 'Just') {
							var _v1 = _v0.a;
							var dtd = _v1.c.a;
							return go(dtd);
						} else {
							var _v3 = _v0.a;
							var _v4 = _v3.c;
							return $miniBill$elm_xml_parser$Common$defaultEntities;
						}
					default:
						if (_v0.a.b.$ === 'Just') {
							var _v2 = _v0.a;
							var dtd = _v2.b.a;
							return go(dtd);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v5.b;
							return $miniBill$elm_xml_parser$Common$defaultEntities;
						}
				}
			} else {
				return $miniBill$elm_xml_parser$Common$defaultEntities;
			}
		}();
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed(
				function (root) {
					return {root: root, docType: maybeDocType, processingInstructions: processingInstructions};
				}),
			$miniBill$elm_xml_parser$XmlParser$element(entities));
	};
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'xml',
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$miniBill$elm_xml_parser$Common$whiteSpace),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2($elm$parser$Parser$Advanced$andThen, bodyParser, headerParser),
					A2(
						$miniBill$elm_xml_parser$Common$repeat,
						$miniBill$elm_xml_parser$Common$zeroOrMore,
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[$miniBill$elm_xml_parser$Common$whiteSpace1, $miniBill$elm_xml_parser$Common$comment])))),
				$miniBill$elm_xml_parser$Common$end)));
}();
var $miniBill$elm_xml_parser$XmlParser$parse = function (source) {
	return A2($elm$parser$Parser$Advanced$run, $miniBill$elm_xml_parser$XmlParser$xml, source);
};
var $ymtszw$elm_xml_decode$Xml$Decode$decodeXml = F2(
	function (_v0, _v1) {
		var decoder = _v0.a;
		var root = _v1.root;
		return decoder(root);
	});
var $ymtszw$elm_xml_decode$Xml$Decode$Internal$escape = function (s) {
	var reducer = function (_char) {
		switch (_char.valueOf()) {
			case '&':
				return $elm$core$String$append('&amp;');
			case '<':
				return $elm$core$String$append('&lt;');
			case '>':
				return $elm$core$String$append('&gt;');
			case '"':
				return $elm$core$String$append('&quot;');
			case '\'':
				return $elm$core$String$append('&apos;');
			default:
				var c = _char;
				return $elm$core$String$cons(c);
		}
	};
	return A3($elm$core$String$foldr, reducer, '', s);
};
var $ymtszw$elm_xml_decode$Xml$Decode$Internal$formatAttribute = function (attribute) {
	return $ymtszw$elm_xml_decode$Xml$Decode$Internal$escape(attribute.name) + ('=\u0022' + ($ymtszw$elm_xml_decode$Xml$Decode$Internal$escape(attribute.value) + '\u0022'));
};
var $ymtszw$elm_xml_decode$Xml$Decode$Internal$attributesToString = function (attrs) {
	if (!attrs.b) {
		return '';
	} else {
		return ' ' + A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $ymtszw$elm_xml_decode$Xml$Decode$Internal$formatAttribute, attrs));
	}
};
var $ymtszw$elm_xml_decode$Xml$Decode$Internal$formatNode = function (node) {
	if (node.$ === 'Element') {
		var tagName = node.a;
		var attrs = node.b;
		var children = node.c;
		return '<' + ($ymtszw$elm_xml_decode$Xml$Decode$Internal$escape(tagName) + ($ymtszw$elm_xml_decode$Xml$Decode$Internal$attributesToString(attrs) + ('>' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, $ymtszw$elm_xml_decode$Xml$Decode$Internal$formatNode, children)) + ('</' + ($ymtszw$elm_xml_decode$Xml$Decode$Internal$escape(tagName) + '>'))))));
	} else {
		var s = node.a;
		return $ymtszw$elm_xml_decode$Xml$Decode$Internal$escape(s);
	}
};
var $ymtszw$elm_xml_decode$Xml$Decode$errorToRows = function (error) {
	switch (error.$) {
		case 'Path':
			var path_ = error.a;
			var innerError = error.b;
			return A2(
				$elm$core$List$cons,
				'Path: /' + A2($elm$core$String$join, '/', path_),
				$ymtszw$elm_xml_decode$Xml$Decode$errorToRows(innerError));
		case 'OneOf':
			if (!error.a.b) {
				return _List_fromArray(
					['No decoders available.']);
			} else {
				var innerErrors = error.a;
				var indentRow = F3(
					function (outerIndex, innerIndex, row) {
						return (!innerIndex) ? (A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr(' '),
							$elm$core$String$fromInt(outerIndex)) + (') ' + row)) : ('    ' + row);
					});
				var genChildRows = function (outerIndex) {
					return A2(
						$elm$core$Basics$composeR,
						$ymtszw$elm_xml_decode$Xml$Decode$errorToRows,
						$elm$core$List$indexedMap(
							indentRow(outerIndex + 1)));
				};
				var innerRows = $elm$core$List$concat(
					A2($elm$core$List$indexedMap, genChildRows, innerErrors));
				return A2($elm$core$List$cons, 'All decoders failed:', innerRows);
			}
		default:
			var problem = error.a;
			var aNode = error.b;
			return _List_fromArray(
				[
					'Node: ' + $ymtszw$elm_xml_decode$Xml$Decode$Internal$formatNode(aNode),
					problem
				]);
	}
};
var $ymtszw$elm_xml_decode$Xml$Decode$errorToString = function (error) {
	return A2(
		$elm$core$String$join,
		'\u000A',
		$ymtszw$elm_xml_decode$Xml$Decode$errorToRows(error));
};
var $ymtszw$elm_xml_decode$Xml$Decode$parserProblemToString = function (problem) {
	switch (problem.$) {
		case 'Expecting':
			var expect = problem.a;
			return 'I was expecting: ' + expect;
		case 'ExpectingInt':
			return 'I was expecting an integer';
		case 'ExpectingHex':
			return 'I was expecting a hexadecimal';
		case 'ExpectingOctal':
			return 'I was expecting an octal';
		case 'ExpectingBinary':
			return 'I was expecting a binary';
		case 'ExpectingFloat':
			return 'I was expecting a float';
		case 'ExpectingNumber':
			return 'I was expecting a number';
		case 'ExpectingVariable':
			return 'I was expecting a variable';
		case 'ExpectingSymbol':
			var symbol = problem.a;
			return 'I was expecting a symbol: ' + symbol;
		case 'ExpectingKeyword':
			var keyword = problem.a;
			return 'I was expecting a keyword: ' + keyword;
		case 'ExpectingEnd':
			return 'I was expecting the end of input';
		case 'UnexpectedChar':
			return 'I got an unexpected character';
		case 'Problem':
			var text = problem.a;
			return text;
		default:
			return 'I got a bad repetition';
	}
};
var $ymtszw$elm_xml_decode$Xml$Decode$parseErrorsToString = function (deadEnds) {
	return A2(
		$elm$core$String$append,
		'Invalid XML document.\u000A',
		A2(
			$elm$core$String$join,
			'\u000A',
			A2(
				$elm$core$List$map,
				function (deadEnd) {
					return _Utils_ap(
						'At [' + ($elm$core$String$fromInt(deadEnd.row) + (',' + ($elm$core$String$fromInt(deadEnd.col) + '], '))),
						$ymtszw$elm_xml_decode$Xml$Decode$parserProblemToString(deadEnd.problem));
				},
				deadEnds)));
};
var $ymtszw$elm_xml_decode$Xml$Decode$decodeString = F2(
	function (decoder, s) {
		var _v0 = $miniBill$elm_xml_parser$XmlParser$parse(s);
		if (_v0.$ === 'Ok') {
			var xml = _v0.a;
			var _v1 = A2($ymtszw$elm_xml_decode$Xml$Decode$decodeXml, decoder, xml);
			if (_v1.$ === 'Ok') {
				var decoded = _v1.a;
				return $elm$core$Result$Ok(decoded);
			} else {
				var dErr = _v1.a;
				return $elm$core$Result$Err(
					$ymtszw$elm_xml_decode$Xml$Decode$errorToString(dErr));
			}
		} else {
			var pErr = _v0.a;
			return $elm$core$Result$Err(
				$ymtszw$elm_xml_decode$Xml$Decode$parseErrorsToString(pErr));
		}
	});
var $author$project$Gpx$Decode$decodeString = function (s) {
	return A2($ymtszw$elm_xml_decode$Xml$Decode$decodeString, $author$project$Gpx$Decode$decoder, s);
};
var $author$project$Pages$Fleet_$Routes$replaceRoute = F2(
	function (r, rs) {
		return A2(
			$elm$core$List$sortWith,
			$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
				function ($) {
					return $.name;
				}),
			A2(
				$elm$core$List$cons,
				r,
				A2(
					$elm$core$List$filter,
					function (r1) {
						return !_Utils_eq(r1.routeId, r.routeId);
					},
					rs)));
	});
var $author$project$Pages$Fleet_$Routes$OnDeleteRoute = function (a) {
	return {$: 'OnDeleteRoute', a: a};
};
var $author$project$Pages$Fleet_$Routes$OnGpxUploaded = function (a) {
	return {$: 'OnGpxUploaded', a: a};
};
var $author$project$Geospatial$MapProjection$degreesPerPixel = F2(
	function (lat, zoom) {
		return A2($author$project$Geospatial$MapProjection$metersPerPixel, lat, zoom) / 111320.0;
	});
var $author$project$Mapbox$Cmd$Template$changeDrawMode = F4(
	function (prt, id, mode, modeOptions) {
		return prt(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string(id)),
						_Utils_Tuple2(
						'command',
						$elm$json$Json$Encode$string('changeMode')),
						_Utils_Tuple2(
						'options',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mode',
									$elm$json$Json$Encode$string(mode)),
									_Utils_Tuple2(
									'options',
									A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, modeOptions))
								])))
					])));
	});
var $author$project$Ports$elmMapboxDrawOutgoing = _Platform_outgoingPort('elmMapboxDrawOutgoing', $elm$core$Basics$identity);
var $author$project$MapCommands$changeDrawMode = F2(
	function (mode, options) {
		return A4($author$project$Mapbox$Cmd$Template$changeDrawMode, $author$project$Ports$elmMapboxDrawOutgoing, $author$project$MapCommands$id, mode, options);
	});
var $author$project$Mapbox$Cmd$Template$addDrawFeatures = F3(
	function (prt, id, features) {
		return prt(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string(id)),
						_Utils_Tuple2(
						'command',
						$elm$json$Json$Encode$string('add')),
						_Utils_Tuple2('options', features)
					])));
	});
var $author$project$MapCommands$addDrawFeatures = function (features) {
	return A3($author$project$Mapbox$Cmd$Template$addDrawFeatures, $author$project$Ports$elmMapboxDrawOutgoing, $author$project$MapCommands$id, features);
};
var $author$project$Views$Mapbox$routeToDrawLayer = function (route) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Feature')),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Route$routeIdToString(route.routeId))),
				_Utils_Tuple2(
				'properties',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'isCircle',
							$elm$json$Json$Encode$bool(false)),
							_Utils_Tuple2(
							'isRoute',
							$elm$json$Json$Encode$bool(true))
						]))),
				_Utils_Tuple2(
				'geometry',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LineString')),
							_Utils_Tuple2(
							'coordinates',
							A2($elm$json$Json$Encode$list, $author$project$Views$Mapbox$latLongToGeoJSON, route.track))
						])))
			]));
};
var $author$project$Pages$Fleet_$Routes$startMapboxDrawEdit = function (route) {
	var selectCmd = A2(
		$author$project$MapCommands$changeDrawMode,
		'direct_select',
		$elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'featureId',
						$elm$json$Json$Encode$string(
							$author$project$Data$Route$routeIdToString(route.routeId)))
					]))));
	return $author$project$Effect$fromCmd(
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					selectCmd,
					$author$project$MapCommands$addDrawFeatures(
					$author$project$Views$Mapbox$routeToDrawLayer(route))
				])));
};
var $author$project$Mapbox$Cmd$Template$deleteAllDrawFeatures = F2(
	function (prt, id) {
		return prt(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'target',
						$elm$json$Json$Encode$string(id)),
						_Utils_Tuple2(
						'command',
						$elm$json$Json$Encode$string('deleteAll'))
					])));
	});
var $author$project$MapCommands$deleteAllDrawFeatures = function (_v0) {
	return A2($author$project$Mapbox$Cmd$Template$deleteAllDrawFeatures, $author$project$Ports$elmMapboxDrawOutgoing, $author$project$MapCommands$id);
};
var $author$project$Pages$Fleet_$Routes$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Effect$none);
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'OnResizeWindow':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Fleet_$Routes$OnGetMapElement,
							$elm$browser$Browser$Dom$getElement('map'))));
			case 'OnGetMapElement':
				if (msg.a.$ === 'Ok') {
					var element = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mapSize: _Utils_Tuple2(element.element.width, element.element.height)
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'MapIdle':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(b))
						}),
					$author$project$Effect$none);
			case 'MapClicked':
				var latLong = msg.a;
				var updatedModel = model.measureModeActive ? _Utils_update(
					model,
					{
						measureLine: _Utils_ap(
							model.measureLine,
							_List_fromArray(
								[
									{lat: latLong.lat, _long: latLong._long},
									{lat: latLong.lat, _long: latLong._long}
								]))
					}) : model;
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'MapMouseMove':
				var latLong = msg.a;
				if (model.measureModeActive) {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: _Utils_ap(
								$author$project$Pages$Fleet_$Routes$dropLast(model.measureLine),
								_List_fromArray(
									[
										{lat: latLong.lat, _long: latLong._long}
									]))
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'ControlClicked':
				var id = msg.a;
				if (id === 'measure') {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: model.measureModeActive ? _List_Nil : model.measureLine,
							measureModeActive: !model.measureModeActive
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'OnFetchGeofences':
				if (msg.a.$ === 'Ok') {
					var gs = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							geofences: A2(
								$elm$core$List$sortWith,
								$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
									function ($) {
										return $.name;
									}),
								gs)
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchRoutes':
				if (msg.a.$ === 'Ok') {
					var rs = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							routes: A2(
								$elm$core$List$sortWith,
								$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
									function ($) {
										return $.name;
									}),
								rs)
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'AddRoute':
				var side = A2(
					$author$project$Geospatial$MapProjection$degreesPerPixel,
					model.mapPosition.centre.lat,
					$elm$core$Basics$round(model.mapPosition.zoom)) * 200;
				var maxLat = model.mapPosition.centre.lat + (side / 2);
				var maxLng = model.mapPosition.centre._long + (side / 2);
				var minLat = model.mapPosition.centre.lat - (side / 2);
				var minLng = model.mapPosition.centre._long - (side / 2);
				var _new = {
					name: '',
					track: _List_fromArray(
						[
							{lat: minLat, _long: minLng},
							{lat: maxLat, _long: maxLng}
						]),
					routeId: $author$project$Views$RouteForm$newRouteId
				};
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 1, model.sheet),
						editingRoute: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$author$project$Views$RouteForm$init(_new),
								_new))
					});
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Pages$Fleet_$Routes$startMapboxDrawEdit(_new));
			case 'SelectRoute':
				var id = msg.a;
				if ($elm_community$maybe_extra$Maybe$Extra$isJust(model.editingRoute)) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					var selectedRoute = A2(
						$elm_community$list_extra$List$Extra$find,
						function (r) {
							return _Utils_eq(r.routeId, id);
						},
						model.routes);
					var updatedModel = _Utils_update(
						model,
						{
							sheet: A2(
								$author$project$Views$SidebarSheet$showPage,
								$elm_community$maybe_extra$Maybe$Extra$isJust(selectedRoute) ? 1 : 0,
								model.sheet),
							editingRoute: A2(
								$elm$core$Maybe$map,
								function (r) {
									return _Utils_Tuple2(
										$author$project$Views$RouteForm$init(r),
										r);
								},
								selectedRoute)
						});
					var bounds = A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.track;
							},
							$author$project$Geospatial$BoundingBox$fromLatLongs),
						selectedRoute);
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Effect$none,
									A2($elm$core$Maybe$map, $author$project$Pages$Fleet_$Routes$startMapboxDrawEdit, selectedRoute)),
									$author$project$Effect$fromCmd(
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											function (b) {
												return A2(
													$author$project$MapCommands$fitBounds,
													_List_fromArray(
														[
															$author$project$Mapbox$Cmd$Option$padding(
															{top: 50, left: 50, right: 50, bottom: 50}),
															$author$project$Mapbox$Cmd$Option$maxZoom(22)
														]),
													_Utils_Tuple2(
														{lat: b.southWest.lat, lng: b.southWest._long},
														{lat: b.northEast.lat, lng: b.northEast._long}));
											},
											bounds)))
								])));
				}
			case 'ChangeGeometry':
				var _v2 = msg.a;
				var id = _v2.a;
				var g = _v2.b;
				var _v3 = _Utils_Tuple2(model.editingRoute, g);
				if ((_v3.a.$ === 'Just') && (_v3.b.$ === 'Line')) {
					var _v4 = _v3.a.a;
					var form = _v4.a;
					var route = _v4.b;
					var ps = _v3.b.a;
					if (_Utils_eq(
						route.routeId,
						$author$project$Data$Route$routeIdFromString(id))) {
						var updatedRoute = _Utils_update(
							route,
							{track: ps});
						var updatedForm = A2($author$project$Views$RouteForm$updateTrack, ps, form);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editingRoute: $elm$core$Maybe$Just(
										_Utils_Tuple2(updatedForm, updatedRoute))
								}),
							$author$project$Effect$none);
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'FormMsg':
				var m = msg.a;
				var _v5 = model.editingRoute;
				if (_v5.$ === 'Just') {
					var _v6 = _v5.a;
					var form = _v6.a;
					var route = _v6.b;
					var updatedForm = A2($author$project$Views$RouteForm$update, m, form);
					var updatedRoute = A2(
						$elm$core$Maybe$withDefault,
						route,
						$author$project$Views$RouteForm$getOutput(updatedForm));
					var updatedModel = _Utils_update(
						model,
						{
							editingRoute: $elm$core$Maybe$Just(
								_Utils_Tuple2(updatedForm, updatedRoute))
						});
					switch (m.$) {
						case 'Submit':
							var _v8 = $author$project$Views$RouteForm$getOutput(updatedForm);
							if (_v8.$ === 'Just') {
								var r = _v8.a;
								return _Utils_Tuple2(
									_Utils_update(
										updatedModel,
										{isSaving: true}),
									$author$project$Effect$batch(
										_List_fromArray(
											[
												A5(
												_Utils_eq(r.routeId, $author$project$Views$RouteForm$newRouteId) ? $author$project$Api$postRoute : $author$project$Api$putRoute,
												session.authToken,
												model.apiUrl,
												model.fleet.slug,
												r,
												$author$project$Pages$Fleet_$Routes$OnSaveRoute),
												$author$project$Effect$fromCmd(
												$author$project$Ports$startProgressBar(_Utils_Tuple0))
											])));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										updatedModel,
										{
											error: $elm$core$Maybe$Just(
												{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'Unable to submit form'})
										}),
									$author$project$Effect$none);
							}
						case 'DeleteRoute':
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{showRouteDeleteWarning: true}),
								$author$project$Effect$none);
						case 'SelectFile':
							return _Utils_Tuple2(
								updatedModel,
								$author$project$Effect$fromCmd(
									A2(
										$elm$file$File$Select$file,
										_List_fromArray(
											['application/gpx+xml']),
										$author$project$Pages$Fleet_$Routes$OnSelectFile)));
						case 'ReverseTrack':
							return _Utils_Tuple2(
								updatedModel,
								$author$project$Pages$Fleet_$Routes$startMapboxDrawEdit(updatedRoute));
						case 'CancelEdit':
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{editingRoute: $elm$core$Maybe$Nothing}),
								$author$project$Effect$fromCmd(
									$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0)));
						default:
							return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'CancelEdit':
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
						editingRoute: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Effect$fromCmd(
						$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0)));
			case 'OnSaveRoute':
				if (msg.a.$ === 'Ok') {
					var route = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
							routes: A2($author$project$Pages$Fleet_$Routes$replaceRoute, route, model.routes),
							isSaving: false,
							editingRoute: $elm$core$Maybe$Nothing
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0),
										$author$project$Ports$completeProgressBar(_Utils_Tuple0)
									]))));
				} else {
					var e = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							error: $elm$core$Maybe$Just(
								{
									icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
									title: 'Error',
									type_: $author$project$Views$Alert$Danger,
									message: $author$project$Api$errorString(e)
								}),
							isSaving: false
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'PromptForDeletion':
				var _v9 = model.editingRoute;
				if (_v9.$ === 'Just') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isDeleting: false, showRouteDeleteWarning: true}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'DeleteRoute':
				var _v10 = model.editingRoute;
				if (_v10.$ === 'Just') {
					var _v11 = _v10.a;
					var r = _v11.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isDeleting: true, showRouteDeleteWarning: true}),
						A5($author$project$Api$deleteRoute, session.authToken, model.apiUrl, model.fleet.slug, r.routeId, $author$project$Pages$Fleet_$Routes$OnDeleteRoute));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnDeleteRoute':
				if (msg.a.$ === 'Ok') {
					var _v12 = model.editingRoute;
					if (_v12.$ === 'Just') {
						var _v13 = _v12.a;
						var r = _v13.b;
						var updatedModel = _Utils_update(
							model,
							{
								sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
								routes: A2(
									$elm$core$List$filter,
									function (r1) {
										return !_Utils_eq(r1.routeId, r.routeId);
									},
									model.routes),
								isDeleting: false,
								editingRoute: $elm$core$Maybe$Nothing,
								showRouteDeleteWarning: false
							});
						return _Utils_Tuple2(
							updatedModel,
							$author$project$Effect$fromCmd(
								$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isDeleting: false, showRouteDeleteWarning: false}),
							$author$project$Effect$none);
					}
				} else {
					var e = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							error: $elm$core$Maybe$Just(
								{
									icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
									title: 'Error',
									type_: $author$project$Views$Alert$Danger,
									message: $author$project$Api$errorString(e)
								}),
							isDeleting: false,
							showRouteDeleteWarning: false
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				}
			case 'OnSelectFile':
				var f = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Fleet_$Routes$OnGpxUploaded,
							A2(
								$elm$core$Task$andThen,
								function (s) {
									var _v14 = $author$project$Gpx$Decode$decodeString(s);
									if (_v14.$ === 'Ok') {
										var g = _v14.a;
										return $elm$core$Task$succeed(g);
									} else {
										var e = _v14.a;
										return $elm$core$Task$fail(e);
									}
								},
								$elm$file$File$toString(f)))));
			case 'OnGpxUploaded':
				if (msg.a.$ === 'Ok') {
					var gpx = msg.a.a;
					var values = function () {
						var _v19 = _Utils_Tuple2(
							$elm$core$List$head(gpx.routes),
							$elm$core$List$head(gpx.tracks));
						if (_v19.a.$ === 'Just') {
							var route = _v19.a.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(route.name, route.points));
						} else {
							if (_v19.b.$ === 'Just') {
								var track = _v19.b.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										track.name,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.point;
											},
											$elm$core$List$concat(track.segments))));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}();
					var _v15 = model.editingRoute;
					if (_v15.$ === 'Just') {
						var _v16 = _v15.a;
						var form = _v16.a;
						var route = _v16.b;
						if (values.$ === 'Just') {
							var _v18 = values.a;
							var track = _v18.b;
							var updatedRoute = A2(
								$elm$core$Maybe$withDefault,
								_Utils_update(
									route,
									{track: track}),
								$author$project$Views$RouteForm$getOutput(form));
							var updatedForm = A2($author$project$Views$RouteForm$updateTrack, track, form);
							var bounds = $author$project$Geospatial$BoundingBox$fromLatLongs(track);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										editingRoute: $elm$core$Maybe$Just(
											_Utils_Tuple2(updatedForm, updatedRoute))
									}),
								$author$project$Effect$batch(
									_List_fromArray(
										[
											$author$project$Pages$Fleet_$Routes$startMapboxDrawEdit(updatedRoute),
											$author$project$Effect$fromCmd(
											A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Platform$Cmd$none,
												A2(
													$elm$core$Maybe$map,
													function (b) {
														return A2(
															$author$project$MapCommands$fitBounds,
															_List_fromArray(
																[
																	$author$project$Mapbox$Cmd$Option$padding(
																	{top: 50, left: 50, right: 50, bottom: 50}),
																	$author$project$Mapbox$Cmd$Option$maxZoom(22)
																]),
															_Utils_Tuple2(
																{lat: b.southWest.lat, lng: b.southWest._long},
																{lat: b.northEast.lat, lng: b.northEast._long}));
													},
													bounds)))
										])));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										error: $elm$core$Maybe$Just(
											{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'No route data available in the GPX file'}),
										isDeleting: false,
										showRouteDeleteWarning: false
									}),
								$author$project$Effect$none);
						}
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'Unable to read GPX file: ' + e}),
								isDeleting: false,
								showRouteDeleteWarning: false
							}),
						$author$project$Effect$none);
				}
			case 'SheetMsg':
				var sheetMsg = msg.a;
				var _v20 = A3(
					$author$project$Views$SidebarSheet$update,
					$author$project$Pages$Fleet_$Routes$sheetConfig(model),
					sheetMsg,
					model.sheet);
				var updatedSheet = _v20.a;
				var cmd = _v20.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sheet: updatedSheet}),
					$author$project$Effect$fromCmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Routes$SheetMsg, cmd)));
			case 'DismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showRouteDeleteWarning: false}),
					$author$project$Effect$none);
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			case 'Logout':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Routes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Fleet_$Routes$SheetMsg,
				$author$project$Views$SidebarSheet$subscriptions(model.sheet))
			]));
};
var $author$project$Pages$Fleet_$Routes$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A4($author$project$Pages$Fleet_$Routes$init, session, shared.apiUrl, shared.fleetUrl, req),
					view: A3($author$project$Pages$Fleet_$Routes$view, session, req, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Routes$update(session),
					subscriptions: $author$project$Pages$Fleet_$Routes$subscriptions
				};
			});
	});
var $author$project$Views$BoatForm$BoatForm = function (name) {
	return function (makeModel) {
		return function (length) {
			return function (beam) {
				return function (draft) {
					return function (yearLaunched) {
						return function (homePort) {
							return function (callSign) {
								return function (photo) {
									return function (boatType) {
										return function (trackerId) {
											return function (isTrailerBoat) {
												return function (maxSpeed) {
													return function (lowBatteryAlertThreshold) {
														return function (highWaterAlertSettings) {
															return function (movementAlertSettings) {
																return function (batteryIsolationEnabled) {
																	return function (helmVesselId) {
																		return {beam: beam, name: name, draft: draft, photo: photo, length: length, boatType: boatType, callSign: callSign, homePort: homePort, maxSpeed: maxSpeed, makeModel: makeModel, trackerId: trackerId, helmVesselId: helmVesselId, yearLaunched: yearLaunched, isTrailerBoat: isTrailerBoat, movementAlertSettings: movementAlertSettings, highWaterAlertSettings: highWaterAlertSettings, batteryIsolationEnabled: batteryIsolationEnabled, lowBatteryAlertThreshold: lowBatteryAlertThreshold};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$BoatForm$fromBoat = function (boat) {
	return $author$project$Views$BoatForm$BoatForm(boat.name)(boat.makeModel)(boat.length)(boat.beam)(boat.draft)(boat.yearLaunched)(boat.homePort)(boat.callSign)(boat.photo)(
		A2($elm$core$Maybe$withDefault, '', boat.boatType))(boat.trackerId)(boat.isTrailerBoat)(boat.maxSpeed)(boat.lowBatteryAlertThreshold)(boat.highWaterAlertSettings)(boat.movementAlertSettings)(
		$elm$core$Maybe$Just(boat.batteryIsolationEnabled))(boat.helmVesselId);
};
var $author$project$Views$BoatForm$defaultBoatType = 'powerInboard';
var $author$project$Views$BoatForm$defaultBoat = $author$project$Views$BoatForm$BoatForm('')($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($author$project$Views$BoatForm$defaultBoatType)($elm$core$Maybe$Nothing)(false)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing);
var $author$project$Data$Duration$toClockString = function (_v0) {
	var totalSeconds = _v0.a;
	var hours = (totalSeconds / 3600) | 0;
	var minutes = ((totalSeconds - (hours * 3600)) / 60) | 0;
	return A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(hours)) + (':' + A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(minutes)));
};
var $author$project$Views$BoatForm$trackerIdToType = function (t) {
	switch (t.$) {
		case 'DMT':
			return 'dmt';
		case 'Sensar':
			return 'sensar';
		default:
			return 'lad';
	}
};
var $author$project$Views$BoatForm$trackerIdToFormId = function (t) {
	switch (t.$) {
		case 'DMT':
			var s = t.a;
			return $elm$core$String$fromInt(s);
		case 'Sensar':
			var s = t.a;
			return s;
		default:
			var s = t.a;
			return $elm$core$String$fromInt(s);
	}
};
var $author$project$Data$Boat$highWaterAlertSettingsToString = function (settings) {
	switch (settings.$) {
		case 'Never':
			return 'never';
		case 'Always':
			return 'always';
		default:
			return 'activationFrequency';
	}
};
var $author$project$Views$BoatForm$toFormValues = F2(
	function (speedUnit, boat) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$enbala$elm_form$Form$Field$string(boat.name)),
				_Utils_Tuple2(
				'makeModel',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.makeModel))),
				_Utils_Tuple2(
				'length',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.length))),
				_Utils_Tuple2(
				'beam',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.beam))),
				_Utils_Tuple2(
				'draft',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.draft))),
				_Utils_Tuple2(
				'yearLaunched',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, boat.yearLaunched)))),
				_Utils_Tuple2(
				'homePort',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.homePort))),
				_Utils_Tuple2(
				'callSign',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.callSign))),
				_Utils_Tuple2(
				'photo',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.photo))),
				_Utils_Tuple2(
				'boatType',
				$enbala$elm_form$Form$Field$string(boat.boatType)),
				_Utils_Tuple2(
				'trackerType',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$Maybe$withDefault,
						'dmt',
						A2($elm$core$Maybe$map, $author$project$Views$BoatForm$trackerIdToType, boat.trackerId)))),
				_Utils_Tuple2(
				'trackerId',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Views$BoatForm$trackerIdToFormId, boat.trackerId)))),
				_Utils_Tuple2(
				'isTrailerBoat',
				$enbala$elm_form$Form$Field$bool(boat.isTrailerBoat)),
				_Utils_Tuple2(
				'maxSpeed',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Data$SpeedUnit$formatSpeed(speedUnit),
							boat.maxSpeed)))),
				_Utils_Tuple2(
				'lowBatteryAlertThreshold',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromFloat, boat.lowBatteryAlertThreshold)))),
				_Utils_Tuple2(
				'highWaterAlertSettings',
				$enbala$elm_form$Form$Field$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Data$Boat$highWaterAlertSettingsToString, boat.highWaterAlertSettings)))),
				_Utils_Tuple2(
				'activationFrequencyPerHour',
				$enbala$elm_form$Form$Field$string(
					function () {
						var _v0 = boat.highWaterAlertSettings;
						if ((_v0.$ === 'Just') && (_v0.a.$ === 'ActivationFrequency')) {
							var n = _v0.a.a;
							return $elm$core$String$fromInt(n);
						} else {
							return '3';
						}
					}())),
				_Utils_Tuple2(
				'movementAlertSettings',
				$enbala$elm_form$Form$Field$bool(
					$elm_community$maybe_extra$Maybe$Extra$isJust(boat.movementAlertSettings))),
				_Utils_Tuple2(
				'batteryIsolationEnabled',
				$enbala$elm_form$Form$Field$bool(
					A2($elm$core$Maybe$withDefault, false, boat.batteryIsolationEnabled))),
				_Utils_Tuple2(
				'movementAlertMode',
				$enbala$elm_form$Form$Field$string(
					function () {
						var _v1 = boat.movementAlertSettings;
						if ((_v1.$ === 'Just') && (_v1.a.$ === 'DaylightHours')) {
							return 'daylightHours';
						} else {
							return 'fixedHours';
						}
					}())),
				_Utils_Tuple2(
				'daylightBufferMinutes',
				$enbala$elm_form$Form$Field$string(
					function () {
						var _v2 = boat.movementAlertSettings;
						if ((_v2.$ === 'Just') && (_v2.a.$ === 'DaylightHours')) {
							var bufferMinutes = _v2.a.a;
							return $elm$core$String$fromInt(bufferMinutes);
						} else {
							return '0';
						}
					}())),
				_Utils_Tuple2(
				'activeHoursStart',
				$enbala$elm_form$Form$Field$string(
					function () {
						var _v3 = boat.movementAlertSettings;
						if ((_v3.$ === 'Just') && (_v3.a.$ === 'FixedHours')) {
							var period = _v3.a.a;
							return $author$project$Data$Duration$toClockString(period.start);
						} else {
							return '06:00';
						}
					}())),
				_Utils_Tuple2(
				'activeHoursEnd',
				$enbala$elm_form$Form$Field$string(
					function () {
						var _v4 = boat.movementAlertSettings;
						if ((_v4.$ === 'Just') && (_v4.a.$ === 'FixedHours')) {
							var period = _v4.a.a;
							return $author$project$Data$Duration$toClockString(period.end);
						} else {
							return '18:00';
						}
					}())),
				_Utils_Tuple2(
				'helmVesselId',
				$enbala$elm_form$Form$Field$string(
					A2($elm$core$Maybe$withDefault, '', boat.helmVesselId)))
			]);
	});
var $author$project$Data$Boat$boatTypes = _List_fromArray(
	[
		_Utils_Tuple2('sailingMonohull', 'Sailing - Monohull'),
		_Utils_Tuple2('sailingMultihull', 'Sailing - Multihull'),
		_Utils_Tuple2('powerInboard', 'Power - Inboard'),
		_Utils_Tuple2('powerOutboard', 'Power - Outboard'),
		_Utils_Tuple2('paddleCraft', 'Paddle Craft'),
		_Utils_Tuple2('pwc', 'Personal Water Craft'),
		_Utils_Tuple2('narrowboat', 'Narrowboat'),
		_Utils_Tuple2('ferry', 'Ferry'),
		_Utils_Tuple2('ship', 'Ship'),
		_Utils_Tuple2('poweredBarge', 'Barge - Powered'),
		_Utils_Tuple2('unpoweredBarge', 'Barge - Unpowered'),
		_Utils_Tuple2('other', 'Other')
	]);
var $author$project$Views$BoatForm$validateBoatType = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (str) {
		return A2(
			$elm$core$List$member,
			str,
			A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Data$Boat$boatTypes)) ? $enbala$elm_form$Form$Validate$succeed(str) : $enbala$elm_form$Form$Validate$fail(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$NotIncludedIn));
	},
	$enbala$elm_form$Form$Validate$string);
var $enbala$elm_form$Form$Error$InvalidFloat = {$: 'InvalidFloat'};
var $enbala$elm_form$Form$Validate$float = function (v) {
	return A2(
		$elm$core$Result$fromMaybe,
		$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidFloat),
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$String$toFloat,
			$enbala$elm_form$Form$Field$asString(v)));
};
var $author$project$Data$SpeedUnit$unitParser = $elm$parser$Parser$backtrackable(
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$Knots),
				$elm$parser$Parser$symbol('knots')),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$Knots),
				$elm$parser$Parser$symbol('kn')),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$KilometresPerHour),
				$elm$parser$Parser$symbol('km/hr')),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$KilometresPerHour),
				$elm$parser$Parser$symbol('km/h')),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$KilometresPerHour),
				$elm$parser$Parser$symbol('kph')),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$MilesPerHour),
				$elm$parser$Parser$symbol('mph')),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always($author$project$Data$SpeedUnit$MilesPerHour),
				$elm$parser$Parser$symbol('m/hr'))
			])));
var $author$project$Data$SpeedUnit$convertFrom = F2(
	function (unit, metresPerSecond) {
		switch (unit.$) {
			case 'Knots':
				return metresPerSecond / 1.94384;
			case 'KilometresPerHour':
				return metresPerSecond / 3.6;
			default:
				return metresPerSecond / 2.23694;
		}
	});
var $author$project$Data$SpeedUnit$speedParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(
				F2(
					function (d, u) {
						return A2($author$project$Data$SpeedUnit$convertFrom, u, d);
					})),
			$elm$parser$Parser$spaces),
		A2($elm$parser$Parser$ignorer, $elm$parser$Parser$float, $elm$parser$Parser$spaces)),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$ignorer, $author$project$Data$SpeedUnit$unitParser, $elm$parser$Parser$spaces),
		$elm$parser$Parser$end));
var $author$project$Data$SpeedUnit$parseSpeed = function (s) {
	return $elm$core$Result$toMaybe(
		A2($elm$parser$Parser$run, $author$project$Data$SpeedUnit$speedParser, s));
};
var $author$project$Views$BoatForm$validateMaxSpeed = function (defaultSpeedUnit) {
	return $enbala$elm_form$Form$Validate$oneOf(
		_List_fromArray(
			[
				A2(
				$enbala$elm_form$Form$Validate$customValidation,
				$enbala$elm_form$Form$Validate$string,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Data$SpeedUnit$parseSpeed,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$fromMaybe(
							$enbala$elm_form$Form$Validate$customError('Please enter a valid speed')),
						$elm$core$Result$map($elm$core$Maybe$Just)))),
				A2(
				$enbala$elm_form$Form$Validate$map,
				function (f) {
					return $elm$core$Maybe$Just(
						A2($author$project$Data$SpeedUnit$convertFrom, defaultSpeedUnit, f));
				},
				$enbala$elm_form$Form$Validate$float),
				A2(
				$enbala$elm_form$Form$Validate$map,
				function (_v0) {
					return $elm$core$Maybe$Nothing;
				},
				$enbala$elm_form$Form$Validate$emptyString)
			]));
};
var $enbala$elm_form$Form$Error$InvalidInt = {$: 'InvalidInt'};
var $author$project$Views$BoatForm$validateMaybeString = function (f) {
	var _v0 = $enbala$elm_form$Form$Field$asString(f);
	if (_v0.$ === 'Just') {
		if (_v0.a === '') {
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		} else {
			var s = _v0.a;
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(s));
		}
	} else {
		return $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidString));
	}
};
var $author$project$Views$BoatForm$validateMaybeInt = function (f) {
	return A2(
		$elm$core$Result$andThen,
		function (s) {
			if (s.$ === 'Nothing') {
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			} else {
				var str = s.a;
				var _v1 = $elm$core$String$toInt(str);
				if (_v1.$ === 'Just') {
					var i = _v1.a;
					return $elm$core$Result$Ok(
						$elm$core$Maybe$Just(i));
				} else {
					return $elm$core$Result$Err(
						$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidInt));
				}
			}
		},
		$author$project$Views$BoatForm$validateMaybeString(f));
};
var $author$project$Views$BoatForm$validateGuid = function () {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$'));
	return A2(
		$enbala$elm_form$Form$Validate$customValidation,
		$enbala$elm_form$Form$Validate$string,
		function (s) {
			return A2($elm$regex$Regex$contains, regex, s) ? $elm$core$Result$Ok(s) : $elm$core$Result$Err(
				$enbala$elm_form$Form$Validate$customError('Invalid GUID'));
		});
}();
var $author$project$Views$BoatForm$validateMaybeGuid = $enbala$elm_form$Form$Validate$oneOf(
	_List_fromArray(
		[
			A2(
			$enbala$elm_form$Form$Validate$map,
			function (_v0) {
				return $elm$core$Maybe$Nothing;
			},
			$enbala$elm_form$Form$Validate$emptyString),
			A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $author$project$Views$BoatForm$validateGuid)
		]));
var $author$project$Views$BoatForm$validateTrackerId = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (s) {
		switch (s) {
			case 'dmt':
				return A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2($enbala$elm_form$Form$Validate$field, 'trackerId', $author$project$Views$BoatForm$validateMaybeInt),
					$enbala$elm_form$Form$Validate$succeed(
						$elm$core$Maybe$map($author$project$Data$Boat$DMT)));
			case 'sensar':
				return A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2($enbala$elm_form$Form$Validate$field, 'trackerId', $author$project$Views$BoatForm$validateMaybeString),
					$enbala$elm_form$Form$Validate$succeed(
						$elm$core$Maybe$map($author$project$Data$Boat$Sensar)));
			case 'lad':
				return A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2($enbala$elm_form$Form$Validate$field, 'trackerId', $author$project$Views$BoatForm$validateMaybeInt),
					$enbala$elm_form$Form$Validate$succeed(
						$elm$core$Maybe$map($author$project$Data$Boat$LAD)));
			default:
				return $enbala$elm_form$Form$Validate$fail(
					$enbala$elm_form$Form$Validate$customError('Invalid tracker type: ' + s));
		}
	},
	A2($enbala$elm_form$Form$Validate$field, 'trackerType', $enbala$elm_form$Form$Validate$string));
var $author$project$Views$BoatForm$validateMaybeFloat = function (f) {
	return A2(
		$elm$core$Result$andThen,
		function (s) {
			if (s.$ === 'Nothing') {
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			} else {
				var str = s.a;
				var _v1 = $elm$core$String$toFloat(str);
				if (_v1.$ === 'Just') {
					var n = _v1.a;
					return $elm$core$Result$Ok(
						$elm$core$Maybe$Just(n));
				} else {
					return $elm$core$Result$Err(
						$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidFloat));
				}
			}
		},
		$author$project$Views$BoatForm$validateMaybeString(f));
};
var $author$project$Views$BoatForm$validateBoatDimension = function (f) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^\u005Cd+[\u005C.\u005Cd]* *(?:ft|m)$'));
	return A2(
		$elm$core$Result$andThen,
		function (s) {
			if (s.$ === 'Nothing') {
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			} else {
				var str = s.a;
				return A2($elm$regex$Regex$contains, regex, str) ? $elm$core$Result$Ok(
					$elm$core$Maybe$Just(str)) : $elm$core$Result$Err(
					$enbala$elm_form$Form$Validate$customError('Please enter a valid dimension (\u0027xx.x m|ft\u0027)'));
			}
		},
		$author$project$Views$BoatForm$validateMaybeString(f));
};
var $enbala$elm_form$Form$Validate$int = function (v) {
	return A2(
		$elm$core$Result$fromMaybe,
		$enbala$elm_form$Form$Error$value($enbala$elm_form$Form$Error$InvalidInt),
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$String$toInt,
			$enbala$elm_form$Form$Field$asString(v)));
};
var $enbala$elm_form$Form$Error$GreaterIntThan = function (a) {
	return {$: 'GreaterIntThan', a: a};
};
var $enbala$elm_form$Form$Validate$maxInt = F3(
	function (max, i, validationField) {
		return (_Utils_cmp(i, max) < 1) ? $elm$core$Result$Ok(i) : $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value(
				$enbala$elm_form$Form$Error$GreaterIntThan(max)));
	});
var $enbala$elm_form$Form$Error$SmallerIntThan = function (a) {
	return {$: 'SmallerIntThan', a: a};
};
var $enbala$elm_form$Form$Validate$minInt = F3(
	function (min, i, validationField) {
		return (_Utils_cmp(i, min) > -1) ? $elm$core$Result$Ok(i) : $elm$core$Result$Err(
			$enbala$elm_form$Form$Error$value(
				$enbala$elm_form$Form$Error$SmallerIntThan(min)));
	});
var $author$project$Data$Duration$parseClock = function (str) {
	var _v0 = A2($elm$core$String$split, ':', str);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var hoursStr = _v0.a;
		var _v1 = _v0.b;
		var minutesStr = _v1.a;
		var _v2 = _Utils_Tuple2(
			$elm$core$String$toInt(hoursStr),
			$elm$core$String$toInt(minutesStr));
		if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Just')) {
			var h = _v2.a.a;
			var m = _v2.b.a;
			return ((h >= 0) && ((h < 24) && ((m >= 0) && (m < 60)))) ? $elm$core$Maybe$Just(
				$author$project$Data$Duration$Seconds((h * 3600) + (m * 60))) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$BoatForm$validateClockTime = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	function (s) {
		return A2(
			$elm$core$Result$fromMaybe,
			$enbala$elm_form$Form$Validate$customError('Please enter a valid time (HH:mm)'),
			$author$project$Data$Duration$parseClock(s));
	});
var $author$project$Views$BoatForm$maxDaylightBufferMinutes = 180;
var $author$project$Views$BoatForm$validateMovementAlertSettings = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (enabled) {
		return enabled ? A2(
			$enbala$elm_form$Form$Validate$andThen,
			function (mode) {
				return (mode === 'daylightHours') ? A2(
					$enbala$elm_form$Form$Validate$map,
					A2($elm$core$Basics$composeR, $author$project$Data$Boat$DaylightHours, $elm$core$Maybe$Just),
					A2(
						$enbala$elm_form$Form$Validate$field,
						'daylightBufferMinutes',
						A2(
							$enbala$elm_form$Form$Validate$andThen,
							$enbala$elm_form$Form$Validate$maxInt($author$project$Views$BoatForm$maxDaylightBufferMinutes),
							A2(
								$enbala$elm_form$Form$Validate$andThen,
								$enbala$elm_form$Form$Validate$minInt(-$author$project$Views$BoatForm$maxDaylightBufferMinutes),
								$enbala$elm_form$Form$Validate$int)))) : A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2($enbala$elm_form$Form$Validate$field, 'activeHoursEnd', $author$project$Views$BoatForm$validateClockTime),
					A2(
						$enbala$elm_form$Form$Validate$andMap,
						A2($enbala$elm_form$Form$Validate$field, 'activeHoursStart', $author$project$Views$BoatForm$validateClockTime),
						$enbala$elm_form$Form$Validate$succeed(
							F2(
								function (start, end) {
									return $elm$core$Maybe$Just(
										$author$project$Data$Boat$FixedHours(
											{end: end, start: start}));
								}))));
			},
			A2($enbala$elm_form$Form$Validate$field, 'movementAlertMode', $enbala$elm_form$Form$Validate$string)) : $enbala$elm_form$Form$Validate$succeed($elm$core$Maybe$Nothing);
	},
	A2($enbala$elm_form$Form$Validate$field, 'movementAlertSettings', $enbala$elm_form$Form$Validate$bool));
var $author$project$Data$Boat$highWaterAlertSettingsFromString = function (s) {
	switch (s) {
		case 'never':
			return $elm$core$Maybe$Just($author$project$Data$Boat$Never);
		case 'always':
			return $elm$core$Maybe$Just($author$project$Data$Boat$Always);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$BoatForm$validateHighWaterAlertSettings = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (ms) {
		if (ms.$ === 'Nothing') {
			return $enbala$elm_form$Form$Validate$succeed($elm$core$Maybe$Nothing);
		} else {
			if (ms.a === 'activationFrequency') {
				return A2(
					$enbala$elm_form$Form$Validate$map,
					A2($elm$core$Basics$composeR, $author$project$Data$Boat$ActivationFrequency, $elm$core$Maybe$Just),
					A2(
						$enbala$elm_form$Form$Validate$field,
						'activationFrequencyPerHour',
						A2(
							$enbala$elm_form$Form$Validate$andThen,
							$enbala$elm_form$Form$Validate$minInt(1),
							$enbala$elm_form$Form$Validate$int)));
			} else {
				var str = ms.a;
				var _v1 = $author$project$Data$Boat$highWaterAlertSettingsFromString(str);
				if (_v1.$ === 'Just') {
					var settings = _v1.a;
					return $enbala$elm_form$Form$Validate$succeed(
						$elm$core$Maybe$Just(settings));
				} else {
					return $enbala$elm_form$Form$Validate$fail(
						$enbala$elm_form$Form$Validate$customError('Invalid high water alert setting: ' + str));
				}
			}
		}
	},
	A2($enbala$elm_form$Form$Validate$field, 'highWaterAlertSettings', $author$project$Views$BoatForm$validateMaybeString));
var $author$project$Views$BoatForm$validateBoat = F2(
	function (isNeboAdmin, speedUnit) {
		return A2(
			$enbala$elm_form$Form$Validate$andMap,
			A2($enbala$elm_form$Form$Validate$field, 'helmVesselId', $author$project$Views$BoatForm$validateMaybeGuid),
			A2(
				$enbala$elm_form$Form$Validate$andMap,
				isNeboAdmin ? A2(
					$enbala$elm_form$Form$Validate$field,
					'batteryIsolationEnabled',
					A2($enbala$elm_form$Form$Validate$map, $elm$core$Maybe$Just, $enbala$elm_form$Form$Validate$bool)) : $enbala$elm_form$Form$Validate$succeed($elm$core$Maybe$Nothing),
				A2(
					$enbala$elm_form$Form$Validate$andMap,
					$author$project$Views$BoatForm$validateMovementAlertSettings,
					A2(
						$enbala$elm_form$Form$Validate$andMap,
						$author$project$Views$BoatForm$validateHighWaterAlertSettings,
						A2(
							$enbala$elm_form$Form$Validate$andMap,
							A2($enbala$elm_form$Form$Validate$field, 'lowBatteryAlertThreshold', $author$project$Views$BoatForm$validateMaybeFloat),
							A2(
								$enbala$elm_form$Form$Validate$andMap,
								A2(
									$enbala$elm_form$Form$Validate$field,
									'maxSpeed',
									$author$project$Views$BoatForm$validateMaxSpeed(speedUnit)),
								A2(
									$enbala$elm_form$Form$Validate$andMap,
									A2($enbala$elm_form$Form$Validate$field, 'isTrailerBoat', $enbala$elm_form$Form$Validate$bool),
									A2(
										$enbala$elm_form$Form$Validate$andMap,
										$author$project$Views$BoatForm$validateTrackerId,
										A2(
											$enbala$elm_form$Form$Validate$andMap,
											A2($enbala$elm_form$Form$Validate$field, 'boatType', $author$project$Views$BoatForm$validateBoatType),
											A2(
												$enbala$elm_form$Form$Validate$andMap,
												A2($enbala$elm_form$Form$Validate$field, 'photo', $author$project$Views$BoatForm$validateMaybeString),
												A2(
													$enbala$elm_form$Form$Validate$andMap,
													A2($enbala$elm_form$Form$Validate$field, 'callSign', $author$project$Views$BoatForm$validateMaybeString),
													A2(
														$enbala$elm_form$Form$Validate$andMap,
														A2($enbala$elm_form$Form$Validate$field, 'homePort', $author$project$Views$BoatForm$validateMaybeString),
														A2(
															$enbala$elm_form$Form$Validate$andMap,
															A2($enbala$elm_form$Form$Validate$field, 'yearLaunched', $author$project$Views$BoatForm$validateMaybeInt),
															A2(
																$enbala$elm_form$Form$Validate$andMap,
																A2($enbala$elm_form$Form$Validate$field, 'draft', $author$project$Views$BoatForm$validateBoatDimension),
																A2(
																	$enbala$elm_form$Form$Validate$andMap,
																	A2($enbala$elm_form$Form$Validate$field, 'beam', $author$project$Views$BoatForm$validateBoatDimension),
																	A2(
																		$enbala$elm_form$Form$Validate$andMap,
																		A2($enbala$elm_form$Form$Validate$field, 'length', $author$project$Views$BoatForm$validateBoatDimension),
																		A2(
																			$enbala$elm_form$Form$Validate$andMap,
																			A2($enbala$elm_form$Form$Validate$field, 'makeModel', $author$project$Views$BoatForm$validateMaybeString),
																			A2(
																				$enbala$elm_form$Form$Validate$andMap,
																				A2(
																					$enbala$elm_form$Form$Validate$field,
																					'name',
																					A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
																				$enbala$elm_form$Form$Validate$succeed($author$project$Views$BoatForm$BoatForm)))))))))))))))))));
	});
var $author$project$Views$BoatForm$init = F4(
	function (isNeboAdmin, e, u, b) {
		return {
			form: A2(
				$enbala$elm_form$Form$initial,
				A2(
					$author$project$Views$BoatForm$toFormValues,
					u,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Views$BoatForm$defaultBoat,
						A2($elm$core$Maybe$map, $author$project$Views$BoatForm$fromBoat, b))),
				A2($author$project$Views$BoatForm$validateBoat, isNeboAdmin, u)),
			image: $elm$core$Maybe$Nothing,
			isUpdate: $elm_community$maybe_extra$Maybe$Extra$isJust(b),
			speedUnit: u,
			isNeboAdmin: isNeboAdmin,
			dropZoneState: $author$project$Views$DropZone$init(
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.photo;
					},
					b)),
			isHelmEnabled: e
		};
	});
var $author$project$Data$DaylightTimes$decodeClock = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Invalid clock time: ' + s),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Data$Duration$parseClock(s)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$DaylightTimes$DaylightTimes = F4(
	function (date, timeZoneId, sunrise, sunset) {
		return {date: date, sunset: sunset, sunrise: sunrise, timeZoneId: timeZoneId};
	});
var $author$project$Data$DaylightTimes$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sunset',
	$elm$json$Json$Decode$nullable($author$project$Data$DaylightTimes$decodeClock),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sunrise',
		$elm$json$Json$Decode$nullable($author$project$Data$DaylightTimes$decodeClock),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timeZoneId',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$DaylightTimes$DaylightTimes)))));
var $author$project$Api$fetchDaylightTimes = F4(
	function (token, apiUrl, fleet, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'daylighttimes']),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson($author$project$Data$DaylightTimes$decode),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$NewBoat$OnFetchDaylightTimes = function (a) {
	return {$: 'OnFetchDaylightTimes', a: a};
};
var $author$project$Pages$Fleet_$NewBoat$init = F3(
	function (session, req, apiUrl) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					form: A4(
						$author$project$Views$BoatForm$init,
						$author$project$Data$User$isNeboAdmin(session.user),
						f.isHelmEnabled,
						f.speedUnit,
						$elm$core$Maybe$Nothing),
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					apiUrl: apiUrl,
					daylightTimes: $elm$core$Maybe$Nothing
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': New Boat'))),
							A4($author$project$Api$fetchDaylightTimes, session.authToken, apiUrl, f.slug, $author$project$Pages$Fleet_$NewBoat$OnFetchDaylightTimes)
						])));
		} else {
			return _Utils_Tuple2(
				{
					form: A4($author$project$Views$BoatForm$init, false, false, $author$project$Data$SpeedUnit$Knots, $elm$core$Maybe$Nothing),
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					apiUrl: apiUrl,
					daylightTimes: $elm$core$Maybe$Nothing
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Views$DaylightArc$width = 240;
var $author$project$Views$DaylightArc$xFor = function (h) {
	return (h / 24) * $author$project$Views$DaylightArc$width;
};
var $author$project$Views$DaylightArc$horizonY = 30;
var $author$project$Views$DaylightArc$dayAmplitude = 24;
var $author$project$Views$DaylightArc$nightAmplitude = 8;
var $author$project$Views$DaylightArc$yFor = F3(
	function (rise, set, h) {
		var nightLength = 24 - (set - rise);
		if ((_Utils_cmp(h, rise) > -1) && (_Utils_cmp(h, set) < 1)) {
			return $author$project$Views$DaylightArc$horizonY - ($author$project$Views$DaylightArc$dayAmplitude * $elm$core$Basics$sin(($elm$core$Basics$pi * (h - rise)) / (set - rise)));
		} else {
			var sinceSunset = (_Utils_cmp(h, set) > 0) ? (h - set) : ((h + 24) - set);
			return $author$project$Views$DaylightArc$horizonY + ($author$project$Views$DaylightArc$nightAmplitude * $elm$core$Basics$sin(($elm$core$Basics$pi * sinceSunset) / nightLength));
		}
	});
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$Views$DaylightArc$sample = F2(
	function (from, to) {
		var steps = A2(
			$elm$core$Basics$max,
			1,
			$elm$core$Basics$ceiling((to - from) * 4));
		return A2(
			$elm$core$List$map,
			function (i) {
				return from + (((to - from) * i) / steps);
			},
			A2($elm$core$List$range, 0, steps));
	});
var $author$project$Views$DaylightArc$toHours = function (d) {
	return $author$project$Data$Duration$toSeconds(d) / 3600;
};
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $author$project$Views$DaylightArc$pathFrom = function (points) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, _v0) {
					var x = _v0.a;
					var y = _v0.b;
					return ((!i) ? 'M' : 'L') + ($elm$core$String$fromFloat(x) + (',' + $elm$core$String$fromFloat(y)));
				}),
			points));
};
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $author$project$Views$DaylightArc$clockString = function (h) {
	return $author$project$Data$Duration$toClockString(
		$author$project$Data$Duration$fromSeconds(
			A3(
				$elm$core$Basics$clamp,
				0,
				(24 * 3600) - 60,
				$elm$core$Basics$round(h * 3600))));
};
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $author$project$Views$DaylightArc$chart = F3(
	function (bufferMinutes, riseTime, setTime) {
		var sunMarker = function (h) {
			return A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx(
						$elm$core$String$fromFloat(
							$author$project$Views$DaylightArc$xFor(h))),
						$elm$svg$Svg$Attributes$cy(
						$elm$core$String$fromFloat($author$project$Views$DaylightArc$horizonY)),
						$elm$svg$Svg$Attributes$r('2.5'),
						$elm$svg$Svg$Attributes$fill('var(--bs-warning)')
					]),
				_List_Nil);
		};
		var marker = function (h) {
			var x = $author$project$Views$DaylightArc$xFor(h);
			return A2(
				$elm$svg$Svg$g,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$line,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x1(
								$elm$core$String$fromFloat(x)),
								$elm$svg$Svg$Attributes$x2(
								$elm$core$String$fromFloat(x)),
								$elm$svg$Svg$Attributes$y1('2'),
								$elm$svg$Svg$Attributes$y2('41'),
								$elm$svg$Svg$Attributes$stroke('var(--bs-secondary-color)'),
								$elm$svg$Svg$Attributes$strokeDasharray('2 2')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$text_,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x(
								$elm$core$String$fromFloat(
									A3($elm$core$Basics$clamp, 14, $author$project$Views$DaylightArc$width - 14, x))),
								$elm$svg$Svg$Attributes$y('50'),
								$elm$svg$Svg$Attributes$textAnchor('middle'),
								$elm$svg$Svg$Attributes$fontSize('9'),
								$elm$svg$Svg$Attributes$fill('var(--bs-secondary-color)')
							]),
						_List_fromArray(
							[
								$elm$svg$Svg$text(
								$author$project$Views$DaylightArc$clockString(h))
							]))
					]));
		};
		var buffer = bufferMinutes / 60;
		var rise = $author$project$Views$DaylightArc$toHours(riseTime);
		var windowStart = A3($elm$core$Basics$clamp, 0, 24, rise - buffer);
		var set = $author$project$Views$DaylightArc$toHours(setTime);
		var point = function (h) {
			return _Utils_Tuple2(
				$author$project$Views$DaylightArc$xFor(h),
				A3($author$project$Views$DaylightArc$yFor, rise, set, h));
		};
		var curve = $author$project$Views$DaylightArc$pathFrom(
			A2(
				$elm$core$List$map,
				point,
				A2($author$project$Views$DaylightArc$sample, 0, 24)));
		var windowEnd = A3($elm$core$Basics$clamp, 0, 24, set + buffer);
		var windowBand = A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(
						$author$project$Views$DaylightArc$xFor(windowStart))),
					$elm$svg$Svg$Attributes$y('2'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(
						$author$project$Views$DaylightArc$xFor(windowEnd) - $author$project$Views$DaylightArc$xFor(windowStart))),
					$elm$svg$Svg$Attributes$height('39'),
					$elm$svg$Svg$Attributes$fill('var(--bs-warning)'),
					$elm$svg$Svg$Attributes$fillOpacity('0.15')
				]),
			_List_Nil);
		var daylightArea = $author$project$Views$DaylightArc$pathFrom(
			A2(
				$elm$core$List$map,
				point,
				A2($author$project$Views$DaylightArc$sample, rise, set))) + ' Z';
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox(
					'0 0 ' + ($elm$core$String$fromFloat($author$project$Views$DaylightArc$width) + ' 54')),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat($author$project$Views$DaylightArc$width)),
					$elm$svg$Svg$Attributes$height('54'),
					$elm$svg$Svg$Attributes$style('max-width: 100%; display: block'),
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						(_Utils_cmp(windowEnd, windowStart) > 0) ? _List_fromArray(
						[windowBand]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d(daylightArea),
									$elm$svg$Svg$Attributes$fill('var(--bs-warning)'),
									$elm$svg$Svg$Attributes$fillOpacity('0.25')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$line,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$x1('0'),
									$elm$svg$Svg$Attributes$x2(
									$elm$core$String$fromFloat($author$project$Views$DaylightArc$width)),
									$elm$svg$Svg$Attributes$y1(
									$elm$core$String$fromFloat($author$project$Views$DaylightArc$horizonY)),
									$elm$svg$Svg$Attributes$y2(
									$elm$core$String$fromFloat($author$project$Views$DaylightArc$horizonY)),
									$elm$svg$Svg$Attributes$stroke('var(--bs-border-color)')
								]),
							_List_Nil)
						]),
						(_Utils_cmp(windowEnd, windowStart) > 0) ? _List_fromArray(
						[
							marker(windowStart),
							marker(windowEnd)
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d(curve),
									$elm$svg$Svg$Attributes$fill('none'),
									$elm$svg$Svg$Attributes$stroke('var(--bs-secondary-color)'),
									$elm$svg$Svg$Attributes$strokeWidth('1.5')
								]),
							_List_Nil),
							sunMarker(rise),
							sunMarker(set)
						])
					])));
	});
var $author$project$Views$DaylightArc$caption = function (s) {
	return A2(
		$elm$html$Html$small,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-text d-block')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(s)
			]));
};
var $author$project$Views$DaylightArc$view = F2(
	function (bufferMinutes, times) {
		var _v0 = _Utils_Tuple2(times.sunrise, times.sunset);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var rise = _v0.a.a;
			var set = _v0.b.a;
			return (_Utils_cmp(
				$author$project$Views$DaylightArc$toHours(set),
				$author$project$Views$DaylightArc$toHours(rise)) > 0) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'aria-label',
						'Sunrise ' + ($author$project$Data$Duration$toClockString(rise) + (', sunset ' + ($author$project$Data$Duration$toClockString(set) + ('. No alerts from ' + ($author$project$Views$DaylightArc$clockString(
							$author$project$Views$DaylightArc$toHours(rise) - (bufferMinutes / 60)) + (' to ' + ($author$project$Views$DaylightArc$clockString(
							$author$project$Views$DaylightArc$toHours(set) + (bufferMinutes / 60)) + '.'))))))))
					]),
				_List_fromArray(
					[
						A3($author$project$Views$DaylightArc$chart, bufferMinutes, rise, set)
					])) : $author$project$Views$DaylightArc$caption(
				'Sunrise ' + ($author$project$Data$Duration$toClockString(rise) + (' · Sunset ' + ($author$project$Data$Duration$toClockString(set) + ' (today at fleet base).'))));
		} else {
			return $author$project$Views$DaylightArc$caption('No sunrise or sunset at the fleet default location today.');
		}
	});
var $author$project$Views$BoatForm$Submit = {$: 'Submit'};
var $author$project$Views$BoatForm$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Views$BoatForm$betaBadge = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('badge bg-warning text-dark ms-2 align-middle')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Beta')
		]));
var $author$project$Views$BoatForm$adminBadge = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('badge bg-secondary ms-2 align-middle')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Nebo admin')
		]));
var $author$project$Views$BoatForm$ArchiveBoat = {$: 'ArchiveBoat'};
var $author$project$Views$BoatForm$DropZoneMsg = function (a) {
	return {$: 'DropZoneMsg', a: a};
};
var $author$project$Form$Extra$selectFieldViewWithLabel = F4(
	function (form, name, prompt, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(name),
							$elm$html$Html$Attributes$class('form-label')
						]),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text(' '),
						prompt)),
					A3(
					$enbala$elm_form$Form$Input$selectInput,
					options,
					A2($enbala$elm_form$Form$getFieldAsString, name, form),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'form-select ' + A2($author$project$Form$Extra$inputValidationClass, name, form))
						]))
				]));
	});
var $author$project$Form$Extra$selectFieldView = F4(
	function (form, name, prompt, options) {
		return A4(
			$author$project$Form$Extra$selectFieldViewWithLabel,
			form,
			name,
			_List_fromArray(
				[
					$elm$html$Html$text(prompt)
				]),
			options);
	});
var $author$project$Form$Extra$checkboxFieldViewWithLabel = F3(
	function (form, name, prompt) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-3 form-check form-switch')
				]),
			_List_fromArray(
				[
					A2(
					$enbala$elm_form$Form$Input$checkboxInput,
					A2($enbala$elm_form$Form$getFieldAsBool, name, form),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'form-check-input ' + A2($author$project$Form$Extra$inputValidationClass, name, form))
						])),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(name),
							$elm$html$Html$Attributes$class('form-check-label')
						]),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text(' '),
						prompt))
				]));
	});
var $author$project$Form$Extra$checkboxFieldView = F3(
	function (form, name, prompt) {
		return A3(
			$author$project$Form$Extra$checkboxFieldViewWithLabel,
			form,
			name,
			_List_fromArray(
				[
					$elm$html$Html$text(prompt)
				]));
	});
var $author$project$Views$BoatForm$hardwareConfigNote = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('form-text mb-3')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Requires hardware configuration. Contact '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('mailto:fleet.support@nebo.global')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('support')
				])),
			$elm$html$Html$text(' to set this up.')
		]));
var $author$project$Data$Boat$highWaterAlertSettingsToDisplayString = function (settings) {
	switch (settings.$) {
		case 'Never':
			return 'Never';
		case 'Always':
			return 'Always';
		default:
			var n = settings.a;
			return 'Activation Frequency';
	}
};
var $author$project$Views$BoatForm$view = F3(
	function (featureDropState, daylightTimes, model) {
		var boatTypeOptions = _Utils_eq(
			A2($enbala$elm_form$Form$getFieldAsString, 'boatType', model.form).value,
			$elm$core$Maybe$Just('')) ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2('', 'Select a type…'),
			$author$project$Data$Boat$boatTypes) : $author$project$Data$Boat$boatTypes;
		var showHighWater = _Utils_eq(
			A2($enbala$elm_form$Form$getFieldAsString, 'trackerType', model.form).value,
			$elm$core$Maybe$Just('dmt'));
		var isNew = function (key) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$FeatureDrop$State$isNew(key),
					featureDropState));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row py-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'name', 'Name', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'makeModel', 'Make/Model', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'length', 'Length', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'beam', 'Beam', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'draft', 'Draft', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'yearLaunched', 'Year Launched', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'homePort', 'Home Port', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'callSign', 'Call Sign', $elm$core$Maybe$Nothing)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row align-items-end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Views$BoatForm$FormMsg,
											A4($author$project$Form$Extra$selectFieldView, model.form, 'boatType', 'Boat Type', boatTypeOptions))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Views$BoatForm$FormMsg,
											A3($author$project$Form$Extra$checkboxFieldView, model.form, 'isTrailerBoat', 'Trailer Boat'))
										]))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$for('trackerId'),
												$elm$html$Html$Attributes$class('form-label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(' ' + 'Tracker')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('input-group mb-3')
											]),
										_List_fromArray(
											[
												A3(
												$enbala$elm_form$Form$Input$selectInput,
												_List_fromArray(
													[
														_Utils_Tuple2('dmt', 'DMT'),
														_Utils_Tuple2('sensar', 'Sensar'),
														_Utils_Tuple2('lad', 'LAD')
													]),
												A2($enbala$elm_form$Form$getFieldAsString, 'trackerType', model.form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class(
														'form-select ' + A2($author$project$Form$Extra$inputValidationClass, 'trackerType', model.form))
													])),
												A2(
												$enbala$elm_form$Form$Input$textInput,
												A2($enbala$elm_form$Form$getFieldAsString, 'trackerId', model.form),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class(
														'form-control ' + A2($author$project$Form$Extra$inputValidationClass, 'trackerId', model.form))
													]))
											])),
										A2($author$project$Form$Extra$validationFeedback, model.form, 'trackerId')
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border rounded p-3 mb-3')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fw-semibold text-secondary text-uppercase small mb-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Alert Settings')
										])),
								A2(
									$elm$core$List$intersperse,
									A2(
										$elm$html$Html$hr,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-0 mb-3 opacity-100'),
												A2($elm$html$Html$Attributes$style, 'border-color', 'var(--bs-border-color)')
											]),
										_List_Nil),
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												$elm$core$Maybe$Just(
												A2(
													$elm$html$Html$map,
													$author$project$Views$BoatForm$FormMsg,
													A4($author$project$Form$Extra$fieldView, model.form, 'lowBatteryAlertThreshold', 'Low Battery Alert Threshold (volts)', $elm$core$Maybe$Nothing))),
												showHighWater ? $elm$core$Maybe$Just(
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('row align-items-end')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-6')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$map,
																	$author$project$Views$BoatForm$FormMsg,
																	A4(
																		$author$project$Form$Extra$selectFieldViewWithLabel,
																		model.form,
																		'highWaterAlertSettings',
																		_List_fromArray(
																			[
																				$elm$html$Html$text('High Water Alert Settings'),
																				$author$project$Views$BoatForm$betaBadge,
																				$author$project$Views$NewDot$view(
																				isNew('high-water'))
																			]),
																		A2(
																			$elm$core$List$map,
																			function (s) {
																				return _Utils_Tuple2(
																					$author$project$Data$Boat$highWaterAlertSettingsToString(s),
																					$author$project$Data$Boat$highWaterAlertSettingsToDisplayString(s));
																			},
																			_List_fromArray(
																				[
																					$author$project$Data$Boat$Never,
																					$author$project$Data$Boat$Always,
																					$author$project$Data$Boat$ActivationFrequency(0)
																				]))))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-6 mt-0')
																]),
															_List_fromArray(
																[$author$project$Views$BoatForm$hardwareConfigNote])),
															_Utils_eq(
															A2($enbala$elm_form$Form$getFieldAsString, 'highWaterAlertSettings', model.form).value,
															$elm$core$Maybe$Just('activationFrequency')) ? A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-6')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$map,
																	$author$project$Views$BoatForm$FormMsg,
																	A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-3')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('input-group')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('input-group-text')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('More than')
																							])),
																						A2(
																						$enbala$elm_form$Form$Input$textInput,
																						A2($enbala$elm_form$Form$getFieldAsString, 'activationFrequencyPerHour', model.form),
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(
																								'form-control ' + A2($author$project$Form$Extra$inputValidationClass, 'activationFrequencyPerHour', model.form))
																							])),
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('input-group-text')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('/hr')
																							]))
																					])),
																				A2($author$project$Form$Extra$validationFeedback, model.form, 'activationFrequencyPerHour')
																			])))
																])) : $elm$html$Html$text('')
														]))) : $elm$core$Maybe$Nothing,
												(model.isNeboAdmin && showHighWater) ? $elm$core$Maybe$Just(
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('row')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-6')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$map,
																	$author$project$Views$BoatForm$FormMsg,
																	A3(
																		$author$project$Form$Extra$checkboxFieldViewWithLabel,
																		model.form,
																		'batteryIsolationEnabled',
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Enable battery isolation status'),
																				$author$project$Views$BoatForm$adminBadge
																			])))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-6')
																]),
															_List_fromArray(
																[$author$project$Views$BoatForm$hardwareConfigNote]))
														]))) : $elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mb-3')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$map,
															$author$project$Views$BoatForm$FormMsg,
															A3(
																$author$project$Form$Extra$checkboxFieldViewWithLabel,
																model.form,
																'movementAlertSettings',
																_List_fromArray(
																	[
																		$elm$html$Html$text('Alert on movement outside of operating hours'),
																		$author$project$Views$BoatForm$betaBadge,
																		$author$project$Views$NewDot$view(
																		isNew('after-hours'))
																	]))),
															_Utils_eq(
															A2($enbala$elm_form$Form$getFieldAsBool, 'movementAlertSettings', model.form).value,
															$elm$core$Maybe$Just(true)) ? A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mb-3')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('mb-3')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$map,
																			$author$project$Views$BoatForm$FormMsg,
																			A4(
																				$author$project$Form$Extra$selectFieldView,
																				model.form,
																				'movementAlertMode',
																				'Operating Hours',
																				_List_fromArray(
																					[
																						_Utils_Tuple2('fixedHours', 'Fixed Hours'),
																						_Utils_Tuple2('daylightHours', 'Daylight Hours')
																					])))
																		])),
																	function () {
																	if (_Utils_eq(
																		A2($enbala$elm_form$Form$getFieldAsString, 'movementAlertMode', model.form).value,
																		$elm$core$Maybe$Just('daylightHours'))) {
																		var bufferField = A2($enbala$elm_form$Form$getFieldAsString, 'daylightBufferMinutes', model.form);
																		var bufferMinutes = A3(
																			$elm$core$Basics$clamp,
																			-$author$project$Views$BoatForm$maxDaylightBufferMinutes,
																			$author$project$Views$BoatForm$maxDaylightBufferMinutes,
																			A2(
																				$elm$core$Maybe$withDefault,
																				0,
																				A2($elm$core$Maybe$andThen, $elm$core$String$toInt, bufferField.value)));
																		return A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('mb-3')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('d-flex flex-wrap align-items-start gap-3')
																						]),
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$map,
																							$author$project$Views$BoatForm$FormMsg,
																							A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('input-group'),
																										A2($elm$html$Html$Attributes$style, 'width', '12rem'),
																										A2($elm$html$Html$Attributes$style, 'margin-top', '2.5px')
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$elm$html$Html$label,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$for('daylightBufferMinutes'),
																												$elm$html$Html$Attributes$class('input-group-text')
																											]),
																										_List_fromArray(
																											[
																												$elm$html$Html$text('Buffer')
																											])),
																										A2(
																										$enbala$elm_form$Form$Input$textInput,
																										bufferField,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$id('daylightBufferMinutes'),
																												$elm$html$Html$Attributes$class(
																												'form-control ' + A2($author$project$Form$Extra$inputValidationClass, 'daylightBufferMinutes', model.form)),
																												$elm$html$Html$Attributes$type_('number'),
																												$elm$html$Html$Attributes$min(
																												$elm$core$String$fromInt(-$author$project$Views$BoatForm$maxDaylightBufferMinutes)),
																												$elm$html$Html$Attributes$max(
																												$elm$core$String$fromInt($author$project$Views$BoatForm$maxDaylightBufferMinutes)),
																												$elm$html$Html$Attributes$step('5')
																											])),
																										A2(
																										$elm$html$Html$span,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$class('input-group-text')
																											]),
																										_List_fromArray(
																											[
																												$elm$html$Html$text('min')
																											]))
																									]))),
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('flex-grow-1'),
																									A2($elm$html$Html$Attributes$style, 'min-width', '0')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$core$Maybe$withDefault,
																									$elm$html$Html$text(''),
																									A2(
																										$elm$core$Maybe$map,
																										$author$project$Views$DaylightArc$view(bufferMinutes),
																										daylightTimes))
																								]))
																						])),
																					(A2($author$project$Form$Extra$inputValidationClass, 'daylightBufferMinutes', model.form) === '') ? $elm$html$Html$text('') : A2(
																					$elm$core$Maybe$withDefault,
																					$elm$html$Html$text(''),
																					A2(
																						$elm$core$Maybe$map,
																						function (e) {
																							return A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('invalid-feedback d-block')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Form$Extra$errorToString(e))
																									]));
																						},
																						A2($author$project$Form$Extra$getErrorFor, 'daylightBufferMinutes', model.form))),
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('form-text')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text('Sunrise/sunset times for today at fleet location. Positive buffer extends before sunrise and after sunset; negative buffer reduces the active window.')
																						]))
																				]));
																	} else {
																		return A2(
																			$elm$html$Html$map,
																			$author$project$Views$BoatForm$FormMsg,
																			A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('mb-3')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('input-group')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('input-group-text')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Operating hours from')
																									])),
																								A2(
																								$enbala$elm_form$Form$Input$textInput,
																								A2($enbala$elm_form$Form$getFieldAsString, 'activeHoursStart', model.form),
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class(
																										'form-control ' + A2($author$project$Form$Extra$inputValidationClass, 'activeHoursStart', model.form)),
																										$elm$html$Html$Attributes$placeholder('HH:mm')
																									])),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('input-group-text')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('to')
																									])),
																								A2(
																								$enbala$elm_form$Form$Input$textInput,
																								A2($enbala$elm_form$Form$getFieldAsString, 'activeHoursEnd', model.form),
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class(
																										'form-control ' + A2($author$project$Form$Extra$inputValidationClass, 'activeHoursEnd', model.form)),
																										$elm$html$Html$Attributes$placeholder('HH:mm')
																									]))
																							])),
																						A2($author$project$Form$Extra$validationFeedback, model.form, 'activeHoursStart'),
																						A2($author$project$Form$Extra$validationFeedback, model.form, 'activeHoursEnd'),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('form-text')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Alerts are triggered on boat movements '),
																								A2(
																								$elm$html$Html$b,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('OUTSIDE')
																									])),
																								$elm$html$Html$text(' the operating hours.')
																							]))
																					])));
																	}
																}()
																])) : $elm$html$Html$text('')
														]))),
												$elm$core$Maybe$Just(
												A2(
													$elm$html$Html$map,
													$author$project$Views$BoatForm$FormMsg,
													A4(
														$author$project$Form$Extra$fieldView,
														model.form,
														'maxSpeed',
														'Max Speed (' + ($author$project$Data$SpeedUnit$abbreviation(model.speedUnit) + ')'),
														$elm$core$Maybe$Just(
															'5 ' + $author$project$Data$SpeedUnit$abbreviation(model.speedUnit)))))
											]))))),
							model.isHelmEnabled ? A2(
							$elm$html$Html$map,
							$author$project$Views$BoatForm$FormMsg,
							A4($author$project$Form$Extra$fieldView, model.form, 'helmVesselId', 'Helm Vessel ID', $elm$core$Maybe$Nothing)) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										model.isUpdate ? _List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-danger mx-2'),
													$elm$html$Html$Events$onClick($author$project$Views$BoatForm$ArchiveBoat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Archive')
												]))
										]) : _List_Nil,
										_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-light'),
													$elm$html$Html$Events$onClick($author$project$Views$BoatForm$Submit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Save')
												]))
										])
									])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Photo')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Views$BoatForm$DropZoneMsg,
									A3(
										$author$project$Views$DropZone$view,
										_List_fromArray(
											['image/png', 'image/jpeg']),
										model.dropZoneState,
										_List_Nil))
								]))
						]))
				]));
	});
var $author$project$Pages$Fleet_$NewBoat$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$NewBoat$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Pages$Fleet_$NewBoat$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$NewBoat$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$NewBoat$view = F3(
	function (session, featureDropState, model) {
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(
						$author$project$Gen$Route$Fleet___NewBoat(
							{fleet: model.fleet.slug})),
					featureDropState,
					$author$project$Pages$Fleet_$NewBoat$ChangelogAction,
					$author$project$Pages$Fleet_$NewBoat$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container-fluid')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Fleet_$NewBoat$FormMsg,
								A3($author$project$Views$BoatForm$view, featureDropState, model.daylightTimes, model.form))
							])),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$NewBoat$CloseError)
					])),
			title: 'New Vessel'
		};
	});
var $author$project$Views$BoatForm$RemoveImage = {$: 'RemoveImage'};
var $author$project$Views$BoatForm$SelectedFile = function (a) {
	return {$: 'SelectedFile', a: a};
};
var $author$project$Views$BoatForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'FormMsg':
				var m = msg.a;
				var updatedForm = A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$BoatForm$validateBoat, model.isNeboAdmin, model.speedUnit),
					m,
					model.form);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{form: updatedForm}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedFile':
				var f = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							image: $elm$core$Maybe$Just(f)
						}),
					$elm$core$Platform$Cmd$none);
			case 'DropZoneMsg':
				var dzmsg = msg.a;
				var _v1 = A3(
					$author$project$Views$DropZone$update,
					{
						droppedFile: $author$project$Views$BoatForm$SelectedFile,
						removeImage: $elm$core$Maybe$Just($author$project$Views$BoatForm$RemoveImage),
						generatePreview: true,
						acceptedMimeTypes: _List_fromArray(
							['image/png', 'image/jpeg'])
					},
					dzmsg,
					model.dropZoneState);
				var state = _v1.a;
				var maybeMsg = _v1.b;
				var cmd = _v1.c;
				var updatedModel = _Utils_update(
					model,
					{dropZoneState: state});
				var updatedCmd = A2($elm$core$Platform$Cmd$map, $author$project$Views$BoatForm$DropZoneMsg, cmd);
				if (maybeMsg.$ === 'Just') {
					var m = maybeMsg.a;
					var _v3 = A2($author$project$Views$BoatForm$update, m, updatedModel);
					var newModel = _v3.a;
					var newCmd = _v3.b;
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[updatedCmd, newCmd])));
				} else {
					return _Utils_Tuple2(updatedModel, updatedCmd);
				}
			case 'RemoveImage':
				var updatedForm = A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$BoatForm$validateBoat, model.isNeboAdmin, model.speedUnit),
					A3(
						$enbala$elm_form$Form$Input,
						'photo',
						$enbala$elm_form$Form$Text,
						$enbala$elm_form$Form$Field$String('')),
					model.form);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{form: updatedForm, image: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'ArchiveBoat':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var updatedForm = A3(
					$enbala$elm_form$Form$update,
					A2($author$project$Views$BoatForm$validateBoat, model.isNeboAdmin, model.speedUnit),
					$enbala$elm_form$Form$Submit,
					model.form);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{form: updatedForm}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Fleet_$NewBoat$OnSubmit = function (a) {
	return {$: 'OnSubmit', a: a};
};
var $author$project$Data$Boat$trackerIdToString = function (t) {
	switch (t.$) {
		case 'DMT':
			var i = t.a;
			return 'dmt-' + $elm$core$String$fromInt(i);
		case 'Sensar':
			var i = t.a;
			return 'sensar-' + i;
		default:
			var i = t.a;
			return 'lad-' + $elm$core$String$fromInt(i);
	}
};
var $author$project$Data$Boat$encodeHighWaterAlertSettings = function (settings) {
	if (settings.$ === 'ActivationFrequency') {
		var n = settings.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'activationFrequency',
					$elm$json$Json$Encode$int(n))
				]));
	} else {
		return $elm$json$Json$Encode$string(
			$author$project$Data$Boat$highWaterAlertSettingsToString(settings));
	}
};
var $author$project$Data$Duration$toDisplayString = function (_v0) {
	var totalSeconds = _v0.a;
	var hours = (totalSeconds / 3600) | 0;
	var minutes = ((totalSeconds - (hours * 3600)) / 60) | 0;
	var seconds = totalSeconds - ((hours * 3600) + (minutes * 60));
	return $elm$core$String$fromInt(hours) + (':' + (A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(minutes)) + (':' + A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(seconds)))));
};
var $author$project$Data$Duration$encode = function (duration) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Duration$toDisplayString(duration));
};
var $author$project$Data$Boat$movementAlertSettingsEncoder = function (settings) {
	if (settings.$ === 'FixedHours') {
		var period = settings.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fixedHours',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'activeHoursStart',
								$author$project$Data$Duration$encode(period.start)),
								_Utils_Tuple2(
								'activeHoursEnd',
								$author$project$Data$Duration$encode(period.end))
							])))
				]));
	} else {
		var bufferMinutes = settings.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'daylightHours',
					$elm$json$Json$Encode$int(bufferMinutes))
				]));
	}
};
var $author$project$Api$postBoat = F6(
	function (token, apiUrl, fleet, form, image, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'boats']),
						_List_Nil),
					body: $elm$http$Http$multipartBody(
						A2(
							$elm$core$List$append,
							$elm_community$maybe_extra$Maybe$Extra$toList(
								A2(
									$elm$core$Maybe$map,
									function (f) {
										return A2($elm$http$Http$filePart, 'image', f);
									},
									image)),
							_List_fromArray(
								[
									A2(
									$elm$http$Http$stringPart,
									'boat',
									A2(
										$elm$json$Json$Encode$encode,
										2,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(form.name)),
													_Utils_Tuple2(
													'makeModel',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.makeModel)),
													_Utils_Tuple2(
													'length',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.length)),
													_Utils_Tuple2(
													'beam',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.beam)),
													_Utils_Tuple2(
													'draft',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.draft)),
													_Utils_Tuple2(
													'yearLaunched',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, form.yearLaunched)),
													_Utils_Tuple2(
													'homePort',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.homePort)),
													_Utils_Tuple2(
													'callSign',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.callSign)),
													_Utils_Tuple2(
													'photo',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.photo)),
													_Utils_Tuple2(
													'boatType',
													$elm$json$Json$Encode$string(form.boatType)),
													_Utils_Tuple2(
													'trackerId',
													A2(
														$elm_community$json_extra$Json$Encode$Extra$maybe,
														$elm$json$Json$Encode$string,
														A2($elm$core$Maybe$map, $author$project$Data$Boat$trackerIdToString, form.trackerId))),
													_Utils_Tuple2(
													'isTrailerBoat',
													$elm$json$Json$Encode$bool(form.isTrailerBoat)),
													_Utils_Tuple2(
													'maxSpeed',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, form.maxSpeed)),
													_Utils_Tuple2(
													'lowBatteryAlertThreshold',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, form.lowBatteryAlertThreshold)),
													_Utils_Tuple2(
													'highWaterAlertSettings',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Boat$encodeHighWaterAlertSettings, form.highWaterAlertSettings)),
													_Utils_Tuple2(
													'movementAlertSettings',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Boat$movementAlertSettingsEncoder, form.movementAlertSettings)),
													_Utils_Tuple2(
													'batteryIsolationEnabled',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$bool, form.batteryIsolationEnabled)),
													_Utils_Tuple2(
													'helmVesselId',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.helmVesselId))
												]))))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$Boat$decode),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Views$BoatForm$getOutput = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (f) {
			return _Utils_Tuple2(f, model.image);
		},
		$enbala$elm_form$Form$getOutput(model.form));
};
var $author$project$Pages$Fleet_$NewBoat$update = F4(
	function (session, req, msg, model) {
		switch (msg.$) {
			case 'FormMsg':
				var m = msg.a;
				var _v1 = A2($author$project$Views$BoatForm$update, m, model.form);
				var updatedForm = _v1.a;
				var formCmd = _v1.b;
				var updatedModel = _Utils_update(
					model,
					{form: updatedForm});
				var formEffect = $author$project$Effect$fromCmd(
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$NewBoat$FormMsg, formCmd));
				if (m.$ === 'Submit') {
					var _v3 = $author$project$Views$BoatForm$getOutput(updatedForm);
					if (_v3.$ === 'Just') {
						var _v4 = _v3.a;
						var f = _v4.a;
						var file = _v4.b;
						return _Utils_Tuple2(
							updatedModel,
							$author$project$Effect$batch(
								_List_fromArray(
									[
										A6($author$project$Api$postBoat, session.authToken, model.apiUrl, model.fleet, f, file, $author$project$Pages$Fleet_$NewBoat$OnSubmit),
										formEffect,
										$author$project$Effect$fromCmd(
										$author$project$Ports$startProgressBar(_Utils_Tuple0))
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{
									error: $elm$core$Maybe$Just(
										{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'Unable to submit form'})
								}),
							formEffect);
					}
				} else {
					return _Utils_Tuple2(updatedModel, formEffect);
				}
			case 'OnSubmit':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							A2(
								$author$project$Request$pushRoute,
								$author$project$Gen$Route$Fleet___Boats(
									{fleet: model.fleet.slug}),
								req)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchDaylightTimes':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							daylightTimes: $elm$core$Result$toMaybe(result)
						}),
					$author$project$Effect$none);
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$NewBoat$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$NewBoat$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$NewBoat$init, session, req, shared.apiUrl),
					view: A2($author$project$Pages$Fleet_$NewBoat$view, session, shared.featureDropState),
					update: A2($author$project$Pages$Fleet_$NewBoat$update, session, req),
					subscriptions: $author$project$Pages$Fleet_$NewBoat$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Summary$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$Pages$Fleet_$Summary$initialModel = F3(
	function (u, f, r) {
		return {
			error: $elm$core$Maybe$Nothing,
			fleet: f,
			apiUrl: u,
			summaries: _List_Nil,
			currentTime: $elm$time$Time$millisToPosix(0),
			currentZone: $elm$time$Time$utc,
			currentRoute: r,
			selectedYear: 0,
			selectedMonth: 0
		};
	});
var $author$project$Pages$Fleet_$Summary$init = F3(
	function (s, u, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			s.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Summary$initialModel, u, f, req.route),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Fleet_$Summary$OnTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (t, z) {
											return _Utils_Tuple2(t, z);
										}),
									$elm$time$Time$now,
									$elm$time$Time$here))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Fleet Usage (Monthly)')))
						])));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Summary$initialModel, u, $author$project$Data$Fleet$empty, $author$project$Gen$Route$NotFound),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$list = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'list',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$list = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$list);
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Pages$Fleet_$Summary$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Summary$monthName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Pages$Fleet_$Summary$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Summary$UpdateYear = function (a) {
	return {$: 'UpdateYear', a: a};
};
var $author$project$Pages$Fleet_$Summary$DownloadCsv = {$: 'DownloadCsv'};
var $author$project$Pages$Fleet_$Summary$UpdateMonth = function (a) {
	return {$: 'UpdateMonth', a: a};
};
var $author$project$Pages$Fleet_$Summary$FetchSummary = {$: 'FetchSummary'};
var $author$project$Pages$Fleet_$Summary$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Summary$view = F3(
	function (session, featureDropState, model) {
		var headerCell = F2(
			function (classes, field) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h2 ' + classes)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field)
						]));
			});
		var footerCell = F2(
			function (classes, field) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h4 ' + classes)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field)
						]));
			});
		var row = function (b) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(b.boatName)
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Gen$Route$toHref(
											$author$project$Gen$Route$Fleet___Boats__BoatId___Logs(
												{
													fleet: model.fleet.slug,
													boatId: $author$project$Data$Boat$boatIdToString(b.boatId)
												})))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('ms-2 text-secondary')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$list))
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(b.trips))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(b.activeDays))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(b.underwayDuration)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Data$DistanceUnit$formatDistance, model.fleet.longDistanceUnit, b.distance))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Data$SpeedUnit$formatSpeed, model.fleet.speedUnit, b.averageSpeed))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Data$SpeedUnit$formatSpeed, model.fleet.speedUnit, b.maxSpeed))
							]))
					]));
		};
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(model.currentRoute),
					featureDropState,
					$author$project$Pages$Fleet_$Summary$ChangelogAction,
					$author$project$Pages$Fleet_$Summary$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reports | Fleet Usage (Monthly)')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column flex-lg-row align-items-center py-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex flex-row d-flex flex-column flex-lg-row align-items-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-select form-select-sm my-1 me-2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Month'),
												$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Summary$UpdateMonth)
											]),
										A2(
											$elm$core$List$map,
											function (i) {
												return A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$selected(
															_Utils_eq(i, model.selectedMonth)),
															$elm$html$Html$Attributes$value(
															$elm$core$String$fromInt(i))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Pages$Fleet_$Summary$monthName(
																$justinmimbs$date$Date$numberToMonth(i)))
														]));
											},
											A2($elm$core$List$range, 1, 12))),
										$elm$html$Html$text('/'),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-select form-select-sm my-1 ms-2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Year'),
												$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Summary$UpdateYear)
											]),
										A2(
											$elm$core$List$map,
											function (i) {
												return A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$selected(
															_Utils_eq(i, model.selectedYear))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(i))
														]));
											},
											A2(
												$elm$core$List$range,
												2018,
												A2($elm$time$Time$toYear, model.currentZone, model.currentTime))))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-light my-1 mx-2'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$disabled((!model.selectedMonth) || (!model.selectedYear)),
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Summary$FetchSummary)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Show Results'),
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('ms-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex-grow-1')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Summary$DownloadCsv),
										$elm$html$Html$Attributes$class('btn btn-anchor text-secondary text-nowrap'),
										$elm$html$Html$Attributes$disabled((!model.selectedMonth) || (!model.selectedYear))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('me-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
										$elm$html$Html$text('Download CSV')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-responsive-md')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(headerCell, '', 'Name'),
														A2(headerCell, 'text-end', 'Trips'),
														A2(headerCell, 'text-end', 'Active Days'),
														A2(headerCell, 'text-end', 'Underway Duration'),
														A2(headerCell, 'text-end', 'Distance'),
														A2(headerCell, 'text-end', 'Average Speed'),
														A2(headerCell, 'text-end', 'Max Speed')
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2($elm$core$List$map, row, model.summaries)),
										A2(
										$elm$html$Html$tfoot,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(footerCell, '', 'Total'),
														A2(
														footerCell,
														'text-end',
														$elm$core$String$fromInt(
															$elm$core$List$sum(
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.trips;
																	},
																	model.summaries)))),
														A2(
														footerCell,
														'text-end',
														$elm$core$String$fromInt(
															$elm$core$List$sum(
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.activeDays;
																	},
																	model.summaries)))),
														A2(footerCell, '', ''),
														A2(
														footerCell,
														'text-end',
														A2(
															$author$project$Data$DistanceUnit$formatDistance,
															model.fleet.longDistanceUnit,
															$elm$core$List$sum(
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.distance;
																	},
																	model.summaries)))),
														A2(footerCell, '', ''),
														A2(footerCell, '', '')
													]))
											]))
									]))
							])),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Summary$CloseError)
					])),
			title: model.fleet.name
		};
	});
var $author$project$Data$BoatUsageSummary$csvEncode = F2(
	function (dUnit, spUnit) {
		return $BrianHicks$elm_csv$Csv$Encode$withFieldNames(
			function (l) {
				return _List_fromArray(
					[
						_Utils_Tuple2('Boat Name', l.boatName),
						_Utils_Tuple2(
						'Trips',
						$elm$core$String$fromInt(l.trips)),
						_Utils_Tuple2(
						'Active Days',
						$elm$core$String$fromInt(l.activeDays)),
						_Utils_Tuple2(
						'Distance',
						A2($author$project$Data$DistanceUnit$formatDistance, dUnit, l.distance)),
						_Utils_Tuple2('Underway Duration', l.underwayDuration),
						_Utils_Tuple2(
						'Average Speed',
						A2($author$project$Data$SpeedUnit$formatSpeed, spUnit, l.averageSpeed)),
						_Utils_Tuple2(
						'Max Speed',
						A2($author$project$Data$SpeedUnit$formatSpeed, spUnit, l.maxSpeed))
					]);
			});
	});
var $author$project$Data$BoatUsageSummary$toCsv = F3(
	function (dUnit, spUnit, ls) {
		return A2(
			$BrianHicks$elm_csv$Csv$Encode$encode,
			{
				encoder: A2($author$project$Data$BoatUsageSummary$csvEncode, dUnit, spUnit),
				fieldSeparator: _Utils_chr(',')
			},
			ls);
	});
var $author$project$Pages$Fleet_$Summary$OnFetchSummary = function (a) {
	return {$: 'OnFetchSummary', a: a};
};
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Data$BoatUsageSummary$BoatUsageSummary = F8(
	function (boatId, boatName, trips, activeDays, underwayDuration, distance, averageSpeed, maxSpeed) {
		return {trips: trips, boatId: boatId, boatName: boatName, distance: distance, maxSpeed: maxSpeed, activeDays: activeDays, averageSpeed: averageSpeed, underwayDuration: underwayDuration};
	});
var $author$project$Data$BoatUsageSummary$decode = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Data$BoatUsageSummary$BoatUsageSummary,
	A2($elm$json$Json$Decode$field, 'boatId', $author$project$Data$Boat$boatIdDecoder),
	A2($elm$json$Json$Decode$field, 'boatName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'trips', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'activeDays', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'underwayDuration', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'distance', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'averageSpeed', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'maxSpeed', $elm$json$Json$Decode$float));
var $author$project$Api$fetchSummaryReport = F6(
	function (token, apiUrl, fleet, year, month, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'monthlysummary',
								$elm$core$String$fromInt(year),
								$elm$core$String$fromInt(month)
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$BoatUsageSummary$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Summary$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'UpdateMonth':
				var m = msg.a;
				var _v1 = $elm$core$String$toInt(m);
				if (_v1.$ === 'Just') {
					var month = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedMonth: month}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'UpdateYear':
				var y = msg.a;
				var _v2 = $elm$core$String$toInt(y);
				if (_v2.$ === 'Just') {
					var year = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedYear: year}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnTime':
				var _v3 = msg.a;
				var t = _v3.a;
				var z = _v3.b;
				var lastMonth = A3(
					$justinmimbs$date$Date$add,
					$justinmimbs$date$Date$Months,
					-1,
					A2($justinmimbs$date$Date$fromPosix, z, t));
				var y = $justinmimbs$date$Date$year(lastMonth);
				var m = $justinmimbs$date$Date$monthNumber(lastMonth);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t, currentZone: z, selectedYear: y, selectedMonth: m}),
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0)),
								A6($author$project$Api$fetchSummaryReport, session.authToken, model.apiUrl, model.fleet.slug, y, m, $author$project$Pages$Fleet_$Summary$OnFetchSummary)
							])));
			case 'FetchSummary':
				return ((!(!model.selectedMonth)) && (!(!model.selectedYear))) ? _Utils_Tuple2(
					model,
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0)),
								A6($author$project$Api$fetchSummaryReport, session.authToken, model.apiUrl, model.fleet.slug, model.selectedYear, model.selectedMonth, $author$project$Pages$Fleet_$Summary$OnFetchSummary)
							]))) : _Utils_Tuple2(model, $author$project$Effect$none);
			case 'OnFetchSummary':
				if (msg.a.$ === 'Ok') {
					var summaries = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								summaries: A2(
									$elm$core$List$sortWith,
									F2(
										function (s1, s2) {
											return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, s1.boatName, s2.boatName);
										}),
									summaries)
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'DownloadCsv':
				var _v4 = model.summaries;
				if (!_v4.b) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					var ss = _v4;
					var filename = model.fleet.slug + ('_' + ($elm$core$String$fromInt(model.selectedYear) + ('_' + ($elm$core$String$fromInt(model.selectedMonth) + '.csv'))));
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							A3(
								$elm$file$File$Download$string,
								filename,
								'text/csv',
								A3($author$project$Data$BoatUsageSummary$toCsv, model.fleet.longDistanceUnit, model.fleet.speedUnit, ss))));
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$Summary$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$Summary$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$Summary$init, session, shared.apiUrl, req),
					view: A2($author$project$Pages$Fleet_$Summary$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Summary$update(session),
					subscriptions: $author$project$Pages$Fleet_$Summary$subscriptions
				};
			});
	});
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Pages$Fleet_$Dashboard$init = F3(
	function (slug, req, key) {
		return _Utils_Tuple2(
			{},
			A2(
				$elm$browser$Browser$Navigation$pushUrl,
				req.key,
				A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[slug, 'public']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'key', key)
						]))));
	});
var $author$project$Pages$Fleet_$Dashboard$view = function (_v0) {
	return $author$project$View$placeholder('Should not arrive here');
};
var $author$project$Pages$Fleet_$Dashboard$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Fleet_$Dashboard$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$Dashboard$page = F2(
	function (_v0, req) {
		return $author$project$Page$element(
			{
				init: A3(
					$author$project$Pages$Fleet_$Dashboard$init,
					req.params.fleet,
					req,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, 'key', req.query))),
				view: $author$project$Pages$Fleet_$Dashboard$view,
				update: $author$project$Pages$Fleet_$Dashboard$update,
				subscriptions: $author$project$Pages$Fleet_$Dashboard$subscriptions
			});
	});
var $author$project$Pages$Fleet_$Discovery$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Discovery$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Views$Discovery$Auto = {$: 'Auto'};
var $author$project$Pages$Fleet_$Discovery$settingsFromFleet = function (fleet) {
	return {
		showPopup: A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.showPopup;
				},
				fleet.guestViewConfiguration)),
		speedUnit: fleet.speedUnit,
		watermarkImage: fleet.watermarkImage,
		routeVisibility: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Fleet$All,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.displayRoutes;
				},
				fleet.guestViewConfiguration)),
		autoDisplayPlaceDistance: A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.autoDisplayPlaceDistance;
			},
			fleet.guestViewConfiguration)
	};
};
var $author$project$Pages$Fleet_$Discovery$initial = F3(
	function (shared, slug, cachedFleet) {
		var settings = $author$project$Pages$Fleet_$Discovery$settingsFromFleet(cachedFleet);
		return {
			alert: $elm$core$Maybe$Nothing,
			boats: _List_Nil,
			fleet: $elm$core$Maybe$Nothing,
			apiUrl: shared.apiUrl,
			locale: shared.locale,
			places: _List_Nil,
			routes: _List_Nil,
			tracks: _List_Nil,
			fleetUrl: shared.fleetUrl,
			mapStyle: $author$project$Views$Mapbox$Satellite,
			timeZone: $elm$time$Time$utc,
			fleetSlug: slug,
			geofences: _List_Nil,
			showPopup: settings.showPopup,
			speedUnit: settings.speedUnit,
			currentTime: $elm$time$Time$millisToPosix(0),
			displayMode: $author$project$Views$Discovery$Auto,
			mapPosition: {
				zoom: cachedFleet.zoom,
				centre: {lat: cachedFleet.latitude, _long: cachedFleet.longitude}
			},
			selectedPlace: $elm$core$Maybe$Nothing,
			selectedRoute: $elm$core$Maybe$Nothing,
			selectedBoatId: $elm$core$Maybe$Nothing,
			watermarkImage: settings.watermarkImage,
			routeVisibility: settings.routeVisibility,
			routesDrawerOpen: false,
			currentSpeedLimit: $elm$core$Maybe$Nothing,
			placeAudioPlaying: false,
			showedNavigationWarning: shared.showedNavigationWarning,
			autoDisplayPlaceDistance: settings.autoDisplayPlaceDistance
		};
	});
var $author$project$Pages$Fleet_$Discovery$OnFetchFleet = function (a) {
	return {$: 'OnFetchFleet', a: a};
};
var $author$project$Pages$Fleet_$Discovery$OnFetchRoutes = function (a) {
	return {$: 'OnFetchRoutes', a: a};
};
var $author$project$Pages$Fleet_$Discovery$init = F3(
	function (shared, session, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return (A2($author$project$Data$User$isFleetAdmin, f.slug, session.user) || $author$project$Data$User$isNeboAdmin(session.user)) ? _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Discovery$initial, shared, req.params.fleet, f),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchFleet, session.authToken, shared.apiUrl, req.params.fleet, $author$project$Pages$Fleet_$Discovery$OnFetchFleet),
							A4($author$project$Api$fetchRoutes, session.authToken, shared.apiUrl, req.params.fleet, $author$project$Pages$Fleet_$Discovery$OnFetchRoutes),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Discovery$GotZone, $elm$time$Time$here)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Discovery$OnTick, $elm$time$Time$now)),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Discovery Settings')))
						]))) : _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Discovery$initial, shared, req.params.fleet, $author$project$Data$Fleet$empty),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$Forbidden, req)));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$Discovery$initial, shared, req.params.fleet, $author$project$Data$Fleet$empty),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Discovery$Save = {$: 'Save'};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$Pages$Fleet_$Discovery$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Discovery$CloseAlert = {$: 'CloseAlert'};
var $author$project$Pages$Fleet_$Discovery$ToggleRoute = function (a) {
	return {$: 'ToggleRoute', a: a};
};
var $author$project$Data$Image$url = function (i) {
	if (i.$ === 'Server') {
		var s = i.a;
		return $elm$core$Maybe$Just(s);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$globe = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'globe',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$globe = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$globe);
var $author$project$Views$Discovery$markdownToHtml = function (md) {
	var _v0 = A2(
		$elm$core$Result$andThen,
		function (ast) {
			return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer, ast);
		},
		A2(
			$elm$core$Result$mapError,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString),
				$elm$core$String$join('\u000A')),
			$dillonkearns$elm_markdown$Markdown$Parser$parse(md)));
	if (_v0.$ === 'Ok') {
		var rendered = _v0.a;
		return A2($elm$html$Html$div, _List_Nil, rendered);
	} else {
		return A2($elm$html$Html$span, _List_Nil, _List_Nil);
	}
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Attributes$preload = $elm$html$Html$Attributes$stringProperty('preload');
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$volumeHigh = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'volume-high',
	_Utils_Tuple2(640, 512),
	_Utils_Tuple2('M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$volumeHigh = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$volumeHigh);
var $author$project$Views$Discovery$placeAudioButton = F2(
	function (config, place) {
		var label = config.placeAudioPlaying ? 'Pause audio' : 'Play audio';
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Data$Image$url, place.audio);
		if (_v0.$ === 'Just') {
			var url = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ms-2 me-3')
					]),
				_List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'span',
						_List_Nil,
						_List_fromArray(
							[
								_Utils_Tuple2(
								place.placeId,
								A2(
									$elm$html$Html$audio,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('placeAudio'),
											$elm$html$Html$Attributes$src(url),
											$elm$html$Html$Attributes$preload('none'),
											A2(
											$elm$html$Html$Events$on,
											'play',
											$elm$json$Json$Decode$succeed(
												config.onPlaceAudioPlaying(true))),
											A2(
											$elm$html$Html$Events$on,
											'pause',
											$elm$json$Json$Decode$succeed(
												config.onPlaceAudioPlaying(false))),
											A2(
											$elm$html$Html$Events$on,
											'ended',
											$elm$json$Json$Decode$succeed(
												config.onPlaceAudioPlaying(false)))
										]),
									_List_Nil))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('btn btn-sm', true),
										_Utils_Tuple2('btn-primary', config.placeAudioPlaying),
										_Utils_Tuple2('btn-outline-primary', !config.placeAudioPlaying)
									])),
								$elm$html$Html$Attributes$title(label),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', label),
								$elm$html$Html$Events$onClick(config.onTogglePlaceAudio)
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$volumeHigh)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Discovery$placeDrawer = function (config) {
	var onClose = config.onClosePlaceDrawer;
	var place = config.selectedPlace;
	var visible = $elm_community$maybe_extra$Maybe$Extra$isJust(place);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('offcanvas', true),
						_Utils_Tuple2('offcanvas-bottom', true),
						_Utils_Tuple2('show', visible)
					])),
				A2($elm$html$Html$Attributes$attribute, 'data-bs-scroll', 'true'),
				A2($elm$html$Html$Attributes$attribute, 'data-bs-backdrop', 'false'),
				A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
				$elm$html$Html$Attributes$id('placeDrawer'),
				A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'offcanvasBottomLabel')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.photos;
						},
						place));
				if (!_v0.b) {
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
				} else {
					var ps = _v0;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-row justify-content-start align-self-stretch overflow-x-scroll bg-secondary-subtle'),
								A2($elm$html$Html$Attributes$style, 'max-height', '150px')
							]),
						A2(
							$elm$core$List$map,
							function (url) {
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(url),
											$elm$html$Html$Attributes$class('img-fluid'),
											A2($elm$html$Html$Attributes$style, 'max-height', '100%'),
											A2($elm$html$Html$Attributes$style, 'object-fit', 'cover')
										]),
									_List_Nil);
							},
							A2($elm$core$List$filterMap, $author$project$Data$Image$url, ps)));
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('offcanvas-header pb-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('offcanvas-title flex-grow-1'),
								$elm$html$Html$Attributes$id('offcanvasBottomLabel')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.name;
										},
										place)))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$Views$Discovery$placeAudioButton(config),
							place)),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn-close flex-shrink-0 ms-0'),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
								$elm$html$Html$Events$onClick(onClose)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('offcanvas-body pt-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.type_;
											},
											$author$project$Data$PlaceType$toDisplayString),
										place)))
							])),
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						A2(
						$elm$core$Maybe$withDefault,
						A2($elm$html$Html$span, _List_Nil, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							$author$project$Views$Discovery$markdownToHtml,
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.description;
								},
								place))),
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.url;
									},
									place);
								if (_v1.$ === 'Just') {
									var url = _v1.a;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(url),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$class('btn btn-outline-primary')
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('px-1')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$globe)),
												$elm$html$Html$text('More Info')
											]));
								} else {
									return A2($elm$html$Html$span, _List_Nil, _List_Nil);
								}
							}()
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-5')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Views$Discovery$routesDrawer = F5(
	function (routes, selectedRoute, open, onSelect, onClose) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('offcanvas', true),
							_Utils_Tuple2('offcanvas-start', true),
							_Utils_Tuple2('show', open)
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-bs-scroll', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'data-bs-backdrop', 'false'),
					A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
					$elm$html$Html$Attributes$id('routesDrawer'),
					A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'offcanvasRoutesLabel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('offcanvas-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('offcanvas-title'),
									$elm$html$Html$Attributes$id('offcanvasRoutesLabel')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Routes')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('btn-close'),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
									$elm$html$Html$Events$onClick(onClose)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('offcanvas-body p-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group list-group-flush')
								]),
							A2(
								$elm$core$List$map,
								function (route) {
									var isSelected = A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											function (sr) {
												return _Utils_eq(sr.routeId, route.routeId);
											},
											selectedRoute));
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('list-group-item', true),
														_Utils_Tuple2('list-group-item-action', true),
														_Utils_Tuple2('active', isSelected)
													])),
												A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
												$elm$html$Html$Events$onClick(
												onSelect(route))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(route.name)
											]));
								},
								A2(
									$elm$core$List$sortWith,
									$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
										function ($) {
											return $.name;
										}),
									routes)))
						]))
				]));
	});
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$Attributes$dominantBaseline = _VirtualDom_attribute('dominant-baseline');
var $author$project$Views$Discovery$speedLimitSign = F2(
	function (unit, limit) {
		if (limit.$ === 'Nothing') {
			return A2($elm$html$Html$span, _List_Nil, _List_Nil);
		} else {
			var speed = limit.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '70px'),
						A2($elm$html$Html$Attributes$style, 'right', '10px'),
						A2($elm$html$Html$Attributes$style, 'height', '100px'),
						A2($elm$html$Html$Attributes$style, 'width', '100px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$svg,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$viewBox('0 0 122.88 122.88')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'style',
								_List_Nil,
								_List_fromArray(
									[
										$elm$svg$Svg$text('.bold { font: bold 70px sans-serif; }')
									])),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('#d92d27'),
										$elm$svg$Svg$Attributes$d('M118.22,38a61.53,61.53,0,1,1-13.34-20,61.29,61.29,0,0,1,13.34,20ZM61.44,12.08A49.36,49.36,0,1,1,12.08,61.44,49.36,49.36,0,0,1,61.44,12.08Z')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('#fff'),
										$elm$svg$Svg$Attributes$d('M61.44,12.08A49.36,49.36,0,1,1,12.08,61.44,49.36,49.36,0,0,1,61.44,12.08Z')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$text_,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x('50%'),
										$elm$svg$Svg$Attributes$y('50%'),
										$elm$svg$Svg$Attributes$textAnchor('middle'),
										$elm$svg$Svg$Attributes$class('bold'),
										$elm$svg$Svg$Attributes$dominantBaseline('central')
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$text(
										A2(
											$myrho$elm_round$Round$round,
											0,
											A2($author$project$Data$SpeedUnit$convertTo, unit, speed)))
									]))
							]))
					]));
		}
	});
var $author$project$Views$Mapbox$withManualMove = F2(
	function (onManualMove, config) {
		return _Utils_update(
			config,
			{
				onManualMove: $elm$core$Maybe$Just(onManualMove)
			});
	});
var $author$project$Views$Mapbox$withRouteButton = F2(
	function (onClick, config) {
		return _Utils_update(
			config,
			{
				onRouteButtonClick: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Views$Mapbox$withCenterButton = F3(
	function (active, onClick, config) {
		return _Utils_update(
			config,
			{
				centerActive: active,
				onCenterButtonClick: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Views$Mapbox$withWatermarkImage = F2(
	function (imageUrl, config) {
		return _Utils_update(
			config,
			{watermarkImage: imageUrl});
	});
var $author$project$Views$Discovery$navigationWarningDialog = F2(
	function (showedWarning, onDismiss) {
		return $author$project$Views$Dialog$view(
			(!showedWarning) ? $elm$core$Maybe$Just(
				{
					body: $elm$core$Maybe$Just(
						$elm$html$Html$text('This map and the boat location shown are a guide and are not to be relied upon for your safety. Always keep a good lookout and operate the boat in accordance with regulations.')),
					footer: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-primary'),
									$elm$html$Html$Events$onClick(onDismiss)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK')
								]))),
					header: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Warning')
								]))),
					closeMessage: $elm$core$Maybe$Just(onDismiss),
					containerClass: $elm$core$Maybe$Nothing
				}) : $elm$core$Maybe$Nothing);
	});
var $author$project$Views$Discovery$view = function (config) {
	var showSpeedLimit = A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			function (t) {
				return t !== 'ferry';
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.boatType;
				},
				config.boat)));
	var mapConfig = function (c) {
		return A2(
			$elm$core$Maybe$withDefault,
			c,
			A2(
				$elm$core$Maybe$map,
				function (onClick) {
					return A2($author$project$Views$Mapbox$withRouteButton, onClick, c);
				},
				config.onRouteButtonClick));
	}(
		A2(
			$author$project$Views$Mapbox$withWatermarkImage,
			config.watermarkImage,
			A2(
				$author$project$Views$Mapbox$withManualMove,
				config.onManualMove,
				A2(
					$author$project$Views$Mapbox$withRoutes,
					$elm_community$maybe_extra$Maybe$Extra$toList(config.selectedRoute),
					A2(
						$author$project$Views$Mapbox$withGeofences,
						A2(
							$elm$core$List$filter,
							function (f) {
								return _Utils_eq(f.type_, $author$project$Data$GeofenceType$Restricted);
							},
							config.geofences),
						A2(
							$author$project$Views$Mapbox$withTracks,
							config.tracks,
							A3(
								$author$project$Views$Mapbox$withCenterButton,
								_Utils_eq(config.displayMode, $author$project$Views$Discovery$Auto),
								config.onCenterClick,
								A2(
									$author$project$Views$Mapbox$withIdleMsg,
									function (_v0) {
										var c = _v0.a;
										var z = _v0.b;
										var bounds = _v0.c;
										return config.onMapIdle(
											{
												zoom: z,
												bounds: {northEast: bounds.ne, southWest: bounds.sw},
												centre: c
											});
									},
									A3(
										$author$project$Views$Mapbox$withStyleSelect,
										config.mapStyle,
										config.onStyleSelect,
										A3($author$project$Views$Mapbox$init, config.mapPosition, config.fleetUrl, config.noOp))))))))));
	var boatPopup = config.showPopup ? A3(
		$elm$core$Maybe$map2,
		F2(
			function (b, bl) {
				return A7(
					$author$project$Views$Mapbox$locationPopupContent,
					config.locale,
					config.timeZone,
					config.speedUnit,
					$elm$core$Maybe$Just(
						_Utils_Tuple3(b.name, b.status, b.isOffline)),
					bl,
					$author$project$Data$Boat$isRestricted(b),
					$author$project$Data$Boat$isOverspeed(b));
			}),
		config.boat,
		A2($elm$core$Maybe$andThen, $author$project$Data$Boat$toBoatLocation, config.boat)) : $elm$core$Maybe$Nothing;
	var markers = A2(
		$elm$core$List$append,
		A2(
			$elm$core$List$map,
			function (p) {
				return A3(
					$author$project$Views$Mapbox$placeMarker,
					p,
					config.onMarkerClick(p.placeId),
					$elm$core$Maybe$Nothing);
			},
			config.places),
		$elm_community$maybe_extra$Maybe$Extra$toList(
			A2(
				$elm$core$Maybe$map,
				function (b) {
					return A5($author$project$Views$Mapbox$boatMarker, b, config.mapStyle, false, true, config.noOp);
				},
				config.boat)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%'),
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				$elm$html$Html$Attributes$class('guest-view-container')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Views$Mapbox$view,
				mapConfig,
				_Utils_ap(
					markers,
					$elm_community$maybe_extra$Maybe$Extra$toList(boatPopup))),
				A2($author$project$Views$Discovery$navigationWarningDialog, config.showedNavigationWarning, config.onDismissModal),
				A5($author$project$Views$Discovery$routesDrawer, config.routes, config.selectedRoute, config.routesDrawerOpen, config.selectRoute, config.onCloseRoutesDrawer),
				$author$project$Views$Discovery$placeDrawer(config),
				showSpeedLimit ? A2($author$project$Views$Discovery$speedLimitSign, config.speedUnit, config.currentSpeedLimit) : $elm$html$Html$text('')
			]));
};
var $author$project$Pages$Fleet_$Discovery$phoneBezel = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
				A2($elm$html$Html$Attributes$style, 'padding', '20px 0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '375px'),
						A2($elm$html$Html$Attributes$style, 'height', '650px'),
						A2($elm$html$Html$Attributes$style, 'border', '12px solid #1a1a1a'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '40px'),
						A2($elm$html$Html$Attributes$style, 'background', '#000'),
						A2($elm$html$Html$Attributes$style, 'box-shadow', '0 0 0 2px #333, 0 20px 60px rgba(0,0,0,0.3)'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
					]),
				_List_fromArray(
					[content]))
			]));
};
var $author$project$Pages$Fleet_$Discovery$PreviewNoOp = {$: 'PreviewNoOp'};
var $author$project$Pages$Fleet_$Discovery$PreviewMapIdle = function (a) {
	return {$: 'PreviewMapIdle', a: a};
};
var $author$project$Pages$Fleet_$Discovery$filteredRoutes = function (model) {
	var _v0 = model.routeVisibility;
	switch (_v0.$) {
		case 'All':
			return model.routes;
		case 'None':
			return _List_Nil;
		default:
			var ids = _v0.a;
			return A2(
				$elm$core$List$filter,
				function (r) {
					return A2($elm$core$List$member, r.routeId, ids);
				},
				model.routes);
	}
};
var $author$project$Pages$Fleet_$Discovery$PreviewManualMove = {$: 'PreviewManualMove'};
var $author$project$Pages$Fleet_$Discovery$PreviewSelectRoute = function (a) {
	return {$: 'PreviewSelectRoute', a: a};
};
var $author$project$Pages$Fleet_$Discovery$PreviewSelectStyle = function (a) {
	return {$: 'PreviewSelectStyle', a: a};
};
var $author$project$Pages$Fleet_$Discovery$PreviewDismissModal = {$: 'PreviewDismissModal'};
var $author$project$Pages$Fleet_$Discovery$PreviewCenterClicked = {$: 'PreviewCenterClicked'};
var $author$project$Pages$Fleet_$Discovery$PreviewMarkerClicked = function (a) {
	return {$: 'PreviewMarkerClicked', a: a};
};
var $author$project$Pages$Fleet_$Discovery$PreviewClosePlaceDrawer = {$: 'PreviewClosePlaceDrawer'};
var $author$project$Pages$Fleet_$Discovery$PreviewOpenRoutesDrawer = {$: 'PreviewOpenRoutesDrawer'};
var $author$project$Pages$Fleet_$Discovery$PreviewTogglePlaceAudio = {$: 'PreviewTogglePlaceAudio'};
var $author$project$Pages$Fleet_$Discovery$PreviewCloseRoutesDrawer = {$: 'PreviewCloseRoutesDrawer'};
var $author$project$Pages$Fleet_$Discovery$PreviewPlaceAudioPlaying = function (a) {
	return {$: 'PreviewPlaceAudioPlaying', a: a};
};
var $author$project$Pages$Fleet_$Discovery$previewPane = function (model) {
	var _v0 = model.fleet;
	if (_v0.$ === 'Nothing') {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-3')
				]),
			_List_fromArray(
				[
					$lattyware$elm_fontawesome$FontAwesome$view(
					A2(
						$lattyware$elm_fontawesome$FontAwesome$styled,
						_List_fromArray(
							[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin]),
						$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch))
				]));
	} else {
		var fleet = _v0.a;
		var _v1 = fleet.guestViewConfiguration;
		if (_v1.$ === 'Nothing') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-muted fst-italic mt-3')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Nebo Discovery is not enabled for this fleet.')
					]));
		} else {
			var selectedBoat = A2(
				$elm$core$Maybe$andThen,
				function (bid) {
					return A2(
						$elm_community$list_extra$List$Extra$find,
						function (b) {
							return _Utils_eq(b.boatId, bid);
						},
						model.boats);
				},
				model.selectedBoatId);
			return $author$project$Pages$Fleet_$Discovery$phoneBezel(
				$author$project$Views$Discovery$view(
					{
						boat: selectedBoat,
						noOp: $author$project$Pages$Fleet_$Discovery$PreviewNoOp,
						locale: model.locale,
						places: model.places,
						routes: $author$project$Pages$Fleet_$Discovery$filteredRoutes(model),
						tracks: (model.fleetSlug === 'ims') ? model.tracks : _List_Nil,
						fleetUrl: model.fleetUrl,
						mapStyle: model.mapStyle,
						timeZone: model.timeZone,
						fleetSlug: model.fleetSlug,
						geofences: model.geofences,
						onMapIdle: $author$project$Pages$Fleet_$Discovery$PreviewMapIdle,
						showPopup: model.showPopup,
						speedUnit: model.speedUnit,
						displayMode: model.displayMode,
						mapPosition: model.mapPosition,
						selectRoute: $author$project$Pages$Fleet_$Discovery$PreviewSelectRoute,
						onManualMove: $author$project$Pages$Fleet_$Discovery$PreviewManualMove,
						onCenterClick: $author$project$Pages$Fleet_$Discovery$PreviewCenterClicked,
						onMarkerClick: $author$project$Pages$Fleet_$Discovery$PreviewMarkerClicked,
						onStyleSelect: $author$project$Pages$Fleet_$Discovery$PreviewSelectStyle,
						selectedPlace: model.selectedPlace,
						selectedRoute: ($elm$core$List$length(
							$author$project$Pages$Fleet_$Discovery$filteredRoutes(model)) === 1) ? $elm$core$List$head(
							$author$project$Pages$Fleet_$Discovery$filteredRoutes(model)) : model.selectedRoute,
						onDismissModal: $author$project$Pages$Fleet_$Discovery$PreviewDismissModal,
						watermarkImage: model.watermarkImage,
						routesDrawerOpen: model.routesDrawerOpen,
						currentSpeedLimit: model.currentSpeedLimit,
						placeAudioPlaying: model.placeAudioPlaying,
						onClosePlaceDrawer: $author$project$Pages$Fleet_$Discovery$PreviewClosePlaceDrawer,
						onRouteButtonClick: ($elm$core$List$length(model.routes) > 1) ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$Discovery$PreviewOpenRoutesDrawer) : $elm$core$Maybe$Nothing,
						onTogglePlaceAudio: $author$project$Pages$Fleet_$Discovery$PreviewTogglePlaceAudio,
						onCloseRoutesDrawer: $author$project$Pages$Fleet_$Discovery$PreviewCloseRoutesDrawer,
						onPlaceAudioPlaying: $author$project$Pages$Fleet_$Discovery$PreviewPlaceAudioPlaying,
						showedNavigationWarning: model.showedNavigationWarning
					}));
		}
	}
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Pages$Fleet_$Discovery$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Discovery$ToggleShowPopup = {$: 'ToggleShowPopup'};
var $author$project$Pages$Fleet_$Discovery$SelectPreviewBoat = function (a) {
	return {$: 'SelectPreviewBoat', a: a};
};
var $author$project$Pages$Fleet_$Discovery$routeVisibilityOption = function (rv) {
	switch (rv.$) {
		case 'All':
			return 'all';
		case 'None':
			return 'none';
		default:
			return 'specified';
	}
};
var $author$project$Pages$Fleet_$Discovery$ToggleAutoDisplayPlace = {$: 'ToggleAutoDisplayPlace'};
var $author$project$Pages$Fleet_$Discovery$SetRouteVisibilityOption = function (a) {
	return {$: 'SetRouteVisibilityOption', a: a};
};
var $author$project$Pages$Fleet_$Discovery$SetAutoDisplayPlaceDistance = function (a) {
	return {$: 'SetAutoDisplayPlaceDistance', a: a};
};
var $author$project$Pages$Fleet_$Discovery$view = F3(
	function (session, featureDropState, model) {
		var rvOption = $author$project$Pages$Fleet_$Discovery$routeVisibilityOption(model.routeVisibility);
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					model.fleet,
					$elm$core$Maybe$Just(
						$author$project$Gen$Route$Fleet___Discovery(
							{fleet: model.fleetSlug})),
					featureDropState,
					$author$project$Pages$Fleet_$Discovery$ChangelogAction,
					$author$project$Pages$Fleet_$Discovery$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Nebo Discovery Settings')
							])),
						A2($author$project$Views$Alert$view, model.alert, $author$project$Pages$Fleet_$Discovery$CloseAlert),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-lg-5')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card p-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-3 form-check')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('checkbox'),
																$elm$html$Html$Attributes$class('form-check-input'),
																$elm$html$Html$Attributes$id('showPopup'),
																$elm$html$Html$Attributes$checked(model.showPopup),
																$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Discovery$ToggleShowPopup)
															]),
														_List_Nil),
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$for('showPopup'),
																$elm$html$Html$Attributes$class('form-check-label')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Show Boat Popup')
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-3 row align-items-center g-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-auto')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-check mb-0')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$input,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$type_('checkbox'),
																				$elm$html$Html$Attributes$class('form-check-input'),
																				$elm$html$Html$Attributes$id('autoDisplayPlace'),
																				$elm$html$Html$Attributes$checked(
																				$elm_community$maybe_extra$Maybe$Extra$isJust(model.autoDisplayPlaceDistance)),
																				$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Discovery$ToggleAutoDisplayPlace)
																			]),
																		_List_Nil),
																		A2(
																		$elm$html$Html$label,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$for('autoDisplayPlace'),
																				$elm$html$Html$Attributes$class('form-check-label')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Automatically show Place card when nearby')
																			]))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-auto'),
																A2(
																$elm$html$Html$Attributes$style,
																'visibility',
																$elm_community$maybe_extra$Maybe$Extra$isJust(model.autoDisplayPlaceDistance) ? 'visible' : 'hidden')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('input-group input-group-sm')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$input,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$type_('number'),
																				$elm$html$Html$Attributes$class('form-control'),
																				A2($elm$html$Html$Attributes$style, 'width', '80px'),
																				$elm$html$Html$Attributes$id('autoDisplayPlaceDistance'),
																				$elm$html$Html$Attributes$value(
																				$elm$core$String$fromFloat(
																					A2($elm$core$Maybe$withDefault, 100, model.autoDisplayPlaceDistance))),
																				$elm$html$Html$Attributes$min('5'),
																				$elm$html$Html$Attributes$max('1000'),
																				$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Discovery$SetAutoDisplayPlaceDistance)
																			]),
																		_List_Nil),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('input-group-text')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('m')
																			]))
																	]))
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('form-label mb-2')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Routes visible on Guest View')
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('d-flex w-100')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-0')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('btn-group'),
																				A2($elm$html$Html$Attributes$attribute, 'role', 'group')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$input,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$type_('radio'),
																						$elm$html$Html$Attributes$class('btn-check'),
																						$elm$html$Html$Attributes$id('visibility-all'),
																						$elm$html$Html$Attributes$name('routeVisibility'),
																						$elm$html$Html$Attributes$autocomplete(false),
																						$elm$html$Html$Attributes$checked(rvOption === 'all'),
																						$elm$html$Html$Events$onClick(
																						$author$project$Pages$Fleet_$Discovery$SetRouteVisibilityOption('all'))
																					]),
																				_List_Nil),
																				A2(
																				$elm$html$Html$label,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('btn btn-sm btn-outline-primary'),
																						$elm$html$Html$Attributes$for('visibility-all')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('All')
																					])),
																				A2(
																				$elm$html$Html$input,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$type_('radio'),
																						$elm$html$Html$Attributes$class('btn-check'),
																						$elm$html$Html$Attributes$id('visibility-none'),
																						$elm$html$Html$Attributes$name('routeVisibility'),
																						$elm$html$Html$Attributes$autocomplete(false),
																						$elm$html$Html$Attributes$checked(rvOption === 'none'),
																						$elm$html$Html$Events$onClick(
																						$author$project$Pages$Fleet_$Discovery$SetRouteVisibilityOption('none'))
																					]),
																				_List_Nil),
																				A2(
																				$elm$html$Html$label,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('btn btn-sm btn-outline-primary'),
																						$elm$html$Html$Attributes$for('visibility-none')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('None')
																					])),
																				A2(
																				$elm$html$Html$input,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$type_('radio'),
																						$elm$html$Html$Attributes$class('btn-check'),
																						$elm$html$Html$Attributes$id('visibility-specified'),
																						$elm$html$Html$Attributes$name('routeVisibility'),
																						$elm$html$Html$Attributes$autocomplete(false),
																						$elm$html$Html$Attributes$checked(rvOption === 'specified'),
																						$elm$html$Html$Attributes$disabled(
																						$elm$core$List$isEmpty(model.routes)),
																						$elm$html$Html$Events$onClick(
																						$author$project$Pages$Fleet_$Discovery$SetRouteVisibilityOption('specified'))
																					]),
																				_List_Nil),
																				A2(
																				$elm$html$Html$label,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('btn btn-sm btn-outline-primary'),
																						$elm$html$Html$Attributes$for('visibility-specified')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('Specific')
																					]))
																			]))
																	])),
																(!$elm$core$List$isEmpty(model.routes)) ? A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('ms-3 border flex-grow-1')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('p-2 w-100')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (r) {
																				return A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('form-check')
																						]),
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$input,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$type_('checkbox'),
																									$elm$html$Html$Attributes$id(
																									$author$project$Data$Route$routeIdToString(r.routeId)),
																									$elm$html$Html$Attributes$class('form-check-input'),
																									$elm$html$Html$Attributes$checked(
																									function () {
																										switch (rvOption) {
																											case 'all':
																												return true;
																											case 'none':
																												return false;
																											default:
																												var _v1 = model.routeVisibility;
																												if (_v1.$ === 'Specified') {
																													var ids = _v1.a;
																													return A2($elm$core$List$member, r.routeId, ids);
																												} else {
																													return false;
																												}
																										}
																									}()),
																									$elm$html$Html$Attributes$disabled(rvOption !== 'specified'),
																									$elm$html$Html$Events$onClick(
																									$author$project$Pages$Fleet_$Discovery$ToggleRoute(r.routeId))
																								]),
																							_List_Nil),
																							A2(
																							$elm$html$Html$label,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('form-check-label'),
																									$elm$html$Html$Attributes$for(
																									$author$project$Data$Route$routeIdToString(r.routeId))
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text(r.name)
																								]))
																						]));
																			},
																			model.routes))
																	])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
															]))
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('btn btn-primary'),
														$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Discovery$Save),
														$elm$html$Html$Attributes$disabled(
														$elm_community$maybe_extra$Maybe$Extra$isNothing(model.fleet))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Save')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-lg-7')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('d-flex align-items-center gap-2 mb-2')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-0')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Preview')
													])),
												(!$elm$core$List$isEmpty(model.boats)) ? A2(
												$elm$html$Html$select,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-select form-select-sm w-auto'),
														$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Discovery$SelectPreviewBoat)
													]),
												A2(
													$elm$core$List$map,
													function (b) {
														return A2(
															$elm$html$Html$option,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$value(
																	$author$project$Data$Boat$boatIdToString(b.boatId)),
																	$elm$html$Html$Attributes$selected(
																	_Utils_eq(
																		$elm$core$Maybe$Just(b.boatId),
																		model.selectedBoatId))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(b.name)
																]));
													},
													model.boats)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
											])),
										$author$project$Pages$Fleet_$Discovery$previewPane(model)
									]))
							]))
					])),
			title: 'Nebo Discovery Settings'
		};
	});
var $author$project$Views$Discovery$Manual = {$: 'Manual'};
var $author$project$Pages$Fleet_$Discovery$OnFetchBoats = function (a) {
	return {$: 'OnFetchBoats', a: a};
};
var $author$project$Pages$Fleet_$Discovery$OnFetchPlaces = function (a) {
	return {$: 'OnFetchPlaces', a: a};
};
var $elm$core$Basics$tan = _Basics_tan;
var $author$project$Geospatial$MapProjection$project = function (latLong) {
	var my = $author$project$Geospatial$MapProjection$equatorialRadius * A2(
		$elm$core$Basics$logBase,
		$elm$core$Basics$e,
		$elm$core$Basics$tan(
			($elm$core$Basics$pi / 4) + ($elm$core$Basics$degrees(latLong.lat) / 2)));
	var mx = $author$project$Geospatial$MapProjection$equatorialRadius * $elm$core$Basics$degrees(latLong._long);
	return _Utils_Tuple2(mx, my);
};
var $author$project$Geospatial$MapProjection$distance = F2(
	function (p1, p2) {
		var _v0 = $author$project$Geospatial$MapProjection$project(p2);
		var x2 = _v0.a;
		var y2 = _v0.b;
		var _v1 = $author$project$Geospatial$MapProjection$project(p1);
		var x1 = _v1.a;
		var y1 = _v1.b;
		var dy = y1 - y2;
		var dx = x1 - x2;
		return $elm$core$Basics$sqrt((dx * dx) + (dy * dy));
	});
var $author$project$Data$Place$isNearby = F3(
	function (ll, distance, place) {
		return _Utils_cmp(
			A2($author$project$Geospatial$MapProjection$distance, place.location, ll),
			distance) < 1;
	});
var $author$project$Data$Place$nearestWithin = F3(
	function (ll, distance, places) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$sortBy,
				function (place) {
					return A2($author$project$Geospatial$MapProjection$distance, place.location, ll);
				},
				A2(
					$elm$core$List$filter,
					A2($author$project$Data$Place$isNearby, ll, distance),
					places)));
	});
var $author$project$Api$patchGuestView = F5(
	function (token, apiUrl, fleetSlug, config, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleetSlug]),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'guestViewConfiguration',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'dashboardKey',
												$elm$json$Json$Encode$string('')),
												_Utils_Tuple2(
												'showPopup',
												$elm$json$Json$Encode$bool(config.showPopup)),
												_Utils_Tuple2(
												'displayRoutes',
												function () {
													var _v0 = config.routeVisibility;
													switch (_v0.$) {
														case 'All':
															return $elm$json$Json$Encode$string('all');
														case 'None':
															return $elm$json$Json$Encode$string('none');
														default:
															var ids = _v0.a;
															return $elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'specified',
																		A2($elm$json$Json$Encode$list, $author$project$Data$Route$routeIdEncoder, ids))
																	]));
													}
												}()),
												_Utils_Tuple2(
												'autoDisplayPlaceDistance',
												A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, config.autoDisplayPlaceDistance)),
												_Utils_Tuple2(
												'watermarkImage',
												A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, config.watermarkImage))
											])))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$Fleet$decode),
					method: 'PATCH',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Discovery$OnFetchGeofences = function (a) {
	return {$: 'OnFetchGeofences', a: a};
};
var $author$project$Pages$Fleet_$Discovery$OnPatchGuestView = function (a) {
	return {$: 'OnPatchGuestView', a: a};
};
var $author$project$Ports$togglePlaceAudio = _Platform_outgoingPort(
	'togglePlaceAudio',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Pages$Fleet_$Discovery$OnFetchTracks = function (a) {
	return {$: 'OnFetchTracks', a: a};
};
var $author$project$Pages$Fleet_$Discovery$fetchTracksForBoat = F3(
	function (session, model, boatId) {
		var _v0 = A3($author$project$Data$TrackDuration$toStartEnd, model.currentTime, model.timeZone, $author$project$Data$TrackDuration$Last30Days);
		var startTime = _v0.a;
		return A7(
			$author$project$Api$fetchTracks,
			session.authToken,
			model.apiUrl,
			model.fleetSlug,
			boatId,
			$jweir$elm_iso8601$ISO8601$fromPosix(startTime),
			$elm$core$Maybe$Nothing,
			$author$project$Pages$Fleet_$Discovery$OnFetchTracks);
	});
var $author$project$Shared$ShowedNavigationWarning = {$: 'ShowedNavigationWarning'};
var $ianmackenzie$elm_geometry$Geometry$Types$Point2d = function (a) {
	return {$: 'Point2d', a: a};
};
var $ianmackenzie$elm_geometry$Point2d$meters = F2(
	function (x, y) {
		return $ianmackenzie$elm_geometry$Geometry$Types$Point2d(
			{x: x, y: y});
	});
var $ianmackenzie$elm_geometry$Geometry$Types$LineSegment2d = function (a) {
	return {$: 'LineSegment2d', a: a};
};
var $ianmackenzie$elm_geometry$LineSegment2d$fromEndpoints = $ianmackenzie$elm_geometry$Geometry$Types$LineSegment2d;
var $ianmackenzie$elm_geometry$LineSegment2d$from = F2(
	function (startPoint_, endPoint_) {
		return $ianmackenzie$elm_geometry$LineSegment2d$fromEndpoints(
			_Utils_Tuple2(startPoint_, endPoint_));
	});
var $ianmackenzie$elm_geometry$Polygon2d$loopEdges = function (vertices_) {
	if (!vertices_.b) {
		return _List_Nil;
	} else {
		var all = vertices_;
		var first = all.a;
		var rest = all.b;
		return A3(
			$elm$core$List$map2,
			$ianmackenzie$elm_geometry$LineSegment2d$from,
			all,
			_Utils_ap(
				rest,
				_List_fromArray(
					[first])));
	}
};
var $ianmackenzie$elm_geometry$Polygon2d$outerLoop = function (_v0) {
	var polygon = _v0.a;
	return polygon.outerLoop;
};
var $ianmackenzie$elm_geometry$Polygon2d$innerLoops = function (_v0) {
	var polygon = _v0.a;
	return polygon.innerLoops;
};
var $ianmackenzie$elm_geometry$Polygon2d$edges = function (polygon) {
	var outerEdges = $ianmackenzie$elm_geometry$Polygon2d$loopEdges(
		$ianmackenzie$elm_geometry$Polygon2d$outerLoop(polygon));
	var innerEdges = A2(
		$elm$core$List$map,
		$ianmackenzie$elm_geometry$Polygon2d$loopEdges,
		$ianmackenzie$elm_geometry$Polygon2d$innerLoops(polygon));
	return $elm$core$List$concat(
		A2($elm$core$List$cons, outerEdges, innerEdges));
};
var $ianmackenzie$elm_geometry$Point2d$xCoordinate = function (_v0) {
	var p = _v0.a;
	return $ianmackenzie$elm_units$Quantity$Quantity(p.x);
};
var $ianmackenzie$elm_geometry$Point2d$yCoordinate = function (_v0) {
	var p = _v0.a;
	return $ianmackenzie$elm_units$Quantity$Quantity(p.y);
};
var $ianmackenzie$elm_geometry$LineSegment2d$endpoints = function (_v0) {
	var endpoints_ = _v0.a;
	return endpoints_;
};
var $ianmackenzie$elm_geometry$Polygon2d$containsPointHelp = F4(
	function (edgeList, xp, yp, k) {
		containsPointHelp:
		while (true) {
			if (!edgeList.b) {
				return !(!A2($elm$core$Basics$modBy, 2, k));
			} else {
				var edge = edgeList.a;
				var rest = edgeList.b;
				var _v1 = $ianmackenzie$elm_geometry$LineSegment2d$endpoints(edge);
				var p0 = _v1.a;
				var p1 = _v1.b;
				var _v2 = $ianmackenzie$elm_geometry$Point2d$xCoordinate(p1);
				var xi1 = _v2.a;
				var _v3 = $ianmackenzie$elm_geometry$Point2d$yCoordinate(p1);
				var yi1 = _v3.a;
				var v2 = yi1 - yp;
				var _v4 = $ianmackenzie$elm_geometry$Point2d$xCoordinate(p0);
				var xi = _v4.a;
				var _v5 = $ianmackenzie$elm_geometry$Point2d$yCoordinate(p0);
				var yi = _v5.a;
				var v1 = yi - yp;
				if (((v1 < 0) && (v2 < 0)) || ((v1 > 0) && (v2 > 0))) {
					var $temp$edgeList = rest,
						$temp$xp = xp,
						$temp$yp = yp,
						$temp$k = k;
					edgeList = $temp$edgeList;
					xp = $temp$xp;
					yp = $temp$yp;
					k = $temp$k;
					continue containsPointHelp;
				} else {
					var u2 = xi1 - xp;
					var u1 = xi - xp;
					if ((v2 > 0) && (v1 <= 0)) {
						var f = (u1 * v2) - (u2 * v1);
						if (f > 0) {
							var $temp$edgeList = rest,
								$temp$xp = xp,
								$temp$yp = yp,
								$temp$k = k + 1;
							edgeList = $temp$edgeList;
							xp = $temp$xp;
							yp = $temp$yp;
							k = $temp$k;
							continue containsPointHelp;
						} else {
							if (!f) {
								return true;
							} else {
								var $temp$edgeList = rest,
									$temp$xp = xp,
									$temp$yp = yp,
									$temp$k = k;
								edgeList = $temp$edgeList;
								xp = $temp$xp;
								yp = $temp$yp;
								k = $temp$k;
								continue containsPointHelp;
							}
						}
					} else {
						if ((v1 > 0) && (v2 <= 0)) {
							var f = (u1 * v2) - (u2 * v1);
							if (f < 0) {
								var $temp$edgeList = rest,
									$temp$xp = xp,
									$temp$yp = yp,
									$temp$k = k + 1;
								edgeList = $temp$edgeList;
								xp = $temp$xp;
								yp = $temp$yp;
								k = $temp$k;
								continue containsPointHelp;
							} else {
								if (!f) {
									return true;
								} else {
									var $temp$edgeList = rest,
										$temp$xp = xp,
										$temp$yp = yp,
										$temp$k = k;
									edgeList = $temp$edgeList;
									xp = $temp$xp;
									yp = $temp$yp;
									k = $temp$k;
									continue containsPointHelp;
								}
							}
						} else {
							if ((!v2) && (v1 < 0)) {
								var f = (u1 * v2) - (u2 * v1);
								if (!f) {
									return true;
								} else {
									var $temp$edgeList = rest,
										$temp$xp = xp,
										$temp$yp = yp,
										$temp$k = k;
									edgeList = $temp$edgeList;
									xp = $temp$xp;
									yp = $temp$yp;
									k = $temp$k;
									continue containsPointHelp;
								}
							} else {
								if ((!v1) && (v2 < 0)) {
									var f = (u1 * v2) - (u2 * v1);
									if (!f) {
										return true;
									} else {
										var $temp$edgeList = rest,
											$temp$xp = xp,
											$temp$yp = yp,
											$temp$k = k;
										edgeList = $temp$edgeList;
										xp = $temp$xp;
										yp = $temp$yp;
										k = $temp$k;
										continue containsPointHelp;
									}
								} else {
									if ((!v1) && (!v2)) {
										if ((u2 <= 0) && (u1 >= 0)) {
											return true;
										} else {
											if ((u1 <= 0) && (u2 >= 0)) {
												return true;
											} else {
												var $temp$edgeList = rest,
													$temp$xp = xp,
													$temp$yp = yp,
													$temp$k = k;
												edgeList = $temp$edgeList;
												xp = $temp$xp;
												yp = $temp$yp;
												k = $temp$k;
												continue containsPointHelp;
											}
										}
									} else {
										var $temp$edgeList = rest,
											$temp$xp = xp,
											$temp$yp = yp,
											$temp$k = k;
										edgeList = $temp$edgeList;
										xp = $temp$xp;
										yp = $temp$yp;
										k = $temp$k;
										continue containsPointHelp;
									}
								}
							}
						}
					}
				}
			}
		}
	});
var $ianmackenzie$elm_geometry$Polygon2d$contains = F2(
	function (point, polygon) {
		var _v0 = $ianmackenzie$elm_geometry$Point2d$yCoordinate(point);
		var y = _v0.a;
		var _v1 = $ianmackenzie$elm_geometry$Point2d$xCoordinate(point);
		var x = _v1.a;
		return A4(
			$ianmackenzie$elm_geometry$Polygon2d$containsPointHelp,
			$ianmackenzie$elm_geometry$Polygon2d$edges(polygon),
			x,
			y,
			0);
	});
var $ianmackenzie$elm_geometry$Geometry$Types$Polygon2d = function (a) {
	return {$: 'Polygon2d', a: a};
};
var $ianmackenzie$elm_units$Quantity$lessThanOrEqualTo = F2(
	function (_v0, _v1) {
		var y = _v0.a;
		var x = _v1.a;
		return _Utils_cmp(x, y) < 1;
	});
var $ianmackenzie$elm_units$Quantity$sum = function (quantities) {
	return A3($elm$core$List$foldl, $ianmackenzie$elm_units$Quantity$plus, $ianmackenzie$elm_units$Quantity$zero, quantities);
};
var $ianmackenzie$elm_geometry$Geometry$Types$Triangle2d = function (a) {
	return {$: 'Triangle2d', a: a};
};
var $ianmackenzie$elm_geometry$Triangle2d$from = F3(
	function (p1, p2, p3) {
		return $ianmackenzie$elm_geometry$Geometry$Types$Triangle2d(
			_Utils_Tuple3(p1, p2, p3));
	});
var $ianmackenzie$elm_geometry$Geometry$Types$Vector2d = function (a) {
	return {$: 'Vector2d', a: a};
};
var $ianmackenzie$elm_geometry$Vector2d$from = F2(
	function (_v0, _v1) {
		var p1 = _v0.a;
		var p2 = _v1.a;
		return $ianmackenzie$elm_geometry$Geometry$Types$Vector2d(
			{x: p2.x - p1.x, y: p2.y - p1.y});
	});
var $ianmackenzie$elm_geometry$Vector2d$cross = F2(
	function (_v0, _v1) {
		var v2 = _v0.a;
		var v1 = _v1.a;
		return $ianmackenzie$elm_units$Quantity$Quantity((v1.x * v2.y) - (v1.y * v2.x));
	});
var $ianmackenzie$elm_geometry$Triangle2d$vertices = function (_v0) {
	var triangleVertices = _v0.a;
	return triangleVertices;
};
var $ianmackenzie$elm_geometry$Triangle2d$counterclockwiseArea = function (triangle) {
	var _v0 = $ianmackenzie$elm_geometry$Triangle2d$vertices(triangle);
	var p1 = _v0.a;
	var p2 = _v0.b;
	var p3 = _v0.c;
	var firstVector = A2($ianmackenzie$elm_geometry$Vector2d$from, p1, p2);
	var secondVector = A2($ianmackenzie$elm_geometry$Vector2d$from, p1, p3);
	return A2(
		$ianmackenzie$elm_units$Quantity$multiplyBy,
		0.5,
		A2($ianmackenzie$elm_geometry$Vector2d$cross, secondVector, firstVector));
};
var $ianmackenzie$elm_geometry$Polygon2d$counterclockwiseArea = function (vertices_) {
	if (!vertices_.b) {
		return $ianmackenzie$elm_units$Quantity$zero;
	} else {
		if (!vertices_.b.b) {
			var single = vertices_.a;
			return $ianmackenzie$elm_units$Quantity$zero;
		} else {
			if (!vertices_.b.b.b) {
				var first = vertices_.a;
				var _v1 = vertices_.b;
				var second = _v1.a;
				return $ianmackenzie$elm_units$Quantity$zero;
			} else {
				var first = vertices_.a;
				var _v2 = vertices_.b;
				var second = _v2.a;
				var rest = _v2.b;
				var segmentArea = F2(
					function (start, end) {
						return $ianmackenzie$elm_geometry$Triangle2d$counterclockwiseArea(
							A3($ianmackenzie$elm_geometry$Triangle2d$from, first, start, end));
					});
				var segmentAreas = A3(
					$elm$core$List$map2,
					segmentArea,
					A2($elm$core$List$cons, second, rest),
					rest);
				return $ianmackenzie$elm_units$Quantity$sum(segmentAreas);
			}
		}
	}
};
var $ianmackenzie$elm_geometry$Polygon2d$makeInnerLoop = function (vertices_) {
	return A2(
		$ianmackenzie$elm_units$Quantity$lessThanOrEqualTo,
		$ianmackenzie$elm_units$Quantity$zero,
		$ianmackenzie$elm_geometry$Polygon2d$counterclockwiseArea(vertices_)) ? vertices_ : $elm$core$List$reverse(vertices_);
};
var $ianmackenzie$elm_units$Quantity$greaterThanOrEqualTo = F2(
	function (_v0, _v1) {
		var y = _v0.a;
		var x = _v1.a;
		return _Utils_cmp(x, y) > -1;
	});
var $ianmackenzie$elm_geometry$Polygon2d$makeOuterLoop = function (vertices_) {
	return A2(
		$ianmackenzie$elm_units$Quantity$greaterThanOrEqualTo,
		$ianmackenzie$elm_units$Quantity$zero,
		$ianmackenzie$elm_geometry$Polygon2d$counterclockwiseArea(vertices_)) ? vertices_ : $elm$core$List$reverse(vertices_);
};
var $ianmackenzie$elm_geometry$Polygon2d$withHoles = F2(
	function (givenInnerLoops, givenOuterLoop) {
		return $ianmackenzie$elm_geometry$Geometry$Types$Polygon2d(
			{
				outerLoop: $ianmackenzie$elm_geometry$Polygon2d$makeOuterLoop(givenOuterLoop),
				innerLoops: A2($elm$core$List$map, $ianmackenzie$elm_geometry$Polygon2d$makeInnerLoop, givenInnerLoops)
			});
	});
var $ianmackenzie$elm_geometry$Polygon2d$singleLoop = function (givenOuterLoop) {
	return A2($ianmackenzie$elm_geometry$Polygon2d$withHoles, _List_Nil, givenOuterLoop);
};
var $author$project$Data$Geofence$contains = F2(
	function (ll, geofence) {
		var _v0 = geofence.geometry;
		switch (_v0.$) {
			case 'Circle':
				var _v1 = _v0.a;
				var center = _v1.a;
				var radius = _v1.b;
				return _Utils_cmp(
					A2($author$project$Geospatial$MapProjection$distance, center, ll),
					radius) < 1;
			case 'Polygon':
				var points = _v0.a;
				var projectedPolygon = $ianmackenzie$elm_geometry$Polygon2d$singleLoop(
					A2(
						$elm$core$List$map,
						function (_v3) {
							var x = _v3.a;
							var y = _v3.b;
							return A2($ianmackenzie$elm_geometry$Point2d$meters, x, y);
						},
						A2($elm$core$List$map, $author$project$Geospatial$MapProjection$project, points)));
				var projectedLL = function (_v2) {
					var x = _v2.a;
					var y = _v2.b;
					return A2($ianmackenzie$elm_geometry$Point2d$meters, x, y);
				}(
					$author$project$Geospatial$MapProjection$project(ll));
				return A2($ianmackenzie$elm_geometry$Polygon2d$contains, projectedLL, projectedPolygon);
			default:
				return false;
		}
	});
var $author$project$Views$Discovery$speedLimitForCurrentLocation = F2(
	function (geofences, boat) {
		return A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.maxSpeed;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (g) {
					var _v0 = boat.latLong;
					if (_v0.$ === 'Just') {
						var ll = _v0.a;
						return A2($author$project$Data$Geofence$contains, ll, g);
					} else {
						return false;
					}
				},
				A2(
					$elm$core$List$filter,
					function (g) {
						return _Utils_eq(g.type_, $author$project$Data$GeofenceType$SpeedRestricted);
					},
					geofences)));
	});
var $author$project$Pages$Fleet_$Discovery$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnFetchFleet':
				if (msg.a.$ === 'Ok') {
					var fleet = msg.a.a;
					var settings = $author$project$Pages$Fleet_$Discovery$settingsFromFleet(fleet);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fleet: $elm$core$Maybe$Just(fleet),
								showPopup: settings.showPopup,
								speedUnit: settings.speedUnit,
								watermarkImage: settings.watermarkImage,
								routeVisibility: settings.routeVisibility,
								autoDisplayPlaceDistance: settings.autoDisplayPlaceDistance
							}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									A4($author$project$Api$fetchBoats, session.authToken, model.apiUrl, fleet, $author$project$Pages$Fleet_$Discovery$OnFetchBoats),
									A4($author$project$Api$fetchGeofences, session.authToken, model.apiUrl, fleet, $author$project$Pages$Fleet_$Discovery$OnFetchGeofences),
									A4($author$project$Api$fetchPlaces, session.authToken, model.apiUrl, fleet, $author$project$Pages$Fleet_$Discovery$OnFetchPlaces)
								])));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								alert: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'OnFetchRoutes':
				if (msg.a.$ === 'Ok') {
					var rs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{routes: rs}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchBoats':
				if (msg.a.$ === 'Ok') {
					var bs = msg.a.a;
					var newSelectedId = function () {
						var _v5 = model.selectedBoatId;
						if (_v5.$ === 'Just') {
							return model.selectedBoatId;
						} else {
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.boatId;
								},
								$elm$core$List$head(bs));
						}
					}();
					var selectedBoat = A2(
						$elm$core$Maybe$andThen,
						function (bid) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								function (b) {
									return _Utils_eq(b.boatId, bid);
								},
								bs);
						},
						newSelectedId);
					var currentSpeedLimit = A2(
						$elm$core$Maybe$andThen,
						$author$project$Views$Discovery$speedLimitForCurrentLocation(model.geofences),
						selectedBoat);
					var insidePlace = A2(
						$elm$core$Maybe$andThen,
						function (latLong) {
							return A3($author$project$Data$Place$nearestWithin, latLong, 100, model.places);
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.latLong;
							},
							selectedBoat));
					var selectedPlace = function () {
						var _v1 = _Utils_Tuple2(model.selectedPlace, insidePlace);
						if (_v1.a.$ === 'Just') {
							var sp = _v1.a.a;
							return $elm$core$Maybe$Just(sp);
						} else {
							if (_v1.b.$ === 'Just') {
								var _v2 = _v1.a;
								var ip = _v1.b.a;
								return $elm$core$Maybe$Just(ip);
							} else {
								var _v3 = _v1.a;
								var _v4 = _v1.b;
								return $elm$core$Maybe$Nothing;
							}
						}
					}();
					var mapPos = A2(
						$elm$core$Maybe$withDefault,
						model.mapPosition,
						A2(
							$elm$core$Maybe$andThen,
							function (b) {
								return A3(
									$elm$core$Maybe$map2,
									$author$project$Geospatial$MapProjection$MapPosition,
									b.latLong,
									$elm$core$Maybe$Just(18));
							},
							selectedBoat));
					var flyCmd = _Utils_eq(model.displayMode, $author$project$Views$Discovery$Auto) ? $author$project$MapCommands$flyTo(
						_List_fromArray(
							[
								$author$project$Mapbox$Cmd$Option$center(
								{lat: mapPos.centre.lat, lng: mapPos.centre._long}),
								$author$project$Mapbox$Cmd$Option$zoom(mapPos.zoom),
								$author$project$Mapbox$Cmd$Option$speed(2.0)
							])) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{boats: bs, mapPosition: mapPos, selectedPlace: selectedPlace, selectedBoatId: newSelectedId, currentSpeedLimit: currentSpeedLimit}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									$author$project$Effect$fromCmd(flyCmd),
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Effect$none,
									A2(
										$elm$core$Maybe$map,
										A2($author$project$Pages$Fleet_$Discovery$fetchTracksForBoat, session, model),
										newSelectedId))
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchGeofences':
				if (msg.a.$ === 'Ok') {
					var gs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{geofences: gs}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchPlaces':
				if (msg.a.$ === 'Ok') {
					var ps = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{places: ps}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchTracks':
				if (msg.a.$ === 'Ok') {
					var ts = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{tracks: ts}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnPatchGuestView':
				if (msg.a.$ === 'Ok') {
					var fleet = msg.a.a;
					var settings = $author$project$Pages$Fleet_$Discovery$settingsFromFleet(fleet);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								alert: $elm$core$Maybe$Just(
									{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$checkCircle, title: 'Saved', type_: $author$project$Views$Alert$Success, message: 'Guest view settings updated.'}),
								fleet: $elm$core$Maybe$Just(fleet),
								showPopup: settings.showPopup,
								speedUnit: settings.speedUnit,
								watermarkImage: settings.watermarkImage,
								routeVisibility: settings.routeVisibility
							}),
						$author$project$Effect$fromShared(
							$author$project$Shared$OnRefreshFleet(
								$elm$core$Result$Ok(fleet))));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								alert: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					function () {
						var _v6 = model.fleet;
						if (_v6.$ === 'Just') {
							var fleet = _v6.a;
							return $author$project$Effect$batch(
								_List_fromArray(
									[
										A4($author$project$Api$fetchBoats, session.authToken, model.apiUrl, fleet, $author$project$Pages$Fleet_$Discovery$OnFetchBoats),
										A2(
										$elm$core$Maybe$withDefault,
										$author$project$Effect$none,
										A2(
											$elm$core$Maybe$map,
											A2(
												$author$project$Pages$Fleet_$Discovery$fetchTracksForBoat,
												session,
												_Utils_update(
													model,
													{currentTime: t})),
											model.selectedBoatId))
									]));
						} else {
							return $author$project$Effect$none;
						}
					}());
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'SelectPreviewBoat':
				var boatIdStr = msg.a;
				var boatId = $author$project$Data$Boat$BoatId(boatIdStr);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tracks: _List_Nil,
							displayMode: $author$project$Views$Discovery$Auto,
							selectedBoatId: $elm$core$Maybe$Just(boatId)
						}),
					$author$project$Effect$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$author$project$Effect$none,
								A2(
									$elm$core$Maybe$map,
									function (f) {
										return A4($author$project$Api$fetchBoats, session.authToken, model.apiUrl, f, $author$project$Pages$Fleet_$Discovery$OnFetchBoats);
									},
									model.fleet)),
								A3($author$project$Pages$Fleet_$Discovery$fetchTracksForBoat, session, model, boatId)
							])));
			case 'PreviewMapIdle':
				var bounds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(bounds))
						}),
					$author$project$Effect$none);
			case 'PreviewSelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'PreviewCenterClicked':
				var selectedBoat = A2(
					$elm$core$Maybe$andThen,
					function (bid) {
						return A2(
							$elm_community$list_extra$List$Extra$find,
							function (b) {
								return _Utils_eq(b.boatId, bid);
							},
							model.boats);
					},
					model.selectedBoatId);
				var newMode = function () {
					var _v7 = model.displayMode;
					if (_v7.$ === 'Auto') {
						return $author$project$Views$Discovery$Manual;
					} else {
						return $author$project$Views$Discovery$Auto;
					}
				}();
				var mapPos = A2(
					$elm$core$Maybe$withDefault,
					model.mapPosition,
					A2(
						$elm$core$Maybe$andThen,
						function (b) {
							return A3(
								$elm$core$Maybe$map2,
								$author$project$Geospatial$MapProjection$MapPosition,
								b.latLong,
								$elm$core$Maybe$Just(18));
						},
						selectedBoat));
				var flyCmd = _Utils_eq(newMode, $author$project$Views$Discovery$Auto) ? $author$project$MapCommands$flyTo(
					_List_fromArray(
						[
							$author$project$Mapbox$Cmd$Option$center(
							{lat: mapPos.centre.lat, lng: mapPos.centre._long}),
							$author$project$Mapbox$Cmd$Option$zoom(mapPos.zoom),
							$author$project$Mapbox$Cmd$Option$speed(2.0)
						])) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{displayMode: newMode, mapPosition: mapPos}),
					$author$project$Effect$fromCmd(flyCmd));
			case 'PreviewOpenRoutesDrawer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{routesDrawerOpen: true}),
					$author$project$Effect$none);
			case 'PreviewCloseRoutesDrawer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{routesDrawerOpen: false}),
					$author$project$Effect$none);
			case 'PreviewSelectRoute':
				var route = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedRoute: $elm$core$Maybe$Just(route),
							routesDrawerOpen: false
						}),
					$author$project$Effect$none);
			case 'PreviewManualMove':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{displayMode: $author$project$Views$Discovery$Manual}),
					$author$project$Effect$none);
			case 'PreviewMarkerClicked':
				var placeId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedPlace: A2(
								$elm_community$list_extra$List$Extra$find,
								function (p) {
									return _Utils_eq(p.placeId, placeId);
								},
								model.places)
						}),
					$author$project$Effect$none);
			case 'PreviewClosePlaceDrawer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedPlace: $elm$core$Maybe$Nothing, placeAudioPlaying: false}),
					$author$project$Effect$none);
			case 'PreviewTogglePlaceAudio':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$author$project$Ports$togglePlaceAudio(_Utils_Tuple0)));
			case 'PreviewPlaceAudioPlaying':
				var playing = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{placeAudioPlaying: playing}),
					$author$project$Effect$none);
			case 'PreviewDismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showedNavigationWarning: true}),
					$author$project$Effect$fromShared($author$project$Shared$ShowedNavigationWarning));
			case 'PreviewNoOp':
				return _Utils_Tuple2(model, $author$project$Effect$none);
			case 'ToggleShowPopup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showPopup: !model.showPopup}),
					$author$project$Effect$none);
			case 'ToggleAutoDisplayPlace':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							autoDisplayPlaceDistance: function () {
								var _v8 = model.autoDisplayPlaceDistance;
								if (_v8.$ === 'Nothing') {
									return $elm$core$Maybe$Just(100);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}()
						}),
					$author$project$Effect$none);
			case 'SetAutoDisplayPlaceDistance':
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							autoDisplayPlaceDistance: A2(
								$elm_community$maybe_extra$Maybe$Extra$orElse,
								model.autoDisplayPlaceDistance,
								$elm$core$String$toFloat(s))
						}),
					$author$project$Effect$none);
			case 'SetRouteVisibilityOption':
				var option = msg.a;
				var newVisibility = function () {
					switch (option) {
						case 'all':
							return $author$project$Data$Fleet$All;
						case 'none':
							return $author$project$Data$Fleet$None;
						case 'specified':
							return $author$project$Data$Fleet$Specified(
								function () {
									var _v10 = model.routeVisibility;
									if (_v10.$ === 'Specified') {
										var ids = _v10.a;
										return ids;
									} else {
										return _List_Nil;
									}
								}());
						default:
							return model.routeVisibility;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{routeVisibility: newVisibility}),
					$author$project$Effect$none);
			case 'ToggleRoute':
				var routeId = msg.a;
				var newVisibility = function () {
					var _v11 = model.routeVisibility;
					if (_v11.$ === 'Specified') {
						var ids = _v11.a;
						return $author$project$Data$Fleet$Specified(
							A2($elm$core$List$member, routeId, ids) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(routeId),
								ids) : A2($elm$core$List$cons, routeId, ids));
					} else {
						return $author$project$Data$Fleet$Specified(
							_List_fromArray(
								[routeId]));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{routeVisibility: newVisibility}),
					$author$project$Effect$none);
			case 'Save':
				return _Utils_Tuple2(
					model,
					A5(
						$author$project$Api$patchGuestView,
						session.authToken,
						model.apiUrl,
						model.fleetSlug,
						{showPopup: model.showPopup, watermarkImage: model.watermarkImage, routeVisibility: model.routeVisibility, autoDisplayPlaceDistance: model.autoDisplayPlaceDistance},
						$author$project$Pages$Fleet_$Discovery$OnPatchGuestView));
			case 'CloseAlert':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{alert: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$Discovery$subscriptions = function (_v0) {
	return A2($elm$time$Time$every, 30 * 1000, $author$project$Pages$Fleet_$Discovery$OnTick);
};
var $author$project$Pages$Fleet_$Discovery$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$Discovery$init, shared, session, req),
					view: A2($author$project$Pages$Fleet_$Discovery$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Discovery$update(session),
					subscriptions: $author$project$Pages$Fleet_$Discovery$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Geofences$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Geofences$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Pages$Fleet_$Geofences$OnGetMapElement = function (a) {
	return {$: 'OnGetMapElement', a: a};
};
var $author$project$Pages$Fleet_$Geofences$OnFetchGeofences = function (a) {
	return {$: 'OnFetchGeofences', a: a};
};
var $author$project$Pages$Fleet_$Geofences$init = F4(
	function (session, apiUrl, fleetUrl, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					sheet: $author$project$Views$SidebarSheet$init,
					apiUrl: apiUrl,
					mapSize: _Utils_Tuple2(350, 850),
					fleetUrl: fleetUrl,
					isSaving: false,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					geofences: _List_Nil,
					isDeleting: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: f.zoom,
						centre: {lat: f.latitude, _long: f.longitude}
					},
					measureLine: _List_Nil,
					editingGeofence: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					showGeofenceDeleteWarning: false
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchGeofences, session.authToken, apiUrl, f, $author$project$Pages$Fleet_$Geofences$OnFetchGeofences),
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Geofences$GotZone, $elm$time$Time$here)),
							$author$project$Effect$fromCmd(
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Geofences$OnTick, $elm$time$Time$now)),
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Fleet_$Geofences$OnGetMapElement,
								$elm$browser$Browser$Dom$getElement('map'))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Edit Geofences')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					sheet: $author$project$Views$SidebarSheet$init,
					apiUrl: apiUrl,
					mapSize: _Utils_Tuple2(350, 850),
					fleetUrl: fleetUrl,
					isSaving: false,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					geofences: _List_Nil,
					isDeleting: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: 12,
						centre: {lat: -32.0620287, _long: 115.7388788}
					},
					measureLine: _List_Nil,
					editingGeofence: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					showGeofenceDeleteWarning: false
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Geofences$NoOp = {$: 'NoOp'};
var $author$project$Pages$Fleet_$Geofences$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Geofences$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $author$project$Pages$Fleet_$Geofences$CancelEdit = {$: 'CancelEdit'};
var $author$project$Pages$Fleet_$Geofences$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Geofences$MapClicked = function (a) {
	return {$: 'MapClicked', a: a};
};
var $author$project$Pages$Fleet_$Geofences$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Pages$Fleet_$Geofences$MapMouseMove = function (a) {
	return {$: 'MapMouseMove', a: a};
};
var $author$project$Pages$Fleet_$Geofences$ChangeGeometry = function (a) {
	return {$: 'ChangeGeometry', a: a};
};
var $author$project$Pages$Fleet_$Geofences$ControlClicked = function (a) {
	return {$: 'ControlClicked', a: a};
};
var $author$project$Pages$Fleet_$Geofences$SelectGeofence = function (a) {
	return {$: 'SelectGeofence', a: a};
};
var $author$project$Pages$Fleet_$Geofences$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Geofences$SheetMsg = function (a) {
	return {$: 'SheetMsg', a: a};
};
var $author$project$Pages$Fleet_$Geofences$Line = {$: 'Line'};
var $author$project$Pages$Fleet_$Geofences$Circle = {$: 'Circle'};
var $author$project$Pages$Fleet_$Geofences$Polygon = {$: 'Polygon'};
var $author$project$Pages$Fleet_$Geofences$AddGeofence = function (a) {
	return {$: 'AddGeofence', a: a};
};
var $author$project$FontAwesome$Internal$log = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'log',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M 9 18 C 13.9706 18 18 13.9706 18 9 C 18 4.0294 13.9706 0 9 0 C 4.0294 0 0 4.0294 0 9 C 0 13.9706 4.0294 18 9 18 Z M 7.1885 6.0317 L 5.9191 7.4421 C 5.8486 7.5302 5.7428 7.5831 5.6194 7.5831 C 5.5136 7.6008 5.3902 7.5479 5.3197 7.4597 L 4.6144 6.7545 C 4.4381 6.5958 4.4381 6.3314 4.6144 6.1551 C 4.7731 5.9964 5.0376 5.9964 5.2139 6.1551 L 5.6017 6.5606 L 6.5714 5.4675 C 6.7301 5.3088 6.9945 5.2912 7.1708 5.4498 C 7.3295 5.6085 7.3472 5.873 7.1885 6.0493 L 7.1885 6.0317 z M 7.8761 6.4548 C 7.8761 6.2256 8.0524 6.0317 8.2992 6.0317 L 13.0947 6.0317 C 13.3239 6.0317 13.5178 6.2256 13.5178 6.4548 C 13.5178 6.7016 13.3239 6.8779 13.0947 6.8779 L 8.2992 6.8779 C 8.0524 6.8779 7.8761 6.7016 7.8761 6.4548 z M 7.1885 8.8525 L 5.9191 10.263 C 5.8486 10.3511 5.7428 10.404 5.6194 10.404 C 5.5136 10.4216 5.3902 10.3687 5.3197 10.2806 L 4.6144 9.5754 C 4.4381 9.4167 4.4381 9.1523 4.6144 8.9759 C 4.7731 8.8173 5.0376 8.8173 5.2139 8.9759 L 5.6017 9.3814 L 6.5714 8.2883 C 6.7301 8.1297 6.9945 8.112 7.1708 8.2707 C 7.3295 8.4294 7.3472 8.6938 7.1885 8.8702 L 7.1885 8.8525 z M 8.2992 8.8525 L 13.0947 8.8525 C 13.3239 8.8525 13.5178 9.0465 13.5178 9.2757 C 13.5178 9.5225 13.3239 9.6988 13.0947 9.6988 L 8.2992 9.6988 C 8.0524 9.6988 7.8761 9.5225 7.8761 9.2757 C 7.8761 9.0465 8.0524 8.8525 8.2992 8.8525 z M 5.6194 12.6607 C 5.302 12.6607 5.0552 12.4139 5.0552 12.0965 C 5.0552 11.7968 5.302 11.5324 5.6194 11.5324 C 5.9191 11.5324 6.1835 11.7968 6.1835 12.0965 C 6.1835 12.4139 5.9191 12.6607 5.6194 12.6607 z M 7.735 11.6734 L 13.0947 11.6734 C 13.3239 11.6734 13.5178 11.8673 13.5178 12.0965 C 13.5178 12.3434 13.3239 12.5197 13.0947 12.5197 L 7.735 12.5197 C 7.4882 12.5197 7.3119 12.3434 7.3119 12.0965 C 7.3119 11.8673 7.4882 11.6734 7.735 11.6734 z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$log = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$log);
var $author$project$FontAwesome$Internal$bellCircle = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fan',
	'bell-circle',
	_Utils_Tuple2(18, 18),
	_Utils_Tuple2('M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M10.34375,13.03121 L7.65625,13.03121 C7.65625,13.38821 7.79692,13.73041 8.04888,13.98241 C8.30083,14.23431 8.64307,14.37501 9,14.37501 C9.35695,14.37501 9.69915,14.23431 9.95115,13.98241 C10.20305,13.73041 10.34375,13.38821 10.34375,13.03121 Z M9,3.625 C8.62837,3.625 8.32813,3.92524 8.32813,4.29687 L8.32813,4.7 C6.79541,5.01074 5.64063,6.36709 5.64063,7.99219 L5.64063,8.52549 C5.64063,9.47871 5.31519,10.40461 4.721,11.14791 L4.40816,11.54051 C4.28638,11.69171 4.26328,11.89951 4.34727,12.07381 C4.43125,12.24811 4.60762,12.35941 4.80078,12.35941 L13.19925,12.35941 C13.39235,12.35941 13.56875,12.24811 13.65275,12.07381 C13.73675,11.89951 13.71365,11.69171 13.59185,11.54051 L13.27905,11.15001 C12.68485,10.40461 12.35935,9.47871 12.35935,8.52549 L12.35935,7.99219 C12.35935,6.36709 11.20455,5.01074 9.67185,4.7 L9.67185,4.29687 C9.67185,3.92524 9.37165,3.625 9,3.625 Z M9,5.64062 C10.29965,5.64062 11.35155,6.69253 11.35155,7.99219 L11.35155,8.52549 C11.35155,9.53121 11.64345,10.51171 12.18515,11.35161 L5.81489,11.35161 C6.35659,10.51171 6.64844,9.53121 6.64844,8.52549 L6.64844,7.99219 C6.64844,6.69253 7.70034,5.64062 9,5.64062 Z M6.00596,3.94834 C5.81489,3.74678 5.49575,3.73838 5.29419,3.93154 C4.26538,4.90996 3.625,6.2936 3.625,7.82422 C3.625,8.10347 3.84966,8.32812 4.12891,8.32812 C4.40816,8.32812 4.63281,8.10347 4.63281,7.82422 C4.63281,6.57915 5.15352,5.45796 5.98916,4.66221 C6.19072,4.47114 6.19912,4.152 6.00596,3.94834 Z M12.70795,3.93154 C12.50635,3.74048 12.18725,3.74678 11.99615,3.94834 C11.80505,4.1499 11.81135,4.46904 12.01085,4.66221 C12.84645,5.45796 13.36715,6.57915 13.36715,7.82422 C13.36715,8.10347 13.59185,8.32812 13.87105,8.32812 C14.15035,8.32812 14.37505,8.10347 14.37505,7.82422 C14.37505,6.2936 13.73465,4.90996 12.70795,3.93154 Z', $elm$core$Maybe$Nothing));
var $author$project$FontAwesome$Custom$bellCircle = $lattyware$elm_fontawesome$FontAwesome$present($author$project$FontAwesome$Internal$bellCircle);
var $author$project$Data$GeofenceType$icon = function (t) {
	switch (t.$) {
		case 'Restricted':
			return $author$project$FontAwesome$Custom$noEntry;
		case 'Log':
			return $author$project$FontAwesome$Custom$log;
		case 'Notify':
			return $author$project$FontAwesome$Custom$bellCircle;
		default:
			return $author$project$FontAwesome$Custom$gauge;
	}
};
var $lattyware$elm_fontawesome$FontAwesome$titled = F2(
	function (title, _v0) {
		var presentation = _v0.a;
		return $lattyware$elm_fontawesome$FontAwesome$Internal$Icon(
			_Utils_update(
				presentation,
				{
					title: $elm$core$Maybe$Just(title)
				}));
	});
var $lattyware$elm_fontawesome$FontAwesome$withId = F2(
	function (id, _v0) {
		var presentation = _v0.a;
		return $lattyware$elm_fontawesome$FontAwesome$Internal$Icon(
			_Utils_update(
				presentation,
				{
					id: $elm$core$Maybe$Just(id)
				}));
	});
var $author$project$Data$GeofenceType$colorClass = function (t) {
	switch (t.$) {
		case 'Restricted':
			return 'text-danger';
		case 'Log':
			return 'text-secondary';
		case 'Notify':
			return 'text-warning';
		default:
			return 'text-warning';
	}
};
var $author$project$Data$GeofenceType$toDisplayString = function (t) {
	switch (t.$) {
		case 'Restricted':
			return 'Restricted Zone';
		case 'Log':
			return 'Log Only';
		case 'Notify':
			switch (t.a.$) {
				case 'Entry':
					var _v1 = t.a;
					return 'Notify on Entry';
				case 'Exit':
					var _v2 = t.a;
					return 'Notify on Exit';
				case 'Both':
					var _v3 = t.a;
					return 'Notify on Entry and Exit';
				default:
					var _v4 = t.a;
					return 'Notify on Crossed';
			}
		default:
			return 'Speed Restricted Zone';
	}
};
var $author$project$Pages$Fleet_$Geofences$geofenceListItem = function (geofence) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group-item py-3 lh-sm')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex w-100 align-items-center justify-content-between')
					]),
				_List_fromArray(
					[
						$lattyware$elm_fontawesome$FontAwesome$view(
						A2(
							$lattyware$elm_fontawesome$FontAwesome$titled,
							$author$project$Data$GeofenceType$toDisplayString(geofence.type_),
							A2(
								$lattyware$elm_fontawesome$FontAwesome$withId,
								'geofence-type-icon-' + geofence.fenceId,
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class(
											$author$project$Data$GeofenceType$colorClass(geofence.type_) + ' me-2 fs-2')
										]),
									$author$project$Data$GeofenceType$icon(geofence.type_))))),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-primary small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(geofence.name)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-1')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Fleet_$Geofences$SelectGeofence(geofence.fenceId)),
								$elm$html$Html$Attributes$title('Edit Geofence')
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('text-secondary small')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$edit))
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Geofences$geofenceList = F2(
	function (geofences, disableAdd) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-3 mx-1 row align-items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col d-none d-md-block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Geofences')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown col-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn btn-sm btn-light dropdown-toggle'),
											$elm$html$Html$Attributes$type_('button'),
											A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'dropdown'),
											$elm$html$Html$Attributes$disabled(disableAdd)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add new Geofence')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dropdown-menu')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('dropdown-item'),
															$elm$html$Html$Events$onClick(
															$author$project$Pages$Fleet_$Geofences$AddGeofence($author$project$Pages$Fleet_$Geofences$Circle))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Circle')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('dropdown-item'),
															$elm$html$Html$Events$onClick(
															$author$project$Pages$Fleet_$Geofences$AddGeofence($author$project$Pages$Fleet_$Geofences$Polygon))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Polygon')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('dropdown-item'),
															$elm$html$Html$Events$onClick(
															$author$project$Pages$Fleet_$Geofences$AddGeofence($author$project$Pages$Fleet_$Geofences$Line))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Line')
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group list-group-flush border-bottom scrollarea')
						]),
					A2($elm$core$List$map, $author$project$Pages$Fleet_$Geofences$geofenceListItem, geofences))
				]));
	});
var $author$project$Data$GeofenceType$lineTypes = _List_fromArray(
	[
		$author$project$Data$GeofenceType$Log,
		$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Crossed)
	]);
var $author$project$Data$GeofenceType$polygonTypes = _List_fromArray(
	[
		$author$project$Data$GeofenceType$Restricted,
		$author$project$Data$GeofenceType$Log,
		$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Entry),
		$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Exit),
		$author$project$Data$GeofenceType$Notify($author$project$Data$GeofenceType$Both),
		$author$project$Data$GeofenceType$SpeedRestricted
	]);
var $author$project$Views$GeofenceForm$view = F5(
	function (form, isSaving, toMsg, cancelMsg, deleteMsg) {
		var validTypes = function () {
			var _v4 = A2($enbala$elm_form$Form$getFieldAsString, 'geometryType', form).value;
			if ((_v4.$ === 'Just') && (_v4.a === 'line')) {
				return $author$project$Data$GeofenceType$lineTypes;
			} else {
				return $author$project$Data$GeofenceType$polygonTypes;
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2(
							$enbala$elm_form$Form$Input$textInput,
							A2($enbala$elm_form$Form$getFieldAsString, 'name', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-control form-control-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'name', form)))
										]))
								])))
					])),
				function () {
				var _v0 = A2($enbala$elm_form$Form$getFieldAsString, 'geometryType', form).value;
				if ((_v0.$ === 'Just') && (_v0.a === 'circle')) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
										$elm$html$Html$Attributes$for('center')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Centre')
									])),
								A2(
								$elm$html$Html$map,
								toMsg,
								A2(
									$enbala$elm_form$Form$Input$textInput,
									A2($enbala$elm_form$Form$getFieldAsString, 'center', form),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('form-control form-control-sm', true),
													_Utils_Tuple2(
													'is-invalid',
													$elm_community$maybe_extra$Maybe$Extra$isJust(
														A2($author$project$Form$Extra$getErrorFor, 'center', form)))
												]))
										])))
							]));
				} else {
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
				}
			}(),
				function () {
				var _v1 = A2($enbala$elm_form$Form$getFieldAsString, 'geometryType', form).value;
				if ((_v1.$ === 'Just') && (_v1.a === 'circle')) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
										$elm$html$Html$Attributes$for('radius')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Radius')
									])),
								A2(
								$elm$html$Html$map,
								toMsg,
								A2(
									$enbala$elm_form$Form$Input$textInput,
									A2($enbala$elm_form$Form$getFieldAsString, 'radius', form),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('form-control form-control-sm', true),
													_Utils_Tuple2(
													'is-invalid',
													$elm_community$maybe_extra$Maybe$Extra$isJust(
														A2($author$project$Form$Extra$getErrorFor, 'radius', form)))
												]))
										])))
							]));
				} else {
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
								$elm$html$Html$Attributes$for('type')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Type')
							])),
						A2(
						$elm$html$Html$map,
						toMsg,
						A3(
							$enbala$elm_form$Form$Input$selectInput,
							A2(
								$elm$core$List$map,
								function (t) {
									return _Utils_Tuple2(
										$author$project$Data$GeofenceType$toString(t),
										$author$project$Data$GeofenceType$toDisplayString(t));
								},
								validTypes),
							A2($enbala$elm_form$Form$getFieldAsString, 'type', form),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-select form-select-sm', true),
											_Utils_Tuple2(
											'is-invalid',
											$elm_community$maybe_extra$Maybe$Extra$isJust(
												A2($author$project$Form$Extra$getErrorFor, 'type', form)))
										]))
								])))
					])),
				function () {
				var _v2 = A2($enbala$elm_form$Form$getFieldAsString, 'geometryType', form).value;
				if ((_v2.$ === 'Just') && (_v2.a === 'line')) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
										$elm$html$Html$Attributes$for('crossingType')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Crossing Type')
									])),
								A2(
								$elm$html$Html$map,
								toMsg,
								A3(
									$enbala$elm_form$Form$Input$selectInput,
									_List_fromArray(
										[
											_Utils_Tuple2('', 'Passed'),
											_Utils_Tuple2('under', 'Passed under')
										]),
									A2($enbala$elm_form$Form$getFieldAsString, 'crossingType', form),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('form-select form-select-sm', true),
													_Utils_Tuple2(
													'is-invalid',
													$elm_community$maybe_extra$Maybe$Extra$isJust(
														A2($author$project$Form$Extra$getErrorFor, 'crossingType', form)))
												]))
										])))
							]));
				} else {
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
				}
			}(),
				function () {
				var _v3 = A2($enbala$elm_form$Form$getFieldAsString, 'type', form).value;
				if ((_v3.$ === 'Just') && (_v3.a === 'speed_restricted')) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-label form-control-sm text-secondary mb-0 ps-0'),
										$elm$html$Html$Attributes$for('maxSpeed')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Max Speed')
									])),
								A2(
								$elm$html$Html$map,
								toMsg,
								A2(
									$enbala$elm_form$Form$Input$textInput,
									A2($enbala$elm_form$Form$getFieldAsString, 'maxSpeed', form),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('form-control form-control-sm', true),
													_Utils_Tuple2(
													'is-invalid',
													$elm_community$maybe_extra$Maybe$Extra$isJust(
														A2($author$project$Form$Extra$getErrorFor, 'maxSpeed', form)))
												]))
										])))
							]));
				} else {
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex my-3 flex-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-sm btn-link col-auto mx-1'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick(cancelMsg)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-sm btn-light col-auto mx-1'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick(deleteMsg)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete'),
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('ms-2')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$trash))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-1')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								'btn btn-sm btn-primary col-auto mx-1' + ($elm$core$List$isEmpty(
									$enbala$elm_form$Form$getErrors(form)) ? '' : ' disabled')),
								$elm$html$Html$Events$onClick(
								toMsg($enbala$elm_form$Form$Submit))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save'),
								isSaving ? $lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
											$elm$svg$Svg$Attributes$class('mx-2')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
							]))
					]))
			]);
	});
var $author$project$Pages$Fleet_$Geofences$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Pages$Fleet_$Geofences$PromptForDeletion = {$: 'PromptForDeletion'};
var $author$project$Pages$Fleet_$Geofences$geofenceEditForm = F2(
	function (geofenceForm, isSaving) {
		var _v0 = geofenceForm;
		var form = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidebar-page flex-column align-items-stretch flex-shrink-0 p-3')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn btn-light btn-sm btn-circle me-2'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Geofences$CancelEdit)
										]),
									_List_fromArray(
										[
											$lattyware$elm_fontawesome$FontAwesome$view($lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small fw-medium')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Back')
										]))
								])),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Edit Geofence')
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]),
						A5($author$project$Views$GeofenceForm$view, form, isSaving, $author$project$Pages$Fleet_$Geofences$FormMsg, $author$project$Pages$Fleet_$Geofences$CancelEdit, $author$project$Pages$Fleet_$Geofences$PromptForDeletion),
						_List_fromArray(
						[
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						])
					])));
	});
var $author$project$Pages$Fleet_$Geofences$geofenceSidebar = F4(
	function (sheet, geofences, geofenceForm, isSaving) {
		return A5(
			$author$project$Views$SidebarSheet$view,
			sheet,
			$author$project$Pages$Fleet_$Geofences$SheetMsg,
			$elm$core$Maybe$Just('Geofences'),
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Fleet_$Geofences$geofenceList,
					geofences,
					$elm_community$maybe_extra$Maybe$Extra$isJust(geofenceForm)),
					function () {
					if (geofenceForm.$ === 'Just') {
						var form = geofenceForm.a;
						return A2($author$project$Pages$Fleet_$Geofences$geofenceEditForm, form, isSaving);
					} else {
						return A2($elm$html$Html$span, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Pages$Fleet_$Geofences$DismissModal = {$: 'DismissModal'};
var $author$project$Pages$Fleet_$Geofences$DeleteGeofence = {$: 'DeleteGeofence'};
var $author$project$Pages$Fleet_$Geofences$confirmDeleteDialog = F2(
	function (showDialog, isDeleting) {
		return $author$project$Views$Dialog$view(
			showDialog ? $elm$core$Maybe$Just(
				{
					body: $elm$core$Maybe$Just(
						$elm$html$Html$text('Are you sure you want to delete this geofence? This action cannot be undone.')),
					footer: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-danger'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Geofences$DeleteGeofence)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete'),
									isDeleting ? $lattyware$elm_fontawesome$FontAwesome$view(
									A2(
										$lattyware$elm_fontawesome$FontAwesome$styled,
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
												$elm$svg$Svg$Attributes$class('ms-2')
											]),
										$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch)) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
								]))),
					header: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Delete Geofence')
								]))),
					closeMessage: $elm$core$Maybe$Just($author$project$Pages$Fleet_$Geofences$DismissModal),
					containerClass: $elm$core$Maybe$Nothing
				}) : $elm$core$Maybe$Nothing);
	});
var $author$project$Pages$Fleet_$Geofences$consolidatedGeofences = function (model) {
	var _v0 = model.editingGeofence;
	if (_v0.$ === 'Nothing') {
		return model.geofences;
	} else {
		var _v1 = _v0.a;
		var editing = _v1.b;
		return A2(
			$elm$core$List$all,
			function (f) {
				return !_Utils_eq(f.fenceId, editing.fenceId);
			},
			model.geofences) ? A2(
			$elm$core$List$append,
			_List_fromArray(
				[editing]),
			model.geofences) : A2(
			$elm$core$List$map,
			function (f) {
				return _Utils_eq(f.fenceId, editing.fenceId) ? editing : f;
			},
			model.geofences);
	}
};
var $author$project$Pages$Fleet_$Geofences$geofencesExceptEditing = function (model) {
	var _v0 = model.editingGeofence;
	if (_v0.$ === 'Nothing') {
		return model.geofences;
	} else {
		var _v1 = _v0.a;
		var editing = _v1.b;
		return A2(
			$elm$core$List$filter,
			function (f) {
				return !_Utils_eq(f.fenceId, editing.fenceId);
			},
			model.geofences);
	}
};
var $author$project$Pages$Fleet_$Geofences$view = F4(
	function (session, req, featureDropState, model) {
		var measureLabel = function () {
			if (model.measureModeActive && ($elm$core$List$length(model.measureLine) >= 2)) {
				var lastPoint = $elm$core$List$head(
					$elm$core$List$reverse(model.measureLine));
				var dist = A2(
					$author$project$Data$DistanceUnit$formatDistance,
					model.fleet.longDistanceUnit,
					$author$project$Geospatial$LatLong$distance(model.measureLine));
				return A2(
					$elm$core$Maybe$map,
					function (ll) {
						return A2($author$project$Views$Mapbox$distanceLocationLabel, ll, dist);
					},
					lastPoint);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var mapConfig = A2(
			$author$project$Views$Mapbox$withDrawConfig,
			{
				onMove: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Pages$Fleet_$Geofences$ChangeGeometry),
						$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Geofences$NoOp))),
				onSelectionChange: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Pages$Fleet_$Geofences$SelectGeofence),
						$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Geofences$CancelEdit))),
				onChangeCoordinates: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Pages$Fleet_$Geofences$ChangeGeometry),
						$elm$core$Maybe$withDefault($author$project$Pages$Fleet_$Geofences$NoOp)))
			},
			A2(
				$author$project$Views$Mapbox$withGeofences,
				$author$project$Pages$Fleet_$Geofences$geofencesExceptEditing(model),
				A2(
					$author$project$Views$Mapbox$withIdleMsg,
					function (_v0) {
						var c = _v0.a;
						var z = _v0.b;
						var bounds = _v0.c;
						return $author$project$Pages$Fleet_$Geofences$MapIdle(
							{
								zoom: z,
								bounds: {northEast: bounds.ne, southWest: bounds.sw},
								centre: c
							});
					},
					A5(
						$author$project$Views$Mapbox$withRuler,
						model.measureLine,
						model.fleet.longDistanceUnit,
						model.measureModeActive,
						$author$project$Pages$Fleet_$Geofences$ControlClicked('measure'),
						A2(
							$author$project$Views$Mapbox$withFeatureClickMsg,
							function (i) {
								return $elm_community$maybe_extra$Maybe$Extra$isJust(model.editingGeofence) ? $author$project$Pages$Fleet_$Geofences$NoOp : $author$project$Pages$Fleet_$Geofences$SelectGeofence(i);
							},
							A2(
								$author$project$Views$Mapbox$withMouseMoveMsg,
								model.measureModeActive ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$Geofences$MapMouseMove) : $elm$core$Maybe$Nothing,
								A2(
									$author$project$Views$Mapbox$withMapClickMsg,
									$author$project$Pages$Fleet_$Geofences$MapClicked,
									A3(
										$author$project$Views$Mapbox$withStyleSelect,
										model.mapStyle,
										$author$project$Pages$Fleet_$Geofences$SelectStyle,
										A3($author$project$Views$Mapbox$init, model.mapPosition, model.fleetUrl, $author$project$Pages$Fleet_$Geofences$NoOp)))))))));
		return {
			body: A2(
				$author$project$Html$Layout$fitWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(req.route),
					featureDropState,
					$author$project$Pages$Fleet_$Geofences$ChangelogAction,
					$author$project$Pages$Fleet_$Geofences$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column-reverse flex-md-row no-wrap'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Views$Mapbox$view,
								mapConfig,
								$elm_community$maybe_extra$Maybe$Extra$toList(measureLabel)),
								A4(
								$author$project$Pages$Fleet_$Geofences$geofenceSidebar,
								model.sheet,
								$author$project$Pages$Fleet_$Geofences$consolidatedGeofences(model),
								model.editingGeofence,
								model.isSaving),
								A2($author$project$Pages$Fleet_$Geofences$confirmDeleteDialog, model.showGeofenceDeleteWarning, model.isDeleting),
								A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Geofences$CloseError)
							]))
					])),
			title: 'Geofences'
		};
	});
var $author$project$Views$GeofenceForm$fromGeofence = F2(
	function (geofence, unit) {
		return A2(
			$elm$core$List$append,
			$author$project$Views$GeofenceForm$fromGeometry(geofence.geometry),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fenceId',
					$enbala$elm_form$Form$Field$string(geofence.fenceId)),
					_Utils_Tuple2(
					'name',
					$enbala$elm_form$Form$Field$string(geofence.name)),
					_Utils_Tuple2(
					'type',
					$enbala$elm_form$Form$Field$string(
						$author$project$Data$GeofenceType$toString(geofence.type_))),
					_Utils_Tuple2(
					'crossingType',
					$enbala$elm_form$Form$Field$string(
						A2($elm$core$Maybe$withDefault, '', geofence.crossingType))),
					_Utils_Tuple2(
					'maxSpeed',
					$enbala$elm_form$Form$Field$string(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Data$SpeedUnit$formatSpeed(unit),
								geofence.maxSpeed))))
				]));
	});
var $author$project$Views$GeofenceForm$validateMaxSpeed = A2(
	$enbala$elm_form$Form$Validate$andThen,
	function (t) {
		var _v0 = $author$project$Data$GeofenceType$fromString(t);
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'SpeedRestricted')) {
			var _v1 = _v0.a;
			return A2(
				$enbala$elm_form$Form$Validate$field,
				'maxSpeed',
				A2(
					$enbala$elm_form$Form$Validate$map,
					$elm$core$Maybe$Just,
					A2(
						$enbala$elm_form$Form$Validate$customValidation,
						$enbala$elm_form$Form$Validate$string,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Data$SpeedUnit$parseSpeed,
							$elm$core$Result$fromMaybe(
								$enbala$elm_form$Form$Validate$customError('Please enter a valid speed'))))));
		} else {
			return $enbala$elm_form$Form$Validate$succeed($elm$core$Maybe$Nothing);
		}
	},
	A2($enbala$elm_form$Form$Validate$field, 'type', $enbala$elm_form$Form$Validate$string));
var $author$project$Views$GeofenceForm$validateGeofenceType = A2(
	$enbala$elm_form$Form$Validate$customValidation,
	$enbala$elm_form$Form$Validate$string,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$GeofenceType$fromString,
		$elm$core$Result$fromMaybe(
			$enbala$elm_form$Form$Validate$customError('Please enter a valid geofence type'))));
var $author$project$Views$GeofenceForm$validateGeofence = A2(
	$enbala$elm_form$Form$Validate$andMap,
	$author$project$Views$GeofenceForm$validateMaxSpeed,
	A2(
		$enbala$elm_form$Form$Validate$andMap,
		A2(
			$enbala$elm_form$Form$Validate$field,
			'crossingType',
			$enbala$elm_form$Form$Validate$maybe(
				A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string))),
		A2(
			$enbala$elm_form$Form$Validate$andMap,
			A2($enbala$elm_form$Form$Validate$field, 'type', $author$project$Views$GeofenceForm$validateGeofenceType),
			A2(
				$enbala$elm_form$Form$Validate$andMap,
				$author$project$Views$GeofenceForm$validateGeometry,
				A2(
					$enbala$elm_form$Form$Validate$andMap,
					A2(
						$enbala$elm_form$Form$Validate$field,
						'name',
						A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
					A2(
						$enbala$elm_form$Form$Validate$andMap,
						A2(
							$enbala$elm_form$Form$Validate$field,
							'fenceId',
							A2($enbala$elm_form$Form$Validate$andThen, $enbala$elm_form$Form$Validate$nonEmpty, $enbala$elm_form$Form$Validate$string)),
						$enbala$elm_form$Form$Validate$succeed($author$project$Data$Geofence$Geofence)))))));
var $author$project$Views$GeofenceForm$init = F2(
	function (g, unit) {
		return A2(
			$enbala$elm_form$Form$initial,
			A2($author$project$Views$GeofenceForm$fromGeofence, g, unit),
			$author$project$Views$GeofenceForm$validateGeofence);
	});
var $author$project$Views$GeofenceForm$update = F2(
	function (msg, form) {
		return A3($enbala$elm_form$Form$update, $author$project$Views$GeofenceForm$validateGeofence, msg, form);
	});
var $author$project$Pages$Fleet_$Geofences$dropLast = function (list) {
	if (!list.b) {
		return _List_Nil;
	} else {
		if (!list.b.b) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$take,
				$elm$core$List$length(list) - 1,
				list);
		}
	}
};
var $author$project$Pages$Fleet_$Geofences$newFenceId = 'new';
var $author$project$Data$Geofence$encodeUpdate = function (geofence) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(geofence.name)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Data$GeofenceType$toString(geofence.type_))),
				_Utils_Tuple2(
				'geometry',
				$author$project$Data$Geofence$geometryEncoder(geofence.geometry)),
				_Utils_Tuple2(
				'crossingType',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, geofence.crossingType)),
				_Utils_Tuple2(
				'maxSpeed',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, geofence.maxSpeed))
			]));
};
var $author$project$Api$putGeofence = F5(
	function (token, apiUrl, fleet, geofence, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'geofences', geofence.fenceId]),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$author$project$Data$Geofence$encodeUpdate(geofence)),
					expect: $author$project$Api$expectJson($author$project$Data$Geofence$decode),
					method: 'PUT',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Geofences$sheetConfig = function (model) {
	var _v0 = model.mapSize;
	var h = _v0.b;
	return {
		detents: _List_fromArray(
			[54, h * 0.4, h - 90])
	};
};
var $author$project$Api$postGeofence = F5(
	function (token, apiUrl, fleet, geofence, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'geofences']),
						_List_Nil),
					body: $elm$http$Http$jsonBody(
						$author$project$Data$Geofence$encodeUpdate(geofence)),
					expect: $author$project$Api$expectJson($author$project$Data$Geofence$decode),
					method: 'POST',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Geofences$OnSaveGeofence = function (a) {
	return {$: 'OnSaveGeofence', a: a};
};
var $author$project$Api$deleteGeofence = F5(
	function (token, apiUrl, fleet, fenceId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet.slug, 'geofences', fenceId]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectWhatever,
					method: 'DELETE',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Views$GeofenceForm$updateGeofence = F3(
	function (g, unit, form) {
		return A3(
			$enbala$elm_form$Form$update,
			$author$project$Views$GeofenceForm$validateGeofence,
			$enbala$elm_form$Form$Reset(
				A2($author$project$Views$GeofenceForm$fromGeofence, g, unit)),
			form);
	});
var $author$project$Pages$Fleet_$Geofences$replaceGeofence = F2(
	function (f, fs) {
		return A2(
			$elm$core$List$sortWith,
			$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
				function ($) {
					return $.name;
				}),
			A2(
				$elm$core$List$cons,
				f,
				A2(
					$elm$core$List$filter,
					function (f1) {
						return !_Utils_eq(f1.fenceId, f.fenceId);
					},
					fs)));
	});
var $author$project$Pages$Fleet_$Geofences$OnDeleteGeofence = function (a) {
	return {$: 'OnDeleteGeofence', a: a};
};
var $author$project$Geospatial$LatLong$toDegrees = function (radians) {
	return (radians * 180.0) / $elm$core$Basics$pi;
};
var $author$project$Geospatial$LatLong$translate = F3(
	function (dist, bearing, latLong) {
		var bearingRad = $elm$core$Basics$degrees(bearing);
		var long1 = $elm$core$Basics$degrees(latLong._long);
		var lat1 = $elm$core$Basics$degrees(latLong.lat);
		var r = 6371088.0;
		var radians = dist / r;
		var lat2 = $elm$core$Basics$asin(
			($elm$core$Basics$sin(lat1) * $elm$core$Basics$cos(radians)) + (($elm$core$Basics$cos(lat1) * $elm$core$Basics$sin(radians)) * $elm$core$Basics$cos(bearingRad)));
		var long2 = long1 + A2(
			$elm$core$Basics$atan2,
			($elm$core$Basics$sin(bearingRad) * $elm$core$Basics$sin(radians)) * $elm$core$Basics$cos(lat1),
			$elm$core$Basics$cos(radians) - ($elm$core$Basics$sin(lat1) * $elm$core$Basics$sin(lat2)));
		return {
			lat: $author$project$Geospatial$LatLong$toDegrees(lat2),
			_long: $author$project$Geospatial$LatLong$toDegrees(long2)
		};
	});
var $author$project$Geospatial$LatLong$generateCirclePolygon = F3(
	function (center, radius, points) {
		return A2(
			$elm$core$List$map,
			function (i) {
				var angle = (i / points) * 360.0;
				return A3($author$project$Geospatial$LatLong$translate, radius, angle, center);
			},
			A2($elm$core$List$range, 0, points - 1));
	});
var $author$project$Views$Mapbox$geofenceToDrawLayer = function (geofence) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Feature')),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(geofence.fenceId)),
				_Utils_Tuple2(
				'properties',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'geofenceType',
							$elm$json$Json$Encode$string(
								$author$project$Data$GeofenceType$toString(geofence.type_))),
							_Utils_Tuple2(
							'radiusInKm',
							function () {
								var _v0 = geofence.geometry;
								if (_v0.$ === 'Circle') {
									var _v1 = _v0.a;
									var r = _v1.b;
									return $elm$json$Json$Encode$float(r / 1000.0);
								} else {
									return $elm$json$Json$Encode$null;
								}
							}()),
							_Utils_Tuple2(
							'isCircle',
							function () {
								var _v2 = geofence.geometry;
								if (_v2.$ === 'Circle') {
									var _v3 = _v2.a;
									return $elm$json$Json$Encode$bool(true);
								} else {
									return $elm$json$Json$Encode$bool(false);
								}
							}()),
							_Utils_Tuple2(
							'isRoute',
							$elm$json$Json$Encode$bool(false)),
							_Utils_Tuple2(
							'center',
							function () {
								var _v4 = geofence.geometry;
								if (_v4.$ === 'Circle') {
									var _v5 = _v4.a;
									var ll = _v5.a;
									return $author$project$Views$Mapbox$latLongToGeoJSON(ll);
								} else {
									return $elm$json$Json$Encode$null;
								}
							}())
						]))),
				_Utils_Tuple2(
				'geometry',
				function () {
					var _v6 = geofence.geometry;
					switch (_v6.$) {
						case 'Polygon':
							var points = _v6.a;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('Polygon')),
										_Utils_Tuple2(
										'coordinates',
										A2(
											$elm$json$Json$Encode$list,
											$elm$json$Json$Encode$list($author$project$Views$Mapbox$latLongToGeoJSON),
											_List_fromArray(
												[points])))
									]));
						case 'Circle':
							var _v7 = _v6.a;
							var center = _v7.a;
							var radius = _v7.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('Polygon')),
										_Utils_Tuple2(
										'coordinates',
										A2(
											$elm$json$Json$Encode$list,
											$elm$json$Json$Encode$list($author$project$Views$Mapbox$latLongToGeoJSON),
											_List_fromArray(
												[
													A3($author$project$Geospatial$LatLong$generateCirclePolygon, center, radius, 64)
												])))
									]));
						default:
							var points = _v6.a;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('LineString')),
										_Utils_Tuple2(
										'coordinates',
										A2($elm$json$Json$Encode$list, $author$project$Views$Mapbox$latLongToGeoJSON, points))
									]));
					}
				}())
			]));
};
var $author$project$Pages$Fleet_$Geofences$startMapboxDrawEdit = function (geofence) {
	var selectCmd = A2(
		$author$project$MapCommands$changeDrawMode,
		'direct_select',
		$elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'featureId',
						$elm$json$Json$Encode$string(geofence.fenceId))
					]))));
	return $author$project$Effect$fromCmd(
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					selectCmd,
					$author$project$MapCommands$addDrawFeatures(
					$author$project$Views$Mapbox$geofenceToDrawLayer(geofence))
				])));
};
var $author$project$Pages$Fleet_$Geofences$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Effect$none);
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'OnResizeWindow':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Fleet_$Geofences$OnGetMapElement,
							$elm$browser$Browser$Dom$getElement('map'))));
			case 'OnGetMapElement':
				if (msg.a.$ === 'Ok') {
					var element = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mapSize: _Utils_Tuple2(element.element.width, element.element.height)
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'MapIdle':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(b))
						}),
					$author$project$Effect$none);
			case 'MapClicked':
				var latLong = msg.a;
				var updatedModel = model.measureModeActive ? _Utils_update(
					model,
					{
						measureLine: _Utils_ap(
							model.measureLine,
							_List_fromArray(
								[
									{lat: latLong.lat, _long: latLong._long},
									{lat: latLong.lat, _long: latLong._long}
								]))
					}) : model;
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'MapMouseMove':
				var latLong = msg.a;
				if (model.measureModeActive) {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: _Utils_ap(
								$author$project$Pages$Fleet_$Geofences$dropLast(model.measureLine),
								_List_fromArray(
									[
										{lat: latLong.lat, _long: latLong._long}
									]))
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'ControlClicked':
				var id = msg.a;
				if (id === 'measure') {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: model.measureModeActive ? _List_Nil : model.measureLine,
							measureModeActive: !model.measureModeActive
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'OnFetchGeofences':
				if (msg.a.$ === 'Ok') {
					var gs = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							geofences: A2(
								$elm$core$List$sortWith,
								$mcordova47$elm_natural_ordering$NaturalOrdering$compareOn(
									function ($) {
										return $.name;
									}),
								gs)
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'AddGeofence':
				var t = msg.a;
				var metersPP = A2(
					$author$project$Geospatial$MapProjection$metersPerPixel,
					model.mapPosition.centre.lat,
					$elm$core$Basics$round(model.mapPosition.zoom));
				var _new = function () {
					switch (t.$) {
						case 'Circle':
							return {
								name: '',
								type_: $author$project$Data$GeofenceType$Restricted,
								fenceId: $author$project$Pages$Fleet_$Geofences$newFenceId,
								geometry: $author$project$Data$Geofence$Circle(
									_Utils_Tuple2(
										{lat: model.mapPosition.centre.lat, _long: model.mapPosition.centre._long},
										100 * metersPP)),
								maxSpeed: $elm$core$Maybe$Nothing,
								crossingType: $elm$core$Maybe$Nothing
							};
						case 'Polygon':
							var side = A2(
								$author$project$Geospatial$MapProjection$degreesPerPixel,
								model.mapPosition.centre.lat,
								$elm$core$Basics$round(model.mapPosition.zoom)) * 100;
							var maxLat = model.mapPosition.centre.lat + (side / 2);
							var maxLng = model.mapPosition.centre._long + (side / 2);
							var minLat = model.mapPosition.centre.lat - (side / 2);
							var minLng = model.mapPosition.centre._long - (side / 2);
							return {
								name: '',
								type_: $author$project$Data$GeofenceType$Restricted,
								fenceId: $author$project$Pages$Fleet_$Geofences$newFenceId,
								geometry: $author$project$Data$Geofence$Polygon(
									_List_fromArray(
										[
											A2($author$project$Geospatial$LatLong$LatLong, minLat, minLng),
											A2($author$project$Geospatial$LatLong$LatLong, minLat, maxLng),
											A2($author$project$Geospatial$LatLong$LatLong, maxLat, maxLng),
											A2($author$project$Geospatial$LatLong$LatLong, maxLat, minLng),
											A2($author$project$Geospatial$LatLong$LatLong, minLat, minLng)
										])),
								maxSpeed: $elm$core$Maybe$Nothing,
								crossingType: $elm$core$Maybe$Nothing
							};
						default:
							var side = A2(
								$author$project$Geospatial$MapProjection$degreesPerPixel,
								model.mapPosition.centre.lat,
								$elm$core$Basics$round(model.mapPosition.zoom)) * 100;
							var maxLat = model.mapPosition.centre.lat + (side / 2);
							var maxLng = model.mapPosition.centre._long + (side / 2);
							var minLat = model.mapPosition.centre.lat - (side / 2);
							var minLng = model.mapPosition.centre._long - (side / 2);
							return {
								name: '',
								type_: $author$project$Data$GeofenceType$Log,
								fenceId: $author$project$Pages$Fleet_$Geofences$newFenceId,
								geometry: $author$project$Data$Geofence$Line(
									_List_fromArray(
										[
											A2($author$project$Geospatial$LatLong$LatLong, minLat, minLng),
											A2($author$project$Geospatial$LatLong$LatLong, maxLat, maxLng)
										])),
								maxSpeed: $elm$core$Maybe$Nothing,
								crossingType: $elm$core$Maybe$Nothing
							};
					}
				}();
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 1, model.sheet),
						editingGeofence: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								A2($author$project$Views$GeofenceForm$init, _new, model.fleet.speedUnit),
								_new))
					});
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Pages$Fleet_$Geofences$startMapboxDrawEdit(_new));
			case 'SelectGeofence':
				var id = msg.a;
				if (_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							function ($) {
								return $.fenceId;
							}),
						model.editingGeofence),
					$elm$core$Maybe$Just(id))) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					var selectedGeofence = A2(
						$elm_community$list_extra$List$Extra$find,
						function (g) {
							return _Utils_eq(g.fenceId, id);
						},
						model.geofences);
					var updatedModel = _Utils_update(
						model,
						{
							sheet: A2(
								$author$project$Views$SidebarSheet$showPage,
								$elm_community$maybe_extra$Maybe$Extra$isJust(selectedGeofence) ? 1 : 0,
								model.sheet),
							editingGeofence: A2(
								$elm$core$Maybe$map,
								function (g) {
									return _Utils_Tuple2(
										A2($author$project$Views$GeofenceForm$init, g, model.fleet.speedUnit),
										g);
								},
								selectedGeofence)
						});
					return _Utils_Tuple2(
						updatedModel,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Effect$none,
							A2($elm$core$Maybe$map, $author$project$Pages$Fleet_$Geofences$startMapboxDrawEdit, selectedGeofence)));
				}
			case 'ChangeGeometry':
				var _v3 = msg.a;
				var id = _v3.a;
				var g = _v3.b;
				var _v4 = model.editingGeofence;
				if (_v4.$ === 'Just') {
					var _v5 = _v4.a;
					var form = _v5.a;
					var geofence = _v5.b;
					if (_Utils_eq(geofence.fenceId, id)) {
						var updatedGeofence = _Utils_update(
							geofence,
							{geometry: g});
						var updatedForm = A3($author$project$Views$GeofenceForm$updateGeofence, updatedGeofence, model.fleet.speedUnit, form);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editingGeofence: $elm$core$Maybe$Just(
										_Utils_Tuple2(updatedForm, updatedGeofence))
								}),
							$author$project$Effect$none);
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'FormMsg':
				var m = msg.a;
				var _v6 = model.editingGeofence;
				if (_v6.$ === 'Just') {
					var _v7 = _v6.a;
					var form = _v7.a;
					var geofence = _v7.b;
					var updatedForm = A2($author$project$Views$GeofenceForm$update, m, form);
					var updatedGeofence = A2(
						$elm$core$Maybe$withDefault,
						geofence,
						$enbala$elm_form$Form$getOutput(updatedForm));
					var updatedModel = _Utils_update(
						model,
						{
							editingGeofence: $elm$core$Maybe$Just(
								_Utils_Tuple2(updatedForm, updatedGeofence))
						});
					if (m.$ === 'Submit') {
						var _v9 = $enbala$elm_form$Form$getOutput(form);
						if (_v9.$ === 'Just') {
							var submittedGeofence = _v9.a;
							var effect = _Utils_eq(submittedGeofence.fenceId, $author$project$Pages$Fleet_$Geofences$newFenceId) ? A5($author$project$Api$postGeofence, session.authToken, model.apiUrl, model.fleet, submittedGeofence, $author$project$Pages$Fleet_$Geofences$OnSaveGeofence) : A5($author$project$Api$putGeofence, session.authToken, model.apiUrl, model.fleet, submittedGeofence, $author$project$Pages$Fleet_$Geofences$OnSaveGeofence);
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{isSaving: true}),
								effect);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{
										error: $elm$core$Maybe$Just(
											{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'Unable to save Geofence'})
									}),
								$author$project$Effect$none);
						}
					} else {
						return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'CancelEdit':
				var updatedModel = _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
						editingGeofence: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					updatedModel,
					$author$project$Effect$fromCmd(
						$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0)));
			case 'OnSaveGeofence':
				if (msg.a.$ === 'Ok') {
					var fence = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
							isSaving: false,
							geofences: A2($author$project$Pages$Fleet_$Geofences$replaceGeofence, fence, model.geofences),
							editingGeofence: $elm$core$Maybe$Nothing
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							error: $elm$core$Maybe$Just(
								{
									icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
									title: 'Error',
									type_: $author$project$Views$Alert$Danger,
									message: $author$project$Api$errorString(e)
								}),
							isSaving: false
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				}
			case 'PromptForDeletion':
				var _v10 = model.editingGeofence;
				if (_v10.$ === 'Just') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isDeleting: false, showGeofenceDeleteWarning: true}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'DeleteGeofence':
				var _v11 = model.editingGeofence;
				if (_v11.$ === 'Just') {
					var _v12 = _v11.a;
					var f = _v12.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isDeleting: true, showGeofenceDeleteWarning: true}),
						A5($author$project$Api$deleteGeofence, session.authToken, model.apiUrl, model.fleet, f.fenceId, $author$project$Pages$Fleet_$Geofences$OnDeleteGeofence));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnDeleteGeofence':
				if (msg.a.$ === 'Ok') {
					var _v13 = model.editingGeofence;
					if (_v13.$ === 'Just') {
						var _v14 = _v13.a;
						var f = _v14.b;
						var updatedModel = _Utils_update(
							model,
							{
								sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
								geofences: A2(
									$elm$core$List$filter,
									function (g) {
										return !_Utils_eq(g.fenceId, f.fenceId);
									},
									model.geofences),
								isDeleting: false,
								editingGeofence: $elm$core$Maybe$Nothing,
								showGeofenceDeleteWarning: false
							});
						return _Utils_Tuple2(
							updatedModel,
							$author$project$Effect$fromCmd(
								$author$project$MapCommands$deleteAllDrawFeatures(_Utils_Tuple0)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isDeleting: false, showGeofenceDeleteWarning: false}),
							$author$project$Effect$none);
					}
				} else {
					var e = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							error: $elm$core$Maybe$Just(
								{
									icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
									title: 'Error',
									type_: $author$project$Views$Alert$Danger,
									message: $author$project$Api$errorString(e)
								}),
							isDeleting: false,
							showGeofenceDeleteWarning: false
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				}
			case 'SheetMsg':
				var sheetMsg = msg.a;
				var _v15 = A3(
					$author$project$Views$SidebarSheet$update,
					$author$project$Pages$Fleet_$Geofences$sheetConfig(model),
					sheetMsg,
					model.sheet);
				var updatedSheet = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sheet: updatedSheet}),
					$author$project$Effect$fromCmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Geofences$SheetMsg, cmd)));
			case 'DismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showGeofenceDeleteWarning: false}),
					$author$project$Effect$none);
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			case 'Logout':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Geofences$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Fleet_$Geofences$SheetMsg,
				$author$project$Views$SidebarSheet$subscriptions(model.sheet))
			]));
};
var $author$project$Pages$Fleet_$Geofences$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A4($author$project$Pages$Fleet_$Geofences$init, session, shared.apiUrl, shared.fleetUrl, req),
					view: A3($author$project$Pages$Fleet_$Geofences$view, session, req, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Geofences$update(session),
					subscriptions: $author$project$Pages$Fleet_$Geofences$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$Public$BoatId_$OnTick = function (a) {
	return {$: 'OnTick', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$GotZone = function (a) {
	return {$: 'GotZone', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$OnFetchBoats = function (a) {
	return {$: 'OnFetchBoats', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$initialModel = F5(
	function (shared, fleet, key, boatId, navWarning) {
		return {
			key: key,
			boat: $elm$core$Maybe$Nothing,
			boats: _List_Nil,
			apiUrl: shared.apiUrl,
			boatId: boatId,
			locale: shared.locale,
			places: _List_Nil,
			routes: _List_Nil,
			tracks: _List_Nil,
			bugsnag: shared.bugsnag,
			fleetUrl: shared.fleetUrl,
			mapStyle: $author$project$Views$Mapbox$Satellite,
			timeZone: $elm$time$Time$utc,
			fleetSlug: fleet,
			geofences: _List_Nil,
			showPopup: false,
			speedUnit: $author$project$Data$SpeedUnit$Knots,
			currentTime: $elm$time$Time$millisToPosix(0),
			displayMode: $author$project$Views$Discovery$Auto,
			mapPosition: {
				zoom: 12,
				centre: {lat: -32.0620287, _long: 115.7388788}
			},
			selectedPlace: $elm$core$Maybe$Nothing,
			selectedRoute: $elm$core$Maybe$Nothing,
			trackDuration: $elm$core$Maybe$Nothing,
			watermarkImage: $elm$core$Maybe$Nothing,
			routesDrawerOpen: false,
			currentSpeedLimit: $elm$core$Maybe$Nothing,
			placeAudioPlaying: false,
			showedNavigationWarning: navWarning,
			autoDisplayPlaceDistance: $elm$core$Maybe$Nothing,
			manuallyDismissedPlaceId: $elm$core$Maybe$Nothing,
			automaticallyShownPlaceId: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Pages$Fleet_$Public$BoatId_$OnFetchGuestViewConfig = function (a) {
	return {$: 'OnFetchGuestViewConfig', a: a};
};
var $author$project$Gen$Route$Fleet___Public__BoatId_ = function (a) {
	return {$: 'Fleet___Public__BoatId_', a: a};
};
var $author$project$Api$GuestViewConfig = F8(
	function (routes, geofences, places, showPopup, speedUnit, distanceUnit, autoDisplayPlaceDistance, watermarkImage) {
		return {places: places, routes: routes, geofences: geofences, showPopup: showPopup, speedUnit: speedUnit, distanceUnit: distanceUnit, watermarkImage: watermarkImage, autoDisplayPlaceDistance: autoDisplayPlaceDistance};
	});
var $author$project$Api$guestViewConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'watermarkImage',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'autoDisplayPlaceDistance',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'distanceUnit',
			$author$project$Data$DistanceUnit$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'speedUnit',
				$author$project$Data$SpeedUnit$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'showPopup',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'places',
						$elm$json$Json$Decode$list($author$project$Data$Place$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'geofences',
							$elm$json$Json$Decode$list($author$project$Data$Geofence$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'routes',
								$elm$json$Json$Decode$list($author$project$Data$Route$decode),
								$elm$json$Json$Decode$succeed($author$project$Api$GuestViewConfig)))))))));
var $author$project$Api$fetchGuestViewConfigPublic = F5(
	function (apiUrl, key, fleet, boatId, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$get(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'public',
								'boats',
								$author$project$Data$Boat$boatIdToString(boatId),
								'guestview'
							]),
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'key', key)
							])),
					expect: $author$project$Api$expectJson($author$project$Api$guestViewConfigDecoder)
				}));
	});
var $author$project$Pages$Fleet_$Public$BoatId_$init = F5(
	function (shared, fleet, key, boatId, navWarning) {
		return _Utils_Tuple2(
			A5($author$project$Pages$Fleet_$Public$BoatId_$initialModel, shared, fleet, key, boatId, navWarning),
			$author$project$Effect$fromCmd(
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A4($author$project$Api$fetchBoatsPublic, shared.apiUrl, key, fleet, $author$project$Pages$Fleet_$Public$BoatId_$OnFetchBoats),
							A5($author$project$Api$fetchGuestViewConfigPublic, shared.apiUrl, key, fleet, boatId, $author$project$Pages$Fleet_$Public$BoatId_$OnFetchGuestViewConfig),
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Public$BoatId_$GotZone, $elm$time$Time$here),
							A2($elm$core$Task$perform, $author$project$Pages$Fleet_$Public$BoatId_$OnTick, $elm$time$Time$now),
							$author$project$Ports$sendPageViewEvent(
							_Utils_Tuple2(
								$author$project$Gen$Route$toHref(
									$author$project$Gen$Route$Fleet___Public__BoatId_(
										{
											fleet: fleet,
											boatId: $author$project$Data$Boat$boatIdToString(boatId)
										})),
								fleet + ': Discovery'))
						]))));
	});
var $author$project$Pages$Fleet_$Public$BoatId_$NoOp = {$: 'NoOp'};
var $author$project$Pages$Fleet_$Public$BoatId_$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$SelectRoute = function (a) {
	return {$: 'SelectRoute', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$DismissModal = {$: 'DismissModal'};
var $author$project$Pages$Fleet_$Public$BoatId_$ManualMoveMap = {$: 'ManualMoveMap'};
var $author$project$Pages$Fleet_$Public$BoatId_$MarkerClicked = function (a) {
	return {$: 'MarkerClicked', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$ClosePlaceDrawer = {$: 'ClosePlaceDrawer'};
var $author$project$Pages$Fleet_$Public$BoatId_$OpenRoutesDrawer = {$: 'OpenRoutesDrawer'};
var $author$project$Pages$Fleet_$Public$BoatId_$TogglePlaceAudio = {$: 'TogglePlaceAudio'};
var $author$project$Pages$Fleet_$Public$BoatId_$CloseRoutesDrawer = {$: 'CloseRoutesDrawer'};
var $author$project$Pages$Fleet_$Public$BoatId_$PlaceAudioPlaying = function (a) {
	return {$: 'PlaceAudioPlaying', a: a};
};
var $author$project$Pages$Fleet_$Public$BoatId_$CenterButtonClicked = {$: 'CenterButtonClicked'};
var $author$project$Pages$Fleet_$Public$BoatId_$view = function (model) {
	return {
		body: $author$project$Html$Layout$fitWindowNoMenu(
			_List_fromArray(
				[
					$author$project$Views$Discovery$view(
					{
						boat: model.boat,
						noOp: $author$project$Pages$Fleet_$Public$BoatId_$NoOp,
						locale: model.locale,
						places: model.places,
						routes: model.routes,
						tracks: (model.fleetSlug === 'ims') ? model.tracks : _List_Nil,
						fleetUrl: model.fleetUrl,
						mapStyle: model.mapStyle,
						timeZone: model.timeZone,
						fleetSlug: model.fleetSlug,
						geofences: model.geofences,
						onMapIdle: $author$project$Pages$Fleet_$Public$BoatId_$MapIdle,
						showPopup: model.showPopup,
						speedUnit: model.speedUnit,
						displayMode: model.displayMode,
						mapPosition: model.mapPosition,
						selectRoute: $author$project$Pages$Fleet_$Public$BoatId_$SelectRoute,
						onManualMove: $author$project$Pages$Fleet_$Public$BoatId_$ManualMoveMap,
						onCenterClick: $author$project$Pages$Fleet_$Public$BoatId_$CenterButtonClicked,
						onMarkerClick: $author$project$Pages$Fleet_$Public$BoatId_$MarkerClicked,
						onStyleSelect: $author$project$Pages$Fleet_$Public$BoatId_$SelectStyle,
						selectedPlace: model.selectedPlace,
						selectedRoute: model.selectedRoute,
						onDismissModal: $author$project$Pages$Fleet_$Public$BoatId_$DismissModal,
						watermarkImage: model.watermarkImage,
						routesDrawerOpen: model.routesDrawerOpen,
						currentSpeedLimit: model.currentSpeedLimit,
						placeAudioPlaying: model.placeAudioPlaying,
						onClosePlaceDrawer: $author$project$Pages$Fleet_$Public$BoatId_$ClosePlaceDrawer,
						onRouteButtonClick: ($elm$core$List$length(model.routes) > 1) ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$Public$BoatId_$OpenRoutesDrawer) : $elm$core$Maybe$Nothing,
						onTogglePlaceAudio: $author$project$Pages$Fleet_$Public$BoatId_$TogglePlaceAudio,
						onCloseRoutesDrawer: $author$project$Pages$Fleet_$Public$BoatId_$CloseRoutesDrawer,
						onPlaceAudioPlaying: $author$project$Pages$Fleet_$Public$BoatId_$PlaceAudioPlaying,
						showedNavigationWarning: model.showedNavigationWarning
					})
				])),
		title: 'Nebo Discovery'
	};
};
var $author$project$Pages$Fleet_$Public$BoatId_$fetchBoats = function (model) {
	return A4($author$project$Api$fetchBoatsPublic, model.apiUrl, model.key, model.fleetSlug, $author$project$Pages$Fleet_$Public$BoatId_$OnFetchBoats);
};
var $author$project$Pages$Fleet_$Public$BoatId_$OnFetchTracks = function (a) {
	return {$: 'OnFetchTracks', a: a};
};
var $author$project$Api$fetchTracksPublic = F6(
	function (apiUrl, key, fleet, bId, start, toMsg) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			$elm$http$Http$get(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'public',
								'boats',
								$author$project$Data$Boat$boatIdToString(bId),
								'track'
							]),
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'key', key),
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start))
							])),
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Track$decode))
				}));
	});
var $author$project$Pages$Fleet_$Public$BoatId_$fetchTracks = function (model) {
	var _v0 = model.trackDuration;
	if (_v0.$ === 'Just') {
		var d = _v0.a;
		var _v1 = A3($author$project$Data$TrackDuration$toStartEnd, model.currentTime, model.timeZone, d);
		var start = _v1.a;
		return A6(
			$author$project$Api$fetchTracksPublic,
			model.apiUrl,
			model.key,
			model.fleetSlug,
			model.boatId,
			$jweir$elm_iso8601$ISO8601$fromPosix(start),
			$author$project$Pages$Fleet_$Public$BoatId_$OnFetchTracks);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Pages$Fleet_$Public$BoatId_$positionForBoat = F2(
	function (_v0, boat) {
		return A3(
			$elm$core$Maybe$map2,
			$author$project$Geospatial$MapProjection$MapPosition,
			boat.latLong,
			$elm$core$Maybe$Just(18));
	});
var $author$project$Pages$Fleet_$Public$BoatId_$toggleDisplayMode = function (mode) {
	if (mode.$ === 'Manual') {
		return $author$project$Views$Discovery$Auto;
	} else {
		return $author$project$Views$Discovery$Manual;
	}
};
var $author$project$Pages$Fleet_$Public$BoatId_$speedLimitForCurrentLocation = $author$project$Views$Discovery$speedLimitForCurrentLocation;
var $author$project$Pages$Fleet_$Public$BoatId_$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnTick':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t}),
					$author$project$Effect$fromCmd(
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Fleet_$Public$BoatId_$fetchBoats(model),
									$author$project$Pages$Fleet_$Public$BoatId_$fetchTracks(model)
								]))));
			case 'GotZone':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timeZone: z}),
					$author$project$Effect$none);
			case 'MapIdle':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(b))
						}),
					$author$project$Effect$none);
			case 'CenterButtonClicked':
				var newDisplayMode = $author$project$Pages$Fleet_$Public$BoatId_$toggleDisplayMode(model.displayMode);
				var oldPos = model.mapPosition;
				var mapPos = A2(
					$elm$core$Maybe$withDefault,
					oldPos,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Pages$Fleet_$Public$BoatId_$positionForBoat(newDisplayMode),
						model.boat));
				var mapboxMoveCmd = _Utils_eq(newDisplayMode, $author$project$Views$Discovery$Auto) ? $author$project$MapCommands$flyTo(
					_List_fromArray(
						[
							$author$project$Mapbox$Cmd$Option$center(
							{lat: mapPos.centre.lat, lng: mapPos.centre._long}),
							$author$project$Mapbox$Cmd$Option$zoom(mapPos.zoom),
							$author$project$Mapbox$Cmd$Option$speed(2.0)
						])) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{displayMode: newDisplayMode, mapPosition: mapPos}),
					$author$project$Effect$fromCmd(mapboxMoveCmd));
			case 'ManualMoveMap':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{displayMode: $author$project$Views$Discovery$Manual}),
					$author$project$Effect$none);
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'OnFetchBoats':
				if (msg.a.$ === 'Ok') {
					var bs = msg.a.a;
					var selectedBoat = A2(
						$elm_community$list_extra$List$Extra$find,
						function (b) {
							return _Utils_eq(b.boatId, model.boatId);
						},
						bs);
					var insidePlace = function () {
						var _v7 = _Utils_Tuple2(
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.latLong;
								},
								selectedBoat),
							model.autoDisplayPlaceDistance);
						if ((_v7.a.$ === 'Just') && (_v7.b.$ === 'Just')) {
							var latLong = _v7.a.a;
							var distance = _v7.b.a;
							return A3($author$project$Data$Place$nearestWithin, latLong, distance, model.places);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var _v1 = function () {
						var _v2 = _Utils_Tuple2(model.selectedPlace, insidePlace);
						if (_v2.a.$ === 'Just') {
							if (_v2.b.$ === 'Nothing') {
								var sp = _v2.a.a;
								var _v3 = _v2.b;
								return _Utils_eq(
									model.automaticallyShownPlaceId,
									$elm$core$Maybe$Just(sp.placeId)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
									$elm$core$Maybe$Just(sp),
									$elm$core$Maybe$Nothing);
							} else {
								var sp = _v2.a.a;
								var ip = _v2.b.a;
								return ((!_Utils_eq(sp.placeId, ip.placeId)) && _Utils_eq(
									model.automaticallyShownPlaceId,
									$elm$core$Maybe$Just(sp.placeId))) ? _Utils_Tuple2(
									$elm$core$Maybe$Just(ip),
									$elm$core$Maybe$Just(ip.placeId)) : _Utils_Tuple2(
									$elm$core$Maybe$Just(sp),
									model.automaticallyShownPlaceId);
							}
						} else {
							if (_v2.b.$ === 'Just') {
								var _v4 = _v2.a;
								var ip = _v2.b.a;
								return _Utils_eq(
									model.manuallyDismissedPlaceId,
									$elm$core$Maybe$Just(ip.placeId)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
									$elm$core$Maybe$Just(ip),
									$elm$core$Maybe$Just(ip.placeId));
							} else {
								var _v5 = _v2.a;
								var _v6 = _v2.b;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
							}
						}
					}();
					var selectedPlace = _v1.a;
					var automaticallyShownPlaceId = _v1.b;
					var mapPos = A2(
						$elm$core$Maybe$andThen,
						$author$project$Pages$Fleet_$Public$BoatId_$positionForBoat(model.displayMode),
						selectedBoat);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{boat: selectedBoat, boats: bs, selectedPlace: selectedPlace, automaticallyShownPlaceId: automaticallyShownPlaceId}),
						$author$project$Effect$fromCmd(
							_Utils_eq(model.displayMode, $author$project$Views$Discovery$Auto) ? A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									function (p) {
										return $author$project$MapCommands$flyTo(
											_List_fromArray(
												[
													$author$project$Mapbox$Cmd$Option$center(
													{lat: p.centre.lat, lng: p.centre._long}),
													$author$project$Mapbox$Cmd$Option$zoom(p.zoom),
													$author$project$Mapbox$Cmd$Option$speed(2.0)
												]));
									},
									mapPos)) : $elm$core$Platform$Cmd$none));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchTracks':
				if (msg.a.$ === 'Ok') {
					var ts = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{tracks: ts}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchGuestViewConfig':
				if (msg.a.$ === 'Ok') {
					var cfg = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								places: cfg.places,
								routes: cfg.routes,
								geofences: cfg.geofences,
								showPopup: cfg.showPopup,
								speedUnit: cfg.speedUnit,
								selectedRoute: ($elm$core$List$length(cfg.routes) === 1) ? $elm$core$List$head(cfg.routes) : $elm$core$Maybe$Nothing,
								watermarkImage: cfg.watermarkImage,
								currentSpeedLimit: A2(
									$elm$core$Maybe$andThen,
									$author$project$Pages$Fleet_$Public$BoatId_$speedLimitForCurrentLocation(cfg.geofences),
									model.boat),
								autoDisplayPlaceDistance: cfg.autoDisplayPlaceDistance
							}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Pages$Fleet_$Public$BoatId_$NoOp),
								A3(
									model.bugsnag.error,
									$author$project$Api$errorString(e),
									model.fleetSlug + ('/public/' + $author$project$Data$Boat$boatIdToString(model.boatId)),
									$elm$core$Dict$empty))));
				}
			case 'MarkerClicked':
				var id = msg.a;
				var place = A2(
					$elm_community$list_extra$List$Extra$find,
					function (p) {
						return _Utils_eq(p.placeId, id);
					},
					model.places);
				if (place.$ === 'Just') {
					var p = place.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								selectedPlace: $elm$core$Maybe$Just(p),
								automaticallyShownPlaceId: $elm$core$Maybe$Nothing
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'ClosePlaceDrawer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedPlace: $elm$core$Maybe$Nothing,
							placeAudioPlaying: false,
							manuallyDismissedPlaceId: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.placeId;
								},
								model.selectedPlace)
						}),
					$author$project$Effect$none);
			case 'TogglePlaceAudio':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$author$project$Ports$togglePlaceAudio(_Utils_Tuple0)));
			case 'PlaceAudioPlaying':
				var playing = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{placeAudioPlaying: playing}),
					$author$project$Effect$none);
			case 'OpenRoutesDrawer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{routesDrawerOpen: true}),
					$author$project$Effect$none);
			case 'CloseRoutesDrawer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{routesDrawerOpen: false}),
					$author$project$Effect$none);
			case 'SelectRoute':
				var route = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedRoute: $elm$core$Maybe$Just(route),
							routesDrawerOpen: false
						}),
					$author$project$Effect$none);
			case 'DismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showedNavigationWarning: true}),
					$author$project$Effect$fromShared($author$project$Shared$ShowedNavigationWarning));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Pages$Fleet_$Public$BoatId_$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 30 * 1000, $author$project$Pages$Fleet_$Public$BoatId_$OnTick)
			]));
};
var $author$project$Pages$Fleet_$Public$BoatId_$page = F2(
	function (shared, req) {
		return $author$project$Page$advanced(
			{
				init: A5(
					$author$project$Pages$Fleet_$Public$BoatId_$init,
					shared,
					req.params.fleet,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Dict$get, 'key', req.query)),
					$author$project$Data$Boat$BoatId(req.params.boatId),
					shared.showedNavigationWarning),
				view: $author$project$Pages$Fleet_$Public$BoatId_$view,
				update: $author$project$Pages$Fleet_$Public$BoatId_$update,
				subscriptions: $author$project$Pages$Fleet_$Public$BoatId_$subscriptions
			});
	});
var $author$project$Pages$Fleet_$DateRangeSummary$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$Pages$Fleet_$DateRangeSummary$UpdateDatePicker = function (a) {
	return {$: 'UpdateDatePicker', a: a};
};
var $author$project$Pages$Fleet_$DateRangeSummary$initialModel = F4(
	function (apiUrl, locale, fleet, r) {
		return {
			error: $elm$core$Maybe$Nothing,
			fleet: fleet,
			apiUrl: apiUrl,
			locale: locale,
			endDate: $elm$core$Maybe$Nothing,
			startDate: $elm$core$Maybe$Nothing,
			summaries: _List_Nil,
			currentTime: $elm$time$Time$millisToPosix(0),
			currentZone: $elm$time$Time$utc,
			currentRoute: r,
			durationDatePicker: $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$DateRangeSummary$UpdateDatePicker)
		};
	});
var $author$project$Pages$Fleet_$DateRangeSummary$init = F4(
	function (session, apiUrl, locale, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				A4($author$project$Pages$Fleet_$DateRangeSummary$initialModel, apiUrl, locale, f, req.route),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Fleet_$DateRangeSummary$OnTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (t, z) {
											return _Utils_Tuple2(t, z);
										}),
									$elm$time$Time$now,
									$elm$time$Time$here))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Fleet Usage (Date Range)')))
						])));
		} else {
			return _Utils_Tuple2(
				A4($author$project$Pages$Fleet_$DateRangeSummary$initialModel, apiUrl, locale, $author$project$Data$Fleet$empty, $author$project$Gen$Route$NotFound),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$DateRangeSummary$Logout = {$: 'Logout'};
var $author$project$Time$RelativeDateRange$LastYear = {$: 'LastYear'};
var $author$project$Time$RelativeDateRange$ThisYear = {$: 'ThisYear'};
var $author$project$Time$RelativeDateRange$LastMonth = {$: 'LastMonth'};
var $author$project$Time$RelativeDateRange$ThisMonth = {$: 'ThisMonth'};
var $author$project$Time$RelativeDateRange$LastQuarter = {$: 'LastQuarter'};
var $author$project$Time$RelativeDateRange$ThisQuarter = {$: 'ThisQuarter'};
var $author$project$Pages$Fleet_$DateRangeSummary$settings = function (model) {
	var s = $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultSettings(model.currentZone);
	return _Utils_update(
		s,
		{
			theme: $author$project$DatePicker$Extra$neboTheme,
			presets: A2(
				$elm$core$List$map,
				A2($author$project$Time$RelativeDateRange$toPreset, model.currentTime, model.currentZone),
				_List_fromArray(
					[$author$project$Time$RelativeDateRange$ThisMonth, $author$project$Time$RelativeDateRange$LastMonth, $author$project$Time$RelativeDateRange$ThisQuarter, $author$project$Time$RelativeDateRange$LastQuarter, $author$project$Time$RelativeDateRange$ThisYear, $author$project$Time$RelativeDateRange$LastYear])),
			dateStringFn: F2(
				function (z, p) {
					return A3(
						$author$project$ISO8601$Extra$toFormattedDate,
						model.locale,
						z,
						$jweir$elm_iso8601$ISO8601$fromPosix(p));
				}),
			isDayDisabled: F2(
				function (_v0, t) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(t),
						$elm$time$Time$posixToMillis(model.currentTime)) > 0;
				}),
			timePickerVisibility: $mercurymedia$elm_datetime_picker$DatePicker$Settings$NeverVisible
		});
};
var $author$project$Pages$Fleet_$DateRangeSummary$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$DateRangeSummary$OpenPicker = {$: 'OpenPicker'};
var $author$project$Pages$Fleet_$DateRangeSummary$DownloadCsv = {$: 'DownloadCsv'};
var $author$project$Pages$Fleet_$DateRangeSummary$FetchSummary = {$: 'FetchSummary'};
var $author$project$Pages$Fleet_$DateRangeSummary$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$DateRangeSummary$view = F3(
	function (session, featureDropState, model) {
		var headerCell = F2(
			function (classes, field) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h2 ' + classes)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field)
						]));
			});
		var footerCell = F2(
			function (classes, field) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h4 ' + classes)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field)
						]));
			});
		var row = function (b) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(b.boatName)
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Gen$Route$toHref(
											$author$project$Gen$Route$Fleet___Boats__BoatId___Logs(
												{
													fleet: model.fleet.slug,
													boatId: $author$project$Data$Boat$boatIdToString(b.boatId)
												}))),
										$elm$html$Html$Attributes$title('View Logs')
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('ms-2 text-secondary')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$list))
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(b.trips))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(b.activeDays))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(b.underwayDuration)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Data$DistanceUnit$formatDistance, model.fleet.longDistanceUnit, b.distance))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Data$SpeedUnit$formatSpeed, model.fleet.speedUnit, b.averageSpeed))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-end')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Data$SpeedUnit$formatSpeed, model.fleet.speedUnit, b.maxSpeed))
							]))
					]));
		};
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(model.currentRoute),
					featureDropState,
					$author$project$Pages$Fleet_$DateRangeSummary$ChangelogAction,
					$author$project$Pages$Fleet_$DateRangeSummary$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reports | Fleet Usage (Date Range)')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column flex-lg-row align-items-center py-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('m-1')
									]),
								_List_fromArray(
									[
										A2(
										$mercurymedia$elm_datetime_picker$DurationDatePicker$view,
										$author$project$Pages$Fleet_$DateRangeSummary$settings(model),
										model.durationDatePicker),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('input-group input-group-sm flex-nowrap')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('input-group-text'),
														$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$DateRangeSummary$OpenPicker)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'No dates selected',
															A3(
																$elm$core$Maybe$map2,
																F2(
																	function (s, e) {
																		return A3($author$project$ISO8601$Extra$toFormattedDate, model.locale, model.currentZone, s) + (' to ' + A3($author$project$ISO8601$Extra$toFormattedDate, model.locale, model.currentZone, e));
																	}),
																model.startDate,
																model.endDate)))
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('btn btn-outline-secondary'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$DateRangeSummary$FetchSummary)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Go')
													]))
											]))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex-grow-1')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$DateRangeSummary$DownloadCsv),
										$elm$html$Html$Attributes$class('btn btn-anchor text-secondary text-nowrap'),
										$elm$html$Html$Attributes$disabled(
										$elm$core$List$isEmpty(model.summaries))
									]),
								_List_fromArray(
									[
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('me-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
										$elm$html$Html$text('Download CSV')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-responsive-md')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(headerCell, '', 'Name'),
														A2(headerCell, 'text-end', 'Trips'),
														A2(headerCell, 'text-end', 'Active Days'),
														A2(headerCell, 'text-end', 'Underway Duration'),
														A2(headerCell, 'text-end', 'Distance'),
														A2(headerCell, 'text-end', 'Average Speed'),
														A2(headerCell, 'text-end', 'Max Speed')
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2($elm$core$List$map, row, model.summaries)),
										A2(
										$elm$html$Html$tfoot,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(footerCell, '', 'Total'),
														A2(
														footerCell,
														'text-end',
														$elm$core$String$fromInt(
															$elm$core$List$sum(
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.trips;
																	},
																	model.summaries)))),
														A2(
														footerCell,
														'text-end',
														$elm$core$String$fromInt(
															$elm$core$List$sum(
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.activeDays;
																	},
																	model.summaries)))),
														A2(footerCell, '', ''),
														A2(
														footerCell,
														'text-end',
														A2(
															$author$project$Data$DistanceUnit$formatDistance,
															model.fleet.longDistanceUnit,
															$elm$core$List$sum(
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.distance;
																	},
																	model.summaries)))),
														A2(footerCell, '', ''),
														A2(footerCell, '', '')
													]))
											]))
									]))
							])),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$DateRangeSummary$CloseError)
					])),
			title: model.fleet.name
		};
	});
var $author$project$Pages$Fleet_$DateRangeSummary$OnFetchSummary = function (a) {
	return {$: 'OnFetchSummary', a: a};
};
var $author$project$Api$fetchDateRangeSummaryReport = F6(
	function (token, apiUrl, fleet, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'rangesummary']),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$BoatUsageSummary$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$DateRangeSummary$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OpenPicker':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							durationDatePicker: A5(
								$mercurymedia$elm_datetime_picker$DurationDatePicker$openPicker,
								$author$project$Pages$Fleet_$DateRangeSummary$settings(model),
								model.currentTime,
								A2($elm$core$Maybe$map, $jweir$elm_iso8601$ISO8601$toPosix, model.startDate),
								A2($elm$core$Maybe$map, $jweir$elm_iso8601$ISO8601$toPosix, model.endDate),
								model.durationDatePicker)
						}),
					$author$project$Effect$none);
			case 'UpdateDatePicker':
				var m = msg.a;
				var _v1 = A3(
					$mercurymedia$elm_datetime_picker$DurationDatePicker$update,
					$author$project$Pages$Fleet_$DateRangeSummary$settings(model),
					m,
					model.durationDatePicker);
				var newPicker = _v1.a;
				var dates = _v1.b;
				if (dates.$ === 'Just') {
					var _v3 = dates.a;
					var start = _v3.a;
					var end = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								endDate: $elm$core$Maybe$Just(
									$jweir$elm_iso8601$ISO8601$fromPosix(end)),
								startDate: $elm$core$Maybe$Just(
									$jweir$elm_iso8601$ISO8601$fromPosix(start)),
								durationDatePicker: newPicker
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{durationDatePicker: newPicker}),
						$author$project$Effect$none);
				}
			case 'OnTime':
				var _v4 = msg.a;
				var t = _v4.a;
				var z = _v4.b;
				var _v5 = A3($author$project$Time$RelativeDateRange$toStartEnd, t, z, $author$project$Time$RelativeDateRange$ThisMonth);
				var defaultStart = _v5.a;
				var defaultEnd = _v5.b;
				var _v6 = _Utils_Tuple3(
					A2(
						$elm$core$Maybe$withDefault,
						$jweir$elm_iso8601$ISO8601$fromPosix(defaultStart),
						model.startDate),
					A2(
						$elm$core$Maybe$withDefault,
						$jweir$elm_iso8601$ISO8601$fromPosix(defaultEnd),
						model.endDate),
					$elm_community$maybe_extra$Maybe$Extra$isNothing(model.startDate));
				var startDate = _v6.a;
				var endDate = _v6.b;
				var fetch = _v6.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							endDate: $elm$core$Maybe$Just(endDate),
							startDate: $elm$core$Maybe$Just(startDate),
							currentTime: t,
							currentZone: z,
							durationDatePicker: $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$DateRangeSummary$UpdateDatePicker)
						}),
					fetch ? $author$project$Effect$batch(
						_List_fromArray(
							[
								A6($author$project$Api$fetchDateRangeSummaryReport, session.authToken, model.apiUrl, model.fleet.slug, startDate, endDate, $author$project$Pages$Fleet_$DateRangeSummary$OnFetchSummary),
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0))
							])) : $author$project$Effect$none);
			case 'FetchSummary':
				var _v7 = _Utils_Tuple2(model.startDate, model.endDate);
				if ((_v7.a.$ === 'Just') && (_v7.b.$ === 'Just')) {
					var startDate = _v7.a.a;
					var endDate = _v7.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								durationDatePicker: $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$DateRangeSummary$UpdateDatePicker)
							}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									$author$project$Effect$fromCmd(
									$author$project$Ports$startProgressBar(_Utils_Tuple0)),
									A6($author$project$Api$fetchDateRangeSummaryReport, session.authToken, model.apiUrl, model.fleet.slug, startDate, endDate, $author$project$Pages$Fleet_$DateRangeSummary$OnFetchSummary)
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnFetchSummary':
				if (msg.a.$ === 'Ok') {
					var summaries = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								summaries: A2(
									$elm$core$List$sortWith,
									F2(
										function (s1, s2) {
											return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, s1.boatName, s2.boatName);
										}),
									summaries)
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'DownloadCsv':
				var _v8 = _Utils_Tuple3(model.summaries, model.startDate, model.endDate);
				if (!_v8.a.b) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					if ((_v8.b.$ === 'Just') && (_v8.c.$ === 'Just')) {
						var ss = _v8.a;
						var start = _v8.b.a;
						var end = _v8.c.a;
						var filename = model.fleet.slug + ('_' + (A2($author$project$ISO8601$Extra$toDateString, model.currentZone, start) + ('_' + (A2($author$project$ISO8601$Extra$toDateString, model.currentZone, end) + '.csv'))));
						return _Utils_Tuple2(
							model,
							$author$project$Effect$fromCmd(
								A3(
									$elm$file$File$Download$string,
									filename,
									'text/csv',
									A3($author$project$Data$BoatUsageSummary$toCsv, model.fleet.longDistanceUnit, model.fleet.speedUnit, ss))));
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$DateRangeSummary$subscriptions = function (model) {
	return A2(
		$mercurymedia$elm_datetime_picker$DurationDatePicker$subscriptions,
		$author$project$Pages$Fleet_$DateRangeSummary$settings(model),
		model.durationDatePicker);
};
var $author$project$Pages$Fleet_$DateRangeSummary$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A4($author$project$Pages$Fleet_$DateRangeSummary$init, session, shared.apiUrl, shared.locale, req),
					view: A2($author$project$Pages$Fleet_$DateRangeSummary$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$DateRangeSummary$update(session),
					subscriptions: $author$project$Pages$Fleet_$DateRangeSummary$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$WeeklyUtilisation$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$Pages$Fleet_$WeeklyUtilisation$initialModel = F3(
	function (u, f, r) {
		return {
			error: $elm$core$Maybe$Nothing,
			fleet: f,
			apiUrl: u,
			currentTime: $elm$time$Time$millisToPosix(0),
			currentZone: $elm$time$Time$utc,
			utilisation: _List_Nil,
			currentRoute: r,
			weeksByEndDate: _List_Nil,
			selectedWeekEnding: A2(
				$justinmimbs$date$Date$fromPosix,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(0))
		};
	});
var $author$project$Pages$Fleet_$WeeklyUtilisation$init = F3(
	function (s, u, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			s.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$WeeklyUtilisation$initialModel, u, f, req.route),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Fleet_$WeeklyUtilisation$OnTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (t, z) {
											return _Utils_Tuple2(t, z);
										}),
									$elm$time$Time$now,
									$elm$time$Time$here))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Fleet Utilisation (Weekly)')))
						])));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$WeeklyUtilisation$initialModel, u, $author$project$Data$Fleet$empty, $author$project$Gen$Route$NotFound),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Views$HorizontalBarChart$days = function (model) {
	var startDay = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, model.zone, model.start);
	var endDay = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, model.zone, model.end);
	return A5($justinmimbs$time_extra$Time$Extra$range, $justinmimbs$time_extra$Time$Extra$Day, 1, model.zone, startDay, endDay);
};
var $author$project$Views$HorizontalBarChart$height = 20;
var $author$project$Views$HorizontalBarChart$width = 1000;
var $author$project$Views$HorizontalBarChart$bar = F5(
	function (index, zone, start, end, data) {
		var scale = ($elm$time$Time$posixToMillis(end) - $elm$time$Time$posixToMillis(start)) / $author$project$Views$HorizontalBarChart$width;
		var y = (index * ($author$project$Views$HorizontalBarChart$height + 10)) + 5;
		var box = function (_v0) {
			var s = _v0.a;
			var e = _v0.b;
			var x = ($elm$time$Time$posixToMillis(s) - $elm$time$Time$posixToMillis(start)) / scale;
			var w = ($elm$time$Time$posixToMillis(e) - $elm$time$Time$posixToMillis(s)) / scale;
			return A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x(
						$elm$core$String$fromFloat(x)),
						$elm$svg$Svg$Attributes$y(
						$elm$core$String$fromFloat(y)),
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromFloat(w)),
						$elm$svg$Svg$Attributes$height(
						$elm$core$String$fromInt($author$project$Views$HorizontalBarChart$height)),
						$elm$svg$Svg$Attributes$fill('#1f77b4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$svg$Svg$text(
								A3($danhandrea$elm_date_format$DateFormat$format, 'yyyy-MM-dd HH:mm', zone, s) + (' to ' + A3($danhandrea$elm_date_format$DateFormat$format, 'yyyy-MM-dd HH:mm', zone, e)))
							]))
					]));
		};
		return A2($elm$core$List$map, box, data);
	});
var $elm$svg$Svg$style = $elm$svg$Svg$trustedNode('style');
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $author$project$Views$HorizontalBarChart$nightBar = F3(
	function (posix, chartHeight, model) {
		var startTime = A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, -6, model.zone, posix);
		var scale = ($elm$time$Time$posixToMillis(model.end) - $elm$time$Time$posixToMillis(model.start)) / $author$project$Views$HorizontalBarChart$width;
		var x = ($elm$time$Time$posixToMillis(startTime) - $elm$time$Time$posixToMillis(model.start)) / scale;
		var w = (((12 * 60) * 60) * 1000) / scale;
		return A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y('0'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(w)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(chartHeight)),
					$elm$svg$Svg$Attributes$fill('#000000'),
					$elm$svg$Svg$Attributes$opacity('0.1')
				]),
			_List_Nil);
	});
var $author$project$Views$HorizontalBarChart$fullDayBar = F3(
	function (posix, chartHeight, model) {
		var scale = ($elm$time$Time$posixToMillis(model.end) - $elm$time$Time$posixToMillis(model.start)) / $author$project$Views$HorizontalBarChart$width;
		var x = ($elm$time$Time$posixToMillis(posix) - $elm$time$Time$posixToMillis(model.start)) / scale;
		var w = (((24 * 60) * 60) * 1000) / scale;
		return A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y('0'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(w)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(chartHeight)),
					$elm$svg$Svg$Attributes$fill('#000000'),
					$elm$svg$Svg$Attributes$opacity('0.1')
				]),
			_List_Nil);
	});
var $author$project$Views$HorizontalBarChart$weekendDays = function (model) {
	var isWeekEnd = function (posix) {
		var _v0 = A2($elm$time$Time$toWeekday, model.zone, posix);
		switch (_v0.$) {
			case 'Sat':
				return true;
			case 'Sun':
				return true;
			default:
				return false;
		}
	};
	return A2(
		$elm$core$List$filter,
		isWeekEnd,
		$author$project$Views$HorizontalBarChart$days(model));
};
var $author$project$Views$HorizontalBarChart$daysPlusNext = function (model) {
	var endDay = A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, model.zone, model.end);
	return A2(
		$elm$core$List$append,
		$author$project$Views$HorizontalBarChart$days(model),
		_List_fromArray(
			[endDay]));
};
var $author$project$Views$HorizontalBarChart$verticalLine = F3(
	function (posix, chartHeight, model) {
		var scale = ($elm$time$Time$posixToMillis(model.end) - $elm$time$Time$posixToMillis(model.start)) / $author$project$Views$HorizontalBarChart$width;
		var x = ($elm$time$Time$posixToMillis(posix) - $elm$time$Time$posixToMillis(model.start)) / scale;
		return A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y1('0'),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromInt(chartHeight)),
					$elm$svg$Svg$Attributes$stroke('#cccccc'),
					$elm$svg$Svg$Attributes$opacity('0.2'),
					$elm$svg$Svg$Attributes$strokeWidth('1')
				]),
			_List_Nil);
	});
var $author$project$Views$HorizontalBarChart$horizontalLine = function (index) {
	return A2(
		$elm$svg$Svg$line,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('0'),
				$elm$svg$Svg$Attributes$y1(
				$elm$core$String$fromFloat(index * ($author$project$Views$HorizontalBarChart$height + 10))),
				$elm$svg$Svg$Attributes$x2(
				$elm$core$String$fromInt($author$project$Views$HorizontalBarChart$width)),
				$elm$svg$Svg$Attributes$y2(
				$elm$core$String$fromFloat(index * ($author$project$Views$HorizontalBarChart$height + 10))),
				$elm$svg$Svg$Attributes$stroke('#cccccc'),
				$elm$svg$Svg$Attributes$opacity('0.2'),
				$elm$svg$Svg$Attributes$strokeWidth('1')
			]),
		_List_Nil);
};
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $author$project$Views$HorizontalBarChart$chartArea = function (model) {
	var horizontalLines = A2(
		$elm$core$List$map,
		function (index) {
			return $author$project$Views$HorizontalBarChart$horizontalLine(index);
		},
		A2(
			$elm$core$List$range,
			0,
			$elm$core$List$length(model.series)));
	var areaHeight = (($author$project$Views$HorizontalBarChart$height + 10) * $elm$core$List$length(model.series)) + 1;
	var verticalLines = A2(
		$elm$core$List$map,
		function (d) {
			return A3($author$project$Views$HorizontalBarChart$verticalLine, d, areaHeight, model);
		},
		$author$project$Views$HorizontalBarChart$daysPlusNext(model));
	var nightBars = function () {
		var _v1 = model.format;
		if (_v1.$ === 'Weekly') {
			return A2(
				$elm$core$List$map,
				function (d) {
					return A3($author$project$Views$HorizontalBarChart$nightBar, d, areaHeight, model);
				},
				$author$project$Views$HorizontalBarChart$daysPlusNext(model));
		} else {
			return A2(
				$elm$core$List$map,
				function (d) {
					return A3($author$project$Views$HorizontalBarChart$fullDayBar, d, areaHeight, model);
				},
				$author$project$Views$HorizontalBarChart$weekendDays(model));
		}
	}();
	var styles = A2(
		$elm$svg$Svg$style,
		_List_Nil,
		_List_fromArray(
			[
				$elm$svg$Svg$text(' .legend-text { font-size: 12px; fill: #666666; } ')
			]));
	var bars = $elm$core$List$concat(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, _v0) {
					var data = _v0.b;
					return A5($author$project$Views$HorizontalBarChart$bar, index, model.zone, model.start, model.end, data);
				}),
			model.series));
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox(
				'0 0 ' + ($elm$core$String$fromInt($author$project$Views$HorizontalBarChart$width) + (' ' + $elm$core$String$fromInt(areaHeight)))),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromInt(areaHeight)),
				$elm$svg$Svg$Attributes$width('100%'),
				$elm$svg$Svg$Attributes$preserveAspectRatio('none')
			]),
		A2(
			$elm$core$List$cons,
			styles,
			_Utils_ap(
				nightBars,
				_Utils_ap(
					horizontalLines,
					_Utils_ap(verticalLines, bars)))));
};
var $author$project$Views$HorizontalBarChart$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('d-flex flex-row width-100')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('height-100 d-flex-column align-items-start justify-content-evenly'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '35px')
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$style,
									'height',
									$elm$core$String$fromInt($author$project$Views$HorizontalBarChart$height + 10) + 'px'),
									A2($elm$html$Html$Attributes$style, 'width', '200px'),
									$elm$html$Html$Attributes$class('text-end pe-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					},
					model.series)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-fill')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-start', '200px'),
								A2(
								$elm$html$Html$Attributes$style,
								'height',
								$elm$core$String$fromInt($author$project$Views$HorizontalBarChart$height + 10) + 'px'),
								A2($elm$html$Html$Attributes$style, 'flex-basis', '0'),
								$elm$html$Html$Attributes$class('d-flex flex-row align-items-center width-100')
							]),
						A2(
							$elm$core$List$map,
							function (d) {
								var title = function () {
									var _v1 = model.format;
									if (_v1.$ === 'Weekly') {
										return A3($danhandrea$elm_date_format$DateFormat$format, 'ddd d', model.zone, d);
									} else {
										return $elm$core$String$fromInt(
											A2($elm$time$Time$toDay, model.zone, d));
									}
								}();
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex-grow-1 text-center'),
											A2($elm$html$Html$Attributes$style, 'width', '0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(title)
										]));
							},
							$author$project$Views$HorizontalBarChart$days(model))),
						$author$project$Views$HorizontalBarChart$chartArea(model)
					]))
			]));
};
var $author$project$Pages$Fleet_$WeeklyUtilisation$Logout = {$: 'Logout'};
var $author$project$Views$HorizontalBarChart$Weekly = {$: 'Weekly'};
var $author$project$Pages$Fleet_$WeeklyUtilisation$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$WeeklyUtilisation$UpdateWeek = function (a) {
	return {$: 'UpdateWeek', a: a};
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$language_en = {
	monthName: $justinmimbs$date$Date$monthToName,
	weekdayName: $justinmimbs$date$Date$weekdayToName,
	dayWithSuffix: $justinmimbs$date$Date$withOrdinalSuffix,
	monthNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	weekdayNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(_Utils_Tuple0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq(
									_Utils_chr('\'')))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq(
								_Utils_chr('\'')))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\u0027');
				},
				$elm$parser$Parser$token('\u0027\u0027')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq(
				_Utils_chr('\'')))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq(
						_Utils_chr('\''))),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (!_Utils_eq(
		_char,
		_Utils_chr('\''))) && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 'Literal') && _v0.b.b) && (_v0.b.a.$ === 'Literal')) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\u0027')),
	$elm$parser$Parser$token('\u0027\u0027'));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ordinalDay;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char.valueOf()) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.monthNameShort(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.monthName(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.monthNameShort(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.dayWithSuffix(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.weekdayName(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4(
							$justinmimbs$date$Date$formatField,
							language,
							_Utils_chr('E'),
							length,
							date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (token.$ === 'Field') {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Pages$Fleet_$WeeklyUtilisation$weekEndTime = F2(
	function (z, d) {
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			z,
			{
				day: $justinmimbs$date$Date$day(d),
				hour: 0,
				year: $justinmimbs$date$Date$year(d),
				month: $justinmimbs$date$Date$month(d),
				minute: 0,
				second: 0,
				millisecond: 0
			});
	});
var $justinmimbs$date$Date$Weeks = {$: 'Weeks'};
var $author$project$Pages$Fleet_$WeeklyUtilisation$weekStartTime = F2(
	function (z, d) {
		var start = A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Weeks, -1, d);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			z,
			{
				day: $justinmimbs$date$Date$day(start),
				hour: 0,
				year: $justinmimbs$date$Date$year(start),
				month: $justinmimbs$date$Date$month(start),
				minute: 0,
				second: 0,
				millisecond: 0
			});
	});
var $author$project$Pages$Fleet_$WeeklyUtilisation$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$WeeklyUtilisation$view = F3(
	function (session, featureDropState, model) {
		var nextWeek = $elm_community$list_extra$List$Extra$last(
			A2(
				$elm$core$List$filter,
				function (d) {
					return _Utils_eq(
						A2($justinmimbs$date$Date$compare, d, model.selectedWeekEnding),
						$elm$core$Basics$GT);
				},
				model.weeksByEndDate));
		var lastWeek = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (d) {
					return _Utils_eq(
						A2($justinmimbs$date$Date$compare, d, model.selectedWeekEnding),
						$elm$core$Basics$LT);
				},
				model.weeksByEndDate));
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(model.currentRoute),
					featureDropState,
					$author$project$Pages$Fleet_$WeeklyUtilisation$ChangelogAction,
					$author$project$Pages$Fleet_$WeeklyUtilisation$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reports | Fleet Utilisation (Weekly)')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column flex-lg-row align-items-center py-3')
							]),
						_List_fromArray(
							[
								function () {
								if (lastWeek.$ === 'Just') {
									var d = lastWeek.a;
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-light my-1 mx-2'),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Fleet_$WeeklyUtilisation$UpdateWeek(
													$justinmimbs$date$Date$toIsoString(d)))
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)),
												$elm$html$Html$text('Previous Week')
											]));
								} else {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-light my-1 mx-2'),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$disabled(true)
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$chevronLeft)),
												$elm$html$Html$text('Previous Week')
											]));
								}
							}(),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex flex-row d-flex flex-column flex-lg-row align-items-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-nowrap')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Week Ending:')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-select form-select-sm my-1 mx-2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Week Ending'),
												$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$WeeklyUtilisation$UpdateWeek)
											]),
										A2(
											$elm$core$List$map,
											function (d) {
												return A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$selected(
															_Utils_eq(d, model.selectedWeekEnding)),
															$elm$html$Html$Attributes$value(
															$justinmimbs$date$Date$toIsoString(d))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$justinmimbs$date$Date$toIsoString(
																A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Days, -1, d)))
														]));
											},
											model.weeksByEndDate))
									])),
								function () {
								if (nextWeek.$ === 'Just') {
									var d = nextWeek.a;
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-light my-1 mx-2'),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Fleet_$WeeklyUtilisation$UpdateWeek(
													$justinmimbs$date$Date$toIsoString(d)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next Week'),
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('ms-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight))
											]));
								} else {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-light my-1 mx-2'),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$disabled(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next Week'),
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('ms-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight))
											]));
								}
							}()
							])),
						$author$project$Views$HorizontalBarChart$view(
						{
							end: A2($author$project$Pages$Fleet_$WeeklyUtilisation$weekEndTime, model.currentZone, model.selectedWeekEnding),
							zone: model.currentZone,
							start: A2($author$project$Pages$Fleet_$WeeklyUtilisation$weekStartTime, model.currentZone, model.selectedWeekEnding),
							format: $author$project$Views$HorizontalBarChart$Weekly,
							series: A2(
								$elm$core$List$map,
								function (u) {
									return _Utils_Tuple2(u.boatName, u.trips);
								},
								model.utilisation)
						}),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$WeeklyUtilisation$CloseError)
					])),
			title: model.fleet.name
		};
	});
var $justinmimbs$date$Date$Years = {$: 'Years'};
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval.$) {
		case 'Year':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Years);
		case 'Quarter':
			return _Utils_Tuple2(3, $justinmimbs$date$Date$Months);
		case 'Month':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Months);
		case 'Day':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Days);
		default:
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Weeks);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $author$project$Pages$Fleet_$WeeklyUtilisation$OnFetchUtilisation = function (a) {
	return {$: 'OnFetchUtilisation', a: a};
};
var $author$project$Data$BoatUtilisation$BoatUtilisation = F3(
	function (boatId, boatName, trips) {
		return {trips: trips, boatId: boatId, boatName: boatName};
	});
var $author$project$Data$BoatUtilisation$decodeTripBounds = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (s, e) {
			return _Utils_Tuple2(
				$jweir$elm_iso8601$ISO8601$toPosix(s),
				$jweir$elm_iso8601$ISO8601$toPosix(e));
		}),
	A2($elm$json$Json$Decode$field, 'start', $jweir$elm_iso8601$ISO8601$decode),
	A2($elm$json$Json$Decode$field, 'end', $jweir$elm_iso8601$ISO8601$decode));
var $author$project$Data$BoatUtilisation$decode = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$BoatUtilisation$BoatUtilisation,
	A2($elm$json$Json$Decode$field, 'boatId', $author$project$Data$Boat$boatIdDecoder),
	A2($elm$json$Json$Decode$field, 'boatName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'trips',
		$elm$json$Json$Decode$list($author$project$Data$BoatUtilisation$decodeTripBounds)));
var $author$project$Api$fetchDateRangeUtilisation = F6(
	function (token, apiUrl, fleet, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'rangeutilisation']),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$BoatUtilisation$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$WeeklyUtilisation$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'UpdateWeek':
				var w = msg.a;
				var _v1 = $justinmimbs$date$Date$fromIsoString(w);
				if (_v1.$ === 'Ok') {
					var date = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedWeekEnding: date}),
						$author$project$Effect$batch(
							_List_fromArray(
								[
									$author$project$Effect$fromCmd(
									$author$project$Ports$startProgressBar(_Utils_Tuple0)),
									A6(
									$author$project$Api$fetchDateRangeUtilisation,
									session.authToken,
									model.apiUrl,
									model.fleet.slug,
									$jweir$elm_iso8601$ISO8601$fromPosix(
										A2($author$project$Pages$Fleet_$WeeklyUtilisation$weekStartTime, model.currentZone, date)),
									$jweir$elm_iso8601$ISO8601$fromPosix(
										A2($author$project$Pages$Fleet_$WeeklyUtilisation$weekEndTime, model.currentZone, date)),
									$author$project$Pages$Fleet_$WeeklyUtilisation$OnFetchUtilisation)
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnTime':
				var _v2 = msg.a;
				var t = _v2.a;
				var z = _v2.b;
				var thisWeek = A2(
					$justinmimbs$date$Date$ceiling,
					$justinmimbs$date$Date$Week,
					A2($justinmimbs$date$Date$fromPosix, z, t));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							currentTime: t,
							currentZone: z,
							weeksByEndDate: A2(
								$elm$core$List$map,
								function (i) {
									return A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Weeks, -i, thisWeek);
								},
								A2($elm$core$List$range, 0, 104)),
							selectedWeekEnding: thisWeek
						}),
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0)),
								A6(
								$author$project$Api$fetchDateRangeUtilisation,
								session.authToken,
								model.apiUrl,
								model.fleet.slug,
								$jweir$elm_iso8601$ISO8601$fromPosix(
									A2($author$project$Pages$Fleet_$WeeklyUtilisation$weekStartTime, model.currentZone, thisWeek)),
								$jweir$elm_iso8601$ISO8601$fromPosix(
									A2($author$project$Pages$Fleet_$WeeklyUtilisation$weekEndTime, model.currentZone, thisWeek)),
								$author$project$Pages$Fleet_$WeeklyUtilisation$OnFetchUtilisation)
							])));
			case 'OnFetchUtilisation':
				if (msg.a.$ === 'Ok') {
					var utilisation = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								utilisation: A2(
									$elm$core$List$sortWith,
									F2(
										function (u1, u2) {
											return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, u1.boatName, u2.boatName);
										}),
									utilisation)
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$WeeklyUtilisation$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$WeeklyUtilisation$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$WeeklyUtilisation$init, session, shared.apiUrl, req),
					view: A2($author$project$Pages$Fleet_$WeeklyUtilisation$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$WeeklyUtilisation$update(session),
					subscriptions: $author$project$Pages$Fleet_$WeeklyUtilisation$subscriptions
				};
			});
	});
var $author$project$Api$fetchBoat = F5(
	function (token, apiUrl, fleet, boatId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'boats',
								$author$project$Data$Boat$boatIdToString(boatId)
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson($author$project$Data$Boat$decode),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnFetchBoat = function (a) {
	return {$: 'OnFetchBoat', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnFetchDaylightTimes = function (a) {
	return {$: 'OnFetchDaylightTimes', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$init = F3(
	function (session, apiUrl, req) {
		var boatId = $author$project$Data$Boat$BoatId(req.params.boatId);
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			session.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				{
					boat: $elm$core$Maybe$Nothing,
					form: A4(
						$author$project$Views$BoatForm$init,
						$author$project$Data$User$isNeboAdmin(session.user),
						f.isHelmEnabled,
						f.speedUnit,
						$elm$core$Maybe$Nothing),
					error: $elm$core$Maybe$Nothing,
					fleet: f,
					apiUrl: apiUrl,
					boatId: boatId,
					daylightTimes: $elm$core$Maybe$Nothing,
					showBoatArchiveWarning: false
				},
				$author$project$Effect$batch(
					_List_fromArray(
						[
							A5($author$project$Api$fetchBoat, session.authToken, apiUrl, f, boatId, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnFetchBoat),
							A4($author$project$Api$fetchDaylightTimes, session.authToken, apiUrl, f.slug, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnFetchDaylightTimes),
							$author$project$Effect$fromCmd(
							$author$project$Ports$startProgressBar(_Utils_Tuple0)),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Edit Boat')))
						])));
		} else {
			return _Utils_Tuple2(
				{
					boat: $elm$core$Maybe$Nothing,
					form: A4($author$project$Views$BoatForm$init, false, false, $author$project$Data$SpeedUnit$Knots, $elm$core$Maybe$Nothing),
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					apiUrl: apiUrl,
					boatId: boatId,
					daylightTimes: $elm$core$Maybe$Nothing,
					showBoatArchiveWarning: false
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$ArchiveBoat = {$: 'ArchiveBoat'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$DismissModal = {$: 'DismissModal'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$view = F3(
	function (session, featureDropState, model) {
		var confirmArchiveDialog = $author$project$Views$Dialog$view(
			model.showBoatArchiveWarning ? $elm$core$Maybe$Just(
				{
					body: $elm$core$Maybe$Just(
						$elm$html$Html$text('Are you sure you want to archive this vessel? This action will disable the vessel in nebofleet and unlink the tracker.')),
					footer: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-danger'),
									$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Edit$ArchiveBoat)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Archive')
								]))),
					header: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Archive Vessel')
								]))),
					closeMessage: $elm$core$Maybe$Just($author$project$Pages$Fleet_$Boats$BoatId_$Edit$DismissModal),
					containerClass: $elm$core$Maybe$Nothing
				}) : $elm$core$Maybe$Nothing);
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(
						$author$project$Gen$Route$Fleet___Boats(
							{fleet: model.fleet.slug})),
					featureDropState,
					$author$project$Pages$Fleet_$Boats$BoatId_$Edit$ChangelogAction,
					$author$project$Pages$Fleet_$Boats$BoatId_$Edit$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container-fluid')
							]),
						_List_fromArray(
							[
								$elm_community$maybe_extra$Maybe$Extra$isJust(model.boat) ? A2(
								$elm$html$Html$map,
								$author$project$Pages$Fleet_$Boats$BoatId_$Edit$FormMsg,
								A3($author$project$Views$BoatForm$view, featureDropState, model.daylightTimes, model.form)) : $lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[$lattyware$elm_fontawesome$FontAwesome$Attributes$spin, $lattyware$elm_fontawesome$FontAwesome$Attributes$fa2x1]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch))
							])),
						confirmArchiveDialog,
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$CloseError)
					])),
			title: 'Edit Boat'
		};
	});
var $author$project$Api$putBoat = F7(
	function (token, apiUrl, fleet, boatId, form, image, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'boats',
								$author$project$Data$Boat$boatIdToString(boatId)
							]),
						_List_Nil),
					body: $elm$http$Http$multipartBody(
						A2(
							$elm$core$List$append,
							$elm_community$maybe_extra$Maybe$Extra$toList(
								A2(
									$elm$core$Maybe$map,
									function (f) {
										return A2($elm$http$Http$filePart, 'image', f);
									},
									image)),
							_List_fromArray(
								[
									A2(
									$elm$http$Http$stringPart,
									'boat',
									A2(
										$elm$json$Json$Encode$encode,
										2,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(form.name)),
													_Utils_Tuple2(
													'makeModel',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.makeModel)),
													_Utils_Tuple2(
													'length',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.length)),
													_Utils_Tuple2(
													'beam',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.beam)),
													_Utils_Tuple2(
													'draft',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.draft)),
													_Utils_Tuple2(
													'yearLaunched',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, form.yearLaunched)),
													_Utils_Tuple2(
													'homePort',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.homePort)),
													_Utils_Tuple2(
													'callSign',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.callSign)),
													_Utils_Tuple2(
													'photo',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.photo)),
													_Utils_Tuple2(
													'boatType',
													$elm$json$Json$Encode$string(form.boatType)),
													_Utils_Tuple2(
													'trackerId',
													A2(
														$elm_community$json_extra$Json$Encode$Extra$maybe,
														$elm$json$Json$Encode$string,
														A2($elm$core$Maybe$map, $author$project$Data$Boat$trackerIdToString, form.trackerId))),
													_Utils_Tuple2(
													'isTrailerBoat',
													$elm$json$Json$Encode$bool(form.isTrailerBoat)),
													_Utils_Tuple2(
													'maxSpeed',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, form.maxSpeed)),
													_Utils_Tuple2(
													'lowBatteryAlertThreshold',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, form.lowBatteryAlertThreshold)),
													_Utils_Tuple2(
													'highWaterAlertSettings',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Boat$encodeHighWaterAlertSettings, form.highWaterAlertSettings)),
													_Utils_Tuple2(
													'movementAlertSettings',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Boat$movementAlertSettingsEncoder, form.movementAlertSettings)),
													_Utils_Tuple2(
													'batteryIsolationEnabled',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$bool, form.batteryIsolationEnabled)),
													_Utils_Tuple2(
													'helmVesselId',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, form.helmVesselId))
												]))))
								]))),
					expect: $author$project$Api$expectJson($author$project$Data$Boat$decode),
					method: 'PUT',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnSubmit = function (a) {
	return {$: 'OnSubmit', a: a};
};
var $author$project$Api$archiveBoat = F5(
	function (token, apiUrl, fleet, boatId, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet.slug,
								'boats',
								$author$project$Data$Boat$boatIdToString(boatId)
							]),
						_List_Nil),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectWhatever,
					method: 'DELETE',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnArchiveBoat = function (a) {
	return {$: 'OnArchiveBoat', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$update = F4(
	function (session, req, msg, model) {
		switch (msg.$) {
			case 'OnFetchBoat':
				if (msg.a.$ === 'Ok') {
					var b = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								boat: $elm$core$Maybe$Just(b),
								form: A4(
									$author$project$Views$BoatForm$init,
									$author$project$Data$User$isNeboAdmin(session.user),
									model.fleet.isHelmEnabled,
									model.fleet.speedUnit,
									$elm$core$Maybe$Just(b))
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchDaylightTimes':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							daylightTimes: $elm$core$Result$toMaybe(result)
						}),
					$author$project$Effect$none);
			case 'FormMsg':
				var m = msg.a;
				var _v1 = A2($author$project$Views$BoatForm$update, m, model.form);
				var updatedForm = _v1.a;
				var formCmd = _v1.b;
				var updatedModel = _Utils_update(
					model,
					{form: updatedForm});
				var formEffect = $author$project$Effect$fromCmd(
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$FormMsg, formCmd));
				switch (m.$) {
					case 'Submit':
						var _v3 = $author$project$Views$BoatForm$getOutput(updatedForm);
						if (_v3.$ === 'Just') {
							var _v4 = _v3.a;
							var f = _v4.a;
							var file = _v4.b;
							return _Utils_Tuple2(
								updatedModel,
								$author$project$Effect$batch(
									_List_fromArray(
										[
											A7($author$project$Api$putBoat, session.authToken, model.apiUrl, model.fleet, model.boatId, f, file, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnSubmit),
											formEffect,
											$author$project$Effect$fromCmd(
											$author$project$Ports$startProgressBar(_Utils_Tuple0))
										])));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{
										error: $elm$core$Maybe$Just(
											{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'Unable to submit form'})
									}),
								formEffect);
						}
					case 'ArchiveBoat':
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{showBoatArchiveWarning: true}),
							formEffect);
					default:
						return _Utils_Tuple2(updatedModel, formEffect);
				}
			case 'OnSubmit':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Request$pushRoute,
										$author$project$Gen$Route$Fleet___Boats(
											{fleet: model.fleet.slug}),
										req),
										$author$project$Ports$completeProgressBar(_Utils_Tuple0)
									]))));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'ArchiveBoat':
				var _v5 = model.boat;
				if (_v5.$ === 'Just') {
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$archiveBoat, session.authToken, model.apiUrl, model.fleet, model.boatId, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$OnArchiveBoat));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation, title: 'Error', type_: $author$project$Views$Alert$Danger, message: 'Boat not loaded'})
							}),
						$author$project$Effect$none);
				}
			case 'OnArchiveBoat':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							A2(
								$author$project$Request$pushRoute,
								$author$project$Gen$Route$Fleet___Boats(
									{fleet: model.fleet.slug}),
								req)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'DismissModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showBoatArchiveWarning: false}),
					$author$project$Effect$none);
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Edit$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$Boats$BoatId_$Edit$init, session, shared.apiUrl, req),
					view: A2($author$project$Pages$Fleet_$Boats$BoatId_$Edit$view, session, shared.featureDropState),
					update: A2($author$project$Pages$Fleet_$Boats$BoatId_$Edit$update, session, req),
					subscriptions: $author$project$Pages$Fleet_$Boats$BoatId_$Edit$subscriptions
				};
			});
	});
var $author$project$Views$ActivityChart$init = function () {
	var collapsed = 70;
	return {
		end: 0,
		logs: _List_Nil,
		zone: $elm$time$Time$utc,
		start: 0,
		locale: $enkidatron$elm_cldr$Cldr$Locale$en,
		voltage: _List_Nil,
		canExpand: false,
		dragStart: $elm$core$Maybe$Nothing,
		maxHeight: 800,
		speedUnit: $author$project$Data$SpeedUnit$Knots,
		activities: _List_Nil,
		heightState: $mdgriffith$elm_animator$Animator$init(collapsed),
		hoveringBar: $elm$core$Maybe$Nothing,
		hoveringDot: $elm$core$Maybe$Nothing,
		hoveredRange: $elm$core$Maybe$Nothing,
		resizeAnchor: $elm$core$Maybe$Nothing,
		bilgeActivity: _List_Nil,
		extrasVisible: $mdgriffith$elm_animator$Animator$init(false),
		mousePosition: $elm$core$Maybe$Nothing,
		expandedHeight: 400,
		signalStrength: _List_Nil,
		binWidthSeconds: 30,
		collapsedHeight: collapsed
	};
}();
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$Views$ActivityChart$setLocale = F2(
	function (locale, model) {
		return _Utils_update(
			model,
			{locale: locale});
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoat = function (a) {
	return {$: 'OnFetchBoat', a: a};
};
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $elm$time$Time$getZoneName = _Time_getZoneName(_Utils_Tuple0);
var $author$project$Data$Session$fleetForSlug = F2(
	function (session, slug) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(f.slug, slug);
			},
			session.fleets);
	});
var $author$project$Views$ActivityChart$setCanExpand = F2(
	function (canExpand, model) {
		return _Utils_update(
			model,
			{canExpand: canExpand});
	});
var $author$project$Views$ActivityChart$setSpeedUnit = F2(
	function (unit, model) {
		return _Utils_update(
			model,
			{speedUnit: unit});
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnGetViewport = function (a) {
	return {$: 'OnGetViewport', a: a};
};
var $author$project$ISO8601$Extra$parseDateTime = F2(
	function (zone, str) {
		return A2(
			$elm$core$Maybe$map,
			$jweir$elm_iso8601$ISO8601$fromPosix,
			A2(
				$elm$core$Maybe$map,
				function (p) {
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(p) - ((A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, p) * 60) * 1000));
				},
				A2(
					$elm$core$Maybe$map,
					$jweir$elm_iso8601$ISO8601$toPosix,
					$elm$core$Result$toMaybe(
						$jweir$elm_iso8601$ISO8601$fromString(str)))));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnGetMapElement = function (a) {
	return {$: 'OnGetMapElement', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchGeofences = function (a) {
	return {$: 'OnFetchGeofences', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateDatePicker = function (a) {
	return {$: 'UpdateDatePicker', a: a};
};
var $author$project$Data$Log$Log = F4(
	function (timestamp, severity, description, latLong) {
		return {latLong: latLong, severity: severity, timestamp: timestamp, description: description};
	});
var $author$project$Data$Log$Info = {$: 'Info'};
var $author$project$Data$Log$Danger = {$: 'Danger'};
var $author$project$Data$Log$Warning = {$: 'Warning'};
var $author$project$Data$Log$severityDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'info':
				return $elm$json$Json$Decode$succeed($author$project$Data$Log$Info);
			case 'warning':
				return $elm$json$Json$Decode$succeed($author$project$Data$Log$Warning);
			case 'danger':
				return $elm$json$Json$Decode$succeed($author$project$Data$Log$Danger);
			default:
				return $elm$json$Json$Decode$fail('Unknown Severity: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Log$decode = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Log$Log,
	A2(
		$elm$json$Json$Decode$map,
		$jweir$elm_iso8601$ISO8601$toPosix,
		A2($elm$json$Json$Decode$field, 'timestamp', $jweir$elm_iso8601$ISO8601$decode)),
	A2($elm$json$Json$Decode$field, 'severity', $author$project$Data$Log$severityDecoder),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Maybe$map2($author$project$Geospatial$LatLong$LatLong),
		A2(
			$elm$json$Json$Decode$field,
			'latitude',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
		A2(
			$elm$json$Json$Decode$field,
			'longitude',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float))));
var $author$project$Api$fetchBoatLogs = F7(
	function (token, apiUrl, fleet, bId, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'boats',
								$author$project$Data$Boat$boatIdToString(bId),
								'logs'
							]),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$Log$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoatLogs = function (a) {
	return {$: 'OnFetchBoatLogs', a: a};
};
var $author$project$Api$fetchBoatLocations = F7(
	function (token, apiUrl, fleet, bId, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'boats',
								$author$project$Data$Boat$boatIdToString(bId),
								'locations'
							]),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$list($author$project$Data$BoatLocation$decode))),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Data$BoatTelemetry$BoatTelemetryItem = F5(
	function (timestamp, externalVoltage, signalStrength, inTrip, highWaterDetected) {
		return {inTrip: inTrip, timestamp: timestamp, signalStrength: signalStrength, externalVoltage: externalVoltage, highWaterDetected: highWaterDetected};
	});
var $author$project$Data$BoatTelemetry$decodeItem = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$BoatTelemetry$BoatTelemetryItem,
	A2(
		$elm$json$Json$Decode$map,
		$jweir$elm_iso8601$ISO8601$toPosix,
		A2($elm$json$Json$Decode$field, 'timestamp', $jweir$elm_iso8601$ISO8601$decode)),
	A2(
		$elm$json$Json$Decode$field,
		'externalVoltage',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$field,
		'signalStrength',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'inTrip', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'highWaterDetected', $elm$json$Json$Decode$bool));
var $author$project$Data$BoatTelemetry$BoatTelemetry = F3(
	function (boatId, boatName, telemetry) {
		return {boatId: boatId, boatName: boatName, telemetry: telemetry};
	});
var $author$project$Data$BoatTelemetry$decode = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$BoatTelemetry$BoatTelemetry,
	A2($elm$json$Json$Decode$field, 'boatId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'boatName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'telemetry',
		$elm$json$Json$Decode$list($author$project$Data$BoatTelemetry$decodeItem)));
var $author$project$Api$fetchBoatTelemetry = F7(
	function (token, apiUrl, fleet, bId, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							[
								'fleet',
								fleet,
								'boats',
								$author$project$Data$Boat$boatIdToString(bId),
								'telemetry'
							]),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson($author$project$Data$BoatTelemetry$decode),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoatLocations = function (a) {
	return {$: 'OnFetchBoatLocations', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoatTelemetry = function (a) {
	return {$: 'OnFetchBoatTelemetry', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$fetchBoatLocations = F2(
	function (session, model) {
		var _v0 = _Utils_Tuple2(model.startDate, model.endDate);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var startDate = _v0.a.a;
			var endDate = _v0.b.a;
			var start = $jweir$elm_iso8601$ISO8601$fromPosix(startDate);
			var end = $jweir$elm_iso8601$ISO8601$fromPosix(endDate);
			return $author$project$Effect$batch(
				_List_fromArray(
					[
						A7($author$project$Api$fetchBoatLocations, session.authToken, model.apiUrl, model.fleet.slug, model.boatId, start, end, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoatLocations),
						A7($author$project$Api$fetchBoatLogs, session.authToken, model.apiUrl, model.fleet.slug, model.boatId, start, end, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoatLogs),
						A7($author$project$Api$fetchBoatTelemetry, session.authToken, model.apiUrl, model.fleet.slug, model.boatId, start, end, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoatTelemetry),
						$author$project$Effect$fromCmd(
						$author$project$Ports$startProgressBar(_Utils_Tuple0))
					]));
		} else {
			return $author$project$Effect$none;
		}
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$init = F3(
	function (shared, session, req) {
		var durationDatePicker = $mercurymedia$elm_datetime_picker$DurationDatePicker$init($author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateDatePicker);
		var startDate = A2(
			$elm$core$Maybe$map,
			$jweir$elm_iso8601$ISO8601$toPosix,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$ISO8601$Extra$parseDateTime($elm$time$Time$utc),
				A2($elm$core$Dict$get, 'start', req.query)));
		var endDate = A2(
			$elm$core$Maybe$map,
			$jweir$elm_iso8601$ISO8601$toPosix,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$ISO8601$Extra$parseDateTime($elm$time$Time$utc),
				A2($elm$core$Dict$get, 'end', req.query)));
		var boatId = $author$project$Data$Boat$boatIdFromString(req.params.boatId);
		var fleet = A2($author$project$Data$Session$fleetForSlug, session, req.params.fleet);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			var model = {
				boat: $elm$core$Maybe$Nothing,
				logs: _List_Nil,
				chart: A2(
					$author$project$Views$ActivityChart$setCanExpand,
					$author$project$Data$User$isNeboAdmin(session.user),
					A2(
						$author$project$Views$ActivityChart$setSpeedUnit,
						f.speedUnit,
						A2($author$project$Views$ActivityChart$setLocale, shared.locale, $author$project$Views$ActivityChart$init))),
				error: $elm$core$Maybe$Nothing,
				fleet: f,
				sheet: $author$project$Views$SidebarSheet$init,
				trips: _List_Nil,
				apiUrl: shared.apiUrl,
				boatId: boatId,
				locale: shared.locale,
				endDate: endDate,
				mapSize: _Utils_Tuple2(350, 850),
				summary: $elm$core$Maybe$Nothing,
				voltage: _List_Nil,
				activity: _Utils_Tuple2(_List_Nil, 30),
				fleetUrl: shared.fleetUrl,
				mapStyle: $author$project$Views$Mapbox$Satellite,
				timeZone: $elm$time$Time$utc,
				geofences: _List_Nil,
				startDate: startDate,
				showPoints: false,
				currentTime: $elm$time$Time$millisToPosix(0),
				mapPosition: {
					zoom: f.zoom,
					centre: {lat: f.latitude, _long: f.longitude}
				},
				measureLine: _List_Nil,
				currentRoute: req.route,
				timeZoneName: $elm$core$Maybe$Nothing,
				bilgeActivity: _List_Nil,
				selectedRange: $elm$core$Maybe$Nothing,
				viewportWidth: 500,
				signalStrength: _List_Nil,
				viewportHeight: 800,
				selectedLocation: $elm$core$Maybe$Nothing,
				hoveredTrackRange: $elm$core$Maybe$Nothing,
				measureModeActive: false,
				durationDatePicker: durationDatePicker
			};
			return _Utils_Tuple2(
				model,
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Ports$startProgressBar(_Utils_Tuple0),
										A2(
										$elm$core$Task$attempt,
										$author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnGetMapElement,
										$elm$browser$Browser$Dom$getElement('map')),
										A2($elm$core$Task$attempt, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnGetViewport, $elm$browser$Browser$Dom$getViewport),
										A2(
										$elm$core$Task$perform,
										$author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnTime,
										A4(
											$elm$core$Task$map3,
											F3(
												function (a, b, c) {
													return _Utils_Tuple3(a, b, c);
												}),
											$elm$time$Time$now,
											$elm$time$Time$here,
											$elm$time$Time$getZoneName)),
										$author$project$Ports$sendPageViewEvent(
										_Utils_Tuple2(req.url.path, f.name + ': Vessel Logs'))
									]))),
							A5($author$project$Api$fetchBoat, session.authToken, shared.apiUrl, f, boatId, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchBoat),
							A4($author$project$Api$fetchGeofences, session.authToken, shared.apiUrl, f, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnFetchGeofences),
							A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$fetchBoatLocations, session, model)
						])));
		} else {
			return _Utils_Tuple2(
				{
					boat: $elm$core$Maybe$Nothing,
					logs: _List_Nil,
					chart: A2($author$project$Views$ActivityChart$setLocale, shared.locale, $author$project$Views$ActivityChart$init),
					error: $elm$core$Maybe$Nothing,
					fleet: $author$project$Data$Fleet$empty,
					sheet: $author$project$Views$SidebarSheet$init,
					trips: _List_Nil,
					apiUrl: shared.apiUrl,
					boatId: boatId,
					locale: shared.locale,
					endDate: $elm$core$Maybe$Nothing,
					mapSize: _Utils_Tuple2(350, 850),
					summary: $elm$core$Maybe$Nothing,
					voltage: _List_Nil,
					activity: _Utils_Tuple2(_List_Nil, 30),
					fleetUrl: shared.fleetUrl,
					mapStyle: $author$project$Views$Mapbox$Satellite,
					timeZone: $elm$time$Time$utc,
					geofences: _List_Nil,
					startDate: $elm$core$Maybe$Nothing,
					showPoints: false,
					currentTime: $elm$time$Time$millisToPosix(0),
					mapPosition: {
						zoom: 0,
						centre: A2($author$project$Geospatial$LatLong$LatLong, 0, 0)
					},
					measureLine: _List_Nil,
					currentRoute: $author$project$Gen$Route$NotFound,
					timeZoneName: $elm$core$Maybe$Nothing,
					bilgeActivity: _List_Nil,
					selectedRange: $elm$core$Maybe$Nothing,
					viewportWidth: 500,
					signalStrength: _List_Nil,
					viewportHeight: 800,
					selectedLocation: $elm$core$Maybe$Nothing,
					hoveredTrackRange: $elm$core$Maybe$Nothing,
					measureModeActive: false,
					durationDatePicker: durationDatePicker
				},
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$NoOp = {$: 'NoOp'};
var $terezka$elm_charts$Internal$Helpers$Attribute = function (a) {
	return {$: 'Attribute', a: a};
};
var $terezka$elm_charts$Chart$Attributes$x1 = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{
					x1: $elm$core$Maybe$Just(v)
				});
		});
};
var $terezka$elm_charts$Chart$Attributes$x2 = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{
					x2: $elm$core$Maybe$Just(v)
				});
		});
};
var $terezka$elm_charts$Chart$Attributes$y1 = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{
					y1: $elm$core$Maybe$Just(v)
				});
		});
};
var $terezka$elm_charts$Chart$Attributes$y2 = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{
					y2: $elm$core$Maybe$Just(v)
				});
		});
};
var $terezka$elm_charts$Internal$Property$NotStacked = function (a) {
	return {$: 'NotStacked', a: a};
};
var $terezka$elm_charts$Internal$Property$notStacked = F3(
	function (toY, interpolation, presentation) {
		return $terezka$elm_charts$Internal$Property$NotStacked(
			{
				toY: toY,
				toYSum: toY,
				variation: F2(
					function (_v0, _v1) {
						return _List_Nil;
					}),
				tooltipName: $elm$core$Maybe$Nothing,
				tooltipText: function (datum) {
					return A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$fromFloat,
							toY(datum)));
				},
				presentation: presentation,
				interpolation: interpolation
			});
	});
var $terezka$elm_charts$Chart$bar = function (y) {
	return A2(
		$terezka$elm_charts$Internal$Property$notStacked,
		A2($elm$core$Basics$composeR, y, $elm$core$Maybe$Just),
		_List_Nil);
};
var $terezka$elm_charts$Internal$Events$Decoder = function (a) {
	return {$: 'Decoder', a: a};
};
var $terezka$elm_charts$Internal$Events$map = F2(
	function (f, _v0) {
		var a = _v0.a;
		return $terezka$elm_charts$Internal$Events$Decoder(
			F3(
				function (ps, s, p) {
					return f(
						A3(a, ps, s, p));
				}));
	});
var $terezka$elm_charts$Chart$Events$map = $terezka$elm_charts$Internal$Events$map;
var $terezka$elm_charts$Chart$SvgElement = function (a) {
	return {$: 'SvgElement', a: a};
};
var $terezka$elm_charts$Chart$svg = function (func) {
	return $terezka$elm_charts$Chart$SvgElement(
		function (p) {
			return func(p);
		});
};
var $terezka$elm_charts$Internal$Item$Bar = function (a) {
	return {$: 'Bar', a: a};
};
var $terezka$elm_charts$Internal$Item$Rendered = F2(
	function (a, b) {
		return {$: 'Rendered', a: a, b: b};
	});
var $terezka$elm_charts$Internal$Item$isBar = function (_v0) {
	var meta = _v0.a;
	var item = _v0.b;
	var _v1 = meta.presentation;
	if (_v1.$ === 'Bar') {
		var bar = _v1.a;
		return $elm$core$Maybe$Just(
			A2(
				$terezka$elm_charts$Internal$Item$Rendered,
				{y: meta.y, x1: meta.x1, x2: meta.x2, name: meta.name, color: meta.color, datum: meta.datum, toAny: $terezka$elm_charts$Internal$Item$Bar, isReal: meta.isReal, tooltipText: meta.tooltipText, presentation: bar, identification: meta.identification},
				item));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $terezka$elm_charts$Internal$Many$Remodel = F2(
	function (a, b) {
		return {$: 'Remodel', a: a, b: b};
	});
var $terezka$elm_charts$Internal$Item$getPosition = F2(
	function (plane, _v0) {
		var item = _v0.b;
		return item.toPosition(plane);
	});
var $terezka$elm_charts$Internal$Many$bars = A2(
	$terezka$elm_charts$Internal$Many$Remodel,
	$terezka$elm_charts$Internal$Item$getPosition,
	$elm$core$List$filterMap($terezka$elm_charts$Internal$Item$isBar));
var $terezka$elm_charts$Chart$Item$bars = $terezka$elm_charts$Internal$Many$bars;
var $terezka$elm_charts$Internal$Item$Dot = function (a) {
	return {$: 'Dot', a: a};
};
var $terezka$elm_charts$Internal$Item$isDot = function (_v0) {
	var meta = _v0.a;
	var item = _v0.b;
	var _v1 = meta.presentation;
	if (_v1.$ === 'Dot') {
		var dot = _v1.a;
		return $elm$core$Maybe$Just(
			A2(
				$terezka$elm_charts$Internal$Item$Rendered,
				{y: meta.y, x1: meta.x1, x2: meta.x2, name: meta.name, color: meta.color, datum: meta.datum, toAny: $terezka$elm_charts$Internal$Item$Dot, isReal: meta.isReal, tooltipText: meta.tooltipText, presentation: dot, identification: meta.identification},
				item));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $terezka$elm_charts$Internal$Coordinates$center = function (pos) {
	return {x: pos.x1 + ((pos.x2 - pos.x1) / 2), y: pos.y1 + ((pos.y2 - pos.y1) / 2)};
};
var $terezka$elm_charts$Internal$Many$fromPoint = function (point) {
	return {x1: point.x, x2: point.x, y1: point.y, y2: point.y};
};
var $terezka$elm_charts$Internal$Many$dots = function () {
	var centerPosition = F2(
		function (plane, item) {
			return $terezka$elm_charts$Internal$Many$fromPoint(
				$terezka$elm_charts$Internal$Coordinates$center(
					A2($terezka$elm_charts$Internal$Item$getPosition, plane, item)));
		});
	return A2(
		$terezka$elm_charts$Internal$Many$Remodel,
		centerPosition,
		$elm$core$List$filterMap($terezka$elm_charts$Internal$Item$isDot));
}();
var $terezka$elm_charts$Chart$Item$dots = $terezka$elm_charts$Internal$Many$dots;
var $terezka$elm_charts$Internal$Coordinates$range = function (axis) {
	var diff = axis.max - axis.min;
	return (diff > 0) ? diff : 1;
};
var $terezka$elm_charts$Internal$Coordinates$innerLength = function (axis) {
	return A2($elm$core$Basics$max, 1, (axis.length - axis.marginMin) - axis.marginMax);
};
var $terezka$elm_charts$Internal$Coordinates$innerWidth = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.x);
};
var $terezka$elm_charts$Internal$Coordinates$scaleSVGX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerWidth(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.x);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, value - plane.x.min) + plane.x.marginMin;
	});
var $terezka$elm_charts$Internal$Coordinates$innerHeight = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.y);
};
var $terezka$elm_charts$Internal$Coordinates$scaleSVGY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerHeight(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.y);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGY = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGY, plane, plane.y.max - value) + plane.y.marginMin;
	});
var $terezka$elm_charts$Internal$Svg$plusPath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(area_ / 4) + off;
		var r6 = side / 2;
		var r3 = side;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_ - r6) + (' ' + $elm$core$String$fromFloat(((y_ - r3) - r6) + off))),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat(r3),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat(r3),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(-r3),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(-r3),
					'v' + $elm$core$String$fromFloat(r3 - off)
				]));
	});
var $terezka$elm_charts$Internal$Svg$trianglePath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(
			(area_ * 4) / $elm$core$Basics$sqrt(3)) + (off * $elm$core$Basics$sqrt(3));
		var height = ($elm$core$Basics$sqrt(3) * side) / 2;
		var fromMiddle = height - (($elm$core$Basics$tan(
			$elm$core$Basics$degrees(30)) * side) / 2);
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_) + (' ' + $elm$core$String$fromFloat(y_ - fromMiddle))),
					'l' + ($elm$core$String$fromFloat((-side) / 2) + (' ' + $elm$core$String$fromFloat(height))),
					'h' + $elm$core$String$fromFloat(side),
					'z'
				]));
	});
var $terezka$elm_charts$Internal$Svg$isWithinPlane = F3(
	function (plane, x, y) {
		return _Utils_eq(
			A3($elm$core$Basics$clamp, plane.x.min, plane.x.max, x),
			x) && _Utils_eq(
			A3($elm$core$Basics$clamp, plane.y.min, plane.y.max, y),
			y);
	});
var $terezka$elm_charts$Internal$Coordinates$toId = function (plane) {
	var numToStr = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromFloat,
		A2($elm$core$String$replace, '.', '-'));
	return A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			[
				'elm-charts__id',
				numToStr(plane.x.length),
				numToStr(plane.x.min),
				numToStr(plane.x.max),
				numToStr(plane.x.marginMin),
				numToStr(plane.x.marginMax),
				numToStr(plane.y.length),
				numToStr(plane.y.min),
				numToStr(plane.y.max),
				numToStr(plane.y.marginMin),
				numToStr(plane.y.marginMax)
			]));
};
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $terezka$elm_charts$Internal$Svg$withinChartArea = function (plane) {
	return $elm$svg$Svg$Attributes$clipPath(
		'url(#' + ($terezka$elm_charts$Internal$Coordinates$toId(plane) + ')'));
};
var $terezka$elm_charts$Internal$Svg$dot = F5(
	function (plane, toX, toY, config, datum_) {
		var highlightColor = (config.highlightColor === '') ? config.color : config.highlightColor;
		var highlightAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(highlightColor),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.highlightWidth)),
				$elm$svg$Svg$Attributes$strokeOpacity(
				$elm$core$String$fromFloat(config.highlight)),
				$elm$svg$Svg$Attributes$fill('transparent'),
				$elm$svg$Svg$Attributes$class('elm-charts__dot-highlight')
			]);
		var styleAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(
				(config.border === '') ? config.color : config.border),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.borderWidth)),
				$elm$svg$Svg$Attributes$fillOpacity(
				$elm$core$String$fromFloat(config.opacity)),
				$elm$svg$Svg$Attributes$fill(config.color),
				$elm$svg$Svg$Attributes$class('elm-charts__dot'),
				config.hideOverflow ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
			]);
		var area_ = (2 * $elm$core$Basics$pi) * config.size;
		var yOrg = toY(datum_);
		var xOrg = toX(datum_);
		var showDot = A3($terezka$elm_charts$Internal$Svg$isWithinPlane, plane, xOrg, yOrg) || config.hideOverflow;
		var view = F3(
			function (toEl, highlightOff, toAttrs) {
				return (config.highlight > 0) ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__dot-container')
						]),
					_List_fromArray(
						[
							A2(
							toEl,
							_Utils_ap(
								toAttrs(highlightOff),
								highlightAttrs),
							_List_Nil),
							A2(
							toEl,
							_Utils_ap(
								toAttrs(0),
								styleAttrs),
							_List_Nil)
						])) : A2(
					toEl,
					_Utils_ap(
						toAttrs(0),
						styleAttrs),
					_List_Nil);
			});
		var y_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, yOrg);
		var x_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, xOrg);
		if (!showDot) {
			return $elm$svg$Svg$text('');
		} else {
			var _v0 = config.shape;
			if (_v0.$ === 'Nothing') {
				return $elm$svg$Svg$text('');
			} else {
				switch (_v0.a.$) {
					case 'Circle':
						var _v1 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$circle,
							config.highlightWidth / 2,
							function (off) {
								var radius = $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(x_)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(y_)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(radius + off))
									]);
							});
					case 'Triangle':
						var _v2 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.highlightWidth,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$trianglePath, area_, off, x_, y_))
									]);
							});
					case 'Square':
						var _v3 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.highlightWidth,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff))
									]);
							});
					case 'Diamond':
						var _v4 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.highlightWidth,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					case 'Cross':
						var _v5 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.highlightWidth,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					default:
						var _v6 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.highlightWidth,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_))
									]);
							});
				}
			}
		}
	});
var $terezka$elm_charts$Internal$Helpers$apply = F2(
	function (attrs, _default) {
		var apply_ = F2(
			function (_v0, a) {
				var f = _v0.a;
				return f(a);
			});
		return A3($elm$core$List$foldl, apply_, _default, attrs);
	});
var $terezka$elm_charts$Internal$Helpers$pink = '#ea60df';
var $terezka$elm_charts$Internal$Svg$defaultDot = {size: 6, color: $terezka$elm_charts$Internal$Helpers$pink, shape: $elm$core$Maybe$Nothing, border: '', opacity: 1, highlight: 0, borderWidth: 0, hideOverflow: false, highlightColor: '', highlightWidth: 5};
var $terezka$elm_charts$Chart$Svg$dot = F4(
	function (plane, toX, toY, edits) {
		return A4(
			$terezka$elm_charts$Internal$Svg$dot,
			plane,
			toX,
			toY,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultDot));
	});
var $terezka$elm_charts$Internal$Helpers$gray = '#EFF2FA';
var $terezka$elm_charts$Internal$Commands$Line = F2(
	function (a, b) {
		return {$: 'Line', a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$Move = F2(
	function (a, b) {
		return {$: 'Move', a: a, b: b};
	});
var $terezka$elm_charts$Internal$Svg$withAttrs = F3(
	function (attrs, toEl, defaultAttrs) {
		return toEl(
			_Utils_ap(
				defaultAttrs,
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					attrs)));
	});
var $terezka$elm_charts$Internal$Commands$Arc = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 'Arc', a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $terezka$elm_charts$Internal$Commands$Close = {$: 'Close'};
var $terezka$elm_charts$Internal$Commands$CubicBeziers = F6(
	function (a, b, c, d, e, f) {
		return {$: 'CubicBeziers', a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziers = F4(
	function (a, b, c, d) {
		return {$: 'QuadraticBeziers', a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$CubicBeziersShort = F4(
	function (a, b, c, d) {
		return {$: 'CubicBeziersShort', a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort = F2(
	function (a, b) {
		return {$: 'QuadraticBeziersShort', a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$translate = F2(
	function (plane, command) {
		switch (command.$) {
			case 'Move':
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Move,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 'Line':
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Line,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 'CubicBeziers':
				var cx1 = command.a;
				var cy1 = command.b;
				var cx2 = command.c;
				var cy2 = command.d;
				var x = command.e;
				var y = command.f;
				return A6(
					$terezka$elm_charts$Internal$Commands$CubicBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 'CubicBeziersShort':
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$CubicBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 'QuadraticBeziers':
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 'QuadraticBeziersShort':
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 'Arc':
				var rx = command.a;
				var ry = command.b;
				var xAxisRotation = command.c;
				var largeArcFlag = command.d;
				var sweepFlag = command.e;
				var x = command.f;
				var y = command.g;
				return A7(
					$terezka$elm_charts$Internal$Commands$Arc,
					rx,
					ry,
					xAxisRotation,
					largeArcFlag,
					sweepFlag,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			default:
				return $terezka$elm_charts$Internal$Commands$Close;
		}
	});
var $terezka$elm_charts$Internal$Commands$joinCommands = function (commands) {
	return A2($elm$core$String$join, ' ', commands);
};
var $terezka$elm_charts$Internal$Commands$stringPoint = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return $elm$core$String$fromFloat(x) + (' ' + $elm$core$String$fromFloat(y));
};
var $terezka$elm_charts$Internal$Commands$stringPoints = function (points) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $terezka$elm_charts$Internal$Commands$stringPoint, points));
};
var $terezka$elm_charts$Internal$Commands$stringBoolInt = function (bool) {
	return bool ? '1' : '0';
};
var $terezka$elm_charts$Internal$Commands$stringCommand = function (command) {
	switch (command.$) {
		case 'Move':
			var x = command.a;
			var y = command.b;
			return 'M' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 'Line':
			var x = command.a;
			var y = command.b;
			return 'L' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 'CubicBeziers':
			var cx1 = command.a;
			var cy1 = command.b;
			var cx2 = command.c;
			var cy2 = command.d;
			var x = command.e;
			var y = command.f;
			return 'C' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(cx2, cy2),
						_Utils_Tuple2(x, y)
					]));
		case 'CubicBeziersShort':
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 'QuadraticBeziers':
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 'QuadraticBeziersShort':
			var x = command.a;
			var y = command.b;
			return 'T' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 'Arc':
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var x = command.f;
			var y = command.g;
			return 'A ' + $terezka$elm_charts$Internal$Commands$joinCommands(
				_List_fromArray(
					[
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(rx, ry)),
						$elm$core$String$fromInt(xAxisRotation),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(largeArcFlag),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(sweepFlag),
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(x, y))
					]));
		default:
			return 'Z';
	}
};
var $terezka$elm_charts$Internal$Commands$description = F2(
	function (plane, commands) {
		return $terezka$elm_charts$Internal$Commands$joinCommands(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$terezka$elm_charts$Internal$Commands$translate(plane),
					$terezka$elm_charts$Internal$Commands$stringCommand),
				commands));
	});
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.x)) / $terezka$elm_charts$Internal$Coordinates$innerWidth(plane);
	});
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.y)) / $terezka$elm_charts$Internal$Coordinates$innerHeight(plane);
	});
var $terezka$elm_charts$Internal$Svg$lengthInCartesianX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX;
var $terezka$elm_charts$Internal$Svg$lengthInCartesianY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY;
var $terezka$elm_charts$Internal$Svg$line = F2(
	function (plane, config) {
		var angle = $elm$core$Basics$degrees(config.tickDirection);
		var _v0 = (config.tickLength > 0) ? _Utils_Tuple2(
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianX,
				plane,
				$elm$core$Basics$cos(angle) * config.tickLength),
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianY,
				plane,
				$elm$core$Basics$sin(angle) * config.tickLength)) : _Utils_Tuple2(0, 0);
		var tickOffsetX = _v0.a;
		var tickOffsetY = _v0.b;
		var _v1 = function () {
			var _v4 = _Utils_Tuple3(
				_Utils_Tuple2(config.x1, config.x2),
				_Utils_Tuple2(config.y1, config.y2),
				_Utils_Tuple2(config.x2Svg, config.y2Svg));
			if (_v4.a.a.$ === 'Just') {
				if (_v4.a.b.$ === 'Just') {
					if (_v4.b.a.$ === 'Nothing') {
						if (_v4.b.b.$ === 'Nothing') {
							var _v5 = _v4.a;
							var a = _v5.a.a;
							var b = _v5.b.a;
							var _v6 = _v4.b;
							var _v7 = _v6.a;
							var _v8 = _v6.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(plane.y.min, plane.y.min));
						} else {
							var _v39 = _v4.a;
							var a = _v39.a.a;
							var b = _v39.b.a;
							var _v40 = _v4.b;
							var _v41 = _v40.a;
							var c = _v40.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						}
					} else {
						if (_v4.b.b.$ === 'Nothing') {
							var _v42 = _v4.a;
							var a = _v42.a.a;
							var b = _v42.b.a;
							var _v43 = _v4.b;
							var c = _v43.a.a;
							var _v44 = _v43.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.x.min, config.x1),
									A2($elm$core$Maybe$withDefault, plane.x.max, config.x2)),
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.y.min, config.y1),
									A2($elm$core$Maybe$withDefault, plane.y.max, config.y2)));
						}
					}
				} else {
					if (_v4.b.a.$ === 'Nothing') {
						if (_v4.b.b.$ === 'Nothing') {
							var _v9 = _v4.a;
							var a = _v9.a.a;
							var _v10 = _v9.b;
							var _v11 = _v4.b;
							var _v12 = _v11.a;
							var _v13 = _v11.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, a),
								_Utils_Tuple2(plane.y.min, plane.y.max));
						} else {
							if (_v4.c.a.$ === 'Just') {
								if (_v4.c.b.$ === 'Just') {
									var _v52 = _v4.a;
									var a = _v52.a.a;
									var _v53 = _v52.b;
									var _v54 = _v4.b;
									var _v55 = _v54.a;
									var b = _v54.b.a;
									var _v56 = _v4.c;
									var xOff = _v56.a.a;
									var yOff = _v56.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v57 = _v4.a;
									var a = _v57.a.a;
									var _v58 = _v57.b;
									var _v59 = _v4.b;
									var _v60 = _v59.a;
									var b = _v59.b.a;
									var _v61 = _v4.c;
									var xOff = _v61.a.a;
									var _v62 = _v61.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v4.c.b.$ === 'Nothing') {
									var _v45 = _v4.a;
									var a = _v45.a.a;
									var _v46 = _v45.b;
									var _v47 = _v4.b;
									var _v48 = _v47.a;
									var b = _v47.b.a;
									var _v49 = _v4.c;
									var _v50 = _v49.a;
									var _v51 = _v49.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.x.max),
										_Utils_Tuple2(b, b));
								} else {
									var _v63 = _v4.a;
									var a = _v63.a.a;
									var _v64 = _v63.b;
									var _v65 = _v4.b;
									var _v66 = _v65.a;
									var b = _v65.b.a;
									var _v67 = _v4.c;
									var _v68 = _v67.a;
									var yOff = _v67.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (_v4.b.b.$ === 'Just') {
							var _v36 = _v4.a;
							var c = _v36.a.a;
							var _v37 = _v36.b;
							var _v38 = _v4.b;
							var a = _v38.a.a;
							var b = _v38.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (_v4.c.a.$ === 'Just') {
								if (_v4.c.b.$ === 'Just') {
									var _v76 = _v4.a;
									var a = _v76.a.a;
									var _v77 = _v76.b;
									var _v78 = _v4.b;
									var b = _v78.a.a;
									var _v79 = _v78.b;
									var _v80 = _v4.c;
									var xOff = _v80.a.a;
									var yOff = _v80.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v81 = _v4.a;
									var a = _v81.a.a;
									var _v82 = _v81.b;
									var _v83 = _v4.b;
									var b = _v83.a.a;
									var _v84 = _v83.b;
									var _v85 = _v4.c;
									var xOff = _v85.a.a;
									var _v86 = _v85.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v4.c.b.$ === 'Nothing') {
									var _v69 = _v4.a;
									var a = _v69.a.a;
									var _v70 = _v69.b;
									var _v71 = _v4.b;
									var b = _v71.a.a;
									var _v72 = _v71.b;
									var _v73 = _v4.c;
									var _v74 = _v73.a;
									var _v75 = _v73.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.x.max),
										_Utils_Tuple2(b, b));
								} else {
									var _v87 = _v4.a;
									var a = _v87.a.a;
									var _v88 = _v87.b;
									var _v89 = _v4.b;
									var b = _v89.a.a;
									var _v90 = _v89.b;
									var _v91 = _v4.c;
									var _v92 = _v91.a;
									var yOff = _v91.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				}
			} else {
				if (_v4.a.b.$ === 'Just') {
					if (_v4.b.a.$ === 'Nothing') {
						if (_v4.b.b.$ === 'Nothing') {
							var _v14 = _v4.a;
							var _v15 = _v14.a;
							var b = _v14.b.a;
							var _v16 = _v4.b;
							var _v17 = _v16.a;
							var _v18 = _v16.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(b, b),
								_Utils_Tuple2(plane.y.min, plane.y.max));
						} else {
							if (_v4.c.a.$ === 'Just') {
								if (_v4.c.b.$ === 'Just') {
									var _v100 = _v4.a;
									var _v101 = _v100.a;
									var a = _v100.b.a;
									var _v102 = _v4.b;
									var _v103 = _v102.a;
									var b = _v102.b.a;
									var _v104 = _v4.c;
									var xOff = _v104.a.a;
									var yOff = _v104.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v105 = _v4.a;
									var _v106 = _v105.a;
									var a = _v105.b.a;
									var _v107 = _v4.b;
									var _v108 = _v107.a;
									var b = _v107.b.a;
									var _v109 = _v4.c;
									var xOff = _v109.a.a;
									var _v110 = _v109.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v4.c.b.$ === 'Nothing') {
									var _v93 = _v4.a;
									var _v94 = _v93.a;
									var a = _v93.b.a;
									var _v95 = _v4.b;
									var _v96 = _v95.a;
									var b = _v95.b.a;
									var _v97 = _v4.c;
									var _v98 = _v97.a;
									var _v99 = _v97.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.x.max),
										_Utils_Tuple2(b, b));
								} else {
									var _v111 = _v4.a;
									var _v112 = _v111.a;
									var a = _v111.b.a;
									var _v113 = _v4.b;
									var _v114 = _v113.a;
									var b = _v113.b.a;
									var _v115 = _v4.c;
									var _v116 = _v115.a;
									var yOff = _v115.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (_v4.b.b.$ === 'Just') {
							var _v33 = _v4.a;
							var _v34 = _v33.a;
							var c = _v33.b.a;
							var _v35 = _v4.b;
							var a = _v35.a.a;
							var b = _v35.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (_v4.c.a.$ === 'Just') {
								if (_v4.c.b.$ === 'Just') {
									var _v124 = _v4.a;
									var _v125 = _v124.a;
									var a = _v124.b.a;
									var _v126 = _v4.b;
									var b = _v126.a.a;
									var _v127 = _v126.b;
									var _v128 = _v4.c;
									var xOff = _v128.a.a;
									var yOff = _v128.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v129 = _v4.a;
									var _v130 = _v129.a;
									var a = _v129.b.a;
									var _v131 = _v4.b;
									var b = _v131.a.a;
									var _v132 = _v131.b;
									var _v133 = _v4.c;
									var xOff = _v133.a.a;
									var _v134 = _v133.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v4.c.b.$ === 'Nothing') {
									var _v117 = _v4.a;
									var _v118 = _v117.a;
									var a = _v117.b.a;
									var _v119 = _v4.b;
									var b = _v119.a.a;
									var _v120 = _v119.b;
									var _v121 = _v4.c;
									var _v122 = _v121.a;
									var _v123 = _v121.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.x.max),
										_Utils_Tuple2(b, b));
								} else {
									var _v135 = _v4.a;
									var _v136 = _v135.a;
									var a = _v135.b.a;
									var _v137 = _v4.b;
									var b = _v137.a.a;
									var _v138 = _v137.b;
									var _v139 = _v4.c;
									var _v140 = _v139.a;
									var yOff = _v139.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				} else {
					if (_v4.b.a.$ === 'Just') {
						if (_v4.b.b.$ === 'Just') {
							var _v19 = _v4.a;
							var _v20 = _v19.a;
							var _v21 = _v19.b;
							var _v22 = _v4.b;
							var a = _v22.a.a;
							var b = _v22.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.x.min, plane.x.min),
								_Utils_Tuple2(a, b));
						} else {
							var _v23 = _v4.a;
							var _v24 = _v23.a;
							var _v25 = _v23.b;
							var _v26 = _v4.b;
							var a = _v26.a.a;
							var _v27 = _v26.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.x.min, plane.x.max),
								_Utils_Tuple2(a, a));
						}
					} else {
						if (_v4.b.b.$ === 'Just') {
							var _v28 = _v4.a;
							var _v29 = _v28.a;
							var _v30 = _v28.b;
							var _v31 = _v4.b;
							var _v32 = _v31.a;
							var b = _v31.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.x.min, plane.x.max),
								_Utils_Tuple2(b, b));
						} else {
							var _v141 = _v4.a;
							var _v142 = _v141.a;
							var _v143 = _v141.b;
							var _v144 = _v4.b;
							var _v145 = _v144.a;
							var _v146 = _v144.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.x.min, plane.x.max),
								_Utils_Tuple2(plane.y.min, plane.y.max));
						}
					}
				}
			}
		}();
		var _v2 = _v1.a;
		var x1 = _v2.a;
		var x2 = _v2.b;
		var _v3 = _v1.b;
		var y1 = _v3.a;
		var y2 = _v3.b;
		var y2_ = y2 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.yOff);
		var y1_ = y1 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.yOff);
		var x2_ = x2 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.xOff);
		var x1_ = x1 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.xOff);
		var cmds = config.flip ? _Utils_ap(
			(config.tickLength > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_ + tickOffsetX, y2_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_, y2_)
				]),
			_Utils_ap(
				config._break ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y1_),
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]),
				(config.tickLength > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_ + tickOffsetX, y1_ + tickOffsetY)
					]) : _List_Nil)) : _Utils_ap(
			(config.tickLength > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_ + tickOffsetX, y1_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_, y1_)
				]),
			_Utils_ap(
				config._break ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y2_),
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]),
				(config.tickLength > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_ + tickOffsetX, y2_ + tickOffsetY)
					]) : _List_Nil));
		return A4(
			$terezka$elm_charts$Internal$Svg$withAttrs,
			config.attrs,
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__line'),
					$elm$svg$Svg$Attributes$fill('transparent'),
					$elm$svg$Svg$Attributes$stroke(config.color),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(config.width)),
					$elm$svg$Svg$Attributes$strokeOpacity(
					$elm$core$String$fromFloat(config.opacity)),
					$elm$svg$Svg$Attributes$strokeDasharray(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, config.dashed))),
					$elm$svg$Svg$Attributes$d(
					A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
					config.hideOverflow ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
				]),
			_List_Nil);
	});
var $terezka$elm_charts$Internal$Svg$defaultLine = {x1: $elm$core$Maybe$Nothing, x2: $elm$core$Maybe$Nothing, y1: $elm$core$Maybe$Nothing, y2: $elm$core$Maybe$Nothing, flip: false, xOff: 0, yOff: 0, attrs: _List_Nil, _break: false, color: 'rgb(210, 210, 210)', width: 1, x2Svg: $elm$core$Maybe$Nothing, y2Svg: $elm$core$Maybe$Nothing, dashed: _List_Nil, opacity: 1, tickLength: 0, hideOverflow: false, tickDirection: -90};
var $terezka$elm_charts$Chart$Svg$line = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$line,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultLine));
	});
var $terezka$elm_charts$Chart$Attributes$size = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{size: v});
		});
};
var $terezka$elm_charts$Chart$Attributes$color = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return (v === '') ? config : _Utils_update(
				config,
				{color: v});
		});
};
var $terezka$elm_charts$Chart$Attributes$width = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{width: v});
		});
};
var $terezka$elm_charts$Internal$Svg$Circle = {$: 'Circle'};
var $terezka$elm_charts$Chart$Attributes$circle = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{
				shape: $elm$core$Maybe$Just($terezka$elm_charts$Internal$Svg$Circle)
			});
	});
var $terezka$elm_charts$Chart$Attributes$dashed = function (value) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{dashed: value});
		});
};
var $terezka$elm_charts$Internal$Helpers$darkGray = 'rgb(200 200 200)';
var $terezka$elm_charts$Chart$GridElement = function (a) {
	return {$: 'GridElement', a: a};
};
var $terezka$elm_charts$Chart$grid = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{color: '', width: 0, dashed: _List_Nil, dotGrid: false});
	var width = (!config.width) ? (config.dotGrid ? 0.5 : 1) : config.width;
	var color = $elm$core$String$isEmpty(config.color) ? (config.dotGrid ? $terezka$elm_charts$Internal$Helpers$darkGray : $terezka$elm_charts$Internal$Helpers$gray) : config.color;
	var toDot = F4(
		function (vs, p, x, y) {
			return (A2($elm$core$List$member, x, vs.xAxis) || A2($elm$core$List$member, y, vs.yAxis)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A5(
					$terezka$elm_charts$Chart$Svg$dot,
					p,
					function ($) {
						return $.x;
					},
					function ($) {
						return $.y;
					},
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$size(width),
							$terezka$elm_charts$Chart$Attributes$circle
						]),
					{x: x, y: y}));
		});
	var toXGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.xAxis) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$x1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.dashed)
						])));
		});
	var toYGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.yAxis) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$y1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.dashed)
						])));
		});
	return $terezka$elm_charts$Chart$GridElement(
		F2(
			function (p, vs) {
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__grid')
						]),
					config.dotGrid ? A2(
						$elm$core$List$concatMap,
						function (x) {
							return A2(
								$elm$core$List$filterMap,
								A3(toDot, vs, p, x),
								vs.ys);
						},
						vs.xs) : _List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__x-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toXGrid, vs, p),
								vs.xs)),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__y-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toYGrid, vs, p),
								vs.ys))
						]));
			}));
};
var $terezka$elm_charts$Internal$Events$map2 = F3(
	function (f, _v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return $terezka$elm_charts$Internal$Events$Decoder(
			F3(
				function (ps, s, p) {
					return A2(
						f,
						A3(a, ps, s, p),
						A3(b, ps, s, p));
				}));
	});
var $terezka$elm_charts$Chart$Events$map2 = $terezka$elm_charts$Internal$Events$map2;
var $terezka$elm_charts$Internal$Events$map3 = F4(
	function (f, _v0, _v1, _v2) {
		var a = _v0.a;
		var b = _v1.a;
		var c = _v2.a;
		return $terezka$elm_charts$Internal$Events$Decoder(
			F3(
				function (ps, s, p) {
					return A3(
						f,
						A3(a, ps, s, p),
						A3(b, ps, s, p),
						A3(c, ps, s, p));
				}));
	});
var $terezka$elm_charts$Chart$Events$map3 = $terezka$elm_charts$Internal$Events$map3;
var $terezka$elm_charts$Chart$HtmlElement = function (a) {
	return {$: 'HtmlElement', a: a};
};
var $terezka$elm_charts$Chart$none = $terezka$elm_charts$Chart$HtmlElement(
	F2(
		function (_v0, _v1) {
			return $elm$html$Html$text('');
		}));
var $terezka$elm_charts$Internal$Svg$rect = F2(
	function (plane, config) {
		var _v0 = function () {
			var _v3 = _Utils_Tuple2(
				_Utils_Tuple2(config.x1, config.x2),
				_Utils_Tuple2(config.y1, config.y2));
			_v3$11:
			while (true) {
				if (_v3.a.a.$ === 'Just') {
					if (_v3.a.b.$ === 'Nothing') {
						if (_v3.b.a.$ === 'Nothing') {
							if (_v3.b.b.$ === 'Nothing') {
								var _v8 = _v3.a;
								var a = _v8.a.a;
								var _v9 = _v8.b;
								var _v10 = _v3.b;
								var _v11 = _v10.a;
								var _v12 = _v10.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(a, a),
									_Utils_Tuple2(plane.y.min, plane.y.max));
							} else {
								break _v3$11;
							}
						} else {
							if (_v3.b.b.$ === 'Just') {
								var _v35 = _v3.a;
								var c = _v35.a.a;
								var _v36 = _v35.b;
								var _v37 = _v3.b;
								var a = _v37.a.a;
								var b = _v37.b.a;
								return _Utils_Tuple2(
									_Utils_Tuple2(c, c),
									_Utils_Tuple2(a, b));
							} else {
								break _v3$11;
							}
						}
					} else {
						if (_v3.b.a.$ === 'Nothing') {
							if (_v3.b.b.$ === 'Nothing') {
								var _v4 = _v3.a;
								var a = _v4.a.a;
								var b = _v4.b.a;
								var _v5 = _v3.b;
								var _v6 = _v5.a;
								var _v7 = _v5.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(a, b),
									_Utils_Tuple2(plane.y.min, plane.y.max));
							} else {
								var _v38 = _v3.a;
								var a = _v38.a.a;
								var b = _v38.b.a;
								var _v39 = _v3.b;
								var _v40 = _v39.a;
								var c = _v39.b.a;
								return _Utils_Tuple2(
									_Utils_Tuple2(a, b),
									_Utils_Tuple2(c, c));
							}
						} else {
							if (_v3.b.b.$ === 'Nothing') {
								var _v41 = _v3.a;
								var a = _v41.a.a;
								var b = _v41.b.a;
								var _v42 = _v3.b;
								var c = _v42.a.a;
								var _v43 = _v42.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(a, b),
									_Utils_Tuple2(c, c));
							} else {
								break _v3$11;
							}
						}
					}
				} else {
					if (_v3.a.b.$ === 'Just') {
						if (_v3.b.a.$ === 'Nothing') {
							if (_v3.b.b.$ === 'Nothing') {
								var _v13 = _v3.a;
								var _v14 = _v13.a;
								var b = _v13.b.a;
								var _v15 = _v3.b;
								var _v16 = _v15.a;
								var _v17 = _v15.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(b, b),
									_Utils_Tuple2(plane.y.min, plane.y.max));
							} else {
								break _v3$11;
							}
						} else {
							if (_v3.b.b.$ === 'Just') {
								var _v32 = _v3.a;
								var _v33 = _v32.a;
								var c = _v32.b.a;
								var _v34 = _v3.b;
								var a = _v34.a.a;
								var b = _v34.b.a;
								return _Utils_Tuple2(
									_Utils_Tuple2(c, c),
									_Utils_Tuple2(a, b));
							} else {
								break _v3$11;
							}
						}
					} else {
						if (_v3.b.a.$ === 'Just') {
							if (_v3.b.b.$ === 'Just') {
								var _v18 = _v3.a;
								var _v19 = _v18.a;
								var _v20 = _v18.b;
								var _v21 = _v3.b;
								var a = _v21.a.a;
								var b = _v21.b.a;
								return _Utils_Tuple2(
									_Utils_Tuple2(plane.x.min, plane.x.min),
									_Utils_Tuple2(a, b));
							} else {
								var _v22 = _v3.a;
								var _v23 = _v22.a;
								var _v24 = _v22.b;
								var _v25 = _v3.b;
								var a = _v25.a.a;
								var _v26 = _v25.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(plane.x.min, plane.x.max),
									_Utils_Tuple2(a, a));
							}
						} else {
							if (_v3.b.b.$ === 'Just') {
								var _v27 = _v3.a;
								var _v28 = _v27.a;
								var _v29 = _v27.b;
								var _v30 = _v3.b;
								var _v31 = _v30.a;
								var b = _v30.b.a;
								return _Utils_Tuple2(
									_Utils_Tuple2(plane.x.min, plane.x.max),
									_Utils_Tuple2(b, b));
							} else {
								var _v44 = _v3.a;
								var _v45 = _v44.a;
								var _v46 = _v44.b;
								var _v47 = _v3.b;
								var _v48 = _v47.a;
								var _v49 = _v47.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(plane.x.min, plane.x.max),
									_Utils_Tuple2(plane.y.min, plane.y.max));
							}
						}
					}
				}
			}
			return _Utils_Tuple2(
				_Utils_Tuple2(
					A2($elm$core$Maybe$withDefault, plane.x.min, config.x1),
					A2($elm$core$Maybe$withDefault, plane.x.max, config.x2)),
				_Utils_Tuple2(
					A2($elm$core$Maybe$withDefault, plane.y.min, config.y1),
					A2($elm$core$Maybe$withDefault, plane.y.max, config.y2)));
		}();
		var _v1 = _v0.a;
		var x1_ = _v1.a;
		var x2_ = _v1.b;
		var _v2 = _v0.b;
		var y1_ = _v2.a;
		var y2_ = _v2.b;
		var cmds = _List_fromArray(
			[
				A2($terezka$elm_charts$Internal$Commands$Move, x1_, y1_),
				A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_),
				A2($terezka$elm_charts$Internal$Commands$Line, x2_, y1_),
				A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_),
				A2($terezka$elm_charts$Internal$Commands$Line, x1_, y2_),
				A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
			]);
		return A4(
			$terezka$elm_charts$Internal$Svg$withAttrs,
			config.attrs,
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__rect'),
					$elm$svg$Svg$Attributes$fill(config.color),
					$elm$svg$Svg$Attributes$fillOpacity(
					$elm$core$String$fromFloat(config.opacity)),
					$elm$svg$Svg$Attributes$stroke(config.border),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(config.borderWidth)),
					$elm$svg$Svg$Attributes$d(
					A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
					config.hideOverflow ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
				]),
			_List_Nil);
	});
var $terezka$elm_charts$Internal$Svg$defaultRect = {x1: $elm$core$Maybe$Nothing, x2: $elm$core$Maybe$Nothing, y1: $elm$core$Maybe$Nothing, y2: $elm$core$Maybe$Nothing, attrs: _List_Nil, color: 'rgba(210, 210, 210, 0.5)', border: 'rgba(210, 210, 210, 1)', opacity: 1, borderWidth: 1, hideOverflow: false};
var $terezka$elm_charts$Chart$Svg$rect = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$rect,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultRect));
	});
var $terezka$elm_charts$Internal$Svg$Event = F2(
	function (name, handler) {
		return {name: name, handler: handler};
	});
var $terezka$elm_charts$Chart$getItems = F2(
	function (plane, elements) {
		var toItems = F2(
			function (el, acc) {
				switch (el.$) {
					case 'Indexed':
						return acc;
					case 'SeriesElement':
						var items = el.b;
						return _Utils_ap(acc, items);
					case 'BarsElement':
						var items = el.b;
						return _Utils_ap(acc, items);
					case 'CustomElement':
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[item]));
					case 'AxisElement':
						var func = el.a;
						return acc;
					case 'TicksElement':
						return acc;
					case 'TickElement':
						return acc;
					case 'LabelsElement':
						return acc;
					case 'LabelElement':
						return acc;
					case 'GridElement':
						return acc;
					case 'SubElements':
						return acc;
					case 'ListOfElements':
						var subs = el.a;
						return A3($elm$core$List$foldl, toItems, acc, subs);
					case 'SvgElement':
						return acc;
					default:
						return acc;
				}
			});
		return A3($elm$core$List$foldl, toItems, _List_Nil, elements);
	});
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $K_Adam$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $terezka$elm_charts$Internal$Coordinates$toCartesianX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, value - plane.x.marginMin) + plane.x.min;
	});
var $terezka$elm_charts$Internal$Coordinates$toCartesianY = F2(
	function (plane, value) {
		return ($terezka$elm_charts$Internal$Coordinates$range(plane.y) - A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, value - plane.y.marginMin)) + plane.y.min;
	});
var $terezka$elm_charts$Internal$Svg$fromSvg = F2(
	function (plane, point) {
		return {
			x: A2($terezka$elm_charts$Internal$Coordinates$toCartesianX, plane, point.x),
			y: A2($terezka$elm_charts$Internal$Coordinates$toCartesianY, plane, point.y)
		};
	});
var $K_Adam$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
var $K_Adam$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $K_Adam$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$K_Adam$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($K_Adam$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$K_Adam$elm_dom$DOM$scrollLeft,
				$K_Adam$elm_dom$DOM$scrollTop,
				$K_Adam$elm_dom$DOM$offsetLeft,
				$K_Adam$elm_dom$DOM$offsetTop));
	});
var $K_Adam$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {top: y, left: x, width: width, height: height};
		}),
	A2($K_Adam$elm_dom$DOM$position, 0, 0),
	$K_Adam$elm_dom$DOM$offsetWidth,
	$K_Adam$elm_dom$DOM$offsetHeight);
function $terezka$elm_charts$Internal$Svg$cyclic$decodePosition() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$K_Adam$elm_dom$DOM$boundingClientRect,
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $K_Adam$elm_dom$DOM$parentElement(
						$terezka$elm_charts$Internal$Svg$cyclic$decodePosition());
				})
			]));
}
try {
	var $terezka$elm_charts$Internal$Svg$decodePosition = $terezka$elm_charts$Internal$Svg$cyclic$decodePosition();
	$terezka$elm_charts$Internal$Svg$cyclic$decodePosition = function () {
		return $terezka$elm_charts$Internal$Svg$decodePosition;
	};
} catch ($) {
	throw 'Some top-level definitions from `Internal.Svg` are causing infinite recursion:\n\n  ┌─────┐\n  │    decodePosition\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $terezka$elm_charts$Internal$Svg$decoder = F2(
	function (plane, toMsg) {
		var handle = F3(
			function (mouseX, mouseY, box) {
				var heightPercent = box.height / plane.y.length;
				var widthPercent = box.width / plane.x.length;
				var yPrev = plane.y;
				var xPrev = plane.x;
				var newPlane = _Utils_update(
					plane,
					{
						x: _Utils_update(
							xPrev,
							{length: box.width, marginMax: plane.x.marginMax * widthPercent, marginMin: plane.x.marginMin * widthPercent}),
						y: _Utils_update(
							yPrev,
							{length: box.height, marginMax: plane.y.marginMax * heightPercent, marginMin: plane.y.marginMin * heightPercent})
					});
				var searched = A2(
					$terezka$elm_charts$Internal$Svg$fromSvg,
					newPlane,
					{x: mouseX - box.left, y: mouseY - box.top});
				return A2(toMsg, newPlane, searched);
			});
		return A4(
			$elm$json$Json$Decode$map3,
			handle,
			A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float),
			$K_Adam$elm_dom$DOM$target($terezka$elm_charts$Internal$Svg$decodePosition));
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $terezka$elm_charts$Internal$Svg$container = F5(
	function (plane, config, below, chartEls, above) {
		var htmlAttrsSize = config.responsive ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(plane.x.length) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromFloat(plane.y.length) + 'px')
			]);
		var chartPosition = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(plane.x.marginMin)),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(plane.y.marginMin)),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerWidth(plane))),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerHeight(plane))),
				$elm$svg$Svg$Attributes$fill('transparent')
			]);
		var svgAttrsSize = config.responsive ? _List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox(
				'0 0 ' + ($elm$core$String$fromFloat(plane.x.length) + (' ' + $elm$core$String$fromFloat(plane.y.length)))),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]) : _List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(plane.x.length)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(plane.y.length)),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]);
		var htmlAttrsDef = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('elm-charts__container-inner')
			]);
		var clipPathDefs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(
							$terezka$elm_charts$Internal$Coordinates$toId(plane))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$rect, chartPosition, _List_Nil)
						]))
				]));
		var htmlAttrs = _Utils_ap(
			config.htmlAttrs,
			_Utils_ap(htmlAttrsDef, htmlAttrsSize));
		var toEvent = function (event) {
			return A2(
				$elm$svg$Svg$Events$on,
				event.name,
				A2($terezka$elm_charts$Internal$Svg$decoder, plane, event.handler));
		};
		var catcher = A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				chartPosition,
				A2($elm$core$List$map, toEvent, config.events)),
			_List_Nil);
		var chart = A2(
			$elm$svg$Svg$svg,
			_Utils_ap(svgAttrsSize, config.attrs),
			_Utils_ap(
				_List_fromArray(
					[clipPathDefs]),
				_Utils_ap(
					chartEls,
					_List_fromArray(
						[catcher]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-charts__container'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					htmlAttrs,
					_Utils_ap(
						below,
						_Utils_ap(
							_List_fromArray(
								[chart]),
							above)))
				]));
	});
var $terezka$elm_charts$Chart$getLegends = function (elements) {
	var toLegends = F2(
		function (el, acc) {
			switch (el.$) {
				case 'Indexed':
					return acc;
				case 'SeriesElement':
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 'BarsElement':
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 'CustomElement':
					return acc;
				case 'AxisElement':
					return acc;
				case 'TicksElement':
					return acc;
				case 'TickElement':
					return acc;
				case 'LabelsElement':
					return acc;
				case 'LabelElement':
					return acc;
				case 'GridElement':
					return acc;
				case 'SubElements':
					return acc;
				case 'ListOfElements':
					var subs = el.a;
					return A3($elm$core$List$foldl, toLegends, acc, subs);
				case 'SvgElement':
					return acc;
				default:
					return acc;
			}
		});
	return A3($elm$core$List$foldl, toLegends, _List_Nil, elements);
};
var $terezka$elm_charts$Chart$Attributes$lowest = F2(
	function (v, edit) {
		return $terezka$elm_charts$Internal$Helpers$Attribute(
			function (b) {
				return _Utils_update(
					b,
					{
						min: A3(edit, v, b.min, b.dataMin)
					});
			});
	});
var $terezka$elm_charts$Chart$Attributes$orLower = F3(
	function (least, real, _v0) {
		return (_Utils_cmp(real, least) > 0) ? least : real;
	});
var $terezka$elm_charts$Internal$Item$getLimits = function (_v0) {
	var item = _v0.b;
	return item.limits;
};
var $terezka$elm_charts$Internal$Coordinates$Position = F4(
	function (x1, x2, y1, y2) {
		return {x1: x1, x2: x2, y1: y1, y2: y2};
	});
var $terezka$elm_charts$Internal$Coordinates$foldPosition = F2(
	function (func, data) {
		var fold = F2(
			function (datum, posM) {
				if (posM.$ === 'Just') {
					var pos = posM.a;
					return $elm$core$Maybe$Just(
						{
							x1: A2(
								$elm$core$Basics$min,
								func(datum).x1,
								pos.x1),
							x2: A2(
								$elm$core$Basics$max,
								func(datum).x2,
								pos.x2),
							y1: A2(
								$elm$core$Basics$min,
								func(datum).y1,
								pos.y1),
							y2: A2(
								$elm$core$Basics$max,
								func(datum).y2,
								pos.y2)
						});
				} else {
					return $elm$core$Maybe$Just(
						func(datum));
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			A4($terezka$elm_charts$Internal$Coordinates$Position, 0, 0, 0, 0),
			A3($elm$core$List$foldl, fold, $elm$core$Maybe$Nothing, data));
	});
var $terezka$elm_charts$Chart$definePlane = F2(
	function (config, elements) {
		var collectLimits = F2(
			function (el, acc) {
				switch (el.$) {
					case 'Indexed':
						return acc;
					case 'SeriesElement':
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 'BarsElement':
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 'CustomElement':
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[
									$terezka$elm_charts$Internal$Item$getLimits(item)
								]));
					case 'AxisElement':
						return acc;
					case 'TicksElement':
						return acc;
					case 'TickElement':
						return acc;
					case 'LabelsElement':
						return acc;
					case 'LabelElement':
						return acc;
					case 'GridElement':
						return acc;
					case 'SubElements':
						return acc;
					case 'ListOfElements':
						var subs = el.a;
						return A3($elm$core$List$foldl, collectLimits, acc, subs);
					case 'SvgElement':
						return acc;
					default:
						return acc;
				}
			});
		var fixSingles = function (bs) {
			return _Utils_eq(bs.min, bs.max) ? _Utils_update(
				bs,
				{max: bs.min + 10}) : bs;
		};
		var toLimit = F5(
			function (length, marginMin, marginMax, min, max) {
				return {max: max, min: min, length: length, dataMax: max, dataMin: min, marginMax: marginMax, marginMin: marginMin};
			});
		var height = A2($elm$core$Basics$max, 1, (config.height - config.padding.bottom) - config.padding.top);
		var width = A2($elm$core$Basics$max, 1, (config.width - config.padding.left) - config.padding.right);
		var limits_ = function (pos) {
			return function (_v3) {
				var y = _v3.y;
				var x = _v3.x;
				return {
					x: fixSingles(x),
					y: fixSingles(y)
				};
			}(
				{
					x: A5(toLimit, width, config.margin.left, config.margin.right, pos.x1, pos.x2),
					y: A5(toLimit, height, config.margin.top, config.margin.bottom, pos.y1, pos.y2)
				});
		}(
			A2(
				$terezka$elm_charts$Internal$Coordinates$foldPosition,
				$elm$core$Basics$identity,
				A3($elm$core$List$foldl, collectLimits, _List_Nil, elements)));
		var calcRange = function () {
			var _v2 = config.range;
			if (!_v2.b) {
				return limits_.x;
			} else {
				var some = _v2;
				return A2($terezka$elm_charts$Internal$Helpers$apply, some, limits_.x);
			}
		}();
		var calcDomain = function () {
			var _v1 = config.domain;
			if (!_v1.b) {
				return A2(
					$terezka$elm_charts$Internal$Helpers$apply,
					_List_fromArray(
						[
							A2($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$orLower)
						]),
					limits_.y);
			} else {
				var some = _v1;
				return A2($terezka$elm_charts$Internal$Helpers$apply, some, limits_.y);
			}
		}();
		var unpadded = {x: calcRange, y: calcDomain};
		var scalePadX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX(unpadded);
		var scalePadY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY(unpadded);
		var yMin = calcDomain.min - scalePadY(config.padding.bottom);
		var yMax = calcDomain.max + scalePadY(config.padding.top);
		var xMin = calcRange.min - scalePadX(config.padding.left);
		var xMax = calcRange.max + scalePadX(config.padding.right);
		return {
			x: _Utils_update(
				calcRange,
				{
					max: A2($elm$core$Basics$max, xMin, xMax),
					min: A2($elm$core$Basics$min, xMin, xMax),
					length: config.width
				}),
			y: _Utils_update(
				calcDomain,
				{
					max: A2($elm$core$Basics$max, yMin, yMax),
					min: A2($elm$core$Basics$min, yMin, yMax),
					length: config.height
				})
		};
	});
var $terezka$elm_charts$Chart$viewElements = F6(
	function (config, plane, tickValues, allItems, allLegends, elements) {
		var viewOne = F2(
			function (el, _v0) {
				var before = _v0.a;
				var chart_ = _v0.b;
				var after = _v0.c;
				switch (el.$) {
					case 'Indexed':
						return _Utils_Tuple3(before, chart_, after);
					case 'SeriesElement':
						var view = el.d;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 'BarsElement':
						var view = el.e;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 'CustomElement':
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 'AxisElement':
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 'TicksElement':
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 'TickElement':
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 'LabelsElement':
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 'LabelElement':
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 'GridElement':
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(view, plane, tickValues),
								chart_),
							after);
					case 'SubElements':
						var func = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							A2(func, plane, allItems));
					case 'ListOfElements':
						var els = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							els);
					case 'SvgElement':
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					default:
						var view = el.a;
						return _Utils_Tuple3(
							($elm$core$List$length(chart_) > 0) ? A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								before) : before,
							chart_,
							($elm$core$List$length(chart_) > 0) ? after : A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								after));
				}
			});
		return A3(
			$elm$core$List$foldr,
			viewOne,
			_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$TickValues = F4(
	function (xAxis, yAxis, xs, ys) {
		return {xs: xs, ys: ys, xAxis: xAxis, yAxis: yAxis};
	});
var $terezka$elm_charts$Chart$getTickValues = F3(
	function (plane, items, elements) {
		var toValues = F2(
			function (el, acc) {
				switch (el.$) {
					case 'Indexed':
						return acc;
					case 'SeriesElement':
						return acc;
					case 'BarsElement':
						var func = el.d;
						return A2(func, plane, acc);
					case 'CustomElement':
						return acc;
					case 'AxisElement':
						var func = el.a;
						return A2(func, plane, acc);
					case 'TicksElement':
						var func = el.a;
						return A2(func, plane, acc);
					case 'TickElement':
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 'LabelsElement':
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 'LabelElement':
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 'SubElements':
						var func = el.a;
						return A3(
							$elm$core$List$foldl,
							toValues,
							acc,
							A2(func, plane, items));
					case 'GridElement':
						return acc;
					case 'ListOfElements':
						var subs = el.a;
						return A3($elm$core$List$foldl, toValues, acc, subs);
					case 'SvgElement':
						return acc;
					default:
						return acc;
				}
			});
		return A3(
			$elm$core$List$foldl,
			toValues,
			A4($terezka$elm_charts$Chart$TickValues, _List_Nil, _List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$chart = F2(
	function (edits, unindexedElements) {
		var indexedElements = function () {
			var toIndexedEl = F2(
				function (el, _v4) {
					var acc = _v4.a;
					var index = _v4.b;
					switch (el.$) {
						case 'Indexed':
							var toElAndIndex = el.a;
							var _v6 = toElAndIndex(index);
							var newEl = _v6.a;
							var newIndex = _v6.b;
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[newEl])),
								newIndex);
						case 'ListOfElements':
							var els = el.a;
							return A3(
								$elm$core$List$foldl,
								toIndexedEl,
								_Utils_Tuple2(acc, index),
								els);
						default:
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[el])),
								index);
					}
				});
			return A3(
				$elm$core$List$foldl,
				toIndexedEl,
				_Utils_Tuple2(_List_Nil, 0),
				unindexedElements).a;
		}();
		var elements = function () {
			var isGrid = function (el) {
				if (el.$ === 'GridElement') {
					return true;
				} else {
					return false;
				}
			};
			return A2($elm$core$List$any, isGrid, indexedElements) ? indexedElements : A2(
				$elm$core$List$cons,
				$terezka$elm_charts$Chart$grid(_List_Nil),
				indexedElements);
		}();
		var legends_ = $terezka$elm_charts$Chart$getLegends(elements);
		var config = A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{
				attrs: _List_fromArray(
					[
						$elm$svg$Svg$Attributes$style('overflow: visible;')
					]),
				range: _List_Nil,
				width: 300,
				domain: _List_Nil,
				events: _List_Nil,
				height: 300,
				margin: {top: 0, left: 0, right: 0, bottom: 0},
				padding: {top: 0, left: 0, right: 0, bottom: 0},
				htmlAttrs: _List_Nil,
				responsive: true
			});
		var plane = A2($terezka$elm_charts$Chart$definePlane, config, elements);
		var items = A2($terezka$elm_charts$Chart$getItems, plane, elements);
		var toEvent = function (_v2) {
			var event_ = _v2.a;
			var _v1 = event_.decoder;
			var decoder = _v1.a;
			return A2(
				$terezka$elm_charts$Internal$Svg$Event,
				event_.name,
				decoder(items));
		};
		var tickValues = A3($terezka$elm_charts$Chart$getTickValues, plane, items, elements);
		var _v0 = A6($terezka$elm_charts$Chart$viewElements, config, plane, tickValues, items, legends_, elements);
		var beforeEls = _v0.a;
		var chartEls = _v0.b;
		var afterEls = _v0.c;
		return A5(
			$terezka$elm_charts$Internal$Svg$container,
			plane,
			{
				attrs: config.attrs,
				events: A2($elm$core$List$map, toEvent, config.events),
				htmlAttrs: config.htmlAttrs,
				responsive: config.responsive
			},
			beforeEls,
			chartEls,
			afterEls);
	});
var $terezka$elm_charts$Internal$Svg$Top = {$: 'Top'};
var $terezka$elm_charts$Chart$Attributes$onTop = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{
				direction: $elm$core$Maybe$Just($terezka$elm_charts$Internal$Svg$Top)
			});
	});
var $terezka$elm_charts$Chart$Attributes$range = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{range: v});
		});
};
var $author$project$Data$Log$split = function (description) {
	var prefixes = _List_fromArray(
		['Low Battery recorded ', 'Exceeded speed limit ', 'Departed ', 'Exited restricted zone ', 'Arrived ', 'Entered restricted zone ', 'Passed ', 'High G event detected', 'High water detected', 'Movement detected']);
	var prefix = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (p) {
					return A2($elm$core$String$startsWith, p, description);
				},
				prefixes)));
	var detail = A2(
		$elm$core$String$dropLeft,
		$elm$core$String$length(prefix),
		description);
	return _Utils_Tuple2(prefix, detail);
};
var $terezka$elm_charts$Internal$Svg$Times = function (a) {
	return {$: 'Times', a: a};
};
var $terezka$elm_charts$Chart$Attributes$times = function (zone) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{
					generate: $terezka$elm_charts$Internal$Svg$Times(zone)
				});
		});
};
var $terezka$elm_charts$Chart$Attributes$amount = function (value) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{amount: value});
		});
};
var $terezka$elm_charts$Chart$Attributes$border = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{border: v});
		});
};
var $terezka$elm_charts$Internal$Coordinates$pointToPosition = function (point) {
	return {x1: point.x, x2: point.x, y1: point.y, y2: point.y};
};
var $terezka$elm_charts$Chart$Attributes$center = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{
				focal: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, $terezka$elm_charts$Internal$Coordinates$center, $terezka$elm_charts$Internal$Coordinates$pointToPosition))
			});
	});
var $terezka$elm_charts$Chart$Attributes$domain = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{domain: v});
		});
};
var $terezka$elm_charts$Chart$Attributes$height = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{height: v});
		});
};
var $terezka$elm_charts$Internal$Svg$positionHtml = F7(
	function (plane, x, y, xOff, yOff, attrs, content) {
		var yPercentage = ((A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y) - yOff) * 100) / plane.y.length;
		var xPercentage = ((A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x) + xOff) * 100) / plane.x.length;
		var posititonStyles = _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromFloat(xPercentage) + '%'),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				$elm$core$String$fromFloat(yPercentage) + '%'),
				A2($elm$html$Html$Attributes$style, 'margin-right', '-400px'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute')
			]);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(posititonStyles, attrs),
			content);
	});
var $terezka$elm_charts$Chart$Svg$positionHtml = $terezka$elm_charts$Internal$Svg$positionHtml;
var $terezka$elm_charts$Chart$htmlAt = F6(
	function (toX, toY, xOff, yOff, att, view) {
		return $terezka$elm_charts$Chart$HtmlElement(
			F2(
				function (p, _v0) {
					return A7(
						$terezka$elm_charts$Chart$Svg$positionHtml,
						p,
						toX(p.x),
						toY(p.y),
						xOff,
						yOff,
						att,
						view);
				}));
	});
var $terezka$elm_charts$Chart$Attributes$margin = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{margin: v});
		});
};
var $terezka$elm_charts$Chart$Attributes$moveUp = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{yOff: config.yOff - v});
		});
};
var $terezka$elm_charts$Chart$Attributes$offset = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{offset: v});
		});
};
var $terezka$elm_charts$Internal$Svg$Left = {$: 'Left'};
var $terezka$elm_charts$Chart$Attributes$onLeft = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{
				direction: $elm$core$Maybe$Just($terezka$elm_charts$Internal$Svg$Left)
			});
	});
var $author$project$Views$ActivityChart$Hovered = F3(
	function (point, bar, dot) {
		return {bar: bar, dot: dot, point: point};
	});
var $author$project$Views$ActivityChart$OnHover = function (a) {
	return {$: 'OnHover', a: a};
};
var $terezka$elm_charts$Internal$Item$map = F2(
	function (func, _v0) {
		var meta = _v0.a;
		var item = _v0.b;
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			{
				y: meta.y,
				x1: meta.x1,
				x2: meta.x2,
				name: meta.name,
				color: meta.color,
				datum: func(meta.datum),
				toAny: meta.toAny,
				isReal: meta.isReal,
				tooltipText: meta.tooltipText,
				presentation: meta.presentation,
				identification: meta.identification
			},
			item);
	});
var $terezka$elm_charts$Internal$Item$getX1 = function (_v0) {
	var meta = _v0.a;
	return meta.x1;
};
var $terezka$elm_charts$Internal$Item$getX2 = function (_v0) {
	var meta = _v0.a;
	return meta.x2;
};
var $terezka$elm_charts$Internal$Many$editLimits = F2(
	function (edit, _v0) {
		var _v1 = _v0.a;
		var x = _v1.a;
		var xs = _v1.b;
		var rendering = _v0.b;
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			_Utils_Tuple2(x, xs),
			_Utils_update(
				rendering,
				{
					limits: A2(edit, x, rendering.limits)
				}));
	});
var $terezka$elm_charts$Internal$Item$render = F2(
	function (plane, _v0) {
		var item = _v0.b;
		return A2(
			item.render,
			plane,
			item.toPosition(plane));
	});
var $terezka$elm_charts$Internal$Item$tooltip = function (_v0) {
	var item = _v0.b;
	return item.tooltip(_Utils_Tuple0);
};
var $terezka$elm_charts$Internal$Many$toGroup = F2(
	function (first, rest) {
		var all = A2($elm$core$List$cons, first, rest);
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			_Utils_Tuple2(first, rest),
			{
				limits: A2($terezka$elm_charts$Internal$Coordinates$foldPosition, $terezka$elm_charts$Internal$Item$getLimits, all),
				render: F2(
					function (plane, _v0) {
						return A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__group')
								]),
							A2(
								$elm$core$List$map,
								$terezka$elm_charts$Internal$Item$render(plane),
								all));
					}),
				tooltip: function (c) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_Nil,
							A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Item$tooltip, all))
						]);
				},
				toPosition: function (plane) {
					return A2(
						$terezka$elm_charts$Internal$Coordinates$foldPosition,
						$terezka$elm_charts$Internal$Item$getPosition(plane),
						all);
				}
			});
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $terezka$elm_charts$Internal$Helpers$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = A2(
						$elm$core$List$partition,
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					return A2(
						helper,
						remaining,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered));
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $terezka$elm_charts$Internal$Many$groupingHelp = F2(
	function (_v0, items) {
		var edits = _v0.edits;
		var equality = _v0.equality;
		var shared = _v0.shared;
		var toNewGroup = function (_v2) {
			var i = _v2.a;
			var is = _v2.b;
			return edits(
				A2($terezka$elm_charts$Internal$Many$toGroup, i, is));
		};
		var toShared = function (_v1) {
			var meta = _v1.a;
			var item = _v1.b;
			return shared(meta);
		};
		var toEquality = F2(
			function (aO, bO) {
				return A2(
					equality,
					toShared(aO),
					toShared(bO));
			});
		return A2(
			$elm$core$List$map,
			toNewGroup,
			A2($terezka$elm_charts$Internal$Helpers$gatherWith, toEquality, items));
	});
var $terezka$elm_charts$Internal$Many$bins = A2(
	$terezka$elm_charts$Internal$Many$Remodel,
	$terezka$elm_charts$Internal$Item$getPosition,
	$terezka$elm_charts$Internal$Many$groupingHelp(
		{
			edits: $terezka$elm_charts$Internal$Many$editLimits(
				F2(
					function (item, pos) {
						return _Utils_update(
							pos,
							{
								x1: $terezka$elm_charts$Internal$Item$getX1(item),
								x2: $terezka$elm_charts$Internal$Item$getX2(item)
							});
					})),
			shared: function (config) {
				return {x1: config.x1, x2: config.x2, elIndex: config.identification.elementIndex, dataIndex: config.identification.dataIndex};
			},
			equality: F2(
				function (a, b) {
					return _Utils_eq(a.x1, b.x1) && (_Utils_eq(a.x2, b.x2) && (_Utils_eq(a.elIndex, b.elIndex) && _Utils_eq(a.dataIndex, b.dataIndex)));
				})
		}));
var $terezka$elm_charts$Chart$Item$bins = $terezka$elm_charts$Internal$Many$bins;
var $terezka$elm_charts$Internal$Many$apply = F2(
	function (_v0, items) {
		var func = _v0.b;
		return func(items);
	});
var $terezka$elm_charts$Chart$Item$apply = $terezka$elm_charts$Internal$Many$apply;
var $terezka$elm_charts$Chart$Indexed = function (a) {
	return {$: 'Indexed', a: a};
};
var $terezka$elm_charts$Chart$Item$getLimits = $terezka$elm_charts$Internal$Item$getLimits;
var $terezka$elm_charts$Internal$Item$generalize = function (_v0) {
	var meta = _v0.a;
	var item = _v0.b;
	return A2(
		$terezka$elm_charts$Internal$Item$Rendered,
		{
			y: meta.y,
			x1: meta.x1,
			x2: meta.x2,
			name: meta.name,
			color: meta.color,
			datum: meta.datum,
			toAny: $elm$core$Basics$identity,
			isReal: meta.isReal,
			tooltipText: meta.tooltipText,
			presentation: meta.toAny(meta.presentation),
			identification: meta.identification
		},
		item);
};
var $terezka$elm_charts$Internal$Many$getMembers = function (_v0) {
	var _v1 = _v0.a;
	var x = _v1.a;
	var xs = _v1.b;
	return A2($elm$core$List$cons, x, xs);
};
var $terezka$elm_charts$Internal$Many$generalize = function (many) {
	return A2(
		$elm$core$List$map,
		$terezka$elm_charts$Internal$Item$generalize,
		$terezka$elm_charts$Internal$Many$getMembers(many));
};
var $terezka$elm_charts$Chart$BarsElement = F5(
	function (a, b, c, d, e) {
		return {$: 'BarsElement', a: a, b: b, c: c, d: d, e: e};
	});
var $terezka$elm_charts$Internal$Produce$defaultBars = {x1: $elm$core$Maybe$Nothing, x2: $elm$core$Maybe$Nothing, grid: false, margin: 0.1, grouped: true, spacing: 0.05, roundTop: 0, roundBottom: 0};
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$pattern = $elm$svg$Svg$trustedNode('pattern');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$patternUnits = _VirtualDom_attribute('patternUnits');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$patternTransform = _VirtualDom_attribute('patternTransform');
var $terezka$elm_charts$Internal$Svg$toPattern = F2(
	function (defaultColor, design) {
		var toPatternDefs = F4(
			function (id, spacing, rotate, inside) {
				return A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$pattern,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(id),
									$elm$svg$Svg$Attributes$patternUnits('userSpaceOnUse'),
									$elm$svg$Svg$Attributes$width(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$height(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$patternTransform(
									'rotate(' + ($elm$core$String$fromFloat(rotate) + ')'))
								]),
							_List_fromArray(
								[inside]))
						]));
			});
		var toPatternId = function (props) {
			return A3(
				$elm$core$String$replace,
				'(',
				'-',
				A3(
					$elm$core$String$replace,
					')',
					'-',
					A3(
						$elm$core$String$replace,
						'.',
						'-',
						A3(
							$elm$core$String$replace,
							',',
							'-',
							A3(
								$elm$core$String$replace,
								' ',
								'-',
								A2(
									$elm$core$String$join,
									'-',
									_Utils_ap(
										_List_fromArray(
											[
												'elm-charts__pattern',
												function () {
												switch (design.$) {
													case 'Striped':
														return 'striped';
													case 'Dotted':
														return 'dotted';
													default:
														return 'gradient';
												}
											}()
											]),
										props)))))));
		};
		var _v0 = function () {
			switch (design.$) {
				case 'Striped':
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Helpers$apply,
						edits,
						{color: defaultColor, width: 3, rotate: 45, spacing: 4});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.color,
								$elm$core$String$fromFloat(config.width),
								$elm$core$String$fromFloat(config.spacing),
								$elm$core$String$fromFloat(config.rotate)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.spacing,
							config.rotate,
							A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x1('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$x2('0'),
										$elm$svg$Svg$Attributes$y2(
										$elm$core$String$fromFloat(config.spacing)),
										$elm$svg$Svg$Attributes$stroke(config.color),
										$elm$svg$Svg$Attributes$strokeWidth(
										$elm$core$String$fromFloat(config.width))
									]),
								_List_Nil)),
						theId);
				case 'Dotted':
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Helpers$apply,
						edits,
						{color: defaultColor, width: 3, rotate: 45, spacing: 4});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.color,
								$elm$core$String$fromFloat(config.width),
								$elm$core$String$fromFloat(config.spacing),
								$elm$core$String$fromFloat(config.rotate)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.spacing,
							config.rotate,
							A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill(config.color),
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(config.width / 3)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(config.width / 3)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(config.width / 3))
									]),
								_List_Nil)),
						theId);
				default:
					var edits = design.a;
					var colors = _Utils_eq(edits, _List_Nil) ? _List_fromArray(
						[defaultColor, 'white']) : edits;
					var totalColors = $elm$core$List$length(colors);
					var toPercentage = function (i) {
						return (i * 100) / (totalColors - 1);
					};
					var toStop = F2(
						function (i, c) {
							return A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$offset(
										$elm$core$String$fromFloat(
											toPercentage(i)) + '%'),
										$elm$svg$Svg$Attributes$stopColor(c)
									]),
								_List_Nil);
						});
					var theId = toPatternId(colors);
					return _Utils_Tuple2(
						A2(
							$elm$svg$Svg$defs,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$linearGradient,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id(theId),
											$elm$svg$Svg$Attributes$x1('0'),
											$elm$svg$Svg$Attributes$x2('0'),
											$elm$svg$Svg$Attributes$y1('0'),
											$elm$svg$Svg$Attributes$y2('1')
										]),
									A2($elm$core$List$indexedMap, toStop, colors))
								])),
						theId);
			}
		}();
		var patternDefs = _v0.a;
		var patternId = _v0.b;
		return _Utils_Tuple2(patternDefs, 'url(#' + (patternId + ')'));
	});
var $terezka$elm_charts$Internal$Svg$bar = F3(
	function (plane, config, point) {
		var borderWidthCarY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, config.borderWidth / 2);
		var highlightWidthCarY = borderWidthCarY + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, config.highlightWidth / 2);
		var borderWidthCarX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, config.borderWidth / 2);
		var highlightWidthCarX = borderWidthCarX + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, config.highlightWidth / 2);
		var highlightColor = (config.highlightColor === '') ? config.color : config.highlightColor;
		var viewBar = F6(
			function (fill, fillOpacity, border, borderWidth, strokeOpacity, cmds) {
				return A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.attrs,
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__bar'),
							$elm$svg$Svg$Attributes$fill(fill),
							$elm$svg$Svg$Attributes$fillOpacity(
							$elm$core$String$fromFloat(fillOpacity)),
							$elm$svg$Svg$Attributes$stroke(border),
							$elm$svg$Svg$Attributes$strokeWidth(
							$elm$core$String$fromFloat(borderWidth)),
							$elm$svg$Svg$Attributes$strokeOpacity(
							$elm$core$String$fromFloat(strokeOpacity)),
							$elm$svg$Svg$Attributes$d(
							A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_Nil);
			});
		var pos = {
			x1: A2($elm$core$Basics$min, point.x1, point.x2) + borderWidthCarX,
			x2: A2($elm$core$Basics$max, point.x1, point.x2) - borderWidthCarX,
			y1: A2($elm$core$Basics$min, point.y1, point.y2) + borderWidthCarY,
			y2: A2($elm$core$Basics$max, point.y1, point.y2) - borderWidthCarY
		};
		var width = $elm$core$Basics$abs(pos.x2 - pos.x1);
		var roundingTop = (A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, width) * 0.5) * A3($elm$core$Basics$clamp, 0, 1, config.roundTop);
		var radiusTopX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, roundingTop);
		var radiusTopY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, roundingTop);
		var roundingBottom = (A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, width) * 0.5) * A3($elm$core$Basics$clamp, 0, 1, config.roundBottom);
		var radiusBottomX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, roundingBottom);
		var radiusBottomY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, roundingBottom);
		var height = $elm$core$Basics$abs(pos.y2 - pos.y1);
		var _v0 = ((((height - (radiusTopY * 0.8)) - (radiusBottomY * 0.8)) <= 0) || (((width - (radiusTopX * 0.8)) - (radiusBottomX * 0.8)) <= 0)) ? _Utils_Tuple2(0, 0) : _Utils_Tuple2(config.roundTop, config.roundBottom);
		var roundTop = _v0.a;
		var roundBottom = _v0.b;
		var highlightPos = {x1: pos.x1 - highlightWidthCarX, x2: pos.x2 + highlightWidthCarX, y1: pos.y1 - highlightWidthCarY, y2: pos.y2 + highlightWidthCarY};
		var _v1 = function () {
			if (_Utils_eq(pos.y1, pos.y2)) {
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			} else {
				var _v2 = _Utils_Tuple2(roundTop > 0, roundBottom > 0);
				if (!_v2.a) {
					if (!_v2.b) {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.x1, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y1)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.x1, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x1, highlightPos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2, highlightPos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y1)
								]));
					} else {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.x1 + radiusBottomX, pos.y1),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.x1, pos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1 + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.x2 - radiusBottomX, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1 + radiusBottomX, pos.y1)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.x1 + radiusBottomX, highlightPos.y1),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.x1, highlightPos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x1, highlightPos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2, highlightPos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2, highlightPos.y1 + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.x2 - radiusBottomX, highlightPos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x1 + radiusBottomX, highlightPos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2 - radiusBottomX, pos.y1),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, false, pos.x2, pos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1)
								]));
					}
				} else {
					if (!_v2.b) {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.x1, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y2 - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.x1 + radiusTopX, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2 - radiusTopX, pos.y2),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.x2, pos.y2 - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y1)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.x1, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x1, highlightPos.y2 - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.x1 + radiusTopX, highlightPos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2 - radiusTopX, highlightPos.y2),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.x2, highlightPos.y2 - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y2 - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.x2 - radiusTopX, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1 + radiusTopX, pos.y2),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.x1, pos.y2 - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y1)
								]));
					} else {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.x1 + radiusBottomX, pos.y1),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.x1, pos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y2 - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.x1 + radiusTopX, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2 - radiusTopX, pos.y2),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.x2, pos.y2 - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1 + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.x2 - radiusBottomX, pos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1 + radiusBottomX, pos.y1)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.x1 + radiusBottomX, highlightPos.y1),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.x1, highlightPos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x1, highlightPos.y2 - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.x1 + radiusTopX, highlightPos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2 - radiusTopX, highlightPos.y2),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.x2, highlightPos.y2 - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x2, highlightPos.y1 + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.x2 - radiusBottomX, highlightPos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.x1 + radiusBottomX, highlightPos.y1),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2 - radiusBottomX, pos.y1),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, false, pos.x2, pos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y2 - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.x2 - radiusTopX, pos.y2),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1 + radiusTopX, pos.y2),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.x1, pos.y2 - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x1, pos.y1 + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.x2, pos.y1)
								]));
					}
				}
			}
		}();
		var commands = _v1.a;
		var highlightCommands = _v1.b;
		var viewAuraBar = function (fill) {
			return (!config.highlight) ? A6(viewBar, fill, config.opacity, config.border, config.borderWidth, 1, commands) : A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__bar-with-highlight')
					]),
				_List_fromArray(
					[
						A6(viewBar, highlightColor, config.highlight, 'transparent', 0, 0, highlightCommands),
						A6(viewBar, fill, config.opacity, config.border, config.borderWidth, 1, commands)
					]));
		};
		var _v3 = config.design;
		if (_v3.$ === 'Nothing') {
			return viewAuraBar(config.color);
		} else {
			var design = _v3.a;
			var _v4 = A2($terezka$elm_charts$Internal$Svg$toPattern, config.color, design);
			var patternDefs = _v4.a;
			var fill = _v4.b;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__bar-with-pattern')
					]),
				_List_fromArray(
					[
						patternDefs,
						viewAuraBar(fill)
					]));
		}
	});
var $terezka$elm_charts$Internal$Produce$toBin = F5(
	function (barsConfig, index, prevM, curr, nextM) {
		var _v0 = _Utils_Tuple2(barsConfig.x1, barsConfig.x2);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return {end: (index + 1) + 0.5, datum: curr, start: (index + 1) - 0.5};
			} else {
				var _v8 = _v0.a;
				var toX2 = _v0.b.a;
				var _v9 = _Utils_Tuple2(prevM, nextM);
				if (_v9.a.$ === 'Just') {
					var prev = _v9.a.a;
					return {
						end: toX2(curr),
						datum: curr,
						start: toX2(prev)
					};
				} else {
					if (_v9.b.$ === 'Just') {
						var _v10 = _v9.a;
						var next = _v9.b.a;
						return {
							end: toX2(curr),
							datum: curr,
							start: toX2(curr) - (toX2(next) - toX2(curr))
						};
					} else {
						var _v11 = _v9.a;
						var _v12 = _v9.b;
						return {
							end: toX2(curr),
							datum: curr,
							start: toX2(curr) - 1
						};
					}
				}
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var toX1 = _v0.a.a;
				var _v3 = _v0.b;
				var _v4 = _Utils_Tuple2(prevM, nextM);
				if (_v4.b.$ === 'Just') {
					var next = _v4.b.a;
					return {
						end: toX1(next),
						datum: curr,
						start: toX1(curr)
					};
				} else {
					if (_v4.a.$ === 'Just') {
						var prev = _v4.a.a;
						var _v5 = _v4.b;
						return {
							end: toX1(curr) + (toX1(curr) - toX1(prev)),
							datum: curr,
							start: toX1(curr)
						};
					} else {
						var _v6 = _v4.a;
						var _v7 = _v4.b;
						return {
							end: toX1(curr) + 1,
							datum: curr,
							start: toX1(curr)
						};
					}
				}
			} else {
				var toX1 = _v0.a.a;
				var toX2 = _v0.b.a;
				return {
					end: toX2(curr),
					datum: curr,
					start: toX1(curr)
				};
			}
		}
	});
var $terezka$elm_charts$Chart$Attributes$roundTop = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{roundTop: v});
		});
};
var $terezka$elm_charts$Internal$Helpers$withFirst = F2(
	function (xs, func) {
		if (xs.b) {
			var x = xs.a;
			var rest = xs.b;
			return $elm$core$Maybe$Just(
				A2(func, x, rest));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $terezka$elm_charts$Internal$Svg$defaultBar = {attrs: _List_Nil, color: $terezka$elm_charts$Internal$Helpers$pink, border: 'white', design: $elm$core$Maybe$Nothing, opacity: 1, roundTop: 0, highlight: 0, borderWidth: 0, roundBottom: 0, highlightColor: '', highlightWidth: 10};
var $terezka$elm_charts$Internal$Produce$tooltipRow = F3(
	function (color, title, text) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', color),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'padding-right', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title + ':')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
							A2($elm$html$Html$Attributes$style, 'padding', '0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]))
				]));
	});
var $terezka$elm_charts$Chart$Attributes$roundBottom = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{roundBottom: v});
		});
};
var $terezka$elm_charts$Internal$Produce$updateBorder = F2(
	function (defaultColor, product) {
		return _Utils_eq(product.border, defaultColor) ? _Utils_update(
			product,
			{border: product.color}) : product;
	});
var $terezka$elm_charts$Internal$Helpers$withSurround = F2(
	function (all, func) {
		var fold = F4(
			function (index, prev, acc, list) {
				fold:
				while (true) {
					if (list.b) {
						if (list.b.b) {
							var a = list.a;
							var _v1 = list.b;
							var b = _v1.a;
							var rest = _v1.b;
							var $temp$index = index + 1,
								$temp$prev = $elm$core$Maybe$Just(a),
								$temp$acc = _Utils_ap(
								acc,
								_List_fromArray(
									[
										A4(
										func,
										index,
										prev,
										a,
										$elm$core$Maybe$Just(b))
									])),
								$temp$list = A2($elm$core$List$cons, b, rest);
							index = $temp$index;
							prev = $temp$prev;
							acc = $temp$acc;
							list = $temp$list;
							continue fold;
						} else {
							var a = list.a;
							return _Utils_ap(
								acc,
								_List_fromArray(
									[
										A4(func, index, prev, a, $elm$core$Maybe$Nothing)
									]));
						}
					} else {
						return acc;
					}
				}
			});
		return A4(fold, 0, $elm$core$Maybe$Nothing, _List_Nil, all);
	});
var $terezka$elm_charts$Internal$Produce$toDefaultName = F2(
	function (ids, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Property #' + $elm$core$String$fromInt(ids.absoluteIndex + 1),
			name);
	});
var $terezka$elm_charts$Internal$Helpers$red = '#F5325B';
var $terezka$elm_charts$Internal$Helpers$blue = '#12A5ED';
var $terezka$elm_charts$Internal$Helpers$moss = '#92b42c';
var $terezka$elm_charts$Internal$Helpers$brown = '#871c1c';
var $terezka$elm_charts$Internal$Helpers$green = '#71c614';
var $terezka$elm_charts$Internal$Helpers$orange = '#FF8400';
var $terezka$elm_charts$Internal$Helpers$purple = '#7b4dff';
var $terezka$elm_charts$Internal$Helpers$yellow = '#FFCA00';
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $terezka$elm_charts$Internal$Helpers$toDefault = F3(
	function (_default, items, index) {
		var dict = $elm$core$Dict$fromList(
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, items));
		var numOfItems = $elm$core$Dict$size(dict);
		var itemIndex = index % numOfItems;
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2($elm$core$Dict$get, itemIndex, dict));
	});
var $terezka$elm_charts$Internal$Helpers$turquoise = '#22d2ba';
var $terezka$elm_charts$Internal$Helpers$toDefaultColor = A2(
	$terezka$elm_charts$Internal$Helpers$toDefault,
	$terezka$elm_charts$Internal$Helpers$pink,
	_List_fromArray(
		[$terezka$elm_charts$Internal$Helpers$purple, $terezka$elm_charts$Internal$Helpers$pink, $terezka$elm_charts$Internal$Helpers$blue, $terezka$elm_charts$Internal$Helpers$green, $terezka$elm_charts$Internal$Helpers$red, $terezka$elm_charts$Internal$Helpers$yellow, $terezka$elm_charts$Internal$Helpers$turquoise, $terezka$elm_charts$Internal$Helpers$orange, $terezka$elm_charts$Internal$Helpers$moss, $terezka$elm_charts$Internal$Helpers$brown]));
var $terezka$elm_charts$Internal$Produce$updateColorIfGradientIsSet = F2(
	function (defaultColor, product) {
		var _v0 = product.design;
		if (((_v0.$ === 'Just') && (_v0.a.$ === 'Gradient')) && _v0.a.a.b) {
			var _v1 = _v0.a.a;
			var first = _v1.a;
			return _Utils_eq(product.color, defaultColor) ? _Utils_update(
				product,
				{color: first}) : product;
		} else {
			return product;
		}
	});
var $terezka$elm_charts$Internal$Produce$toBarSeries = F4(
	function (elementIndex, barsAttrs, properties, data) {
		var barsConfig = A2($terezka$elm_charts$Internal$Helpers$apply, barsAttrs, $terezka$elm_charts$Internal$Produce$defaultBars);
		var numOfStacks = barsConfig.grouped ? $elm$core$List$length(properties) : 1;
		var forEachDataPoint = F7(
			function (absoluteIndex, stackSeriesConfigIndex, barSeriesConfigIndex, numOfBarsInStack, barSeriesConfig, dataIndex, bin) {
				var identification = {dataIndex: dataIndex, stackIndex: stackSeriesConfigIndex, seriesIndex: barSeriesConfigIndex, elementIndex: elementIndex, absoluteIndex: absoluteIndex};
				var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefaultColor(identification.absoluteIndex);
				var isSingle = numOfBarsInStack === 1;
				var isBottom = _Utils_eq(identification.seriesIndex, numOfBarsInStack - 1);
				var roundBottom = (isSingle || isBottom) ? barsConfig.roundBottom : 0;
				var start = bin.start;
				var isTop = !identification.seriesIndex;
				var roundTop = (isSingle || isTop) ? barsConfig.roundTop : 0;
				var basicAttributes = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$roundTop(roundTop),
						$terezka$elm_charts$Chart$Attributes$roundBottom(roundBottom),
						$terezka$elm_charts$Chart$Attributes$color(defaultColor),
						$terezka$elm_charts$Chart$Attributes$border(defaultColor)
					]);
				var barPresentationConfig = A2(
					$terezka$elm_charts$Internal$Produce$updateBorder,
					defaultColor,
					A2(
						$terezka$elm_charts$Internal$Produce$updateColorIfGradientIsSet,
						defaultColor,
						A2(
							$terezka$elm_charts$Internal$Helpers$apply,
							_Utils_ap(
								basicAttributes,
								_Utils_ap(
									barSeriesConfig.presentation,
									A2(barSeriesConfig.variation, identification, bin.datum))),
							$terezka$elm_charts$Internal$Svg$defaultBar)));
				var ySum = barSeriesConfig.toYSum(bin.datum);
				var minY = (numOfBarsInStack > 1) ? $elm$core$Basics$max(0) : $elm$core$Basics$identity;
				var end = bin.end;
				var length = end - start;
				var margin = length * barsConfig.margin;
				var spacing = length * barsConfig.spacing;
				var width = ((length - (margin * 2)) - ((numOfStacks - 1) * spacing)) / numOfStacks;
				var offset = barsConfig.grouped ? ((identification.stackIndex * width) + (identification.stackIndex * spacing)) : 0;
				var y2 = minY(
					A2($elm$core$Maybe$withDefault, 0, ySum));
				var x2 = ((start + margin) + offset) + width;
				var x1 = (start + margin) + offset;
				var y = barSeriesConfig.toY(bin.datum);
				var y1 = minY(
					A2($elm$core$Maybe$withDefault, 0, ySum) - A2($elm$core$Maybe$withDefault, 0, y));
				return A2(
					$terezka$elm_charts$Internal$Item$Rendered,
					{
						y: A2($elm$core$Maybe$withDefault, 0, y),
						x1: start,
						x2: end,
						name: barSeriesConfig.tooltipName,
						color: barPresentationConfig.color,
						datum: bin.datum,
						toAny: $terezka$elm_charts$Internal$Item$Bar,
						isReal: !_Utils_eq(y, $elm$core$Maybe$Nothing),
						tooltipText: barSeriesConfig.tooltipText(bin.datum),
						presentation: barPresentationConfig,
						identification: identification
					},
					{
						limits: {
							x1: x1,
							x2: x2,
							y1: A2($elm$core$Basics$min, y1, y2),
							y2: A2($elm$core$Basics$max, y1, y2)
						},
						render: F2(
							function (plane, position) {
								return A3($terezka$elm_charts$Internal$Svg$bar, plane, barPresentationConfig, position);
							}),
						tooltip: function (_v5) {
							return _List_fromArray(
								[
									A3(
									$terezka$elm_charts$Internal$Produce$tooltipRow,
									barPresentationConfig.color,
									A2($terezka$elm_charts$Internal$Produce$toDefaultName, identification, barSeriesConfig.tooltipName),
									barSeriesConfig.tooltipText(bin.datum))
								]);
						},
						toPosition: function (_v6) {
							return {x1: x1, x2: x2, y1: y1, y2: y2};
						}
					});
			});
		var forEachBarSeriesConfig = F6(
			function (bins, absoluteIndex, stackSeriesConfigIndex, numOfBarsInStack, barSeriesConfigIndex, barSeriesConfig) {
				var absoluteIndexNew = absoluteIndex + barSeriesConfigIndex;
				var items = A2(
					$elm$core$List$indexedMap,
					A5(forEachDataPoint, absoluteIndexNew, stackSeriesConfigIndex, barSeriesConfigIndex, numOfBarsInStack, barSeriesConfig),
					bins);
				return A2(
					$terezka$elm_charts$Internal$Helpers$withFirst,
					items,
					F2(
						function (first, rest) {
							return A2(
								$terezka$elm_charts$Internal$Item$Rendered,
								_Utils_Tuple2(first, rest),
								{
									limits: A2($terezka$elm_charts$Internal$Coordinates$foldPosition, $terezka$elm_charts$Internal$Item$getLimits, items),
									render: F2(
										function (plane, _v3) {
											return A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('elm-charts__series')
													]),
												A2(
													$elm$core$List$map,
													$terezka$elm_charts$Internal$Item$render(plane),
													items));
										}),
									tooltip: function (_v4) {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$table,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'margin', '0')
													]),
												A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Item$tooltip, items))
											]);
									},
									toPosition: function (plane) {
										return A2(
											$terezka$elm_charts$Internal$Coordinates$foldPosition,
											$terezka$elm_charts$Internal$Item$getPosition(plane),
											items);
									}
								});
						}));
			});
		var forEachStackSeriesConfig = F3(
			function (bins, stackSeriesConfig, _v2) {
				var absoluteIndex = _v2.a;
				var stackSeriesConfigIndex = _v2.b;
				var items = _v2.c;
				var seriesItems = function () {
					if (stackSeriesConfig.$ === 'NotStacked') {
						var barSeriesConfig = stackSeriesConfig.a;
						return _List_fromArray(
							[
								A6(forEachBarSeriesConfig, bins, absoluteIndex, stackSeriesConfigIndex, 1, 0, barSeriesConfig)
							]);
					} else {
						var barSeriesConfigs = stackSeriesConfig.a;
						var numOfBarsInStack = $elm$core$List$length(barSeriesConfigs);
						return A2(
							$elm$core$List$indexedMap,
							A4(forEachBarSeriesConfig, bins, absoluteIndex, stackSeriesConfigIndex, numOfBarsInStack),
							barSeriesConfigs);
					}
				}();
				return _Utils_Tuple3(
					absoluteIndex + $elm$core$List$length(seriesItems),
					stackSeriesConfigIndex + 1,
					_Utils_ap(
						items,
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, seriesItems)));
			});
		return function (bins) {
			return function (_v0) {
				var items = _v0.c;
				return items;
			}(
				A3(
					$elm$core$List$foldl,
					forEachStackSeriesConfig(bins),
					_Utils_Tuple3(elementIndex, 0, _List_Nil),
					properties));
		}(
			A2(
				$terezka$elm_charts$Internal$Helpers$withSurround,
				data,
				$terezka$elm_charts$Internal$Produce$toBin(barsConfig)));
	});
var $terezka$elm_charts$Internal$Legend$BarLegend = F2(
	function (a, b) {
		return {$: 'BarLegend', a: a, b: b};
	});
var $terezka$elm_charts$Internal$Property$toConfigs = function (property) {
	if (property.$ === 'NotStacked') {
		var config = property.a;
		return _List_fromArray(
			[config]);
	} else {
		var configs = property.a;
		return configs;
	}
};
var $terezka$elm_charts$Internal$Legend$toBarLegends = F3(
	function (elIndex, barsAttrs, properties) {
		var toBarConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultBar);
		};
		var barsConfig = A2($terezka$elm_charts$Internal$Helpers$apply, barsAttrs, $terezka$elm_charts$Internal$Produce$defaultBars);
		var toBarLegend = F2(
			function (colorIndex, prop) {
				var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefaultColor(colorIndex);
				var defaultName = 'Property #' + $elm$core$String$fromInt(colorIndex + 1);
				var rounding = A2($elm$core$Basics$max, barsConfig.roundTop, barsConfig.roundBottom);
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$roundTop(rounding),
						$terezka$elm_charts$Chart$Attributes$roundBottom(rounding),
						$terezka$elm_charts$Chart$Attributes$color(defaultColor),
						$terezka$elm_charts$Chart$Attributes$border(defaultColor)
					]);
				var attrsOrg = _Utils_ap(defaultAttrs, prop.presentation);
				var productOrg = toBarConfig(attrsOrg);
				var attrs = _Utils_eq(productOrg.border, defaultColor) ? _Utils_ap(
					attrsOrg,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$border(productOrg.color)
						])) : attrsOrg;
				return A2(
					$terezka$elm_charts$Internal$Legend$BarLegend,
					A2($elm$core$Maybe$withDefault, defaultName, prop.tooltipName),
					attrs);
			});
		return A2(
			$elm$core$List$indexedMap,
			function (propIndex) {
				return toBarLegend(elIndex + propIndex);
			},
			A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Property$toConfigs, properties));
	});
var $terezka$elm_charts$Chart$barsMap = F4(
	function (mapData, edits, properties, data) {
		return $terezka$elm_charts$Chart$Indexed(
			function (index) {
				var barsConfig = A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Produce$defaultBars);
				var legends_ = A3($terezka$elm_charts$Internal$Legend$toBarLegends, index, edits, properties);
				var items = A4($terezka$elm_charts$Internal$Produce$toBarSeries, index, edits, properties, data);
				var generalized = A2(
					$elm$core$List$map,
					$terezka$elm_charts$Internal$Item$map(mapData),
					A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Many$generalize, items));
				var bins = A2($terezka$elm_charts$Chart$Item$apply, $terezka$elm_charts$Chart$Item$bins, generalized);
				var toTicks = F2(
					function (plane, acc) {
						return _Utils_update(
							acc,
							{
								xs: _Utils_ap(
									acc.xs,
									barsConfig.grid ? A2(
										$elm$core$List$concatMap,
										A2(
											$elm$core$Basics$composeR,
											$terezka$elm_charts$Chart$Item$getLimits,
											function (pos) {
												return _List_fromArray(
													[pos.x1, pos.x2]);
											}),
										bins) : _List_Nil)
							});
					});
				var toLimits = A2($elm$core$List$map, $terezka$elm_charts$Internal$Item$getLimits, bins);
				return _Utils_Tuple2(
					A5(
						$terezka$elm_charts$Chart$BarsElement,
						toLimits,
						generalized,
						legends_,
						toTicks,
						function (plane) {
							return A2(
								$elm$svg$Svg$map,
								$elm$core$Basics$never,
								A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('elm-charts__bar-series')
										]),
									A2(
										$elm$core$List$map,
										$terezka$elm_charts$Internal$Item$render(plane),
										items)));
						}),
					index + $elm$core$List$length(items));
			});
	});
var $terezka$elm_charts$Chart$Attributes$exactly = F3(
	function (exact, _v0, _v1) {
		return exact;
	});
var $terezka$elm_charts$Internal$Item$getDatum = function (_v0) {
	var meta = _v0.a;
	return meta.datum;
};
var $terezka$elm_charts$Chart$Item$getData = $terezka$elm_charts$Internal$Item$getDatum;
var $terezka$elm_charts$Chart$Attributes$highest = F2(
	function (v, edit) {
		return $terezka$elm_charts$Internal$Helpers$Attribute(
			function (b) {
				return _Utils_update(
					b,
					{
						max: A3(edit, v, b.max, b.dataMax)
					});
			});
	});
var $terezka$elm_charts$Chart$Attributes$noArrow = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{arrow: false});
	});
var $terezka$elm_charts$Chart$html = function (func) {
	return $terezka$elm_charts$Chart$HtmlElement(
		F2(
			function (p, _v0) {
				return func(p);
			}));
};
var $terezka$elm_charts$Internal$Coordinates$top = function (pos) {
	return {x: pos.x1 + ((pos.x2 - pos.x1) / 2), y: pos.y2};
};
var $terezka$elm_charts$Internal$Coordinates$left = function (pos) {
	return {x: pos.x1, y: pos.y1 + ((pos.y2 - pos.y1) / 2)};
};
var $terezka$elm_charts$Internal$Svg$Right = {$: 'Right'};
var $terezka$elm_charts$Internal$Coordinates$right = function (pos) {
	return {x: pos.x2, y: pos.y1 + ((pos.y2 - pos.y1) / 2)};
};
var $terezka$elm_charts$Internal$Svg$Bottom = {$: 'Bottom'};
var $terezka$elm_charts$Internal$Coordinates$bottom = function (pos) {
	return {x: pos.x1 + ((pos.x2 - pos.x1) / 2), y: pos.y1};
};
var $terezka$elm_charts$Internal$Svg$tooltipPointerStyle = F4(
	function (direction, className, background, borderColor) {
		var config = function () {
			switch (direction.$) {
				case 'Top':
					return {a: 'right', b: 'top', c: 'left'};
				case 'Bottom':
					return {a: 'right', b: 'bottom', c: 'left'};
				case 'Left':
					return {a: 'bottom', b: 'left', c: 'top'};
				case 'Right':
					return {a: 'bottom', b: 'right', c: 'top'};
				case 'LeftOrRight':
					return {a: 'bottom', b: 'left', c: 'top'};
				default:
					return {a: 'right', b: 'top', c: 'left'};
			}
		}();
		return '\u000A  .' + (className + (':before, .' + (className + (':after {\u000A    content: \u0022\u0022;\u000A    position: absolute;\u000A    border-' + (config.c + (': 5px solid transparent;\u000A    border-' + (config.a + (': 5px solid transparent;\u000A    ' + (config.b + (': 100%;\u000A    ' + (config.c + (': 50%;\u000A    margin-' + (config.c + (': -5px;\u000A  }\u000A\u000A  .' + (className + (':after {\u000A    border-' + (config.b + (': 5px solid ' + (background + (';\u000A    margin-' + (config.b + (': -1px;\u000A    z-index: 1;\u000A    height: 0px;\u000A  }\u000A\u000A  .' + (className + (':before {\u000A    border-' + (config.b + (': 5px solid ' + (borderColor + ';\u000A    height: 0px;\u000A  }\u000A  ')))))))))))))))))))))))))));
	});
var $terezka$elm_charts$Internal$Svg$tooltip = F5(
	function (plane, pos, config, htmlAttrs, content) {
		var distanceBottom = plane.y.length - A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, pos.y1);
		var distanceRight = plane.x.length - A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, pos.x1);
		var distanceLeft = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, pos.x2);
		var distanceTop = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, pos.y2);
		var arrowWidth = config.arrow ? 4 : 0;
		var direction = function () {
			var _v5 = config.direction;
			if (_v5.$ === 'Just') {
				switch (_v5.a.$) {
					case 'LeftOrRight':
						var _v6 = _v5.a;
						return (config.width > 0) ? ((_Utils_cmp(distanceLeft, config.width + config.offset) > 0) ? $terezka$elm_charts$Internal$Svg$Left : $terezka$elm_charts$Internal$Svg$Right) : ((_Utils_cmp(distanceLeft, distanceRight) > 0) ? $terezka$elm_charts$Internal$Svg$Left : $terezka$elm_charts$Internal$Svg$Right);
					case 'TopOrBottom':
						var _v7 = _v5.a;
						return (config.height > 0) ? ((_Utils_cmp(distanceTop, config.height + config.offset) > 0) ? $terezka$elm_charts$Internal$Svg$Top : $terezka$elm_charts$Internal$Svg$Bottom) : ((_Utils_cmp(distanceTop, distanceBottom) > 0) ? $terezka$elm_charts$Internal$Svg$Top : $terezka$elm_charts$Internal$Svg$Bottom);
					default:
						var dir = _v5.a;
						return dir;
				}
			} else {
				var isLargest = function (a) {
					return $elm$core$List$all(
						function (b) {
							return _Utils_cmp(a, b) > -1;
						});
				};
				return A2(
					isLargest,
					distanceTop,
					_List_fromArray(
						[distanceBottom, distanceLeft, distanceRight])) ? $terezka$elm_charts$Internal$Svg$Top : (A2(
					isLargest,
					distanceBottom,
					_List_fromArray(
						[distanceTop, distanceLeft, distanceRight])) ? $terezka$elm_charts$Internal$Svg$Bottom : (A2(
					isLargest,
					distanceLeft,
					_List_fromArray(
						[distanceTop, distanceBottom, distanceRight])) ? $terezka$elm_charts$Internal$Svg$Left : $terezka$elm_charts$Internal$Svg$Right));
			}
		}();
		var focalPoint = function () {
			var _v2 = config.focal;
			if (_v2.$ === 'Just') {
				var focal = _v2.a;
				switch (direction.$) {
					case 'Top':
						return $terezka$elm_charts$Internal$Coordinates$top(
							focal(pos));
					case 'Bottom':
						return $terezka$elm_charts$Internal$Coordinates$bottom(
							focal(pos));
					case 'Left':
						return $terezka$elm_charts$Internal$Coordinates$left(
							focal(pos));
					case 'Right':
						return $terezka$elm_charts$Internal$Coordinates$right(
							focal(pos));
					case 'LeftOrRight':
						return $terezka$elm_charts$Internal$Coordinates$left(
							focal(pos));
					default:
						return $terezka$elm_charts$Internal$Coordinates$right(
							focal(pos));
				}
			} else {
				switch (direction.$) {
					case 'Top':
						return $terezka$elm_charts$Internal$Coordinates$top(pos);
					case 'Bottom':
						return $terezka$elm_charts$Internal$Coordinates$bottom(pos);
					case 'Left':
						return $terezka$elm_charts$Internal$Coordinates$left(pos);
					case 'Right':
						return $terezka$elm_charts$Internal$Coordinates$right(pos);
					case 'LeftOrRight':
						return $terezka$elm_charts$Internal$Coordinates$left(pos);
					default:
						return $terezka$elm_charts$Internal$Coordinates$right(pos);
				}
			}
		}();
		var _v0 = function () {
			switch (direction.$) {
				case 'Top':
					return {xOff: 0, yOff: config.offset + arrowWidth, className: 'elm-charts__tooltip-top', transformation: 'translate(-50%, -100%)'};
				case 'Bottom':
					return {xOff: 0, yOff: (-config.offset) - arrowWidth, className: 'elm-charts__tooltip-bottom', transformation: 'translate(-50%, 0%)'};
				case 'Left':
					return {xOff: (-config.offset) - arrowWidth, yOff: 0, className: 'elm-charts__tooltip-left', transformation: 'translate(-100%, -50%)'};
				case 'Right':
					return {xOff: config.offset + arrowWidth, yOff: 0, className: 'elm-charts__tooltip-right', transformation: 'translate(0, -50%)'};
				case 'LeftOrRight':
					return {xOff: (-config.offset) - arrowWidth, yOff: 0, className: 'elm-charts__tooltip-leftOrRight', transformation: 'translate(0, -50%)'};
				default:
					return {xOff: 0, yOff: config.offset + arrowWidth, className: 'elm-charts__tooltip-topOrBottom', transformation: 'translate(-50%, -100%)'};
			}
		}();
		var className = _v0.className;
		var transformation = _v0.transformation;
		var yOff = _v0.yOff;
		var xOff = _v0.xOff;
		var children = config.arrow ? A2(
			$elm$core$List$cons,
			A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A4($terezka$elm_charts$Internal$Svg$tooltipPointerStyle, direction, className, config.background, config.border))
					])),
			content) : content;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className),
					A2($elm$html$Html$Attributes$style, 'transform', transformation),
					A2($elm$html$Html$Attributes$style, 'padding', '5px 8px'),
					A2($elm$html$Html$Attributes$style, 'background', config.background),
					A2($elm$html$Html$Attributes$style, 'border', '1px solid ' + config.border),
					A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
				]),
			htmlAttrs);
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A7($terezka$elm_charts$Internal$Svg$positionHtml, plane, focalPoint.x, focalPoint.y, xOff, yOff, attributes, children));
	});
var $terezka$elm_charts$Internal$Svg$defaultTooltip = {arrow: true, focal: $elm$core$Maybe$Nothing, width: 0, border: '#D8D8D8', height: 0, offset: 8, direction: $elm$core$Maybe$Nothing, background: 'white'};
var $terezka$elm_charts$Chart$Svg$tooltip = F3(
	function (plane, pos, edits) {
		return A3(
			$terezka$elm_charts$Internal$Svg$tooltip,
			plane,
			pos,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultTooltip));
	});
var $terezka$elm_charts$Chart$tooltip = F4(
	function (i, edits, attrs_, content) {
		return $terezka$elm_charts$Chart$html(
			function (p) {
				var content_ = _Utils_eq(content, _List_Nil) ? $terezka$elm_charts$Internal$Item$tooltip(i) : content;
				var pos = $terezka$elm_charts$Internal$Item$getLimits(i);
				return A3($terezka$elm_charts$Internal$Svg$isWithinPlane, p, pos.x1, pos.y2) ? A5(
					$terezka$elm_charts$Chart$Svg$tooltip,
					p,
					A2($terezka$elm_charts$Internal$Item$getPosition, p, i),
					edits,
					attrs_,
					content_) : $elm$html$Html$text('');
			});
	});
var $terezka$elm_charts$Chart$Attributes$zero = function (b) {
	return A3($elm$core$Basics$clamp, b.min, b.max, 0);
};
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $terezka$elm_charts$Internal$Svg$position = F6(
	function (plane, rotation, x_, y_, xOff_, yOff_) {
		return $elm$svg$Svg$Attributes$transform(
			'translate(' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x_) + xOff_) + (',' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y_) + yOff_) + (') rotate(' + ($elm$core$String$fromFloat(rotation) + ')'))))));
	});
var $elm$svg$Svg$foreignObject = $elm$svg$Svg$trustedNode('foreignObject');
var $terezka$elm_charts$Internal$Svg$label = F4(
	function (plane, config, inner, point) {
		var _v0 = config.ellipsis;
		if (_v0.$ === 'Nothing') {
			var withOverflowWrap = function (el) {
				return config.hideOverflow ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.uppercase ? 'text-transform: uppercase;' : '';
			var anchorStyle = function () {
				var _v2 = config.anchor;
				if (_v2.$ === 'Nothing') {
					return 'text-anchor: middle;';
				} else {
					switch (_v2.a.$) {
						case 'End':
							var _v3 = _v2.a;
							return 'text-anchor: end;';
						case 'Start':
							var _v4 = _v2.a;
							return 'text-anchor: start;';
						default:
							var _v5 = _v2.a;
							return 'text-anchor: middle;';
					}
				}
			}();
			var fontStyle = function () {
				var _v1 = config.fontSize;
				if (_v1.$ === 'Just') {
					var size_ = _v1.a;
					return 'font-size: ' + ($elm$core$String$fromInt(size_) + 'px;');
				} else {
					return '';
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.attrs,
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$stroke(config.border),
							$elm$svg$Svg$Attributes$strokeWidth(
							$elm$core$String$fromFloat(config.borderWidth)),
							$elm$svg$Svg$Attributes$fill(config.color),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.rotate, point.x, point.y, config.xOff, config.yOff),
							$elm$svg$Svg$Attributes$style(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									['pointer-events: none;', fontStyle, anchorStyle, uppercaseStyle])))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$tspan, _List_Nil, inner)
						])));
		} else {
			var ellipsis = _v0.a;
			var withOverflowWrap = function (el) {
				return config.hideOverflow ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var xOffWithAnchor = function () {
				var _v11 = config.anchor;
				if (_v11.$ === 'Nothing') {
					return config.xOff - (ellipsis.width / 2);
				} else {
					switch (_v11.a.$) {
						case 'End':
							var _v12 = _v11.a;
							return config.xOff - ellipsis.width;
						case 'Start':
							var _v13 = _v11.a;
							return config.xOff;
						default:
							var _v14 = _v11.a;
							return config.xOff - (ellipsis.width / 2);
					}
				}
			}();
			var uppercaseStyle = config.uppercase ? A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase') : A2($elm$html$Html$Attributes$style, '', '');
			var anchorStyle = function () {
				var _v7 = config.anchor;
				if (_v7.$ === 'Nothing') {
					return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
				} else {
					switch (_v7.a.$) {
						case 'End':
							var _v8 = _v7.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'right');
						case 'Start':
							var _v9 = _v7.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'left');
						default:
							var _v10 = _v7.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
					}
				}
			}();
			var fontStyle = function () {
				var _v6 = config.fontSize;
				if (_v6.$ === 'Just') {
					var size_ = _v6.a;
					return A2(
						$elm$html$Html$Attributes$style,
						'font-size',
						$elm$core$String$fromInt(size_) + 'px');
				} else {
					return A2($elm$html$Html$Attributes$style, '', '');
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.attrs,
					$elm$svg$Svg$foreignObject,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$class('elm-charts__html-label'),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromFloat(ellipsis.width)),
							$elm$svg$Svg$Attributes$height(
							$elm$core$String$fromFloat(ellipsis.height)),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.rotate, point.x, point.y, xOffWithAnchor, config.yOff - 10)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/1999/xhtml'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
									A2($elm$html$Html$Attributes$style, 'color', config.color),
									fontStyle,
									uppercaseStyle,
									anchorStyle
								]),
							inner)
						])));
		}
	});
var $terezka$elm_charts$Internal$Svg$Floats = {$: 'Floats'};
var $terezka$elm_charts$Internal$Svg$defaultLabel = {xOff: 0, yOff: 0, attrs: _List_Nil, color: '#808BAB', anchor: $elm$core$Maybe$Nothing, border: 'white', rotate: 0, ellipsis: $elm$core$Maybe$Nothing, fontSize: $elm$core$Maybe$Nothing, uppercase: false, borderWidth: 0, hideOverflow: false};
var $terezka$elm_charts$Chart$LabelsElement = F3(
	function (a, b, c) {
		return {$: 'LabelsElement', a: a, b: b, c: c};
	});
var $terezka$intervals$Intervals$correctFloat = function (prec) {
	return A2(
		$elm$core$Basics$composeR,
		$myrho$elm_round$Round$round(prec),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toFloat,
			$elm$core$Maybe$withDefault(0)));
};
var $terezka$intervals$Intervals$getPrecision = function (number) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(number));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var before = _v0.a;
		var _v1 = _v0.b;
		var after = _v1.a;
		return $elm$core$Basics$abs(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(after)));
	} else {
		var _v2 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$fromFloat(number));
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var before = _v2.a;
			var _v3 = _v2.b;
			var after = _v3.a;
			return $elm$core$String$length(after);
		} else {
			return 0;
		}
	}
};
var $terezka$intervals$Intervals$positions = F5(
	function (range, beginning, interval, m, acc) {
		positions:
		while (true) {
			var nextPosition = A2(
				$terezka$intervals$Intervals$correctFloat,
				$terezka$intervals$Intervals$getPrecision(interval),
				beginning + (m * interval));
			if (_Utils_cmp(nextPosition, range.max) > 0) {
				return acc;
			} else {
				var $temp$range = range,
					$temp$beginning = beginning,
					$temp$interval = interval,
					$temp$m = m + 1,
					$temp$acc = _Utils_ap(
					acc,
					_List_fromArray(
						[nextPosition]));
				range = $temp$range;
				beginning = $temp$beginning;
				interval = $temp$interval;
				m = $temp$m;
				acc = $temp$acc;
				continue positions;
			}
		}
	});
var $terezka$intervals$Intervals$toMagnitude = function (num) {
	return A2(
		$elm$core$Basics$pow,
		10,
		$elm$core$Basics$floor(
			A2($elm$core$Basics$logBase, $elm$core$Basics$e, num) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
};
var $terezka$intervals$Intervals$getMultiples = F3(
	function (magnitude, allowDecimals, hasTickAmount) {
		var defaults = hasTickAmount ? _List_fromArray(
			[1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) : _List_fromArray(
			[1, 2, 2.5, 5, 10]);
		return allowDecimals ? defaults : ((magnitude === 1) ? A2(
			$elm$core$List$filter,
			function (n) {
				return _Utils_eq(
					$elm$core$Basics$round(n),
					n);
			},
			defaults) : ((magnitude <= 0.1) ? _List_fromArray(
			[1 / magnitude]) : defaults));
	});
var $terezka$intervals$Intervals$getInterval = F3(
	function (intervalRaw, allowDecimals, hasTickAmount) {
		var magnitude = $terezka$intervals$Intervals$toMagnitude(intervalRaw);
		var multiples = A3($terezka$intervals$Intervals$getMultiples, magnitude, allowDecimals, hasTickAmount);
		var normalized = intervalRaw / magnitude;
		var findMultiple = function (multiples_) {
			findMultiple:
			while (true) {
				if (multiples_.b) {
					if (multiples_.b.b) {
						var m1 = multiples_.a;
						var _v1 = multiples_.b;
						var m2 = _v1.a;
						var rest = _v1.b;
						if (_Utils_cmp(normalized, (m1 + m2) / 2) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = A2($elm$core$List$cons, m2, rest);
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					} else {
						var m1 = multiples_.a;
						var rest = multiples_.b;
						if (_Utils_cmp(normalized, m1) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = rest;
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					}
				} else {
					return 1;
				}
			}
		};
		var findMultipleExact = function (multiples_) {
			findMultipleExact:
			while (true) {
				if (multiples_.b) {
					var m1 = multiples_.a;
					var rest = multiples_.b;
					if (_Utils_cmp(m1 * magnitude, intervalRaw) > -1) {
						return m1;
					} else {
						var $temp$multiples_ = rest;
						multiples_ = $temp$multiples_;
						continue findMultipleExact;
					}
				} else {
					return 1;
				}
			}
		};
		var multiple = hasTickAmount ? findMultipleExact(multiples) : findMultiple(multiples);
		var precision = $terezka$intervals$Intervals$getPrecision(magnitude) + $terezka$intervals$Intervals$getPrecision(multiple);
		return A2($terezka$intervals$Intervals$correctFloat, precision, multiple * magnitude);
	});
var $terezka$intervals$Intervals$ceilingTo = F2(
	function (prec, number) {
		return prec * $elm$core$Basics$ceiling(number / prec);
	});
var $terezka$intervals$Intervals$getBeginning = F2(
	function (min, interval) {
		var multiple = min / interval;
		return _Utils_eq(
			multiple,
			$elm$core$Basics$round(multiple)) ? min : A2($terezka$intervals$Intervals$ceilingTo, interval, min);
	});
var $terezka$intervals$Intervals$values = F4(
	function (allowDecimals, exact, amountRough, range) {
		var amountRoughSafe = (!amountRough) ? 1 : amountRough;
		var intervalRough = (range.max - range.min) / amountRough;
		var interval = A3($terezka$intervals$Intervals$getInterval, intervalRough, allowDecimals, exact);
		var intervalSafe = (!interval) ? 1 : interval;
		var beginning = A2($terezka$intervals$Intervals$getBeginning, range.min, intervalSafe);
		return A5($terezka$intervals$Intervals$positions, range, beginning, intervalSafe, 0, _List_Nil);
	});
var $terezka$intervals$Intervals$ints = F2(
	function (amount, range) {
		return A2(
			$elm$core$List$map,
			$elm$core$Basics$round,
			function () {
				if (amount.$ === 'Exactly') {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, true, number, range);
				} else {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, false, number, range);
				}
			}());
	});
var $terezka$intervals$Intervals$Around = function (a) {
	return {$: 'Around', a: a};
};
var $terezka$intervals$Intervals$around = $terezka$intervals$Intervals$Around;
var $terezka$elm_charts$Internal$Svg$Generator = function (a) {
	return {$: 'Generator', a: a};
};
var $terezka$elm_charts$Internal$Svg$ints = $terezka$elm_charts$Internal$Svg$Generator(
	F2(
		function (i, b) {
			return A2(
				$terezka$intervals$Intervals$ints,
				$terezka$intervals$Intervals$around(i),
				{max: b.max, min: b.min});
		}));
var $terezka$elm_charts$Chart$Svg$ints = $terezka$elm_charts$Internal$Svg$ints;
var $terezka$intervals$Intervals$Day = {$: 'Day'};
var $terezka$intervals$Intervals$Hour = {$: 'Hour'};
var $terezka$intervals$Intervals$Year = {$: 'Year'};
var $terezka$intervals$Intervals$Month = {$: 'Month'};
var $terezka$intervals$Intervals$Minute = {$: 'Minute'};
var $terezka$intervals$Intervals$Second = {$: 'Second'};
var $terezka$intervals$Intervals$Time$Day = {$: 'Day'};
var $terezka$intervals$Intervals$Time$Hour = {$: 'Hour'};
var $terezka$intervals$Intervals$Time$Year = {$: 'Year'};
var $terezka$intervals$Intervals$Time$Month = {$: 'Month'};
var $terezka$intervals$Intervals$Time$Minute = {$: 'Minute'};
var $terezka$intervals$Intervals$Time$Second = {$: 'Second'};
var $terezka$intervals$Intervals$Time$Millisecond = {$: 'Millisecond'};
var $terezka$intervals$Intervals$Time$getChange = F3(
	function (zone, a, b) {
		var bP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b);
		var aP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a);
		return (!_Utils_eq(aP.year, bP.year)) ? $terezka$intervals$Intervals$Time$Year : ((!_Utils_eq(aP.month, bP.month)) ? $terezka$intervals$Intervals$Time$Month : ((!_Utils_eq(aP.day, bP.day)) ? $terezka$intervals$Intervals$Time$Day : ((!_Utils_eq(aP.hour, bP.hour)) ? $terezka$intervals$Intervals$Time$Hour : ((!_Utils_eq(aP.minute, bP.minute)) ? $terezka$intervals$Intervals$Time$Minute : ((!_Utils_eq(aP.second, bP.second)) ? $terezka$intervals$Intervals$Time$Second : $terezka$intervals$Intervals$Time$Millisecond)))));
	});
var $terezka$intervals$Intervals$Time$unitToInt = function (unit) {
	switch (unit.$) {
		case 'Millisecond':
			return 0;
		case 'Second':
			return 1;
		case 'Minute':
			return 2;
		case 'Hour':
			return 3;
		case 'Day':
			return 4;
		case 'Month':
			return 5;
		default:
			return 6;
	}
};
var $terezka$intervals$Intervals$Time$largerUnit = function (unit) {
	switch (unit.$) {
		case 'Millisecond':
			return $elm$core$Maybe$Just($terezka$intervals$Intervals$Time$Second);
		case 'Second':
			return $elm$core$Maybe$Just($terezka$intervals$Intervals$Time$Minute);
		case 'Minute':
			return $elm$core$Maybe$Just($terezka$intervals$Intervals$Time$Hour);
		case 'Hour':
			return $elm$core$Maybe$Just($terezka$intervals$Intervals$Time$Day);
		case 'Day':
			return $elm$core$Maybe$Just($terezka$intervals$Intervals$Time$Month);
		case 'Month':
			return $elm$core$Maybe$Just($terezka$intervals$Intervals$Time$Year);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $terezka$intervals$Intervals$Time$toMs = $elm$time$Time$posixToMillis;
var $terezka$intervals$Intervals$Time$oneMs = 1;
var $terezka$intervals$Intervals$Time$oneSecond = 1000;
var $terezka$intervals$Intervals$Time$oneMinute = $terezka$intervals$Intervals$Time$oneSecond * 60;
var $terezka$intervals$Intervals$Time$oneHour = $terezka$intervals$Intervals$Time$oneMinute * 60;
var $terezka$intervals$Intervals$Time$oneDay = $terezka$intervals$Intervals$Time$oneHour * 24;
var $terezka$intervals$Intervals$Time$monthAsInt = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $danhandrea$elm_time_extra$Util$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 400, year)) || ((!(!A2($elm$core$Basics$modBy, 100, year))) && (!A2($elm$core$Basics$modBy, 4, year)));
};
var $danhandrea$elm_time_extra$Month$days = F2(
	function (year, month) {
		switch (month.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $danhandrea$elm_time_extra$Util$isLeapYear(year) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $danhandrea$elm_time_extra$TimeExtra$daysInMonth = $danhandrea$elm_time_extra$Month$days;
var $terezka$intervals$Intervals$Time$getDiff = F3(
	function (zone, a, b) {
		var _v0 = (_Utils_cmp(
			$terezka$intervals$Intervals$Time$toMs(a),
			$terezka$intervals$Intervals$Time$toMs(b)) < 0) ? _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b)) : _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a));
		var aP = _v0.a;
		var bP = _v0.b;
		var dMsX = bP.millisecond - aP.millisecond;
		var dMs = (dMsX < 0) ? (1000 + dMsX) : dMsX;
		var dSecondX = (bP.second - aP.second) + ((dMsX < 0) ? (-1) : 0);
		var dSecond = (dSecondX < 0) ? (60 + dSecondX) : dSecondX;
		var dMinuteX = (bP.minute - aP.minute) + ((dSecondX < 0) ? (-1) : 0);
		var dHourX = (bP.hour - aP.hour) + ((dMinuteX < 0) ? (-1) : 0);
		var dDayX = (bP.day - aP.day) + ((dHourX < 0) ? (-1) : 0);
		var dDay = (dDayX < 0) ? (A2($danhandrea$elm_time_extra$TimeExtra$daysInMonth, bP.year, bP.month) + dDayX) : dDayX;
		var dMonthX = ($terezka$intervals$Intervals$Time$monthAsInt(bP.month) - $terezka$intervals$Intervals$Time$monthAsInt(aP.month)) + ((dDayX < 0) ? (-1) : 0);
		var dMonth = (dMonthX < 0) ? (12 + dMonthX) : dMonthX;
		var dYearX = (bP.year - aP.year) + ((dMonthX < 0) ? (-1) : 0);
		var dYear = (dYearX < 0) ? ($terezka$intervals$Intervals$Time$monthAsInt(bP.month) + dYearX) : dYearX;
		var dHour = (dHourX < 0) ? (24 + dHourX) : dHourX;
		var dMinute = (dMinuteX < 0) ? (60 + dMinuteX) : dMinuteX;
		return {day: dDay, hour: dHour, year: dYear, month: dMonth, minute: dMinute, second: dSecond, millisecond: dMs};
	});
var $terezka$intervals$Intervals$Time$ceilingMs = F3(
	function (zone, mult, stamp) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, stamp);
		var rem = parts.millisecond % mult;
		return (!rem) ? A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts) : A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Millisecond, mult - rem, zone, stamp);
	});
var $terezka$intervals$Intervals$Time$ceilingDay = F3(
	function (zone, mult, stamp) {
		return (mult === 7) ? A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Week, zone, stamp) : A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Day, zone, stamp);
	});
var $terezka$intervals$Intervals$Time$ceilingHour = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Hour, zone, stamp));
		var rem = parts.hour % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, mult - rem, zone, _new);
	});
var $terezka$intervals$Intervals$Time$ceilingYear = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Year, zone, stamp));
		var rem = parts.year % mult;
		var newYear = (!rem) ? parts.year : ((parts.year - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			_Utils_update(
				parts,
				{year: newYear}));
	});
var $terezka$intervals$Intervals$Time$intAsMonth = function (_int) {
	switch (_int) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		case 12:
			return $elm$time$Time$Dec;
		default:
			return $elm$time$Time$Dec;
	}
};
var $terezka$intervals$Intervals$Time$ceilingMonth = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Month, zone, stamp));
		var monthInt = $terezka$intervals$Intervals$Time$monthAsInt(parts.month);
		var rem = (monthInt - 1) % mult;
		var newMonth = (!rem) ? monthInt : ((monthInt - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			(newMonth > 12) ? _Utils_update(
				parts,
				{
					year: parts.year + 1,
					month: $terezka$intervals$Intervals$Time$intAsMonth(newMonth - 12)
				}) : _Utils_update(
				parts,
				{
					month: $terezka$intervals$Intervals$Time$intAsMonth(newMonth)
				}));
	});
var $terezka$intervals$Intervals$Time$ceilingMinute = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Minute, zone, stamp));
		var rem = parts.minute % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Minute, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Second = {$: 'Second'};
var $terezka$intervals$Intervals$Time$ceilingSecond = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, $justinmimbs$time_extra$Time$Extra$Second, zone, stamp));
		var rem = parts.second % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Second, mult - rem, zone, _new);
	});
var $terezka$intervals$Intervals$Time$ceilingUnit = F3(
	function (zone, unit, mult) {
		switch (unit.$) {
			case 'Millisecond':
				return A2($terezka$intervals$Intervals$Time$ceilingMs, zone, mult);
			case 'Second':
				return A2($terezka$intervals$Intervals$Time$ceilingSecond, zone, mult);
			case 'Minute':
				return A2($terezka$intervals$Intervals$Time$ceilingMinute, zone, mult);
			case 'Hour':
				return A2($terezka$intervals$Intervals$Time$ceilingHour, zone, mult);
			case 'Day':
				return A2($terezka$intervals$Intervals$Time$ceilingDay, zone, mult);
			case 'Month':
				return A2($terezka$intervals$Intervals$Time$ceilingMonth, zone, mult);
			default:
				return A2($terezka$intervals$Intervals$Time$ceilingYear, zone, mult);
		}
	});
var $terezka$intervals$Intervals$Time$getNumOfTicks = F5(
	function (zone, unit, mult, a, b) {
		var div = F2(
			function (n1, n2) {
				return $elm$core$Basics$floor(n1 / n2);
			});
		var diff = function (property) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				property(
					A3($terezka$intervals$Intervals$Time$getDiff, zone, ceiled, b)),
				mult);
		};
		var timeDiff = function (ms) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				A2(
					div,
					$terezka$intervals$Intervals$Time$toMs(b) - $terezka$intervals$Intervals$Time$toMs(ceiled),
					ms),
				mult);
		};
		switch (unit.$) {
			case 'Millisecond':
				return timeDiff($terezka$intervals$Intervals$Time$oneMs) + 1;
			case 'Second':
				return timeDiff($terezka$intervals$Intervals$Time$oneSecond) + 1;
			case 'Minute':
				return timeDiff($terezka$intervals$Intervals$Time$oneMinute) + 1;
			case 'Hour':
				return timeDiff($terezka$intervals$Intervals$Time$oneHour) + 1;
			case 'Day':
				return timeDiff($terezka$intervals$Intervals$Time$oneDay) + 1;
			case 'Month':
				return diff(
					function (d) {
						return d.month + (d.year * 12);
					}) + 1;
			default:
				return diff(
					function ($) {
						return $.year;
					}) + 1;
		}
	});
var $terezka$intervals$Intervals$Time$niceMultiples = function (unit) {
	switch (unit.$) {
		case 'Millisecond':
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500]);
		case 'Second':
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 'Minute':
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 'Hour':
			return _List_fromArray(
				[1, 2, 3, 4, 6, 8, 12]);
		case 'Day':
			return _List_fromArray(
				[1, 2, 3, 7, 14]);
		case 'Month':
			return _List_fromArray(
				[1, 2, 3, 4, 6]);
		default:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 10000, 1000000, 10000000]);
	}
};
var $terezka$intervals$Intervals$Time$toBestUnit = F4(
	function (zone, amount, min, max) {
		var toNice = function (unit) {
			toNice:
			while (true) {
				var niceNums = $terezka$intervals$Intervals$Time$niceMultiples(unit);
				var maybeNiceNum = A2(
					$elm$core$List$filter,
					function (n) {
						return _Utils_cmp(
							A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, n, min, max),
							amount) < 1;
					},
					niceNums);
				var div = F2(
					function (n1, n2) {
						return $elm$core$Basics$ceiling(n1 / n2);
					});
				var _v0 = $elm$core$List$head(maybeNiceNum);
				if (_v0.$ === 'Just') {
					var niceNum = _v0.a;
					return _Utils_Tuple2(unit, niceNum);
				} else {
					var _v1 = $terezka$intervals$Intervals$Time$largerUnit(unit);
					if (_v1.$ === 'Just') {
						var larger = _v1.a;
						var $temp$unit = larger;
						unit = $temp$unit;
						continue toNice;
					} else {
						return _Utils_Tuple2($terezka$intervals$Intervals$Time$Year, 100000000);
					}
				}
			}
		};
		return toNice($terezka$intervals$Intervals$Time$Millisecond);
	});
var $terezka$intervals$Intervals$Time$toExtraUnit = function (unit) {
	switch (unit.$) {
		case 'Millisecond':
			return $justinmimbs$time_extra$Time$Extra$Millisecond;
		case 'Second':
			return $justinmimbs$time_extra$Time$Extra$Second;
		case 'Minute':
			return $justinmimbs$time_extra$Time$Extra$Minute;
		case 'Hour':
			return $justinmimbs$time_extra$Time$Extra$Hour;
		case 'Day':
			return $justinmimbs$time_extra$Time$Extra$Day;
		case 'Month':
			return $justinmimbs$time_extra$Time$Extra$Month;
		default:
			return $justinmimbs$time_extra$Time$Extra$Year;
	}
};
var $terezka$intervals$Intervals$Time$values = F4(
	function (zone, maxMmount, min, max) {
		var _v0 = A4($terezka$intervals$Intervals$Time$toBestUnit, zone, maxMmount, min, max);
		var unit = _v0.a;
		var mult = _v0.b;
		var tUnit = $terezka$intervals$Intervals$Time$toExtraUnit(unit);
		var amount = A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, mult, min, max);
		var toTick = F3(
			function (x, timestamp, change) {
				return {
					unit: unit,
					zone: zone,
					change: (_Utils_cmp(
						$terezka$intervals$Intervals$Time$unitToInt(change),
						$terezka$intervals$Intervals$Time$unitToInt(unit)) > 0) ? $elm$core$Maybe$Just(change) : $elm$core$Maybe$Nothing,
					isFirst: !x,
					multiple: mult,
					timestamp: timestamp
				};
			});
		var initial = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, min);
		var toTicks = F2(
			function (xs, acc) {
				toTicks:
				while (true) {
					if (xs.b) {
						var x = xs.a;
						var rest = xs.b;
						var prev = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, (x - 1) * mult, zone, initial);
						var curr = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, x * mult, zone, initial);
						var change = A3($terezka$intervals$Intervals$Time$getChange, zone, prev, curr);
						var $temp$xs = rest,
							$temp$acc = A2(
							$elm$core$List$cons,
							A3(toTick, x, curr, change),
							acc);
						xs = $temp$xs;
						acc = $temp$acc;
						continue toTicks;
					} else {
						return acc;
					}
				}
			});
		return $elm$core$List$reverse(
			A2(
				toTicks,
				A2($elm$core$List$range, 0, amount - 1),
				_List_Nil));
	});
var $terezka$intervals$Intervals$Millisecond = {$: 'Millisecond'};
var $terezka$intervals$Intervals$times = F3(
	function (zone, amount, range) {
		var toUnit = function (unit) {
			switch (unit.$) {
				case 'Millisecond':
					return $terezka$intervals$Intervals$Millisecond;
				case 'Second':
					return $terezka$intervals$Intervals$Second;
				case 'Minute':
					return $terezka$intervals$Intervals$Minute;
				case 'Hour':
					return $terezka$intervals$Intervals$Hour;
				case 'Day':
					return $terezka$intervals$Intervals$Day;
				case 'Month':
					return $terezka$intervals$Intervals$Month;
				default:
					return $terezka$intervals$Intervals$Year;
			}
		};
		var translateUnit = function (time) {
			return {
				unit: toUnit(time.unit),
				zone: time.zone,
				change: A2($elm$core$Maybe$map, toUnit, time.change),
				isFirst: time.isFirst,
				multiple: time.multiple,
				timestamp: time.timestamp
			};
		};
		var fromMs = function (ts) {
			return $elm$time$Time$millisToPosix(
				$elm$core$Basics$round(ts));
		};
		return A2(
			$elm$core$List$map,
			translateUnit,
			A4(
				$terezka$intervals$Intervals$Time$values,
				zone,
				amount,
				fromMs(range.min),
				fromMs(range.max)));
	});
var $terezka$elm_charts$Internal$Svg$times = function (zone) {
	return $terezka$elm_charts$Internal$Svg$Generator(
		F2(
			function (i, b) {
				return A3(
					$terezka$intervals$Intervals$times,
					zone,
					i,
					{max: b.max, min: b.min});
			}));
};
var $terezka$elm_charts$Chart$Svg$times = $terezka$elm_charts$Internal$Svg$times;
var $terezka$intervals$Intervals$floats = function (amount) {
	if (amount.$ === 'Exactly') {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, true, number);
	} else {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, false, number);
	}
};
var $terezka$elm_charts$Internal$Svg$floats = $terezka$elm_charts$Internal$Svg$Generator(
	F2(
		function (i, b) {
			return A2(
				$terezka$intervals$Intervals$floats,
				$terezka$intervals$Intervals$around(i),
				{max: b.max, min: b.min});
		}));
var $terezka$elm_charts$Chart$Svg$floats = $terezka$elm_charts$Internal$Svg$floats;
var $terezka$elm_charts$Internal$Svg$generate = F3(
	function (amount, _v0, limits) {
		var func = _v0.a;
		return A2(func, amount, limits);
	});
var $terezka$elm_charts$Chart$Svg$generate = $terezka$elm_charts$Internal$Svg$generate;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 'Text', a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {toAmPm: toAmPm, toMonthName: toMonthName, toWeekdayName: toWeekdayName, toOrdinalSuffix: toOrdinalSuffix, toMonthAbbreviation: toMonthAbbreviation, toWeekdayAbbreviation: toWeekdayAbbreviation};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.toAmPm(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[$elm$time$Time$Jan, $elm$time$Time$Feb, $elm$time$Time$Mar, $elm$time$Time$Apr, $elm$time$Time$May, $elm$time$Time$Jun, $elm$time$Time$Jul, $elm$time$Time$Aug, $elm$time$Time$Sep, $elm$time$Time$Oct, $elm$time$Time$Nov, $elm$time$Time$Dec]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, $elm$time$Time$Jan),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[$elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat]);
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, $elm$time$Time$Sun),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 'MonthNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthNameAbbreviated':
				return language.toMonthAbbreviation(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'MonthNameFull':
				return language.toMonthName(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'QuarterNumber':
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 'QuarterSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 'DayOfMonthNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfMonthSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfMonthFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfYearNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfYearSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfYearFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfWeekNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 'DayOfWeekSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 'DayOfWeekNameAbbreviated':
				return language.toWeekdayAbbreviation(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 'DayOfWeekNameFull':
				return language.toWeekdayName(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 'WeekOfYearNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 'WeekOfYearSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 'WeekOfYearFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 'YearNumberLastTwo':
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 'YearNumber':
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 'AmPmUppercase':
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 'AmPmLowercase':
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 'HourMilitaryNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 'HourMilitaryFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 'HourNumber':
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'HourFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'HourMilitaryFromOneNumber':
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'HourMilitaryFromOneFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'MinuteNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 'MinuteFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 'SecondNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 'SecondFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 'MillisecondNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 'MillisecondFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$MonthNumber = {$: 'MonthNumber'};
var $ryan_haskell$date_format$DateFormat$monthNumber = $ryan_haskell$date_format$DateFormat$MonthNumber;
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 'DayOfMonthNumber'};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $terezka$elm_charts$Internal$Svg$formatDate = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNumber,
			$ryan_haskell$date_format$DateFormat$text('/'),
			$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
		]));
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 'YearNumber'};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $terezka$elm_charts$Internal$Svg$formatYear = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$yearNumber]));
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 'MinuteFixed'};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 'HourMilitaryFixed'};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $terezka$elm_charts$Internal$Svg$formatClock = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 'MonthNameAbbreviated'};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $terezka$elm_charts$Internal$Svg$formatMonth = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$monthNameAbbreviated]));
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull = {$: 'DayOfWeekNameFull'};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameFull = $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull;
var $terezka$elm_charts$Internal$Svg$formatWeekday = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull]));
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 'SecondFixed'};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $ryan_haskell$date_format$DateFormat$MillisecondFixed = {$: 'MillisecondFixed'};
var $ryan_haskell$date_format$DateFormat$millisecondFixed = $ryan_haskell$date_format$DateFormat$MillisecondFixed;
var $terezka$elm_charts$Internal$Svg$formatClockMillis = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$secondFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$millisecondFixed
		]));
var $terezka$elm_charts$Internal$Svg$formatClockSecond = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$secondFixed
		]));
var $terezka$elm_charts$Internal$Svg$formatTime = F2(
	function (zone, time) {
		var _v0 = A2($elm$core$Maybe$withDefault, time.unit, time.change);
		switch (_v0.$) {
			case 'Millisecond':
				return A2($terezka$elm_charts$Internal$Svg$formatClockMillis, zone, time.timestamp);
			case 'Second':
				return A2($terezka$elm_charts$Internal$Svg$formatClockSecond, zone, time.timestamp);
			case 'Minute':
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.timestamp);
			case 'Hour':
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.timestamp);
			case 'Day':
				return (time.multiple === 7) ? A2($terezka$elm_charts$Internal$Svg$formatWeekday, zone, time.timestamp) : A2($terezka$elm_charts$Internal$Svg$formatDate, zone, time.timestamp);
			case 'Month':
				return A2($terezka$elm_charts$Internal$Svg$formatMonth, zone, time.timestamp);
			default:
				return A2($terezka$elm_charts$Internal$Svg$formatYear, zone, time.timestamp);
		}
	});
var $terezka$elm_charts$Chart$Svg$formatTime = $terezka$elm_charts$Internal$Svg$formatTime;
var $terezka$elm_charts$Chart$generateValues = F4(
	function (amount, tick, maybeFormat, axis) {
		var toTickValues = F2(
			function (toValue, toString) {
				return $elm$core$List$map(
					function (i) {
						return {
							label: function () {
								if (maybeFormat.$ === 'Just') {
									var formatter = maybeFormat.a;
									return formatter(
										toValue(i));
								} else {
									return toString(i);
								}
							}(),
							value: toValue(i)
						};
					});
			});
		switch (tick.$) {
			case 'Floats':
				return A3(
					toTickValues,
					$elm$core$Basics$identity,
					$elm$core$String$fromFloat,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$floats, axis));
			case 'Ints':
				return A3(
					toTickValues,
					$elm$core$Basics$toFloat,
					$elm$core$String$fromInt,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$ints, axis));
			default:
				var zone = tick.a;
				return A3(
					toTickValues,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$toFloat, $elm$time$Time$posixToMillis),
						function ($) {
							return $.timestamp;
						}),
					$terezka$elm_charts$Chart$Svg$formatTime(zone),
					A3(
						$terezka$elm_charts$Chart$Svg$generate,
						amount,
						$terezka$elm_charts$Chart$Svg$times(zone),
						axis));
		}
	});
var $terezka$elm_charts$Chart$xLabels = function (edits) {
	var toConfig = function (p) {
		return A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{flip: false, grid: false, xOff: 0, yOff: 18, attrs: _List_Nil, color: '#808BAB', amount: 5, anchor: $elm$core$Maybe$Nothing, format: $elm$core$Maybe$Nothing, limits: _List_Nil, pinned: $terezka$elm_charts$Chart$Attributes$zero, rotate: 0, ellipsis: $elm$core$Maybe$Nothing, fontSize: $elm$core$Maybe$Nothing, generate: $terezka$elm_charts$Internal$Svg$Floats, uppercase: false, hideOverflow: false});
	};
	var toTicks = F2(
		function (p, config) {
			return A4(
				$terezka$elm_charts$Chart$generateValues,
				config.amount,
				config.generate,
				config.format,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.limits, p.x));
		});
	var toTickValues = F3(
		function (p, config, ts) {
			return (!config.grid) ? ts : _Utils_update(
				ts,
				{
					xs: _Utils_ap(
						ts.xs,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.value;
							},
							A2(toTicks, p, config)))
				});
		});
	return A3(
		$terezka$elm_charts$Chart$LabelsElement,
		toConfig,
		toTickValues,
		F2(
			function (p, config) {
				var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
				var toLabel = function (item) {
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						_Utils_update(
							_default,
							{
								xOff: config.xOff,
								yOff: config.flip ? ((-config.yOff) + 10) : config.yOff,
								attrs: config.attrs,
								color: config.color,
								anchor: config.anchor,
								rotate: config.rotate,
								ellipsis: config.ellipsis,
								fontSize: config.fontSize,
								uppercase: config.uppercase,
								hideOverflow: config.hideOverflow
							}),
						_List_fromArray(
							[
								$elm$svg$Svg$text(item.label)
							]),
						{
							x: item.value,
							y: config.pinned(p.y)
						});
				};
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__x-labels')
						]),
					A2(
						$elm$core$List$map,
						toLabel,
						A2(toTicks, p, config)));
			}));
};
var $author$project$Views$ActivityChart$LogDatum = function (a) {
	return {$: 'LogDatum', a: a};
};
var $terezka$elm_charts$Chart$Attributes$fontSize = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{
					fontSize: $elm$core$Maybe$Just(v)
				});
		});
};
var $terezka$elm_charts$Chart$Attributes$withGrid = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{grid: true});
	});
var $author$project$Views$ActivityChart$OnMouseUp = function (a) {
	return {$: 'OnMouseUp', a: a};
};
var $author$project$Views$ActivityChart$dragState = function (model) {
	var _v0 = _Utils_Tuple2(model.dragStart, model.mousePosition);
	if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
		var s = _v0.a.a;
		var e = _v0.b.a;
		return ($elm$core$Basics$abs(s.x - e.x) >= 600.0) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(s, e)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $terezka$elm_charts$Internal$Events$getCoords = $terezka$elm_charts$Internal$Events$Decoder(
	F3(
		function (_v0, plane, searched) {
			return searched;
		}));
var $terezka$elm_charts$Chart$Events$getCoords = $terezka$elm_charts$Internal$Events$getCoords;
var $terezka$elm_charts$Internal$Svg$closestPoint = F2(
	function (pos, searched) {
		return {
			x: A3($elm$core$Basics$clamp, pos.x1, pos.x2, searched.x),
			y: A3($elm$core$Basics$clamp, pos.y1, pos.y2, searched.y)
		};
	});
var $terezka$elm_charts$Internal$Svg$distanceX = F3(
	function (plane, searched, point) {
		return $elm$core$Basics$abs(
			A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, point.x) - A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, searched.x));
	});
var $terezka$elm_charts$Internal$Svg$distanceY = F3(
	function (plane, searched, point) {
		return $elm$core$Basics$abs(
			A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, point.y) - A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, searched.y));
	});
var $terezka$elm_charts$Internal$Svg$distanceSquared = F3(
	function (plane, searched, point) {
		return A2(
			$elm$core$Basics$pow,
			A3($terezka$elm_charts$Internal$Svg$distanceX, plane, searched, point),
			2) + A2(
			$elm$core$Basics$pow,
			A3($terezka$elm_charts$Internal$Svg$distanceY, plane, searched, point),
			2);
	});
var $terezka$elm_charts$Internal$Svg$withinRadius = F4(
	function (plane, radius, searched, point) {
		return _Utils_cmp(
			A3($terezka$elm_charts$Internal$Svg$distanceSquared, plane, searched, point),
			A2($elm$core$Basics$pow, radius, 2)) < 1;
	});
var $terezka$elm_charts$Internal$Svg$keepOne = function (toPosition) {
	var toArea = function (a) {
		return function (pos) {
			return (pos.x1 - pos.x2) * (pos.y1 - pos.y2);
		}(
			toPosition(a));
	};
	var func = F2(
		function (one, acc) {
			var _v0 = $elm$core$List$head(acc);
			if (_v0.$ === 'Nothing') {
				return _List_fromArray(
					[one]);
			} else {
				var other = _v0.a;
				return _Utils_eq(
					toPosition(other),
					toPosition(one)) ? A2($elm$core$List$cons, other, acc) : ((_Utils_cmp(
					toArea(other),
					toArea(one)) > 0) ? _List_fromArray(
					[one]) : acc);
			}
		});
	return A2($elm$core$List$foldr, func, _List_Nil);
};
var $terezka$elm_charts$Internal$Svg$getNearestHelp = F4(
	function (toPosition, items, plane, searched) {
		var distanceSquared_ = A2($terezka$elm_charts$Internal$Svg$distanceSquared, plane, searched);
		var toPoint = function (i) {
			return A2(
				$terezka$elm_charts$Internal$Svg$closestPoint,
				toPosition(i),
				searched);
		};
		var getClosest = F2(
			function (item, allClosest) {
				var _v0 = $elm$core$List$head(allClosest);
				if (_v0.$ === 'Just') {
					var closest = _v0.a;
					return _Utils_eq(
						toPoint(closest),
						toPoint(item)) ? A2($elm$core$List$cons, item, allClosest) : ((_Utils_cmp(
						distanceSquared_(
							toPoint(closest)),
						distanceSquared_(
							toPoint(item))) > 0) ? _List_fromArray(
						[item]) : allClosest);
				} else {
					return _List_fromArray(
						[item]);
				}
			});
		return A2(
			$terezka$elm_charts$Internal$Svg$keepOne,
			toPosition,
			A3($elm$core$List$foldl, getClosest, _List_Nil, items));
	});
var $terezka$elm_charts$Internal$Svg$getWithin = F5(
	function (radius, toPosition, items, plane, searched) {
		var toPoint = function (i) {
			return A2(
				$terezka$elm_charts$Internal$Svg$closestPoint,
				toPosition(i),
				searched);
		};
		var keepIfEligible = function (closest) {
			return A4(
				$terezka$elm_charts$Internal$Svg$withinRadius,
				plane,
				radius,
				searched,
				toPoint(closest));
		};
		return A2(
			$elm$core$List$filter,
			keepIfEligible,
			A4($terezka$elm_charts$Internal$Svg$getNearestHelp, toPosition, items, plane, searched));
	});
var $terezka$elm_charts$Internal$Events$getWithin = F2(
	function (radius, grouping) {
		var toPos = grouping.a;
		return $terezka$elm_charts$Internal$Events$Decoder(
			F2(
				function (items, plane) {
					var groups = A2($terezka$elm_charts$Internal$Many$apply, grouping, items);
					return A4(
						$terezka$elm_charts$Internal$Svg$getWithin,
						radius,
						toPos(plane),
						groups,
						plane);
				}));
	});
var $terezka$elm_charts$Chart$Events$getWithin = $terezka$elm_charts$Internal$Events$getWithin;
var $terezka$elm_charts$Internal$Events$Event = function (a) {
	return {$: 'Event', a: a};
};
var $terezka$elm_charts$Internal$Events$on = F2(
	function (name, decoder) {
		return $terezka$elm_charts$Internal$Helpers$Attribute(
			function (config) {
				return _Utils_update(
					config,
					{
						events: A2(
							$elm$core$List$cons,
							$terezka$elm_charts$Internal$Events$Event(
								{name: name, decoder: decoder}),
							config.events)
					});
			});
	});
var $terezka$elm_charts$Chart$Events$on = $terezka$elm_charts$Internal$Events$on;
var $terezka$elm_charts$Chart$Events$onMouseUp = F2(
	function (onMsg, decoder) {
		return A2(
			$terezka$elm_charts$Chart$Events$on,
			'mouseup',
			A2($terezka$elm_charts$Chart$Events$map, onMsg, decoder));
	});
var $author$project$Views$ActivityChart$axisMargin = 40;
var $author$project$Views$ActivityChart$bilgeColor = '#f0a202';
var $author$project$Views$ActivityChart$OnMouseDown = function (a) {
	return {$: 'OnMouseDown', a: a};
};
var $author$project$Views$ActivityChart$StartResize = function (a) {
	return {$: 'StartResize', a: a};
};
var $terezka$elm_charts$Chart$Events$onMouseDown = F2(
	function (onMsg, decoder) {
		return A2(
			$terezka$elm_charts$Chart$Events$on,
			'mousedown',
			A2($terezka$elm_charts$Chart$Events$map, onMsg, decoder));
	});
var $terezka$elm_charts$Chart$Events$onMouseMove = F2(
	function (onMsg, decoder) {
		return A2(
			$terezka$elm_charts$Chart$Events$on,
			'mousemove',
			A2($terezka$elm_charts$Chart$Events$map, onMsg, decoder));
	});
var $author$project$Views$ActivityChart$ToggleExpand = {$: 'ToggleExpand'};
var $terezka$elm_charts$Chart$rect = function (attrs) {
	return $terezka$elm_charts$Chart$SvgElement(
		function (p) {
			return A2($terezka$elm_charts$Chart$Svg$rect, p, attrs);
		});
};
var $terezka$elm_charts$Chart$Attributes$opacity = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{opacity: v});
		});
};
var $terezka$elm_charts$Chart$Attributes$borderWidth = function (v) {
	return $terezka$elm_charts$Internal$Helpers$Attribute(
		function (config) {
			return _Utils_update(
				config,
				{borderWidth: v});
		});
};
var $author$project$Views$ActivityChart$posixToFloat = function (posix) {
	return $elm$time$Time$posixToMillis(posix);
};
var $author$project$Views$ActivityChart$activityBand = F4(
	function (minSpanMillis, color, opacity, period) {
		var x2 = $author$project$Views$ActivityChart$posixToFloat(period.end);
		var x1 = $author$project$Views$ActivityChart$posixToFloat(period.start);
		var _v0 = function () {
			if (_Utils_cmp(x2 - x1, minSpanMillis) < 0) {
				var centre = (x1 + x2) / 2;
				return _Utils_Tuple2(centre - (minSpanMillis / 2), centre + (minSpanMillis / 2));
			} else {
				return _Utils_Tuple2(x1, x2);
			}
		}();
		var bandX1 = _v0.a;
		var bandX2 = _v0.b;
		return $terezka$elm_charts$Chart$rect(
			_List_fromArray(
				[
					$terezka$elm_charts$Chart$Attributes$x1(bandX1),
					$terezka$elm_charts$Chart$Attributes$x2(bandX2),
					$terezka$elm_charts$Chart$Attributes$color(color),
					$terezka$elm_charts$Chart$Attributes$opacity(opacity),
					$terezka$elm_charts$Chart$Attributes$border('transparent'),
					$terezka$elm_charts$Chart$Attributes$borderWidth(0)
				]));
	});
var $author$project$Views$ActivityChart$floatToPosix = function (milliseconds) {
	return $elm$time$Time$millisToPosix(
		$elm$core$Basics$round(milliseconds));
};
var $terezka$elm_charts$Chart$Events$onMouseLeave = function (onMsg) {
	return A2(
		$terezka$elm_charts$Chart$Events$on,
		'mouseleave',
		A2(
			$terezka$elm_charts$Chart$Events$map,
			$elm$core$Basics$always(onMsg),
			$terezka$elm_charts$Chart$Events$getCoords));
};
var $author$project$Views$ActivityChart$ActivityDatum = function (a) {
	return {$: 'ActivityDatum', a: a};
};
var $mdgriffith$elm_animator$Internal$Interpolate$unwrapUnits = function (_v0) {
	var velocity = _v0.velocity;
	var position = _v0.position;
	return {
		position: function () {
			var val = position.a;
			return val;
		}(),
		velocity: function () {
			var val = velocity.a;
			return val;
		}()
	};
};
var $mdgriffith$elm_animator$Internal$Interpolate$details = F2(
	function (timeline, lookup) {
		return $mdgriffith$elm_animator$Internal$Interpolate$unwrapUnits(
			A3($mdgriffith$elm_animator$Internal$Timeline$foldp, lookup, $mdgriffith$elm_animator$Internal$Interpolate$moving, timeline));
	});
var $mdgriffith$elm_animator$Animator$move = F2(
	function (timeline, lookup) {
		return A2(
			$mdgriffith$elm_animator$Internal$Interpolate$details,
			timeline,
			A2($elm$core$Basics$composeL, $mdgriffith$elm_animator$Internal$Interpolate$withStandardDefault, lookup)).position;
	});
var $author$project$Views$ActivityChart$currentHeight = function (model) {
	return A2($mdgriffith$elm_animator$Animator$move, model.heightState, $mdgriffith$elm_animator$Animator$at);
};
var $author$project$Views$ActivityChart$formatVoltage = function (v) {
	return $elm$core$String$fromFloat(
		$elm$core$Basics$round(v * 10) / 10) + 'v';
};
var $author$project$Data$Log$severityColor = function (severity) {
	switch (severity.$) {
		case 'Danger':
			return '#f84e4e';
		case 'Warning':
			return '#ffd042';
		default:
			return '#d9e2ec';
	}
};
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $terezka$elm_charts$Internal$Interpolation$linear = $elm$core$List$map(
	$elm$core$List$map(
		function (_v0) {
			var y = _v0.y;
			var x = _v0.x;
			return A2($terezka$elm_charts$Internal$Commands$Line, x, y);
		}));
var $terezka$elm_charts$Internal$Interpolation$Point = F2(
	function (x, y) {
		return {x: x, y: y};
	});
var $terezka$elm_charts$Internal$Interpolation$after = F2(
	function (a, b) {
		return _List_fromArray(
			[
				a,
				A2($terezka$elm_charts$Internal$Interpolation$Point, b.x, a.y),
				b
			]);
	});
var $terezka$elm_charts$Internal$Interpolation$stepped = function (sections) {
	var expand = F2(
		function (result, section) {
			expand:
			while (true) {
				if (section.b) {
					if (section.b.b) {
						var a = section.a;
						var _v1 = section.b;
						var b = _v1.a;
						var rest = _v1.b;
						var $temp$result = _Utils_ap(
							result,
							A2($terezka$elm_charts$Internal$Interpolation$after, a, b)),
							$temp$section = A2($elm$core$List$cons, b, rest);
						result = $temp$result;
						section = $temp$section;
						continue expand;
					} else {
						var last = section.a;
						return result;
					}
				} else {
					return result;
				}
			}
		});
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			expand(_List_Nil),
			$elm$core$List$map(
				function (_v2) {
					var y = _v2.y;
					var x = _v2.x;
					return A2($terezka$elm_charts$Internal$Commands$Line, x, y);
				})),
		sections);
};
var $terezka$elm_charts$Internal$Interpolation$First = {$: 'First'};
var $terezka$elm_charts$Internal$Interpolation$slope2 = F3(
	function (point0, point1, t) {
		var h = point1.x - point0.x;
		return (!(!h)) ? ((((3 * (point1.y - point0.y)) / h) - t) / 2) : t;
	});
var $terezka$elm_charts$Internal$Interpolation$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $terezka$elm_charts$Internal$Interpolation$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $terezka$elm_charts$Internal$Interpolation$slope3 = F3(
	function (point0, point1, point2) {
		var h1 = point2.x - point1.x;
		var h0 = point1.x - point0.x;
		var s0h = A2($terezka$elm_charts$Internal$Interpolation$toH, h0, h1);
		var s0 = (point1.y - point0.y) / s0h;
		var s1h = A2($terezka$elm_charts$Internal$Interpolation$toH, h1, h0);
		var s1 = (point2.y - point1.y) / s1h;
		var p = ((s0 * h1) + (s1 * h0)) / (h0 + h1);
		var slope = ($terezka$elm_charts$Internal$Interpolation$sign(s0) + $terezka$elm_charts$Internal$Interpolation$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
		return $elm$core$Basics$isNaN(slope) ? 0 : slope;
	});
var $terezka$elm_charts$Internal$Interpolation$Previous = function (a) {
	return {$: 'Previous', a: a};
};
var $terezka$elm_charts$Internal$Interpolation$monotoneCurve = F4(
	function (point0, point1, tangent0, tangent1) {
		var dx = (point1.x - point0.x) / 3;
		return A6($terezka$elm_charts$Internal$Commands$CubicBeziers, point0.x + dx, point0.y + (dx * tangent0), point1.x - dx, point1.y - (dx * tangent1), point1.x, point1.y);
	});
var $terezka$elm_charts$Internal$Interpolation$monotonePart = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var commands = _v0.b;
		var _v1 = _Utils_Tuple2(tangent, points);
		_v1$4:
		while (true) {
			if (_v1.a.$ === 'First') {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var p0 = _v3.a;
						var _v4 = _v3.b;
						var p1 = _v4.a;
						var _v5 = _v4.b;
						var p2 = _v5.a;
						var rest = _v5.b;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p2);
						var t0 = A3($terezka$elm_charts$Internal$Interpolation$slope2, p0, p1, t1);
						return A2(
							$terezka$elm_charts$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$terezka$elm_charts$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var _v9 = _v1.a;
						var _v10 = _v1.b;
						var p0 = _v10.a;
						var _v11 = _v10.b;
						var p1 = _v11.a;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$terezka$elm_charts$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t1, t1),
										A2($terezka$elm_charts$Internal$Commands$Line, p1.x, p1.y)
									])));
					}
				} else {
					break _v1$4;
				}
			} else {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var t0 = _v1.a.a;
						var _v6 = _v1.b;
						var p0 = _v6.a;
						var _v7 = _v6.b;
						var p1 = _v7.a;
						var _v8 = _v7.b;
						var p2 = _v8.a;
						var rest = _v8.b;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p2);
						return A2(
							$terezka$elm_charts$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$terezka$elm_charts$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var t0 = _v1.a.a;
						var _v12 = _v1.b;
						var p0 = _v12.a;
						var _v13 = _v12.b;
						var p1 = _v13.a;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$terezka$elm_charts$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1),
										A2($terezka$elm_charts$Internal$Commands$Line, p1.x, p1.y)
									])));
					}
				} else {
					break _v1$4;
				}
			}
		}
		return _Utils_Tuple2(tangent, commands);
	});
var $terezka$elm_charts$Internal$Interpolation$monotoneSection = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var acc = _v0.b;
		var _v1 = function () {
			if (points.b) {
				var p0 = points.a;
				var rest = points.b;
				return A2(
					$terezka$elm_charts$Internal$Interpolation$monotonePart,
					A2($elm$core$List$cons, p0, rest),
					_Utils_Tuple2(
						tangent,
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Line, p0.x, p0.y)
							])));
			} else {
				return _Utils_Tuple2(tangent, _List_Nil);
			}
		}();
		var t0 = _v1.a;
		var commands = _v1.b;
		return _Utils_Tuple2(
			t0,
			A2($elm$core$List$cons, commands, acc));
	});
var $terezka$elm_charts$Internal$Interpolation$monotone = function (sections) {
	return A3(
		$elm$core$List$foldr,
		$terezka$elm_charts$Internal$Interpolation$monotoneSection,
		_Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$First, _List_Nil),
		sections).b;
};
var $terezka$elm_charts$Internal$Svg$last = function (list) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$drop,
			$elm$core$List$length(list) - 1,
			list));
};
var $terezka$elm_charts$Internal$Svg$withBorder = F2(
	function (stuff, func) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return $elm$core$Maybe$Just(
				A2(
					func,
					first,
					A2(
						$elm$core$Maybe$withDefault,
						first,
						$terezka$elm_charts$Internal$Svg$last(rest))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $terezka$elm_charts$Internal$Svg$toCommands = F4(
	function (method, toX, toY, data) {
		var toSets = F2(
			function (ps, cmds) {
				return A2(
					$terezka$elm_charts$Internal$Svg$withBorder,
					ps,
					F2(
						function (first, last_) {
							return _Utils_Tuple3(first, cmds, last_);
						}));
			});
		var fold = F2(
			function (datum_, acc) {
				var _v1 = toY(datum_);
				if (_v1.$ === 'Just') {
					var y_ = _v1.a;
					if (acc.b) {
						var latest = acc.a;
						var rest = acc.b;
						return A2(
							$elm$core$List$cons,
							_Utils_ap(
								latest,
								_List_fromArray(
									[
										{
										x: toX(datum_),
										y: y_
									}
									])),
							rest);
					} else {
						return A2(
							$elm$core$List$cons,
							_List_fromArray(
								[
									{
									x: toX(datum_),
									y: y_
								}
								]),
							acc);
					}
				} else {
					return A2($elm$core$List$cons, _List_Nil, acc);
				}
			});
		var points = $elm$core$List$reverse(
			A3($elm$core$List$foldl, fold, _List_Nil, data));
		var commands = function () {
			switch (method.$) {
				case 'Linear':
					return $terezka$elm_charts$Internal$Interpolation$linear(points);
				case 'Monotone':
					return $terezka$elm_charts$Internal$Interpolation$monotone(points);
				default:
					return $terezka$elm_charts$Internal$Interpolation$stepped(points);
			}
		}();
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A3($elm$core$List$map2, toSets, points, commands));
	});
var $terezka$elm_charts$Internal$Svg$area = F6(
	function (plane, toX, toY2M, toY, config, data) {
		var _v0 = function () {
			var _v1 = config.design;
			if (_v1.$ === 'Nothing') {
				return _Utils_Tuple2(
					$elm$svg$Svg$text(''),
					config.color);
			} else {
				var design = _v1.a;
				return A2($terezka$elm_charts$Internal$Svg$toPattern, config.color, design);
			}
		}();
		var patternDefs = _v0.a;
		var fill = _v0.b;
		var view = function (cmds) {
			return A4(
				$terezka$elm_charts$Internal$Svg$withAttrs,
				config.attrs,
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__area-section'),
						$elm$svg$Svg$Attributes$fill(fill),
						$elm$svg$Svg$Attributes$fillOpacity(
						$elm$core$String$fromFloat(config.opacity)),
						$elm$svg$Svg$Attributes$strokeWidth('0'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d(
						A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
						$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
					]),
				_List_Nil);
		};
		var withUnder = F2(
			function (_v5, _v6) {
				var firstBottom = _v5.a;
				var cmdsBottom = _v5.b;
				var endBottom = _v5.c;
				var firstTop = _v6.a;
				var cmdsTop = _v6.b;
				var endTop = _v6.c;
				return view(
					_Utils_ap(
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Move, firstBottom.x, firstBottom.y),
								A2($terezka$elm_charts$Internal$Commands$Line, firstTop.x, firstTop.y)
							]),
						_Utils_ap(
							cmdsTop,
							_Utils_ap(
								_List_fromArray(
									[
										A2($terezka$elm_charts$Internal$Commands$Move, firstBottom.x, firstBottom.y)
									]),
								_Utils_ap(
									cmdsBottom,
									_List_fromArray(
										[
											A2($terezka$elm_charts$Internal$Commands$Line, endTop.x, endTop.y)
										]))))));
			});
		var withoutUnder = function (_v4) {
			var first = _v4.a;
			var cmds = _v4.b;
			var end = _v4.c;
			return view(
				_Utils_ap(
					_List_fromArray(
						[
							A2($terezka$elm_charts$Internal$Commands$Move, first.x, 0),
							A2($terezka$elm_charts$Internal$Commands$Line, first.x, first.y)
						]),
					_Utils_ap(
						cmds,
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Line, end.x, 0)
							]))));
		};
		if (config.opacity <= 0) {
			return $elm$svg$Svg$text('');
		} else {
			var _v2 = config.method;
			if (_v2.$ === 'Nothing') {
				return $elm$svg$Svg$text('');
			} else {
				var method = _v2.a;
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__area-sections')
						]),
					function () {
						if (toY2M.$ === 'Nothing') {
							return A2(
								$elm$core$List$cons,
								patternDefs,
								A2(
									$elm$core$List$map,
									withoutUnder,
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
						} else {
							var toY2 = toY2M.a;
							return A2(
								$elm$core$List$cons,
								patternDefs,
								A3(
									$elm$core$List$map2,
									withUnder,
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY2, data),
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
						}
					}());
			}
		}
	});
var $terezka$elm_charts$Internal$Helpers$noChange = $terezka$elm_charts$Internal$Helpers$Attribute($elm$core$Basics$identity);
var $terezka$elm_charts$Internal$Svg$toRadius = F2(
	function (size_, shape) {
		var area_ = (2 * $elm$core$Basics$pi) * size_;
		switch (shape.$) {
			case 'Circle':
				return $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
			case 'Triangle':
				var side = $elm$core$Basics$sqrt(
					(area_ * 4) / $elm$core$Basics$sqrt(3));
				return $elm$core$Basics$sqrt(3) * side;
			case 'Square':
				return $elm$core$Basics$sqrt(area_) / 2;
			case 'Diamond':
				return $elm$core$Basics$sqrt(area_) / 2;
			case 'Cross':
				return $elm$core$Basics$sqrt(area_ / 4);
			default:
				return $elm$core$Basics$sqrt(area_ / 4);
		}
	});
var $terezka$elm_charts$Internal$Svg$interpolation = F5(
	function (plane, toX, toY, config, data) {
		var view = function (_v1) {
			var first = _v1.a;
			var cmds = _v1.b;
			return A4(
				$terezka$elm_charts$Internal$Svg$withAttrs,
				config.attrs,
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__interpolation-section'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$stroke(config.color),
						$elm$svg$Svg$Attributes$strokeDasharray(
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, config.dashed))),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromFloat(config.width)),
						$elm$svg$Svg$Attributes$d(
						A2(
							$terezka$elm_charts$Internal$Commands$description,
							plane,
							A2(
								$elm$core$List$cons,
								A2($terezka$elm_charts$Internal$Commands$Move, first.x, first.y),
								cmds))),
						$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
					]),
				_List_Nil);
		};
		var _v0 = config.method;
		if (_v0.$ === 'Nothing') {
			return $elm$svg$Svg$text('');
		} else {
			var method = _v0.a;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__interpolation-sections')
					]),
				A2(
					$elm$core$List$map,
					view,
					A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
		}
	});
var $terezka$elm_charts$Internal$Svg$defaultInterpolation = {attrs: _List_Nil, color: $terezka$elm_charts$Internal$Helpers$pink, width: 1, dashed: _List_Nil, design: $elm$core$Maybe$Nothing, method: $elm$core$Maybe$Nothing, opacity: 0};
var $terezka$elm_charts$Internal$Produce$toDotSeries = F4(
	function (elementIndex, toX, properties, data) {
		var forEachDataPoint = F9(
			function (absoluteIndex, stackSeriesConfigIndex, lineSeriesConfigIndex, lineSeriesConfig, interpolationConfig, defaultColor, defaultOpacity, dataIndex, datum) {
				var identification = {dataIndex: dataIndex, stackIndex: stackSeriesConfigIndex, seriesIndex: lineSeriesConfigIndex, elementIndex: elementIndex, absoluteIndex: absoluteIndex};
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(interpolationConfig.color),
						$terezka$elm_charts$Chart$Attributes$border(interpolationConfig.color),
						_Utils_eq(interpolationConfig.method, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $terezka$elm_charts$Internal$Helpers$noChange
					]);
				var dotAttrs = _Utils_ap(
					defaultAttrs,
					_Utils_ap(
						lineSeriesConfig.presentation,
						A2(lineSeriesConfig.variation, identification, datum)));
				var dotConfig = A2($terezka$elm_charts$Internal$Helpers$apply, dotAttrs, $terezka$elm_charts$Internal$Svg$defaultDot);
				var tooltipTextColor = (dotConfig.color === 'white') ? ((dotConfig.border === 'white') ? interpolationConfig.color : dotConfig.border) : dotConfig.color;
				var radius = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$terezka$elm_charts$Internal$Svg$toRadius(dotConfig.size),
						dotConfig.shape));
				var y = A2(
					$elm$core$Maybe$withDefault,
					0,
					lineSeriesConfig.toYSum(datum));
				var x = toX(datum);
				return A2(
					$terezka$elm_charts$Internal$Item$Rendered,
					{
						y: y,
						x1: x,
						x2: x,
						name: lineSeriesConfig.tooltipName,
						color: tooltipTextColor,
						datum: datum,
						toAny: $terezka$elm_charts$Internal$Item$Dot,
						isReal: !_Utils_eq(
							lineSeriesConfig.toY(datum),
							$elm$core$Maybe$Nothing),
						tooltipText: lineSeriesConfig.tooltipText(datum),
						presentation: dotConfig,
						identification: identification
					},
					{
						limits: {x1: x, x2: x, y1: y, y2: y},
						render: F2(
							function (plane, _v5) {
								var _v6 = lineSeriesConfig.toY(datum);
								if (_v6.$ === 'Nothing') {
									return $elm$svg$Svg$text('');
								} else {
									return A5(
										$terezka$elm_charts$Internal$Svg$dot,
										plane,
										function ($) {
											return $.x;
										},
										function ($) {
											return $.y;
										},
										dotConfig,
										{x: x, y: y});
								}
							}),
						tooltip: function (_v7) {
							return _List_fromArray(
								[
									A3(
									$terezka$elm_charts$Internal$Produce$tooltipRow,
									tooltipTextColor,
									A2($terezka$elm_charts$Internal$Produce$toDefaultName, identification, lineSeriesConfig.tooltipName),
									lineSeriesConfig.tooltipText(datum))
								]);
						},
						toPosition: function (plane) {
							var radiusY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, radius);
							var radiusX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, radius);
							return {x1: x - radiusX, x2: x + radiusX, y1: y - radiusY, y2: y + radiusY};
						}
					});
			});
		var forEachLine = F5(
			function (isStacked, absoluteIndex, stackSeriesConfigIndex, lineSeriesConfigIndex, lineSeriesConfig) {
				var absoluteIndexNew = absoluteIndex + lineSeriesConfigIndex;
				var defaultOpacity = isStacked ? 0.4 : 0;
				var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefaultColor(absoluteIndexNew);
				var interpolationAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(defaultColor),
						$terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
					]);
				var interpolationConfig = A2(
					$terezka$elm_charts$Internal$Helpers$apply,
					_Utils_ap(interpolationAttrs, lineSeriesConfig.interpolation),
					$terezka$elm_charts$Internal$Svg$defaultInterpolation);
				var dotItems = A2(
					$elm$core$List$indexedMap,
					A7(forEachDataPoint, absoluteIndexNew, stackSeriesConfigIndex, lineSeriesConfigIndex, lineSeriesConfig, interpolationConfig, defaultColor, defaultOpacity),
					data);
				var viewSeries = function (plane) {
					var toBottom = function (datum) {
						return A3(
							$elm$core$Maybe$map2,
							F2(
								function (y, ySum) {
									return ySum - y;
								}),
							lineSeriesConfig.toY(datum),
							lineSeriesConfig.toYSum(datum));
					};
					return A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('elm-charts__series')
							]),
						_List_fromArray(
							[
								A6(
								$terezka$elm_charts$Internal$Svg$area,
								plane,
								toX,
								$elm$core$Maybe$Just(toBottom),
								lineSeriesConfig.toYSum,
								interpolationConfig,
								data),
								A5($terezka$elm_charts$Internal$Svg$interpolation, plane, toX, lineSeriesConfig.toYSum, interpolationConfig, data),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('elm-charts__dots')
									]),
								A2(
									$elm$core$List$map,
									$terezka$elm_charts$Internal$Item$render(plane),
									dotItems))
							]));
				};
				return A2(
					$terezka$elm_charts$Internal$Helpers$withFirst,
					dotItems,
					F2(
						function (first, rest) {
							return A2(
								$terezka$elm_charts$Internal$Item$Rendered,
								_Utils_Tuple2(first, rest),
								{
									limits: A2($terezka$elm_charts$Internal$Coordinates$foldPosition, $terezka$elm_charts$Internal$Item$getLimits, dotItems),
									render: F2(
										function (plane, _v3) {
											return viewSeries(plane);
										}),
									tooltip: function (_v4) {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$table,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'margin', '0')
													]),
												A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Item$tooltip, dotItems))
											]);
									},
									toPosition: function (plane) {
										return A2(
											$terezka$elm_charts$Internal$Coordinates$foldPosition,
											$terezka$elm_charts$Internal$Item$getPosition(plane),
											dotItems);
									}
								});
						}));
			});
		var forEachStackSeriesConfig = F2(
			function (stackSeriesConfig, _v2) {
				var absoluteIndex = _v2.a;
				var stackSeriesConfigIndex = _v2.b;
				var items = _v2.c;
				var lineItems = function () {
					if (stackSeriesConfig.$ === 'NotStacked') {
						var lineSeriesConfig = stackSeriesConfig.a;
						return _List_fromArray(
							[
								A5(forEachLine, false, absoluteIndex, stackSeriesConfigIndex, 0, lineSeriesConfig)
							]);
					} else {
						var lineSeriesConfigs = stackSeriesConfig.a;
						return A2(
							$elm$core$List$indexedMap,
							A3(forEachLine, true, absoluteIndex, stackSeriesConfigIndex),
							lineSeriesConfigs);
					}
				}();
				return _Utils_Tuple3(
					absoluteIndex + $elm$core$List$length(lineItems),
					stackSeriesConfigIndex + 1,
					_Utils_ap(
						items,
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, lineItems)));
			});
		return function (_v0) {
			var items = _v0.c;
			return items;
		}(
			A3(
				$elm$core$List$foldl,
				forEachStackSeriesConfig,
				_Utils_Tuple3(elementIndex, 0, _List_Nil),
				properties));
	});
var $terezka$elm_charts$Internal$Legend$LineLegend = F3(
	function (a, b, c) {
		return {$: 'LineLegend', a: a, b: b, c: c};
	});
var $terezka$elm_charts$Internal$Legend$toDotLegends = F2(
	function (elIndex, properties) {
		var toInterConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultInterpolation);
		};
		var toDotLegend = F3(
			function (props, prop, colorIndex) {
				var defaultOpacity = ($elm$core$List$length(props) > 1) ? 0.4 : 0;
				var defaultName = 'Property #' + $elm$core$String$fromInt(colorIndex + 1);
				var interAttr = _Utils_ap(
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(
							$terezka$elm_charts$Internal$Helpers$toDefaultColor(colorIndex)),
							$terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
						]),
					prop.interpolation);
				var interConfig = toInterConfig(interAttr);
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(interConfig.color),
						$terezka$elm_charts$Chart$Attributes$border(interConfig.color),
						_Utils_eq(interConfig.method, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $terezka$elm_charts$Internal$Helpers$noChange
					]);
				var dotAttrs = _Utils_ap(defaultAttrs, prop.presentation);
				return A3(
					$terezka$elm_charts$Internal$Legend$LineLegend,
					A2($elm$core$Maybe$withDefault, defaultName, prop.tooltipName),
					interAttr,
					dotAttrs);
			});
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (propIndex, f) {
					return f(elIndex + propIndex);
				}),
			A2(
				$elm$core$List$concatMap,
				function (ps) {
					return A2(
						$elm$core$List$map,
						toDotLegend(ps),
						ps);
				},
				A2($elm$core$List$map, $terezka$elm_charts$Internal$Property$toConfigs, properties)));
	});
var $terezka$elm_charts$Chart$SeriesElement = F4(
	function (a, b, c, d) {
		return {$: 'SeriesElement', a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Chart$seriesMap = F4(
	function (mapData, toX, properties, data) {
		return $terezka$elm_charts$Chart$Indexed(
			function (index) {
				var legends_ = A2($terezka$elm_charts$Internal$Legend$toDotLegends, index, properties);
				var items = A4($terezka$elm_charts$Internal$Produce$toDotSeries, index, toX, properties, data);
				var toLimits = A2($elm$core$List$map, $terezka$elm_charts$Internal$Item$getLimits, items);
				var generalized = A2(
					$elm$core$List$map,
					$terezka$elm_charts$Internal$Item$map(mapData),
					A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Many$generalize, items));
				return _Utils_Tuple2(
					A4(
						$terezka$elm_charts$Chart$SeriesElement,
						toLimits,
						generalized,
						legends_,
						function (p) {
							return A2(
								$elm$svg$Svg$map,
								$elm$core$Basics$never,
								A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('elm-charts__dot-series')
										]),
									A2(
										$elm$core$List$map,
										$terezka$elm_charts$Internal$Item$render(p),
										items)));
						}),
					index + $elm$core$List$length(items));
			});
	});
var $author$project$Views$ActivityChart$SignalDatum = function (a) {
	return {$: 'SignalDatum', a: a};
};
var $terezka$elm_charts$Internal$Svg$Linear = {$: 'Linear'};
var $terezka$elm_charts$Chart$Attributes$linear = $terezka$elm_charts$Internal$Helpers$Attribute(
	function (config) {
		return _Utils_update(
			config,
			{
				method: $elm$core$Maybe$Just($terezka$elm_charts$Internal$Svg$Linear)
			});
	});
var $terezka$elm_charts$Chart$interpolated = F2(
	function (y, inter) {
		return A2(
			$terezka$elm_charts$Internal$Property$notStacked,
			A2($elm$core$Basics$composeR, y, $elm$core$Maybe$Just),
			_Utils_ap(
				_List_fromArray(
					[$terezka$elm_charts$Chart$Attributes$linear]),
				inter));
	});
var $author$project$Views$ActivityChart$signalColorAt = function (alpha) {
	return 'rgba(253, 126, 20, ' + ($elm$core$String$fromFloat(alpha) + ')');
};
var $author$project$Views$ActivityChart$signalOverlay = F3(
	function (model, speedTop, alpha) {
		var strengths = A2(
			$elm$core$List$map,
			function ($) {
				return $.signalStrength;
			},
			model.signalStrength);
		var color = $author$project$Views$ActivityChart$signalColorAt(alpha);
		var lo = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$minimum(strengths)) - 1;
		var hi = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(strengths)) + 1;
		var span = hi - lo;
		var scale = function (s) {
			return (span <= 0) ? (speedTop / 2) : (((s - lo) / span) * speedTop);
		};
		return _List_fromArray(
			[
				A4(
				$terezka$elm_charts$Chart$seriesMap,
				$author$project$Views$ActivityChart$SignalDatum,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.timestamp;
					},
					$author$project$Views$ActivityChart$posixToFloat),
				_List_fromArray(
					[
						A3(
						$terezka$elm_charts$Chart$interpolated,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.signalStrength;
							},
							scale),
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(color),
								$terezka$elm_charts$Chart$Attributes$width(1.5),
								$terezka$elm_charts$Chart$Attributes$dashed(
								_List_fromArray(
									[4, 2]))
							]),
						_List_Nil)
					]),
				model.signalStrength)
			]);
	});
var $author$project$Views$ActivityChart$dotHoverRadius = 15;
var $author$project$Views$ActivityChart$expandProgress = function (model) {
	return A2(
		$mdgriffith$elm_animator$Animator$move,
		model.extrasVisible,
		function (visible) {
			return $mdgriffith$elm_animator$Animator$at(
				visible ? 1 : 0);
		});
};
var $author$project$Views$ActivityChart$isPastMidpoint = function (model) {
	return _Utils_cmp(
		$author$project$Views$ActivityChart$currentHeight(model),
		(model.collapsedHeight + model.expandedHeight) / 2) > 0;
};
var $author$project$Views$ActivityChart$VoltageDatum = function (a) {
	return {$: 'VoltageDatum', a: a};
};
var $author$project$Views$ActivityChart$voltageColorAt = function (alpha) {
	return 'rgba(42, 157, 143, ' + ($elm$core$String$fromFloat(alpha) + ')');
};
var $author$project$Views$ActivityChart$voltageOverlay = F3(
	function (model, speedTop, alpha) {
		var voltages = A2(
			$elm$core$List$map,
			function ($) {
				return $.voltage;
			},
			model.voltage);
		var color = $author$project$Views$ActivityChart$voltageColorAt(alpha);
		var lo = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$minimum(voltages)) - 0.2;
		var hi = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(voltages)) + 0.2;
		var span = hi - lo;
		var scale = function (v) {
			return (span <= 0) ? (speedTop / 2) : (((v - lo) / span) * speedTop);
		};
		return _List_fromArray(
			[
				A4(
				$terezka$elm_charts$Chart$seriesMap,
				$author$project$Views$ActivityChart$VoltageDatum,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.timestamp;
					},
					$author$project$Views$ActivityChart$posixToFloat),
				_List_fromArray(
					[
						A3(
						$terezka$elm_charts$Chart$interpolated,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.voltage;
							},
							scale),
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(color),
								$terezka$elm_charts$Chart$Attributes$width(1.5)
							]),
						_List_Nil)
					]),
				model.voltage)
			]);
	});
var $author$project$Views$ActivityChart$secondsPerPixel = F2(
	function (model, width) {
		var totalSeconds = model.end - model.start;
		return totalSeconds / width;
	});
var $author$project$Views$ActivityChart$labelCountForWidth = function (width) {
	return (width < 600) ? 5 : ((width < 1200) ? 10 : 20);
};
var $author$project$Views$ActivityChart$formatSignalStrength = function (s) {
	var rounded = $elm$core$Basics$round(s);
	return $author$project$Data$Boat$gsmSignalStrengthDisplayString(rounded) + (' (' + ($elm$core$String$fromInt(rounded) + ')'));
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$downLeftAndUpRightToCenter = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'down-left-and-up-right-to-center',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272l144 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$downLeftAndUpRightToCenter = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$downLeftAndUpRightToCenter);
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$upRightAndDownLeftFromCenter = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'up-right-and-down-left-from-center',
	_Utils_Tuple2(512, 512),
	_Utils_Tuple2('M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$upRightAndDownLeftFromCenter = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$upRightAndDownLeftFromCenter);
var $author$project$Views$ActivityChart$view = F2(
	function (model, width) {
		var dragTooltipEl = function () {
			var _v7 = $author$project$Views$ActivityChart$dragState(model);
			if (_v7.$ === 'Just') {
				var _v8 = _v7.a;
				var start = _v8.a;
				var end = _v8.b;
				return A6(
					$terezka$elm_charts$Chart$htmlAt,
					$elm$core$Basics$always(end.x),
					$elm$core$Basics$always(end.y),
					0,
					50,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white border border-dark-subtle rounded-1 p-1 small user-select-none')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-secondary')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('From: '),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fw-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$author$project$ISO8601$Extra$toFormattedDateTime,
														model.locale,
														model.zone,
														$jweir$elm_iso8601$ISO8601$fromPosix(
															$author$project$Views$ActivityChart$floatToPosix(start.x))))
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-secondary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('To: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fw-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$author$project$ISO8601$Extra$toFormattedDateTime,
														model.locale,
														model.zone,
														$jweir$elm_iso8601$ISO8601$fromPosix(
															$author$project$Views$ActivityChart$floatToPosix(end.x))))
												]))
										]))
								]))
						]));
			} else {
				var _v9 = _Utils_Tuple2(model.hoveringDot, model.hoveringBar);
				if ((_v9.a.$ === 'Nothing') && (_v9.b.$ === 'Just')) {
					var _v10 = _v9.a;
					var bar = _v9.b.a;
					var _v11 = function () {
						var _v12 = $terezka$elm_charts$Chart$Item$getData(bar);
						switch (_v12.$) {
							case 'ActivityDatum':
								var activity = _v12.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'z-index', '1000'),
											$elm$html$Html$Attributes$class('small')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-secondary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Timestamp: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fw-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$author$project$ISO8601$Extra$toFormattedDateTime,
														model.locale,
														model.zone,
														$jweir$elm_iso8601$ISO8601$fromPosix(activity.timestamp)))
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-secondary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Avg Speed: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fw-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($author$project$Data$SpeedUnit$formatSpeed, model.speedUnit, activity.speed))
												]))
										]));
							case 'LogDatum':
								var log = _v12.a;
								var _v13 = $author$project$Data$Log$split(log.description);
								var prefix = _v13.a;
								var description = _v13.b;
								var bgColor = function () {
									var _v14 = log.severity;
									switch (_v14.$) {
										case 'Danger':
											return 'bg-danger-subtle border-danger';
										case 'Warning':
											return 'bg-warning-subtle border-warning';
										default:
											return 'bg-light';
									}
								}();
								return _Utils_Tuple2(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'z-index', '1000'),
											$elm$html$Html$Attributes$class('small ' + bgColor)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-secondary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$author$project$ISO8601$Extra$toFormattedDateTime,
														model.locale,
														model.zone,
														$jweir$elm_iso8601$ISO8601$fromPosix(log.timestamp)))
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fw-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(prefix + ' ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-secondary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(description)
												]))
										]));
							case 'VoltageDatum':
								return _Utils_Tuple2(_List_Nil, _List_Nil);
							default:
								return _Utils_Tuple2(_List_Nil, _List_Nil);
						}
					}();
					var attrs = _v11.a;
					var elems = _v11.b;
					return A4(
						$terezka$elm_charts$Chart$tooltip,
						bar,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$onLeft,
								$terezka$elm_charts$Chart$Attributes$offset(5),
								$terezka$elm_charts$Chart$Attributes$center,
								$terezka$elm_charts$Chart$Attributes$noArrow
							]),
						attrs,
						elems);
				} else {
					return $terezka$elm_charts$Chart$none;
				}
			}
		}();
		var resizeHandle = model.canExpand ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('position-absolute start-0 end-0 activity-chart-resize-handle'),
					A2($elm$html$Html$Attributes$style, 'bottom', '0'),
					A2($elm$html$Html$Attributes$style, 'height', '8px'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'row-resize'),
					A2($elm$html$Html$Attributes$style, 'z-index', '9'),
					A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
					A2(
					$elm$html$Html$Events$preventDefaultOn,
					'mousedown',
					A2(
						$elm$json$Json$Decode$map,
						function (y) {
							return _Utils_Tuple2(
								$author$project$Views$ActivityChart$StartResize(y),
								true);
						},
						A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float)))
				]),
			_List_Nil) : $elm$html$Html$text('');
		var expandButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-sm btn-light border position-absolute d-flex align-items-center justify-content-center p-0'),
					A2($elm$html$Html$Attributes$style, 'bottom', '6px'),
					A2($elm$html$Html$Attributes$style, 'right', '6px'),
					A2($elm$html$Html$Attributes$style, 'width', '26px'),
					A2($elm$html$Html$Attributes$style, 'height', '26px'),
					A2($elm$html$Html$Attributes$style, 'z-index', '10'),
					$elm$html$Html$Attributes$disabled(!model.canExpand),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-label',
					$author$project$Views$ActivityChart$isPastMidpoint(model) ? 'Collapse chart' : 'Expand chart'),
					$elm$html$Html$Attributes$title(
					(!model.canExpand) ? 'Expanded sensor data is coming soon' : ($author$project$Views$ActivityChart$isPastMidpoint(model) ? 'Collapse chart' : 'Expand chart')),
					$elm$html$Html$Events$onClick($author$project$Views$ActivityChart$ToggleExpand)
				]),
			_List_fromArray(
				[
					$lattyware$elm_fontawesome$FontAwesome$view(
					$author$project$Views$ActivityChart$isPastMidpoint(model) ? $lattyware$elm_fontawesome$FontAwesome$Solid$downLeftAndUpRightToCenter : $lattyware$elm_fontawesome$FontAwesome$Solid$upRightAndDownLeftFromCenter)
				]));
		var dotTooltipEl = function () {
			var _v2 = _Utils_Tuple2(
				$author$project$Views$ActivityChart$dragState(model),
				model.hoveringDot);
			if ((_v2.a.$ === 'Nothing') && (_v2.b.$ === 'Just')) {
				var _v3 = _v2.a;
				var dot = _v2.b.a;
				var maybeRow = function () {
					var _v6 = $terezka$elm_charts$Chart$Item$getData(dot);
					switch (_v6.$) {
						case 'VoltageDatum':
							var vp = _v6.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									vp.timestamp,
									'Battery: ',
									$author$project$Views$ActivityChart$formatVoltage(vp.voltage)));
						case 'SignalDatum':
							var sp = _v6.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									sp.timestamp,
									'Signal: ',
									$author$project$Views$ActivityChart$formatSignalStrength(sp.signalStrength)));
						default:
							return $elm$core$Maybe$Nothing;
					}
				}();
				if (maybeRow.$ === 'Just') {
					var _v5 = maybeRow.a;
					var timestamp = _v5.a;
					var label = _v5.b;
					var value = _v5.c;
					return A4(
						$terezka$elm_charts$Chart$tooltip,
						dot,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$onTop,
								$terezka$elm_charts$Chart$Attributes$offset(6),
								$terezka$elm_charts$Chart$Attributes$noArrow
							]),
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'z-index', '1000'),
								$elm$html$Html$Attributes$class('small')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-secondary')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Timestamp: ')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fw-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3(
											$author$project$ISO8601$Extra$toFormattedDateTime,
											model.locale,
											model.zone,
											$jweir$elm_iso8601$ISO8601$fromPosix(timestamp)))
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-secondary')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fw-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(value)
									]))
							]));
				} else {
					return $terezka$elm_charts$Chart$none;
				}
			} else {
				return $terezka$elm_charts$Chart$none;
			}
		}();
		var extrasAlpha = $author$project$Views$ActivityChart$expandProgress(model);
		var chartMargin = _List_fromArray(
			[
				$terezka$elm_charts$Chart$Attributes$margin(
				{top: 4, left: 6, right: $author$project$Views$ActivityChart$axisMargin, bottom: 22})
			]);
		var hasVoltage = !$elm$core$List$isEmpty(model.voltage);
		var dragRectEl = function () {
			var _v0 = $author$project$Views$ActivityChart$dragState(model);
			if (_v0.$ === 'Just') {
				var _v1 = _v0.a;
				var start = _v1.a;
				var end = _v1.b;
				return $terezka$elm_charts$Chart$svg(
					function (plane) {
						return A2(
							$terezka$elm_charts$Chart$Svg$rect,
							plane,
							_List_fromArray(
								[
									$terezka$elm_charts$Chart$Attributes$x1(start.x),
									$terezka$elm_charts$Chart$Attributes$y1(plane.y.min),
									$terezka$elm_charts$Chart$Attributes$x2(end.x),
									$terezka$elm_charts$Chart$Attributes$y2(plane.y.max),
									$terezka$elm_charts$Chart$Attributes$color('rgba(0, 0, 0, 0.1)'),
									$terezka$elm_charts$Chart$Attributes$border('none')
								]));
					});
			} else {
				return $terezka$elm_charts$Chart$none;
			}
		}();
		var bilgeBands = (extrasAlpha > 0.02) ? A2(
			$elm$core$List$map,
			A3($author$project$Views$ActivityChart$activityBand, ((model.end - model.start) / width) * 4, $author$project$Views$ActivityChart$bilgeColor, 0.15 * extrasAlpha),
			model.bilgeActivity) : _List_Nil;
		var hasSignal = !$elm$core$List$isEmpty(model.signalStrength);
		var speedTop = A2(
			$elm$core$Maybe$withDefault,
			5,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.speed;
					},
					model.activities))) * 1.1;
		var chartDomain = (hasVoltage || hasSignal) ? _List_fromArray(
			[
				$terezka$elm_charts$Chart$Attributes$domain(
				_List_fromArray(
					[
						A2($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$exactly),
						A2($terezka$elm_charts$Chart$Attributes$highest, speedTop, $terezka$elm_charts$Chart$Attributes$exactly)
					]))
			]) : _List_Nil;
		var signalElements = (hasSignal && (extrasAlpha > 0.02)) ? A3($author$project$Views$ActivityChart$signalOverlay, model, speedTop, extrasAlpha) : _List_Nil;
		var voltageElements = (hasVoltage && (extrasAlpha > 0.02)) ? A3($author$project$Views$ActivityChart$voltageOverlay, model, speedTop, extrasAlpha) : _List_Nil;
		var logBars = function (severity) {
			return A4(
				$terezka$elm_charts$Chart$barsMap,
				$author$project$Views$ActivityChart$LogDatum,
				_List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$x1(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.timestamp;
							},
							$author$project$Views$ActivityChart$posixToFloat)),
						$terezka$elm_charts$Chart$Attributes$x2(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.timestamp;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Views$ActivityChart$posixToFloat,
								$elm$core$Basics$add(
									2.0 * A2($author$project$Views$ActivityChart$secondsPerPixel, model, width))))),
						$terezka$elm_charts$Chart$Attributes$margin(0.02),
						$terezka$elm_charts$Chart$Attributes$roundTop(0.5)
					]),
				_List_fromArray(
					[
						A2(
						$terezka$elm_charts$Chart$bar,
						$elm$core$Basics$always(
							1.1 * A2(
								$elm$core$Maybe$withDefault,
								5,
								$elm$core$List$maximum(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.speed;
										},
										model.activities)))),
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(
								$author$project$Data$Log$severityColor(severity))
							]))
					]),
				A2(
					$elm$core$List$filter,
					function (l) {
						return _Utils_eq(l.severity, severity);
					},
					model.logs));
		};
		var height = $author$project$Views$ActivityChart$currentHeight(model);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2(
					$elm$html$Html$Attributes$style,
					'user-select',
					(!_Utils_eq(model.resizeAnchor, $elm$core$Maybe$Nothing)) ? 'none' : 'auto')
				]),
			_List_fromArray(
				[
					expandButton,
					resizeHandle,
					A2(
					$terezka$elm_charts$Chart$chart,
					_Utils_ap(
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$height(height),
								$terezka$elm_charts$Chart$Attributes$width(width),
								$terezka$elm_charts$Chart$Attributes$range(
								_List_fromArray(
									[
										A2($terezka$elm_charts$Chart$Attributes$lowest, model.start, $terezka$elm_charts$Chart$Attributes$exactly),
										A2($terezka$elm_charts$Chart$Attributes$highest, model.end, $terezka$elm_charts$Chart$Attributes$exactly)
									])),
								A2(
								$terezka$elm_charts$Chart$Events$onMouseMove,
								A2($elm$core$Basics$composeL, $author$project$Views$ActivityChart$OnHover, $elm$core$Maybe$Just),
								A4(
									$terezka$elm_charts$Chart$Events$map3,
									$author$project$Views$ActivityChart$Hovered,
									$terezka$elm_charts$Chart$Events$getCoords,
									A2(
										$terezka$elm_charts$Chart$Events$map,
										$elm$core$List$head,
										A2($terezka$elm_charts$Chart$Events$getWithin, 5, $terezka$elm_charts$Chart$Item$bars)),
									A2(
										$terezka$elm_charts$Chart$Events$map,
										$elm$core$List$head,
										A2($terezka$elm_charts$Chart$Events$getWithin, $author$project$Views$ActivityChart$dotHoverRadius, $terezka$elm_charts$Chart$Item$dots)))),
								A2($terezka$elm_charts$Chart$Events$onMouseDown, $author$project$Views$ActivityChart$OnMouseDown, $terezka$elm_charts$Chart$Events$getCoords),
								A2(
								$terezka$elm_charts$Chart$Events$onMouseUp,
								$author$project$Views$ActivityChart$OnMouseUp,
								A3(
									$terezka$elm_charts$Chart$Events$map2,
									F2(
										function (p, b) {
											return _Utils_Tuple2(p, b);
										}),
									$terezka$elm_charts$Chart$Events$getCoords,
									A2(
										$terezka$elm_charts$Chart$Events$map,
										$elm$core$List$head,
										A2($terezka$elm_charts$Chart$Events$getWithin, 5, $terezka$elm_charts$Chart$Item$bars)))),
								$terezka$elm_charts$Chart$Events$onMouseLeave(
								$author$project$Views$ActivityChart$OnHover($elm$core$Maybe$Nothing))
							]),
						_Utils_ap(chartDomain, chartMargin)),
					_Utils_ap(
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$grid(
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$color('#D9E2EC')
									])),
								$terezka$elm_charts$Chart$xLabels(
								_List_fromArray(
									[
										$terezka$elm_charts$Chart$Attributes$withGrid,
										$terezka$elm_charts$Chart$Attributes$fontSize(10),
										$terezka$elm_charts$Chart$Attributes$color('#102A43'),
										$terezka$elm_charts$Chart$Attributes$moveUp(4),
										$terezka$elm_charts$Chart$Attributes$amount(
										$author$project$Views$ActivityChart$labelCountForWidth(width)),
										$terezka$elm_charts$Chart$Attributes$times(model.zone)
									]))
							]),
						_Utils_ap(
							bilgeBands,
							_Utils_ap(
								_List_fromArray(
									[
										A4(
										$terezka$elm_charts$Chart$barsMap,
										$author$project$Views$ActivityChart$ActivityDatum,
										_List_fromArray(
											[
												$terezka$elm_charts$Chart$Attributes$x1(
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.timestamp;
													},
													$author$project$Views$ActivityChart$posixToFloat)),
												$terezka$elm_charts$Chart$Attributes$x2(
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.timestamp;
													},
													A2(
														$elm$core$Basics$composeR,
														$author$project$Views$ActivityChart$posixToFloat,
														$elm$core$Basics$add(model.binWidthSeconds * 1000.0)))),
												$terezka$elm_charts$Chart$Attributes$margin(0.02),
												$terezka$elm_charts$Chart$Attributes$roundTop(0.5)
											]),
										_List_fromArray(
											[
												A2(
												$terezka$elm_charts$Chart$bar,
												function ($) {
													return $.speed;
												},
												_List_fromArray(
													[
														$terezka$elm_charts$Chart$Attributes$color('#1f77b4')
													]))
											]),
										model.activities),
										logBars($author$project$Data$Log$Danger),
										logBars($author$project$Data$Log$Warning)
									]),
								_Utils_ap(
									voltageElements,
									_Utils_ap(
										signalElements,
										_List_fromArray(
											[dragRectEl, dragTooltipEl, dotTooltipEl])))))))
				]));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$Logout = {$: 'Logout'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$MapIdle = function (a) {
	return {$: 'MapIdle', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$ChartMsg = function (a) {
	return {$: 'ChartMsg', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$MapClicked = function (a) {
	return {$: 'MapClicked', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$SheetMsg = function (a) {
	return {$: 'SheetMsg', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$formatLogText = function (log) {
	var _v0 = $author$project$Data$Log$split(log.description);
	var prefix = _v0.a;
	var detail = _v0.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-primary fw-semibold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(prefix)
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-secondary')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(detail)
				]))
		]);
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$ShowLogLocation = function (a) {
	return {$: 'ShowLogLocation', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$logListRow = F3(
	function (locale, tz, log) {
		var cellSeverityClass = function () {
			var _v1 = log.severity;
			switch (_v1.$) {
				case 'Info':
					return '';
				case 'Warning':
					return 'log-warning';
				default:
					return 'log-danger';
			}
		}();
		var rowSeverityClass = function () {
			var _v0 = log.severity;
			switch (_v0.$) {
				case 'Info':
					return '';
				case 'Warning':
					return 'bg-warning-subtle';
				default:
					return 'bg-danger-subtle';
			}
		}();
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small ' + rowSeverityClass),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$ShowLogLocation(log))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(cellSeverityClass + ' text-nowrap text-secondary bg-transparent')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3(
								$author$project$ISO8601$Extra$toFormattedDateTime,
								locale,
								tz,
								$jweir$elm_iso8601$ISO8601$fromPosix(log.timestamp)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-auto bg-transparent')
						]),
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$formatLogText(log))
				]));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$role = $elm$html$Html$Attributes$attribute('role');
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$DownloadCsv = {$: 'DownloadCsv'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$DownloadGpx = {$: 'DownloadGpx'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateEndDate = function (a) {
	return {$: 'UpdateEndDate', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateStartDate = function (a) {
	return {$: 'UpdateStartDate', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$FetchBoatHistory = {$: 'FetchBoatHistory'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateShowPoints = function (a) {
	return {$: 'UpdateShowPoints', a: a};
};
var $author$project$ISO8601$Extra$toDateTimeString = F2(
	function (zone, dto) {
		return A3(
			$danhandrea$elm_date_format$DateFormat$format,
			'yyyy-MM-ddTHH:mm',
			zone,
			$jweir$elm_iso8601$ISO8601$toPosix(dto));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$filterInline = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex-row flex-wrap align-items-baseline p-1 d-flex d-md-none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-check form-switch m-1 ms-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-check-input'),
								$elm$html$Html$Attributes$type_('checkbox'),
								$fapian$elm_html_aria$Html$Attributes$Aria$role('switch'),
								$elm$html$Html$Attributes$checked(model.showPoints),
								$elm$html$Html$Attributes$id('showPoints'),
								$elm$html$Html$Events$onCheck($author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateShowPoints)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-check-label form-text'),
								$elm$html$Html$Attributes$for('showPoints')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Show Track Points')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('btn btn-light dropdown-toggle', true),
										_Utils_Tuple2(
										'disabled',
										$elm$core$List$isEmpty(model.trips))
									])),
								$elm$html$Html$Attributes$type_('button'),
								A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'dropdown'),
								A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-menu')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
												$elm$html$Html$Attributes$href(
												A3(
													$elm$url$Url$Builder$crossOrigin,
													model.apiUrl,
													_List_fromArray(
														[
															'fleet',
															$author$project$Data$Boat$boatIdToString(model.boatId),
															'summary'
														]),
													A2(
														$elm$core$List$filterMap,
														$elm$core$Basics$identity,
														_List_fromArray(
															[
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$jweir$elm_iso8601$ISO8601$fromPosix,
																	A2(
																		$elm$core$Basics$composeR,
																		$jweir$elm_iso8601$ISO8601$toString,
																		$elm$url$Url$Builder$string('start'))),
																model.startDate),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$jweir$elm_iso8601$ISO8601$fromPosix,
																	A2(
																		$elm$core$Basics$composeR,
																		$jweir$elm_iso8601$ISO8601$toString,
																		$elm$url$Url$Builder$string('end'))),
																model.endDate),
																A2(
																$elm$core$Maybe$map,
																$elm$url$Url$Builder$string('zone'),
																A2(
																	$elm$core$Maybe$andThen,
																	function (n) {
																		if (n.$ === 'Name') {
																			var s = n.a;
																			return $elm$core$Maybe$Just(s);
																		} else {
																			return $elm$core$Maybe$Nothing;
																		}
																	},
																	model.timeZoneName))
															]))))
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
												$elm$html$Html$text('Logs as PDF')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
												$elm$html$Html$Attributes$disabled(
												$elm$core$List$isEmpty(model.trips)),
												$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$DownloadCsv)
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
												$elm$html$Html$text('Locations as CSV')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
												$elm$html$Html$Attributes$disabled(
												$elm$core$List$isEmpty(model.trips)),
												$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$DownloadGpx)
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
												$elm$html$Html$text('Tracks as GPX')
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex'),
						A2($elm$html$Html$Attributes$style, 'flex-basis', '100%')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('end-date'),
						$elm$html$Html$Attributes$class('form-label form-control-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Show data from')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('datetime-local'),
						$elm$html$Html$Attributes$id('start-date'),
						A2($elm$html$Html$Attributes$style, 'width', 'auto'),
						$elm$html$Html$Attributes$class('form-control form-control-sm mt-2'),
						$elm$html$Html$Attributes$value(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$jweir$elm_iso8601$ISO8601$fromPosix,
									$author$project$ISO8601$Extra$toDateTimeString(model.timeZone)),
								model.startDate))),
						A2(
						$elm$html$Html$Attributes$attribute,
						'max',
						A2(
							$author$project$ISO8601$Extra$toDateTimeString,
							model.timeZone,
							$jweir$elm_iso8601$ISO8601$fromPosix(
								A2($elm$core$Maybe$withDefault, model.currentTime, model.endDate)))),
						$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateStartDate)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('end-date'),
						$elm$html$Html$Attributes$class('form-label form-control-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('to')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-group input-group-sm'),
						A2($elm$html$Html$Attributes$style, 'width', 'auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('datetime-local'),
								$elm$html$Html$Attributes$id('end-date'),
								A2($elm$html$Html$Attributes$style, 'width', 'auto'),
								$elm$html$Html$Attributes$class('form-control form-control-sm'),
								$elm$html$Html$Attributes$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$jweir$elm_iso8601$ISO8601$fromPosix,
											$author$project$ISO8601$Extra$toDateTimeString(model.timeZone)),
										model.endDate))),
								A2(
								$elm$html$Html$Attributes$attribute,
								'max',
								A2(
									$author$project$ISO8601$Extra$toDateTimeString,
									model.timeZone,
									$jweir$elm_iso8601$ISO8601$fromPosix(model.currentTime))),
								$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateEndDate)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-outline-secondary'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$FetchBoatHistory)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Go')
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$historyDetail = function (model) {
	var definitionRow = F4(
		function (title1, content1, title2, content2) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row my-1 small')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-3 text-secondary')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title1)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-3 fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(content1)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-3 text-secondary')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title2)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-3 fw-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(content2)
							]))
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidebar flex-column align-items-stretch flex-shrink-0 scrollarea'),
				A2($elm$html$Html$Attributes$style, 'height', '100%')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.summary;
				if (_v0.$ === 'Just') {
					var s = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('row d-none d-md-block')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.name;
														},
														model.boat)))
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A4(
								definitionRow,
								'Duration',
								$author$project$Data$Duration$toDisplayString(s.duration),
								'Distance',
								A2($author$project$Data$DistanceUnit$formatDistance, model.fleet.longDistanceUnit, s.distance)),
								A4(
								definitionRow,
								'Max Speed',
								A2($author$project$Data$SpeedUnit$formatSpeed, model.fleet.speedUnit, s.maxSpeed),
								'Avg Speed',
								A2($author$project$Data$SpeedUnit$formatSpeed, model.fleet.speedUnit, s.averageSpeed)),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil)
							]));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-4')
							]),
						_List_fromArray(
							[
								$lattyware$elm_fontawesome$FontAwesome$view(
								A2(
									$lattyware$elm_fontawesome$FontAwesome$styled,
									_List_fromArray(
										[
											$lattyware$elm_fontawesome$FontAwesome$Attributes$spin,
											$lattyware$elm_fontawesome$FontAwesome$Attributes$fa2x1,
											$elm$svg$Svg$Attributes$style('text-align: center')
										]),
									$lattyware$elm_fontawesome$FontAwesome$Solid$circleNotch))
							]));
				}
			}(),
				$author$project$Pages$Fleet_$Boats$BoatId_$Logs$filterInline(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('p-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table table-borderless vertical-align-top logs-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$logListRow, model.locale, model.timeZone),
									model.logs))
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$logsSidebar = F2(
	function (sheet, model) {
		return A5(
			$author$project$Views$SidebarSheet$view,
			sheet,
			$author$project$Pages$Fleet_$Boats$BoatId_$Logs$SheetMsg,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				model.boat),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-shrink-0')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$historyDetail(model)
				]));
	});
var $author$project$Views$Mapbox$showHeatmap = F2(
	function (show, config) {
		return _Utils_update(
			config,
			{showHeatmap: show});
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$MapMouseMove = function (a) {
	return {$: 'MapMouseMove', a: a};
};
var $lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$video = A4(
	$lattyware$elm_fontawesome$FontAwesome$IconDef,
	'fas',
	'video',
	_Utils_Tuple2(576, 512),
	_Utils_Tuple2('M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z', $elm$core$Maybe$Nothing));
var $lattyware$elm_fontawesome$FontAwesome$Solid$video = $lattyware$elm_fontawesome$FontAwesome$present($lattyware$elm_fontawesome$FontAwesome$Solid$Definitions$video);
var $author$project$Time$RelativeDateRange$Today = {$: 'Today'};
var $author$project$Time$RelativeDateRange$ThisWeek = {$: 'ThisWeek'};
var $author$project$Time$RelativeDateRange$Yesterday = {$: 'Yesterday'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$settings = function (model) {
	var s = $mercurymedia$elm_datetime_picker$DatePicker$Settings$defaultSettings(model.timeZone);
	return _Utils_update(
		s,
		{
			theme: $author$project$DatePicker$Extra$neboTheme,
			presets: A2(
				$elm$core$List$map,
				A2($author$project$Time$RelativeDateRange$toPreset, model.currentTime, model.timeZone),
				_List_fromArray(
					[$author$project$Time$RelativeDateRange$Today, $author$project$Time$RelativeDateRange$Yesterday, $author$project$Time$RelativeDateRange$ThisWeek, $author$project$Time$RelativeDateRange$LastWeek])),
			dateStringFn: F2(
				function (z, p) {
					return A3(
						$author$project$ISO8601$Extra$toFormattedDate,
						model.locale,
						z,
						$jweir$elm_iso8601$ISO8601$fromPosix(p));
				}),
			isDayDisabled: F2(
				function (_v0, t) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(t),
						$elm$time$Time$posixToMillis(model.currentTime)) > 0;
				})
		});
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$videoUrl = F4(
	function (fleet, boatId, start, end) {
		return A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				[fleet, 'video']),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'boat',
					$author$project$Data$Boat$boatIdToString(boatId)),
					A2(
					$elm$url$Url$Builder$string,
					'start',
					$jweir$elm_iso8601$ISO8601$toString(
						$jweir$elm_iso8601$ISO8601$fromPosix(start))),
					A2(
					$elm$url$Url$Builder$string,
					'end',
					$jweir$elm_iso8601$ISO8601$toString(
						$jweir$elm_iso8601$ISO8601$fromPosix(end)))
				]));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OpenPicker = {$: 'OpenPicker'};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$filterTopBar = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex-row align-items-center p-2 d-none d-md-flex')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-1')
					]),
				_List_fromArray(
					[
						A2(
						$mercurymedia$elm_datetime_picker$DurationDatePicker$view,
						$author$project$Pages$Fleet_$Boats$BoatId_$Logs$settings(model),
						model.durationDatePicker),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-group input-group-sm')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input-group-text'),
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$OpenPicker)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'No dates selected',
											A3(
												$elm$core$Maybe$map2,
												F2(
													function (s, e) {
														return A3(
															$author$project$ISO8601$Extra$toFormattedDateTime,
															model.locale,
															model.timeZone,
															$jweir$elm_iso8601$ISO8601$fromPosix(s)) + (' to ' + A3(
															$author$project$ISO8601$Extra$toFormattedDateTime,
															model.locale,
															model.timeZone,
															$jweir$elm_iso8601$ISO8601$fromPosix(e)));
													}),
												model.startDate,
												model.endDate)))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-outline-secondary'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$FetchBoatHistory)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Go')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-check form-switch m-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-check-input'),
								$elm$html$Html$Attributes$type_('checkbox'),
								$fapian$elm_html_aria$Html$Attributes$Aria$role('switch'),
								$elm$html$Html$Attributes$checked(model.showPoints),
								$elm$html$Html$Attributes$id('showPoints'),
								$elm$html$Html$Events$onCheck($author$project$Pages$Fleet_$Boats$BoatId_$Logs$UpdateShowPoints)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-check-label form-text'),
								$elm$html$Html$Attributes$for('showPoints')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Show Track Points')
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-grow-1')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('btn btn-light dropdown-toggle', true),
										_Utils_Tuple2(
										'disabled',
										$elm$core$List$isEmpty(model.trips))
									])),
								$elm$html$Html$Attributes$type_('button'),
								A2($elm$html$Html$Attributes$attribute, 'data-bs-toggle', 'dropdown'),
								A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-menu')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
												$elm$html$Html$Attributes$href(
												A3(
													$elm$url$Url$Builder$crossOrigin,
													model.apiUrl,
													_List_fromArray(
														[
															'fleet',
															$author$project$Data$Boat$boatIdToString(model.boatId),
															'summary'
														]),
													A2(
														$elm$core$List$filterMap,
														$elm$core$Basics$identity,
														_List_fromArray(
															[
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$jweir$elm_iso8601$ISO8601$fromPosix,
																	A2(
																		$elm$core$Basics$composeR,
																		$jweir$elm_iso8601$ISO8601$toString,
																		$elm$url$Url$Builder$string('start'))),
																model.startDate),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$jweir$elm_iso8601$ISO8601$fromPosix,
																	A2(
																		$elm$core$Basics$composeR,
																		$jweir$elm_iso8601$ISO8601$toString,
																		$elm$url$Url$Builder$string('end'))),
																model.endDate),
																A2(
																$elm$core$Maybe$map,
																$elm$url$Url$Builder$string('zone'),
																A2(
																	$elm$core$Maybe$andThen,
																	function (n) {
																		if (n.$ === 'Name') {
																			var s = n.a;
																			return $elm$core$Maybe$Just(s);
																		} else {
																			return $elm$core$Maybe$Nothing;
																		}
																	},
																	model.timeZoneName))
															]))))
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
												$elm$html$Html$text('Logs as PDF')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
												$elm$html$Html$Attributes$disabled(
												$elm$core$List$isEmpty(model.trips)),
												$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$DownloadCsv)
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
												$elm$html$Html$text('Locations as CSV')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
												$elm$html$Html$Attributes$disabled(
												$elm$core$List$isEmpty(model.trips)),
												$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$Boats$BoatId_$Logs$DownloadGpx)
											]),
										_List_fromArray(
											[
												$lattyware$elm_fontawesome$FontAwesome$view(
												A2(
													$lattyware$elm_fontawesome$FontAwesome$styled,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('me-2')
														]),
													$lattyware$elm_fontawesome$FontAwesome$Solid$download)),
												$elm$html$Html$text('Tracks as GPX')
											]))
									])),
								function () {
								var _v1 = _Utils_Tuple2(model.startDate, model.endDate);
								if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
									var start = _v1.a.a;
									var end = _v1.b.a;
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('dropdown-item text-nowrap text-secondary'),
														$elm$html$Html$Attributes$disabled(
														$elm$core$List$isEmpty(model.trips)),
														$elm$html$Html$Attributes$href(
														A4($author$project$Pages$Fleet_$Boats$BoatId_$Logs$videoUrl, model.fleet.slug, model.boatId, start, end))
													]),
												_List_fromArray(
													[
														$lattyware$elm_fontawesome$FontAwesome$view(
														A2(
															$lattyware$elm_fontawesome$FontAwesome$styled,
															_List_fromArray(
																[
																	$elm$svg$Svg$Attributes$class('me-2')
																]),
															$lattyware$elm_fontawesome$FontAwesome$Solid$video)),
														$elm$html$Html$text('Nebo Replay Link'),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('badge bg-warning text-dark ms-2 align-middle')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Beta')
															]))
													]))
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$ControlClicked = function (a) {
	return {$: 'ControlClicked', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Views$Mapbox$showTrackMarkers = F2(
	function (show, config) {
		return _Utils_update(
			config,
			{showTrackMarkers: show});
	});
var $author$project$Views$Mapbox$addOrReplaceSources = F2(
	function (newSources, sources) {
		return A3($elm$core$List$foldl, $author$project$Views$Mapbox$addOrReplaceSource, sources, newSources);
	});
var $author$project$Data$BoatLocation$filterCollisionsMapbox = F2(
	function (zoom, locations) {
		var distanceInDegrees = F2(
			function (ll1, ll2) {
				return $elm$core$Basics$sqrt(
					A2(
						$elm$core$Basics$pow,
						$elm$core$Basics$abs(ll1.lat - ll2.lat),
						2) + A2(
						$elm$core$Basics$pow,
						$elm$core$Basics$abs(ll1._long - ll2._long),
						2));
			});
		var filterDistance = A2(
			$author$project$Geospatial$MapProjection$degreesPerPixel,
			A2(
				$elm$core$Maybe$withDefault,
				0.0,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.latLong;
						},
						function ($) {
							return $.lat;
						}),
					$elm$core$List$head(locations))),
			zoom) * 30.0;
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				F2(
					function (l, acc) {
						if (!acc.b) {
							return _List_fromArray(
								[l]);
						} else {
							var x = acc.a;
							var xs = acc.b;
							return (_Utils_cmp(
								A2(distanceInDegrees, l.latLong, x.latLong),
								filterDistance) < 0) ? A2($elm$core$List$cons, x, xs) : A2(
								$elm$core$List$cons,
								l,
								A2($elm$core$List$cons, x, xs));
						}
					}),
				_List_Nil,
				locations));
	});
var $author$project$Views$Mapbox$boatLocationsToLayers = F5(
	function (ts, selectedLocation, hoveredRange, zoom, heatmap) {
		var inHoveredRange = function (loc) {
			if (hoveredRange.$ === 'Just') {
				var _v1 = hoveredRange.a;
				var start = _v1.a;
				var end = _v1.b;
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(loc.timestamp),
					$elm$time$Time$posixToMillis(start)) > -1) && (_Utils_cmp(
					$elm$time$Time$posixToMillis(loc.timestamp),
					$elm$time$Time$posixToMillis(end)) < 1);
			} else {
				return false;
			}
		};
		var locationMarker = function (loc) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Feature')),
						_Utils_Tuple2(
						'properties',
						$elm$json$Json$Encode$object(
							_Utils_ap(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'selected',
										$elm$json$Json$Encode$bool(
											_Utils_eq(
												$author$project$Data$BoatLocation$toMarkerId(loc),
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Data$BoatLocation$toMarkerId, selectedLocation))))),
										_Utils_Tuple2(
										'hovered',
										$elm$json$Json$Encode$bool(
											inHoveredRange(loc))),
										_Utils_Tuple2(
										'markerId',
										$elm$json$Json$Encode$string(
											$author$project$Data$BoatLocation$toMarkerId(loc)))
									]),
								$elm_community$maybe_extra$Maybe$Extra$toList(
									A2(
										$elm$core$Maybe$map,
										function (h) {
											return _Utils_Tuple2(
												'heading',
												$elm$json$Json$Encode$float(h));
										},
										loc.heading))))),
						_Utils_Tuple2(
						'geometry',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string('Point')),
									_Utils_Tuple2(
									'coordinates',
									$author$project$Views$Mapbox$latLongToGeoJSON(loc.latLong))
								])))
					]));
		};
		var lineFeature = function (locs) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Feature')),
						_Utils_Tuple2(
						'geometry',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string('LineString')),
									_Utils_Tuple2(
									'coordinates',
									A2(
										$elm$json$Json$Encode$list,
										$author$project$Views$Mapbox$latLongToGeoJSON,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.latLong;
											},
											locs)))
								])))
					]));
		};
		var hoveredFeatures = A2(
			$elm$core$List$map,
			lineFeature,
			A2(
				$elm$core$List$filter,
				function (locs) {
					return $elm$core$List$length(locs) >= 2;
				},
				A2(
					$elm$core$List$map,
					$elm$core$List$filter(inHoveredRange),
					ts)));
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'tracks',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('FeatureCollection')),
							_Utils_Tuple2(
							'features',
							A2($elm$json$Json$Encode$list, lineFeature, ts))
						]))),
				_Utils_Tuple2(
				'hovered-track',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('FeatureCollection')),
							_Utils_Tuple2(
							'features',
							A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, hoveredFeatures))
						]))),
				_Utils_Tuple2(
				'track-markers',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('FeatureCollection')),
							_Utils_Tuple2(
							'features',
							A2(
								$elm$json$Json$Encode$list,
								locationMarker,
								heatmap ? A2($elm$core$List$concatMap, $elm$core$Basics$identity, ts) : A2(
									$elm$core$List$concatMap,
									$author$project$Data$BoatLocation$filterCollisionsMapbox(zoom),
									ts)))
						])))
			]);
	});
var $author$project$Views$Mapbox$withBoatLocations = F6(
	function (trips, selectedLocation, hoveredRange, zoom, show, config) {
		return _Utils_update(
			config,
			{
				sources: A2(
					$author$project$Views$Mapbox$addOrReplaceSources,
					A5(
						$author$project$Views$Mapbox$boatLocationsToLayers,
						trips,
						selectedLocation,
						hoveredRange,
						$elm$core$Basics$round(zoom),
						show),
					config.sources)
			});
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$SelectBoatLocation = function (a) {
	return {$: 'SelectBoatLocation', a: a};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$markerSelectedFromMap = function (s) {
	return $author$project$Pages$Fleet_$Boats$BoatId_$Logs$SelectBoatLocation(
		$elm$core$Maybe$Just(s));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$view = F3(
	function (session, featureDropState, model) {
		var locationPopup = A2(
			$elm$core$Maybe$map,
			function (bl) {
				return A7($author$project$Views$Mapbox$locationPopupContent, model.locale, model.timeZone, model.fleet.speedUnit, $elm$core$Maybe$Nothing, bl, false, false);
			},
			model.selectedLocation);
		var measureLabel = function () {
			if (model.measureModeActive && ($elm$core$List$length(model.measureLine) >= 2)) {
				var lastPoint = $elm$core$List$head(
					$elm$core$List$reverse(model.measureLine));
				var dist = A2(
					$author$project$Data$DistanceUnit$formatDistance,
					model.fleet.longDistanceUnit,
					$author$project$Geospatial$LatLong$distance(model.measureLine));
				return A2(
					$elm$core$Maybe$map,
					function (ll) {
						return A2($author$project$Views$Mapbox$distanceLocationLabel, ll, dist);
					},
					lastPoint);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var pointCount = $elm$core$List$sum(
			A2($elm$core$List$map, $elm$core$List$length, model.trips));
		var showHeatmap = pointCount > 30000;
		var mapConfig = A2(
			$author$project$Views$Mapbox$withGeofences,
			model.geofences,
			A6(
				$author$project$Views$Mapbox$withBoatLocations,
				model.trips,
				model.selectedLocation,
				model.hoveredTrackRange,
				model.mapPosition.zoom,
				showHeatmap,
				A2(
					$author$project$Views$Mapbox$showHeatmap,
					showHeatmap,
					A2(
						$author$project$Views$Mapbox$showTrackMarkers,
						model.showPoints,
						A2(
							$author$project$Views$Mapbox$withIdleMsg,
							function (_v0) {
								var c = _v0.a;
								var z = _v0.b;
								var bounds = _v0.c;
								return $author$project$Pages$Fleet_$Boats$BoatId_$Logs$MapIdle(
									{
										zoom: z,
										bounds: {northEast: bounds.ne, southWest: bounds.sw},
										centre: c
									});
							},
							A5(
								$author$project$Views$Mapbox$withRuler,
								model.measureLine,
								model.fleet.longDistanceUnit,
								model.measureModeActive,
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$ControlClicked('measure'),
								A2(
									$author$project$Views$Mapbox$withFeatureClickMsg,
									$author$project$Pages$Fleet_$Boats$BoatId_$Logs$markerSelectedFromMap,
									A2(
										$author$project$Views$Mapbox$withMouseMoveMsg,
										model.measureModeActive ? $elm$core$Maybe$Just($author$project$Pages$Fleet_$Boats$BoatId_$Logs$MapMouseMove) : $elm$core$Maybe$Nothing,
										A2(
											$author$project$Views$Mapbox$withMapClickMsg,
											$author$project$Pages$Fleet_$Boats$BoatId_$Logs$MapClicked,
											A3(
												$author$project$Views$Mapbox$withStyleSelect,
												model.mapStyle,
												$author$project$Pages$Fleet_$Boats$BoatId_$Logs$SelectStyle,
												A3($author$project$Views$Mapbox$init, model.mapPosition, model.fleetUrl, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$NoOp)))))))))));
		return {
			body: A2(
				$author$project$Html$Layout$fitWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(model.currentRoute),
					featureDropState,
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$ChangelogAction,
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column'),
								A2($elm$html$Html$Attributes$style, 'height', '100%')
							]),
						_List_fromArray(
							[
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$filterTopBar(model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-none d-md-block flex-shrink-0'),
										A2($elm$html$Html$Attributes$style, 'width', '100%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Fleet_$Boats$BoatId_$Logs$ChartMsg,
										A2($author$project$Views$ActivityChart$view, model.chart, model.viewportWidth))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex flex no-wrap flex-grow-1'),
										A2($elm$html$Html$Attributes$style, 'overflow-x', 'auto'),
										A2($elm$html$Html$Attributes$style, 'overflow-y', 'hidden'),
										A2($elm$html$Html$Attributes$style, 'min-height', '0')
									]),
								_List_fromArray(
									[
										A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$logsSidebar, model.sheet, model),
										A2(
										$author$project$Views$Mapbox$view,
										mapConfig,
										_Utils_ap(
											$elm_community$maybe_extra$Maybe$Extra$toList(locationPopup),
											$elm_community$maybe_extra$Maybe$Extra$toList(measureLabel)))
									]))
							])),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$CloseError)
					])),
			title: 'Vessel Logs'
		};
	});
var $author$project$Gpx$Encode$Element = F3(
	function (a, b, c) {
		return {$: 'Element', a: a, b: b, c: c};
	});
var $author$project$Gpx$Encode$Text = function (a) {
	return {$: 'Text', a: a};
};
var $author$project$Gpx$Encode$trackPoint = function (loc) {
	return A3(
		$author$project$Gpx$Encode$Element,
		'trkpt',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lat',
				$elm$core$String$fromFloat(loc.latLong.lat)),
				_Utils_Tuple2(
				'lon',
				$elm$core$String$fromFloat(loc.latLong._long))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Gpx$Encode$Element,
				'time',
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Gpx$Encode$Text(
						$jweir$elm_iso8601$ISO8601$toString(
							$jweir$elm_iso8601$ISO8601$fromPosix(loc.timestamp)))
					]))
			]));
};
var $author$project$Gpx$Encode$segment = function (locs) {
	return A3(
		$author$project$Gpx$Encode$Element,
		'trkseg',
		_List_Nil,
		A2($elm$core$List$map, $author$project$Gpx$Encode$trackPoint, locs));
};
var $author$project$Gpx$Encode$track = function (locs) {
	return A3(
		$author$project$Gpx$Encode$Element,
		'trk',
		_List_Nil,
		A2($elm$core$List$map, $author$project$Gpx$Encode$segment, locs));
};
var $author$project$Gpx$Encode$metadata = F2(
	function (now, bbox) {
		return A3(
			$author$project$Gpx$Encode$Element,
			'metadata',
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Gpx$Encode$Element,
					'time',
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Gpx$Encode$Text(
							$jweir$elm_iso8601$ISO8601$toString(
								$jweir$elm_iso8601$ISO8601$fromPosix(now)))
						])),
				function () {
					if (bbox.$ === 'Nothing') {
						return _List_Nil;
					} else {
						var b = bbox.a;
						return _List_fromArray(
							[
								A3(
								$author$project$Gpx$Encode$Element,
								'bounds',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'minlat',
										$elm$core$String$fromFloat(b.southWest.lat)),
										_Utils_Tuple2(
										'minlon',
										$elm$core$String$fromFloat(b.southWest._long)),
										_Utils_Tuple2(
										'maxlat',
										$elm$core$String$fromFloat(b.northEast.lat)),
										_Utils_Tuple2(
										'maxlon',
										$elm$core$String$fromFloat(b.northEast._long))
									]),
								_List_Nil)
							]);
					}
				}()));
	});
var $author$project$Gpx$Encode$gpx = F2(
	function (now, locs) {
		var bbox = $author$project$Geospatial$BoundingBox$fromLatLongs(
			A2(
				$elm$core$List$concatMap,
				function (l) {
					return _List_fromArray(
						[l.latLong]);
				},
				$elm$core$List$concat(locs)));
		return {
			version: '1.0',
			encoding: 'utf-8',
			rootNode: A3(
				$author$project$Gpx$Encode$Element,
				'gpx',
				_List_fromArray(
					[
						_Utils_Tuple2('version', '1.1'),
						_Utils_Tuple2('creator', 'Nebo'),
						_Utils_Tuple2('xmlns', 'http://www.topografix.com/GPX/1/1')
					]),
				_List_fromArray(
					[
						A2($author$project$Gpx$Encode$metadata, now, bbox),
						$author$project$Gpx$Encode$track(locs)
					]))
		};
	});
var $author$project$Data$BoatLocation$csvEncode = function (spUnit) {
	return $BrianHicks$elm_csv$Csv$Encode$withFieldNames(
		function (l) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'Timestamp',
					$jweir$elm_iso8601$ISO8601$toString(
						$jweir$elm_iso8601$ISO8601$fromPosix(l.timestamp))),
					_Utils_Tuple2(
					'Latitude',
					$elm$core$String$fromFloat(l.latLong.lat)),
					_Utils_Tuple2(
					'Longitude',
					$elm$core$String$fromFloat(l.latLong._long)),
					_Utils_Tuple2(
					'Accuracy (m)',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromFloat, l.accuracy))),
					_Utils_Tuple2(
					'Speed (' + ($author$project$Data$SpeedUnit$abbreviation(spUnit) + ')'),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Data$SpeedUnit$convertTo(spUnit),
								$elm$core$String$fromFloat),
							l.speed))),
					_Utils_Tuple2(
					'Heading (degrees)',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromFloat, l.heading)))
				]);
		});
};
var $author$project$Data$BoatLocation$toCsv = F2(
	function (spUnit, ls) {
		return A2(
			$BrianHicks$elm_csv$Csv$Encode$encode,
			{
				encoder: $author$project$Data$BoatLocation$csvEncode(spUnit),
				fieldSeparator: _Utils_chr(',')
			},
			ls);
	});
var $author$project$Gpx$Encode$encodeNode = function (node) {
	if (node.$ === 'Element') {
		var name = node.a;
		var attrs = node.b;
		var children = node.c;
		var attrString = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function (_v1) {
					var k = _v1.a;
					var v = _v1.b;
					return k + ('=\u0022' + (v + '\u0022'));
				},
				attrs));
		return '<' + (name + (($elm$core$List$isEmpty(attrs) ? '' : (' ' + attrString)) + ('>' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, $author$project$Gpx$Encode$encodeNode, children)) + ('</' + (name + '>'))))));
	} else {
		var text = node.a;
		return text;
	}
};
var $author$project$Gpx$Encode$encode = function (doc) {
	return '<?xml version=\u0022' + (doc.version + ('\u0022 encoding=\u0022' + (doc.encoding + ('\u0022?>' + $author$project$Gpx$Encode$encodeNode(doc.rootNode)))));
};
var $author$project$Mapbox$Cmd$Template$resize = F2(
	function (prt, id) {
		return A4($author$project$Mapbox$Cmd$Template$makeCmd, prt, id, 'resize', _List_Nil);
	});
var $author$project$MapCommands$resize = A2($author$project$Mapbox$Cmd$Template$resize, $author$project$Ports$elmMapboxOutgoing, $author$project$MapCommands$id);
var $author$project$Views$ActivityChart$Hover = function (a) {
	return {$: 'Hover', a: a};
};
var $mdgriffith$elm_animator$Animator$slowly = $mdgriffith$elm_animator$Animator$millis(400);
var $mdgriffith$elm_animator$Internal$Timeline$needsUpdate = function (tl) {
	var timeline = tl.a;
	var _v0 = timeline.queued;
	if (_v0.$ === 'Nothing') {
		var _v1 = timeline.interruption;
		if (!_v1.b) {
			return timeline.running;
		} else {
			return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_animator$Animator$watchingWith = F4(
	function (get, set, eventIsRestable, _v0) {
		var isRunning = _v0.a;
		var updateModel = _v0.b;
		return A2(
			$mdgriffith$elm_animator$Internal$Timeline$Animator,
			function (model) {
				if (isRunning(model)) {
					return true;
				} else {
					var timeline = get(model);
					return $mdgriffith$elm_animator$Internal$Timeline$needsUpdate(timeline) ? true : eventIsRestable(
						$mdgriffith$elm_animator$Internal$Timeline$current(timeline));
				}
			},
			F2(
				function (now, model) {
					var newModel = A2(updateModel, now, model);
					return A2(
						set,
						A2(
							$mdgriffith$elm_animator$Internal$Timeline$update,
							now,
							get(newModel)),
						newModel);
				}));
	});
var $author$project$Views$ActivityChart$animator = A4(
	$mdgriffith$elm_animator$Animator$watchingWith,
	function ($) {
		return $.extrasVisible;
	},
	F2(
		function (_new, model) {
			return _Utils_update(
				model,
				{extrasVisible: _new});
		}),
	function (_v1) {
		return false;
	},
	A4(
		$mdgriffith$elm_animator$Animator$watchingWith,
		function ($) {
			return $.heightState;
		},
		F2(
			function (_new, model) {
				return _Utils_update(
					model,
					{heightState: _new});
			}),
		function (_v0) {
			return false;
		},
		$mdgriffith$elm_animator$Animator$animator));
var $author$project$Views$ActivityChart$xToPosix = F2(
	function (x, model) {
		return ((!model.start) || (!model.end)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Views$ActivityChart$floatToPosix(x));
	});
var $author$project$Views$ActivityChart$Animating = {$: 'Animating'};
var $author$project$Views$ActivityChart$LogClicked = function (a) {
	return {$: 'LogClicked', a: a};
};
var $author$project$Views$ActivityChart$ExpandToggled = function (a) {
	return {$: 'ExpandToggled', a: a};
};
var $author$project$Views$ActivityChart$hoveredRangeOf = function (model) {
	var _v0 = A2($elm$core$Maybe$map, $terezka$elm_charts$Chart$Item$getData, model.hoveringBar);
	if ((_v0.$ === 'Just') && (_v0.a.$ === 'ActivityDatum')) {
		var a = _v0.a.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				a.timestamp,
				$author$project$Views$ActivityChart$floatToPosix(
					$author$project$Views$ActivityChart$posixToFloat(a.timestamp) + (model.binWidthSeconds * 1000))));
	} else {
		var _v1 = A2($elm$core$Maybe$map, $terezka$elm_charts$Chart$Item$getData, model.hoveringDot);
		_v1$2:
		while (true) {
			if (_v1.$ === 'Just') {
				switch (_v1.a.$) {
					case 'VoltageDatum':
						var v = _v1.a.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(v.timestamp, v.timestamp));
					case 'SignalDatum':
						var s = _v1.a.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(s.timestamp, s.timestamp));
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$ActivityChart$ActivityClicked = F2(
	function (a, b) {
		return {$: 'ActivityClicked', a: a, b: b};
	});
var $author$project$Views$ActivityChart$DateRangeSelected = F2(
	function (a, b) {
		return {$: 'DateRangeSelected', a: a, b: b};
	});
var $author$project$Views$ActivityChart$goToExtrasVisible = function (visible) {
	return A2(
		$mdgriffith$elm_animator$Animator$go,
		$mdgriffith$elm_animator$Animator$millis(600),
		visible);
};
var $author$project$Views$ActivityChart$fadeStartFraction = 0.4;
var $author$project$Views$ActivityChart$fadeThreshold = function (model) {
	return model.collapsedHeight + ((model.expandedHeight - model.collapsedHeight) * $author$project$Views$ActivityChart$fadeStartFraction);
};
var $author$project$Views$ActivityChart$wantsExtras = function (model) {
	return _Utils_cmp(
		$author$project$Views$ActivityChart$currentHeight(model),
		$author$project$Views$ActivityChart$fadeThreshold(model)) > 0;
};
var $author$project$Views$ActivityChart$syncExtrasVisibility = function (model) {
	var wants = $author$project$Views$ActivityChart$wantsExtras(model);
	return _Utils_eq(
		wants,
		$mdgriffith$elm_animator$Animator$current(model.extrasVisible)) ? model : _Utils_update(
		model,
		{
			extrasVisible: A2($author$project$Views$ActivityChart$goToExtrasVisible, wants, model.extrasVisible)
		});
};
var $author$project$Views$ActivityChart$updateChart = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnHover':
				if (msg.a.$ === 'Just') {
					var hovered = msg.a.a;
					var updated = _Utils_update(
						model,
						{
							hoveringBar: hovered.bar,
							hoveringDot: hovered.dot,
							mousePosition: $elm$core$Maybe$Just(hovered.point)
						});
					var range = $author$project$Views$ActivityChart$hoveredRangeOf(updated);
					return _Utils_eq(range, model.hoveredRange) ? _Utils_Tuple2(updated, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
						_Utils_update(
							updated,
							{hoveredRange: range}),
						$elm$core$Maybe$Just(
							$author$project$Views$ActivityChart$Hover(range)));
				} else {
					var _v1 = msg.a;
					var updated = _Utils_update(
						model,
						{dragStart: $elm$core$Maybe$Nothing, hoveringBar: $elm$core$Maybe$Nothing, hoveringDot: $elm$core$Maybe$Nothing, mousePosition: $elm$core$Maybe$Nothing});
					return _Utils_eq(model.hoveredRange, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(updated, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
						_Utils_update(
							updated,
							{hoveredRange: $elm$core$Maybe$Nothing}),
						$elm$core$Maybe$Just(
							$author$project$Views$ActivityChart$Hover($elm$core$Maybe$Nothing)));
				}
			case 'ToggleExpand':
				if (!model.canExpand) {
					return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
				} else {
					var target = $author$project$Views$ActivityChart$isPastMidpoint(model) ? model.collapsedHeight : model.expandedHeight;
					var goingExpanded = _Utils_cmp(target, model.collapsedHeight) > 0;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								heightState: A3($mdgriffith$elm_animator$Animator$go, $mdgriffith$elm_animator$Animator$slowly, target, model.heightState),
								extrasVisible: A2($author$project$Views$ActivityChart$goToExtrasVisible, goingExpanded, model.extrasVisible)
							}),
						$elm$core$Maybe$Just(
							$author$project$Views$ActivityChart$ExpandToggled(goingExpanded)));
				}
			case 'AnimationTick':
				var t = msg.a;
				return _Utils_Tuple2(
					A3($mdgriffith$elm_animator$Animator$update, t, $author$project$Views$ActivityChart$animator, model),
					$elm$core$Maybe$Just($author$project$Views$ActivityChart$Animating));
			case 'StartResize':
				var clientY = msg.a;
				return (!model.canExpand) ? _Utils_Tuple2(model, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resizeAnchor: $elm$core$Maybe$Just(
								{
									startHeight: $author$project$Views$ActivityChart$currentHeight(model),
									startClientY: clientY
								})
						}),
					$elm$core$Maybe$Nothing);
			case 'ResizeTo':
				var clientY = msg.a;
				var _v2 = model.resizeAnchor;
				if (_v2.$ === 'Just') {
					var anchor = _v2.a;
					var newHeight = A3($elm$core$Basics$clamp, model.collapsedHeight, model.maxHeight, anchor.startHeight + (clientY - anchor.startClientY));
					return _Utils_Tuple2(
						$author$project$Views$ActivityChart$syncExtrasVisibility(
							_Utils_update(
								model,
								{
									heightState: $mdgriffith$elm_animator$Animator$init(newHeight)
								})),
						$elm$core$Maybe$Just($author$project$Views$ActivityChart$Animating));
				} else {
					return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
				}
			case 'EndResize':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{resizeAnchor: $elm$core$Maybe$Nothing}),
					$elm$core$Maybe$Just($author$project$Views$ActivityChart$Animating));
			case 'OnMouseDown':
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dragStart: $elm$core$Maybe$Just(point)
						}),
					$elm$core$Maybe$Nothing);
			default:
				var _v3 = msg.a;
				var endCoords = _v3.a;
				var bar = _v3.b;
				var _v4 = $author$project$Views$ActivityChart$dragState(model);
				if (_v4.$ === 'Just') {
					var _v5 = _v4.a;
					var coords = _v5.a;
					var window = (_Utils_cmp(endCoords.x, coords.x) > 0) ? _Utils_Tuple2(coords.x, endCoords.x) : _Utils_Tuple2(endCoords.x, coords.x);
					var _v6 = A3(
						$elm$core$Tuple$mapBoth,
						function (x) {
							return A2($author$project$Views$ActivityChart$xToPosix, x, model);
						},
						function (x) {
							return A2($author$project$Views$ActivityChart$xToPosix, x, model);
						},
						window);
					if ((_v6.a.$ === 'Just') && (_v6.b.$ === 'Just')) {
						var start = _v6.a.a;
						var end = _v6.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dragStart: $elm$core$Maybe$Nothing}),
							$elm$core$Maybe$Just(
								A2($author$project$Views$ActivityChart$DateRangeSelected, start, end)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dragStart: $elm$core$Maybe$Nothing}),
							$elm$core$Maybe$Nothing);
					}
				} else {
					if (bar.$ === 'Just') {
						var b = bar.a;
						var _v8 = $terezka$elm_charts$Chart$Item$getData(b);
						switch (_v8.$) {
							case 'ActivityDatum':
								var activity = _v8.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{dragStart: $elm$core$Maybe$Nothing}),
									$elm$core$Maybe$Just(
										A2(
											$author$project$Views$ActivityChart$ActivityClicked,
											activity.timestamp,
											$author$project$Views$ActivityChart$floatToPosix(
												$author$project$Views$ActivityChart$posixToFloat(activity.timestamp) + (model.binWidthSeconds * 1000)))));
							case 'LogDatum':
								var log = _v8.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{dragStart: $elm$core$Maybe$Nothing}),
									$elm$core$Maybe$Just(
										$author$project$Views$ActivityChart$LogClicked(log.timestamp)));
							case 'VoltageDatum':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{dragStart: $elm$core$Maybe$Nothing}),
									$elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{dragStart: $elm$core$Maybe$Nothing}),
									$elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dragStart: $elm$core$Maybe$Nothing}),
							$elm$core$Maybe$Nothing);
					}
				}
		}
	});
var $author$project$Views$ActivityChart$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(model.resizeAnchor, msg);
		_v0$3:
		while (true) {
			if (_v0.a.$ === 'Just') {
				switch (_v0.b.$) {
					case 'OnHover':
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					case 'OnMouseDown':
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					case 'OnMouseUp':
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return A2($author$project$Views$ActivityChart$updateChart, msg, model);
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$dropLast = function (list) {
	if (!list.b) {
		return _List_Nil;
	} else {
		if (!list.b.b) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$take,
				$elm$core$List$length(list) - 1,
				list);
		}
	}
};
var $author$project$Views$ActivityChart$setHeights = F4(
	function (collapsed, expandedH, maxH, model) {
		return _Utils_update(
			model,
			{maxHeight: maxH, expandedHeight: expandedH, collapsedHeight: collapsed});
	});
var $author$project$Views$ActivityChart$setVoltage = F2(
	function (points, model) {
		return _Utils_update(
			model,
			{voltage: points});
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$sheetConfig = function (model) {
	var _v0 = model.mapSize;
	var h = _v0.b;
	return {
		detents: _List_fromArray(
			[54, h * 0.4, h - 90])
	};
};
var $author$project$Views$ActivityChart$setDateRange = F3(
	function (start, end, model) {
		return _Utils_update(
			model,
			{
				end: $author$project$Views$ActivityChart$posixToFloat(end),
				start: $author$project$Views$ActivityChart$posixToFloat(start)
			});
	});
var $author$project$Views$ActivityChart$setBilgeActivity = F2(
	function (periods, model) {
		return _Utils_update(
			model,
			{bilgeActivity: periods});
	});
var $author$project$Views$ActivityChart$setSignalStrength = F2(
	function (points, model) {
		return _Utils_update(
			model,
			{signalStrength: points});
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$clearTelemetry = A2(
	$elm$core$Basics$composeR,
	$author$project$Views$ActivityChart$setVoltage(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Views$ActivityChart$setSignalStrength(_List_Nil),
		$author$project$Views$ActivityChart$setBilgeActivity(_List_Nil)));
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$maxChartHeight = function (viewportHeight) {
	return viewportHeight * 0.85;
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$showLogLocation = F2(
	function (model, l) {
		var _v0 = l.latLong;
		if (_v0.$ === 'Just') {
			var ll = _v0.a;
			var boatLocation = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (bl) {
						return _Utils_eq(bl.latLong, ll);
					},
					$elm$core$List$concat(model.trips)));
			var _v1 = _Utils_Tuple2(model.showPoints, boatLocation);
			if (_v1.a && (_v1.b.$ === 'Just')) {
				var loc = _v1.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedLocation: $elm$core$Maybe$Just(loc)
						}),
					$author$project$Effect$fromCmd(
						$author$project$MapCommands$flyTo(
							_List_fromArray(
								[
									$author$project$Mapbox$Cmd$Option$center(
									{lat: ll.lat, lng: ll._long}),
									$author$project$Mapbox$Cmd$Option$zoom(
									A2($elm$core$Basics$max, model.mapPosition.zoom, 15)),
									$author$project$Mapbox$Cmd$Option$speed(2.0)
								]))));
			} else {
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromCmd(
						$author$project$MapCommands$flyTo(
							_List_fromArray(
								[
									$author$project$Mapbox$Cmd$Option$center(
									{lat: ll.lat, lng: ll._long}),
									$author$project$Mapbox$Cmd$Option$zoom(
									A2($elm$core$Basics$max, model.mapPosition.zoom, 15)),
									$author$project$Mapbox$Cmd$Option$speed(2.0)
								]))));
			}
		} else {
			return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Data$BoatLocation$maxSpeed = function (locations) {
	var _v0 = A2(
		$elm$core$List$filterMap,
		function ($) {
			return $.speed;
		},
		locations);
	if (!_v0.b) {
		return 0;
	} else {
		var speeds = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(speeds));
	}
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$calculateTripSummary = function (locations) {
	var maxSpeed = $author$project$Data$BoatLocation$maxSpeed(locations);
	var duration = $author$project$Data$BoatLocation$trackDuration(locations);
	var distance = $author$project$Data$BoatLocation$trackDistance(locations);
	var averageSpeed = ($author$project$Data$Duration$toSeconds(duration) > 0) ? (distance / $author$project$Data$Duration$toSeconds(duration)) : 0;
	return {distance: distance, duration: duration, maxSpeed: maxSpeed, averageSpeed: averageSpeed};
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$calculateSummary = function (locations) {
	var summaries = A2($elm$core$List$map, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$calculateTripSummary, locations);
	return A3(
		$elm$core$List$foldl,
		F2(
			function (acc, summary) {
				var maxSpeed = A2($elm$core$Basics$max, acc.maxSpeed, summary.maxSpeed);
				var duration = A2($author$project$Data$Duration$add, acc.duration, summary.duration);
				var distance = acc.distance + summary.distance;
				return {
					distance: distance,
					duration: duration,
					maxSpeed: maxSpeed,
					averageSpeed: ($author$project$Data$Duration$toSeconds(duration) > 0) ? (distance / $author$project$Data$Duration$toSeconds(duration)) : 0
				};
			}),
		{distance: 0, duration: $author$project$Data$Duration$zero, maxSpeed: 0, averageSpeed: 0},
		summaries);
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$telemetryToVoltage = function (items) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.timestamp;
			},
			$elm$time$Time$posixToMillis),
		A2(
			$elm$core$List$filterMap,
			function (item) {
				return A2(
					$elm$core$Maybe$map,
					function (v) {
						return {voltage: v, timestamp: item.timestamp};
					},
					item.externalVoltage);
			},
			items));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$expandedChartHeight = function (viewportHeight) {
	return viewportHeight * 0.5;
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$collapsedChartHeight = 70;
var $author$project$Ports$pushUrlSilent = _Platform_outgoingPort('pushUrlSilent', $elm$json$Json$Encode$string);
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$pushUrlParamsEffect = function (model) {
	var _v0 = _Utils_Tuple2(model.startDate, model.endDate);
	if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
		var start = _v0.a.a;
		var end = _v0.b.a;
		return $author$project$Effect$fromCmd(
			$author$project$Ports$pushUrlSilent(
				A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							model.fleet.slug,
							'boats',
							$author$project$Data$Boat$boatIdToString(model.boatId),
							'logs'
						]),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'start',
							$jweir$elm_iso8601$ISO8601$toString(
								$jweir$elm_iso8601$ISO8601$fromPosix(start))),
							A2(
							$elm$url$Url$Builder$string,
							'end',
							$jweir$elm_iso8601$ISO8601$toString(
								$jweir$elm_iso8601$ISO8601$fromPosix(end)))
						]))));
	} else {
		return $author$project$Effect$none;
	}
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$changeDateRangeEffect = F2(
	function (session, model) {
		return $author$project$Effect$batch(
			_List_fromArray(
				[
					A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$fetchBoatLocations, session, model),
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$pushUrlParamsEffect(model)
				]));
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$hoverRangeWithTolerance = F2(
	function (binWidthSeconds, _v0) {
		var start = _v0.a;
		var end = _v0.b;
		if (_Utils_eq(
			$elm$time$Time$posixToMillis(start),
			$elm$time$Time$posixToMillis(end))) {
			var halfBinMs = $elm$core$Basics$round((binWidthSeconds * 1000) / 2);
			return _Utils_Tuple2(
				$elm$time$Time$millisToPosix(
					$elm$time$Time$posixToMillis(start) - halfBinMs),
				$elm$time$Time$millisToPosix(
					$elm$time$Time$posixToMillis(end) + halfBinMs));
		} else {
			return _Utils_Tuple2(start, end);
		}
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$telemetryToBilgeActivity = function (items) {
	var step = F2(
		function (item, _v8) {
			var openPeriod = _v8.a;
			var periods = _v8.b;
			var _v3 = _Utils_Tuple2(openPeriod, item.highWaterDetected);
			if (_v3.a.$ === 'Just') {
				if (_v3.b) {
					var _v4 = _v3.a.a;
					var start = _v4.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(start, item.timestamp)),
						periods);
				} else {
					var _v5 = _v3.a.a;
					var start = _v5.a;
					var lastTrue = _v5.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$List$cons,
							{end: lastTrue, start: start},
							periods));
				}
			} else {
				if (_v3.b) {
					var _v6 = _v3.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(item.timestamp, item.timestamp)),
						periods);
				} else {
					var _v7 = _v3.a;
					return _Utils_Tuple2($elm$core$Maybe$Nothing, periods);
				}
			}
		});
	var _v0 = A3(
		$elm$core$List$foldl,
		step,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.timestamp;
				},
				$elm$time$Time$posixToMillis),
			items));
	var finalOpen = _v0.a;
	var closed = _v0.b;
	return $elm$core$List$reverse(
		function () {
			if (finalOpen.$ === 'Just') {
				var _v2 = finalOpen.a;
				var start = _v2.a;
				var lastTrue = _v2.b;
				return A2(
					$elm$core$List$cons,
					{end: lastTrue, start: start},
					closed);
			} else {
				return closed;
			}
		}());
};
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$summariseActivityIntoBins = F5(
	function (locations, width, zone, start, end) {
		var spanInSeconds = ($elm$time$Time$posixToMillis(end) - $elm$time$Time$posixToMillis(start)) / 1000;
		var secondsPerPixel = spanInSeconds / width;
		var binSizes = _List_fromArray(
			[60, 60 * 2, 60 * 5, 60 * 10, 60 * 30, 60 * 60, (60 * 60) * 3, (60 * 60) * 6, (60 * 60) * 12]);
		var binSize = $elm$core$Basics$round(
			A2(
				$elm$core$Maybe$withDefault,
				(60 * 60) * 12,
				$elm$core$List$minimum(
					A2(
						$elm$core$List$filter,
						function (s) {
							return (s / secondsPerPixel) >= 2;
						},
						binSizes))));
		var offset = (A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, start) * 60) * 1000;
		var adjustedBinIndex = function (ts) {
			var pos = $elm$time$Time$posixToMillis(ts);
			var adjusted = ((pos - offset) / 1000) | 0;
			return (adjusted / binSize) | 0;
		};
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var fst = _v0.a;
					var ls = _v0.b;
					var timestamp = $elm$time$Time$millisToPosix(
						((adjustedBinIndex(fst.timestamp) * binSize) * 1000) + offset);
					var all = A2($elm$core$List$cons, fst, ls);
					var speed = $elm$core$List$sum(
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.speed;
							},
							all));
					var avg = speed / $elm$core$List$length(all);
					return {speed: avg, timestamp: timestamp};
				},
				A2(
					$elm_community$list_extra$List$Extra$gatherEqualsBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.timestamp;
						},
						adjustedBinIndex),
					locations)),
			binSize);
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$telemetryToSignalStrength = function (items) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.timestamp;
			},
			$elm$time$Time$posixToMillis),
		A2(
			$elm$core$List$filterMap,
			function (item) {
				return A2(
					$elm$core$Maybe$andThen,
					function (s) {
						return (s === 99) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							{timestamp: item.timestamp, signalStrength: s});
					},
					item.signalStrength);
			},
			items));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnGetViewport':
				if (msg.a.$ === 'Ok') {
					var viewport = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								chart: A4(
									$author$project$Views$ActivityChart$setHeights,
									$author$project$Pages$Fleet_$Boats$BoatId_$Logs$collapsedChartHeight,
									$author$project$Pages$Fleet_$Boats$BoatId_$Logs$expandedChartHeight(viewport.viewport.height),
									$author$project$Pages$Fleet_$Boats$BoatId_$Logs$maxChartHeight(viewport.viewport.height),
									model.chart),
								activity: A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2(_List_Nil, 30),
									A3(
										$elm$core$Maybe$map2,
										F2(
											function (s, e) {
												return A5(
													$author$project$Pages$Fleet_$Boats$BoatId_$Logs$summariseActivityIntoBins,
													$elm$core$List$concat(model.trips),
													viewport.viewport.width,
													model.timeZone,
													s,
													e);
											}),
										model.startDate,
										model.endDate)),
								viewportWidth: viewport.viewport.width,
								viewportHeight: viewport.viewport.height
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnResizeWindow':
				var w = msg.a;
				var h = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							chart: A4(
								$author$project$Views$ActivityChart$setHeights,
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$collapsedChartHeight,
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$expandedChartHeight(h),
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$maxChartHeight(h),
								model.chart),
							activity: A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(_List_Nil, 30),
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (s, e) {
											return A5(
												$author$project$Pages$Fleet_$Boats$BoatId_$Logs$summariseActivityIntoBins,
												$elm$core$List$concat(model.trips),
												w,
												model.timeZone,
												s,
												e);
										}),
									model.startDate,
									model.endDate)),
							viewportWidth: w,
							viewportHeight: h
						}),
					$author$project$Effect$fromCmd(
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnGetMapElement,
							$elm$browser$Browser$Dom$getElement('map'))));
			case 'OnGetMapElement':
				if (msg.a.$ === 'Ok') {
					var element = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mapSize: _Utils_Tuple2(element.element.width, element.element.height)
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnTime':
				var _v1 = msg.a;
				var t = _v1.a;
				var z = _v1.b;
				var n = _v1.c;
				var _v2 = A3($author$project$Time$RelativeDateRange$toStartEnd, t, z, $author$project$Time$RelativeDateRange$Today);
				var defaultStart = _v2.a;
				var defaultEnd = _v2.b;
				var _v3 = _Utils_Tuple3(
					A2($elm$core$Maybe$withDefault, defaultStart, model.startDate),
					A2($elm$core$Maybe$withDefault, defaultEnd, model.endDate),
					$elm_community$maybe_extra$Maybe$Extra$isNothing(model.startDate));
				var startDate = _v3.a;
				var endDate = _v3.b;
				var fetch = _v3.c;
				var chart = function (c) {
					return A3(
						$author$project$Views$ActivityChart$setDateRange,
						startDate,
						endDate,
						_Utils_update(
							c,
							{zone: z}));
				}(model.chart);
				var updatedModel = _Utils_update(
					model,
					{
						chart: chart,
						endDate: $elm$core$Maybe$Just(endDate),
						timeZone: z,
						startDate: $elm$core$Maybe$Just(startDate),
						currentTime: t,
						timeZoneName: $elm$core$Maybe$Just(n),
						selectedRange: $elm$core$Maybe$Just($author$project$Time$RelativeDateRange$Today)
					});
				return fetch ? _Utils_Tuple2(
					updatedModel,
					A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$changeDateRangeEffect, session, updatedModel)) : _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'MapIdle':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mapPosition: $author$project$Geospatial$MapProjection$positionFromBounds(
								$author$project$Geospatial$MapProjection$normaliseBounds(b))
						}),
					$author$project$Effect$none);
			case 'MapClicked':
				var latLong = msg.a;
				var updatedModel = model.measureModeActive ? _Utils_update(
					model,
					{
						measureLine: _Utils_ap(
							model.measureLine,
							_List_fromArray(
								[
									{lat: latLong.lat, _long: latLong._long},
									{lat: latLong.lat, _long: latLong._long}
								]))
					}) : _Utils_update(
					model,
					{
						sheet: A2($author$project$Views$SidebarSheet$showPage, 0, model.sheet),
						selectedLocation: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
			case 'MapMouseMove':
				var latLong = msg.a;
				if (model.measureModeActive) {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: _Utils_ap(
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$dropLast(model.measureLine),
								_List_fromArray(
									[
										{lat: latLong.lat, _long: latLong._long}
									]))
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'ControlClicked':
				var id = msg.a;
				if (id === 'measure') {
					var updatedModel = _Utils_update(
						model,
						{
							measureLine: model.measureModeActive ? _List_Nil : model.measureLine,
							measureModeActive: !model.measureModeActive
						});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectStyle':
				var style = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapStyle: style}),
					$author$project$Effect$none);
			case 'FetchBoatHistory':
				var updatedModel = _Utils_update(
					model,
					{
						chart: $author$project$Pages$Fleet_$Boats$BoatId_$Logs$clearTelemetry(model.chart),
						error: $elm$core$Maybe$Nothing,
						trips: _List_Nil,
						summary: $elm$core$Maybe$Nothing,
						voltage: _List_Nil,
						bilgeActivity: _List_Nil,
						signalStrength: _List_Nil,
						selectedLocation: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					updatedModel,
					A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$changeDateRangeEffect, session, updatedModel));
			case 'OnFetchBoat':
				if (msg.a.$ === 'Ok') {
					var b = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								boat: $elm$core$Maybe$Just(b)
							}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchBoatLocations':
				if (msg.a.$ === 'Ok') {
					var trips = msg.a.a;
					var flattenedLocations = $elm$core$List$concat(trips);
					var activity = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(_List_Nil, 30),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (s, e) {
									return A5($author$project$Pages$Fleet_$Boats$BoatId_$Logs$summariseActivityIntoBins, flattenedLocations, model.viewportWidth, model.timeZone, s, e);
								}),
							model.startDate,
							model.endDate));
					var mapPos = A2(
						$elm$core$Maybe$withDefault,
						model.mapPosition,
						A2(
							$elm$core$Maybe$map,
							function (_v5) {
								var la = _v5.a;
								var lo = _v5.b;
								var z = _v5.c;
								return A2(
									$author$project$Geospatial$MapProjection$MapPosition,
									A2($author$project$Geospatial$LatLong$LatLong, la, lo),
									z);
							},
							$author$project$Geospatial$MapProjection$calculateBoundingBox(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.latLong;
									},
									flattenedLocations))));
					var bounds = $author$project$Geospatial$BoundingBox$fromLatLongs(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.latLong;
							},
							flattenedLocations));
					var chart = function (c) {
						return _Utils_update(
							c,
							{activities: activity.a, binWidthSeconds: activity.b});
					}(model.chart);
					var updatedModel = _Utils_update(
						model,
						{
							chart: chart,
							trips: trips,
							summary: $elm$core$Maybe$Just(
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$calculateSummary(trips)),
							activity: activity,
							mapPosition: mapPos,
							selectedLocation: $elm$core$Maybe$Nothing
						});
					return _Utils_Tuple2(
						updatedModel,
						$author$project$Effect$fromCmd(
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Ports$completeProgressBar(_Utils_Tuple0),
										A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											function (b) {
												return A2(
													$author$project$MapCommands$fitBounds,
													_List_fromArray(
														[
															$author$project$Mapbox$Cmd$Option$padding(
															{top: 50, left: 50, right: 50, bottom: 50}),
															$author$project$Mapbox$Cmd$Option$maxZoom(22)
														]),
													_Utils_Tuple2(
														{lat: b.southWest.lat, lng: b.southWest._long},
														{lat: b.northEast.lat, lng: b.northEast._long}));
											},
											bounds))
									]))));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'OnFetchBoatLogs':
				if (msg.a.$ === 'Ok') {
					var logs = msg.a.a;
					var chart = function (c) {
						return _Utils_update(
							c,
							{logs: logs});
					}(model.chart);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{logs: logs, chart: chart}),
						$author$project$Effect$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$none);
				}
			case 'OnFetchBoatTelemetry':
				if (msg.a.$ === 'Ok') {
					var telemetry = msg.a.a;
					var signalStrength = $author$project$Pages$Fleet_$Boats$BoatId_$Logs$telemetryToSignalStrength(telemetry.telemetry);
					var voltage = $author$project$Pages$Fleet_$Boats$BoatId_$Logs$telemetryToVoltage(telemetry.telemetry);
					var bilge = $author$project$Pages$Fleet_$Boats$BoatId_$Logs$telemetryToBilgeActivity(telemetry.telemetry);
					var chart = A2(
						$author$project$Views$ActivityChart$setBilgeActivity,
						bilge,
						A2(
							$author$project$Views$ActivityChart$setSignalStrength,
							signalStrength,
							A2($author$project$Views$ActivityChart$setVoltage, voltage, model.chart)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{chart: chart, voltage: voltage, bilgeActivity: bilge, signalStrength: signalStrength}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'ChartMsg':
				var cMsg = msg.a;
				var _v6 = A2($author$project$Views$ActivityChart$update, cMsg, model.chart);
				var newChart = _v6.a;
				var outMsg = _v6.b;
				if (outMsg.$ === 'Just') {
					switch (outMsg.a.$) {
						case 'DateRangeSelected':
							var _v8 = outMsg.a;
							var start = _v8.a;
							var end = _v8.b;
							if (_Utils_cmp(
								(($elm$time$Time$posixToMillis(end) - $elm$time$Time$posixToMillis(start)) / 1000) | 0,
								60 * 30) < 0) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{chart: newChart}),
									$author$project$Effect$none);
							} else {
								var filteredBilge = A2(
									$elm$core$List$filter,
									function (p) {
										return (_Utils_cmp(
											$elm$time$Time$posixToMillis(p.end),
											$elm$time$Time$posixToMillis(start)) > -1) && (_Utils_cmp(
											$elm$time$Time$posixToMillis(p.start),
											$elm$time$Time$posixToMillis(end)) < 1);
									},
									model.bilgeActivity);
								var inRange = function (ts) {
									return (_Utils_cmp(
										$elm$time$Time$posixToMillis(ts),
										$elm$time$Time$posixToMillis(start)) > -1) && (_Utils_cmp(
										$elm$time$Time$posixToMillis(ts),
										$elm$time$Time$posixToMillis(end)) < 1);
								};
								var filteredLogs = A2(
									$elm$core$List$filter,
									function (l) {
										return inRange(l.timestamp);
									},
									model.logs);
								var filteredTrips = A2(
									$elm$core$List$filter,
									function (l) {
										return $elm$core$List$length(l) > 0;
									},
									A2(
										$elm$core$List$map,
										$elm$core$List$filter(
											function (l) {
												return inRange(l.timestamp);
											}),
										model.trips));
								var updatedSummary = $author$project$Pages$Fleet_$Boats$BoatId_$Logs$calculateSummary(filteredTrips);
								var updatedActivity = A5(
									$author$project$Pages$Fleet_$Boats$BoatId_$Logs$summariseActivityIntoBins,
									$elm$core$List$concat(filteredTrips),
									model.viewportWidth,
									model.timeZone,
									start,
									end);
								var filteredVoltage = A2(
									$elm$core$List$filter,
									function (v) {
										return inRange(v.timestamp);
									},
									model.voltage);
								var filteredSignalStrength = A2(
									$elm$core$List$filter,
									function (s) {
										return inRange(s.timestamp);
									},
									model.signalStrength);
								var updatedChart = A2(
									$author$project$Views$ActivityChart$setBilgeActivity,
									filteredBilge,
									A2(
										$author$project$Views$ActivityChart$setSignalStrength,
										filteredSignalStrength,
										A2(
											$author$project$Views$ActivityChart$setVoltage,
											filteredVoltage,
											A3(
												$author$project$Views$ActivityChart$setDateRange,
												start,
												end,
												function (c) {
													return _Utils_update(
														c,
														{activities: updatedActivity.a, binWidthSeconds: updatedActivity.b});
												}(newChart)))));
								var updatedModel = _Utils_update(
									model,
									{
										logs: filteredLogs,
										chart: updatedChart,
										error: $elm$core$Maybe$Nothing,
										trips: filteredTrips,
										endDate: $elm$core$Maybe$Just(end),
										summary: $elm$core$Maybe$Just(updatedSummary),
										voltage: filteredVoltage,
										startDate: $elm$core$Maybe$Just(start),
										bilgeActivity: filteredBilge,
										selectedRange: $elm$core$Maybe$Nothing,
										signalStrength: filteredSignalStrength
									});
								return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
							}
						case 'ActivityClicked':
							var _v9 = outMsg.a;
							var start = _v9.a;
							var end = _v9.b;
							var filteredPoints = A2(
								$elm$core$List$concatMap,
								$elm$core$List$filter(
									function (l) {
										return (_Utils_cmp(
											$elm$time$Time$posixToMillis(l.timestamp),
											$elm$time$Time$posixToMillis(start)) > -1) && (_Utils_cmp(
											$elm$time$Time$posixToMillis(l.timestamp),
											$elm$time$Time$posixToMillis(end)) < 1);
									}),
								model.trips);
							var bounds = $author$project$Geospatial$BoundingBox$fromLatLongs(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.latLong;
									},
									filteredPoints));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{chart: newChart}),
								$author$project$Effect$fromCmd(
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											function (b) {
												return A2(
													$author$project$MapCommands$fitBounds,
													_List_fromArray(
														[
															$author$project$Mapbox$Cmd$Option$padding(
															{top: 50, left: 50, right: 50, bottom: 50}),
															$author$project$Mapbox$Cmd$Option$maxZoom(22)
														]),
													_Utils_Tuple2(
														{lat: b.southWest.lat, lng: b.southWest._long},
														{lat: b.northEast.lat, lng: b.northEast._long}));
											},
											bounds))));
						case 'LogClicked':
							var timestamp = outMsg.a.a;
							var log = $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (l) {
										return _Utils_eq(l.timestamp, timestamp);
									},
									model.logs));
							if (log.$ === 'Just') {
								var l = log.a;
								return A2(
									$author$project$Pages$Fleet_$Boats$BoatId_$Logs$showLogLocation,
									_Utils_update(
										model,
										{chart: newChart}),
									l);
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{chart: newChart}),
									$author$project$Effect$none);
							}
						case 'ExpandToggled':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{chart: newChart}),
								$author$project$Effect$none);
						case 'Animating':
							var _v11 = outMsg.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{chart: newChart}),
								$author$project$Effect$fromCmd($author$project$MapCommands$resize));
						default:
							var range = outMsg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										chart: newChart,
										hoveredTrackRange: A2(
											$elm$core$Maybe$map,
											$author$project$Pages$Fleet_$Boats$BoatId_$Logs$hoverRangeWithTolerance(newChart.binWidthSeconds),
											range)
									}),
								$author$project$Effect$none);
					}
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{chart: newChart}),
						$author$project$Effect$none);
				}
			case 'OnFetchGeofences':
				if (msg.a.$ === 'Ok') {
					var gs = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{geofences: gs}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SelectRelativeRange':
				var r = msg.a;
				var _v12 = A3($author$project$Time$RelativeDateRange$toStartEnd, model.currentTime, model.timeZone, r);
				var start = _v12.a;
				var end = _v12.b;
				var chart = $author$project$Pages$Fleet_$Boats$BoatId_$Logs$clearTelemetry(
					A3($author$project$Views$ActivityChart$setDateRange, start, end, model.chart));
				var updatedModel = _Utils_update(
					model,
					{
						chart: chart,
						error: $elm$core$Maybe$Nothing,
						trips: _List_Nil,
						endDate: $elm$core$Maybe$Just(end),
						summary: $elm$core$Maybe$Nothing,
						voltage: _List_Nil,
						startDate: $elm$core$Maybe$Just(start),
						bilgeActivity: _List_Nil,
						selectedRange: $elm$core$Maybe$Just(r),
						signalStrength: _List_Nil
					});
				return _Utils_Tuple2(
					updatedModel,
					A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$changeDateRangeEffect, session, updatedModel));
			case 'OpenPicker':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							durationDatePicker: A5(
								$mercurymedia$elm_datetime_picker$DurationDatePicker$openPicker,
								$author$project$Pages$Fleet_$Boats$BoatId_$Logs$settings(model),
								model.currentTime,
								model.startDate,
								model.endDate,
								model.durationDatePicker)
						}),
					$author$project$Effect$none);
			case 'UpdateDatePicker':
				var m = msg.a;
				var _v13 = A3(
					$mercurymedia$elm_datetime_picker$DurationDatePicker$update,
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$settings(model),
					m,
					model.durationDatePicker);
				var newPicker = _v13.a;
				var dates = _v13.b;
				if (dates.$ === 'Just') {
					var _v15 = dates.a;
					var start = _v15.a;
					var end = _v15.b;
					var chart = A3($author$project$Views$ActivityChart$setDateRange, start, end, model.chart);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								chart: chart,
								endDate: $elm$core$Maybe$Just(end),
								startDate: $elm$core$Maybe$Just(start),
								selectedRange: $elm$core$Maybe$Nothing,
								durationDatePicker: newPicker
							}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{durationDatePicker: newPicker}),
						$author$project$Effect$none);
				}
			case 'UpdateStartDate':
				var d = msg.a;
				var newStart = A2(
					$elm$core$Maybe$map,
					$jweir$elm_iso8601$ISO8601$toPosix,
					A2($author$project$ISO8601$Extra$parseDateTime, model.timeZone, d));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							startDate: A2($elm_community$maybe_extra$Maybe$Extra$orElse, model.startDate, newStart)
						}),
					$author$project$Effect$none);
			case 'UpdateEndDate':
				var d = msg.a;
				var newEnd = A2(
					$elm$core$Maybe$map,
					$jweir$elm_iso8601$ISO8601$toPosix,
					A2($author$project$ISO8601$Extra$parseDateTime, model.timeZone, d));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							endDate: A2($elm_community$maybe_extra$Maybe$Extra$orElse, model.endDate, newEnd)
						}),
					$author$project$Effect$none);
			case 'UpdateShowPoints':
				var b = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showPoints: b}),
					$author$project$Effect$none);
			case 'SelectBoatLocation':
				if (msg.a.$ === 'Just') {
					var markerId = msg.a.a;
					var location = $elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							$elm_community$list_extra$List$Extra$find(
								function (l) {
									return _Utils_eq(
										$author$project$Data$BoatLocation$toMarkerId(l),
										markerId);
								}),
							model.trips));
					var updatedModel = _Utils_update(
						model,
						{selectedLocation: location});
					return _Utils_Tuple2(updatedModel, $author$project$Effect$none);
				} else {
					var _v16 = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedLocation: $elm$core$Maybe$Nothing}),
						$author$project$Effect$none);
				}
			case 'ShowLogLocation':
				var l = msg.a;
				return A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$showLogLocation, model, l);
			case 'DownloadCsv':
				var flattenedLocations = $elm$core$List$concat(model.trips);
				var _v17 = _Utils_Tuple3(flattenedLocations, model.startDate, model.endDate);
				if (!_v17.a.b) {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				} else {
					if ((_v17.b.$ === 'Just') && (_v17.c.$ === 'Just')) {
						var locs = _v17.a;
						var start = _v17.b.a;
						var end = _v17.c.a;
						var filename = A3(
							$elm$core$String$replace,
							' ',
							'_',
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Data$Boat$boatIdToString(model.boatId),
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.name;
									},
									model.boat))) + ('_' + (A2(
							$author$project$ISO8601$Extra$toDateString,
							model.timeZone,
							$jweir$elm_iso8601$ISO8601$fromPosix(start)) + ('_' + (A2(
							$author$project$ISO8601$Extra$toDateString,
							model.timeZone,
							$jweir$elm_iso8601$ISO8601$fromPosix(end)) + '.csv'))));
						return _Utils_Tuple2(
							model,
							$author$project$Effect$fromCmd(
								A3(
									$elm$file$File$Download$string,
									filename,
									'text/csv',
									A2($author$project$Data$BoatLocation$toCsv, model.fleet.speedUnit, locs))));
					} else {
						return _Utils_Tuple2(model, $author$project$Effect$none);
					}
				}
			case 'DownloadGpx':
				var _v18 = _Utils_Tuple2(model.startDate, model.endDate);
				if ((_v18.a.$ === 'Just') && (_v18.b.$ === 'Just')) {
					var start = _v18.a.a;
					var end = _v18.b.a;
					var filename = A3(
						$elm$core$String$replace,
						' ',
						'_',
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Boat$boatIdToString(model.boatId),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.name;
								},
								model.boat))) + ('_' + (A2(
						$author$project$ISO8601$Extra$toDateString,
						model.timeZone,
						$jweir$elm_iso8601$ISO8601$fromPosix(start)) + ('_' + (A2(
						$author$project$ISO8601$Extra$toDateString,
						model.timeZone,
						$jweir$elm_iso8601$ISO8601$fromPosix(end)) + '.gpx'))));
					return _Utils_Tuple2(
						model,
						$author$project$Effect$fromCmd(
							A3(
								$elm$file$File$Download$string,
								filename,
								'application/gpx+xml',
								$author$project$Gpx$Encode$encode(
									A2($author$project$Gpx$Encode$gpx, model.currentTime, model.trips)))));
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'SheetMsg':
				var sheetMsg = msg.a;
				var _v19 = A3(
					$author$project$Views$SidebarSheet$update,
					$author$project$Pages$Fleet_$Boats$BoatId_$Logs$sheetConfig(model),
					sheetMsg,
					model.sheet);
				var updatedSheet = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sheet: updatedSheet}),
					$author$project$Effect$fromCmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$SheetMsg, cmd)));
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			case 'Logout':
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
			default:
				return _Utils_Tuple2(model, $author$project$Effect$none);
		}
	});
var $author$project$Views$ActivityChart$ResizeTo = function (a) {
	return {$: 'ResizeTo', a: a};
};
var $author$project$Views$ActivityChart$EndResize = {$: 'EndResize'};
var $author$project$Views$ActivityChart$AnimationTick = function (a) {
	return {$: 'AnimationTick', a: a};
};
var $author$project$Views$ActivityChart$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A3($mdgriffith$elm_animator$Animator$toSubscription, $author$project$Views$ActivityChart$AnimationTick, model, $author$project$Views$ActivityChart$animator),
				function () {
				var _v0 = model.resizeAnchor;
				if (_v0.$ === 'Just') {
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								$elm$browser$Browser$Events$onMouseMove(
								A2(
									$elm$json$Json$Decode$map,
									$author$project$Views$ActivityChart$ResizeTo,
									A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))),
								$elm$browser$Browser$Events$onMouseUp(
								$elm$json$Json$Decode$succeed($author$project$Views$ActivityChart$EndResize))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnResizeWindow = F2(
	function (a, b) {
		return {$: 'OnResizeWindow', a: a, b: b};
	});
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$mercurymedia$elm_datetime_picker$DurationDatePicker$subscriptions,
				$author$project$Pages$Fleet_$Boats$BoatId_$Logs$settings(model),
				model.durationDatePicker),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Fleet_$Boats$BoatId_$Logs$SheetMsg,
				$author$project$Views$SidebarSheet$subscriptions(model.sheet)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Fleet_$Boats$BoatId_$Logs$ChartMsg,
				$author$project$Views$ActivityChart$subscriptions(model.chart)),
				$elm$browser$Browser$Events$onResize($author$project$Pages$Fleet_$Boats$BoatId_$Logs$OnResizeWindow)
			]));
};
var $author$project$Pages$Fleet_$Boats$BoatId_$Logs$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$Boats$BoatId_$Logs$init, shared, session, req),
					view: A2($author$project$Pages$Fleet_$Boats$BoatId_$Logs$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$Boats$BoatId_$Logs$update(session),
					subscriptions: $author$project$Pages$Fleet_$Boats$BoatId_$Logs$subscriptions
				};
			});
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$initialModel = F3(
	function (u, f, r) {
		return {
			error: $elm$core$Maybe$Nothing,
			fleet: f,
			apiUrl: u,
			activeDays: _List_Nil,
			currentTime: $elm$time$Time$millisToPosix(0),
			currentZone: $elm$time$Time$utc,
			utilisation: _List_Nil,
			currentRoute: r,
			selectedYear: 0,
			selectedMonth: 0
		};
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$init = F3(
	function (s, u, req) {
		var fleet = A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(req.params.fleet, f.slug);
			},
			s.fleets);
		if (fleet.$ === 'Just') {
			var f = fleet.a;
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$MonthlyUtilisation$initialModel, u, f, req.route),
				$author$project$Effect$batch(
					_List_fromArray(
						[
							$author$project$Effect$fromCmd(
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Fleet_$MonthlyUtilisation$OnTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (t, z) {
											return _Utils_Tuple2(t, z);
										}),
									$elm$time$Time$now,
									$elm$time$Time$here))),
							$author$project$Effect$fromCmd(
							$author$project$Ports$sendPageViewEvent(
								_Utils_Tuple2(req.url.path, f.name + ': Fleet Utilisation (Monthly)')))
						])));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Pages$Fleet_$MonthlyUtilisation$initialModel, u, $author$project$Data$Fleet$empty, $author$project$Gen$Route$NotFound),
				$author$project$Effect$fromCmd(
					A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req)));
		}
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$Logout = {$: 'Logout'};
var $author$project$Views$HorizontalBarChart$Monthly = {$: 'Monthly'};
var $author$project$Pages$Fleet_$MonthlyUtilisation$monthName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$CloseError = {$: 'CloseError'};
var $author$project$Pages$Fleet_$MonthlyUtilisation$UpdateYear = function (a) {
	return {$: 'UpdateYear', a: a};
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$UpdateMonth = function (a) {
	return {$: 'UpdateMonth', a: a};
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$monthFromInt = function (i) {
	switch (i) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		case 12:
			return $elm$time$Time$Dec;
		default:
			return $elm$time$Time$Jan;
	}
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$monthEndTime = F3(
	function (z, year, month) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$ceiling,
			$justinmimbs$time_extra$Time$Extra$Month,
			z,
			A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				z,
				{
					day: 28,
					hour: 0,
					year: year,
					month: $author$project$Pages$Fleet_$MonthlyUtilisation$monthFromInt(month),
					minute: 0,
					second: 0,
					millisecond: 0
				}));
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$monthStartTime = F3(
	function (z, year, month) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$floor,
			$justinmimbs$time_extra$Time$Extra$Month,
			z,
			A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				z,
				{
					day: 1,
					hour: 0,
					year: year,
					month: $author$project$Pages$Fleet_$MonthlyUtilisation$monthFromInt(month),
					minute: 0,
					second: 0,
					millisecond: 0
				}));
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$ChangelogAction = function (a) {
	return {$: 'ChangelogAction', a: a};
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$FetchActiveDays = {$: 'FetchActiveDays'};
var $author$project$Pages$Fleet_$MonthlyUtilisation$activeDaysToUtilisation = F2(
	function (zone, bad) {
		return _Utils_Tuple2(
			bad.boatName,
			A2(
				$elm$core$List$map,
				function (d) {
					return _Utils_Tuple2(
						A3($justinmimbs$time_extra$Time$Extra$floor, $justinmimbs$time_extra$Time$Extra$Day, zone, d),
						A3(
							$justinmimbs$time_extra$Time$Extra$ceiling,
							$justinmimbs$time_extra$Time$Extra$Day,
							zone,
							A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Hour, 11, zone, d)));
				},
				bad.activeDays));
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$view = F3(
	function (session, featureDropState, model) {
		return {
			body: A2(
				$author$project$Html$Layout$scrollWindow,
				A6(
					$author$project$Html$Layout$createNavModel,
					session,
					$elm$core$Maybe$Just(model.fleet),
					$elm$core$Maybe$Just(model.currentRoute),
					featureDropState,
					$author$project$Pages$Fleet_$MonthlyUtilisation$ChangelogAction,
					$author$project$Pages$Fleet_$MonthlyUtilisation$Logout),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reports | Fleet Utilisation (Monthly)')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('d-flex flex-column flex-lg-row align-items-center py-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('d-flex flex-row d-flex flex-column flex-lg-row align-items-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-select form-select-sm my-1 me-2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Month'),
												$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$MonthlyUtilisation$UpdateMonth)
											]),
										A2(
											$elm$core$List$map,
											function (i) {
												return A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$selected(
															_Utils_eq(i, model.selectedMonth)),
															$elm$html$Html$Attributes$value(
															$elm$core$String$fromInt(i))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Pages$Fleet_$MonthlyUtilisation$monthName(
																$justinmimbs$date$Date$numberToMonth(i)))
														]));
											},
											A2($elm$core$List$range, 1, 12))),
										$elm$html$Html$text('/'),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-select form-select-sm my-1 ms-2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Year'),
												$elm$html$Html$Events$onInput($author$project$Pages$Fleet_$MonthlyUtilisation$UpdateYear)
											]),
										A2(
											$elm$core$List$map,
											function (i) {
												return A2(
													$elm$html$Html$option,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$selected(
															_Utils_eq(i, model.selectedYear))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(i))
														]));
											},
											A2(
												$elm$core$List$range,
												2018,
												A2($elm$time$Time$toYear, model.currentZone, model.currentTime))))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-light my-1 mx-2'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$disabled((!model.selectedMonth) || (!model.selectedYear)),
										$elm$html$Html$Events$onClick($author$project$Pages$Fleet_$MonthlyUtilisation$FetchActiveDays)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Show Results'),
										$lattyware$elm_fontawesome$FontAwesome$view(
										A2(
											$lattyware$elm_fontawesome$FontAwesome$styled,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('ms-2')
												]),
											$lattyware$elm_fontawesome$FontAwesome$Solid$chevronRight))
									]))
							])),
						$author$project$Views$HorizontalBarChart$view(
						{
							end: A3($author$project$Pages$Fleet_$MonthlyUtilisation$monthEndTime, model.currentZone, model.selectedYear, model.selectedMonth),
							zone: model.currentZone,
							start: A3($author$project$Pages$Fleet_$MonthlyUtilisation$monthStartTime, model.currentZone, model.selectedYear, model.selectedMonth),
							format: $author$project$Views$HorizontalBarChart$Monthly,
							series: A2(
								$elm$core$List$map,
								$author$project$Pages$Fleet_$MonthlyUtilisation$activeDaysToUtilisation(model.currentZone),
								model.activeDays)
						}),
						A2($author$project$Views$Alert$view, model.error, $author$project$Pages$Fleet_$MonthlyUtilisation$CloseError)
					])),
			title: model.fleet.name
		};
	});
var $author$project$Data$BoatActiveDays$BoatActiveDays = F3(
	function (boatId, boatName, activeDays) {
		return {boatId: boatId, boatName: boatName, activeDays: activeDays};
	});
var $author$project$Data$BoatActiveDays$decode = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$BoatActiveDays$BoatActiveDays,
	A2($elm$json$Json$Decode$field, 'boatId', $author$project$Data$Boat$boatIdDecoder),
	A2($elm$json$Json$Decode$field, 'boatName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'activeDays',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$toPosix, $jweir$elm_iso8601$ISO8601$decode))));
var $author$project$Api$fetchActiveDays = F6(
	function (token, apiUrl, fleet, start, end, toMsg) {
		return A2(
			$author$project$Api$logoutIf401,
			toMsg,
			$elm$http$Http$request(
				{
					url: A3(
						$elm$url$Url$Builder$crossOrigin,
						apiUrl,
						_List_fromArray(
							['fleet', fleet, 'activedays']),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'start',
								$jweir$elm_iso8601$ISO8601$toString(start)),
								A2(
								$elm$url$Url$Builder$string,
								'end',
								$jweir$elm_iso8601$ISO8601$toString(end))
							])),
					body: $elm$http$Http$emptyBody,
					expect: $author$project$Api$expectJson(
						$elm$json$Json$Decode$list($author$project$Data$BoatActiveDays$decode)),
					method: 'GET',
					headers: _List_fromArray(
						[
							$author$project$Http$Extra$authHeader(token)
						]),
					timeout: $elm$core$Maybe$Nothing,
					tracker: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$OnFetchActiveDays = function (a) {
	return {$: 'OnFetchActiveDays', a: a};
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'UpdateMonth':
				var m = msg.a;
				var _v1 = $elm$core$String$toInt(m);
				if (_v1.$ === 'Just') {
					var month = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedMonth: month}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'UpdateYear':
				var y = msg.a;
				var _v2 = $elm$core$String$toInt(y);
				if (_v2.$ === 'Just') {
					var year = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedYear: year}),
						$author$project$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$Effect$none);
				}
			case 'OnTime':
				var _v3 = msg.a;
				var t = _v3.a;
				var z = _v3.b;
				var lastMonth = A3(
					$justinmimbs$date$Date$add,
					$justinmimbs$date$Date$Months,
					-1,
					A2($justinmimbs$date$Date$fromPosix, z, t));
				var y = $justinmimbs$date$Date$year(lastMonth);
				var m = $justinmimbs$date$Date$monthNumber(lastMonth);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentTime: t, currentZone: z, selectedYear: y, selectedMonth: m}),
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0)),
								A6(
								$author$project$Api$fetchActiveDays,
								session.authToken,
								model.apiUrl,
								model.fleet.slug,
								$jweir$elm_iso8601$ISO8601$fromPosix(
									A3($author$project$Pages$Fleet_$MonthlyUtilisation$monthStartTime, z, y, m)),
								$jweir$elm_iso8601$ISO8601$fromPosix(
									A3($author$project$Pages$Fleet_$MonthlyUtilisation$monthEndTime, z, y, m)),
								$author$project$Pages$Fleet_$MonthlyUtilisation$OnFetchActiveDays)
							])));
			case 'FetchActiveDays':
				return ((!(!model.selectedMonth)) && (!(!model.selectedYear))) ? _Utils_Tuple2(
					model,
					$author$project$Effect$batch(
						_List_fromArray(
							[
								$author$project$Effect$fromCmd(
								$author$project$Ports$startProgressBar(_Utils_Tuple0)),
								A6(
								$author$project$Api$fetchActiveDays,
								session.authToken,
								model.apiUrl,
								model.fleet.slug,
								$jweir$elm_iso8601$ISO8601$fromPosix(
									A3($author$project$Pages$Fleet_$MonthlyUtilisation$monthStartTime, model.currentZone, model.selectedYear, model.selectedMonth)),
								$jweir$elm_iso8601$ISO8601$fromPosix(
									A3($author$project$Pages$Fleet_$MonthlyUtilisation$monthEndTime, model.currentZone, model.selectedYear, model.selectedMonth)),
								$author$project$Pages$Fleet_$MonthlyUtilisation$OnFetchActiveDays)
							]))) : _Utils_Tuple2(model, $author$project$Effect$none);
			case 'OnFetchActiveDays':
				if (msg.a.$ === 'Ok') {
					var activeDays = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeDays: A2(
									$elm$core$List$sortWith,
									F2(
										function (u1, u2) {
											return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, u1.boatName, u2.boatName);
										}),
									activeDays)
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									{
										icon: $lattyware$elm_fontawesome$FontAwesome$Solid$triangleExclamation,
										title: 'Error',
										type_: $author$project$Views$Alert$Danger,
										message: $author$project$Api$errorString(e)
									})
							}),
						$author$project$Effect$fromCmd(
							$author$project$Ports$completeProgressBar(_Utils_Tuple0)));
				}
			case 'CloseError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing}),
					$author$project$Effect$none);
			case 'ChangelogAction':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared(
						$author$project$Shared$ChangelogAction(action)));
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Effect$fromShared($author$project$Shared$SignOut));
		}
	});
var $author$project$Pages$Fleet_$MonthlyUtilisation$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Fleet_$MonthlyUtilisation$page = F2(
	function (shared, req) {
		return $author$project$Page$protected.advanced(
			function (session) {
				return {
					init: A3($author$project$Pages$Fleet_$MonthlyUtilisation$init, session, shared.apiUrl, req),
					view: A2($author$project$Pages$Fleet_$MonthlyUtilisation$view, session, shared.featureDropState),
					update: $author$project$Pages$Fleet_$MonthlyUtilisation$update(session),
					subscriptions: $author$project$Pages$Fleet_$MonthlyUtilisation$subscriptions
				};
			});
	});
var $author$project$Pages$NotFound$view = $author$project$View$placeholder('Page not found.');
var $author$project$Gen$Msg$Home_ = function (a) {
	return {$: 'Home_', a: a};
};
var $author$project$Gen$Model$Home_ = F2(
	function (a, b) {
		return {$: 'Home_', a: a, b: b};
	});
var $author$project$Gen$Msg$Login = function (a) {
	return {$: 'Login', a: a};
};
var $author$project$Gen$Model$Login = F2(
	function (a, b) {
		return {$: 'Login', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet_ = function (a) {
	return {$: 'Fleet_', a: a};
};
var $author$project$Gen$Model$Fleet_ = F2(
	function (a, b) {
		return {$: 'Fleet_', a: a, b: b};
	});
var $author$project$View$map = F2(
	function (fn, view) {
		return {
			body: A2(
				$elm$core$List$map,
				$elm$html$Html$map(fn),
				view.body),
			title: view.title
		};
	});
var $author$project$Effect$map = F2(
	function (fn, effect) {
		switch (effect.$) {
			case 'None':
				return $author$project$Effect$None;
			case 'Cmd':
				var cmd = effect.a;
				return $author$project$Effect$Cmd(
					A2($elm$core$Platform$Cmd$map, fn, cmd));
			case 'Shared':
				var msg = effect.a;
				return $author$project$Effect$Shared(msg);
			case 'EitherCmd':
				var cmd = effect.a;
				return $author$project$Effect$EitherCmd(
					A2(
						$elm$core$Platform$Cmd$map,
						function (e) {
							if (e.$ === 'PageMsg') {
								var m = e.a;
								return $author$project$Effect$PageMsg(
									fn(m));
							} else {
								var m = e.a;
								return $author$project$Effect$SharedMsg(m);
							}
						},
						cmd));
			case 'Batch':
				var list = effect.a;
				return $author$project$Effect$Batch(
					A2(
						$elm$core$List$map,
						$author$project$Effect$map(fn),
						list));
			case 'PushUrl':
				var url = effect.a;
				return $author$project$Effect$PushUrl(url);
			default:
				var url = effect.a;
				return $author$project$Effect$ReplaceUrl(url);
		}
	});
var $author$project$View$none = $author$project$View$placeholder('');
var $ryan_haskell$elm_spa$ElmSpa$Request$query = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Dict$empty;
	} else {
		var decode = function (val) {
			return A2(
				$elm$core$Maybe$withDefault,
				val,
				$elm$url$Url$percentDecode(val));
		};
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				A2($elm$core$Tuple$mapBoth, decode, decode),
				A2(
					$elm$core$List$filterMap,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$split('='),
						function (eq) {
							return A3(
								$elm$core$Maybe$map2,
								$elm$core$Tuple$pair,
								$elm$core$List$head(eq),
								$elm$core$Maybe$Just(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$elm$core$List$head(
											A2($elm$core$List$drop, 1, eq)))));
						}),
					A2($elm$core$String$split, '&', str))));
	}
};
var $ryan_haskell$elm_spa$ElmSpa$Request$create = F4(
	function (route, params, url, key) {
		return {
			key: key,
			url: url,
			query: A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($elm$core$Maybe$map, $ryan_haskell$elm_spa$ElmSpa$Request$query, url.query)),
			route: route,
			params: params
		};
	});
var $ryan_haskell$elm_spa$ElmSpa$Page$toResult = F3(
	function (toPage, shared, req) {
		var _v0 = A2(toPage, shared, req);
		var toResult_ = _v0.a;
		return A2(
			toResult_,
			shared,
			A4($ryan_haskell$elm_spa$ElmSpa$Request$create, req.route, _Utils_Tuple0, req.url, req.key));
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $ryan_haskell$elm_spa$ElmSpa$Page$bundle = function (_v0) {
	var toMsg = _v0.toMsg;
	var toModel = _v0.toModel;
	var page = _v0.page;
	var mapView = _v0.mapView;
	var mapEffect = _v0.mapEffect;
	var fromCmd = _v0.fromCmd;
	var toUrl = _v0.toUrl;
	var toRoute = _v0.toRoute;
	var redirecting = _v0.redirecting;
	return {
		init: F4(
			function (params, shared, url, key) {
				var req = A4(
					$ryan_haskell$elm_spa$ElmSpa$Request$create,
					toRoute(url),
					params,
					url,
					key);
				var _v1 = A3($ryan_haskell$elm_spa$ElmSpa$Page$toResult, page, shared, req);
				if (_v1.$ === 'Ok') {
					var record = _v1.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						toModel(req.params),
						mapEffect,
						record.init(_Utils_Tuple0));
				} else {
					var route = _v1.a;
					return _Utils_Tuple2(
						redirecting.model,
						fromCmd(
							A2(
								$elm$browser$Browser$Navigation$replaceUrl,
								req.key,
								toUrl(route))));
				}
			}),
		view: F5(
			function (params, model, shared, url, key) {
				var req = A4(
					$ryan_haskell$elm_spa$ElmSpa$Request$create,
					toRoute(url),
					params,
					url,
					key);
				var _v2 = A3($ryan_haskell$elm_spa$ElmSpa$Page$toResult, page, shared, req);
				if (_v2.$ === 'Ok') {
					var record = _v2.a;
					return mapView(
						record.view(model));
				} else {
					return redirecting.view;
				}
			}),
		update: F6(
			function (params, msg, model, shared, url, key) {
				var req = A4(
					$ryan_haskell$elm_spa$ElmSpa$Request$create,
					toRoute(url),
					params,
					url,
					key);
				var _v3 = A3($ryan_haskell$elm_spa$ElmSpa$Page$toResult, page, shared, req);
				if (_v3.$ === 'Ok') {
					var record = _v3.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						toModel(req.params),
						mapEffect,
						A2(record.update, msg, model));
				} else {
					var route = _v3.a;
					return _Utils_Tuple2(
						redirecting.model,
						fromCmd(
							A2(
								$elm$browser$Browser$Navigation$replaceUrl,
								req.key,
								toUrl(route))));
				}
			}),
		subscriptions: F5(
			function (params, model, shared, url, key) {
				var req = A4(
					$ryan_haskell$elm_spa$ElmSpa$Request$create,
					toRoute(url),
					params,
					url,
					key);
				var _v4 = A3($ryan_haskell$elm_spa$ElmSpa$Page$toResult, page, shared, req);
				if (_v4.$ === 'Ok') {
					var record = _v4.a;
					return A2(
						$elm$core$Platform$Sub$map,
						toMsg,
						record.subscriptions(model));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			})
	};
};
var $elm$url$Url$Parser$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return $elm$url$Url$Parser$Parser(
		function (state) {
			return A2(
				$elm$core$List$concatMap,
				function (_v0) {
					var parser = _v0.a;
					return parser(state);
				},
				parsers);
		});
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {frag: frag, value: value, params: params, visited: visited, unvisited: unvisited};
	});
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 'Nothing') {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 'Nothing') {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 'Nothing') {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.unvisited;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.value);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.value);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0.a;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.path),
					$elm$url$Url$Parser$prepareQuery(url.query),
					url.fragment,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var value = _v0.value;
		var frag = _v0.frag;
		var params = _v0.params;
		var unvisited = _v0.unvisited;
		var visited = _v0.visited;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0.a;
		return $elm$url$Url$Parser$Parser(
			function (_v1) {
				var value = _v1.value;
				var frag = _v1.frag;
				var params = _v1.params;
				var unvisited = _v1.unvisited;
				var visited = _v1.visited;
				return A2(
					$elm$core$List$map,
					$elm$url$Url$Parser$mapState(value),
					parseArg(
						A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
			});
	});
var $elm$url$Url$Parser$top = $elm$url$Url$Parser$Parser(
	function (state) {
		return _List_fromArray(
			[state]);
	});
var $author$project$Gen$Params$Home_$parser = $elm$url$Url$Parser$top;
var $elm$url$Url$Parser$s = function (str) {
	return $elm$url$Url$Parser$Parser(
		function (_v0) {
			var value = _v0.value;
			var frag = _v0.frag;
			var params = _v0.params;
			var unvisited = _v0.unvisited;
			var visited = _v0.visited;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				return _Utils_eq(next, str) ? _List_fromArray(
					[
						A5(
						$elm$url$Url$Parser$State,
						A2($elm$core$List$cons, next, visited),
						rest,
						params,
						frag,
						value)
					]) : _List_Nil;
			}
		});
};
var $author$project$Gen$Params$Login$parser = $elm$url$Url$Parser$s('login');
var $author$project$Gen$Params$Fleet_$Params = function (fleet) {
	return {fleet: fleet};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return $elm$url$Url$Parser$Parser(
			function (_v0) {
				var value = _v0.value;
				var frag = _v0.frag;
				var params = _v0.params;
				var unvisited = _v0.unvisited;
				var visited = _v0.visited;
				if (!unvisited.b) {
					return _List_Nil;
				} else {
					var next = unvisited.a;
					var rest = unvisited.b;
					var _v2 = stringToSomething(next);
					if (_v2.$ === 'Just') {
						var nextValue = _v2.a;
						return _List_fromArray(
							[
								A5(
								$elm$url$Url$Parser$State,
								A2($elm$core$List$cons, next, visited),
								rest,
								params,
								frag,
								value(nextValue))
							]);
					} else {
						return _List_Nil;
					}
				}
			});
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Gen$Params$Fleet_$parser = A2($elm$url$Url$Parser$map, $author$project$Gen$Params$Fleet_$Params, $elm$url$Url$Parser$string);
var $author$project$Gen$Params$NotFound$parser = $elm$url$Url$Parser$s('not-found');
var $author$project$Gen$Params$Register$parser = $elm$url$Url$Parser$s('register');
var $author$project$Gen$Params$Changelog$parser = $elm$url$Url$Parser$s('changelog');
var $author$project$Gen$Params$Forbidden$parser = $elm$url$Url$Parser$s('forbidden');
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0.a;
		var parseAfter = _v1.a;
		return $elm$url$Url$Parser$Parser(
			function (state) {
				return A2(
					$elm$core$List$concatMap,
					parseAfter,
					parseBefore(state));
			});
	});
var $author$project$Gen$Params$Fleet_$Edit$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Edit$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Edit$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('edit')));
var $author$project$Gen$Params$Fleet_$Boats$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Boats$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Boats$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('boats')));
var $author$project$Gen$Params$Fleet_$Users$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Users$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Users$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('users')));
var $author$project$Gen$Params$Fleet_$Video$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Video$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Video$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('video')));
var $author$project$Gen$Params$Fleet_$OnTime$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$OnTime$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$OnTime$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('on-time')));
var $author$project$Gen$Params$Fleet_$Places$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Places$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Places$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('places')));
var $author$project$Gen$Params$Fleet_$Public$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Public$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Public$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('public')));
var $author$project$Gen$Params$Fleet_$Routes$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Routes$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Routes$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('routes')));
var $author$project$Gen$Params$Fleet_$NewBoat$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$NewBoat$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$NewBoat$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('new-boat')));
var $author$project$Gen$Params$Fleet_$Summary$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Summary$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Summary$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('summary')));
var $author$project$Gen$Params$Fleet_$Dashboard$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Dashboard$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Dashboard$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('dashboard')));
var $author$project$Gen$Params$Fleet_$Discovery$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Discovery$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Discovery$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('discovery')));
var $author$project$Gen$Params$Fleet_$Geofences$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$Geofences$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Geofences$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('geofences')));
var $author$project$Gen$Params$Fleet_$Public$BoatId_$Params = F2(
	function (fleet, boatId) {
		return {fleet: fleet, boatId: boatId};
	});
var $author$project$Gen$Params$Fleet_$Public$BoatId_$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Public$BoatId_$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('public'),
			$elm$url$Url$Parser$string)));
var $author$project$Gen$Params$Fleet_$DateRangeSummary$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$DateRangeSummary$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$DateRangeSummary$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('date-range-summary')));
var $author$project$Gen$Params$Fleet_$WeeklyUtilisation$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$WeeklyUtilisation$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$WeeklyUtilisation$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('weekly-utilisation')));
var $author$project$Gen$Params$Fleet_$Boats$BoatId_$Edit$Params = F2(
	function (fleet, boatId) {
		return {fleet: fleet, boatId: boatId};
	});
var $author$project$Gen$Params$Fleet_$Boats$BoatId_$Edit$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Boats$BoatId_$Edit$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('boats'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$string,
				$elm$url$Url$Parser$s('edit')))));
var $author$project$Gen$Params$Fleet_$Boats$BoatId_$Logs$Params = F2(
	function (fleet, boatId) {
		return {fleet: fleet, boatId: boatId};
	});
var $author$project$Gen$Params$Fleet_$Boats$BoatId_$Logs$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$Boats$BoatId_$Logs$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('boats'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$string,
				$elm$url$Url$Parser$s('logs')))));
var $author$project$Gen$Params$Fleet_$MonthlyUtilisation$Params = function (fleet) {
	return {fleet: fleet};
};
var $author$project$Gen$Params$Fleet_$MonthlyUtilisation$parser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Gen$Params$Fleet_$MonthlyUtilisation$Params,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$string,
		$elm$url$Url$Parser$s('monthly-utilisation')));
var $author$project$Gen$Route$Fleet___Video = function (a) {
	return {$: 'Fleet___Video', a: a};
};
var $author$project$Gen$Route$Fleet___Dashboard = function (a) {
	return {$: 'Fleet___Dashboard', a: a};
};
var $author$project$Gen$Route$routes = _List_fromArray(
	[
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Home_, $author$project$Gen$Params$Home_$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Changelog, $author$project$Gen$Params$Changelog$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Forbidden, $author$project$Gen$Params$Forbidden$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Login, $author$project$Gen$Params$Login$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Register, $author$project$Gen$Params$Register$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$NotFound, $author$project$Gen$Params$NotFound$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet_, $author$project$Gen$Params$Fleet_$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Boats, $author$project$Gen$Params$Fleet_$Boats$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Dashboard, $author$project$Gen$Params$Fleet_$Dashboard$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___DateRangeSummary, $author$project$Gen$Params$Fleet_$DateRangeSummary$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Discovery, $author$project$Gen$Params$Fleet_$Discovery$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Edit, $author$project$Gen$Params$Fleet_$Edit$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Geofences, $author$project$Gen$Params$Fleet_$Geofences$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___MonthlyUtilisation, $author$project$Gen$Params$Fleet_$MonthlyUtilisation$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___NewBoat, $author$project$Gen$Params$Fleet_$NewBoat$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___OnTime, $author$project$Gen$Params$Fleet_$OnTime$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Places, $author$project$Gen$Params$Fleet_$Places$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Public, $author$project$Gen$Params$Fleet_$Public$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Routes, $author$project$Gen$Params$Fleet_$Routes$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Summary, $author$project$Gen$Params$Fleet_$Summary$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Users, $author$project$Gen$Params$Fleet_$Users$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Video, $author$project$Gen$Params$Fleet_$Video$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___WeeklyUtilisation, $author$project$Gen$Params$Fleet_$WeeklyUtilisation$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Public__BoatId_, $author$project$Gen$Params$Fleet_$Public$BoatId_$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Boats__BoatId___Edit, $author$project$Gen$Params$Fleet_$Boats$BoatId_$Edit$parser),
		A2($elm$url$Url$Parser$map, $author$project$Gen$Route$Fleet___Boats__BoatId___Logs, $author$project$Gen$Params$Fleet_$Boats$BoatId_$Logs$parser)
	]);
var $author$project$Gen$Route$fromUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$Parser$parse(
		$elm$url$Url$Parser$oneOf($author$project$Gen$Route$routes)),
	$elm$core$Maybe$withDefault($author$project$Gen$Route$NotFound));
var $author$project$Gen$Model$Redirecting_ = {$: 'Redirecting_'};
var $author$project$Gen$Pages$bundle = F3(
	function (page, toModel, toMsg) {
		return $ryan_haskell$elm_spa$ElmSpa$Page$bundle(
			{
				page: page,
				toMsg: toMsg,
				toUrl: $author$project$Gen$Route$toHref,
				fromCmd: $author$project$Effect$fromCmd,
				mapView: $author$project$View$map(toMsg),
				toModel: toModel,
				toRoute: $author$project$Gen$Route$fromUrl,
				mapEffect: $author$project$Effect$map(toMsg),
				redirecting: {view: $author$project$View$none, model: $author$project$Gen$Model$Redirecting_}
			});
	});
var $author$project$Gen$Pages$static = F2(
	function (view_, toModel) {
		return {
			init: F4(
				function (params, _v0, _v1, _v2) {
					return _Utils_Tuple2(
						toModel(params),
						$author$project$Effect$none);
				}),
			view: F5(
				function (_v3, _v4, _v5, _v6, _v7) {
					return A2($author$project$View$map, $elm$core$Basics$never, view_);
				}),
			update: F6(
				function (params, _v8, _v9, _v10, _v11, _v12) {
					return _Utils_Tuple2(
						toModel(params),
						$author$project$Effect$none);
				}),
			subscriptions: F5(
				function (_v13, _v14, _v15, _v16, _v17) {
					return $elm$core$Platform$Sub$none;
				})
		};
	});
var $author$project$Gen$Model$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $author$project$Gen$Msg$Register = function (a) {
	return {$: 'Register', a: a};
};
var $author$project$Gen$Model$Register = F2(
	function (a, b) {
		return {$: 'Register', a: a, b: b};
	});
var $author$project$Gen$Msg$Changelog = function (a) {
	return {$: 'Changelog', a: a};
};
var $author$project$Gen$Model$Changelog = F2(
	function (a, b) {
		return {$: 'Changelog', a: a, b: b};
	});
var $author$project$Gen$Msg$Forbidden = function (a) {
	return {$: 'Forbidden', a: a};
};
var $author$project$Gen$Model$Forbidden = F2(
	function (a, b) {
		return {$: 'Forbidden', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Edit = function (a) {
	return {$: 'Fleet___Edit', a: a};
};
var $author$project$Gen$Model$Fleet___Edit = F2(
	function (a, b) {
		return {$: 'Fleet___Edit', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Boats = function (a) {
	return {$: 'Fleet___Boats', a: a};
};
var $author$project$Gen$Model$Fleet___Boats = F2(
	function (a, b) {
		return {$: 'Fleet___Boats', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Users = function (a) {
	return {$: 'Fleet___Users', a: a};
};
var $author$project$Gen$Model$Fleet___Users = F2(
	function (a, b) {
		return {$: 'Fleet___Users', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Video = function (a) {
	return {$: 'Fleet___Video', a: a};
};
var $author$project$Gen$Model$Fleet___Video = F2(
	function (a, b) {
		return {$: 'Fleet___Video', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___OnTime = function (a) {
	return {$: 'Fleet___OnTime', a: a};
};
var $author$project$Gen$Model$Fleet___OnTime = F2(
	function (a, b) {
		return {$: 'Fleet___OnTime', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Places = function (a) {
	return {$: 'Fleet___Places', a: a};
};
var $author$project$Gen$Model$Fleet___Places = F2(
	function (a, b) {
		return {$: 'Fleet___Places', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Public = function (a) {
	return {$: 'Fleet___Public', a: a};
};
var $author$project$Gen$Model$Fleet___Public = F2(
	function (a, b) {
		return {$: 'Fleet___Public', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Routes = function (a) {
	return {$: 'Fleet___Routes', a: a};
};
var $author$project$Gen$Model$Fleet___Routes = F2(
	function (a, b) {
		return {$: 'Fleet___Routes', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___NewBoat = function (a) {
	return {$: 'Fleet___NewBoat', a: a};
};
var $author$project$Gen$Model$Fleet___NewBoat = F2(
	function (a, b) {
		return {$: 'Fleet___NewBoat', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Summary = function (a) {
	return {$: 'Fleet___Summary', a: a};
};
var $author$project$Gen$Model$Fleet___Summary = F2(
	function (a, b) {
		return {$: 'Fleet___Summary', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Dashboard = function (a) {
	return {$: 'Fleet___Dashboard', a: a};
};
var $author$project$Gen$Model$Fleet___Dashboard = F2(
	function (a, b) {
		return {$: 'Fleet___Dashboard', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Discovery = function (a) {
	return {$: 'Fleet___Discovery', a: a};
};
var $author$project$Gen$Model$Fleet___Discovery = F2(
	function (a, b) {
		return {$: 'Fleet___Discovery', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Geofences = function (a) {
	return {$: 'Fleet___Geofences', a: a};
};
var $author$project$Gen$Model$Fleet___Geofences = F2(
	function (a, b) {
		return {$: 'Fleet___Geofences', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Public__BoatId_ = function (a) {
	return {$: 'Fleet___Public__BoatId_', a: a};
};
var $author$project$Gen$Model$Fleet___Public__BoatId_ = F2(
	function (a, b) {
		return {$: 'Fleet___Public__BoatId_', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___DateRangeSummary = function (a) {
	return {$: 'Fleet___DateRangeSummary', a: a};
};
var $author$project$Gen$Model$Fleet___DateRangeSummary = F2(
	function (a, b) {
		return {$: 'Fleet___DateRangeSummary', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___WeeklyUtilisation = function (a) {
	return {$: 'Fleet___WeeklyUtilisation', a: a};
};
var $author$project$Gen$Model$Fleet___WeeklyUtilisation = F2(
	function (a, b) {
		return {$: 'Fleet___WeeklyUtilisation', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___MonthlyUtilisation = function (a) {
	return {$: 'Fleet___MonthlyUtilisation', a: a};
};
var $author$project$Gen$Model$Fleet___MonthlyUtilisation = F2(
	function (a, b) {
		return {$: 'Fleet___MonthlyUtilisation', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Boats__BoatId___Edit = function (a) {
	return {$: 'Fleet___Boats__BoatId___Edit', a: a};
};
var $author$project$Gen$Model$Fleet___Boats__BoatId___Edit = F2(
	function (a, b) {
		return {$: 'Fleet___Boats__BoatId___Edit', a: a, b: b};
	});
var $author$project$Gen$Msg$Fleet___Boats__BoatId___Logs = function (a) {
	return {$: 'Fleet___Boats__BoatId___Logs', a: a};
};
var $author$project$Gen$Model$Fleet___Boats__BoatId___Logs = F2(
	function (a, b) {
		return {$: 'Fleet___Boats__BoatId___Logs', a: a, b: b};
	});
var $author$project$Gen$Pages$pages = {
	home_: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Home_$page, $author$project$Gen$Model$Home_, $author$project$Gen$Msg$Home_),
	login: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Login$page, $author$project$Gen$Model$Login, $author$project$Gen$Msg$Login),
	fleet_: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$page, $author$project$Gen$Model$Fleet_, $author$project$Gen$Msg$Fleet_),
	notFound: A2($author$project$Gen$Pages$static, $author$project$Pages$NotFound$view, $author$project$Gen$Model$NotFound),
	register: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Register$page, $author$project$Gen$Model$Register, $author$project$Gen$Msg$Register),
	changelog: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Changelog$page, $author$project$Gen$Model$Changelog, $author$project$Gen$Msg$Changelog),
	forbidden: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Forbidden$page, $author$project$Gen$Model$Forbidden, $author$project$Gen$Msg$Forbidden),
	fleet___edit: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Edit$page, $author$project$Gen$Model$Fleet___Edit, $author$project$Gen$Msg$Fleet___Edit),
	fleet___boats: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Boats$page, $author$project$Gen$Model$Fleet___Boats, $author$project$Gen$Msg$Fleet___Boats),
	fleet___users: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Users$page, $author$project$Gen$Model$Fleet___Users, $author$project$Gen$Msg$Fleet___Users),
	fleet___video: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Video$page, $author$project$Gen$Model$Fleet___Video, $author$project$Gen$Msg$Fleet___Video),
	fleet___onTime: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$OnTime$page, $author$project$Gen$Model$Fleet___OnTime, $author$project$Gen$Msg$Fleet___OnTime),
	fleet___places: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Places$page, $author$project$Gen$Model$Fleet___Places, $author$project$Gen$Msg$Fleet___Places),
	fleet___public: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Public$page, $author$project$Gen$Model$Fleet___Public, $author$project$Gen$Msg$Fleet___Public),
	fleet___routes: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Routes$page, $author$project$Gen$Model$Fleet___Routes, $author$project$Gen$Msg$Fleet___Routes),
	fleet___newBoat: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$NewBoat$page, $author$project$Gen$Model$Fleet___NewBoat, $author$project$Gen$Msg$Fleet___NewBoat),
	fleet___summary: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Summary$page, $author$project$Gen$Model$Fleet___Summary, $author$project$Gen$Msg$Fleet___Summary),
	fleet___dashboard: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Dashboard$page, $author$project$Gen$Model$Fleet___Dashboard, $author$project$Gen$Msg$Fleet___Dashboard),
	fleet___discovery: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Discovery$page, $author$project$Gen$Model$Fleet___Discovery, $author$project$Gen$Msg$Fleet___Discovery),
	fleet___geofences: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Geofences$page, $author$project$Gen$Model$Fleet___Geofences, $author$project$Gen$Msg$Fleet___Geofences),
	fleet___public__boatId_: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Public$BoatId_$page, $author$project$Gen$Model$Fleet___Public__BoatId_, $author$project$Gen$Msg$Fleet___Public__BoatId_),
	fleet___dateRangeSummary: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$DateRangeSummary$page, $author$project$Gen$Model$Fleet___DateRangeSummary, $author$project$Gen$Msg$Fleet___DateRangeSummary),
	fleet___weeklyUtilisation: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$WeeklyUtilisation$page, $author$project$Gen$Model$Fleet___WeeklyUtilisation, $author$project$Gen$Msg$Fleet___WeeklyUtilisation),
	fleet___monthlyUtilisation: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$MonthlyUtilisation$page, $author$project$Gen$Model$Fleet___MonthlyUtilisation, $author$project$Gen$Msg$Fleet___MonthlyUtilisation),
	fleet___boats__boatId___edit: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Boats$BoatId_$Edit$page, $author$project$Gen$Model$Fleet___Boats__BoatId___Edit, $author$project$Gen$Msg$Fleet___Boats__BoatId___Edit),
	fleet___boats__boatId___logs: A3($author$project$Gen$Pages$bundle, $author$project$Pages$Fleet_$Boats$BoatId_$Logs$page, $author$project$Gen$Model$Fleet___Boats__BoatId___Logs, $author$project$Gen$Msg$Fleet___Boats__BoatId___Logs)
};
var $author$project$Gen$Pages$init = function (route) {
	switch (route.$) {
		case 'Changelog':
			return $author$project$Gen$Pages$pages.changelog.init(_Utils_Tuple0);
		case 'Fleet_':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet_.init(params);
		case 'Forbidden':
			return $author$project$Gen$Pages$pages.forbidden.init(_Utils_Tuple0);
		case 'Home_':
			return $author$project$Gen$Pages$pages.home_.init(_Utils_Tuple0);
		case 'Login':
			return $author$project$Gen$Pages$pages.login.init(_Utils_Tuple0);
		case 'Register':
			return $author$project$Gen$Pages$pages.register.init(_Utils_Tuple0);
		case 'Fleet___Boats':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___boats.init(params);
		case 'Fleet___Dashboard':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___dashboard.init(params);
		case 'Fleet___DateRangeSummary':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___dateRangeSummary.init(params);
		case 'Fleet___Discovery':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___discovery.init(params);
		case 'Fleet___Edit':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___edit.init(params);
		case 'Fleet___Geofences':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___geofences.init(params);
		case 'Fleet___MonthlyUtilisation':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___monthlyUtilisation.init(params);
		case 'Fleet___NewBoat':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___newBoat.init(params);
		case 'Fleet___OnTime':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___onTime.init(params);
		case 'Fleet___Places':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___places.init(params);
		case 'Fleet___Public':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___public.init(params);
		case 'Fleet___Routes':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___routes.init(params);
		case 'Fleet___Summary':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___summary.init(params);
		case 'Fleet___Users':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___users.init(params);
		case 'Fleet___Video':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___video.init(params);
		case 'Fleet___WeeklyUtilisation':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___weeklyUtilisation.init(params);
		case 'Fleet___Boats__BoatId___Edit':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___boats__boatId___edit.init(params);
		case 'Fleet___Boats__BoatId___Logs':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___boats__boatId___logs.init(params);
		case 'Fleet___Public__BoatId_':
			var params = route.a;
			return $author$project$Gen$Pages$pages.fleet___public__boatId_.init(params);
		default:
			return $author$project$Gen$Pages$pages.notFound.init(_Utils_Tuple0);
	}
};
var $author$project$Main$Model = F4(
	function (url, key, shared, page) {
		return {key: key, url: url, page: page, shared: shared};
	});
var $author$project$Effect$toCmd = F3(
	function (key, _v0, effect) {
		var fromSharedMsg = _v0.a;
		var fromPageMsg = _v0.b;
		var fromEither = function (e) {
			if (e.$ === 'PageMsg') {
				var m = e.a;
				return fromPageMsg(m);
			} else {
				var m = e.a;
				return fromSharedMsg(m);
			}
		};
		switch (effect.$) {
			case 'None':
				return $elm$core$Platform$Cmd$none;
			case 'Cmd':
				var cmd = effect.a;
				return A2($elm$core$Platform$Cmd$map, fromPageMsg, cmd);
			case 'Shared':
				var msg = effect.a;
				return A2(
					$elm$core$Task$perform,
					fromSharedMsg,
					$elm$core$Task$succeed(msg));
			case 'EitherCmd':
				var cmd = effect.a;
				return A2($elm$core$Platform$Cmd$map, fromEither, cmd);
			case 'Batch':
				var list = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2(
							$author$project$Effect$toCmd,
							key,
							_Utils_Tuple2(fromSharedMsg, fromPageMsg)),
						list));
			case 'PushUrl':
				var url = effect.a;
				return A2($elm$browser$Browser$Navigation$pushUrl, key, url);
			default:
				var url = effect.a;
				return A2($elm$browser$Browser$Navigation$replaceUrl, key, url);
		}
	});
var $author$project$Main$Shared = function (a) {
	return {$: 'Shared', a: a};
};
var $author$project$Request$create = F3(
	function (params, url, key) {
		return A4(
			$ryan_haskell$elm_spa$ElmSpa$Request$create,
			$author$project$Gen$Route$fromUrl(url),
			params,
			url,
			key);
	});
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var _v0 = A2(
			$author$project$Shared$init,
			A3($author$project$Request$create, _Utils_Tuple0, url, key),
			flags);
		var shared = _v0.a;
		var sharedCmd = _v0.b;
		var _v1 = A4(
			$author$project$Gen$Pages$init,
			$author$project$Gen$Route$fromUrl(url),
			shared,
			url,
			key);
		var page = _v1.a;
		var effect = _v1.b;
		return _Utils_Tuple2(
			A4($author$project$Main$Model, url, key, shared, page),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
						A3(
						$author$project$Effect$toCmd,
						key,
						_Utils_Tuple2($author$project$Main$Shared, $author$project$Main$Page),
						effect)
					])));
	});
var $author$project$Gen$Pages$view = function (model_) {
	switch (model_.$) {
		case 'Redirecting_':
			return F3(
				function (_v1, _v2, _v3) {
					return $author$project$View$none;
				});
		case 'Changelog':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.changelog.view, params, model);
		case 'Fleet_':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet_.view, params, model);
		case 'Forbidden':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.forbidden.view, params, model);
		case 'Home_':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.home_.view, params, model);
		case 'Login':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.login.view, params, model);
		case 'Register':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.register.view, params, model);
		case 'Fleet___Boats':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___boats.view, params, model);
		case 'Fleet___Dashboard':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___dashboard.view, params, model);
		case 'Fleet___DateRangeSummary':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___dateRangeSummary.view, params, model);
		case 'Fleet___Discovery':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___discovery.view, params, model);
		case 'Fleet___Edit':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___edit.view, params, model);
		case 'Fleet___Geofences':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___geofences.view, params, model);
		case 'Fleet___MonthlyUtilisation':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___monthlyUtilisation.view, params, model);
		case 'Fleet___NewBoat':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___newBoat.view, params, model);
		case 'Fleet___OnTime':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___onTime.view, params, model);
		case 'Fleet___Places':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___places.view, params, model);
		case 'Fleet___Public':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___public.view, params, model);
		case 'Fleet___Routes':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___routes.view, params, model);
		case 'Fleet___Summary':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___summary.view, params, model);
		case 'Fleet___Users':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___users.view, params, model);
		case 'Fleet___Video':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___video.view, params, model);
		case 'Fleet___WeeklyUtilisation':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___weeklyUtilisation.view, params, model);
		case 'Fleet___Boats__BoatId___Edit':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___boats__boatId___edit.view, params, model);
		case 'Fleet___Boats__BoatId___Logs':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___boats__boatId___logs.view, params, model);
		case 'Fleet___Public__BoatId_':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___public__boatId_.view, params, model);
		default:
			var params = model_.a;
			return A2($author$project$Gen$Pages$pages.notFound.view, params, _Utils_Tuple0);
	}
};
var $author$project$View$toBrowserDocument = function (view) {
	return {body: view.body, title: view.title};
};
var $author$project$Main$view = function (model) {
	return $author$project$View$toBrowserDocument(
		A2(
			$author$project$View$map,
			$author$project$Main$Page,
			A4($author$project$Gen$Pages$view, model.page, model.shared, model.url, model.key)));
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (maybe.$ === 'Just') {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$save = _Platform_outgoingPort(
	'save',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					function ($) {
					return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$core$Basics$identity, $);
				}(b)
				]));
	});
var $author$project$Data$TrackDuration$encode = function (r) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$TrackDuration$toString(r));
};
var $author$project$FeatureDrop$Manifest$encodeCta = function (cta) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(cta.label)),
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(cta.url))
			]));
};
var $author$project$FeatureDrop$Manifest$maybeField = F3(
	function (key, encoder, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					key,
					encoder(value))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$FeatureDrop$Manifest$encodeTrigger = function (trigger) {
	return $elm$json$Json$Encode$object(
		function () {
			switch (trigger.$) {
				case 'PageTrigger':
					var match = trigger.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('page')),
							_Utils_Tuple2(
							'match',
							$elm$json$Json$Encode$string(match))
						]);
				case 'UsageTrigger':
					var minActions = trigger.a.minActions;
					var event = trigger.a.event;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('usage')),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'event',
								$elm$json$Json$Encode$string(event)),
							A3($author$project$FeatureDrop$Manifest$maybeField, 'minActions', $elm$json$Json$Encode$int, minActions)));
				case 'TimeTrigger':
					var minSeconds = trigger.a.minSeconds;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('time')),
							_Utils_Tuple2(
							'minSeconds',
							$elm$json$Json$Encode$float(minSeconds))
						]);
				case 'MilestoneTrigger':
					var event = trigger.a.event;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('milestone')),
							_Utils_Tuple2(
							'event',
							$elm$json$Json$Encode$string(event))
						]);
				case 'FrustrationTrigger':
					var threshold = trigger.a.threshold;
					var pattern = trigger.a.pattern;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('frustration')),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'pattern',
								$elm$json$Json$Encode$string(pattern)),
							A3($author$project$FeatureDrop$Manifest$maybeField, 'threshold', $elm$json$Json$Encode$float, threshold)));
				default:
					var minPercent = trigger.a.minPercent;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('scroll')),
						A3($author$project$FeatureDrop$Manifest$maybeField, 'minPercent', $elm$json$Json$Encode$float, minPercent));
			}
		}());
};
var $author$project$FeatureDrop$Manifest$encodeJsonObject = A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity);
var $author$project$FeatureDrop$Manifest$encodeVariant = function (variant) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$FeatureDrop$Manifest$maybeField, 'label', $elm$json$Json$Encode$string, variant.label),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'description', $elm$json$Json$Encode$string, variant.description),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'image', $elm$json$Json$Encode$string, variant.image),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'cta', $author$project$FeatureDrop$Manifest$encodeCta, variant.cta),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'meta', $author$project$FeatureDrop$Manifest$encodeJsonObject, variant.meta)
				])));
};
var $author$project$FeatureDrop$Manifest$encodeVersion = function (version) {
	if (version.$ === 'VersionString') {
		var s = version.a;
		return $elm$json$Json$Encode$string(s);
	} else {
		var range = version.a;
		return $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						A3($author$project$FeatureDrop$Manifest$maybeField, 'introduced', $elm$json$Json$Encode$string, range.introduced),
						A3($author$project$FeatureDrop$Manifest$maybeField, 'showNewUntil', $elm$json$Json$Encode$string, range.showNewUntil),
						A3($author$project$FeatureDrop$Manifest$maybeField, 'deprecatedAt', $elm$json$Json$Encode$string, range.deprecatedAt),
						A3($author$project$FeatureDrop$Manifest$maybeField, 'showIn', $elm$json$Json$Encode$string, range.showIn)
					])));
	}
};
var $author$project$FeatureDrop$Manifest$encodeFeatureType = function (featureType) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (featureType.$) {
				case 'Feature':
					return 'feature';
				case 'Improvement':
					return 'improvement';
				case 'Fix':
					return 'fix';
				default:
					return 'breaking';
			}
		}());
};
var $author$project$FeatureDrop$Manifest$encodeAudienceRule = function (audience) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'plan',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
					audience.plan),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'role',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
					audience.role),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'region',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
					audience.region),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'custom', $author$project$FeatureDrop$Manifest$encodeJsonObject, audience.custom)
				])));
};
var $author$project$FeatureDrop$Manifest$encodeDependencies = function (deps) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'seen',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
					deps.seen),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'clicked',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
					deps.clicked),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'dismissed',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
					deps.dismissed)
				])));
};
var $author$project$FeatureDrop$Manifest$encodeFeaturePriority = function (priority) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (priority.$) {
				case 'Critical':
					return 'critical';
				case 'Normal':
					return 'normal';
				default:
					return 'low';
			}
		}());
};
var $author$project$FeatureDrop$Manifest$encodeEntry = function (entry) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(entry.id)),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(entry.label)),
						_Utils_Tuple2(
						'releasedAt',
						$elm$json$Json$Encode$string(
							$justinmimbs$date$Date$toIsoString(entry.releasedAt))),
						_Utils_Tuple2(
						'showNewUntil',
						$elm$json$Json$Encode$string(
							$justinmimbs$date$Date$toIsoString(entry.showNewUntil)))
					]),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'description', $elm$json$Json$Encode$string, entry.description),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'version', $author$project$FeatureDrop$Manifest$encodeVersion, entry.version),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'sidebarKey', $elm$json$Json$Encode$string, entry.sidebarKey),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'category', $elm$json$Json$Encode$string, entry.category),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'product', $elm$json$Json$Encode$string, entry.product),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'url', $elm$json$Json$Encode$string, entry.url),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'flagKey', $elm$json$Json$Encode$string, entry.flagKey),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'type', $author$project$FeatureDrop$Manifest$encodeFeatureType, entry.type_),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'priority', $author$project$FeatureDrop$Manifest$encodeFeaturePriority, entry.priority),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'image', $elm$json$Json$Encode$string, entry.image),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'cta', $author$project$FeatureDrop$Manifest$encodeCta, entry.cta),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'publishAt',
					A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string),
					entry.publishAt),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'meta', $author$project$FeatureDrop$Manifest$encodeJsonObject, entry.meta),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'variants',
					A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$FeatureDrop$Manifest$encodeVariant),
					entry.variants),
					A3(
					$author$project$FeatureDrop$Manifest$maybeField,
					'variantSplit',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$float),
					entry.variantSplit),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'audience', $author$project$FeatureDrop$Manifest$encodeAudienceRule, entry.audience),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'dependsOn', $author$project$FeatureDrop$Manifest$encodeDependencies, entry.dependsOn),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'trigger', $author$project$FeatureDrop$Manifest$encodeTrigger, entry.trigger)
				])));
};
var $author$project$FeatureDrop$Manifest$encode = function (manifest) {
	return A2($elm$json$Json$Encode$list, $author$project$FeatureDrop$Manifest$encodeEntry, manifest);
};
var $author$project$FeatureDrop$Manifest$encodeUserContext = function (ctx) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$FeatureDrop$Manifest$maybeField, 'plan', $elm$json$Json$Encode$string, ctx.plan),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'role', $elm$json$Json$Encode$string, ctx.role),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'region', $elm$json$Json$Encode$string, ctx.region),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'traits', $author$project$FeatureDrop$Manifest$encodeJsonObject, ctx.traits)
				])));
};
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$json$Json$Encode$set = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$Set$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $author$project$FeatureDrop$Manifest$encodeTriggerContext = function (ctx) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$FeatureDrop$Manifest$maybeField, 'path', $elm$json$Json$Encode$string, ctx.path),
					_List_fromArray(
					[
						_Utils_Tuple2(
						'events',
						A2($elm$json$Json$Encode$set, $elm$json$Json$Encode$string, ctx.events)),
						_Utils_Tuple2(
						'milestones',
						A2($elm$json$Json$Encode$set, $elm$json$Json$Encode$string, ctx.milestones)),
						_Utils_Tuple2(
						'usage',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$float, ctx.usage))
					]),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'elapsedMs', $elm$json$Json$Encode$float, ctx.elapsedMs),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'scrollPercent', $elm$json$Json$Encode$float, ctx.scrollPercent),
					A3($author$project$FeatureDrop$Manifest$maybeField, 'metadata', $author$project$FeatureDrop$Manifest$encodeJsonObject, ctx.metadata)
				])));
};
var $author$project$FeatureDrop$Manifest$encodeDependencyState = function (state) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'seenIds',
				A2($elm$json$Json$Encode$set, $elm$json$Json$Encode$string, state.seenIds)),
				_Utils_Tuple2(
				'clickedIds',
				A2($elm$json$Json$Encode$set, $elm$json$Json$Encode$string, state.clickedIds)),
				_Utils_Tuple2(
				'dismissedIds',
				A2($elm$json$Json$Encode$set, $elm$json$Json$Encode$string, state.dismissedIds))
			]));
};
var $author$project$FeatureDrop$Actions$encode = function (action) {
	var optional = F2(
		function (encoder, maybe) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, encoder, $elm$core$List$singleton),
					maybe));
		});
	var call = F2(
		function (method, args) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'method',
						$elm$json$Json$Encode$string(method)),
						_Utils_Tuple2(
						'args',
						A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, args))
					]));
		});
	switch (action.$) {
		case 'Refresh':
			return A2(call, 'refresh', _List_Nil);
		case 'Dismiss':
			var id = action.a;
			return A2(
				call,
				'dismiss',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(id)
					]));
		case 'DismissAll':
			return A2(call, 'dismissAll', _List_Nil);
		case 'SetManifest':
			var manifest = action.a;
			return A2(
				call,
				'setManifest',
				_List_fromArray(
					[
						$author$project$FeatureDrop$Manifest$encode(manifest)
					]));
		case 'SetUserContext':
			var userContext = action.a;
			return A2(
				call,
				'setUserContext',
				A2(optional, $author$project$FeatureDrop$Manifest$encodeUserContext, userContext));
		case 'SetAppVersion':
			var appVersion = action.a;
			return A2(
				call,
				'setAppVersion',
				A2(optional, $elm$json$Json$Encode$string, appVersion));
		case 'SetDependencyState':
			var dependencyState = action.a;
			return A2(
				call,
				'setDependencyState',
				A2(optional, $author$project$FeatureDrop$Manifest$encodeDependencyState, dependencyState));
		case 'MarkFeatureSeen':
			var featureId = action.a;
			return A2(
				call,
				'markFeatureSeen',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(featureId)
					]));
		case 'MarkFeatureClicked':
			var featureId = action.a;
			return A2(
				call,
				'markFeatureClicked',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(featureId)
					]));
		case 'SetTriggerContext':
			var triggerContext = action.a;
			return A2(
				call,
				'setTriggerContext',
				A2(optional, $author$project$FeatureDrop$Manifest$encodeTriggerContext, triggerContext));
		case 'SetTriggerPath':
			var path = action.a;
			return A2(
				call,
				'setTriggerPath',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(path)
					]));
		case 'TrackUsageEvent':
			var event = action.a;
			var delta = action.b;
			return A2(
				call,
				'trackUsageEvent',
				A2(
					$elm$core$List$cons,
					$elm$json$Json$Encode$string(event),
					A2(optional, $elm$json$Json$Encode$float, delta)));
		case 'TrackTriggerEvent':
			var event = action.a;
			return A2(
				call,
				'trackTriggerEvent',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(event)
					]));
		case 'TrackMilestone':
			var event = action.a;
			return A2(
				call,
				'trackMilestone',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(event)
					]));
		case 'SetTriggerElapsedMs':
			var elapsedMs = action.a;
			return A2(
				call,
				'setTriggerElapsedMs',
				_List_fromArray(
					[
						$elm$json$Json$Encode$float(elapsedMs)
					]));
		case 'SetTriggerScrollPercent':
			var scrollPercent = action.a;
			return A2(
				call,
				'setTriggerScrollPercent',
				_List_fromArray(
					[
						$elm$json$Json$Encode$float(scrollPercent)
					]));
		case 'SetTriggerMetadata':
			var metadata = action.a;
			return A2(
				call,
				'setTriggerMetadata',
				_List_fromArray(
					[
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, metadata)
					]));
		default:
			var product = action.a;
			return A2(
				call,
				'setProduct',
				A2(optional, $elm$json$Json$Encode$string, product));
	}
};
var $author$project$FeatureDrop$Actions$SetUserContext = function (a) {
	return {$: 'SetUserContext', a: a};
};
var $author$project$FeatureDrop$Actions$TrackMilestone = function (a) {
	return {$: 'TrackMilestone', a: a};
};
var $author$project$Ports$featureDropAction = _Platform_outgoingPort('featureDropAction', $elm$core$Basics$identity);
var $author$project$Shared$enteredApp = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[
			$author$project$Ports$featureDropAction(
			$author$project$FeatureDrop$Actions$encode(
				$author$project$FeatureDrop$Actions$TrackMilestone('app_entered'))),
			$author$project$Ports$featureDropAction(
			$author$project$FeatureDrop$Actions$encode(
				$author$project$FeatureDrop$Actions$SetUserContext(
					$elm$core$Maybe$Just(
						{plan: $elm$core$Maybe$Nothing, role: $elm$core$Maybe$Nothing, region: $elm$core$Maybe$Nothing, traits: $elm$core$Maybe$Nothing}))))
		]));
var $author$project$Data$Fleet$fleetIdToString = function (_v0) {
	var accountId = _v0.a;
	return accountId;
};
var $author$project$Data$Fleet$fleetIdEncoder = function (f) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Fleet$fleetIdToString(f));
};
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$union, dict1, dict2));
	});
var $author$project$FeatureDrop$State$markDismissing = F2(
	function (ids, state) {
		return _Utils_update(
			state,
			{
				dismissing: A2(
					$elm$core$Set$union,
					$elm$core$Set$fromList(ids),
					state.dismissing)
			});
	});
var $author$project$Data$User$encode = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'accountId',
				$elm$json$Json$Encode$string(
					$author$project$Data$User$accountIdToString(user.accountId))),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(user.email)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(user.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(user.lastName)),
				_Utils_Tuple2(
				'profilePhoto',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, user.profilePhoto)),
				_Utils_Tuple2(
				'isAdmin',
				$elm$json$Json$Encode$bool(user.isAdmin)),
				_Utils_Tuple2(
				'roles',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Data$User$roleEncoder, user.roles))
			]));
};
var $author$project$Data$Fleet$fleetTypeEncoder = function (ft) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Fleet$fleetTypeToString(ft));
};
var $author$project$Data$Fleet$helmConfigurationEncoder = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'tenantId',
				$elm$json$Json$Encode$string(config.tenantId)),
				_Utils_Tuple2(
				'apiKey',
				$elm$json$Json$Encode$string(config.apiKey)),
				_Utils_Tuple2(
				'eventTypeId',
				$elm$json$Json$Encode$string(config.eventTypeId))
			]));
};
var $author$project$Data$Fleet$guestViewConfigurationEncoder = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardKey',
				$elm$json$Json$Encode$string(config.dashboardKey)),
				_Utils_Tuple2(
				'displayRoutes',
				function () {
					var _v0 = config.displayRoutes;
					switch (_v0.$) {
						case 'All':
							return $elm$json$Json$Encode$string('all');
						case 'None':
							return $elm$json$Json$Encode$string('none');
						default:
							var routeIds = _v0.a;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'specified',
										A2($elm$json$Json$Encode$list, $author$project$Data$Route$routeIdEncoder, routeIds))
									]));
					}
				}()),
				_Utils_Tuple2(
				'showPopup',
				$elm$json$Json$Encode$bool(config.showPopup)),
				_Utils_Tuple2(
				'autoDisplayPlaceDistance',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, config.autoDisplayPlaceDistance))
			]));
};
var $author$project$Data$Fleet$encode = function (fleet) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fleetId',
				$elm$json$Json$Encode$string(
					$author$project$Data$Fleet$fleetIdToString(fleet.fleetId))),
				_Utils_Tuple2(
				'slug',
				$elm$json$Json$Encode$string(fleet.slug)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fleet.name)),
				_Utils_Tuple2(
				'isPrivate',
				$elm$json$Json$Encode$bool(fleet.isPrivate)),
				_Utils_Tuple2(
				'timeZoneId',
				$elm$json$Json$Encode$string(fleet.timeZoneId)),
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(fleet.latitude)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(fleet.longitude)),
				_Utils_Tuple2(
				'zoom',
				$elm$json$Json$Encode$float(fleet.zoom)),
				_Utils_Tuple2(
				'shortDistanceUnit',
				$author$project$Data$DistanceUnit$encode(fleet.shortDistanceUnit)),
				_Utils_Tuple2(
				'longDistanceUnit',
				$author$project$Data$DistanceUnit$encode(fleet.longDistanceUnit)),
				_Utils_Tuple2(
				'speedUnit',
				$author$project$Data$SpeedUnit$encode(fleet.speedUnit)),
				_Utils_Tuple2(
				'isHelmEnabled',
				$elm$json$Json$Encode$bool(fleet.isHelmEnabled)),
				_Utils_Tuple2(
				'isSeaRescue',
				$elm$json$Json$Encode$bool(fleet.isSeaRescue)),
				_Utils_Tuple2(
				'fleetType',
				$author$project$Data$Fleet$fleetTypeEncoder(fleet.fleetType)),
				_Utils_Tuple2(
				'speedAlertsEnabled',
				$elm$json$Json$Encode$bool(fleet.speedAlertsEnabled)),
				_Utils_Tuple2(
				'notificationGroups',
				A2($elm$json$Json$Encode$list, $author$project$Data$Fleet$notificationGroupEncoder, fleet.notificationGroups)),
				_Utils_Tuple2(
				'helmConfiguration',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Fleet$helmConfigurationEncoder, fleet.helmConfiguration)),
				_Utils_Tuple2(
				'watermarkImage',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, fleet.watermarkImage)),
				_Utils_Tuple2(
				'guestViewConfiguration',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Fleet$guestViewConfigurationEncoder, fleet.guestViewConfiguration))
			]));
};
var $author$project$Data$Session$authTokenEncoder = function (auth) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(
					$author$project$Data$Session$tokenToString(auth.token))),
				_Utils_Tuple2(
				'expiry',
				$elm$json$Json$Encode$string(
					$jweir$elm_iso8601$ISO8601$toString(
						$jweir$elm_iso8601$ISO8601$fromPosix(auth.expiry))))
			]));
};
var $author$project$Data$Session$sessionEncoder = function (session) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$author$project$Data$User$encode(session.user)),
				_Utils_Tuple2(
				'fleets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Fleet$encode, session.fleets)),
				_Utils_Tuple2(
				'authToken',
				$author$project$Data$Session$authTokenEncoder(session.authToken))
			]));
};
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$intersect, dict1, dict2));
	});
var $author$project$FeatureDrop$State$carryDismissing = F2(
	function (previous, next) {
		var stillNew = $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				next.newFeatures));
		return _Utils_update(
			next,
			{
				dismissing: A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Set$empty,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dismissing;
							},
							$elm$core$Set$intersect(stillNew)),
						previous))
			});
	});
var $author$project$Shared$mapPositionEncoder = function (pos) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lat',
				$elm$json$Json$Encode$float(pos.centre.lat)),
				_Utils_Tuple2(
				'lng',
				$elm$json$Json$Encode$float(pos.centre._long)),
				_Utils_Tuple2(
				'zoom',
				$elm$json$Json$Encode$float(pos.zoom))
			]));
};
var $author$project$Shared$SendFeatureDropAction = function (a) {
	return {$: 'SendFeatureDropAction', a: a};
};
var $author$project$Data$User$analyticsRoleForFleet = F2(
	function (slug, user) {
		if ($author$project$Data$User$isNeboAdmin(user)) {
			return 'Nebo Admin';
		} else {
			var _v0 = A2($author$project$Data$User$roleForFleet, slug, user);
			if (_v0.$ === 'Just') {
				var role = _v0.a;
				return $author$project$Data$User$roleToString(role);
			} else {
				return '';
			}
		}
	});
var $author$project$Shared$sendFeatureDropAction = A2($elm$core$Basics$composeR, $author$project$FeatureDrop$Actions$encode, $author$project$Ports$featureDropAction);
var $author$project$Ports$setAnalyticsParameters = _Platform_outgoingPort(
	'setAnalyticsParameters',
	$elm$json$Json$Encode$list(
		function ($) {
			var a = $.a;
			var b = $.b;
			return A2(
				$elm$json$Json$Encode$list,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(a),
						$elm$json$Json$Encode$string(b)
					]));
		}));
var $author$project$FeatureDrop$Actions$Dismiss = function (a) {
	return {$: 'Dismiss', a: a};
};
var $author$project$FeatureDrop$Actions$DismissAll = {$: 'DismissAll'};
var $author$project$FeatureDrop$Actions$MarkFeatureClicked = function (a) {
	return {$: 'MarkFeatureClicked', a: a};
};
var $author$project$Shared$changelogActionToRenderer = function (action) {
	switch (action.$) {
		case 'Dismiss':
			var id = action.a;
			return _List_fromArray(
				[
					$author$project$FeatureDrop$Actions$Dismiss(id)
				]);
		case 'DismissAll':
			return _List_fromArray(
				[$author$project$FeatureDrop$Actions$DismissAll]);
		default:
			var id = action.a;
			return _List_fromArray(
				[
					$author$project$FeatureDrop$Actions$MarkFeatureClicked(id),
					$author$project$FeatureDrop$Actions$Dismiss(id)
				]);
	}
};
var $author$project$Shared$update = F3(
	function (req, msg, model) {
		switch (msg.$) {
			case 'SignIn':
				var session = msg.a;
				var updatedConfig = function (c) {
					return _Utils_update(
						c,
						{
							user: $elm$core$Maybe$Just(
								$author$project$Shared$sessionToBugsnagUser(session))
						});
				}(model.bugsnagConfig);
				var _v1 = A2($author$project$Data$Session$defaultFleet, session, $elm$core$Maybe$Nothing);
				if (_v1.$ === 'Just') {
					var f = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bugsnag: $tremlab$bugsnag_elm$BugsnagElm$start(updatedConfig),
								session: $elm$core$Maybe$Just(session),
								bugsnagConfig: updatedConfig,
								selectedFleetId: $elm$core$Maybe$Just(f.fleetId)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Request$pushRoute,
									$author$project$Gen$Route$Fleet_(
										{fleet: f.slug}),
									req),
									$author$project$Ports$save(
									_Utils_Tuple2(
										'selectedFleetId',
										$elm$core$Maybe$Just(
											$author$project$Data$Fleet$fleetIdEncoder(f.fleetId)))),
									$author$project$Ports$setAnalyticsParameters(
									_List_fromArray(
										[
											_Utils_Tuple2('fleet', f.name),
											_Utils_Tuple2(
											'role',
											A2($author$project$Data$User$analyticsRoleForFleet, f.slug, session.user))
										])),
									$author$project$Ports$save(
									_Utils_Tuple2(
										'session',
										$elm$core$Maybe$Just(
											$author$project$Data$Session$sessionEncoder(session)))),
									A3($author$project$Shared$refreshFleetCmd, session.authToken, model.apiUrl, f.slug),
									$author$project$Shared$enteredApp
								])));
				} else {
					return _Utils_Tuple2(
						model,
						A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req));
				}
			case 'SelectFleet':
				var fleetId = msg.a;
				var _v2 = _Utils_Tuple2(
					model.session,
					A2(
						$elm$core$Maybe$andThen,
						function (s) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								function (f) {
									return _Utils_eq(f.fleetId, fleetId);
								},
								s.fleets);
						},
						model.session));
				if (_v2.a.$ === 'Nothing') {
					var _v3 = _v2.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Request$pushRoute, $author$project$Gen$Route$Login, req));
				} else {
					if (_v2.b.$ === 'Just') {
						var session = _v2.a.a;
						var fleet = _v2.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									selectedFleetId: $elm$core$Maybe$Just(fleetId),
									defaultMapPosition: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Request$pushRoute,
										$author$project$Gen$Route$Fleet_(
											{fleet: fleet.slug}),
										req),
										$author$project$Ports$save(
										_Utils_Tuple2(
											'selectedFleetId',
											$elm$core$Maybe$Just(
												$author$project$Data$Fleet$fleetIdEncoder(fleetId)))),
										$author$project$Ports$setAnalyticsParameters(
										_List_fromArray(
											[
												_Utils_Tuple2('fleet', fleet.name),
												_Utils_Tuple2(
												'role',
												A2($author$project$Data$User$analyticsRoleForFleet, fleet.slug, session.user))
											])),
										$author$project$Ports$save(
										_Utils_Tuple2('defaultMapPosition', $elm$core$Maybe$Nothing)),
										A3($author$project$Shared$refreshFleetCmd, session.authToken, model.apiUrl, fleet.slug)
									])));
					} else {
						var _v4 = _v2.b;
						return _Utils_Tuple2(
							model,
							A2($author$project$Request$pushRoute, $author$project$Gen$Route$NotFound, req));
					}
				}
			case 'OnRefreshFleet':
				if (msg.a.$ === 'Ok') {
					var f = msg.a.a;
					var _v5 = model.session;
					if (_v5.$ === 'Just') {
						var session = _v5.a;
						var updatedSession = _Utils_update(
							session,
							{
								fleets: A2(
									$elm$core$List$append,
									_List_fromArray(
										[f]),
									A2(
										$elm$core$List$filter,
										function (fl) {
											return !_Utils_eq(fl.fleetId, f.fleetId);
										},
										session.fleets))
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									session: $elm$core$Maybe$Just(updatedSession)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Ports$save(
										_Utils_Tuple2(
											'session',
											$elm$core$Maybe$Just(
												$author$project$Data$Session$sessionEncoder(updatedSession)))),
										$author$project$Shared$enteredApp
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'SetDefaultMapPosition':
				var pos = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{defaultMapPosition: pos}),
					$author$project$Ports$save(
						_Utils_Tuple2(
							'defaultMapPosition',
							A2($elm$core$Maybe$map, $author$project$Shared$mapPositionEncoder, pos))));
			case 'ShowedNavigationWarning':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showedNavigationWarning: true}),
					$author$project$Ports$save(
						_Utils_Tuple2(
							'showedNavigationWarning',
							$elm$core$Maybe$Just(
								$elm$json$Json$Encode$bool(true)))));
			case 'UseNewServer':
				var useNew = msg.a;
				var url = useNew ? model.newApiUrl : model.oldApiUrl;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{apiUrl: url}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$save(
								_Utils_Tuple2(
									'useNewServer',
									$elm$core$Maybe$Just(
										$elm$json$Json$Encode$bool(useNew)))),
								A2($author$project$Request$pushRoute, $author$project$Gen$Route$Home_, req)
							])));
			case 'UpdateFleets':
				var fleets = msg.a;
				var _v6 = model.session;
				if (_v6.$ === 'Just') {
					var session = _v6.a;
					var updatedSession = _Utils_update(
						session,
						{
							fleets: A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.name;
								},
								fleets)
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								session: $elm$core$Maybe$Just(updatedSession)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$save(
									_Utils_Tuple2(
										'session',
										$elm$core$Maybe$Just(
											$author$project$Data$Session$sessionEncoder(updatedSession)))),
									$author$project$Shared$enteredApp
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'UpdateTrackDuration':
				var duration = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							defaultTrackDuration: $elm$core$Maybe$Just(duration)
						}),
					$author$project$Ports$save(
						_Utils_Tuple2(
							'defaultTrackDuration',
							$elm$core$Maybe$Just(
								$author$project$Data$TrackDuration$encode(duration)))));
			case 'OnFeatureDropState':
				var maybeState = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							featureDropState: A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$FeatureDrop$State$setLocale(model.locale),
									$author$project$FeatureDrop$State$carryDismissing(model.featureDropState)),
								maybeState)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ChangelogAction':
				var action = msg.a;
				var dismissing = function () {
					switch (action.$) {
						case 'Dismiss':
							var id = action.a;
							return _List_fromArray(
								[id]);
						case 'DismissAll':
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.newFeatures;
										},
										$elm$core$List$map(
											function ($) {
												return $.id;
											})),
									model.featureDropState));
						default:
							return _List_Nil;
					}
				}();
				var send = function (a) {
					return $elm$core$List$isEmpty(dismissing) ? $author$project$Shared$sendFeatureDropAction(a) : A2(
						$elm$core$Task$perform,
						function (_v7) {
							return $author$project$Shared$SendFeatureDropAction(a);
						},
						$elm$core$Process$sleep(250));
				};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							featureDropState: A2(
								$elm$core$Maybe$map,
								$author$project$FeatureDrop$State$markDismissing(dismissing),
								model.featureDropState)
						}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							send,
							$author$project$Shared$changelogActionToRenderer(action))));
			case 'SendFeatureDropAction':
				var a = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Shared$sendFeatureDropAction(a));
			default:
				var updatedConfig = function (c) {
					return _Utils_update(
						c,
						{user: $elm$core$Maybe$Nothing});
				}(model.bugsnagConfig);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bugsnag: $tremlab$bugsnag_elm$BugsnagElm$start(updatedConfig),
							session: $elm$core$Maybe$Nothing,
							bugsnagConfig: updatedConfig,
							selectedFleetId: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$save(
								_Utils_Tuple2('session', $elm$core$Maybe$Nothing)),
								A2($author$project$Request$pushRoute, $author$project$Gen$Route$Login, req)
							])));
		}
	});
var $author$project$Gen$Pages$update = F2(
	function (msg_, model_) {
		var _v0 = _Utils_Tuple2(msg_, model_);
		_v0$25:
		while (true) {
			switch (_v0.a.$) {
				case 'Changelog':
					if (_v0.b.$ === 'Changelog') {
						var msg = _v0.a.a;
						var _v1 = _v0.b;
						var params = _v1.a;
						var model = _v1.b;
						return A3($author$project$Gen$Pages$pages.changelog.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet_':
					if (_v0.b.$ === 'Fleet_') {
						var msg = _v0.a.a;
						var _v2 = _v0.b;
						var params = _v2.a;
						var model = _v2.b;
						return A3($author$project$Gen$Pages$pages.fleet_.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Forbidden':
					if (_v0.b.$ === 'Forbidden') {
						var msg = _v0.a.a;
						var _v3 = _v0.b;
						var params = _v3.a;
						var model = _v3.b;
						return A3($author$project$Gen$Pages$pages.forbidden.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Home_':
					if (_v0.b.$ === 'Home_') {
						var msg = _v0.a.a;
						var _v4 = _v0.b;
						var params = _v4.a;
						var model = _v4.b;
						return A3($author$project$Gen$Pages$pages.home_.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Login':
					if (_v0.b.$ === 'Login') {
						var msg = _v0.a.a;
						var _v5 = _v0.b;
						var params = _v5.a;
						var model = _v5.b;
						return A3($author$project$Gen$Pages$pages.login.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Register':
					if (_v0.b.$ === 'Register') {
						var msg = _v0.a.a;
						var _v6 = _v0.b;
						var params = _v6.a;
						var model = _v6.b;
						return A3($author$project$Gen$Pages$pages.register.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Boats':
					if (_v0.b.$ === 'Fleet___Boats') {
						var msg = _v0.a.a;
						var _v7 = _v0.b;
						var params = _v7.a;
						var model = _v7.b;
						return A3($author$project$Gen$Pages$pages.fleet___boats.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Dashboard':
					if (_v0.b.$ === 'Fleet___Dashboard') {
						var msg = _v0.a.a;
						var _v8 = _v0.b;
						var params = _v8.a;
						var model = _v8.b;
						return A3($author$project$Gen$Pages$pages.fleet___dashboard.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___DateRangeSummary':
					if (_v0.b.$ === 'Fleet___DateRangeSummary') {
						var msg = _v0.a.a;
						var _v9 = _v0.b;
						var params = _v9.a;
						var model = _v9.b;
						return A3($author$project$Gen$Pages$pages.fleet___dateRangeSummary.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Discovery':
					if (_v0.b.$ === 'Fleet___Discovery') {
						var msg = _v0.a.a;
						var _v10 = _v0.b;
						var params = _v10.a;
						var model = _v10.b;
						return A3($author$project$Gen$Pages$pages.fleet___discovery.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Edit':
					if (_v0.b.$ === 'Fleet___Edit') {
						var msg = _v0.a.a;
						var _v11 = _v0.b;
						var params = _v11.a;
						var model = _v11.b;
						return A3($author$project$Gen$Pages$pages.fleet___edit.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Geofences':
					if (_v0.b.$ === 'Fleet___Geofences') {
						var msg = _v0.a.a;
						var _v12 = _v0.b;
						var params = _v12.a;
						var model = _v12.b;
						return A3($author$project$Gen$Pages$pages.fleet___geofences.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___MonthlyUtilisation':
					if (_v0.b.$ === 'Fleet___MonthlyUtilisation') {
						var msg = _v0.a.a;
						var _v13 = _v0.b;
						var params = _v13.a;
						var model = _v13.b;
						return A3($author$project$Gen$Pages$pages.fleet___monthlyUtilisation.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___NewBoat':
					if (_v0.b.$ === 'Fleet___NewBoat') {
						var msg = _v0.a.a;
						var _v14 = _v0.b;
						var params = _v14.a;
						var model = _v14.b;
						return A3($author$project$Gen$Pages$pages.fleet___newBoat.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___OnTime':
					if (_v0.b.$ === 'Fleet___OnTime') {
						var msg = _v0.a.a;
						var _v15 = _v0.b;
						var params = _v15.a;
						var model = _v15.b;
						return A3($author$project$Gen$Pages$pages.fleet___onTime.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Places':
					if (_v0.b.$ === 'Fleet___Places') {
						var msg = _v0.a.a;
						var _v16 = _v0.b;
						var params = _v16.a;
						var model = _v16.b;
						return A3($author$project$Gen$Pages$pages.fleet___places.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Public':
					if (_v0.b.$ === 'Fleet___Public') {
						var msg = _v0.a.a;
						var _v17 = _v0.b;
						var params = _v17.a;
						var model = _v17.b;
						return A3($author$project$Gen$Pages$pages.fleet___public.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Routes':
					if (_v0.b.$ === 'Fleet___Routes') {
						var msg = _v0.a.a;
						var _v18 = _v0.b;
						var params = _v18.a;
						var model = _v18.b;
						return A3($author$project$Gen$Pages$pages.fleet___routes.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Summary':
					if (_v0.b.$ === 'Fleet___Summary') {
						var msg = _v0.a.a;
						var _v19 = _v0.b;
						var params = _v19.a;
						var model = _v19.b;
						return A3($author$project$Gen$Pages$pages.fleet___summary.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Users':
					if (_v0.b.$ === 'Fleet___Users') {
						var msg = _v0.a.a;
						var _v20 = _v0.b;
						var params = _v20.a;
						var model = _v20.b;
						return A3($author$project$Gen$Pages$pages.fleet___users.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Video':
					if (_v0.b.$ === 'Fleet___Video') {
						var msg = _v0.a.a;
						var _v21 = _v0.b;
						var params = _v21.a;
						var model = _v21.b;
						return A3($author$project$Gen$Pages$pages.fleet___video.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___WeeklyUtilisation':
					if (_v0.b.$ === 'Fleet___WeeklyUtilisation') {
						var msg = _v0.a.a;
						var _v22 = _v0.b;
						var params = _v22.a;
						var model = _v22.b;
						return A3($author$project$Gen$Pages$pages.fleet___weeklyUtilisation.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Boats__BoatId___Edit':
					if (_v0.b.$ === 'Fleet___Boats__BoatId___Edit') {
						var msg = _v0.a.a;
						var _v23 = _v0.b;
						var params = _v23.a;
						var model = _v23.b;
						return A3($author$project$Gen$Pages$pages.fleet___boats__boatId___edit.update, params, msg, model);
					} else {
						break _v0$25;
					}
				case 'Fleet___Boats__BoatId___Logs':
					if (_v0.b.$ === 'Fleet___Boats__BoatId___Logs') {
						var msg = _v0.a.a;
						var _v24 = _v0.b;
						var params = _v24.a;
						var model = _v24.b;
						return A3($author$project$Gen$Pages$pages.fleet___boats__boatId___logs.update, params, msg, model);
					} else {
						break _v0$25;
					}
				default:
					if (_v0.b.$ === 'Fleet___Public__BoatId_') {
						var msg = _v0.a.a;
						var _v25 = _v0.b;
						var params = _v25.a;
						var model = _v25.b;
						return A3($author$project$Gen$Pages$pages.fleet___public__boatId_.update, params, msg, model);
					} else {
						break _v0$25;
					}
			}
		}
		return F3(
			function (_v26, _v27, _v28) {
				return _Utils_Tuple2(model_, $author$project$Effect$none);
			});
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 'Nothing') {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 'Nothing') {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.protocol;
		if (_v0.$ === 'Http') {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.fragment,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.query,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.port_,
					_Utils_ap(http, url.host)),
				url.path)));
};
var $author$project$Ports$cancelEventStream = _Platform_outgoingPort(
	'cancelEventStream',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ClickedLink':
				if (msg.a.$ === 'Internal') {
					var url = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.key,
							$elm$url$Url$toString(url)));
				} else {
					var url = msg.a.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 'ChangedUrl':
				var url = msg.a;
				var _v1 = A4(
					$author$project$Gen$Pages$init,
					$author$project$Gen$Route$fromUrl(url),
					model.shared,
					url,
					model.key);
				var page = _v1.a;
				var effect = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{url: url, page: page}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$cancelEventStream(_Utils_Tuple0),
								A3(
								$author$project$Effect$toCmd,
								model.key,
								_Utils_Tuple2($author$project$Main$Shared, $author$project$Main$Page),
								effect)
							])));
			case 'Shared':
				var sharedMsg = msg.a;
				var _v2 = A3(
					$author$project$Shared$update,
					A3($author$project$Request$create, _Utils_Tuple0, model.url, model.key),
					sharedMsg,
					model.shared);
				var shared = _v2.a;
				var sharedCmd = _v2.b;
				var _v3 = A4(
					$author$project$Gen$Pages$init,
					$author$project$Gen$Route$fromUrl(model.url),
					shared,
					model.url,
					model.key);
				var page = _v3.a;
				var effect = _v3.b;
				return _Utils_eq(page, $author$project$Gen$Model$Redirecting_) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{page: page, shared: shared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
								A3(
								$author$project$Effect$toCmd,
								model.key,
								_Utils_Tuple2($author$project$Main$Shared, $author$project$Main$Page),
								effect)
							]))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{shared: shared}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd));
			default:
				var pageMsg = msg.a;
				var _v4 = A5($author$project$Gen$Pages$update, pageMsg, model.page, model.shared, model.url, model.key);
				var page = _v4.a;
				var effect = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{page: page}),
					A3(
						$author$project$Effect$toCmd,
						model.key,
						_Utils_Tuple2($author$project$Main$Shared, $author$project$Main$Page),
						effect));
		}
	});
var $author$project$Main$ChangedUrl = function (a) {
	return {$: 'ChangedUrl', a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 'ClickedLink', a: a};
};
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Ports$featureDropState = _Platform_incomingPort('featureDropState', $elm$json$Json$Decode$value);
var $author$project$Shared$OnFeatureDropState = function (a) {
	return {$: 'OnFeatureDropState', a: a};
};
var $author$project$Shared$subscriptions = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ports$featureDropState(
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Decode$decodeValue($author$project$FeatureDrop$State$decoder),
						A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $author$project$Shared$OnFeatureDropState)))
				]));
	});
var $author$project$Gen$Pages$subscriptions = function (model_) {
	switch (model_.$) {
		case 'Redirecting_':
			return F3(
				function (_v1, _v2, _v3) {
					return $elm$core$Platform$Sub$none;
				});
		case 'Changelog':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.changelog.subscriptions, params, model);
		case 'Fleet_':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet_.subscriptions, params, model);
		case 'Forbidden':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.forbidden.subscriptions, params, model);
		case 'Home_':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.home_.subscriptions, params, model);
		case 'Login':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.login.subscriptions, params, model);
		case 'Register':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.register.subscriptions, params, model);
		case 'Fleet___Boats':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___boats.subscriptions, params, model);
		case 'Fleet___Dashboard':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___dashboard.subscriptions, params, model);
		case 'Fleet___DateRangeSummary':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___dateRangeSummary.subscriptions, params, model);
		case 'Fleet___Discovery':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___discovery.subscriptions, params, model);
		case 'Fleet___Edit':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___edit.subscriptions, params, model);
		case 'Fleet___Geofences':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___geofences.subscriptions, params, model);
		case 'Fleet___MonthlyUtilisation':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___monthlyUtilisation.subscriptions, params, model);
		case 'Fleet___NewBoat':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___newBoat.subscriptions, params, model);
		case 'Fleet___OnTime':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___onTime.subscriptions, params, model);
		case 'Fleet___Places':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___places.subscriptions, params, model);
		case 'Fleet___Public':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___public.subscriptions, params, model);
		case 'Fleet___Routes':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___routes.subscriptions, params, model);
		case 'Fleet___Summary':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___summary.subscriptions, params, model);
		case 'Fleet___Users':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___users.subscriptions, params, model);
		case 'Fleet___Video':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___video.subscriptions, params, model);
		case 'Fleet___WeeklyUtilisation':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___weeklyUtilisation.subscriptions, params, model);
		case 'Fleet___Boats__BoatId___Edit':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___boats__boatId___edit.subscriptions, params, model);
		case 'Fleet___Boats__BoatId___Logs':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___boats__boatId___logs.subscriptions, params, model);
		case 'Fleet___Public__BoatId_':
			var params = model_.a;
			var model = model_.b;
			return A2($author$project$Gen$Pages$pages.fleet___public__boatId_.subscriptions, params, model);
		default:
			var params = model_.a;
			return A2($author$project$Gen$Pages$pages.notFound.subscriptions, params, _Utils_Tuple0);
	}
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Page,
				A4($author$project$Gen$Pages$subscriptions, model.page, model.shared, model.url, model.key)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Shared,
				A2(
					$author$project$Shared$subscriptions,
					A3($author$project$Request$create, _Utils_Tuple0, model.url, model.key),
					model.shared))
			]));
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{init: $author$project$Main$init, view: $author$project$Main$view, update: $author$project$Main$update, onUrlChange: $author$project$Main$ChangedUrl, onUrlRequest: $author$project$Main$ClickedLink, subscriptions: $author$project$Main$subscriptions});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));; 
const denest = (originalObj) => {
  const elmModulePath = ["Main"]
  let keyPath = [...elmModulePath]
  let obj = originalObj
  while (keyPath.length > 0) {
    let key = keyPath.shift()
    obj = obj[key]
  }
  obj.__elmModulePath = elmModulePath
  return obj
}; return denest(this.Elm) } }).run(); 
if (import.meta.hot) {
  let id = "/opt/src/src/Main.elm"
  let wasSuccessful = true

  class ElmErrorOverlay extends HTMLElement {
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
    }

    onContentChanged(html) {
      this.shadowRoot.querySelector('.elm-error').innerHTML = html

      // Adds "Jump to problem" button click listeners
      let buttons = this.shadowRoot.querySelectorAll('button[data-source]')
      for (let btn of buttons) {
        btn.addEventListener('click', () => {
          let filepath = btn.getAttribute('data-source')
          import.meta.hot.send('elm:open-editor', { filepath })
        })
      }
    }

    connectedCallback() {
      this.shadowRoot.innerHTML = `
        <style>
          /* ATOM DARK */
          :host {
            --elmError__red: #E06C75;
            --elmError__green: #98C379;
            --elmError__yellow: #E5C07B;
            --elmError__blue: #61AFEF;
            --elmError__magenta: #C678DD;
            --elmError__cyan: #56B6C2;
            --elmError__background: #282C34;
            --elmError__foreground: #e6e7eb;
          }
      
          @media (prefers-color-scheme: light) {
            /* ATOM LIGHT */
            :host {
              --elmError__red: #CA1243;
              --elmError__green: #50A14F;
              --elmError__yellow: #C18401;
              --elmError__blue: #4078F2;
              --elmError__magenta: #A626A4;
              --elmError__cyan: #0184BC;
              --elmError__background: #FAFAFA;
              --elmError__foreground: #383A42;
            }
          }

          elm-error-overlay {
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            z-index: 9669;
          }
          button {
            font-size: inherit;
            padding: 0;
            color: inherit;
            background: none;
            border: 0;
            font-family: inherit;
            cursor: pointer;
            position: relative;
            z-index: 1;
            margin: 0;
            border-bottom: solid 0.1em;
          }
          a:hover, button:hover {
            opacity: 0.75;
          }
          button:active {
            opacity: 1;
            color: var(--elmError__foreground)
          }
          .elm-error__background {
            position: fixed;
            z-index: 2147483648;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.25;
            background: #000;
          }
          .elm-error__parent {    
            position: fixed;
            z-index: 2147483648;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1em;
            font-family: 'Fira Code', Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace;
            font-variant-ligatures: none;
            font-weight: 400;
            font-size: clamp(0.5rem, 2vw, 1rem);
          }
          .elm-error {
            position: relative;
            background: var(--elmError__background);
            color: var(--elmError__foreground);
            white-space: nowrap;
            line-height: 1.5;
            border-radius: 0.5em;
            box-shadow: 0 1em 1em rgba(0, 0, 0, 0.125);
            border-top: solid 0.5em var(--elmError__red);
            max-height: calc(100vh - 4em);
            overflow: auto;
            max-width: 100%;
            box-sizing: border-box;
          }
          .elm-error > * {
            max-width: calc(80em - 4em);
            padding: 2em;
          }
        </style>
        <div class="elm-error__background"></div>
        <div class="elm-error__parent">
          <div class="elm-error"></div>
        </div>
      `
    }
  }

  import.meta.hot.on('elm:error', (data) => {
    if (!customElements.get('elm-error-overlay')) {
      customElements.define('elm-error-overlay', ElmErrorOverlay)
    }

    let existingOverlay = document.querySelector('elm-error-overlay')
    if (existingOverlay) {
      existingOverlay.onContentChanged(data.error)
    } else {
      let node = document.createElement('elm-error-overlay')
      let root = document.body
      root.appendChild(node)
      document.querySelector('elm-error-overlay').onContentChanged(data.error)
    }
  })

  import.meta.hot.on('elm:success', (data) => {
    if (data.id === id) {
      let existingOverlay = document.querySelector('elm-error-overlay')
      if (existingOverlay) {
        existingOverlay.remove()
      }
    }
    if (!wasSuccessful) {
      import.meta.hot.invalidate('Triggering reload!')
    }
  })

  if (import.meta.env.DEV) {
    import.meta.hot.send('elm:client-ready', { id })
  }

  import.meta.hot.accept((module) => {
    var data = module.default.init("__elmWatchReturnData");
    var apps = import.meta.hot.data.elmApps || [];
    var reloadReasons = [];
    for (var index = 0; index < apps.length; index++) {
      var app = apps[index];
      if (app.__elmWatchProgramType !== data.programType) {
        reloadReasons.push({
          tag: "ProgramTypeChanged",
          previousProgramType: app.__elmWatchProgramType,
          newProgramType: data.programType,
        });
      } else {
        try {
          var innerReasons = app.__elmWatchHotReload(data);
          reloadReasons = reloadReasons.concat(innerReasons);
        } catch (error) {
          reloadReasons.push({
            tag: "HotReloadCaughtError",
            caughtError: error,
          });
        }
      }
    }
    if (reloadReasons.length > 0) {
      for (var index = 0; index < apps.length; index++) {
        let app = apps[index]
        if (app && app.unmount) { app.unmount() }
      }
      import.meta.hot.invalidate(reloadReasons[0].tag);
    }
  })
}
